webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _ContextedDispatcher2 = __webpack_require__(462);

var _ContextedDispatcher3 = _interopRequireDefault(_ContextedDispatcher2);

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

var _ContextedReduceStore = __webpack_require__(30);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _logActionToConsole = __webpack_require__(938);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _global = window || {};
if (_global.__flux_dispatcher_created && !_global.testEnv) {
    throw new Error("You've got something screwy, multiple Dispatchers were 'require'-ed");
}
_global.__flux_dispatcher_created = true;

var checkAction = function checkAction(action) {
    (0, _invariant2.default)(!action.hasOwnProperty(_ContextedReduceStore.ACTION_CONTEXT_KEY), "You may not dispatch actions containing a '" + _ContextedReduceStore.ACTION_CONTEXT_KEY + "' key.");
    (0, _invariant2.default)(action.type, "Actions must have a 'type' key");
    if (action.type.actionTypes != null) {
        _propTypes2.default.checkPropTypes(action.type.actionTypes, { action: action }, "actionTypes", action.type);
    }
};

// yeah, i know. compose, don't extend. shush.

var ValidatingDispatcher = function (_ContextedDispatcher) {
    _inherits(ValidatingDispatcher, _ContextedDispatcher);

    function ValidatingDispatcher() {
        var enableLogging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        _classCallCheck(this, ValidatingDispatcher);

        var _this = _possibleConstructorReturn(this, (ValidatingDispatcher.__proto__ || Object.getPrototypeOf(ValidatingDispatcher)).call(this));

        _this._enableLogging = enableLogging;
        return _this;
    }

    _createClass(ValidatingDispatcher, [{
        key: "register",
        value: function register(callback) {
            var token = _get(ValidatingDispatcher.prototype.__proto__ || Object.getPrototypeOf(ValidatingDispatcher.prototype), "register", this).call(this, callback);
            if (this._enableLogging && callback === _logActionToConsole.logActionToConsole) {
                // tee-hee
                this.unregister(token);
            }
            return token;
        }
    }, {
        key: "_startDispatching",
        value: function _startDispatching(action) {
            if (this._enableLogging && (0, _logActionToConsole.actionGroupInConsole)(action)) {
                this._start = Date.now();
            }
            _get(ValidatingDispatcher.prototype.__proto__ || Object.getPrototypeOf(ValidatingDispatcher.prototype), "_startDispatching", this).call(this, action);
        }
    }, {
        key: "_stopDispatching",
        value: function _stopDispatching() {
            _get(ValidatingDispatcher.prototype.__proto__ || Object.getPrototypeOf(ValidatingDispatcher.prototype), "_stopDispatching", this).call(this);
            if (this._enableLogging && this._start) {
                var elapsed = Date.now() - this._start;
                elapsed > 20 && console.warn(elapsed + "ms");
                console.groupEnd();
                delete this._start;
            }
        }
    }, {
        key: "dispatch",
        value: function dispatch(action) {
            checkAction(action);
            (0, _invariant2.default)(action.type.charAt(0) !== "*", "Action '" + action.type + "' MUST be dispatched contextually");
            _get(ValidatingDispatcher.prototype.__proto__ || Object.getPrototypeOf(ValidatingDispatcher.prototype), "dispatch", this).call(this, action);
        }
    }, {
        key: "contextDispatch",
        value: function contextDispatch(context, action) {
            (0, _invariant2.default)(typeof context === "string" && context, "Contexts must be named by non-empty strings");
            checkAction(action);
            _get(ValidatingDispatcher.prototype.__proto__ || Object.getPrototypeOf(ValidatingDispatcher.prototype), "contextDispatch", this).call(this, context, action);
        }
    }]);

    return ValidatingDispatcher;
}(_ContextedDispatcher3.default);

exports.default =  true ? new _ContextedDispatcher3.default() : new ValidatingDispatcher(false);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.descriptorPropTypes = exports.controlPropTypes = undefined;

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates base PropTypes for react controls. Allows custom config shapes and more.
 *
 * @param {object} configShape
 * @param {boolean} isDisableable
 * @param {boolean} hasChildren
 * @return {object}
 */
var controlPropTypes = exports.controlPropTypes = function controlPropTypes(configShape) {
    var isDisableable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var hasChildren = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return {
        // it all starts here
        descriptor: _propTypes2.default.shape(descriptorPropTypes(configShape, isDisableable, hasChildren)),
        value: _propTypes2.default.any,
        enabled: _propTypes2.default.bool,
        options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            value: _propTypes2.default.string,
            label: _propTypes2.default.string
        })),

        // standard react event api
        // ...(event, descriptor, controlValue)
        onChange: _propTypes2.default.func,
        onClick: _propTypes2.default.func,
        onKeyDown: _propTypes2.default.func, //...(event, descriptor, controlValue, isKeyboardShortcut)
        onBlur: _propTypes2.default.func,
        onFocus: _propTypes2.default.func, //...(event, descriptor, controlValue, keyboardShortcuts)

        // data record getters and setters
        // ...(descriptor, [value])
        onCommitChange: _propTypes2.default.func.isRequired, // set the records value

        // Initially passed into Form and reused by other recursive controls.
        // Callback function that allows for overloading the current controls
        // props such as value, enabled, options, onCommitChange, descriptor.
        // ...(descriptor)
        propsResolver: _propTypes2.default.func,

        // other UI options
        controlOnly: _propTypes2.default.bool,
        placeholder: _propTypes2.default.bool
    };
};

/**
 * Creates base PropTypes for descriptors. Allows custom config shapes and more.
 *
 * @param {object} configShape
 * @param {boolean} isDisableable
 * @param {boolean} hasChildren
 * @return {object}
 */
var descriptorPropTypes = exports.descriptorPropTypes = function descriptorPropTypes(configShape) {
    var isDisableable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var hasChildren = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var pts = {
        id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
        boundTo: _propTypes2.default.string,
        control: _propTypes2.default.string.isRequired,
        disableBehaviour: _propTypes2.default.oneOf(["disable", "hide"]),
        key: _propTypes2.default.string.isRequired,
        label: _propTypes2.default.string.isRequired,
        type: _propTypes2.default.string.isRequired
    };
    if (configShape) {
        pts.config = _propTypes2.default.shape(configShape);
    }
    if (isDisableable) {
        pts.disableBehaviour = pts.disableBehaviour.isRequired;
    }
    if (hasChildren) {
        pts.childItems = _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired;
    }
    return pts;
};

exports.default = {
    controlPropTypes: controlPropTypes,
    descriptorPropTypes: descriptorPropTypes
};

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UserStore = exports.getHexForms = exports.canMergeLookups = exports.canMergeMagicRoots = exports.canCrossAppMap = exports.canAISuggestion = exports.canManageLookups = exports.canPrint = exports.canCreate = exports.canDelete = exports.canWrite = exports.canUseHex = exports.canUseDqr = exports.canUseDE = exports.allGrants = exports.anyGrant = exports.checkGrant = exports.getLicensePreferenceMutability = exports.isGenericXmlExportAvailable = exports.getOrganizationalPreference = exports.getLicensePreference = exports.hasLicenseFeature = exports.isPrefManForAnything = exports.getImplsWithHiddenFieldAdmin = exports.getImplsWithValidationAdmin = exports.getNavTree = exports.getAllOrgs = exports.getActiveOrg = exports.getActiveOrgKey = exports.getDisplayName = exports.getUsername = exports.getLastName = exports.getFirstName = exports.withUpdatedOrgPreference = exports.withUpdatedLicensePreference = exports.I_PERMISSIONS = exports.PERMISSIONS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _GxepActions = __webpack_require__(171);

var _GxepActions2 = _interopRequireDefault(_GxepActions);

var _SearchFormActions = __webpack_require__(75);

var _SearchFormActions2 = _interopRequireDefault(_SearchFormActions);

var _SearchFormStore = __webpack_require__(82);

var _SearchFormStore2 = _interopRequireDefault(_SearchFormStore);

var _ContextedReduceStore = __webpack_require__(30);

var _loadObjectOf = __webpack_require__(220);

var _loadObjectOf2 = _interopRequireDefault(_loadObjectOf);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _dotPropImmutable = __webpack_require__(40);

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _utils = __webpack_require__(13);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DataManager = __webpack_require__(43);

var _DataManager2 = _interopRequireDefault(_DataManager);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _slices = __webpack_require__(172);

var _storeUtils = __webpack_require__(54);

var _UserActions = __webpack_require__(123);

var _UserActions2 = _interopRequireDefault(_UserActions);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var IMPLEMENTATION_ADT = "adt";

var IMPLEMENTATION_HEMO = "hemo";

var PERMISSIONS = exports.PERMISSIONS = {
    READ: "READ",
    WRITE: "WRITE",
    CREATE: "CREATE",
    DELETE: "DELETE",
    ACCESS: "ACCESS",
    EXPORT: "EXPORT",
    MERGE: "MERGE",
    PREFERENCE_MANAGER: "PREFERENCE_MANAGER",
    HARVEST: "HARVEST",
    LOOKUP_MANAGER: "LOOKUP_MANAGER",
    AI_SUGGESTION: "AI_SUGGESTION",
    CROSS_APP_MAPPING: "CROSS_APP_MAPPING"

};

var PERMISSION_INDEXES = [PERMISSIONS.READ, PERMISSIONS.WRITE, PERMISSIONS.CREATE, PERMISSIONS.DELETE, null, // ADMINISTRATION
null, // READ_DEIDENTIFIED
PERMISSIONS.ACCESS, PERMISSIONS.EXPORT, PERMISSIONS.MERGE, PERMISSIONS.PREFERENCE_MANAGER, PERMISSIONS.HARVEST, PERMISSIONS.LOOKUP_MANAGER, PERMISSIONS.AI_SUGGESTION, PERMISSIONS.CROSS_APP_MAPPING];

var I_PERMISSIONS = exports.I_PERMISSIONS = Object.keys(PERMISSIONS).reduce(function (agg, k) {
    agg[k] = 1 << PERMISSION_INDEXES.indexOf(PERMISSIONS[k]);
    return agg;
}, {});

var GENERIC_XML_EXPORT_PASSWORD_PREF = "generic-xml-export-encryption-password";

var withUpdatedLicensePreference = exports.withUpdatedLicensePreference = function withUpdatedLicensePreference(state, impl, pref, value) {
    return _dotPropImmutable2.default.set(state, ["orgs", "byKey", state.activeOrg, "lics", "byKey", impl, "prefs", pref], value);
};

var withUpdatedOrgPreference = exports.withUpdatedOrgPreference = function withUpdatedOrgPreference(state, pref, value) {
    return _dotPropImmutable2.default.set(state, ["orgs", "byKey", state.activeOrg, "prefs", pref], value);
};

var _getFirstName = function _getFirstName(raw) {
    return raw.firstname;
};

exports.getFirstName = _getFirstName;
var _getLastName = function _getLastName(raw) {
    return raw.lastname;
};

exports.getLastName = _getLastName;
var _getUsername = function _getUsername(raw) {
    return raw.username;
};

exports.getUsername = _getUsername;
var _getDisplayName = function _getDisplayName(raw) {
    return raw.firstname || raw.username;
};

exports.getDisplayName = _getDisplayName;
var _getActiveOrgKey = function _getActiveOrgKey(raw) {
    return raw.activeOrg;
};

exports.getActiveOrgKey = _getActiveOrgKey;
var _getOrg = function _getOrg(raw, orgKey) {
    if (orgKey == null) {
        orgKey = raw.activeOrg;
    }
    if (!raw.orgs.byKey.hasOwnProperty(orgKey)) {
        throw new Error("No '" + orgKey + "' organization is known");
    }
    return raw.orgs.byKey[orgKey];
};

// don't allow an unintended orgKey to slip through
var _getActiveOrg = function _getActiveOrg(raw) {
    return _getOrg(raw);
};

exports.getActiveOrg = _getActiveOrg;
var _getAllOrgs = function _getAllOrgs(raw) {
    return (0, _slices.fromSlice)(raw.orgs, function (o) {
        return Object.assign({ active: o.key === raw.activeOrg }, o);
    });
};

exports.getAllOrgs = _getAllOrgs;
var _getNavTree = function _getNavTree(raw) {
    return raw.navTree;
};

exports.getNavTree = _getNavTree;
var _getImplsWithValidationAdmin = function _getImplsWithValidationAdmin(raw) {
    return _getImplsWithAdminAvailable(raw, "validation-show-admin", "validation-excluded-fields");
};

exports.getImplsWithValidationAdmin = _getImplsWithValidationAdmin;
var _getImplsWithHiddenFieldAdmin = function _getImplsWithHiddenFieldAdmin(raw) {
    return _canUseDE(raw) ? _getImplsWithAdminAvailable(raw, "user-hidden-field-admin", "user-hidden-fields") : [];
};

exports.getImplsWithHiddenFieldAdmin = _getImplsWithHiddenFieldAdmin;
var _getImplsWithAdminAvailable = function _getImplsWithAdminAvailable(raw, flag, pref) {
    return (0, _slices.fromSlice)(_getOrg(raw).lics).filter(function (l) {
        var show = l.prefs[flag];
        var isAdmin = allGrants(l.igrants, I_PERMISSIONS.PREFERENCE_MANAGER);
        var isUnlocked = l.prefLocks[pref] !== "NONE";
        return show && isAdmin && isUnlocked;
    });
};

var _isPrefManForAnything = function _isPrefManForAnything(raw) {
    return !!(0, _slices.fromSlice)(raw.orgs).find(function (o) {
        return !!(0, _slices.fromSlice)(o.lics).find(function (l) {
            return allGrants(l.igrants, I_PERMISSIONS.PREFERENCE_MANAGER);
        });
    });
};

exports.isPrefManForAnything = _isPrefManForAnything;
var _getRawLicense = function _getRawLicense(raw, implKey) {
    var orgKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var org = _getOrg(raw, orgKey);
    if (!org.lics.byKey.hasOwnProperty(implKey)) {
        throw new Error("No '" + implKey + "' license is known for '" + org.key + "'");
    }
    return org.lics.byKey[implKey];
};

var _hasFeature = function _hasFeature(holder, feature) {
    return holder.features && holder.features.has(feature);
};

var _hasLicenseFeature = function _hasLicenseFeature(raw, feature, impl) {
    return _hasFeature(_getRawLicense(raw, impl), feature);
};

exports.hasLicenseFeature = _hasLicenseFeature;
var _getPref = function _getPref(holder, pref) {
    var prefs = holder.prefs;
    if (!prefs.hasOwnProperty(pref)) {
        throw new Error("No '" + pref + "' preference is known");
    }
    return prefs[pref];
};

var _getLicensePreference = function _getLicensePreference(raw, pref, impl) {
    var org = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return _getPref(_getRawLicense(raw, impl, org), pref);
};

exports.getLicensePreference = _getLicensePreference;
var _getOrganizationalPreference = function _getOrganizationalPreference(raw, pref) {
    var org = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    return _getPref(_getOrg(raw, org), pref);
};

exports.getOrganizationalPreference = _getOrganizationalPreference;
var _isGenericXmlExportAvailable = function _isGenericXmlExportAvailable(raw) {
    var org = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return !!_getOrganizationalPreference(raw, GENERIC_XML_EXPORT_PASSWORD_PREF, org);
};

exports.isGenericXmlExportAvailable = _isGenericXmlExportAvailable;
var _getLicensePreferenceMutability = function _getLicensePreferenceMutability(raw, pref, impl) {
    var org = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    if (org == null) {
        org = raw.activeOrg;
    }
    var locks = _getRawLicense(raw, impl, org).prefLocks;
    if (!locks.hasOwnProperty(pref)) {
        throw new Error("No '" + pref + "' preference is known");
    }
    return locks[pref];
};

/** DEPRECATED: use anyGrant or allGrants instead */
exports.getLicensePreferenceMutability = _getLicensePreferenceMutability;
var checkGrant = exports.checkGrant = function checkGrant(igrants, perm) {
    if (typeof perm === "string") {
        if (!I_PERMISSIONS.hasOwnProperty(perm)) {
            throw new Error("No '" + perm + "' permission is known");
        }
        perm = I_PERMISSIONS[perm];
    }
    return anyGrant(igrants, perm);
};

var anyGrant = exports.anyGrant = function anyGrant(igrants, perm) {
    return (igrants & perm) !== 0;
};

var allGrants = exports.allGrants = function allGrants(igrants, perm) {
    return (igrants & perm) === perm;
};

var _canUseDE = function _canUseDE(raw) {
    return !raw.aggregate && (0, _slices.fromSlice)(_getOrg(raw).lics).some(function (l) {
        return allGrants(l.igrants, I_PERMISSIONS.READ);
    });
};

exports.canUseDE = _canUseDE;
var _canUseDqr = function _canUseDqr(raw) {
    return (0, _slices.fromSlice)(_getOrg(raw).lics).some(function (l) {
        return allGrants(l.igrants, I_PERMISSIONS.READ);
    });
};

exports.canUseDqr = _canUseDqr;
var _canUseHex = function _canUseHex(raw) {
    return (0, _slices.fromSlice)(_getOrg(raw).lics).some(function (l) {
        return l.exporters != null;
    });
};

exports.canUseHex = _canUseHex;
var buildPermCheck = function buildPermCheck(perm) {
    return function (raw, implKey) {
        return allGrants(_getRawLicense(raw, implKey).igrants, perm);
    };
};

/**
 * By fiat, "every license" ignores the ADT and Hemo implementations, as
 * they are data-less.
 */
var checkGrantAcrossEveryLicense = function checkGrantAcrossEveryLicense(raw, grant) {
    return (0, _slices.fromSlice)(_getOrg(raw).lics).every(function (l) {
        return l.key === IMPLEMENTATION_ADT || l.key === IMPLEMENTATION_HEMO || allGrants(l.igrants, grant);
    });
};

var _canWrite = buildPermCheck(I_PERMISSIONS.WRITE);

exports.canWrite = _canWrite;
var _canDelete = buildPermCheck(I_PERMISSIONS.DELETE);

exports.canDelete = _canDelete;
var _canCreate = buildPermCheck(I_PERMISSIONS.CREATE);

exports.canCreate = _canCreate;
var _canPrint = buildPermCheck(I_PERMISSIONS.EXPORT);

exports.canPrint = _canPrint;
var _canManageLookups = buildPermCheck(I_PERMISSIONS.LOOKUP_MANAGER);

exports.canManageLookups = _canManageLookups;
var _canAISuggestion = buildPermCheck(I_PERMISSIONS.AI_SUGGESTION);

exports.canAISuggestion = _canAISuggestion;
var _canCrossAppMap = buildPermCheck(I_PERMISSIONS.CROSS_APP_MAPPING);

exports.canCrossAppMap = _canCrossAppMap;
var buildMergePermCheck = function buildMergePermCheck(perm) {
    return function (raw) {
        var org = _getActiveOrg(raw);
        if (!org.completeAccess) return false;
        return checkGrantAcrossEveryLicense(raw, perm);
    };
};

// and any other normal record, I believe?
var _canMergeMagicRoots = buildMergePermCheck(I_PERMISSIONS.MERGE | I_PERMISSIONS.DELETE);

exports.canMergeMagicRoots = _canMergeMagicRoots;
var _canMergeLookups = buildMergePermCheck(I_PERMISSIONS.MERGE | I_PERMISSIONS.DELETE | I_PERMISSIONS.LOOKUP_MANAGER);

exports.canMergeLookups = _canMergeLookups;
var _getHexForms = function _getHexForms(raw) {
    var all = (0, _slices.fromSlice)(_getOrg(raw).lics).map(function (l) {
        return l.exporters;
    }).filter(function (it) {
        return it != null;
    }).reduce(function (a, v) {
        return a.concat(v);
    }, []);
    // kludge-y deduplicate
    return (0, _slices.fromSlice)((0, _slices.toSlice)(all, "key"));
};

exports.getHexForms = _getHexForms;
var saveOrgUserPref = function saveOrgUserPref(state, pref, value) {
    var curr = _getOrganizationalPreference(state.getRequiredValue(), pref);
    if (curr === value) return state;
    return state.loading(_DataManager2.default.updateOrgUserPreference(pref, value));
};

function _getDescendantOrgKeys(raw) {
    var org = _getActiveOrg(raw);
    return [].concat(_toConsumableArray(new Set((0, _slices.fromSlice)(org.lics).flatMap(function (l) {
        return l.descendants;
    }))));
}

function _getImplementationDescendantOrgKeys(raw, implKeys) {
    if (!implKeys || implKeys.length === 0) {
        throw new Error("You've requested descendants for zero implementations?!");
    }
    var org = _getActiveOrg(raw);
    return [].concat(_toConsumableArray(new Set(implKeys.filter(function (k) {
        return org.lics.byKey.hasOwnProperty(k);
    }).flatMap(function (k) {
        return org.lics.byKey[k].descendants;
    }))));
}

function _getExporterFilterOrgKeys(raw, exporterKey) {
    var org = _getActiveOrg(raw);
    var lics = (0, _slices.fromSlice)(org.lics).filter(function (l) {
        return l.exporters.some(function (e) {
            return e.key === exporterKey;
        });
    });
    if (lics.length === 0) return [];
    var exp = lics[0].exporters.find(function (e) {
        return e.key === exporterKey;
    });
    if (exp.aggregateSupport !== "FILTER") return []; // doesn't support filtering
    return [].concat(_toConsumableArray(new Set(lics.flatMap(function (l) {
        return l.descendants;
    }))));
}

var UserStore = exports.UserStore = function (_ReduceStore) {
    _inherits(UserStore, _ReduceStore);

    function UserStore() {
        _classCallCheck(this, UserStore);

        return _possibleConstructorReturn(this, (UserStore.__proto__ || Object.getPrototypeOf(UserStore)).apply(this, arguments));
    }

    _createClass(UserStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return _LoadObject2.default.empty();
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {
                case _UserActions2.default.START_LOAD:
                    {
                        return state.loading(_DataManager2.default.loadUser());
                    }

                case _UserActions2.default.LOADED:
                    {
                        var u = action.user;
                        var activeOrgs = u.organizations.filter(function (it) {
                            return it.active;
                        });
                        if (activeOrgs.length !== 1) {
                            // per HO-143 - should eventually be a load error
                            throw new Error("User must have exactly one active organization, not " + activeOrgs.length + ".");
                        }
                        var activeOrg = activeOrgs[0];
                        if (false) {
                            if (!u.navTree || !u.navTree.items || u.navTree.items.length === 0) {
                                u.navTree = {
                                    items: [{
                                        label: "Hybrid Outcomes",
                                        url: "."
                                    }, {
                                        items: [{
                                            items: [],
                                            label: "Images",
                                            url: "https://www.google.com/imghp"
                                        }, {
                                            items: [],
                                            label: "GMail",
                                            url: "https://mail.google.com/mail"
                                        }],
                                        label: "Google",
                                        url: "https://www.google.com/"
                                    }]
                                };
                            }
                        }
                        return state.receiveValue({
                            username: u.username,
                            firstname: u.firstname,
                            lastname: u.lastname,
                            superuser: !!u.superuser,
                            mode: u.mode,
                            navTree: u.navTree,
                            activeOrg: activeOrg.key,
                            aggregate: !!activeOrg.aggregate,
                            orgs: (0, _slices.toSlice)(u.organizations, "key", function (o) {
                                return {
                                    name: o.name,
                                    key: o.key,
                                    completeAccess: o.completeAccess,
                                    lics: (0, _slices.toSlice)(o.implementations, "key", function (l) {
                                        return {
                                            key: l.key,
                                            name: l.name,
                                            exporters: l.exporters != null && l.exporters.length > 0 ? l.exporters : null,
                                            igrants: l.igrants,
                                            prefs: Object.keys(l.preferences).reduce(function (m, p) {
                                                return _extends({}, m, _defineProperty({}, p, l.preferences[p][0]));
                                            }, {}),
                                            prefLocks: Object.keys(l.preferences).reduce(function (m, p) {
                                                return _extends({}, m, _defineProperty({}, p, l.preferences[p][1]));
                                            }, {}),
                                            features: new Set(l.features),
                                            descendants: l.descendants
                                        };
                                    }) || (0, _slices.newSlice)(),
                                    prefs: _extends({}, o.preferences)
                                };
                            })
                        });
                    }

                case _UserActions2.default.LOAD_ERROR:
                    {
                        return state.receiveError(action.error);
                    }

                case _UserActions2.default.UPDATE_LICENSE_PREFERENCE:
                    {
                        return state.loading(_DataManager2.default.updateLicensePreference(action.impl, action.pref, action.value));
                    }

                case _UserActions2.default.LICENSE_PREFERENCE_UPDATED:
                    {
                        return state.map(function (raw) {
                            return withUpdatedLicensePreference(raw, action.impl, action.pref, action.newValue);
                        }).done();
                    }

                case _UserActions2.default.LICENSE_PREFERENCE_UPDATE_ERROR:
                    {
                        return state.setError(action.error).done();
                    }

                case _SearchFormActions2.default.INITIATE_SEARCH_AND_SAVE_DEFAULT:
                    {
                        return saveOrgUserPref(state, "default-search-query", JSON.stringify(_SearchFormStore2.default.getSearchToSave(action[_ContextedReduceStore.ACTION_CONTEXT_KEY])));
                    }

                case _UserActions2.default.UPDATE_ORG_USER_PREFERENCE:
                    {
                        return saveOrgUserPref(state, action.pref, action.value);
                    }

                case _UserActions2.default.ORG_USER_PREFERENCE_UPDATED:
                    {
                        return state.map(function (raw) {
                            raw = withUpdatedOrgPreference(raw, action.pref, action.newValue);
                            // The server is the canonical home of this dependency,
                            // but the way the API works, there isn't a way to
                            // represent it across the wire. So double-implement for
                            // now. If it comes up again, we can revisit the API's
                            // structure to address this case more gracefully and
                            // then retrofit.
                            if (action.pref === "use-default-search" && !action.newValue) {
                                raw = withUpdatedOrgPreference(raw, "default-search-query", "{}");
                            }
                            return raw;
                        }).done();
                    }

                case _UserActions2.default.ORG_USER_PREFERENCE_UPDATE_ERROR:
                    {
                        return state.setError(action.error).done();
                    }

                case _GxepActions2.default.SAVED:
                    {
                        // update the active org's password...
                        return state.map(function (raw) {
                            var org = action.packet.find(function (o) {
                                return o.key === raw.activeOrg;
                            });
                            if (org == null) return raw;
                            return withUpdatedOrgPreference(raw, GENERIC_XML_EXPORT_PASSWORD_PREF, org.password);
                        });
                    }

                default:
                    return state;
            }
        }
    }, {
        key: "getUserLO",
        value: function getUserLO() {
            var _this2 = this;

            return (0, _storeUtils.hotLoadObject)(function () {
                return _this2.getState();
            }, function () {
                return _Dispatcher2.default.dispatch({
                    type: _UserActions2.default.START_LOAD
                });
            });
        }
    }, {
        key: "isRealSession",
        value: function isRealSession() {
            // this one shouldn't initiate
            var lo = this.getState();
            return !lo.hasValue() || lo.getRequiredValue().mode !== "client";
        }
    }, {
        key: "getRawData",
        value: function getRawData() {
            return this.getState().getRequiredValue();
        }
    }, {
        key: "getFirstName",
        value: function getFirstName() {
            return _getFirstName(this.getRawData());
        }
    }, {
        key: "getLastName",
        value: function getLastName() {
            return _getLastName(this.getRawData());
        }
    }, {
        key: "getUsername",
        value: function getUsername() {
            return _getUsername(this.getRawData());
        }
    }, {
        key: "getDisplayName",
        value: function getDisplayName() {
            return _getDisplayName(this.getRawData());
        }
    }, {
        key: "getActiveOrgKey",
        value: function getActiveOrgKey() {
            return _getActiveOrgKey(this.getRawData());
        }
    }, {
        key: "getActiveOrg",
        value: function getActiveOrg() {
            return _getActiveOrg(this.getRawData());
        }
    }, {
        key: "getAllOrgs",
        value: function getAllOrgs() {
            return _getAllOrgs(this.getRawData());
        }
    }, {
        key: "getNavTree",
        value: function getNavTree() {
            return _getNavTree(this.getRawData());
        }
    }, {
        key: "getImplsWithValidationAdmin",
        value: function getImplsWithValidationAdmin() {
            return _getImplsWithValidationAdmin(this.getRawData());
        }
    }, {
        key: "isPrefManForAnything",
        value: function isPrefManForAnything() {
            return _isPrefManForAnything(this.getRawData());
        }
    }, {
        key: "canManageLookups",
        value: function canManageLookups(implKey) {
            return _canManageLookups(this.getRawData(), implKey);
        }
    }, {
        key: "canAISuggestion",
        value: function canAISuggestion(implKey) {
            return _canAISuggestion(this.getRawData(), implKey);
        }
    }, {
        key: "canCrossAppMap",
        value: function canCrossAppMap(implKey) {
            return _canCrossAppMap(this.getRawData(), implKey);
        }
    }, {
        key: "isSuperuser",
        value: function isSuperuser() {
            return this.getRawData().superuser;
        }
    }, {
        key: "isAggregate",
        value: function isAggregate() {
            return this.getRawData().aggregate;
        }
    }, {
        key: "getDescendantOrgKeys",
        value: function getDescendantOrgKeys() {
            return _getDescendantOrgKeys(this.getRawData());
        }
    }, {
        key: "getImplementationDescendantOrgKeys",
        value: function getImplementationDescendantOrgKeys() {
            for (var _len = arguments.length, implKeys = Array(_len), _key = 0; _key < _len; _key++) {
                implKeys[_key] = arguments[_key];
            }

            return _getImplementationDescendantOrgKeys(this.getRawData(), implKeys);
        }
    }, {
        key: "getExporterFilterOrgKeys",
        value: function getExporterFilterOrgKeys(exporterKey) {
            return _getExporterFilterOrgKeys(this.getRawData(), exporterKey);
        }
    }, {
        key: "isGenericXmlExportAvailable",
        value: function isGenericXmlExportAvailable() {
            var org = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            return _isGenericXmlExportAvailable(this.getRawData(), org);
        }
    }, {
        key: "getImplsWithHiddenFieldAdmin",
        value: function getImplsWithHiddenFieldAdmin() {
            return _getImplsWithHiddenFieldAdmin(this.getRawData());
        }
    }, {
        key: "getLicensePreference",
        value: function getLicensePreference(pref, impl) {
            var org = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            return _getLicensePreference(this.getRawData(), pref, impl, org);
        }
    }, {
        key: "getIllegalLabel",
        value: function getIllegalLabel(entityOrImplKey) {
            var impl = entityOrImplKey.indexOf("/") < 0 ? entityOrImplKey : new _EntityName2.default(entityOrImplKey).implKey;
            var label = _getLicensePreference(this.getRawData(), "validation-label-illegal", impl);
            return label || "Illegal";
        }
    }, {
        key: "getLicensePreferenceMutability",
        value: function getLicensePreferenceMutability(pref, impl) {
            var org = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            return _getLicensePreferenceMutability(this.getRawData(), pref, impl, org);
        }
    }, {
        key: "getOrganizationalPreference",
        value: function getOrganizationalPreference(pref) {
            var org = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            return _getOrganizationalPreference(this.getRawData(), pref, org);
        }
    }, {
        key: "hasLicenseFeature",
        value: function hasLicenseFeature(feature, impl) {
            return _hasLicenseFeature(this.getRawData(), feature, impl);
        }
    }, {
        key: "getDefaultSearchConfig",
        value: function getDefaultSearchConfig() {
            var state = this.getState();
            if (!state.hasValue()) {
                return { enabled: false };
            }
            var raw = state.getValueEnforcing();
            var enabled = !!_getOrganizationalPreference(raw, "use-default-search");
            var query = void 0;
            if (enabled) {
                try {
                    query = _getOrganizationalPreference(raw, "default-search-query");
                    query = JSON.parse(query);
                    if (!query.key || !query.fields) {
                        query = undefined;
                    }
                } catch (e) {
                    console.warn("Error parsing default search query", e, query);
                    query = undefined;
                }
            }
            return {
                enabled: enabled,
                query: query
            };
        }
    }, {
        key: "canUseDE",
        value: function canUseDE() {
            return _canUseDE(this.getRawData());
        }
    }, {
        key: "canUseDqr",
        value: function canUseDqr() {
            return _canUseDqr(this.getRawData());
        }
    }, {
        key: "canUseHex",
        value: function canUseHex() {
            return _canUseHex(this.getRawData());
        }
    }, {
        key: "canMergeMagicRoots",
        value: function canMergeMagicRoots() {
            return _canMergeMagicRoots(this.getRawData());
        }
    }, {
        key: "canMergeLookups",
        value: function canMergeLookups() {
            return _canMergeLookups(this.getRawData());
        }
    }, {
        key: "canWrite",
        value: function canWrite(implKey) {
            return _canWrite(this.getRawData(), implKey);
        }
    }, {
        key: "canDelete",
        value: function canDelete(implKey) {
            return _canDelete(this.getRawData(), implKey);
        }
    }, {
        key: "canCreate",
        value: function canCreate(implKey) {
            return _canCreate(this.getRawData(), implKey);
        }
    }, {
        key: "canPrint",
        value: function canPrint(implKey) {
            return _canPrint(this.getRawData(), implKey);
        }
    }, {
        key: "getHexForms",
        value: function getHexForms() {
            return _getHexForms(this.getRawData());
        }
    }]);

    return UserStore;
}(_utils.ReduceStore);

var navItemShape = {
    label: _propTypes2.default.string.isRequired,
    url: _propTypes2.default.string.isRequired
};
navItemShape.items = _propTypes2.default.arrayOf(_propTypes2.default.exact(navItemShape));

UserStore.stateTypes = (0, _loadObjectOf2.default)(_propTypes2.default.exact({
    username: _propTypes2.default.string.isRequired,
    firstname: _propTypes2.default.string.isRequired,
    lastname: _propTypes2.default.string.isRequired,
    superuser: _propTypes2.default.bool.isRequired,
    mode: _propTypes2.default.string.isRequired,
    navTree: _propTypes2.default.exact({
        items: navItemShape.items
    }),
    activeOrg: _propTypes2.default.string.isRequired,
    aggregate: _propTypes2.default.bool,
    orgs: (0, _slices.sliceTypeBuilder)(_propTypes2.default.exact({
        key: _propTypes2.default.string.isRequired,
        name: _propTypes2.default.string.isRequired,
        completeAccess: _propTypes2.default.bool.isRequired,
        lics: (0, _slices.sliceTypeBuilder)(_propTypes2.default.exact({
            name: _propTypes2.default.string.isRequired,
            key: _propTypes2.default.string.isRequired,
            exporters: _propTypes2.default.array,
            igrants: _propTypes2.default.number.isRequired,
            prefs: _propTypes2.default.objectOf(_propTypes2.default.any),
            prefLocks: _propTypes2.default.objectOf(_propTypes2.default.string),
            features: _propTypes2.default.instanceOf(Set),
            descendants: _propTypes2.default.arrayOf(_propTypes2.default.string)
        })).isRequired,
        prefs: _propTypes2.default.objectOf(_propTypes2.default.any)
    })).isRequired
}));

var userStore = (0, _typeCheckingStore2.default)(new UserStore(_Dispatcher2.default));

exports.default = userStore;

/***/ }),
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TableStore = exports.isUnconfirmedVersionChange = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(13);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _SuperRecordListActions = __webpack_require__(140);

var _SuperRecordListActions2 = _interopRequireDefault(_SuperRecordListActions);

var _RecordActions = __webpack_require__(60);

var _RecordActions2 = _interopRequireDefault(_RecordActions);

var _TableAccess = __webpack_require__(77);

var _TableAccess2 = _interopRequireDefault(_TableAccess);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _TableProxy = __webpack_require__(222);

var _TableProxy2 = _interopRequireDefault(_TableProxy);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _FileUploadActions = __webpack_require__(223);

var _FileUploadActions2 = _interopRequireDefault(_FileUploadActions);

var _MappingActions = __webpack_require__(109);

var _MappingActions2 = _interopRequireDefault(_MappingActions);

var _OverStore = __webpack_require__(61);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _SuperRecordStore = __webpack_require__(36);

var _SuperRecordStore2 = _interopRequireDefault(_SuperRecordStore);

var _stereotypes = __webpack_require__(126);

var _entityFields = __webpack_require__(158);

var _NavigatorStore = __webpack_require__(33);

var _NavigatorStore2 = _interopRequireDefault(_NavigatorStore);

var _ContextedReduceStore = __webpack_require__(30);

var _MapButtonActions = __webpack_require__(141);

var _MapButtonActions2 = _interopRequireDefault(_MapButtonActions);

var _MapDialogActions = __webpack_require__(64);

var _MapDialogActions2 = _interopRequireDefault(_MapDialogActions);

var _SearchResultActions = __webpack_require__(143);

var _SearchResultActions2 = _interopRequireDefault(_SearchResultActions);

var _MappingStore = __webpack_require__(65);

var _MappingStore2 = _interopRequireDefault(_MappingStore);

var _TableMappingVisitor = __webpack_require__(483);

var _TableMappingVisitor2 = _interopRequireDefault(_TableMappingVisitor);

var _MergeActions = __webpack_require__(59);

var _MergeActions2 = _interopRequireDefault(_MergeActions);

var _MergeStore = __webpack_require__(53);

var _MergeStore2 = _interopRequireDefault(_MergeStore);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isEntityAction = function isEntityAction(action) {
    return _EntityName2.default.is(action.recordKey);
};

var isUnconfirmedVersionChange = exports.isUnconfirmedVersionChange = function isUnconfirmedVersionChange(tableStoreOrAccess, action) {
    if (!action[_RecordActions.OPT_USER_INITIATED] || action[_RecordActions.OPT_USER_CONFIRMED]) {
        // only confirm user actions need confirmation
        return false;
    }
    if (!(0, _entityFields.isVersionInfluencing)(action.recordKey, action.fieldKey)) {
        // only confirm version-influencing fields
        return false;
    }
    var access = void 0;
    if (tableStoreOrAccess instanceof TableStore) {
        access = new _TableAccess2.default(tableStoreOrAccess.getState());
    } else if (tableStoreOrAccess instanceof _TableAccess2.default) {
        access = tableStoreOrAccess;
    } else {
        throw new Error("Illegal tableStoreOrAccess passed");
    }
    // will the new value change the version?
    var ei = _entityMetaStore2.default.getInfo(action.recordKey);
    (0, _invariant2.default)(ei.type === "ROOT", "Only ROOT entities can change versions, not %s", ei.type);
    var tp = new _TableProxy2.default(access, ei.tableKey, action.recordId);
    var ep = new _EntityProxy2.default(tp, action.recordKey);
    if (false) {
        // sanity checks
        if (!tp.isEntity(ei) || !ep.isCorrectVersion()) {
            console.warn("Record " + action.recordId + " isn't a '" + action.recordKey + "'?!");
        }
    }
    access.updateEntityRecordField(action.recordKey, action.recordId, action.fieldKey, action.value);
    return !ep.isCorrectVersion();
};

var takeSnapshot = function takeSnapshot(state) {
    return _extends({}, state, {
        _snapshot: clearSnapshot(state)
    });
};

// eslint-disable-next-line no-unused-vars
var _getSnapshot = function _getSnapshot(state) {
    return state._snapshot;
};

var clearSnapshot = function clearSnapshot(state) {
    if (state._snapshot == null) return state;
    state = _extends({}, state);
    delete state._snapshot;
    return state;
};

var restoreSnapshot = function restoreSnapshot(state) {
    var snap = state._snapshot;
    if (snap == null) return state; // nothing to do
    state = clearSnapshot(state);
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = Object.keys(snap.tables)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var tk = _step.value;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Object.keys(snap.tables[tk])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var id = _step2.value;

                    state.tables[tk][id] = snap.tables[tk][id];
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return state;
};

var _mapping_workflow = function _mapping_workflow(state) {

    // ensure MappingStore goes first
    _Dispatcher2.default.waitFor([// todo: get this.dispatcher...
    _MappingStore2.default.getDispatchToken()]);

    // If MappingStore didn't change, I won't either.
    if (!_MappingStore2.default.hasChanged()) return state;

    // If MappingStore isn't ready, wait until it is.
    if (!_MappingStore2.default.isReady()) return state;

    /*
     * We are GO!
     */

    var tableAccess = new _TableAccess2.default(state);
    var snap = _getSnapshot(state);
    new _TableMappingVisitor2.default(_MappingStore2.default.getState(), tableAccess, snap == null ? null : new _TableAccess2.default(snap, true)).execute();

    return tableAccess.getState();
};

var _do_final_global_merge_work = function _do_final_global_merge_work(state) {
    if (_MergeStore2.default.isReady()) return state; // not merging anything
    var access = new _TableAccess2.default(state);
    // update any global references of source id to target id
    var mergeState = _MergeStore2.default.getState();
    access.remapGlobalMergeTargetToSource(mergeState.target, mergeState.source);
    return clearSnapshot(access.getState()); // finally cleanup the snapshot.
};

var _do_final_mapping_work = function _do_final_mapping_work(state) {
    if (_MergeStore2.default.isReady()) return clearSnapshot(state); // not merging anything, mapping completed.
    var access = new _TableAccess2.default(state);
    switch (_MergeStore2.default.getPluginKey()) {
        case _MergeStore.MERGE_PLUGINS.RECORD_MERGE:
            {
                var action = _MergeStore2.default.getDeleteAction();
                var args = [action.recordKey, action.recordId];
                isEntityAction(action) ? access.deleteEntityRecord.apply(access, args) : access.deleteTableRecord.apply(access, args);
                return clearSnapshot(access.getState());
            }

        case _MergeStore.MERGE_PLUGINS.CHILD_MERGE:
            {
                var _action = _MergeStore2.default.getDeleteAction();
                var _args = [_action.recordKey, _action.recordId, _action.fieldKey, _action.childId];
                isEntityAction(_action) ? access.deleteEntityChild.apply(access, _args) : access.deleteTableChild.apply(access, _args);
                return clearSnapshot(access.getState());
            }
        // no client delete necessary.
        case _MergeStore.MERGE_PLUGINS.GLOBAL_MERGE:
            // global merge is not complete until SuperRecordActions.UPDATED
            // happens. Keep the snapshot until then.
            return state;
        default:
            // unknown merge plugin.
            return clearSnapshot(state);
    }
};

/**
 * I store table-level record data. I replace PersistenceContext (drink!). I
 * don't manage loading state; a record is either here or not, period.
 */

var TableStore = exports.TableStore = function (_ReduceStore) {
    _inherits(TableStore, _ReduceStore);

    function TableStore() {
        _classCallCheck(this, TableStore);

        return _possibleConstructorReturn(this, (TableStore.__proto__ || Object.getPrototypeOf(TableStore)).apply(this, arguments));
    }

    _createClass(TableStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {
                tables: {},
                listQueue: {}
            };
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {

                case _SuperRecordActions2.default.LOADED:
                case _SuperRecordActions2.default.CREATED:
                    {
                        var access = new _TableAccess2.default(state);
                        access.loadSuperRecordPacket(action.data);
                        return _mapping_workflow(access.getState());
                    }

                case _SuperRecordActions2.default.UPDATED:
                    {
                        return _do_final_global_merge_work(new _TableAccess2.default(state).loadSuperRecordPacket(action.data).getState());
                    }

                case _SuperRecordListActions2.default.LOADED:
                    {
                        var _access = new _TableAccess2.default(state);
                        action.data.forEach(function (packet) {
                            return _access.loadSuperRecordPacket(packet);
                        });
                        _access.processListQueue(action.key, action.data.map(function (r) {
                            return r.id;
                        }));
                        return _mapping_workflow(_access.getState());
                    }

                case _FileUploadActions2.default.COMPLETE:
                    {
                        var _access2 = new _TableAccess2.default(state);
                        var value = _extends({}, action.file, action.value);
                        if (value._multiValued) {
                            value = _access2.addToEntityCollection(action.recordKey, action.recordId, action.fieldKey, value);
                        }
                        var args = [action.recordKey, action.recordId, action.fieldKey, value];
                        if (isEntityAction(action)) {
                            _access2.updateEntityRecordField.apply(_access2, args);
                        } else {
                            _access2.updateTableRecordColumn.apply(_access2, args);
                        }
                        return _access2.getState();
                    }

                case _RecordActions2.default.SET_FIELD:
                    {
                        var _access3 = new _TableAccess2.default(state);
                        var _args2 = [action.recordKey, action.recordId, action.fieldKey, action.value];
                        if (isEntityAction(action)) {
                            if (isUnconfirmedVersionChange(this, action)) {
                                return state;
                            }
                            _access3.updateEntityRecordField.apply(_access3, _args2);
                        } else {
                            _access3.updateTableRecordColumn.apply(_access3, _args2);
                        }
                        return _access3.getState();
                    }

                case _SuperRecordActions2.default.NEW:
                case _RecordActions2.default.NEW:
                    {
                        var _access4 = new _TableAccess2.default(state);
                        var _args3 = [action.recordKey, action.newId];
                        isEntityAction(action) ? _access4.createEntityRecord.apply(_access4, _args3) : _access4.createTableRecord.apply(_access4, _args3);
                        return _access4.getState();
                    }

                case _RecordActions2.default.NEW_CHILD:
                    {
                        var _access5 = new _TableAccess2.default(state);
                        var _args4 = [action.recordKey, action.recordId, action.fieldKey, action.newId, action.insertAt];
                        isEntityAction(action) ? _access5.createEntityChild.apply(_access5, _args4) : _access5.createTableChild.apply(_access5, _args4);
                        return _access5.getState();
                    }

                case _RecordActions2.default.DELETE_CHILD:
                    {
                        if (!(0, _OverStore.isConfirmed)(action)) return state;
                        var _access6 = new _TableAccess2.default(state);
                        var _args5 = [action.recordKey, action.recordId, action.fieldKey, action.childId];
                        isEntityAction(action) ? _access6.deleteEntityChild.apply(_access6, _args5) : _access6.deleteTableChild.apply(_access6, _args5);
                        return _access6.getState();
                    }

                case _SuperRecordActions2.default.NEW_MAGIC_CHILD:
                    {
                        // this one is different. it receives _stereotypical_ coords and
                        // an explicit entityKey to create, along with the desired newId
                        return new _TableAccess2.default(state).createMagicChild(action.recordId, action.entityKey, action.newId).getState();
                    }

                case _MergeActions2.default.DO_MERGE:
                    {
                        if (!(0, _OverStore.isConfirmed)(action)) return state;
                        return takeSnapshot(state);
                    }

                case _MappingActions2.default.__PROCESS_NEXT_IN_QUEUE:
                    {
                        return takeSnapshot(state);
                    }

                case _MapButtonActions2.default.LAUNCH_DIALOG:
                case _MergeActions2.default.LAUNCH_DIALOG:
                    {
                        return takeSnapshot(state);
                    }

                case _MapButtonActions2.default.AUTOMAP_TO_NEW_MAGIC_CHILD:
                    {
                        var magic = _NavigatorStore2.default.getMagicState(action[_ContextedReduceStore.ACTION_CONTEXT_KEY]);
                        var _access7 = new _TableAccess2.default(state);
                        _access7.createMagicChild(magic.id, action.entityKey, action.newId);
                        // Because of circular deps, don't do workflow here; mapping
                        // will do it again.
                        return clearSnapshot(_access7.getState());
                    }

                case _MapButtonActions2.default.AUTOMAP_FROM:
                    {
                        return clearSnapshot(_mapping_workflow(state));
                    }

                case _MappingActions2.default.MODEL_LOADED:
                case _MapDialogActions2.default.TOGGLE_EXCLUSION:
                case _MapDialogActions2.default.SET_MAGIC_ROOT_EXCLUSION:
                case _MapDialogActions2.default.IMPORT:
                case _SearchResultActions2.default.SEARCH_RESULT:
                case _MappingActions2.default.__DO_IT_AGAIN:
                    {
                        return _mapping_workflow(state);
                    }

                // not MergeActions.CANCEL_FOR_SOURCE_OPTLOCK!
                case _MergeActions2.default.CANCEL:
                case _MapDialogActions2.default.CANCEL:
                case _SuperRecordActions2.default.CANCEL_FOR_OPTLOCK:
                    {
                        return restoreSnapshot(state);
                    }

                case _MappingActions2.default.IT_IS_DONE:
                    {
                        return _do_final_mapping_work(state);
                    }

                case _RecordActions2.default.DELETE_RECORD:
                    {
                        if (!(0, _OverStore.isConfirmed)(action)) return state;
                        var _access8 = new _TableAccess2.default(state);
                        var _args6 = [action.recordKey, action.recordId];
                        isEntityAction(action) ? _access8.deleteEntityRecord.apply(_access8, _args6) : _access8.deleteTableRecord.apply(_access8, _args6);
                        return _access8.getState();
                    }

                case _SuperRecordActions2.default.DELETED:
                    {
                        var _access9 = new _TableAccess2.default(state);
                        var stereoInfo = _StereotypesStore2.default.getStereotypeByKey(action.key);
                        var implementations = (0, _stereotypes.getImplementations)(stereoInfo, _access9, action.id);
                        if (implementations.length === 0) {
                            return _access9.getState();
                        }
                        var entityInfo = _entityMetaStore2.default.getInfo(implementations[0].key);
                        var srInfo = _SuperRecordStore2.default.getRecordLO(action.key, action.id).getValue();
                        // clean up the magic children
                        if (srInfo && srInfo.topLevelIds) {
                            var _iteratorNormalCompletion3 = true;
                            var _didIteratorError3 = false;
                            var _iteratorError3 = undefined;

                            try {
                                for (var _iterator3 = Object.keys(srInfo.topLevelIds)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                    var mck = _step3.value;
                                    var _iteratorNormalCompletion4 = true;
                                    var _didIteratorError4 = false;
                                    var _iteratorError4 = undefined;

                                    try {
                                        for (var _iterator4 = srInfo.topLevelIds[mck][Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                            var mcid = _step4.value;

                                            _access9.deleteEntityRecord(mck, mcid);
                                        }
                                    } catch (err) {
                                        _didIteratorError4 = true;
                                        _iteratorError4 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                                _iterator4.return();
                                            }
                                        } finally {
                                            if (_didIteratorError4) {
                                                throw _iteratorError4;
                                            }
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError3 = true;
                                _iteratorError3 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                        _iterator3.return();
                                    }
                                } finally {
                                    if (_didIteratorError3) {
                                        throw _iteratorError3;
                                    }
                                }
                            }
                        }
                        // do the magic root
                        _access9.deleteEntityRecord(entityInfo.key, action.id);
                        return _access9.getState();
                    }

                default:
                    return state;
            }
        }
    }, {
        key: "hasRecord",
        value: function hasRecord(table, id) {
            return new _TableAccess2.default(this.getState()).hasRecord(table, id);
        }
    }, {
        key: "hasEntityRecord",
        value: function hasEntityRecord(entityKey, id) {
            var ei = _entityMetaStore2.default.getInfo(entityKey);
            return new _TableAccess2.default(this.getState()).hasRecord(ei.tableKey, id);
        }
    }, {
        key: "getRecordData",
        value: function getRecordData(table, id) {
            return new _TableAccess2.default(this.getState()).getRecordData(table, id);
        }
    }, {
        key: "getColumnData",
        value: function getColumnData(table, id, column) {
            return new _TableAccess2.default(this.getState()).getColumnData(table, id, column);
        }
    }, {
        key: "getEntityProxy",
        value: function getEntityProxy(entityKey, id) {
            return new _TableAccess2.default(this.getState()).getEntityProxy(entityKey, id);
        }
    }, {
        key: "getStereotypeProxy",
        value: function getStereotypeProxy(stereoKey, id) {
            return new _TableAccess2.default(this.getState()).getStereotypeProxy(stereoKey, id);
        }
    }, {
        key: "getSnapshot",
        value: function getSnapshot() {
            return _getSnapshot(this.getState());
        }
    }, {
        key: "isWaiting",
        value: function isWaiting() {
            var q = this.getState().listQueue;
            // This is `Object.isEmpty(q)` or something
            for (var ek in q) {
                if (q.hasOwnProperty(ek)) return true;
            }return false;
        }
    }]);

    return TableStore;
}(_utils.ReduceStore);

TableStore.stateTypes = {
    tables: _propTypes2.default.objectOf( // table key
    _propTypes2.default.objectOf( // id
    _propTypes2.default.shape({
        meta: _propTypes2.default.oneOfType([_propTypes2.default.shape({
            id: _propTypes2.default.number.isRequired,
            ts: _propTypes2.default.number.isRequired,
            waiting: _propTypes2.default.bool.isRequired
        }), _propTypes2.default.shape({
            id: _ClientId2.default.propType.isRequired,
            waiting: _propTypes2.default.bool.isRequired
        })]).isRequired,
        // arbitrary stuff
        data: _propTypes2.default.object.isRequired
    }))).isRequired,
    listQueue: _propTypes2.default.objectOf(
    // these are passed a TableAccess and an array of IDs (the list)
    _propTypes2.default.arrayOf(_propTypes2.default.func)).isRequired,
    _snapshot: _propTypes2.default.any
};

exports.default = (0, _typeCheckingStore2.default)(new TableStore(_Dispatcher2.default));

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var builder = function builder(self, method, type, initial) {
    var name = self.constructor.name;
    method = method.bind(self);
    var typesKey = type + "Types";
    var typeSpecs = self.constructor[typesKey];
    if (typeSpecs == null) {
        throw new Error("No " + typesKey + " defined for " + name + "; can't activate type checking.");
    }
    // PropTypes doesn't allow you to declare type information where the
    // top-level properties are anonymous, which is exactly what is needed for
    // an "id lookup"-style Store. Rather than forcing the Store to deal with
    // the extra layer just to get typechecking, assume that if the store's
    // type info is a function, it's the result of an `objectOf` call for the
    // top-level state object itself. The extra named layer will be created
    // implicitly before validating. And, in fact, `objectOf` is in no way
    // special; this mechanism will allow any checker to be used for a store.
    var isChecker = typeof typeSpecs === "function";
    if (isChecker) {
        typeSpecs = { state: typeSpecs };
    }
    var check = function check(next) {
        if (isChecker) {
            next = { state: next };
        }
        _propTypes2.default.checkPropTypes(typeSpecs, next, type, name);
    };
    if (initial != null) {
        check(initial);
    }
    return function (curr, action, contextId) {
        var next = method(curr, action, contextId);
        if (!self.areEqual(curr, next)) {
            check(next);
        }
        return next;
    };
};

var typeCheckingStore = function typeCheckingStore(self) {
    if (self.reduceContext) {
        // contexted
        self.reduceContext = builder(self, self.reduceContext, "context", self.getInitialContext());
        if (self.reduceEachContext) {
            self.reduceEachContext = builder(self, self.reduceEachContext, "context");
        }
    } else if (self.reduce) {
        self.reduce = builder(self, self.reduce, "state", self.getInitialState());
    } else {
        throw new Error("No 'reduce' method found on store.");
    }
    return self;
};

exports.default =  true ? function (self) {
    return self;
} : typeCheckingStore;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NONE = "NONE";
var LOADING = "LOADING";
var CREATING = "CREATING";
var UPDATING = "UPDATING";
var DELETING = "DELETING";

// LoadObjects expose a promise for their work to facilitate migration of
// non-reactive flows (all the controller spaghetti!). They should NOT be used
// in new code.

// don't let clients construct new instances - use a factory!
var SECRET = "SECRET:" + Math.random();

var LoadObject = function () {
    function LoadObject(secret, state, hasValue, value, error, promise, propTypes) {
        _classCallCheck(this, LoadObject);

        if (secret !== SECRET) {
            throw new Error("Construct LoadObjects via static LoadObject.empty()");
        }
        this._operation = state;
        this._hasValue = hasValue;
        this._value = value;
        this._error = error;
        this._promise = promise;
        this._propTypes = propTypes;
    }

    _createClass(LoadObject, [{
        key: "getOperation",
        value: function getOperation() {
            return this._operation;
        }
    }, {
        key: "isPending",
        value: function isPending() {
            // armus
            return this.hasOperation();
        }
    }, {
        key: "isDone",
        value: function isDone() {
            // compat
            return !this.hasOperation();
        }
    }, {
        key: "hasOperation",
        value: function hasOperation() {
            // compat
            return this._operation !== NONE;
        }
    }, {
        key: "isLoading",
        value: function isLoading() {
            return this._operation === LOADING;
        }
    }, {
        key: "isCreating",
        value: function isCreating() {
            return this._operation === CREATING;
        }
    }, {
        key: "isUpdating",
        value: function isUpdating() {
            return this._operation === UPDATING;
        }
    }, {
        key: "isDeleting",
        value: function isDeleting() {
            return this._operation === DELETING;
        }
    }, {
        key: "isEmpty",
        value: function isEmpty() {
            return !this.hasValue() && !this.hasOperation() && !this.hasError();
        }
    }, {
        key: "map",
        value: function map(work) {
            if (!this.hasValue()) {
                return this;
            }
            var curr = this.getValueEnforcing();
            var next = work(curr);
            if (curr === next) {
                return this;
            }
            return this.setValue(next);
        }
    }, {
        key: "setOperation",
        value: function setOperation(operation) {
            // compat
            throw new Error("setOperation is not supported, because Promise junk.");
        }
    }, {
        key: "setValue",
        value: function setValue(value) {
            if (false) {
                var pt = this._propTypes;
                _propTypes2.default.checkPropTypes(pt.typeSpecs, value, "key", pt.componentName);
            }
            return new LoadObject(SECRET, this._operation, true, value, this._error, this._promise, this._propTypes);
        }
    }, {
        key: "clearValue",
        value: function clearValue() {
            // armus
            return this.removeValue();
        }
    }, {
        key: "removeValue",
        value: function removeValue() {
            if (this._value === undefined && this._hasValue === false) {
                return this;
            }
            return new LoadObject(SECRET, this._operation, false, undefined, this._error, this._promise, this._propTypes);
        }
    }, {
        key: "hasValue",
        value: function hasValue() {
            return this._hasValue;
        }
    }, {
        key: "getValue",
        value: function getValue() {
            return this._value;
        }
    }, {
        key: "getRequiredValue",
        value: function getRequiredValue() {
            // armus
            return this.getValueEnforcing();
        }
    }, {
        key: "getValueEnforcing",
        value: function getValueEnforcing() {
            // compat
            if (!this.hasValue()) {
                throw new Error("This LoadObject does not have a value");
            }
            return this._value;
        }
    }, {
        key: "setError",
        value: function setError(error) {
            return new LoadObject(SECRET, this._operation, this._hasValue, this._value, error, undefined, this._propTypes);
        }
    }, {
        key: "clearError",
        value: function clearError() {
            // armus
            return this.removeError();
        }
    }, {
        key: "removeError",
        value: function removeError() {
            // compat
            if (this._error === undefined) {
                return this;
            }
            return new LoadObject(SECRET, this._operation, this._hasValue, this._value, undefined, undefined, this._propTypes);
        }
    }, {
        key: "hasError",
        value: function hasError() {
            return this._error != null;
        }
    }, {
        key: "getError",
        value: function getError() {
            return this._error;
        }
    }, {
        key: "getRequiredError",
        value: function getRequiredError() {
            // armus
            return this.getErrorEnforcing();
        }
    }, {
        key: "getErrorEnforcing",
        value: function getErrorEnforcing() {
            // compat
            if (!this.hasError()) {
                throw new Error("This LoadObject does not have an error");
            }
            return this._error;
        }
    }, {
        key: "promise",
        value: function promise() {
            if (this.isPending()) {
                return this._promise;
            }
            if (this.hasValue()) {
                return Promise.resolve(this.getValueEnforcing());
            }
            if (this.hasError()) {
                return Promise.reject(this.getErrorEnforcing());
            }
            throw new Error("Empty LoadObjects can't make promises");
        }
    }, {
        key: "loading",
        value: function loading(promise) {
            return new LoadObject(SECRET, LOADING, this._hasValue, this._value, this._error, promise, this._propTypes);
        }
    }, {
        key: "creating",
        value: function creating(promise) {
            return new LoadObject(SECRET, CREATING, this._hasValue, this._value, this._error, promise, this._propTypes);
        }
    }, {
        key: "updating",
        value: function updating(promise) {
            return new LoadObject(SECRET, UPDATING, this._hasValue, this._value, this._error, promise, this._propTypes);
        }
    }, {
        key: "deleting",
        value: function deleting(promise) {
            return new LoadObject(SECRET, DELETING, this._hasValue, this._value, this._error, promise, this._propTypes);
        }
    }, {
        key: "done",
        value: function done() {
            return this.removeOperation();
        }
    }, {
        key: "removeOperation",
        value: function removeOperation() {
            // compat
            if (this._operation === NONE) {
                return this;
            }
            return new LoadObject(SECRET, NONE, this._hasValue, this._value, this._error, undefined, this._propTypes);
        }
    }, {
        key: "receiveValue",
        value: function receiveValue(value) {
            return this.done().setValue(value);
        }
    }, {
        key: "receiveError",
        value: function receiveError(error) {
            return this.done().setError(error);
        }
    }, {
        key: "withPropTypes",
        value: function withPropTypes(typeSpecs) {
            var componentName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "LoadObject";

            if (true) {
                return this;
            } else {
                if (this._hasValue) {
                    _propTypes2.default.checkPropTypes(typeSpecs, this._value, "key", componentName);
                }
                return new LoadObject(SECRET, this._operation, this._hasValue, this._value, this._error, this._promise, {
                    typeSpecs: typeSpecs,
                    componentName: componentName
                });
            }
        }
    }], [{
        key: "load",
        value: function load(promise) {
            // armus
            return LoadObject.loading(promise);
        }
    }, {
        key: "loading",
        value: function loading(promise) {
            // compat
            return new LoadObject(SECRET, LOADING, false, undefined, undefined, promise);
        }
    }, {
        key: "creating",
        value: function creating(promise) {
            // compat
            return new LoadObject(SECRET, CREATING, false, undefined, undefined, promise);
        }
    }, {
        key: "updating",
        value: function updating(promise) {
            // compat
            return new LoadObject(SECRET, UPDATING, false, undefined, undefined, promise);
        }
    }, {
        key: "deleting",
        value: function deleting(promise) {
            // compat
            return new LoadObject(SECRET, DELETING, false, undefined, undefined, promise);
        }
    }, {
        key: "empty",
        value: function empty() {
            return new LoadObject(SECRET, NONE, false);
        }
    }, {
        key: "withValue",
        value: function withValue(value) {
            return LoadObject.empty().setValue(value);
        }
    }, {
        key: "withError",
        value: function withError(error) {
            return LoadObject.empty().setError(error);
        }
    }]);

    return LoadObject;
}();

exports.default = LoadObject;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildStereotypeFields = exports.getRecordComparator = exports.getOrderingComponents = exports.getFieldType = exports.getDataQualityStereotypes = exports.getLookupStereotypes = exports.getMergeStereotypes = exports.getDataEntryStereotypes = exports.getAllStereotypes = exports.getStereotypeByKey = exports.getMagicRoot = exports.getDefault = exports.getDefaultKey = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

var _StereotypesActions = __webpack_require__(473);

var _StereotypesActions2 = _interopRequireDefault(_StereotypesActions);

var _utils = __webpack_require__(13);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _storeUtils = __webpack_require__(54);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _DataManager = __webpack_require__(43);

var _DataManager2 = _interopRequireDefault(_DataManager);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _compareRecords = __webpack_require__(475);

var _StereotypeProjection = __webpack_require__(962);

var _StereotypeProjection2 = _interopRequireDefault(_StereotypeProjection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _getDefaultKey = function _getDefaultKey(state) {
    return state.defaultKey.getRequiredValue();
};

exports.getDefaultKey = _getDefaultKey;
var _getDefault = function _getDefault(state) {
    return _getStereotypeByKey(state, _getDefaultKey(state));
};

exports.getDefault = _getDefault;
var _getMagicRoot = function _getMagicRoot(state) {
    var forEntity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var all = _getAllStereotypes(state);
    var predicate = function predicate(stereotype) {
        return stereotype.magicRoot === true;
    };
    if (!forEntity) return all.find(predicate);
    var en = void 0;
    if (typeof forEntity === "string") {
        en = new _EntityName2.default(forEntity);
    } else if (forEntity instanceof _EntityName2.default) {
        en = forEntity;
    } else {
        throw new Error("Unsupported '" + forEntity + "' forEntity value; use an EntityName or a three-part entity key");
    }
    return all.filter(predicate).find(function (stereotype) {
        return stereotype.creatables.some(function (creatable) {
            return creatable.versions.some(function (version) {
                return version.key.indexOf(en.implKey) === 0;
            });
        });
    });
};

exports.getMagicRoot = _getMagicRoot;
var _getStereotypeByKey = function _getStereotypeByKey(state, key) {
    if (!state.byKey.hasOwnProperty(key)) {
        if (!state.defaultKey || !state.defaultKey.hasValue()) {
            throw new Error("RACE? Let global stereotypes load before requesting '" + key + "'.");
        }
        throw new Error("No '" + key + "' stereotype is known.");
    }
    var lo = state.byKey[key];
    if (!lo.hasValue()) {
        throw new Error("RACE? The '" + key + "' stereotype is loading...");
    }
    var s = lo.getValueEnforcing();
    if (s == null) {
        throw new Error("No '" + key + "' stereotype is known.");
    }
    return s;
};

exports.getStereotypeByKey = _getStereotypeByKey;
var _getAllStereotypes = function _getAllStereotypes(state) {
    var result = [];
    Object.entries(state.byKey).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            lo = _ref2[1];

        return lo.hasValue() && result.push(lo.getRequiredValue());
    });
    return result;
};

exports.getAllStereotypes = _getAllStereotypes;
var _getDataEntryStereotypes = function _getDataEntryStereotypes(state) {
    return _getAllStereotypes(state).filter(function (stereotype) {
        return stereotype.magicRoot || stereotype.magicRootKey != null;
    });
};

exports.getDataEntryStereotypes = _getDataEntryStereotypes;
var _getMergeStereotypes = function _getMergeStereotypes(state) {
    return _getAllStereotypes(state).filter(function (stereotype) {
        return stereotype.magicRoot;
    });
};

exports.getMergeStereotypes = _getMergeStereotypes;
var _getLookupStereotypes = function _getLookupStereotypes(state) {
    return _getAllStereotypes(state).filter(function (stereotype) {
        return !stereotype.magicRoot && stereotype.magicRootKey == null && stereotype.creatables.length;
    });
};

exports.getLookupStereotypes = _getLookupStereotypes;
var _getDataQualityStereotypes = function _getDataQualityStereotypes(state) {
    return _getAllStereotypes(state).filter(function (stereotype) {
        return stereotype.magicRootKey != null;
    });
};

exports.getDataQualityStereotypes = _getDataQualityStereotypes;
var getFieldType = exports.getFieldType = function getFieldType(stereoInfo, fieldKey) {
    return (
        // todo: index this instead of scanning
        stereoInfo.fields.find(function (it) {
            return it.key === fieldKey;
        }).type.toUpperCase()
    );
}; // for reasons that are unclear, stereotype field types were lowercased into model.js...

var getOrderingComponents = exports.getOrderingComponents = function getOrderingComponents(stereoInfo) {
    return (stereoInfo.orderingComponents || []).map(function (c) {
        return _extends({}, c, {
            type: getFieldType(stereoInfo, c.key)
        });
    });
};

var getRecordComparator = exports.getRecordComparator = function getRecordComparator(stereoInfo) {
    var components = getOrderingComponents(stereoInfo);
    var comparator = (0, _compareRecords.objectBuilder)(components);
    return function (a, b) {
        return comparator(new _StereotypeProjection2.default(stereoInfo, a), new _StereotypeProjection2.default(stereoInfo, b));
    };
};

var buildStereotypeFields = exports.buildStereotypeFields = function buildStereotypeFields(state, stereotypeKey) {
    var stereotype = _getStereotypeByKey(state, stereotypeKey);
    if (stereotype) {
        return stereotype.fields.map(function (field) {
            var newField = _extends({}, field, { stereotypeKey: stereotypeKey });
            if (field.otherStereotype && (field.type === "to-one" || field.type === "to-many")) {
                var relStereotype = _getStereotypeByKey(state, field.otherStereotype);
                if ((typeof relStereotype === "undefined" ? "undefined" : _typeof(relStereotype)) === "object") {
                    /*
                      not sure where this renaming came from but it seems like if
                      the meta author named the relationship something we would
                      not want to override that? Keeping the override for now.
                    */
                    newField.name = relStereotype.name;
                    // recursive: could cause infinite loop if circular relationship exists.
                    // Not sure if this situation exists:
                    // User -> Group ... Group -> User
                    newField.fields = buildStereotypeFields(state, relStereotype.key);
                }
            }
            return newField;
        });
    }
    return false;
};

var id_seq = 0;

var prepStereotypeInfo = function prepStereotypeInfo(s) {
    var scripts = s.scripts || {};
    if (scripts.hasOwnProperty("toString")) {
        // eslint-disable-next-line no-new-func
        scripts.toString = new Function("instance", scripts.toString);
    }
    if (scripts.hasOwnProperty("toDetailString")) {
        // eslint-disable-next-line no-new-func
        scripts.toDetailString = new Function("instance", scripts.toDetailString);
    }
    return _extends({}, s, {
        fields: s.fields.map(function (field) {
            var processedField = _extends({}, field, {
                id: "sfi" + ++id_seq
            });
            if (field.expectedValues && field.expectedValues.length > 0) {
                processedField.hasExpectedValues = true;
                processedField.expectedValueLookup = field.expectedValues.reduce(function (l, v) {
                    return _extends({}, l, _defineProperty({}, v.value, v.label));
                }, {});
            }
            return processedField;
        }),
        synthetic: _EntityName2.default.is(s.key),
        scripts: scripts,
        // todo: make an index to avoid scanning
        implementations: (s.implementations || []).map(function (it) {
            var en = new _EntityName2.default(it.key);
            return _extends({}, it, {
                implementationKey: en.implKey,
                versionKey: en.versionKey,
                // todo: make an index to avoid scanning
                fieldImpls: it.fieldImpls.map(function (fi) {
                    return _extends({}, fi, {
                        script: fi.script != null
                        // eslint-disable-next-line no-new-func
                        ? new Function("instance", "return (" + fi.script + ");") : function () {
                            return null;
                        }
                    });
                })
            });
        })
    });
};

var fieldShape = {
    key: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    otherStereotype: _propTypes2.default.string,
    type: _propTypes2.default.string.isRequired
};
fieldShape.value = _propTypes2.default.arrayOf(_propTypes2.default.shape(fieldShape));
var stereoShape = {
    creatables: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        defaultKey: _propTypes2.default.string,
        label: _propTypes2.default.string.isRequired,
        orgs: _propTypes2.default.arrayOf(_propTypes2.default.string),
        versions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            key: _propTypes2.default.string.isRequired,
            label: _propTypes2.default.string.isRequired
        })).isRequired
    })).isRequired,
    defaultFieldKey: _propTypes2.default.string,
    fields: _propTypes2.default.arrayOf(_propTypes2.default.shape(fieldShape)).isRequired,
    key: _propTypes2.default.string.isRequired,
    magicRoot: _propTypes2.default.bool.isRequired,
    magicRootKey: _propTypes2.default.string,
    magicChildKey: _propTypes2.default.string,
    name: _propTypes2.default.string.isRequired,
    pluralName: _propTypes2.default.string.isRequired,
    supportsEnablement: _propTypes2.default.bool.isRequired,
    scripts: _propTypes2.default.shape({
        toString: _propTypes2.default.func.isRequired,
        toDetailString: _propTypes2.default.func
    }).isRequired,
    implementations: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        key: _propTypes2.default.string.isRequired,
        name: _propTypes2.default.string.isRequired,
        implementationKey: _propTypes2.default.string.isRequired,
        implementationName: _propTypes2.default.string.isRequired,
        versionKey: _propTypes2.default.string.isRequired,
        versionName: _propTypes2.default.string.isRequired,
        entityName: _propTypes2.default.string.isRequired,
        childKey: _propTypes2.default.string,
        creatable: _propTypes2.default.bool,
        fieldImpls: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            key: _propTypes2.default.string.isRequired,
            script: _propTypes2.default.func.isRequired
        }))
    })),
    synthetic: _propTypes2.default.bool.isRequired,
    orderingComponents: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        key: _propTypes2.default.string.isRequired,
        ascending: _propTypes2.default.bool.isRequired
    }))
};

var StereotypesStore = function (_ReduceStore) {
    _inherits(StereotypesStore, _ReduceStore);

    function StereotypesStore() {
        _classCallCheck(this, StereotypesStore);

        return _possibleConstructorReturn(this, (StereotypesStore.__proto__ || Object.getPrototypeOf(StereotypesStore)).call(this, _Dispatcher2.default));
    }

    _createClass(StereotypesStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {
                defaultKey: _LoadObject2.default.empty(), // LoadObject<String>
                byKey: {} // Map<String, LoadObject<Stereotype>>
            };
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {
                case _StereotypesActions2.default.START_LOAD:
                    this.__dispatcher.waitFor([_userStore2.default.getDispatchToken()]);
                    return _extends({}, state, {
                        defaultKey: state.defaultKey.loading(_DataManager2.default.loadStereotypes(_userStore2.default.getActiveOrgKey()))
                    });
                case _StereotypesActions2.default.LOADED:
                    state = _extends({}, state, {
                        defaultKey: state.defaultKey.receiveValue(action.data.defaultKey),
                        byKey: _extends({}, state.byKey)
                    });
                    action.data.stereotypes.map(prepStereotypeInfo).forEach(function (s) {
                        state.byKey[s.key] = (state.byKey[s.key] || _LoadObject2.default.empty().withPropTypes(stereoShape)).receiveValue(s);
                    });
                    return state;
                case _StereotypesActions2.default.LOAD_ERROR:
                    return {
                        defaultKey: state.defaultKey.receiveError(action.error)
                    };

                case _StereotypesActions2.default.START_STEREOTYPE_LOAD:
                    {
                        (0, _invariant2.default)(state.defaultKey && state.defaultKey.hasValue(), "Request for single stereotype before request for all?");
                        return _extends({}, state, {
                            byKey: _extends({}, state.byKey, _defineProperty({}, action.key, (state.byKey[action.key] || _LoadObject2.default.empty().withPropTypes(stereoShape)).loading(_DataManager2.default.loadStereotype(action.key))))
                        });
                    }

                case _StereotypesActions2.default.STEREOTYPE_LOADED:
                    return _extends({}, state, {
                        byKey: _extends({}, state.byKey, _defineProperty({}, action.key, (state.byKey[action.key] || _LoadObject2.default.empty().withPropTypes(stereoShape)).receiveValue(prepStereotypeInfo(action.data))))
                    });
                case _StereotypesActions2.default.STEREOTYPE_LOAD_ERROR:
                    return _extends({}, state, {
                        byKey: _extends({}, state.byKey, _defineProperty({}, action.key, (state.byKey[action.key] || _LoadObject2.default.empty().withPropTypes(stereoShape)).receiveError(action.error)))
                    });
                default:
                    return state;
            }
        }
    }, {
        key: "getDefaultKey",
        value: function getDefaultKey() {
            return _getDefaultKey(this.getState());
        }
    }, {
        key: "getDefault",
        value: function getDefault() {
            return _getDefault(this.getState());
        }
    }, {
        key: "getMagicRoot",
        value: function getMagicRoot() {
            var forEntity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            return _getMagicRoot(this.getState(), forEntity);
        }
    }, {
        key: "getStereotypeByKey",
        value: function getStereotypeByKey(key) {
            return _getStereotypeByKey(this.getState(), key);
        }
    }, {
        key: "getStereotypesByKeys",
        value: function getStereotypesByKeys(keys) {
            var s = this.getState();
            return keys.map(function (k) {
                return _getStereotypeByKey(s, k);
            });
        }
    }, {
        key: "getStereotypeFieldsByKey",
        value: function getStereotypeFieldsByKey(key) {
            return buildStereotypeFields(this.getState(), key);
        }
    }, {
        key: "getStereotypeLO",
        value: function getStereotypeLO(key) {
            var _this2 = this;

            return (0, _storeUtils.hotLoadObject)(function () {
                return _this2.getState().byKey[key];
            }, function () {
                return _Dispatcher2.default.dispatch({
                    type: _StereotypesActions2.default.START_STEREOTYPE_LOAD,
                    key: key
                });
            });
        }
    }, {
        key: "getAllStereotypesLO",
        value: function getAllStereotypesLO() {
            var _this3 = this;

            return (0, _storeUtils.hotLoadObject)(function () {
                return _this3.getState().defaultKey;
            }, function () {
                return _Dispatcher2.default.dispatch({
                    type: _StereotypesActions2.default.START_LOAD
                });
            });
        }
    }, {
        key: "getAllStereotypes",
        value: function getAllStereotypes() {
            return _getAllStereotypes(this.getState());
        }
    }, {
        key: "getDataEntryStereotypes",
        value: function getDataEntryStereotypes() {
            return _getDataEntryStereotypes(this.getState());
        }
    }, {
        key: "getMergeStereotypes",
        value: function getMergeStereotypes() {
            return _getMergeStereotypes(this.getState());
        }
    }, {
        key: "getLookupStereotypes",
        value: function getLookupStereotypes() {
            return _getLookupStereotypes(this.getState());
        }
    }, {
        key: "getDataQualityStereotypes",
        value: function getDataQualityStereotypes() {
            return _getDataQualityStereotypes(this.getState());
        }
    }, {
        key: "getImplementations",
        value: function getImplementations(key) {
            return this.getStereotypeByKey(key).implementations;
        }
    }]);

    return StereotypesStore;
}(_utils.ReduceStore);

exports.default = new StereotypesStore();

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EntityFieldMetaStore = exports.getFieldInfoComparator = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(13);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _dotPropImmutable = __webpack_require__(40);

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _DefineActions = __webpack_require__(124);

var _DefineActions2 = _interopRequireDefault(_DefineActions);

var _humanizedKeyList = __webpack_require__(477);

var _humanizedKeyList2 = _interopRequireDefault(_humanizedKeyList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var makeIndex = function makeIndex(keyProp) {
    return function (fields) {
        return Object.keys(fields).reduce(function (a, v) {
            a[fields[v][keyProp]] = v;
            return a;
        }, {});
    };
};

/*
 * This stuff runs _after_ OccurrenceRecord's custom extends method! That will
 * need to be folded into this (and entityMetaStore) when it's finally replaced
 * with pure data.
 */
var loadEntityIntoState = function loadEntityIntoState(state, def) {
    var fields = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = Object.keys(def.FIELD_INFO)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var f = def.FIELD_INFO[key];
            fields[key] = _extends({}, f, {
                entityKey: def.KEY
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return _dotPropImmutable2.default.set(state, [def.KEY], {
        byKey: fields,
        idxLogicalColumn: makeIndex("logicalColumn")(fields),
        idxLogicalKey: makeIndex("logicalKey")(fields)
    });
};

var LAST = 1000000;
var getFieldInfoComparator = exports.getFieldInfoComparator = function getFieldInfoComparator(infosByKey) {
    var keyProp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "key";
    return function (a, b) {
        if (a == null) return b == null ? 0 : -1;
        if (b == null) return 1;
        var akey = a.hasOwnProperty(keyProp) ? a[keyProp] : a.get(keyProp);
        var bkey = b.hasOwnProperty(keyProp) ? b[keyProp] : b.get(keyProp);
        var aorder = infosByKey.hasOwnProperty(akey) ? infosByKey[akey].order : LAST;
        var border = infosByKey.hasOwnProperty(bkey) ? infosByKey[bkey].order : LAST;
        if (aorder < 0) return b < 0 ? 0 : -1;
        if (border < 0) return 1;
        return aorder - border;
    };
};

var EntityFieldMetaStore = exports.EntityFieldMetaStore = function (_ReduceStore) {
    _inherits(EntityFieldMetaStore, _ReduceStore);

    function EntityFieldMetaStore() {
        _classCallCheck(this, EntityFieldMetaStore);

        return _possibleConstructorReturn(this, (EntityFieldMetaStore.__proto__ || Object.getPrototypeOf(EntityFieldMetaStore)).apply(this, arguments));
    }

    _createClass(EntityFieldMetaStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {};
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            if (action.type === _DefineActions2.default._UNLOAD) {
                return this.getInitialState();
            }
            if (action.type === _DefineActions2.default.ENTITY) {
                return loadEntityIntoState(state, action.def);
            }
            return state;
        }
    }, {
        key: "_getAllInfos",
        value: function _getAllInfos(entityKey) {
            var s = this.getState();
            if (!s.hasOwnProperty(entityKey)) {
                throw new Error("No '" + entityKey + "' entity is known: " + Object.keys(s));
            }
            return s[entityKey];
        }
    }, {
        key: "getInfo",
        value: function getInfo(entityKey, fieldKey) {
            var fields = this._getAllInfos(entityKey).byKey;
            if (!fields.hasOwnProperty(fieldKey)) {
                throw new Error( false ? "No '" + fieldKey + "' field is known on '" + entityKey + "': " + (0, _humanizedKeyList2.default)(fields) : "No '" + fieldKey + "' field is known on '" + entityKey + "'");
            }
            return fields[fieldKey];
        }
    }, {
        key: "getInfosByKey",
        value: function getInfosByKey(entityKey) {
            return this._getAllInfos(entityKey).byKey;
        }
    }, {
        key: "getAllInfos",
        value: function getAllInfos(entityKey, optionalFilter) {
            var result = [];
            var fields = this._getAllInfos(entityKey).byKey;
            if (optionalFilter == null) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = Object.keys(fields)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var k = _step2.value;

                        result.push(fields[k]);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            } else {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = Object.keys(fields)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var _k = _step3.value;

                        var info = fields[_k];
                        if (optionalFilter(info)) {
                            result.push(info);
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
            return result;
        }
    }, {
        key: "getInfosForColumn",
        value: function getInfosForColumn(entityKeys, columnName) {
            var result = [];
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = entityKeys[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var ek = _step4.value;

                    var info = this.getInfoForColumn(ek, columnName, false);
                    if (info == null) continue;
                    result.push(info);
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            return result;
        }
    }, {
        key: "getInfosForColumnKey",
        value: function getInfosForColumnKey(entityKeys, colKey) {
            var result = [];
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = entityKeys[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var ek = _step5.value;

                    var info = this.getInfoForColumnKey(ek, colKey, false);
                    if (info == null) continue;
                    result.push(info);
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            return result;
        }
    }, {
        key: "_getInfoFromIndex",
        value: function _getInfoFromIndex(entityKey, indexName, value) {
            var errorOnMissing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

            var indexes = this._getAllInfos(entityKey);
            if (indexes[indexName].hasOwnProperty(value)) {
                return indexes.byKey[indexes[indexName][value]];
            }
            if (!errorOnMissing) return null;
            throw new Error("Entity '" + entityKey + "' has no field for " + indexName.substr(3) + " '" + value + "'");
        }
    }, {
        key: "getInfoForColumn",
        value: function getInfoForColumn(entityKey, colName) {
            var errorOnMissing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            return this._getInfoFromIndex(entityKey, "idxLogicalColumn", colName, errorOnMissing);
        }
    }, {
        key: "getInfoForColumnKey",
        value: function getInfoForColumnKey(entityKey, colKey) {
            var errorOnMissing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            return this._getInfoFromIndex(entityKey, "idxLogicalKey", colKey, errorOnMissing);
        }
    }]);

    return EntityFieldMetaStore;
}(_utils.ReduceStore);

var entityFieldMetaStore = new EntityFieldMetaStore(_Dispatcher2.default);

exports.default = entityFieldMetaStore;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EntityMetaStore = exports.entityInfoComparator = exports.loadEntityIntoState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(13);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _dotPropImmutable = __webpack_require__(40);

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _DefineActions = __webpack_require__(124);

var _DefineActions2 = _interopRequireDefault(_DefineActions);

var _audit = __webpack_require__(173);

var _HybridConfig = __webpack_require__(41);

var _HybridConfig2 = _interopRequireDefault(_HybridConfig);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var buildBaseEntityInfo = function buildBaseEntityInfo(def) {
    var info = {
        key: def.KEY,
        label: def.LABEL,
        tableKey: def.TABLE,
        implKey: (def.KEY || "").split("/")[0],
        associations: {
            csv: [],
            cmv: [],
            asv: [],
            amv: [],
            inv: []
        },
        keys: def.KEYS,
        scripts: {}
    };
    ["logicalKey", "magicRootPointerKey", "mappingSources", "name", "orderingComponents", "parentPointerKey", "pluralName", "type", "maxDepGraphSet", "lookup"].forEach(function (k) {
        return info[k] = def.INFO[k];
    });
    return info;
};

var addMappingSourcesSearchScripts = function addMappingSourcesSearchScripts(info) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = info.mappingSources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var src = _step.value;

            if (src.hasOwnProperty("searchScript")) {
                // eslint-disable-next-line no-new-func
                src.searchScript = new Function("instance", src.searchScript);
                if (_HybridConfig2.default.auditScriptlets()) {
                    src.searchScript = (0, _audit.auditable)("searchScript", src.searchScript);
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};

/*
 * This stuff runs after _or_munge_info! That will need to be folded into this
 * (and entityFieldMetaStore) when it's finally replaced with pure data.
 */
var loadEntityIntoState = exports.loadEntityIntoState = function loadEntityIntoState(state, def) {
    var info = buildBaseEntityInfo(def);
    info.typePriority = info.type === "ROOT" ? 0 : info.type === "GLOBAL" ? 1 : 2;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = Object.keys(def.FIELD_INFO)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var key = _step2.value;

            var f = def.FIELD_INFO[key];
            if (f.type === "CompositionField") {
                info.associations[f.multiValued ? "cmv" : "csv"].push(f.key);
            } else if (f.type === "AssociationField") {
                info.associations[f.multiValued ? "amv" : "asv"].push(f.key);
            } else if (f.type === "InverseAssociationField") {
                info.associations.inv.push(f.key);
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    if (def.INFO.versionDate instanceof Array) {
        var ps = def.INFO.versionDate;
        info.versionDate = new Date(ps[0], ps[1] - 1, ps[2]);
    }
    if (def.INFO.scripts != null) {
        var ss = def.INFO.scripts;
        if (ss.hasOwnProperty("toString")) {
            // eslint-disable-next-line no-new-func
            info.scripts.toString = new Function("instance", ss.toString);
        }
        ["filter", "enable", "isVersion"].forEach(function (sn) {
            if (ss.hasOwnProperty(sn)) {
                // eslint-disable-next-line no-new-func
                info.scripts[sn] = new Function("instance", "var v = " + ss[sn] + ";\nreturn v == null ? false : v;");
            }
        });
        if (_HybridConfig2.default.auditScriptlets()) {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = Object.keys(info.scripts)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var sn = _step3.value;

                    info.scripts[sn] = (0, _audit.auditable)(sn, info.scripts[sn]);
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
    }
    if (info.mappingSources != null) {
        addMappingSourcesSearchScripts(info);
    }

    if (_userStore2.default.getState().isEmpty()) {
        info.canCreate = info.canWrite = info.canDelete = true;
    } else if (info.lookup && !_userStore2.default.canManageLookups(info.implKey)) {
        info.canCreate = info.canWrite = info.canDelete = false;
    } else {
        info.canCreate = _userStore2.default.canCreate(info.implKey);
        info.canWrite = _userStore2.default.canWrite(info.implKey);
        info.canDelete = _userStore2.default.canDelete(info.implKey);
    }

    state = _dotPropImmutable2.default.set(state, ["byKey", def.KEY], info);
    if (state.idxTableKey.hasOwnProperty(def.TABLE)) {
        state = _dotPropImmutable2.default.set(state, ["idxTableKey", def.TABLE], function (v) {
            return v.concat(def.KEY);
        });
    } else {
        state = _dotPropImmutable2.default.set(state, ["idxTableKey", def.TABLE], [def.KEY]);
    }
    return state;
};

// export const recordComparator = entityInfo => {
//     entityInfo.orderingComponents...
// };

var entityInfoComparator = exports.entityInfoComparator = function entityInfoComparator(a, b) {
    if (a.versionDate && b.versionDate) {
        return b.versionDate - a.versionDate;
    } else if (a.versionDate) {
        return -1;
    } else if (b.versionDate) {
        return 1;
    }
    if (a.typePriority !== b.typePriority) {
        return a.typePriority - b.typePriority;
    }
    if (a.name !== b.name) {
        return a.name < b.name ? -1 : 1;
    }
    // keys MUST be distinct
    return a.key < b.key ? -1 : 1;
};

var EntityMetaStore = exports.EntityMetaStore = function (_ReduceStore) {
    _inherits(EntityMetaStore, _ReduceStore);

    function EntityMetaStore() {
        _classCallCheck(this, EntityMetaStore);

        return _possibleConstructorReturn(this, (EntityMetaStore.__proto__ || Object.getPrototypeOf(EntityMetaStore)).call(this, _Dispatcher2.default));
    }

    _createClass(EntityMetaStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {
                byKey: {},
                idxTableKey: {}
            };
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            if (action.type === _DefineActions2.default._UNLOAD) {
                return this.getInitialState();
            }
            if (action.type === _DefineActions2.default.ENTITY) {
                return loadEntityIntoState(state, action.def);
            }
            return state;
        }
    }, {
        key: "hasInfo",
        value: function hasInfo(entityKeyOrKeys) {
            if (typeof entityKeyOrKeys === "string") {
                entityKeyOrKeys = [entityKeyOrKeys];
            }
            var slice = this.getState().byKey;
            return entityKeyOrKeys.every(function (k) {
                return slice.hasOwnProperty(k);
            });
        }
    }, {
        key: "getInfo",
        value: function getInfo(entityKey) {
            var infos = this.getState().byKey;
            if (!infos.hasOwnProperty(entityKey)) {
                throw new Error("No '" + entityKey + "' entity is known: " + Object.keys(infos));
            }
            return infos[entityKey];
        }
    }, {
        key: "getAllInfos",
        value: function getAllInfos(optionalFilter) {
            var result = [];
            var infos = this.getState().byKey;
            if (optionalFilter == null) {
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = Object.keys(infos)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var ek = _step4.value;

                        result.push(infos[ek]);
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }
            } else {
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = Object.keys(infos)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var _ek = _step5.value;

                        var info = infos[_ek];
                        if (optionalFilter(info)) {
                            result.push(info);
                        }
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }
            }
            return result;
        }

        // ofEntityKey supports prefix matches (i.e., can be a version key too)

    }, {
        key: "getInfosForLogicalTable",
        value: function getInfosForLogicalTable(tableKey) {
            var ofEntityKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var result = [];
            var s = this.getState();
            if (!s.idxTableKey.hasOwnProperty(tableKey)) {
                throw new Error("No entities are stored in table '" + tableKey + "'");
            }
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = s.idxTableKey[tableKey][Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var k = _step6.value;

                    var info = s.byKey[k];
                    if (ofEntityKey != null) {
                        if (info.key === ofEntityKey) return [info];
                        if (info.key.indexOf(ofEntityKey) !== 0) continue;
                    }
                    result.push(info);
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }

            return result;
        }
    }, {
        key: "isRootRecord",
        value: function isRootRecord(entityKey) {
            return this.getInfo(entityKey).type === "ROOT";
        }
    }]);

    return EntityMetaStore;
}(_utils.ReduceStore);

EntityMetaStore.stateTypes = {
    byKey: _propTypes2.default.objectOf(_propTypes2.default.shape({
        key: _propTypes2.default.string.isRequired,
        type: _propTypes2.default.string.isRequired,
        name: _propTypes2.default.string.isRequired,
        pluralName: _propTypes2.default.string.isRequired,
        label: _propTypes2.default.string.isRequired, // deprecated - use name
        logicalKey: _propTypes2.default.string.isRequired,
        tableKey: _propTypes2.default.string.isRequired, // deprecated - use logicalKey
        implKey: _propTypes2.default.string.isRequired,
        magicRootPointerKey: _propTypes2.default.string,
        parentPointerKey: _propTypes2.default.string,
        associations: _propTypes2.default.shape({
            csv: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
            cmv: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
            asv: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
            amv: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
            inv: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
        }).isRequired,
        scripts: _propTypes2.default.shape({
            toString: _propTypes2.default.func,
            filter: _propTypes2.default.func,
            enable: _propTypes2.default.func,
            isVersion: _propTypes2.default.func
        }).isRequired,
        orderingComponents: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            key: _propTypes2.default.string.isRequired,
            ascending: _propTypes2.default.bool.isRequired
        })),
        keys: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            name: _propTypes2.default.string.isRequired,
            importance: _propTypes2.default.number.isRequired,
            fieldKeys: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
            fieldAliases: _propTypes2.default.object
        })),
        versionDate: _propTypes2.default.instanceOf(Date)
    })).isRequired,
    idxTableKey: _propTypes2.default.objectOf(_propTypes2.default.arrayOf(_propTypes2.default.string)).isRequired
};

var entityMetaStore = (0, _typeCheckingStore2.default)(new EntityMetaStore());

exports.default = entityMetaStore;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ControlResolver = __webpack_require__(139);

exports.default = function (props) {
  return (0, _ControlResolver.buildDescriptorControl)("StringField", "dropdown", props);
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeHelpers = __webpack_require__(302);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EntityName = function () {
    function EntityName(entityKey) {
        _classCallCheck(this, EntityName);

        this.key = entityKey;
        this.entityKey = entityKey;
        this.parts = entityKey.split("/");
        this.implKey = this.parts[0];
        this.versionKey = this.parts[0] + "/" + this.parts[1];
        this.bareVersionKey = this.parts[1];
        this.bareEntityKey = this.parts[2];
    }

    _createClass(EntityName, null, [{
        key: "is",
        value: function is(key) {
            if (typeof key !== "string") {
                throw new Error("Only strings may be EntityNames, not " + (typeof key === "undefined" ? "undefined" : _typeof(key)));
            }
            // exactly three slash-delimited parts;
            var i = key.indexOf("/");
            if (i < 0) return false;
            i = key.indexOf("/", i + 1);
            if (i < 0) return false;
            i = key.indexOf("/", i + 1);
            return i < 0;
        }
    }]);

    return EntityName;
}();

// I can't figure out how to include this in the class definition...


EntityName.propType = (0, _typeHelpers.createChainableTypeChecker)(function (props, propName, componentName) {
    if (EntityName.is(props[propName])) {
        return;
    }
    return new _typeHelpers.PropTypeError("'" + propName + "' (supplied to " + componentName + ") isn't a valid EntityName");
});

exports.default = EntityName;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ERR_NOT_YET_PROCESSED_BY_TABLESTORE = exports.serverFilteredSearch = exports.clientFilteredSearch = exports.clientFilteredList = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _SuperRecordStore = __webpack_require__(36);

var _SuperRecordStore2 = _interopRequireDefault(_SuperRecordStore);

var _BaseServices = __webpack_require__(76);

var _BaseServices2 = _interopRequireDefault(_BaseServices);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Q = __webpack_require__(176);

var _Q2 = _interopRequireDefault(_Q);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _typedefs = __webpack_require__(44);

var _typedAction = __webpack_require__(86);

var _typedAction2 = _interopRequireDefault(_typedAction);

var _RecordActions = __webpack_require__(60);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

var _superRecords = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var singleRecordRequestType = {
    key: _propTypes2.default.string.isRequired, // stereotype key
    id: _typedefs.recordIdType.isRequired,
    initiatingContext: _propTypes2.default.string
};
var singleRecordResponseType = _extends({}, singleRecordRequestType, {
    data: _superRecords.superRecordPacketType.isRequired
});
var singleRecordErrorType = _extends({}, singleRecordRequestType, {
    error: _propTypes2.default.object.isRequired
});

var SuperRecordActions = {
    /*
     * async triples
     */
    START_LOAD: "super-record/start-load",
    LOADED: (0, _typedAction2.default)("super-record/loaded", singleRecordResponseType),
    LOAD_ERROR: "super-record/load-error",

    START_CREATE: (0, _typedAction2.default)("super-record/start-create", singleRecordRequestType),
    CREATED: (0, _typedAction2.default)("super-record/created", singleRecordResponseType),
    CREATE_ERROR: (0, _typedAction2.default)("super-record/create-error", singleRecordErrorType),

    START_UPDATE: (0, _typedAction2.default)("super-record/start-update", singleRecordRequestType),
    UPDATED: (0, _typedAction2.default)("super-record/updated", singleRecordResponseType),
    UPDATE_ERROR: (0, _typedAction2.default)("super-record/update-error", singleRecordErrorType),

    // this might be for an unsaved record
    DELETE_RECORD: (0, _typedAction2.default)("super-record/delete-record", _extends({}, singleRecordRequestType, _defineProperty({}, _RecordActions.OPT_USER_CONFIRMED, _propTypes2.default.bool))),
    DELETED: "super-record/deleted",
    DELETE_ERROR: (0, _typedAction2.default)("super-record/delete-error", singleRecordErrorType),

    /*
     * user actions
     */
    NEW: (0, _typedAction2.default)("super-record/new", {
        stereoKey: _propTypes2.default.string.isRequired,
        recordKey: _EntityName2.default.propType.isRequired,
        newId: _ClientId2.default.propType.isRequired,
        navigate: _propTypes2.default.bool
    }),
    NEW_MAGIC_CHILD: (0, _typedAction2.default)("super-record/new-magic-child", {
        recordKey: _propTypes2.default.string.isRequired,
        recordId: _typedefs.recordIdType.isRequired,
        entityKey: _EntityName2.default.propType.isRequired,
        newId: _ClientId2.default.propType.isRequired,
        navigate: _propTypes2.default.bool
    }),
    OPEN: (0, _typedAction2.default)("super-record/open", {
        key: _propTypes2.default.string.isRequired,
        id: _typedefs.recordIdType.isRequired,
        entityKey: _propTypes2.default.any,
        recordId: _propTypes2.default.any, //PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        fieldKey: _propTypes2.default.any
    }),
    SAVE: "super-record/save",
    CANCEL: "super-record/cancel",
    CANCEL_FOR_OPTLOCK: "super-record/cancel-for-optlock"
};

/**
 * I return a LoadObject containing a client-filtered list as an array of
 * EntityProxy. DO NOT TRUST THE PROMISE INSIDE.
 */
var clientFilteredList = exports.clientFilteredList = function clientFilteredList(SuperRecordListStore, TableStoreOrAccess, entityKey, accept) {
    var idsLO = SuperRecordListStore.getListLO(entityKey);
    if (!idsLO.hasValue()) return idsLO;
    var recordsLO = recordsFromServer(_SuperRecordStore2.default, TableStoreOrAccess, idsLO.getValueEnforcing(), entityKey);
    return accept == null ? recordsLO : recordsLO.map(function (rs) {
        return rs.filter(accept);
    });
};

/**
 * I return a LoadObject containing a client-filtered search as an array of
 * EntityProxy. DO NOT TRUST THE PROMISE INSIDE.
 */
var clientFilteredSearch = exports.clientFilteredSearch = function clientFilteredSearch(SearchResultStore, entityKey, query, order, limit) {
    var accept = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function (r) {
        return true;
    };
    var showLoadingModal = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;

    var results = [];
    var page = 0;
    var isFinalPage = false;
    var isQ = query instanceof _Q2.default;
    var queryAS = isQ ? query.toAS() : query;
    var nextPage = function nextPage() {
        page += 1;
        if (page === 10) {
            console.warn("We're to page 10; is something wrong?");
        } else if (page === 20) {
            console.error("We're to page 20; something is wrong.");
        }
        var searchLO = SearchResultStore.getSearchLO(entityKey, queryAS, order, limit, page, showLoadingModal);
        if (searchLO.hasValue()) {
            var data = searchLO.getRequiredValue();
            if (data.results.length < data.pageSize) {
                isFinalPage = true;
            }
            var recordsLO = recordsFromServer(_SuperRecordStore2.default, _TableStore2.default, data.results.map(function (r) {
                return r.id;
            }), entityKey);
            if (recordsLO.hasValue()) {
                var rs = recordsLO.getRequiredValue();
                if (isQ && _BaseServices2.default.__mocked) {
                    rs = rs.filter(query.test);
                }
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = rs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var r = _step.value;

                        if (accept == null || accept(r)) {
                            results.push(r);
                            if (results.length >= limit) {
                                break;
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                if (results.length < limit && !isFinalPage) {
                    return nextPage();
                } else {
                    return _LoadObject2.default.withValue(results);
                }
            } else if (recordsLO.isPending()) {
                return recordsLO;
            } else if (recordsLO.hasError()) {
                return recordsLO;
            }
        } else if (searchLO.isPending()) {
            return searchLO;
        } else if (searchLO.hasError()) {
            return searchLO;
        }
    };
    return nextPage();
};

var serverFilteredSearch = exports.serverFilteredSearch = function serverFilteredSearch(SearchResultStore, entityKey, query, order, limit) {
    var page = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
    var showLoadingModal = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
    var onlyEnabledRecords = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;

    var results = [];
    var isQ = query instanceof _Q2.default;
    var queryAS = isQ ? query.toAS() : query;
    var searchLO = SearchResultStore.getSearchLO(entityKey, queryAS, order, limit, page, showLoadingModal, onlyEnabledRecords);
    if (searchLO.hasValue()) {
        var data = searchLO.getRequiredValue();
        var recordsLO = recordsFromServer(_SuperRecordStore2.default, _TableStore2.default, data.results.map(function (r) {
            return r.id;
        }), entityKey);
        if (recordsLO.hasValue()) {
            var rs = recordsLO.getRequiredValue();
            if (isQ && _BaseServices2.default.__mocked) {
                rs = rs.filter(query.test);
            }
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = rs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var r = _step2.value;

                    results.push(r);
                    if (results.length >= limit) {
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return _LoadObject2.default.withValue(results);
        } else if (recordsLO.isPending()) {
            return recordsLO;
        } else if (recordsLO.hasError()) {
            return recordsLO;
        }
    } else if (searchLO.isPending()) {
        return searchLO;
    } else if (searchLO.hasError()) {
        return searchLO;
    }
};

var MAX_CONCURRENT = 4;

/**
 * I return a LoadObject containing an EntityProxy or an array of them. DO NOT
 * TRUST THE PROMISE INSIDE.
 */
var recordsFromServer = function recordsFromServer(SuperRecordStore, tableStoreOrAccess, idOrIds, entityKey) {
    if (idOrIds == null || idOrIds.length === 0) {
        return _LoadObject2.default.withValue([]);
    }
    var multiValued = Array.isArray(idOrIds);
    var ids = multiValued ? idOrIds : [idOrIds];
    if (ids.length > 11) {
        // only do this work when we need to.
        // only message once when actually loading records from the server.
        // There is probably a more elegant way of doing this.
        var uniqueMessageId = entityKey + ids.join(",");
        if (!messagingCache[uniqueMessageId]) {
            // how many records are loaded vs need to load.
            var loadCount = ids.length - ids.filter(function (id) {
                return tableStoreOrAccess.hasEntityRecord(entityKey, id);
            }).length;
            if (loadCount > 21) {
                console.warn("Pulling", ids.length, entityKey, "records. That's a LOT.");
            } else if (loadCount > 11) {
                console.log("Pulling", ids.length, entityKey, "records. That's quite a few.");
            }
        }
        messagingCache[uniqueMessageId] = true;
    }
    var eps = [];
    var inFlight = 0;
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = ids[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var id = _step3.value;

            if (tableStoreOrAccess.hasEntityRecord(entityKey, id)) {
                eps.push(tableStoreOrAccess.getEntityProxy(entityKey, id));
            } else {
                var lo = SuperRecordStore.getRecordLO(entityKey, id);
                if (lo.hasValue()) {
                    // must be inside a store listening for the API response, but
                    // TableStore hasn't processed it yet...
                    if (false) {
                        var d = SuperRecordStore.getDispatcher();
                        if (d.isDispatching()) {
                            var payload = d._pendingPayload; // tee-hee!
                            var type = payload == null ? "??UNKNOWN??" : payload.type;
                            console.warn("During dispatch of '" + type + "', TableStore was asked for the data it hasn't loaded yet (because it hasn't run yet).");
                        } else {
                            throw new Error("You've got some sort of need-a-record race.");
                        }
                    }
                    return _LoadObject2.default.empty().setError(ERR_NOT_YET_PROCESSED_BY_TABLESTORE).loading("garbage");
                } else if (lo.hasError()) {
                    return lo;
                } else if (lo.isPending()) {
                    inFlight += 1;
                    if (inFlight >= MAX_CONCURRENT) {
                        break;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    if (inFlight > 0) {
        return _LoadObject2.default.loading("garbage");
    }
    return _LoadObject2.default.withValue(multiValued ? eps : eps.length === 0 ? null : eps[0]);
};

// hash table to manage large recordsFromServer requests messaging.
var messagingCache = {};

var ERR_NOT_YET_PROCESSED_BY_TABLESTORE = exports.ERR_NOT_YET_PROCESSED_BY_TABLESTORE = "Client-filtered list requested during dispatch loading a record in the list. Try again.";

exports.default = SuperRecordActions;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = ControlTemplate;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formhelpers = __webpack_require__(5);

var _classnames = __webpack_require__(51);

var _classnames2 = _interopRequireDefault(_classnames);

var _isMissing = __webpack_require__(443);

var _isMissing2 = _interopRequireDefault(_isMissing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ControlTemplate(_ref) {
    var className = _ref.className,
        descriptor = _ref.descriptor,
        controlOnly = _ref.controlOnly,
        enabled = _ref.enabled,
        value = _ref.value,
        children = _ref.children,
        controlRef = _ref.controlRef,
        _ref$extraProps = _ref.extraProps,
        extraProps = _ref$extraProps === undefined ? {} : _ref$extraProps;

    if (descriptor.disableBehaviour === "hide" && !enabled) {
        // control is disabled and should be hidden.
        return null;
    }

    var selector = "control-container-" + descriptor.key;
    var required = enabled && descriptor.required;

    var Control = _react2.default.createElement(
        "div",
        _extends({
            ref: controlRef,
            id: descriptor.id,
            className: (0, _classnames2.default)(selector, "control", "react-control", className, {
                "control-only": controlOnly,
                "required": required,
                "illegal": required && (0, _isMissing2.default)(value)
            }),
            "data-control-type": descriptor.control,
            "data-shortname": descriptor.key
        }, extraProps),
        children && children
    );

    if (controlOnly) {
        return Control;
    }

    return _react2.default.createElement(
        "div",
        { className: "form-item" },
        _react2.default.createElement(
            "div",
            { className: "left-side" },
            _react2.default.createElement(
                "label",
                null,
                descriptor.label
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "right-side" },
            Control
        )
    );
}

ControlTemplate.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)(null, false), {
    onCommitChange: _propTypes2.default.func,
    children: _propTypes2.default.any,
    controlRef: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object])
});

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeHelpers = __webpack_require__(302);

var _underscore = __webpack_require__(261);

// so we can interleave!
var next = function next() {
    return (0, _underscore.uniqueId)("c");
};

/*
 * I provide a source of client-side IDs, distinct from server-generated IDs,
 * and a test for differentiating between them. Currently I piggy-back atop
 * Backbone to avoid conflicts while we're still assuming Backbone "stuff" both
 * client- and server-side. Eventually that restriction can lift and the
 * generation made more efficient (and safer), if it's useful.
 */
var ClientId = {
    next: next,

    is: function is(id) {
        var sid = id.toString();
        if (sid.charAt(0) !== "c") {
            return false;
        }
        var digits = sid.substr(1);
        return parseInt(digits, 10).toString(10) === digits;
    },


    propType: (0, _typeHelpers.createChainableTypeChecker)(function (props, propName, componentName) {
        if (ClientId.is(props[propName])) {
            return;
        }
        return new _typeHelpers.PropTypeError("'" + propName + "' (supplied to " + componentName + ") isn't a valid ClientId");
    })
};

exports.default = ClientId;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BaseFormItem = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.deriveValueAndEnabledFromProps = deriveValueAndEnabledFromProps;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _formhelpers = __webpack_require__(5);

var _RecordActions = __webpack_require__(60);

var _RecordActions2 = _interopRequireDefault(_RecordActions);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _shallowEqual = __webpack_require__(1343);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function deriveValueAndEnabledFromProps(props) {
    var activeRecord = props.activeRecord,
        descriptor = props.descriptor;

    return {
        value: activeRecord.get(descriptor.key),
        enabled: activeRecord.isFieldEnabled(descriptor.key)
    };
}

var BaseFormItem = exports.BaseFormItem = function (_React$Component) {
    _inherits(BaseFormItem, _React$Component);

    function BaseFormItem(props) {
        _classCallCheck(this, BaseFormItem);

        var _this = _possibleConstructorReturn(this, (BaseFormItem.__proto__ || Object.getPrototypeOf(BaseFormItem)).call(this, props));

        _this.onCommitChange = _this.onCommitChange.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onKeyDown = _this.onKeyDown.bind(_this);

        _this.state = {
            pureOverValueAndEnabled: false
        };
        return _this;
    }

    /**
     * Call _from the constructor_ to indicate this component is pure over its
     * value and enable state.
     * @protected
     */


    _createClass(BaseFormItem, [{
        key: "__enablePureOverValueAndEnabledHandling",
        value: function __enablePureOverValueAndEnabledHandling() {
            // eslint-disable-next-line react/no-direct-mutation-state
            this.state = _extends({
                pureOverValueAndEnabled: true
            }, deriveValueAndEnabledFromProps(this.props));
        }
    }, {
        key: "UNSAFE_componentWillReceiveProps",
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.state.pureOverValueAndEnabled) {
                this.setState(deriveValueAndEnabledFromProps(nextProps));
            }
        }
    }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
            return this.state.pureOverValueAndEnabled ? !(0, _shallowEqual2.default)(this.state, nextState) : true;
        }

        // Most of the controls handle events the same way. Only a few need to
        // overload the following functions.

    }, {
        key: "onCommitChange",
        value: function onCommitChange(d, v) {
            var userInvoked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
            var label = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            // set the active record value
            var _props = this.props,
                descriptor = _props.descriptor,
                activeRecord = _props.activeRecord;

            if (d.key !== descriptor.key) throw new Error("Inconsistent descriptor for " + activeRecord.getKey() + ": " + d.key + " passed, " + descriptor.key + " from props.");
            this.doSetField(activeRecord, descriptor.key, v, userInvoked, label);
        }
    }, {
        key: "doSetField",
        value: function doSetField(record, fieldKey, value) {
            var userInvoked = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
            var label = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
            var fluxContext = this.props.fluxContext;

            _Dispatcher2.default.contextDispatch(fluxContext, _defineProperty({
                type: _RecordActions2.default.SET_FIELD,
                recordKey: record.entityKey,
                recordId: record.id,
                fieldKey: fieldKey,
                value: value,
                label: label
            }, _RecordActions.OPT_USER_INITIATED, userInvoked));
        }
    }, {
        key: "onFocus",
        value: function onFocus(e, d, v, k) {
            // (event, descriptor, value, keyboardShortcuts)
            var onFocus = this.props.onFocus;
            // moveFocus expects the target to be the .react-control which has the field id

            e.currentTarget = $(e.currentTarget).parents(".react-control").get(0);
            onFocus && onFocus(e, k);
        }
    }, {
        key: "onBlur",
        value: function onBlur(e, d, v) {
            // (event, descriptor, value)
            var onBlur = this.props.onBlur;
            // moveFocus expects the target to be the .react-control which has the field id

            e.currentTarget = $(e.currentTarget).parents(".react-control").get(0);
            onBlur && onBlur(e);
        }
    }, {
        key: "onKeyDown",
        value: function onKeyDown(e, d, v, isKeyboardShortcut) {
            // (event, descriptor, value, isKeyboardShortcut)
            var onKeyDown = this.props.onKeyDown;

            onKeyDown && onKeyDown(e, isKeyboardShortcut);
        }
    }, {
        key: "getPlumbingProps",
        value: function getPlumbingProps() {
            return {
                controlOnly: this.props.controlOnly,
                descriptor: this.props.descriptor,
                enabled: true,

                // why this block?
                valueKey: undefined,
                labelKey: undefined,
                options: undefined,
                placeholder: undefined,
                // end questionable block...

                // callbacks
                onCommitChange: this.onCommitChange,

                // EntityForm is handling this callback at the moment with .control
                onKeyDown: this.onKeyDown, // (event, descriptor, value) callback function

                // EntityForm is not tracking .react-control focus or blur events.
                // onFocus and onBlur should not need to be overloaded.
                onFocus: this.onFocus,
                onBlur: this.onBlur
            };
        }
    }]);

    return BaseFormItem;
}(_react2.default.Component);

// initial PropTypes for all controls that extend BaseFormItem


BaseFormItem.propTypes = {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)()),
    fluxContext: _propTypes2.default.string.isRequired,
    activeRecord: _propTypes2.default.instanceOf(_EntityProxy2.default).isRequired,
    controlOnly: _propTypes2.default.bool,
    onFocus: _propTypes2.default.func.isRequired,
    onBlur: _propTypes2.default.func.isRequired,
    onKeyDown: _propTypes2.default.func.isRequired
};

exports.default = BaseFormItem;

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.keyFactory = exports.ACTION_CONTEXT_KEY = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _utils = __webpack_require__(13);

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

var _ContextedDispatcher = __webpack_require__(462);

var _ContextedDispatcher2 = _interopRequireDefault(_ContextedDispatcher);

var _ContextActions = __webpack_require__(170);

var _ContextActions2 = _interopRequireDefault(_ContextActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ACTION_CONTEXT_KEY = exports.ACTION_CONTEXT_KEY = "__CONTEXT_KEY";

var keyCounter = 0;

var keyFactory = exports.keyFactory = function keyFactory() {
    return "CTX_" + ++keyCounter;
};

var ContextedReduceStore = function (_ReduceStore) {
    _inherits(ContextedReduceStore, _ReduceStore);

    function ContextedReduceStore(dispatcher) {
        _classCallCheck(this, ContextedReduceStore);

        var _this = _possibleConstructorReturn(this, (ContextedReduceStore.__proto__ || Object.getPrototypeOf(ContextedReduceStore)).call(this, dispatcher));

        (0, _invariant2.default)(dispatcher instanceof _ContextedDispatcher2.default, "ContextedReduceStore requires a ContextedDispatcher");
        // fast-fail on Bad Things(tm)
        (0, _invariant2.default)(_this.reduce === _utils.ReduceStore.prototype.reduce, "ContextedReduceStore subtypes may not override 'reduce'");
        (0, _invariant2.default)(_this.getInitialState === ContextedReduceStore.prototype.getInitialState, "ContextedReduceStore subtypes may not override 'getInitialState'");
        (0, _invariant2.default)(_this.getState === ContextedReduceStore.prototype.getState, "ContextedReduceStore subtypes may not override 'getState'");
        var reduceAll = _this.reduceEachContext !== ContextedReduceStore.prototype.reduceEachContext;
        // "final" reduce
        _this.reduce = function (state, action) {
            var targetCtxName = action[ACTION_CONTEXT_KEY];
            if (targetCtxName != null) {
                var prev = state.hasOwnProperty(targetCtxName) ? state[targetCtxName] : _this.getInitialContext();
                var next = _this.reduceContext(prev, action, targetCtxName);
                if (next !== prev) {
                    state = _extends({}, state, _defineProperty({}, targetCtxName, next));
                }
            }
            if (reduceAll) {
                for (var ctx in state) {
                    if (!state.hasOwnProperty(ctx)) continue;
                    var _prev = state[ctx];
                    var _next = _this.reduceEachContext(_prev, action, ctx);
                    if (_prev !== _next) {
                        state = _extends({}, state, _defineProperty({}, ctx, _next));
                    }
                }
            }
            if (action.type === _ContextActions2.default.CLOSE) {
                /*
                Blow it away, but it's important that the action is still
                run through the context reducer, in case resources need to
                be cleaned up or side effects need to be initiated.
                 */
                state = _extends({}, state);
                delete state[targetCtxName];
            }
            return state;
        };
        return _this;
    }

    _createClass(ContextedReduceStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {};
        }
    }, {
        key: "getInitialContext",
        value: function getInitialContext() {
            throw new Error("ContextedReduceStore subtypes must override 'getInitialContext'");
        }

        /*
         I get invoked on the target context for every contexted action. This is the
         one you want.
         */

    }, {
        key: "reduceContext",
        value: function reduceContext(context, action) {
            throw new Error("ContextedReduceStore subtypes must override 'reduceContext'");
        }

        /*
         I get invoked on each context, for every non-contexted action. You probably
         don't want this one.
         */

    }, {
        key: "reduceEachContext",
        value: function reduceEachContext(context, action, contextId) {
            return context;
        }
    }, {
        key: "getState",
        value: function getState(context) {
            (0, _invariant2.default)(typeof context === "string", "ContextedReduceStore can only retrieve state by context");
            var s = _get(ContextedReduceStore.prototype.__proto__ || Object.getPrototypeOf(ContextedReduceStore.prototype), "getState", this).call(this);
            return s.hasOwnProperty(context) ? s[context] : this.getInitialContext();
        }
    }, {
        key: "getEachContext",
        value: function getEachContext() {
            var s = _get(ContextedReduceStore.prototype.__proto__ || Object.getPrototypeOf(ContextedReduceStore.prototype), "getState", this).call(this);
            return Object.keys(s).map(function (k) {
                return s[k];
            });
        }

        /*
         I indicate whether there's an active context with the given name. You don't
         want this one either, unless you're looking to fast-fail on a race that
         involves a ContextActions.CLOSE action.
         */

    }, {
        key: "hasContext",
        value: function hasContext(context) {
            return _get(ContextedReduceStore.prototype.__proto__ || Object.getPrototypeOf(ContextedReduceStore.prototype), "getState", this).call(this).hasOwnProperty(context);
        }
    }, {
        key: "getContextNames",
        value: function getContextNames() {
            return Object.keys(_get(ContextedReduceStore.prototype.__proto__ || Object.getPrototypeOf(ContextedReduceStore.prototype), "getState", this).call(this));
        }
    }]);

    return ContextedReduceStore;
}(_utils.ReduceStore);

exports.default = ContextedReduceStore;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isSelection = exports.isFile = exports.isChoice = exports.isComposition = exports.isAbstractAssoc = exports.isInverseAssoc = exports.isAutoManaged = exports.hasIsVersionScript = exports.hasFilterScript = exports.hasEnableScript = exports.hasCandidateFilter = exports.hasRecalcScript = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _TableColumnMetaStore = __webpack_require__(125);

var _TableColumnMetaStore2 = _interopRequireDefault(_TableColumnMetaStore);

var _options = __webpack_require__(156);

var _TableProxy = __webpack_require__(222);

var _TableProxy2 = _interopRequireDefault(_TableProxy);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _compareRecords = __webpack_require__(475);

var _infoTypeToFieldType = __webpack_require__(221);

var _asArray = __webpack_require__(157);

var _asArray2 = _interopRequireDefault(_asArray);

var _recordLabel = __webpack_require__(303);

var _recordLabel2 = _interopRequireDefault(_recordLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// QUACK! FieldInfo's and EntityInfo's scripts are shaped the same!
var hasScript = function hasScript(name) {
    return function (info) {
        return info.scripts && info.scripts.hasOwnProperty(name) && !!info.scripts[name];
    };
};

var hasRecalcScript = exports.hasRecalcScript = hasScript("recalc");

var hasCandidateFilter = exports.hasCandidateFilter = hasScript("filter");

var hasEnableScript = exports.hasEnableScript = hasScript("enable");

var hasFilterScript = exports.hasFilterScript = hasScript("filter");

var hasIsVersionScript = exports.hasIsVersionScript = hasScript("isVersion");

var isAutoManaged = exports.isAutoManaged = function isAutoManaged(fieldInfo) {
    return fieldInfo.autoManageKey != null;
};

var isInverseAssoc = exports.isInverseAssoc = function isInverseAssoc(fieldInfo) {
    return fieldInfo.type === "InverseAssociationField";
};

var isAbstractAssoc = exports.isAbstractAssoc = function isAbstractAssoc(fieldInfo) {
    return fieldInfo.type === "AssociationField" || isInverseAssoc(fieldInfo) || isComposition(fieldInfo);
};

var isComposition = exports.isComposition = function isComposition(fieldInfo) {
    return fieldInfo.type === "CompositionField";
};

var isChoice = exports.isChoice = function isChoice(fieldInfo) {
    return fieldInfo.type === "ChoiceField";
};

var isFile = exports.isFile = function isFile(fieldInfo) {
    return fieldInfo.type === "FileField";
};

var isSelection = exports.isSelection = function isSelection(fieldInfo) {
    return isChoice(fieldInfo) || isAbstractAssoc(fieldInfo);
};

/**
 * I proxy Store data as a stateful object w/ a `get` method, like Backbone's
 * Model has, and which is needed for passing into AS scriptlets.
 */

var EntityProxy = function () {

    /**
     * I accept _either_ (TableAccess, entityKey, tableKey, id), (TableAccess,
     * entityInfo, id), _or_ (TableProxy, entityKey). Javascript provides no way
     * to gracefully expose multiple constructors.
     * @param access a TableAccess or TableProxy to use for data access
     * @param entityKey key or info for the entity to masquerade as
     * @param tableKey the key of the table under the entity; only needed if a
     *  TableAccess is provided and entity info is not.
     * @param id the id of the record being proxied; only needed if a
     *  TableAccess is provided.
     */
    function EntityProxy(access, entityKey, tableKey, id) {
        _classCallCheck(this, EntityProxy);

        // "overload" the constructor
        if (entityKey == null) {
            throw new Error("Proxies cannot be constructed with null keys or ids ('" + entityKey + "#" + id + "').");
        }
        if (entityKey.hasOwnProperty("key")) {
            // it's an info object
            this.entityInfo = entityKey;
            entityKey = this.entityInfo.key;
            id = tableKey;
            tableKey = this.entityInfo.tableKey;
        } else {
            this.entityInfo = _entityMetaStore2.default.getInfo(entityKey);
        }
        if (access instanceof _TableProxy2.default) {
            this.tableProxy = access;
            this.entityKey = entityKey;
            this.id = access.id;
        } else {
            if (tableKey == null) {
                tableKey = this.entityInfo.tableKey;
            }
            if (tableKey == null || id == null) {
                throw new Error("Proxies cannot be constructed with null keys or ids ('" + entityKey + ":" + tableKey + "#" + id + "').");
            }
            this.tableProxy = new _TableProxy2.default(access, tableKey, id);
            this.entityKey = entityKey;
            this.id = id;
        }
    }

    _createClass(EntityProxy, [{
        key: "get",
        value: function get(field) {
            try {
                return this.getField(field);
            } catch (e) {
                console.warn("EP.get: " + this.entityKey + "#" + this.id + "." + field, e);
                return null;
            }
        }
    }, {
        key: "isFieldEnabled",
        value: function isFieldEnabled(fieldOrInfo) {
            var info = typeof fieldOrInfo === "string" ? _entityFieldMetaStore2.default.getInfo(this.entityKey, fieldOrInfo) : fieldOrInfo;
            (0, _invariant2.default)(this.entityKey === info.entityKey, "Field '%s' belongs to '%s', not '%s'", info.key, info.entityKey, this.entityKey);
            if (!hasEnableScript(info)) return true;
            try {
                var enabled = info.scripts.enable(this);
                return enabled == null || enabled;
            } catch (e) {
                console.warn("ENABLED: " + this.entityKey + "#" + this.id + "." + info.key, e);
                return true;
            }
        }
    }, {
        key: "isRecordEnabled",
        value: function isRecordEnabled() {
            if (!hasEnableScript(this.entityInfo)) return true;
            try {
                var enabled = this.entityInfo.scripts.enable(this);
                return enabled == null || enabled;
            } catch (e) {
                console.warn("ENABLED: " + this.entityKey + "#" + this.id, e);
                return true;
            }
        }
    }, {
        key: "frontsColumnWithKey",
        value: function frontsColumnWithKey(colKey) {
            // first, ensure it's even a legal column
            _TableColumnMetaStore2.default.getInfoByKey(this.tableProxy.tableKey, colKey);
            // todo: this should probably cache column mappings
            return _entityFieldMetaStore2.default.getInfoForColumnKey(this.entityKey, colKey, false) != null;
        }
    }, {
        key: "getAttributeType",
        value: function getAttributeType(fieldOrInfo) {
            var info = this._toInfo(fieldOrInfo);
            return (0, _infoTypeToFieldType.infoTypeToFieldType)(info.type);
        }
    }, {
        key: "_toInfo",
        value: function _toInfo(fieldOrInfo) {
            if (typeof fieldOrInfo === "string") {
                // todo: this should probably cache entity-table mappings
                return _entityFieldMetaStore2.default.getInfo(this.entityKey, fieldOrInfo);
            } else {
                return fieldOrInfo;
            }
        }
    }, {
        key: "getField",
        value: function getField(fieldOrInfo) {
            var _this = this;

            var info = this._toInfo(fieldOrInfo);
            var value = this.tableProxy.getColumn(info.logicalKey, true);
            if (value == null) return null;
            if (isAbstractAssoc(info)) {
                var colInfo = _TableColumnMetaStore2.default.getInfoByKey(this.tableProxy.tableKey, info.logicalKey);
                value = (0, _asArray2.default)(value).map(function (id) {
                    return new EntityProxy(_this.tableProxy.access, info.otherEntityKey, colInfo.otherTableKey, id);
                });

                if (value.length > 1) {
                    var comparator = (0, _compareRecords.comparatorForField)(info);
                    if (comparator) {
                        value.sort(comparator);
                    }
                }
            } else if (isChoice(info)) {
                value = (0, _asArray2.default)(value).map((0, _options.optionName)(info.choiceKey));
            }
            if (isSelection(info)) {
                value = info.multiValued ? value : value.length > 0 ? value[0] : null;
            }
            return value;
        }
    }, {
        key: "compareTo",
        value: function compareTo(other) {
            if (this.entityKey !== other.entityKey) {
                throw new Error("'" + this.entityKey + "' is not of the same entity type '" + other.entityKey + "'");
            }
            if (this.id === other.id) {
                // identical quick return;
                return 0;
            }
            if (this._natural_order == null) {
                this._natural_order = (0, _compareRecords.comparatorForEntity)(this.entityInfo);
            }
            return this._natural_order(this, other);
        }
    }, {
        key: "getColumnByKey",
        value: function getColumnByKey(colKey) {
            return this.getField(_entityFieldMetaStore2.default.getInfoForColumnKey(this.entityKey, colKey).key);
        }
    }, {
        key: "getKey",
        value: function getKey() {
            return this.entityKey + "#" + this.id;
        }
    }, {
        key: "getLabel",
        value: function getLabel() {
            return (0, _recordLabel2.default)(this.entityInfo, this);
        }
    }, {
        key: "getParent",
        value: function getParent() {
            return this.entityInfo.parentPointerKey ? this.getField(this.entityInfo.parentPointerKey) : null;
        }
    }, {
        key: "getRecordMeta",
        value: function getRecordMeta() {
            return this.tableProxy.getRecordMeta();
        }
    }, {
        key: "equals",
        value: function equals(o) {
            if (o == null) return false;
            if (!(o instanceof EntityProxy)) return false;
            if (this.entityKey !== o.entityKey) return false;
            if (!this.tableProxy.equals(o.tableProxy)) return false;
            return true;
        }

        // is this record still the type it was created as?

    }, {
        key: "isCorrectVersion",
        value: function isCorrectVersion() {
            if (this.entityInfo.type === "ROOT" && hasIsVersionScript(this.entityInfo)) {
                var v = this.entityInfo.scripts.isVersion(this);
                return v == null || !!v;
            }
            return true;
        }
    }, {
        key: "getFieldModelComparator",
        value: function getFieldModelComparator() {
            var shortnameAttribute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "shortname";

            return (0, _entityFieldMetaStore.getFieldInfoComparator)(_entityFieldMetaStore2.default.getInfosByKey(this.entityKey), shortnameAttribute);
        }
    }, {
        key: "canCreate",
        value: function canCreate() {
            return this.entityInfo.canCreate;
        }
    }, {
        key: "canWrite",
        value: function canWrite() {
            return this.entityInfo.canWrite;
        }
    }, {
        key: "canDelete",
        value: function canDelete() {
            return this.entityInfo.canDelete;
        }
    }, {
        key: "getMetadata",
        value: function getMetadata() {
            return this.tableProxy.getMetadata();
        }
    }]);

    return EntityProxy;
}();

exports.default = EntityProxy;

/***/ }),
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isAllImplementationsSelected = exports.isImplementationExpanded = exports.isImplementationSelected = exports.isVersionSelected = exports.isRecordSelected = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ContextedReduceStore2 = __webpack_require__(30);

var _ContextedReduceStore3 = _interopRequireDefault(_ContextedReduceStore2);

var _NavigationActions = __webpack_require__(80);

var _NavigationActions2 = _interopRequireDefault(_NavigationActions);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _typedefs = __webpack_require__(44);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _RecordActions = __webpack_require__(60);

var _RecordActions2 = _interopRequireDefault(_RecordActions);

var _OverStore = __webpack_require__(61);

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _dotPropImmutable = __webpack_require__(40);

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _entityFields = __webpack_require__(158);

var _superRecords = __webpack_require__(63);

var _MapButtonActions = __webpack_require__(141);

var _MapButtonActions2 = _interopRequireDefault(_MapButtonActions);

var _MergeActions = __webpack_require__(59);

var _MergeActions2 = _interopRequireDefault(_MergeActions);

var _MappingActions = __webpack_require__(109);

var _MappingActions2 = _interopRequireDefault(_MappingActions);

var _MergeStore = __webpack_require__(53);

var _MergeStore2 = _interopRequireDefault(_MergeStore);

var _SuperRecordStore = __webpack_require__(36);

var _SuperRecordStore2 = _interopRequireDefault(_SuperRecordStore);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isRecordSelected = exports.isRecordSelected = function isRecordSelected(state, entityKey, id) {
    var rec = state.record;
    if (rec == null) return false;
    return rec.key === entityKey && rec.id === id;
};

var isVersionSelected = exports.isVersionSelected = function isVersionSelected(state, entityOrVersionKey) {
    var magic = state.magic;
    if (magic == null) return false;
    if (magic.versionKey == null) return false;
    return magic.versionKey === new _EntityName2.default(entityOrVersionKey).versionKey;
};

var isImplementationSelected = exports.isImplementationSelected = function isImplementationSelected(state, implementationKey) {
    var magic = state.magic;
    if (magic == null) return false;
    if (magic.versionKey != null) return false;
    return magic.implementationKey === implementationKey;
};

var isImplementationExpanded = exports.isImplementationExpanded = function isImplementationExpanded(state, implementationKey) {
    var magic = state.magic;
    if (magic == null) return false;
    if (magic.expandedImplKeys != null) {
        if (magic.expandedImplKeys.indexOf(implementationKey) >= 0) {
            return true;
        }
    }
    if (magic.versionKey == null) return false;
    return new _EntityName2.default(magic.versionKey).implKey === implementationKey;
};

var isAllImplementationsSelected = exports.isAllImplementationsSelected = function isAllImplementationsSelected(state) {
    var magic = state.magic;
    return magic.implementationKey == null && magic.versionKey == null;
};

var addDistinct = function addDistinct(items, newItem) {
    if (items == null) return [newItem];
    if (items.indexOf(newItem) >= 0) return items;
    return items.concat(newItem);
};

var removeDistinct = function removeDistinct(items, oldItem) {
    if (items == null) return null;
    var idx = items.indexOf(oldItem);
    if (idx < 0) return items;
    if (idx === 0) items.slice(1);
    items = items.slice();
    items.splice(idx, 1);
    return items;
};

var _deleteRecord = function _deleteRecord(context, action) {
    if (context.record == null || context.record.id !== action.recordId) return context;
    var en = new _EntityName2.default(action.recordKey);
    return {
        magic: _extends({}, context.magic, {
            implementationKey: en.implKey,
            versionKey: en.versionKey
        }),
        record: {
            // this is gonna cause problems for non-magics (globals)
            key: _StereotypesStore2.default.getStereotypeByKey(context.magic.key).implementations.find(function (it) {
                return it.childKey === action.recordKey;
            }).key,
            id: context.magic.id
        }
    };
};

var _deleteChild = function _deleteChild(context, action) {
    if (context.record == null || context.record.id !== action.childId) return context;
    // select the parent record
    return _extends({}, context, {
        record: {
            key: action.recordKey,
            id: action.recordId
        }
    });
};

var _merge_delete = function _merge_delete(context) {
    if (_MergeStore2.default.isReady()) return context; // not merging anything
    _Dispatcher2.default.waitFor([// todo: get this.dispatcher...
    _TableStore2.default.getDispatchToken(), _SuperRecordStore2.default.getDispatchToken()]);
    switch (_MergeStore2.default.getPluginKey()) {
        case _MergeStore.MERGE_PLUGINS.RECORD_MERGE:
            {
                var action = _MergeStore2.default.getDeleteAction();
                return _deleteRecord(context, action);
            }

        case _MergeStore.MERGE_PLUGINS.CHILD_MERGE:
            {
                var _action = _MergeStore2.default.getDeleteAction();
                return _deleteChild(context, _action);
            }
        // nothing to delete on the client
        default:
            return context;
    }
};

function openRecord(context, key, id) {
    if (isRecordSelected(context, key, id)) {
        return context;
    }
    var next = _extends({}, context, {
        record: {
            key: key,
            id: id
        }
    });
    if (context.magic && context.magic.id === id) {
        var en = new _EntityName2.default(key);
        next.magic = _extends({}, next.magic, {
            implementationKey: en.implKey,
            expandedImplKeys: addDistinct(next.magic.expandedImplKeys, en.implKey),
            versionKey: en.versionKey
        });
    }
    return next;
}

var processSROpenState = function processSROpenState(context, action) {
    if (isRecordSelected(context, action.entityKey, action.recordId)) {
        return _extends({}, context, { // this allows the target record to be set before the superrecord is loaded
            magic: {
                key: action.key,
                id: action.id
            }
        });
    }
    var next = _extends({}, context, {
        magic: {
            key: action.key,
            id: action.id
        },
        record: action.entityKey != null && action.recordId != null ? {
            key: action.entityKey,
            id: action.recordId
        } : null
    });
    if (context.magic && context.magic.id === action.recordId) {
        var en = new _EntityName2.default(action.entityKey);
        next.magic = _extends({}, next.magic, {
            implementationKey: en.implKey,
            expandedImplKeys: addDistinct(next.magic.expandedImplKeys, en.implKey),
            versionKey: en.versionKey
        });
    }
    return next;
};

var processSelectImplementationState = function processSelectImplementationState(context, action) {
    if (isImplementationSelected(context, action.implementationKey)) {
        return context;
    }
    var magic = _extends({}, context.magic, {
        implementationKey: action.implementationKey,
        expandedImplKeys: addDistinct(context.magic.expandedImplKeys, action.implementationKey)
    });
    delete magic.versionKey;
    return {
        magic: magic
        // kill record
    };
};

var processToggleImplementationState = function processToggleImplementationState(context, action) {
    var open = isImplementationExpanded(context, action.implementationKey);
    var magic = _extends({}, context.magic);
    magic.expandedImplKeys = open ? removeDistinct(magic.expandedImplKeys, action.implementationKey) : addDistinct(magic.expandedImplKeys, action.implementationKey);
    if (open && magic.versionKey != null) {
        var vk = new _EntityName2.default(magic.versionKey);
        if (vk.implKey === action.implementationKey) {
            magic.versionKey = null;
        }
    }
    return _extends({}, context, {
        magic: magic
    });
};

var processSelectAllImplementationsState = function processSelectAllImplementationsState(context) {
    var magic = _extends({}, context.magic);
    delete magic.versionKey;
    delete magic.implementationKey;
    return {
        magic: magic
        // kill record
    };
};

var processNewRecordState = function processNewRecordState(context, action) {
    if (!action.navigate) return context;
    var en = new _EntityName2.default(action.recordKey);
    return {
        magic: {
            key: action.stereoKey,
            id: action.newId,
            implementationKey: en.implKey,
            expandedImplKeys: [en.implKey],
            versionKey: en.versionKey
        },
        record: {
            key: action.recordKey,
            id: action.newId
        }
    };
};

var processNewMagicChildState = function processNewMagicChildState(context, action) {
    if (!action.navigate) return context;
    var en = new _EntityName2.default(action.entityKey);
    var magic = _extends({}, context.magic, {
        expandedImplKeys: addDistinct(context.magic.expandedImplKeys, en.implKey)
    });
    if (isAllImplementationsSelected(context)) {
        // sweet!
    } else if (isImplementationSelected(context, en.implKey)) {
        // also good enough!
    } else if (isVersionSelected(context, action.entityKey)) {
        // and good enough again!
    } else {
        magic.implementationKey = en.implKey;
        magic.versionKey = null;
    }
    return {
        magic: magic,
        record: {
            key: action.entityKey,
            id: action.newId
        }
    };
};

var processSetFieldState = function processSetFieldState(context, action) {
    // and that there WAS a change
    if (!_TableStore2.default.hasChanged()) return context;
    var ep = _TableStore2.default.getEntityProxy(action.recordKey, action.recordId);
    if (!(0, _entityFields.isVersionInfluencing)(action.recordKey, action.fieldKey)) {
        return context;
    }
    if (ep.isCorrectVersion()) return context;
    // so it changed versions. figure out what the new one is...
    var tp = ep.tableProxy;
    var eks = tp.getEntityKeys();
    if (eks.length === 0) {
        throw new Error("Record '" + ep.getKey() + "' has '" + action.fieldKey + "': '" + action.value + "'. This matches no version.");
    }
    if (eks.length > 1) {
        throw new Error("Record '" + ep.getKey() + "' has '" + action.fieldKey + "': '" + action.value + "'. This matches multiple versions (" + eks.join(", ") + ").");
    }
    context = _extends({}, context, {
        record: _extends({}, context.record, {
            key: eks[0]
        })
    });
    if (context.magic != null && new _EntityName2.default(action.recordKey).versionKey === context.magic.versionKey) {
        context.magic = _extends({}, context.magic, {
            versionKey: new _EntityName2.default(eks[0]).versionKey
        });
    }
    return context;
};

var processDoMergeState = function processDoMergeState(context, action) {
    if (!(0, _OverStore.isConfirmed)(action)) return context;
    switch (_MergeStore2.default.getPluginKey()) {
        case _MergeStore.MERGE_PLUGINS.RECORD_MERGE:
            return _deleteRecord(context, action);
        case _MergeStore.MERGE_PLUGINS.CHILD_MERGE:
            return _deleteChild(context, action);
        default:
            return context;
    }
};

var processLoadedState = function processLoadedState(context, action) {
    var magic = context.magic;
    if (magic == null) return context;
    if (magic.key !== action.key) return context;
    if (magic.id !== action.id) return context;
    var rec = context.record;
    if (rec == null) return context;
    if (!_ClientId2.default.is(rec.id)) return context;
    //  reloading the same magic with the current record being
    // client-only means the current record is no more.
    return _dotPropImmutable2.default.delete(context, "record");
};

var processUpdatedState = function processUpdatedState(context, action) {
    if (context.magic && action.data.newIds.hasOwnProperty(context.magic.id)) {
        context = _dotPropImmutable2.default.set(context, ["magic", "id"], action.data.newIds[context.magic.id]);
    }
    if (context.record && action.data.newIds.hasOwnProperty(context.record.id)) {
        context = _dotPropImmutable2.default.set(context, ["record", "id"], action.data.newIds[context.record.id]);
    }
    return context;
};

var NavigatorStore = function (_ContextedReduceStore) {
    _inherits(NavigatorStore, _ContextedReduceStore);

    function NavigatorStore() {
        _classCallCheck(this, NavigatorStore);

        return _possibleConstructorReturn(this, (NavigatorStore.__proto__ || Object.getPrototypeOf(NavigatorStore)).call(this, _Dispatcher2.default));
    }

    _createClass(NavigatorStore, [{
        key: "getInitialContext",
        value: function getInitialContext() {
            return {};
        }
    }, {
        key: "reduceContext",
        value: function reduceContext(context, action) {
            switch (action.type) {

                case _SuperRecordActions2.default.OPEN:
                    {
                        return processSROpenState(context, action);
                    }

                case _NavigationActions2.default.SELECT_RECORD:
                case _NavigationActions2.default.FOCUS_FIELD:
                    {
                        return openRecord(context, action.entityKey, action.recordId);
                    }

                case _NavigationActions2.default.SELECT_IMPLEMENTATION:
                    {
                        return processSelectImplementationState(context, action);
                    }

                case _NavigationActions2.default.TOGGLE_IMPLEMENTATION:
                    {
                        return processToggleImplementationState(context, action);
                    }

                case _NavigationActions2.default.SELECT_ALL_IMPLEMENTATIONS:
                    {
                        return processSelectAllImplementationsState(context, action);
                    }

                case _SuperRecordActions2.default.NEW:
                    {
                        return processNewRecordState(context, action);
                    }

                case _SuperRecordActions2.default.NEW_MAGIC_CHILD:
                case _MapButtonActions2.default.AUTOMAP_TO_NEW_MAGIC_CHILD:
                    {
                        return processNewMagicChildState(context, action);
                    }

                case _RecordActions2.default.NEW_CHILD:
                    {
                        if (!action.navigate) {
                            return context;
                        }
                        return openRecord(context, action.entityKey, action.newId);
                    }

                default:
                    return context;
            }
        }
    }, {
        key: "reduceEachContext",
        value: function reduceEachContext(context, action) {
            switch (action.type) {

                case _RecordActions2.default.SET_FIELD:
                    {
                        // ensure the change is recorded
                        this.__dispatcher.waitFor([_TableStore2.default.getDispatchToken()]);
                        return processSetFieldState(context, action);
                    }

                case _MappingActions2.default.IT_IS_DONE:
                    {
                        // This is not needed for the current merge flow (Merge From...).
                        // But if we ever decide to go the other direction (Merge To...)
                        // this will be necessary.
                        return _merge_delete(context);
                    }

                case _MergeActions2.default.DO_MERGE:
                    {
                        // wait for merge to be processed then delete.
                        this.__dispatcher.waitFor([_TableStore2.default.getDispatchToken(), _MergeStore2.default.getDispatchToken()]);

                        return processDoMergeState(context, action);
                    }

                case _RecordActions2.default.DELETE_RECORD:
                    {
                        if (!(0, _OverStore.isConfirmed)(action)) return context;
                        return _deleteRecord(context, action);
                    }

                case _RecordActions2.default.DELETE_CHILD:
                    if (!(0, _OverStore.isConfirmed)(action)) return context;
                    return _deleteChild(context, action);

                case _SuperRecordActions2.default.LOADED:
                    {
                        return processLoadedState(context, action);
                    }

                case _SuperRecordActions2.default.CREATED:
                case _SuperRecordActions2.default.UPDATED:
                    {
                        return processUpdatedState(context, action);
                    }

                case _SuperRecordActions2.default.DELETED:
                    if (context.magic == null || context.magic.id !== action.id) return context;
                    return this.getInitialContext();

                default:
                    return context;
            }
        }
    }, {
        key: "getMagicState",
        value: function getMagicState(context) {
            return this.getState(context).magic;
        }
    }, {
        key: "getRecordState",
        value: function getRecordState(context) {
            return this.getState(context).record;
        }
    }, {
        key: "getRecordPath",
        value: function getRecordPath(context) {
            return (0, _superRecords.getRecordNavPath)(this.getState(context));
        }
    }]);

    return NavigatorStore;
}(_ContextedReduceStore3.default);

NavigatorStore.contextTypes = {
    magic: _propTypes2.default.exact({
        key: _propTypes2.default.string,
        id: _typedefs.recordIdType,
        implementationKey: _propTypes2.default.string,
        expandedImplKeys: _propTypes2.default.arrayOf(_propTypes2.default.string),
        versionKey: _propTypes2.default.string
    }),
    record: _propTypes2.default.shape({
        key: _propTypes2.default.string,
        id: _typedefs.recordIdType
    })
};

exports.default = (0, _typeCheckingStore2.default)(new NavigatorStore());

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addNew = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(13);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

var _DataManager = __webpack_require__(43);

var _DataManager2 = _interopRequireDefault(_DataManager);

var _dotPropImmutable = __webpack_require__(40);

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

var _SuperRecordListActions = __webpack_require__(140);

var _SuperRecordListActions2 = _interopRequireDefault(_SuperRecordListActions);

var _storeUtils = __webpack_require__(54);

var _superRecords = __webpack_require__(63);

var _RecordActions = __webpack_require__(60);

var _RecordActions2 = _interopRequireDefault(_RecordActions);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _OverStore = __webpack_require__(61);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _NavigatorStore = __webpack_require__(33);

var _NavigatorStore2 = _interopRequireDefault(_NavigatorStore);

var _ContextedReduceStore = __webpack_require__(30);

var _saveit = __webpack_require__(226);

var _MapButtonActions = __webpack_require__(141);

var _MapButtonActions2 = _interopRequireDefault(_MapButtonActions);

var _MappingStore = __webpack_require__(65);

var _MappingStore2 = _interopRequireDefault(_MappingStore);

var _MappingActions = __webpack_require__(109);

var _MappingActions2 = _interopRequireDefault(_MappingActions);

var _MapDialogActions = __webpack_require__(64);

var _MapDialogActions2 = _interopRequireDefault(_MapDialogActions);

var _SearchResultActions = __webpack_require__(143);

var _SearchResultActions2 = _interopRequireDefault(_SearchResultActions);

var _MergeStore = __webpack_require__(53);

var _MergeStore2 = _interopRequireDefault(_MergeStore);

var _SuperRecordMappingVisitor = __webpack_require__(978);

var _SuperRecordMappingVisitor2 = _interopRequireDefault(_SuperRecordMappingVisitor);

var _MergeStore3 = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isMagicRootKey = function isMagicRootKey(key) {
    return !_EntityName2.default.is(key);
};

var keyPath = function keyPath(key) {
    return isMagicRootKey(key) ? "mr" : "tlr";
};

var path = function path(action) {
    var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : action.id;
    return [id, keyPath(action.key)];
};

var addTopLevelId = function addTopLevelId(state, srKey, srId, tlrKey, tlrId) {
    return _dotPropImmutable2.default.set(state, [srId, keyPath(srKey)], function (lo) {
        return lo.map(function (v) {
            return _dotPropImmutable2.default.set(v, ["topLevelIds", tlrKey], function (ids) {
                return Array.isArray(ids) ? ids.concat(tlrId) : [tlrId];
            });
        });
    });
};

var addNew = exports.addNew = function addNew(state, key, id) {
    return _dotPropImmutable2.default.set(state, [id, keyPath(key)], _LoadObject2.default.withValue({
        id: id,
        topLevelIds: {}
    }));
};

var create = function create(state, key, id, initiatingContext) {
    var prop = [id, keyPath(key)];
    (0, _invariant2.default)(!_dotPropImmutable2.default.get(state, prop).isCreating(), "RACE! Multiple concurrent requests to create %s#%s.", key, id);
    var storeVal = (0, _superRecords.superRecordPacket)(_TableStore2.default, _StereotypesStore2.default.getStereotypeByKey(key), id, getLO(state, key, id).getValueEnforcing(), _userStore2.default.getActiveOrgKey());
    return _dotPropImmutable2.default.set(state, prop, _LoadObject2.default.withValue(storeVal).creating(_DataManager2.default.createSuperrecord(key, id, storeVal, _userStore2.default.getActiveOrgKey(), initiatingContext)));
};

var getLO = function getLO(state, key, id) {
    if (!state.hasOwnProperty(id)) return null;
    var path = keyPath(key);
    if (state[id].hasOwnProperty(path)) return state[id][path];
    return state[id].mr;
};

var _mapping_workflow = function _mapping_workflow(state) {
    // ensure MappingStore goes first
    _Dispatcher2.default.waitFor([// todo: get this.dispatcher...
    _MappingStore2.default.getDispatchToken(), _TableStore2.default.getDispatchToken()]);

    // If MappingStore didn't change, I won't either.
    if (!_MappingStore2.default.hasChanged()) return state;

    // If MappingStore isn't ready, wait until it is.
    if (!_MappingStore2.default.isReady()) return state;

    /*
     * We are GO!
     */

    return new _SuperRecordMappingVisitor2.default(state).execute().getState();
};

var _deleteRecord = function _deleteRecord(state, action) {
    // todo: index instead of scanning
    Object.keys(state).forEach(function (id) {
        if (!state[id].hasOwnProperty("mr")) {
            return;
        }
        if (state[id].mr.isPending()) {
            return;
        }
        var r = state[id].mr.getRequiredValue();
        if (!r.topLevelIds.hasOwnProperty(action.recordKey)) {
            return;
        }
        var i = r.topLevelIds[action.recordKey].indexOf(action.recordId);
        if (i < 0) {
            return;
        }
        state = _dotPropImmutable2.default.set(state, [id, "mr"], function (lo) {
            return lo.map(function (v) {
                return _dotPropImmutable2.default.set(v, ["topLevelIds", action.recordKey], function (ids) {
                    return ids.slice(0, i).concat(ids.slice(i + 1));
                });
            });
        });
    });
    return state;
};

var SuperRecordStore = function (_ReduceStore) {
    _inherits(SuperRecordStore, _ReduceStore);

    function SuperRecordStore() {
        _classCallCheck(this, SuperRecordStore);

        return _possibleConstructorReturn(this, (SuperRecordStore.__proto__ || Object.getPrototypeOf(SuperRecordStore)).call(this, _Dispatcher2.default));
    }

    _createClass(SuperRecordStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {};
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {

                case _RecordActions2.default.SET_FIELD:
                    {
                        this.__dispatcher.waitFor([_NavigatorStore2.default.getDispatchToken()]);
                        if (!_NavigatorStore2.default.hasChanged()) return state;
                        // nav changed; probably a version change!
                        var ep = _TableStore2.default.getEntityProxy(action.recordKey, action.recordId);
                        var tp = ep.tableProxy;
                        var eks = tp.getEntityKeys();
                        if (eks[0] === action.recordKey) return state;

                        //todo: It's pretty dumb to need to do this munge, but this
                        // whole store is a kludge for marionette load flows and should
                        // go away at some point. For now... it "works".

                        // indeed! do the munge...
                        Object.keys(state).filter(function (id) {
                            return state[id].mr != null;
                        }).filter(function (id) {
                            return state[id].mr.hasValue();
                        }).map(function (id) {
                            return state[id].mr.getRequiredValue();
                        }).filter(function (mr) {
                            return mr.topLevelIds != null;
                        }).filter(function (mr) {
                            return mr.topLevelIds.hasOwnProperty(action.recordKey);
                        }).forEach(function (mr) {
                            state = _dotPropImmutable2.default.set(state, [mr.id, "mr"], function (lo) {
                                return lo.map(function (mr) {
                                    var _extends2;

                                    var prev = mr.topLevelIds[action.recordKey].slice();
                                    var idx = prev.indexOf(action.recordId);
                                    if (idx < 0) return mr;
                                    prev.splice(idx, 1);
                                    var next = (mr.topLevelIds[eks[0]] || []).slice();
                                    next.push(action.recordId);
                                    return _extends({}, mr, {
                                        topLevelIds: _extends({}, mr.topLevelIds, (_extends2 = {}, _defineProperty(_extends2, action.recordKey, prev), _defineProperty(_extends2, eks[0], next), _extends2))
                                    });
                                });
                            });
                        });
                        return state;
                    }

                case _SuperRecordActions2.default.START_LOAD:
                    this.__dispatcher.waitFor([_userStore2.default.getDispatchToken()]);
                    (0, _invariant2.default)(!_ClientId2.default.is(action.id), "You can't load client-side records (%s#%s) from the server.", action.key, action.id);
                    return _dotPropImmutable2.default.set(state, path(action), _LoadObject2.default.load(_DataManager2.default.loadSuperrecord(action.key, action.id, _userStore2.default.getActiveOrgKey())));

                case _SuperRecordActions2.default.LOADED:
                    {
                        state = _dotPropImmutable2.default.set(state, path(action), function (lo) {
                            return lo.receiveValue({
                                id: action.data.id,
                                topLevelIds: action.data.topLevelIds
                            });
                        });
                        state = _mapping_workflow(state);
                        return state;
                    }

                case _SuperRecordListActions2.default.LOADED:
                    {
                        if (action.data.length === 0) return state;
                        var next = _extends({}, state);
                        action.data.forEach(function (r) {
                            var type = keyPath(action.key);
                            var rec = next[r.id] = next.hasOwnProperty(r.id) ? _extends({}, next[r.id]) : {};
                            var lo = rec[type] || _LoadObject2.default.empty();
                            rec[type] = lo.receiveValue(r);
                        });
                        return next;
                    }

                case _SuperRecordActions2.default.LOAD_ERROR:
                    {
                        return _dotPropImmutable2.default.set(state, path(action), function (lo) {
                            return lo.receiveError(action.error);
                        });
                    }

                case _SuperRecordActions2.default.START_CREATE:
                    {
                        if (!(0, _saveit.canSave)()) return state;
                        this.__dispatcher.waitFor([_userStore2.default.getDispatchToken()]);
                        return create(state, action.key, action.id, action[_ContextedReduceStore.ACTION_CONTEXT_KEY] || action.initiatingContext);
                    }

                case _SuperRecordActions2.default.CREATED:
                    {
                        var lo = _dotPropImmutable2.default.get(state, path(action));
                        state = _dotPropImmutable2.default.delete(state, path(action));
                        state = _dotPropImmutable2.default.set(state, path(action, action.data.id), lo.receiveValue({
                            id: action.data.id,
                            topLevelIds: action.data.topLevelIds
                        }));
                        state = _mapping_workflow(state);
                        return state;
                    }

                case _SuperRecordActions2.default.NEW:
                    {
                        return addNew(state, action.stereoKey, action.newId);
                    }

                case _SuperRecordActions2.default.CREATE_ERROR:
                    return _dotPropImmutable2.default.set(state, path(action), function (lo) {
                        return lo.receiveError(action.error);
                    });

                case _SuperRecordActions2.default.START_UPDATE:
                    {
                        if (!(0, _saveit.canSave)()) return state;
                        if (_ClientId2.default.is(action.id)) {
                            throw new Error("Update an unsaved (client-only) superrecord?!");
                        }
                        this.__dispatcher.waitFor([_userStore2.default.getDispatchToken()]);
                        var storeVal = (0, _superRecords.superRecordPacket)(_TableStore2.default, _StereotypesStore2.default.getStereotypeByKey(action.key), action.id, getLO(state, action.key, action.id).getValueEnforcing(), _userStore2.default.getActiveOrgKey());
                        return _dotPropImmutable2.default.set(state, path(action), function (lo) {
                            return lo.setValue(storeVal).updating(_DataManager2.default.updateSuperrecord(action.key, action.id, storeVal, _userStore2.default.getActiveOrgKey(), action[_ContextedReduceStore.ACTION_CONTEXT_KEY] || action.initiatingContext));
                        });
                    }

                case _SuperRecordActions2.default.UPDATED:
                    return _dotPropImmutable2.default.set(state, path(action), function (lo) {
                        return lo.receiveValue({
                            id: action.data.id,
                            topLevelIds: action.data.topLevelIds
                        });
                    });
                case _SuperRecordActions2.default.UPDATE_ERROR:
                    return _dotPropImmutable2.default.set(state, path(action), function (lo) {
                        return lo.receiveError(action.error);
                    });
                case _SuperRecordActions2.default.DELETE_RECORD:
                    if (!(0, _OverStore.isConfirmed)(action)) return state;
                    this.__dispatcher.waitFor([_TableStore2.default.getDispatchToken(), _userStore2.default.getDispatchToken()]);
                    return _dotPropImmutable2.default.set(state, path(action), function (lo) {
                        return lo.deleting(_DataManager2.default.deleteSuperrecord(action.key, action.id, _userStore2.default.getActiveOrgKey(), action[_ContextedReduceStore.ACTION_CONTEXT_KEY] || action.initiatingContext));
                    });
                case _SuperRecordActions2.default.DELETED:
                    return _dotPropImmutable2.default.delete(state, path(action));
                case _SuperRecordActions2.default.DELETE_ERROR:
                    return _dotPropImmutable2.default.set(state, path(action), function (lo) {
                        return lo.receiveError(action.error);
                    });
                case _RecordActions2.default.NEW:
                    return _dotPropImmutable2.default.set(state, [action.newId, keyPath(action.recordKey)], _LoadObject2.default.withValue({
                        id: action.newId,
                        topLevelIds: {}
                    }));

                case _SuperRecordActions2.default.NEW_MAGIC_CHILD:
                    {
                        return addTopLevelId(state, action.recordKey, action.recordId, action.entityKey, action.newId);
                    }

                case _MapButtonActions2.default.AUTOMAP_TO_NEW_MAGIC_CHILD:
                    {
                        var magic = _NavigatorStore2.default.getMagicState(action[_ContextedReduceStore.ACTION_CONTEXT_KEY]);
                        return addTopLevelId(state, magic.key, magic.id, action.entityKey, action.newId);
                    }

                case _MapButtonActions2.default.AUTOMAP_FROM:
                case _MappingActions2.default.MODEL_LOADED:
                case _MapDialogActions2.default.TOGGLE_EXCLUSION:
                case _MapDialogActions2.default.SET_MAGIC_ROOT_EXCLUSION:
                case _MapDialogActions2.default.IMPORT:
                case _SearchResultActions2.default.SEARCH_RESULT:
                case _MappingActions2.default.__DO_IT_AGAIN:
                    {
                        return _mapping_workflow(state);
                    }

                case _MappingActions2.default.IT_IS_DONE:
                    {
                        if (_MergeStore2.default.isReady()) return state; // not merging anything
                        // wait for merge to be processed then delete.
                        this.__dispatcher.waitFor([_TableStore2.default.getDispatchToken()]);
                        var mergeType = _MergeStore2.default.getPluginKey();

                        if (mergeType === _MergeStore3.MERGE_PLUGINS.RECORD_MERGE) {
                            var _action = _MergeStore2.default.getDeleteAction();
                            return _deleteRecord(state, _action);
                        } else if (mergeType === _MergeStore3.MERGE_PLUGINS.GLOBAL_MERGE) {
                            // now we need to save the target record.
                            this.__dispatcher.waitFor([_userStore2.default.getDispatchToken()]);
                            var mergeState = _MergeStore2.default.getState();
                            var updateAction = {
                                key: mergeState.target.stereoKey,
                                id: mergeState.target.id,
                                sourceId: mergeState.source.id
                            };

                            var _storeVal = (0, _superRecords.superRecordPacket)(_TableStore2.default, _StereotypesStore2.default.getStereotypeByKey(updateAction.key), updateAction.id, getLO(state, updateAction.key, updateAction.id).getValueEnforcing(), _userStore2.default.getActiveOrgKey());
                            return _dotPropImmutable2.default.set(state, path(updateAction), function (lo) {
                                return lo.setValue(_storeVal).updating(_DataManager2.default.mergeSuperrecord(updateAction.key, updateAction.id, updateAction.sourceId, _storeVal, _userStore2.default.getActiveOrgKey(), action.initiatingContext));
                            });
                        }
                        return state;
                    }

                case _RecordActions2.default.DELETE_RECORD:
                    if (!(0, _OverStore.isConfirmed)(action)) return state;
                    return _deleteRecord(state, action);
                default:
                    return state;
            }
        }
    }, {
        key: "isUnsaved",
        value: function isUnsaved(key, id) {
            var lo = getLO(this.getState(), key, id);
            return lo != null && !lo.hasOperation();
        }
    }, {
        key: "getRecord",
        value: function getRecord(key, id) {
            return this.getRecordLO(key, id).getValueEnforcing();
        }
    }, {
        key: "getRecordLO",
        value: function getRecordLO(key, id, forceRefresh) {
            var _this2 = this;

            return (0, _storeUtils.hotLoadObject)(function () {
                return getLO(_this2.getState(), key, id);
            }, function () {
                return _Dispatcher2.default.dispatch({
                    type: _SuperRecordActions2.default.START_LOAD,
                    key: key,
                    id: id
                });
            }, function (lo) {
                return !lo.isPending() && (forceRefresh || lo.isEmpty());
            });
        }
    }]);

    return SuperRecordStore;
}(_utils.ReduceStore);

exports.default = new SuperRecordStore();

/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = useKeyValueState;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function useKeyValueState(initialState) {
    var _React$useState = _react2.default.useState(initialState),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    var setKey = _react2.default.useCallback(function (key, value) {
        return (// update key, value
            setState(function (s) {
                return _extends({}, s, _defineProperty({}, key, value));
            })
        );
    }, [setState]);
    return [state, setKey];
};

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HybridConfig = function () {
    function HybridConfig() {
        _classCallCheck(this, HybridConfig);
    }

    _createClass(HybridConfig, [{
        key: "get",
        value: function get(key, defaultValue) {
            var keyArray = key.split(".");
            var currentContext = this.getConfig();
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = keyArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var currentKey = _step.value;

                    if (currentContext[currentKey] != null) {
                        currentContext = currentContext[currentKey];
                    } else {
                        return defaultValue;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return currentContext;
        }
    }, {
        key: "auditScriptlets",
        value: function auditScriptlets() {
            return this.get("auditing", false);
        }
    }, {
        key: "set",
        value: function set(key, value) {
            var parts = key.split(".");
            var final = parts.pop();
            var curr = this.getConfig();
            for (var i = 0; i < parts.length; i++) {
                var p = parts[i];
                if (!curr.hasOwnProperty(p)) {
                    console.warn("CONFIG", "container '" + parts.slice(0, i + 1).join(".") + "' doesn't exist");
                    curr[p] = {};
                }
                curr = curr[p];
            }
            if (!curr.hasOwnProperty(final)) {
                console.warn("CONFIG", "key '" + key + "' doesn't exist");
            }
            curr[final] = value;
        }
    }, {
        key: "setConfig",
        value: function setConfig(config) {
            this.config = config;
        }
    }, {
        key: "getConfig",
        value: function getConfig() {
            if (this.config != null) {
                return this.config;
            } else if (window.HybridConfig != null) {
                return window.HybridConfig;
            } else {
                return {};
            }
        }
    }]);

    return HybridConfig;
}();

exports.default = new HybridConfig();

/***/ }),
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _UserActions = __webpack_require__(123);

var _UserActions2 = _interopRequireDefault(_UserActions);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _StereotypesActions = __webpack_require__(473);

var _StereotypesActions2 = _interopRequireDefault(_StereotypesActions);

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

var _Services = __webpack_require__(110);

var _Services2 = _interopRequireDefault(_Services);

var _SuperRecordListActions = __webpack_require__(140);

var _SuperRecordListActions2 = _interopRequireDefault(_SuperRecordListActions);

var _SearchResultActions = __webpack_require__(143);

var _SearchResultActions2 = _interopRequireDefault(_SearchResultActions);

var _FormActions = __webpack_require__(307);

var _FormActions2 = _interopRequireDefault(_FormActions);

var _DataDefActions = __webpack_require__(484);

var _DataDefActions2 = _interopRequireDefault(_DataDefActions);

var _AbstractionAiActions = __webpack_require__(321);

var _AbstractionAiActions2 = _interopRequireDefault(_AbstractionAiActions);

var _AboutActions = __webpack_require__(485);

var _AboutActions2 = _interopRequireDefault(_AboutActions);

var _FileUploadActions = __webpack_require__(223);

var _FileUploadActions2 = _interopRequireDefault(_FileUploadActions);

var _ajaxHelper = __webpack_require__(318);

var _ajaxHelper2 = _interopRequireDefault(_ajaxHelper);

var _MappingActions = __webpack_require__(109);

var _MappingActions2 = _interopRequireDefault(_MappingActions);

var _promisify = __webpack_require__(97);

var _promisify2 = _interopRequireDefault(_promisify);

var _AdtStore = __webpack_require__(228);

var _AdtActions = __webpack_require__(308);

var _AdtActions2 = _interopRequireDefault(_AdtActions);

var _HemoStore = __webpack_require__(229);

var _HemoActions = __webpack_require__(309);

var _HemoActions2 = _interopRequireDefault(_HemoActions);

var _EcmoEmrStore = __webpack_require__(230);

var _EcmoEmrActions = __webpack_require__(310);

var _EcmoEmrActions2 = _interopRequireDefault(_EcmoEmrActions);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

var _GxepActions = __webpack_require__(171);

var _GxepActions2 = _interopRequireDefault(_GxepActions);

var _DefineActions = __webpack_require__(124);

var _DefineActions2 = _interopRequireDefault(_DefineActions);

var _LiveMap = __webpack_require__(178);

var _LiveMap2 = _interopRequireDefault(_LiveMap);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _or_munge_info2 = __webpack_require__(977);

var _or_munge_info3 = _interopRequireDefault(_or_munge_info2);

var _MappingInfoStore = __webpack_require__(160);

var _MappingInfoStore2 = _interopRequireDefault(_MappingInfoStore);

var _ExportParamActions = __webpack_require__(180);

var _ExportParamActions2 = _interopRequireDefault(_ExportParamActions);

var _CrossAppActions = __webpack_require__(313);

var _CrossAppActions2 = _interopRequireDefault(_CrossAppActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// These functions return promises, which are tracked through the LoadObjects to
// facilitate migration of non-reactive flows (of which there are a lot). New
// code should NOT use the promises returned from these methods (directly or
// via LoadObject).

var modelAwarenessPromises = new _LiveMap2.default(function (orgAndKey) {
    var _orgAndKey$split = orgAndKey.split(":"),
        _orgAndKey$split2 = _slicedToArray(_orgAndKey$split, 2),
        org = _orgAndKey$split2[0],
        key = _orgAndKey$split2[1];

    var eks = _EntityName2.default.is(key) ? [key] : _StereotypesStore2.default.getStereotypeByKey(key).implementations.map(function (i) {
        return i.key;
    });
    if (_entityMetaStore2.default.hasInfo(eks)) {
        // sweet!
        return Promise.resolve();
    }
    return (0, _promisify2.default)(_Services2.default.loadModelJson(org, key)).then(function (data) {
        data.choices && data.choices.forEach(function (def) {
            return _Dispatcher2.default.dispatch({
                type: _DefineActions2.default.CHOICE,
                key: def.key,
                def: def
            });
        });
        data.tables.forEach(function (def) {
            return _Dispatcher2.default.dispatch({
                type: _DefineActions2.default.TABLE,
                key: def.key,
                def: def
            });
        });
        data.entities.forEach(function (def) {
            return _Dispatcher2.default.dispatch({
                type: _DefineActions2.default.ENTITY,
                key: def.key,
                def: (0, _or_munge_info3.default)({ INFO: def })
            });
        });
        // do NOT pass data through!
    });
});

var implementationAwarenessPromises = new _LiveMap2.default(function (orgAndImplKey) {
    var _orgAndImplKey$split = orgAndImplKey.split(":"),
        _orgAndImplKey$split2 = _slicedToArray(_orgAndImplKey$split, 2),
        org = _orgAndImplKey$split2[0],
        implKey = _orgAndImplKey$split2[1];

    var tuples = _StereotypesStore2.default.getDataEntryStereotypes().filter(function (s) {
        return s.magicRoot;
    }).map(function (s) {
        var si = s.implementations.find(function (it) {
            return it.implementationKey === implKey;
        });
        return [s, si];
    }).filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            s = _ref2[0],
            si = _ref2[1];

        return si != null;
    }).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            s = _ref4[0],
            si = _ref4[1];

        return [s, si, _entityMetaStore2.default.hasInfo(si.key)];
    });
    if (tuples.some(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 3),
            s = _ref6[0],
            si = _ref6[1],
            loaded = _ref6[2];

        return loaded;
    })) {
        // sweet!
        return Promise.resolve();
    }
    // don't have awareness; this stereotype can get it for us
    return modelAwarenessPromises.get(org + ":" + tuples[0][0].key);
});

var mappingAwarenessPromises = new _LiveMap2.default(function (orgTargetSource) {
    var _orgTargetSource$spli = orgTargetSource.split(":"),
        _orgTargetSource$spli2 = _slicedToArray(_orgTargetSource$spli, 3),
        org = _orgTargetSource$spli2[0],
        targetKey = _orgTargetSource$spli2[1],
        sourceKey = _orgTargetSource$spli2[2];

    if (_MappingInfoStore2.default.hasInfo(targetKey, sourceKey)) {
        // sweet!
        return Promise.resolve();
    }
    return (0, _promisify2.default)(_Services2.default.loadMappingJson(org, targetKey, sourceKey)).then(function (data) {
        data.mappings.forEach(function (def) {
            return _Dispatcher2.default.dispatch({
                type: _DefineActions2.default.MAPPING,
                def: { INFO: def }
            });
        });
        // do NOT pass data through!
    });
});

var DataManager = {
    loadVersionInfo: function loadVersionInfo() {
        return (0, _ajaxHelper2.default)(_Services2.default.loadVersion(), {
            type: _AboutActions2.default.LOADED_VERSION_INFO
        }, {
            type: _AboutActions2.default.LOAD_VERSION_INFO_ERROR
        });
    },

    loadDataDefinition: function loadDataDefinition(entityKey, fieldKey, org) {
        return (0, _ajaxHelper2.default)(_Services2.default.loadFieldData(entityKey, fieldKey, org), {
            type: _DataDefActions2.default.LOADED,
            entityKey: entityKey,
            fieldKey: fieldKey
        }, {
            type: _DataDefActions2.default.LOAD_ERROR,
            entityKey: entityKey,
            fieldKey: fieldKey
        });
    },

    loadAbstractionAi: function loadAbstractionAi(org, entityKey, fieldKey, payload) {
        return (0, _ajaxHelper2.default)(_Services2.default.loadAbstractionAi(org, entityKey, fieldKey, payload), {
            type: _AbstractionAiActions2.default.LOADED,
            entityKey: entityKey,
            fieldKey: fieldKey
        }, {
            type: _AbstractionAiActions2.default.LOAD_ERROR,
            entityKey: entityKey,
            fieldKey: fieldKey
        });
    },

    loadAbstractionAiApi: function loadAbstractionAiApi(org, entityKey, fieldKey, payload) {
        return (0, _ajaxHelper2.default)(_Services2.default.loadAbstractionAiApi(org, entityKey, fieldKey, payload), {
            type: _AbstractionAiActions2.default.LOADED,
            entityKey: entityKey,
            fieldKey: fieldKey
        }, {
            type: _AbstractionAiActions2.default.LOAD_ERROR,
            entityKey: entityKey,
            fieldKey: fieldKey
        });
    },

    loadFormDescriptor: function loadFormDescriptor(key, org) {
        return (0, _ajaxHelper2.default)(_Services2.default.loadEntityFormDescriptor(key, org), {
            type: _FormActions2.default.LOADED,
            key: key
        }, {
            type: _FormActions2.default.LOAD_ERROR,
            key: key
        });
    },

    search: function search(key, query, order, pageSize, page, onlyEnabledRecords) {
        return (0, _ajaxHelper2.default)(_Services2.default.searchEntity(query, order, key, pageSize, page, onlyEnabledRecords), {
            type: _SearchResultActions2.default.SEARCH_RESULT,
            query: query,
            order: order,
            key: key,
            pageSize: pageSize,
            page: page,
            onlyEnabledRecords: onlyEnabledRecords
        }, {
            type: _SearchResultActions2.default.SEARCH_ERROR,
            query: query,
            order: order,
            key: key,
            pageSize: pageSize,
            page: page,
            onlyEnabledRecords: onlyEnabledRecords
        });
    },

    createSuperrecord: function createSuperrecord(key, id, data, org, initiatingContext) {
        return (0, _ajaxHelper2.default)(_Services2.default.createEntityData(key, data, org), {
            type: _SuperRecordActions2.default.CREATED,
            key: key,
            id: id,
            initiatingContext: initiatingContext
        }, {
            type: _SuperRecordActions2.default.CREATE_ERROR,
            key: key,
            id: id,
            initiatingContext: initiatingContext
        });
    },

    loadSuperrecord: function loadSuperrecord(key, id, org) {
        return (0, _ajaxHelper2.default)(_Services2.default.loadEntityData(key, id, org), {
            type: _SuperRecordActions2.default.LOADED,
            key: key,
            id: id
        }, function (error) {
            return {
                type: error.status === 404 ? _SuperRecordActions2.default.DELETED : _SuperRecordActions2.default.LOAD_ERROR,
                key: key,
                id: id,
                error: error
            };
        });
    },

    loadSuperrecordList: function loadSuperrecordList(key, org) {
        return (0, _ajaxHelper2.default)(_Services2.default.getByStereotype(org, key), {
            type: _SuperRecordListActions2.default.LOADED,
            key: key
        }, {
            type: _SuperRecordListActions2.default.LOAD_ERROR,
            key: key
        });
    },

    updateSuperrecord: function updateSuperrecord(key, id, data, org, initiatingContext) {
        return (0, _ajaxHelper2.default)(_Services2.default.updateEntityData(key, id, data, org), {
            type: _SuperRecordActions2.default.UPDATED,
            key: key,
            id: id,
            initiatingContext: initiatingContext
        }, {
            type: _SuperRecordActions2.default.UPDATE_ERROR,
            key: key,
            id: id,
            initiatingContext: initiatingContext
        });
    },

    mergeSuperrecord: function mergeSuperrecord(key, targetId, sourceId, data, org, initiatingContext) {
        return (0, _ajaxHelper2.default)(_Services2.default.mergeEntityData(key, targetId, sourceId, data, org), {
            // TODO: we use SuperRecordActions.UPDATED because many stores
            // rely on this action to update a SR in many places. However
            // it would probably be better to create a
            // MergeActions.GLOBAL_MERGE_COMPLETE for code readability at
            // some point.
            type: _SuperRecordActions2.default.UPDATED,
            key: key,
            id: targetId,
            initiatingContext: initiatingContext
        }, {
            type: _SuperRecordActions2.default.UPDATE_ERROR,
            key: key,
            id: targetId,
            initiatingContext: initiatingContext
        });
    },

    deleteSuperrecord: function deleteSuperrecord(key, id, org, initiatingContext) {
        return (0, _ajaxHelper2.default)(_ClientId2.default.is(id) ? Promise.resolve() : _Services2.default.deleteEntityData(key, id, org), function (ignored) {
            return {
                type: _SuperRecordActions2.default.DELETED,
                key: key,
                id: id,
                initiatingContext: initiatingContext
            };
        }, {
            type: _SuperRecordActions2.default.DELETE_ERROR,
            key: key,
            id: id,
            initiatingContext: initiatingContext
        });
    },

    loadUser: function loadUser() {
        return (0, _ajaxHelper2.default)(_Services2.default.loadUser(), function (user) {
            return {
                type: _UserActions2.default.LOADED,
                user: user
            };
        }, {
            type: _UserActions2.default.LOAD_ERROR
        });
    },

    updateLicensePreference: function updateLicensePreference(impl, pref, value) {
        return (0, _ajaxHelper2.default)(_Services2.default.saveLicensePreference(_userStore2.default.getActiveOrgKey(), impl, pref, value), function (newValue) {
            return {
                type: _UserActions2.default.LICENSE_PREFERENCE_UPDATED,
                impl: impl,
                pref: pref,
                newValue: newValue
            };
        }, function (error) {
            return {
                type: _UserActions2.default.LICENSE_PREFERENCE_UPDATE_ERROR,
                impl: impl,
                pref: pref,
                error: error
            };
        });
    },

    updateOrgUserPreference: function updateOrgUserPreference(pref, value) {
        return (0, _ajaxHelper2.default)(_Services2.default.saveOrgUserPreference(_userStore2.default.getActiveOrgKey(), pref, value), function (newValue) {
            return {
                type: _UserActions2.default.ORG_USER_PREFERENCE_UPDATED,
                pref: pref,
                newValue: newValue
            };
        }, function (error) {
            return {
                type: _UserActions2.default.ORG_USER_PREFERENCE_UPDATE_ERROR,
                pref: pref,
                error: error
            };
        });
    },

    loadExportParams: function loadExportParams(org) {
        return (0, _ajaxHelper2.default)(_Services2.default.loadExportParams(org), {
            type: _ExportParamActions2.default.LOADED
        }, {
            type: _ExportParamActions2.default.LOAD_ERROR
        });
    },

    createExportParams: function createExportParams(org, data) {
        return (0, _ajaxHelper2.default)(_Services2.default.createExportParams(org, data), {
            type: _ExportParamActions2.default.CREATED
        }, {
            type: _ExportParamActions2.default.CREATE_ERROR
        });
    },

    updateExportParams: function updateExportParams(org, data) {
        return (0, _ajaxHelper2.default)(_Services2.default.updateExportParams(org, data), {
            type: _ExportParamActions2.default.UPDATED
        }, {
            type: _ExportParamActions2.default.UPDATE_ERROR
        });
    },

    deleteExportParams: function deleteExportParams(org, id) {
        return (0, _ajaxHelper2.default)(_Services2.default.deleteExportParams(org, id), {
            type: _ExportParamActions2.default.DELETED
        }, {
            type: _ExportParamActions2.default.DELETE_ERROR
        });
    },

    loadGxepInfo: function loadGxepInfo(org) {
        return (0, _ajaxHelper2.default)(_Services2.default.loadGxepInfo(org), {
            type: _GxepActions2.default.LOADED
        }, {
            type: _GxepActions2.default.LOAD_ERROR
        });
    },

    saveGxepInfo: function saveGxepInfo(org, data) {
        return (0, _ajaxHelper2.default)(_Services2.default.saveGxepInfo(org, data), {
            type: _GxepActions2.default.SAVED,
            packet: data
        }, {
            type: _GxepActions2.default.SAVE_ERROR,
            packet: data
        });
    },

    loadStereotypes: function loadStereotypes(org) {
        var p = (0, _ajaxHelper2.default)(_Services2.default.loadStereotypes(), {
            type: _StereotypesActions2.default.LOADED
        }, {
            type: _StereotypesActions2.default.LOAD_ERROR
        });
        // don't chain p! The point is to do it in the background!
        p.then(function (ss) {
            var mrs = ss.stereotypes.filter(function (s) {
                return s.magicRoot;
            });
            if (mrs.length === 1) {
                DataManager.promiseModelAwareness(org, mrs[0].key);
            }
            return ss;
        });
        return p;
    },
    promiseImplementationAwareness: function promiseImplementationAwareness(org, implKey) {
        return implementationAwarenessPromises.get(org + ":" + implKey);
    },
    promiseModelAwareness: function promiseModelAwareness(org, key) {
        return modelAwarenessPromises.get(org + ":" + key);
    },


    loadStereotype: function loadStereotype(key) {
        return (0, _ajaxHelper2.default)(_Services2.default.loadStereotype(key), {
            type: _StereotypesActions2.default.STEREOTYPE_LOADED,
            key: key
        }, {
            type: _StereotypesActions2.default.STEREOTYPE_LOAD_ERROR,
            key: key
        });
    },

    promiseMappingAwareness: function promiseMappingAwareness(org, targetKey, sourceKey) {
        return mappingAwarenessPromises.get(org + ":" + targetKey + ":" + sourceKey);
    },


    loadMappingModel: function loadMappingModel(org, targetKey, sourceKey) {
        return (0, _ajaxHelper2.default)(DataManager.promiseMappingAwareness(org, targetKey, sourceKey), function (ignored) {
            return {
                type: _MappingActions2.default.MODEL_LOADED,
                targetKey: targetKey,
                sourceKey: sourceKey
            };
        }, {
            type: _MappingActions2.default.MODEL_LOAD_ERROR,
            targetKey: targetKey,
            sourceKey: sourceKey
        });
    },

    adtSearch: function adtSearch(org, query, interactive) {
        return DataManager.promiseModelAwareness(org, _AdtStore.ADT_EPISODE_KEY).then(function () {
            return (0, _ajaxHelper2.default)(_Services2.default.searchADT(org, query), {
                type: _AdtActions2.default.SEARCH_RESULT,
                query: query,
                interactive: interactive
            }, {
                type: _AdtActions2.default.SEARCH_ERROR,
                query: query,
                interactive: interactive
            });
        });
    },

    hemoSearch: function hemoSearch(org, query, interactive) {
        return DataManager.promiseModelAwareness(org, _HemoStore.HEMO_MESSAGE_KEY).then(function () {
            return (0, _ajaxHelper2.default)(_Services2.default.searchHemo(org, query), {
                type: _HemoActions2.default.SEARCH_RESULT,
                query: query,
                interactive: interactive
            }, {
                type: _HemoActions2.default.SEARCH_ERROR,
                query: query,
                interactive: interactive
            });
        });
    },

    ecmoEmrSearch: function ecmoEmrSearch(org, query, interactive) {
        return DataManager.promiseModelAwareness(org, _EcmoEmrStore.ECMOEMR_MESSAGE_KEY).then(function () {
            return (0, _ajaxHelper2.default)(_Services2.default.searchEcmoEmr(org, query), {
                type: _EcmoEmrActions2.default.SEARCH_RESULT,
                query: query,
                interactive: interactive
            }, {
                type: _EcmoEmrActions2.default.SEARCH_ERROR,
                query: query,
                interactive: interactive
            });
        });
    },

    crossAppSearch: function crossAppSearch(org, stereotype, impl, version, entity, query, page, pageSize, interactive) {
        return DataManager.promiseModelAwareness(org, impl + "/" + version + "/" + entity).then(function () {
            return (0, _ajaxHelper2.default)(_Services2.default.searchCrossApp(org, stereotype, impl, version, entity, query, page, pageSize), {
                type: _CrossAppActions2.default.SEARCH_RESULT,
                query: query,
                interactive: interactive,
                impl: impl,
                version: version
            }, {
                type: _CrossAppActions2.default.SEARCH_ERROR,
                query: query,
                interactive: interactive
            });
        });
    },

    uploadFile: function uploadFile(recordKey, recordId, fieldKey, file) {

        var buildFileUploadAction = function buildFileUploadAction(type, extra) {
            return _extends({
                type: type,
                recordKey: recordKey,
                recordId: recordId,
                fieldKey: fieldKey,
                file: file
            }, extra);
        };
        var throttledProgress = _.throttle(function (e) {
            return _Dispatcher2.default.dispatch(buildFileUploadAction(_FileUploadActions2.default.PROGRESS, {
                progress: e.lengthComputable ? e.loaded / e.total * 100 : 0
            }));
        }, 250);

        // The uploadFile service does not return a promise but instead uses a
        // callback function to obtain the promise once it is created.
        var uploadFilePromise = new Promise(function (resolve, reject) {
            _Services2.default.uploadFile(file._org, file._impl, file._version, file._entity, file._record_id, file._field, file._data, function (p) {
                // callback function with the actual xhr promise
                _Dispatcher2.default.dispatch( // dispatch that the upload has started and save the promise
                buildFileUploadAction(_FileUploadActions2.default.PROGRESS, {
                    progress: 0,
                    promise: p // actual upload xhr promise so we can abort.
                }));
                p.fail(reject);
                resolve(p); // resolve with the xhr promise
            }, function (e) {
                // progress callback
                throttledProgress(e);
            });
        });

        return (0, _ajaxHelper2.default)(uploadFilePromise, function (data) {
            return buildFileUploadAction(_FileUploadActions2.default.COMPLETE, {
                value: data
            });
        }, function (error) {
            return buildFileUploadAction(_FileUploadActions2.default.Error, {
                error: error
            });
        });
    }
};

exports.default = DataManager;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.recordIdType = undefined;

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var recordIdType = exports.recordIdType = _propTypes2.default.oneOfType([_propTypes2.default.number, _ClientId2.default.propType]);

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SPACE_KEY = exports.ENTER_KEY = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formhelpers = __webpack_require__(5);

var _DropdownWrapper = __webpack_require__(214);

var _DropdownWrapper2 = _interopRequireDefault(_DropdownWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ENTER_KEY = exports.ENTER_KEY = "Enter";
var SPACE_KEY = exports.SPACE_KEY = " ";

var toIconNode = function toIconNode(icon) {
    var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (placeholder && !icon) {
        icon = "placeholder";
    }
    return typeof icon === "string" ? _react2.default.createElement("span", { key: "icon", className: "glyphicon glyphicon-" + icon }) : icon || _react2.default.createElement("span", null);
};

var Button = function (_React$Component) {
    _inherits(Button, _React$Component);

    function Button(props) {
        _classCallCheck(this, Button);

        var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.onClick = _this.onClick.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onHide = _this.onHide.bind(_this);

        // for buttons with dropdown options
        _this.buttonRef = _react2.default.createRef();
        _this.dropdownRef = _react2.default.createRef();
        _this.hasOptions = _this.hasOptions.bind(_this);
        _this.state = {
            showDropdownMenu: false
        };
        return _this;
    }

    _createClass(Button, [{
        key: "onKeyDown",
        value: function onKeyDown(e) {
            var _props = this.props,
                descriptor = _props.descriptor,
                onKeyDown = _props.onKeyDown,
                value = _props.value;

            var key = e.key;
            if (key === ENTER_KEY || key === SPACE_KEY) {
                // enter
                this.onClick(e);
                e.preventDefault();
                e.stopPropagation(); // prevents dropdown from immediately being closed
                return;
            }
            onKeyDown && onKeyDown(e, descriptor, value, false);
        }
    }, {
        key: "onClick",
        value: function onClick(e, v) {
            e.preventDefault();
            if (v && v.disabled) return;
            var _props2 = this.props,
                descriptor = _props2.descriptor,
                enabled = _props2.enabled,
                onClick = _props2.onClick,
                options = _props2.options,
                collapse = _props2.collapse;

            if (!enabled) return;
            var hasOptions = this.hasOptions();
            var value = this.props.value;
            if (hasOptions) {
                if (hasOptions === 1 && collapse) {
                    v = options[0];
                }
                if (v === undefined) {
                    // no value means toggle dropdown
                    this.setState(function (s) {
                        return { showDropdownMenu: !s.showDropdownMenu };
                    });
                    return;
                }
                value = v;
            }
            onClick && onClick(e, descriptor, value);
            this.setState(function (s) {
                return s.showDropdownMenu ? { showDropdownMenu: false } : null;
            }); // hide dropdown menu after click.
        }
    }, {
        key: "onFocus",
        value: function onFocus(e) {
            var _props3 = this.props,
                descriptor = _props3.descriptor,
                onFocus = _props3.onFocus,
                value = _props3.value;

            onFocus && onFocus(e, descriptor, value);
        }
    }, {
        key: "onBlur",
        value: function onBlur(e) {
            var _props4 = this.props,
                descriptor = _props4.descriptor,
                onBlur = _props4.onBlur,
                value = _props4.value;

            onBlur && onBlur(e, descriptor, value);
        }
    }, {
        key: "onHide",
        value: function onHide() {
            this.setState({ showDropdownMenu: false });
        }
    }, {
        key: "hasOptions",
        value: function hasOptions() {
            var _props$options = this.props.options,
                options = _props$options === undefined ? [] : _props$options;

            return options ? options.length : 0;
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props5 = this.props,
                id = _props5.id,
                value = _props5.value,
                label = _props5.label,
                options = _props5.options,
                enabled = _props5.enabled,
                _props5$className = _props5.className,
                className = _props5$className === undefined ? "focusable btn btn-widget" : _props5$className,
                _props5$icon = _props5.icon,
                icon = _props5$icon === undefined ? null : _props5$icon,
                dropdownCarrot = _props5.dropdownCarrot,
                dataAlign = _props5.dataAlign,
                autoSize = _props5.autoSize,
                collapse = _props5.collapse,
                anchorRef = _props5.anchorRef,
                ddActionName = _props5.ddActionName;

            var hasOptions = collapse ? this.hasOptions() > 1 : !!this.hasOptions();
            var v = typeof value === "string" ? value : "";
            var button = _react2.default.createElement(
                "button",
                {
                    id: id,
                    ref: anchorRef || this.buttonRef,
                    type: "button",
                    className: className + (hasOptions ? " dropdown-toggle" : ""),
                    onClick: this.onClick,
                    onKeyDown: this.onKeyDown,
                    onFocus: this.onFocus,
                    onBlur: this.onBlur,
                    disabled: !enabled,
                    value: v,
                    "data-control-type": hasOptions ? "bootstrap-dropdown" : "",
                    "data-dd-action-name": ddActionName
                },
                toIconNode(icon),
                " ",
                label || v,
                dropdownCarrot && hasOptions && [" ", _react2.default.createElement("span", { key: "caret", className: "caret" })]
            );

            if (!hasOptions) {
                return button;
            }

            var hasIcons = options.some(function (o) {
                return o.icon;
            });
            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                button,
                this.state.showDropdownMenu && enabled && _react2.default.createElement(
                    _DropdownWrapper2.default,
                    {
                        targetRef: anchorRef || this.buttonRef,
                        dropdownRef: this.dropdownRef,
                        onHide: this.onHide,
                        align: dataAlign,
                        autoSize: autoSize || false
                    },
                    _react2.default.createElement(
                        "ul",
                        { className: "dropdown-menu", ref: this.dropdownRef },
                        options.map(function (option, idx) {
                            var label = option.label;
                            if (hasIcons) {
                                label = [toIconNode(option.icon, true), " ", label];
                            }
                            return _react2.default.createElement(
                                "li",
                                {
                                    key: option.value || idx,
                                    onClick: option.disabled ? undefined : function (e) {
                                        return _this2.onClick(e, option);
                                    },
                                    className: option.disabled ? "disabled" : undefined
                                },
                                _react2.default.createElement(
                                    "a",
                                    {
                                        tabIndex: "-1",
                                        href: "#",
                                        "data-key": option.value
                                    },
                                    label
                                )
                            );
                        })
                    )
                )
            );
        }
    }]);

    return Button;
}(_react2.default.Component);

exports.default = Button;


Button.defaultProps = {
    dropdownCarrot: true,
    label: "",
    value: "",
    collapse: true
};

Button.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)(null, false), {
    onCommitChange: _propTypes2.default.func,
    onClick: _propTypes2.default.func.isRequired,
    value: _propTypes2.default.any,
    label: _propTypes2.default.node,
    options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        icon: _propTypes2.default.node,
        label: _propTypes2.default.node.isRequired,
        value: _propTypes2.default.any.isRequired
    })),
    dropdownCarrot: _propTypes2.default.bool,
    collapse: _propTypes2.default.bool,
    dataAlign: _propTypes2.default.string,
    anchorRef: _propTypes2.default.object // ref for anchoring the dropdown
});

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.spIshShape = exports.epIshShape = exports.isMergeContext = exports.MERGE_CONTEXT = exports.MERGE_PLUGINS = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(13);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _ContextedReduceStore = __webpack_require__(30);

var _MergeActions = __webpack_require__(59);

var _MergeActions2 = _interopRequireDefault(_MergeActions);

var _MappingActions = __webpack_require__(109);

var _MappingActions2 = _interopRequireDefault(_MappingActions);

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _SuperRecordStore = __webpack_require__(36);

var _SuperRecordStore2 = _interopRequireDefault(_SuperRecordStore);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _NavigatorStore = __webpack_require__(33);

var _NavigatorStore2 = _interopRequireDefault(_NavigatorStore);

var _MappingStore = __webpack_require__(65);

var _MappingStore2 = _interopRequireDefault(_MappingStore);

var _OverStore = __webpack_require__(61);

var _OverStore2 = _interopRequireDefault(_OverStore);

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

var _OverStore3 = __webpack_require__(61);

var _lockStore = __webpack_require__(144);

var _lockStore2 = _interopRequireDefault(_lockStore);

var _typedefs = __webpack_require__(44);

var _SearchFormStore = __webpack_require__(82);

var _SearchFormStore2 = _interopRequireDefault(_SearchFormStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MERGE_PLUGINS = exports.MERGE_PLUGINS = {
    GLOBAL_MERGE: "global-merge",
    RECORD_MERGE: "record-merge",
    CHILD_MERGE: "child-merge"
};

var MERGE_CONTEXT = exports.MERGE_CONTEXT = ":merge";
var isMergeContext = exports.isMergeContext = function isMergeContext(contextKey) {
    return (contextKey || "").indexOf(MERGE_CONTEXT) !== -1;
};

var _isReady = function _isReady(state) {
    return !state.active;
}; // not currently merging anything

var processLaunchDialogState = function processLaunchDialogState(state, action) {
    var fluxContext = action[_ContextedReduceStore.ACTION_CONTEXT_KEY];
    (0, _invariant2.default)(fluxContext, "merge must be initiated w/ a contexted dispatch");
    if (!Object.values(MERGE_PLUGINS).includes(action.plugin)) {
        throw Error("Unknown plugin provided \"" + action.plugin + "\"");
    }
    return _extends({}, state, {
        active: false,
        interactive: true,
        modalParams: _extends({}, state.modalParams, {
            drawerOpen: true,
            title: action.title
        }),
        pluginKey: action.plugin,
        target: action.target,
        parent: action.parent || null,
        source: action.source || null
    });
};

var processSelectSourceState = function processSelectSourceState(state, action) {
    return _extends({}, state, {
        source: action.source,
        modalParams: _extends({}, state.modalParams, {
            drawerOpen: false
        })
    });
};

var processToggleDrawerState = function processToggleDrawerState(state) {
    return _extends({}, state, {
        modalParams: _extends({}, state.modalParams, {
            drawerOpen: !state.modalParams.drawerOpen
        })
    });
};

var processDoMergeState = function processDoMergeState(state, action) {
    if (!(0, _OverStore3.isConfirmed)(action)) return state;
    var fluxContext = action[_ContextedReduceStore.ACTION_CONTEXT_KEY];
    (0, _invariant2.default)(fluxContext, "merge must be initiated w/ a contexted dispatch");
    (0, _invariant2.default)(state.interactive, "global merge must be interactive.");
    (0, _invariant2.default)(state.source.id && (state.source.stereoKey || state.source.entityKey), "global source must be StereotypeProxy or EntityProxy.");
    (0, _invariant2.default)(state.target.id && (state.target.stereoKey || state.target.entityKey), "global target must be StereotypeProxy or EntityProxy.");
    return _extends({}, state, {
        active: true,
        parent: action.parent || state.parent || null,
        pluginKey: action.plugin || state.pluginKey
    });
};

var MergeStore = function (_ReduceStore) {
    _inherits(MergeStore, _ReduceStore);

    function MergeStore() {
        _classCallCheck(this, MergeStore);

        return _possibleConstructorReturn(this, (MergeStore.__proto__ || Object.getPrototypeOf(MergeStore)).call(this, _Dispatcher2.default));
    }

    _createClass(MergeStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {
                plugin: null,
                active: false,
                type: null,
                parent: null,
                target: null,
                source: null,
                modalParams: {
                    title: null,
                    drawerOpen: true
                },
                interactive: false
            };
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {
                case _MergeActions2.default.LAUNCH_DIALOG:
                    {
                        this.__dispatcher.waitFor([_NavigatorStore2.default.getDispatchToken(), _SuperRecordStore2.default.getDispatchToken(), _TableStore2.default.getDispatchToken()]);
                        return processLaunchDialogState(this.getInitialState(), action);
                    }

                case _MergeActions2.default.SELECT_SOURCE:
                    {
                        return processSelectSourceState(state, action);
                    }

                case _MergeActions2.default.TOGGLE_DRAWER:
                    {
                        return processToggleDrawerState(state);
                    }

                case _MergeActions2.default.DO_MERGE:
                    {
                        return processDoMergeState(state, action);
                    }

                case _MappingActions2.default.IT_IS_DONE:
                    {
                        if (!state.active) return state;
                        this.__dispatcher.waitFor([_NavigatorStore2.default.getDispatchToken(), _SuperRecordStore2.default.getDispatchToken(), _TableStore2.default.getDispatchToken(), _MappingStore2.default.getDispatchToken(), _SearchFormStore2.default.getDispatchToken()]);
                        if (state.pluginKey === MERGE_PLUGINS.GLOBAL_MERGE) {
                            // global merge requires a save to happen.
                            // Save gets invoked in SuperRecordStore.
                            // Global merge is not complete until
                            // SuperRecordActions.UPDATED is dispatched...
                            return state;
                        }
                        // wait for other stores
                        return this.getInitialState(); // reset merge state... all done!
                    }

                case _SuperRecordActions2.default.UPDATED:
                    {
                        if (!state.active) return state;
                        if (state.pluginKey !== MERGE_PLUGINS.GLOBAL_MERGE) return state;
                        this.__dispatcher.waitFor([_NavigatorStore2.default.getDispatchToken(), _SuperRecordStore2.default.getDispatchToken(), _TableStore2.default.getDispatchToken(), _OverStore2.default.getDispatchToken(), _lockStore2.default.getDispatchToken(), _SearchFormStore2.default.getDispatchToken()]);
                        // GLOBAL MERGE SUCCESSFUL!!!
                        return this.getInitialState(); // reset merge state... all done!
                    }

                case _MergeActions2.default.CANCEL:
                case _MappingActions2.default.CANCEL:
                case _SuperRecordActions2.default.CANCEL_FOR_OPTLOCK:
                    {
                        if (!state.interactive) return state;
                        return this.getInitialState(); // reset merge state... all done!
                    }

                case _MergeActions2.default.CANCEL_FOR_SOURCE_OPTLOCK:
                    {
                        this.__dispatcher.waitFor([_lockStore2.default.getDispatchToken()]);
                        return _extends({}, state, {
                            source: null,
                            modalParams: _extends({}, state.modalParams, {
                                drawerOpen: true
                            })
                        });
                    }

                case _SuperRecordActions2.default.UPDATE_ERROR:
                    {
                        if (!state.active) return state;
                        if (state.pluginKey !== MERGE_PLUGINS.GLOBAL_MERGE) return state;
                        // error happened during global merge
                        // reset the active state so they can try again.
                        return _extends({}, state, { active: false });
                    }

                default:
                    return state;
            }
        }
    }, {
        key: "isReady",
        value: function isReady() {
            return _isReady(this.getState());
        }
    }, {
        key: "getPluginKey",
        value: function getPluginKey() {
            return this.getState().pluginKey;
        }
    }, {
        key: "getProxyPair",
        value: function getProxyPair() {
            var _getState = this.getState(),
                src = _getState.source,
                tgt = _getState.target;

            return {
                source: _TableStore2.default.getStereotypeProxy(src.stereoKey, src.id),
                target: _TableStore2.default.getStereotypeProxy(tgt.stereoKey, tgt.id)
            };
        }
    }, {
        key: "getDeleteAction",
        value: function getDeleteAction() {
            // builds the action used for deleting the source record.
            var state = this.getState();
            switch (state.pluginKey) {
                case MERGE_PLUGINS.RECORD_MERGE:
                    {
                        return {
                            recordKey: state.target.entityKey,
                            recordId: state.source.id, // source id
                            targetId: state.target.id // target id
                        };
                    }
                case MERGE_PLUGINS.CHILD_MERGE:
                    {
                        var ppInfo = _entityFieldMetaStore2.default.getInfo(state.target.entityInfo.key, state.target.entityInfo.parentPointerKey);
                        return {
                            recordKey: state.parent.entityKey, // parent key
                            recordId: state.parent.id, // parent id
                            fieldKey: ppInfo.inverseKey, // source field
                            childKey: state.source.entityKey, // source key
                            childId: state.source.id, // source id
                            targetId: state.target.id //target id
                        };
                    }
                default:
                    throw Error("Unknown merge plugin key \"" + state.pluginKey + "\"");
            }
        }
    }]);

    return MergeStore;
}(_utils.ReduceStore);

var epIshShape = exports.epIshShape = _propTypes2.default.exact({
    entityKey: _propTypes2.default.string.isRequired,
    id: _typedefs.recordIdType.isRequired
});

var spIshShape = exports.spIshShape = _propTypes2.default.exact({
    stereoKey: _propTypes2.default.string.isRequired,
    id: _typedefs.recordIdType.isRequired
});

MergeStore.stateTypes = {
    active: _propTypes2.default.bool.isRequired,
    pluginKey: _propTypes2.default.string,
    parent: epIshShape,
    target: _propTypes2.default.oneOfType([epIshShape, spIshShape]),
    source: _propTypes2.default.oneOfType([epIshShape, spIshShape])
};

exports.default = (0, _typeCheckingStore2.default)(new MergeStore());

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hotLoadObject = exports.translateValue = undefined;

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

var _dotPropImmutable = __webpack_require__(40);

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * I allow translating a value at some path in a state object through a mapping
 * object or function. If the path doesn't exist, the same state will be
 * returned. If a mapping object is used, and it lacks a key for the current
 * value, no mapping will be performed. If a mapping function is used, it will
 * be invoked with the current value to provide the new value. No null checks
 * are performed on the current value, only the path to the value. That is, you
 * _can_ map null into something else.
 *
 * @param state The state to update (or return unmodified)
 * @param propertyChain An array of string property names to traverse to get to
 *  the value to translate (if any)
 * @param valueMap Either an Object containing old-to-new mappings, or a
 *  function accepting an old value and returning the corresponding new one.
 * @return {*} the updated state
 */
var translateValue = exports.translateValue = function translateValue(state, propertyChain, valueMap) {
    if (valueMap == null) {
        return state;
    }
    var curr = state;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = propertyChain[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var link = _step.value;

            if (curr == null || !curr.hasOwnProperty(link)) {
                // don't have a current one
                return state;
            }
            curr = curr[link];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var next = void 0;
    if (typeof valueMap === "function") {
        next = valueMap(curr);
    } else {
        if (!valueMap.hasOwnProperty(curr)) {
            // there's no translation for it
            return state;
        }
        next = valueMap[curr];
    }
    if (next === curr) {
        // the new one is the same.
        return state;
    }
    return _dotPropImmutable2.default.set(state, propertyChain, next);
};

/**
 * I provide hot-loading logic that a store may plug into any selector which
 * returns a LoadObject that should auto-populate. It takes two callbacks, one
 * to obtain the store's LO in question, and one to initiate loading into the
 * LO (almost certainly via dispatching a "start loading" action). It's expected
 * that this is mostly useful for 'loading' operations, but can be used for any
 * LO action.
 *
 * If getLO returns falsey, an empty LO will be automatically substituted.
 *
 * If shouldLoad returns falsey, the LO will be returned as-is.
 *
 * If shouldLoad returns truthy, doLoad will be invoked, and a new LO will be
 * returned in a pending state with an unresolved Promise bound to the eventual
 * resolution of what doLoad initiated. Note that _which_ pending state the LO
 * will be in is undefined. On the next tick, the LO will be in the pending
 * state that doLoad resulted in. This is a kludge to facilitate a synchronously
 * returned Promise for non-reactive flows, and this functionality is done at
 * the expense of the LO's internal state that single tick.
 *
 * @param getLO return the current LO from the store
 * @param doLoad initiate loading, which must synchronously update the store so
 *  that the next invocation of getLO returns a non-empty (loading) LO.
 * @param shouldLoad optional function accepting a LO to indicate whether it
 *  needs to be loaded. LoadObject.isEmpty() will be used by default.
 * @return {LoadObject}
 */

/* hotLoadObjectActiveCount is used purely for AppDrivers wait action.
 * because HLO starts the promise in the next frame to avoid reentrant
 * flux dispatches we need to help the wait action know that the currant frame
 * should also be considered "loading".
 */
window.hotLoadObjectActiveCount = 0;

var hotLoadObject = exports.hotLoadObject = function hotLoadObject(getLO, doLoad, shouldLoad) {
    var defaultShouldLoad = shouldLoad == null;
    if (defaultShouldLoad) {
        shouldLoad = function shouldLoad(lo) {
            return lo.isEmpty();
        };
    }
    var lo = getLO() || _LoadObject2.default.empty();
    if (shouldLoad(lo)) {
        window.hotLoadObjectActiveCount++;
        /*
        Note that this is more complex that it seems like it should be so that
        we can get a synchronously-created Promise for the calling code can
        react to the eventual load. This is only needed for the non-reactive
        flows; the Promises will eventually be completely removed.
         A thunk is queued for the next tick to avoid reentrant dispatches (the
        expected behaviour of doLoad), but doing so means the Store doesn't get
        it's pending LO for the remainder of this tick. That, in turn, means
        that multiple requests for the same LO in the same tick will all queue
        separate (but equivalent) thunks. The second `shouldLoad` check inside
        the thunk will make all subsequent thunks "do nothing".
        */
        lo = lo.loading(new Promise(function (resolve) {
            // eslint-disable-next-line no-settimeout
            setTimeout(function () {
                var nextLO = getLO();
                if (nextLO == null || shouldLoad(nextLO)) {
                    doLoad();
                    nextLO = getLO();
                    (0, _invariant2.default)(nextLO != null, "doLoad must warm up getLO's cache");
                    if (defaultShouldLoad) {
                        (0, _invariant2.default)(!shouldLoad(lo), "doLoad must create a pending LO");
                    }
                }
                resolve(nextLO.promise().finally(function () {
                    window.hotLoadObjectActiveCount--;
                }));
            }, 0);
        }));
    }
    return lo;
};

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.appAlert = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _safeDispatch = __webpack_require__(169);

var _safeDispatch2 = _interopRequireDefault(_safeDispatch);

var _OverActions = __webpack_require__(122);

var _OverActions2 = _interopRequireDefault(_OverActions);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * I am a factory function for creating overs. I am passed over options, and
 * return a function that can be used to "wrap" a work callback with managed
 * over according to the passed options.
 *
 * <p>The returned function should be invoked with a callback. When invoked, an
 * over will be shown, then the callback itself invoked, then the over hidden.
 * If the callback returns a thenable, the over will be hidden asynchronously.
 * All other return types will cause the over to be hidden synchronously.
 *
 * <p>It is deliberate that a callback is passed and not a thenable; this lets
 * the over render synchonously, before the callback is invoked to actually
 * initiate the work beneath the over. Otherwise any setup (e.g., the body of
 * the function passed to the Promise constructor) will run before the over is
 * visible.
 *
 * <p>For simple uses, the curried form is klunky, so it may be invoked
 * uncurried for the same effect. Semantics are exactly the same, except the
 * function produced by the factory is hidden. For even simpler uses where no
 * options are needed, the work callback may be passed as the sole argument.
 *
 * <p>Below are examples of all invocation styles:
 *
 * <pre>
 * // full curried
 * const one1 = withOver({message: "..."})(() => { ...; return 1; });
 * // full uncurried
 * const one2 = withOver({message: "..."}, ( => { ...; return 1; });
 * // no options curried
 * const one3 = withOver()(() => { ...; return 1; });
 * // no options uncurried
 * const one4 = withOver(() => { ...; return 1; });
 * </pre>
 *
 * @param options the options to use for all overs created by the returned
 *  function
 * @param uncurriedWork OPTIONAL work to be invoked directly in an uncurried
 *  fashion.
 * @returns {Function} a function accepting work that should have an over
 *  displayed for it's duration.
 */
function withOver() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var uncurriedWork = arguments[1];

    var invokeImmediate = arguments.length >= 2;
    if (arguments.length === 1 && typeof options === "function") {
        uncurriedWork = options;
        options = {};
        invokeImmediate = true;
    }
    if (typeof options === "string") {
        options = {
            message: options
        };
    }
    var retfunc = function retfunc(work) {
        var overKey = "with-over-" + Date.now().toString(36) + "-" + Math.random().toString(36).substr(2);
        _Dispatcher2.default.dispatch({
            type: _OverActions2.default.SHOW,
            options: _extends({}, options, { key: overKey })
        });
        var doHide = function doHide(v) {
            _Dispatcher2.default.dispatch({
                type: _OverActions2.default.HIDE,
                key: overKey
            });
            return v;
        };
        var hideAfter = true;
        try {
            var result = work.call(null);
            if (result != null && typeof result.then === "function") {
                Promise.resolve(result).finally(doHide);
                hideAfter = false;
            }
            return result;
        } finally {
            if (hideAfter) {
                doHide();
            }
        }
    };
    return invokeImmediate ? retfunc(uncurriedWork) : retfunc;
}

// i don't really belong here. per usual, options may be a message string, but
// only message and title keys are accepted
var appAlert = exports.appAlert = function appAlert(options, onOk) {
    if (typeof options === "string" || typeof options === "function") {
        options = { message: options };
    }
    (0, _safeDispatch2.default)({
        type: _OverActions2.default.APP_ALERT,
        message: options.message,
        actions: options.actions,
        title: options.title,
        callback: onOk
    });
};

exports.default = withOver;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typedAction = __webpack_require__(86);

var _typedAction2 = _interopRequireDefault(_typedAction);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MergeStore = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MergeActions = {
    // merge modal actions
    LAUNCH_DIALOG: (0, _typedAction2.default)("merge/launch-modal", {
        target: _propTypes2.default.oneOfType([_MergeStore.epIshShape, _MergeStore.spIshShape]),
        title: _propTypes2.default.string.isRequired,
        plugin: _propTypes2.default.string.isRequired
    }),
    SELECT_SOURCE: (0, _typedAction2.default)("merge/select-source", {
        source: _propTypes2.default.oneOfType([_MergeStore.epIshShape, _MergeStore.spIshShape])
    }),
    TOGGLE_DRAWER: "merge/toggle-drawer",
    CANCEL: "merge/cancel",
    CANCEL_FOR_SOURCE_OPTLOCK: "merge/cancel-for-source-optlock",

    // auto merge actions
    DO_MERGE: "merge/do-merge"
};

exports.default = MergeActions;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// these aren't super awesome. but we need something orthogonal to action name
var OPT_USER_INITIATED = exports.OPT_USER_INITIATED = "__user_initiated";
var OPT_USER_CONFIRMED = exports.OPT_USER_CONFIRMED = "__user_confirmed";

var RecordActions = {
    // create a new top-level (standalone) record.
    NEW: "record/new",
    // set a field on an existing record.
    SET_FIELD: "record/set-field",
    // create a new composed record and wire it.
    NEW_CHILD: "record/new-child",
    // delete a composed child
    DELETE_CHILD: "record/delete-child",
    // delete a top-level record (incl. magic children)
    DELETE_RECORD: "record/delete-record"
};

exports.default = RecordActions;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.optionTypes = exports.isConfirmed = exports.isModalInteractive = exports.getActiveItem = exports.isEmpty = exports.isModalShowing = exports.overOptions = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(13);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _OverActions = __webpack_require__(122);

var _OverActions2 = _interopRequireDefault(_OverActions);

var _RecordActions = __webpack_require__(60);

var _RecordActions2 = _interopRequireDefault(_RecordActions);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _ContextedReduceStore = __webpack_require__(30);

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _SuperRecordStore = __webpack_require__(36);

var _SuperRecordStore2 = _interopRequireDefault(_SuperRecordStore);

var _ActiveFormActions = __webpack_require__(111);

var _ActiveFormActions2 = _interopRequireDefault(_ActiveFormActions);

var _ActiveFormStore = __webpack_require__(112);

var _ActiveFormStore2 = _interopRequireDefault(_ActiveFormStore);

var _records = __webpack_require__(113);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _utils2 = __webpack_require__(175);

var _NavigationActions = __webpack_require__(80);

var _NavigationActions2 = _interopRequireDefault(_NavigationActions);

var _FormStore = __webpack_require__(142);

var _FormStore2 = _interopRequireDefault(_FormStore);

var _FormActions = __webpack_require__(307);

var _FormActions2 = _interopRequireDefault(_FormActions);

var _NavigatorStore = __webpack_require__(33);

var _NavigatorStore2 = _interopRequireDefault(_NavigatorStore);

var _AdtActions = __webpack_require__(308);

var _AdtActions2 = _interopRequireDefault(_AdtActions);

var _HemoActions = __webpack_require__(309);

var _HemoActions2 = _interopRequireDefault(_HemoActions);

var _EcmoEmrActions = __webpack_require__(310);

var _EcmoEmrActions2 = _interopRequireDefault(_EcmoEmrActions);

var _MappingActions = __webpack_require__(109);

var _MappingActions2 = _interopRequireDefault(_MappingActions);

var _saveit = __webpack_require__(226);

var _MapButtonActions = __webpack_require__(141);

var _MapButtonActions2 = _interopRequireDefault(_MapButtonActions);

var _MapDialogActions = __webpack_require__(64);

var _MapDialogActions2 = _interopRequireDefault(_MapDialogActions);

var _MappingStore = __webpack_require__(65);

var _MappingStore2 = _interopRequireDefault(_MappingStore);

var _MergeStore = __webpack_require__(53);

var _MergeStore2 = _interopRequireDefault(_MergeStore);

var _mergeHelpers = __webpack_require__(232);

var _MergeActions = __webpack_require__(59);

var _MergeActions2 = _interopRequireDefault(_MergeActions);

var _userEditedRecordStore = __webpack_require__(315);

var _userEditedRecordStore2 = _interopRequireDefault(_userEditedRecordStore);

var _GxepActions = __webpack_require__(171);

var _GxepActions2 = _interopRequireDefault(_GxepActions);

var _UserActions = __webpack_require__(123);

var _UserActions2 = _interopRequireDefault(_UserActions);

var _SearchResultActions = __webpack_require__(143);

var _SearchResultActions2 = _interopRequireDefault(_SearchResultActions);

var _SearchFormActions = __webpack_require__(75);

var _SearchFormActions2 = _interopRequireDefault(_SearchFormActions);

var _LockActions = __webpack_require__(316);

var _LockActions2 = _interopRequireDefault(_LockActions);

var _lockStore = __webpack_require__(144);

var _lockStore2 = _interopRequireDefault(_lockStore);

var _hasUnsavedChanges = __webpack_require__(319);

var _hasUnsavedChanges2 = _interopRequireDefault(_hasUnsavedChanges);

var _oxfordList = __webpack_require__(975);

var _oxfordList2 = _interopRequireDefault(_oxfordList);

var _ExportParamActions = __webpack_require__(180);

var _ExportParamActions2 = _interopRequireDefault(_ExportParamActions);

var _ModalPrompt = __webpack_require__(976);

var _ModalPrompt2 = _interopRequireDefault(_ModalPrompt);

var _BaseServices = __webpack_require__(76);

var _BaseServices2 = _interopRequireDefault(_BaseServices);

var _SessionActions = __webpack_require__(320);

var _SessionActions2 = _interopRequireDefault(_SessionActions);

var _CrossAppActions = __webpack_require__(313);

var _CrossAppActions2 = _interopRequireDefault(_CrossAppActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ENTITY_FORM_OVER_KEY = "agg:entity-form";
var MAPPING_PLUGIN_SEARCH_KEY = "mapping:plugin-search";
var MAPPING_WORKFLOW_KEY = "mapping:workflow";
var MERGE_WORKFLOW_KEY = "merge:workflow";
var SUPER_RECORD_DELETE_KEY = "super-record-delete";
var EXPORT_PARAM_SET_KEY = "export-param-set";
var SESSION_EXPIRING_KEY = "session-expiration-imminent";
var CONNECTION_INTERRUPTED_KEY = "connection-interrupted";
var AUTO_KEY_PREFIX = "-auto-key-";

/**
 * I accept an 'options' object with the following keys to show as an over:
 *
 * -    **message**: the message to display in the box. Can be a simple string,
 *      a string with HTML in it (deprecated), or a zero-arg function returning
 *      a React render tree. (default `"Loading..."`)
 * -    **actions**: an array of objects, each with 'label' and 'callback'
 *      keys to render as a row of buttons at the bottom of the box (default
 *      `[]`)
 * -    **spinner**: whether to show the spinner above the message (default
 *      `true` if actions is empty, `false` otherwise)
 * -    **title**: a title for the dialog (default `null`)
 * -    **autoHide**: whether to hide the modal when an action button is
 *      clicked and the callback returns (default `true`)
 * -    **key**: a unique string which can be passed to 'over:hide' to close
 *      the the same over (default `null`)
 *
 * For backwards compatibility reasons, I can accept a positional parameter
 * corresponding to the 'message' option value.  No positional equivalent is
 * available for other options.
 */
var overOptions = exports.overOptions = function overOptions(options, createMissingKey) {
    if (options == null) {
        options = {};
    }
    if (createMissingKey == null) {
        createMissingKey = true;
    }
    if (typeof options === "string" || typeof options === "function") {
        options = {
            message: options
        };
    }
    options = _extends({
        __at: Date.now(),
        message: "Loading...",
        actions: [],
        title: null,
        autoHide: true,
        key: null
    }, options);
    if (!options.hasOwnProperty("interactive")) {
        options.interactive = options.actions.length > 0;
    }
    if (!options.hasOwnProperty("spinner")) {
        options.spinner = !options.interactive;
    }
    if (createMissingKey && options.key == null) {
        options.key = AUTO_KEY_PREFIX + Math.random();
    }
    return options;
};

var _isModalShowing = function _isModalShowing(state) {
    return !_isEmpty(state);
};

exports.isModalShowing = _isModalShowing;
var _isEmpty = function _isEmpty(state) {
    return state.length === 0;
};

exports.isEmpty = _isEmpty;
var _is_interactive = function _is_interactive(it) {
    if (!it) return false;
    if (it.hasOwnProperty("interactive")) return it.interactive;
    return it.actions && it.actions.length > 0;
};

var _getActiveItem = function _getActiveItem(state) {
    var ist = state.filter(_is_interactive);
    if (ist.length > 0) {
        return ist[ist.length - 1];
    }
    return state[state.length - 1];
};

exports.getActiveItem = _getActiveItem;
var _isModalInteractive = function _isModalInteractive(state) {
    return _is_interactive(_getActiveItem(state));
};

// reducer helpers
exports.isModalInteractive = _isModalInteractive;
var show = function show(state, options) {
    var newState = state.slice();
    options = overOptions(options);
    newState.push(options);
    return newState;
};

var isShowing = function isShowing(state, key) {
    return state.some(function (it) {
        return it.key === key;
    });
};

var showUnique = function showUnique(state, key, options) {
    return isShowing(state, key) ? state : show(state, _extends({}, options, {
        key: key
    }));
};

var hide = function hide(state, key) {
    var allInstancesOfKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var newState = state.slice();
    for (var i = newState.length - 1; i >= 0; i--) {
        var it = newState[i];
        var isKey = it.key === key;
        if (isKey || key == null && it.key.indexOf(AUTO_KEY_PREFIX) === 0) {
            newState.splice(i, 1);
            if (isKey && allInstancesOfKey) continue;
            break;
        }
    }
    return newState;
};

var isConfirmed = exports.isConfirmed = function isConfirmed(action) {
    return action.hasOwnProperty(_RecordActions.OPT_USER_CONFIRMED) && action[_RecordActions.OPT_USER_CONFIRMED];
};

var confirmDispatch = function confirmDispatch(state, action, message) {
    var yesLabel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "Yes";
    var noLabel = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "No";
    return show(state, {
        message: message,
        spinner: false,
        actions: [{
            label: yesLabel,
            callback: function callback() {
                var a = _extends({}, action, _defineProperty({}, _RecordActions.OPT_USER_CONFIRMED, true));
                if (a.hasOwnProperty(_ContextedReduceStore.ACTION_CONTEXT_KEY)) {
                    var ctx = a[_ContextedReduceStore.ACTION_CONTEXT_KEY];
                    delete a[_ContextedReduceStore.ACTION_CONTEXT_KEY];
                    _Dispatcher2.default.contextDispatch(ctx, a);
                } else {
                    _Dispatcher2.default.dispatch(a);
                }
            }
        }, {
            label: noLabel,
            callback: function callback() {
                /* noop */
            }
        }]
    });
};

var confirmDelete = function confirmDelete(state, action, ep) {
    return confirmDispatch(state, action, function () {
        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                "p",
                null,
                "Are you sure you would like to delete this ",
                ep.entityInfo.name,
                " ",
                ep.getLabel(),
                " record?"
            ),
            _react2.default.createElement(
                "p",
                null,
                "(Note that you will need to save your changes with the SAVE button for the deletion to be saved.)"
            )
        );
    });
};

var callbackAndHideBuilder = function callbackAndHideBuilder(callback, key) {
    return function () {
        callback.apply(undefined, arguments);
        _Dispatcher2.default.dispatch({
            type: _OverActions2.default.HIDE,
            key: key
        });
    };
};

// I mimic window.prompt, but via callback, not blocking. The callback will be
// passed the entered value on ok or null on cancel.
var showPrompt = function showPrompt(state, title, label, initialValue, callback) {
    var key = "prompt-" + Date.now();
    return show(state, {
        key: key,
        title: title,
        interactive: true,
        messageIsUi: true,
        message: function message() {
            return _react2.default.createElement(_ModalPrompt2.default, {
                title: title,
                label: label,
                initialValue: initialValue,
                callback: callbackAndHideBuilder(callback, key)
            });
        }
    });
};

var showAlert = function showAlert(state, message, titleOrCallback, callback, actions) {
    if (typeof titleOrCallback === "function") {
        callback = titleOrCallback;
        titleOrCallback = undefined;
    }
    return show(state, {
        message: message,
        title: titleOrCallback, // likely undefined
        spinner: false,
        actions: actions && actions.length > 0 ? actions : [okAction(callback)]
    });
};

var okAction = function okAction(callback) {
    return {
        label: "Ok",
        keyCode: 27, // trigger on escape
        callback: callback
    };
};

var showOptLockAlert = function showOptLockAlert(state, violators, ctxKey, alertKey, key, id) {
    var type = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : _lockStore.LockTypes.LAYER;

    if (!alertKey) alertKey = ctxKey;
    alertKey = "optlock-" + alertKey;
    var recordLabel = _TableStore2.default.getStereotypeProxy(key, id).getLabel();
    var attribution = (0, _oxfordList2.default)(violators);
    var _message = void 0,
        callback = void 0;
    if (type === _lockStore.LockTypes.MERGE_SOURCE) {
        _message = _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                "p",
                null,
                "Sorry, ",
                _react2.default.createElement(
                    "strong",
                    null,
                    recordLabel
                ),
                " has been updated by ",
                attribution,
                "."
            ),
            _react2.default.createElement(
                "p",
                null,
                "Please click OK to see their updates. "
            )
        );
        callback = function callback() {
            return _Dispatcher2.default.contextDispatch(ctxKey, {
                type: _MergeActions2.default.CANCEL_FOR_SOURCE_OPTLOCK,
                key: key,
                id: id
            });
        };
    } else {
        // layer
        _message = _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                "p",
                null,
                "Sorry, ",
                _react2.default.createElement(
                    "strong",
                    null,
                    recordLabel
                ),
                " has been updated by ",
                attribution,
                "."
            ),
            _react2.default.createElement(
                "p",
                null,
                "Please click OK to see their updates. Any updates you've made since you opened or last saved the record must be re-entered."
            )
        );
        callback = function callback() {
            return _Dispatcher2.default.contextDispatch(ctxKey, {
                type: _SuperRecordActions2.default.CANCEL_FOR_OPTLOCK,
                key: key,
                id: id
            });
        };
    }
    return show(hide(state, alertKey), {
        key: alertKey,
        message: function message() {
            return _message;
        },
        spinner: false,
        actions: [{
            label: "Ok",
            keyCode: 27, // trigger on escape
            callback: callback
        }]
    });
};

var OverStore = function (_ReduceStore) {
    _inherits(OverStore, _ReduceStore);

    function OverStore() {
        _classCallCheck(this, OverStore);

        return _possibleConstructorReturn(this, (OverStore.__proto__ || Object.getPrototypeOf(OverStore)).call(this, _Dispatcher2.default));
    }

    _createClass(OverStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return [];
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            var _this2 = this;

            switch (action.type) {

                // old-style explicit actions
                case _OverActions2.default.SHOW:
                    return show(state, action.options);
                case _OverActions2.default.HIDE:
                    return hide(state, action.key);
                case _OverActions2.default.APP_ALERT:
                    return showAlert(state, action.message, action.title, action.callback, action.actions);

                case _SessionActions2.default.timeoutImminent:
                    /*
                     * Do "showUnique" manually. We don't want to skip if there is
                     * one already, we want to replace it.
                     */
                    state = hide(state, SESSION_EXPIRING_KEY, true);
                    var secLeft = action.timeLeft / 1000;
                    var msg = void 0;
                    if (secLeft > 90) {
                        msg = Math.round(secLeft / 60) + " minutes";
                    } else if (secLeft > 45) {
                        msg = "one minute";
                    } else {
                        msg = "a few seconds";
                    }
                    return show(state, {
                        key: SESSION_EXPIRING_KEY,
                        message: "Your session will expire in " + msg,
                        actions: [{
                            label: "I'm Still Here!",
                            callback: function callback() {
                                return Backbone.dispatcher.trigger("user:activity");
                            }
                        }, {
                            label: "Logout Now",
                            callback: function callback() {
                                return Backbone.dispatcher.trigger("user:logout");
                            }
                        }]
                    });

                case _OverActions2.default.BROWSER_OFFLINE:
                case _OverActions2.default.ARMUS_UNREACHABLE:
                    return showUnique(state, CONNECTION_INTERRUPTED_KEY, {
                        message: "There has been an interruption in your connection; please try again.",
                        actions: [okAction()]
                    });

                case _OverActions2.default.API_UNREACHABLE:
                    return showUnique(state, CONNECTION_INTERRUPTED_KEY, {
                        message: "There has been an interruption in your connection; please wait a few moments and try again.",
                        actions: [okAction()]
                    });

                case _OverActions2.default.HTTP_UNAUTHORIZED:
                    if (_BaseServices2.default.reauthInFlight) return state;
                    return showUnique(state, "http-unauthorized", {
                        message: "Looks like your session has terminated. Probably because there was network connectivity issues which prevented us from keeping it alive like we usually do.\n\nDo you want to reload the app so you can reauthenticate?",
                        actions: [okAction(function () {
                            console.info("User requested reauth");
                            _this2.__dispatcher.dispatch({
                                type: _OverActions2.default.SHOW,
                                message: "Reloading..."
                            });
                            _BaseServices2.default.navigateToAuthUrl();
                        }), {
                            label: "Cancel",
                            callback: function callback() {
                                return console.warn("User declined reauth");
                            }
                        }]
                    });

                case _OverActions2.default.HTTP_FORBIDDEN:
                case _OverActions2.default.HTTP_NOT_FOUND:
                    return showUnique(state, "http-not-found", {
                        message: "You have requested a non-existent resource.",
                        actions: [okAction()]
                    });

                // new-style implicit actions
                case _NavigationActions2.default.SELECT_RECORD:
                    this.__dispatcher.waitFor([_NavigatorStore2.default.getDispatchToken()]);
                    if (!_NavigatorStore2.default.hasChanged()) return state;
                    return show(state, {
                        key: ENTITY_FORM_OVER_KEY
                    });

                case _FormActions2.default.START_LOAD:
                case _ActiveFormActions2.default.START_RENDER:
                    return show(state, {
                        key: ENTITY_FORM_OVER_KEY
                    });

                case _FormActions2.default.LOAD_ERROR:
                case _ActiveFormActions2.default.RENDERED:
                case _ActiveFormActions2.default.NO_FORM_TO_RENDER:
                    return hide(state, ENTITY_FORM_OVER_KEY, true);

                case _RecordActions2.default.SET_FIELD:
                    if ((0, _TableStore.isUnconfirmedVersionChange)(_TableStore2.default, action)) {
                        return confirmDispatch(state, action, function () {
                            return _react2.default.createElement(
                                _react2.default.Fragment,
                                null,
                                _react2.default.createElement(
                                    "p",
                                    null,
                                    "The value you entered will result in a data version form change. Would you like to proceed?"
                                ),
                                _react2.default.createElement(
                                    "p",
                                    null,
                                    "Select Yes to change the data version."
                                ),
                                _react2.default.createElement(
                                    "p",
                                    null,
                                    "Select No to retain the data version."
                                )
                            );
                        });
                    }
                    return state;

                case _UserActions2.default.UPDATE_LICENSE_PREFERENCE:
                case _UserActions2.default.UPDATE_ORG_USER_PREFERENCE:
                    {
                        return show(state, "Saving...");
                    }

                case _UserActions2.default.LICENSE_PREFERENCE_UPDATED:
                case _UserActions2.default.LICENSE_PREFERENCE_UPDATE_ERROR:
                case _UserActions2.default.ORG_USER_PREFERENCE_UPDATED:
                case _UserActions2.default.ORG_USER_PREFERENCE_UPDATE_ERROR:
                    {
                        return hide(state);
                    }

                case _SuperRecordActions2.default.START_CREATE:
                case _SuperRecordActions2.default.START_UPDATE:
                    {
                        if (!(0, _saveit.canSave)()) {
                            return showAlert(state, "Sorry, we are unable to save while your upload(s) are in progress.");
                        }
                        return show(state, "Saving...");
                    }

                case _SuperRecordActions2.default.CREATED:
                case _SuperRecordActions2.default.UPDATED:
                    {
                        if (_MergeStore2.default.isReady()) return hide(state);
                        return hide(state, MERGE_WORKFLOW_KEY); // Finally hide the merging overlay
                    }

                case _SuperRecordActions2.default.CREATE_ERROR:
                case _SuperRecordActions2.default.UPDATE_ERROR:
                    {
                        state = hide(state);
                        if (!_MergeStore2.default.isReady()) {
                            // error during global merge
                            state = hide(state, MERGE_WORKFLOW_KEY);
                        }
                        if (isShowing(state, CONNECTION_INTERRUPTED_KEY)) return state;
                        var xhr = action.error;
                        var message = "An error has occurred.";
                        var title = undefined;
                        if (xhr.status === 400) {
                            var response = JSON.parse(xhr.responseText);
                            if (response.status === "ENTITY_KEY_VIOLATION") {
                                title = message;
                                message = response.message;
                            }
                        }
                        if (xhr.status === 500) {
                            var _response = JSON.parse(xhr.responseText);
                            if (_response.message.indexOf("by another transaction.") !== -1) {
                                return showOptLockAlert(state, "another user or process", action.initiatingContext, action.initiatingContext, action.key, action.id);
                            }
                        }
                        console.error(message, title, xhr);
                        return showAlert(state, message, title);
                    }

                case _GxepActions2.default.START_LOAD:
                    {
                        return show(state, "Loading...");
                    }

                case _GxepActions2.default.START_SAVE:
                    {
                        return show(state, "Saving...");
                    }

                case _GxepActions2.default.LOADED:
                case _GxepActions2.default.LOAD_ERROR:
                case _GxepActions2.default.SAVED:
                case _GxepActions2.default.SAVE_ERROR:
                    {
                        return hide(state);
                    }

                case _SuperRecordActions2.default.DELETE_RECORD:
                    {
                        if (isConfirmed(action)) {
                            return show(state, {
                                message: "Deleting...",
                                key: SUPER_RECORD_DELETE_KEY
                            });
                        }
                        var stereoInfo = _StereotypesStore2.default.getStereotypeByKey(action.key);
                        var sp = _TableStore2.default.getStereotypeProxy(action.key, action.id);
                        var fluxContext = action[_ContextedReduceStore.ACTION_CONTEXT_KEY];
                        var srInfo = _SuperRecordStore2.default.getRecord(action.key, action.id, fluxContext);
                        var labels = void 0;
                        var childInfo = void 0;
                        if (srInfo.topLevelIds != null) {
                            labels = [];
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;

                            try {
                                for (var _iterator = Object.keys(srInfo.topLevelIds)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    var mck = _step.value;
                                    var _iteratorNormalCompletion2 = true;
                                    var _didIteratorError2 = false;
                                    var _iteratorError2 = undefined;

                                    try {
                                        for (var _iterator2 = srInfo.topLevelIds[mck][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                            var id = _step2.value;

                                            labels.push(_TableStore2.default.getEntityProxy(mck, id).getLabel());
                                        }
                                    } catch (err) {
                                        _didIteratorError2 = true;
                                        _iteratorError2 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                                _iterator2.return();
                                            }
                                        } finally {
                                            if (_didIteratorError2) {
                                                throw _iteratorError2;
                                            }
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return) {
                                        _iterator.return();
                                    }
                                } finally {
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }

                            if (labels.length > 0) {
                                childInfo = _StereotypesStore2.default.getStereotypeByKey(stereoInfo.magicChildKey);
                            }
                        }
                        return confirmDispatch(state, action, function () {
                            return _react2.default.createElement(
                                _react2.default.Fragment,
                                null,
                                _react2.default.createElement(
                                    "p",
                                    null,
                                    "Are you sure you want to delete this ",
                                    stereoInfo.name,
                                    " ",
                                    _react2.default.createElement(
                                        "strong",
                                        null,
                                        sp.getLabel()
                                    )
                                ),
                                labels && labels.length > 0 && _react2.default.createElement(
                                    _react2.default.Fragment,
                                    null,
                                    " ",
                                    "with",
                                    " ",
                                    labels.length === 1 ? childInfo.name : childInfo.pluralName,
                                    ":",
                                    _react2.default.createElement(
                                        "ul",
                                        null,
                                        labels.map(function (l, i) {
                                            return _react2.default.createElement(
                                                "li",
                                                { key: i },
                                                l
                                            );
                                        })
                                    )
                                ),
                                _react2.default.createElement(
                                    "p",
                                    null,
                                    "THIS ACTION CANNOT BE UNDONE."
                                )
                            );
                        }, "Yes, Delete " + stereoInfo.name);
                    }

                case _SuperRecordActions2.default.DELETED:
                    {
                        return hide(state, SUPER_RECORD_DELETE_KEY);
                    }

                case _SuperRecordActions2.default.DELETE_ERROR:
                    {
                        state = hide(state, SUPER_RECORD_DELETE_KEY);
                        if (isShowing(state, CONNECTION_INTERRUPTED_KEY)) return state;
                        var _stereoInfo = _StereotypesStore2.default.getStereotypeByKey(action.key);
                        var _xhr = action.error;
                        var _message2 = "We are unable to delete this " + _stereoInfo.name + " at this time.";
                        if (_xhr.responseText) {
                            //xhr.responseText = '{"message": "This Patient has inaccessable Episodes (CathPCI)","impls": [{ "name": "CathPCI", "key": "cathpci" }],"grant": 8}'
                            var resp = JSON.parse(_xhr.responseText);
                            if (resp.impls != null) {
                                _message2 = "The " + _stereoInfo.name + " has records for registries to which you do not have access (";
                                var regs = [];
                                var _iteratorNormalCompletion3 = true;
                                var _didIteratorError3 = false;
                                var _iteratorError3 = undefined;

                                try {
                                    for (var _iterator3 = resp.impls[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                        var reg = _step3.value;

                                        regs.push(reg.name);
                                    }
                                } catch (err) {
                                    _didIteratorError3 = true;
                                    _iteratorError3 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                            _iterator3.return();
                                        }
                                    } finally {
                                        if (_didIteratorError3) {
                                            throw _iteratorError3;
                                        }
                                    }
                                }

                                _message2 += regs.join(",");
                                _message2 += ").\n\nPlease consult your administrator to delete this " + _stereoInfo.name + ".";
                            }
                        }
                        return showAlert(state, _message2);
                    }

                case _RecordActions2.default.DELETE_RECORD:
                    {
                        if (isConfirmed(action)) return state;
                        var ep = _TableStore2.default.getEntityProxy(action.recordKey, action.recordId);
                        return confirmDelete(state, action, ep);
                    }

                case _RecordActions2.default.DELETE_CHILD:
                    {
                        if (isConfirmed(action)) return state;
                        var _ep = _TableStore2.default.getEntityProxy(action.childKey, action.childId);
                        return confirmDelete(state, action, _ep);
                    }

                case _ActiveFormActions2.default.BLUR_ELEMENT:
                    {
                        if (action.fieldKey == null) return state;
                        this.__dispatcher.waitFor([_ActiveFormStore2.default.getDispatchToken(), _TableStore2.default.getDispatchToken(), _SuperRecordStore2.default.getDispatchToken()]);
                        var _fluxContext = action[_ContextedReduceStore.ACTION_CONTEXT_KEY];
                        var val = (0, _records.lastBlurredValidation)(_fluxContext, _TableStore2.default, _ActiveFormStore2.default);
                        if (val == null || (0, _utils2.isOk)(val.code)) return state;
                        var implKey = new _EntityName2.default(action.entityKey).implKey;
                        var confirm = function confirm(severity) {
                            return _userStore2.default.getLicensePreference(severity + "-data-confirmation-on-blur", implKey);
                        };
                        var focusField = function focusField(key) {
                            return _Dispatcher2.default.contextDispatch(_fluxContext, {
                                type: _NavigationActions2.default.FOCUS_FIELD,
                                entityKey: action.entityKey,
                                recordId: action.recordId,
                                fieldKey: key
                            });
                        };
                        var focusNextField = function focusNextField(key) {
                            var next = _FormStore2.default.getNextControl(action.entityKey, key, true);
                            if (next == null) return;
                            focusField(next.key);
                        };

                        if ((0, _utils2.isIllegal)(val.code) && confirm("illegal")) {
                            var illegalLabel = _userStore2.default.getIllegalLabel(implKey);
                            return showAlert(state, "The Field Contains " + illegalLabel + " Data.\n " + val.message, function () {
                                return focusField(action.fieldKey);
                            });
                        } else if (val.isUnusual && confirm("unusual")) {
                            return showAlert(state, "The Field Contains Unusual Data.\n " + val.message, function () {
                                return focusNextField(action.fieldKey);
                            });
                        } else if ((0, _utils2.isWarning)(val.code) && confirm("warning")) {
                            return showAlert(state, "Warning: " + val.message, function () {
                                return focusNextField(action.fieldKey);
                            });
                        }
                        return state;
                    }

                case _AdtActions2.default.SEARCH:
                case _HemoActions2.default.SEARCH:
                case _EcmoEmrActions2.default.SEARCH:
                case _CrossAppActions2.default.SEARCH:
                    {
                        if (!action.interactive) return state;
                        return show(state, {
                            key: MAPPING_PLUGIN_SEARCH_KEY,
                            message: "Searching..."
                        });
                    }

                case _AdtActions2.default.SEARCH_RESULT:
                case _AdtActions2.default.SEARCH_ERROR:
                case _HemoActions2.default.SEARCH_RESULT:
                case _HemoActions2.default.SEARCH_ERROR:
                case _EcmoEmrActions2.default.SEARCH_RESULT:
                case _EcmoEmrActions2.default.SEARCH_ERROR:
                case _CrossAppActions2.default.SEARCH_RESULT:
                case _CrossAppActions2.default.SEARCH_ERROR:
                    {
                        if (!action.interactive) return state;
                        return hide(state, MAPPING_PLUGIN_SEARCH_KEY);
                    }

                case _SearchFormActions2.default.INITIATE_SEARCH:
                case _SearchFormActions2.default.INITIATE_SEARCH_AND_SAVE_DEFAULT:
                case _SearchFormActions2.default.RESTORE_DEFAULT_AND_INITIATE_SEARCH:
                case _SearchResultActions2.default.START_SEARCH:
                    if (action.showLoadingModal === false) {
                        return state;
                    }
                    return show(state, {
                        key: "search:" + action.key,
                        message: "Searching..."
                    });

                case _SearchResultActions2.default.SEARCH_RESULT:
                case _SearchResultActions2.default.SEARCH_ERROR:
                    {
                        return hide(state, "search:" + action.key);
                    }

                case _MergeActions2.default.DO_MERGE:
                    {
                        if (isConfirmed(action)) {
                            return show(state, {
                                key: MERGE_WORKFLOW_KEY,
                                message: "Merging..."
                            });
                        }
                        return confirmDispatch(state, action, function () {
                            var _MergeStore$getProxyP = _MergeStore2.default.getProxyPair(),
                                source = _MergeStore$getProxyP.source,
                                target = _MergeStore$getProxyP.target;

                            var sourceChildren = (0, _mergeHelpers.getAutoMergeGlobalSummary)(source);
                            var typeLabel = target.stereoInfo.name.toLowerCase();
                            var sourceLabel = _react2.default.createElement(
                                "strong",
                                null,
                                source.getLabel(),
                                " ",
                                source.getDetailString() && _react2.default.createElement(
                                    "small",
                                    null,
                                    source.getDetailString()
                                )
                            );
                            // const targetLabel = <strong>{target.getLabel()} {target.getDetailString() && <small>{target.getDetailString()}</small>}</strong>;
                            return _react2.default.createElement(
                                _react2.default.Fragment,
                                null,
                                _react2.default.createElement(
                                    "p",
                                    null,
                                    "Are you sure you want to merge and delete this ",
                                    typeLabel,
                                    " ",
                                    sourceLabel,
                                    ":"
                                ),
                                _react2.default.createElement(
                                    "ul",
                                    null,
                                    sourceChildren.map(function (g) {
                                        return g.items.map(function (l, i) {
                                            return _react2.default.createElement(
                                                "li",
                                                { key: i },
                                                l
                                            );
                                        });
                                    })
                                ),
                                _react2.default.createElement(
                                    "p",
                                    null,
                                    "THIS ACTION CANNOT BE UNDONE."
                                )
                            );
                        }, "Yes, Merge and Delete");
                    }

                case _MapDialogActions2.default.SELECT_SOURCE:
                case _MapDialogActions2.default.IMPORT:
                case _MapButtonActions2.default.AUTOMAP_FROM:
                case _MapButtonActions2.default.AUTOMAP_TO_NEW_MAGIC_CHILD:
                    {
                        return show(state, {
                            key: MAPPING_WORKFLOW_KEY,
                            message: "Mapping..."
                        });
                    }

                case _MappingActions2.default.MODEL_LOAD_ERROR:
                    {
                        state = hide(state, MAPPING_WORKFLOW_KEY);
                        return showAlert(state, "A non-recoverable error happened.");
                    }

                case _MappingActions2.default.MODEL_LOADED:
                    {
                        this.__dispatcher.waitFor([_MappingStore2.default.getDispatchToken()]);
                        if (_MappingStore2.default.isInteractive()) {
                            return hide(state, MAPPING_WORKFLOW_KEY);
                        } else {
                            return state;
                        }
                    }

                case _MappingActions2.default.IT_IS_DONE:
                    {
                        this.__dispatcher.waitFor([_MergeStore2.default.getDispatchToken(), _MappingStore2.default.getDispatchToken(), _TableStore2.default.getDispatchToken(), _SuperRecordStore2.default.getDispatchToken()]);
                        if (_MergeStore2.default.isReady()) {
                            // record merge is done here.
                            state = hide(state, MERGE_WORKFLOW_KEY);
                        }
                        return hide(state, MAPPING_WORKFLOW_KEY);
                    }

                case _OverActions2.default.EXTERNAL_NAV:
                    {
                        this.__dispatcher.waitFor([_userEditedRecordStore2.default.getDispatchToken(), _lockStore2.default.getDispatchToken()]);
                        if (isConfirmed(action)) {
                            var ret = show(state, {
                                message: action.message
                            });
                            action.callback();
                            return ret;
                        }
                        if ((0, _hasUnsavedChanges2.default)()) {
                            // there are unsaved changes
                            return confirmDispatch(state, action, "<p>Changes you made may not be saved.</p>\n" + "<p>Select Cancel to review your changes.</p>\n" + "<p>Select Ok to continue without saving.</p>", "Ok", "Cancel");
                        } else {
                            // no edits continue with navigation.
                            action.callback();
                        }
                        return state;
                    }

                case _LockActions2.default.LOCKSET_CREATED:
                case _LockActions2.default.LOCKSET_CONFIRMED:
                    {
                        this.__dispatcher.waitFor([_lockStore2.default.getDispatchToken()]);
                        var _iteratorNormalCompletion4 = true;
                        var _didIteratorError4 = false;
                        var _iteratorError4 = undefined;

                        try {
                            for (var _iterator4 = _lockStore2.default.getContextNames()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                var ctxName = _step4.value;

                                var ctx = _lockStore2.default.getState(ctxName);
                                var ol = ctx.optlock;
                                if (ol && ol.violated && !ol.dismissed) {
                                    return showOptLockAlert(state, ol.violators, ctxName, ol.id, ctx.key, ctx.id, ctx.type);
                                }
                            }
                        } catch (err) {
                            _didIteratorError4 = true;
                            _iteratorError4 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                    _iterator4.return();
                                }
                            } finally {
                                if (_didIteratorError4) {
                                    throw _iteratorError4;
                                }
                            }
                        }

                        return state;
                    }

                case _ExportParamActions2.default.CREATE:
                    {
                        if (action.name) {
                            return show(state, {
                                key: EXPORT_PARAM_SET_KEY,
                                message: "Saving parameter selection..."
                            });
                        }
                        return showPrompt(state, "New Saved Parameter Selection", "Name", "", function (name) {
                            if (!name) return;
                            name = name.trim();
                            if (!name) return;
                            _this2.__dispatcher.dispatch(_extends({}, action, {
                                name: name
                            }));
                        });
                    }

                case _ExportParamActions2.default.UPDATE:
                    {
                        return show(state, {
                            key: EXPORT_PARAM_SET_KEY,
                            message: "Saving parameter selection..."
                        });
                    }

                case _ExportParamActions2.default.RENAME:
                    {
                        if (action.name) {
                            return show(state, {
                                key: EXPORT_PARAM_SET_KEY,
                                message: "Renaming parameter selection..."
                            });
                        }
                        return showPrompt(state, "Rename Parameter Selection", "Name", action.oldName, function (name) {
                            if (!name) return;
                            name = name.trim();
                            if (!name) return;
                            if (name === action.oldName) return;
                            _this2.__dispatcher.dispatch(_extends({}, action, {
                                name: name
                            }));
                        });
                    }

                case _ExportParamActions2.default.DELETE:
                    {
                        if (isConfirmed(action)) {
                            return show(state, {
                                key: EXPORT_PARAM_SET_KEY,
                                message: "Deleting parameter selection..."
                            });
                        }
                        return confirmDispatch(state, action, "Are you sure you want to delete this parameter selection?");
                    }

                case _ExportParamActions2.default.CREATED:
                case _ExportParamActions2.default.RENAMED:
                case _ExportParamActions2.default.UPDATED:
                case _ExportParamActions2.default.DELETED:
                    {
                        return hide(state, EXPORT_PARAM_SET_KEY);
                    }

                case _ExportParamActions2.default.CREATE_ERROR:
                case _ExportParamActions2.default.UPDATE_ERROR:
                    {
                        state = hide(state, EXPORT_PARAM_SET_KEY);
                        return showAlert(state, "Failed to save parameter selection");
                    }

                case _ExportParamActions2.default.RENAME_ERROR:
                    {
                        state = hide(state, EXPORT_PARAM_SET_KEY);
                        return showAlert(state, "Failed to rename parameter selection");
                    }

                case _ExportParamActions2.default.DELETE_ERROR:
                    {
                        state = hide(state, EXPORT_PARAM_SET_KEY);
                        return showAlert(state, "Failed to delete parameter selection");
                    }

                default:
                    return state;
            }
        }
    }, {
        key: "isModalShowing",
        value: function isModalShowing() {
            return _isModalShowing(this.getState());
        }
    }, {
        key: "isEmpty",
        value: function isEmpty() {
            return _isEmpty(this.getState());
        }
    }, {
        key: "getActiveItem",
        value: function getActiveItem() {
            return _getActiveItem(this.getState());
        }
    }, {
        key: "isModalInteractive",
        value: function isModalInteractive() {
            return _isModalInteractive(this.getState());
        }
    }]);

    return OverStore;
}(_utils.ReduceStore);

var optionTypes = exports.optionTypes = _propTypes2.default.shape({
    __at: _propTypes2.default.number.isRequired,
    message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func] // a render callback
    ).isRequired,
    actions: _propTypes2.default.oneOfType([_propTypes2.default.PropTypes.arrayOf(_propTypes2.default.shape({
        label: _propTypes2.default.string.isRequired,
        keyCode: _propTypes2.default.number, // button action trigger key
        callback: _propTypes2.default.func // not required (e.g., alert w/ no action on dismiss)
    })), _propTypes2.default.func] // a render callback
    ),
    title: _propTypes2.default.string,
    autoHide: _propTypes2.default.bool,
    messageIsUi: _propTypes2.default.bool,
    interactive: _propTypes2.default.bool,
    key: _propTypes2.default.string.isRequired,
    spinner: _propTypes2.default.bool
});

OverStore.stateTypes = _propTypes2.default.arrayOf(optionTypes);

exports.default = (0, _typeCheckingStore2.default)(new OverStore());

/***/ }),
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getRecordNavPath = exports.rerouteFieldNav = exports.canMergeSuperRecord = exports.canDeleteSuperRecord = exports.getActiveRecordSiblings = exports.getSuperRecordItems = exports.getSuperRecordCreatables = exports.getSuperSelectedVersion = exports.superNavTree = exports.nearestNavigableParent = exports.getTopLevelRecords = exports.superRecordPacket = exports.oneOffSuperRecordPacket = exports.superRecordPacketType = exports.TOP_LEVEL_RECORDS_KEY = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _TableColumnMetaStore = __webpack_require__(125);

var _TableColumnMetaStore2 = _interopRequireDefault(_TableColumnMetaStore);

var _hydration = __webpack_require__(304);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _NavigatorStore = __webpack_require__(33);

var _NavigatorStore2 = _interopRequireDefault(_NavigatorStore);

var _TableAccess = __webpack_require__(77);

var _TableAccess2 = _interopRequireDefault(_TableAccess);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _SuperRecordStore = __webpack_require__(36);

var _SuperRecordStore2 = _interopRequireDefault(_SuperRecordStore);

var _NavigatorStore3 = __webpack_require__(33);

var _records = __webpack_require__(113);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _LiveMap = __webpack_require__(178);

var _LiveMap2 = _interopRequireDefault(_LiveMap);

var _stereotypes = __webpack_require__(126);

var _typedefs = __webpack_require__(44);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TOP_LEVEL_RECORDS_KEY = exports.TOP_LEVEL_RECORDS_KEY = "topLevelRecords";

var superRecordPacketType = exports.superRecordPacketType = _propTypes2.default.shape({
    id: _typedefs.recordIdType.isRequired,
    owner: _propTypes2.default.string.isRequired,
    tables: _propTypes2.default.objectOf( // tableKey
    _propTypes2.default.objectOf( // ao_id
    _propTypes2.default.shape({ // record
        _id: _typedefs.recordIdType.isRequired,
        _ts: _propTypes2.default.number.isRequired,
        _cts: _propTypes2.default.number.isRequired
        // all the dynamic occurrence data by logical field key
    }))).isRequired,
    topLevelIds: _propTypes2.default.objectOf( // entityKey
    _propTypes2.default.arrayOf(_typedefs.recordIdType) // ao_id[]
    ),
    newIds: _propTypes2.default.objectOf( // clientId
    _typedefs.recordIdType // ao_id
    )
});

function srPacketSkeleton(id, owner) {
    return {
        id: id,
        owner: owner,
        tables: {},
        topLevelIds: {},
        newIds: {}
    };
}

// don't use this, in general.
var oneOffSuperRecordPacket = exports.oneOffSuperRecordPacket = function oneOffSuperRecordPacket(key, id, owner) {
    var includeAssocRecords = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (!_EntityName2.default.is(key)) {
        // stereotype
        return superRecordPacket(_TableStore2.default, _StereotypesStore2.default.getStereotypeByKey(key), id, _SuperRecordStore2.default.getRecord(key, id), owner, includeAssocRecords);
    }
    // entity
    var packet = srPacketSkeleton(id, owner);
    var addTableRecord = addTableRecordBuilder(_TableStore2.default, packet.tables, includeAssocRecords);
    addTableRecord(key, id);
    return packet;
};

var addTableRecordBuilder = function addTableRecordBuilder(TableStore, tables, includeAssocRecords) {
    // there's likely to be a lot of repeats, so locally-cache the lookups
    var tkc = new _LiveMap2.default(function (ek) {
        return _entityMetaStore2.default.getInfo(ek).tableKey;
    });
    var cic = new _LiveMap2.default(function (tk) {
        return _TableColumnMetaStore2.default.getAllColumns(tk).filter(function (it) {
            return !it.inverse;
        });
    });
    var cfic = new _LiveMap2.default(function (tk) {
        return _entityMetaStore2.default.getInfosForLogicalTable(tk).reduce(function (cols, ei) {
            return _entityFieldMetaStore2.default.getAllInfos(ei.key, function (info) {
                return info.type === "CompositionField" || includeAssocRecords && info.type === "AssociationField";
            }).reduce(function (cols, fi) {
                return _extends({}, cols, _defineProperty({}, fi.logicalColumn, fi.otherEntityKey));
            }, cols);
        }, {});
    });

    var addTableRecord = function addTableRecord(ek, id) {
        var tableKey = tkc.get(ek);
        var colInfos = cic.get(tableKey);
        var compMap = cfic.get(tableKey);
        if (!tables.hasOwnProperty(tableKey)) {
            tables[tableKey] = {};
        }
        var table = tables[tableKey];
        if (table.hasOwnProperty(id)) {
            return;
        }
        var rd = TableStore.getRecordData(tableKey, id);
        table[id] = {
            _id: rd.meta.id
        };
        if (rd.meta.ts) {
            table[id]._ts = rd.meta.ts;
        }
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = colInfos[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var ci = _step.value;

                table[id][ci.name] = (0, _hydration.dehydrateField)(rd.data[ci.name], ci.type);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = Object.keys(compMap)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var lc = _step2.value;

                var cids = table[id][lc];
                if (cids == null) continue;
                if (Array.isArray(cids)) {
                    if (cids.length === 0) continue;
                } else {
                    cids = [cids];
                }
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = cids[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var cid = _step3.value;

                        addTableRecord(compMap[lc], cid);
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    };
    return addTableRecord;
};

var superRecordPacket = exports.superRecordPacket = function superRecordPacket(TableStore, stereoInfo, id, srInfo, owner) {
    var includeAssocRecords = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    if (stereoInfo == null) {
        throw new Error("Can't build a superRecord packet w/ null stereotype info!");
    }
    var packet = _extends({}, srPacketSkeleton(id, owner), {
        topLevelIds: srInfo.topLevelIds
    });
    var addTableRecord = addTableRecordBuilder(TableStore, packet.tables, includeAssocRecords);

    var access = new _TableAccess2.default(TableStore.getState());
    var stereoImplementations = (0, _stereotypes.getImplementations)(stereoInfo, access, id);
    // doesn't matter what implementation this is - they all become the same tableKey
    addTableRecord(stereoImplementations[0].key, id);
    tlrBuilder(TableStore, srInfo)(addTableRecord);
    return packet;
};

var tlrBuilder = function tlrBuilder(TableStore, srInfo) {
    return function (keyAndIdWork) {
        return Object.keys(srInfo.topLevelIds).forEach(function (ek) {
            return srInfo.topLevelIds[ek].forEach(function (id) {
                return keyAndIdWork(ek, id);
            });
        });
    };
};

var getTopLevelRecords = exports.getTopLevelRecords = function getTopLevelRecords(TableStore, srInfo) {
    var result = [];
    tlrBuilder(TableStore, srInfo)(function (ek, id) {
        return result.push(TableStore.getEntityProxy(ek, id));
    });
    return result;
};

// Find the nearest navigable parent of the given key:id:shortname triple,
// ideally itself. Return the resulting triple, plus a flag for whether a
// non-navigable edge was chopped off.
var nearestNavigableParent = exports.nearestNavigableParent = function nearestNavigableParent(TableStore, srInfo, key, id, shortname) {
    var versionKey = new _EntityName2.default(key).versionKey;
    var candidateTLRs = getTopLevelRecords(TableStore, srInfo).filter(function (it) {
        return new _EntityName2.default(it.entityKey).versionKey === versionKey;
    });

    // i return the path to the record, or null if it can't be found
    var findPath = function findPath(record, includeAssoc) {
        if (record.id === id && record.entityKey === key) return { record: record };
        var cbk = (0, _records.getChildrenByKey)(record, includeAssoc);
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
            for (var _iterator4 = Object.keys(cbk)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var fk = _step4.value;

                var v = cbk[fk];
                var info = _entityFieldMetaStore2.default.getInfo(record.entityKey, fk);
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = (v instanceof Array ? v : [v])[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var r = _step5.value;

                        var child = findPath(r, includeAssoc);
                        if (child != null) {
                            return {
                                record: record,
                                child: _extends({}, child, {
                                    info: info
                                })
                            };
                        }
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                }
            } finally {
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }

        return null;
    };

    var path = void 0;
    var usedAssoc = false;
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
        for (var _iterator6 = candidateTLRs[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var tlr = _step6.value;

            path = findPath(tlr, false);
            if (path != null) break;
        }
    } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
            }
        } finally {
            if (_didIteratorError6) {
                throw _iteratorError6;
            }
        }
    }

    if (path == null) {
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
            for (var _iterator7 = candidateTLRs[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                var _tlr = _step7.value;

                path = findPath(_tlr, true);
                if (path != null) {
                    usedAssoc = true;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                    _iterator7.return();
                }
            } finally {
                if (_didIteratorError7) {
                    throw _iteratorError7;
                }
            }
        }
    }
    if (path != null) {
        var me = path;
        while (me.child && me.child.info) {
            if (!(me.child.info.mrPointer || me.child.info.type === "CompositionField" && me.child.info.navigable)) {
                break;
            }
            me = me.child;
        }
        return [me.record.entityKey, me.record.id, me.child && me.child.info.key || shortname, usedAssoc];
    }
    console.error("couldn't find a navigable parent...", key, id, shortname);
    return [key, id, shortname, false];
};

var superNavTree = exports.superNavTree = function superNavTree(TableStore, srInfo, navState, key, id) {
    var rootInfo = _StereotypesStore2.default.getStereotypeByKey(key);
    var helper = (0, _records.navTreeHelperBuilder)(navState);
    var rootAccess = new _TableAccess2.default(TableStore.getState());
    var rootImplementations = (0, _stereotypes.getImplementations)(rootInfo, rootAccess, id);
    var sp = TableStore.getStereotypeProxy(key, id);
    var rs = navState.record;
    if (rs != null) sp.withEntityContext(rs.key);
    var tree = {
        id: id,
        fields: [],
        childCount: 0,
        label: sp.getLabel(),
        detail: sp.getDetailString(),
        supportsEnablement: sp.stereoInfo.supportsEnablement,
        isMagic: rootInfo.magicRoot,
        name: rootInfo.name,
        key: key,
        stereoKey: key,
        selected: (0, _NavigatorStore3.isAllImplementationsSelected)(navState)
    };
    var activePrefix = void 0;
    tree.projections = Object.values(rootImplementations.reduce(function (ps, it) {
        if (!ps.hasOwnProperty(it.implementationKey)) {
            var _selected = (0, _NavigatorStore3.isImplementationSelected)(navState, it.implementationKey);
            if (_selected) activePrefix = it.implementationKey;
            ps[it.implementationKey] = {
                implementationKey: it.implementationKey,
                implementationName: it.implementationName,
                selected: _selected,
                expanded: (0, _NavigatorStore3.isImplementationExpanded)(navState, it.implementationKey),
                versions: []
            };
        }
        var selected = (0, _NavigatorStore3.isVersionSelected)(navState, it.key);
        var recTree = helper(TableStore.getEntityProxy(it.key, id));
        var v = {
            versionKey: it.versionKey,
            versionName: it.versionName,
            key: it.key,
            name: it.entityName,
            selected: selected,
            childCount: recTree.childCount
        };
        if (selected) {
            var _tree$fields;

            activePrefix = it.versionKey;
            (_tree$fields = tree.fields).push.apply(_tree$fields, _toConsumableArray(recTree.fields));
            tree.childCount += recTree.childCount;
        }
        ps[it.implementationKey].versions.push(v);
        return ps;
    }, {}));
    if (tree.isMagic) {
        var topLevelRecords = getTopLevelRecords(TableStore, srInfo);
        var childInfo = _StereotypesStore2.default.getStereotypeByKey(rootInfo.magicChildKey);
        tree.fields.push({
            key: TOP_LEVEL_RECORDS_KEY,
            recordKey: key,
            recordId: id,
            name: childInfo.pluralName,
            creatables: getSuperRecordCreatables(childInfo),
            allowDelete: true,
            items: getSuperRecordItems(topLevelRecords, childInfo).filter(function (it) {
                return activePrefix == null || it.entityKey.startsWith(activePrefix + "/");
            }).map(function (it) {
                return helper(it);
            })
        });
        tree.childCount = topLevelRecords.length;
        tree.projections.forEach(function (p) {
            p.childCount = topLevelRecords.filter(function (it) {
                return it.entityKey.startsWith(p.implementationKey + "/");
            }).length;
            p.versions.forEach(function (v) {
                v.childCount += topLevelRecords.filter(function (it) {
                    return it.entityKey.startsWith(v.versionKey + "/");
                }).length;
            });
        });
    }
    return tree;
};

var getSuperSelectedVersion = exports.getSuperSelectedVersion = function getSuperSelectedVersion(item) {
    // return first selected version found or null.
    if (!item.isMagic || !item.hasOwnProperty("projections")) {
        console.log("Expected item to be super record with projections");
        return null;
    }
    var _iteratorNormalCompletion8 = true;
    var _didIteratorError8 = false;
    var _iteratorError8 = undefined;

    try {
        for (var _iterator8 = item.projections[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
            var p = _step8.value;
            var _iteratorNormalCompletion9 = true;
            var _didIteratorError9 = false;
            var _iteratorError9 = undefined;

            try {
                for (var _iterator9 = p.versions[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                    var v = _step9.value;

                    if (!v.selected) continue;
                    return v;
                }
            } catch (err) {
                _didIteratorError9 = true;
                _iteratorError9 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion9 && _iterator9.return) {
                        _iterator9.return();
                    }
                } finally {
                    if (_didIteratorError9) {
                        throw _iteratorError9;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion8 && _iterator8.return) {
                _iterator8.return();
            }
        } finally {
            if (_didIteratorError8) {
                throw _iteratorError8;
            }
        }
    }

    return null;
};

var getSuperRecordCreatables = exports.getSuperRecordCreatables = function getSuperRecordCreatables(sr) {
    return sr.implementations.filter(function (it) {
        return it.creatable;
    }).map(function (it) {
        return {
            // this needs to be the magic children
            key: it.key,
            name: it.implementationName + " v" + it.versionName,
            implKey: it.implementationKey
        };
    });
};

var getSuperRecordItems = exports.getSuperRecordItems = function getSuperRecordItems(topLevelRecords, childInfo) {
    return topLevelRecords.sort((0, _StereotypesStore.getRecordComparator)(childInfo));
};

var getActiveRecordSiblings = exports.getActiveRecordSiblings = function getActiveRecordSiblings(fluxContext, activeRecord) {
    var extraFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var entityInfo = activeRecord.entityInfo;
    var items = [];
    switch (entityInfo.type) {
        case "GLOBAL":
            // this list could be to large and should requires a search modal.
            // Just return empty array.
            return [];
        case "ROOT":
            var magic = _NavigatorStore2.default.getMagicState(fluxContext);
            var srInfo = _SuperRecordStore2.default.getRecord(magic.key, magic.id);
            items = getTopLevelRecords(_TableStore2.default, srInfo);
            break;
        case "CHILD":
            // use parentPointerKey to get parent then look for siblings
            if (!entityInfo.parentPointerKey) {
                throw new Error("expecting parentPointerKey to be defined");
            }
            var ppInfo = _entityFieldMetaStore2.default.getInfo(entityInfo.key, entityInfo.parentPointerKey);
            var parentEP = activeRecord.get(ppInfo.key);
            if (parentEP === null) {
                // the activeRecord has been orphaned... therefore no siblings
                return [];
            }
            items = parentEP.get(ppInfo.inverseKey) || []; // aways return array
            break;
        default:
            throw new Error("Unknown activeRecord type");
    }
    return items.filter(function (it) {
        return !it.equals(activeRecord) && (typeof extraFilter === "function" ? extraFilter(it) : true);
    });
};

var canDeleteSuperRecord = exports.canDeleteSuperRecord = function canDeleteSuperRecord(sp) {
    if (sp.stereoInfo.magicRoot) {
        // every magic child must be deletable as well
        var srLO = _SuperRecordStore2.default.getRecordLO(sp.stereoKey, sp.id);
        if (!srLO.hasValue()) return false;
        var tlrs = getTopLevelRecords(_TableStore2.default, srLO.getValueEnforcing());
        if (tlrs.some(function (it) {
            return !it.canDelete();
        })) {
            return false;
        }
    } else if (sp.stereoInfo.supportsEnablement) {
        // using enablement, so never deletable
        return false;
    }
    // If can delete any implementation, good enough
    return (0, _stereotypes.getImplementations)(sp.stereoInfo, new _TableAccess2.default(_TableStore2.default.getState()), sp.id).some(function (it) {
        return _entityMetaStore2.default.getInfo(it.key).canDelete;
    });
};

var canMergeSuperRecord = exports.canMergeSuperRecord = function canMergeSuperRecord(sp) {
    if (_ClientId2.default.is(sp.id)) return false;
    var partiallyNormal = (0, _stereotypes.getImplementations)(sp.stereoInfo, new _TableAccess2.default(_TableStore2.default.getState()), sp.id).some(function (it) {
        return !_entityMetaStore2.default.getInfo(it.key).lookup;
    });
    return partiallyNormal ? _userStore2.default.canMergeMagicRoots() : _userStore2.default.canMergeLookups();
};

var rerouteFieldNav = exports.rerouteFieldNav = function rerouteFieldNav(magic, entityKey, recordId, fieldKey) {
    var fieldSpec = {
        entityKey: entityKey,
        recordId: recordId,
        fieldKey: fieldKey
    };
    var assocInPlay = void 0;
    // eslint-disable-next-line prefer-const

    var _nearestNavigablePare = nearestNavigableParent(_TableStore2.default, _SuperRecordStore2.default.getRecord(magic.key, magic.id), entityKey, recordId, fieldKey);

    var _nearestNavigablePare2 = _slicedToArray(_nearestNavigablePare, 4);

    entityKey = _nearestNavigablePare2[0];
    recordId = _nearestNavigablePare2[1];
    fieldKey = _nearestNavigablePare2[2];
    assocInPlay = _nearestNavigablePare2[3];

    if (recordId == null || entityKey == null) throw new Error("how/why did this happen?");
    if (assocInPlay) {
        fieldSpec.entityKey = entityKey;
        fieldSpec.recordId = recordId;
        fieldSpec.fieldKey = fieldKey;
    }
    return [entityKey, recordId, fieldSpec];
};

var getRecordNavPath = exports.getRecordNavPath = function getRecordNavPath(navigatorStoreState) {
    var magicState = navigatorStoreState.magic;
    var recordState = navigatorStoreState.record;
    if (magicState == null || recordState == null) return [];
    var isSuperRecord = !_EntityName2.default.is(magicState.key);
    var srLO = void 0;
    if (isSuperRecord) {
        srLO = _SuperRecordStore2.default.getRecordLO(magicState.key, magicState.id);
        if (!srLO.hasValue()) return [];
    }
    var tree = isSuperRecord ? superNavTree(_TableStore2.default, srLO.getRequiredValue(), navigatorStoreState, magicState.key, magicState.id) : (0, _records.navTree)(_TableStore2.default, navigatorStoreState, magicState.key, magicState.id);
    var activeRecords = [];
    var filterTree = function filterTree(node) {
        if (node.items && node.items.length) {
            node.items.forEach(function (item) {
                filterTree(item);
            });
        } else if (node.fields && node.fields.length) {
            node.fields.forEach(function (col) {
                if (col.items.length) {
                    col.items.forEach(function (item) {
                        filterTree(item);
                    });
                }
            });
        }
        if (node.selected && !node.isMagic) {
            activeRecords.push({
                key: node.entityKey,
                id: node.id
            });
        }
    };
    filterTree(tree);
    activeRecords.reverse();
    // add the magic root to the beginning
    if (isSuperRecord) {
        activeRecords.unshift({
            key: tree.key,
            id: tree.id
        });
        if (activeRecords.length >= 2) {
            // we know the projection
            var parts = activeRecords[1].key.split("/");
            activeRecords[0].key = parts[0] + "/" + parts[1] + "/" + activeRecords[0].key;
        } else {
            // try to find the selected projection and version
            var selected = null;
            tree.projections.forEach(function (pi) {
                if (selected) return;
                pi.versions.forEach(function (vi) {
                    if (selected) return;
                    if (vi.selected) {
                        selected = vi;
                    }
                });
            });
            if (selected) {
                activeRecords[0].key = selected.key;
            }
        }
    }
    return activeRecords;
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typedAction = __webpack_require__(86);

var _typedAction2 = _interopRequireDefault(_typedAction);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _typedefs = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapDialogActions = {
    SELECT_PLUGIN: (0, _typedAction2.default)("map-dialog/select-plugin", {
        key: _propTypes2.default.string.isRequired
    }),
    TOGGLE_DRAWER: "map-dialog/toggle-drawer",
    SELECT_SOURCE: (0, _typedAction2.default)("map-dialog/select-source", {
        source: _propTypes2.default.instanceOf(_EntityProxy2.default).isRequired
    }),
    SELECT_STEREOTYPE: "map-dialog/select-stereotype",
    SELECT_PAGE: "map-dialog/select-page",
    SET_MAGIC_ROOT_EXCLUSION: (0, _typedAction2.default)("map-dialog/set-magic-root-exclusion", {
        excluded: _propTypes2.default.bool.isRequired
    }),
    TOGGLE_EXCLUSION: (0, _typedAction2.default)("map-dialog/toggle-exclusion", {
        recordId: _typedefs.recordIdType.isRequired,
        columnKey: _propTypes2.default.string.isRequired,
        itemKey: _propTypes2.default.any // undefined for field-level exclusions
    }),
    IMPORT: "map-dialog/import",
    CANCEL: "map-dialog/cancel"
};

exports.default = MapDialogActions;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isExcluded = exports.setExclusion = exports.toggleExclusion = exports.getPairedIdLO_unqualified = exports.getPairedIdLO = exports.setPairLO = exports.getPairLO = exports.ERR_MULTIPLE_MATCHES_FOUND = exports.ERR_NO_MATCH_FOUND = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(13);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _typedefs = __webpack_require__(44);

var _MappingActions = __webpack_require__(109);

var _MappingActions2 = _interopRequireDefault(_MappingActions);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _entities = __webpack_require__(311);

var _ContextedReduceStore = __webpack_require__(30);

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

var _DataManager = __webpack_require__(43);

var _DataManager2 = _interopRequireDefault(_DataManager);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _dotPropImmutable = __webpack_require__(40);

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

var _SearchResultActions = __webpack_require__(143);

var _SearchResultActions2 = _interopRequireDefault(_SearchResultActions);

var _SearchResultStore = __webpack_require__(159);

var _SearchResultStore2 = _interopRequireDefault(_SearchResultStore);

var _SuperRecordStore = __webpack_require__(36);

var _SuperRecordStore2 = _interopRequireDefault(_SuperRecordStore);

var _loadObjectOf = __webpack_require__(220);

var _loadObjectOf2 = _interopRequireDefault(_loadObjectOf);

var _MapButtonActions = __webpack_require__(141);

var _MapButtonActions2 = _interopRequireDefault(_MapButtonActions);

var _MapDialogActions = __webpack_require__(64);

var _MapDialogActions2 = _interopRequireDefault(_MapDialogActions);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _saveit = __webpack_require__(226);

var _safeDispatch = __webpack_require__(169);

var _safeDispatch2 = _interopRequireDefault(_safeDispatch);

var _MappingWorkflowVisitor = __webpack_require__(970);

var _MappingWorkflowVisitor2 = _interopRequireDefault(_MappingWorkflowVisitor);

var _SuperRecordListActions = __webpack_require__(140);

var _SuperRecordListActions2 = _interopRequireDefault(_SuperRecordListActions);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _MergeActions = __webpack_require__(59);

var _MergeActions2 = _interopRequireDefault(_MergeActions);

var _MergeStore = __webpack_require__(53);

var _MergeStore2 = _interopRequireDefault(_MergeStore);

var _mergeHelpers = __webpack_require__(232);

var _buildMergeExclusions = __webpack_require__(972);

var _OverStore = __webpack_require__(61);

var _MergeStore3 = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
I am NOT contexted, even though I operate w/in a contexted scope. This is due to
the fact that all mapping operations are modal, so there can never be more
than one active at a time. The context to operate within is supplied by the
initiating action
 */

var ENTIRE_FIELD = "__ENTIRE_FIELD";

var selectSource = function selectSource(state, source) {
    (0, _invariant2.default)(state.target, "Can't select a source w/o a target already selected");
    return _extends({}, state, {
        source: source,
        modelLO: _LoadObject2.default.loading(_DataManager2.default.loadMappingModel(_userStore2.default.getActiveOrgKey(), state.target.entityKey, source.entityKey))
    });
};

/**
 * I execute a callback on each id pair in the passed state. The callback will
 * be invoked with three arguments: a LoadObject containing a {id, key, global}
 * type, the source record id, and the entity-qualified field key of the field
 * it's for (e.g., "ob/1/episode.newborns").
 * @param state
 * @param callback
 */
var forEachIdPair = function forEachIdPair(state, callback) {
    if (!state.hasOwnProperty("idPairs")) return;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = Object.keys(state.idPairs)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var sid = _step.value;

            var fields = state.idPairs[sid];
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Object.keys(fields)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var rfk = _step2.value;

                    callback(fields[rfk], sid, rfk);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};

var mapIdPairs = function mapIdPairs(state, callback) {
    forEachIdPair(state, function (curr, sid, rfk) {
        var next = callback(curr, sid, rfk);
        if (curr !== next) {
            state = _dotPropImmutable2.default.set(state, ["idPairs", sid, rfk], next);
        }
    });
    return state;
};

var ERR_NO_MATCH_FOUND = exports.ERR_NO_MATCH_FOUND = "No matching records were found.";
var ERR_MULTIPLE_MATCHES_FOUND = exports.ERR_MULTIPLE_MATCHES_FOUND = "Multiple matching records were found.";

var doItAgain = function doItAgain(reason) {
    (0, _invariant2.default)(_Dispatcher2.default.isDispatching(), "doItAgain only makes sense during dispatch");
    (0, _safeDispatch2.default)({
        type: _MappingActions2.default.__DO_IT_AGAIN,
        reason: reason
    });
};

var _isReady = function _isReady(state) {
    // If there's no mapping active, I'm not ready
    if (!state.active) return false;

    // If there's no model loading, I'm not ready
    if (state.modelLO == null) return false;

    // If the model's loaded, I'm ready!
    return state.modelLO.hasValue();
};

var __workflow = function __workflow(state) {
    // If I'm not ready, do nothing
    if (!_isReady(state)) return state;

    // register the helper, if needed
    if (!state.interactive && state.helperToken == null) {
        state = _extends({}, state, {
            helperToken: _Dispatcher2.default.register(__workflow_helper)
        });
        doItAgain("registered workflow helper");
    }

    _Dispatcher2.default.waitFor([// todo: get this.dispatcher...
    _SearchResultStore2.default.getDispatchToken()]
    /*
     * I might need TableStore to process certain actions before I can do
     * my job, but generally it's exactly the reverse. So I'll just detect
     * when the order's backwards, and call doItAgain. This will
     * occasionally introduce a handful-of-milliseconds delay. But Flux is
     * well worth it, especially since it'll only be incurred in the face
     * of API requests which are much slower than that.
     */
    );

    var visitor = new _MappingWorkflowVisitor2.default(state).execute();
    state = visitor.getState();
    if (visitor.isDoItAgain()) {
        doItAgain(visitor.getDoItAgainReason());
    }

    // all we _really_ need to do is change state, but the counter is useful for
    // detecting/breaking infinite loops. :)
    return _extends({}, state, {
        _counter: (state._counter || 0) + 1
    });
};

var __workflow_helper = function __workflow_helper(action) {
    _Dispatcher2.default.waitFor([// todo: get this.dispatcher...
    _SuperRecordStore2.default.getDispatchToken(), _TableStore2.default.getDispatchToken(), rawStore.getDispatchToken()]);

    var state = rawStore.getState();
    var bail =  true ? function () {/* noop */} : function (fmt) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
        }

        // console.log itself supports format strings, but it doesn't expand
        // arrays when interpolating, so do it manually.
        args.unshift(state._counter);
        var argIndex = 0;
        console.log(("MAP(%s)> " + fmt).replace(/%s/g, function () {
            return args[argIndex++];
        }));
    };

    // If the workflow didn't run, ignore the action.
    if (!rawStore.hasChanged()) {
        return bail("Workflow didn't run");
    }

    // Prevent infinite loops in development.
    if (false) {
        (0, _invariant2.default)(state._counter < 50, "Mapping went through the workflow %s times?!", state._counter);
    }

    // If we're not active, something is very wrong.
    (0, _invariant2.default)(state.active, "Mapping workflow helper is wired with no active mapping?!");

    // If we're interactive, something is wrong.
    (0, _invariant2.default)(!state.interactive, "Mapping workflow helper is wired while interactive?!");

    // If TableStore changed, idPairs might be stale, so re-initiate and bail.
    if (_TableStore2.default.hasChanged()) {
        doItAgain("TableStore changed");
        return bail("TableStore changed");
    }

    // If TableStore is waiting for any lists, bail.
    if (_TableStore2.default.isWaiting()) {
        return bail("TableStore is waiting");
    }

    // If any idPairs are pending (load OR create!), bail and wait for them.
    var pendingOps = [];
    forEachIdPair(state, function (lo) {
        if (lo.hasOperation()) {
            pendingOps.push(lo.getOperation());
        }
    });
    if (pendingOps.length > 0) return bail("pending ops: %s", pendingOps);

    // Find any globals that need to be created.
    var toFlush = [];
    forEachIdPair(state, function (lo) {
        if (!lo.hasValue()) return;
        var t = lo.getValueEnforcing();
        if (t.global && _ClientId2.default.is(t.id)) toFlush.push(t);
    });

    // Sanity check that none are currently flushing...
    if (false) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = toFlush[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var g = _step3.value;

                var lo = _SuperRecordStore2.default.getRecordLO(g.key, g.id);
                if (!lo.isDone()) console.warn("SuperRecord and Mapping are out of sync regarding %s#%s.", g.key, g.id);
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }
    }

    // If any exist, flush one, bail, and wait for it.
    if (toFlush.length > 0) {
        var _g = toFlush.find(function (g) {
            return _StereotypesStore2.default.getStereotypeLO(g.key).isDone();
        });
        if (_g == null) {
            // every single one is waiting for stereotypes
            return bail("stereotype/%s loading", toFlush[0].key);
        }
        (0, _saveit.saveSuperRecord)(_g.key, _g.id, state.initiatingContext);
        return bail("flush %s#%s initiated", _g.key, _g.id);
    }

    // DONE!
    _Dispatcher2.default.unregister(state.helperToken);

    if (Array.isArray(state.queue) && state.queue.length) {
        // if state.queue.length ... but wait there is more to do!
        (0, _safeDispatch2.default)({
            type: _MappingActions2.default.__PROCESS_NEXT_IN_QUEUE
        });
        return bail("More items in the mapping queue to process.");
    }

    (0, _safeDispatch2.default)({
        type: _MappingActions2.default.IT_IS_DONE,
        trigger: action.type.toString(),
        initiatingContext: state.initiatingContext
    });
};

var getPairPath = function getPairPath(sourceId, targetRecordKey, targetFieldKey) {
    (0, _invariant2.default)(sourceId != null, "You must pass a non-null sourceId");
    (0, _invariant2.default)(targetRecordKey, "You must pass a non-null targetRecordKey");
    (0, _invariant2.default)(targetFieldKey, "You must pass a non-null targetFieldKey");
    var targetKey = targetRecordKey + "." + targetFieldKey;
    return ["idPairs", sourceId, targetKey];
};

// You probably don't want this one, but rather getPairedIdLO (below)
var getPairLO = exports.getPairLO = function getPairLO(state, sourceId, targetRecordKey, targetFieldKey) {
    return _dotPropImmutable2.default.get(state, getPairPath(sourceId, targetRecordKey, targetFieldKey)) || _LoadObject2.default.empty();
};

var setPairLO = exports.setPairLO = function setPairLO(state, sourceId, targetRecordKey, targetFieldKey, lo) {
    (0, _invariant2.default)(lo != null, "You must pass a non-null LoadObject");
    return _dotPropImmutable2.default.set(state, getPairPath(sourceId, targetRecordKey, targetFieldKey), lo);
};

var getPairedIdLO = exports.getPairedIdLO = function getPairedIdLO(state, sourceId, targetRecordKey, targetFieldKey) {
    return getPairLO(state, sourceId, targetRecordKey, targetFieldKey).map(function (v) {
        return v.id;
    });
};

/*
 * I return a "don't care where" paired id LO, and am questionable. While
 * idPairs are inherently bound to a location in the target tree (via the target
 * entity and field keys), this method ignores that information and acts as if
 * every source record maps onto exactly one target record. When that tenet is
 * violated, an exception will be raised, so it's up to calling code to decide
 * if it's safe to call or not (based on the mapping structure). Note that the
 * exception is raised on a "best effort" basis and should not be relied upon
 * for program correctness.
 */
var getPairedIdLO_unqualified = exports.getPairedIdLO_unqualified = function getPairedIdLO_unqualified(state, sourceId) {
    var obj = state.idPairs;
    if (obj == null) return _LoadObject2.default.empty();
    obj = obj[sourceId];
    if (obj == null) return _LoadObject2.default.empty();
    var keys = Object.keys(obj);
    if (keys.length === 0) return _LoadObject2.default.empty();
    if (keys.length === 1) return obj[keys[0]].map(function (v) {
        return v.id;
    });
    // if there are many, but they all give the same answer, that's good enough
    var ids = new Set(keys.map(function (k) {
        return obj[k].getValueEnforcing().id;
    }));
    if (ids.size === 1) {
        // thanks IE
        var theId = void 0;
        ids.forEach(function (id) {
            return theId = id;
        });
        return _LoadObject2.default.withValue(theId);
    }
    throw new Error("Ambiguous unqualified idPair query for " + sourceId);
};

function requireContext(action) {
    var fluxContext = action[_ContextedReduceStore.ACTION_CONTEXT_KEY];
    (0, _invariant2.default)(fluxContext, "mapping must be initiated w/ a contexted dispatch");
    return fluxContext;
}

var MappingStore = function (_ReduceStore) {
    _inherits(MappingStore, _ReduceStore);

    function MappingStore() {
        _classCallCheck(this, MappingStore);

        return _possibleConstructorReturn(this, (MappingStore.__proto__ || Object.getPrototypeOf(MappingStore)).call(this, _Dispatcher2.default));
    }

    _createClass(MappingStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {
                active: false
            };
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {

                case _MapButtonActions2.default.LAUNCH_DIALOG:
                    {
                        var fluxContext = requireContext(action);
                        var plugins = (0, _entities.getMappingPlugins)(action.target, fluxContext);
                        // start from scratch
                        return {
                            active: true,
                            initiatingContext: fluxContext,
                            interactive: true,
                            pluginKey: plugins[0].get("id"), // default to the first one
                            target: action.target,
                            drawerOpen: true,
                            exclusions: {}
                        };
                    }

                case _MapDialogActions2.default.SELECT_PLUGIN:
                    {
                        return _extends({}, state, {
                            pluginKey: action.key
                        });
                    }

                case _MapDialogActions2.default.SELECT_STEREOTYPE:
                    {
                        return _extends({}, state, {
                            selectedStereotype: action.selectedStereotype
                        });
                    }

                case _MapDialogActions2.default.SELECT_SOURCE:
                    {
                        return selectSource(state, action.source);
                    }

                case _MergeActions2.default.LAUNCH_DIALOG:
                    {
                        this.__dispatcher.waitFor([_MergeStore2.default.getDispatchToken()]);
                        var mergeState = _MergeStore2.default.getState();
                        if (mergeState.source != null) {
                            var nextState = (0, _mergeHelpers.buildMappingStateFromMergeState)(mergeState);
                            nextState.initiatingContext = requireContext(action);
                            nextState = __workflow(nextState);
                            nextState.exclusions = (0, _buildMergeExclusions.buildMergeExclusions)(nextState);
                            return nextState;
                        }
                        return state;
                    }

                case _MergeActions2.default.SELECT_SOURCE:
                    {
                        this.__dispatcher.waitFor([_MergeStore2.default.getDispatchToken()]);
                        var _nextState = __workflow((0, _mergeHelpers.buildMappingStateFromMergeState)(_MergeStore2.default.getState()));
                        _nextState.exclusions = (0, _buildMergeExclusions.buildMergeExclusions)(_nextState);
                        return _nextState;
                    }

                case _MergeActions2.default.DO_MERGE:
                    {
                        if (!(0, _OverStore.isConfirmed)(action)) return state;
                        this.__dispatcher.waitFor([_MergeStore2.default.getDispatchToken()]);
                        return __workflow(_extends({}, state, {
                            active: true,
                            initiatingContext: requireContext(action),
                            interactive: false
                        }));
                    }

                case _MapButtonActions2.default.AUTOMAP_FROM:
                    {
                        // start from scratch
                        return __workflow(selectSource({
                            active: true,
                            initiatingContext: requireContext(action),
                            target: action.target
                        }, action.source));
                    }

                case _MapButtonActions2.default.AUTOMAP_TO_NEW_MAGIC_CHILD:
                    {
                        this.__dispatcher.waitFor([_TableStore2.default.getDispatchToken()]);
                        // start from scratch
                        state = __workflow(selectSource({
                            active: true,
                            initiatingContext: requireContext(action),
                            target: _TableStore2.default.getEntityProxy(action.entityKey, action.newId)
                        }, action.source));
                        doItAgain("TableStore race w/ AUTOMAP_TO_NEW_MAGIC_CHILD");
                        return state;
                    }

                case _MappingActions2.default.MODEL_LOADED:
                    {
                        state = _extends({}, state, {
                            // don't maintain the promise...
                            modelLO: _LoadObject2.default.withValue(null)
                        });
                        if (state.interactive) {
                            state.drawerOpen = false;
                        }
                        return __workflow(state);
                    }

                case _MappingActions2.default.MODEL_LOAD_ERROR:
                    {
                        return _extends({}, state, {
                            // don't maintain the promise...
                            modelLO: _LoadObject2.default.withError(action.error)
                        });
                    }

                case _MapDialogActions2.default.TOGGLE_DRAWER:
                    {
                        return _extends({}, state, {
                            drawerOpen: !state.drawerOpen
                        });
                    }

                case _MapDialogActions2.default.TOGGLE_EXCLUSION:
                    {
                        return __workflow(toggleExclusion(state, action.recordId, action.columnKey, action.itemKey));
                    }

                case _MapDialogActions2.default.SET_MAGIC_ROOT_EXCLUSION:
                    {
                        var ei = _entityMetaStore2.default.getInfo(state.target.entityKey);
                        if (ei.magicRootPointerKey == null) {
                            // there's no MR...
                            console.warn("Magic root fields' exclusion was set, but there's no magic root?!");
                            return state;
                        }
                        var mr = state.target.get(ei.magicRootPointerKey);
                        var infos = _entityFieldMetaStore2.default.getAllInfos(mr.entityKey);
                        var _iteratorNormalCompletion4 = true;
                        var _didIteratorError4 = false;
                        var _iteratorError4 = undefined;

                        try {
                            for (var _iterator4 = infos[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                var i = _step4.value;

                                state = setExclusion(state, mr.id, i.logicalColumn, null, action.excluded);
                            }
                        } catch (err) {
                            _didIteratorError4 = true;
                            _iteratorError4 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                    _iterator4.return();
                                }
                            } finally {
                                if (_didIteratorError4) {
                                    throw _iteratorError4;
                                }
                            }
                        }

                        return __workflow(state);
                    }

                case _MapDialogActions2.default.IMPORT:
                    {
                        return __workflow(_extends({}, state, {
                            interactive: false
                        }));
                    }

                case _SearchResultActions2.default.SEARCH_RESULT:
                case _SuperRecordActions2.default.LOADED:
                case _SuperRecordListActions2.default.LOADED:
                    {
                        if (!state.active) return state;
                        return __workflow(state);
                    }

                case _SuperRecordActions2.default.START_CREATE:
                    {
                        if (!state.active) return state;
                        state = mapIdPairs(state, function (lo) {
                            if (!lo.hasValue()) return lo;
                            if (lo.getValueEnforcing().id !== action.id) return lo;
                            return lo.creating("garbage");
                        });
                        return state; // No need to run workflow
                    }

                case _SuperRecordActions2.default.CREATED:
                    {
                        if (!state.active) return state;
                        state = mapIdPairs(state, function (lo) {
                            if (!lo.hasValue()) return lo;
                            if (lo.getValueEnforcing().id !== action.id) return lo;
                            return lo.done().map(function (v) {
                                return _extends({}, v, {
                                    id: action.data.id
                                });
                            });
                        });
                        return __workflow(state);
                    }

                case _MappingActions2.default.__PROCESS_NEXT_IN_QUEUE:
                    {
                        if (!Array.isArray(state.queue)) {
                            throw Error("Mapping queue expected to be an array.");
                        }
                        if (!state.queue.length) {
                            throw Error("Mapping queue should have finished. Something went wrong with the queue.");
                        }
                        if (typeof state.processQueueCallback !== "function") {
                            throw Error("Mapping queue should have a processQueueCallback function to process the remaining queue.");
                        }
                        var newState = state.processQueueCallback(state);
                        newState._counter = 0; // reset the counter
                        return __workflow(newState);
                    }

                case _MappingActions2.default.__DO_IT_AGAIN:
                    {
                        return __workflow(state);
                    }

                case _MappingActions2.default.IT_IS_DONE:
                    {
                        return this.getInitialState();
                    }

                case _MergeActions2.default.CANCEL:
                case _MapDialogActions2.default.CANCEL:
                case _SuperRecordActions2.default.CANCEL_FOR_OPTLOCK:
                    {
                        this.__dispatcher.waitFor([_TableStore2.default.getDispatchToken()]);
                        return this.getInitialState();
                    }

                case _MergeActions2.default.CANCEL_FOR_SOURCE_OPTLOCK:
                    {
                        this.__dispatcher.waitFor([_MergeStore2.default.getDispatchToken()]);
                        return _extends({}, state, {
                            exclusions: {}
                        });
                    }

                case _SuperRecordActions2.default.UPDATE_ERROR:
                    {
                        if (!state.active) return state;
                        if (_MergeStore2.default.getPluginKey() !== _MergeStore3.MERGE_PLUGINS.GLOBAL_MERGE) return state;
                        // error happened during global merge
                        // reset the active state so they can try again.
                        return _extends({}, state, { active: false });
                    }

                default:
                    {
                        return state;
                    }
            }
        }
    }, {
        key: "isReady",
        value: function isReady() {
            return _isReady(this.getState());
        }
    }, {
        key: "isInteractive",
        value: function isInteractive() {
            var state = this.getState();
            (0, _invariant2.default)(state.active, "Asking about interactivity w/o an active mapping is forbidden.");
            return !!state.interactive;
        }
    }]);

    return MappingStore;
}(_utils.ReduceStore);

// these are NOT contextually aware - they only checks the state of this field,
// not any records/fields it is within.


var toggleExclusion = exports.toggleExclusion = function toggleExclusion(state, recordId, fieldKey, optionalItemKey) {
    return _dotPropImmutable2.default.set(state, ["exclusions", recordId, fieldKey, optionalItemKey || ENTIRE_FIELD], function (v) {
        return (typeof v === "undefined" ? "undefined" : _typeof(v)) === "object" ? true // it didn't exist
        : !v;
    } // reverse it
    );
};

var setExclusion = exports.setExclusion = function setExclusion(state, recordId, columnKey, optionalItemKey, value) {
    var curr = isExcluded(state, recordId, columnKey, optionalItemKey);
    if (value && curr) return state;
    if (!value && !curr) return state;
    return toggleExclusion(state, recordId, columnKey, optionalItemKey);
};

var isExcluded = exports.isExcluded = function isExcluded(state, recordId, columnKey, optionalItemKey) {
    var es = _dotPropImmutable2.default.get(state, ["exclusions", recordId, columnKey, optionalItemKey || ENTIRE_FIELD]);
    return es == null ? false : es;
};

MappingStore.stateTypes = {
    active: _propTypes2.default.bool,
    initiatingContext: _propTypes2.default.string,
    interactive: _propTypes2.default.bool,
    pluginKey: _propTypes2.default.string,
    target: _propTypes2.default.instanceOf(_EntityProxy2.default),
    source: _propTypes2.default.instanceOf(_EntityProxy2.default),
    modelLO: (0, _loadObjectOf2.default)(_propTypes2.default.any), // only want the LO, not the value
    drawerOpen: _propTypes2.default.bool,
    exclusions: _propTypes2.default.objectOf( // record id (target)
    _propTypes2.default.objectOf( // field key
    _propTypes2.default.objectOf( // target item ID or ENTIRE_FIELD
    _propTypes2.default.bool // flag
    ))),
    idPairs: _propTypes2.default.objectOf( // record id (source)
    _propTypes2.default.objectOf( // entity- (compositions) or record- (associations) qualified field key (target)
    (0, _loadObjectOf2.default)(_propTypes2.default.shape({
        key: _EntityName2.default.propType.isRequired,
        id: _typedefs.recordIdType.isRequired,
        global: _propTypes2.default.bool
    })))),
    // internal
    helperToken: _propTypes2.default.string,
    queue: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        target: _propTypes2.default.instanceOf(_EntityProxy2.default),
        source: _propTypes2.default.instanceOf(_EntityProxy2.default)
    })),
    processQueueCallback: _propTypes2.default.func,
    _counter: _propTypes2.default.number
};

var rawStore = new MappingStore();
exports.default = (0, _typeCheckingStore2.default)(rawStore);

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.registerForm = registerForm;

var _AccActionExportForm = __webpack_require__(950);

var _AccActionExportForm2 = _interopRequireDefault(_AccActionExportForm);

var _AccAFibExportForm = __webpack_require__(951);

var _AccAFibExportForm2 = _interopRequireDefault(_AccAFibExportForm);

var _AccCathPciExportForm = __webpack_require__(952);

var _AccCathPciExportForm2 = _interopRequireDefault(_AccCathPciExportForm);

var _AccIcdExportForm = __webpack_require__(953);

var _AccIcdExportForm2 = _interopRequireDefault(_AccIcdExportForm);

var _AccImpactExportForm = __webpack_require__(954);

var _AccImpactExportForm2 = _interopRequireDefault(_AccImpactExportForm);

var _AccPVIExportForm = __webpack_require__(955);

var _AccPVIExportForm2 = _interopRequireDefault(_AccPVIExportForm);

var _AdultCardiacExportForm = __webpack_require__(956);

var _AdultCardiacExportForm2 = _interopRequireDefault(_AdultCardiacExportForm);

var _AdultCardiacHarvestForm = __webpack_require__(958);

var _AdultCardiacHarvestForm2 = _interopRequireDefault(_AdultCardiacHarvestForm);

var _CongenitalExportForm = __webpack_require__(959);

var _CongenitalExportForm2 = _interopRequireDefault(_CongenitalExportForm);

var _CongenitalHarvestForm = __webpack_require__(960);

var _CongenitalHarvestForm2 = _interopRequireDefault(_CongenitalHarvestForm);

var _GenericXmlExportForm = __webpack_require__(961);

var _GenericXmlExportForm2 = _interopRequireDefault(_GenericXmlExportForm);

var _StsAccTvtExportForm = __webpack_require__(979);

var _StsAccTvtExportForm2 = _interopRequireDefault(_StsAccTvtExportForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formRegistry = {
    "acc-action-export": _AccActionExportForm2.default,
    "acc-afib-export": _AccAFibExportForm2.default,
    "acc-cathpci-export": _AccCathPciExportForm2.default,
    "acc-icd-export": _AccIcdExportForm2.default,
    "acc-impact-export": _AccImpactExportForm2.default,
    "acc-pvi-export": _AccPVIExportForm2.default,
    "adult-cardiac-export": _AdultCardiacExportForm2.default,
    "adult-cardiac-harvest": _AdultCardiacHarvestForm2.default,
    "congenital-export": _CongenitalExportForm2.default,
    "congenital-harvest": _CongenitalHarvestForm2.default,
    "generic-xml": _GenericXmlExportForm2.default,
    "sts-acc-tvt-export": _StsAccTvtExportForm2.default
};

function registerForm(key, formComponent) {
    formRegistry[key] = formComponent;
}

exports.default = formRegistry;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SearchFormActions = {
    DEEP_LINKED_SEARCH: "search-form/deep-linked-search",
    INITIALIZE_CONTEXT: "search-form/initialize-context",
    INITIATE_SEARCH: "search-form/initiate-search",
    INITIATE_SEARCH_AND_SAVE_DEFAULT: "search-form/initiate-search-and-save-default",
    RESTORE_DEFAULT_AND_INITIATE_SEARCH: "search-form/restore-default-and-initiate-search",
    SELECT_STEREOTYPE: "search-form/select-stereotype",
    CLEAR_FIELDS: "search-form/clear-fields",
    SET_FIELD: "search-form/set-field",
    SET_USE_RELATIVE_DATES: "search-form/set-use-relative-dates",
    SORT: "search-form/sort",
    SELECT_PAGE: "search-form/select-page",
    SET_PAGE_SIZE: "search-form/set-page-size",
    SELECT_RESULT: "search-form/select-result"
};

exports.default = SearchFormActions;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BaseServices = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _HybridConfig = __webpack_require__(41);

var _HybridConfig2 = _interopRequireDefault(_HybridConfig);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _OverActions = __webpack_require__(122);

var _OverActions2 = _interopRequireDefault(_OverActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CSRF_PARAM = "_csrf";
var CSRF_HEADER = "X-CSRF-TOKEN";

var noCacheToken = new Date().valueOf();

var addNoCacheToken = function addNoCacheToken(url) {
    return url + (url.indexOf("?") < 0 ? "?" : "&") + "_=" + ++noCacheToken;
};

var addNoCacheHeaders = function addNoCacheHeaders(jqXHR) {
    jqXHR.setRequestHeader("Cache-Control", "no-cache");
    jqXHR.setRequestHeader("Pragma", "no-cache");
};

var BaseServices = exports.BaseServices = function () {
    function BaseServices(dispatcher) {
        _classCallCheck(this, BaseServices);

        this.ajaxSendHandler = this.ajaxSendHandler.bind(this);
        this.ajaxErrorHandler = this.ajaxErrorHandler.bind(this);
        this.ajaxSuccessHandler = this.ajaxSuccessHandler.bind(this);
        this.navigateToAuthUrl = this.navigateToAuthUrl.bind(this);
        this.authUrl = this.authUrl.bind(this);
        this.ensureSession = this.ensureSession.bind(this);
        this.endSession = this.endSession.bind(this);
        this.url = this.url.bind(this);
        this.rawPost = this.rawPost.bind(this);
        this.jsonPost = this.jsonPost.bind(this);
        this.getRequest = this.getRequest.bind(this);

        this.__dispatcher = dispatcher;
        this.root_url = _HybridConfig2.default.get("apiRoot", "v2/");
        this.csrfToken = null;
        this.cacheToken = new Date().valueOf();
        this.lastSuccess = null;
        this.reauthInFlight = false;
        this.metaPrefix = this.url("meta/");

        $(document).ajaxSend(this.ajaxSendHandler).ajaxError(this.ajaxErrorHandler).ajaxSuccess(this.ajaxSuccessHandler);
        $(window).bind("beforeunload", function () {
            $(document).unbind("ajaxSend");
            $(document).unbind("ajaxError");
            $(document).unbind("ajaxSuccess");
        });
    }

    _createClass(BaseServices, [{
        key: "ajaxSendHandler",
        value: function ajaxSendHandler(e, jqXHR, ajaxSettings) {
            if (ajaxSettings.ignoreFailure) {
                jqXHR.__ignore_ajax_failure = true;
            }
            // cache-bust GETs for non-metamodel JSON
            if (ajaxSettings.type === "GET" && ajaxSettings.dataType === "json" && ajaxSettings.url.indexOf(this.metaPrefix) < 0) {
                addNoCacheHeaders(jqXHR);
                ajaxSettings.url = addNoCacheToken(ajaxSettings.url);
            }
            if (this.csrfToken && !/^(GET|HEAD|TRACE|OPTIONS)$/i.test(ajaxSettings.type)) {
                jqXHR.setRequestHeader(CSRF_HEADER, this.csrfToken);
            }
        }
    }, {
        key: "ajaxErrorHandler",
        value: function ajaxErrorHandler(e, jqXHR, ajaxSettings, thrownError) {
            if (jqXHR.status === 0 && thrownError === "abort") return; // don't care about aborts
            var log = function log(detail) {
                var message = "Received " + jqXHR.status + " for '" + ajaxSettings.type + " " + ajaxSettings.url + "'";
                if (detail) {
                    message += "; " + detail;
                }
                console.warn(message);
            };
            if (jqXHR.status === 401) {
                log(this.reauthInFlight ? "reauth already in flight" : "ask user about reauth");
                this.__dispatcher.dispatch({
                    type: _OverActions2.default.HTTP_UNAUTHORIZED
                });
            } else if (ajaxSettings.background) {
                log("[in background]");
            } else if (jqXHR.status === 403) {
                log();
                this.__dispatcher.dispatch({
                    type: _OverActions2.default.HTTP_FORBIDDEN
                });
            } else if (jqXHR.status === 404) {
                log();
                this.__dispatcher.dispatch({
                    type: _OverActions2.default.HTTP_NOT_FOUND
                });
            } else if (jqXHR.status === 0) {
                if (navigator.onLine) {
                    log("browser online; checking 'empty.json'...");
                    this.__dispatcher.dispatch({
                        type: _OverActions2.default.ARMUS_UNREACHABLE
                    });
                    jQuery.ajax({
                        url: "empty.json", // not API relative!
                        global: false,
                        timeout: 3000, // don't wait too long, but allow for "slow"
                        beforeSend: addNoCacheHeaders
                    }).then(function () {
                        return log("API dead ('empty.json' is fine)");
                    }, function (jqXHR) {
                        return log("ARMUS unreachable ('empty.json' failed w/ " + jqXHR.status + ")");
                    });
                } else {
                    log("browser offline");
                    this.__dispatcher.dispatch({
                        type: _OverActions2.default.BROWSER_OFFLINE
                    });
                }
            } else {
                log();
            }
        }
    }, {
        key: "ajaxSuccessHandler",
        value: function ajaxSuccessHandler(e, jqXHR, ajaxSettings, data) {
            this.lastSuccess = new Date();
            var token = jqXHR.getResponseHeader(CSRF_HEADER);
            if (token) {
                this.csrfToken = token;
            }
        }
    }, {
        key: "navigateToAuthUrl",
        value: function navigateToAuthUrl() {
            this.reauthInFlight = true;
            window.location.replace(this.authUrl());
        }
    }, {
        key: "getLastSuccess",
        value: function getLastSuccess() {
            return this.lastSuccess;
        }
    }, {
        key: "authUrl",
        value: function authUrl() {
            return this.url(addNoCacheToken("auth.html" + window.location.search));
        }
    }, {
        key: "ensureSession",
        value: function ensureSession() {
            return $.ajax({
                type: "GET",
                url: this.url(""),
                dataType: "text",
                background: true
            });
        }

        /*
        This is just _daft_ because of the intersection between the UR un-auth flow,
        CSRF protection, CORS config, and XHR limitations. The important parts are
        that XHR can't be prevented from following redirects, but we can't redirect
        to the UR because of it's CORS, and we can't use a GET because of CSRF. Thus
        we use a magic form which is embedded in the logout link to do a normal form
        POST at the page level to get it done.
         The logout form is provided by AppLayout's template in-DOM, so that it can
        be populated and submitted programmatically here.
        */

    }, {
        key: "endSession",
        value: function endSession() {
            $("#logout-form").find("input").attr("name", CSRF_PARAM).val(this.csrfToken).end().attr("method", "post").attr("action", this.url("j_spring_security_logout")).submit();
        }
    }, {
        key: "url",
        value: function url(path) {
            if (_.isArray(path)) {
                // strip any leading or trailing slashes before joining
                path = path.map(function (s) {
                    if (typeof s !== "string") return s;
                    while (s.charAt(0) === "/") {
                        s = s.substr(1);
                    }
                    while (s.charAt(s.length - 1) === "/") {
                        s = s.substr(0, s.length - 1);
                    }
                    return s;
                }).join("/");
            }

            return this.root_url + path;
        }

        // URL can be either a string or an array. We will prefix the root_url via @url function here.

    }, {
        key: "rawPost",
        value: function rawPost(url, data, settings) {
            if (data == null) {
                data = {};
            }
            url = this.url(url);
            return $.ajax(_extends({
                type: "POST",
                url: url,
                data: data
            }, settings));
        }
    }, {
        key: "jsonPost",
        value: function jsonPost(url, data, settings) {
            return this.rawPost(url, {}, _extends({
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(data)
            }, settings));
        }

        // URL can be either a string or an array. We will prefix the root_url via @url function here.

    }, {
        key: "getRequest",
        value: function getRequest(url, data, settings) {
            return this.rawPost(url, data, _extends({
                type: "GET",
                dataType: "json"
            }, settings));
        }
    }]);

    return BaseServices;
}();

exports.default = new BaseServices(_Dispatcher2.default);

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dotPropImmutable = __webpack_require__(40);

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

var _TableColumnMetaStore = __webpack_require__(125);

var _TableColumnMetaStore2 = _interopRequireDefault(_TableColumnMetaStore);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _options = __webpack_require__(156);

var _hydration = __webpack_require__(304);

var _TableProxy = __webpack_require__(222);

var _TableProxy2 = _interopRequireDefault(_TableProxy);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _SuperRecordListStore = __webpack_require__(155);

var _SuperRecordListStore2 = _interopRequireDefault(_SuperRecordListStore);

var _cleanValue = __webpack_require__(963);

var _cleanValue2 = _interopRequireDefault(_cleanValue);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _StereotypeProxy = __webpack_require__(305);

var _StereotypeProxy2 = _interopRequireDefault(_StereotypeProxy);

var _parseId = __webpack_require__(479);

var _parseId2 = _interopRequireDefault(_parseId);

var _asArray = __webpack_require__(157);

var _asArray2 = _interopRequireDefault(_asArray);

var _TableMetaStore = __webpack_require__(478);

var _TableMetaStore2 = _interopRequireDefault(_TableMetaStore);

var _uniqueFilterBuilder = __webpack_require__(480);

var _uniqueFilterBuilder2 = _interopRequireDefault(_uniqueFilterBuilder);

var _stereotypes = __webpack_require__(126);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function areEqual(curr, next) {
    if (curr === next) return true;
    var isCurrArray = Array.isArray(curr);
    var isNextArray = Array.isArray(next);
    if (curr == null || next == null) {
        // if either one is null, use a coercive check. If coercion fixes it
        // that means one's null and one's undefined or something, which is
        // equal for our purposes.
        // noinspection EqualityComparisonWithCoercionJS
        if (curr == next) return true;
        // we also consider an empty array to be equal to null, following
        // Hibernate's "null/empty" semantics (for parity across the wire).
        if (next == null && isCurrArray && curr.length === 0) return true;
        if (curr == null && isNextArray && next.length === 0) return true;
    }
    if (isCurrArray && isNextArray && curr.length === next.length) {
        // only consider simple values in arrays (i.e., not deep equals).
        return curr.every(function (it, i) {
            return it === next[i];
        });
    } else if (moment.isMoment(curr) && moment.isMoment(next)) {
        // if Moment's have the same value and timezone, consider them equal.
        // the `Moment.isSame` method is too new for us to use.
        return curr.valueOf() === next.valueOf() && curr.zone() === next.zone();
    }
    return false;
}

function updateIfNeeded(state, path, valueOrMutator) {
    var curr = _dotPropImmutable2.default.get(state, path);
    var next = typeof valueOrMutator === "function" ? valueOrMutator(curr) : valueOrMutator;
    return areEqual(curr, next) ? state : _dotPropImmutable2.default.set(state, path, next);
}

function chaseDownstream(entityProxies, downstream) {
    var currs = entityProxies;
    var parts = downstream.split(".");
    var targetColumnKey = parts.pop();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var p = _step.value;

            var nexts = [];
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = currs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var c = _step2.value;

                    if (!c.frontsColumnWithKey(p)) {
                        continue;
                    }
                    var v = c.getColumnByKey(p);
                    if (v instanceof Array) {
                        nexts.push.apply(nexts, _toConsumableArray(v));
                    } else if (v != null) {
                        nexts.push(v);
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            currs = nexts;
            if (currs.length === 0) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return [currs.filter(function (it) {
        return it.frontsColumnWithKey(targetColumnKey);
    }).filter((0, _uniqueFilterBuilder2.default)(function (it) {
        return it.getKey();
    })), targetColumnKey];
}

function buildFieldInfosByColumn(entityInfos) {
    var optionalFieldFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var fieldInfosByColumn = {};
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = entityInfos[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var ei = _step3.value;
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = _entityFieldMetaStore2.default.getAllInfos(ei.key, optionalFieldFilter)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var f = _step4.value;

                    if (fieldInfosByColumn.hasOwnProperty(f.logicalColumn)) {
                        fieldInfosByColumn[f.logicalColumn].push(f);
                    } else {
                        fieldInfosByColumn[f.logicalColumn] = [f];
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    return fieldInfosByColumn;
}

/*
 * I wrap up all the voodoo around a single record mutating action into a nice
 * stateful piece which is testable without Flux, and simplifies the Store(s)
 * it's needed in.
 *
 * In particular, pay careful attention to colName vs colKey (and their
 * shorthands cn and ck). Because of the way jsmodel works, most column-level
 * operations use names not keys, but it's not quite 100%.
 *
 * Many methods accepting a key (table, entity, field, etc.) will take an info
 * object as well. If you try and it doesn't work, consider adding the
 * capability to the method, rather than changing the callsite to dereference
 * the key.
 */

var TableAccess = function () {
    function TableAccess(state, readOnly) {
        _classCallCheck(this, TableAccess);

        if (!state) {
            throw new TypeError("TableAccess requires non-null state");
        }
        this.state = state;
        this.readOnly = !!readOnly;
        // Because automanagement will always end up changing a field that has
        // the auto-managed collection as a downstream, we have to break cycles.
        // This queue is how we do it.
        this.inFlightAutomanagement = new Set();
    }

    _createClass(TableAccess, [{
        key: "_ensureWriteable",
        value: function _ensureWriteable() {
            if (!this.readOnly) return;
            throw new Error("This TableAccess does not support mutation");
        }

        // direct-access methods
        // these are the _only_ methods allows to touch `this.state` in any way

    }, {
        key: "getState",
        value: function getState() {
            return this.state;
        }
    }, {
        key: "hasRecord",
        value: function hasRecord(tableKey, id) {
            var tables = this.state.tables;
            return tables.hasOwnProperty(tableKey) && tables[tableKey].hasOwnProperty(id);
        }
    }, {
        key: "hasEntityRecord",
        value: function hasEntityRecord(entityKey, id) {
            var ei = _entityMetaStore2.default.getInfo(entityKey);
            return this.hasRecord(ei.tableKey, id);
        }
    }, {
        key: "getRecordData",
        value: function getRecordData(tableKey, id) {
            if (!this.hasRecord(tableKey, id)) {
                console.warn("Data requested for non-existant record", tableKey, id);
                return null;
            }
            return this.state.tables[tableKey][id];
        }
    }, {
        key: "getAllRecords",
        value: function getAllRecords(tableKey) {
            // todo: gross. don't do this. index it for callsites to use
            var tables = this.state.tables;
            if (!tables.hasOwnProperty(tableKey)) {
                // This isn't a problem. It's reasonable to request all top-level
                // records before any have been created, for example. But it's weird
                // enough that seeing a trace during dev is useful
                if (false) {
                    console.warn("Records requested for non-existent '" + tableKey + "' table");
                }
                return [];
            }
            return Object.values(tables[tableKey]);
        }
    }, {
        key: "_setRecord",
        value: function _setRecord(tableKey, id, fullRecord) {
            this._ensureWriteable();
            this.state = _dotPropImmutable2.default.set(this.state, ["tables", tableKey, id], fullRecord);
        }

        // really "ensure column has value", and returns whether a change was made

    }, {
        key: "_setColumn",
        value: function _setColumn(tableKey, id, colName, valueOrMutator) {
            this._ensureWriteable();
            var path = ["tables", tableKey, id, "data", colName];
            var prev = this.state;
            this.state = updateIfNeeded(prev, path, valueOrMutator);
            return this.state !== prev;
        }
    }, {
        key: "_getColumn",
        value: function _getColumn(tableKey, id, colName) {
            return _dotPropImmutable2.default.get(this.state, ["tables", tableKey, id, "data", colName]);
        }
    }, {
        key: "_deleteRecord",
        value: function _deleteRecord(tableKey, id) {
            this._ensureWriteable();
            this.state = _dotPropImmutable2.default.delete(this.state, ["tables", tableKey, id]);
        }
    }, {
        key: "_enqueueListHandler",
        value: function _enqueueListHandler(entityKey, handler) {
            this._ensureWriteable();
            this.state = _dotPropImmutable2.default.set(this.state, ["listQueue", entityKey], function (v) {
                v = v instanceof Array ? v.slice() : [];
                v.push(handler);
                return v;
            });
        }
    }, {
        key: "_dequeueListHandlers",
        value: function _dequeueListHandlers(entityKey) {
            this._ensureWriteable();
            var queue = this.state.listQueue;
            var handlers = queue[entityKey];
            if (handlers != null) {
                this.state = _dotPropImmutable2.default.delete(this.state, ["listQueue", entityKey]);
            }
            return handlers || [];
        }

        // end direct access methods

    }, {
        key: "getColumnData",
        value: function getColumnData(tableKey, id, colName) {
            var r = this.getRecordData(tableKey, id);
            if (r == null) return null;
            if (false) {
                if (!r.data.hasOwnProperty(colName)) {
                    console.warn("Column data requested for unknown column", tableKey, id, colName);
                }
            }
            return r.data[colName];
        }
    }, {
        key: "getEntityProxy",
        value: function getEntityProxy(entityKey, id) {
            var info = _entityMetaStore2.default.getInfo(entityKey);
            return new _EntityProxy2.default(this, info, id);
        }
    }, {
        key: "getStereotypeProxy",
        value: function getStereotypeProxy(stereoKey, id) {
            var info = _StereotypesStore2.default.getStereotypeByKey(stereoKey);
            return new _StereotypeProxy2.default(this, info, id);
        }
    }, {
        key: "loadRecordData",
        value: function loadRecordData(tableKey, id, meta, data) {
            this._setRecord(tableKey, id, {
                meta: _extends({}, meta, {
                    id: id,
                    waiting: false
                }),
                data: data
            });
            return this;
        }
    }, {
        key: "loadSuperRecordPacket",
        value: function loadSuperRecordPacket(packet) {
            var ofEntityKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            // load all the data in
            var idsPerTable = {};
            var allIds = new Set();
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = Object.keys(packet.tables)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var tableKey = _step5.value;

                    var rs = packet.tables[tableKey];
                    idsPerTable[tableKey] = [];
                    var _iteratorNormalCompletion8 = true;
                    var _didIteratorError8 = false;
                    var _iteratorError8 = undefined;

                    try {
                        for (var _iterator8 = Object.keys(rs)[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                            var idString = _step8.value;

                            var id = (0, _parseId2.default)(idString);
                            idsPerTable[tableKey].push(id);
                            allIds.add(id);
                        }
                    } catch (err) {
                        _didIteratorError8 = true;
                        _iteratorError8 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                _iterator8.return();
                            }
                        } finally {
                            if (_didIteratorError8) {
                                throw _iteratorError8;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = Object.keys(packet.tables)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var _tableKey = _step6.value;

                    var rs = packet.tables[_tableKey];
                    var _iteratorNormalCompletion9 = true;
                    var _didIteratorError9 = false;
                    var _iteratorError9 = undefined;

                    try {
                        for (var _iterator9 = Object.keys(rs)[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                            var _idString = _step9.value;

                            var _id2 = (0, _parseId2.default)(_idString);
                            var data = _extends({}, rs[_id2]);
                            var ts = data._ts;
                            var cts = data._cts;
                            delete data._id;
                            delete data._ts;
                            delete data._cts;
                            var colInfos = _TableColumnMetaStore2.default.getAllColumnsByName(_tableKey);
                            // cull any bad assoc FKs
                            var _iteratorNormalCompletion10 = true;
                            var _didIteratorError10 = false;
                            var _iteratorError10 = undefined;

                            try {
                                for (var _iterator10 = Object.keys(colInfos)[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                                    var n = _step10.value;

                                    if (colInfos[n].type !== "ASSOCIATION") continue;
                                    if (data[n] == null) continue;
                                    if (_.isArray(data[n])) {
                                        data[n] = data[n].filter(function (it) {
                                            return allIds.has(it);
                                        });
                                    } else if (!allIds.has(data[n])) {
                                        data[n] = null;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError10 = true;
                                _iteratorError10 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion10 && _iterator10.return) {
                                        _iterator10.return();
                                    }
                                } finally {
                                    if (_didIteratorError10) {
                                        throw _iteratorError10;
                                    }
                                }
                            }

                            this.loadRecordData(_tableKey, _id2, { ts: ts, cts: cts }, (0, _hydration.rehydrate)(data, _tableKey, false, colInfos));
                        }
                    } catch (err) {
                        _didIteratorError9 = true;
                        _iteratorError9 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion9 && _iterator9.return) {
                                _iterator9.return();
                            }
                        } finally {
                            if (_didIteratorError9) {
                                throw _iteratorError9;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }

            var newIdMirror = {};
            if (packet.newIds) {
                Object.keys(packet.newIds).forEach(function (oid) {
                    return newIdMirror[packet.newIds[oid]] = oid;
                });
            }
            // initialize all the records
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
                for (var _iterator7 = Object.keys(idsPerTable)[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var _tableKey2 = _step7.value;

                    var writable = _TableMetaStore2.default.canWrite(_tableKey2);
                    var _iteratorNormalCompletion11 = true;
                    var _didIteratorError11 = false;
                    var _iteratorError11 = undefined;

                    try {
                        for (var _iterator11 = idsPerTable[_tableKey2][Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                            var _id3 = _step11.value;

                            if (newIdMirror.hasOwnProperty(_id3) && this.hasRecord(_tableKey2, newIdMirror[_id3])) {
                                this._deleteRecord(_tableKey2, newIdMirror[_id3]);
                            }
                            if (writable && this.hasRecord(_tableKey2, _id3)) {
                                this.initializeTableRecord(_tableKey2, _id3, ofEntityKey, ofEntityKey != null);
                            }
                        }
                    } catch (err) {
                        _didIteratorError11 = true;
                        _iteratorError11 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion11 && _iterator11.return) {
                                _iterator11.return();
                            }
                        } finally {
                            if (_didIteratorError11) {
                                throw _iteratorError11;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                        _iterator7.return();
                    }
                } finally {
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }

            return this;
        }
    }, {
        key: "initializeTableRecord",
        value: function initializeTableRecord(tableKey, id) {
            var ofEntityKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var filterEntityInfos = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            // first derivations
            var allCols = _TableColumnMetaStore2.default.getAllColumnsByName(tableKey);
            var proxy = new _TableProxy2.default(this, tableKey, id, true);
            var _iteratorNormalCompletion12 = true;
            var _didIteratorError12 = false;
            var _iteratorError12 = undefined;

            try {
                for (var _iterator12 = Object.keys(allCols)[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                    var n = _step12.value;

                    var info = allCols[n];
                    var d = info.derivation;
                    if (d == null) continue;
                    if (d.sourceKey == null && proxy.getColumn(info.key) != null) {
                        // has a value already, skip it
                        continue;
                    }
                    this._doDerivation(proxy, d);
                }

                // now do entity stuff....
            } catch (err) {
                _didIteratorError12 = true;
                _iteratorError12 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion12 && _iterator12.return) {
                        _iterator12.return();
                    }
                } finally {
                    if (_didIteratorError12) {
                        throw _iteratorError12;
                    }
                }
            }

            var isNew = _ClientId2.default.is(id);
            var entityInfos = _entityMetaStore2.default.getInfosForLogicalTable(tableKey, filterEntityInfos === true ? ofEntityKey : null);
            if (ofEntityKey != null) {
                entityInfos.sort(function (a, b) {
                    if (a.key === ofEntityKey) return -1;
                    if (b.key === ofEntityKey) return +1;
                    return 0;
                });
            }

            // recalcs
            // todo: materialize this index
            var recalcsByColumn = buildFieldInfosByColumn(entityInfos, _EntityProxy.hasRecalcScript);
            if (isNew) {
                // all of them!
                var _iteratorNormalCompletion13 = true;
                var _didIteratorError13 = false;
                var _iteratorError13 = undefined;

                try {
                    for (var _iterator13 = Object.keys(recalcsByColumn)[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                        var colName = _step13.value;

                        this.recalculateTableRecordColumn(tableKey, id, colName, recalcsByColumn[colName]);
                    }
                } catch (err) {
                    _didIteratorError13 = true;
                    _iteratorError13 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion13 && _iterator13.return) {
                            _iterator13.return();
                        }
                    } finally {
                        if (_didIteratorError13) {
                            throw _iteratorError13;
                        }
                    }
                }
            } else {
                // only updateable, non-null ones
                var _iteratorNormalCompletion14 = true;
                var _didIteratorError14 = false;
                var _iteratorError14 = undefined;

                try {
                    for (var _iterator14 = Object.keys(recalcsByColumn)[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                        var _colName = _step14.value;

                        var v = this.getColumnData(tableKey, id, _colName);
                        if (v != null && (!(v instanceof Array) || v.length !== 0)) {
                            continue;
                        }
                        var infos = recalcsByColumn[_colName];
                        if (infos.some(function (f) {
                            return f.nonUpdateable;
                        })) continue;
                        this.recalculateTableRecordColumn(tableKey, id, _colName, infos);
                    }
                } catch (err) {
                    _didIteratorError14 = true;
                    _iteratorError14 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion14 && _iterator14.return) {
                            _iterator14.return();
                        }
                    } finally {
                        if (_didIteratorError14) {
                            throw _iteratorError14;
                        }
                    }
                }
            }

            // auto-management
            // todo: materialize this index
            var autoManageByColumn = buildFieldInfosByColumn(entityInfos, _EntityProxy.isAutoManaged);
            if (Object.keys(autoManageByColumn).length > 0) {
                // const lo = SuperRecordListStore.getList()
                var _iteratorNormalCompletion15 = true;
                var _didIteratorError15 = false;
                var _iteratorError15 = undefined;

                try {
                    for (var _iterator15 = Object.values(autoManageByColumn)[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                        var fis = _step15.value;
                        var _iteratorNormalCompletion16 = true;
                        var _didIteratorError16 = false;
                        var _iteratorError16 = undefined;

                        try {
                            for (var _iterator16 = fis[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
                                var fi = _step16.value;

                                this._requestAutoManagement(tableKey, id, fi);
                            }
                        } catch (err) {
                            _didIteratorError16 = true;
                            _iteratorError16 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion16 && _iterator16.return) {
                                    _iterator16.return();
                                }
                            } finally {
                                if (_didIteratorError16) {
                                    throw _iteratorError16;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError15 = true;
                    _iteratorError15 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion15 && _iterator15.return) {
                            _iterator15.return();
                        }
                    } finally {
                        if (_didIteratorError15) {
                            throw _iteratorError15;
                        }
                    }
                }
            }

            return this;
        }
    }, {
        key: "_requestAutoManagement",
        value: function _requestAutoManagement(tableKey, id, fieldInfo) {
            if (fieldInfo.autoManageKey == null) throw new Error(fieldInfo.key + " isn't auto-managed");
            var mfi = _entityFieldMetaStore2.default.getInfo(fieldInfo.otherEntityKey, fieldInfo.autoManageKey);
            var lo = _SuperRecordListStore2.default.getListLO(mfi.otherEntityKey);
            if (lo.hasValue()) {
                this._doAutoManagement(tableKey, id, fieldInfo, mfi, lo.getRequiredValue());
            } else {
                this._enqueueListHandler(mfi.otherEntityKey, function (access, ids) {
                    if (access.hasRecord(tableKey, id)) {
                        access._doAutoManagement(tableKey, id, fieldInfo, mfi, ids);
                    }
                });
            }
        }
    }, {
        key: "processListQueue",
        value: function processListQueue(entityKey, ids) {
            var _iteratorNormalCompletion17 = true;
            var _didIteratorError17 = false;
            var _iteratorError17 = undefined;

            try {
                for (var _iterator17 = this._dequeueListHandlers(entityKey)[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
                    var h = _step17.value;

                    h(this, ids);
                }
            } catch (err) {
                _didIteratorError17 = true;
                _iteratorError17 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion17 && _iterator17.return) {
                        _iterator17.return();
                    }
                } finally {
                    if (_didIteratorError17) {
                        throw _iteratorError17;
                    }
                }
            }
        }
    }, {
        key: "_buildEnableState",
        value: function _buildEnableState(tableKey, id, downstreams) {
            var result = {
                // table#id#colKey: enabled
            };
            this._forEachDownstream(tableKey, id, downstreams, function (entityProxies, colKey) {
                if (entityProxies.length === 0) return; // nothing to do
                _entityFieldMetaStore2.default.getInfosForColumnKey(entityProxies.map(function (p) {
                    return p.entityKey;
                }), colKey).filter(function (it) {
                    return (0, _EntityProxy.hasEnableScript)(it);
                }).flatMap(function (fieldInfo) {
                    return entityProxies.filter(function (ep) {
                        return ep.entityKey === fieldInfo.entityKey;
                    }).map(function (ep) {
                        return {
                            tableKey: ep.tableProxy.getKey(),
                            enabled: ep.isFieldEnabled(fieldInfo)
                        };
                    });
                }).forEach(function (it) {
                    return result[it.tableKey + "#" + colKey] = it.enabled;
                });
            });
            return result;
        }

        // the magic edge is backwards, so we get the child's type, not the parent's

    }, {
        key: "createMagicChild",
        value: function createMagicChild(id, entityKey, newId) {
            this.createEntityRecord(entityKey, newId, false);
            var e = _entityMetaStore2.default.getInfo(entityKey);
            this.updateEntityRecordField(entityKey, newId, e.magicRootPointerKey, id);
            this.initializeTableRecord(e.tableKey, newId, entityKey);
            return this;
        }
    }, {
        key: "createEntityRecord",
        value: function createEntityRecord(entityKey, newId) {
            var initialize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            var e = _entityMetaStore2.default.getInfo(entityKey);
            this.createTableRecord(e.tableKey, newId, entityKey, initialize);
            return this;
        }
    }, {
        key: "createEntityChild",
        value: function createEntityChild(entityKeyOrInfo, id, fieldKeyOrInfo, newId, insertAt) {
            var ei = typeof entityKeyOrInfo === "string" ? _entityMetaStore2.default.getInfo(entityKeyOrInfo) : entityKeyOrInfo;
            var fi = typeof fieldKeyOrInfo === "string" ? _entityFieldMetaStore2.default.getInfo(ei.key, fieldKeyOrInfo) : fieldKeyOrInfo;
            this.createEntityRecord(fi.otherEntityKey, newId, false);
            var colInfo = _TableColumnMetaStore2.default.getInfoByKey(ei.tableKey, fi.logicalKey);
            this.wireTableChild(ei.tableKey, id, colInfo, newId, insertAt);
            this.initializeTableRecord(colInfo.otherTableKey, newId, fi.otherEntityKey);
            return this;
        }
    }, {
        key: "createTableRecord",
        value: function createTableRecord(tableKey, newId) {
            var ofEntityKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var initialize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

            this.loadRecordData(tableKey, newId, {}, (0, _hydration.rehydrate)({}, tableKey));
            if (initialize) {
                this.initializeTableRecord(tableKey, newId, ofEntityKey);
            }
            return this;
        }
    }, {
        key: "createTableChild",
        value: function createTableChild(tableKey, id, colName, newId, insertAt) {
            var colInfo = _TableColumnMetaStore2.default.getInfoByName(tableKey, colName);
            this.createTableRecord(colInfo.otherTableKey, newId);
            this.wireTableChild(tableKey, id, colInfo, newId, insertAt);
            return this;
        }
    }, {
        key: "deleteEntityRecord",
        value: function deleteEntityRecord(entityKey, id) {
            var e = _entityMetaStore2.default.getInfo(entityKey);
            this.deleteTableRecord(e.tableKey, id);
            return this;
        }
    }, {
        key: "deleteEntityChild",
        value: function deleteEntityChild(entityKeyOrInfo, id, fieldKeyOrInfo, childId) {
            var ei = typeof entityKeyOrInfo === "string" ? _entityMetaStore2.default.getInfo(entityKeyOrInfo) : entityKeyOrInfo;
            var fi = typeof fieldKeyOrInfo === "string" ? _entityFieldMetaStore2.default.getInfo(ei.key, fieldKeyOrInfo) : fieldKeyOrInfo;
            this.deleteTableChild(ei.tableKey, id, fi.logicalColumn, childId);
            return this;
        }
    }, {
        key: "deleteTableRecord",
        value: function deleteTableRecord(tableKey, id) {
            if (!this.hasRecord(tableKey, id)) return this;
            var tp = new _TableProxy2.default(this, tableKey, id);
            var entityInfos = tp.getEntityKeys().map(function (ek) {
                return _entityMetaStore2.default.getInfo(ek);
            });
            var _iteratorNormalCompletion18 = true;
            var _didIteratorError18 = false;
            var _iteratorError18 = undefined;

            try {
                for (var _iterator18 = entityInfos[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
                    var ei = _step18.value;

                    // ON DELETE CASCADE for compositions
                    var _iteratorNormalCompletion19 = true;
                    var _didIteratorError19 = false;
                    var _iteratorError19 = undefined;

                    try {
                        for (var _iterator19 = ei.associations.csv[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
                            var comp = _step19.value;

                            var efi = _entityFieldMetaStore2.default.getInfo(ei.key, comp);
                            var v = this.getColumnData(tableKey, id, efi.logicalColumn);
                            if (v != null) {
                                this.deleteEntityRecord(efi.otherEntityKey, v);
                            }
                        }
                    } catch (err) {
                        _didIteratorError19 = true;
                        _iteratorError19 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion19 && _iterator19.return) {
                                _iterator19.return();
                            }
                        } finally {
                            if (_didIteratorError19) {
                                throw _iteratorError19;
                            }
                        }
                    }

                    var _iteratorNormalCompletion20 = true;
                    var _didIteratorError20 = false;
                    var _iteratorError20 = undefined;

                    try {
                        for (var _iterator20 = ei.associations.cmv[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
                            var _comp = _step20.value;

                            var efi = _entityFieldMetaStore2.default.getInfo(ei.key, _comp);
                            var v = this.getColumnData(tableKey, id, efi.logicalColumn);
                            if (v != null && v.length !== 0) {
                                var _iteratorNormalCompletion22 = true;
                                var _didIteratorError22 = false;
                                var _iteratorError22 = undefined;

                                try {
                                    for (var _iterator22 = v[Symbol.iterator](), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
                                        var _id4 = _step22.value;

                                        this.deleteEntityRecord(efi.otherEntityKey, _id4);
                                    }
                                } catch (err) {
                                    _didIteratorError22 = true;
                                    _iteratorError22 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion22 && _iterator22.return) {
                                            _iterator22.return();
                                        }
                                    } finally {
                                        if (_didIteratorError22) {
                                            throw _iteratorError22;
                                        }
                                    }
                                }
                            }
                        }

                        // unwireChildCrossTreeRefs() works from the child out but here we
                        // need to work in the other direction. Leaving this for now.
                        // ON DELETE SET NULL for cross-tree associations
                    } catch (err) {
                        _didIteratorError20 = true;
                        _iteratorError20 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion20 && _iterator20.return) {
                                _iterator20.return();
                            }
                        } finally {
                            if (_didIteratorError20) {
                                throw _iteratorError20;
                            }
                        }
                    }

                    var _iteratorNormalCompletion21 = true;
                    var _didIteratorError21 = false;
                    var _iteratorError21 = undefined;

                    try {
                        for (var _iterator21 = ei.associations.inv[Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
                            var inv = _step21.value;

                            var ifi = _entityFieldMetaStore2.default.getInfo(ei.key, inv);
                            var efi = _entityFieldMetaStore2.default.getInfo(ifi.otherEntityKey, ifi.inverseKey);
                            if (efi.type === "CompositionField") {
                                continue;
                            }
                            var ownerIds = tp.get(ifi.logicalColumn);
                            if (ownerIds == null || ownerIds.length === 0) {
                                continue;
                            }
                            var iei = _entityMetaStore2.default.getInfo(efi.entityKey);
                            var ci = _TableColumnMetaStore2.default.getInfoByKey(iei.tableKey, efi.logicalKey);
                            var _iteratorNormalCompletion23 = true;
                            var _didIteratorError23 = false;
                            var _iteratorError23 = undefined;

                            try {
                                for (var _iterator23 = ownerIds[Symbol.iterator](), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
                                    var oid = _step23.value;

                                    this.unwireTableChild(iei.tableKey, oid, ci, id);
                                }
                            } catch (err) {
                                _didIteratorError23 = true;
                                _iteratorError23 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion23 && _iterator23.return) {
                                        _iterator23.return();
                                    }
                                } finally {
                                    if (_didIteratorError23) {
                                        throw _iteratorError23;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError21 = true;
                        _iteratorError21 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion21 && _iterator21.return) {
                                _iterator21.return();
                            }
                        } finally {
                            if (_didIteratorError21) {
                                throw _iteratorError21;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError18 = true;
                _iteratorError18 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion18 && _iterator18.return) {
                        _iterator18.return();
                    }
                } finally {
                    if (_didIteratorError18) {
                        throw _iteratorError18;
                    }
                }
            }

            this._deleteRecord(tableKey, id);
            return this;
        }
    }, {
        key: "deleteTableChild",
        value: function deleteTableChild(tableKey, id, colNameOrInfo, childId) {
            var colInfo = typeof colNameOrInfo === "string" ? _TableColumnMetaStore2.default.getInfoByName(tableKey, colNameOrInfo) : colNameOrInfo;
            this.unwireTableChild(tableKey, id, colInfo, childId);
            this.unwireChildCrossTreeRefs(colInfo, childId);
            return this;
        }
    }, {
        key: "_doAutoManagement",
        value: function _doAutoManagement(tableKey, id, childInfo, globalInfo, allIds) {
            var _this = this;

            /*
             * tableKey.id owns a composed collection, described by childInfo. One
             * of the fields on the child type is a global association described by
             * globalInfo. The IDs of the global records are in allIds.
             *
             * The task is to populate the composed collection with one record for
             * every global record which passes the global association's candidate
             * filter. This includes removing children who no longer have a global
             * record. It is against the rules for the filter expression to
             * reference the child record itself, excepting to get up to the parent
             * record (referenced by tableKey.id).
             */
            var ifamKey = id + ":" + tableKey; // id will differentiate earlier
            if (this.inFlightAutomanagement.has(ifamKey)) return;
            this.inFlightAutomanagement.add(ifamKey);
            try {
                // create a fake child record to use for candidate filtering the global
                // list, with fail-fast-on-silly behaviour.
                var ownerTP = new _TableProxy2.default(this, tableKey, id);
                var ownerEP = new _EntityProxy2.default(ownerTP, childInfo.entityKey);
                if (!ownerEP.isFieldEnabled(childInfo)) return;
                var childTableKey = _entityMetaStore2.default.getInfo(childInfo.otherEntityKey).tableKey;
                var globalTableKey = _entityMetaStore2.default.getInfo(globalInfo.otherEntityKey).tableKey;
                var fakeChild = {
                    get: function get(name) {
                        if (name === childInfo.inverseKey) {
                            return ownerEP;
                        }
                        throw new Error("Auto-management candidate filters can only reference the instance's parent field");
                    }
                };

                // todo: we need to care about enablement somewhere?
                var filteredIds = void 0;
                if ((0, _EntityProxy.hasCandidateFilter)(globalInfo)) {
                    // inflate ids to EntityProxies
                    var eps = allIds.map(function (id) {
                        return new _EntityProxy2.default(_this, globalInfo.otherEntityKey, globalTableKey, id);
                    });
                    // run candidate filter
                    var filter = globalInfo.scripts.filter;
                    eps = eps.filter(function (it) {
                        return filter(fakeChild, it);
                    });
                    // back to ids
                    filteredIds = eps.map(function (it) {
                        return it.id;
                    });
                } else {
                    filteredIds = allIds;
                }
                // now we know the set of global IDs we need to have a child for!

                // get the current children
                var currChildIds = ownerTP.get(childInfo.logicalColumn);
                var currs = currChildIds.map(function (id) {
                    return {
                        child: id,
                        global: _this.getColumnData(childTableKey, id, globalInfo.logicalColumn)
                    };
                });
                // for each child
                var _iteratorNormalCompletion24 = true;
                var _didIteratorError24 = false;
                var _iteratorError24 = undefined;

                try {
                    for (var _iterator24 = currs[Symbol.iterator](), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
                        var curr = _step24.value;

                        // if its AMF's id is not filteredIds, delete
                        if (filteredIds.indexOf(curr.global) >= 0) continue;
                        this.deleteEntityChild(ownerEP.entityKey, ownerEP.id, childInfo.key, curr.child);
                    }
                    // for each newId
                } catch (err) {
                    _didIteratorError24 = true;
                    _iteratorError24 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion24 && _iterator24.return) {
                            _iterator24.return();
                        }
                    } finally {
                        if (_didIteratorError24) {
                            throw _iteratorError24;
                        }
                    }
                }

                var _loop = function _loop(_id5) {
                    // if its has no child w/ that AMF id, create
                    if (currs.some(function (it) {
                        return it.global === _id5;
                    })) return "continue";
                    var newId = _ClientId2.default.next();
                    _this.createEntityChild(ownerEP.entityKey, ownerEP.id, childInfo.key, newId);
                    _this.updateTableRecordColumn(childTableKey, newId, globalInfo.logicalColumn, _id5);
                };

                var _iteratorNormalCompletion25 = true;
                var _didIteratorError25 = false;
                var _iteratorError25 = undefined;

                try {
                    for (var _iterator25 = filteredIds[Symbol.iterator](), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
                        var _id5 = _step25.value;

                        var _ret = _loop(_id5);

                        if (_ret === "continue") continue;
                    }
                } catch (err) {
                    _didIteratorError25 = true;
                    _iteratorError25 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion25 && _iterator25.return) {
                            _iterator25.return();
                        }
                    } finally {
                        if (_didIteratorError25) {
                            throw _iteratorError25;
                        }
                    }
                }
            } finally {
                this.inFlightAutomanagement.delete(ifamKey);
            }
        }
    }, {
        key: "_doDerivation",
        value: function _doDerivation(tableProxy, derivation) {
            var info = _TableColumnMetaStore2.default.getInfoByKey(tableProxy.tableKey, derivation.targetKey);
            var value = derivation.script(tableProxy);
            if (value != null && info.type === "CHOICE") {
                value = (0, _options.optionId)(derivation.choiceKey)(value);
            }
            this.updateTableRecordColumn(tableProxy.tableKey, tableProxy.id, derivation.targetName, value, info);
            return this;
        }
    }, {
        key: "_doDerivations",
        value: function _doDerivations(tableKey, id, derivations) {
            if (derivations.length === 0) return this;
            // these are simpler than downstreams, because they're entirely at the table
            // level, and they're not allowed to traverse associations.
            var proxy = new _TableProxy2.default(this, tableKey, id, true);
            var _iteratorNormalCompletion26 = true;
            var _didIteratorError26 = false;
            var _iteratorError26 = undefined;

            try {
                for (var _iterator26 = derivations[Symbol.iterator](), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
                    var d = _step26.value;

                    this._doDerivation(proxy, d);
                }
            } catch (err) {
                _didIteratorError26 = true;
                _iteratorError26 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion26 && _iterator26.return) {
                        _iterator26.return();
                    }
                } finally {
                    if (_didIteratorError26) {
                        throw _iteratorError26;
                    }
                }
            }

            return this;
        }
    }, {
        key: "_doDownstreamEnablements",
        value: function _doDownstreamEnablements(tableKey, id, downstreams, priorEnableState) {
            if (downstreams.length === 0) return this;
            var enableState = this._buildEnableState(tableKey, id, downstreams);
            var _iteratorNormalCompletion27 = true;
            var _didIteratorError27 = false;
            var _iteratorError27 = undefined;

            try {
                for (var _iterator27 = Object.keys(enableState)[Symbol.iterator](), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
                    var k = _step27.value;

                    var enabled = enableState[k];
                    var wasEnabled = priorEnableState.hasOwnProperty(k) && priorEnableState[k];

                    var _k$split = k.split("#"),
                        _k$split2 = _slicedToArray(_k$split, 3),
                        _tableKey3 = _k$split2[0],
                        idString = _k$split2[1],
                        colKey = _k$split2[2];

                    var _id6 = (0, _parseId2.default)(idString);
                    var info = _TableColumnMetaStore2.default.getInfoByKey(_tableKey3, colKey);
                    if (!enabled && wasEnabled) {
                        // became disabled
                        this.updateTableRecordColumn(_tableKey3, _id6, info.name, info.multiValued ? [] : null, info);
                    } else if (enabled && !wasEnabled) {
                        // became enabled
                        var fieldInfos = _entityFieldMetaStore2.default.getInfosForColumn(new _TableProxy2.default(this, _tableKey3, _id6).getEntityKeys(), info.name);
                        var toRecalc = fieldInfos.filter(_EntityProxy.hasRecalcScript);
                        if (toRecalc.length) {
                            this.recalculateTableRecordColumn(_tableKey3, _id6, info.name, toRecalc, false);
                        }
                        if (info.type === "ASSOCIATION") {
                            var _iteratorNormalCompletion28 = true;
                            var _didIteratorError28 = false;
                            var _iteratorError28 = undefined;

                            try {
                                for (var _iterator28 = fieldInfos[Symbol.iterator](), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
                                    var fi = _step28.value;

                                    if (fi.autoManageKey) {
                                        this._requestAutoManagement(_tableKey3, _id6, fi);
                                        break; // first one wins
                                    }
                                }
                            } catch (err) {
                                _didIteratorError28 = true;
                                _iteratorError28 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion28 && _iterator28.return) {
                                        _iterator28.return();
                                    }
                                } finally {
                                    if (_didIteratorError28) {
                                        throw _iteratorError28;
                                    }
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError27 = true;
                _iteratorError27 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion27 && _iterator27.return) {
                        _iterator27.return();
                    }
                } finally {
                    if (_didIteratorError27) {
                        throw _iteratorError27;
                    }
                }
            }

            return this;
        }
    }, {
        key: "_doDownstreamRecalcs",
        value: function _doDownstreamRecalcs(tableKey, id, downstreams) {
            var _this2 = this;

            // todo: does this need to do an enabled check?
            if (downstreams.length === 0) return this;
            this._forEachDownstream(tableKey, id, downstreams, function (eps, colKey) {
                var ep = eps.find(function (ep) {
                    var entityKey = ep.entityKey;
                    var fieldInfo = _entityFieldMetaStore2.default.getInfoForColumnKey(entityKey, colKey);
                    // this is, perhaps, a little generous. But if we hit it, the
                    // metamodel is inconsistent, so unlikely we can guess right
                    // anyway. But do something, at least, not nothing (per HJC-430)
                    return fieldInfo.calculated;
                });
                if (!ep) return;
                var tableKey = ep.tableProxy.tableKey;
                var targetColumnName = _TableColumnMetaStore2.default.getInfoByKey(tableKey, colKey).name;
                var _iteratorNormalCompletion29 = true;
                var _didIteratorError29 = false;
                var _iteratorError29 = undefined;

                try {
                    for (var _iterator29 = eps[Symbol.iterator](), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
                        var p = _step29.value;

                        _this2.recalculateTableRecordColumn(tableKey, p.id, targetColumnName);
                    }
                } catch (err) {
                    _didIteratorError29 = true;
                    _iteratorError29 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion29 && _iterator29.return) {
                            _iterator29.return();
                        }
                    } finally {
                        if (_didIteratorError29) {
                            throw _iteratorError29;
                        }
                    }
                }
            });
            return this;
        }
    }, {
        key: "_doDownstreamAutoManagement",
        value: function _doDownstreamAutoManagement(tableKey, id, downstreams) {
            var _this3 = this;

            // todo: does this need to do an enabled check?
            if (downstreams.length === 0) return this;
            this._forEachDownstream(tableKey, id, downstreams, function (eps, colKey) {
                if (eps.length === 0) return;
                var tableKey = eps[0].tableProxy.tableKey;
                var colInfo = _TableColumnMetaStore2.default.getInfoByKey(tableKey, colKey);
                var targetColumnName = colInfo.name;
                var _iteratorNormalCompletion30 = true;
                var _didIteratorError30 = false;
                var _iteratorError30 = undefined;

                try {
                    for (var _iterator30 = eps[Symbol.iterator](), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
                        var p = _step30.value;

                        var fieldInfo = _entityFieldMetaStore2.default.getInfoForColumn(p.entityKey, targetColumnName);
                        if (fieldInfo.autoManageKey == null) return;
                        _this3._requestAutoManagement(tableKey, p.id, fieldInfo);
                    }
                } catch (err) {
                    _didIteratorError30 = true;
                    _iteratorError30 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion30 && _iterator30.return) {
                            _iterator30.return();
                        }
                    } finally {
                        if (_didIteratorError30) {
                            throw _iteratorError30;
                        }
                    }
                }
            });
        }
    }, {
        key: "_forEachDownstream",
        value: function _forEachDownstream(tableKey, id, downstreams, work) {
            if (!this.hasRecord(tableKey, id)) return;
            var initialEps = new _TableProxy2.default(this, tableKey, id).getEntityProxies();
            var _iteratorNormalCompletion31 = true;
            var _didIteratorError31 = false;
            var _iteratorError31 = undefined;

            try {
                for (var _iterator31 = downstreams[Symbol.iterator](), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
                    var ds = _step31.value;

                    var _chaseDownstream = chaseDownstream(initialEps, ds),
                        _chaseDownstream2 = _slicedToArray(_chaseDownstream, 2),
                        eps = _chaseDownstream2[0],
                        targetColumnKey = _chaseDownstream2[1];

                    if (eps.length === 0) continue;
                    work(eps, targetColumnKey);
                }
            } catch (err) {
                _didIteratorError31 = true;
                _iteratorError31 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion31 && _iterator31.return) {
                        _iterator31.return();
                    }
                } finally {
                    if (_didIteratorError31) {
                        throw _iteratorError31;
                    }
                }
            }
        }
    }, {
        key: "_gatherDownstreams",
        value: function _gatherDownstreams(tableKey, id, colInfo) {
            var _this4 = this;

            // todo: respect the dependency-ordered field tree?
            var derivations = colInfo.derivations || [];
            var downstreams = colInfo.downstreams || {};
            var enableDownstreams = downstreams.ENABLEMENT || [];
            var assignDownstreams = downstreams.ASSIGNMENT || [];
            var filterDownstreams = downstreams.CANDIDATE_FILTER || [];
            // todo: index these?
            var autoManageDownstreams = filterDownstreams.map(function (it) {
                return it.split(".");
            }).filter(function (it) {
                return it.length >= 2;
            }).map(function (it) {
                it.pop();
                return it.join(".");
            });
            var enableState = void 0;
            if (enableDownstreams.length > 0) {
                enableState = this._buildEnableState(tableKey, id, enableDownstreams);
            }
            return { execute: function execute() {
                    if (derivations.length > 0) {
                        _this4._doDerivations(tableKey, id, derivations);
                    }
                    if (enableDownstreams.length > 0) {
                        _this4._doDownstreamEnablements(tableKey, id, enableDownstreams, enableState);
                    }
                    if (assignDownstreams.length > 0) {
                        _this4._doDownstreamRecalcs(tableKey, id, assignDownstreams);
                    }
                    if (autoManageDownstreams.length > 0) {
                        _this4._doDownstreamAutoManagement(tableKey, id, autoManageDownstreams);
                    }
                } };
        }
    }, {
        key: "appendAssociationIds",
        value: function appendAssociationIds(tableKey, ids, targetId, columnNameOrInfo) {
            var _this5 = this;

            var columnInfo = typeof columnNameOrInfo === "string" ? _TableColumnMetaStore2.default.getInfoByName(tableKey, columnNameOrInfo) : columnNameOrInfo;
            if (columnInfo.type !== "ASSOCIATION") {
                throw new Error("Expected type to be an association.");
            }
            if (!Array.isArray(ids)) {
                throw new Error("Expected ids to be an array of Ids but received \"" + (typeof ids === "undefined" ? "undefined" : _typeof(ids)) + "\"");
            }
            // rewire ids to target
            ids.forEach(function (id) {
                return _this5.wireTableChild(tableKey, targetId, columnInfo, id);
            });
            return this;
        }
    }, {
        key: "moveAssociationIds",
        value: function moveAssociationIds(tableKey, sourceId, targetId, columnNameOrInfo) {
            var columnInfo = typeof columnNameOrInfo === "string" ? _TableColumnMetaStore2.default.getInfoByName(tableKey, columnNameOrInfo) : columnNameOrInfo;
            var ids = this._getColumn(tableKey, sourceId, columnInfo.name); // get source ids
            this.appendAssociationIds(tableKey, ids, targetId, columnInfo); // rewire source ids
            this._setColumn(tableKey, sourceId, columnInfo.name, []); // empty source
            return this;
        }
    }, {
        key: "recalculateTableRecordColumn",
        value: function recalculateTableRecordColumn(tableKey, id, columnName, optionalFieldInfos) {
            var checkEnablement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

            // todo: consider a contextual preference (an ofEntityKey)
            var tableProxy = new _TableProxy2.default(this, tableKey, id);
            var fieldInfos = (optionalFieldInfos == null ? _entityFieldMetaStore2.default.getInfosForColumn(tableProxy.getEntityKeys(), columnName) : optionalFieldInfos).filter(_EntityProxy.hasRecalcScript);
            if (fieldInfos.length === 0) {
                if (optionalFieldInfos != null) {
                    console.warn("Recalc requested for scriptless column", tableKey, id, columnName);
                }
                return this;
            }

            // jsmodel broke these ties via "whatever order the change listeners
            // were registered in", because that was the only choice. it's also
            // completely non-obvious that that's the behaviour unless you dig deep
            // and exhibit great care during your travels. We'll be just as
            // arbitrary, but at least we're obvious about it. We'll also ensure the
            // _same_ info is picked every time, rather than potentially changing as
            // new metadata is loaded into the running app.
            var info = fieldInfos[0]; // FIRST IS BEST!
            // except this one. this one is special. :)
            var nonUpdateable = fieldInfos.some(function (it) {
                return it.nonUpdateable;
            });

            var proxy = new _EntityProxy2.default(tableProxy, info.entityKey);
            if (checkEnablement && !proxy.isFieldEnabled(info)) return this;
            var curr = proxy.getField(info.key);
            if (nonUpdateable && curr != null) return this;
            var newVal = info.scripts.recalc(proxy);
            this.updateEntityRecordField(info.entityKey, id, info.key, newVal);
            return this;
        }
    }, {
        key: "updateEntityRecordField",
        value: function updateEntityRecordField(entityKey, id, fieldKey, value) {
            var entityInfo = _entityMetaStore2.default.getInfo(entityKey);
            var fieldInfo = _entityFieldMetaStore2.default.getInfo(entityKey, fieldKey);
            if ((0, _EntityProxy.isChoice)(fieldInfo)) {
                var nameToId = (0, _options.optionId)(fieldInfo.choiceKey);
                if (value instanceof Array) {
                    value = value.map(nameToId).filter(function (it) {
                        return it != null;
                    });
                } else if (value != null) {
                    value = nameToId(value);
                }
            }
            this.updateTableRecordColumn(entityInfo.tableKey, id, fieldInfo.logicalColumn, value);
            return this;
        }
    }, {
        key: "addToEntityCollection",
        value: function addToEntityCollection(entityKey, id, fieldKey, valueToAdd) {
            var entityInfo = _entityMetaStore2.default.getInfo(entityKey);
            var fieldInfo = _entityFieldMetaStore2.default.getInfo(entityKey, fieldKey);
            var oldValue = this._getColumn(entityInfo.tableKey, id, fieldInfo.logicalColumn);
            if (oldValue && !Array.isArray(oldValue)) {
                console.error("Expected oldValue to be null or an array but received \"" + (typeof oldValue === "undefined" ? "undefined" : _typeof(oldValue)) + "\".", oldValue);
            }
            var newValue = !oldValue ? [] : [].concat(_toConsumableArray(oldValue)); // always return new array
            newValue.push(valueToAdd);
            return newValue;
        }
    }, {
        key: "updateTableRecordColumn",
        value: function updateTableRecordColumn(tableKey, id, colName, valueOrMutator, optionalColumnInfo) // do this default manually to avoid no-op updates
        {
            var _this6 = this;

            if (!this.hasRecord(tableKey, id)) {
                console.error("update ignored for unknown record '" + tableKey + "#" + id + "'", colName, valueOrMutator);
                return this;
            }

            var colInfo = optionalColumnInfo != null ? optionalColumnInfo : _TableColumnMetaStore2.default.getInfoByName(tableKey, colName);
            var oldValue = this._getColumn(tableKey, id, colName);
            var newValue = (0, _cleanValue2.default)(typeof valueOrMutator === "function" ? valueOrMutator(oldValue) : valueOrMutator, colInfo.type);

            // ignore no-op updates
            if (areEqual(oldValue, newValue)) return this;

            if (colInfo.inverse) {
                console.error("Trying to set an inverse: " + colInfo.tableKey + "." + colInfo.key + " (." + colInfo.name + ")");
            }

            // calc downstreams so we have pre-update enable state
            var downstreams = this._gatherDownstreams(tableKey, id, colInfo);
            var inverseDownstreams = null;
            if (colInfo.type === "ASSOCIATION") {
                var removedIds = (0, _asArray2.default)(oldValue).filter(newValue instanceof Array ? function (v) {
                    return newValue.indexOf(v) < 0;
                } : function (v) {
                    return v !== newValue;
                });

                // if this column stores composition references, delete orphaned records
                var fieldInfos = _entityFieldMetaStore2.default.getInfosForColumn(new _TableProxy2.default(this, tableKey, id).getEntityKeys(), colName);
                var isComp = fieldInfos.some(_EntityProxy.isComposition);
                if (isComp) {
                    removedIds.forEach(function (id) {
                        return _this6.deleteTableRecord(colInfo.otherTableKey, id);
                    });
                }

                if (colInfo.hasOwnProperty("inverseKey") && colInfo.inverseKey) {
                    var invInfo = _TableColumnMetaStore2.default.getInfoByKey(colInfo.otherTableKey, colInfo.inverseKey);
                    var ids = (0, _asArray2.default)(newValue);
                    if (!isComp) {
                        var _ids;

                        ids = (_ids = ids).concat.apply(_ids, _toConsumableArray(removedIds));
                    }
                    inverseDownstreams = ids.map(function (v) {
                        return _this6._gatherDownstreams(colInfo.otherTableKey, v, invInfo);
                    });
                }
            }

            // actually do the set
            var changed = this._setColumn(tableKey, id, colName, newValue);
            if (!changed) {
                // per helen's decree, a no-op change does NOT cause the dependency
                // cascade to happen. if the user wants the cascade to fire without
                // changing a field, they need to make two changes: one to some
                // garbage value, and a second back to the original.
                return;
            }

            // do the downstreams, based on the pre-update state gathered above
            downstreams.execute();
            inverseDownstreams && inverseDownstreams.forEach(function (it) {
                return it.execute();
            });
            return this;
        }
    }, {
        key: "wireTableChild",
        value: function wireTableChild(tableKey, id, colInfo, newId, insertAt) {
            this.updateTableRecordColumn(tableKey, id, colInfo.name, colInfo.multiValued ? function (v) {
                if (v == null) return [newId];
                v = v.slice();
                if (insertAt == null) v.push(newId);else v.splice(insertAt, 0, newId);
                return v;
            } : newId, colInfo);
            return this;
        }
    }, {
        key: "unwireTableChild",
        value: function unwireTableChild(tableKey, id, colInfo, childId) {
            this.updateTableRecordColumn(tableKey, id, colInfo.name, colInfo.multiValued ? function (v) {
                if (v == null) return v;
                var i = v.indexOf(childId);
                if (i < 0) return v;
                v = v.slice();
                v.splice(i, 1);
                return v;
            } : function (v) {
                return v === childId ? null : v;
            }, colInfo);
            return this;
        }
    }, {
        key: "unwireChildCrossTreeRefs",
        value: function unwireChildCrossTreeRefs(colInfo, childId) {
            var _this7 = this;

            // find all table columns referencing inverse key
            var assocCols = _TableColumnMetaStore2.default.getAllColumns(colInfo.otherTableKey).filter(function (it) {
                return it.type === "ASSOCIATION" && !!it.inverseKey && it.key !== colInfo.inverseKey;
            });
            // cleanup any remaining references to the just deleted childId.
            assocCols.forEach(function (_assocColInfo) {
                // get all ID's for otherTableKey
                var ids = _this7.getAllRecords(_assocColInfo.otherTableKey).map(function (_assocColInfo) {
                    return _assocColInfo.meta.id;
                });
                ids.forEach(function (_id) {
                    var _colInfo = _TableColumnMetaStore2.default.getInfoByKey(_assocColInfo.otherTableKey, _assocColInfo.inverseKey);
                    _this7.unwireTableChild(_assocColInfo.otherTableKey, _id, _colInfo, childId);
                });
            });
            return this;
        }
    }, {
        key: "remapGlobalMergeTargetToSource",
        value: function remapGlobalMergeTargetToSource(target, source) {
            var _this8 = this;

            var backedTables = (0, _stereotypes.getTableKeys)(_StereotypesStore2.default.getStereotypeByKey(target.stereoKey));
            if (backedTables.length !== 1) {
                // how did we get here... can only merge single table backed stereotypes.
                throw new Error("Merge only supports single table backed stereotypes.");
            }
            var tableKey = backedTables[0];
            // global merge may have source id associations that need to be remapped
            // to the target id after merge.

            // 1. first get all inverse association fields from TableColumnMetaStore.
            var tableKeys = Object.keys(this.state.tables);
            var assocCols = _TableColumnMetaStore2.default.getAllColumns(tableKey).filter(function (it) {
                return it.type === "ASSOCIATION" && !!it.inverseKey && tableKeys.includes(it.otherTableKey) // we only care about the records currently loaded
                ;
            });

            // 2. loop over all associations and update each record that referenced
            // the target id and change it to the source id.
            assocCols.forEach(function (it) {
                var columnInfo = _TableColumnMetaStore2.default.getInfoByKey(it.otherTableKey, it.inverseKey);
                var ids = _this8.getAllRecords(it.otherTableKey).map(function (_assocColInfo) {
                    return _assocColInfo.meta.id;
                });
                ids.forEach(function (id) {
                    var value = _this8.getColumnData(it.otherTableKey, id, columnInfo.name);
                    var needsUpdate = false;
                    var newValue = void 0;
                    if (Array.isArray(value)) {
                        var idx = value.indexOf(source.id);
                        if (idx >= 0) {
                            needsUpdate = true;
                            newValue = [].concat(_toConsumableArray(value));
                            newValue[idx] = target.id;
                        }
                    } else {
                        if (value === source.id) {
                            needsUpdate = true;
                            newValue = target.id;
                        }
                    }
                    if (needsUpdate) {
                        _this8.updateTableRecordColumn(it.otherTableKey, id, columnInfo.name, newValue);
                    }
                });
            });
            return this;
        }
    }]);

    return TableAccess;
}();

exports.default = TableAccess;

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _typedAction = __webpack_require__(86);

var _typedAction2 = _interopRequireDefault(_typedAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var implKeyShape = {
    implementationKey: _propTypes2.default.string.isRequired
};

var NavigationActions = {
    FOCUS_FIELD: "navigation/focus-field",

    SELECT_RECORD: "navigation/select-record",
    SELECT_IMPLEMENTATION: (0, _typedAction2.default)("navigation/select-implementation", implKeyShape),
    TOGGLE_IMPLEMENTATION: (0, _typedAction2.default)("navigation/toggle-implementation", implKeyShape),
    SELECT_ALL_IMPLEMENTATIONS: "navigation/select-all-implementations"
};

exports.default = NavigationActions;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var quarters = [{ value: "", label: "" }, { value: "1", label: "Q1 (Jan 1 - Mar 31)" }, { value: "2", label: "Q2 (Apr 1 - Jun 30)" }, { value: "3", label: "Q3 (Jul 1 - Sep 30)" }, { value: "4", label: "Q4 (Oct 1 - Dec 31)" }];

var QuarterYearSelect = function QuarterYearSelect(_ref) {
    var quarter = _ref.quarter,
        year = _ref.year,
        min = _ref.min,
        max = _ref.max,
        onChange = _ref.onChange,
        _ref$expanded = _ref.expanded,
        expanded = _ref$expanded === undefined ? false : _ref$expanded,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === undefined ? true : _ref$disabled,
        _ref$required = _ref.required,
        required = _ref$required === undefined ? false : _ref$required;

    var minYear = min[0],
        maxYear = max[0];
    var years = [];
    for (var i = maxYear; i >= minYear; i--) {
        years.push(i.toString());
    }

    var quarterOptions = quarters;
    var yearOptions = years.map(function (y) {
        return { label: y, value: y };
    });
    yearOptions.unshift({ label: "", value: "" });

    return _react2.default.createElement(
        "div",
        { className: "quarterFields export-datecontrols" },
        _react2.default.createElement(
            "div",
            { className: "form-group row" },
            _react2.default.createElement(
                "div",
                { className: "col-sm-7" },
                _react2.default.createElement(_Select2.default, {
                    value: quarter,
                    width: "100%",
                    className: "quarter_select quarter_from partdep form-control",
                    disabled: disabled,
                    onCommitChange: function onCommitChange(v) {
                        return onChange("quarter", v);
                    },
                    options: quarterOptions,
                    required: required
                })
            ),
            _react2.default.createElement(
                "div",
                { className: "col-sm-5" },
                _react2.default.createElement(_Select2.default, {
                    value: year,
                    className: "year_select year_from partdep form-control",
                    disabled: disabled,
                    onCommitChange: function onCommitChange(v) {
                        return onChange("year", v);
                    },
                    options: yearOptions,
                    required: required
                })
            )
        )
    );
};

QuarterYearSelect.propTypes = {
    quarter: _propTypes2.default.string,
    year: _propTypes2.default.string,
    min: _propTypes2.default.array,
    max: _propTypes2.default.array,
    onChange: _propTypes2.default.func,
    expanded: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    required: _propTypes2.default.bool
};

exports.default = QuarterYearSelect;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchFormStore = exports.copyFieldValuesByKey = exports.toHuman = exports.toQ = exports.restoreSavedSearch = exports.extractSearchToSave = exports.hasFieldType = exports.hasValues = exports.clearFields = exports.getValueByPath = exports.setValueByPath = exports.buildKeyPaths = exports.pathToArray = exports.arrayToPath = exports.buildPathNode = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _SearchFormActions = __webpack_require__(75);

var _SearchFormActions2 = _interopRequireDefault(_SearchFormActions);

var _MergeActions = __webpack_require__(59);

var _MergeActions2 = _interopRequireDefault(_MergeActions);

var _ContextedReduceStore2 = __webpack_require__(30);

var _ContextedReduceStore3 = _interopRequireDefault(_ContextedReduceStore2);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Q = __webpack_require__(176);

var _Q2 = _interopRequireDefault(_Q);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _isFieldHidden = __webpack_require__(177);

var _isFieldHidden2 = _interopRequireDefault(_isFieldHidden);

var _sortsToOrder = __webpack_require__(322);

var _sortsToOrder2 = _interopRequireDefault(_sortsToOrder);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _MappingActions = __webpack_require__(109);

var _MappingActions2 = _interopRequireDefault(_MappingActions);

var _MergeStore = __webpack_require__(53);

var _MergeStore2 = _interopRequireDefault(_MergeStore);

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

var _MapDialogActions = __webpack_require__(64);

var _MapDialogActions2 = _interopRequireDefault(_MapDialogActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * The following three functions are used for crating the lookup path for each
 * field.
 */
var buildPathNode = exports.buildPathNode = function buildPathNode(index, key) {
    return { index: index, key: key };
};
var arrayToPath = exports.arrayToPath = function arrayToPath(arr) {
    return arr.map(function (node) {
        return node.index + "." + node.key;
    }).join("/");
};
var pathToArray = exports.pathToArray = function pathToArray(path) {
    if (!path) {
        // Possible rogue mutation of state.fields?
        throw new Error("pathToArray path is 'undefined'.");
    }
    return path.split("/").map(function (str) {
        var arr = str.split(".");
        return { index: arr[0], key: arr[1] };
    });
};

var addMissingCheckbox = function addMissingCheckbox(field, path) {
    return field.fields.push({
        name: "Missing " + field.name,
        stereotypeKey: field.stereotypeKey,
        key: field.key + "missing",
        id: field.id + "missing",
        type: "checkbox",
        path: arrayToPath([].concat(_toConsumableArray(path), [buildPathNode(field.fields.length, field.key + "missing")]))
    });
};

/**
 * Given raw fields array this function traverse each field adding a lookup path
 * build the correct search fields structure.
 *
 * @param {object} options
 * @param {array} fields
 * @param {array} path
 * @return array
 */
var buildKeyPaths = exports.buildKeyPaths = function buildKeyPaths() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var fields = arguments[1];
    var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var newFields = [].concat(_toConsumableArray(fields));
    return newFields.map(function (field, index) {
        var newField = _extends({}, field);
        var newPath = [].concat(_toConsumableArray(path));
        newPath.push(buildPathNode(index, newField.key)); // array index location for faster lookups
        if (newField.type === "to-one" || newField.type === "to-many") {
            newField.fields = buildKeyPaths(options, newField.fields, newPath);
        } else if (options.useDateRanges && ["date", "daterange", "datetime", "datetimerange"].includes(newField.type)) {
            var baseType = newField.type.replace(/range$/, "");
            if (options.useRelativeDates) {
                // HJC-380 add relative date options to search.
                newField.type = baseType + "relative";
                if (!Array.isArray(newField.fields)) {
                    newField.fields = [{
                        name: "" + newField.name,
                        key: newField.key + "lastndays",
                        id: newField.id + "lastndays",
                        stereotypeKey: newField.stereotypeKey,
                        type: "string",
                        hasExpectedValues: true,
                        expectedValues: [{ label: "Today", value: "today" }, { label: "Yesterday", value: "1,days" }, { label: "Last 7 days", value: "7,days" }, { label: "Last 30 days", value: "30,days" }, { label: "Last 90 days", value: "90,days" }, { label: "Last 180 days", value: "180,days" }],
                        expectedValueLookup: {},
                        path: arrayToPath([].concat(_toConsumableArray(newPath), [buildPathNode(0, newField.key + "lastndays")]))
                    }];
                }
            } else {
                // HO-2683 convert all date/datetime to date daterange/datetimerange
                newField.type = baseType + "range";
                if (!Array.isArray(newField.fields)) {
                    // create the date range newFields
                    newField.fields = [{
                        name: newField.name + " Start",
                        key: newField.key + "min",
                        id: newField.id + "min",
                        stereotypeKey: newField.stereotypeKey,
                        type: baseType,
                        path: arrayToPath([].concat(_toConsumableArray(newPath), [buildPathNode(0, newField.key + "min")]))
                    }, {
                        name: newField.name + " End",
                        stereotypeKey: newField.stereotypeKey,
                        key: newField.key + "max",
                        id: newField.id + "max",
                        type: baseType,
                        path: arrayToPath([].concat(_toConsumableArray(newPath), [buildPathNode(1, newField.key + "max")]))
                    }];
                }
            }
        }
        if (typeof options.useMissingCheckbox === "string" && new RegExp("(^|.*,)" + newField.type + "(,.*|$)").test(options.useMissingCheckbox)) {
            if (!Array.isArray(newField.fields)) {
                // wrap it first
                newField.fields = [_extends({}, newField, {
                    key: newField.key + "val",
                    id: newField.id + "val",
                    type: newField.type,
                    path: arrayToPath([].concat(_toConsumableArray(newPath), [buildPathNode(0, newField.key + "val")]))
                })];
                newField.type += "ormissing";
            }
            addMissingCheckbox(newField, newPath);
        }
        newField.path = arrayToPath(newPath);
        return newField;
    });
};

/**
 * Creates a new state and updates the value at the given path.
 *
 * @param {object} state
 * @param {string} path
 * @param {any} value
 * @return {object}
 */
var setValueByPath = exports.setValueByPath = function setValueByPath(state, path, value) {
    // returns new state with updated value.
    var newState = _extends({}, state);
    var updateField = function updateField(fields) {
        var nodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        var node = nodes[0];
        var newFields = [].concat(_toConsumableArray(fields));
        var newField = _extends({}, newFields[node.index]);
        if (node.key === newField.key) {
            if (nodes.length > 1 && Array.isArray(newField.fields)) {
                newField.fields = updateField(newField.fields, nodes.slice(1));
            } else if (nodes.length > 1) {
                // Possible rogue mutation of state.fields?
                throw new Error("setValueByPath path not found '" + path + "'");
            } else {
                if (value === undefined) {
                    // the value should no longer be set
                    delete newField.value;
                } else {
                    newField.value = value;
                }
            }
            newFields[node.index] = newField;
        } else {
            // Possible rogue mutation of state.fields?
            throw new Error("setValueByPath key mismatch expected '" + newField.key + "' to be '" + node.key + "'");
        }
        return newFields;
    };
    newState.fields = updateField(newState.fields, pathToArray(path));
    return newState;
};

/**
 * Given the current state this finds and returns the value at the given path.
 * returns null when no value is set.
 *
 * @param {object} state
 * @param {string} path
 * @return {any}
 */
var _getValueByPath = function _getValueByPath(state, path) {
    // returns new state with updated value.
    var findFieldByPath = function findFieldByPath(fields) {
        var nodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        var node = nodes[0];
        var field = fields[node.index];
        if (node.key === field.key) {
            if (nodes.length > 1 && Array.isArray(field.fields)) {
                return findFieldByPath(field.fields, nodes.slice(1));
            } else if (nodes.length > 1) {
                // Possible rogue mutation of state.fields?
                throw new Error("getValueByPath path not found '" + path + "'");
            }
            return field;
        } else {
            // Possible rogue mutation of state.fields?
            throw new Error("getValueByPath key mismatch expected '" + field.key + "' to be '" + node.key + "'");
        }
    };
    var value = findFieldByPath(state.fields, pathToArray(path)).value;
    return value !== undefined ? value : null;
};

/**
 * Creates a new state based on the previous one with all field values removed.
 *
 * @param {object} state
 * @return {object}
 */
exports.getValueByPath = _getValueByPath;
var clearFields = exports.clearFields = function clearFields(state) {
    // returns new state with updated value.
    var newState = _extends({}, state);
    var updateField = function updateField(fields) {
        return fields.map(function (field) {
            var newField = _extends({}, field);
            if (Array.isArray(newField.fields)) {
                newField.fields = updateField(newField.fields);
                return newField;
            } else if (newField.value != null) {
                delete newField.value;
                return newField;
            }
            return field;
        });
    };
    newState.fields = updateField(newState.fields);
    return newState;
};

/**
 * Given the current state this find the first field with a value and
 * return true otherwise false.
 *
 * @param {object} state
 * @return {boolean}
 */
var _hasValues = function _hasValues(state) {
    var findValues = function findValues(f) {
        if (f.value != null && (f.value.trim ? f.value.trim() : f.value) !== "") {
            return true; // found value exit fast
        }
        if (Array.isArray(f.fields)) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.keys(f.fields)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var i = _step.value;

                    if (findValues(f.fields[i])) {
                        return true; // found value exit fast
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        return false;
    };
    return findValues(state);
};

exports.hasValues = _hasValues;
var hasFieldType = exports.hasFieldType = function hasFieldType(state, find) {
    var findType = function findType(f) {
        if (f.type && f.type.indexOf(find) !== -1) {
            return true; // found type exit fast
        }
        if (Array.isArray(f.fields)) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Object.keys(f.fields)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var i = _step2.value;

                    if (findType(f.fields[i])) {
                        return true; // found type exit fast
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
        return false;
    };
    return findType(state);
};

var extractSearchToSave = exports.extractSearchToSave = function extractSearchToSave(state) {
    var extract = function extract(f) {
        if (Array.isArray(f.fields)) {
            var packet = null;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = f.fields[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var it = _step3.value;

                    var next = extract(it);
                    if (next != null) {
                        if (packet == null) packet = {};
                        packet[it.key] = next;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            return packet;
        } else if (f.value != null && f.value !== "") {
            switch (f.type) {
                case "time":
                    return f.value.format("HH:mm:ss");
                case "date":
                    return f.value.format("YYYY-MM-DD");
                case "datetime":
                    return f.value.format("YYYY-MM-DDTHH:mm:ss");
                default:
                    return f.value;
            }
        }
        return null;
    };
    return {
        key: state.key,
        useRelativeDates: state.useRelativeDates,
        fields: extract(state) || {}
    };
};

var restoreSavedSearch = exports.restoreSavedSearch = function restoreSavedSearch(state, query) {
    if (!query || !query.key || !query.fields) return state;
    if (state.availableKeys.indexOf(query.key) < 0) return state;
    var inject = function inject(data, f) {
        if (data == null || data === "") return f;
        if (Array.isArray(f.fields)) {
            f = _extends({}, f, {
                fields: f.fields.map(function (it) {
                    if (data.hasOwnProperty(it.key)) {
                        it = inject(data[it.key], it);
                    }
                    return it;
                })
            });
        } else {
            var value = void 0;
            switch (f.type) {
                case "time":
                    value = moment(data, "HH:mm:ss");
                    break;
                case "date":
                    value = moment(data, "YYYY-MM-DD");
                    if (value.year() < 1850) value = null; // never mind
                    break;
                case "datetime":
                    value = moment(data, "YYYY-MM-DDTHH:mm:ss");
                    if (value.year() < 1850) value = null; // never mind
                    break;
                default:
                    value = data;
                    break;
            }
            if (value != null) {
                f = _extends({}, f, {
                    value: value
                });
            }
        }
        return f;
    };
    state = clearFields(state);
    if (state.key !== query.key || state.useRelativeDates !== query.useRelativeDates) {
        state.useRelativeDates = query.useRelativeDates;
        state = selectStereotype({ key: query.key }, state);
    }
    return inject(query.fields, state);
};

var toQ = exports.toQ = function toQ(state) {
    var convertType = function convertType(type) {
        switch (type) {
            case "date":
                return "DATE";
            case "datetime":
                return "DATETIME";
            case "time":
                return "TIME";
            case "string":
                return "STRING";
            case "checkbox":
                return "BOOLEAN";
            default:
                throw new Error("Unknown type: '" + type + "'");
        }
    };
    var getSubField = function getSubField(fs, key) {
        return fs.find(function (f) {
            return f.key === key;
        });
    };
    var subvalue = function subvalue(fs, key) {
        var f = getSubField(fs, key);
        if (f == null || !f.value) {
            return null;
        }
        return _Q2.default.value(f.value, convertType(f.type));
    };
    var orMissing = function orMissing(q, f, base) {
        var includeNulls = subvalue(f.fields, f.key + "missing") === _Q2.default.true();
        return base === _Q2.default.true() ? includeNulls ? q.isNull() : q.isNotNull() : includeNulls ? q.isNull().or(base) : q.isNotNull().and(base);
    };
    var doField = function doField(q, f) {
        if (!_hasValues(f)) {
            return _Q2.default.true();
        }
        if (/relative/.test(f.type)) {
            var field = getSubField(f.fields, f.key + "lastndays");
            var value = field.value;
            if (f == null || !value) {
                return orMissing(q, f, _Q2.default.true());
            }
            var baseType = f.type.replace(/relative/, "");
            var minValue = void 0,
                maxValue = void 0;
            if (value === "today") {
                maxValue = moment();
                minValue = moment().startOf("day");
            } else {
                var _value$split = value.split(","),
                    _value$split2 = _slicedToArray(_value$split, 2),
                    v = _value$split2[0],
                    unit = _value$split2[1];

                maxValue = moment().startOf("day");
                // This is old version of momentjs 1.7.2
                minValue = moment().subtract(unit, parseInt(v, 10));
                // moment 2.7.0
                //minValue = maxValue.subtract(parseInt(v, 10), unit); // also note the unit values have changed from 'days' to 'day'
            }
            return orMissing(q, f, q.between(_Q2.default.value(minValue, convertType(baseType)), _Q2.default.value(maxValue, convertType(baseType))));
        }
        if (/range$/.test(f.type)) {
            return orMissing(q, f, q.between(subvalue(f.fields, f.key + "min"), subvalue(f.fields, f.key + "max")));
        }
        if (/ormissing$/.test(f.type)) {
            return orMissing(q, f, doField(q, f.fields[0]));
        }
        switch (f.type) {
            case "integer":
                return q.eq(_Q2.default.value(f.value, "INTEGER"));
            case "decimal":
                return q.eq(_Q2.default.value(f.value, "DECIMAL"));
            case "time":
                return q.eq(_Q2.default.value(f.value, "TIME"));
            case "date":
                return q.eq(_Q2.default.value(f.value, "DATE"));
            case "datetime":
                return q.eq(_Q2.default.value(f.value, "DATETIME"));
            case "string":
                return q.contains(_Q2.default.value(f.value, "STRING"));
            case "to-one":
                return doFields(q, f.fields);
            case "to-many":
                var sub = doFields(_Q2.default.ref("it" /*com.armus.script.transform.MapperBinder.ITEM_NAME*/), f.fields);
                return sub === _Q2.default.true() ? _Q2.default.true() : q.any(sub);
            default:
                throw new Error("Field '" + f.key + "' has an unrecognized type: '" + f.type + "'");
        }
    };
    var doFields = function doFields(base, fields) {
        return _Q2.default.conjunction(fields.map(function (f) {
            var q = base == null ? _Q2.default.ref(f.key) : base.dot(f.key);
            return doField(q, f);
        }));
    };
    return doFields(null, state.fields);
};

var toHuman = exports.toHuman = function toHuman(state) {
    var IS_MISSING = Object.create(null);
    var formatValue = function formatValue(value, type) {
        switch (type) {
            case "integer":
            case "decimal":
            case "string":
            case "checkbox":
                return value;
            case "date":
                return value.format("M/D/YYYY");
            case "datetime":
                return value.format("M/D/YYYY h:mm a");
            case "time":
                return value.format("h:mm a");
            default:
                throw new Error("Unknown type: '" + type + "'");
        }
    };
    var getSubField = function getSubField(fs, key) {
        return fs.find(function (f) {
            return f.key === key;
        });
    };
    var subvalue = function subvalue(fs, key) {
        var f = getSubField(fs, key);
        if (f == null || !f.value) {
            return null;
        }
        return formatValue(f.value, f.type);
    };
    var orMissing = function orMissing(f, base) {
        if (!subvalue(f.fields, f.key + "missing")) {
            return base;
        }
        if (base == null) {
            return IS_MISSING;
        }
        return base + " or missing";
    };
    var doField = function doField(prefix, f) {
        if (!_hasValues(f)) {
            return null;
        }
        if (/relative/.test(f.type)) {
            var field = getSubField(f.fields, f.key + "lastndays");
            return orMissing(f, "last " + field.value.replace(/,/, " "));
        }
        if (/range$/.test(f.type)) {
            var min = subvalue(f.fields, f.key + "min");
            var max = subvalue(f.fields, f.key + "max");
            var base = void 0;
            if (min == null) {
                if (max == null) base = null;else base = "before " + max;
            } else {
                if (max == null) base = "after " + min;else base = min + "-" + max;
            }
            return orMissing(f, base);
        }
        if (/ormissing$/.test(f.type)) {
            return orMissing(f, doField(prefix, f.fields[0]));
        }
        switch (f.type) {
            case "integer":
            case "decimal":
            case "time":
            case "date":
            case "datetime":
            case "string":
                return formatValue(f.value, f.type);
            case "to-one":
            case "to-many":
                return doFields(makeLabel(prefix, f.name), f.fields);
            default:
                throw new Error("Field '" + f.key + "' has an unrecognized type: '" + f.type + "'");
        }
    };
    var makeLabel = function makeLabel(prefix, name) {
        return prefix ? prefix + " " + name : name;
    };
    var doFields = function doFields(prefix, fields) {
        return fields.flatMap(function (f) {
            var val = doField(prefix, f);
            if (val == null) return null;
            if (val instanceof Array) return val;
            return makeLabel(prefix, f.name) + (val === IS_MISSING ? " is missing" : ": " + val);
        }).filter(function (it) {
            return it;
        });
    };
    return doFields(null, state.fields).join(", ");
};

/**
 * Create new array with values copied from sourceFields to destinationFields
 * when matching keys are found.
 *
 * @param {array} destinationFields
 * @param {array} sourceFields
 * @returns {array}
 */
var copyFieldValuesByKey = exports.copyFieldValuesByKey = function copyFieldValuesByKey(destinationFields, sourceFields) {
    var newFields = [].concat(_toConsumableArray(destinationFields));
    var updateField = function updateField(dFields, findField) {
        return dFields.forEach(function (field, index) {
            var newField = _extends({}, field);
            if (Array.isArray(newField.fields)) {
                updateField(newField.fields, findField);
            }

            // make sure to check stereotype
            var newKeyPath = newField.stereotypeKey + newField.key;
            var findKeyPath = findField.stereotypeKey + findField.key;

            if (newKeyPath === findKeyPath && // only copy same key
            newField.type === findField.type && // only copy same type values
            findField.value != null && findField.value !== "" // ignore
            ) {
                    newField.value = findField.value;
                    dFields[index] = newField;
                }
        });
    };
    var copyValuesToDestination = function copyValuesToDestination(fields, dFields) {
        return fields.forEach(function (field) {
            if (Array.isArray(field.fields)) {
                copyValuesToDestination(field.fields, dFields);
            }
            if (field.value !== null && field.value !== undefined && field.value !== "") {
                // set destination key value
                updateField(dFields, field);
            }
        });
    };
    copyValuesToDestination(sourceFields, newFields);
    return newFields;
};

function selectStereotype(action, contextState) {
    var rawFields = void 0,
        copyValues = void 0;
    var stereoKey = action.key || contextState.key;
    var useRelativeDates = action.useRelativeDates !== undefined ? action.useRelativeDates : contextState.useRelativeDates;
    if (action.fields) {
        // a custom schmanky (mapping search)
        rawFields = action.fields;
    } else {
        // normal stereotype-based thinger
        rawFields = _StereotypesStore2.default.getStereotypeFieldsByKey(stereoKey);
        copyValues = contextState.fields;
    }
    var options = {
        useRelativeDates: useRelativeDates,
        useDateRanges: action.useDateRanges !== undefined ? action.useDateRanges : true,
        // this is searched _after_ range processing
        useMissingCheckbox: action.useMissingCheckbox !== undefined ? action.useMissingCheckbox : "string,daterange,datetimerange,daterelative,datetimerelative"
    };
    if (_EntityName2.default.is(stereoKey)) {
        rawFields = rawFields.filter(function (f) {
            return !(0, _isFieldHidden2.default)(stereoKey, f.key);
        });
    }
    var fields = buildKeyPaths(options, rawFields);
    if (copyValues && Array.isArray(copyValues)) {
        fields = copyFieldValuesByKey(fields, copyValues);
    }
    return _extends({}, contextState, {
        fields: fields,
        key: stereoKey,
        useRelativeDates: useRelativeDates
    });
}

var restoreDefaultSearchOtherwise = function restoreDefaultSearchOtherwise(state, otherwiseWork) {
    var defaultSearch = _userStore2.default.getDefaultSearchConfig();
    if (defaultSearch.enabled) {
        return restoreSearchOtherwise(state, defaultSearch.query, otherwiseWork);
    } else {
        return otherwiseWork();
    }
};

var restoreSearchOtherwise = function restoreSearchOtherwise(state, query, otherwiseWork) {
    if (query && state.availableKeys.indexOf(query.key) >= 0) {
        return restoreSavedSearch(_extends({}, state, {
            page: 1,
            sorts: {}
        }), query);
    } else {
        return otherwiseWork();
    }
};

var restoreDeepLinkOtherwise = function restoreDeepLinkOtherwise(state, otherwiseWork) {
    var link = state.__deepLink,
        next = _objectWithoutProperties(state, ["__deepLink"]);

    next = selectStereotype(link, next);
    var fields = {};
    var addVal = function addVal(fs, path, v) {
        var k = path.shift();
        if (path.length === 0) {
            var _fs$k;

            fs[k] = (_fs$k = {}, _defineProperty(_fs$k, k + "val", v), _defineProperty(_fs$k, k + "min", v), _defineProperty(_fs$k, k + "max", v), _fs$k);
        } else {
            if (!fs.hasOwnProperty(k)) {
                fs[k] = {};
            }
            addVal(fs[k], path, v);
        }
    };
    link.fieldData.forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            k = _ref2[0],
            v = _ref2[1];

        return addVal(fields, k.split("."), v);
    });
    var query = {
        key: link.key,
        fields: fields
    };
    return restoreSavedSearch(next, query);
};

var SearchFormStore = exports.SearchFormStore = function (_ContextedReduceStore) {
    _inherits(SearchFormStore, _ContextedReduceStore);

    function SearchFormStore() {
        _classCallCheck(this, SearchFormStore);

        return _possibleConstructorReturn(this, (SearchFormStore.__proto__ || Object.getPrototypeOf(SearchFormStore)).apply(this, arguments));
    }

    _createClass(SearchFormStore, [{
        key: "getInitialContext",
        value: function getInitialContext() {
            return {
                page: 1, // server index at 1
                pageSize: 25,
                sorts: {},
                fields: [],
                key: "",
                availableKeys: [],
                selectedResult: null,
                useRelativeDates: false,
                __deepLink: null
            };
        }
    }, {
        key: "reduceContext",
        value: function reduceContext(contextState, action) {
            switch (action.type) {

                case _SearchFormActions2.default.DEEP_LINKED_SEARCH:
                    {
                        return _extends({}, contextState, {
                            __deepLink: {
                                key: action.key,
                                fieldData: action.fieldData
                            }
                        });
                    }

                case _SearchFormActions2.default.INITIALIZE_CONTEXT:
                    {
                        if (contextState.key) return contextState;
                        contextState = _extends({}, contextState, {
                            availableKeys: action.availableKeys
                        });
                        var otherwiseWork = function otherwiseWork() {
                            return selectStereotype(action, contextState);
                        };
                        if (action.query) {
                            return restoreSearchOtherwise(contextState, action.query, otherwiseWork);
                        } else if (contextState.__deepLink) {
                            action.initiateSearch = true;
                            return restoreDeepLinkOtherwise(contextState, otherwiseWork);
                        } else if (action.useDefaultSearch) {
                            return restoreDefaultSearchOtherwise(contextState, otherwiseWork);
                        } else {
                            return otherwiseWork();
                        }
                    }

                case _SearchFormActions2.default.INITIATE_SEARCH:
                case _SearchFormActions2.default.INITIATE_SEARCH_AND_SAVE_DEFAULT:
                    {
                        contextState = _extends({}, contextState, {
                            page: 1
                        });
                        return contextState;
                    }
                case _SearchFormActions2.default.RESTORE_DEFAULT_AND_INITIATE_SEARCH:
                    {
                        return restoreDefaultSearchOtherwise(contextState, function () {
                            return clearFields(contextState);
                        });
                    }
                case _MergeActions2.default.LAUNCH_DIALOG:
                    {
                        return selectStereotype(_extends({}, action, { key: action.target.stereoKey }), contextState);
                    }
                case _SearchFormActions2.default.SELECT_STEREOTYPE:
                    {
                        return selectStereotype(action, contextState);
                    }
                case _SearchFormActions2.default.SET_USE_RELATIVE_DATES:
                    return selectStereotype(action, contextState);
                case _SearchFormActions2.default.SET_FIELD:
                    return setValueByPath(contextState, action.path, action.value);
                case _MergeActions2.default.CANCEL_FOR_SOURCE_OPTLOCK:
                case _MergeActions2.default.CANCEL:
                case _SearchFormActions2.default.CLEAR_FIELDS:
                    return clearFields(contextState);

                case _SearchFormActions2.default.SORT:
                    {
                        var newContextState = _extends({}, contextState);
                        var dir = "asc";
                        if (action.sort) {
                            dir = action.sort;
                        } else {
                            var sorts = newContextState.sorts;
                            if (sorts[action.key]) {
                                if (sorts[action.key] === "desc") {
                                    dir = undefined;
                                } else {
                                    dir = "desc";
                                }
                            }
                        }
                        if (dir) {
                            // explicit
                            newContextState.sorts[action.key] = dir;
                        } else {
                            delete newContextState.sorts[action.key];
                        }
                        newContextState.page = 1;
                        return newContextState;
                    }

                case _MapDialogActions2.default.SELECT_PAGE:
                case _SearchFormActions2.default.SELECT_PAGE:
                    return _extends({}, contextState, { page: action.page });
                case _SearchFormActions2.default.SET_PAGE_SIZE:
                    return _extends({}, contextState, { pageSize: action.pageSize });

                case _SearchFormActions2.default.SELECT_RESULT:
                    {
                        return _extends({}, contextState, {
                            selectedResult: {
                                key: action.result.key,
                                id: action.result.id
                            }
                        });
                    }

                default:
                    return contextState;
            }
        }
    }, {
        key: "reduceEachContext",
        value: function reduceEachContext(ctx, action, contextId) {
            switch (action.type) {
                case _MappingActions2.default.IT_IS_DONE:
                    {
                        if (!(0, _MergeStore.isMergeContext)(contextId)) return ctx;
                        if (_MergeStore2.default.isReady()) return ctx;
                        if (_MergeStore2.default.getPluginKey() == _MergeStore.MERGE_PLUGINS.GLOBAL_MERGE) return ctx;
                        return clearFields(ctx);
                    }
                case _SuperRecordActions2.default.UPDATED:
                    {
                        if (!(0, _MergeStore.isMergeContext)(contextId)) return ctx;
                        if (_MergeStore2.default.isReady()) return ctx;
                        if (_MergeStore2.default.getPluginKey() !== _MergeStore.MERGE_PLUGINS.GLOBAL_MERGE) return ctx;
                        return clearFields(ctx);
                    }
                default:
                    return ctx;
            }
        }
    }, {
        key: "getKey",
        value: function getKey(context) {
            return this.getState(context).key || _StereotypesStore2.default.getDefaultKey();
        }
    }, {
        key: "getAvailableKeys",
        value: function getAvailableKeys(context) {
            return this.getState(context).availableKeys;
        }
    }, {
        key: "getFields",
        value: function getFields(context) {
            return this.getState(context).fields;
        }
    }, {
        key: "getSearchToSave",
        value: function getSearchToSave(context) {
            return extractSearchToSave(this.getState(context));
        }
    }, {
        key: "getSorts",
        value: function getSorts(context) {
            return this.getState(context).sorts;
        }
    }, {
        key: "getPage",
        value: function getPage(context) {
            return this.getState(context).page;
        }
    }, {
        key: "getPageSize",
        value: function getPageSize(context) {
            return this.getState(context).pageSize;
        }
    }, {
        key: "hasValues",
        value: function hasValues(context) {
            return _hasValues(this.getState(context));
        }
    }, {
        key: "hasDateFields",
        value: function hasDateFields(context) {
            return hasFieldType(this.getState(context), "date");
        }
    }, {
        key: "getValueByPath",
        value: function getValueByPath(context, path) {
            return _getValueByPath(this.getState(context), path);
        }
    }, {
        key: "getQ",
        value: function getQ(context) {
            return toQ(this.getState(context));
        }
    }, {
        key: "getHuman",
        value: function getHuman(context) {
            return toHuman(this.getState(context));
        }
    }, {
        key: "getUseRelativeDates",
        value: function getUseRelativeDates(context) {
            return this.getState(context).useRelativeDates;
        }
    }, {
        key: "getSearchArgs",
        value: function getSearchArgs(context) {
            // key, query, order, pageSize = 100, page = 1
            var s = this.getState(context);
            return [s.key, toQ(s).toAS(), (0, _sortsToOrder2.default)(s.sorts), s.pageSize, s.page];
        }
    }, {
        key: "getSelectedResult",
        value: function getSelectedResult(context) {
            return this.getState(context).selectedResult;
        }
    }]);

    return SearchFormStore;
}(_ContextedReduceStore3.default);

SearchFormStore.contextTypes = {
    key: _propTypes2.default.string.isRequired,
    page: _propTypes2.default.number,
    pageSize: _propTypes2.default.number,
    sorts: _propTypes2.default.object,
    fields: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        name: _propTypes2.default.string.isRequired,
        key: _propTypes2.default.string.isRequired,
        type: _propTypes2.default.string.isRequired,
        path: _propTypes2.default.string.isRequired,
        value: _propTypes2.default.any
    })),
    selectedResult: _propTypes2.default.shape({
        key: _propTypes2.default.string.isRequired,
        id: _propTypes2.default.number.isRequired
    })
};

exports.default = (0, _typeCheckingStore2.default)(new SearchFormStore(_Dispatcher2.default));

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Base class for all models.
var Model = function (_Backbone$Model) {
    _inherits(Model, _Backbone$Model);

    function Model() {
        _classCallCheck(this, Model);

        return _possibleConstructorReturn(this, (Model.__proto__ || Object.getPrototypeOf(Model)).apply(this, arguments));
    }

    return Model;
}(Backbone.Model);

exports.default = Model;

/***/ }),
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ContextedReduceStore = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * This function uses a bit of JS trickery in order to "hide" a proptypes def
 * on a string, which will then be used by ValidatingDispatcher to validate that
 * actions of this type are dispatched with the correct shape.
 *
 * NB: the 'type' and `ACTION_CONTEXT_KEY` keys are implicitly allowed for any
 * action.
 */
var typedAction = function typedAction(name, shape) {
    if (shape == null) {
        throw new Error("typedAction must be passed a non-null shape");
    }
    // noinspection JSPrimitiveTypeWrapperUsage
    name = new String(name); // eslint-disable-line no-new-wrappers
    // noinspection JSPrimitiveTypeWrapperUsage
    name.actionTypes = {
        action: _propTypes2.default.shape(_extends({}, shape, _defineProperty({
            type: _propTypes2.default.instanceOf(String).isRequired
        }, _ContextedReduceStore.ACTION_CONTEXT_KEY, _propTypes2.default.string))).isRequired
    };
    return name;
};

exports.default =  true ? function (name) {
    return name;
} : typedAction;

/***/ }),
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dateToString = exports.isDateRangeValid = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Date = __webpack_require__(957);

var _Date2 = _interopRequireDefault(_Date);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var quarters = {
    start: [{ m: "01", d: "01", label: "Q1 (Jan 1)" }, { m: "04", d: "01", label: "Q2 (Apr 1)" }, { m: "07", d: "01", label: "Q3 (Jul 1)" }, { m: "10", d: "01", label: "Q4 (Oct 1)" }],
    end: [{ m: "03", d: "31", label: "Q1 (Mar 31)" }, { m: "06", d: "30", label: "Q2 (Jun 30)" }, { m: "09", d: "30", label: "Q3 (Sep 30)" }, { m: "12", d: "31", label: "Q4 (Dec 31)" }]
};
var allQuarters = [].concat(_toConsumableArray(quarters.start), _toConsumableArray(quarters.end));

var isDateRangeValid = exports.isDateRangeValid = function isDateRangeValid(start, end) {
    if (!start) {
        return false;
    }
    if (!end) {
        return false;
    }
    return start <= end;
};

function zeroPad(it, len) {
    it = it.toString();
    if (it.length === 0) return it;
    while (it.length < len) {
        it = "0" + it;
    }return it;
}

var dateToString = exports.dateToString = function dateToString(v) {
    if (typeof v === "string") {
        return v;
    }
    if ((typeof v === "undefined" ? "undefined" : _typeof(v)) === "object") {
        if (typeof v.format === "function") {
            return v.format("YYYY-MM-DD");
        }
        if (typeof v.getDate === "function") {
            return [zeroPad(v.getFullYear(), 4), zeroPad(v.getMonth() + 1, 2), zeroPad(v.getDate(), 2)].join("-");
        }
    }
    if (Array.isArray(v)) {
        return v.join("-");
    }
    return ""; // not sure what we got for a date.
};

var getYMD = function getYMD(v) {
    var parts = void 0;
    if (typeof v === "string") {
        var _v$split = v.split("-"),
            _v$split2 = _slicedToArray(_v$split, 3),
            y = _v$split2[0],
            m = _v$split2[1],
            d = _v$split2[2];

        y = parseInt(y, 10);
        m = parseInt(m, 10);
        d = parseInt(d, 10);
        parts = [y, m, d];
    } else if (v instanceof _Date2.default) {
        parts = [v.getFullYear(), v.getMonth() + 1, v.getDate()];
    } else if (Array.isArray(v)) {
        parts = [v[0], v[1], v[2]];
    } else {
        parts = ["", "", ""]; // not sure what we got for a date.
    }
    return [zeroPad(parts[0], 4), zeroPad(parts[1], 2), zeroPad(parts[2], 2)];
};

var getQuarter = function getQuarter(v) {
    // returns the valid quarter value or false;
    if (!v) return false;

    var _getYMD = getYMD(v),
        _getYMD2 = _slicedToArray(_getYMD, 3),
        m = _getYMD2[1],
        d = _getYMD2[2];

    for (var i in allQuarters) {
        if (allQuarters[i].m === m && allQuarters[i].d === d) {
            return v;
        }
    }
    return false;
};

var isQuarter = function isQuarter(v) {
    return !!getQuarter(v);
};

function dissectValue(value) {
    var year = "",
        month = "",
        day = "",
        monthDay = "";
    if (isQuarter(value)) {
        var _getYMD3 = getYMD(value);

        var _getYMD4 = _slicedToArray(_getYMD3, 3);

        year = _getYMD4[0];
        month = _getYMD4[1];
        day = _getYMD4[2];

        monthDay = month + "-" + day;
    }
    return { y: year, md: monthDay };
}

var QuarterSelect = function QuarterSelect(_ref) {
    var options = _ref.options,
        value = _ref.value,
        min = _ref.min,
        max = _ref.max,
        onChange = _ref.onChange,
        disabled = _ref.disabled,
        _ref$required = _ref.required,
        required = _ref$required === undefined ? false : _ref$required,
        props = _objectWithoutProperties(_ref, ["options", "value", "min", "max", "onChange", "disabled", "required"]);

    var _React$useState = _react2.default.useState(function () {
        return dissectValue(value);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(dissectValue(value));
    }, [value]);
    var handleChange = function handleChange(key, value) {
        // construct date from quarter + year
        var nextState = void 0;
        if (key === "quarter") {
            nextState = _extends({}, state, { md: value });
        } else {
            nextState = _extends({}, state, { y: value });
        }
        if (!!nextState.y && !!nextState.md) {
            onChange(nextState.y + "-" + nextState.md);
        } else {
            onChange("");
        }
        setState(nextState);
    };
    var minYear = min[0],
        maxYear = max[0];
    var years = [];
    for (var i = maxYear; i >= minYear; i--) {
        years.push(i.toString());
    }

    var quarterOptions = options.map(function (o) {
        return { label: o.label, value: o.m + "-" + o.d };
    });
    quarterOptions.unshift({ label: "", value: "" });
    var yearOptions = years.map(function (y) {
        return { label: y, value: y };
    });
    yearOptions.unshift({ label: "", value: "" });

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            "div",
            { className: "col-sm-7" },
            _react2.default.createElement(_Select2.default, {
                value: state.md,
                width: "100%",
                className: "quarter_select quarter_from partdep form-control",
                disabled: disabled,
                onCommitChange: function onCommitChange(v) {
                    return handleChange("quarter", v);
                },
                options: quarterOptions,
                required: required
            })
        ),
        _react2.default.createElement(
            "div",
            { className: "col-sm-5" },
            _react2.default.createElement(_Select2.default, {
                value: state.y,
                className: "year_select year_from partdep form-control",
                disabled: disabled,
                onCommitChange: function onCommitChange(v) {
                    return handleChange("year", v);
                },
                options: yearOptions,
                required: required
            })
        )
    );
};

QuarterSelect.propTypes = {
    options: _propTypes2.default.array,
    value: _propTypes2.default.string,
    min: _propTypes2.default.array,
    max: _propTypes2.default.array,
    onChange: _propTypes2.default.func,
    disabled: _propTypes2.default.bool,
    required: _propTypes2.default.bool
};

var DateRange = function DateRange(_ref2) {
    var start = _ref2.start,
        end = _ref2.end,
        min = _ref2.min,
        max = _ref2.max,
        onChange = _ref2.onChange,
        _ref2$expanded = _ref2.expanded,
        expanded = _ref2$expanded === undefined ? false : _ref2$expanded,
        _ref2$disabled = _ref2.disabled,
        disabled = _ref2$disabled === undefined ? true : _ref2$disabled,
        _ref2$required = _ref2.required,
        required = _ref2$required === undefined ? false : _ref2$required;

    var _React$useState3 = _react2.default.useState(!!start || !!end ? !isQuarter(start) && !isQuarter(end) : false),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        byDate = _React$useState4[0],
        setByDate = _React$useState4[1];

    var handleChange = function handleChange(key, value) {
        if (byDate) {
            value = value ? value.format("YYYY-MM-DD") : "";
        }
        onChange(key, value);
    };

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            "ul",
            { className: "nav nav-tabs" },
            _react2.default.createElement(
                "li",
                { role: "presentation", className: !byDate ? "active" : "" },
                _react2.default.createElement(
                    "a",
                    {
                        href: "#",
                        className: "dateSelect",
                        "data-role": "quarter",
                        onClick: function onClick(e) {
                            e.preventDefault();setByDate(false);
                        }
                    },
                    "By Quarter"
                )
            ),
            _react2.default.createElement(
                "li",
                { role: "presentation", className: byDate ? "active" : "" },
                _react2.default.createElement(
                    "a",
                    {
                        href: "#",
                        className: "dateSelect",
                        "data-role": "date",
                        onClick: function onClick(e) {
                            e.preventDefault();setByDate(true);
                        }
                    },
                    "By Date"
                )
            )
        ),
        _react2.default.createElement("br", null),
        !!byDate ? _react2.default.createElement(
            "div",
            { className: "dateFields export-datecontrols" },
            _react2.default.createElement(
                "div",
                { className: "form-group" },
                _react2.default.createElement(
                    "div",
                    { className: "col-sm-12" },
                    _react2.default.createElement(
                        "div",
                        { id: "date_from", className: "date partdep" },
                        _react2.default.createElement(_Date2.default, {
                            value: start,
                            disabled: disabled,
                            onCommitChange: function onCommitChange(v) {
                                return handleChange("start", v);
                            },
                            required: required
                        })
                    )
                )
            ),
            _react2.default.createElement(
                "div",
                { className: "form-group" },
                _react2.default.createElement(
                    "div",
                    { className: "col-sm-12" },
                    _react2.default.createElement(
                        "div",
                        { id: "date_to", className: "date partdep" },
                        _react2.default.createElement(_Date2.default, {
                            value: end,
                            disabled: disabled,
                            onCommitChange: function onCommitChange(v) {
                                return handleChange("end", v);
                            },
                            required: required
                        })
                    )
                )
            )
        ) : _react2.default.createElement(
            "div",
            { className: "quarterFields export-datecontrols" },
            _react2.default.createElement(
                "div",
                { className: "form-group row" },
                _react2.default.createElement(QuarterSelect, {
                    options: quarters.start,
                    value: start,
                    min: min,
                    max: max,
                    onChange: function onChange(v) {
                        return handleChange("start", v);
                    },
                    disabled: disabled,
                    required: required
                })
            ),
            _react2.default.createElement(
                "div",
                { className: "form-group row" },
                _react2.default.createElement(QuarterSelect, {
                    options: quarters.end,
                    value: end,
                    min: min,
                    max: max,
                    onChange: function onChange(v) {
                        return handleChange("end", v);
                    },
                    disabled: disabled,
                    required: required
                })
            )
        ),
        start && end && !isDateRangeValid(start, end) && _react2.default.createElement(
            "div",
            {
                className: "alert alert-danger after-form-group"
            },
            byDate ? "Start date cannot be after end date." : "Start quarter cannot be after end quarter."
        )
    );
};

DateRange.propTypes = {
    start: _propTypes2.default.string,
    end: _propTypes2.default.string,
    min: _propTypes2.default.array,
    max: _propTypes2.default.array,
    onChange: _propTypes2.default.func,
    expanded: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    required: _propTypes2.default.bool
};

exports.default = DateRange;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = serializeParams;
exports.toCommaSafeArray = toCommaSafeArray;
exports.fromCommaSafeArray = fromCommaSafeArray;
exports.stringifyJson = stringifyJson;
exports.unstringifyJson = unstringifyJson;
var COMMA_SAFE_ARRAY_AUGMENTATION = "!@#$%^&*(comma-safe)*&^%$#@!"; // keep in sync with hybrid-web-export

/**
 * I accept an object containing parameters to send w/ an XHR request and
 * convert them to a query string. Of particular note, array parameters are
 * serialized as multiple instances of "the same" parameter, with no suffix.
 * This is in contrast to jQuery, which adds "[]" to array params to support
 * PHP which will ignore repeated params of the same name (keeping on the last)
 * unless the name itself indicates that the param is supposed to be an array
 * (via the suffix). Yay for dynamic languages? This doesn't do that.
 *
 * @param params an object w/ param names for keys and param values as values.
 * @return {string} a query string version of the params.
 */
function serializeParams(params) {
    if (!params) return "";
    var result = [];
    Object.keys(params).forEach(function (name) {
        var value = params[name];
        if (value instanceof Array) {
            value.forEach(function (it) {
                return result.push([name, it]);
            });
        } else {
            result.push([name, value]);
        }
    });
    return result.map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            n = _ref2[0],
            v = _ref2[1];

        return encodeURIComponent(n) + "=" + encodeURIComponent(v);
    }).join("&");
}

/**
 * I accept an object containing parameters to send w/ an XHR request, along
 * with varargs of keys which are array that need to be made comma-safe. For
 * example, the values <tt>"jones, john"</tt> and <tt>["jones, john"]</tt> will
 * serialize to the same query string: <tt>?key=jones%2C%20john</tt>. If the
 * server accepts a list, it will treat the in-value comma as a delimiter, and
 * assume <tt>["jones", " john"]</tt> was intended. By passing an extra garbage
 * parameter of the same name (e.g., <tt>?key=jones%2C%20john&key=garbage</tt>),
 * the server will assume that each same-named parameter is a single value, that
 * is <tt>>["jones, john", "garbage"]</tt> was intended.
 *
 * <p>If the array contains the empty string as its sole value, the entire param
 * key will be deleted instead.
 *
 * <p>This is pretty kludge, but such is life.
 *
 * @param params an object w/ param names for keys and param values as values.
 * @param paramKeys an array of param names that should be made comma safe.
 * @return {object} an updated params object with comma-safe array parameters.
 */
function toCommaSafeArray(params) {
    params = _extends({}, params);

    for (var _len = arguments.length, paramKeys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        paramKeys[_key - 1] = arguments[_key];
    }

    paramKeys.forEach(function (k) {
        if (params[k] && params[k].length === 1) {
            if (params[k][0] === "") {
                delete params[k];
            } else {
                params[k] = params[k].concat(COMMA_SAFE_ARRAY_AUGMENTATION);
            }
        }
    });
    return params;
}

/**
 * I reverse what {@link toCommaSafeArray} does.
 * @param params
 * @param paramKeys
 * @return {*}
 */
function fromCommaSafeArray(params) {
    params = _extends({}, params);

    for (var _len2 = arguments.length, paramKeys = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        paramKeys[_key2 - 1] = arguments[_key2];
    }

    paramKeys.forEach(function (k) {
        if (!params[k] || params[k].length === 0) {
            params[k] = [""]; // all
        } else {
            params[k] = params[k].filter(function (it) {
                return it !== COMMA_SAFE_ARRAY_AUGMENTATION;
            });
        }
    });
    return params;
}

function stringifyJson(params) {
    params = _extends({}, params);

    for (var _len3 = arguments.length, paramKeys = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        paramKeys[_key3 - 1] = arguments[_key3];
    }

    paramKeys.forEach(function (k) {
        if (params[k] && typeof params[k] !== "string") {
            params[k] = JSON.stringify(params[k]);
        }
    });
    return params;
}

function unstringifyJson(params) {
    params = _extends({}, params);

    for (var _len4 = arguments.length, paramKeys = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        paramKeys[_key4 - 1] = arguments[_key4];
    }

    paramKeys.forEach(function (k) {
        if (typeof params[k] === "string") {
            try {
                params[k] = JSON.parse(params[k]);
            } catch (e) {
                console.warn("failed to deserialize " + k, e, params[k]);
                params[k] = {}; // bummer
            }
        }
    });
    return params;
}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * I convert a thenable into an actual Promise. Looking at you, jQuery.Deferred.
 * If passed a Promise, it will be returned unchanged. If an Error is passed,
 * it will be wrapped as a rejected Promise. If anything else (i.e., a
 * non-Promise, non-thenable, non-Error value) is passed, it will be wrapped
 * with a resolved Promise.
 */
var promisify = function promisify(thenable) {
    if (thenable instanceof Promise) {
        return thenable;
    } else if (typeof thenable.then === "function") {
        return new Promise(function (resolve, reject) {
            return thenable.then(resolve, reject);
        });
    } else if (thenable instanceof Error) {
        return Promise.reject(thenable);
    } else {
        return Promise.resolve(thenable);
    }
};

exports.default = promisify;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var DevelopmentActions = {
    // IT manifest
    START_IT_MANIFEST_LOAD: "development/start-it-manifest-load",
    IT_MANIFEST_LOADED: "development/it-manifest-loaded",
    IT_MANIFEST_ERROR: "development/it-manifest-error",
    // IT test
    SELECT_IT_TEST: "development/select-it-test",
    AD_HOC_IT_TEST: "development/ad-hoc-it-test",
    IT_TEST_SUCCESS: "development/it-test-success",
    IT_TEST_ERROR: "development/it-test-error",
    RESET_IT_TEST_STATUS: "development/reset-it-test-status",
    // mockset manifest
    START_MOCKSET_MANIFEST_LOAD: "development/start-mockset-manifest-load",
    MOCKSET_MANIFEST_LOADED: "development/mockset-manifest-loaded",
    MOCKSET_MANIFEST_ERROR: "development/mockset-manifest-error",
    // mockset
    SELECT_MOCKSET: "development/select-mockset"
};

exports.default = DevelopmentActions;

/***/ }),
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.asMarionetteView = asMarionetteView;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(154);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RESERVED_WORDS = ["key", "ref"];

function asMarionetteView(WrappedComponent) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var viewClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Backbone.Marionette.View;


    return function (_viewClass$extend) {
        _inherits(MarionetteAdapter, _viewClass$extend);

        function MarionetteAdapter() {
            _classCallCheck(this, MarionetteAdapter);

            return _possibleConstructorReturn(this, (MarionetteAdapter.__proto__ || Object.getPrototypeOf(MarionetteAdapter)).apply(this, arguments));
        }

        _createClass(MarionetteAdapter, [{
            key: "initialize",
            value: function initialize(options) {
                var _this2 = this;

                this.options = options || {};
                this.options.view = this;
                var violatingOptions = RESERVED_WORDS.filter(function (w) {
                    return _this2.options.hasOwnProperty(w);
                });
                if (violatingOptions.length) {
                    throw new Error("Reserved words were found in options: " + violatingOptions + ". Please rename them.");
                }
            }
        }, {
            key: "render",
            value: function render() {
                this.el.dataset.wrappedReactComponent = WrappedComponent.displayName || WrappedComponent.name || "Component";
                _reactDom2.default.render(_react2.default.createElement(WrappedComponent, this.options), this.el);
            }
        }, {
            key: "onBeforeClose",
            value: function onBeforeClose() {
                _reactDom2.default.unmountComponentAtNode(this.el);
            }
        }]);

        return MarionetteAdapter;
    }(viewClass.extend(opts));
}

/***/ }),
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ControlResolver = __webpack_require__(139);

var _ControlResolver2 = _interopRequireDefault(_ControlResolver);

var _formhelpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Form = function (_React$Component) {
    _inherits(Form, _React$Component);

    function Form() {
        _classCallCheck(this, Form);

        return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
    }

    _createClass(Form, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                descriptor = _props.descriptor,
                propsResolver = _props.propsResolver;

            return descriptor.childItems.map(function (itemDescriptor) {
                var controlProps = _extends({}, _this2.props, {
                    propsResolver: propsResolver,
                    descriptor: itemDescriptor }, propsResolver(itemDescriptor));
                var Control = (0, _ControlResolver2.default)(controlProps.descriptor);

                return _react2.default.createElement(Control, _extends({
                    key: controlProps.descriptor.key
                }, controlProps));
            });
        }
    }]);

    return Form;
}(_react2.default.Component);

Form.defaultProps = {
    descriptor: {},
    controlOnly: false,
    placeholder: false,
    childItems: []
};

Form.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)(null, false, true), {
    propsResolver: _propTypes2.default.func.isRequired,
    onCommitChange: _propTypes2.default.func // not required
});

exports.default = Form;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var hasAnyChecked = function hasAnyChecked() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var hasFieldEntity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    for (var i in data.fields) {
        var it = data.fields[i];
        if (hasFieldEntity) {
            if (state[it.entity].includes(it.key)) return true;
        } else {
            if (state[data.key].includes(it.key)) return true;
        }
    }
    return false;
};

var OptionGroupItem = function OptionGroupItem(_ref) {
    var _ref$state = _ref.state,
        state = _ref$state === undefined ? {} : _ref$state,
        _ref$data = _ref.data,
        data = _ref$data === undefined ? {} : _ref$data,
        onChange = _ref.onChange,
        _ref$expanded = _ref.expanded,
        expanded = _ref$expanded === undefined ? false : _ref$expanded,
        _ref$hasFieldEntity = _ref.hasFieldEntity,
        hasFieldEntity = _ref$hasFieldEntity === undefined ? false : _ref$hasFieldEntity;

    var anyChecked = hasAnyChecked(state, data, hasFieldEntity);

    var _React$useState = _react2.default.useState(expanded),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        expand = _React$useState2[0],
        setExpand = _React$useState2[1];

    var handleExpand = function handleExpand() {
        setExpand(!expand);
    };
    var handleChange = function handleChange(key, stateKey) {
        var v = void 0;
        if (state[stateKey].includes(key)) {
            v = state[stateKey].filter(function (it) {
                return it !== key;
            });
        } else {
            v = [].concat(_toConsumableArray(state[stateKey]), [key]);
        }
        onChange(_extends({}, state, _defineProperty({}, stateKey, v)));
    };
    var handleGroupToggle = function handleGroupToggle(e) {
        e.stopPropagation();
        if (hasFieldEntity) {
            var v = _extends({}, state);
            data.fields.forEach(function (it) {
                if (anyChecked) {
                    // remove
                    if (v[it.entity].includes(it.key)) {
                        v[it.entity] = v[it.entity].filter(function (key) {
                            return key !== it.key;
                        });
                    }
                } else {
                    // check
                    v[it.entity].push(it.key);
                }
            });
            onChange(v);
        } else {
            onChange(_extends({}, state, _defineProperty({}, data.key, anyChecked ? [] : data.fields.map(function (it) {
                return it.key;
            }))));
        }
    };
    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            "div",
            { className: "entity group-title " + (expand ? "" : "collapsed"), onClick: handleExpand },
            _react2.default.createElement(
                "span",
                null,
                _react2.default.createElement("input", {
                    type: "checkbox",
                    checked: anyChecked,
                    readOnly: true,
                    onClick: handleGroupToggle
                }),
                " ",
                data.name
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "collapse group-items " + (expand ? "in" : ""), id: data.key },
            data.fields.map(function (f) {
                var stateKey = hasFieldEntity ? f.entity : data.key;
                return _react2.default.createElement(
                    "label",
                    { key: stateKey + "." + f.key },
                    _react2.default.createElement("input", { type: "checkbox",
                        className: "optionalField",
                        checked: state[stateKey].includes(f.key),
                        onChange: function onChange() {
                            return handleChange(f.key, stateKey);
                        },
                        "data-key": f.key,
                        "data-entity": data.key
                    }),
                    " ",
                    _react2.default.createElement(
                        "span",
                        null,
                        f.name
                    )
                );
            })
        )
    );
};

OptionGroupItem.propTypes = {
    state: _propTypes2.default.object,
    data: _propTypes2.default.object,
    onChange: _propTypes2.default.func,
    expanded: _propTypes2.default.bool,
    hasFieldEntity: _propTypes2.default.bool
};

var initializeState = function initializeState(state, data, hasFieldEntity) {
    // make sure state has all the fields
    var keys = {};
    if (hasFieldEntity) {
        data.forEach(function (it) {
            it.fields.forEach(function (f) {
                if (!keys[f.entity]) {
                    keys[f.entity] = [];
                }
            });
        });
    } else {
        data.forEach(function (it) {
            if (!keys[it.key]) {
                keys[it.key] = [];
            }
        });
    }
    return _extends({}, keys, state);
};

var OptionGroup = function OptionGroup(_ref2) {
    var _ref2$title = _ref2.title,
        title = _ref2$title === undefined ? "Fields to include in export:" : _ref2$title,
        state = _ref2.state,
        _ref2$data = _ref2.data,
        data = _ref2$data === undefined ? [] : _ref2$data,
        onChange = _ref2.onChange,
        _ref2$expanded = _ref2.expanded,
        expanded = _ref2$expanded === undefined ? false : _ref2$expanded,
        _ref2$hasFieldEntity = _ref2.hasFieldEntity,
        hasFieldEntity = _ref2$hasFieldEntity === undefined ? false : _ref2$hasFieldEntity;

    state = initializeState(state, data, hasFieldEntity);
    var handleSelectAll = function handleSelectAll(e) {
        e.preventDefault();
        e.stopPropagation();
        var v = {};
        data.forEach(function (it) {
            if (hasFieldEntity) {
                it.fields.forEach(function (f) {
                    if (!v[f.entity]) {
                        v[f.entity] = [];
                    }
                    v[f.entity].push(f.key);
                });
            } else {
                v[it.key] = it.fields.map(function (f) {
                    return f.key;
                });
            }
        });
        onChange(v);
    };
    var handleSelectNone = function handleSelectNone(e) {
        e.preventDefault();
        e.stopPropagation();
        var v = _extends({}, state);
        Object.keys(state).forEach(function (key) {
            v[key] = [];
        });
        onChange(v);
    };
    return _react2.default.createElement(
        "div",
        { className: "form-section-inner" },
        _react2.default.createElement(
            "h3",
            null,
            title,
            " ",
            _react2.default.createElement(
                "span",
                { className: "header-links" },
                _react2.default.createElement(
                    "a",
                    { href: "#", className: "select-all", onClick: handleSelectAll },
                    "Select All"
                ),
                " / ",
                _react2.default.createElement(
                    "a",
                    { href: "#", className: "clear-all", onClick: handleSelectNone },
                    "Clear All"
                )
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
                "div",
                { className: "col-md-12" },
                _react2.default.createElement(
                    "div",
                    { className: "optionHolder" },
                    data.map(function (it) {
                        return _react2.default.createElement(OptionGroupItem, {
                            key: it.key + it.name,
                            state: state,
                            data: it,
                            expanded: expanded,
                            onChange: onChange,
                            hasFieldEntity: hasFieldEntity
                        });
                    })
                )
            )
        )
    );
};

OptionGroup.propTypes = {
    title: _propTypes2.default.string,
    state: _propTypes2.default.object,
    data: _propTypes2.default.array,
    onChange: _propTypes2.default.func,
    expanded: _propTypes2.default.bool,
    hasFieldEntity: _propTypes2.default.bool
};

exports.default = OptionGroup;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _typedAction = __webpack_require__(86);

var _typedAction2 = _interopRequireDefault(_typedAction);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MappingActions = {
    MODEL_LOADED: (0, _typedAction2.default)("mapping/model-loaded", {
        targetKey: _EntityName2.default.propType.isRequired,
        sourceKey: _EntityName2.default.propType.isRequired
    }),
    MODEL_LOAD_ERROR: (0, _typedAction2.default)("mapping/model-load-error", {
        targetKey: _EntityName2.default.propType.isRequired,
        sourceKey: _EntityName2.default.propType.isRequired
    }),

    // An order-of-operations cycle is present, so need to... do it again.
    // This also implies that we're not waiting for an async operation to
    // resolve, as that'll reexecute the workflow on it's own.
    __DO_IT_AGAIN: (0, _typedAction2.default)("mapping/--do-it-again", {
        reason: _propTypes2.default.string.isRequired
    }),

    __PROCESS_NEXT_IN_QUEUE: "mapping/--process-next-in-queue",

    // Time to commit and clean up.
    IT_IS_DONE: (0, _typedAction2.default)("mapping/it-is-done", {
        trigger: _propTypes2.default.string.isRequired,
        initiatingContext: _propTypes2.default.string
    })
};

exports.default = MappingActions;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CacheManager = __webpack_require__(474);

var _CacheManager2 = _interopRequireDefault(_CacheManager);

var _HybridConfig = __webpack_require__(41);

var _HybridConfig2 = _interopRequireDefault(_HybridConfig);

var _BaseServices = __webpack_require__(76);

var _BaseServices2 = _interopRequireDefault(_BaseServices);

var _promisify = __webpack_require__(97);

var _promisify2 = _interopRequireDefault(_promisify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var cacheParam = "_=" + new Date().valueOf().toString();
var metaPrefix = _BaseServices2.default.url("meta/");

var Services = function () {
    function Services() {
        var _this = this;

        _classCallCheck(this, Services);

        this.loadStereotypes = this.loadStereotypes.bind(this);
        this.cachingProxy = this.cachingProxy.bind(this);
        this.loadModelJson = this.loadModelJson.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this.getStereotypeForEntity = this.getStereotypeForEntity.bind(this);

        this.cache = _CacheManager2.default;
        this.cacheConfig = {};
        this.cacheParam = cacheParam;
        var _arr = ["isolatePage", "hydratedRecordList"];
        for (var _i = 0; _i < _arr.length; _i++) {
            var k = _arr[_i];
            this.cacheConfig[k] = _HybridConfig2.default.get("cache." + k, false);
        }

        if (this.cacheConfig.isolatePage) {
            $(document).ajaxSend(function (e, jqXHR, ajaxSettings) {
                if (ajaxSettings.type === "GET" && ajaxSettings.url.indexOf(metaPrefix) === 0) {
                    ajaxSettings.url += (ajaxSettings.url.indexOf("?") < 0 ? "?" : "&") + _this.cacheParam;
                }
            });
        }
    }

    _createClass(Services, [{
        key: "loadVersion",
        value: function loadVersion() {
            return _BaseServices2.default.getRequest("meta/version.json");
        }
    }, {
        key: "loadUser",
        value: function loadUser() {
            return $.ajax({
                type: "GET",
                url: _BaseServices2.default.url("user.json"),
                dataType: "json",
                statusCode: {
                    401: function _() {
                        return _BaseServices2.default.navigateToAuthUrl();
                    }
                }
            });
        }
    }, {
        key: "loadExportParams",
        value: function loadExportParams(org) {
            return _BaseServices2.default.getRequest("export/" + org + "/saved-params.json");
        }
    }, {
        key: "createExportParams",
        value: function createExportParams(org, data) {
            return _BaseServices2.default.jsonPost("export/" + org + "/saved-params.json", data);
        }
    }, {
        key: "updateExportParams",
        value: function updateExportParams(org, data) {
            return _BaseServices2.default.jsonPost("export/" + org + "/saved-params/" + data.id + ".json", data, { type: "PUT" });
        }
    }, {
        key: "deleteExportParams",
        value: function deleteExportParams(org, id) {
            return _BaseServices2.default.jsonPost("export/" + org + "/saved-params/" + id + ".json", {}, { type: "DELETE" });
        }
    }, {
        key: "loadArmusScript",
        value: function loadArmusScript() {
            return $.ajax({
                type: "GET",
                url: _BaseServices2.default.url(["meta", "armusscript.js"]),
                dataType: "script",
                cache: true
            });
        }
    }, {
        key: "loadStereotypes",
        value: function loadStereotypes() {
            return _BaseServices2.default.getRequest("meta/stereotype.json");
        }
    }, {
        key: "loadStereotype",
        value: function loadStereotype(key) {
            return _BaseServices2.default.getRequest("meta/stereotype/" + key);
        }

        /*
        ex: /remote/data-source/adt/sentara/search?mrn=asdf1234&arrivaldate=2014-10-30&admitdate=2014-10-30
         A web endpoint is available at /v2/remote/data-source/adt/washington/search which will return
        a list of adt/1-0/episode records or raise an exception if no metadata is available to back it.
         It accepts mrn, arrivaldate, and admitdate query parameters to search on.
        */

    }, {
        key: "searchADT",
        value: function searchADT(org, query) {
            return _BaseServices2.default.getRequest("remote/data-source/adt/" + org + "/search", query);
        }
    }, {
        key: "searchHemo",
        value: function searchHemo(org, query) {
            return _BaseServices2.default.getRequest("remote/data-source/hemo/" + org + "/search", query);
        }
    }, {
        key: "searchEcmoEmr",
        value: function searchEcmoEmr(org, query) {
            return _BaseServices2.default.getRequest("remote/data-source/ecmoemr/" + org + "/search", query);
        }
    }, {
        key: "searchCrossApp",
        value: function searchCrossApp(org, stereotype, impl, version, entity, query, page, pageSize) {
            if (pageSize == null) {
                pageSize = 20;
            }
            if (page == null) {
                page = 1;
            }
            return _BaseServices2.default.getRequest("remote/data-source/cross-app/" + org + "/" + stereotype + "/" + impl + "/" + version + "/" + entity + "/search", {
                q: query,
                p: page,
                ps: pageSize
            });
        }
    }, {
        key: "searchEntity",
        value: function searchEntity(query, sorts, fqen, pageSize, page) {
            var onlyEnabledRecords = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
            var owners = arguments[6];

            if (pageSize == null) {
                pageSize = 20;
            }
            if (page == null) {
                page = 1;
            }
            return _BaseServices2.default.getRequest(["search", fqen], {
                q: query,
                o: sorts,
                ps: pageSize,
                p: page,
                oe: onlyEnabledRecords,
                owners: owners
            });
        }

        // @param {function} work - must return a promise.

    }, {
        key: "cachingProxy",
        value: function cachingProxy(enabled, region, key, work, forceReload) {
            if (forceReload == null) {
                forceReload = false;
            }
            if (enabled && !forceReload && this.cache.has(region, key)) {
                return this.cache.get(region, key);
            } else {
                var p = work();
                if (enabled) {
                    this.cache.put(region, key, p);
                }
                return p;
            }
        }
    }, {
        key: "getByStereotype",
        value: function getByStereotype(org, stereotype) {
            // @RequestMapping(value = "/{org}/{stereotype}", method = GET)
            return _BaseServices2.default.getRequest([org, stereotype]);
        }
    }, {
        key: "loadEntityFormDescriptor",
        value: function loadEntityFormDescriptor(ekey, org) {
            return _BaseServices2.default.getRequest(["meta", org, ekey, "form.json"]);
        }
    }, {
        key: "loadModelJson",
        value: function loadModelJson(org, key) {
            ///meta/{org}/{key}/model.json
            return _BaseServices2.default.getRequest(["meta", org, key, "model.json"]);
        }
    }, {
        key: "loadEntityData",
        value: function loadEntityData(entity, id, org) {
            ///{org}/{stereotype}/{id}
            return _BaseServices2.default.getRequest([org, entity, id]);
        }
    }, {
        key: "createEntityData",
        value: function createEntityData(key, data, org) {
            // POST /{org}/{stereotype}
            return $.ajax({
                type: "POST",
                url: _BaseServices2.default.url([org, key]),
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(data)
            });
        }
    }, {
        key: "updateEntityData",
        value: function updateEntityData(key, id, data, org) {
            // PUT /{org}/{stereotype}/{id}
            return $.ajax({
                type: "PUT",
                url: _BaseServices2.default.url([org, key, id]),
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(data)
            });
        }
    }, {
        key: "mergeEntityData",
        value: function mergeEntityData(key, targetId, sourceId, data, org) {
            // PUT /{org}/{stereotype}/{targetId}?mergeFrom={sourceId}
            return $.ajax({
                type: "PUT",
                url: _BaseServices2.default.url([org, key, targetId]) + "?mergeFrom=" + sourceId,
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(data)
            });
        }
    }, {
        key: "deleteEntityData",
        value: function deleteEntityData(key, id, org) {
            return $.ajax({
                type: "DELETE",
                url: _BaseServices2.default.url([org, key, id]),
                dataType: "json",
                contentType: "application/json"
            });
        }
    }, {
        key: "saveActiveOrgs",
        value: function saveActiveOrgs(keys) {
            ///user/active-organizations
            return $.ajax({
                type: "PUT",
                url: _BaseServices2.default.url("user/active-organizations"),
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify({ keys: keys })
            });
        }
    }, {
        key: "getFileInfo",
        value: function getFileInfo(org, impl, version, entity, recordId, field, fileId) {
            return _BaseServices2.default.getRequest([org, impl, version, entity, recordId, "fields", field, "files", fileId]);
        }
    }, {
        key: "getFile",
        value: function getFile(org, impl, version, entity, recordId, field, fileId, fileName) {
            return _BaseServices2.default.getRequest([org, impl, version, entity, recordId, "fields", field, "files", fileId, fileName]);
        }
    }, {
        key: "createFileReader",
        value: function createFileReader() {
            return new FileReader();
        }
    }, {
        key: "uploadFile",
        value: function uploadFile(org, impl, version, entity, recordId, field, fileData, callBack, progressCallback) {
            var url = _BaseServices2.default.url([org, impl, version, entity, recordId, "fields", field, "files"]);

            var reader = this.createFileReader();
            reader.onload = function (evt) {
                var promise = $.ajax({
                    url: url,
                    type: "POST",
                    data: evt.target.result,
                    processData: false,
                    contentType: fileData.type,
                    headers: {
                        "X-Hybrid-Filename": fileData.name
                    },
                    xhr: function xhr() {
                        var myXhr = $.ajaxSettings.xhr();
                        if (myXhr.upload != null) {
                            myXhr.upload.onprogress = progressCallback;
                        }
                        return myXhr;
                    }
                });

                if (callBack != null) {
                    return callBack(promise);
                }
            };

            return reader.readAsArrayBuffer(fileData);
        }

        // GET /v2/meta/{org}/{impl}/{version}/{entity}/mapping-src/{srcImpl}/{srcVersion}/{srcEntity}.json

    }, {
        key: "loadMappingJson",
        value: function loadMappingJson(org, targetKey, srcKey) {
            return _BaseServices2.default.getRequest(["meta", org, targetKey, "mapping-src", srcKey + ".json"]);
        }
    }, {
        key: "loadFieldData",
        value: function loadFieldData(key, shortname, org) {
            ///meta/{org}/{impl}/{version}/{entity}/fields/{field}
            return _BaseServices2.default.getRequest(["meta", org, key, "fields", shortname], {}, {
                background: true
            });
        }
    }, {
        key: "loadAbstractionAi",
        value: function loadAbstractionAi(org, entityKey, shortname, payload) {
            ///{org}/{impl}/{version}/suggest/{field}
            var _entityKey$split = entityKey.split("/"),
                _entityKey$split2 = _slicedToArray(_entityKey$split, 2),
                impl = _entityKey$split2[0],
                version = _entityKey$split2[1];

            return _BaseServices2.default.jsonPost([org, impl, version, "suggest", shortname], payload, {
                background: true,
                ignoreFailure: true
            });
        }
    }, {
        key: "loadAbstractionAiApi",
        value: function loadAbstractionAiApi(org, entityKey, shortname, payload) {
            var _entityKey$split3 = entityKey.split("/"),
                _entityKey$split4 = _slicedToArray(_entityKey$split3, 3),
                impl = _entityKey$split4[0],
                version = _entityKey$split4[1],
                entityName = _entityKey$split4[2];

            return _BaseServices2.default.jsonPost([org, impl, version, "suggest", "api", entityName, shortname], payload, {
                background: true,
                ignoreFailure: true
            });
        }
    }, {
        key: "loadDQRSummary",
        value: function loadDQRSummary(stereotype, q, code, p, ps, o, owners) {
            return _BaseServices2.default.getRequest(["dqr", stereotype.get("key")], {
                q: q,
                code: code,
                p: p,
                ps: ps,
                o: o,
                owners: owners
            });
        }
    }, {
        key: "loadDQRDetail",
        value: function loadDQRDetail(stereotype, q, code, p, ps, o, owners) {
            return _BaseServices2.default.getRequest(["dqr", stereotype.get("key"), "fields"], {
                q: q,
                code: code,
                p: p,
                ps: ps,
                o: o,
                owners: owners
            });
        }
    }, {
        key: "loadITManifest",
        value: function loadITManifest() {
            if (true) {
                return Promise.reject();
            } else {
                var root = "test/it";
                return (0, _promisify2.default)($.ajax({
                    type: "GET",
                    url: root + "/manifest.txt",
                    dataType: "text"
                })).then(function (list) {
                    return {
                        root: root,
                        tests: list
                    };
                });
            }
        }
    }, {
        key: "loadMocksetManifest",
        value: function loadMocksetManifest() {
            if (true) {
                return Promise.reject();
            } else {
                var root = "mocks";
                return (0, _promisify2.default)($.ajax({
                    type: "GET",
                    url: root + "/manifest.txt",
                    dataType: "text"
                }));
            }
        }
    }, {
        key: "getStereotypeForEntity",
        value: function getStereotypeForEntity(key, stereotypes) {
            var sts = this.getStereotypesForEntity(key, stereotypes);
            if (sts.length) {
                return sts[sts.length - 1];
            } else {
                return null;
            }
        }
    }, {
        key: "getStereotypesForEntity",
        value: function getStereotypesForEntity(key, stereotypes) {
            var sts = [];
            stereotypes.each(function (stereotype, i) {
                var creatables = stereotype.get("creatables");
                return creatables.each(function (creatable, j) {
                    var versions = creatable.get("versions");
                    return versions.each(function (version, k) {
                        var vk = version.get("key");
                        if (vk === key) {
                            return sts.push(stereotype);
                        }
                    });
                });
            });
            return sts;
        }
    }, {
        key: "_putJsonPref",
        value: function _putJsonPref(url, value) {
            return $.ajax({
                type: "PUT",
                url: _BaseServices2.default.url(url),
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(value)
            });
        }
    }, {
        key: "saveLicensePreference",
        value: function saveLicensePreference(org, impl, pref, value) {
            if (_BaseServices2.default.__mocked) {
                // If we're mocked, saving the preference will always respond with
                // the static value. That precludes testing behavior based on the
                // updated preference, which is means you have to gen a mockset with
                // every potential preference value you want to test with (and use
                // separate tests per value too).
                return Promise.resolve(value);
            }
            return this._putJsonPref(["prefs", org, impl, pref], value);
        }
    }, {
        key: "saveOrgUserPreference",
        value: function saveOrgUserPreference(org, pref, value) {
            if (_BaseServices2.default.__mocked) {
                return Promise.resolve(value);
            }
            return this._putJsonPref(["user", "prefs", org, pref], value);
        }
    }, {
        key: "loadGxepInfo",
        value: function loadGxepInfo(org) {
            return _BaseServices2.default.getRequest(["gxep", org]);
        }
    }, {
        key: "saveGxepInfo",
        value: function saveGxepInfo(org, infos) {
            return this._putJsonPref(["gxep", org], infos);
        }
    }, {
        key: "createLockClient",
        value: function createLockClient() {
            return (0, _promisify2.default)(_BaseServices2.default.jsonPost(["lock"]));
        }
    }, {
        key: "createLockSet",
        value: function createLockSet(clientId, lockSet) {
            return (0, _promisify2.default)(_BaseServices2.default.jsonPost(["lock", clientId, "set"], lockSet));
        }
    }, {
        key: "confirmLockSet",
        value: function confirmLockSet(clientId, lockSetId) {
            return (0, _promisify2.default)(_BaseServices2.default.jsonPost(["lock", clientId, "set", lockSetId, "active"], null, { type: "PUT", background: true }));
        }
    }, {
        key: "releaseLockSet",
        value: function releaseLockSet(clientId, lockSetId) {
            return (0, _promisify2.default)(_BaseServices2.default.jsonPost(["lock", clientId, "set", lockSetId], null, { type: "DELETE" }));
        }

        // I DO NOT return a Promise/thenable, and only sorta work on browsers w/o
        // full fetch support.

    }, {
        key: "deleteLockClient",
        value: function deleteLockClient(clientId) {
            var url = this.url(["lock", clientId]);
            if (!window.fetch.polyfill && "keepalive" in new Request("")) {
                // noinspection JSIgnoredPromiseFromCall
                window.fetch(url, {
                    method: "DELETE",
                    credentials: "same-origin",
                    keepalive: true
                });
            } else {
                // no keepalive support...
                $.ajax({
                    type: "DELETE",
                    url: url,
                    async: false
                });
            }
        }
    }, {
        key: "url",
        value: function url(path) {
            return _BaseServices2.default.url(path);
        }
    }]);

    return Services;
}();

exports.default = new Services();

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _typedAction3 = __webpack_require__(86);

var _typedAction4 = _interopRequireDefault(_typedAction3);

var _typedefs = __webpack_require__(44);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _ContextedReduceStore = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var focusType = _defineProperty({
    entityKey: _EntityName2.default.propType.isRequired,
    recordId: _typedefs.recordIdType.isRequired,
    fieldKey: _propTypes2.default.string,
    keyboardShortcuts: _propTypes2.default.any,
    domId: _propTypes2.default.string.isRequired
}, _ContextedReduceStore.ACTION_CONTEXT_KEY, _propTypes2.default.string.isRequired);

var ActiveFormActions = {
    // these aren't very good actions...
    START_RENDER: "active-form/start-render",
    RENDERED: "active-form/rendered",
    NO_FORM_TO_RENDER: "active-form/no-form-to-render",
    MOVE_FOCUS: (0, _typedAction4.default)("*active-form/move-focus", _defineProperty({
        recordId: _typedefs.recordIdType.isRequired,
        fieldKey: _propTypes2.default.string,
        domId: _propTypes2.default.string.isRequired,
        delta: _propTypes2.default.number.isRequired,
        orNextEnabled: _propTypes2.default.bool
    }, _ContextedReduceStore.ACTION_CONTEXT_KEY, _propTypes2.default.string.isRequired)),
    PLACE_FOCUS_AT_START: (0, _typedAction4.default)("*active-form/place-focus-at-start", _defineProperty({
        recordId: _typedefs.recordIdType.isRequired
    }, _ContextedReduceStore.ACTION_CONTEXT_KEY, _propTypes2.default.string.isRequired)),
    // These get dispatched on all elements, control or not
    FOCUS_ELEMENT: (0, _typedAction4.default)("*active-form/focus-element", focusType),
    BLUR_ELEMENT: (0, _typedAction4.default)("*active-form/blur-element", focusType),
    SELECT_SIDEBAR_TAB: "active-form/select-sidebar-tab"
};

exports.default = ActiveFormActions;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isSameControl = exports.isControl = exports.isSameElement = exports.isElement = exports.FIRST_FIELD = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _ActiveFormActions = __webpack_require__(111);

var _ActiveFormActions2 = _interopRequireDefault(_ActiveFormActions);

var _ActiveSectionActions = __webpack_require__(224);

var _ActiveSectionActions2 = _interopRequireDefault(_ActiveSectionActions);

var _ContextedReduceStore2 = __webpack_require__(30);

var _ContextedReduceStore3 = _interopRequireDefault(_ContextedReduceStore2);

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

var _storeUtils = __webpack_require__(54);

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

var _NavigationActions = __webpack_require__(80);

var _NavigationActions2 = _interopRequireDefault(_NavigationActions);

var _NavigatorStore = __webpack_require__(33);

var _NavigatorStore2 = _interopRequireDefault(_NavigatorStore);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _typedefs = __webpack_require__(44);

var _FormStore = __webpack_require__(142);

var _FormStore2 = _interopRequireDefault(_FormStore);

var _RecordActions = __webpack_require__(60);

var _RecordActions2 = _interopRequireDefault(_RecordActions);

var _OverStore = __webpack_require__(61);

var _ContextedReduceStore4 = __webpack_require__(30);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIRST_FIELD = exports.FIRST_FIELD = "--first-field--";

function isCurrent(state, action) {
    return state.key === action.key && state.id === action.id;
}

/**
 * I indicate whether the passed data packet describes an element. Element
 * packets are objects containing nullable 'entityKey', 'recordId', and
 * 'domId' keys.
 *
 * @param a a data packet to check
 * @return {boolean} whether the packet describes an element.
 */
var isElement = exports.isElement = function isElement(a) {
    return a != null && a.hasOwnProperty("entityKey") && a.hasOwnProperty("recordId") && a.hasOwnProperty("domId");
};

/**
 * I indicate whether two element packets describe the same element. Each packet
 * may be null or something isElement returns true when passed.
 *
 * @param a one element packet
 * @param b another element packet
 * @return {boolean} whether the two packets refer to the same element
 */
var isSameElement = exports.isSameElement = function isSameElement(a, b) {
    (0, _invariant2.default)((a == null || isElement(a)) && (b == null || isElement(b)), "isSameElement only accepts element packets");
    if (a == null) {
        return b == null;
    } else if (b == null) {
        return false;
    }
    if (a.entityKey !== b.entityKey) {
        return false;
    }
    if (a.recordId !== b.recordId) {
        return false;
    }
    return a.domId === b.domId;
};

/**
 * I indicate whether the passed data packet describes a control. Control
 * packets are objects containing non-null 'entityKey', 'recordId', and
 * 'fieldKey' keys. This matches the format for the active and last blurred
 * controls managed by this store, as well as the FOCUS_ELEMENT action payload.
 *
 * @param a a data packet to check
 * @return {boolean} whether the packet describes a control.
 */
var isControl = exports.isControl = function isControl(a) {
    return a != null && !!(a.entityKey && a.recordId && a.fieldKey);
};

var processSetFieldState = function processSetFieldState(ctx, action, initialContext) {
    if (_NavigatorStore2.default.hasChanged()) {
        var navState = _NavigatorStore2.default.getState(action[_ContextedReduceStore4.ACTION_CONTEXT_KEY]);
        if (!(action.recordKey !== navState.record.key && action.recordId === navState.record.id)) {
            return initialContext;
        }
    }
    if (ctx.focusMovement) {
        if ((0, _TableStore.isUnconfirmedVersionChange)(_TableStore2.default, action)) {
            ctx = _extends({}, ctx, {
                focusMovement: _extends({}, ctx.focusMovement, {
                    delta: 0 // always return to the same field
                })
            });
        }
    }
    return ctx;
};

var processStartRenderState = function processStartRenderState(ctx, action) {
    if (isCurrent(ctx, action)) {
        // reloading the same form...
        return ctx;
    }
    if (ctx.id === action.id) {
        // just changing versions...
        return _extends({}, ctx, {
            key: action.key,
            lastBlurredControl: null
        });
    }
    var fm = ctx.focusMovement;
    if (fm == null) {
        fm = {
            recordId: action.id,
            delta: 0,
            fieldKey: FIRST_FIELD
        };
    }
    return _extends({}, ctx, {
        key: action.key,
        id: action.id,
        lastBlurredControl: null,
        activeControl: null,
        focusMovement: fm
    });
};

var processJumpToSectionState = function processJumpToSectionState(ctx, action) {
    var firstItem = _FormStore2.default.getFirstItemInSection(ctx.key, action.section);
    var focusMovement = firstItem == null ? null : {
        recordId: ctx.id,
        domId: firstItem.id,
        delta: 0
    };
    return _extends({}, ctx, {
        focusMovement: focusMovement
    });
};

var processFocusElementState = function processFocusElementState(ctx, action) {
    if (ctx.focusMovement) {
        ctx = _extends({}, ctx, {
            focusMovement: null
        });
    }
    if (!isSameElement(ctx.focusedElement, action)) {
        ctx = _extends({}, ctx, {
            focusedElement: {
                entityKey: action.entityKey,
                recordId: action.recordId,
                domId: action.domId,
                isControl: isControl(action)
            }
        });
    }
    if (isControl(action)) {
        if (!isSameControl(ctx.activeControl, action)) {
            ctx = _extends({}, ctx, {
                activeControl: {
                    fieldKey: action.fieldKey,
                    entityKey: action.entityKey,
                    recordId: action.recordId,
                    domId: action.domId,
                    keyboardShortcuts: action.keyboardShortcuts
                }
            });
            // This is pretty gross. But unclear exactly how to do
            // it better, since a) there's no store for it, and b)
            // it's not for every focus action, it's only for focus
            // actions which target a control that isn't already
            // focused. Because "reasons"?
            Backbone.dispatcher.trigger("user:activity");
        }
    } else if (ctx.activeControl) {
        ctx = _extends({}, ctx, {
            activeControl: null
        });
    }
    return ctx;
};

var processBlurElementState = function processBlurElementState(ctx, action) {
    if (isControl(action) && !isSameControl(ctx.lastBlurredControl, action)) {
        return _extends({}, ctx, {
            focusedElement: null,
            lastBlurredControl: {
                fieldKey: action.fieldKey,
                entityKey: action.entityKey,
                recordId: action.recordId,
                domId: action.domId
            },
            focusMovement: null
        });
    }
    return ctx;
};

var processMoveFocusState = function processMoveFocusState(ctx, action) {
    return _extends({}, ctx, {
        focusedElement: null,
        activeControl: null,
        focusMovement: {
            recordId: action.recordId,
            fieldKey: action.fieldKey,
            domId: action.domId,
            delta: action.delta
        }
    });
};

var processPlaceFocusAtStartState = function processPlaceFocusAtStartState(ctx, action) {
    return _extends({}, ctx, {
        focusedElement: null,
        activeControl: null,
        focusMovement: {
            recordId: action.recordId,
            delta: 0,
            fieldKey: FIRST_FIELD
        }
    });
};

var processNewChildState = function processNewChildState(ctx, action) {
    return _extends({}, ctx, {
        lastBlurredControl: null,
        activeControl: null,
        focusMovement: {
            recordId: action.newId,
            delta: 0,
            fieldKey: action.focusFieldKey || FIRST_FIELD
        }
    });
};

var processFocusFieldState = function processFocusFieldState(ctx, action) {
    // since it was in our context, this is initiates a focus change
    if (!action.entityKey) return ctx;
    if (!action.recordId) return ctx;
    var fm = void 0;
    if (action.fieldKey && action.fieldKey.hasOwnProperty("fieldKey")) {
        // it's a full triple
        fm = {
            recordId: action.fieldKey.recordId,
            delta: 0,
            fieldKey: action.fieldKey.fieldKey || FIRST_FIELD,
            orNextEnabled: !!action.fieldKey.fieldKey
        };
    } else {
        fm = {
            recordId: action.recordId,
            delta: 0,
            fieldKey: action.fieldKey || FIRST_FIELD,
            orNextEnabled: !!action.fieldKey
        };
    }
    return _extends({}, ctx, {
        lastBlurredControl: null,
        activeControl: null,
        focusMovement: fm
    });
};

/**
 * I indicate whether two control packets describe the same control. Each packet
 * may be null or something isControl returns true when passed.
 *
 * @param a one control packet
 * @param b another control packet
 * @return {boolean} whether the two packets refer to the same control
 */
var isSameControl = exports.isSameControl = function isSameControl(a, b) {
    (0, _invariant2.default)((a == null || isControl(a)) && (b == null || isControl(b)), "isSameControl only accepts control packets");
    if (a == null) {
        return b == null;
    } else if (b == null) {
        return false;
    }
    if (a.entityKey !== b.entityKey) {
        return false;
    }
    if (a.recordId !== b.recordId) {
        return false;
    }
    return a.fieldKey === b.fieldKey;
};

var ActiveFormStore = function (_ContextedReduceStore) {
    _inherits(ActiveFormStore, _ContextedReduceStore);

    function ActiveFormStore() {
        _classCallCheck(this, ActiveFormStore);

        return _possibleConstructorReturn(this, (ActiveFormStore.__proto__ || Object.getPrototypeOf(ActiveFormStore)).call(this, _Dispatcher2.default));
    }

    _createClass(ActiveFormStore, [{
        key: "getInitialContext",
        value: function getInitialContext() {
            return {
                key: null,
                id: null,
                activeSidebarTab: "definitions",
                focusedElement: null,
                activeControl: null,
                lastBlurredControl: null,
                focusMovement: null
            };
        }
    }, {
        key: "reduceContext",
        value: function reduceContext(ctx, action) {
            this.__dispatcher.waitFor([_NavigatorStore2.default.getDispatchToken()]);

            // TODO: find out which actions under what
            // conditions need to reset the context

            //if (NavigatorStore.hasChanged()) {
            //    ctx = this.getInitialContext();
            //}

            switch (action.type) {
                case _RecordActions2.default.SET_FIELD:
                    {
                        return processSetFieldState(ctx, action, this.getInitialContext());
                    }

                case _ActiveFormActions2.default.START_RENDER:
                    {
                        return processStartRenderState(ctx, action);
                    }

                case _ActiveFormActions2.default.RENDERED:
                    if (!isCurrent(ctx, action)) {
                        /*
                        You'd think this wouldn't happen, but because rendering is
                        both async and callback based, there's no way to cancel a
                        requested render if another render is requested. So the
                        first render still ends up happening, into an EntityForm
                        instance which is no longer attached to the view tree.
                         As such, it's not necessarily problematic, but it's pretty
                        damn silly. So log it, but don't raise an exception.
                         */
                        console.warn("Form '" + action.key + "#" + action.id + "' rendered after '" + ctx.key + "#" + ctx.id + "' started. Race much?");
                    }
                    return ctx;

                case _ActiveSectionActions2.default.JUMP_TO_SECTION:
                    this.__dispatcher.waitFor([_FormStore2.default.getDispatchToken()]);
                    return processJumpToSectionState(ctx, action);

                case _ActiveFormActions2.default.FOCUS_ELEMENT:
                    {
                        return processFocusElementState(ctx, action);
                    }

                case _ActiveFormActions2.default.BLUR_ELEMENT:
                    {
                        return processBlurElementState(ctx, action);
                    }

                case _ActiveFormActions2.default.MOVE_FOCUS:
                    {
                        return processMoveFocusState(ctx, action);
                    }

                case _ActiveFormActions2.default.PLACE_FOCUS_AT_START:
                    {
                        return processPlaceFocusAtStartState(ctx, action);
                    }

                case _RecordActions2.default.NEW_CHILD:
                    {
                        return processNewChildState(ctx, action);
                    }

                case _SuperRecordActions2.default.OPEN:
                case _NavigationActions2.default.SELECT_RECORD:
                case _NavigationActions2.default.FOCUS_FIELD:
                    {
                        return processFocusFieldState(ctx, action);
                    }

                case _SuperRecordActions2.default.NEW:
                    {
                        if (!(0, _OverStore.isConfirmed)(action)) return ctx;
                        return this.getInitialContext();
                    }

                case _SuperRecordActions2.default.DELETED:
                    {
                        return this.getInitialContext();
                    }

                case _ActiveFormActions2.default.SELECT_SIDEBAR_TAB:
                    {
                        return _extends({}, ctx, {
                            activeSidebarTab: action.id
                        });
                    }

                default:
                    return ctx;
            }
        }
    }, {
        key: "reduceEachContext",
        value: function reduceEachContext(ctx, action) {
            switch (action.type) {
                case _SuperRecordActions2.default.CREATED:
                case _SuperRecordActions2.default.UPDATED:
                    // there are four potential IDs to munge
                    ctx = (0, _storeUtils.translateValue)(ctx, ["id"], action.data.newIds);
                    ctx = (0, _storeUtils.translateValue)(ctx, ["focusedElement", "recordId"], action.data.newIds);
                    ctx = (0, _storeUtils.translateValue)(ctx, ["activeControl", "recordId"], action.data.newIds);
                    // clear the lastBlurredControl. For refocus reasons this will
                    // let us know that the activeControl and lastBlurredControl
                    // are different and we need to kick off a refocus.
                    ctx.lastBlurredControl = null;
                    return ctx;

                case _SuperRecordActions2.default.DELETED:
                    if (ctx.id === action.id) {
                        return this.getInitialContext();
                    }
                    return ctx;

                case _RecordActions2.default.DELETE_RECORD:
                    if (!(0, _OverStore.isConfirmed)(action)) return ctx;
                    if (ctx.id === action.recordId) {
                        return this.getInitialContext();
                    }
                    return ctx;

                case _RecordActions2.default.DELETE_CHILD:
                    if (!(0, _OverStore.isConfirmed)(action)) return ctx;
                    // down the tree
                    if (ctx.id === action.childId) {
                        // eventually this should probably set what was navigated to
                        // (i.e., waitFor NavStore, and as it how to initialize),
                        // but that points to _this_ store doing bad things by
                        // duplicating data...
                        return this.getInitialContext();
                    }
                    return ctx;

                default:
                    return ctx;
            }
        }
    }, {
        key: "getActiveSidebarTab",
        value: function getActiveSidebarTab(context) {
            return this.getState(context).activeSidebarTab;
        }
    }, {
        key: "getActiveControl",
        value: function getActiveControl(context) {
            return this.getState(context).activeControl;
        }
    }, {
        key: "getFocusedElement",
        value: function getFocusedElement(context) {
            return this.getState(context).focusedElement;
        }
    }, {
        key: "getLastBlurredControl",
        value: function getLastBlurredControl(context) {
            return this.getState(context).lastBlurredControl;
        }
    }, {
        key: "getFocusMovement",
        value: function getFocusMovement(context) {
            return this.getState(context).focusMovement;
        }
    }]);

    return ActiveFormStore;
}(_ContextedReduceStore3.default);

ActiveFormStore.contextTypes = {
    key: _propTypes2.default.string,
    id: _typedefs.recordIdType,
    activeSidebarTab: _propTypes2.default.string.isRequired,
    focusedElement: _propTypes2.default.shape({
        entityKey: _propTypes2.default.string,
        recordId: _typedefs.recordIdType,
        domId: _propTypes2.default.string.isRequired,
        isControl: _propTypes2.default.bool.isRequired
    }),
    activeControl: _propTypes2.default.shape({
        fieldKey: _propTypes2.default.string.isRequired,
        entityKey: _propTypes2.default.string.isRequired,
        recordId: _typedefs.recordIdType.isRequired,
        domId: _propTypes2.default.string,
        keyboardShortcuts: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            key: _propTypes2.default.string.isRequired,
            name: _propTypes2.default.string.isRequired
        }))
    }),
    lastBlurredControl: _propTypes2.default.shape({
        fieldKey: _propTypes2.default.string.isRequired,
        entityKey: _propTypes2.default.string.isRequired,
        recordId: _typedefs.recordIdType.isRequired,
        domId: _propTypes2.default.string.isRequired
    }),
    focusMovement: _propTypes2.default.exact({
        // no entityKey to allow movement across version changes
        // recordId is need for motion w/in a subform (e.g., grid)
        recordId: _typedefs.recordIdType.isRequired,
        domId: _propTypes2.default.string,
        fieldKey: _propTypes2.default.string,
        // how to move from the specified anchor
        delta: _propTypes2.default.number.isRequired,
        orNextEnabled: _propTypes2.default.bool
    })
};

exports.default = (0, _typeCheckingStore2.default)(new ActiveFormStore());

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.navTree = exports.navTreeHelperBuilder = exports.getChildrenByKey = exports.getChildren = exports.lastBlurredValidation = exports.getActiveRecord = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _NavigatorStore = __webpack_require__(33);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _or_validate2 = __webpack_require__(481);

var _or_validate3 = _interopRequireDefault(_or_validate2);

var _isFieldHidden = __webpack_require__(177);

var _isFieldHidden2 = _interopRequireDefault(_isFieldHidden);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getActiveRecord = exports.getActiveRecord = function getActiveRecord(TableStore, recState) {
    if (recState == null) return null;
    if (!TableStore.hasEntityRecord(recState.key, recState.id)) return null;
    return TableStore.getEntityProxy(recState.key, recState.id);
};

var lastBlurredValidation = exports.lastBlurredValidation = function lastBlurredValidation(fluxContext, TableStore, ActiveFormStore) {
    var lbc = ActiveFormStore.getLastBlurredControl(fluxContext);
    if (lbc == null) return null;
    var ep = void 0;
    try {
        // This try catch is because focus lbc is not guaranteed to exist in the
        // table. Not the ideal solution but keeps us moving forward.
        // Example: Field within a record grid row that has been deleted.
        ep = TableStore.getEntityProxy(lbc.entityKey, lbc.recordId);
    } catch (err) {
        // if no record is known just return null
        return null;
    }
    var info = _entityFieldMetaStore2.default.getInfo(lbc.entityKey, lbc.fieldKey);
    return info.dqr ? (0, _or_validate3.default)(info, ep.get(lbc.fieldKey), ep) : null;
};

var getChildren = exports.getChildren = function getChildren(record) {
    var includeAssoc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return Object.values(getChildrenByKey(record, includeAssoc)).reduce(function (agg, rs) {
        return agg.concat(rs);
    }, []);
};

var getChildrenByKey = exports.getChildrenByKey = function getChildrenByKey(record) {
    var includeAssoc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var fieldKeys = [];
    fieldKeys.push.apply(fieldKeys, _toConsumableArray(record.entityInfo.associations.csv));
    fieldKeys.push.apply(fieldKeys, _toConsumableArray(record.entityInfo.associations.cmv));
    if (includeAssoc) {
        fieldKeys.push.apply(fieldKeys, _toConsumableArray(record.entityInfo.associations.asv));
        fieldKeys.push.apply(fieldKeys, _toConsumableArray(record.entityInfo.associations.amv));
    }
    return fieldKeys.map(function (fk) {
        return [fk, record.get(fk)];
    }).filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            fk = _ref2[0],
            v = _ref2[1];

        return v != null;
    }).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            fk = _ref4[0],
            v = _ref4[1];

        return [fk, v instanceof Array ? v : [v]];
    }).filter(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            fk = _ref6[0],
            v = _ref6[1];

        return v.length > 0;
    }).reduce(function (result, _ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
            fk = _ref8[0],
            v = _ref8[1];

        return _extends({}, result, _defineProperty({}, fk, v));
    }, {});
};

var navTreeHelperBuilder = exports.navTreeHelperBuilder = function navTreeHelperBuilder(navState) {
    var helper = function helper(ep) {
        var includeFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        if (false) {
            throw new Error("Non-boolean passed for includeFields: " + includeFields);
        }
        var item = {
            entityKey: ep.entityKey,
            implKey: ep.entityInfo.implKey,
            id: ep.id,
            selected: (0, _NavigatorStore.isRecordSelected)(navState, ep.entityKey, ep.id),
            label: ep.getLabel(),
            fields: includeFields ? ep.entityInfo.associations.cmv.map(function (k) {
                return _entityFieldMetaStore2.default.getInfo(ep.entityKey, k);
            }).filter(function (it) {
                return it.navigable && ep.isFieldEnabled(it) && !(0, _isFieldHidden2.default)(ep.entityKey, it);
            }).map(function (it) {
                var oei = _entityMetaStore2.default.getInfo(it.otherEntityKey);
                var creatables = oei.canCreate && it.autoManageKey == null ? [{
                    key: oei.key,
                    name: oei.name,
                    implKey: oei.implKey
                }] : [];
                var field = {
                    key: it.key,
                    recordKey: ep.entityKey,
                    recordId: ep.id,
                    name: it.name,
                    // no create/delete the field is auto-managed
                    creatables: creatables,
                    allowDelete: oei.canDelete && creatables.length,
                    items: ep.get(it).map(function (it) {
                        return helper(it);
                    })
                };
                field.active = field.items.some(function (f) {
                    return f.selected;
                });
                return field;
            }) : []
        };
        if (!item.selected) {
            // check down the tree
            item.selected = item.fields.some(function (f) {
                return f.active;
            });
        }
        item.childCount = item.fields.reduce(function (n, f) {
            return n + f.items.length;
        }, 0);
        return item;
    };
    return helper;
};

var navTree = exports.navTree = function navTree(TableStore, navState, key, id) {
    var ep = TableStore.getEntityProxy(key, id);
    var item = navTreeHelperBuilder(navState)(ep);
    return {
        key: key,
        entityKey: key,
        id: ep.id,
        name: ep.entityInfo.name,
        label: ep.getLabel(),
        creatables: [],
        allowDelete: false,
        items: [item]
    };
};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var RE_CLEAN = /[^a-z0-9_-]+/ig;

var clean = function clean(str, fallback) {
    if (str == null) {
        str = fallback;
    } else if (typeof str !== "string") {
        str = "" + str;
    }
    return str.replace(RE_CLEAN, "-");
};

var formatId = function formatId(ITid) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return clean(prefix, "it-id") + "-" + clean(ITid, "unspecified");
};

exports.default = formatId;

/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _typedAction = __webpack_require__(86);

var _typedAction2 = _interopRequireDefault(_typedAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OverActions = {
    SHOW: "over/show",
    HIDE: "over/hide",
    EXTERNAL_NAV: (0, _typedAction2.default)("over/external-nav", {
        message: _propTypes2.default.string.isRequired,
        title: _propTypes2.default.string,
        callback: _propTypes2.default.func,
        actions: _propTypes2.default.array
    }),
    APP_ALERT: (0, _typedAction2.default)("over/app-alert", {
        message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func] // a render callback
        ).isRequired,
        title: _propTypes2.default.string,
        callback: _propTypes2.default.func,
        actions: _propTypes2.default.array
    }),
    BROWSER_OFFLINE: "over/browser-offline",
    ARMUS_UNREACHABLE: "over/armus-unreachable",
    API_UNREACHABLE: "over/api-unreachable",
    HTTP_UNAUTHORIZED: "over/http-unauthorized",
    HTTP_FORBIDDEN: "over/http-forbidden",
    HTTP_NOT_FOUND: "over/http-not-found"
};

exports.default = OverActions;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var UserActions = {
    // the base ajax triple
    START_LOAD: "user/start-load",
    LOADED: "user/loaded",
    LOAD_ERROR: "user/load-error",
    // license prefs
    UPDATE_LICENSE_PREFERENCE: "user/update-license-preference",
    LICENSE_PREFERENCE_UPDATED: "user/license-preference-updated",
    LICENSE_PREFERENCE_UPDATE_ERROR: "user/license-preference-update-error",
    // user-org prefs
    UPDATE_ORG_USER_PREFERENCE: "user/update-org-user-preference",
    ORG_USER_PREFERENCE_UPDATED: "user/org-user-preference-updated",
    ORG_USER_PREFERENCE_UPDATE_ERROR: "user/org-user-preference-update-error"
};

exports.default = UserActions;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _typedAction = __webpack_require__(86);

var _typedAction2 = _interopRequireDefault(_typedAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefineActions = {
    // these are dispatched by the define function for scraping
    CHOICE: (0, _typedAction2.default)("global-define/choice", {
        key: _propTypes2.default.string.isRequired,
        def: _propTypes2.default.shape({
            key: _propTypes2.default.string.isRequired,
            options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
                id: _propTypes2.default.number.isRequired,
                name: _propTypes2.default.string.isRequired, // the human name, NOT the script one!
                label: _propTypes2.default.string, // missing implies "use name"
                atomic: _propTypes2.default.bool // missing implies "false"
            })).isRequired
        }).isRequired
    }),
    ENTITY: "global-define/entity",
    TABLE: "global-define/table",
    MAPPING: "global-define/mapping",
    STEREOTYPE: "global-define/stereotype",
    SYNTHETIC_STEREOTYPE: "global-define/synthetic-stereotype",

    // this is dispatched by the _unload function used in tests
    _UNLOAD: "global-define/_unload"
};

exports.default = DefineActions;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadTableIntoState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(13);

var _dotPropImmutable = __webpack_require__(40);

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DefineActions = __webpack_require__(124);

var _DefineActions2 = _interopRequireDefault(_DefineActions);

var _get_type_key = __webpack_require__(476);

var _get_type_key2 = _interopRequireDefault(_get_type_key);

var _audit = __webpack_require__(173);

var _HybridConfig = __webpack_require__(41);

var _HybridConfig2 = _interopRequireDefault(_HybridConfig);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _humanizedKeyList = __webpack_require__(477);

var _humanizedKeyList2 = _interopRequireDefault(_humanizedKeyList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var COLLISION_KEY = "_collision_";

var buildInitialColumns = function buildInitialColumns(info) {
    var key = info.key;
    var columns = {
        byKey: {},
        idxName: {}
    };
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = info.columns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var c = _step.value;

            var col = _extends({}, c, {
                type: (0, _get_type_key2.default)(c.type)
            });
            if (columns.idxName.hasOwnProperty(c.name)) {
                var curr = columns.idxName[c.name];
                if (c.name !== "ao_id") console.log("'" + key + "." + c.key + "' collides on the '" + c.name + "' name " + (curr === COLLISION_KEY ? "too" : "w/ '" + curr + "'"));
                // so it can't be used ambiguously
                columns.idxName[c.name] = COLLISION_KEY;
            } else {
                columns.idxName[c.name] = c.key;
            }
            if (columns.byKey.hasOwnProperty(c.key)) {
                throw new Error("Collision on " + key + "'s " + c.key + " key");
            }
            columns.byKey[c.key] = col;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return columns;
};

var addDerivationsToColumns = function addDerivationsToColumns(info, columns) {
    // derivations get reversed (so they're like downstreams), but we can't do
    // it inline above, as the source field might be later in the column list.
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = info.columns[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var c = _step2.value;

            var derivation = c.derivation;
            if (derivation == null) continue;

            derivation.targetKey = c.key;
            derivation.targetName = c.name;
            // eslint-disable-next-line no-new-func
            derivation.script = new Function("instance", derivation.script);
            if (_HybridConfig2.default.auditScriptlets()) {
                derivation.script = (0, _audit.auditable)("derivation", derivation.script);
            }

            if (derivation.sourceKey == null) continue;

            var src = columns.byKey[derivation.sourceKey];
            if (!src.hasOwnProperty("derivations")) {
                src.derivations = [];
            }
            src.derivations.push(derivation);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
};

var addDownstreamsToColumnQueue = function addDownstreamsToColumnQueue(queue, key, c, type) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = c.downstreams[type][Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var ds = _step3.value;

            var parts = ds.split(".");
            if (parts.length === 1) continue; // no edges
            queue.push({
                tableKey: key,
                triggerCol: parts[0],
                type: type,
                parts: parts
            });
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }
};

var processColumnQueueState = function processColumnQueueState(state, queue) {
    var newQueue = [];
    while (queue.length > 0) {
        var _queue$shift = queue.shift(),
            tableKey = _queue$shift.tableKey,
            triggerCol = _queue$shift.triggerCol,
            parts = _queue$shift.parts,
            type = _queue$shift.type;

        if (parts.length === 0) {
            throw new Error("No parts, eh?");
        }
        if (!state.tables.hasOwnProperty(tableKey)) {
            newQueue.push({
                tableKey: tableKey,
                triggerCol: triggerCol,
                parts: parts,
                type: type
            });
            continue;
        }
        var info = state.tables[tableKey].byKey[triggerCol];
        if (info == null || !info.hasOwnProperty("name")) {
            throw new Error("No " + tableKey + "." + triggerCol + " is known with " + parts + " of " + type + "?!");
        }
        if (info.inverse) {
            // add the downstream on the inverse for symmetry/sanity, even
            // though only the real/forward association will ever have its
            // downstreams processed.
            state = addDownstream(state, info, tableKey, triggerCol, type, parts);
            queue.push({
                tableKey: info.otherTableKey,
                triggerCol: info.inverseKey,
                parts: parts[0] === info.key ? parts.slice(1) : parts,
                type: type
            });
            continue;
        }
        if (parts.length === 1) {
            if (parts[0] !== triggerCol) {
                state = addDownstream(state, info, tableKey, triggerCol, type, parts);
            }
            continue; // no more edges
        }

        state = addDownstream(state, info, tableKey, triggerCol, type, parts);

        // cascade on to subsequent edges...
        if (triggerCol === parts[0]) {
            queue.push({
                tableKey: info.otherTableKey,
                triggerCol: parts[1],
                parts: parts.slice(1),
                type: type
            });
        } else {
            queue.push({
                tableKey: tableKey,
                triggerCol: parts[0],
                parts: parts,
                type: type
            });
        }
    }
    state = _dotPropImmutable2.default.set(state, "downstreamQueue", newQueue);
    return state;
};

var loadTableIntoState = exports.loadTableIntoState = function loadTableIntoState(state, info) {
    var key = info.key;
    var columns = buildInitialColumns(info);
    addDerivationsToColumns(info, columns);

    // this table's columns are set
    state = _dotPropImmutable2.default.set(state, ["tables", key], columns);

    // Downstreams need to be split up and the remainder added to each
    // intervening edge's downstreams. Derivations would need this too, except
    // they can't traverse assocs, so there is always zero intervening edges.
    //
    // Because we load tables one at a time, those edges might go through tables
    // which aren't defined yet, and thus can't be inflated. So we queue the
    // work, and then flush the queue. About half the time, the newly queued
    // work will NOT be flushed. The other half of the time some previously
    // queued work will ALSO be flushed.
    var queue = state.downstreamQueue.slice();
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
        for (var _iterator4 = Object.values(columns.byKey)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var c = _step4.value;

            if (c.downstreams == null) continue;
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = Object.keys(c.downstreams)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var type = _step5.value;

                    if (type === "VALIDATION") continue;
                    addDownstreamsToColumnQueue(queue, key, c, type);
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }
        }

        // now process
    } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
            }
        } finally {
            if (_didIteratorError4) {
                throw _iteratorError4;
            }
        }
    }

    if (queue.length > 0) {
        state = processColumnQueueState(state, queue);
    }

    return state;
};

var addDownstream = function addDownstream(state, info, tableKey, triggerCol, type, parts) {
    // add to this edge's downstreams...
    if (!info.hasOwnProperty("downstreams")) {
        info.downstreams = {};
    }
    if (!info.downstreams.hasOwnProperty(type)) {
        info.downstreams[type] = [];
    }
    var ds = parts.join(".");
    if (info.downstreams[type].indexOf(ds) < 0) {
        state = _dotPropImmutable2.default.set(state, ["tables", tableKey, "byKey", triggerCol], _dotPropImmutable2.default.set(info, ["downstreams", type], function (dss) {
            return dss.concat(ds);
        }));
    }

    return state;
};

var TableColumnMetaStore = function (_ReduceStore) {
    _inherits(TableColumnMetaStore, _ReduceStore);

    function TableColumnMetaStore() {
        _classCallCheck(this, TableColumnMetaStore);

        return _possibleConstructorReturn(this, (TableColumnMetaStore.__proto__ || Object.getPrototypeOf(TableColumnMetaStore)).apply(this, arguments));
    }

    _createClass(TableColumnMetaStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {
                tables: {},
                downstreamQueue: []
            };
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            if (action.type === _DefineActions2.default._UNLOAD) {
                return this.getInitialState();
            }
            if (action.type === _DefineActions2.default.TABLE) {
                return loadTableIntoState(state, action.def);
            }
            return state;
        }
    }, {
        key: "getAssociationFieldKeys",
        value: function getAssociationFieldKeys(tableKey) {
            var assocs = [];
            var columns = this.getState().tables[tableKey];
            if (!columns) {
                return assocs;
            }
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = Object.keys(columns)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var fk = _step6.value;

                    var f = columns[fk];
                    if (f.type === "ASSOCIATION") {
                        assocs.push(fk);
                    }
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }

            return assocs;
        }
    }, {
        key: "_getIndexes",
        value: function _getIndexes(tableKey) {
            var s = this.getState().tables;
            if (!s.hasOwnProperty(tableKey)) {
                throw new Error("No '" + tableKey + "' table is known: " + Object.keys(s));
            }
            return s[tableKey];
        }

        // deprecated

    }, {
        key: "getInfo",
        value: function getInfo(tableKey, columnName) {
            console.warn("TableColumnMetaStore.getInfo is deprecated; use getInfoByName");
            return this.getInfoByName(tableKey, columnName);
        }
    }, {
        key: "getInfoByName",
        value: function getInfoByName(tableKey, columnName) {
            var columns = this._getIndexes(tableKey).idxName;
            if (!columns.hasOwnProperty(columnName)) {
                throw new Error("No '" + columnName + "' column is known on '" + tableKey + "': " + Object.keys(columns));
            }
            var key = columns[columnName];
            if (key === COLLISION_KEY) {
                throw new Error("Column '" + columnName + "' on '" + tableKey + "' has a naming collision (check your inverses)");
            }
            return this.getInfoByKey(tableKey, key);
        }
    }, {
        key: "getAllColumnsByName",
        value: function getAllColumnsByName(tableKey) {
            var result = {};
            var idxs = this._getIndexes(tableKey);
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
                for (var _iterator7 = Object.keys(idxs.idxName)[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var name = _step7.value;

                    var key = idxs.idxName[name];
                    if (key === COLLISION_KEY) {
                        continue;
                    }
                    result[name] = idxs.byKey[key];
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                        _iterator7.return();
                    }
                } finally {
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }

            return result;
        }
    }, {
        key: "getAllColumns",
        value: function getAllColumns(tableKey) {
            return Object.values(this._getIndexes(tableKey).byKey);
        }

        // this is gross, but needed because of how we started with names

    }, {
        key: "getInfoByKey",
        value: function getInfoByKey(tableKey, columnKey) {
            var columns = this._getIndexes(tableKey).byKey;
            if (!columns.hasOwnProperty(columnKey)) {
                throw new Error( false ? "No '" + columnKey + "' column is known on '" + tableKey + "': " + (0, _humanizedKeyList2.default)(columns) : "No '" + columnKey + "' column is known on '" + tableKey + "'");
            }
            return columns[columnKey];
        }
    }]);

    return TableColumnMetaStore;
}(_utils.ReduceStore);

var metaType = _propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired,
    downstreams: _propTypes2.default.shape({
        ENABLEMENT: _propTypes2.default.arrayOf(_propTypes2.default.string),
        ASSIGNMENT: _propTypes2.default.arrayOf(_propTypes2.default.string),
        VALIDATION: _propTypes2.default.arrayOf(_propTypes2.default.string),
        CANDIDATE_FILTER: _propTypes2.default.arrayOf(_propTypes2.default.string)
    })
});
TableColumnMetaStore.stateTypes = {
    downstreamQueue: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        tableKey: _propTypes2.default.string.isRequired,
        triggerCol: _propTypes2.default.string.isRequired,
        type: _propTypes2.default.string.isRequired,
        parts: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
    })).isRequired,
    tables: _propTypes2.default.objectOf(_propTypes2.default.shape({
        idxName: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
        byKey: _propTypes2.default.objectOf(metaType).isRequired
    })).isRequired
};

exports.default = (0, _typeCheckingStore2.default)(new TableColumnMetaStore(_Dispatcher2.default));

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTableKeys = exports.getImplementations = exports.buildMenu = exports.isCreatableFrom = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _slices = __webpack_require__(172);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isCreatableFrom = exports.isCreatableFrom = function isCreatableFrom(stereoInfo, entityKey) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = stereoInfo.creatables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var c = _step.value;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = c.versions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var v = _step2.value;

                    if (v.key === entityKey) return true;
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return false;
};

var buildMenu = exports.buildMenu = function buildMenu(stereotypeKey) {
    if (stereotypeKey == null) {
        throw new Error("key is required to build menu");
    }
    var stereotype = _StereotypesStore2.default.getStereotypeByKey(stereotypeKey);
    var creatables = stereotype.creatables;
    var implsByKey = (0, _slices.toSlice)(stereotype.implementations, "key").byKey;
    var tree = [];
    var org = _userStore2.default.getActiveOrg();
    var canCreate = function canCreate(ek) {
        // full entity models aren't available yet...
        var impl = implsByKey[ek];
        if (!_userStore2.default.canCreate(impl.implementationKey)) return false;
        if (!impl.lookup) return true;
        return _userStore2.default.canManageLookups(impl.implementationKey);
    };

    _(creatables).filter(function (c) {
        return _(c.orgs).contains(org.key);
    }).forEach(function (c) {
        var def = void 0;
        if (c.hasOwnProperty("defaultKey")) {
            def = c.versions.find(function (v) {
                return v.key === c.defaultKey;
            });
        }
        var label = c.label;
        if (def != null) {
            if (!canCreate(def.key)) {
                return; // does not have create permissions for this implementation.
            }
            return tree.push({
                label: label,
                key: def.key,
                org: org.key,
                entity: stereotypeKey
            });
        } else {
            return c.versions.forEach(function (v) {
                if (!canCreate(v.key)) {
                    return; // does not have create permissions for this implementation.
                }
                tree.push({
                    label: label + " > " + v.label,
                    key: v.key,
                    org: org.key,
                    entity: stereotypeKey
                });
            });
        }
    });
    return squishMenuList(tree);
};

var squishMenuList = function squishMenuList(list) {
    var result = [];
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = list[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var item = _step3.value;

            result.push(squishMenuItem(item));
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    return result;
};

var squishMenuItem = function squishMenuItem(item) {
    // TODO: figure out where "kids" come from. At first glance this seems
    // unnecessary because we never create any kids property in buildMenu?
    // Possibly bad BB conversion?
    if (item.kids) {
        var kids = undefined.squishMenuList(item.kids);
        var newItem = _extends({}, item);
        newItem.kids = kids;
        if (kids.size() === 1) {
            var kid = kids.pop(); // remove it
            kid.label = newItem.label + " > " + kid.label;
            return kid;
        }
        return newItem;
    }
    return item;
};

var getImplementations = exports.getImplementations = function getImplementations(stereoInfo, access, recordId) {
    return stereoInfo.implementations.filter(function (imp) {
        return access.hasEntityRecord(imp.key, recordId);
    });
};

var getTableKeys = exports.getTableKeys = function getTableKeys(stereoInfo) {
    var tableKeys = [];
    stereoInfo.creatables.forEach(function (it) {
        it.versions.forEach(function (ver) {
            var t = _entityMetaStore2.default.getInfo(ver.key).tableKey;
            if (!tableKeys.includes(t)) {
                tableKeys.push(t);
            }
        });
    });
    return tableKeys;
};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.backboneConnect = backboneConnect;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _processAdapterConfig = __webpack_require__(999);

var _processAdapterConfig2 = _interopRequireDefault(_processAdapterConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A higher-order component which takes a bind config and a "normal" component
 * to bind. There are several ways of expressing a bind config. Here are
 * several equivalent ways:
 *
 * <p>This one is fully explicit, and is the "base" way that the other
 * mechanisms are converted to:
 *
 * <pre>
 * [ { listenOn: "model",
 *     prop: "firstname",
 *     event: "change:firstname",
 *     func: model => ({
 *       firstname: model.get("firstname")
 *     })
 *   }
 * ]</pre>
 *
 * <p>This one uses get instead of func to reduce a little noise, setting the
 * value into the named prop implicitly. Similarly, you can use a value key to
 * supply a literal value for a prop.
 *
 * <pre>
 * [ { listenOn: "model",
 *     prop: "firstname",
 *     event: "change:firstname",
 *     get: model =>
 *       model.get("firstname")
 *   }
 * ]</pre>
 *
 * <p>By naming an attribute, the prop will be set the same, the change event
 * for the attribute will be used, and the function to do it will be generated.
 *
 * <pre>
 * [ { listenOn: "model",
 *     attribute: "firstname"
 *   }
 * ]</pre>
 *
 * <p>This one uses an object, instead of an array, where the object's keys are
 * props to set. This time, the attribute is set to the prop (reverse of
 * above), but the rest is the same. An explicit attribute is supported, if
 * it's different than the prop.
 *
 * <pre>
 * { firstname: { listenOn: "model" }
 * }</pre>
 *
 * <p>With an object config, you can also pass through raw functions in
 * addition to bindings:
 *
 * <pre>
 * { firstname: { listenOn: "model" },
 *   toggleThinger: (arg1, arg2) => ... do some stuff
 * }</pre>
 *
 * <p>Finally, you may pass a function as a bind config. It will be invoked
 * once (and only once!) when the wrapped component is created, and will be
 * passed the component's props. It must return an object or array config as
 * detailed above. This is primarily of interest for model access in your
 * handlers, but can be used to dynamically build config as well. Just keep
 * in mind that it only gets invoked once!
 *
 * <pre>
 * props => ({
 *   firstname: { listenOn: "model" },
 *   toggleThinger: (arg1, arg2) => ... do some stuff using props.model
 * })</pre>
 *
 * <p>If you provide a `get` or `func` function, it will be passed all the
 * arguments the backbone callback will receive, not just model. This is
 * primarily of interest when listening for add/remove events on a Collection,
 * as they pass the collection itself as the second arg (the model that was
 * added or removed is the first).
 *
 * <p>Getting an attribute from a model may throw an error. If you wish, the adapter
 * can catch these errors and instead pass in a default error value. For example:
 *
 * <pre>
 * { firstname: { listenOn: "model", errorValue: "unknown name"} }
 * </pre>
 *
 * <p>So if model.get("firstname") throws an exception, the prop firstname will
 * be set to "unknown name". Note that `errorValue` is only supported for items
 * which don't use `value` or `get`, and rely on the implicit `func`.
 *
 * <p>When the adapted component mounts, props will be initialized if the
 * binding meets any of these criteria:
 *
 * <ul>
 *     <li>has a `value` key,
 *     <li>has a `get` function,
 *     <li>uses a "change:xxx" event (implicitly or explicitly), OR
 *     <li>listens for "add", "remove", or "destroy" on a Collection
 * </ul>
 *
 * <p>All bindings, regardless of type, will be wired up to monitor changes, and
 * then unwired on unmount. Bindings will also be transparently moved to a new
 * model, if one is set into the wrapping component's props.
 *
 * @param {(array|object|function)} bindConfig - An Backbone bind config; see above.
 * @returns {function} A function that takes a React Component and returns a new React Component.
 */
function backboneConnect(bindConfig) {
    return function (WrappedComponent) {
        var BackboneConnect = function (_React$Component) {
            _inherits(BackboneConnect, _React$Component);

            function BackboneConnect(props) {
                _classCallCheck(this, BackboneConnect);

                var _this = _possibleConstructorReturn(this, (BackboneConnect.__proto__ || Object.getPrototypeOf(BackboneConnect)).call(this, props));

                var config = (0, _processAdapterConfig2.default)(_this, bindConfig);
                _this.state = config.statics;
                _this.listenOns = {};
                config.forEach(function (c) {
                    var lo = c.listenOn;
                    if (!_this.listenOns.hasOwnProperty(lo)) {
                        _this.listenOns[lo] = [c];
                    } else {
                        _this.listenOns[lo].push(c);
                    }
                });
                return _this;
            }

            _createClass(BackboneConnect, [{
                key: "UNSAFE_componentWillMount",
                value: function UNSAFE_componentWillMount() {
                    this.doBackboneInitialization();
                }
            }, {
                key: "UNSAFE_componentWillReceiveProps",
                value: function UNSAFE_componentWillReceiveProps(nextProps) {
                    for (var listenOn in this.listenOns) {
                        if (this.props[listenOn] !== nextProps[listenOn]) {
                            this.doBackboneListeners("off", listenOn, this.props);
                            this.doBackboneListeners("on", listenOn, nextProps);
                            this.doBackboneInitialization(listenOn, nextProps);
                        }
                    }
                }
            }, {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.doBackboneListeners("on");
                }
            }, {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.doBackboneListeners("off");
                }
            }, {
                key: "doBackboneListeners",
                value: function doBackboneListeners(method) {
                    var _this2 = this;

                    var listeningOn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;

                    var _loop = function _loop(listenOn) {
                        if (listeningOn != null && listeningOn !== listenOn) return "continue";
                        _this2.listenOns[listenOn].forEach(function (_ref) {
                            var event = _ref.event,
                                listenerFunc = _ref.listenerFunc;

                            if (isListenable(props[listenOn])) {
                                props[listenOn][method](event, listenerFunc, _this2);
                            }
                        });
                    };

                    for (var listenOn in this.listenOns) {
                        var _ret = _loop(listenOn);

                        if (_ret === "continue") continue;
                    }
                }
            }, {
                key: "doBackboneInitialization",
                value: function doBackboneInitialization() {
                    var _this3 = this;

                    var listeningOn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;

                    var _loop2 = function _loop2(listenOn) {
                        if (listeningOn != null && listeningOn !== listenOn) return "continue";
                        _this3.listenOns[listenOn].forEach(function (c) {
                            var func = c.func,
                                event = c.event;

                            if (isListenable(props[listenOn])) {
                                if ("change:" === event.substr(0, 7) || c.hasOwnProperty("value") || c.hasOwnProperty("get")) {
                                    // add/remove/destroy collection events pass the collection as the _second_ arg
                                    if (props[listenOn] instanceof Backbone.Collection && (event.indexOf("add") >= 0 || event.indexOf("remove") >= 0 || event.indexOf("destroy") >= 0)) {
                                        _this3.setState(func(null, props[listenOn]));
                                    } else {
                                        // still might be a collection, but it's not a model-centric collection event
                                        _this3.setState(func(props[listenOn]));
                                    }
                                }
                            } else if (false) {
                                var avail = Object.keys(props).filter(function (k) {
                                    return isListenable(props[k]);
                                }).map(function (it) {
                                    return "'" + it + "'";
                                });
                                console.error("adapter listenOn set to '" + listenOn + "', but only " + avail.join(", ") + " " + (avail.length === 1 ? "is" : "are") + " available");
                            }
                        });
                    };

                    for (var listenOn in this.listenOns) {
                        var _ret2 = _loop2(listenOn);

                        if (_ret2 === "continue") continue;
                    }
                }
            }, {
                key: "render",
                value: function render() {
                    return _react2.default.createElement(WrappedComponent, _extends({}, this.props, this.state));
                }
            }]);

            return BackboneConnect;
        }(_react2.default.Component);

        BackboneConnect.displayName = "Connect(" + (WrappedComponent.displayName || WrappedComponent.name || "Component") + ")";
        return BackboneConnect;
    };
}

var isListenable = function isListenable(it) {
    var instances = [Backbone.Model, Backbone.Collection];

    return instances.some(function (x) {
        return it instanceof x;
    });
};

/***/ }),
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ModalLayout = __webpack_require__(252);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _backboneConnect = __webpack_require__(127);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _ModalActions = __webpack_require__(1489);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * I convert a given component into a modal, using the supplied options. Options
 * may be a string (for the title) or an object containing title and size keys.
 * If not specified, size will be "lg".
 */
var asModal = function asModal(options) {
    return function (WrappedComponent) {
        if (typeof options === "string") {
            options = {
                title: options
            };
        }
        var _options = options,
            _options$title = _options.title,
            title = _options$title === undefined ? "Untitled Modal" : _options$title,
            _options$size = _options.size,
            size = _options$size === undefined ? "lg" : _options$size;

        var Modal = function Modal(props) {
            return _react2.default.createElement(
                _ModalLayout.ModalLayout,
                {
                    title: title,
                    size: size,
                    triggerClose: props.triggerClose
                },
                _react2.default.createElement(WrappedComponent, props)
            );
        };

        Modal.propTypes = {
            triggerClose: _propTypes2.default.func.isRequired
        };

        Modal.displayName = "Modal(" + (WrappedComponent.displayName || WrappedComponent.name || "Component") + ")";

        var config = function config(props) {
            return {
                triggerClose: function triggerClose() {
                    props.view.trigger("close");
                    _Dispatcher2.default.dispatch({
                        type: _ModalActions2.default.CLOSE
                    });
                }
            };
        };

        return (0, _backboneConnect.backboneConnect)(config)(Modal);
    };
};

exports.default = asModal;

/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildDescriptorControl = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _NotFound = __webpack_require__(901);

var _NotFound2 = _interopRequireDefault(_NotFound);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formcontrols = {
    // These should stay as require
    AssociationFieldlabel: __webpack_require__(442).default,
    AssociationFieldrecordbrowser: __webpack_require__(444).default,
    AssociationFieldtypeahead: __webpack_require__(445).default,
    ChoiceFieldcheckbox: __webpack_require__(447).default,
    ChoiceFielddropdown: __webpack_require__(448).default,
    ChoiceFieldlabel: __webpack_require__(449).default,
    ChoiceFieldtypeahead: __webpack_require__(450).default,
    DateFieldcalendar: __webpack_require__(451).default,
    DateFieldlabel: __webpack_require__(458).default,
    DateTimeFieldcalendar: __webpack_require__(294).default,
    DateTimeFieldlabel: __webpack_require__(295).default,
    DecimalFieldlabel: __webpack_require__(459).default,
    DecimalFieldtext: __webpack_require__(460).default,
    FileFieldlabel: __webpack_require__(939).default,
    FileFieldmanager: __webpack_require__(297).default,
    IntegerFieldlabel: __webpack_require__(467).default,
    IntegerFieldspinner: __webpack_require__(468).default,
    Layoutcolumn: __webpack_require__(941).default,
    Layoutcolumnset: __webpack_require__(942).default,
    Layoutgrid: __webpack_require__(943).default,
    Layoutgridrow: __webpack_require__(944).default,
    Layoutgridcell: __webpack_require__(945).default,
    Layoutrow: __webpack_require__(946).default,
    Layoutsection: __webpack_require__(947).default,
    StringFielddropdown: __webpack_require__(469).default,
    StringFieldtext: __webpack_require__(298).default,
    StringFieldtextarea: __webpack_require__(299).default,
    StringFieldlabel: __webpack_require__(300).default,
    TimeFieldspinner: __webpack_require__(470).default,
    TimeFieldlabel: __webpack_require__(471).default,
    Widgetbutton: __webpack_require__(301).default,
    Widgetlabel: __webpack_require__(472).default,
    Widgetvaluemutationbutton: __webpack_require__(949).default

    /* TODO: make temporary jQuery control wrapper
    AssociationFielddevicelesiongrid: require("./AssociationField/devicelesiongrid").default,
    CompositionFieldsummarysection: require("./CompositionField/summarysection").default,
    CompositionFielddevicelesiongrid: require("./CompositionField/devicelesiongrid").default,
    Widgetmagicrootsummarysection: require("./Widget/magicrootsummarysection").default,
    */
};

/**
 * Finds a react control component based on descriptor type and control.
 *
 * @param {object} descriptor
 * @return {node}
 */
var controlResolver = function controlResolver(descriptor) {
    var key = descriptor.type + descriptor.control;
    var ControlComponent = formcontrols[key];
    if (ControlComponent) {
        return ControlComponent;
    }
    // NotFound is also handling error messaging to the console.
    return _NotFound2.default;
};

exports.default = controlResolver;

/**
 * Use descriptor control types as a standalone component without the knowledge of
 * the actual descriptor shape. Builds the descriptor for one off use.
 *
 * @param {string} type
 * @param {string} control
 * @param {object} props
 * @return {node}
 */

var buildDescriptorControl = exports.buildDescriptorControl = function buildDescriptorControl(type, control, props) {
    // create a descriptor that is valid all controls.
    var descriptor = {
        control: control,
        type: type,
        key: props.shortname || props.id || "",
        id: props.id || props.key || "",
        disableBehaviour: "disable",
        label: props.label || "",
        required: !!props.required,
        config: {
            options: props.options,
            checkedValue: props.checkedValue !== undefined ? props.checkedValue : true,
            uncheckedValue: props.uncheckedValue !== undefined ? props.uncheckedValue : false,
            granularity: props.granularity || (type === "DateField" ? "DAY" : "MINUTE"),
            multiValued: props.multiValued !== undefined ? props.multiValued : false,
            valueKey: props.valueKey || "value",
            labelKey: props.labelKey || "label",
            mode: props.mode || "client"
        }
    };

    var newProps = _extends({}, props, {
        value: props.value !== undefined ? props.value : null,
        enabled: props.enabled !== undefined ? props.enabled : !props.disabled,
        descriptor: descriptor,
        className: props.className || "",
        onCommitChange: function onCommitChange(d, v) {
            props.onCommitChange && props.onCommitChange(v);
        },
        onChange: function onChange(e, d, v) {
            props.onChange && props.onChange(e, v); // strip off the descriptor
        },
        onFocus: function onFocus(e, d, v, keyboardShortcuts) {
            props.onFocus && props.onFocus(e, v, keyboardShortcuts); // strip off the descriptor
        },
        onBlur: function onBlur(e, d, v) {
            props.onBlur && props.onBlur(e, v); // strip off the descriptor
        },
        onKeyDown: function onKeyDown(e, d, v) {
            props.onKeyDown && props.onKeyDown(e, v); // strip off the descriptor
        },
        onClick: function onClick(e, d, v) {
            props.onClick && props.onClick(e, v); // strip off the descriptor
        },
        valueType: props.valueType || "string",
        controlOnly: props.controlOnly !== undefined ? props.controlOnly : true,
        placeholder: props.placeholder !== undefined ? props.placeholder : true
    });
    // time to get the actual descriptor control.
    var Control = controlResolver(descriptor);
    return _react2.default.createElement(Control, newProps);
};
/*
buildDescriptorControl.propTypes = {
    // basic props
    id: PropTypes.string,
    key: PropTypes.string,
    controlOnly: PropTypes.bool,
    placeholder: PropTypes.bool,
    className: PropTypes.string,
    value: PropTypes.any,
    label: PropTypes.string,
    enabled: PropTypes.bool,
    disabled: PropTypes.bool,

    // action props
    onCommitChange: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onKeyDown: PropTypes.func,
    onClick: PropTypes.func,

    // input props
    valueType: PropTypes.string,

    // select/typeahead props
    multiValued: PropTypes.bool,
    options: PropTypes.array,
    valueKey: PropTypes.string,
    labelKey: PropTypes.string,

    // typeahead
    mode: PropTypes.oneOf(["client","server"]),

    // date props
    granularity: PropTypes.string,

    // checkbox props
    checkedValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
    uncheckedValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
};
*/

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSuperRecordListRecords = undefined;

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SuperRecordListStore = __webpack_require__(155);

var _SuperRecordListStore2 = _interopRequireDefault(_SuperRecordListStore);

var _SuperRecordActions = __webpack_require__(25);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _typedAction = __webpack_require__(86);

var _typedAction2 = _interopRequireDefault(_typedAction);

var _superRecords = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SuperRecordListActions = {
    START_LOAD: "super-record-list/start-load",
    LOADED: (0, _typedAction2.default)("super-record-list/loaded", {
        key: _propTypes2.default.string.isRequired,
        data: _propTypes2.default.arrayOf(_superRecords.superRecordPacketType).isRequired
    }),
    LOAD_ERROR: "super-record-list/load-error"
};

exports.default = SuperRecordListActions;

// Deprecated-ish :)

var getSuperRecordListRecords = exports.getSuperRecordListRecords = function getSuperRecordListRecords(entityKey) {
    return (0, _SuperRecordActions.clientFilteredList)(_SuperRecordListStore2.default, _TableStore2.default, entityKey);
};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typedAction = __webpack_require__(86);

var _typedAction2 = _interopRequireDefault(_typedAction);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapButtonActions = {
    LAUNCH_DIALOG: (0, _typedAction2.default)("map-button/launch-dialog", {
        target: _propTypes2.default.instanceOf(_EntityProxy2.default).isRequired
    }),
    AUTOMAP_TO_NEW_MAGIC_CHILD: (0, _typedAction2.default)("map-button/automap-to-new-magic-child", {
        entityKey: _EntityName2.default.propType.isRequired,
        newId: _ClientId2.default.propType.isRequired,
        source: _propTypes2.default.instanceOf(_EntityProxy2.default).isRequired
    }),
    AUTOMAP_FROM: (0, _typedAction2.default)("map-button/automap-from", {
        target: _propTypes2.default.instanceOf(_EntityProxy2.default).isRequired,
        source: _propTypes2.default.instanceOf(_EntityProxy2.default).isRequired
    })
};

exports.default = MapButtonActions;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.firstItemInSection = exports.extractSectionList = exports.IMPLICIT_TOP_OF_FORM_SECTION_NAME = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(13);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _storeUtils = __webpack_require__(54);

var _FormActions = __webpack_require__(307);

var _FormActions2 = _interopRequireDefault(_FormActions);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _dotPropImmutable = __webpack_require__(40);

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _DataManager = __webpack_require__(43);

var _DataManager2 = _interopRequireDefault(_DataManager);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _NavigationActions = __webpack_require__(80);

var _NavigationActions2 = _interopRequireDefault(_NavigationActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var id_seq = 0;

var BASE_TIMESTAMP_DESCRIPTOR = {
    _synthetic: true,
    type: "Widget",
    control: "timestamp",
    disableBehaviour: "hide",
    config: {
        mask: "MM/dd/yyyy HH:mm"
    }
};

var hasConfigColumns = function hasConfigColumns(it) {
    var isCompSummary = it.type === "CompositionField" && it.control === "summarysection";
    var isCompDLG = it.type === "CompositionField" && it.control === "devicelesiongrid";
    var isAssocDLG = it.type === "AssociationField" && it.control === "devicelesiongrid";
    var isSummaryOrDLG = isCompSummary || isCompDLG || isAssocDLG;
    return isSummaryOrDLG && it.hasOwnProperty("config") && it.config.hasOwnProperty("columns");
};

var assignIds = function assignIds(it) {
    if (it.id == null) {
        it.id = "fi" + ++id_seq;
    }
    if (it.childItems != null) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = it.childItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var c = _step.value;

                assignIds(c);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    if (hasConfigColumns(it)) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = it.config.columns[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _c = _step2.value;

                _c.hasOwnProperty("itemInfo") && assignIds(_c.itemInfo);
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    }
};

var RE_FIELD_TYPE = /.*Field$/;
var convertToViewOnly = function convertToViewOnly(it) {
    if (it.childItems != null) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = it.childItems[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var c = _step3.value;

                convertToViewOnly(c);
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }
    }
    if (hasConfigColumns(it)) {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
            for (var _iterator4 = it.config.columns[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var _c2 = _step4.value;

                if (_c2.type === "edit") _c2.type = "view";
                _c2.hasOwnProperty("itemInfo") && convertToViewOnly(_c2.itemInfo);
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                }
            } finally {
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }
    } else if (RE_FIELD_TYPE.test(it.type) && it.control !== "label") {
        it.control = "label";
    }
};

var itemTypes = {
    id: _propTypes2.default.string.isRequired,
    key: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired,
    control: _propTypes2.default.string.isRequired,
    config: _propTypes2.default.object,
    childItems: _propTypes2.default.array // of PropTypes.shape(itemTypes)
};

// it's a little weird to have a display name here in a store, but the way the
// jump-to menu was implemented, it uses display names as keys. thus while this
// _is_ a display name, it's semantics in this context are "section key". one of
// the smaller problems in the data model. :|
var IMPLICIT_TOP_OF_FORM_SECTION_NAME = exports.IMPLICIT_TOP_OF_FORM_SECTION_NAME = "Top of Form";

var extractSectionList = exports.extractSectionList = function extractSectionList(descriptor) {
    var names = extractSectionListHelper(descriptor);
    if (names.length > 1) {
        // only see about adding the implicit top-of-form item if there is more
        // than one explicit section on the form.
        var desc = descriptor.childItems[0];
        if (desc.type !== "Layout" || desc.control !== "section") {
            // there is stuff above the form's first section
            names.unshift(IMPLICIT_TOP_OF_FORM_SECTION_NAME);
        }
    }
    return names;
};

var extractSectionListHelper = function extractSectionListHelper(desc) {
    var names = [];
    if (desc.type === "Layout" && desc.control === "section") {
        names.push(desc.label);
    }
    if (desc.hasOwnProperty("childItems")) {
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
            for (var _iterator5 = desc.childItems[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var it = _step5.value;

                names.push.apply(names, _toConsumableArray(extractSectionListHelper(it)));
            }
        } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                }
            } finally {
                if (_didIteratorError5) {
                    throw _iteratorError5;
                }
            }
        }
    }
    return names;
};

var firstNonSyntheticChild = function firstNonSyntheticChild(desc) {
    return desc.childItems.find(function (it) {
        return !it._synthetic;
    });
};

var firstItemInSection = exports.firstItemInSection = function firstItemInSection(desc, sectionName) {
    if (sectionName === IMPLICIT_TOP_OF_FORM_SECTION_NAME) {
        return firstNonSyntheticChild(desc);
    } else {
        return firstItemInSectionHelper(desc, sectionName);
    }
};

var firstItemInSectionHelper = function firstItemInSectionHelper(desc, sectionName) {
    if (desc.type === "Layout" && desc.control === "section" && desc.label === sectionName) {
        // this one!
        return firstNonSyntheticChild(desc);
    }
    if (desc.hasOwnProperty("childItems")) {
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
            for (var _iterator6 = desc.childItems[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var it = _step6.value;

                var item = firstItemInSectionHelper(it, sectionName);
                if (item != null) {
                    return item;
                }
            }
        } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                    _iterator6.return();
                }
            } finally {
                if (_didIteratorError6) {
                    throw _iteratorError6;
                }
            }
        }
    }
    return null;
};

var FormStore = function (_ReduceStore) {
    _inherits(FormStore, _ReduceStore);

    function FormStore() {
        _classCallCheck(this, FormStore);

        return _possibleConstructorReturn(this, (FormStore.__proto__ || Object.getPrototypeOf(FormStore)).call(this, _Dispatcher2.default));
    }

    _createClass(FormStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {};
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {

                case _NavigationActions2.default.SELECT_RECORD:
                    {
                        var key = action.entityKey;
                        if (!state[key]) return state;
                        var lo = state[key];
                        if (lo.hasOperation() || lo.hasValue() || !lo.hasError()) return state;
                        // it has exactly an error; clear it to try again
                        return _extends({}, state, _defineProperty({}, key, lo.removeError()));
                    }

                case _FormActions2.default.START_LOAD:
                    {
                        this.__dispatcher.waitFor([_userStore2.default.getDispatchToken()]);
                        var _lo = state[action.key] || _LoadObject2.default.empty().withPropTypes(itemTypes);
                        return _dotPropImmutable2.default.set(state, action.key, _lo.loading(_DataManager2.default.loadFormDescriptor(action.key, _userStore2.default.getActiveOrgKey())));
                    }

                case _FormActions2.default.LOADED:
                    {
                        this.__dispatcher.waitFor([_entityMetaStore2.default.getDispatchToken()]);
                        action.data.sectionNames = extractSectionList(action.data);
                        var implKey = new _EntityName2.default(action.key).implKey;
                        if (_userStore2.default.getLicensePreference("record-timestamps-on-form", implKey)) {
                            action.data.childItems.unshift(_extends({}, BASE_TIMESTAMP_DESCRIPTOR, {
                                key: "ao_created_at",
                                label: "Record Created"
                            }), _extends({}, BASE_TIMESTAMP_DESCRIPTOR, {
                                key: "ao_updated_at",
                                label: "Record Updated"
                            }));
                        }
                        if (!_entityMetaStore2.default.getInfo(action.key).canWrite) {
                            convertToViewOnly(action.data);
                        }
                        assignIds(action.data);
                        return _dotPropImmutable2.default.set(state, action.key, function (lo) {
                            return lo.receiveValue(action.data);
                        });
                    }

                case _FormActions2.default.LOAD_ERROR:
                    return _dotPropImmutable2.default.set(state, action.key, function (lo) {
                        return lo.receiveError(action.error);
                    });

                default:
                    return state;
            }
        }
    }, {
        key: "getFirstItemInSection",
        value: function getFirstItemInSection(key, sectionName) {
            return firstItemInSection(this.getForm(key), sectionName);
        }
    }, {
        key: "getSectionNames",
        value: function getSectionNames(key) {
            return this.getForm(key).sectionNames;
        }
    }, {
        key: "getForm",
        value: function getForm(key) {
            return this.getFormLO(key).getRequiredValue();
        }
    }, {
        key: "getFormLO",
        value: function getFormLO(key) {
            var _this2 = this;

            return (0, _storeUtils.hotLoadObject)(function () {
                return _this2.getState()[key];
            }, function () {
                return _Dispatcher2.default.dispatch({
                    type: _FormActions2.default.START_LOAD,
                    key: key
                });
            });
        }
    }, {
        key: "getNextControl",
        value: function getNextControl(entityKey, fieldKey) {
            var fieldOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var form = this.getForm(entityKey);
            var returnNext = false;
            var work = function work(layout) {
                var _iteratorNormalCompletion7 = true;
                var _didIteratorError7 = false;
                var _iteratorError7 = undefined;

                try {
                    for (var _iterator7 = layout.childItems[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                        var kid = _step7.value;

                        if (returnNext && (fieldOnly ? kid.type.endsWith("Field") : kid.type !== "Layout")) {
                            return kid;
                        }
                        if (kid.key === fieldKey) {
                            returnNext = true;
                            continue;
                        }
                        if (kid.childItems) {
                            var result = work(kid);
                            if (result != null) {
                                return result;
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError7 = true;
                    _iteratorError7 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion7 && _iterator7.return) {
                            _iterator7.return();
                        }
                    } finally {
                        if (_didIteratorError7) {
                            throw _iteratorError7;
                        }
                    }
                }
            };
            var next = work(form);
            return next == null ? null : next;
        }
    }]);

    return FormStore;
}(_utils.ReduceStore);

exports.default = new FormStore();

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SearchResultActions = {
    // this is unlikely to be what you want. Check out SearchFormActions
    START_SEARCH: "search-result/start-search",

    SEARCH_RESULT: "search-result/search-result",
    SEARCH_ERROR: "search-result/search-error",
    RESET_SEARCH: "search-result/reset-search"
};

exports.default = SearchResultActions;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.lockShape = exports.LockStore = exports.LockTypes = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ContextedReduceStore2 = __webpack_require__(30);

var _ContextedReduceStore3 = _interopRequireDefault(_ContextedReduceStore2);

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _LockApi = __webpack_require__(317);

var _LockApi2 = _interopRequireDefault(_LockApi);

var _LockActions = __webpack_require__(316);

var _LockActions2 = _interopRequireDefault(_LockActions);

var _TableAccess = __webpack_require__(77);

var _TableAccess2 = _interopRequireDefault(_TableAccess);

var _LockBuilder = __webpack_require__(974);

var _LockBuilder2 = _interopRequireDefault(_LockBuilder);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

var _ContextActions = __webpack_require__(170);

var _ContextActions2 = _interopRequireDefault(_ContextActions);

var _SuperRecordStore = __webpack_require__(36);

var _SuperRecordStore2 = _interopRequireDefault(_SuperRecordStore);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _typedefs = __webpack_require__(44);

var _MergeActions = __webpack_require__(59);

var _MergeActions2 = _interopRequireDefault(_MergeActions);

var _MergeStore = __webpack_require__(53);

var _MergeStore2 = _interopRequireDefault(_MergeStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LockTypes = exports.LockTypes = {
    LAYER: "layer", // normal kind
    MERGE_SOURCE: "merge-source"
};

var resetLockStates = function resetLockStates(context, optViolators, pessViolators) {
    var optlock = optViolators && optViolators.length ? _extends({}, context.optlock, {
        violated: true,
        violators: optViolators
    }) : _extends({}, context.optlock, {
        violated: false,
        violators: null,
        dismissed: false
    });
    var pesslock = pessViolators && pessViolators.length ? _extends({}, context.pesslock, {
        violated: true,
        violators: pessViolators.map(function (v) {
            return v.username;
        })
    }) : _extends({}, context.pesslock, {
        violated: false,
        violators: null,
        dismissed: false
    });
    return _extends({}, context, {
        optlock: optlock,
        pesslock: pesslock
    });
};

var releaseLockSetForContext = function releaseLockSetForContext(context) {
    context = resetLockStates(context);
    if (!context.lockSet) return context;
    if (_ClientId2.default.is(context.lockSet.id)) {
        // no need to go server-side
        return deleteLockSetFromContext(context);
    }
    _LockApi2.default.releaseLockset(context.lockSet);
    return context;
};

var deleteLockSetFromContext = function deleteLockSetFromContext(context) {
    context = _extends({}, context);
    delete context.lockSet;
    return context;
};

var createLockSetForContext = function createLockSetForContext(context, key, id) {
    var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : LockTypes.LAYER;

    context = releaseLockSetForContext(context);
    var builder = new _LockBuilder2.default(new _TableAccess2.default(_TableStore2.default.getState(), true), key, id);
    if (builder.isEmpty()) {
        return context;
    }
    var lockSet = builder.toLockSet();
    _LockApi2.default.createLockSet(lockSet);
    return _extends({}, context, {
        key: key,
        id: id,
        type: type,
        lockSet: lockSet
    });
};

var processSuperRecordUpdateState = function processSuperRecordUpdateState(context, action) {
    if (_MergeStore2.default.getPluginKey() === _MergeStore.MERGE_PLUGINS.GLOBAL_MERGE) {
        var mergeState = _MergeStore2.default.getState();
        if (mergeState.source.stereoKey === context.key && mergeState.source.id === context.id) {
            // remove the lock state for the merge source
            return releaseLockSetForContext(context);
        }
    }

    if (context.key !== action.key || context.id !== action.id) {
        return context;
    }
    return createLockSetForContext(context, context.key, context.id);
};

var LockStore = exports.LockStore = function (_ContextedReduceStore) {
    _inherits(LockStore, _ContextedReduceStore);

    function LockStore() {
        _classCallCheck(this, LockStore);

        return _possibleConstructorReturn(this, (LockStore.__proto__ || Object.getPrototypeOf(LockStore)).apply(this, arguments));
    }

    _createClass(LockStore, [{
        key: "getInitialContext",
        value: function getInitialContext() {
            return resetLockStates({});
        }
    }, {
        key: "reduceContext",
        value: function reduceContext(context, action) {
            switch (action.type) {

                case _SuperRecordActions2.default.NEW:
                    {
                        return _extends({}, releaseLockSetForContext(context), {
                            key: action.stereoKey,
                            id: action.newId
                        });
                    }

                case _ContextActions2.default.CLOSE:
                    {
                        return releaseLockSetForContext(context);
                    }

                case _SuperRecordActions2.default.CANCEL:
                case _SuperRecordActions2.default.CANCEL_FOR_OPTLOCK:
                    {
                        return _extends({}, context, {
                            optlock: _extends({}, context.optlock, {
                                dismissed: true
                            }),
                            pesslock: _extends({}, context.pesslock, {
                                dismissed: true
                            })
                        });
                    }

                case _SuperRecordActions2.default.OPEN:
                    {
                        this.__dispatcher.waitFor([_TableStore2.default.getDispatchToken(), _SuperRecordStore2.default.getDispatchToken()]);
                        return createLockSetForContext(context, action.key, action.id);
                    }

                case _MergeActions2.default.SELECT_SOURCE:
                    {
                        this.__dispatcher.waitFor([_MergeStore2.default.getDispatchToken()]);
                        if (_MergeStore2.default.isReady() && _MergeStore2.default.getPluginKey() === _MergeStore.MERGE_PLUGINS.GLOBAL_MERGE) {
                            // only for global merge
                            return createLockSetForContext(context, action.source.stereoKey, action.source.id, LockTypes.MERGE_SOURCE);
                        }
                        return context;
                    }

                case _MergeActions2.default.CANCEL:
                case _MergeActions2.default.CANCEL_FOR_SOURCE_OPTLOCK:
                    {
                        if (_MergeStore2.default.getPluginKey() === _MergeStore.MERGE_PLUGINS.GLOBAL_MERGE && _MergeStore2.default.getState().source !== null) {
                            // global merge with selected source canceled.
                            return releaseLockSetForContext(context);
                        }
                        return context;
                    }

                default:
                    return context;
            }
        }
    }, {
        key: "reduceEachContext",
        value: function reduceEachContext(context, action, contextId) {
            switch (action.type) {

                case _SuperRecordActions2.default.CREATED:
                    {
                        if (context.key !== action.key || context.id !== action.id) {
                            return context;
                        }
                        this.__dispatcher.waitFor([_TableStore2.default.getDispatchToken(), _SuperRecordStore2.default.getDispatchToken()]);
                        context = _extends({}, context, {
                            id: action.data.id
                        });
                        return createLockSetForContext(context, context.key, context.id);
                    }

                case _SuperRecordActions2.default.UPDATED:
                    {
                        this.__dispatcher.waitFor([_TableStore2.default.getDispatchToken(), _SuperRecordStore2.default.getDispatchToken()]);
                        return processSuperRecordUpdateState(context, action);
                    }

                case _SuperRecordActions2.default.DELETED:
                    {
                        if (context.key !== action.key || context.id !== action.id) {
                            return context;
                        }
                        this.__dispatcher.waitFor([_TableStore2.default.getDispatchToken(), _SuperRecordStore2.default.getDispatchToken()]);
                        return releaseLockSetForContext(context);
                    }

                case _LockActions2.default.LOCKSET_CREATED:
                case _LockActions2.default.LOCKSET_CONFIRMED:
                    {
                        if (!context.lockSet || action.id !== context.lockSet.id) {
                            return context;
                        }
                        context = _extends({}, context, {
                            lockSet: action.data
                        });
                        context = resetLockStates(context, action.data.optimisticViolators, action.data.pessimisticViolators);
                        if (context.optlock.violated) {
                            _LockApi2.default.releaseLockset(context.lockSet);
                        }
                        return context;
                    }

                case _LockActions2.default.LOCKSET_RELEASED:
                    {
                        if (!context.lockSet || action.id !== context.lockSet.id) {
                            return context;
                        }
                        return deleteLockSetFromContext(context);
                    }

                default:
                    return context;
            }
        }
    }, {
        key: "getOptLock",
        value: function getOptLock(context) {
            return this.getState(context).optlock;
        }
    }, {
        key: "getPessLock",
        value: function getPessLock(context) {
            var s = this.getState(context);
            return s.lockSet && !_ClientId2.default.is(s.lockSet.id) ? s.pesslock : null;
        }
    }, {
        key: "getActiveLocksetIds",
        value: function getActiveLocksetIds() {
            return this.getEachContext().map(function (ctx) {
                return ctx.lockSet;
            }).filter(function (ls) {
                return ls;
            }).map(function (ls) {
                return ls.id;
            }).filter(function (id) {
                return id && !_ClientId2.default.is(id);
            });
        }
    }]);

    return LockStore;
}(_ContextedReduceStore3.default);

var lockShape = exports.lockShape = {
    violated: _propTypes2.default.bool.isRequired,
    violators: _propTypes2.default.arrayOf(_propTypes2.default.string),
    dismissed: _propTypes2.default.bool.isRequired
};

LockStore.contextTypes = {
    key: _propTypes2.default.string,
    id: _typedefs.recordIdType,
    type: _propTypes2.default.string,
    lockSet: _propTypes2.default.object,
    optlock: _propTypes2.default.exact(lockShape).isRequired,
    pesslock: _propTypes2.default.exact(lockShape).isRequired
};

var lockStore = (0, _typeCheckingStore2.default)(new LockStore(_Dispatcher2.default));

exports.default = lockStore;

/***/ }),
/* 145 */
/***/ (function(module, exports) {

var Collection, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

module.exports = Collection = (function(_super) {
  __extends(Collection, _super);

  function Collection() {
    _ref = Collection.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  Collection.prototype.initialize = function(list, options) {
    if (options == null) {
      options = {};
    }
    if (options.defaultKey) {
      this["default"] = options.defaultKey;
    }
    return Collection.__super__.initialize.call(this, list, options);
  };

  Collection.prototype.getDefault = function() {
    var _this = this;

    return this.find(function(item) {
      return item.get('key') === _this["default"];
    });
  };

  Collection.prototype.getDefaultIndex = function() {
    return this.indexOf(this.getDefault());
  };

  return Collection;

})(Backbone.Collection);


/***/ }),
/* 146 */,
/* 147 */,
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolver = __webpack_require__(348);

var _isFieldHidden = __webpack_require__(177);

var _isFieldHidden2 = _interopRequireDefault(_isFieldHidden);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Kids = function Kids(props) {
    return props.descriptor.childItems && props.descriptor.childItems.length ? props.descriptor.childItems.filter(function (desc) {
        return !desc.type.endsWith("Field") || !(0, _isFieldHidden2.default)(props.activeRecord.entityKey, desc.key);
    }).map(function (desc) {
        return (0, _resolver.renderer)(_extends({}, props, { descriptor: desc }));
    }) : null;
};

exports.default = Kids;

/***/ }),
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
 Convert key events to standardized names.
 This is a work around for IE 11 using non standard e.key names.
*/
var processKeyName = exports.processKeyName = function processKeyName(key) {
    switch (key) {
        case "Up":
            return "ArrowUp";
        case "Down":
            return "ArrowDown";
        case "Left":
            return "ArrowLeft";
        case "Right":
            return "ArrowRight";
        case "Spacebar":
            return " ";
        default:
            return key || "";
    }
};

/***/ }),
/* 154 */,
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(13);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _SuperRecordListActions = __webpack_require__(140);

var _SuperRecordListActions2 = _interopRequireDefault(_SuperRecordListActions);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _dotPropImmutable = __webpack_require__(40);

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _DataManager = __webpack_require__(43);

var _DataManager2 = _interopRequireDefault(_DataManager);

var _storeUtils = __webpack_require__(54);

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * I store List<ID> per superrecord key. I do NOT store actual records!
 */
var SuperRecordListStore = function (_ReduceStore) {
    _inherits(SuperRecordListStore, _ReduceStore);

    function SuperRecordListStore() {
        _classCallCheck(this, SuperRecordListStore);

        return _possibleConstructorReturn(this, (SuperRecordListStore.__proto__ || Object.getPrototypeOf(SuperRecordListStore)).call(this, _Dispatcher2.default));
    }

    _createClass(SuperRecordListStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {};
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            var _this2 = this;

            switch (action.type) {
                case _SuperRecordListActions2.default.START_LOAD:
                    {
                        this.__dispatcher.waitFor([_userStore2.default.getDispatchToken()]);

                        var getPromise = function getPromise() {
                            return _DataManager2.default.loadSuperrecordList(action.key, _userStore2.default.getActiveOrgKey());
                        };
                        var p = void 0;
                        var modelLO = _StereotypesStore2.default.getStereotypeLO(action.key);
                        if (modelLO.hasValue()) {
                            p = getPromise();
                        } else {
                            p = new Promise(function (resolve) {
                                var token = _Dispatcher2.default.register(function () {
                                    _this2.__dispatcher.waitFor([_StereotypesStore2.default.getDispatchToken()]);
                                    if (!_StereotypesStore2.default.hasChanged()) return;
                                    var lo = _StereotypesStore2.default.getStereotypeLO(action.key);
                                    if (!lo.hasValue()) return;
                                    resolve(getPromise());
                                    _Dispatcher2.default.unregister(token);
                                });
                            });
                        }
                        return _dotPropImmutable2.default.set(state, action.key, _LoadObject2.default.loading(p));
                    }

                case _SuperRecordListActions2.default.LOADED:
                    {
                        if (_dotPropImmutable2.default.get(state, action.key) == null) return state;
                        return _dotPropImmutable2.default.set(state, action.key, function (lo) {
                            return lo.receiveValue(action.data.map(function (r) {
                                return r.id;
                            }));
                        });
                    }

                case _SuperRecordListActions2.default.LOAD_ERROR:
                    {
                        if (_dotPropImmutable2.default.get(state, action.key) == null) return state;
                        return _dotPropImmutable2.default.set(state, action.key, function (lo) {
                            return lo.receiveError(action.error);
                        });
                    }

                case _SuperRecordActions2.default.CREATED:
                case _SuperRecordActions2.default.UPDATED:
                case _SuperRecordActions2.default.DELETED:
                    {
                        // this is a _little_ draconian, but it ain't wrong!
                        return this.getInitialState();
                    }

                default:
                    return state;
            }
        }
    }, {
        key: "getList",
        value: function getList(key) {
            return this.getListLO(key).getRequiredValue();
        }
    }, {
        key: "getListLO",
        value: function getListLO(key) {
            var _this3 = this;

            return (0, _storeUtils.hotLoadObject)(function () {
                return _this3.getState()[key];
            }, function () {
                return _Dispatcher2.default.dispatch({
                    type: _SuperRecordListActions2.default.START_LOAD,
                    key: key
                });
            });
        }
    }]);

    return SuperRecordListStore;
}(_utils.ReduceStore);

exports.default = new SuperRecordListStore();

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.optionsForField = exports.optionLabel = exports.optionIsAtomic = exports.optionName = exports.optionId = undefined;

var _ChoiceStore = __webpack_require__(174);

var _ChoiceStore2 = _interopRequireDefault(_ChoiceStore);

var _asArray = __webpack_require__(157);

var _asArray2 = _interopRequireDefault(_asArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var optionId = exports.optionId = function optionId(choiceKey) {
    var options = _ChoiceStore2.default.getChoiceByKey(choiceKey).options;
    return function (name) {
        var opt = (0, _ChoiceStore.fromName)(options, name);
        return opt == null ? null : opt.id;
    };
};

var optionName = exports.optionName = function optionName(choiceKey) {
    return _ChoiceStore2.default.optionName(choiceKey);
};

var optionIsAtomic = exports.optionIsAtomic = function optionIsAtomic(choiceKey) {
    var options = _ChoiceStore2.default.getChoiceByKey(choiceKey).options;
    return function (nameOrId) {
        var opt = (0, _ChoiceStore.fromNameOrId)(options, nameOrId);
        return opt == null ? null : !!opt.atomic;
    };
};

var optionLabel = exports.optionLabel = function optionLabel(choiceKey) {
    var options = _ChoiceStore2.default.getChoiceByKey(choiceKey).options;
    return function (nameOrId) {
        var opt = (0, _ChoiceStore.fromNameOrId)(options, nameOrId);
        return opt == null ? null : opt.label;
    };
};

var optionsForField = exports.optionsForField = function optionsForField(fieldInfo, instance, choice) {
    var includeCurrent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var conditions = fieldInfo.conditions;
    var options = choice.options;
    if (conditions == null || conditions.length === 0) {
        return options;
    }
    var ids = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = conditions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var c = _step.value;

            if (c.expression(instance)) {
                ids.push.apply(ids, _toConsumableArray(c.optionIds));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    if (includeCurrent) {
        var val = (0, _asArray2.default)(instance.get(fieldInfo.key));

        var _loop = function _loop(v) {
            var o = options.find(function (o) {
                return o.name === v;
            });
            if (o) ids.push(o.id);
        };

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = val[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var v = _step2.value;

                _loop(v);
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    }
    return options.filter(function (o) {
        return ids.indexOf(o.id) >= 0;
    });
};

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * I accept a value or an array of values and return a new array containing all
 * the non-null values passed. Flattening is not performed.
 * @param valueOrArray the value or array (or null) to repackage as an array of
 *  values
 * @return {*[]} an array of passed values, possibly empty, never null.
 */
var asArray = function asArray(valueOrArray) {
  return valueOrArray == null ? [] : valueOrArray instanceof Array ? valueOrArray.filter(function (it) {
    return it != null;
  }) : [valueOrArray];
};

exports.default = asArray;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isVersionInfluencing = exports.getPartialCandidateFilter = exports.buildInterpolator = exports.getCandidateFilter = undefined;
exports.asLiteral = asLiteral;

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _Q = __webpack_require__(176);

var _Q2 = _interopRequireDefault(_Q);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCandidateFilter = exports.getCandidateFilter = function getCandidateFilter(fieldInfo, instance) {
    var func = fieldInfo.scripts.filter;
    if (func == null) return function () {
        return true;
    };
    return function (it) {
        return func(instance, it);
    };
};

var ERR_UNSUPPORTED_REF = "Unsupported interpolation ref";
var ERR_UNSUPPORTED_TYPE = "Unsupported interpolation type";
var ERR_UNSUPPORTED_VALUE = "Unsupported interpolation value";

function asLiteral(type, value) {
    switch (type) {
        // a mixture of AS VariableType names and HO XxxField class names
        case "Boolean":
            return value == null ? "_null(true)" : value.toString();
        case "DateField":
            return value == null ? "_null(createDate(1970,1,1))" : _Q2.default.value(value, "DATE").toAS();
        case "Date":
        case "DateTimeField":
            return value == null ? "_null(createDateTime(1970,1,1,0,0,0))" : _Q2.default.value(value, "DATETIME").toAS();
        case "Number":
        case "DecimalField":
            return value == null || isNaN(value) ? "_null(0.0)" : value.toString();
        case "int":
        case "IntegerField":
            return value == null || isNaN(value) ? "_null(0)" : Math.round(value).toString();
        case "ChoiceField":
        case "String":
        case "StringField":
            if (value == null) return "_null(\"\")";
            if (value.indexOf("\"") >= 0) {
                var _e = new Error(ERR_UNSUPPORTED_VALUE);
                _e.type = type;
                _e.value = value;
                throw _e;
            }
            return "\"" + value + "\"";
        case "Time":
        case "TimeField":
            return value == null ? "_null(createTime(0,0,0))" : _Q2.default.value(value, "TIME").toAS();
        default:
            var e = new Error(ERR_UNSUPPORTED_TYPE);
            e.type = type;
            throw e;
    }
}

var buildInterpolator = exports.buildInterpolator = function buildInterpolator(interp) {
    interp.refs.forEach(function (r) {
        if (r.expr) {
            // eslint-disable-next-line no-new-func
            r.expr = Function("instance", "return " + r.expr + ";");
        } else if (r.name) {
            // old untyped refchain style
            r.expr = function (instance) {
                var path = r.name.split(".");
                path.shift(); // "instance"
                if (!r.type) {
                    r.type = path.reduce(function (ek, segment) {
                        var fi = _entityFieldMetaStore2.default.getInfo(ek, segment);
                        return fi.otherEntityKey || fi.type;
                    }, instance.entityKey);
                }
                return ArmusScript._traverse(instance, path);
            };
        } else {
            throw new Error(ERR_UNSUPPORTED_REF);
        }
    });
    return function (instance) {
        var binding = new Map();
        interp.refs.forEach(function (r) {
            return binding.set(r.id, asLiteral(r.type, r.expr(instance)));
        });
        var shards = [];
        interp.parts.forEach(function (p, i) {
            if (i > 0) {
                shards.push(binding.get(interp.ids[i - 1]));
            }
            shards.push(p);
        });
        return shards.join("");
    };
};

var getPartialCandidateFilter = exports.getPartialCandidateFilter = function getPartialCandidateFilter(fieldInfo, instance) {
    // something returned from buildInterpolator (above)
    var func = fieldInfo.scripts.partialFilter;
    if (func == null) return null;
    try {
        return func(instance);
    } catch (e) {
        if (e.message === ERR_UNSUPPORTED_REF) {
            console.warn("Field " + instance.entityKey + "." + fieldInfo.key + "'s candidate filter has a malformed reference, so cannot be partially applied for server-side processing.");
            return null;
        }
        if (e.message === ERR_UNSUPPORTED_TYPE) {
            console.warn("Field " + instance.entityKey + "." + fieldInfo.key + "'s candidate filter uses a " + e.type + " reference, so cannot be partially applied for server-side processing.");
            return null;
        }
        if (e.message === ERR_UNSUPPORTED_VALUE) {
            console.warn("Field " + instance.entityKey + "." + fieldInfo.key + "'s candidate filter uses an unsupported " + e.type + " value, so cannot be partially applied for server-side processing.", e.value);
            return null;
        }
        throw e;
    }
};

var isVersionInfluencing = exports.isVersionInfluencing = function isVersionInfluencing(entityKeyOrInfo, fieldKeyOrInfo) {
    if (typeof fieldKeyOrInfo === "string") {
        var ek = typeof entityKeyOrInfo === "string" ? entityKeyOrInfo : entityKeyOrInfo.key;
        fieldKeyOrInfo = _entityFieldMetaStore2.default.getInfo(ek, fieldKeyOrInfo);
    }
    return fieldKeyOrInfo.versionInfluencing;
};

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(13);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _SearchResultActions = __webpack_require__(143);

var _SearchResultActions2 = _interopRequireDefault(_SearchResultActions);

var _storeUtils = __webpack_require__(54);

var _DataManager = __webpack_require__(43);

var _DataManager2 = _interopRequireDefault(_DataManager);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _dotPropImmutable = __webpack_require__(40);

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

var _SearchFormActions = __webpack_require__(75);

var _SearchFormActions2 = _interopRequireDefault(_SearchFormActions);

var _SearchFormStore = __webpack_require__(82);

var _SearchFormStore2 = _interopRequireDefault(_SearchFormStore);

var _ContextedReduceStore = __webpack_require__(30);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _MergeActions = __webpack_require__(59);

var _MergeActions2 = _interopRequireDefault(_MergeActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var buildKey = function buildKey(key, query, order, pageSize, page) {
    var onlyEnabledRecords = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    if (typeof key !== "string") {
        // assume it's an action (aggregate)
        var a = key;
        key = a.key;
        query = a.query;
        order = a.order;
        pageSize = a.pageSize;
        page = a.page;
        if (a.onlyEnabledRecords != undefined) {
            // if a.onlyEnabledRecords has a value use it.
            // Otherwise use the default value for onlyEnabledRecords.
            onlyEnabledRecords = a.onlyEnabledRecords;
        }
    }
    return key + "?q=" + query + "&o=" + order + "[" + page + ":" + pageSize + "]&oe=" + onlyEnabledRecords;
};

var setPathShape = function setPathShape(state, path, params, data) {
    return _dotPropImmutable2.default.set(state, [path], {
        params: params,
        data: data // could be the raw response data or a LoadObject
    });
};

var getPathData = function getPathData(state, path) {
    var obj = _dotPropImmutable2.default.get(state, [path]);
    return obj ? obj.data : obj;
};

var getPathParams = function getPathParams(state, path) {
    var obj = _dotPropImmutable2.default.get(state, [path]);
    return obj ? obj.params : obj;
};

function freshenSearchCaches(state, key) {
    var isStale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (lo) {
        return true;
    };

    state = _extends({}, state);
    var cacheKeys = new Set();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = Object.keys(state)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var k = _step.value;

            if (k.indexOf("?") < 0) continue; // it's a key cache
            var bareKey = k.split("?", 2)[0];
            if (bareKey !== key) continue;
            var lo = getPathData(state, k);
            if (!isStale(lo)) continue;
            cacheKeys.add(bareKey);
            delete state[k];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = cacheKeys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var cacheKey = _step2.value;

            var params = getPathParams(state, cacheKey);
            if (params) {
                state = doSearch(state, params.key, params.query, params.order, params.pageSize, params.page);
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return state;
}

function resetSearch(state, key, query, order) {
    var tempKey = buildKey(key, query, order, 100, 1);
    var prefix = tempKey.substr(0, tempKey.indexOf("[") + 1);
    var toReset = Object.keys(state).filter(function (k) {
        return k.indexOf(prefix) === 0;
    });
    if (toReset.length === 0) return state;
    state = _extends({}, state);
    toReset.forEach(function (k) {
        return delete state[k];
    });
    return state;
}

function doSearch(state, key, query, order, pageSize, page) {
    var onlyEnabledRecords = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;

    var params = { key: key, query: query, order: order, pageSize: pageSize, page: page, onlyEnabledRecords: onlyEnabledRecords };
    var lo = _LoadObject2.default.load(_DataManager2.default.search(key, query, order, pageSize, page, onlyEnabledRecords));
    state = setPathShape(state, buildKey(key, query, order, pageSize, page, onlyEnabledRecords), params, lo);
    // Set the old cache load object to loading if it exists. Doing this allows
    // the ui to keep the old results visible while showing a spinner overlay.
    // If there is no old cache key just use the actual search LO.
    var cacheLO = getPathData(state, key);
    return setPathShape(state, key, // cache key
    params, cacheLO ? cacheLO.loading() : lo);
}

function doSearchFromStore(fluxContext, state) {
    var _SearchFormStore$getS = _SearchFormStore2.default.getSearchArgs(fluxContext),
        _SearchFormStore$getS2 = _slicedToArray(_SearchFormStore$getS, 5),
        key = _SearchFormStore$getS2[0],
        query = _SearchFormStore$getS2[1],
        order = _SearchFormStore$getS2[2],
        pageSize = _SearchFormStore$getS2[3],
        page = _SearchFormStore$getS2[4];

    return doSearch(state, key, query, order, pageSize, page);
}

var SearchResultStore = function (_ReduceStore) {
    _inherits(SearchResultStore, _ReduceStore);

    function SearchResultStore() {
        _classCallCheck(this, SearchResultStore);

        return _possibleConstructorReturn(this, (SearchResultStore.__proto__ || Object.getPrototypeOf(SearchResultStore)).call(this, _Dispatcher2.default));
    }

    _createClass(SearchResultStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {};
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {

                case _SearchFormActions2.default.INITIALIZE_CONTEXT:
                    {
                        if (!action[_ContextedReduceStore.ACTION_CONTEXT_KEY]) return state;
                        var fluxContext = action[_ContextedReduceStore.ACTION_CONTEXT_KEY];
                        this.__dispatcher.waitFor([_SearchFormStore2.default.getDispatchToken()]);
                        var initiate = !!action.initiateSearch;
                        if (!initiate) {
                            var defaultSearch = _userStore2.default.getDefaultSearchConfig();
                            initiate = defaultSearch.enabled && !!defaultSearch.query && _SearchFormStore2.default.getKey(fluxContext) === defaultSearch.query.key && _SearchFormStore2.default.hasValues(fluxContext);
                        }
                        if (!initiate) return state;
                        if (!action.initiateSearch && !_SearchFormStore2.default.hasValues(fluxContext)) {
                            // Don't do an unconstrained query, unless _explicitly_
                            // requested. This will avoid unbounded searches in the face
                            // of a user's default search becoming obsolete due to
                            // metamodel changes.
                            return state;
                        }
                        return doSearchFromStore(fluxContext, state);
                    }

                case _SearchFormActions2.default.INITIATE_SEARCH:
                case _SearchFormActions2.default.INITIATE_SEARCH_AND_SAVE_DEFAULT:
                    {
                        this.__dispatcher.waitFor([_SearchFormStore2.default.getDispatchToken()]);
                        return doSearchFromStore(action[_ContextedReduceStore.ACTION_CONTEXT_KEY], state);
                    }

                case _SearchFormActions2.default.SORT:
                case _SearchFormActions2.default.SELECT_PAGE:
                case _SearchFormActions2.default.RESTORE_DEFAULT_AND_INITIATE_SEARCH:
                    {
                        this.__dispatcher.waitFor([_SearchFormStore2.default.getDispatchToken()]);
                        return doSearchFromStore(action[_ContextedReduceStore.ACTION_CONTEXT_KEY], state);
                    }

                case _SearchResultActions2.default.START_SEARCH:
                    {
                        var key = action.key,
                            query = action.query,
                            order = action.order,
                            pageSize = action.pageSize,
                            page = action.page,
                            onlyEnabledRecords = action.onlyEnabledRecords;

                        return doSearch(state, key, query, order, pageSize, page, onlyEnabledRecords);
                    }

                case _SearchResultActions2.default.RESET_SEARCH:
                    {
                        var _key = action.key,
                            _query = action.query,
                            _order = action.order;

                        return resetSearch(state, _key, _query, _order);
                    }

                case _SearchResultActions2.default.SEARCH_RESULT:
                    {
                        var params = {
                            key: action.key,
                            query: action.query,
                            order: action.order,
                            pageSize: action.pageSize,
                            page: action.page
                        };
                        state = setPathShape(state, action.key, // cache key
                        params, _LoadObject2.default.empty().receiveValue(action.data) // fake LO
                        );
                        var path = buildKey(action);
                        var lo = getPathData(state, path);
                        if (lo == null) return state;
                        if (lo.receiveValue == null) debugger;
                        return setPathShape(state, path, params, lo.receiveValue(action.data));
                    }

                case _SearchResultActions2.default.SEARCH_ERROR:
                    {
                        var _path = buildKey(action);
                        var _lo = getPathData(state, _path);
                        if (_lo == null) return state;
                        var _params = getPathParams(state, _path);
                        state = setPathShape(state, action.key, // cache key
                        _params, _LoadObject2.default.empty().receiveError(action.error) // fake LO
                        );
                        return setPathShape(state, _path, _params, _lo.receiveError(action.error));
                    }

                case _SuperRecordActions2.default.CREATED:
                    {
                        return freshenSearchCaches(state, action.key);
                    }

                case _SuperRecordActions2.default.UPDATED:
                case _SuperRecordActions2.default.CANCEL_FOR_OPTLOCK:
                case _MergeActions2.default.CANCEL_FOR_SOURCE_OPTLOCK:
                    {
                        return freshenSearchCaches(state, action.key, function (lo) {
                            return !lo.hasValue() || lo.getValueEnforcing().results.some(function (r) {
                                return r.id === action.id;
                            });
                        });
                    }

                case _SuperRecordActions2.default.DELETED:
                    {
                        var next = _extends({}, state);
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                            for (var _iterator3 = Object.keys(next)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var k = _step3.value;

                                if (k.indexOf("?") < 0) continue; // it's a key cache
                                var bareKey = k.split("?", 2)[0];
                                var _lo2 = getPathData(next, k);
                                var isLastForKey = _lo2.getValueEnforcing() === getPathData(next, bareKey).getValueEnforcing();
                                if (!_lo2.hasValue()) {
                                    delete next[k];
                                    if (isLastForKey) {
                                        delete next[bareKey];
                                    }
                                    continue;
                                }
                                var _params2 = getPathParams(next, k);
                                next = setPathShape(next, k, _params2, _lo2.map(function (result) {
                                    var countBefore = result.results.length;
                                    var filtered = _extends({}, result, {
                                        results: result.results.filter(function (r) {
                                            return r.id !== action.id;
                                        })
                                    });
                                    var countAfter = filtered.results.length;
                                    if (countBefore === countAfter) return result; // nothing changed
                                    filtered.totalResultCount -= countBefore - countAfter;
                                    return filtered;
                                }));
                                if (isLastForKey) {
                                    // update cache key
                                    next = setPathShape(next, bareKey, _params2, getPathData(next, k));
                                }
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }

                        return next;
                    }

                default:
                    return state;
            }
        }
    }, {
        key: "getSearchLO",
        value: function getSearchLO(key, query, order) {
            var pageSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 100;
            var page = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

            var _this2 = this;

            var showLoadingModal = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
            var onlyEnabledRecords = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;

            /*
            If we were a bit smarter here, we could track an LO per key/query/order,
            building up a growing number of results over time, and service
            page/pageSize via slicing of the array, instead of making separate
            requests for redundant data. But for now, not doing that is still
            appreciably more efficient than the behaviour to this point.
             */
            var path = buildKey(key, query, order, pageSize, page, onlyEnabledRecords);
            return (0, _storeUtils.hotLoadObject)(function () {
                return getPathData(_this2.getState(), path);
            }, function () {
                return _Dispatcher2.default.dispatch({
                    type: _SearchResultActions2.default.START_SEARCH,
                    key: key,
                    query: query,
                    order: order,
                    pageSize: pageSize,
                    page: page,
                    showLoadingModal: showLoadingModal,
                    onlyEnabledRecords: onlyEnabledRecords
                });
            });
        }
    }, {
        key: "isMostRecentSearchLoading",
        value: function isMostRecentSearchLoading(key) {
            var lo = getPathData(this.getState(), key);
            return lo ? lo.isLoading() : false;
        }
    }, {
        key: "getMostRecentSearch",
        value: function getMostRecentSearch(key) {
            var lo = getPathData(this.getState(), key);
            return lo ? lo.getValue() : undefined;
        }
    }]);

    return SearchResultStore;
}(_utils.ReduceStore);

exports.default = new SearchResultStore();

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ORDER_ITEM_TYPE = exports.MAP_REFERENCE_GLOBAL = exports.MAP_PLACEHOLDER = exports.MAP_INSERT_GLOBAL = exports.MAP_TARGET = exports.FT_MAGIC_ROOT = exports.FT_GLOBAL_REFERENCE_OR_CREATE = exports.FT_GLOBAL_REFERENCE_ONLY = exports.FT_CHILD = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(13);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _DefineActions = __webpack_require__(124);

var _DefineActions2 = _interopRequireDefault(_DefineActions);

var _dotPropImmutable = __webpack_require__(40);

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _HybridConfig = __webpack_require__(41);

var _HybridConfig2 = _interopRequireDefault(_HybridConfig);

var _audit = __webpack_require__(173);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _buildSelfToSelfMappingDef = __webpack_require__(971);

var _ActiveFormActions = __webpack_require__(111);

var _ActiveFormActions2 = _interopRequireDefault(_ActiveFormActions);

var _MergeActions = __webpack_require__(59);

var _MergeActions2 = _interopRequireDefault(_MergeActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FT_CHILD = exports.FT_CHILD = "CHILD"; // RECORD_MAPPING_TYPE_INSERT
var FT_GLOBAL_REFERENCE_ONLY = exports.FT_GLOBAL_REFERENCE_ONLY = "GLOBAL_REFERENCE_ONLY";
var FT_GLOBAL_REFERENCE_OR_CREATE = exports.FT_GLOBAL_REFERENCE_OR_CREATE = "GLOBAL_REFERENCE_OR_CREATE";
var FT_MAGIC_ROOT = exports.FT_MAGIC_ROOT = "MAGIC_ROOT";
// these are historical/legacy
var MAP_TARGET = exports.MAP_TARGET = "RECORD_MAPPING_TYPE_TARGET";
var MAP_INSERT_GLOBAL = exports.MAP_INSERT_GLOBAL = "RECORD_MAPPING_TYPE_INSERT_GLOBAL";
var MAP_PLACEHOLDER = exports.MAP_PLACEHOLDER = "RECORD_MAPPING_TYPE_PLACEHOLDER";
var MAP_REFERENCE_GLOBAL = exports.MAP_REFERENCE_GLOBAL = "RECORD_MAPPING_TYPE_REFERENCE";

var ORDER_ITEM_TYPE = exports.ORDER_ITEM_TYPE = {
    FIELD: 1,
    CHILD: 2
};

var extractFieldMapping = function extractFieldMapping(f) {
    var info = {
        fieldKey: f.fieldKey,
        versionInfluencing: f.versionInfluencing,
        enableScript: f.enableScript,
        // one or the other
        sourceFieldKey: f.sourceFieldKey,
        sourceScript: f.sourceScript
    };
    ["enableScript", "sourceScript"].forEach(function (sn) {
        if (info[sn] != null) {
            // eslint-disable-next-line no-new-func
            info[sn] = new Function("instance", info[sn]);
            if (_HybridConfig2.default.auditScriptlets()) {
                var key = "map" + sn.charAt(0).toUpperCase() + sn.substring(1, sn.length - 6);
                info[sn] = (0, _audit.auditable)(key, info[sn]);
            }
        }
    });
    return info;
};

function loadMapping(state, def) {
    var targetKey = def.INFO.targetKey;
    var sourceKey = def.INFO.sourceKey;
    var info = {
        targetKey: targetKey,
        sourceKey: sourceKey
    };
    info.formOrder = [];

    info.children = def.INFO.children ? def.INFO.children.map(function (c) {
        return {
            edge: extractFieldMapping(c.edge),
            sourceKey: c.sourceKey,
            targetKey: c.targetKey,
            type: c.type
        };
    }) : [];
    info.children.forEach(function (c) {
        return info.formOrder.push({
            shortname: c.edge.fieldKey,
            type: ORDER_ITEM_TYPE.CHILD,
            child: c
        });
    });

    info.fields = def.INFO.fields ? def.INFO.fields.map(extractFieldMapping) : [];
    info.fields.forEach(function (f) {
        return info.formOrder.push({
            shortname: f.fieldKey,
            type: ORDER_ITEM_TYPE.FIELD,
            field: f
        });
    });

    // sanity checks
    if (false) {
        var sns = info.formOrder.map(function (it) {
            return it.shortname;
        });
        if (!sns.every(function (it) {
            return it;
        })) {
            console.log("unnamed : ", info.formOrder.filter(function (it) {
                return !it.shortname;
            }));
            throw new Error("something's missing a shortname");
        }
        var unique = new Set(sns);
        if (unique.size !== sns.length) {
            console.log("shortnames : ", sns.slice().sort());
            console.log("    unique : ", Array.from(unique).sort());
            unique.forEach(function (sn) {
                return sns.splice(sns.indexOf(sn), 1);
            });
            console.log("     dupes : ", sns.slice().sort());
            throw new Error("duplicate shortname(s)?");
        }
    }
    info.formOrder.sort((0, _entityFieldMetaStore.getFieldInfoComparator)(_entityFieldMetaStore2.default.getInfosByKey(targetKey), "shortname"));

    /*
     * Cross tree associations are special in mapping, as they're always
     * implicit, and they live on their nearest common ancestor, not on the
     * owning end. So they aren't part of form order; they're always a
     * separate thing.
     */
    info.crossTrees = def.INFO.crossTrees ? def.INFO.crossTrees.map(function (ct) {
        return {
            fieldKey: ct.fieldKey,
            sourceFieldKey: ct.sourceFieldKey,
            sourceOwnerPath: ct.sourceOwnerPath,
            targetOwnerPath: ct.targetOwnerPath
        };
    }) : [];
    state = _dotPropImmutable2.default.set(state, ["targets", targetKey, "sources", sourceKey], info);
    return state;
}

// TODO: this key is so we don't rebuild the self to self mapping defs every
// time ActiveFormActions.START_RENDER is dispatched.
var SELF_TO_SELF_KEY = "_selfToSelfLoaded";

var MappingInfoStore = function (_ReduceStore) {
    _inherits(MappingInfoStore, _ReduceStore);

    function MappingInfoStore() {
        _classCallCheck(this, MappingInfoStore);

        return _possibleConstructorReturn(this, (MappingInfoStore.__proto__ || Object.getPrototypeOf(MappingInfoStore)).call(this, _Dispatcher2.default));
    }

    _createClass(MappingInfoStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return _defineProperty({
                targets: {}
            }, SELF_TO_SELF_KEY, false);
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {
                case _MergeActions2.default.LAUNCH_DIALOG:
                case _ActiveFormActions2.default.START_RENDER:
                    {
                        if (state[SELF_TO_SELF_KEY]) {
                            return state;
                        }
                        this.__dispatcher.waitFor([_entityFieldMetaStore2.default.getDispatchToken()]);
                        // build all self to self mapping defs
                        (0, _buildSelfToSelfMappingDef.getSelfToSelfMappingDefs)().forEach(function (def) {
                            state = loadMapping(state, def);
                        });

                        state[SELF_TO_SELF_KEY] = true;
                        return state;
                    }
                case _DefineActions2.default.MAPPING:
                    this.__dispatcher.waitFor([_entityFieldMetaStore2.default.getDispatchToken()]);
                    return loadMapping(state, action.def);
                case _DefineActions2.default._UNLOAD:
                    return this.getInitialState();
                default:
                    return state;
            }
        }
    }, {
        key: "getInfo",
        value: function getInfo(targetKey, sourceKey) {
            var targets = this.getState().targets;
            if (!targets.hasOwnProperty(targetKey)) {
                throw new Error("No mappings targeting " + targetKey + " are known.");
            }
            var sources = targets[targetKey].sources;
            if (!sources.hasOwnProperty(sourceKey)) {
                throw new Error("No mapping from " + sourceKey + " to " + targetKey + " is known.");
            }
            return sources[sourceKey];
        }
    }, {
        key: "hasInfo",
        value: function hasInfo(targetKey, sourceKey) {
            var targets = this.getState().targets;
            if (!targets.hasOwnProperty(targetKey)) {
                return false;
            }
            var sources = targets[targetKey].sources;
            if (!sources.hasOwnProperty(sourceKey)) {
                return false;
            }
            return true;
        }
    }]);

    return MappingInfoStore;
}(_utils.ReduceStore);

var coreFieldShape = {
    fieldKey: _propTypes2.default.string.isRequired,
    versionInfluencing: _propTypes2.default.bool,
    enableScript: _propTypes2.default.func
};

var fieldType = _propTypes2.default.oneOfType([_propTypes2.default.shape(_extends({}, coreFieldShape, {
    sourceFieldKey: _propTypes2.default.string.isRequired
})), _propTypes2.default.shape(_extends({}, coreFieldShape, {
    sourceScript: _propTypes2.default.func.isRequired
}))]);

MappingInfoStore.stateTypes = {
    targets: _propTypes2.default.objectOf(_propTypes2.default.shape({
        sources: _propTypes2.default.objectOf(_propTypes2.default.shape({
            sourceKey: _propTypes2.default.string.isRequired,
            targetKey: _propTypes2.default.string.isRequired,
            children: _propTypes2.default.arrayOf(_propTypes2.default.shape({
                edge: _propTypes2.default.oneOfType([fieldType,
                // neither a script nor a key, which means we're "spreading"
                // a single source record across a target hierarchy
                _propTypes2.default.shape(coreFieldShape)]).isRequired,
                sourceKey: _propTypes2.default.string.isRequired,
                targetKey: _propTypes2.default.string.isRequired,
                type: _propTypes2.default.oneOf([FT_CHILD, FT_GLOBAL_REFERENCE_ONLY, FT_GLOBAL_REFERENCE_OR_CREATE, FT_MAGIC_ROOT]).isRequired
            })),
            fields: _propTypes2.default.arrayOf(fieldType),
            crossTrees: _propTypes2.default.arrayOf(_propTypes2.default.shape({
                fieldKey: _propTypes2.default.string.isRequired,
                sourceFieldKey: _propTypes2.default.string.isRequired,
                sourceOwnerPath: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
            }))
        }))
    })).isRequired
};

exports.default = (0, _typeCheckingStore2.default)(new MappingInfoStore());

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ADD_BOTTOM_BUTTON = exports.ADD_TOP_LAST = exports.ADD_TOP_EACH = exports.ADD_TOP = exports.ADD_LAST_ROW = exports.ADD_EACH_ROW = exports.ADD_NONE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formhelpers = __webpack_require__(5);

var _ActionButton = __webpack_require__(249);

var _ActionButton2 = _interopRequireDefault(_ActionButton);

var _HeaderCell = __webpack_require__(1394);

var _HeaderCell2 = _interopRequireDefault(_HeaderCell);

var _HybridCell = __webpack_require__(1395);

var _HybridCell2 = _interopRequireDefault(_HybridCell);

var _formatId = __webpack_require__(114);

var _formatId2 = _interopRequireDefault(_formatId);

var _ErrorBoundary = __webpack_require__(329);

var _ErrorBoundary2 = _interopRequireDefault(_ErrorBoundary);

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ADD_NONE = exports.ADD_NONE = null;
var ADD_EACH_ROW = exports.ADD_EACH_ROW = "each-row";
var ADD_LAST_ROW = exports.ADD_LAST_ROW = "last-row";
var ADD_TOP = exports.ADD_TOP = "top";
var ADD_TOP_EACH = exports.ADD_TOP_EACH = "top-each";
var ADD_TOP_LAST = exports.ADD_TOP_LAST = "top-last";
var ADD_BOTTOM_BUTTON = exports.ADD_BOTTOM_BUTTON = "bottom-button";

var RecordGrid = function (_React$Component) {
    _inherits(RecordGrid, _React$Component);

    function RecordGrid() {
        _classCallCheck(this, RecordGrid);

        return _possibleConstructorReturn(this, (RecordGrid.__proto__ || Object.getPrototypeOf(RecordGrid)).apply(this, arguments));
    }

    _createClass(RecordGrid, [{
        key: "getRowActions",
        value: function getRowActions() {
            var _props = this.props,
                allowView = _props.allowView,
                addMode = _props.addMode,
                allowCreate = _props.allowCreate,
                allowRemove = _props.allowRemove;

            var rowActions = [];
            if (allowView) {
                rowActions.push("view");
            }
            if (allowCreate && [ADD_EACH_ROW, ADD_LAST_ROW, ADD_TOP_EACH, ADD_TOP_LAST].includes(addMode)) {
                rowActions.push("add");
            }
            if (allowRemove) {
                rowActions.push("remove");
            }
            return rowActions;
        }
    }, {
        key: "getCreatableOptions",
        value: function getCreatableOptions() {
            var creatables = this.props.creatables;

            return creatables.map(function (c) {
                return _extends({ value: c.id }, c);
            });
        }
    }, {
        key: "renderTopActions",
        value: function renderTopActions() {
            var _props2 = this.props,
                addMode = _props2.addMode,
                descriptor = _props2.descriptor,
                allowCreate = _props2.allowCreate,
                onAddClick = _props2.onAddClick,
                onFocus = _props2.onFocus,
                onBlur = _props2.onBlur,
                onKeyDown = _props2.onKeyDown,
                enabled = _props2.enabled;

            if (allowCreate && [ADD_TOP, ADD_TOP_EACH, ADD_TOP_LAST].includes(addMode)) {
                return _react2.default.createElement(_ActionButton2.default, {
                    id: descriptor.id + "-add-top",
                    actionType: "new",
                    label: "Add New",
                    dataAlign: "right",
                    onClick: function onClick(e, d, v) {
                        return onAddClick && onAddClick(e, descriptor, v);
                    },
                    options: this.getCreatableOptions(),
                    onKeyDown: onKeyDown,
                    onFocus: onFocus,
                    onBlur: onBlur,
                    enabled: enabled
                });
            }
            return null;
        }
    }, {
        key: "renderRowActions",
        value: function renderRowActions(record, index) {
            var _props3 = this.props,
                addMode = _props3.addMode,
                records = _props3.records,
                descriptor = _props3.descriptor,
                onAddClick = _props3.onAddClick,
                onRemoveClick = _props3.onRemoveClick,
                onViewClick = _props3.onViewClick,
                onFocus = _props3.onFocus,
                onBlur = _props3.onBlur,
                onKeyDown = _props3.onKeyDown,
                enabled = _props3.enabled;

            var actions = [];
            var unique = descriptor.id + record.id + index;
            var rowActions = this.getRowActions();
            var creatableOptions = this.getCreatableOptions();
            rowActions.forEach(function (actionType) {
                var actionProps = {
                    id: unique + actionType,
                    key: unique + actionType,
                    actionType: actionType,
                    onFocus: onFocus,
                    onBlur: onBlur,
                    onKeyDown: onKeyDown,
                    enabled: enabled
                };
                switch (actionType) {
                    case "view":
                        actionProps.onClick = function (e) {
                            return onViewClick && onViewClick(e, descriptor, record, index);
                        };
                        actionProps.entityKey = record.entityKey;
                        break;
                    case "add":
                        if (index !== records.length - 1 && [ADD_LAST_ROW, ADD_TOP_LAST].includes(addMode)) {
                            // only want "add" on the last row.
                            return;
                        }
                        if (creatableOptions.length === 1) {
                            // add action
                            actionProps.onClick = function (e, d, v) {
                                return onAddClick && onAddClick(e, descriptor, v, record);
                            };
                            actionProps.options = creatableOptions;
                        }
                        break;
                    case "remove":
                        actionProps.onClick = function (e) {
                            return onRemoveClick && onRemoveClick(e, descriptor, record, index);
                        };
                        actionProps.entityKey = record.entityKey;
                        break;
                    default:
                        return;

                }
                actions.push(_react2.default.createElement(_ActionButton2.default, actionProps));
            });
            return actions;
        }
    }, {
        key: "renderBottomActions",
        value: function renderBottomActions() {
            var _props4 = this.props,
                addMode = _props4.addMode,
                descriptor = _props4.descriptor,
                creatables = _props4.creatables,
                allowCreate = _props4.allowCreate,
                onAddClick = _props4.onAddClick,
                onFocus = _props4.onFocus,
                onBlur = _props4.onBlur,
                onKeyDown = _props4.onKeyDown,
                enabled = _props4.enabled;

            if (allowCreate && [ADD_BOTTOM_BUTTON].includes(addMode)) {
                var actions = [];
                creatables.forEach(function (c, index) {
                    (0, _invariant2.default)(_EntityName2.default.is(c.id), "non-entityKey creatable id: '" + c.id + "'");
                    actions.push(_react2.default.createElement(_ActionButton2.default, {
                        key: descriptor.id + index,
                        id: descriptor.id + "-add-bottom-" + index,
                        actionType: "new",
                        label: "Add New " + c.label,
                        onClick: function onClick(e, d, v) {
                            return onAddClick && onAddClick(e, descriptor, c);
                        },
                        onFocus: onFocus,
                        onBlur: onBlur,
                        onKeyDown: onKeyDown,
                        enabled: enabled,
                        entityKey: c.id
                    }));
                });
                return actions;
            }
            return null;
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props5 = this.props,
                columns = _props5.columns,
                records = _props5.records,
                onHeaderClick = _props5.onHeaderClick,
                onViewClick = _props5.onViewClick,
                allowView = _props5.allowView,
                descriptor = _props5.descriptor;

            var rowActions = this.getRowActions();
            var actionWidth = rowActions.length * 22;
            var topActions = this.renderTopActions();
            var hasActionColumn = topActions !== null || rowActions.length > 0;
            return _react2.default.createElement(
                _ErrorBoundary2.default,
                null,
                _react2.default.createElement(
                    "div",
                    { key: descriptor.id, className: "record-grid-container" },
                    _react2.default.createElement(
                        "div",
                        { className: "record-grid" },
                        _react2.default.createElement(
                            "table",
                            { className: "table-alt table-condensed" },
                            _react2.default.createElement(
                                "thead",
                                null,
                                _react2.default.createElement(
                                    "tr",
                                    null,
                                    columns.map(function (column, index) {
                                        return _react2.default.createElement(_HeaderCell2.default, {
                                            key: index + column.id,
                                            onClick: function onClick(e) {
                                                return onHeaderClick && onHeaderClick(e, column);
                                            },
                                            column: column
                                        });
                                    }),
                                    hasActionColumn && _react2.default.createElement(
                                        "th",
                                        { className: "actions", width: actionWidth },
                                        _react2.default.createElement(
                                            "div",
                                            { className: "btn-group" },
                                            topActions
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                "tbody",
                                null,
                                records.map(function (record, recordIndex) {
                                    return _react2.default.createElement(
                                        "tr",
                                        { key: record.id, id: (0, _formatId2.default)(record.id, "grid-row") },
                                        columns.map(function (column, columnIndex) {
                                            return _react2.default.createElement(_HybridCell2.default, {
                                                key: columnIndex + column.id,
                                                onDoubleClick: function onDoubleClick(e) {
                                                    return allowView && onViewClick && onViewClick(e, descriptor, record, column);
                                                },
                                                record: record,
                                                column: column
                                            });
                                        }),
                                        hasActionColumn && _react2.default.createElement(
                                            "td",
                                            { className: "actions", width: actionWidth },
                                            _react2.default.createElement(
                                                "p",
                                                { className: "form-control-static" },
                                                _this2.renderRowActions(record, recordIndex)
                                            )
                                        )
                                    );
                                })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "bottom-button-row-container" },
                        _react2.default.createElement(
                            "div",
                            { className: "bottom-button-row" },
                            this.renderBottomActions()
                        )
                    )
                )
            );
        }
    }]);

    return RecordGrid;
}(_react2.default.Component);

exports.default = RecordGrid;


RecordGrid.defaultProps = {
    addMode: ADD_TOP,
    allowView: false,
    allowCreate: false,
    allowRemove: false,
    singularLabel: "Record",
    records: [],
    columns: [],
    creatables: []
};

RecordGrid.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)(null, false), {
    onCommitChange: _propTypes2.default.func, // not required

    addMode: _propTypes2.default.oneOf([ADD_NONE, ADD_EACH_ROW, ADD_LAST_ROW, ADD_TOP, ADD_TOP_EACH, ADD_TOP_LAST, ADD_BOTTOM_BUTTON]),
    allowView: _propTypes2.default.bool,
    allowCreate: _propTypes2.default.bool,
    allowRemove: _propTypes2.default.bool,

    columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
        content: _propTypes2.default.func.isRequired, /* column render function given the record data */
        label: _propTypes2.default.any,
        width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
    })).isRequired,
    records: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    creatables: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
        label: _propTypes2.default.any.isRequired
    })).isRequired,

    // actions
    onAddClick: _propTypes2.default.func,
    onRemoveClick: _propTypes2.default.func,
    onHeaderClick: _propTypes2.default.func,
    onViewClick: _propTypes2.default.func
});

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isExpandAll = exports.isExpanded = exports.setExpandAll = exports.setExpandNode = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _TreeItemTypes = __webpack_require__(621);

var _TreeItemTypes2 = _interopRequireDefault(_TreeItemTypes);

var _ContextedReduceStore2 = __webpack_require__(30);

var _ContextedReduceStore3 = _interopRequireDefault(_ContextedReduceStore2);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var setExpandNode = exports.setExpandNode = function setExpandNode(ctx, key, expand) {
    if (expand && _isExpanded(ctx, key)) {
        return ctx; // already expanded
    }
    if (!expand && !_isExpanded(ctx, key)) {
        return ctx; // already collapsed
    }
    // noinspection EqualityComparisonWithCoercionJS
    return _extends({}, ctx, {
        itemOverrides: ctx.expandAll == expand ? ctx.itemOverrides.filter(function (it) {
            return it !== key;
        }) : ctx.itemOverrides.concat(key)
    });
};

var setExpandAll = exports.setExpandAll = function setExpandAll(ctx, expandAll) {
    return ctx.expandAll === expandAll && ctx.itemOverrides.length === 0 ? ctx : _extends({}, ctx, {
        expandAll: expandAll,
        itemOverrides: [] // clear per-item state
    });
};

var _isExpanded = function _isExpanded(ctx, key) {
    return ctx.expandAll ? ctx.itemOverrides.indexOf(key) < 0 : ctx.itemOverrides.indexOf(key) >= 0;
};

exports.isExpanded = _isExpanded;
var _isExpandAll = function _isExpandAll(ctx) {
    return ctx.expandAll;
};

exports.isExpandAll = _isExpandAll;

var TreeItemStore = function (_ContextedReduceStore) {
    _inherits(TreeItemStore, _ContextedReduceStore);

    function TreeItemStore() {
        _classCallCheck(this, TreeItemStore);

        return _possibleConstructorReturn(this, (TreeItemStore.__proto__ || Object.getPrototypeOf(TreeItemStore)).call(this, _Dispatcher2.default));
    }

    _createClass(TreeItemStore, [{
        key: "getInitialContext",
        value: function getInitialContext() {
            return {
                expandAll: true,
                itemOverrides: []
            };
        }
    }, {
        key: "reduceContext",
        value: function reduceContext(ctx, action) {
            switch (action.type) {
                case _TreeItemTypes2.default.COLLAPSE_ALL:
                    return setExpandAll(ctx, false);
                case _TreeItemTypes2.default.EXPAND_ALL:
                    return setExpandAll(ctx, true);
                case _TreeItemTypes2.default.COLLAPSE_OR_EXPAND:
                    return setExpandNode(ctx, action.key, !_isExpanded(ctx, action.key));
                default:
                    return ctx;
            }
        }
    }, {
        key: "isExpandAll",
        value: function isExpandAll(contextId) {
            return _isExpandAll(this.getState(contextId));
        }
    }, {
        key: "isExpanded",
        value: function isExpanded(contextId, key) {
            return _isExpanded(this.getState(contextId), key);
        }
    }, {
        key: "getExpandedTest",
        value: function getExpandedTest(contextId) {
            var ctx = this.getState(contextId);
            return function (key) {
                return _isExpanded(ctx, key);
            };
        }
    }]);

    return TreeItemStore;
}(_ContextedReduceStore3.default);

TreeItemStore.contextTypes = {
    expandAll: _propTypes2.default.bool.isRequired,
    // this should be a Set, but Node doesn't JSON.stringify correctly
    itemOverrides: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
};

exports.default = (0, _typeCheckingStore2.default)(new TreeItemStore());

/***/ }),
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var safeDispatch = function safeDispatch(payload, isStillNeeded) {
    if (_Dispatcher2.default.isDispatching()) {
        console.warn("deferred dispatch of " + payload.type);
        // eslint-disable-next-line no-settimeout
        setTimeout(function () {
            if (isStillNeeded == null || isStillNeeded()) {
                _Dispatcher2.default.dispatch(payload);
            }
        });
    } else {
        _Dispatcher2.default.dispatch(payload);
    }
};

exports.default = safeDispatch;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ContextActions = {
    CLOSE: "*context/close"
};

exports.default = ContextActions;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _typedAction = __webpack_require__(86);

var _typedAction2 = _interopRequireDefault(_typedAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GxepActions = {
    START_LOAD: "gxep/start-load",
    LOADED: "gxep/loaded",
    LOAD_ERROR: "gxep/load-error",

    START_SAVE: "gxep/start-save",
    SAVED: "gxep/saved",
    SAVE_ERROR: "gxep/save-error",

    UPDATE_PASSWORD: (0, _typedAction2.default)("gxep/update-password", {
        key: _propTypes2.default.string.isRequired,
        password: _propTypes2.default.string.isRequired
    }),

    DIALOG_CLOSED: "gxep/dialog-closed"
};

exports.default = GxepActions;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.concatSlice = exports.fromSlice = exports.toSlice = exports.sliceTypeBuilder = exports.newSlice = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var newSlice = exports.newSlice = function newSlice() {
    return {
        keys: [],
        byKey: {}
    };
};

var sliceTypeBuilder = exports.sliceTypeBuilder = function sliceTypeBuilder(valueType) {
    return _propTypes2.default.shape({
        keys: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
        byKey: _propTypes2.default.objectOf(valueType).isRequired
    });
};

/*
 * Slices are a simple indexed collection represented as an Object. The object
 * has two properties: 'keys', and 'byKey'. Every item in the collection must
 * have an key, and they are listed in order in the 'keys' array. The 'byKey'
 * property contains an object with keys corresponding to the items' keys, and
 * values of the items themselves. This is almost exactly analogous to a
 * clustered PRIMARY KEY in a traditional relational database. The main
 * difference is that the order of the original array is preserved; the items
 * are not ordered by their keys as is normally (though implicitly) the case in
 * a relational database. This makes slices suitable for storing custom-ordered
 * lists (e.g., search results).
 *
 * The 'toSlice' function will take an array of items and create a slice from
 * it, by default using the 'id' propery of each item as the key, and leaving
 * the items untouched. The property to use for the slice may be customized, as
 * well as a "transform" function to mutate the items in the resulting slice.
 * "transform"'s type is `(A, K) -> B`.
 *
 * The 'fromSlice' function will take a slice and return it to it's original
 * array form, preserving order. It also accepts a "transform" function to
 * mutate the items in the resulting array. "transform"'s type is `(B, K) -> A`.
 */

var toSlice = exports.toSlice = function toSlice(items) {
    var keyProp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "id";
    var transform = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    if (items == null) {
        return null;
    }
    if (!(items instanceof Array)) {
        throw new Error("Slices can only be constructed from an array");
    }
    if (typeof keyProp !== "string") {
        throw new Error("toSlice requires a string key property");
    }
    if (transform && typeof transform !== "function") {
        throw new Error("transform, if supplied, must be a function");
    }
    return items.reduce(function (slice, it) {
        if (!it.hasOwnProperty(keyProp)) {
            throw new Error("Item found with no '" + keyProp + "' property");
        }
        var key = it[keyProp];
        if (!slice.byKey.hasOwnProperty(key)) {
            slice.keys.push(key);
        }
        slice.byKey[key] = transform ? transform(it, key) : it;
        return slice;
    }, newSlice());
};

var fromSlice = exports.fromSlice = function fromSlice(slice) {
    var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    if (slice == null) {
        return slice;
    }
    if (transform && typeof transform !== "function") {
        throw new Error("transform, if supplied, must be a function");
    }
    if (!slice.hasOwnProperty("byKey") || !slice.hasOwnProperty("keys")) {
        throw new Error("fromSlice requires a valid slice");
    }
    return slice.keys.map(function (key) {
        var it = slice.byKey[key];
        return transform ? transform(it, key) : it;
    });
};

var concatSlice = exports.concatSlice = function concatSlice() {
    for (var _len = arguments.length, slices = Array(_len), _key = 0; _key < _len; _key++) {
        slices[_key] = arguments[_key];
    }

    var byKey = slices.filter(function (s) {
        return s;
    }).map(function (s) {
        return s.byKey;
    }).reduce(function (allByKey, sliceByKey) {
        return _extends({}, allByKey, sliceByKey);
    }, {});
    return {
        keys: Object.keys(byKey),
        byKey: byKey
    };
};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.audit = exports.auditable = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
                                                                                                                                                                                                                                                                   * I provide a very primitive auditing framework for "stuff".
                                                                                                                                                                                                                                                                   */


var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SKELETON = {
    _count: 0,
    _elapsed: 0, // this is gonna be BS, because of nesting!
    _flux: {
        count: 0,
        elapsed: 0
    },
    _ui: {
        count: 0,
        elapsed: 0
    },
    push: function push(name, elapsed) {
        if (!window.audit.hasOwnProperty(name)) {
            window.audit[name] = {
                count: 0,
                elapsed: 0,
                flux: {
                    count: 0,
                    elapsed: 0
                },
                ui: {
                    count: 0,
                    elapsed: 0
                },
                samples: []
            };
        }
        window.audit._count += 1;
        window.audit._elapsed += elapsed;
        var bucket = window.audit[name];
        bucket.count += 1;
        bucket.elapsed += elapsed;
        if (_Dispatcher2.default.isDispatching()) {
            window.audit._flux.count += 1;
            window.audit._flux.elapsed += elapsed;
            bucket.flux.count += 1;
            bucket.flux.elapsed += elapsed;
        } else {
            window.audit._ui.count += 1;
            window.audit._ui.elapsed += elapsed;
            bucket.ui.count += 1;
            bucket.ui.elapsed += elapsed;
        }
        if (bucket.count <= 100) {
            bucket.samples.push(elapsed);
        }
    },
    reset: function reset() {
        window.audit = _extends({}, SKELETON);
    }
};

SKELETON.reset();

var auditable = exports.auditable = function auditable(name, fn) {
    if (typeof name === "function") {
        console.warn("unnamed auditable created");
        fn = name;
        name = "_unnamed_auditable_";
    }
    return function () {
        var s = Date.now();

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var r = fn.apply(this, args);
        var e = Date.now() - s;
        window.audit.push(name, e);
        return r;
    };
};

var audit = exports.audit = function audit(name, work) {
    if (typeof name === "function") {
        console.warn("unnamed audit performed");
        work = name;
        name = "_unnamed_audit_";
    }
    return auditable(name, work)();
};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChoiceStore = exports.fromNameOrId = exports.fromId = exports.fromName = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(13);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _DefineActions = __webpack_require__(124);

var _DefineActions2 = _interopRequireDefault(_DefineActions);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function loadChoiceIntoState(state, def) {
    return _extends({}, state, _defineProperty({}, def.key, {
        key: def.key,
        atomic: def.options.some(function (o) {
            return o.atomic;
        }),
        options: def.options.map(function (o) {
            return {
                id: o.id,
                name: o.name.toUpperCase(),
                label: o.label || o.name,
                atomic: o.atomic
            };
        })
    }));
}

var fromName = exports.fromName = function fromName(options, name) {
    if (name == null) {
        return null;
    }
    name = name.toUpperCase();
    return options.find(function (o) {
        return o.name === name;
    });
};

var fromId = exports.fromId = function fromId(options, id) {
    if (id == null) {
        return null;
    }
    return options.find(function (o) {
        return o.id === id;
    });
};

var fromNameOrId = exports.fromNameOrId = function fromNameOrId(options, nameOrId) {
    return typeof nameOrId === "string" ? fromName(options, nameOrId) : fromId(options, nameOrId);
};

var ChoiceStore = exports.ChoiceStore = function (_ReduceStore) {
    _inherits(ChoiceStore, _ReduceStore);

    function ChoiceStore() {
        _classCallCheck(this, ChoiceStore);

        return _possibleConstructorReturn(this, (ChoiceStore.__proto__ || Object.getPrototypeOf(ChoiceStore)).apply(this, arguments));
    }

    _createClass(ChoiceStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {};
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {
                case _DefineActions2.default._UNLOAD:
                    return this.getInitialState();
                case _DefineActions2.default.CHOICE:
                    return loadChoiceIntoState(state, action.def);
                default:
                    return state;
            }
        }
    }, {
        key: "getChoiceByKey",
        value: function getChoiceByKey(key) {
            var state = this.getState();
            if (!state.hasOwnProperty(key)) {
                throw new Error("No '" + key + "' choice is known.");
            }
            return state[key];
        }
    }, {
        key: "optionName",
        value: function optionName(choiceKey) {
            var state = this.getState();
            var options = state[choiceKey].options;
            return function (id) {
                var opt = fromId(options, id);
                if (opt != null) {
                    return opt.name;
                }
                // if the named choice doesn't have it, check all choices
                for (var k in state) {
                    if (!state.hasOwnProperty(k)) continue;
                    var otherOpts = state[k].options;
                    opt = fromId(otherOpts, id);
                    if (opt != null) {
                        // found the option
                        if (fromName(options, opt.name) != null) {
                            // the target choice has an equivalent option
                            return opt.name;
                        }
                        // stop looking
                        break;
                    }
                }
                return null;
            };
        }
    }]);

    return ChoiceStore;
}(_utils.ReduceStore);

ChoiceStore.stateTypes = _propTypes2.default.objectOf(_propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    atomic: _propTypes2.default.bool.isRequired,
    options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.number.isRequired,
        name: _propTypes2.default.string.isRequired,
        label: _propTypes2.default.string.isRequired,
        atomic: _propTypes2.default.bool // missing is false-y
    })).isRequired
}));

exports.default = (0, _typeCheckingStore2.default)(new ChoiceStore(_Dispatcher2.default));

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getKeyPrefix = getKeyPrefix;
exports.isOk = isOk;
exports.isWarning = isWarning;
exports.isIllegal = isIllegal;
exports.isBlocking = isBlocking;
exports.sprintf = sprintf;
var ERR_OK = parseInt(ArmusScript.ERR_OK().toString(), 10);
var ERR_ILLEGAL = parseInt(ArmusScript.ERR_ILLEGAL().toString(), 10);
var ERR_WARNING = parseInt(ArmusScript.ERR_WARNING().toString(), 10);
var ERR_BLOCKING = parseInt(ArmusScript.ERR_BLOCKING().toString(), 10);

/**
 * I strip the last segment of a multi-part key. E.g., make two-part version key
 * from a three-part entity key.
 */
function getKeyPrefix(key) {
    var parts = key.split("/").filter(function (it) {
        return it;
    });
    if (parts.length === 1) {
        throw new Error("Single-part key '" + key + "' has no prefix");
    }
    parts.pop();
    return parts.join("/");
}

function isOk(code) {
    return code === ERR_OK;
}

function isWarning(code) {
    return code >= ERR_WARNING && code < ERR_ILLEGAL;
}

function isIllegal(code) {
    return code >= ERR_ILLEGAL && code < ERR_BLOCKING;
}

function isBlocking(code) {
    return code >= ERR_BLOCKING;
}

function sprintf(format) {
    var result = format;
    var i = 1;
    var l = arguments.length;
    while (i < l) {
        result = result.replace(/%s/, arguments[i]);
        i++;
    }
    return result;
}

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SECRET = "q-secret-" + Math.random();

var _NULL = "null";
var _BOOL = "bool";
var _VAL = "val";
var _REF = "ref";
var _DOT = ".";
var _AT = "at";
var _NOT = "!";
var _LT = "<";
var _LTE = "<=";
var _GT = ">";
var _GTE = ">=";
var _EQ = "==";
var _NEQ = "!=";
var _AND = "&&";
var _OR = "||";
var _CALL = "call";
var _ANY = "any";

var T_BOOLEAN = "BOOLEAN";
var T_INTEGER = "INTEGER";
var T_DECIMAL = "DECIMAL";
var T_STRING = "STRING";
var T_DATE = "DATE";
var T_DATETIME = "DATETIME";
var T_TIME = "TIME";
var T_UNBOUND = "UNBOUND";

var isBooleanType = function isBooleanType(type) {
    return type === T_BOOLEAN || type === T_UNBOUND;
};

var isStringType = function isStringType(type) {
    return type === T_STRING || type === T_UNBOUND;
};

var isTimeType = function isTimeType(type) {
    return type === T_UNBOUND || type === T_TIME;
};

var isTemporalType = function isTemporalType(type) {
    return isTimeType(type) || type === T_DATE || type === T_DATETIME;
};

var dot = function dot(base, name) {
    return base == null ? null : typeof base.get === "function" ? base.get(name) : base[name];
};

var at = function at(base, index) {
    return base == null ? null : typeof base.at === "function" ? base.at(index) : base[index];
};

var toLowerCase = function toLowerCase(q) {
    return q.state._ === _VAL ? Q.value(q.state.value.toLowerCase(), T_STRING) : q.call("toLowerCase", T_STRING);
};

var getCompatibleType = function getCompatibleType(left, right) {
    if (left === Q.null()) {
        return right.getType();
    }
    if (right === Q.null()) {
        return left.getType();
    }
    var leftUnbound = left.getType() === T_UNBOUND;
    var rightUnbound = right.getType() === T_UNBOUND;
    if (leftUnbound && rightUnbound) {
        throw new TypeError("Comparison ops require type information on at least one side.");
    }
    if (!leftUnbound && !rightUnbound && left.getType() !== right.getType()) {
        throw new TypeError("Comparison ops only operate on like types.");
    }
    return leftUnbound ? right.getType() : left.getType();
};

var formatValue = function formatValue(val, type) {
    if (val == null) {
        return "null";
    }
    switch (type) {
        case T_STRING:
        case T_INTEGER:
        case T_DECIMAL:
            return val.toString();
        case T_DATE:
            return val.year() + "/" + (val.month() + 1) + "/" + val.date();
        case T_DATETIME:
            return val.year() + "/" + (val.month() + 1) + "/" + val.date() + "T" + val.hours() + ":" + val.minutes() + ":" + val.seconds();
        case T_TIME:
            return "T" + val.hours() + ":" + val.minutes() + ":" + val.seconds();
        default:
            throw new TypeError("Unknown '" + type + "' value");
    }
};

var zeroPad = function zeroPad(n) {
    var l = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

    var s = n.toString();
    while (s.length < l) {
        s = "0" + s;
    }
    return s;
};

var formatQSValue = function formatQSValue(val, type) {
    if (val == null) {
        return "null";
    }
    switch (type) {
        case T_STRING:
            return encodeURIComponent(val);
        case T_INTEGER:
        case T_DECIMAL:
            return val.toString();
        case T_DATE:
            return zeroPad(val.year(), 4) + "-" + zeroPad(val.month() + 1) + "-" + zeroPad(val.date());
        case T_DATETIME:
            return zeroPad(val.year(), 4) + "-" + zeroPad(val.month() + 1) + "-" + zeroPad(val.date()) + "T" + zeroPad(val.hours()) + ":" + zeroPad(val.minutes()) + ":" + zeroPad(val.seconds());
        case T_TIME:
            return zeroPad(val.hours()) + ":" + zeroPad(val.minutes()) + ":" + zeroPad(val.seconds());
        default:
            throw new TypeError("Unknown '" + type + "' value");
    }
};

var Q = function () {
    function Q(secret, state) {
        var _this = this;

        _classCallCheck(this, Q);

        if (secret !== SECRET) {
            throw new Error("You cannot construct Q instances; use a factory method");
        }
        this.state = state;
        this.test = this.test.bind(this);
        var comparisonMethodFactory = function comparisonMethodFactory(_) {
            return function (right) {
                var type = getCompatibleType(_this, right);
                if (isTimeType(type)) {
                    throw new Error("Cannot compare times except for equality");
                }
                return new Q(SECRET, { _: _, left: _this, right: right });
            };
        };
        this.lt = comparisonMethodFactory(_LT);
        this.lte = comparisonMethodFactory(_LTE);
        this.gt = comparisonMethodFactory(_GT);
        this.gte = comparisonMethodFactory(_GTE);
    }

    _createClass(Q, [{
        key: "and",
        value: function and(q) {
            if (!isBooleanType(this.getType()) || !isBooleanType(q.getType())) {
                throw new TypeError("Cannot .and non-boolean expressions");
            }
            if (this.state._ === _BOOL) {
                return this.state.value ? q : this;
            }
            if (q.state._ === _BOOL) {
                return q.state.value ? this : q;
            }
            return new Q(SECRET, { _: _AND, left: this, right: q });
        }
    }, {
        key: "or",
        value: function or(q) {
            if (!isBooleanType(this.getType()) || !isBooleanType(q.getType())) {
                throw new TypeError("Cannot .or non-boolean expressions");
            }
            if (this.state._ === _BOOL) {
                return this.state.value ? this : q;
            }
            if (q.state._ === _BOOL) {
                return q.state.value ? q : this;
            }
            return new Q(SECRET, { _: _OR, left: this, right: q });
        }
    }, {
        key: "at",
        value: function at(index) {
            var type = this.getType();
            if (type !== T_UNBOUND) {
                throw new TypeError("Cannot use 'at' on " + type + " expressions, only refs");
            }
            return new Q(SECRET, { _: _AT, base: this, index: index });
        }
    }, {
        key: "dot",
        value: function dot(name) {
            var type = this.getType();
            if (type !== T_UNBOUND) {
                throw new TypeError("Cannot use 'dot' on " + type + " expressions, only refs");
            }
            return new Q(SECRET, { _: _DOT, base: this, name: name });
        }
    }, {
        key: "any",
        value: function any(test) {
            var type = this.getType();
            if (type !== T_UNBOUND) {
                throw new TypeError("Cannot use 'any' on " + type + " expressions, only refs");
            }
            if (!isBooleanType(test.getType())) {
                throw new TypeError("Cannot .any a non-boolean test");
            }
            return new Q(SECRET, { _: _ANY, delegate: this, test: test });
        }
    }, {
        key: "eq",
        value: function eq(right) {
            getCompatibleType(this, right); // for fail-fast behaviour
            return new Q(SECRET, { _: _EQ, left: this, right: right });
        }
    }, {
        key: "neq",
        value: function neq(right) {
            getCompatibleType(this, right); // for fail-fast behaviour
            return new Q(SECRET, { _: _NEQ, left: this, right: right });
        }
    }, {
        key: "isNull",
        value: function isNull() {
            if (this.state._ === _VAL) {
                return this.state.value == null ? Q.true() : Q.false();
            }
            return this.eq(Q.null());
        }
    }, {
        key: "isNotNull",
        value: function isNotNull() {
            if (this.state._ === _VAL) {
                return this.state.value == null ? Q.false() : Q.true();
            }
            return this.neq(Q.null());
        }
    }, {
        key: "contains",
        value: function contains(right) {
            if (right == null) {
                return Q.true();
            }
            if (!isStringType(this.getType()) || !isStringType(right.getType())) {
                throw new TypeError("Cannot .contains non-string expressions");
            }
            return this.isNotNull().and(right.isNull().or(toLowerCase(this).call("contains", T_BOOLEAN, [toLowerCase(right)])));
        }
    }, {
        key: "call",
        value: function call(method, type) {
            var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

            return new Q(SECRET, { _: _CALL, delegate: this, method: method, args: args, type: type });
        }
    }, {
        key: "negate",
        value: function negate() {
            if (!isBooleanType(this.getType())) {
                throw new TypeError("Cannot .negate a non-boolean");
            }
            if (this.state._ === _BOOL) {
                return this.state.value ? Q.false() : Q.true();
            }
            if (this.state._ === _EQ) {
                return this.state.left.neq(this.state.right);
            }
            if (this.state._ === _NEQ) {
                return this.state.left.eq(this.state.right);
            }
            return new Q(SECRET, { _: _NOT, base: this });
        }

        // like SQL's BETWEEN, both endpoints are included

    }, {
        key: "between",
        value: function between(start, end) {
            var e = Q.true();
            if (start != null) {
                e = e.and(this.gte(start));
            }
            if (end != null) {
                e = e.and(this.lte(end));
            }
            return e;
        }
    }, {
        key: "getType",
        value: function getType() {
            var s = this.state;
            switch (s._) {
                case _NULL:
                    return T_UNBOUND;
                case _BOOL:
                    return T_BOOLEAN;
                case _VAL:
                    return s.type;
                case _REF:
                case _DOT:
                case _AT:
                    return s.type || T_UNBOUND;
                case _NOT:
                case _EQ:
                case _NEQ:
                case _LT:
                case _LTE:
                case _GT:
                case _GTE:
                case _AND:
                case _OR:
                    return T_BOOLEAN;
                case _CALL:
                    return s.type;
                case _ANY:
                    return T_BOOLEAN;
                default:
                    throw new TypeError("Unknown '" + s._ + "' type");
            }
        }
    }, {
        key: "toString",
        value: function toString() {
            var s = this.state;
            switch (s._) {
                case _NULL:
                    return s._;
                case _BOOL:
                    return "" + s.value;
                case _VAL:
                    return "(" + formatValue(s.value, s.type) + " " + s.type + ")";
                case _REF:
                    return s.type == null ? s.name : "(" + s.name + " " + s.type + ")";
                case _DOT:
                    return "(" + s._ + " " + s.base.toString() + " " + s.name + ")";
                case _AT:
                    return "(" + s._ + " " + s.base.toString() + " " + s.index + ")";
                case _NOT:
                    return "(" + s._ + " " + s.base.toString() + ")";
                case _EQ:
                case _NEQ:
                case _LT:
                case _LTE:
                case _GT:
                case _GTE:
                case _AND:
                case _OR:
                    return "(" + s._ + " " + s.left.toString() + " " + s.right.toString() + ")";
                case _CALL:
                    return "(" + s._ + " " + s.delegate.toString() + " " + s.method + s.args.map(function (it) {
                        return " " + it.toString();
                    }).join("") + ")";
                case _ANY:
                    return "(" + s._ + " " + s.delegate.toString() + " " + s.test.toString() + ")";
                default:
                    throw new TypeError("Unknown '" + s._ + "' type");
            }
        }
    }, {
        key: "toObjectFilter",
        value: function toObjectFilter() {
            console.log("Q.toObjectFilter is deprecated; use .test instead");
            return this.test;
        }
    }, {
        key: "toModelFilter",
        value: function toModelFilter() {
            console.log("Q.toModelFilter is deprecated; use .test instead");
            return this.test;
        }
    }, {
        key: "toFilter",
        value: function toFilter() {
            if (this.getType() !== T_BOOLEAN) {
                console.log("a non-boolean filter function?!");
            }
            console.log("Q.toFilter is deprecated; use .test instead");
            return this.test;
        }
    }, {
        key: "test",
        value: function test(record) {
            var s = this.state;
            var delegate = void 0;
            switch (s._) {
                case _NULL:
                    return null;
                case _BOOL:
                    return s.value;
                case _VAL:
                    return s.value;
                case _REF:
                    return dot(record, s.name);
                case _DOT:
                    return dot(s.base.test(record), s.name);
                case _AT:
                    return at(s.base.test(record), s.index);

                case _NOT:
                    return !s.base.test(record);

                case _EQ:
                    // noinspection EqualityComparisonWithCoercionJS
                    return s.left.test(record) == s.right.test(record);
                case _NEQ:
                    // noinspection EqualityComparisonWithCoercionJS
                    return s.left.test(record) != s.right.test(record);
                case _LT:
                    return s.left.test(record) < s.right.test(record);
                case _LTE:
                    return s.left.test(record) <= s.right.test(record);
                case _GT:
                    return s.left.test(record) > s.right.test(record);
                case _GTE:
                    return s.left.test(record) >= s.right.test(record);
                case _AND:
                    return s.left.test(record) && s.right.test(record);
                case _OR:
                    return s.left.test(record) || s.right.test(record);

                case _CALL:
                    delegate = s.delegate.test(record);
                    return delegate[s.method].apply(delegate, s.args.map(function (it) {
                        return it.test(record);
                    }));
                case _ANY:
                    delegate = s.delegate.test(record);
                    return delegate == null ? false : delegate.find(function (it) {
                        return s.test.test({ it: it });
                    }) != null;
                default:
                    throw new TypeError("Unknown '" + s._ + "' type");
            }
        }
    }, {
        key: "toQS",
        value: function toQS() {
            var s = this.state;
            switch (s._) {
                case _NULL:
                    return s._;
                case _BOOL:
                    return "" + s.value;
                case _VAL:
                    return formatQSValue(s.value, s.type);
                case _REF:
                    return encodeURIComponent(s.name);
                case _EQ:
                    var l_ = s.left.state._;
                    if (l_ !== _REF) {
                        throw new Error("When creating a querying, the LHS of EQ must be a ref ('" + l_ + "' is unsupported)");
                    }
                    var r_ = s.right.state._;
                    if (r_ !== _NULL && r_ !== _BOOL && r_ !== _VAL) {
                        throw new Error("When creating a querying, the RHS of EQ must be a value type ('" + r_ + "' is unsupported)");
                    }
                    return s.left.toQS() + "=" + s.right.toQS();
                case _AND:
                    return s.left.toQS() + "&" + s.right.toQS();
                case _DOT:
                case _AT:
                case _NOT:
                case _NEQ:
                case _LT:
                case _LTE:
                case _GT:
                case _GTE:
                case _OR:
                case _CALL:
                case _ANY:
                    throw new Error("'" + s._ + "' nodes are unsupported when creating a query string");
                default:
                    throw new TypeError("Unknown '" + s._ + "' type");
            }
        }
    }, {
        key: "toAS",
        value: function toAS() {
            var s = this.state;
            switch (s._) {
                case _NULL:
                    return "null";
                case _BOOL:
                    return s.value ? "true" : "false";
                case _VAL:
                    if (s.value == null) {
                        return "null";
                    }
                    switch (s.type) {
                        case T_INTEGER:
                        case T_DECIMAL:
                            return s.value.toString();
                        case T_DATE:
                            return "createDate(" + s.value.year() + "," + (s.value.month() + 1) + "," + s.value.date() + ")";
                        case T_DATETIME:
                            return "createDateTime(" + s.value.year() + "," + (s.value.month() + 1) + "," + s.value.date() + "," + s.value.hours() + "," + s.value.minutes() + "," + s.value.seconds() + ")";
                        case T_TIME:
                            return "createTime(" + s.value.hours() + "," + s.value.minutes() + "," + s.value.seconds() + ")";
                        case T_STRING:
                            if (s.value.indexOf("\"") >= 0) {
                                throw new TypeError("Strings can't contain double quotes in ArmusScript");
                            }
                            return "\"" + s.value + "\"";
                        default:
                            throw new TypeError("Unknown '" + s.type + "' value");
                    }
                case _REF:
                    return s.name;
                case _DOT:
                    return s.base.toAS() + "." + s.name;
                case _AT:
                    return s.base.toAS() + "[" + s.index + "]";

                case _NOT:
                    return "!(" + s.base.toAS() + ")";

                case _EQ:
                    return s.left.toAS() + "==" + s.right.toAS();
                case _NEQ:
                    return s.left.toAS() + "!=" + s.right.toAS();
                case _LT:
                    return isTemporalType(getCompatibleType(s.left, s.right)) ? "isBefore(" + s.left.toAS() + "," + s.right.toAS() + ")" : s.left.toAS() + "<" + s.right.toAS();
                case _LTE:
                    return isTemporalType(getCompatibleType(s.left, s.right)) ? "!(isAfter(" + s.left.toAS() + "," + s.right.toAS() + "))" : s.left.toAS() + "<=" + s.right.toAS();
                case _GT:
                    return isTemporalType(getCompatibleType(s.left, s.right)) ? "isAfter(" + s.left.toAS() + "," + s.right.toAS() + ")" : s.left.toAS() + ">" + s.right.toAS();
                case _GTE:
                    return isTemporalType(getCompatibleType(s.left, s.right)) ? "!(isBefore(" + s.left.toAS() + "," + s.right.toAS() + "))" : s.left.toAS() + ">=" + s.right.toAS();
                case _AND:
                    return "(" + s.left.toAS() + "&&" + s.right.toAS() + ")";
                case _OR:
                    return "(" + s.left.toAS() + "||" + s.right.toAS() + ")";

                case _CALL:
                    return s.delegate.toAS() + "." + s.method + "(" + s.args.map(function (it) {
                        return it.toAS();
                    }).join(",") + ")";
                case _ANY:
                    return s.delegate.toAS() + ".any({" + s.test.toAS() + "})";
                default:
                    throw new TypeError("Unknown '" + s._ + "' type");
            }
        }
    }]);

    return Q;
}();

// literals


Q.TRUE = new Q(SECRET, { _: _BOOL, value: true });
Q.FALSE = new Q(SECRET, { _: _BOOL, value: false });
Q.NULL = new Q(SECRET, { _: _NULL });

// static factory functions (for literals)
Q.true = function () {
    return Q.TRUE;
};
Q.false = function () {
    return Q.FALSE;
};
Q.null = function () {
    return Q.NULL;
};

Q.ref = function (name, type) {
    return new Q(SECRET, { _: _REF, name: name, type: type });
};

Q.value = function (value, type) {
    if (type == null) {
        throw new TypeError("Q.value must be passed a non-null type");
    }
    if (type === T_STRING && value != null && value.indexOf("\"") >= 0) {
        console.warn("Q.value was passed a string containing a double quote. This will work for filtering, but not AS conversion.", value);
    }
    if (type === T_BOOLEAN) {
        if (value === true) {
            return Q.true();
        } else if (value === false) {
            return Q.false();
        }
    }
    return new Q(SECRET, { _: _VAL, value: value, type: type });
};

// obsolete factories left to throw helpful messages
Q.all = function () {
    throw new Error("Use 'Q.conjunction', not 'Q.all'");
};
Q.any = function () {
    throw new Error("Use 'Q.disjunction', not 'Q.any'");
};
Q.not = function (value) {
    throw new Error("Use 'q.negate', not 'Q.not'");
};
Q.equal = function (left, right) {
    throw new Error("Use 'q.eq', not 'Q.equal'");
};
Q.notEqual = function (left, right) {
    throw new Error("Use 'q.neq', not 'Q.notQqual'");
};

// utility functions
Q.conjunction = function () {
    for (var _len = arguments.length, exprs = Array(_len), _key = 0; _key < _len; _key++) {
        exprs[_key] = arguments[_key];
    }

    if (exprs.length === 1 && exprs[0] instanceof Array) {
        exprs = exprs[0];
    }
    var l = exprs.length;
    if (l === 0) {
        return Q.true();
    } else if (l === 1) {
        if (!isBooleanType(exprs[0].getType())) {
            throw new TypeError("Cannot .and non-boolean expressions");
        }
        return exprs[0];
    } else {
        var q = exprs[0];
        for (var i = 1; i < l; i++) {
            q = q.and(exprs[i]);
        }
        return q;
    }
};

Q.disjunction = function () {
    for (var _len2 = arguments.length, exprs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        exprs[_key2] = arguments[_key2];
    }

    if (exprs.length === 1 && exprs[0] instanceof Array) {
        exprs = exprs[0];
    }
    var l = exprs.length;
    if (l === 0) {
        return Q.false();
    } else if (l === 1) {
        if (!isBooleanType(exprs[0].getType())) {
            throw new TypeError("Cannot .or non-boolean expressions");
        }
        return exprs[0];
    } else {
        var q = exprs[0];
        for (var i = 1; i < l; i++) {
            q = q.or(exprs[i]);
        }
        return q;
    }
};

exports.default = Q;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _HiddenFieldStore = __webpack_require__(306);

var _HiddenFieldStore2 = _interopRequireDefault(_HiddenFieldStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isFieldHidden = function isFieldHidden(entityKey, fieldKeyOrInfo) {
    if (entityKey == null) {
        throw new Error("isFieldHidden doesn't accept a null entityKey");
    }
    if (fieldKeyOrInfo == null) {
        throw new Error("isFieldHidden doesn't accept a null fieldKeyOrInfo");
    }
    // is it hideable?
    var fi = typeof fieldKeyOrInfo === "string" ? _entityFieldMetaStore2.default.getInfo(entityKey, fieldKeyOrInfo) : fieldKeyOrInfo;
    if (!fi.userHideable) {
        return false;
    }
    var en = new _EntityName2.default(entityKey);
    // is it included in the hidden fields preference?
    if (!_HiddenFieldStore2.default.isIncluded(en.implKey, en.bareEntityKey, fi.key)) {
        return false;
    }
    // it's hidden!
    return true;
};

exports.default = isFieldHidden;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LiveMap = function LiveMap(loader) {
    _classCallCheck(this, LiveMap);

    var cache = new Map();
    this.get = function (key) {
        if (cache.has(key)) return cache.get(key);
        var value = loader(key);
        cache.set(key, value);
        return value;
    };
};

exports.default = LiveMap;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

var _SearchFormStore = __webpack_require__(82);

var _SearchFormStore2 = _interopRequireDefault(_SearchFormStore);

var _SearchFormActions = __webpack_require__(75);

var _SearchFormActions2 = _interopRequireDefault(_SearchFormActions);

var _records = __webpack_require__(113);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BasePlugin = function (_Backbone$Model) {
    _inherits(BasePlugin, _Backbone$Model);

    function BasePlugin() {
        _classCallCheck(this, BasePlugin);

        return _possibleConstructorReturn(this, (BasePlugin.__proto__ || Object.getPrototypeOf(BasePlugin)).apply(this, arguments));
    }

    _createClass(BasePlugin, [{
        key: "defaults",
        value: function defaults() {
            return {
                id: "baseplugin",
                name: "Unknown Plugin",
                fluxContext: "CTX_MappingPlugin",
                fields: []
            };
        }
    }, {
        key: "initialize",
        value: function initialize() {
            var _this2 = this;

            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.options = options;

            this.fluxContext = options.fluxContext;

            this.defaultValuesFromForm = {};

            this.activeRecord = this.options.activeRecord;
            this.entity = this.options.entity;

            this.mapping = this.options.mapping || {};

            this.org = this.options.org;

            this.filterRecords = this.filterRecords.bind(this);
            this.on("change:fields", function (_, v) {
                return v.forEach(function (f) {
                    if (!f.id) f.id = "mpfi-" + _this2.get("id") + "-" + f.key;
                });
            });
        }
    }, {
        key: "loadFields",
        value: function loadFields() {
            // overload me
            _Dispatcher2.default.contextDispatch(this.get("fluxContext"), {
                type: _SearchFormActions2.default.SELECT_STEREOTYPE,
                fields: this.get("fields"),
                key: this.get("id"),
                useDateRanges: false, // no date ranges for plugin search queries.
                useMissingCheckbox: false // no 'missing' checkboxes for plugin search queries.
            });
        }
    }, {
        key: "getDefaultValues",
        value: function getDefaultValues(record) {
            if (this.hasSearchScript()) {
                if (record == null) {
                    record = (0, _records.getActiveRecord)(_TableStore2.default, {
                        key: this.activeRecord.entityKey,
                        id: this.activeRecord.id
                    });
                }
                var qs = this.mapping.searchScript(record);
                return this.parseSearchString(qs);
            }
            return {};
        }
    }, {
        key: "hasPaginationParams",
        value: function hasPaginationParams() {
            return false;
        }
    }, {
        key: "hasSearchScript",
        value: function hasSearchScript() {
            return this.mapping.searchScript && typeof this.mapping.searchScript === "function";
        }
    }, {
        key: "deriveDefaultValuesFromActiveRecord",
        value: function deriveDefaultValuesFromActiveRecord() {
            var _this3 = this;

            if (this.hasSearchScript()) {
                this.defaultValuesFromForm = this.getDefaultValues();

                var fields = _SearchFormStore2.default.getFields(this.get("fluxContext"));
                fields.forEach(function (field) {
                    if (_this3.defaultValuesFromForm[field.key]) {
                        // set the default field value
                        _Dispatcher2.default.contextDispatch(_this3.get("fluxContext"), {
                            type: _SearchFormActions2.default.SET_FIELD,
                            path: field.path,
                            value: _this3.getFormattedValue(field, _this3.defaultValuesFromForm[field.key], true)
                        });
                    }
                });
            }
        }
    }, {
        key: "parseSearchString",
        value: function parseSearchString(searchString) {
            if (searchString == null) return {};
            var arr = searchString.split("&");
            return _.chain(arr)
            // This handles the case of searchString being an empty string.
            .compact().map(function (it) {
                return it.split("=");
            })

            // Armusscript serializes null values as 'null'.
            // If a user needs to enter the string literal 'null'
            // into a form we will need to revisit this.
            //
            // Also filtering out any 'falsy' values
            .filter(function (it) {
                return it[1] !== "null" && it[1];
            }).object().value();
        }
    }, {
        key: "collectionSearchParams",
        value: function collectionSearchParams() {
            var _this4 = this;

            var fields = _SearchFormStore2.default.getFields(this.get("fluxContext"));
            var params = _.chain(fields).map(function (field) {
                return [field.key, _this4.getFormattedValue(field, field.value)];
            })
            // Filter out 'falsy' values
            .filter(function (it) {
                return it[1];
            }).object().value();

            if (this.hasPaginationParams()) {
                params.pagesize = _SearchFormStore2.default.getPageSize(this.get("fluxContext"));
                params.pagenumber = _SearchFormStore2.default.getPage(this.get("fluxContext"));
            }
            return params;
        }
    }, {
        key: "filterRecords",
        value: function filterRecords(records) {
            var results = [];

            if (this.mapping.types == null) return results;
            var types = new Set(this.mapping.types);
            if (types.size === 0) return results;

            var visited = new Set();
            var addChildRecords = function addChildRecords(records) {
                return records.forEach(addRecord);
            };
            var addRecord = function addRecord(record) {
                if (visited.has(record.getKey())) return;
                visited.add(record.getKey());
                if (types.has(record.entityKey)) results.push(record);
                addChildRecords((0, _records.getChildren)(record, true));
            };
            addChildRecords(records);

            return results;
        }
    }, {
        key: "getButtonListingPrefix",
        value: function getButtonListingPrefix() {
            return "Map From ";
        }

        // This may need to be someplace else.
        // We cannot assume any given endpoints
        // will accept search params in the same
        // format.

    }, {
        key: "getFormattedValue",
        value: function getFormattedValue(field, value) {
            var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            if (!value) {
                return;
            }

            switch (field.type) {
                case "date":
                    return direction ? moment(value) : moment(value).format("YYYY-MM-DD");

                default:
                    return value;
            }
        }
    }, {
        key: "getRegisterNotifySearchCallback",
        value: function getRegisterNotifySearchCallback(callback) {
            var _this5 = this;

            if (this.mapping.registerNotifySearchCallback) {
                this.mapping.registerNotifySearchCallback(this, this.activeRecord, function () {
                    _this5.deriveDefaultValuesFromActiveRecord();
                    callback();
                });
            }
        }
    }, {
        key: "getQueryLO",
        value: function getQueryLO(query, initiate, interactive) {
            (0, _invariant2.default)(false, "Subclasses of BasePlugin must override getQueryLO() with their own implementation.");
        }
    }, {
        key: "searchFromActiveRecord",
        value: function searchFromActiveRecord() {
            if (!this.hasSearchScript()) return _LoadObject2.default.empty();
            var params = this.getDefaultValues();
            if (Object.keys(params).filter(function (it) {
                return params[it];
            }).length === 0) {
                // no params means no search
                return _LoadObject2.default.empty();
            }
            return this._searchInternal(params, true, false);
        }
    }, {
        key: "searchInteractive",
        value: function searchInteractive() {
            var initiate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var params = this.collectionSearchParams();
            return this._searchInternal(params, initiate, true);
        }
    }, {
        key: "_searchInternal",
        value: function _searchInternal(params, initiate, interactive) {
            return this.getQueryLO(jQuery.param(params), initiate, interactive).map(this.filterRecords);
        }
    }, {
        key: "searchPaginationResult",
        value: function searchPaginationResult() {
            if (!this.hasPaginationParams()) {
                return {
                    page: 1,
                    pageCount: 0,
                    pageSize: 25,
                    totalResultCount: 0
                };
            }
            var params = this.collectionSearchParams();
            return this.getPagination(jQuery.param(params));
        }

        // this is so ADT can have a hard-coded format, ignoring the metamodel

    }, {
        key: "getLabelForResult",
        value: function getLabelForResult(entityProxy) {
            return entityProxy.getLabel();
        }
    }, {
        key: "validate",
        value: function validate() {
            var fluxContext = this.get("fluxContext");
            if (_SearchFormStore2.default.getFields(fluxContext).length > 0) {
                return _SearchFormStore2.default.hasValues(fluxContext);
            }
            return true;
        }
    }, {
        key: "loadingMessage",
        value: function loadingMessage() {
            return {
                label: "Loading..."
            };
        }
    }]);

    return BasePlugin;
}(Backbone.Model);

exports.default = BasePlugin;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ExportParamActions = {
    START_LOAD: "export-param/start-load",
    LOADED: "export-param/loaded",
    LOAD_ERROR: "export-param/load-error",
    INVALIDATE_CACHE: "export-param/invalidate-cache",

    CREATE: "export-param/create",
    CREATED: "export-param/created",
    CREATE_ERROR: "export-param/create-error",

    RENAME: "export-param/rename",
    RENAMED: "export-param/renamed",
    RENAME_ERROR: "export-param/rename-error",

    UPDATE: "export-param/update",
    UPDATED: "export-param/updated",
    UPDATE_ERROR: "export-param/update-error",

    DELETE: "export-param/delete",
    DELETED: "export-param/deleted",
    DELETE_ERROR: "export-param/delete-error"
};

exports.default = ExportParamActions;

/***/ }),
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
    I parse the query string and return an object representing the parameters
    provided.  Params with a single value will be returned as a string, while
    params with multiple values will be returned as a comma delimited list. The
    `merge` param can be used to override the merge/combing behavior. All keys
    and values will be URL-decoded.
*/
var parse = exports.parse = function parse() {
    var queryString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.search;
    var merge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (agg, it) {
        return agg + "," + it;
    };

    var params = {};
    if (queryString) {
        if (queryString.indexOf("?") === 0) {
            queryString = queryString.substr(1);
        }
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = queryString.split("&")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var pair = _step.value;

                var parts = pair.split("=");
                var name = decodeURIComponent(parts.shift());
                var value = parts.join("=");
                value = decodeURIComponent(value != null ? value : "");
                if (params[name] != null) {
                    params[name] = merge(params[name], value);
                } else {
                    params[name] = value;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return params;
};

/*
    I take a set of key-value pairs and return a query string representing the
    same data.  Values will be implicitly stringified, so complex values will
    need to be pre-serialized.  All keys and values will be URL-encoded.
*/
var serialize = exports.serialize = function serialize(params) {
    var s = [];
    for (var n in params) {
        var v = params[n];
        s.push(encodeURIComponent(n) + "=" + encodeURIComponent(v));
    }
    return s.join("&");
};

exports.default = {
    parse: parse,
    serialize: serialize
};

/***/ }),
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(51);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var counter = 0;

function GonkBox(_ref) {
    var children = _ref.children,
        className = _ref.className,
        style = _ref.style,
        attrs = _objectWithoutProperties(_ref, ["children", "className", "style"]);

    return _react2.default.createElement(
        "div",
        _extends({}, attrs, {
            className: (0, _classnames2.default)("gonk-box", "gonk-box-" + ++counter, className),
            style: _extends({}, style, {
                margin: "1em",
                padding: "1em 2em",
                border: "1px solid #ce838f",
                borderRadius: "0.3em",
                backgroundColor: "#f2dede",
                fontWeight: "bold",
                clear: "both"
            })
        }),
        children || "Gonk! Something's Busted!"
    );
}

GonkBox.propTypes = {
    children: _propTypes2.default.node.isRequired,
    className: _propTypes2.default.string,
    style: _propTypes2.default.object
};

exports.default = GonkBox;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_SHORTCUT_KEYS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formhelpers = __webpack_require__(5);

var _keyEvents = __webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_SHORTCUT_KEYS = exports.DEFAULT_SHORTCUT_KEYS = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]; // 0 - 9

var MISSING_VALUE = "_NULL";

var Select = function (_React$Component) {
    _inherits(Select, _React$Component);

    function Select(props) {
        _classCallCheck(this, Select);

        var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

        _this.selectRef = null;
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onClick = _this.onClick.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        return _this;
    }

    _createClass(Select, [{
        key: "convertStringToValue",
        value: function convertStringToValue(value) {
            var addMissing = this.props.addMissing;

            if (addMissing && value === MISSING_VALUE) {
                return null;
            }
            return value;
        }
    }, {
        key: "convertValueToString",
        value: function convertValueToString(value) {
            var addMissing = this.props.addMissing;

            if (addMissing && (value === undefined || value === null)) {
                return MISSING_VALUE;
            }
            return value;
        }
    }, {
        key: "onKeyDown",
        value: function onKeyDown(e) {
            var _props = this.props,
                descriptor = _props.descriptor,
                onKeyDown = _props.onKeyDown,
                onCommitChange = _props.onCommitChange,
                valueKey = _props.valueKey,
                labelKey = _props.labelKey;

            var options = this.buildOptions();
            var value = this.getValueFromEvent(e);
            var label = null;
            var key = (0, _keyEvents.processKeyName)(e.key);
            var index = DEFAULT_SHORTCUT_KEYS.indexOf(key);
            var isKeyboardShortcut = false;
            var doCommit = false;
            if (index !== -1 && index < options.length) {
                // keyboardShortcuts 0-9 commit change.
                // user typed a valid option
                value = options[index][valueKey];
                label = options[index][labelKey];
                isKeyboardShortcut = true;
                doCommit = true;
            }
            onKeyDown && onKeyDown(e, descriptor, this.convertStringToValue(value), isKeyboardShortcut);
            doCommit && onCommitChange && onCommitChange(descriptor, this.convertStringToValue(value), true, label);
        }
    }, {
        key: "buildKeyboardShortcuts",
        value: function buildKeyboardShortcuts() {
            var labelKey = this.props.labelKey;

            var options = this.buildOptions();
            var keyboardShortcuts = [];
            for (var i = 0; i < 10 && i < options.length; i++) {
                keyboardShortcuts.push({
                    key: DEFAULT_SHORTCUT_KEYS[i],
                    name: options[i][labelKey]
                });
            }
            return keyboardShortcuts;
        }
    }, {
        key: "getValueFromEvent",
        value: function getValueFromEvent(e) {
            var _props$multiple = this.props.multiple,
                multiple = _props$multiple === undefined ? false : _props$multiple;

            if (multiple) {
                var v = e.target.selectedOptions || [];
                return Array.from(v, function (it) {
                    return it.value;
                });
            }
            return e.target.value;
        }
    }, {
        key: "getLabelFromEvent",
        value: function getLabelFromEvent(e) {
            var _props2 = this.props,
                _props2$multiple = _props2.multiple,
                multiple = _props2$multiple === undefined ? false : _props2$multiple,
                valueKey = _props2.valueKey,
                labelKey = _props2.labelKey;

            var options = this.buildOptions();
            if (multiple) {
                var v = e.target.selectedOptions || [];
                return Array.from(v, function (it) {
                    return it.value;
                }).map(function (v) {
                    return options.find(function (it) {
                        return it[valueKey] == v;
                    })[labelKey];
                });
            }
            return options.find(function (it) {
                return it[valueKey] == e.target.value;
            })[labelKey];
        }
    }, {
        key: "onClick",
        value: function onClick(e) {
            var _props3 = this.props,
                descriptor = _props3.descriptor,
                onClick = _props3.onClick;

            var value = this.getValueFromEvent(e);
            onClick && onClick(e, descriptor, this.convertStringToValue(value));
        }
    }, {
        key: "onFocus",
        value: function onFocus(e) {
            var _props4 = this.props,
                descriptor = _props4.descriptor,
                onFocus = _props4.onFocus;

            onFocus && onFocus(e, descriptor, this.convertStringToValue(this.getValueFromEvent(e)), this.buildKeyboardShortcuts());
        }
    }, {
        key: "onBlur",
        value: function onBlur(e) {
            var _props5 = this.props,
                descriptor = _props5.descriptor,
                onBlur = _props5.onBlur;

            var value = this.getValueFromEvent(e);
            onBlur && onBlur(e, descriptor, this.convertStringToValue(value));
        }
    }, {
        key: "onChange",
        value: function onChange(e) {
            var _props6 = this.props,
                descriptor = _props6.descriptor,
                onCommitChange = _props6.onCommitChange,
                enabled = _props6.enabled;

            var value = this.getValueFromEvent(e);
            var label = this.getLabelFromEvent(e);
            enabled && onCommitChange && onCommitChange(descriptor, this.convertStringToValue(value), true, label);
        }
    }, {
        key: "buildOptions",
        value: function buildOptions() {
            var _props7 = this.props,
                _props7$options = _props7.options,
                options = _props7$options === undefined ? [] : _props7$options,
                valueKey = _props7.valueKey,
                labelKey = _props7.labelKey,
                addMissing = _props7.addMissing;

            if (addMissing) {
                var _optionsArr$unshift;

                var optionsArr = [].concat(_toConsumableArray(options));
                optionsArr.unshift((_optionsArr$unshift = {}, _defineProperty(_optionsArr$unshift, valueKey, MISSING_VALUE), _defineProperty(_optionsArr$unshift, labelKey, "Missing"), _optionsArr$unshift));
                return optionsArr;
            }
            return options;
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props8 = this.props,
                _ref = _props8._ref,
                className = _props8.className,
                descriptor = _props8.descriptor,
                placeholder = _props8.placeholder,
                value = _props8.value,
                enabled = _props8.enabled,
                style = _props8.style,
                size = _props8.size,
                valueKey = _props8.valueKey,
                labelKey = _props8.labelKey,
                multiple = _props8.multiple;

            var classname = (className || "form-control") + " focusable";
            var selVal = this.convertValueToString(value) || "";
            var selLbl = "";
            var selOpts = this.buildOptions().map(function (option, index) {
                var value = option[valueKey];
                var label = option[labelKey];
                if (value === selVal) {
                    selLbl = label;
                }
                return _react2.default.createElement(
                    "option",
                    { key: index + "_" + value, value: value },
                    label
                );
            });
            var select = _react2.default.createElement(
                "select",
                {
                    ref: function ref(_ref2) {
                        _this2.selectRef = _ref2;
                        _ref && _ref(_ref2);
                    },
                    className: classname,
                    onChange: this.onChange,
                    onClick: this.onClick,
                    onFocus: this.onFocus,
                    onBlur: this.onBlur,
                    onKeyDown: this.onKeyDown,
                    value: selVal,
                    size: size,
                    disabled: !enabled,
                    style: style,
                    multiple: multiple
                },
                selOpts
            );
            // This will emulate a placeholder overlay like an INPUT control, but
            // which SELECT doesn't support for obvious reasons. One more "violate
            // best practices" like ARMUS loves to do and then kludge around!
            if (placeholder && selLbl === "" && descriptor.label) {
                return _react2.default.createElement(
                    "div",
                    {
                        style: {
                            display: "block",
                            position: "relative",
                            margin: 0,
                            padding: 0
                        }
                    },
                    _react2.default.createElement(
                        "div",
                        {
                            style: {
                                position: "absolute",
                                top: "0.55em",
                                left: "1em",
                                fontSize: "110%",
                                color: "#9d9d9d",
                                pointerEvents: "none"
                            }
                        },
                        descriptor.label
                    ),
                    select
                );
            }
            return select;
        }
    }]);

    return Select;
}(_react2.default.Component);

exports.default = Select;


Select.defaultProps = {
    valueKey: "value",
    labelKey: "label"
};

Select.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)(), {
    options: _propTypes2.default.arrayOf(_propTypes2.default.object.isRequired),
    valueKey: _propTypes2.default.string.isRequired,
    labelKey: _propTypes2.default.string.isRequired,
    addMissing: _propTypes2.default.bool
});

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(154);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _keyEvents = __webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DROPDOWN_ROOT_ID = "react-dropdown-container";

var getDropdownRoot = function getDropdownRoot() {
    var dropdownRoot = document.getElementById(DROPDOWN_ROOT_ID);
    if (!dropdownRoot) {
        // then create it
        dropdownRoot = document.createElement("div");
        dropdownRoot.setAttribute("id", DROPDOWN_ROOT_ID);
        document.body.appendChild(dropdownRoot);
    }
    return dropdownRoot;
};

var DropdownWrapper = function (_React$Component) {
    _inherits(DropdownWrapper, _React$Component);

    function DropdownWrapper(props) {
        _classCallCheck(this, DropdownWrapper);

        var _this = _possibleConstructorReturn(this, (DropdownWrapper.__proto__ || Object.getPrototypeOf(DropdownWrapper)).call(this, props));

        _this.onClick = _this.onClick.bind(_this);
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.onHide = _this.onHide.bind(_this);
        _this.onResize = _this.onResize.bind(_this);
        _this.addListeners = _this.addListeners.bind(_this);
        _this.removeListeners = _this.removeListeners.bind(_this);

        _this.wrapperRef = _react2.default.createRef();
        _this.dropdownRef = props.dropdownRef || _react2.default.createRef();
        _this.dropdownRoot = getDropdownRoot();
        _this.el = document.createElement("div"); // the portal div
        _this.activeIndex = null;
        _this.dropdownPositioning = null;
        return _this;
    }

    _createClass(DropdownWrapper, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            // remove event listeners
            this.dropdownRoot.contains(this.el) && this.dropdownRoot.removeChild(this.el);
            this.removeListeners();
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            var initialActiveIndex = this.props.initialActiveIndex;

            this.activeIndex = initialActiveIndex !== undefined ? initialActiveIndex : 0;
            this.updateDropdownPosition();
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            var initialActiveIndex = this.props.initialActiveIndex;

            if (prevProps.initialActiveIndex !== initialActiveIndex) {
                this.activeIndex = initialActiveIndex !== undefined ? initialActiveIndex : 0;
            }
            this.updateDropdownPosition();
        }
    }, {
        key: "onClick",
        value: function onClick(e) {
            // handle hide
            if ($(e.target).is(this.props.ignoreClickSelector) || $(e.target).parents().is(this.props.ignoreClickSelector)) {
                return;
            } else if (e.target === this.wrapperRef.current) {
                // hide immediately
                this.onHide();
                return;
            }
            this.onHide();
        }
    }, {
        key: "onKeyDown",
        value: function onKeyDown(e) {
            // handle Enter/Escape/Arrow keys
            var _props = this.props,
                targetRef = _props.targetRef,
                ignoreSpaceKey = _props.ignoreSpaceKey,
                itemSelector = _props.itemSelector,
                onEnterKey = _props.onEnterKey,
                activeItemClass = _props.activeItemClass;

            var keyDownName = (0, _keyEvents.processKeyName)(e.key);
            if (!["ArrowUp", "ArrowDown", "Escape", "Enter", " ", "Tab"].includes(keyDownName)) {
                return;
            }

            if ([" "].includes(keyDownName) && (this.activeIndex === null || ignoreSpaceKey)) {
                return;
            }

            // has keyboard accessible items to focus/click.
            e.preventDefault();
            e.stopPropagation();

            var $target = $(targetRef.current);
            if (["Escape", "Tab"].includes(keyDownName) || $target.is(".disabled, :disabled")) {
                this.onHide();
                return;
            }

            var $dropdown = $(this.dropdownRef.current);
            var $items = $dropdown.find(itemSelector);
            if ($items.length === 0) {
                // no items to show
                return;
            }

            var $activeItem = $items.eq(this.activeIndex);
            if (["Enter", " "].includes(keyDownName)) {
                if (this.activeIndex === null) {
                    // no active items just hide.
                    this.onHide();
                    return;
                } else {
                    // click active item
                    if (onEnterKey) {
                        onEnterKey(e, this.activeIndex);
                    } else {
                        $activeItem.trigger("click") // for react
                        .get(0).click(); // for everything else
                        this.onHide();
                    }
                    return;
                }
            }

            if (this.activeIndex === null) {
                this.activeIndex = 0;
            } else if (["ArrowUp"].includes(keyDownName)) {
                this.activeIndex--; // up
            } else if (["ArrowDown"].includes(keyDownName)) {
                this.activeIndex++; // down
            }

            if (this.activeIndex < 0) {
                // loop to the end
                this.activeIndex = $items.length - 1;
            }
            if (this.activeIndex >= $items.length) {
                // loop to the beginning
                this.activeIndex = 0;
            }

            var $newActiveItem = $items.eq(this.activeIndex);
            if (activeItemClass) {
                // remove/add the active item class
                if ($activeItem.hasClass(activeItemClass)) {
                    $activeItem.removeClass(activeItemClass);
                }
                $newActiveItem.addClass(activeItemClass);
            }

            $dropdown.scrollTo($newActiveItem);
            $newActiveItem.trigger("focus");
        }
    }, {
        key: "onResize",
        value: function onResize() {
            this.onHide();
        }
    }, {
        key: "onHide",
        value: function onHide() {
            // reset local state
            this.removeListeners();
            this.props.onHide && this.props.onHide();
        }
    }, {
        key: "addListeners",
        value: function addListeners() {
            var targetRef = this.props.targetRef;

            $(targetRef.current).parent().addClass("open");
            window.addEventListener("resize", this.onResize);
            window.addEventListener("keydown", this.onKeyDown);
        }
    }, {
        key: "removeListeners",
        value: function removeListeners() {
            var targetRef = this.props.targetRef;

            $(targetRef.current).parent().removeClass("open");
            window.removeEventListener("resize", this.onResize);
            window.removeEventListener("keydown", this.onKeyDown);
        }
    }, {
        key: "zIndexOfLayer",
        value: function zIndexOfLayer(layer) {
            switch (layer) {
                case "navbar":
                    return 11001;
                case "IT":
                    return 11000; // /test/it/lib/templates/style.less
                default:
                    return 9999;
            }
        }
    }, {
        key: "updateDropdownPosition",
        value: function updateDropdownPosition() {
            var _props2 = this.props,
                targetRef = _props2.targetRef,
                autoSize = _props2.autoSize,
                align = _props2.align,
                dropdownLength = _props2.dropdownLength,
                itemSelector = _props2.itemSelector,
                activeItemClass = _props2.activeItemClass,
                layer = _props2.layer,
                scrollSelector = _props2.scrollSelector;

            var $dropdown = $(this.dropdownRef.current);
            var $wrapper = $(this.wrapperRef.current);
            var $target = $(targetRef.current);

            var containerHeight = $(window).height();
            var maxHeight = $dropdown.outerHeight(); // height of dropdown.
            var width = autoSize || align === "fill" ? $target.outerWidth() : $dropdown.outerWidth();
            var left = $target.offset().left;
            var top = $target.offset().top + $target.outerHeight();

            // find if the target has a parent ".record-grid-container" then adjust the left and width to be from .record-grid-container
            var $gridContainer = $target.parents(".record-grid-container");
            if ($gridContainer.length && (autoSize || align === "fill")) {
                // in a record grid! Use the $gridContainer's width and left position.
                width = $gridContainer.outerWidth();
                left = $gridContainer.offset().left;
            }

            var $items = $dropdown.find("tr, li, div"); // find the items in the dropdown
            if (dropdownLength && autoSize) {
                var itemHeight = $items.length > 0 ? $items.first().outerHeight() : 37; // default height of an item
                maxHeight = itemHeight * dropdownLength;
                if ($items.length < dropdownLength) {
                    maxHeight = itemHeight * $items.length;
                }
            }

            if ($target.offset().top + maxHeight + $target.outerHeight() >= containerHeight + $(window).scrollTop()) {
                // to big to completely show
                // find out if top or bottom has more room overall for the dropdown
                if (top >= containerHeight / 2 + $(window).scrollTop()) {
                    // top has more room
                    top = $target.offset().top - maxHeight;
                    if ($(window).scrollTop() > top) {
                        // crop the dropdown.
                        maxHeight = maxHeight - Math.abs(top - $(window).scrollTop()) - 5;
                        top = $(window).scrollTop() + 5;
                    }
                } else {
                    // bottom has more room
                    // crop it the dropdown.
                    var overflow = $target.offset().top + maxHeight + $target.outerHeight() - (containerHeight + $(window).scrollTop());
                    maxHeight = maxHeight - overflow - 5;
                }
            }

            switch (align) {
                case "right":
                    left += $target.outerWidth() - $dropdown.outerWidth();
                    break;
                case "center":
                    left += $target.outerWidth() / 2 - $dropdown.outerWidth() / 2;
                    break;
                case "fill":
                case "left":
                default:
                // defaults to left.
            }

            var styles = {
                left: left + "px",
                top: top + "px",
                maxHeight: autoSize ? maxHeight + "px" : "",
                width: width + "px",
                height: "auto",
                overflow: "auto"
            };

            // Now do the DOM stuff
            $wrapper.css({ zIndex: this.zIndexOfLayer(layer) }); // set dropdowns zIndex

            if (this.activeIndex !== null && activeItemClass) {
                // focus and add active styling to activeIndex
                var $activeItem = $dropdown.find(itemSelector).eq(this.activeIndex);
                $activeItem.addClass(activeItemClass);
                $dropdown.scrollTo($activeItem); // also scroll item into view.
                $activeItem.trigger("focus");
            } else if (scrollSelector) {
                var _$activeItem = $dropdown.find(scrollSelector);
                $dropdown.scrollTo(_$activeItem); // also scroll item into view.
            }

            if (!_.isEqual(styles, this.dropdownPositioning)) {
                // only update if different.
                $dropdown.css(styles);
            }
            this.dropdownPositioning = styles;
        }
    }, {
        key: "render",
        value: function render() {
            var children = this.props.children;

            if (!this.dropdownRoot.contains(this.el)) {
                // add listener
                this.dropdownRoot.appendChild(this.el);
                this.addListeners();
            }

            var kid = children;
            if (!this.props.dropdownRef) {
                // setup a dropdownRef for the provided child.
                kid = _react2.default.Children.toArray(children);
                if (kid.length > 1) {
                    throw new Error("DropdownHelper only supports a single child.");
                } else {
                    kid = _react2.default.cloneElement(kid[0], { ref: this.dropdownRef });
                }
            }

            var content = _react2.default.createElement(
                "div",
                {
                    ref: this.wrapperRef,
                    className: "dropdown-wrapper open",
                    onClick: this.onClick,
                    onKeyDown: this.onKeyDown
                },
                kid
            );

            return _reactDom2.default.createPortal(content, this.el);
        }
    }]);

    return DropdownWrapper;
}(_react2.default.Component);

exports.default = DropdownWrapper;


DropdownWrapper.defaultProps = {
    appendTo: "body", dropdownLength: 8,
    autoSize: true,
    align: "left",
    layer: "default",
    toggle: true,
    itemSelector: "li:not(.disabled):visible a",
    ignoreClickSelector: "",
    initialActiveIndex: null,
    activeItemClass: "",
    scrollSelector: null,
    ignoreSpaceKey: false
};

DropdownWrapper.propTypes = {
    targetRef: _propTypes2.default.object.isRequired,
    dropdownRef: _propTypes2.default.object,
    children: _propTypes2.default.any,
    options: _propTypes2.default.object,
    onHide: _propTypes2.default.func.isRequired,
    appendTo: _propTypes2.default.string,
    dropdownLength: _propTypes2.default.number,
    autoSize: _propTypes2.default.bool,
    align: _propTypes2.default.string,
    layer: _propTypes2.default.string,
    toggle: _propTypes2.default.bool,
    onEnterKey: _propTypes2.default.func,
    itemSelector: _propTypes2.default.string,
    ignoreClickSelector: _propTypes2.default.string,
    initialActiveIndex: _propTypes2.default.number,
    activeItemClass: _propTypes2.default.string,
    scrollSelector: _propTypes2.default.string,
    ignoreSpaceKey: _propTypes2.default.bool
};

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.INPUT_VALUE_TYPES = exports.ENTER_KEY = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formhelpers = __webpack_require__(5);

var _InputMask = __webpack_require__(907);

var _InputMask2 = _interopRequireDefault(_InputMask);

var _keyEvents = __webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ENTER_KEY = exports.ENTER_KEY = "Enter";
var INPUT_VALUE_TYPES = exports.INPUT_VALUE_TYPES = {
    INTEGER: "integer",
    DECIMAL: "decimal",
    STRING: "string"
};

var checkIntegerKey = function checkIntegerKey(rawValue, key, index) {
    var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : INPUT_VALUE_TYPES.INTEGER;

    if (key === "-") {
        // ignore negative numbers.
        if (rawValue.indexOf("-") > 0) {
            // only allow one negative sign
            return "Invalid character \"a 2nd negative\" was entered for this " + type + " field and will be ignored.";
        }
        if (index > 0) {
            // only allow one negative sign
            return "Invalid character position \"negative\" was entered for this " + type + " field and will be ignored.";
        }
    } else if ((key < "0" || key > "9") && // ignore 0-9
    key.length === 1 // ignore named keys.
    ) {
            return "Invalid character \"" + key + "\" was entered for this " + type + " field and will be ignored.";
        }
};

var checkDecimalKey = function checkDecimalKey(rawValue, key, index) {
    if (key === ".") {
        if (rawValue.indexOf(".") >= 0) {
            // only allow one decimal point
            return "Invalid character \"a 2nd decimal\" was entered for this decimal field and will be ignored.";
        }
    } else {
        return checkIntegerKey(rawValue, key, index, INPUT_VALUE_TYPES.DECIMAL);
    }
};

var validateInsertText = function validateInsertText(valueType, currentValue, selectionStart, selectionEnd, insertValue) {
    // returns
    //   false - no errors present.
    //   {msg,value} - error occurred, returns valid value up to error point.
    var checkKey = valueType === INPUT_VALUE_TYPES.INTEGER ? checkIntegerKey : valueType === INPUT_VALUE_TYPES.DECIMAL ? checkDecimalKey : null;
    if (checkKey == null) return false; // no rules to validate.
    var nextValue = currentValue;
    if (selectionStart === undefined) {
        // browser does not expose e.target.selectionStart/End?
        // paste to end of value
        selectionEnd = selectionStart = currentValue.length;
    }
    // insert the clipboard text into the value replacing the selectionStart/End contents.
    nextValue = nextValue.slice(0, selectionStart) + insertValue + nextValue.slice(selectionEnd);

    var value = "";
    for (var i = 0; i < nextValue.length; i++) {
        var c = nextValue.charAt(i);
        var msg = checkKey(value, c, i);
        if (msg != null) {
            return {
                msg: msg,
                value: value
            };
        }
        value += c;
    }
    return false;
};

var Input = function (_React$Component) {
    _inherits(Input, _React$Component);

    function Input(props) {
        _classCallCheck(this, Input);

        var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

        _this.inputRef = props._ref || _react2.default.createRef();
        /* Some controls will require a local state so editing can take place
         * before the final value is actually committed.
         */
        _this.state = {
            value: _this.convertValueToString(props.value)
        };
        _this.hasChanges = false; // this is used so onBlur only commits when changes have been made.
        _this.hasFocus = false; // only commit change when control has focus.
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onClick = _this.onClick.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.onPaste = _this.onPaste.bind(_this);
        return _this;
    }

    _createClass(Input, [{
        key: "convertStringToValue",
        value: function convertStringToValue(strValue) {
            var checkForChanged = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var _props = this.props,
                valueType = _props.valueType,
                value = _props.value;

            if (checkForChanged && !this.hasChanges) {
                // just return the prop value
                return value;
            }
            if (strValue === "") {
                return null;
            }
            switch (valueType) {
                case INPUT_VALUE_TYPES.DECIMAL:
                    if (strValue === ".") return "0.";
                    return isNaN(parseFloat(strValue)) ? null : strValue;
                case INPUT_VALUE_TYPES.INTEGER:
                    strValue = parseInt(strValue, 10);
                    return !isNaN(strValue) ? strValue : null;
                case INPUT_VALUE_TYPES.STRING:
                default:
                    return strValue;
            }
        }
    }, {
        key: "convertValueToString",
        value: function convertValueToString(value) {
            var valueType = this.props.valueType;

            if (value === undefined || value === null) {
                return "";
            }
            switch (valueType) {
                case INPUT_VALUE_TYPES.DECIMAL:
                    return value.toString();
                case INPUT_VALUE_TYPES.INTEGER:
                    return value.toString();
                case INPUT_VALUE_TYPES.STRING:
                default:
                    return value;
            }
        }
    }, {
        key: "onKeyDown",
        value: function onKeyDown(e) {
            var _props2 = this.props,
                descriptor = _props2.descriptor,
                onKeyDown = _props2.onKeyDown,
                value = _props2.value,
                onCommitChange = _props2.onCommitChange,
                enabled = _props2.enabled,
                valueType = _props2.valueType,
                onIllegal = _props2.onIllegal;

            var rawValue = e.target.value;
            var newValue = this.convertStringToValue(rawValue);
            var key = (0, _keyEvents.processKeyName)(e.key);
            if (key === ENTER_KEY) {
                // enter
                if (newValue !== value) {
                    // commit the value change
                    enabled && onCommitChange(descriptor, newValue);
                    this.hasChanges = false;
                }
            } else {
                var isModifier = e.ctrlKey || e.altKey || e.metaKey || key.length > 1;
                if (!isModifier) {
                    var result = validateInsertText(valueType, rawValue, e.target.selectionStart, e.target.selectionEnd, key);
                    if (result) {
                        // validation failed
                        e.preventDefault && e.preventDefault();
                        e.stopPropagation && e.stopPropagation();
                        onIllegal(result.msg);
                    }
                }
            }
            onKeyDown && onKeyDown(e, descriptor, newValue, false);
        }
    }, {
        key: "onPaste",
        value: function onPaste(e) {
            var _props3 = this.props,
                valueType = _props3.valueType,
                onIllegal = _props3.onIllegal;

            var result = validateInsertText(valueType, e.target.value, e.target.selectionStart, e.target.selectionEnd, e.clipboardData.getData("Text"));
            if (result) {
                // validation failed
                e.preventDefault && e.preventDefault();
                e.stopPropagation && e.stopPropagation();
                this.setState({ value: result.value });
                this.hasChanges = true;
                onIllegal(result.msg);
            }
        }
    }, {
        key: "onClick",
        value: function onClick(e) {
            var _props4 = this.props,
                descriptor = _props4.descriptor,
                onClick = _props4.onClick;

            onClick && onClick(e, descriptor, this.convertStringToValue(e.target.value));
        }
    }, {
        key: "onFocus",
        value: function onFocus(e) {
            var _props5 = this.props,
                descriptor = _props5.descriptor,
                onFocus = _props5.onFocus;

            onFocus && onFocus(e, descriptor, this.convertStringToValue(e.target.value));
            this.hasFocus = true;
        }
    }, {
        key: "onBlur",
        value: function onBlur(e) {
            var _props6 = this.props,
                descriptor = _props6.descriptor,
                onBlur = _props6.onBlur,
                value = _props6.value,
                enabled = _props6.enabled,
                onCommitChange = _props6.onCommitChange,
                focused = _props6.focused;

            if (!this.hasFocus && !focused) {
                // control does not have focus.
                return;
            }
            var newValue = this.convertStringToValue(e.target.value);
            if (newValue !== value) {
                // commit the value change
                enabled && onCommitChange(descriptor, newValue);
            }
            this.hasChanges = false;
            // trigger blur after onCommitChange has fired.
            enabled && onBlur && onBlur(e, descriptor, newValue);
            this.hasFocus = false;
        }
    }, {
        key: "UNSAFE_componentWillReceiveProps",
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            // if the control has focus and has changes then don't change the local state.
            // the user is most editing a while records are updating in the background.
            if (this.hasChanges && this.hasFocus) return;

            /* Make sure the local state stays in sync with the passed in props. */
            var nextPropValue = this.convertValueToString(nextProps.value);
            if (this.state.value !== nextPropValue || this.inputRef.current.value !== nextPropValue) {
                // only update state if the prop values do not match
                // otherwise let the user continue their edits.
                this.setState({ value: nextPropValue });
                this.hasChanges = false;
            }
        }
    }, {
        key: "onChange",
        value: function onChange(e) {
            this.setState({ value: e.target.value });
            this.hasChanges = true;
        }
    }, {
        key: "render",
        value: function render() {
            var _props7 = this.props,
                className = _props7.className,
                descriptor = _props7.descriptor,
                placeholder = _props7.placeholder,
                enabled = _props7.enabled,
                _props7$style = _props7.style,
                style = _props7$style === undefined ? {} : _props7$style,
                maxLength = _props7.maxLength,
                maskFormat = _props7.maskFormat;

            if (maxLength) {
                // when length is provided resize width of input
                style.width = parseFloat(maxLength.toString()) * 0.8 + 2.0 + "em";
            }
            var value = this.state.value || "";
            var classname = (className || "form-control") + " focusable";
            return _react2.default.createElement(_InputMask2.default, {
                type: "input",
                _ref: this.inputRef,
                className: classname,
                onClick: this.onClick,
                onChange: this.onChange,
                onFocus: this.onFocus,
                onBlur: this.onBlur,
                onKeyDown: this.onKeyDown,
                maskFormat: maskFormat,
                value: value,
                maxLength: maxLength,
                placeholder: placeholder ? descriptor.label : "",
                disabled: !enabled,
                onPasteCapture: this.onPaste,
                style: style
            });
        }
    }]);

    return Input;
}(_react2.default.Component);

exports.default = Input;


Input.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)(), {
    onIllegal: _propTypes2.default.func
});

Input.defaultProps = {
    onIllegal: function onIllegal() {/* noop */}
};

/***/ }),
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
    This will be the new location for format mask constants used in InputMask.
    mask = the actual mask used for InputMask (required)
    placeholder = text to show the user as they type. Must be same length as mask. (optional)
    momentjs = Required if the mask is going to be used in DateInput. otherwise (optional)
 */

exports.default = {
    "armus_date_year": {
        mask: "YYYY",
        placeholder: "yyyy",
        momentjs: "YYYY"
    },
    "armus_date_month": {
        mask: "MM/YYYY",
        placeholder: "mm/yyyy",
        momentjs: "MM/YYYY"
    },
    "armus_date_day": {
        mask: "MM/DD/YYYY",
        placeholder: "mm/dd/yyyy",
        momentjs: "MM/DD/YYYY"
    },
    "armus_datetime_hour": {
        mask: "MM/DD/YYYY HH",
        placeholder: "mm/dd/yyyy hh",
        momentjs: "MM/DD/YYYY HH"
    },
    "armus_datetime_minute": {
        mask: "MM/DD/YYYY HH:mm",
        placeholder: "mm/dd/yyyy hh:mm",
        momentjs: "MM/DD/YYYY HH:mm"
    },
    "armus_datetime_second": {
        mask: "MM/DD/YYYY HH:mm:ss",
        placeholder: "mm/dd/yyyy hh:mm:ss",
        momentjs: "MM/DD/YYYY HH:mm:ss"
    },
    "armus_time_hour": {
        mask: "HH",
        placeholder: "hh",
        momentjs: "HH"
    },
    "armus_time_minute": {
        mask: "HH:mm",
        placeholder: "hh:mm",
        momentjs: "HH:mm"
    },
    "armus_time_second": {
        mask: "HH:mm:ss",
        placeholder: "hh:mm:ss",
        momentjs: "HH:mm:ss"
    }
};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ReactPropTypesSecret = __webpack_require__(441);

var _ReactPropTypesSecret2 = _interopRequireDefault(_ReactPropTypesSecret);

var _typeHelpers = __webpack_require__(302);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadObjectOf = function loadObjectOf(valueTypeChecker, optionalErrorTypeChecker) {
    return (0, _typeHelpers.createChainableTypeChecker)(function (props, propName, componentName, location, propFullName) {
        if (typeof valueTypeChecker !== "function" || optionalErrorTypeChecker != null && typeof optionalErrorTypeChecker !== "function") {
            return new _typeHelpers.PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside loadObjectOf.");
        }
        var lo = props[propName];
        if (!(lo instanceof _LoadObject2.default)) {
            return new _typeHelpers.PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + (0, _typeHelpers.getClassName)(lo) + "` supplied to `" + componentName + "`, expected instance of `LoadObject`.");
        }
        if (lo.hasValue()) {
            var error = valueTypeChecker({ value: lo.getValueEnforcing() }, "value", "LoadObject", location, propFullName + ".value", _ReactPropTypesSecret2.default);
            if (error != null) return error;
        }
        if (optionalErrorTypeChecker != null && lo.hasError()) {
            var _error = valueTypeChecker({ error: lo.getErrorEnforcing() }, "error", "LoadObject", location, propFullName + ".error", _ReactPropTypesSecret2.default);
            if (_error != null) return _error;
        }
        return null;
    });
}; /*
    * Copyright (c) 2018 Barney Boisvert
    *
    * Permission is hereby granted, free of charge, to any person obtaining a copy
    * of this software and associated documentation files (the "Software"), to deal
    * in the Software without restriction, including without limitation the rights
    * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    * copies of the Software, and to permit persons to whom the Software is
    * furnished to do so, subject to the following conditions:
    *
    * The above copyright notice and this permission notice shall be included in
    * all copies or substantial portions of the Software.
    *
    * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    * SOFTWARE.
    */

exports.default = loadObjectOf;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var infoTypeToFieldType = exports.infoTypeToFieldType = function infoTypeToFieldType(it) {
    switch (it) {
        case "ChoiceField":
            return "STRING";
        case "DateField":
            return "DATE";
        case "DateTimeField":
            return "DATETIME";
        case "DecimalField":
            return "DECIMAL";
        case "IntegerField":
            return "INTEGER";
        case "StringField":
            return "STRING";
        case "TimeField":
            return "TIME";
        case "TZTimestampField":
            return "TIME";
        case "InverseAssociationField":
        case "AssociationField":
            return "ASSOCIATION";
        default:
            throw new Error("Unknown '" + it + "' info type");
    }
};

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

var _TableColumnMetaStore = __webpack_require__(125);

var _TableColumnMetaStore2 = _interopRequireDefault(_TableColumnMetaStore);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

var _TableMetaStore = __webpack_require__(478);

var _TableMetaStore2 = _interopRequireDefault(_TableMetaStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var testable = function testable(ep) {
    return function (test) {
        var result = test(ep);
        return result == null || !!result;
    };
};

function is(tp, entityInfo) {
    if (entityInfo.type === "CHILD") {
        /*
         * The type of child records is defined by the parent record and the
         * association field; it is not intrinsic to the record itself. So
         * delegate up the tree.
         */
        var pfi = _entityFieldMetaStore2.default.getInfo(entityInfo.key, entityInfo.parentPointerKey);
        var pid = tp.getColumn(pfi.logicalKey, true);
        if (pid == null) return false; // the logical tree is a graph, I guess. Woo!
        var pei = _entityMetaStore2.default.getInfo(pfi.otherEntityKey);
        return is(new TableProxy(tp.access, pei.tableKey, pid), pei);
    }
    var tester = testable(new _EntityProxy2.default(tp, entityInfo.key));
    if (entityInfo.type === "ROOT" && (0, _EntityProxy.hasIsVersionScript)(entityInfo)) {
        if (!tester(entityInfo.scripts.isVersion)) return false;
    }
    if ((0, _EntityProxy.hasFilterScript)(entityInfo)) {
        if (!tester(entityInfo.scripts.filter)) return false;
    }
    return true;
}

/**
 * I proxy Store data as a stateful object w/ a `get` method, like Backbone's
 * Model has, and which is needed for passing into AS scriptlets.
 */

var TableProxy = function () {
    function TableProxy(access, tableKey, id) {
        var useKeys = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        _classCallCheck(this, TableProxy);

        if (tableKey == null || id == null) {
            throw new Error("Proxies cannot be constructed with null keys or ids ('" + tableKey + "#" + id + "').");
        }
        (0, _invariant2.default)(_ClientId2.default.is(id) || typeof id === "number", "Non-numeric, non-client ID '%s' of type %s", id, typeof id === "undefined" ? "undefined" : _typeof(id));
        if (!access.hasRecord(tableKey, id)) {
            throw new Error("No " + tableKey + "#" + id + " record is known");
        }
        this.access = access;
        this.tableKey = tableKey;
        this.id = id;
        this.useKeys = useKeys;
    }

    _createClass(TableProxy, [{
        key: "get",
        value: function get(column) {
            try {
                return this.getColumn(column);
            } catch (e) {
                console.warn(this.tableKey + "#" + this.id + "." + column, e);
                return null;
            }
        }
    }, {
        key: "getAttributeType",
        value: function getAttributeType(column) {
            var byKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.useKeys;

            return this._toInfo(column, byKey).type;
        }
    }, {
        key: "_toInfo",
        value: function _toInfo(column, byKey) {
            return byKey ? _TableColumnMetaStore2.default.getInfoByKey(this.tableKey, column) : _TableColumnMetaStore2.default.getInfoByName(this.tableKey, column);
        }
    }, {
        key: "getColumn",
        value: function getColumn(column) {
            var _this = this;

            var byKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.useKeys;

            var info = this._toInfo(column, byKey);
            if (info.inverse) {
                // todo: this gets combined with `getAllRecords` into something indexed. please.
                var rs = this.access.getAllRecords(info.otherTableKey);
                var invInf = _TableColumnMetaStore2.default.getInfoByKey(info.otherTableKey, info.inverseKey);
                var ids = rs.filter(function (r) {
                    var v = r.data[invInf.name];
                    return v instanceof Array ? v.indexOf(_this.id) >= 0 : v === _this.id;
                }).map(function (r) {
                    return r.meta.id;
                });
                return info.multiValued ? ids : ids.length === 0 ? null : ids[0];
            } else {
                return this.access.getColumnData(this.tableKey, this.id, info.name);
            }
        }
    }, {
        key: "getKey",
        value: function getKey() {
            return this.tableKey + "#" + this.id;
        }
    }, {
        key: "getRecordMeta",
        value: function getRecordMeta() {
            return this.access.getRecordData(this.tableKey, this.id).meta;
        }
    }, {
        key: "isEntity",
        value: function isEntity(entityKeyOrInfo) {
            if (typeof entityKeyOrInfo === "string") {
                entityKeyOrInfo = _entityMetaStore2.default.getInfo(entityKeyOrInfo);
            }
            return is(this, entityKeyOrInfo);
        }
    }, {
        key: "getEntityKeys",
        value: function getEntityKeys() {
            var _this2 = this;

            var infos = _entityMetaStore2.default.getInfosForLogicalTable(this.tableKey);
            var isInfos = infos.filter(function (info) {
                return is(_this2, info);
            });
            // todo: This isn't quite right. But it's close? Maybe? Barney needs to think about it when he's not 20 minutes away from a 17 day vacation
            // invariant(
            //     isInfos.length > 0 || infos.some(it => it.type !== "CHILD"),
            //     "composed child %s#%s's parent record (via '%s') doesn't exist?", this.tableKey, this.id, infos[0].parentPointerKey);
            return isInfos.map(function (it) {
                return it.key;
            });
        }
    }, {
        key: "getEntityProxies",
        value: function getEntityProxies() {
            var _this3 = this;

            return this.getEntityKeys().map(function (ek) {
                return new _EntityProxy2.default(_this3, ek);
            });
        }
    }, {
        key: "equals",
        value: function equals(o) {
            if (o == null) return false;
            if (!(o instanceof TableProxy)) return false;
            if (this.tableKey !== o.tableKey) return false;
            if (this.id !== o.id) return false;
            return true;
        }
    }, {
        key: "canWrite",
        value: function canWrite() {
            return _TableMetaStore2.default.canWrite(this.tableKey);
        }
    }, {
        key: "canDelete",
        value: function canDelete() {
            return _TableMetaStore2.default.canDelete(this.tableKey);
        }
    }, {
        key: "getMetadata",
        value: function getMetadata() {
            return this.access.getRecordData(this.tableKey, this.id).meta;
        }
    }]);

    return TableProxy;
}();

exports.default = TableProxy;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var FileUploadActions = exports.FileUploadActions = {
    QUEUED: "file-upload/queued",
    PROGRESS: "file-upload/progress",
    COMPLETE: "file-upload/complete",
    ERROR: "file-upload/error",
    CANCEL: "file-upload/cancel"
};

exports.default = FileUploadActions;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ActiveSectionActions = {
    SCROLL: "*active-section/scroll",
    JUMP_TO_SECTION: "*active-section/jump-to-section"
};

exports.default = ActiveSectionActions;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable no-useless-escape */
exports.default = {
    OK: { code: 0, message: "ok" },
    UNUSUAL: { code: 100, message: "unusual" },
    MISSING: { code: 200, message: "missing" },
    WARNING: { code: 300, message: "warning" },
    WARNING_CUSTOM: { code: 301, message: "custom" },
    WARNING_MISSING: { code: 302, message: "missing" },
    WARNING_NON_NUMERIC: { code: 303, message: "non-numeric" },
    WARNING_TOO_SHORT: { code: 304, message: "\'%s\' shorter than minimum length [%s]" },
    WARNING_TOO_LONG: { code: 305, message: "\'%s\' longer than maximum length [%s]" },
    WARNING_LENGTH: { code: 306, message: "invalid length" },
    WARNING_PRECISION: { code: 307, message: "\'%s\' exceeds allowed digits [%s]" },
    WARNING_SCALE: { code: 308, message: "\'%s\' exceeds allowed fractional digits [%s]" },
    WARNING_OUT_OF_RANGE: { code: 310, message: "out of range" },
    WARNING_LESS_THAN_MIN: { code: 311, message: "%s less than allowed minimum [%s]" },
    WARNING_GREATER_THAN_MAX: { code: 312, message: "%s greater than allowed maximum [%s]" },
    WARNING_OUT_OF_USUAL_RANGE: { code: 320, message: "out of usual range" },
    WARNING_LESS_THAN_USUAL_MIN: { code: 321, message: "%s less than usual minimum [%s]" },
    WARNING_GREATER_THAN_USUAL_MAX: { code: 322, message: "%s greater than usual maximum [%s]" },
    WARNING_ATOMIC_OPTIONS: { code: 330, message: "%s must be selected atomically" },
    WARNING_INACTIVE_OPTION: { code: 331, message: "%s is not active" },
    ILLEGAL: { code: 400, message: "illegal" },
    ILLEGAL_CUSTOM: { code: 401, message: "custom" },
    ILLEGAL_MISSING: { code: 402, message: "missing" },
    ILLEGAL_NON_NUMERIC: { code: 403, message: "non-numeric" },
    ILLEGAL_TOO_SHORT: { code: 404, message: "\'%s\' shorter than minimum length [%s]" },
    ILLEGAL_TOO_LONG: { code: 405, message: "\'%s\' longer than maximum length [%s]" },
    ILLEGAL_LENGTH: { code: 406, message: "invalid length" },
    ILLEGAL_PRECISION: { code: 407, message: "\'%s\' exceeds allowed digits [%s]" },
    ILLEGAL_SCALE: { code: 408, message: "\'%s\' exceeds allowed fractional digits [%s]" },
    ILLEGAL_OUT_OF_RANGE: { code: 410, message: "out of range" },
    ILLEGAL_LESS_THAN_MIN: { code: 411, message: "%s less than allowed minimum [%s]" },
    ILLEGAL_GREATER_THAN_MAX: { code: 412, message: "%s greater than allowed maximum [%s]" },
    ILLEGAL_OUT_OF_USUAL_RANGE: { code: 420, message: "out of usual range" },
    ILLEGAL_LESS_THAN_USUAL_MIN: { code: 421, message: "%s less than usual minimum [%s]" },
    ILLEGAL_GREATER_THAN_USUAL_MAX: { code: 422, message: "%s greater than usual maximum [%s]" },
    ILLEGAL_ATOMIC_OPTIONS: { code: 430, message: "%s must be selected atomically" },
    ILLEGAL_INACTIVE_OPTION: { code: 431, message: "%s is not active" },
    BLOCKING: { code: 500, message: "record cannot be saved until error is resolved" }
};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.saveSuperRecord = exports.canSave = undefined;

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

var _FileUploadStore = __webpack_require__(227);

var _FileUploadStore2 = _interopRequireDefault(_FileUploadStore);

var _safeDispatch = __webpack_require__(169);

var _safeDispatch2 = _interopRequireDefault(_safeDispatch);

var _SuperRecordStore = __webpack_require__(36);

var _SuperRecordStore2 = _interopRequireDefault(_SuperRecordStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canSave = exports.canSave = function canSave() {
    return _FileUploadStore2.default.getAllInProgressFiles().length === 0;
};

var saveSuperRecord = exports.saveSuperRecord = function saveSuperRecord(key, id, initiatingContext) {
    return (0, _safeDispatch2.default)({
        type: _ClientId2.default.is(id) ? _SuperRecordActions2.default.START_CREATE : _SuperRecordActions2.default.START_UPDATE,
        key: key,
        id: id,
        initiatingContext: initiatingContext
    }, function () {
        return _SuperRecordStore2.default.isUnsaved(key, id);
    });
};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.handleErrorAction = exports.handleCompleteAction = exports.handleCancelAction = exports.handleProgressAction = exports.handleQueuedAction = exports.checkConcurrentUploads = exports.removeFileFromState = exports.replaceStateFileWithFile = exports.mergeStateFileWithFile = exports.filterFilesByFieldAndStatus = exports.filterFilesByStatus = exports.getFileIndexInState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(13);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _FileUploadActions = __webpack_require__(223);

var _FileUploadActions2 = _interopRequireDefault(_FileUploadActions);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _HybridConfig = __webpack_require__(41);

var _HybridConfig2 = _interopRequireDefault(_HybridConfig);

var _DataManager = __webpack_require__(43);

var _DataManager2 = _interopRequireDefault(_DataManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/*
 This store keeps track of queued/in-progress/errored file uploads in one big bucket.
 */

// finds the index of the provided file within the state.
var getFileIndexInState = exports.getFileIndexInState = function getFileIndexInState(state, file) {
    return _.findIndex(state, function (f) {
        return f.id === file.id;
    });
};

var filterFilesByStatus = exports.filterFilesByStatus = function filterFilesByStatus(state, statuses) {
    return state.filter(function (f) {
        return statuses.includes(f._status);
    }) || [];
};

var filterFilesByFieldAndStatus = exports.filterFilesByFieldAndStatus = function filterFilesByFieldAndStatus(state, field, record_id) {
    var statuses = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    return filterFilesByStatus(state, statuses).filter(function (f) {
        return f._field === field && f._record_id === record_id;
    }) || [];
};

// finds the provided file in the state and returns a new instance of it.
var mergeStateFileWithFile = exports.mergeStateFileWithFile = function mergeStateFileWithFile(state, file) {
    var fileIndex = getFileIndexInState(state, file);
    if (fileIndex !== -1) {
        return _extends({}, state[fileIndex], file);
    }
    return _extends({}, file);
};

// merges a state a with the provided file
var replaceStateFileWithFile = exports.replaceStateFileWithFile = function replaceStateFileWithFile(state, file) {
    var createOnNotFound = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var newState = [].concat(_toConsumableArray(state));
    // find file index or add it.
    var fileIndex = getFileIndexInState(newState, file);
    if (fileIndex !== -1) {
        newState[fileIndex] = file;
    } else if (createOnNotFound) {
        // else add it to the newState.
        newState.push(file);
    }
    return newState;
};

// removes the provided file from the state.
var removeFileFromState = exports.removeFileFromState = function removeFileFromState(state, file) {
    var newState = [].concat(_toConsumableArray(state));
    var fileIndex = getFileIndexInState(newState, file);
    if (fileIndex !== -1) {
        newState.splice(fileIndex, 1);
    }
    return newState;
};

// checks the current state and determines if there is room to start uploading a queued file.
var checkConcurrentUploads = exports.checkConcurrentUploads = function checkConcurrentUploads(state) {
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var queuedFiles = state.filter(function (f) {
        return f._status === Hybrid.FileInfo.FILEUPLOADSTATES.QUEUED;
    });
    if (queuedFiles.length === 0) {
        // nothing to upload at this time.
        return state;
    }
    var inProgressFiles = state.filter(function (f) {
        return f._status === Hybrid.FileInfo.FILEUPLOADSTATES.INPROGRESS;
    });
    var concurrentUploads = _HybridConfig2.default.get("fileUpload.concurrentLimit", 4);
    if (inProgressFiles.length < concurrentUploads) {
        // there is room to start one or more file uploads
        var newState = [].concat(_toConsumableArray(state));
        for (var i = 0; i + inProgressFiles.length < concurrentUploads && i < queuedFiles.length; i++) {
            // change the file to in-progress.
            var file = _extends({}, queuedFiles[i], {
                _status: Hybrid.FileInfo.FILEUPLOADSTATES.INPROGRESS,
                _progress: 0
            });
            var fileIndex = getFileIndexInState(state, file);
            newState[fileIndex] = file; // replace the file

            if (action.recordKey && action.recordId && action.fieldKey) {
                // Start the file upload
                _DataManager2.default.uploadFile(action.recordKey, action.recordId, action.fieldKey, file);
            }
        }
        return newState;
    }
    // the upload queue is currently full.
    console.log("Maximum concurrent uploads reached. Waiting for in-progress queue to shrink.");
    return state;
};

// reducer action handlers
var handleQueuedAction = exports.handleQueuedAction = function handleQueuedAction(state, action) {
    var file = mergeStateFileWithFile(state, action.file);
    file._status = Hybrid.FileInfo.FILEUPLOADSTATES.QUEUED;
    file._progress = 0;
    return checkConcurrentUploads(replaceStateFileWithFile(state, file, true), // create on notFound
    action);
};

var handleProgressAction = exports.handleProgressAction = function handleProgressAction(state, action) {
    var file = mergeStateFileWithFile(state, action.file);
    if (action.promise) {
        file._promise = action.promise; // used for xhr cancel/abort
    }
    file._status = Hybrid.FileInfo.FILEUPLOADSTATES.INPROGRESS;
    file._progress = action.progress;
    return replaceStateFileWithFile(state, file);
};

var handleCancelAction = exports.handleCancelAction = function handleCancelAction(state, action) {
    var file = mergeStateFileWithFile(state, action.file);
    file._status = Hybrid.FileInfo.FILEUPLOADSTATES.ABORTED;
    file._progress = 0;
    file._promise && file._promise.abort();
    return checkConcurrentUploads(removeFileFromState(state, file), action);
};

var handleCompleteAction = exports.handleCompleteAction = function handleCompleteAction(state, action) {
    return checkConcurrentUploads(removeFileFromState(state, action.file), action);
};

var handleErrorAction = exports.handleErrorAction = function handleErrorAction(state, action) {
    var file = mergeStateFileWithFile(state, action.file);
    file._status = Hybrid.FileInfo.FILEUPLOADSTATES.ERROR;
    file._progress = 0;
    file._promise = undefined;
    file._error = action.error;
    return checkConcurrentUploads(replaceStateFileWithFile(state, file), action);
};

var FileUploadStore = function (_ReduceStore) {
    _inherits(FileUploadStore, _ReduceStore);

    function FileUploadStore() {
        _classCallCheck(this, FileUploadStore);

        return _possibleConstructorReturn(this, (FileUploadStore.__proto__ || Object.getPrototypeOf(FileUploadStore)).call(this, _Dispatcher2.default));
    }

    _createClass(FileUploadStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return [];
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {
                case _FileUploadActions2.default.QUEUED:
                    return handleQueuedAction(state, action);
                case _FileUploadActions2.default.PROGRESS:
                    return handleProgressAction(state, action);
                case _FileUploadActions2.default.CANCEL:
                    return handleCancelAction(state, action);
                case _FileUploadActions2.default.COMPLETE:
                    return handleCompleteAction(state, action);
                case _FileUploadActions2.default.ERROR:
                    return handleErrorAction(state, action);
                default:
                    return state;
            }
        }
    }, {
        key: "getInProgressFilesByField",
        value: function getInProgressFilesByField(field, record_id) {
            return filterFilesByFieldAndStatus(this.getState(), field, record_id, [Hybrid.FileInfo.FILEUPLOADSTATES.INPROGRESS, Hybrid.FileInfo.FILEUPLOADSTATES.QUEUED, Hybrid.FileInfo.FILEUPLOADSTATES.ERROR]);
        }
    }, {
        key: "getAllInProgressFiles",
        value: function getAllInProgressFiles() {
            return filterFilesByStatus(this.getState(), [Hybrid.FileInfo.FILEUPLOADSTATES.INPROGRESS, Hybrid.FileInfo.FILEUPLOADSTATES.QUEUED, Hybrid.FileInfo.FILEUPLOADSTATES.ERROR]);
        }
    }]);

    return FileUploadStore;
}(_utils.ReduceStore);

FileUploadStore.stateTypes = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    _index: _propTypes2.default.number.isRequired,
    filename: _propTypes2.default.string.isRequired,
    contentType: _propTypes2.default.string.isRequired,
    size: _propTypes2.default.number,
    _org: _propTypes2.default.string.isRequired,
    _impl: _propTypes2.default.string.isRequired,
    _version: _propTypes2.default.string.isRequired,
    _entity: _propTypes2.default.string.isRequired,
    _field: _propTypes2.default.string.isRequired,
    _record_id: _propTypes2.default.string.isRequired,
    _progress: _propTypes2.default.number,
    _status: _propTypes2.default.string,
    _data: _propTypes2.default.any,
    _promise: _propTypes2.default.object,
    _onComplete: _propTypes2.default.func
}));

exports.default = (0, _typeCheckingStore2.default)(new FileUploadStore());

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ADT_EPISODE_KEY = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(13);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _storeUtils = __webpack_require__(54);

var _AdtActions = __webpack_require__(308);

var _AdtActions2 = _interopRequireDefault(_AdtActions);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _dotPropImmutable = __webpack_require__(40);

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _DataManager = __webpack_require__(43);

var _DataManager2 = _interopRequireDefault(_DataManager);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _TableAccess = __webpack_require__(77);

var _TableAccess2 = _interopRequireDefault(_TableAccess);

var _MapDialogActions = __webpack_require__(64);

var _MapDialogActions2 = _interopRequireDefault(_MapDialogActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ADT_EPISODE_KEY = exports.ADT_EPISODE_KEY = "adt/1-0/episode";

var _getPagination = function _getPagination(state, query) {
    return state.pagination && state.pagination.hasOwnProperty(query) ? state.pagination[query] : {
        page: 1,
        pageCount: 0,
        pageSize: 25,
        totalResultCount: 0
    };
};

var getQueryLO = function getQueryLO(state, query) {
    return state.queries.hasOwnProperty(query) ? state.queries[query] : _LoadObject2.default.empty();
};

var idsToRecordsBuilder = function idsToRecordsBuilder(state) {
    var access = new _TableAccess2.default(state);
    return function (ids) {
        return ids.map(function (id) {
            return access.getEntityProxy(ADT_EPISODE_KEY, id);
        });
    };
};

var AdtStore = function (_ReduceStore) {
    _inherits(AdtStore, _ReduceStore);

    function AdtStore() {
        _classCallCheck(this, AdtStore);

        return _possibleConstructorReturn(this, (AdtStore.__proto__ || Object.getPrototypeOf(AdtStore)).call(this, _Dispatcher2.default));
    }

    _createClass(AdtStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {
                tables: {},
                queries: {},
                pagination: {}
            };
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {

                case _AdtActions2.default.SEARCH:
                    {
                        var lo = getQueryLO(state, action.query);
                        return _dotPropImmutable2.default.set(state, ["queries", action.query], lo.loading(_DataManager2.default.adtSearch(_userStore2.default.getActiveOrgKey(), action.query, action.interactive)));
                    }

                case _AdtActions2.default.SEARCH_RESULT:
                    {
                        // add response pagination info
                        var newState = _dotPropImmutable2.default.set(state, ["pagination", action.query], {
                            page: action.data.page,
                            pageCount: action.data.pageCount,
                            pageSize: action.data.pageSize,
                            query: action.data.query,
                            totalResultCount: action.data.totalResultCount
                        });
                        var access = new _TableAccess2.default(newState);
                        action.data.results.forEach(function (it) {
                            return access.loadSuperRecordPacket(it);
                        });
                        return _dotPropImmutable2.default.set(access.getState(), ["queries", action.query], function (lo) {
                            return lo.setValue(action.data.results.map(function (it) {
                                return it.id;
                            })).done();
                        });
                    }

                case _AdtActions2.default.SEARCH_ERROR:
                    {
                        return _dotPropImmutable2.default.set(state, ["queries", action.query], function (lo) {
                            return lo.setError(action.error).done();
                        });
                    }

                case _MapDialogActions2.default.SELECT_PLUGIN:
                    {
                        return this.getInitialState(); // per Helen's decree
                    }

                default:
                    return state;
            }
        }
    }, {
        key: "getPagination",
        value: function getPagination(query) {
            return _getPagination(this.getState(), query);
        }
    }, {
        key: "getColdLO",
        value: function getColdLO(query) {
            return getQueryLO(this.getState(), query).map(idsToRecordsBuilder(this.getState()));
        }
    }, {
        key: "getHotLO",
        value: function getHotLO(query, interactive) {
            var _this2 = this;

            return (0, _storeUtils.hotLoadObject)(function () {
                return getQueryLO(_this2.getState(), query);
            }, function () {
                return _Dispatcher2.default.dispatch({
                    type: _AdtActions2.default.SEARCH,
                    query: query,
                    interactive: interactive
                });
            }, function (lo) {
                return interactive || lo.isEmpty();
            }).map(idsToRecordsBuilder(this.getState()));
        }
    }]);

    return AdtStore;
}(_utils.ReduceStore);

AdtStore.stateTypes = {
    tables: _propTypes2.default.object.isRequired,
    queries: _propTypes2.default.objectOf(_propTypes2.default.instanceOf(_LoadObject2.default)).isRequired
};

exports.default = (0, _typeCheckingStore2.default)(new AdtStore());

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HEMO_MESSAGE_KEY = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(13);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _storeUtils = __webpack_require__(54);

var _HemoActions = __webpack_require__(309);

var _HemoActions2 = _interopRequireDefault(_HemoActions);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _dotPropImmutable = __webpack_require__(40);

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _DataManager = __webpack_require__(43);

var _DataManager2 = _interopRequireDefault(_DataManager);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _TableAccess = __webpack_require__(77);

var _TableAccess2 = _interopRequireDefault(_TableAccess);

var _MapDialogActions = __webpack_require__(64);

var _MapDialogActions2 = _interopRequireDefault(_MapDialogActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HEMO_MESSAGE_KEY = exports.HEMO_MESSAGE_KEY = "hemo/1-0/message";

var _getPagination = function _getPagination(state, query) {
    return state.pagination && state.pagination.hasOwnProperty(query) ? state.pagination[query] : {
        page: 1,
        pageCount: 0,
        pageSize: 25,
        totalResultCount: 0
    };
};

var getQueryLO = function getQueryLO(state, query) {
    return state.queries.hasOwnProperty(query) ? state.queries[query] : _LoadObject2.default.empty();
};

var idsToRecordsBuilder = function idsToRecordsBuilder(state) {
    var access = new _TableAccess2.default(state);
    return function (ids) {
        return ids.map(function (id) {
            return access.getEntityProxy(HEMO_MESSAGE_KEY, id);
        });
    };
};

var HemoStore = function (_ReduceStore) {
    _inherits(HemoStore, _ReduceStore);

    function HemoStore() {
        _classCallCheck(this, HemoStore);

        return _possibleConstructorReturn(this, (HemoStore.__proto__ || Object.getPrototypeOf(HemoStore)).call(this, _Dispatcher2.default));
    }

    _createClass(HemoStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {
                tables: {},
                queries: {},
                pagination: {}
            };
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {

                case _HemoActions2.default.SEARCH:
                    {
                        var lo = getQueryLO(state, action.query);
                        return _dotPropImmutable2.default.set(state, ["queries", action.query], lo.loading(_DataManager2.default.hemoSearch(_userStore2.default.getActiveOrgKey(), action.query, action.interactive)));
                    }

                case _HemoActions2.default.SEARCH_RESULT:
                    {
                        // add response pagination info
                        var newState = _dotPropImmutable2.default.set(state, ["pagination", action.query], {
                            page: action.data.page,
                            pageCount: action.data.pageCount,
                            pageSize: action.data.pageSize,
                            query: action.data.query,
                            totalResultCount: action.data.totalResultCount
                        });
                        var access = new _TableAccess2.default(newState);
                        action.data.results.forEach(function (it) {
                            return access.loadSuperRecordPacket(it);
                        });
                        return _dotPropImmutable2.default.set(access.getState(), ["queries", action.query], function (lo) {
                            return lo.setValue(action.data.results.map(function (it) {
                                return it.id;
                            })).done();
                        });
                    }

                case _HemoActions2.default.SEARCH_ERROR:
                    {
                        return _dotPropImmutable2.default.set(state, ["queries", action.query], function (lo) {
                            return lo.setError(action.error).done();
                        });
                    }

                case _MapDialogActions2.default.SELECT_PLUGIN:
                    {
                        return this.getInitialState(); // per Helen's decree
                    }

                default:
                    return state;
            }
        }
    }, {
        key: "getPagination",
        value: function getPagination(query) {
            return _getPagination(this.getState(), query);
        }
    }, {
        key: "getColdLO",
        value: function getColdLO(query) {
            return getQueryLO(this.getState(), query).map(idsToRecordsBuilder(this.getState()));
        }
    }, {
        key: "getHotLO",
        value: function getHotLO(query, interactive) {
            var _this2 = this;

            return (0, _storeUtils.hotLoadObject)(function () {
                return getQueryLO(_this2.getState(), query);
            }, function () {
                return _Dispatcher2.default.dispatch({
                    type: _HemoActions2.default.SEARCH,
                    query: query,
                    interactive: interactive
                });
            }, function (lo) {
                return interactive || lo.isEmpty();
            }).map(idsToRecordsBuilder(this.getState()));
        }
    }]);

    return HemoStore;
}(_utils.ReduceStore);

HemoStore.stateTypes = {
    tables: _propTypes2.default.object.isRequired,
    queries: _propTypes2.default.objectOf(_propTypes2.default.instanceOf(_LoadObject2.default)).isRequired
};

exports.default = (0, _typeCheckingStore2.default)(new HemoStore());

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ECMOEMR_MESSAGE_KEY = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(13);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _storeUtils = __webpack_require__(54);

var _EcmoEmrActions = __webpack_require__(310);

var _EcmoEmrActions2 = _interopRequireDefault(_EcmoEmrActions);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _dotPropImmutable = __webpack_require__(40);

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _DataManager = __webpack_require__(43);

var _DataManager2 = _interopRequireDefault(_DataManager);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _TableAccess = __webpack_require__(77);

var _TableAccess2 = _interopRequireDefault(_TableAccess);

var _MapDialogActions = __webpack_require__(64);

var _MapDialogActions2 = _interopRequireDefault(_MapDialogActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ECMOEMR_MESSAGE_KEY = exports.ECMOEMR_MESSAGE_KEY = "ecmoemr/1-0/message";
var _getPagination = function _getPagination(state, query) {
    return state.pagination && state.pagination.hasOwnProperty(query) ? state.pagination[query] : {
        page: 1,
        pageCount: 0,
        pageSize: 25,
        totalResultCount: 0
    };
};

var getQueryLO = function getQueryLO(state, query) {
    return state.queries.hasOwnProperty(query) ? state.queries[query] : _LoadObject2.default.empty();
};

var idsToRecordsBuilder = function idsToRecordsBuilder(state) {
    var access = new _TableAccess2.default(state);
    return function (ids) {
        return ids.map(function (id) {
            return access.getEntityProxy(ECMOEMR_MESSAGE_KEY, id);
        });
    };
};

var EcmoEmrStore = function (_ReduceStore) {
    _inherits(EcmoEmrStore, _ReduceStore);

    function EcmoEmrStore() {
        _classCallCheck(this, EcmoEmrStore);

        return _possibleConstructorReturn(this, (EcmoEmrStore.__proto__ || Object.getPrototypeOf(EcmoEmrStore)).call(this, _Dispatcher2.default));
    }

    _createClass(EcmoEmrStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {
                tables: {},
                queries: {},
                pagination: {}
            };
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {

                case _EcmoEmrActions2.default.SEARCH:
                    {
                        var lo = getQueryLO(state, action.query);
                        return _dotPropImmutable2.default.set(state, ["queries", action.query], lo.loading(_DataManager2.default.ecmoEmrSearch(_userStore2.default.getActiveOrgKey(), action.query, action.interactive)));
                    }

                case _EcmoEmrActions2.default.SEARCH_RESULT:
                    {
                        // add response pagination info
                        var newState = _dotPropImmutable2.default.set(state, ["pagination", action.query], {
                            page: action.data.page,
                            pageCount: action.data.pageCount,
                            pageSize: action.data.pageSize,
                            query: action.data.query,
                            totalResultCount: action.data.totalResultCount
                        });
                        var access = new _TableAccess2.default(newState);
                        action.data.results.forEach(function (it) {
                            return access.loadSuperRecordPacket(it);
                        });
                        return _dotPropImmutable2.default.set(access.getState(), ["queries", action.query], function (lo) {
                            return lo.setValue(action.data.results.map(function (it) {
                                return it.id;
                            })).done();
                        });
                    }

                case _EcmoEmrActions2.default.SEARCH_ERROR:
                    {
                        return _dotPropImmutable2.default.set(state, ["queries", action.query], function (lo) {
                            return lo.setError(action.error).done();
                        });
                    }

                case _MapDialogActions2.default.SELECT_PLUGIN:
                    {
                        return this.getInitialState(); // per Helen's decree
                    }

                default:
                    return state;
            }
        }
    }, {
        key: "getPagination",
        value: function getPagination(query) {
            return _getPagination(this.getState(), query);
        }
    }, {
        key: "getColdLO",
        value: function getColdLO(query) {
            return getQueryLO(this.getState(), query).map(idsToRecordsBuilder(this.getState()));
        }
    }, {
        key: "getHotLO",
        value: function getHotLO(query, interactive) {
            var _this2 = this;

            return (0, _storeUtils.hotLoadObject)(function () {
                return getQueryLO(_this2.getState(), query);
            }, function () {
                return _Dispatcher2.default.dispatch({
                    type: _EcmoEmrActions2.default.SEARCH,
                    query: query,
                    interactive: interactive
                });
            }, function (lo) {
                return interactive || lo.isEmpty();
            }).map(idsToRecordsBuilder(this.getState()));
        }
    }]);

    return EcmoEmrStore;
}(_utils.ReduceStore);

EcmoEmrStore.stateTypes = {
    tables: _propTypes2.default.object.isRequired,
    queries: _propTypes2.default.objectOf(_propTypes2.default.instanceOf(_LoadObject2.default)).isRequired
};

exports.default = (0, _typeCheckingStore2.default)(new EcmoEmrStore());

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sanitizeValue = exports.getValue = exports.isMappingEnabled = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _MappingInfoStore = __webpack_require__(160);

var _MappingInfoStore2 = _interopRequireDefault(_MappingInfoStore);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _MappingStore = __webpack_require__(65);

var _LiveMap = __webpack_require__(178);

var _LiveMap2 = _interopRequireDefault(_LiveMap);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

var _parseId = __webpack_require__(479);

var _parseId2 = _interopRequireDefault(_parseId);

var _asArray = __webpack_require__(157);

var _asArray2 = _interopRequireDefault(_asArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// from RecordMapping
var isMappingEnabled = exports.isMappingEnabled = function isMappingEnabled(instance, scriptOrInfo) {
    if (scriptOrInfo == null) return true;
    var script = scriptOrInfo.hasOwnProperty("fieldKey") ? scriptOrInfo.enableScript : scriptOrInfo;
    if (script == null) return true;
    try {
        return script(instance);
    } catch (e) {
        return true;
    }
};

// from RecordMapping
var getValue = exports.getValue = function getValue(instance, key, script) {
    if (key != null && key.hasOwnProperty("fieldKey")) {
        // it's a whole FieldMappingInfo - chop it up
        script = key.sourceScript;
        key = key.sourceFieldKey;
    }
    if (script) {
        try {
            return script(instance);
        } catch (e) {
            console.warn("Error in mapping script for '" + instance.getKey() + "." + key + "'", e);
            return null;
        }
    }
    if (key) {
        return instance.get(key);
    }
    // neither a script nor a key, which means we're "spreading" a
    // a single source record across a target hierarchy
    return instance;
};

// from FieldMapping
var sanitizeValue = exports.sanitizeValue = function sanitizeValue(info, val) {
    if (val == null) return val;
    if (info.type === "ChoiceField") {
        if (info.multiValued) {
            if (!(val instanceof Array)) {
                return [val.toUpperCase()];
            } else {
                // make sure all selected values are upper case HJC-97
                return val.map(function (v) {
                    return v.toUpperCase();
                });
            }
        } else {
            if (val instanceof Array) {
                return val.length === 0 ? null : val[0].toUpperCase();
            } else {
                // make sure the value is upper case HJC-97
                return val.toUpperCase();
            }
        }
    } else if (info.type === "StringField") {
        if (val instanceof Array) {
            return val.join(",");
        }
    }
    return val;
};

var MappingVisitor = function () {
    function MappingVisitor(mappingState, tableAccess, snapAccess) {
        var _this = this;

        _classCallCheck(this, MappingVisitor);

        this.state = mappingState;
        this._initialState = mappingState;
        this.access = tableAccess;
        this._snapshot = snapAccess;
        this.old = new _LiveMap2.default(function (key) {
            var _key$split = key.split("#"),
                _key$split2 = _slicedToArray(_key$split, 2),
                ek = _key$split2[0],
                idString = _key$split2[1];

            var id = (0, _parseId2.default)(idString);
            if (!_this._snapshot.hasEntityRecord(ek, id)) return null;
            return _this._snapshot.getEntityProxy(ek, id);
        });
    }

    _createClass(MappingVisitor, [{
        key: "execute",
        value: function execute(ctx) {
            this.doRecord(ctx || {}, this.access.getEntityProxy(this.state.target.entityKey, this.state.target.id), false, this.state.source, _MappingInfoStore.MAP_TARGET, null);
            return this;
        }
    }, {
        key: "doRecord",
        value: function doRecord(ctx, target, excluded, source, type, edgeInfo) {
            var mappingInfo = _MappingInfoStore2.default.getInfo(target.entityKey, source.entityKey);

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = mappingInfo.formOrder[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var it = _step.value;

                    switch (it.type) {
                        case _MappingInfoStore.ORDER_ITEM_TYPE.FIELD:
                            this._doRecordField(ctx, target, source, it.field);
                            break;
                        case _MappingInfoStore.ORDER_ITEM_TYPE.CHILD:
                            this._doRecordChild(ctx, target, source, it.child);
                            break;
                        default:
                            throw new Error("Unknown '" + it.type + "' item type?");
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = mappingInfo.crossTrees[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var cta = _step2.value;

                    this._doRecordCTA(ctx, target, source, cta);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    }, {
        key: "_doRecordField",
        value: function _doRecordField(ctx, target, source, f) {
            if (!isMappingEnabled(source, f)) return;
            var fieldInfo = _entityFieldMetaStore2.default.getInfo(target.entityKey, f.fieldKey);
            // this may need to change if we need to support selecting a subset
            // of a multi-valued ChoiceField's options...
            var excludeField = (0, _MappingStore.isExcluded)(this.state, target.id, fieldInfo.logicalColumn);
            var cctx = _extends({}, ctx, {
                fieldMappingInfo: f
            });
            if (!this.shouldDoField(ctx, target, excludeField, fieldInfo)) return;
            var rawValue = sanitizeValue(fieldInfo, getValue(source, f));
            this.doField(cctx, target, excludeField, fieldInfo, rawValue);
        }
    }, {
        key: "_doRecordChild",
        value: function _doRecordChild(ctx, target, source, c) {
            if (!isMappingEnabled(source, c.edge)) return;
            var fieldInfo = _entityFieldMetaStore2.default.getInfo(target.entityKey, c.edge.fieldKey);
            var excludeField = (0, _MappingStore.isExcluded)(this.state, target.id, fieldInfo.logicalColumn);
            var cctx = _extends({}, ctx, {
                childMappingInfo: c
            });
            if (!this.shouldDoChild(cctx, target, excludeField, fieldInfo, c.type)) return;
            var items = (0, _asArray2.default)(getValue(source, c.edge));
            var rawValue = this.__cleanMultiplicity(fieldInfo, items);
            if (c.type === _MappingInfoStore.FT_MAGIC_ROOT) {
                this.doMagicRoot(cctx, target, excludeField, fieldInfo, rawValue);
            } else if (c.type === _MappingInfoStore.FT_GLOBAL_REFERENCE_ONLY) {
                this.doGlobalAssoc(cctx, target, excludeField, fieldInfo, rawValue, false);
            } else if (c.type === _MappingInfoStore.FT_GLOBAL_REFERENCE_OR_CREATE) {
                this.doGlobalAssoc(cctx, target, excludeField, fieldInfo, rawValue, true);
            } else if (c.type === _MappingInfoStore.FT_CHILD) {
                if (fieldInfo.autoManageKey != null) {
                    var amfi = _entityFieldMetaStore2.default.getInfo(fieldInfo.otherEntityKey, fieldInfo.autoManageKey);
                    var kids = _MappingInfoStore2.default.getInfo(c.targetKey, c.sourceKey).children;
                    if (kids == null) return;
                    // todo: index this
                    var amem = kids.find(function (it) {
                        return it.edge.fieldKey === fieldInfo.autoManageKey;
                    });
                    if (amem == null) return; // AMK isn't mapped
                    this.doAutomanaged(cctx, target, excludeField, fieldInfo, amfi, rawValue, function (s) {
                        return (
                            // Blindly keep assuming the managed-by field's mapping is a copy
                            s.get(amem.edge.sourceFieldKey)
                        );
                    });
                } else {
                    // normal composition
                    this.doComposition(cctx, target, excludeField, fieldInfo, rawValue);
                }
            } else {
                throw new Error("Unknown '" + c.type + "' child type");
            }
        }
    }, {
        key: "_doRecordCTA",
        value: function _doRecordCTA(ctx, target, source, cta) {
            var _this2 = this;

            // Walk the sourceOwnerPath from the current source record to get
            // the owners of the CTA, named by sourceFieldKey.
            var sourceOwners = cta.sourceOwnerPath.reduce(function (curr, fk) {
                var next = [];
                curr.forEach(function (c) {
                    return _this2.__forEach(c.get(fk), function (n) {
                        return next.push(n);
                    });
                });
                return next;
            }, [source]);
            if (sourceOwners.length === 0) return;

            var targetFieldInfo = void 0;
            var ctaFieldInfo = void 0;
            var targetRecord = void 0;
            if (cta.targetOwnerPath.length === 0) {
                // Get the fieldInfo that the CTA edge points at.
                ctaFieldInfo = _entityFieldMetaStore2.default.getInfo(target.entityKey, cta.fieldKey);
                targetFieldInfo = _extends({}, ctaFieldInfo, {
                    otherEntityKey: target.entityKey
                });
                targetRecord = target;
            } else {
                // Get the fieldInfo that the CTA path points at.
                targetFieldInfo = cta.targetOwnerPath.reduce(function (curr, fk) {
                    return _entityFieldMetaStore2.default.getInfo(curr.otherEntityKey, fk);
                }, { otherEntityKey: target.entityKey });
                ctaFieldInfo = _entityFieldMetaStore2.default.getInfo(targetFieldInfo.otherEntityKey, cta.fieldKey);
                // we want the owner of the CTA, not the CTA record itself
                targetRecord = cta.targetOwnerPath.slice(0, cta.targetOwnerPath.length - 1).reduce(function (curr, fk) {
                    return curr.get(fk);
                }, target);
            }

            // Find the corresponding target record for each source record, if
            // one exists, by walking the metadata from the current target's
            // entity down to one shy of the last entry in targetOwnerPath, and
            // then using the last one to query the id pair.
            var ownerPairs = sourceOwners.map(function (so) {
                var lo = (0, _MappingStore.getPairedIdLO)(_this2.state, so.id, targetRecord.getKey(), targetFieldInfo.key);
                if (!lo.hasValue()) return [so, null];
                var tid = lo.getValueEnforcing();
                var to = _this2.access.hasEntityRecord(targetFieldInfo.otherEntityKey, tid) ? _this2.access.getEntityProxy(targetFieldInfo.otherEntityKey, tid) : null;
                return [so, to];
            }).filter(function (p) {
                return p[1] != null;
            });
            if (ownerPairs.length === 0) return;

            var cctx = _extends({}, ctx, {
                active: true, // CTAs are always active, but just for symmetry
                crossTreeAssoc: cta
            });
            ownerPairs.forEach(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    so = _ref2[0],
                    to = _ref2[1];

                var excludeField = (0, _MappingStore.isExcluded)(_this2.state, to.id, ctaFieldInfo.logicalColumn);
                if (!_this2.shouldDoCrossTree(cctx, to, excludeField, ctaFieldInfo)) return;
                _this2.doCrossTree(cctx, to, excludeField, ctaFieldInfo, so.get(cta.sourceFieldKey));
            });
        }
    }, {
        key: "doField",
        value: function doField(ctx, target, excluded, fieldInfo, sourceValue) {
            /* will be overloaded */
        }
    }, {
        key: "doMagicRoot",
        value: function doMagicRoot(ctx, target, excluded, fieldInfo, sourceValue) {
            this.__doChildRecordHelper(ctx, target, fieldInfo, sourceValue, _MappingInfoStore.FT_MAGIC_ROOT);
        }
    }, {
        key: "doGlobalAssoc",
        value: function doGlobalAssoc(ctx, target, excluded, fieldInfo, sourceValue, createIfMissing) {
            var _this3 = this;

            // only cascade for created globals - existing ones are only referenced,
            // not updated, so their tree is irrelevant.
            var creationHappened = false;
            this.__forEach(sourceValue, function (it) {
                if (creationHappened || !createIfMissing) return;
                var lo = _this3.__getTargetIdLO(it, target, fieldInfo);
                if (!lo.hasValue()) return;
                creationHappened = _ClientId2.default.is(lo.getValueEnforcing());
            });
            if (creationHappened) {
                this.__doChildRecordHelper(ctx, target, fieldInfo, sourceValue, createIfMissing ? _MappingInfoStore.FT_GLOBAL_REFERENCE_OR_CREATE : _MappingInfoStore.FT_GLOBAL_REFERENCE_ONLY);
            }
        }
    }, {
        key: "doComposition",
        value: function doComposition(ctx, target, excluded, fieldInfo, sourceValue) {
            var _this4 = this;

            if (sourceValue == null) return;
            this.__forEach(sourceValue, function (it) {
                var lo = _this4.__getTargetIdLO(it, target, fieldInfo);
                if (!lo.hasValue()) return;
                var id = lo.getValueEnforcing();
                if ((0, _MappingStore.isExcluded)(_this4.state, target.id, fieldInfo.logicalColumn, id)) {
                    _this4.doExcludedChild(ctx, target, fieldInfo, id, it);
                } else {
                    _this4.doComposedChild(ctx, target, fieldInfo, _this4.access.getEntityProxy(fieldInfo.otherEntityKey, id), it);
                }
            });
        }
    }, {
        key: "doComposedChild",
        value: function doComposedChild(ctx, targetParent, edgeInfo, target, source) {
            return this.doRecord(ctx, target, false, source, _MappingInfoStore.FT_CHILD, edgeInfo);
        }
    }, {
        key: "doExcludedChild",
        value: function doExcludedChild(ctx, targetParent, edgeInfo, targetId, source) {
            /* will be overloaded */
        }
    }, {
        key: "__getAutomanagedTargetLookup",
        value: function __getAutomanagedTargetLookup(target, fieldInfo) {
            var targets = target.get(fieldInfo.key);
            if (targets == null) return;
            if (!Array.isArray(targets)) targets = [targets]; // that's weird
            if (targets.length === 0) return;

            var targetLookup = {}; // target global id -> target child
            targets.forEach(function (t) {
                var targetGlobal = t.get(fieldInfo.autoManageKey);
                if (targetGlobal == null) return;
                targetLookup[targetGlobal.id] = t;
            });
            return targetLookup;
        }
    }, {
        key: "__getAutomanagedTarget",
        value: function __getAutomanagedTarget(target, source, fieldInfo) {
            var lo = this.__getPairedIdLO(source.id, target.entityKey, // composition, so no ID
            fieldInfo.key);
            if (!lo.hasValue()) return null;
            return this.access.getEntityProxy(fieldInfo.otherEntityKey, lo.getValueEnforcing());
        }

        // `sourceManagedByGetter` accepts a source record, and returns the value of
        // being mapped onto the target child's auto-managed-by field (named by
        // `fieldInfo.autoManageKey`). I.e., it gets the record

    }, {
        key: "doAutomanaged",
        value: function doAutomanaged(ctx, target, excluded, fieldInfo, autoManagedByFieldInfo, sourceValue, sourceManagedByGetter) {
            this.__doChildRecordHelper(ctx, target, fieldInfo, sourceValue, _MappingInfoStore.FT_CHILD);
        }
    }, {
        key: "doCrossTree",
        value: function doCrossTree(ctx, target, excluded, fieldInfo, sourceValue) {
            /* will be overloaded */
        }
    }, {
        key: "shouldDoField",
        value: function shouldDoField(ctx, target, excluded, fieldInfo) {
            return target.isFieldEnabled(fieldInfo);
        }
    }, {
        key: "shouldDoChild",
        value: function shouldDoChild(ctx, target, excluded, fieldInfo, type) {
            return target.isFieldEnabled(fieldInfo);
        }
    }, {
        key: "shouldDoCrossTree",
        value: function shouldDoCrossTree(ctx, target, excluded, fieldInfo) {
            return target.isFieldEnabled(fieldInfo);
        }
    }, {
        key: "__cleanMultiplicity",
        value: function __cleanMultiplicity(fieldInfo, items) {
            return fieldInfo.multiValued ? items : items.length === 0 ? null : items[0];
        }
    }, {
        key: "__oldValue",
        value: function __oldValue(target, fieldInfo) {
            var ep = this.old.get(target.getKey());
            return ep == null ? null : ep.get(fieldInfo.key);
        }
    }, {
        key: "__doChildRecordHelper",
        value: function __doChildRecordHelper(ctx, target, fieldInfo, sourceValue, type) {
            var _this5 = this;

            if (sourceValue == null) return;
            this.__forEach(sourceValue, function (it) {
                var lo = _this5.__getTargetIdLO(it, target, fieldInfo);
                if (!lo.hasValue()) return;
                var id = lo.getValueEnforcing();
                _this5.doRecord(ctx, _this5.access.getEntityProxy(fieldInfo.otherEntityKey, id), (0, _MappingStore.isExcluded)(_this5.state, target.id, fieldInfo.logicalColumn, id), it, type, fieldInfo);
            });
        }

        // Note that this operates off the _initial_ state passed to the visitor; it
        // doesn't update during the walk.

    }, {
        key: "__getTargetIdLO",
        value: function __getTargetIdLO(sourceRecord, target, fieldInfo) {
            return this.__getPairedIdLO(sourceRecord.id, target.getKey(), fieldInfo.key);
        }

        // Note that this operates off the _initial_ state passed to the visitor; it
        // doesn't update during the walk.

    }, {
        key: "__getPairedIdLO",
        value: function __getPairedIdLO(sourceId, targetRecordKey, targetFieldKey) {
            return (0, _MappingStore.getPairedIdLO)(this._initialState, sourceId, targetRecordKey, targetFieldKey);
        }

        /**
         * I iterate over a single item or a collection of them, performing work on
         * each item. This is a common idiom w/in mapping (just process the child
         * records - I don't care about multiplicity).
         */

    }, {
        key: "__forEach",
        value: function __forEach(itemOrItems, work) {
            if (itemOrItems == null) return;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = (0, _asArray2.default)(itemOrItems)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var it = _step3.value;

                    work(it);
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
    }]);

    return MappingVisitor;
}();

exports.default = MappingVisitor;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildMappingStateFromMergeState = exports.processAutoMergeGlobalMappingState = exports.getAutoMergeRecordSummary = exports.getAutoMergeGlobalSummary = exports.getAutoMergeInclusions = exports.getAutoMergeExclusions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _MergeStore = __webpack_require__(53);

var _SuperRecordStore = __webpack_require__(36);

var _SuperRecordStore2 = _interopRequireDefault(_SuperRecordStore);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getAutoMergeExclusions = exports.getAutoMergeExclusions = function getAutoMergeExclusions(ep) {
    // this function builds an array of fields to exclude from auto merge
    // for use with self to self mapping.
    var entityInfo = _entityMetaStore2.default.getInfo(ep.entityKey);
    var entityFieldInfos = _entityFieldMetaStore2.default.getAllInfos(entityInfo.key);
    var exclude = [];
    // Find all fields that are not enabled multivalve compositions &
    // auto-manage and exclude them...
    entityFieldInfos.filter(function (fi) {
        return !(fi.type === "CompositionField" && fi.autoManageKey == null && ep.isFieldEnabled(fi));
    }).forEach(function (fi) {
        exclude.push(fi);
    });
    return exclude;
};

var getAutoMergeInclusions = exports.getAutoMergeInclusions = function getAutoMergeInclusions(ep) {
    // this function builds an array of fields to include from auto merge
    // for use with self to self mapping.
    var entityInfo = _entityMetaStore2.default.getInfo(ep.entityKey);
    var entityFieldInfos = _entityFieldMetaStore2.default.getAllInfos(entityInfo.key);
    var include = [];
    // Find all fields that are not enabled multivalve compositions &
    // auto-manage and includes them...
    entityFieldInfos.filter(function (fi) {
        return fi.type === "CompositionField" && fi.autoManageKey == null && ep.isFieldEnabled(fi);
    }).forEach(function (fi) {
        include.push(fi);
    });
    return include;
};

var getAutoMergeGlobalSummary = exports.getAutoMergeGlobalSummary = function getAutoMergeGlobalSummary(sp) {
    var sourceChildren = [];
    // return records being moved
    var stereoInfo = _StereotypesStore2.default.getStereotypeByKey(sp.stereoKey);
    var srInfo = _SuperRecordStore2.default.getRecord(sp.stereoKey, sp.id);

    // all ComositionFields
    stereoInfo.implementations.forEach(function (it) {
        var ep = _TableStore2.default.getEntityProxy(it.key, sp.id);
        getAutoMergeInclusions(ep).forEach(function (fi) {
            var items = ep.get(fi.key);
            if (Array.isArray(items) && items.length) {
                sourceChildren.push({
                    label: fi.name,
                    items: items.map(function (r) {
                        return r.getLabel();
                    })
                });
            }
        });
    });

    // all children
    if (srInfo.topLevelIds != null) {
        var labels = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = Object.keys(srInfo.topLevelIds)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var mck = _step.value;
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = srInfo.topLevelIds[mck][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var id = _step2.value;

                        _TableStore2.default.getEntityProxy(mck, id);
                        var ep = _TableStore2.default.getEntityProxy(mck, id);
                        labels.push(ep.getLabel());
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        if (labels.length > 0) {
            var childInfo = _StereotypesStore2.default.getStereotypeByKey(stereoInfo.magicChildKey);
            sourceChildren.push({
                label: labels.length === 1 ? childInfo.name : childInfo.pluralName,
                items: labels
            });
        }
    }
    return sourceChildren;
};

var getAutoMergeRecordSummary = exports.getAutoMergeRecordSummary = function getAutoMergeRecordSummary(ep) {
    var sourceChildren = [];
    var childFields = getAutoMergeInclusions(ep);
    childFields.forEach(function (field) {
        var labels = [];
        var records = ep.get(field.key);
        records.forEach(function (r) {
            labels.push(r.getLabel());
        });
        if (labels.length > 0) {
            sourceChildren.push({
                label: field.name,
                items: labels
            });
        }
    });
    return sourceChildren;
};

var getInitialGlobalMergeQueue = function getInitialGlobalMergeQueue(targetSP, sourceSP) {
    var queue = [];
    var stereoInfo = _StereotypesStore2.default.getStereotypeByKey(targetSP.stereoKey);
    stereoInfo.implementations.forEach(function (it) {
        queue.push({
            target: _TableStore2.default.getEntityProxy(it.key, targetSP.id), // these should exist already
            source: _TableStore2.default.getEntityProxy(it.key, sourceSP.id)
        });
    });
    return queue;
};

var processAutoMergeGlobalMappingState = exports.processAutoMergeGlobalMappingState = function processAutoMergeGlobalMappingState() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var newQueue = void 0;
    if (state.queue === undefined) {
        // Initial call build the queue.
        var mergeState = _extends({}, state);
        newQueue = getInitialGlobalMergeQueue(mergeState.target, mergeState.source);
    } else {
        // otherwise use the existing queue
        newQueue = [].concat(_toConsumableArray(state.queue));
    }

    if (!newQueue.length) {
        // mapping workflow should stop before we get here
        throw Error("Attempting to process empty queue.");
    }

    // get the first
    var first = newQueue.shift();

    // start from scratch
    return {
        active: true,
        interactive: state.interactive || false,
        target: first.target,
        source: first.source,
        // don't maintain the promise...
        modelLO: _LoadObject2.default.withValue(null),
        drawerOpen: false,
        exclusions: state.exclusions || {},
        queue: newQueue,
        processQueueCallback: processAutoMergeGlobalMappingState
    };
};

var buildMappingStateFromMergeState = exports.buildMappingStateFromMergeState = function buildMappingStateFromMergeState(mergeState) {
    var plugin = mergeState.pluginKey;
    switch (plugin) {
        case _MergeStore.MERGE_PLUGINS.GLOBAL_MERGE:
            // Global mergeState uses stereotype proxies for the source and
            // target instead of entity proxies. We need to convert the
            // merge state into a queue of mapping states.
            return processAutoMergeGlobalMappingState(mergeState);
        case _MergeStore.MERGE_PLUGINS.RECORD_MERGE:
            // Record and child level merges are already entity proxies.
            return {
                active: true,
                interactive: mergeState.interactive || false,
                target: mergeState.target,
                source: mergeState.source,
                // don't maintain the promise...
                modelLO: _LoadObject2.default.withValue(null),
                drawerOpen: false,
                exclusions: mergeState.exclusions || {}
            };
        default:
            throw Error("Unknown merge plugin \"" + plugin + "\"");
    }
};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertFieldToDescriptor = exports.InnerSearchForm = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _form = __webpack_require__(107);

var _form2 = _interopRequireDefault(_form);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _SearchFormActions = __webpack_require__(75);

var _SearchFormActions2 = _interopRequireDefault(_SearchFormActions);

var _SearchFormStore = __webpack_require__(82);

var _SearchFormStore2 = _interopRequireDefault(_SearchFormStore);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InnerSearchForm = exports.InnerSearchForm = function (_React$Component) {
    _inherits(InnerSearchForm, _React$Component);

    function InnerSearchForm(props) {
        _classCallCheck(this, InnerSearchForm);

        var _this = _possibleConstructorReturn(this, (InnerSearchForm.__proto__ || Object.getPrototypeOf(InnerSearchForm)).call(this, props));

        _this.advancedInputRef = _react2.default.createRef();

        _this.advancedToggle = _this.advancedToggle.bind(_this);

        _this.onClear = _this.onClear.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);

        _this.state = {
            showAdvanced: props.alwaysShowAdvanced || props.showAdvanced || false,
            height: props.alwaysShowAdvanced || props.showAdvanced ? 0 : 34
        };
        return _this;
    }

    _createClass(InnerSearchForm, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            var height = this.advancedInputRef.current.scrollHeight;
            if (this.state.showAdvanced && this.state.height !== 0 && this.state.height !== this.advancedInputRef.current.scrollHeight) {
                this.setState({ height: height });
            }
        }
    }, {
        key: "advancedToggle",
        value: function advancedToggle(e) {
            var showAdvanced = !this.state.showAdvanced;
            e.preventDefault();
            var height = showAdvanced ? this.advancedInputRef.current.scrollHeight : 34;
            this.setState({ showAdvanced: showAdvanced, height: height });
            var onHeightChange = this.props.onHeightChange;

            onHeightChange && onHeightChange();
        }
    }, {
        key: "onSubmit",
        value: function onSubmit(e) {
            var onSubmit = this.props.onSubmit;

            e.preventDefault();
            onSubmit && onSubmit(e);
        }
    }, {
        key: "onClear",
        value: function onClear(e) {
            var onClearFields = this.props.onClearFields;

            e.preventDefault();
            onClearFields && onClearFields();
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                searchFields = _props.searchFields,
                fieldPropsResolver = _props.fieldPropsResolver,
                alwaysShowAdvanced = _props.alwaysShowAdvanced,
                onToggleRelativeDates = _props.onToggleRelativeDates,
                supportsRelativeDates = _props.supportsRelativeDates,
                hasDateFields = _props.hasDateFields,
                useRelativeDates = _props.useRelativeDates;
            var showAdvanced = this.state.showAdvanced;
            // first field will always be the default basic

            var formDescriptor = convertFieldToDescriptor(showAdvanced ? searchFields : searchFields.slice(0, 1));
            return _react2.default.createElement(
                "form",
                { className: "form-search", action: "#unbound", onSubmit: this.onSubmit },
                _react2.default.createElement(
                    "fieldset",
                    null,
                    _react2.default.createElement(
                        "div",
                        { className: "advanced-search-inputs row" },
                        _react2.default.createElement(
                            "div",
                            { className: "search-inputs col-md-12", ref: this.advancedInputRef },
                            _react2.default.createElement(_form2.default, {
                                descriptor: formDescriptor,
                                propsResolver: fieldPropsResolver,
                                controlOnly: true,
                                placeholder: true
                            })
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "row" },
                        _react2.default.createElement(
                            "div",
                            { className: "col-md-4" },
                            _react2.default.createElement(
                                "a",
                                { href: "#", className: "clear", onClick: this.onClear },
                                _react2.default.createElement("span", { className: "glyphicon glyphicon-remove" }),
                                " ",
                                "clear search"
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "col-md-4" },
                            hasDateFields && supportsRelativeDates && _react2.default.createElement(
                                "a",
                                { href: "#", className: "togglerelativedates", onClick: function onClick(e) {
                                        return onToggleRelativeDates(e, useRelativeDates);
                                    } },
                                _react2.default.createElement("span", { className: "glyphicon glyphicon-calendar" }),
                                " ",
                                !useRelativeDates ? "use last n days" : "use date range"
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "col-md-4" },
                            searchFields.length > 1 && !alwaysShowAdvanced && _react2.default.createElement(
                                "a",
                                { href: "#", className: "advanced-search-toggle pull-right", onClick: this.advancedToggle },
                                _react2.default.createElement("span", { className: "glyphicon glyphicon-" + (showAdvanced ? "minus" : "plus") }),
                                " ",
                                showAdvanced ? "hide search options" : "show search options"
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    "button",
                    { type: "submit", className: "hidden" },
                    "SEARCH"
                )
            );
        }
    }]);

    return InnerSearchForm;
}(_react2.default.Component);

InnerSearchForm.propTypes = {
    fluxContext: _propTypes2.default.string.isRequired,
    showAdvanced: _propTypes2.default.bool,
    alwaysShowAdvanced: _propTypes2.default.bool,
    onSubmit: _propTypes2.default.func.isRequired,
    searchFields: _propTypes2.default.array.isRequired,
    supportsRelativeDates: _propTypes2.default.bool,
    hasDateFields: _propTypes2.default.bool,
    useRelativeDates: _propTypes2.default.bool,
    fieldPropsResolver: _propTypes2.default.func.isRequired,
    onClearFields: _propTypes2.default.func.isRequired,
    onToggleRelativeDates: _propTypes2.default.func.isRequired,
    onHeightChange: _propTypes2.default.func
};

var SearchForm = function SearchForm(props) {
    var fluxContext = props.fluxContext;

    var state = (0, _useFluxStore2.default)(function () {
        return {
            searchFields: _SearchFormStore2.default.getFields(fluxContext),
            hasDateFields: _SearchFormStore2.default.hasDateFields(fluxContext),
            useRelativeDates: _SearchFormStore2.default.getUseRelativeDates(fluxContext),
            onClearFields: function onClearFields() {
                _Dispatcher2.default.contextDispatch(fluxContext, {
                    type: _SearchFormActions2.default.CLEAR_FIELDS
                });
            },
            onToggleRelativeDates: function onToggleRelativeDates(e, useRelativeDates) {
                e.preventDefault();
                _Dispatcher2.default.contextDispatch(fluxContext, {
                    type: _SearchFormActions2.default.SET_USE_RELATIVE_DATES,
                    useRelativeDates: !useRelativeDates
                });
            },
            fieldPropsResolver: function fieldPropsResolver(field) {
                return {
                    // build the props for each control.
                    descriptor: convertFieldToDescriptor(field),
                    onCommitChange: function onCommitChange(d, value) {
                        _Dispatcher2.default.contextDispatch(fluxContext, {
                            type: _SearchFormActions2.default.SET_FIELD,
                            path: d.path,
                            value: value !== null ? value : null
                        });
                    },
                    value: field.value !== undefined ? field.value : null,
                    enabled: true
                };
            }
        };
    }, [_SearchFormStore2.default], [fluxContext]);
    return _react2.default.createElement(InnerSearchForm, _extends({}, props, state));
};

SearchForm.propTypes = {
    fluxContext: _propTypes2.default.string.isRequired
};

exports.default = SearchForm;

/**
 * Converts a SearchFormStore field into a descriptor object.
 *
 * @param {array, object} field
 * @return {object}
 */

var convertFieldToDescriptor = exports.convertFieldToDescriptor = function convertFieldToDescriptor(field) {
    if (Array.isArray(field)) {
        // initial Form descriptor
        return {
            key: "",
            id: "",
            path: "",
            label: "",
            type: "Form",
            control: "form",
            disableBehaviour: "disable",
            childItems: field
        };
    }

    var descriptor = {
        config: {},
        key: field.key,
        id: field.id || field.key,
        path: field.path,
        label: field.name,
        disableBehaviour: "disable"
    };
    switch (field.type) {
        case "string":
            if (field.hasExpectedValues) {
                descriptor.control = "dropdown";
                descriptor.config = {
                    options: [""].concat(_toConsumableArray(field.expectedValues))
                };
            } else {
                descriptor.control = "text";
            }
            descriptor.type = "StringField";
            break;
        case "checkbox":
            descriptor.control = "checkbox";
            descriptor.type = "ChoiceField";
            descriptor.config.checkedValue = true;
            descriptor.config.uncheckedValue = null;
            break;
        case "date":
            descriptor.control = "calendar";
            descriptor.type = "DateField";
            descriptor.config.granularity = "DAY";
            break;
        case "datetime":
            descriptor.control = "calendar";
            descriptor.type = "DateTimeField";
            descriptor.config.granularity = "MINUTE";
            break;
        case "time":
            descriptor.control = "spinner";
            descriptor.type = "TimeField";
            descriptor.config.granularity = "MINUTE";
            break;
        case "dropdown":
            descriptor.control = "dropdown";
            descriptor.type = "ChoiceField";
            break;
        case "integer":
            descriptor.control = "spinner";
            descriptor.type = "IntegerField";
            break;
        case "to-one":
            descriptor.control = "section";
            descriptor.type = "Layout";
            break;
        case "to-many":
            descriptor.control = "section";
            descriptor.type = "Layout";
            break;
        default:
            if (/(relative|range|ormissing)$/.test(field.type)) {
                descriptor.control = "row";
                descriptor.type = "Layout";
            } else {
                console.warn("No \"" + field.type + "\" descriptor type is known.");
                descriptor.control = field.type;
                descriptor.type = field.type;
            }
    }

    if (Array.isArray(field.fields)) {
        // for recursive controls
        descriptor.childItems = field.fields;
    }

    return descriptor;
};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BackboneSelectionTable = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Body = __webpack_require__(1030);

var _Body2 = _interopRequireDefault(_Body);

var _Header = __webpack_require__(1034);

var _Header2 = _interopRequireDefault(_Header);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _backboneConnect = __webpack_require__(127);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectionTable = function (_React$Component) {
    _inherits(SelectionTable, _React$Component);

    function SelectionTable(props) {
        _classCallCheck(this, SelectionTable);

        var _this = _possibleConstructorReturn(this, (SelectionTable.__proto__ || Object.getPrototypeOf(SelectionTable)).call(this, props));

        _this.state = {
            showDisabled: props.showDisabled
        };
        return _this;
    }

    _createClass(SelectionTable, [{
        key: "onShowDisabledChange",
        value: function onShowDisabledChange() {
            this.setState({
                showDisabled: !this.state.showDisabled
            });
        }
    }, {
        key: "getFilteredColumns",
        value: function getFilteredColumns() {
            var _props = this.props,
                hasStereotype = _props.hasStereotype,
                reportTypeKey = _props.reportTypeKey,
                supportsEnablement = _props.supportsEnablement,
                columns = _props.columns;

            var filteredColumns = [].concat(_toConsumableArray(columns));

            // This assumes that the records can't have both
            // enablement and stereotype
            if (this.state.showDisabled) {
                if (supportsEnablement) {
                    filteredColumns.push({
                        key: "_enabled",
                        name: "Enabled",
                        type: "string"
                    });
                }
            } else {
                if (hasStereotype) {
                    if (hasStereotype && reportTypeKey === "d") {
                        filteredColumns.push({
                            key: "_longname",
                            name: "Field",
                            type: "string"
                        });

                        filteredColumns.push({
                            key: "_message",
                            name: "Message",
                            type: "string"
                        });
                    }
                }
            }
            return filteredColumns;
        }
    }, {
        key: "getFilteredCollection",
        value: function getFilteredCollection() {
            var _props2 = this.props,
                records = _props2.records,
                supportsEnablement = _props2.supportsEnablement;
            var showDisabled = this.state.showDisabled;


            var filteredRecords = supportsEnablement ? records.filter(function (m) {
                return showDisabled ? true : m.data._enabled === true;
            }) : records;
            return showDisabled ? records : filteredRecords;
        }
    }, {
        key: "render",
        value: function render() {
            var _props3 = this.props,
                sorts = _props3.sorts,
                renderUnsafe = _props3.renderUnsafe,
                hasHover = _props3.hasHover,
                supportsEnablement = _props3.supportsEnablement,
                fixedHeaders = _props3.fixedHeaders,
                onRecordSelection = _props3.onRecordSelection,
                onDownloadClick = _props3.onDownloadClick,
                onSort = _props3.onSort,
                sortable = _props3.sortable,
                selected = _props3.selected,
                _props3$maxHeight = _props3.maxHeight,
                maxHeight = _props3$maxHeight === undefined ? "auto" : _props3$maxHeight;

            var records = this.getFilteredCollection();

            var filteredColumns = this.getFilteredColumns();

            var header = _react2.default.createElement(_Header2.default, {
                onSort: sortable ? onSort : null,
                columns: filteredColumns,
                sorts: sorts,
                fixedHeaders: fixedHeaders
            });

            var body = _react2.default.createElement(_Body2.default, {
                records: records,
                selected: selected,
                columns: filteredColumns,
                onRecordSelection: onRecordSelection,
                onDownloadClick: onDownloadClick,
                renderUnsafe: renderUnsafe
            });

            var enablement = supportsEnablement ? _react2.default.createElement(
                "label",
                {
                    className: "text-right showDisabled",
                    style: { paddingRight: 10 + "px", display: "block" }
                },
                _react2.default.createElement("input", {
                    type: "checkbox",
                    onChange: this.onShowDisabledChange.bind(this),
                    id: "showDisabled",
                    defaultChecked: this.state.showDisabled ? "checked" : null
                }),
                " Show Disabled Records"
            ) : null;

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                enablement,
                _react2.default.createElement(
                    "div",
                    { className: "search-results " + (fixedHeaders ? "fixed-headers" : "") },
                    _react2.default.createElement(
                        "div",
                        { className: "scroll-container", style: {
                                maxHeight: supportsEnablement ? "calc(" + maxHeight + " - 30px)" : maxHeight
                            } },
                        _react2.default.createElement(
                            "table",
                            { className: hasHover ? "table-alt table-striped table-hover" : "table-alt table-striped" },
                            _react2.default.createElement(
                                "thead",
                                null,
                                _react2.default.createElement(
                                    "tr",
                                    null,
                                    header
                                )
                            ),
                            _react2.default.createElement(
                                "tbody",
                                null,
                                body
                            )
                        )
                    )
                )
            );
        }
    }]);

    return SelectionTable;
}(_react2.default.Component);

exports.default = SelectionTable;


SelectionTable.propTypes = {
    records: _propTypes2.default.array,
    columns: _propTypes2.default.array,
    fixedHeaders: _propTypes2.default.bool,
    selected: _propTypes2.default.object,
    sorts: _propTypes2.default.object,
    showDisabled: _propTypes2.default.bool,
    supportsEnablement: _propTypes2.default.bool,
    hasHover: _propTypes2.default.bool,
    hasStereotype: _propTypes2.default.bool,
    renderUnsafe: _propTypes2.default.bool,
    sortable: _propTypes2.default.bool,
    onSort: _propTypes2.default.func,
    reportTypeKey: _propTypes2.default.string,
    onRecordSelection: _propTypes2.default.func.isRequired,
    onDownloadClick: _propTypes2.default.func,
    maxHeight: _propTypes2.default.string
};

SelectionTable.defaultProps = {
    fixedHeaders: false,
    records: [],
    columns: [],
    sorts: {},
    showDisabled: false,
    supportsEnablement: false,
    hasHover: true,
    sortable: true,
    renderUnsafe: true
};

var config = function config(props) {
    return {
        records: {
            listenOn: "collection",
            get: function get(collection) {
                return collection.map(function (it) {
                    return _extends({}, it.toJSON(), { id: it.cid, _record: it });
                });
            }
        },
        sorts: {
            listenOn: "sorts",
            event: "sort",
            get: function get() {
                return props.sorts.toJSON();
            }
        },
        selected: {
            listenOn: "collection",
            event: "selected",
            func: function func(model) {
                return { selected: model.toJSON() };
            }
        },
        columns: {
            listenOn: "fields",
            get: function get(fields) {
                return fields.toJSON();
            }
        },
        onRecordSelection: function onRecordSelection(record) {
            if (!props.onRecordSelection) return;
            record._record.trigger("selected", record._record);
            props.onRecordSelection(record._record);
        },
        onSort: function onSort(column) {
            var key = column.key;
            var sort = props.sorts ? props.sorts.get(key) : undefined;

            if (sort) {
                if (sort === "desc") {
                    props.sorts.set(key, "asc");
                } else if (sort === "asc") {
                    props.sorts.unset(key);
                }
            } else {
                props.sorts.set(key, "desc");
            }
            props.sorts.trigger("sort", props.sorts);
            props.onSort();
        }
    };
};

var BackboneSelectionTable = exports.BackboneSelectionTable = (0, _backboneConnect.backboneConnect)(config)(SelectionTable);

/***/ }),
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = __webpack_require__(52);

var _Button2 = _interopRequireDefault(_Button);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildCreateProps = function buildCreateProps(props, entityKey, options) {
    if (Array.isArray(options)) {
        // filter createables based off permissions ... allow collapse if filterd list length is equal to unfilterd list length.
        var filteredOptions = options.filter(function (o) {
            (0, _invariant2.default)(_EntityName2.default.is(o.value), "ActionButton creatable w/ non-EK '" + o.value + "' value?!");
            return _entityMetaStore2.default.getInfo(o.value).canCreate;
        });
        if (filteredOptions.length > 0) {
            // modify props
            props.collapse = filteredOptions.length === options.length;
            props.options = filteredOptions;
            return true;
        } else {
            return false;
        }
    } else if (entityKey) {
        return _entityMetaStore2.default.getInfo(entityKey).canCreate;
    }
    throw new Error("ActionButton creatable w/out entityKey?!");
};

var ActionButton = function ActionButton(props) {
    var options = props.options,
        className = props.className,
        _props$focusable = props.focusable,
        focusable = _props$focusable === undefined ? true : _props$focusable,
        entityKey = props.entityKey,
        _props$disableBehavio = props.disableBehaviour,
        disableBehaviour = _props$disableBehavio === undefined ? "hide" : _props$disableBehavio;

    (0, _invariant2.default)(!props.implKey, "ActionButton w/ an implKey prop: '" + props.implKey + "'");
    var buttonProps = _extends({}, props, {
        enabled: props.enabled !== undefined ? props.enabled : true
    });

    switch (props.actionType) {
        case "new":
            buttonProps.icon = _react2.default.createElement("i", { className: "glyphicon glyphicon-plus-circle" });
            buttonProps.className = "btn btn-default btn-new";
            buttonProps.dropdownCarrot = true;
            if (!buildCreateProps(buttonProps, entityKey, options)) {
                if (disableBehaviour === "hide") {
                    return null;
                } else {
                    buttonProps.enabled = false;
                }
            }
            break;
        case "add":
            buttonProps.icon = _react2.default.createElement("i", { className: "glyphicon glyphicon-plus-circle" });
            buttonProps.className = "btn-link btn-icon btn-add";
            buttonProps.dropdownCarrot = false;
            if (!buildCreateProps(buttonProps, entityKey, options)) {
                if (disableBehaviour === "hide") {
                    return null;
                } else {
                    buttonProps.enabled = false;
                }
            }
            break;
        case "remove":
            buttonProps.icon = _react2.default.createElement("i", { className: "glyphicon glyphicon-remove-circle" });
            buttonProps.className = "btn-link btn-icon btn-remove";
            buttonProps.dropdownCarrot = false;
            if (entityKey && !_entityMetaStore2.default.getInfo(entityKey).canDelete) {
                if (disableBehaviour === "hide") {
                    return null;
                } else {
                    buttonProps.enabled = false;
                }
            }
            break;
        case "view":
            buttonProps.icon = _react2.default.createElement("i", { className: "glyphicon glyphicon-new-window" });
            buttonProps.className = "btn-link btn-icon btn-view";
            buttonProps.dropdownCarrot = false;
            break;
        default:
            buttonProps.icon = null;
            buttonProps.dropdownCarrot = true;
            buttonProps.className = "btn btn-default";
    }
    if (focusable) {
        buttonProps.className += " keyboard-focusable";
    }
    if (className) {
        buttonProps.className += " " + className;
    }
    return _react2.default.createElement(_Button2.default, buttonProps);
};

ActionButton.propTypes = {
    actionType: _propTypes2.default.string.isRequired,
    focusable: _propTypes2.default.bool,
    disableBehaviour: _propTypes2.default.string
};

exports.default = ActionButton;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildDevicelesiongridCheckboxColumns = exports.buildColumnsFromConfig = exports.buildColumn = exports.buildCreatable = exports.MagicRecordGridDataGateway = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _superRecords = __webpack_require__(63);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _RecordGrid = __webpack_require__(161);

var _ActionButton = __webpack_require__(249);

var _ActionButton2 = _interopRequireDefault(_ActionButton);

var _Checkbox = __webpack_require__(615);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _RecordActions = __webpack_require__(60);

var _RecordActions2 = _interopRequireDefault(_RecordActions);

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

var _NavigationActions = __webpack_require__(80);

var _NavigationActions2 = _interopRequireDefault(_NavigationActions);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

var _resolver = __webpack_require__(348);

var _isFieldHidden = __webpack_require__(177);

var _isFieldHidden2 = _interopRequireDefault(_isFieldHidden);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RecordGridDataGateway = function (_React$PureComponent) {
    _inherits(RecordGridDataGateway, _React$PureComponent);

    function RecordGridDataGateway(props) {
        _classCallCheck(this, RecordGridDataGateway);

        var _this = _possibleConstructorReturn(this, (RecordGridDataGateway.__proto__ || Object.getPrototypeOf(RecordGridDataGateway)).apply(this, arguments));

        _this.singularLabel = props.singularLabel || "Record";

        _this.onAddClick = _this.onAddClick.bind(_this);
        _this.onHeaderClick = _this.onHeaderClick.bind(_this);
        _this.onRemoveClick = _this.onRemoveClick.bind(_this);
        _this.onViewClick = _this.onViewClick.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        return _this;
    }

    _createClass(RecordGridDataGateway, [{
        key: "getCoords",
        value: function getCoords() {
            var _props = this.props,
                activeRecord = _props.activeRecord,
                shortname = _props.shortname,
                colCoords = _props.colCoords;

            var coords = colCoords;
            if (coords == null) {
                coords = {
                    record: activeRecord,
                    fieldKey: shortname
                };
            } else if (coords instanceof Array || coords instanceof Backbone.Collection) {
                throw new Error("Don't pass a collection to RecordGrid, pass coordinates");
            }
            return coords;
        }
    }, {
        key: "onAddClick",
        value: function onAddClick(creatable, afterRecord) {
            var _props2 = this.props,
                fluxContext = _props2.fluxContext,
                _props2$allowView = _props2.allowView,
                allowView = _props2$allowView === undefined ? false : _props2$allowView;


            var selfCoords = this.getCoords();
            var coords = creatable.colCoords ? creatable.colCoords : selfCoords;
            if (creatable.collection && !creatable.colCoords) {
                console.log("creatable:", creatable.toJSON());
                throw new Error("Creatable w/ collection but not coords");
            }

            var records = recordsFromCoords(coords);
            var navigate = selfCoords.record.entityKey === coords.record.entityKey && selfCoords.fieldKey === coords.fieldKey ? allowView : true;

            var insertAt = undefined;
            if (afterRecord != null) {
                // this works. not like how you'd think, but it does work.
                records.forEach(function (it, i) {
                    if (it.id === afterRecord.id) {
                        insertAt = i + 1;
                    }
                });
            }
            var newId = _ClientId2.default.next();
            _Dispatcher2.default.contextDispatch(fluxContext, {
                type: _RecordActions2.default.NEW_CHILD,
                recordKey: coords.record.entityKey,
                recordId: coords.record.id,
                fieldKey: coords.fieldKey,
                entityKey: creatable.id,
                newId: newId,
                navigate: navigate,
                insertAt: insertAt
            });
        }
    }, {
        key: "onViewClick",
        value: function onViewClick(r) {
            var fluxContext = this.props.fluxContext;

            _Dispatcher2.default.contextDispatch(fluxContext, {
                type: _NavigationActions2.default.SELECT_RECORD,
                entityKey: r.entityKey,
                recordId: r.id
            });
        }
    }, {
        key: "onHeaderClick",
        value: function onHeaderClick(r) {
            /* noop */
        }
    }, {
        key: "onRemoveClick",
        value: function onRemoveClick(r) {
            var fluxContext = this.props.fluxContext;

            var coords = this.getCoords();
            var action = {
                type: _RecordActions2.default.DELETE_CHILD,
                recordKey: coords.record.entityKey,
                recordId: coords.record.id,
                fieldKey: coords.fieldKey,
                childKey: r.entityKey,
                childId: r.id
            };

            _Dispatcher2.default.contextDispatch(fluxContext, action);
        }
    }, {
        key: "onFocus",
        value: function onFocus(e, d, v, k) {
            var onFocus = this.props.onFocus;

            onFocus && onFocus(e, k);
        }
    }, {
        key: "onBlur",
        value: function onBlur(e) {
            var onBlur = this.props.onBlur;

            onBlur && onBlur(e);
        }
    }, {
        key: "onKeyDown",
        value: function onKeyDown(e) {
            var onKeyDown = this.props.onKeyDown;

            onKeyDown && onKeyDown(e);
        }
    }, {
        key: "getRecords",
        value: function getRecords() {
            return recordsFromCoords(this.getCoords());
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props3 = this.props,
                Component = _props3.component,
                descriptor = _props3.descriptor,
                controlOnly = _props3.controlOnly,
                enabled = _props3.enabled,
                addMode = _props3.addMode,
                creatables = _props3.creatables,
                rawColumns = _props3.columns,
                allowView = _props3.allowView,
                allowCreate = _props3.allowCreate,
                allowRemove = _props3.allowRemove;

            var coords = this.getCoords();
            var columns = rawColumns || [];
            if (coords.fieldKey !== _superRecords.TOP_LEVEL_RECORDS_KEY) {
                var efi = _entityFieldMetaStore2.default.getInfo(coords.record.entityKey, coords.fieldKey);
                columns = columns.filter(function (col) {
                    if (col.type === "script") return true;
                    if (!col.hasOwnProperty("fieldKey")) return true;
                    return !(0, _isFieldHidden2.default)(efi.otherEntityKey, col.fieldKey);
                });
            }
            return _react2.default.createElement(Component, {
                key: descriptor.id // react requires a unique key for all iterators
                , descriptor: descriptor // set the descriptor
                , controlOnly: controlOnly,

                enabled: enabled !== undefined ? enabled : true

                // grid structure
                , addMode: creatables.length ? addMode || _RecordGrid.ADD_TOP : _RecordGrid.ADD_NONE,
                records: this.getRecords() || [],
                creatables: creatables || [],
                columns: columns

                // allowed actions
                , allowView: allowView !== undefined ? allowView : true,
                allowCreate: allowCreate !== undefined ? allowCreate : true,
                allowRemove: allowRemove !== undefined ? allowRemove : true

                // actions
                , onRemoveClick: function onRemoveClick(e, d, record) {
                    return _this2.onRemoveClick(record);
                },
                onAddClick: function onAddClick(e, d, creatable, afterRecord) {
                    return _this2.onAddClick(creatable, afterRecord);
                },
                onHeaderClick: function onHeaderClick(e, d, column, i) {
                    return _this2.onHeaderClick(column);
                },
                onViewClick: function onViewClick(e, d, record, i) {
                    return _this2.onViewClick(record);
                },
                onKeyDown: this.onKeyDown

                // other events
                , onFocus: this.onFocus,
                onBlur: this.onBlur
            });
        }
    }]);

    return RecordGridDataGateway;
}(_react2.default.PureComponent);

RecordGridDataGateway.propTypes = {
    descriptor: _propTypes2.default.object.isRequired,
    fluxContext: _propTypes2.default.string.isRequired,
    activeRecord: _propTypes2.default.instanceOf(_EntityProxy2.default).isRequired,
    component: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]).isRequired,
    shortname: _propTypes2.default.string.isRequired,
    singularLabel: _propTypes2.default.string,
    colCoords: _propTypes2.default.shape({
        record: _propTypes2.default.any,
        fieldKey: _propTypes2.default.string
    }),

    controlOnly: _propTypes2.default.bool,
    enabled: _propTypes2.default.bool,
    addMode: _propTypes2.default.string,
    allowView: _propTypes2.default.bool,
    allowCreate: _propTypes2.default.bool,
    allowRemove: _propTypes2.default.bool,
    columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
        content: _propTypes2.default.func.isRequired, /* column render function given the record data */
        label: _propTypes2.default.any,
        width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
    })),
    records: _propTypes2.default.arrayOf(_propTypes2.default.object),
    creatables: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
        label: _propTypes2.default.any.isRequired
    })).isRequired
};

exports.default = RecordGridDataGateway;

var MagicRecordGridDataGateway = exports.MagicRecordGridDataGateway = function (_RecordGridDataGatewa) {
    _inherits(MagicRecordGridDataGateway, _RecordGridDataGatewa);

    function MagicRecordGridDataGateway() {
        _classCallCheck(this, MagicRecordGridDataGateway);

        return _possibleConstructorReturn(this, (MagicRecordGridDataGateway.__proto__ || Object.getPrototypeOf(MagicRecordGridDataGateway)).apply(this, arguments));
    }

    _createClass(MagicRecordGridDataGateway, [{
        key: "onAddClick",
        value: function onAddClick(creatable) {
            var fluxContext = this.props.fluxContext;

            var coords = this.getCoords();
            var navigate = true;
            var action = {
                type: _SuperRecordActions2.default.NEW_MAGIC_CHILD,
                recordKey: coords.record.entityKey,
                recordId: coords.record.id,
                entityKey: creatable.id,
                newId: _ClientId2.default.next(),
                navigate: navigate
            };
            _Dispatcher2.default.contextDispatch(fluxContext, action);
        }
    }, {
        key: "onRemoveClick",
        value: function onRemoveClick(r) {
            var fluxContext = this.props.fluxContext;

            var action = {
                type: _RecordActions2.default.DELETE_RECORD,
                recordKey: r.entityKey,
                recordId: r.id
            };
            _Dispatcher2.default.contextDispatch(fluxContext, action);
        }
    }]);

    return MagicRecordGridDataGateway;
}(RecordGridDataGateway);

MagicRecordGridDataGateway.propTypes = _extends({}, RecordGridDataGateway.propTypes, {
    activeRecord: _propTypes2.default.shape({
        entityKey: _propTypes2.default.string.isRequired,
        id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
        topLevelRecords: _propTypes2.default.array
    }).isRequired
});

var recordsFromCoords = function recordsFromCoords(colCoords) {
    return colCoords.fieldKey === _superRecords.TOP_LEVEL_RECORDS_KEY ? colCoords.record.hasOwnProperty("topLevelIds") ? (0, _superRecords.getTopLevelRecords)(_TableStore2.default, colCoords.record) : colCoords.record.topLevelRecords : colCoords.record.get(colCoords.fieldKey);
};

var buildCreatable = exports.buildCreatable = function buildCreatable(implKey, label, id) {
    var collectionKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var activeRecord = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    var creatable = {
        id: id,
        implKey: implKey,
        label: label,
        enabled: true
    };

    if (collectionKey != null) {
        var coords = {
            record: activeRecord,
            fieldKey: collectionKey
        };
        creatable.colCoords = coords;
        creatable.collection = recordsFromCoords(coords);
    }

    if (activeRecord) {
        // TODO: DLG creatable enabled state is not correct but so far nothing
        // is relying on this functionality.
        // we need each row and column add action to have their own enabled
        // state.
        creatable.enabled = activeRecord.isFieldEnabled(collectionKey);
    }
    return creatable;
};

var buildColumn = exports.buildColumn = function buildColumn(column) {
    return _extends({
        id: "",
        content: function content(record) {/* noop */},
        label: "",
        width: undefined
    }, column);
};

var buildColumnsFromConfig = exports.buildColumnsFromConfig = function buildColumnsFromConfig() {
    var configColumns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var props = arguments[1];
    return configColumns.map(function (col, i) {
        var c = {
            id: i,
            label: col.heading,
            width: col.width
        };
        if (col.itemInfo) {
            c.fieldKey = col.itemInfo.key;
        }

        if (col.type === "script") {
            c.content = function (record) {
                return _react2.default.createElement(
                    "div",
                    {
                        key: record.id,
                        className: "control-container-expr-" + i + " control expression-field" },

                    /* eslint-disable-next-line no-new-func */
                    Function("instance", col.script)(record)
                );
            };
        } else {
            var descriptor = col.itemInfo; // descriptor
            c.content = function (record) {
                return (0, _resolver.renderer)(_extends({}, props, {
                    descriptor: _extends({}, descriptor, {
                        // overload the descriptor with new id for this cell
                        id: descriptor.id + "r" + (record.id || record.cid)
                    }),
                    activeRecord: record,
                    controlOnly: true
                }));
            };
        }
        return buildColumn(c);
    });
};

var buildDevicelesiongridCheckboxColumns = exports.buildDevicelesiongridCheckboxColumns = function buildDevicelesiongridCheckboxColumns(props) {
    var columnRecords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var fluxContext = props.fluxContext,
        activeRecord = props.activeRecord,
        descriptor = props.descriptor,
        _onFocus = props.onFocus,
        _onBlur = props.onBlur,
        _onKeyDown = props.onKeyDown;

    if (columnRecords == null) {
        columnRecords = activeRecord.get(descriptor.key);
    }
    var config = descriptor.config || {};
    var rowMembershipCollectionKey = config.rowSourceEntityCollectionKey;
    var canWrite = activeRecord.canWrite();

    var onViewClick = function onViewClick(r) {
        _Dispatcher2.default.contextDispatch(fluxContext, {
            type: _NavigationActions2.default.SELECT_RECORD,
            entityKey: r.entityKey,
            recordId: r.id
        });
    };

    var columnAddFn = function columnAddFn(columnRecord) {
        var columnLabel = columnRecord.getLabel();

        return buildColumn({
            id: columnRecord.id,
            entityContext: columnRecord.entityKey,
            width: "100",
            align: "center",
            label: _react2.default.createElement(
                _react2.default.Fragment,
                null,
                columnLabel,
                " ",
                _react2.default.createElement(_ActionButton2.default, { actionType: "view",
                    focusable: false,
                    onClick: function onClick() {
                        return onViewClick(columnRecord);
                    } })
            ),
            content: function content(rowRecord) {
                var coll = columnRecord.get(rowMembershipCollectionKey);
                var columnProps = {
                    id: descriptor.id + "r" + (rowRecord.id || rowRecord.cid) + "c" + (columnRecord.id || columnRecord.cid),
                    shortname: rowMembershipCollectionKey,
                    enabled: canWrite && columnRecord.isFieldEnabled(rowMembershipCollectionKey),
                    value: coll != null && coll.some(function (r) {
                        return r.id === rowRecord.id;
                    }),
                    onCommitChange: function onCommitChange(v) {
                        return _Dispatcher2.default.contextDispatch(fluxContext, _defineProperty({
                            type: _RecordActions2.default.SET_FIELD,
                            recordKey: columnRecord.entityKey,
                            recordId: columnRecord.id,
                            fieldKey: rowMembershipCollectionKey,
                            value: v ? function (v) {
                                return v.concat(rowRecord.id);
                            } : function (v) {
                                return v.filter(function (rID) {
                                    return rID !== rowRecord.id;
                                });
                            }
                        }, _RecordActions.OPT_USER_INITIATED, true));
                    },
                    onFocus: function onFocus(e, v, k) {
                        // (event, descriptor, value, keyboardShortcuts)
                        // moveFocus expects the target to be the .react-control which has the field id
                        e.currentTarget = $(e.currentTarget).parents(".react-control").get(0);
                        _onFocus && _onFocus(e, k);
                    },
                    onBlur: function onBlur(e) {
                        // (event, descriptor, value)
                        // moveFocus expects the target to be the .react-control which has the field id
                        e.currentTarget = $(e.currentTarget).parents(".react-control").get(0);
                        _onBlur && _onBlur(e);
                    },
                    onKeyDown: function onKeyDown(e) {
                        // (event, descriptor, value, isKeyboardShortcut)
                        _onKeyDown && _onKeyDown(e);
                    }
                };
                return _react2.default.createElement(_Checkbox2.default, _extends({
                    controlOnly: true
                }, columnProps));
            }
        });
    };

    return columnRecords.map(columnAddFn);
};

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var safeContextDispatch = function safeContextDispatch(context, payload, isStillNeeded) {
    if (_Dispatcher2.default.isDispatching()) {
        console.warn("deferred dispatch of " + payload.type);
        // eslint-disable-next-line no-settimeout
        setTimeout(function () {
            if (isStillNeeded == null || isStillNeeded()) {
                _Dispatcher2.default.contextDispatch(context, payload);
            }
        });
    } else {
        _Dispatcher2.default.contextDispatch(context, payload);
    }
};

exports.default = safeContextDispatch;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ModalLayout = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _GonkBoundary = __webpack_require__(635);

var _GonkBoundary2 = _interopRequireDefault(_GonkBoundary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalLayout = exports.ModalLayout = function (_React$Component) {
    _inherits(ModalLayout, _React$Component);

    function ModalLayout(props) {
        _classCallCheck(this, ModalLayout);

        var _this = _possibleConstructorReturn(this, (ModalLayout.__proto__ || Object.getPrototypeOf(ModalLayout)).call(this, props));

        _this.resizeBodyRef = _this.resizeBodyRef.bind(_this);
        return _this;
    }

    _createClass(ModalLayout, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                _props$modalOptions = _props.modalOptions,
                modalOptions = _props$modalOptions === undefined ? {} : _props$modalOptions,
                size = _props.size,
                children = _props.children,
                triggerClose = _props.triggerClose,
                moduleRef = _props.moduleRef;
            var title = this.props.title;

            if (title == null) title = modalOptions.title;
            var sizeClass = size == null ? modalOptions.size || "modal-xlg" : "modal-" + size;

            var body = void 0;

            if (children != null) {
                body = _react2.default.createElement(
                    _GonkBoundary2.default,
                    null,
                    _react2.default.createElement(
                        "div",
                        { className: "modal-body",
                            ref: this.resizeBodyRef
                        },
                        children
                    )
                );
            } else {
                body = _react2.default.createElement(
                    _GonkBoundary2.default,
                    null,
                    _react2.default.createElement("div", { className: "modal-body",
                        ref: function ref(n) {
                            if (n == null) return; // not mounted anymore...
                            _this2.resizeBodyRef(n, true);
                            // This allows a modal coming back to the top of the
                            // stack to dispatch during (re)initialization, even if
                            // the stack pop was triggered by a dispatch.
                            //
                            // eslint-disable-next-line no-settimeout
                            setTimeout(function () {
                                moduleRef.render();
                                $(n).html(moduleRef.el);
                                moduleRef.onDomRefresh();
                            });
                        }
                    })
                );
            }

            return _react2.default.createElement(
                "div",
                { className: "modal" },
                _react2.default.createElement(
                    "div",
                    { className: "modal-dialog " + sizeClass },
                    _react2.default.createElement(
                        "div",
                        { className: "modal-content" },
                        _react2.default.createElement(
                            "div",
                            { className: "modal-header",
                                ref: "header" },
                            _react2.default.createElement(
                                "button",
                                { type: "button", onClick: triggerClose, className: "modal-close" },
                                _react2.default.createElement("span", { "aria-hidden": "true" }),
                                _react2.default.createElement(
                                    "span",
                                    { className: "sr-only" },
                                    "Close"
                                )
                            ),
                            _react2.default.createElement(
                                "div",
                                { className: "modal-title" },
                                title
                            )
                        ),
                        body
                    )
                )
            );
        }
    }, {
        key: "resizeBodyRef",
        value: function resizeBodyRef(node) {
            var defaultBehaviour = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var resizeBodyOnRender = this.props.resizeBodyOnRender;

            if (resizeBodyOnRender == null) {
                resizeBodyOnRender = defaultBehaviour;
            }
            if (!resizeBodyOnRender) return;
            // An element needs to be visible
            // in order to read its dimensions
            var el = $(this.refs.header).clone().css("display", "none");
            $("body").append(el);
            var height = el.height();
            el.remove();

            $(node).css({
                position: "absolute",
                top: height + "px",
                bottom: "0px"
            });
        }
    }]);

    return ModalLayout;
}(_react2.default.Component);

ModalLayout.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]),
    moduleRef: _propTypes2.default.object,
    modalOptions: _propTypes2.default.shape({
        // these are ignored if the top-level props are set
        title: _propTypes2.default.string,
        size: _propTypes2.default.string // an arbitrary CSS class (or classes)
    }),
    title: _propTypes2.default.string,
    size: _propTypes2.default.string, // one of the bootstrap sizes: sm, md, lg, xlg
    triggerClose: _propTypes2.default.func.isRequired,
    resizeBodyOnRender: _propTypes2.default.bool // default true for BB modules, false otherwise
};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BackboneTestReauth = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.usePerms = usePerms;
exports.useOrgs = useOrgs;
exports.useArmusExists = useArmusExists;
exports.useImpls = useImpls;
exports.TestReauth = TestReauth;

var _BaseServices = __webpack_require__(76);

var _BaseServices2 = _interopRequireDefault(_BaseServices);

var _asModal = __webpack_require__(130);

var _asModal2 = _interopRequireDefault(_asModal);

var _promisify = __webpack_require__(97);

var _promisify2 = _interopRequireDefault(_promisify);

var _Form = __webpack_require__(642);

var _Form2 = _interopRequireDefault(_Form);

var _utils = __webpack_require__(644);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _InlineLoader = __webpack_require__(353);

var _InlineLoader2 = _interopRequireDefault(_InlineLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DbContext = _react2.default.createContext(undefined);

function usePerms() {
    return _react2.default.useContext(DbContext).perms;
}

function useOrgs() {
    return _react2.default.useContext(DbContext).orgs;
}

function useArmusExists() {
    var orgs = useOrgs();
    return _react2.default.useMemo(function () {
        return orgs.indexOf("armus") >= 0;
    }, [orgs]);
}

function useImpls() {
    return _react2.default.useContext(DbContext).impls;
}

function TestReauth(_ref) {
    var triggerClose = _ref.triggerClose;

    var cookie = _react2.default.useMemo(_utils.readCookie, []);

    var _React$useState = _react2.default.useState({}),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        database = _React$useState2[0],
        setDatabase = _React$useState2[1];

    _react2.default.useEffect(function () {
        (0, _promisify2.default)(_BaseServices2.default.getRequest("_/license_info")).then(function (db) {
            db.perms.unshift("ALL");
            db.perms.push("NONE");
            setDatabase(db);
        });
    }, []);

    function handleSave(spec) {
        (0, _utils.setCookie)(spec);
        window.location.reload();
    }

    return _react2.default.createElement(
        "div",
        {
            className: "reauth"
        },
        _react2.default.createElement(
            DbContext.Provider,
            { value: database },
            database.orgs ? _react2.default.createElement(_Form2.default, {
                cookie: cookie,
                onSave: handleSave,
                onCancel: triggerClose
            }) : _react2.default.createElement(_InlineLoader2.default, null)
        )
    );
}

TestReauth.propTypes = {
    triggerClose: _propTypes2.default.func.isRequired
};

var BackboneTestReauth = exports.BackboneTestReauth = (0, _asModal2.default)("Reauthorize")(TestReauth);

/***/ }),
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.STATUS_MESSAGE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formhelpers = __webpack_require__(5);

var _Core = __webpack_require__(902);

var _Core2 = _interopRequireDefault(_Core);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var STATUS_MESSAGE = exports.STATUS_MESSAGE = {
    EMPTY: "Nothing Found",
    PARTIAL: "Type what you're looking for; more choices available.",
    LOADING: "Refreshing options...",
    ERROR: "Error loading results; try again?"
};

var Typeahead = function (_React$Component) {
    _inherits(Typeahead, _React$Component);

    function Typeahead(props) {
        _classCallCheck(this, Typeahead);

        var _this = _possibleConstructorReturn(this, (Typeahead.__proto__ || Object.getPrototypeOf(Typeahead)).call(this, props));

        var debounceTime = props.debounceTime;

        _this.onSearch = _.debounce(_this.onSearch.bind(_this), debounceTime);
        return _this;
    }

    _createClass(Typeahead, [{
        key: "isServer",
        value: function isServer(props) {
            props = props || this.props;
            var descriptor = props.descriptor || {};
            var config = descriptor.config || {};
            return props.mode === "server" && config.otherEntityKey != null;
        }
    }, {
        key: "onSearch",
        value: function onSearch(searchText, sort) {
            var _props = this.props,
                onSearch = _props.onSearch,
                descriptor = _props.descriptor;

            onSearch && onSearch(descriptor, searchText, sort);
        }
    }, {
        key: "buildOptions",
        value: function buildOptions() {
            var _props2 = this.props,
                options = _props2.options,
                valueKey = _props2.valueKey,
                labelKey = _props2.labelKey,
                addMissing = _props2.addMissing,
                multiValued = _props2.multiValued;

            var optionsArr = [].concat(_toConsumableArray(options));
            if (addMissing && !multiValued) {
                var _optionsArr$unshift;

                optionsArr.unshift((_optionsArr$unshift = {}, _defineProperty(_optionsArr$unshift, valueKey, _Core.MISSING.VALUE), _defineProperty(_optionsArr$unshift, labelKey, _Core.MISSING.LABEL), _optionsArr$unshift));
                return optionsArr;
            }
            return optionsArr;
        }
    }, {
        key: "buildColumns",
        value: function buildColumns() {
            var _props3 = this.props,
                labelKey = _props3.labelKey,
                columns = _props3.columns;

            if (columns.length) {
                return columns;
            }
            // create a default column
            return [{
                key: labelKey,
                isSortable: false,
                includeInFilter: true,
                label: null
            }];
        }
    }, {
        key: "buildStatusMessage",
        value: function buildStatusMessage() {
            var _props4 = this.props,
                statusMessage = _props4.statusMessage,
                isLoading = _props4.isLoading,
                isPartial = _props4.isPartial,
                isError = _props4.isError;

            var status = statusMessage;
            if (this.isServer() && !status) {
                if (isPartial) {
                    status = STATUS_MESSAGE.PARTIAL;
                }
                if (isLoading) {
                    status = STATUS_MESSAGE.LOADING;
                }
                if (isError) {
                    status = STATUS_MESSAGE.ERROR;
                }
            }
            return status;
        }
    }, {
        key: "render",
        value: function render() {
            return _react2.default.createElement(_Core2.default, _extends({}, this.props, {
                onSearch: this.onSearch,
                options: this.buildOptions(),
                columns: this.buildColumns(),
                statusMessage: this.buildStatusMessage(),
                isServer: this.isServer()
            }));
        }
    }]);

    return Typeahead;
}(_react2.default.Component);

exports.default = Typeahead;


Typeahead.defaultProps = {
    debounceTime: 200,
    searchPageSize: 100,
    dropdownLength: 8,
    mode: "client",
    options: [],
    columns: [],
    multiValued: false,
    valueKey: "value",
    labelKey: "label",
    showRecordBrowserIcon: false,
    showSelectAll: false,
    autoSelectFirstItem: false,
    autoSelectOnlyOption: false,
    addMissing: false,
    keepSelectionInList: false
};

Typeahead.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)(), {
    onSearch: _propTypes2.default.func,
    onRecordbrowserClick: _propTypes2.default.func,

    // Value is assumed to be the inflated value(s) or null. Meaning an object
    // with {[valueKey]: ... , [labelKey]: ... } or array with those objects.
    // This is different from how the jQuery control worked which only supplied
    // the value string(s) and expected the inflated value to exist in the
    // options list.
    value: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.arrayOf(_propTypes2.default.object)]),

    options: _propTypes2.default.arrayOf(_propTypes2.default.object),
    columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        includeInFilter: _propTypes2.default.bool,
        isSortable: _propTypes2.default.bool,
        key: _propTypes2.default.string.isRequired,
        label: _propTypes2.default.string
    })).isRequired,

    mode: _propTypes2.default.oneOf(["client", "server"]),
    valueKey: _propTypes2.default.string.isRequired,
    labelKey: _propTypes2.default.string.isRequired,
    addMissing: _propTypes2.default.bool,
    multiValued: _propTypes2.default.bool,
    statusMessage: _propTypes2.default.string,
    autoSelectOnlyOption: _propTypes2.default.bool,
    autoSelectFirstItem: _propTypes2.default.bool,
    keepSelectionInList: _propTypes2.default.bool,
    showRecordBrowserIcon: _propTypes2.default.bool,
    showSelectAll: _propTypes2.default.bool,

    dropdownLength: _propTypes2.default.number,
    debounceTime: _propTypes2.default.number,
    searchPageSize: _propTypes2.default.number,

    // these are required for server lists
    isLoading: _propTypes2.default.bool,
    isPartial: _propTypes2.default.bool,
    isError: _propTypes2.default.bool
});

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NOW_KEY = exports.CALENDAR_KEY = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(366);

var _moment2 = _interopRequireDefault(_moment);

var _Input = __webpack_require__(215);

var _Input2 = _interopRequireDefault(_Input);

var _formhelpers = __webpack_require__(5);

var _entry = __webpack_require__(910);

var _entry2 = _interopRequireDefault(_entry);

var _DropdownWrapper = __webpack_require__(214);

var _DropdownWrapper2 = _interopRequireDefault(_DropdownWrapper);

var _keyEvents = __webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CALENDAR_KEY = exports.CALENDAR_KEY = "c";
var NOW_KEY = exports.NOW_KEY = "t";

var Calendar = function (_React$Component) {
    _inherits(Calendar, _React$Component);

    function Calendar(props) {
        _classCallCheck(this, Calendar);

        var _this = _possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call(this, props));

        _this.inputRef = _react2.default.createRef();
        _this.calendarButton = _react2.default.createRef();

        _this.onCalendarClick = _this.onCalendarClick.bind(_this);
        _this.onCalendarMouseDown = _this.onCalendarMouseDown.bind(_this);
        _this.onCalendarChange = _this.onCalendarChange.bind(_this);
        _this.onCommitChange = _this.onCommitChange.bind(_this);
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);

        _this.state = {
            showDatePicker: false,
            hasFocus: false
        };
        _this.clickedCalendar = false;

        // setup keyboard shortcuts
        _this.keyboardShortcuts = [{
            key: NOW_KEY,
            name: "Set to now"
        }];

        if (props.showCalendar) {
            _this.keyboardShortcuts.push({
                key: CALENDAR_KEY,
                name: "Show calendar"
            });
        }
        return _this;
    }

    _createClass(Calendar, [{
        key: "convertStringToMoment",
        value: function convertStringToMoment(value) {
            var maskFormat = this.props.maskFormat;

            if (value && value !== maskFormat.placeholder) {
                if (value != null && typeof value === "string" && value.length !== 0) {
                    // on commit check if the user entered a partial year...
                    // find year chunk in the mask.
                    var yearIndex = maskFormat.mask.indexOf("YYYY");
                    if (yearIndex !== -1) {
                        var m = (0, _moment2.default)(value, maskFormat.momentjs);
                        var fullYear = value.substr(yearIndex, 4);
                        var yearInt = parseInt(fullYear, 10) | 0;
                        var yearString = yearInt.toString();
                        if (yearString.length < 3) {
                            var today = new Date();
                            var digits = parseInt(today.getFullYear().toString().slice(2), 10);
                            //pad single
                            if (yearString.length === 1) {
                                yearString = "0" + yearString;
                            }
                            if (parseInt(yearInt, 10) <= digits) {
                                fullYear = "20" + yearString;
                            } else {
                                fullYear = "19" + yearString;
                            }
                            m.year(parseInt(fullYear, 10));
                            value = m.format(maskFormat.momentjs);
                        }
                    }
                }
                // convert value string to moment
                value = (0, _moment2.default)(value, maskFormat.momentjs);
            } else {
                value = null;
            }
            return value;
        }
    }, {
        key: "convertMomentToString",
        value: function convertMomentToString(value) {
            var maskFormat = this.props.maskFormat;

            if (value) {
                //convert Date to string
                var m = (0, _moment2.default)(value);
                return m.format(maskFormat.momentjs);
            }
            return null;
        }
    }, {
        key: "onCommitChange",
        value: function onCommitChange(descriptor, newValueStr) {
            var _props = this.props,
                onCommitChange = _props.onCommitChange,
                enabled = _props.enabled,
                value = _props.value;
            /*
             * Take note that this control only returns moment() objects.
             */

            var newValue = this.convertStringToMoment(newValueStr);
            if (this.state.showDatePicker) {
                this.setState({ showDatePicker: false });
            }
            if (newValueStr !== this.convertMomentToString(value)) {
                // TODO: Figure out why "Enter" key and blur fire two commit changes.
                // So far this issue does not seem to be causing any problems.
                // But it may be something to be aware of.

                // only commit change if the value actually changed.
                enabled && onCommitChange && onCommitChange(descriptor, newValue);
            }
            // convertStringToMoment fixes partial date strings.
            // this make sure the date input shows the actual string value being committed.
            // temporary until the next render comes around.
            this.inputRef.current.value = this.convertMomentToString(newValue);
        }
    }, {
        key: "onCalendarChange",
        value: function onCalendarChange(dateValue) {
            var _props2 = this.props,
                descriptor = _props2.descriptor,
                maskFormat = _props2.maskFormat;

            this.onCommitChange(descriptor, (0, _moment2.default)(dateValue).format(maskFormat.momentjs));
        }
    }, {
        key: "onCalendarMouseDown",
        value: function onCalendarMouseDown() {
            // This is to get ahead of the input blur/focus events. Allows us to not
            // bubble up the focus or blur event when the calendar is being clicked.
            // Gets us around the alert on Illegal/Warning values loop.
            this.clickedCalendar = true;
        }
    }, {
        key: "onCalendarClick",
        value: function onCalendarClick(e) {
            var _props3 = this.props,
                showCalendar = _props3.showCalendar,
                descriptor = _props3.descriptor,
                enabled = _props3.enabled;

            if (showCalendar && enabled && !this.state.showDatePicker) {
                // show calendar
                this.setState({ showDatePicker: true });
                this.onFocus(e, descriptor, this.inputRef.current.value);
                // refocus the input control
                this.inputRef.current.focus();
            }
        }
    }, {
        key: "onFocus",
        value: function onFocus(e, descriptor, v) {
            var _props4 = this.props,
                enabled = _props4.enabled,
                onFocus = _props4.onFocus,
                value = _props4.value;

            if (this.state.hasFocus) {
                return;
            } // already focused
            this.setState({ hasFocus: true });
            var newValue = this.convertStringToMoment(v);
            onFocus && onFocus(e, descriptor, enabled ? newValue : value, this.keyboardShortcuts);
        }
    }, {
        key: "onBlur",
        value: function onBlur(e, descriptor, v) {
            var _props5 = this.props,
                enabled = _props5.enabled,
                onBlur = _props5.onBlur,
                value = _props5.value;

            if (this.state.showDatePicker || this.clickedCalendar) {
                // date picker is closing or being opened
                // don't blur, instead refocus the input
                this.inputRef.current.focus();
                this.clickedCalendar = false;
                return;
            }
            this.clickedCalendar = false;
            this.setState({ hasFocus: false });
            var newValue = this.convertStringToMoment(v);
            onBlur && onBlur(e, descriptor, enabled ? newValue : value);
        }
    }, {
        key: "onKeyDown",
        value: function onKeyDown(e, d, value) {
            var _props6 = this.props,
                descriptor = _props6.descriptor,
                showCalendar = _props6.showCalendar,
                onKeyDown = _props6.onKeyDown,
                enabled = _props6.enabled,
                maskFormat = _props6.maskFormat;

            var isKeyboardShortcut = false;
            if (enabled) {
                var isModifier = e.ctrlKey || e.altKey || e.metaKey;
                var key = (0, _keyEvents.processKeyName)(e.key);
                if (showCalendar && key === CALENDAR_KEY && !isModifier) {
                    // CALENDAR_KEY: only show the date picker dropdown.
                    this.onCalendarClick(e);
                } else if (key === NOW_KEY) {
                    // NOW_KEY: commit and move focus
                    isKeyboardShortcut = true;
                    this.onCommitChange(descriptor, (0, _moment2.default)(new Date()).format(maskFormat.momentjs));
                }
                onKeyDown && onKeyDown(e, descriptor, this.convertStringToMoment(value), isKeyboardShortcut);
            }
        }
    }, {
        key: "getCurrentDate",
        value: function getCurrentDate() {
            if (this.state.showDatePicker) {
                var dirtyValue = this.inputRef.current.value;
                if (dirtyValue && !isNaN(parseFloat(dirtyValue.charAt(0)))) {
                    return (0, _moment2.default)(this.inputRef.current.value, this.props.maskFormat.momentjs).toDate();
                }
            }
            return new Date();
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props7 = this.props,
                maskFormat = _props7.maskFormat,
                showCalendar = _props7.showCalendar,
                controlOnly = _props7.controlOnly,
                icon = _props7.icon,
                value = _props7.value;

            var inputGroupStyle = controlOnly ? {} : { width: (maskFormat.mask.length + (showCalendar ? 3 : 0) + 2) * 0.8 + "em" };
            var hasFocus = this.state.hasFocus;

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    "div",
                    { className: showCalendar || icon ? "input-group" : "", style: inputGroupStyle },
                    _react2.default.createElement(_Input2.default, _extends({
                        _ref: this.inputRef
                    }, this.props, {
                        onCommitChange: this.onCommitChange,
                        onBlur: this.onBlur,
                        onFocus: this.onFocus,
                        onKeyDown: this.onKeyDown,
                        value: this.convertMomentToString(value),
                        valueType: "string",
                        maskFormat: maskFormat,
                        focused: hasFocus
                    })),
                    (showCalendar || icon) && _react2.default.createElement(
                        "span",
                        {
                            ref: this.calendarButton,
                            onClick: this.onCalendarClick,
                            onMouseDown: this.onCalendarMouseDown,
                            className: "calendar-button input-group-addon"
                        },
                        _react2.default.createElement("span", { className: "glyphicon glyphicon-" + (icon ? icon : "calendar") + " icon-calendar" })
                    )
                ),
                this.state.showDatePicker && _react2.default.createElement(
                    _DropdownWrapper2.default,
                    {
                        targetRef: this.calendarButton,
                        autoSize: false,
                        align: "left",
                        ignoreClickSelector: ".calendar-container",
                        onHide: function onHide() {
                            _this2.setState({ showDatePicker: false });
                        }
                    },
                    _react2.default.createElement(
                        "div",
                        { className: "calendar-container" },
                        _react2.default.createElement(_entry2.default, {
                            onChange: this.onCalendarChange,
                            minDetail: "decade",
                            calendarType: "US",
                            showFixedNumberOfWeeks: true,
                            formatMonth: function formatMonth(locale, date) {
                                return (0, _moment2.default)(date).format("MMM");
                            },
                            formatShortWeekday: function formatShortWeekday(locale, date) {
                                return (0, _moment2.default)(date).format("dd");
                            },
                            minDate: new Date("01/01/1850"),
                            maxDate: new Date("01/01/2100"),
                            value: this.getCurrentDate()
                        })
                    )
                )
            );
        }
    }]);

    return Calendar;
}(_react2.default.Component);

exports.default = Calendar;


Calendar.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)({
    granularity: _propTypes2.default.string
}), {
    maskFormat: _propTypes2.default.object.isRequired,
    showCalendar: _propTypes2.default.bool.isRequired,
    controlOnly: _propTypes2.default.bool,
    icon: _propTypes2.default.string
});

/***/ }),
/* 293 */,
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _DateInput = __webpack_require__(292);

var _DateInput2 = _interopRequireDefault(_DateInput);

var _formhelpers = __webpack_require__(5);

var _MaskConstants = __webpack_require__(219);

var _MaskConstants2 = _interopRequireDefault(_MaskConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Calendar = function (_React$Component) {
    _inherits(Calendar, _React$Component);

    function Calendar() {
        _classCallCheck(this, Calendar);

        return _possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).apply(this, arguments));
    }

    _createClass(Calendar, [{
        key: "render",
        value: function render() {
            var descriptor = this.props.descriptor;
            var granularity = descriptor.config.granularity;


            var format = _MaskConstants2.default.armus_datetime_second;
            var showCalendar = true;
            if (granularity === "SECOND") {
                format = _MaskConstants2.default.armus_datetime_second;
                showCalendar = true;
            } else if (granularity === "MINUTE") {
                format = _MaskConstants2.default.armus_datetime_minute;
                showCalendar = true;
            } else if (granularity === "HOUR") {
                format = _MaskConstants2.default.armus_datetime_hour;
                showCalendar = true;
            } else if (granularity === "DAY") {
                format = _MaskConstants2.default.armus_date_day;
                showCalendar = true;
            } else if (granularity === "MONTH") {
                format = _MaskConstants2.default.armus_date_month;
                showCalendar = true;
            } else if (granularity === "YEAR") {
                format = _MaskConstants2.default.armus_date_year;
                showCalendar = true;
            }

            return _react2.default.createElement(
                _ControlTemplate2.default,
                _extends({}, this.props, { className: "datetime-field" }),
                _react2.default.createElement(_DateInput2.default, _extends({}, this.props, {
                    maskFormat: format,
                    showCalendar: showCalendar
                }))
            );
        }
    }]);

    return Calendar;
}(_react2.default.Component);

exports.default = Calendar;


Calendar.propTypes = (0, _formhelpers.controlPropTypes)({
    granularity: _propTypes2.default.string
});

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _formhelpers = __webpack_require__(5);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Label = function (_React$Component) {
    _inherits(Label, _React$Component);

    function Label() {
        _classCallCheck(this, Label);

        return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
    }

    _createClass(Label, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                descriptor = _props.descriptor,
                value = _props.value;

            var valueStr = ArmusScript["dateFormat(Date,String)"](value, descriptor.config.mask) || "";
            return _react2.default.createElement(
                _ControlTemplate2.default,
                _extends({}, this.props, { className: "datetime-field" }),
                _react2.default.createElement(
                    "span",
                    null,
                    valueStr
                )
            );
        }
    }]);

    return Label;
}(_react2.default.Component);

exports.default = Label;


Label.propTypes = (0, _formhelpers.controlPropTypes)({
    mask: _propTypes2.default.string.isRequired
});

/***/ }),
/* 296 */,
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _FileField = __webpack_require__(466);

var _FileField2 = _interopRequireDefault(_FileField);

var _formhelpers = __webpack_require__(5);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Manager = function (_React$Component) {
    _inherits(Manager, _React$Component);

    function Manager() {
        _classCallCheck(this, Manager);

        return _possibleConstructorReturn(this, (Manager.__proto__ || Object.getPrototypeOf(Manager)).apply(this, arguments));
    }

    _createClass(Manager, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                _ControlTemplate2.default,
                _extends({}, this.props, { className: "file-field" }),
                _react2.default.createElement(_FileField2.default, this.props)
            );
        }
    }]);

    return Manager;
}(_react2.default.Component);

exports.default = Manager;


Manager.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)({ multiValued: _propTypes2.default.bool }), {

    files: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        filename: _propTypes2.default.string.isRequired,
        status: _propTypes2.default.string.isRequired,
        progress: _propTypes2.default.number.isRequired,
        filesize: _propTypes2.default.number.isRequired
    })),

    onFileOpen: _propTypes2.default.func,
    onFileRemove: _propTypes2.default.func,

    // file control properties
    multiValued: _propTypes2.default.bool,

    // html control event methods
    onFileUpload: _propTypes2.default.func.isRequired
});

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Text;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _Input = __webpack_require__(215);

var _Input2 = _interopRequireDefault(_Input);

var _formhelpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Text(props) {
    return _react2.default.createElement(
        _ControlTemplate2.default,
        _extends({}, props, { className: "string-field" }),
        _react2.default.createElement(_Input2.default, _extends({}, props, {
            valueType: "string"
        }))
    );
}

Text.propTypes = (0, _formhelpers.controlPropTypes)();

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _Textarea = __webpack_require__(948);

var _Textarea2 = _interopRequireDefault(_Textarea);

var _formhelpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Textarea = function (_React$Component) {
    _inherits(Textarea, _React$Component);

    function Textarea() {
        _classCallCheck(this, Textarea);

        return _possibleConstructorReturn(this, (Textarea.__proto__ || Object.getPrototypeOf(Textarea)).apply(this, arguments));
    }

    _createClass(Textarea, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                _ControlTemplate2.default,
                _extends({}, this.props, { className: "string-field textarea" }),
                _react2.default.createElement(_Textarea2.default, this.props)
            );
        }
    }]);

    return Textarea;
}(_react2.default.Component);

exports.default = Textarea;


Textarea.propTypes = (0, _formhelpers.controlPropTypes)();

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _formhelpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Label = function (_React$Component) {
    _inherits(Label, _React$Component);

    function Label() {
        _classCallCheck(this, Label);

        return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
    }

    _createClass(Label, [{
        key: "render",
        value: function render() {
            var value = this.props.value;

            return _react2.default.createElement(
                _ControlTemplate2.default,
                _extends({}, this.props, { className: "string-field" }),
                _react2.default.createElement(
                    "span",
                    null,
                    value
                )
            );
        }
    }]);

    return Label;
}(_react2.default.Component);

exports.default = Label;


Label.propTypes = (0, _formhelpers.controlPropTypes)();

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _formhelpers = __webpack_require__(5);

var _Button = __webpack_require__(52);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Button = function (_React$Component) {
    _inherits(Button, _React$Component);

    function Button() {
        _classCallCheck(this, Button);

        return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
    }

    _createClass(Button, [{
        key: "render",
        value: function render() {
            var descriptor = this.props.descriptor;

            return _react2.default.createElement(
                _ControlTemplate2.default,
                _extends({}, this.props, {
                    descriptor: _extends({}, descriptor, { label: "" }),
                    className: "",
                    extraProps: {
                        "data-widget-label": descriptor.label
                    }
                }),
                _react2.default.createElement(_Button2.default, _extends({
                    label: descriptor.label,
                    value: descriptor.label
                }, this.props))
            );
        }
    }]);

    return Button;
}(_react2.default.Component);

exports.default = Button;


Button.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)(null, false), {
    onCommitChange: _propTypes2.default.func
});

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PropTypeError = PropTypeError;
exports.createChainableTypeChecker = createChainableTypeChecker;
exports.getClassName = getClassName;
//////////////////////////////////////////////////////////////////////
// This file is taken directly from the `prop-types` library's
// internals, so that our custom checkers can work the same as the
// standard ones. It's not ideal, but they don't expose these details
// via module exports, so we have to duplicate...
//////////////////////////////////////////////////////////////////////

var ANONYMOUS = "<<anonymous>>";

/**
 * We use an Error-like object for backward compatibility as people may call
 * PropTypes directly and inspect their output. However, we don't use real
 * Errors anymore. We don't inspect their stack anyway, and creating them
 * is prohibitively expensive if they are created too often, such as what
 * happens in oneOfType() for any type before the one that matched.
 */
function PropTypeError(message) {
    this.message = message;
    this.stack = "";
}

// Make `instanceof Error` still work for returned errors.
PropTypeError.prototype = Error.prototype;

function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;

        if (props[propName] == null) {
            if (isRequired) {
                if (props[propName] === null) {
                    return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `null`.");
                }
                return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `undefined`.");
            }
            return null;
        } else {
            return validate(props, propName, componentName, location, propFullName);
        }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
}

// Returns class name of the object, if any.
function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
    }
    return propValue.constructor.name;
}

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var recordLabel = function recordLabel(info, instance) {
    if (!info.scripts.hasOwnProperty("toString")) {
        return "Unknown " + info.label;
    }
    var label = info.scripts.toString(instance);
    return label == null ? "NULL" : label;
};

exports.default = recordLabel;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rehydrate = exports.dehydrate = exports.dehydrateField = undefined;

var _TableColumnMetaStore = __webpack_require__(125);

var _TableColumnMetaStore2 = _interopRequireDefault(_TableColumnMetaStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dehydrateField = exports.dehydrateField = function dehydrateField(v, t) {
    if (v == null) {
        return null;
    } else if (t === "ASSOCIATION" || t === "FILE") {
        return _.isArray(v) ? v.slice() : v;
    } else if (t === "DECIMAL") {
        // todo: should already be a string
        return v.toString();
    } else if (t === "DATE") {
        return [v.year(), v.month() + 1, v.date()];
    } else if (t === "TIME") {
        return [v.hours(), v.minutes(), v.seconds()];
    } else if (t === "DATETIME") {
        return [v.year(), v.month() + 1, v.date(), v.hours(), v.minutes(), v.seconds()];
    } else if (t === "TZTIMESTAMP") {
        return v.valueOf();
    } else if (t === "INTERVAL") {
        var parts = [v.years(), v.months(), v.days(), v.hours(), v.minutes(), v.seconds()];
        if (parts[0] === 0 && parts[1] === 0 && parts[2] === 0) {
            parts.splice(0, 3);
        }
        return parts;
    } else {
        return v;
    }
}; /*
    * I move from wire to application representations of data and back. These
    * functions correspond to LogicalRecord's dehydrate and rehydrate (where they
    * got their names).
    */

var dehydrate = exports.dehydrate = function dehydrate(data, tableKey) {
    var columnInfos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _TableColumnMetaStore2.default.getAllColumnsByName(tableKey);

    var result = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = Object.keys(columnInfos)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var n = _step.value;

            result[n] = dehydrateField(data[n], columnInfos[n].type);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return result;
};

/**
 * I convert from the wire format to data as the application stores it.
 *
 * @param data The wire data to convert
 * @param tableKey The key of the table whose data it is
 * @param columnInfos Optional columnInfo; if omitted it'll be auto-obtained
 */
var rehydrate = exports.rehydrate = function rehydrate(data, tableKey) {
    var includeInverses = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var columnInfos = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _TableColumnMetaStore2.default.getAllColumnsByName(tableKey);

    var parts = void 0;
    var trans = {};
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = Object.keys(columnInfos)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var n = _step2.value;

            var info = columnInfos[n];
            if (!includeInverses && info.inverse) continue;
            var t = info.type;
            if (data[n] == null) {
                trans[n] = info.multiValued ? [] : null;
            } else if (t === "ASSOCIATION" || t === "FILE") {
                trans[n] = _.isArray(data[n]) ? data[n].slice() : data[n];
            } else if (t === "DECIMAL") {
                trans[n] = typeof data[n] === "string" ? isNaN(parseFloat(data[n])) ? null : data[n] : data[n];
            } else if (t === "DATE") {
                parts = [].concat(data[n]);
                parts[1]--;
                // zero-indexed months
                trans[n] = moment(parts);
            } else if (t === "TIME") {
                trans[n] = moment([1970, 0, 1].concat(data[n]));
            } else if (t === "DATETIME") {
                parts = [].concat(data[n]);
                parts[1]--;
                // zero-indexed months
                trans[n] = moment(parts);
            } else if (t === "TZTIMESTAMP") {
                trans[n] = moment(data[n]);
            } else if (t === "INTERVAL") {
                var s = [].concat(data[n]);
                if (s.length === 7) {
                    s[3] += 7 * s[2];
                    // move weeks to days
                    s.splice(3, 1);
                } else if (s.length === 3) {
                    s = [0, 0, 0].concat(s);
                }
                // add date parts
                while (s.length < 6) {
                    s.push(0);
                }
                trans[n] = moment.duration({
                    years: s[0],
                    months: s[1],
                    days: s[2],
                    hours: s[3],
                    minutes: s[4],
                    seconds: s[5] });
            } else {
                trans[n] = data[n];
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return trans;
};

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _stereotypes = __webpack_require__(126);

var _utils = __webpack_require__(175);

var _recordLabel = __webpack_require__(303);

var _recordLabel2 = _interopRequireDefault(_recordLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StereotypeProxy = function () {
    function StereotypeProxy(access, keyOrInfo, id) {
        _classCallCheck(this, StereotypeProxy);

        if (keyOrInfo.hasOwnProperty("key")) {
            this.stereoInfo = keyOrInfo;
            this.stereoKey = this.stereoInfo.key;
        } else {
            this.stereoKey = keyOrInfo;
            this.stereoInfo = _StereotypesStore2.default.getStereotypeByKey(this.stereoKey);
        }
        this.access = access;
        this.id = id;
    }

    _createClass(StereotypeProxy, [{
        key: "getAttributeType",
        value: function getAttributeType(field) {
            return (0, _StereotypesStore.getFieldType)(this.stereoInfo, field);
        }
    }, {
        key: "get",
        value: function get(field) {
            var _this = this;

            var self = this;
            // get record implementations
            var impls = (0, _stereotypes.getImplementations)(this.stereoInfo, this.access, self.id);
            impls = this.entityContext ? impls.filter(function (impl) {
                return (0, _utils.getKeyPrefix)(impl.key) === _this.entityContext;
            }) : impls;
            var values = _.compact(impls.map(function (impl) {
                var fi = impl.fieldImpls.find(function (fi) {
                    return fi.key === field;
                });
                if (fi == null) return null;
                return fi.script(self.access.getEntityProxy(impl.key, self.id));
            }));
            if (_.isEmpty(values)) return null;
            return values.sort()[0];
        }
    }, {
        key: "getKey",
        value: function getKey() {
            return this.stereoKey + "#" + this.id;
        }
    }, {
        key: "equals",
        value: function equals(o) {
            if (o == null) return false;
            if (!(o instanceof StereotypeProxy)) return false;
            if (this.stereoKey !== o.stereoKey) return false;
            if (this.id !== o.id) return false;
            return true;
        }
    }, {
        key: "getLabel",
        value: function getLabel() {
            return (0, _recordLabel2.default)(this.stereoInfo, this);
        }
    }, {
        key: "getDetailString",
        value: function getDetailString() {
            if (this.stereoInfo.scripts.hasOwnProperty("toDetailString")) {
                return this.stereoInfo.scripts.toDetailString(this);
            }
            return null;
        }
    }, {
        key: "withEntityContext",
        value: function withEntityContext(entityKey) {
            this.entityContext = (0, _utils.getKeyPrefix)(entityKey);
        }
    }]);

    return StereotypeProxy;
}();

exports.default = StereotypeProxy;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _FieldSetPreferenceCache = __webpack_require__(482);

var _FieldSetPreferenceCache2 = _interopRequireDefault(_FieldSetPreferenceCache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _FieldSetPreferenceCache2.default(_Dispatcher2.default, "user-hidden-fields");

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var FormActions = {
    START_LOAD: "form/start-load",
    LOADED: "form/loaded",
    LOAD_ERROR: "form/load-error"
};

exports.default = FormActions;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var AdtActions = {
    SEARCH: "adt/search",
    SEARCH_RESULT: "adt/search-result",
    SEARCH_ERROR: "adt/search-error"
};

exports.default = AdtActions;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var HemoActions = {
    SEARCH: "hemo/search",
    SEARCH_RESULT: "hemo/search-result",
    SEARCH_ERROR: "hemo/search-error"
};

exports.default = HemoActions;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var EcmoEmrActions = {
    SEARCH: "ecmoemr/search",
    SEARCH_RESULT: "ecmoemr/search-result",
    SEARCH_ERROR: "ecmoemr/search-error"
};

exports.default = EcmoEmrActions;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMappingPlugins = undefined;

var _resolver = __webpack_require__(964);

var _resolver2 = _interopRequireDefault(_resolver);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CROSS_APP_KEY = "cross-app";

var getMappingPlugins = exports.getMappingPlugins = function getMappingPlugins(activeRecord, fluxContext) {
    var sources = activeRecord.entityInfo.mappingSources;
    if (sources == null) return [];

    return filterSources(activeRecord, sources).map(function (s) {
        return (0, _resolver2.default)(s.pluginKey, {
            activeRecord: activeRecord,
            fluxContext: fluxContext,
            mapping: s,
            org: _userStore2.default.getActiveOrgKey()
        });
    });
};

function filterSources(activeRecord, sources) {
    var allowedSources = sources;
    if (!hasCrossAppMappingPermission(activeRecord)) {
        allowedSources = sources.filter(function (s) {
            return s.pluginKey !== CROSS_APP_KEY;
        });
    }

    return allowedSources;
}

function hasCrossAppMappingPermission(activeRecord) {
    var implKey = activeRecord && activeRecord.entityKey ? new _EntityName2.default(activeRecord.entityKey).implKey : false;
    if (!implKey) {
        return false;
    }
    return _userStore2.default.canCrossAppMap(implKey);
}

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(13);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _storeUtils = __webpack_require__(54);

var _CrossAppActions = __webpack_require__(313);

var _CrossAppActions2 = _interopRequireDefault(_CrossAppActions);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _dotPropImmutable = __webpack_require__(40);

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _DataManager = __webpack_require__(43);

var _DataManager2 = _interopRequireDefault(_DataManager);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _TableAccess = __webpack_require__(77);

var _TableAccess2 = _interopRequireDefault(_TableAccess);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _MapDialogActions = __webpack_require__(64);

var _MapDialogActions2 = _interopRequireDefault(_MapDialogActions);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _EntityProxy = __webpack_require__(31);

var _SuperRecordListStore = __webpack_require__(155);

var _SuperRecordListStore2 = _interopRequireDefault(_SuperRecordListStore);

var _SuperRecordActions = __webpack_require__(25);

var _Q = __webpack_require__(176);

var _Q2 = _interopRequireDefault(_Q);

var _infoTypeToFieldType = __webpack_require__(221);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _getPagination = function _getPagination(state, query) {
    return state.pagination && state.pagination.hasOwnProperty(query) ? state.pagination[query] : {
        page: 1,
        pageCount: 0,
        pageSize: 25,
        totalResultCount: 0
    };
};

var getQueryLO = function getQueryLO(state, query) {
    return state.queries.hasOwnProperty(query) ? state.queries[query] : _LoadObject2.default.empty();
};

var idsToRecordsBuilder = function idsToRecordsBuilder(state, entityKey) {
    var access = new _TableAccess2.default(state);
    return function (ids) {
        return ids.map(function (id) {
            return access.getEntityProxy(entityKey, id);
        });
    };
};

var CrossAppStore = function (_ReduceStore) {
    _inherits(CrossAppStore, _ReduceStore);

    function CrossAppStore() {
        _classCallCheck(this, CrossAppStore);

        return _possibleConstructorReturn(this, (CrossAppStore.__proto__ || Object.getPrototypeOf(CrossAppStore)).call(this, _Dispatcher2.default));
    }

    _createClass(CrossAppStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {
                tables: {},
                queries: {},
                pagination: {}
            };
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {

                case _CrossAppActions2.default.SEARCH:
                    {
                        var lo = getQueryLO(state, action.query);
                        var entityNameBits = action.entity.split("/");
                        var impl = entityNameBits[0];
                        var version = entityNameBits[1];
                        var entity = entityNameBits[2];
                        return _dotPropImmutable2.default.set(state, ["queries", action.query], lo.loading(_DataManager2.default.crossAppSearch(_userStore2.default.getActiveOrgKey(), action.stereotype, impl, version, entity, action.query, action.page, action.pageSize, action.interactive)));
                    }

                case _CrossAppActions2.default.SEARCH_RESULT:
                    {
                        // add response pagination info
                        var newState = _dotPropImmutable2.default.set(state, ["pagination", action.query], {
                            page: action.data.page,
                            pageCount: action.data.pageCount,
                            pageSize: action.data.pageSize,
                            query: action.data.query,
                            totalResultCount: action.data.totalResultCount
                        });
                        var access = new _TableAccess2.default(newState);
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = action.data.results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var result = _step.value;

                                this.doAutomanagement(result);
                                access.loadSuperRecordPacket(result, action.impl + "/" + action.version);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        return _dotPropImmutable2.default.set(access.getState(), ["queries", action.query], function (lo) {
                            return lo.setValue(action.data.results.map(function (it) {
                                return it.id;
                            })).done();
                        });
                    }

                case _CrossAppActions2.default.SEARCH_ERROR:
                    {
                        return _dotPropImmutable2.default.set(state, ["queries", action.query], function (lo) {
                            return lo.setError(action.error).done();
                        });
                    }

                case _MapDialogActions2.default.SELECT_PLUGIN:
                    {
                        return this.getInitialState(); // per Helen's decree
                    }

                case _MapDialogActions2.default.SELECT_STEREOTYPE:
                    {
                        return this.getInitialState();
                    }

                default:
                    return state;
            }
        }
    }, {
        key: "getPagination",
        value: function getPagination(query) {
            return _getPagination(this.getState(), query);
        }
    }, {
        key: "getColdLO",
        value: function getColdLO(query, entity) {
            return getQueryLO(this.getState(), query).map(idsToRecordsBuilder(this.getState(), entity));
        }
    }, {
        key: "getHotLO",
        value: function getHotLO(query, params, stereotype, entity, interactive) {
            var _this2 = this;

            var page = params.pagenumber !== "undefined" ? params.pagenumber : null;
            var pageSize = params.pagesize !== "undefined" ? params.pagesize : null;

            return (0, _storeUtils.hotLoadObject)(function () {
                return getQueryLO(_this2.getState(), query);
            }, function () {
                return _Dispatcher2.default.dispatch({
                    type: _CrossAppActions2.default.SEARCH,
                    query: query,
                    interactive: interactive,
                    stereotype: stereotype,
                    entity: entity,
                    page: page,
                    pageSize: pageSize
                });
            }, function (lo) {
                return interactive || lo.isEmpty();
            }).map(idsToRecordsBuilder(this.getState(), entity));
        }

        // for automanaged fields mapping requires that the ids of the assocaited records are within the set of available ids in the local
        // records for this hybrid instance, but with cross-app mapping the sources records are not from the local instance
        // so we need to look up the associated records by their key fields and set the ids accordingly before loading the records
        // this is a best-effort approach and will throw an error if no match is found

    }, {
        key: "doAutomanagement",
        value: function doAutomanagement(packet) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Object.keys(packet.tables)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var tableKey = _step2.value;

                    //const table = packet.tables[tableKey];
                    var entityInfos = _entityMetaStore2.default.getInfosForLogicalTable(tableKey);
                    var access = new _TableAccess2.default(_TableStore2.default.getState());
                    var autoManageByColumn = this.buildFieldInfosByColumn(entityInfos, _EntityProxy.isAutoManaged);
                    if (Object.keys(autoManageByColumn).length > 0) {
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                            for (var _iterator3 = Object.values(autoManageByColumn)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var fis = _step3.value;

                                var _loop = function _loop(fieldInfo) {
                                    var mfi = _entityFieldMetaStore2.default.getInfo(fieldInfo.otherEntityKey, fieldInfo.autoManageKey);

                                    // parent entity info - we're going to need this later for the stored in table 
                                    var pEK = mfi.entityKey;
                                    var parentInfo = _entityMetaStore2.default.getInfo(pEK);

                                    // global entity info
                                    var gEK = mfi.otherEntityKey;
                                    var targetGlobalsLO = (0, _SuperRecordActions.clientFilteredList)(_SuperRecordListStore2.default, access, gEK);
                                    if (!targetGlobalsLO.hasValue()) return {
                                            v: void 0
                                        };
                                    // get the entire list of global candidates for the field
                                    var targetGlobals = targetGlobalsLO.getValueEnforcing();

                                    // get the key fields to match the source and target on
                                    var globalInfo = _entityMetaStore2.default.getInfo(gEK);
                                    var keyFields = globalInfo.keys ? globalInfo.keys[0].fieldKeys : [];

                                    // parent source record table
                                    // add it if it doesn't exist otherwise things will fall over in access.loadSuperRecordPacket
                                    if (!packet.tables.hasOwnProperty(parentInfo.tableKey)) {
                                        packet.tables[parentInfo.tableKey] = {};
                                    }
                                    var pSourceRecordTable = packet.tables[parentInfo.tableKey];

                                    // global source record table
                                    // add it if it doesn't exist otherwise things will fall over in access.loadSuperRecordPacket
                                    if (!packet.tables.hasOwnProperty(globalInfo.tableKey)) {
                                        packet.tables[globalInfo.tableKey] = {};
                                    }
                                    var gSourceRecordTable = packet.tables[globalInfo.tableKey];

                                    // iterate through the sources and find the matching target

                                    var _loop2 = function _loop2(gSourceRecordKey) {
                                        var gSourceRecord = gSourceRecordTable[gSourceRecordKey];
                                        var query = _Q2.default.conjunction(keyFields.map(function (fn) {
                                            return _entityFieldMetaStore2.default.getInfo( // switch to fieldInfo
                                            mfi.otherEntityKey, fn);
                                        }).filter(function (fi) {
                                            return fi.type !== "FileField";
                                        }) // exclude file fields
                                        .map(function (fi) {
                                            return _Q2.default.ref(fi.key).eq(_Q2.default.value(gSourceRecord[fi.key], (0, _infoTypeToFieldType.infoTypeToFieldType)(fi.type)));
                                        }));
                                        var targetGlobal = targetGlobals.find(query.test);
                                        if (targetGlobal == null) {
                                            throw new Error("No " + globalInfo.tableKey + " match found for " + gSourceRecord._id);
                                        }
                                        // update the source table map and the gSourceRecord _id to match the target
                                        gSourceRecord._id = targetGlobal.id;
                                        gSourceRecordTable[targetGlobal.id] = gSourceRecord;

                                        delete gSourceRecordTable[gSourceRecordKey];

                                        // now find the parent record referencing the replaced global id and update it as well.
                                        var _iteratorNormalCompletion7 = true;
                                        var _didIteratorError7 = false;
                                        var _iteratorError7 = undefined;

                                        try {
                                            for (var _iterator7 = Object.keys(pSourceRecordTable)[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                                                var pSourceRecordKey = _step7.value;

                                                var pSourceRecord = pSourceRecordTable[pSourceRecordKey];
                                                if (pSourceRecord[mfi.logicalColumn].toString() === gSourceRecordKey) {
                                                    pSourceRecord[mfi.logicalColumn] = targetGlobal.id;
                                                }
                                            }
                                        } catch (err) {
                                            _didIteratorError7 = true;
                                            _iteratorError7 = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                                    _iterator7.return();
                                                }
                                            } finally {
                                                if (_didIteratorError7) {
                                                    throw _iteratorError7;
                                                }
                                            }
                                        }
                                    };

                                    var _iteratorNormalCompletion5 = true;
                                    var _didIteratorError5 = false;
                                    var _iteratorError5 = undefined;

                                    try {
                                        for (var _iterator5 = Object.keys(gSourceRecordTable)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                            var gSourceRecordKey = _step5.value;

                                            _loop2(gSourceRecordKey);
                                        }

                                        // After processing existing records, add any targetGlobals that are missing from gSourceRecordTable
                                    } catch (err) {
                                        _didIteratorError5 = true;
                                        _iteratorError5 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                                _iterator5.return();
                                            }
                                        } finally {
                                            if (_didIteratorError5) {
                                                throw _iteratorError5;
                                            }
                                        }
                                    }

                                    var _iteratorNormalCompletion6 = true;
                                    var _didIteratorError6 = false;
                                    var _iteratorError6 = undefined;

                                    try {
                                        for (var _iterator6 = targetGlobals[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                            var _targetGlobal = _step6.value;

                                            if (!gSourceRecordTable.hasOwnProperty(_targetGlobal.id)) {
                                                // Add the targetGlobal to gSourceRecordTable
                                                var globalRecord = {
                                                    _id: _targetGlobal.id
                                                };
                                                // Copy all field values from the targetGlobal EntityProxy
                                                var _iteratorNormalCompletion8 = true;
                                                var _didIteratorError8 = false;
                                                var _iteratorError8 = undefined;

                                                try {
                                                    for (var _iterator8 = keyFields[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                                                        var fieldKey = _step8.value;

                                                        var _fieldInfo = _entityFieldMetaStore2.default.getInfo(gEK, fieldKey);
                                                        if (_fieldInfo) {
                                                            globalRecord[_fieldInfo.key] = _targetGlobal.get(_fieldInfo.key);
                                                        }
                                                    }
                                                } catch (err) {
                                                    _didIteratorError8 = true;
                                                    _iteratorError8 = err;
                                                } finally {
                                                    try {
                                                        if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                                            _iterator8.return();
                                                        }
                                                    } finally {
                                                        if (_didIteratorError8) {
                                                            throw _iteratorError8;
                                                        }
                                                    }
                                                }

                                                gSourceRecordTable[_targetGlobal.id] = globalRecord;

                                                // Add a corresponding parent record to pSourceRecordTable
                                                // Generate a new ID for the parent record
                                                var newParentId = -(Date.now() + Math.floor(Math.random() * 10000));
                                                pSourceRecordTable[newParentId] = _defineProperty({
                                                    _id: newParentId
                                                }, mfi.logicalColumn, _targetGlobal.id);
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError6 = true;
                                        _iteratorError6 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                                _iterator6.return();
                                            }
                                        } finally {
                                            if (_didIteratorError6) {
                                                throw _iteratorError6;
                                            }
                                        }
                                    }
                                };

                                var _iteratorNormalCompletion4 = true;
                                var _didIteratorError4 = false;
                                var _iteratorError4 = undefined;

                                try {
                                    for (var _iterator4 = fis[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                        var fieldInfo = _step4.value;

                                        var _ret = _loop(fieldInfo);

                                        if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
                                    }
                                } catch (err) {
                                    _didIteratorError4 = true;
                                    _iteratorError4 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                            _iterator4.return();
                                        }
                                    } finally {
                                        if (_didIteratorError4) {
                                            throw _iteratorError4;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    }, {
        key: "buildFieldInfosByColumn",
        value: function buildFieldInfosByColumn(entityInfos) {
            var optionalFieldFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var fieldInfosByColumn = {};
            var _iteratorNormalCompletion9 = true;
            var _didIteratorError9 = false;
            var _iteratorError9 = undefined;

            try {
                for (var _iterator9 = entityInfos[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                    var ei = _step9.value;
                    var _iteratorNormalCompletion10 = true;
                    var _didIteratorError10 = false;
                    var _iteratorError10 = undefined;

                    try {
                        for (var _iterator10 = _entityFieldMetaStore2.default.getAllInfos(ei.key, optionalFieldFilter)[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                            var f = _step10.value;

                            if (fieldInfosByColumn.hasOwnProperty(f.logicalColumn)) {
                                fieldInfosByColumn[f.logicalColumn].push(f);
                            } else {
                                fieldInfosByColumn[f.logicalColumn] = [f];
                            }
                        }
                    } catch (err) {
                        _didIteratorError10 = true;
                        _iteratorError10 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion10 && _iterator10.return) {
                                _iterator10.return();
                            }
                        } finally {
                            if (_didIteratorError10) {
                                throw _iteratorError10;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError9 = true;
                _iteratorError9 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion9 && _iterator9.return) {
                        _iterator9.return();
                    }
                } finally {
                    if (_didIteratorError9) {
                        throw _iteratorError9;
                    }
                }
            }

            return fieldInfosByColumn;
        }
    }]);

    return CrossAppStore;
}(_utils.ReduceStore);

CrossAppStore.stateTypes = {
    tables: _propTypes2.default.object.isRequired,
    queries: _propTypes2.default.objectOf(_propTypes2.default.instanceOf(_LoadObject2.default)).isRequired
};

exports.default = (0, _typeCheckingStore2.default)(new CrossAppStore());

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var CrossAppActions = {
    SELECT_STEREOTYPE: "search-form/select-stereotype",
    SEARCH: "cross-app/search",
    SEARCH_RESULT: "cross-app/search-result",
    SEARCH_ERROR: "cross-app/search-error"
};

exports.default = CrossAppActions;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toDisplayValue = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _MappingVisitor2 = __webpack_require__(231);

var _MappingVisitor3 = _interopRequireDefault(_MappingVisitor2);

var _MappingInfoStore = __webpack_require__(160);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _TableColumnMetaStore = __webpack_require__(125);

var _TableColumnMetaStore2 = _interopRequireDefault(_TableColumnMetaStore);

var _MappingStore = __webpack_require__(65);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _MapDialogActions = __webpack_require__(64);

var _MapDialogActions2 = _interopRequireDefault(_MapDialogActions);

var _isFieldHidden = __webpack_require__(177);

var _isFieldHidden2 = _interopRequireDefault(_isFieldHidden);

var _isMoment = __webpack_require__(973);

var _isMoment2 = _interopRequireDefault(_isMoment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BuildMappingTreeVisitor = function (_MappingVisitor) {
    _inherits(BuildMappingTreeVisitor, _MappingVisitor);

    function BuildMappingTreeVisitor(state, access, snapshot) {
        _classCallCheck(this, BuildMappingTreeVisitor);

        var _this = _possibleConstructorReturn(this, (BuildMappingTreeVisitor.__proto__ || Object.getPrototypeOf(BuildMappingTreeVisitor)).call(this, state, access, snapshot));

        _this.stack = [];
        return _this;
    }

    _createClass(BuildMappingTreeVisitor, [{
        key: "execute",
        value: function execute(ctx) {
            var treeQueue = [];
            var hasQueue = void 0;
            do {
                this._enterFrame();
                _get(BuildMappingTreeVisitor.prototype.__proto__ || Object.getPrototypeOf(BuildMappingTreeVisitor.prototype), "execute", this).call(this, ctx);
                var stateTree = this._leaveFrame().children[0];
                treeQueue.push(stateTree);
                if (this.state.queue && this.state.queue.length > 0) {
                    hasQueue = true;
                    // get the next mapping state off the queue.
                    this.state = this.state.processQueueCallback(this.state);
                } else {
                    hasQueue = false;
                }
            } while (hasQueue); // loop over each queued mapping state
            this.state = this._initialState; // reset the state

            if (treeQueue.length > 1) {
                var children = [];
                var distinctColumnNames = new Set();
                treeQueue.forEach(function (it) {
                    it.children.forEach(function (field) {
                        var tk = _entityMetaStore2.default.getInfo(field.info.entityKey).tableKey;
                        var ti = _TableColumnMetaStore2.default.getInfoByKey(tk, field.info.logicalKey);
                        if (ti.derivation != null) return; // don't show derived fields.
                        if (!distinctColumnNames.has(field.info.logicalColumn)) {
                            distinctColumnNames.add(field.info.logicalColumn);
                            children.push(field);
                        }
                    });
                });
                // sort the field labels by natural order.
                children.sort(function (a, b) {
                    return a.label.localeCompare(b.label, navigator.languages[0] || navigator.language, {
                        numeric: true,
                        ignorePunctuation: true
                    });
                });

                this.tree = _extends({}, treeQueue[treeQueue.length - 1], { // use the first state as the root
                    children: children
                });
            } else {
                this.tree = treeQueue[treeQueue.length - 1];
            }
            return this;
        }
    }, {
        key: "getTree",
        value: function getTree() {
            return this.tree;
        }
    }, {
        key: "_enterFrame",
        value: function _enterFrame(item) {
            if (item == null) {
                item = {
                    children: []
                };
            }
            this.stack.unshift(item);
            this.item = this.stack[0];
            this.children = this.item.children;
        }
    }, {
        key: "_leaveFrame",
        value: function _leaveFrame() {
            var item = this.item;
            this.stack.shift();
            if (this.stack.length === 0) {
                delete this.item;
                delete this.children;
            } else {
                this.item = this.stack[0];
                this.children = this.item.children;
                this.children.push(item);
            }
            return item;
        }
    }, {
        key: "doRecord",
        value: function doRecord(ctx, target, excluded, source, type, edgeInfo) {
            var _this2 = this;

            this._enterFrame();
            _get(BuildMappingTreeVisitor.prototype.__proto__ || Object.getPrototypeOf(BuildMappingTreeVisitor.prototype), "doRecord", this).call(this, ctx, target, excluded, source, type, edgeInfo);
            var label = target.getLabel();
            Object.assign(this.item, {
                label: label,
                type: type,
                active: !excluded,
                source: source,
                target: target,
                cid: target.id
            });
            if (type === _MappingInfoStore.MAP_TARGET) {
                this.item.shortname = "TARGET";
                this.item.forceActive = "The mapping target may not be excluded.";
            } else {
                this.item.shortname = edgeInfo.key;
            }
            if (this.magicPointerKey != null) {
                var i = this.children.findIndex(function (it) {
                    return it.shortname === _this2.magicPointerKey;
                });
                if (i >= 0) {
                    var mr = this.children[i];
                    this.children.splice(i, 1);
                    this.item.shortname = mr.shortname; // this doesn't make any sense. except "backwards compatible". :|
                    mr.children.push(this.item);
                    mr.isMagicRoot = true;
                    this.item = mr;
                    this.children = mr.children;
                }
            }
            return this._leaveFrame();
        }
    }, {
        key: "doMagicRoot",
        value: function doMagicRoot(ctx, target, excluded, fieldInfo, sourceValue) {
            _get(BuildMappingTreeVisitor.prototype.__proto__ || Object.getPrototypeOf(BuildMappingTreeVisitor.prototype), "doMagicRoot", this).call(this, ctx, target, excluded, fieldInfo, sourceValue);
            this.magicPointerKey = fieldInfo.key;
        }
    }, {
        key: "doGlobalAssoc",
        value: function doGlobalAssoc(ctx, target, excluded, fieldInfo, sourceValue, createIfMissing) {
            var _this3 = this;

            if ((0, _isFieldHidden2.default)(target.entityKey, fieldInfo)) return;
            var cmi = ctx.childMappingInfo;
            var targetInfo = _entityMetaStore2.default.getInfo(cmi.targetKey);
            var kids = this.children;
            this.__forEach(sourceValue, function (it) {
                var lo = _this3.__getTargetIdLO(it, target, fieldInfo);
                var skeleton = {
                    shortname: fieldInfo.key,
                    active: true,
                    type: _MappingInfoStore.MAP_PLACEHOLDER,
                    forceActive: false,
                    children: [],
                    loadObject: lo,
                    cid: target.id + "-" + fieldInfo.key + "-" + it.id,
                    info: fieldInfo,
                    exclusionInfo: buildExclusionInfo(target.id, fieldInfo.logicalColumn)
                };
                if (fieldInfo.multiValued) {
                    skeleton.forceActive = "Multi-select lists may not be excluded.";
                }
                if (lo.hasValue()) {
                    var id = lo.getValueEnforcing();
                    var ep = _this3.access.getEntityProxy(fieldInfo.otherEntityKey, id);
                    // this.doRecord(ctx, ep, it, cmi.type, fieldInfo);
                    var label = ep.getLabel();
                    kids.push(_extends({}, skeleton, {
                        type: _MappingInfoStore.MAP_REFERENCE_GLOBAL,
                        label: fieldInfo.name + ": " + label,
                        active: !(0, _MappingStore.isExcluded)(_this3.state, target.id, fieldInfo.logicalColumn, id),
                        exclusionInfo: buildExclusionInfo(target.id, fieldInfo.logicalColumn, id),
                        toggleActive: fieldInfo.multiValued ? null : function () {
                            return toggleExclusion(target.id, fieldInfo.logicalColumn, id);
                        }
                    }));
                } else if (lo.hasError()) {
                    var err = lo.getErrorEnforcing();
                    switch (err) {
                        case _MappingStore.ERR_MULTIPLE_MATCHES_FOUND:
                            kids.push(_extends({}, skeleton, {
                                label: "Multiple matching " + targetInfo.pluralName + " found, leaving prior value."
                            }));
                            break;
                        case _MappingStore.ERR_NO_MATCH_FOUND:
                            kids.push(_extends({}, skeleton, {
                                label: "No matching " + targetInfo.name + " was found for " + it.getLabel() + "."
                            }));
                            break;
                        default:
                            console.error("Error loading", fieldInfo.otherEntityKey, it, err);
                            break;
                    }
                } else {
                    // this might be a lie, but it'll be true here in a sec. :)
                    kids.push(_extends({}, skeleton, {
                        label: "Loading \"" + targetInfo.pluralName + "\" list..."
                    }));
                }
            });
        }
    }, {
        key: "doComposedChild",
        value: function doComposedChild(ctx, targetParent, edgeInfo, target, source) {
            if ((0, _isFieldHidden2.default)(targetParent.entityKey, edgeInfo)) return;
            _get(BuildMappingTreeVisitor.prototype.__proto__ || Object.getPrototypeOf(BuildMappingTreeVisitor.prototype), "doComposedChild", this).call(this, ctx, targetParent, edgeInfo, target, source);
            var item = this.item.children[this.item.children.length - 1];
            item.label = edgeInfo.name + ": " + item.label;
            item.exclusionInfo = buildExclusionInfo(targetParent.id, edgeInfo.logicalColumn, target.id);
            item.toggleActive = function () {
                return toggleExclusion(targetParent.id, edgeInfo.logicalColumn, target.id);
            };
        }
    }, {
        key: "doExcludedChild",
        value: function doExcludedChild(ctx, targetParent, edgeInfo, targetId, source) {
            if ((0, _isFieldHidden2.default)(targetParent.entityKey, edgeInfo)) return;
            _get(BuildMappingTreeVisitor.prototype.__proto__ || Object.getPrototypeOf(BuildMappingTreeVisitor.prototype), "doExcludedChild", this).call(this, ctx, targetParent, edgeInfo, targetId, source);
            this.children.push({
                shortname: edgeInfo.key,
                label: edgeInfo.name + ": " + source.getLabel(),
                type: _MappingInfoStore.FT_CHILD,
                active: false,
                exclusionInfo: buildExclusionInfo(targetParent.id, edgeInfo.logicalColumn, targetId),
                toggleActive: function toggleActive() {
                    return toggleExclusion(targetParent.id, edgeInfo.logicalColumn, targetId);
                },
                source: source,
                target: null,
                cid: targetId
            });
        }
    }, {
        key: "doField",
        value: function doField(ctx, target, excluded, fieldInfo, sourceValue) {
            _get(BuildMappingTreeVisitor.prototype.__proto__ || Object.getPrototypeOf(BuildMappingTreeVisitor.prototype), "doField", this).call(this, ctx, target, excluded, fieldInfo, sourceValue);
            if ((0, _isFieldHidden2.default)(target.entityKey, fieldInfo)) return;
            var oldValue = this.__oldValue(target, fieldInfo);
            this.children.push({
                shortname: fieldInfo.key,
                label: fieldInfo.name,
                sourceValue: sourceValue,
                targetValue: oldValue,
                value: toDisplayValue(fieldInfo, sourceValue),
                old: toDisplayValue(fieldInfo, oldValue),
                type: fieldInfo.type,
                info: fieldInfo, // todo: what is this for?
                fieldEnabled: target.isFieldEnabled(fieldInfo),
                children: [], // always empty....
                active: !excluded,
                exclusionInfo: buildExclusionInfo(target.id, fieldInfo.logicalColumn),
                toggleActive: function toggleActive() {
                    return toggleExclusion(target.id, fieldInfo.logicalColumn);
                },
                cid: target.entityKey + "-" + target.id + "-" + fieldInfo.key
            });
        }
    }, {
        key: "doAutomanaged",
        value: function doAutomanaged(ctx, target, excluded, fieldInfo, autoManagedByFieldInfo, sourceValue) {
            var _this4 = this;

            this.__forEach(sourceValue, function (it) {
                var t = _this4.__getAutomanagedTarget(target, it, fieldInfo);
                if (t == null) return;
                var item = _this4.doRecord(ctx, t, false, it, _MappingInfoStore.FT_CHILD, fieldInfo);
                item.label = fieldInfo.name + ": " + item.label;
                item.forceActive = "Managed records may not be excluded.";
                var amfItem = item.children.find(function (c) {
                    return c.shortname === autoManagedByFieldInfo.key;
                });
                if (amfItem != null) {
                    amfItem.forceActive = "Management records may not be excluded.";
                }
            });
        }
    }]);

    return BuildMappingTreeVisitor;
}(_MappingVisitor3.default);

var buildExclusionInfo = function buildExclusionInfo(recordId, columnKey, itemKey) {
    return {
        recordId: recordId, columnKey: columnKey, itemKey: itemKey
    };
};

var toggleExclusion = function toggleExclusion(recordId, columnKey, itemKey) {
    return _Dispatcher2.default.dispatch({
        type: _MapDialogActions2.default.TOGGLE_EXCLUSION,
        recordId: recordId,
        columnKey: columnKey,
        itemKey: itemKey
    });
};

// from FieldMapping
var toDisplayValue = exports.toDisplayValue = function toDisplayValue(info, value) {
    if (value == null) {
        return "";
    } else if (info.type === "DateField") {
        return moment(value).format("MM/DD/YYYY");
    } else if (info.type === "DateTimeField") {
        return moment(value).format("MM/DD/YYYY HH:mm");
    } else if (info.type === "TimeField") {
        return moment(value).format("HH:mm");
    } else if ((0, _isMoment2.default)(value)) {
        return moment(value).format("MM/DD/YYYY HH:mm");
    } else if (info.type === "ChoiceField") {
        return value instanceof Array ? value.join(", ") : value;
    } else {
        return value;
    }
};

exports.default = BuildMappingTreeVisitor;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UserEditedRecordStore = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _ContextedReduceStore2 = __webpack_require__(30);

var _ContextedReduceStore3 = _interopRequireDefault(_ContextedReduceStore2);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

var _RecordActions = __webpack_require__(60);

var _RecordActions2 = _interopRequireDefault(_RecordActions);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

var _typedefs = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _hasEdits = function _hasEdits(state) {
    return state.deletion || state.records.length > 0;
};

var recordEdited = function recordEdited(state, key, id) {
    var compoundId = key + "#" + id;
    if (state.records.some(function (id) {
        return id === compoundId;
    })) {
        // already recorded as dirty
        return state;
    }
    return _extends({}, state, {
        records: state.records.concat(compoundId)
    });
};

var recordDeleted = function recordDeleted(state, key, id) {
    var compoundId = key + "#" + id;
    return _extends({}, state, {
        deletion: true,
        records: state.records.filter(function (id) {
            return id !== compoundId;
        })
    });
};

var UserEditedRecordStore = exports.UserEditedRecordStore = function (_ContextedReduceStore) {
    _inherits(UserEditedRecordStore, _ContextedReduceStore);

    function UserEditedRecordStore() {
        _classCallCheck(this, UserEditedRecordStore);

        return _possibleConstructorReturn(this, (UserEditedRecordStore.__proto__ || Object.getPrototypeOf(UserEditedRecordStore)).apply(this, arguments));
    }

    _createClass(UserEditedRecordStore, [{
        key: "getInitialContext",
        value: function getInitialContext() {
            return {
                deletion: false,
                records: []
            };
        }
    }, {
        key: "hasEdits",
        value: function hasEdits(ctx) {
            if (ctx) {
                return _hasEdits(this.getState(ctx));
            }
            return this.getEachContext().some(_hasEdits);
        }
    }, {
        key: "getRecordKeys",
        value: function getRecordKeys(ctx) {
            var keySet = new Set();
            if (ctx) {
                this.getState(ctx).records.forEach(function (k) {
                    return keySet.add(k);
                });
            } else {
                this.getEachContext().forEach(function (s) {
                    return s.records.forEach(function (k) {
                        return keySet.add(k);
                    });
                });
            }
            return Array.from(keySet).map(function (k) {
                return k.split("#");
            }).map(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    key = _ref2[0],
                    id = _ref2[1];

                return {
                    key: key,
                    id: _ClientId2.default.is(id) ? id : parseInt(id)
                };
            });
        }
    }, {
        key: "reduceContext",
        value: function reduceContext(ctx, action) {
            switch (action.type) {

                case _SuperRecordActions2.default.NEW:
                    {
                        return _extends({}, this.getInitialContext(), {
                            key: action.stereoKey,
                            id: action.newId
                        });
                    }

                case _SuperRecordActions2.default.OPEN:
                    {
                        return _extends({}, this.getInitialContext(), {
                            key: action.key,
                            id: action.id
                        });
                    }

                case _RecordActions2.default.NEW:
                    {
                        return recordEdited(ctx, action.recordKey, action.newId);
                    }

                case _RecordActions2.default.NEW_CHILD:
                    {
                        return recordEdited(ctx, action.recordKey, action.recordId);
                    }

                case _RecordActions2.default.DELETE_CHILD:
                    {
                        if (!action[_RecordActions.OPT_USER_CONFIRMED]) return ctx;
                        ctx = recordEdited(ctx, action.recordKey, action.recordId);
                        ctx = recordDeleted(ctx, action.childKey, action.childId);
                        return ctx;
                    }

                case _RecordActions2.default.DELETE_RECORD:
                    {
                        if (!action[_RecordActions.OPT_USER_CONFIRMED]) return ctx;
                        return recordDeleted(ctx, action.recordKey, action.recordId);
                    }

                case _RecordActions2.default.SET_FIELD:
                    {
                        if (!action[_RecordActions.OPT_USER_INITIATED]) return ctx;
                        return recordEdited(ctx, action.recordKey, action.recordId);
                    }

                default:
                    return ctx;
            }
        }
    }, {
        key: "reduceEachContext",
        value: function reduceEachContext(ctx, action) {
            switch (action.type) {
                case _SuperRecordActions2.default.CREATED:
                case _SuperRecordActions2.default.UPDATED:
                    {
                        if (ctx.key !== action.key || ctx.id !== action.id) return ctx;
                        return _extends({}, this.getInitialContext(), {
                            key: action.key,
                            id: action.data.id
                        });
                    }

                case _SuperRecordActions2.default.DELETED:
                    {
                        if (ctx.key !== action.key || ctx.id !== action.id) return ctx;
                        return this.getInitialContext();
                    }

                default:
                    return ctx;
            }
        }
    }]);

    return UserEditedRecordStore;
}(_ContextedReduceStore3.default);

UserEditedRecordStore.contextTypes = {
    key: _propTypes2.default.string,
    id: _typedefs.recordIdType,
    deletion: _propTypes2.default.bool.isRequired,
    records: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
};

exports.default = (0, _typeCheckingStore2.default)(new UserEditedRecordStore(_Dispatcher2.default));

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var LockActions = {
    LOCKSET_CREATED: "lock/lockset-created",
    LOCKSET_CREATE_ERROR: "lock/lockset-create-error",
    LOCKSET_RELEASED: "lock/lockset-released",
    LOCKSET_RELEASE_ERROR: "lock/lockset-release-error",
    LOCKSET_CONFIRMED: "lock/lockset-confirmed",
    LOCKSET_CONFIRM_ERROR: "lock/lockset-confirm-error"
};

exports.default = LockActions;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Services = __webpack_require__(110);

var _Services2 = _interopRequireDefault(_Services);

var _ajaxHelper = __webpack_require__(318);

var _ajaxHelper2 = _interopRequireDefault(_ajaxHelper);

var _LockActions = __webpack_require__(316);

var _LockActions2 = _interopRequireDefault(_LockActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AUTO_RETRY_DELAY = 10 * 1000;

var lockClientId = void 0;

var promiseClientId = function promiseClientId() {
    return lockClientId != null ? Promise.resolve(lockClientId) : _Services2.default.createLockClient().then(function (info) {
        return lockClientId = info.id;
    });
};

var withAutoRetry = function withAutoRetry(work) {
    return work().catch(function (error) {
        if (error && error.hasOwnProperty("status") && error.status >= 500) {
            // server error; try again in a sec
            return new Promise(function (resolve) {
                return (
                    // eslint-disable-next-line no-settimeout
                    setTimeout(function () {
                        return resolve(work());
                    }, AUTO_RETRY_DELAY)
                );
            });
        }
        return Promise.reject(error);
    });
};

var idFromLockSetOrId = function idFromLockSetOrId(lockSetOrId) {
    return typeof lockSetOrId === "number" ? lockSetOrId : lockSetOrId.id;
};

var LockApi = {

    createLockSet: function createLockSet(lockSet) {
        return (0, _ajaxHelper2.default)(promiseClientId().then(function (clientId) {
            return withAutoRetry(function () {
                return _Services2.default.createLockSet(clientId, { locks: lockSet.locks });
            });
        }), {
            type: _LockActions2.default.LOCKSET_CREATED,
            id: lockSet.id
        }, {
            type: _LockActions2.default.LOCKSET_CREATE_ERROR,
            id: lockSet.id
        });
    },

    confirmLockset: function confirmLockset(lockSetOrId) {
        var id = idFromLockSetOrId(lockSetOrId);
        if (id == null) return;
        return (0, _ajaxHelper2.default)(promiseClientId().then(function (clientId) {
            return _Services2.default.confirmLockSet(clientId, id);
        }), {
            type: _LockActions2.default.LOCKSET_CONFIRMED,
            id: id
        }, {
            type: _LockActions2.default.LOCKSET_CONFIRM_ERROR,
            id: id
        });
    },

    releaseLockset: function releaseLockset(lockSetOrId) {
        var id = idFromLockSetOrId(lockSetOrId);
        if (id == null) return;
        return (0, _ajaxHelper2.default)(promiseClientId().then(function (clientId) {
            return withAutoRetry(function () {
                return _Services2.default.releaseLockSet(clientId, id);
            });
        }), {
            type: _LockActions2.default.LOCKSET_RELEASED,
            id: id
        }, {
            type: _LockActions2.default.LOCKSET_RELEASE_ERROR,
            id: id
        });
    },

    releaseClient: function releaseClient() {
        if (lockClientId == null) return;
        _Services2.default.deleteLockClient(lockClientId);
    }
};

exports.default = LockApi;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _promisify = __webpack_require__(97);

var _promisify2 = _interopRequireDefault(_promisify);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * These control how much delay is added to helped Promises in "not production".
 * If DEV_DELAY is set to a negative number, production behaviour (no delay)
 * will be used. Otherwise, each Promise will be delayed a random amount between
 * DEV_DELAY and DEV_DELAY+DEV_DELAY_JITTER. The specific delay for a given
 * Promise is hidden, cannot be influenced, and is determined separately from
 * any other delayed Promises.
 *
 * If you're interested in checking "loading" status indicators, set DEV_DELAY
 * high.
 *
 * If you're interested in race conditions, set DEV_DELAY_JITTER high.
 */
var DEV_DELAY = -1;
var DEV_DELAY_JITTER = 100;

var myPromisify =  false ? function (p) {
    return new Promise(function (resolve) {
        var doc = $(document).trigger("ajaxDelay");
        // eslint-disable-next-line no-settimeout
        setTimeout(function () {
            resolve(p.then(function (val) {
                doc.trigger("ajaxResume");
                return val;
            }, function (err) {
                doc.trigger("ajaxResume");
                return Promise.reject(err);
            }));
        }, DEV_DELAY + Math.random() * DEV_DELAY_JITTER);
    });
} : _promisify2.default;

var ajaxHelper = function ajaxHelper(ajaxDeferred, resolveActionTemplateOrCallback, rejectActionTemplateOrCallback) {
    return myPromisify(ajaxDeferred).then(function (data) {
        _Dispatcher2.default.dispatch(typeof resolveActionTemplateOrCallback === "function" ? resolveActionTemplateOrCallback(data) : _extends({ data: data }, resolveActionTemplateOrCallback));
        return data;
    }, function (error) {
        _Dispatcher2.default.dispatch(typeof rejectActionTemplateOrCallback === "function" ? rejectActionTemplateOrCallback(error) : _extends({ error: error }, rejectActionTemplateOrCallback));
        return Promise.reject(error);
    });
};

exports.default = ajaxHelper;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _userEditedRecordStore = __webpack_require__(315);

var _userEditedRecordStore2 = _interopRequireDefault(_userEditedRecordStore);

var _lockStore = __webpack_require__(144);

var _lockStore2 = _interopRequireDefault(_lockStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasUnsavedChanges = function hasUnsavedChanges(fluxContextOrNull) {
    if (fluxContextOrNull) {
        var optlock = _lockStore2.default.getOptLock(fluxContextOrNull);
        return _userEditedRecordStore2.default.hasEdits(fluxContextOrNull) && (!optlock || !optlock.violated);
    } else {
        return _userEditedRecordStore2.default.getContextNames().some(function (it) {
            return it && hasUnsavedChanges(it);
        });
    }
};

exports.default = hasUnsavedChanges;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SessionActions = {
    timeout: "session/timeout",
    timeoutImminent: "session/timeoutImminent"
};

exports.default = SessionActions;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/*  
    AI Suggest Store - Actions
    These are the current events AI Suggest will kickoff.
    All events are listed below.
    TODO: future events will need to be added for the birds eye view.
*/

var AbstractionAiActions = {
    START_LOAD: "abstraction-ai/start-load",
    LOADED: "abstraction-ai/loaded",
    LOAD_ERROR: "abstraction-ai/load-error",
    FEEDBACK: "abstraction-ai/feedback"
};

exports.default = AbstractionAiActions;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
 Using a map for this works because JS guarantees iteration order of properties
 based on the order of creation. But it's definitely a weird way to represent
 ordered data.
 */
var sortsToOrder = function sortsToOrder(map) {
    var qs = [];
    if (map != null) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = Object.keys(map)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var k = _step.value;

                var v = map[k];
                qs.push(k + " " + v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return qs.join(",");
};

exports.default = sortsToOrder;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GenericXmlExportPasswordAdmin = exports.title = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _GxepStore = __webpack_require__(486);

var _loadObjectOf = __webpack_require__(220);

var _loadObjectOf2 = _interopRequireDefault(_loadObjectOf);

var _form = __webpack_require__(107);

var _form2 = _interopRequireDefault(_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var title = exports.title = "ARMUS XML Export Password Manager";

var GenericXmlExportPasswordAdmin = exports.GenericXmlExportPasswordAdmin = function (_React$Component) {
    _inherits(GenericXmlExportPasswordAdmin, _React$Component);

    function GenericXmlExportPasswordAdmin(props) {
        _classCallCheck(this, GenericXmlExportPasswordAdmin);

        var _this = _possibleConstructorReturn(this, (GenericXmlExportPasswordAdmin.__proto__ || Object.getPrototypeOf(GenericXmlExportPasswordAdmin)).call(this, props));

        _this.handleCancel = _this.handleCancel.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSave = _this.handleSave.bind(_this);
        return _this;
    }

    _createClass(GenericXmlExportPasswordAdmin, [{
        key: "handleCancel",
        value: function handleCancel(e) {
            e.preventDefault();
            this.props.onCancel();
        }
    }, {
        key: "handleChange",
        value: function handleChange(desc, value) {
            this.props.onChange(desc.key, value || ""); // no nulls!
        }
    }, {
        key: "handleSave",
        value: function handleSave(e) {
            e.preventDefault();
            this.props.onSave();
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var passwordsLO = this.props.passwordsLO;

            if (passwordsLO.isLoading()) return null;
            if (!passwordsLO.hasValue()) {
                if (passwordsLO.hasError()) {
                    return _react2.default.createElement(
                        "h2",
                        null,
                        "A loading error occurred."
                    );
                }
                return null;
            }
            var passwords = passwordsLO.getValueEnforcing();
            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(_form2.default, {
                    descriptor: {
                        key: "",
                        id: "",
                        path: "",
                        label: "",
                        type: "Form",
                        control: "form",
                        disableBehaviour: "disable",
                        childItems: passwords
                    },
                    propsResolver: function propsResolver(it) {
                        return {
                            descriptor: {
                                config: {},
                                key: it.key,
                                id: it.key,
                                path: it.key,
                                label: it.name,
                                disableBehaviour: "disable",
                                control: "text",
                                type: "StringField"
                            },
                            onCommitChange: _this2.handleChange,
                            value: it.password,
                            enabled: true
                        };
                    }
                }),
                _react2.default.createElement(
                    "div",
                    { className: "modal-footer" },
                    _react2.default.createElement(
                        "button",
                        {
                            className: "btn btn-save",
                            onClick: this.handleSave
                        },
                        _react2.default.createElement("span", null),
                        " Save"
                    ),
                    _react2.default.createElement(
                        "button",
                        {
                            onClick: this.handleCancel,
                            className: "btn btn-cancel"
                        },
                        _react2.default.createElement("span", null),
                        " Cancel"
                    )
                )
            );
        }
    }]);

    return GenericXmlExportPasswordAdmin;
}(_react2.default.Component);

GenericXmlExportPasswordAdmin.propTypes = {
    passwordsLO: (0, _loadObjectOf2.default)(_propTypes2.default.arrayOf(_GxepStore.itemShapeType)),
    onCancel: _propTypes2.default.func.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    onSave: _propTypes2.default.func.isRequired
};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var ACTION_CONTEXT_KEY, AppModel, ContextActions, DataEntry, Dispatcher, Model, RecordBrowserState, Stereotypes, SuperRecordActions, contextKeyFactory, isConfirmed, userStore, _ref,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Model = __webpack_require__(83)["default"];

DataEntry = __webpack_require__(991);

Stereotypes = __webpack_require__(488);

RecordBrowserState = __webpack_require__(490);

userStore = __webpack_require__(8)["default"];

contextKeyFactory = __webpack_require__(30).keyFactory;

Dispatcher = __webpack_require__(4)["default"];

ContextActions = __webpack_require__(170)["default"];

SuperRecordActions = __webpack_require__(25)["default"];

ACTION_CONTEXT_KEY = __webpack_require__(30).ACTION_CONTEXT_KEY;

isConfirmed = __webpack_require__(61).isConfirmed;

module.exports = AppModel = (function(_super) {
  __extends(AppModel, _super);

  function AppModel() {
    this.squishMenuItem = __bind(this.squishMenuItem, this);
    this.squishMenuList = __bind(this.squishMenuList, this);
    this.buildNewMenu = __bind(this.buildNewMenu, this);    _ref = AppModel.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  AppModel.prototype.defaults = function() {
    return {
      fluxContext: contextKeyFactory(),
      stereotypes: new Stereotypes(),
      lookups: new Stereotypes(),
      recordBrowserState: new RecordBrowserState(),
      dataEntry: new DataEntry(),
      isModal: false,
      hex: null,
      dataQualityReport: null,
      view: "de"
    };
  };

  AppModel.prototype.initialize = function() {
    var _this = this;

    return this.__dispatch_token = Dispatcher.register(function(action) {
      if (action[ACTION_CONTEXT_KEY] !== _this.get("fluxContext")) {
        return;
      }
      switch (action.type) {
        case ContextActions.CLOSE:
          return Dispatcher.unregister(_this.__dispatch_token);
      }
    });
  };

  AppModel.prototype.buildNewMenu = function(root) {
    var org, tree;

    if (root == null) {
      throw new Error('root is required to build menu');
    }
    tree = new Backbone.Collection();
    org = userStore.getActiveOrg();
    _(root.get('creatables').filter(function(c) {
      return _(c.get('orgs')).contains(org.key);
    })).each(function(c) {
      var def, label;

      if (c.has("defaultKey")) {
        def = c.get("versions").find(function(v) {
          return v.get('key') === c.get('defaultKey');
        });
      }
      label = c.get('label');
      if (def != null) {
        return tree.add(new Backbone.Model({
          label: label,
          key: def.get('key'),
          org: org.key,
          entity: root.get('key')
        }));
      } else {
        return c.get("versions").each(function(v) {
          return tree.add(new Backbone.Model({
            label: label + " > " + v.get('label'),
            key: v.get('key'),
            org: org.key,
            entity: root.get('key')
          }));
        });
      }
    });
    return this.squishMenuList(tree);
  };

  AppModel.prototype.squishMenuList = function(list) {
    var item, result, _i, _len, _ref1;

    result = new Backbone.Collection();
    _ref1 = list.models;
    for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
      item = _ref1[_i];
      result.add(this.squishMenuItem(item));
    }
    return result;
  };

  AppModel.prototype.squishMenuItem = function(item) {
    var kid, kids;

    if (item.get("kids")) {
      kids = this.squishMenuList(item.get("kids"));
      item.set("kids", kids);
      if (kids.size() === 1) {
        kid = kids.pop();
        kid.set("label", item.get("label") + " > " + kid.get("label"));
        return kid;
      }
    }
    return item;
  };

  return AppModel;

})(Model);


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * I manage a periodic task, invoking it immediately, and then every `interval`
 * milliseconds afterward, as long as the component is mounted. The deps array
 * is the same as for React.useEffect: the variables the task closes over. If
 * the dependencies change, the task will be immediately invoked and
 * rescheduled, regardless of when the prior
 * invocation was.
 * @param task The task to periodically invoke
 * @param interval Interval in milliseconds between invocations
 * @param deps The dependencies of the task. If these change, the task will be
 *  immediately invoked with the new dependencies and the scheduler restarted.
 */
function usePeriodicTask(task, interval, deps) {
    _react2.default.useEffect(function () {
        task();
        // eslint-disable-next-line no-settimeout
        var id = setInterval(task, interval);
        return function () {
            return clearInterval(id);
        };
    }, deps);
}

exports.default = usePeriodicTask;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(51);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DropdownWrapper = __webpack_require__(214);

var _DropdownWrapper2 = _interopRequireDefault(_DropdownWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropDown = function (_React$Component) {
    _inherits(DropDown, _React$Component);

    function DropDown(props) {
        _classCallCheck(this, DropDown);

        var _this = _possibleConstructorReturn(this, (DropDown.__proto__ || Object.getPrototypeOf(DropDown)).call(this, props));

        _this.targetRef = _react2.default.createRef();
        _this.state = {
            showDropdownMenu: false
        };

        _this.onClick = _this.onClick.bind(_this);
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.onHide = _this.onHide.bind(_this);
        return _this;
    }

    _createClass(DropDown, [{
        key: "onClick",
        value: function onClick(e) {
            e.preventDefault();
            this.setState(function (s) {
                return { showDropdownMenu: !s.showDropdownMenu };
            });
        }
    }, {
        key: "onKeyDown",
        value: function onKeyDown(e) {
            if (e.target === this.targetRef.current) {
                if ([" ", "Space"].includes(e.key)) {
                    this.setState(function (s) {
                        return { showDropdownMenu: !s.showDropdownMenu };
                    });
                }
            }
        }
    }, {
        key: "onHide",
        value: function onHide() {
            var onHide = this.props.onHide;

            this.setState({ showDropdownMenu: false });
            onHide && onHide();
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                title = _props.title,
                icon = _props.icon,
                label = _props.label,
                children = _props.children,
                className = _props.className,
                onKeyDown = _props.onKeyDown,
                align = _props.align;

            if (children == null) return null;
            if (Array.isArray(children)) {
                if (children.length === 0) return null;
                if (children.every(function (it) {
                    return !it;
                })) return null;
            } else if (!children) {
                return null;
            }
            return _react2.default.createElement(
                "li",
                { title: title, className: (0, _classnames2.default)("dropdown", className), "data-control-type": "bootstrap-dropdown", onKeyDown: onKeyDown },
                _react2.default.createElement(
                    "a",
                    {
                        ref: this.targetRef,
                        className: "dropdown-toggle",
                        href: "#",
                        onClick: this.onClick,
                        onKeyDown: this.onKeyDown
                    },
                    icon && _react2.default.createElement("span", { className: "glyphicon glyphicon-" + icon }),
                    " ",
                    label,
                    " ",
                    _react2.default.createElement("b", { className: "caret" })
                ),
                this.state.showDropdownMenu && _react2.default.createElement(
                    _DropdownWrapper2.default,
                    {
                        targetRef: this.targetRef,
                        align: align || "left",
                        layer: "navbar",
                        scrollSelector: "li.active",
                        onHide: this.onHide,
                        autoSize: false
                    },
                    _react2.default.createElement(
                        "ul",
                        { className: "dropdown-menu navbar-menu" },
                        children
                    )
                )
            );
        }
    }]);

    return DropDown;
}(_react2.default.Component);

DropDown.propTypes = {
    title: _propTypes2.default.string,
    label: _propTypes2.default.any,
    icon: _propTypes2.default.string,
    className: _propTypes2.default.string,
    children: _propTypes2.default.node,
    align: _propTypes2.default.oneOf(["left", "right"]),
    onKeyDown: _propTypes2.default.func,
    onHide: _propTypes2.default.func
};

exports.default = DropDown;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMessage = exports.isError = exports.isSuccess = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(13);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _DevelopmentActions = __webpack_require__(98);

var _DevelopmentActions2 = _interopRequireDefault(_DevelopmentActions);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _ITTestStore = __webpack_require__(493);

var _ITTestStore2 = _interopRequireDefault(_ITTestStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LS_KEY = "IT_TEST_HISTORY";

var cleanPath = function cleanPath(path) {
    if (path == null) return path;
    // everything is within this directory. we'll just blindly assume there
    // isn't an earlier duplicate instance in the url. :)
    var idx = path.indexOf("test/it/");
    return idx === 0 ? path : path.substr(idx);
};

var recordResult = function recordResult(state, success, message) {
    var path = cleanPath(_ITTestStore2.default.getState().path);
    if (path == null) return state;
    state = _extends({}, state);
    state[path] = {
        success: success,
        message: message
    };
    window.localStorage.setItem(LS_KEY, JSON.stringify(state));
    return state;
};

var ITTestHistoryStore = function (_ReduceStore) {
    _inherits(ITTestHistoryStore, _ReduceStore);

    function ITTestHistoryStore() {
        _classCallCheck(this, ITTestHistoryStore);

        return _possibleConstructorReturn(this, (ITTestHistoryStore.__proto__ || Object.getPrototypeOf(ITTestHistoryStore)).call(this, _Dispatcher2.default));
    }

    _createClass(ITTestHistoryStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            var state = null;
            try {
                state = JSON.parse(window.localStorage.getItem(LS_KEY));
            } catch (e) {
                state = null;
            }
            if (state == null) {
                state = {};
            }
            return state;
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {
                case _DevelopmentActions2.default.IT_TEST_ERROR:
                    {
                        return recordResult(state, false, action.message);
                    }

                case _DevelopmentActions2.default.IT_TEST_SUCCESS:
                    {
                        return recordResult(state, true);
                    }

                case _DevelopmentActions2.default.RESET_IT_TEST_STATUS:
                    {
                        window.localStorage.removeItem(LS_KEY);
                        return this.getInitialState();
                    }

                default:
                    return state;
            }
        }
    }]);

    return ITTestHistoryStore;
}(_utils.ReduceStore);

ITTestHistoryStore.stateTypes = _propTypes2.default.objectOf(_propTypes2.default.exact({
    success: _propTypes2.default.bool.isRequired,
    message: _propTypes2.default.string
}));

var isSuccess = exports.isSuccess = function isSuccess(history, path) {
    path = cleanPath(path);
    return history.hasOwnProperty(path) && history[path].success;
};

var isError = exports.isError = function isError(history, path) {
    path = cleanPath(path);
    return history.hasOwnProperty(path) && !history[path].success;
};

var getMessage = exports.getMessage = function getMessage(history, path) {
    path = cleanPath(path);
    return history.hasOwnProperty(path) ? history[path].message : null;
};

exports.default = (0, _typeCheckingStore2.default)(new ITTestHistoryStore());

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var DrawerLayout, template, _ref,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

template = __webpack_require__(1027);

module.exports = DrawerLayout = (function(_super) {
  __extends(DrawerLayout, _super);

  function DrawerLayout() {
    this.onDrawerToggle = __bind(this.onDrawerToggle, this);
    this.onDrawerOpen = __bind(this.onDrawerOpen, this);
    this.onDrawerClose = __bind(this.onDrawerClose, this);
    this.onDrawerEnable = __bind(this.onDrawerEnable, this);    _ref = DrawerLayout.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  DrawerLayout.prototype.template = template;

  DrawerLayout.prototype.triggers = {
    "click .drawer-pull": "drawer:toggle"
  };

  DrawerLayout.prototype.ui = {
    "drawer": ".drawer-container",
    "drawerBody": ".drawer-body"
  };

  DrawerLayout.prototype.regions = {
    "drawer": ".drawer-body",
    "content": ".drawer-content"
  };

  DrawerLayout.prototype.open = false;

  DrawerLayout.prototype.onDrawerEnable = function() {
    if (this.ui.drawer.hasClass('enabled')) {
      return;
    }
    this.ui.drawer.removeClass('disabled');
    return this.ui.drawer.addClass('enabled');
  };

  DrawerLayout.prototype.onDrawerClose = function() {
    if (!this.ui.drawer.hasClass('open')) {
      return;
    }
    this.fullHeight = this.ui.drawerBody.height();
    this.ui.drawer.removeClass('open');
    this.open = false;
    this.ui.drawerBody.css({
      height: this.fullHeight
    });
    return this.ui.drawer.css({
      top: -this.fullHeight
    });
  };

  DrawerLayout.prototype.onDrawerOpen = function() {
    if (this.ui.drawer.hasClass('open')) {
      return;
    }
    this.open = true;
    this.ui.drawer.addClass('open');
    this.ui.drawerBody.css({
      height: ""
    });
    return this.ui.drawer.css({
      top: ""
    });
  };

  DrawerLayout.prototype.onDrawerToggle = function() {
    if (this.ui.drawer.hasClass('disabled')) {
      return;
    }
    if (this.ui.drawer.hasClass('open')) {
      return this.onDrawerClose();
    } else {
      return this.onDrawerOpen();
    }
  };

  return DrawerLayout;

})(Backbone.Marionette.Layout);


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _GonkBox = __webpack_require__(212);

var _GonkBox2 = _interopRequireDefault(_GonkBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_MESSAGE = "Unknown Error";

var ErrorBoundary = function (_React$Component) {
    _inherits(ErrorBoundary, _React$Component);

    function ErrorBoundary(props) {
        _classCallCheck(this, ErrorBoundary);

        var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));

        _this.state = {
            hasError: false
        };
        return _this;
    }

    _createClass(ErrorBoundary, [{
        key: "componentDidCatch",
        value: function componentDidCatch(error, info) {
            // send to monitoring, perhaps?
            var isRealError = error instanceof Error;
            this.setState({
                hasError: true,
                error: isRealError ? error : null,
                info: info,
                message: (isRealError ? error.message : error == null ? null : error.toString()) || DEFAULT_MESSAGE
            });
        }
    }, {
        key: "render",
        value: function render() {
            if (this.state.hasError) {
                var _state = this.state,
                    error = _state.error,
                    message = _state.message;

                return _react2.default.createElement(
                    _GonkBox2.default,
                    null,
                    _react2.default.createElement(
                        "h2",
                        null,
                        "Uncaught ",
                        error && error.name || "Error"
                    ),
                    _react2.default.createElement(
                        "p",
                        null,
                        message
                    )
                );
            }

            return this.props.children;
        }
    }]);

    return ErrorBoundary;
}(_react2.default.Component);

ErrorBoundary.propTypes = {
    children: _propTypes2.default.node.isRequired
};

exports.default = ErrorBoundary;

/***/ }),
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.renderer = exports.resolver = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formhelpers = __webpack_require__(5);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _form = __webpack_require__(607);

var _column = __webpack_require__(1335);

var _columnset = __webpack_require__(1336);

var _grid = __webpack_require__(1337);

var _gridcell = __webpack_require__(1338);

var _gridrow = __webpack_require__(1339);

var _section = __webpack_require__(1340);

var _NotFound = __webpack_require__(1341);

var _dropdown = __webpack_require__(1342);

var _label = __webpack_require__(1344);

var _text = __webpack_require__(1345);

var _textarea = __webpack_require__(1346);

var _label2 = __webpack_require__(1347);

var _spinner = __webpack_require__(1348);

var _calendar = __webpack_require__(1349);

var _label3 = __webpack_require__(1350);

var _calendar2 = __webpack_require__(1351);

var _label4 = __webpack_require__(1352);

var _label5 = __webpack_require__(1353);

var _text2 = __webpack_require__(1354);

var _label6 = __webpack_require__(1355);

var _manager = __webpack_require__(608);

var _rfpi = __webpack_require__(1356);

var _label7 = __webpack_require__(1386);

var _spinner2 = __webpack_require__(1387);

var _button = __webpack_require__(1388);

var _label8 = __webpack_require__(1389);

var _timestamp = __webpack_require__(1390);

var _timestamp2 = _interopRequireDefault(_timestamp);

var _valuemutationbutton = __webpack_require__(1391);

var _magicrootsummarysection = __webpack_require__(1392);

var _summarysection = __webpack_require__(1396);

var _devicelesiongrid = __webpack_require__(1398);

var _recordbrowser = __webpack_require__(1400);

var _label9 = __webpack_require__(1401);

var _typeahead = __webpack_require__(1402);

var _typeahead2 = __webpack_require__(1404);

var _checkbox = __webpack_require__(1405);

var _dropdown2 = __webpack_require__(1406);

var _devicelesiongrid2 = __webpack_require__(1407);

var _label10 = __webpack_require__(1409);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resolver = exports.resolver = function resolver(descriptor) {
    switch (descriptor.type + descriptor.control) {
        // This IntelliJ token is enabled in the preferences at
        //     Editor > Code Style > Formatter Controls
        // @formatter:off
        case "AssociationFielddevicelesiongrid":
            return _devicelesiongrid2.AssociationFielddevicelesiongrid;
        case "AssociationFieldlabel":
            return _label9.AssociationFieldlabel;
        case "AssociationFieldrecordbrowser":
            return _recordbrowser.AssociationFieldrecordbrowser;
        case "AssociationFieldtypeahead":
            return _typeahead.AssociationFieldtypeahead;
        case "ChoiceFieldcheckbox":
            return _checkbox.ChoiceFieldcheckbox;
        case "ChoiceFielddropdown":
            return _dropdown2.ChoiceFielddropdown;
        case "ChoiceFieldlabel":
            return _label10.ChoiceFieldlabel;
        case "ChoiceFieldtypeahead":
            return _typeahead2.ChoiceFieldtypeahead;
        case "CompositionFieldsummarysection":
            return _summarysection.CompositionFieldsummarysection;
        case "CompositionFielddevicelesiongrid":
            return _devicelesiongrid.CompositionFielddevicelesiongrid;
        case "DateFieldcalendar":
            return _calendar2.DateFieldcalendar;
        case "DateFieldlabel":
            return _label4.DateFieldlabel;
        case "DateTimeFieldcalendar":
            return _calendar.DateTimeFieldcalendar;
        case "DateTimeFieldlabel":
            return _label3.DateTimeFieldlabel;
        case "DecimalFieldlabel":
            return _label5.DecimalFieldlabel;
        case "DecimalFieldtext":
            return _text2.DecimalFieldtext;
        case "FileFieldlabel":
            return _label6.FileFieldlabel;
        case "FileFieldmanager":
            return _manager.FileFieldmanager;
        case "FileFieldrfpi":
            return _rfpi.FileFieldrfpi;
        case "Formform":
            return _form.Formform;
        case "IntegerFieldlabel":
            return _label2.IntegerFieldlabel;
        case "IntegerFieldspinner":
            return _spinner.IntegerFieldspinner;
        case "Layoutcolumn":
            return _column.Layoutcolumn;
        case "Layoutcolumnset":
            return _columnset.Layoutcolumnset;
        case "Layoutgrid":
            return _grid.Layoutgrid;
        case "Layoutgridrow":
            return _gridrow.Layoutgridrow;
        case "Layoutgridcell":
            return _gridcell.Layoutgridcell;
        case "Layoutsection":
            return _section.Layoutsection;
        case "StringFielddropdown":
            return _dropdown.StringFielddropdown;
        case "StringFieldlabel":
            return _label.StringFieldlabel;
        case "StringFieldtext":
            return _text.StringFieldtext;
        case "StringFieldtextarea":
            return _textarea.StringFieldtextarea;
        case "TimeFieldlabel":
            return _label7.TimeFieldlabel;
        case "TimeFieldspinner":
            return _spinner2.TimeFieldspinner;
        case "Widgetbutton":
            return _button.Widgetbutton;
        case "Widgetlabel":
            return _label8.Widgetlabel;
        case "Widgettimestamp":
            return _timestamp2.default;
        case "Widgetvaluemutationbutton":
            return _valuemutationbutton.Widgetvaluemutationbutton;
        case "Widgetmagicrootsummarysection":
            return _magicrootsummarysection.Widgetmagicrootsummarysection;
        default:
            return _NotFound.NotFound;
        // @formatter:on
    }
};

var renderer = exports.renderer = function renderer(props) {
    var descriptor = props.descriptor;

    var Component = resolver(descriptor);
    if (Component == null) {
        return _react2.default.createElement(_NotFound.NotFound, {
            key: descriptor.key,
            descriptor: descriptor
        });
    }
    return _react2.default.createElement(Component, _extends({}, props, {
        key: descriptor.key
    }));
};

renderer.propTypes = {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)(null, false, true)),
    fluxContext: _propTypes2.default.string.isRequired,
    activeRecord: _propTypes2.default.instanceOf(_EntityProxy2.default).isRequired,
    onFocus: _propTypes2.default.func.isRequired,
    onBlur: _propTypes2.default.func.isRequired,
    onKeyDown: _propTypes2.default.func.isRequired,
    onGlobalRecordLookup: _propTypes2.default.func.isRequired
};

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.previewFile = exports.buildFileUrl = exports.buildFileMeta = exports.buildFilesForField = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _FileUploadStore = __webpack_require__(227);

var _FileUploadStore2 = _interopRequireDefault(_FileUploadStore);

var _Services = __webpack_require__(110);

var _Services2 = _interopRequireDefault(_Services);

var _BaseServices = __webpack_require__(76);

var _BaseServices2 = _interopRequireDefault(_BaseServices);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// combine a fields in-progress uploads with completed uploads.
var buildFilesForField = exports.buildFilesForField = function buildFilesForField(field, record_id) {
    var completedFiles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var inProgressFiles = _FileUploadStore2.default.getInProgressFilesByField(field, record_id);
    var allFiles = completedFiles.concat(inProgressFiles);
    allFiles.sort(function (a, b) {
        return a._index <= b._index;
    });
    return allFiles;
};

// add extra meta data to the file.
var buildFileMeta = exports.buildFileMeta = function buildFileMeta(fieldKey, recordId, org, entityKey, multiValued, file) {
    var keyArr = entityKey.split("/");

    return _extends({}, file, {
        id: file.id,
        filename: file.filename,
        contentType: file.contentType,
        size: file.size,

        _data: file._data,

        _org: org,
        _impl: keyArr[0],
        _version: keyArr[1],
        _entity: keyArr[2],
        _field: fieldKey,
        _record_id: recordId,
        _index: file._index,
        _multiValued: multiValued
    });
};

var buildFileUrl = exports.buildFileUrl = function buildFileUrl(file) {
    if (file._status !== Hybrid.FileInfo.FILEUPLOADSTATES.COMPLETE) {
        return window.URL.createObjectURL(file._data);
    } else {
        var url = _Services2.default.url([file._org, file._impl, file._version, file._entity, file._record_id, "fields", file._field, "files", file.id, file.filename]);

        // TODO: it might be better to make a get request and get the url from there.
        // that way, if we add the appropriate patterns to mock_config.js
        // this check below won't be necessary. the existing machinery will take care of
        // the url redirection/rewriting when an ajax request is made and there is a pattern in place.
        // however, the response data will be the raw file data which obviously can't be parsed
        // as JSON, thus resulting in an ajax error.
        if (_BaseServices2.default.__mocked) {
            return window.HybridConfig.mockRoot + url.split("/").slice(window.HybridConfig.apiRoot.split("/")
            // filter out empty values (e.g.: '')
            .filter(function (x) {
                return x;
            }).length).join("/");
        }

        return url;
    }
};

// preview a file in new window. handles completed vs in-progress.
var previewFile = exports.previewFile = function previewFile(file) {
    var url = buildFileUrl(file);
    if (file._status !== Hybrid.FileInfo.FILEUPLOADSTATES.COMPLETE) {
        window.open(url, "_blank").addEventListener("load", function () {
            return window.URL.revokeObjectURL(url);
        }, { once: true });
    } else {
        window.open(url, "_blank");
    }
};

/***/ }),
/* 350 */,
/* 351 */,
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ControlResolver = __webpack_require__(139);

exports.default = function (props) {
  return (0, _ControlResolver.buildDescriptorControl)("StringField", "label", props);
};

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InlineLoader = function InlineLoader(_ref) {
    var _ref$message = _ref.message,
        message = _ref$message === undefined ? "Loading..." : _ref$message;
    return _react2.default.createElement(
        "span",
        null,
        _react2.default.createElement("img", { src: "images/waiting.svg",
            alt: message,
            className: "infinite-spin",
            style: {
                display: "inline-block",
                height: "1.5em",
                marginRight: "0.5em"
            }
        }),
        message
    );
};

InlineLoader.propTypes = {
    message: _propTypes2.default.string
};

exports.default = InlineLoader;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _utils = __webpack_require__(13);

var _BrowserActions = __webpack_require__(616);

var _BrowserActions2 = _interopRequireDefault(_BrowserActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var measureWindow = function measureWindow() {
    return {
        height: window.innerHeight,
        width: window.innerWidth
    };
};

var BrowserStore = function (_ReduceStore) {
    _inherits(BrowserStore, _ReduceStore);

    function BrowserStore() {
        _classCallCheck(this, BrowserStore);

        return _possibleConstructorReturn(this, (BrowserStore.__proto__ || Object.getPrototypeOf(BrowserStore)).apply(this, arguments));
    }

    _createClass(BrowserStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {
                size: measureWindow()
            };
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {

                case _BrowserActions2.default.RESIZE:
                    {
                        return _extends({}, state, {
                            size: measureWindow()
                        });
                    }

                default:
                    return state;
            }
        }
    }, {
        key: "getSize",
        value: function getSize() {
            return this.getState().size;
        }
    }]);

    return BrowserStore;
}(_utils.ReduceStore);

BrowserStore.stateTypes = {
    size: _propTypes2.default.shape({
        height: _propTypes2.default.number.isRequired,
        width: _propTypes2.default.number.isRequired
    }).isRequired
};

exports.default = (0, _typeCheckingStore2.default)(new BrowserStore(_Dispatcher2.default));

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _TreeItemTypes = __webpack_require__(621);

var _TreeItemTypes2 = _interopRequireDefault(_TreeItemTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TreeItemActions = {
    collapseAll: function collapseAll(ctx) {
        _Dispatcher2.default.contextDispatch(ctx, {
            type: _TreeItemTypes2.default.COLLAPSE_ALL
        });
    },
    expandAll: function expandAll(ctx) {
        _Dispatcher2.default.contextDispatch(ctx, {
            type: _TreeItemTypes2.default.EXPAND_ALL
        });
    },
    childCollapseOrExpand: function childCollapseOrExpand(ctx, key) {
        _Dispatcher2.default.contextDispatch(ctx, {
            type: _TreeItemTypes2.default.COLLAPSE_OR_EXPAND,
            key: key
        });
    }
};

exports.default = TreeItemActions;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validationTreeItemType = exports.itemType = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(0);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var states = ["blocking", "illegal", "warning",
// "unusual",
// "missing",
"ok", "unknown"];

var item = {
    message: _propTypes.string.isRequired,
    state: (0, _propTypes.oneOf)(states).isRequired,
    nestedState: (0, _propTypes.oneOf)(states).isRequired,
    cid: _propTypes.string.isRequired,
    entityKey: _propTypes.string.isRequired,
    recordId: (0, _propTypes.oneOfType)([_ClientId2.default.propType, _propTypes.number]).isRequired,

    // only for non-leaves
    children: _propTypes.array,

    // only for fields...
    fieldKey: _propTypes.string
};

var itemType = exports.itemType = (0, _propTypes.shape)(_extends({}, item));

var validationTreeItemType = exports.validationTreeItemType = _extends({
    collapsedAll: _propTypes.bool,
    expandedAll: _propTypes.bool
}, item, {
    onNavToField: _propTypes.func.isRequired
});

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrganizationsStore = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _utils = __webpack_require__(13);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _UserActions = __webpack_require__(123);

var _UserActions2 = _interopRequireDefault(_UserActions);

var _slices = __webpack_require__(172);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrganizationsStore = exports.OrganizationsStore = function (_ReduceStore) {
    _inherits(OrganizationsStore, _ReduceStore);

    function OrganizationsStore() {
        _classCallCheck(this, OrganizationsStore);

        return _possibleConstructorReturn(this, (OrganizationsStore.__proto__ || Object.getPrototypeOf(OrganizationsStore)).apply(this, arguments));
    }

    _createClass(OrganizationsStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return (0, _slices.newSlice)();
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {
                case _UserActions2.default.LOADED:
                    {
                        var u = action.user;
                        return (0, _slices.concatSlice)(state, (0, _slices.toSlice)(u.organizations, "key", function (o) {
                            return {
                                key: o.key,
                                name: o.name,
                                accessible: true
                            };
                        }), (0, _slices.toSlice)(u.extraDescendantOrgs, "key"));
                    }

                default:
                    return state;
            }
        }
    }, {
        key: "getKeyLookup",
        value: function getKeyLookup() {
            return this.getState().byKey;
        }
    }]);

    return OrganizationsStore;
}(_utils.ReduceStore);

OrganizationsStore.stateTypes = (0, _slices.sliceTypeBuilder)(_propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired
}));

var organizationsStore = (0, _typeCheckingStore2.default)(new OrganizationsStore(_Dispatcher2.default));

exports.default = organizationsStore;

/***/ }),
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createDraggable = exports.createCloseable = exports.itview = exports.extend = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.extendRight = extendRight;
exports.extendLeft = extendLeft;
exports.setUpDOM = setUpDOM;

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _DevelopmentActions = __webpack_require__(98);

var _DevelopmentActions2 = _interopRequireDefault(_DevelopmentActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * decaffeinate suggestions:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DS102: Remove unnecessary code created because of implicit returns
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DS203: Remove `|| {}` from converted for-own loops
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DS205: Consider reworking code to avoid use of IIFEs
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DS206: Consider reworking classes to avoid initClass
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DS207: Consider shorter variations of null checks
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


function extendRight(base) {
    for (var _len = arguments.length, others = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        others[_key - 1] = arguments[_key];
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = others[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var other = _step.value;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Object.keys(other || {})[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var key = _step2.value;

                    base[key] = other[key];
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return base;
}

function extendLeft(base) {
    for (var _len2 = arguments.length, others = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        others[_key2 - 1] = arguments[_key2];
    }

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = others[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var other = _step3.value;
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = Object.keys(other || {})[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var key = _step4.value;

                    if (!base.hasOwnProperty(key)) {
                        base[key] = other[key];
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    return base;
}

var extend = exports.extend = extendRight;

var WindowView = function (_Backbone$Marionette$) {
    _inherits(WindowView, _Backbone$Marionette$);

    function WindowView() {
        _classCallCheck(this, WindowView);

        return _possibleConstructorReturn(this, (WindowView.__proto__ || Object.getPrototypeOf(WindowView)).apply(this, arguments));
    }

    _createClass(WindowView, null, [{
        key: "initClass",
        value: function initClass() {
            this.prototype.template = __webpack_require__(1598);
        }
    }]);

    return WindowView;
}(Backbone.Marionette.CompositeView);

WindowView.initClass();

var StringView = function (_Backbone$Marionette$2) {
    _inherits(StringView, _Backbone$Marionette$2);

    function StringView() {
        _classCallCheck(this, StringView);

        return _possibleConstructorReturn(this, (StringView.__proto__ || Object.getPrototypeOf(StringView)).apply(this, arguments));
    }

    _createClass(StringView, [{
        key: "template",
        value: function template(model) {
            return model.body;
        }
    }], [{
        key: "initClass",
        value: function initClass() {
            this.prototype.tagName = "li";
        }
    }]);

    return StringView;
}(Backbone.Marionette.ItemView);

StringView.initClass();

var ErrorList = function (_Backbone$Marionette$3) {
    _inherits(ErrorList, _Backbone$Marionette$3);

    function ErrorList() {
        _classCallCheck(this, ErrorList);

        return _possibleConstructorReturn(this, (ErrorList.__proto__ || Object.getPrototypeOf(ErrorList)).apply(this, arguments));
    }

    _createClass(ErrorList, null, [{
        key: "initClass",
        value: function initClass() {
            this.prototype.template = __webpack_require__(1599);
            this.prototype.itemView = StringView;
            this.prototype.itemViewContainer = "ul";
        }
    }]);

    return ErrorList;
}(Backbone.Marionette.CompositeView);

ErrorList.initClass();

var windowCount = 0;
var itwindow = function itwindow(type, title) {
    var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

    var hoffset = windowCount % 5;
    var voffset = Math.floor(windowCount / 5);
    windowCount += 1;
    if (typeof body === "string") {
        body = new StringView({
            model: new Backbone.Model({
                body: body
            })
        });
    }
    var w = itview(new WindowView({
        model: new Backbone.Model({
            top: 15 + hoffset * 5 + voffset * 3,
            left: 30 + hoffset * 5 - voffset,
            type: type != null ? type : "default",
            title: title
        })
    }));
    body.setElement(w.find(".panel-body")).render();
    return w;
};

var itview = exports.itview = function itview(view) {
    var $el = void 0;
    if ($("#IT-UI").length === 0) {
        $("body").append("<div id=\"IT-UI\"></div>");
    }
    $("#IT-UI").append($el = $("<div></div>"));
    view.setElement($el).render();
    return $el.find(".IT-window");
};

var createCloseable = exports.createCloseable = function createCloseable(closeableSelector, triggerSubselector) {
    return $("body").on("click", closeableSelector + " " + triggerSubselector, function () {
        return $(this).parents(closeableSelector).first().remove();
    });
};

var createDraggable = exports.createDraggable = function createDraggable(draggableSelector, handleSubselector) {
    var getMaxZIndex = function getMaxZIndex(except) {
        return $(draggableSelector).not(except).map(function () {
            return parseInt($(this).css("z-index"));
        }).sort(function (a, b) {
            return b - a;
        })[0];
    };
    return $("body").on("mousedown", draggableSelector + " " + handleSubselector, function (e) {
        e.preventDefault();
        var $this = $(this).css({ cursor: "move" });
        var $draggable = $this.parents(draggableSelector).first();
        var maxZIndex = getMaxZIndex($draggable.get(0));
        var ps = $draggable.css("z-index", maxZIndex + 1).offset();
        var ds = {
            left: e.pageX,
            top: e.pageY
        };
        var recalc = function recalc(e) {
            var de = {
                left: e.pageX,
                top: e.pageY
            };
            var css = {
                left: ps.left + de.left - ds.left + "px",
                top: ps.top + de.top - ds.top + "px"
            };
            return $draggable.css(css);
        };
        var handleMove = null;
        handleMove = function handleMove(e) {
            e.preventDefault();
            return recalc(e);
        };
        var _handleUp = null;
        _handleUp = function handleUp(e) {
            e.preventDefault();
            $this.css({ cursor: "auto" });
            $("body").off("mouseup", _handleUp).off("mousemove", handleMove);
            return recalc(e);
        };
        return $("body").on("mouseup", _handleUp).on("mousemove", handleMove);
    }).on("click", draggableSelector, function () {
        var maxZIndex = getMaxZIndex(this);
        return $(this).css("z-index", maxZIndex + 1);
    });
};

var sendStatusMessage = function sendStatusMessage(body) {
    return (
        // eslint-disable-next-line no-restricted-globals
        top.postMessage("test-status:" + body, "*")
    );
};

function setUpDOM() {
    $("body").addClass("IT-pending");
    sendStatusMessage("pending");
    createCloseable(".IT-window", ".close");
    return createDraggable(".IT-window", ".panel-heading");
}

var error = function error(e) {
    return itwindow("danger", "Error!", e instanceof Error ? e.message : e);
};

var info = function info(title, message) {
    return itwindow("info", title, message);
};

var complete = function complete() {
    var success = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    var $body = $("body");
    $body.removeClass("IT-pending").addClass(success ? "IT-success" : "IT-error").addClass("IT-complete");
    if (success) {
        sendStatusMessage("success");
        _Dispatcher2.default.dispatch({
            type: _DevelopmentActions2.default.IT_TEST_SUCCESS
        });
    } else {
        var message = $body.data("error");
        sendStatusMessage("error:" + message);
        _Dispatcher2.default.dispatch({
            type: _DevelopmentActions2.default.IT_TEST_ERROR,
            message: message
        });
    }
    return sendStatusMessage("complete");
};

var addErrorData = function addErrorData(e) {
    var $body = $("body");
    if ($body.data("error") == null) {
        if (e instanceof Error) {
            $body.attr("data-error", e.message);
            return $body.attr("data-coords", e.line + ":" + e.column);
        } else {
            return $body.attr("data-error", e);
        }
    }
};

exports.default = {
    extend: extend,
    extendLeft: extendLeft,
    extendRight: extendRight,
    itview: itview,
    createCloseable: createCloseable,
    createDraggable: createDraggable,
    setUpDOM: setUpDOM,
    error: error,
    info: info,
    complete: complete,
    addErrorData: addErrorData
};

/***/ }),
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _formhelpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Label = function (_React$Component) {
    _inherits(Label, _React$Component);

    function Label() {
        _classCallCheck(this, Label);

        return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
    }

    _createClass(Label, [{
        key: "render",
        value: function render() {
            var value = this.props.value;

            return _react2.default.createElement(
                _ControlTemplate2.default,
                _extends({}, this.props, { className: "association-field" }),
                _react2.default.createElement(
                    "span",
                    null,
                    value
                )
            );
        }
    }]);

    return Label;
}(_react2.default.Component);

exports.default = Label;


Label.propTypes = (0, _formhelpers.controlPropTypes)();

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function isMissing(value) {
    if (value instanceof Array) {
        return value.length === 0;
    } else if (typeof value === "string") {
        return !value;
    } else if (typeof value === "number") {
        return isNaN(value);
    } else {
        return value == null;
    }
}

exports.default = isMissing;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = __webpack_require__(213);

var _Select2 = _interopRequireDefault(_Select);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _formhelpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Recordbrowser = function (_React$Component) {
    _inherits(Recordbrowser, _React$Component);

    function Recordbrowser(props) {
        _classCallCheck(this, Recordbrowser);

        var _this = _possibleConstructorReturn(this, (Recordbrowser.__proto__ || Object.getPrototypeOf(Recordbrowser)).call(this, props));

        _this.onRecordbrowserClick = _this.onRecordbrowserClick.bind(_this);
        return _this;
    }

    _createClass(Recordbrowser, [{
        key: "onRecordbrowserClick",
        value: function onRecordbrowserClick(e) {
            var _props = this.props,
                onRecordbrowserClick = _props.onRecordbrowserClick,
                descriptor = _props.descriptor;

            onRecordbrowserClick && onRecordbrowserClick(e, descriptor);
        }
    }, {
        key: "render",
        value: function render() {
            var _props2 = this.props,
                options = _props2.options,
                descriptor = _props2.descriptor,
                isLoading = _props2.isLoading,
                enabled = _props2.enabled;

            var config = descriptor.config || {};
            var showRecordBrowserIcon = config.showRecordBrowserIcon == null || config.showRecordBrowserIcon;
            return _react2.default.createElement(
                _ControlTemplate2.default,
                _extends({}, this.props, { className: "association-field" }),
                _react2.default.createElement(
                    "div",
                    { className: showRecordBrowserIcon ? "input-group" : "" },
                    _react2.default.createElement(_Select2.default, _extends({}, this.props, {
                        options: options,
                        valueKey: config.valueKey || "name",
                        labelKey: config.labelKey || "display",
                        addMissing: true
                    })),
                    showRecordBrowserIcon && enabled && _react2.default.createElement(
                        "span",
                        { className: "input-group-addon record_browser_icon_container", onClick: this.onRecordbrowserClick },
                        _react2.default.createElement("span", { className: "glyphicon glyphicon-search icon-search" })
                    ),
                    isLoading && _react2.default.createElement(
                        "div",
                        { className: "local-over-modal" },
                        "Searching..."
                    )
                )
            );
        }
    }]);

    return Recordbrowser;
}(_react2.default.Component);

exports.default = Recordbrowser;


Recordbrowser.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)({
    otherEntityKey: _propTypes2.default.string.isRequired,
    autoSelectOnlyOption: _propTypes2.default.bool,
    showRecordBrowserIcon: _propTypes2.default.bool
}), {
    onRecordbrowserClick: _propTypes2.default.func,
    isLoading: _propTypes2.default.bool
});

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Typeahead = __webpack_require__(291);

var _Typeahead2 = _interopRequireDefault(_Typeahead);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _formhelpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssociationTypeahead = function (_React$Component) {
    _inherits(AssociationTypeahead, _React$Component);

    function AssociationTypeahead() {
        _classCallCheck(this, AssociationTypeahead);

        return _possibleConstructorReturn(this, (AssociationTypeahead.__proto__ || Object.getPrototypeOf(AssociationTypeahead)).apply(this, arguments));
    }

    _createClass(AssociationTypeahead, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                descriptor = _props.descriptor,
                value = _props.value,
                options = _props.options,
                columns = _props.columns,
                valueKey = _props.valueKey,
                labelKey = _props.labelKey;

            var config = descriptor.config || { options: [] };
            return _react2.default.createElement(
                _ControlTemplate2.default,
                _extends({}, this.props, { className: "association-field", extraProps: { style: { display: "block" } } }),
                _react2.default.createElement(_Typeahead2.default, _extends({}, this.props, {
                    value: value,
                    options: options || config.options,
                    columns: columns || config.columns,
                    valueKey: valueKey || config.valueKey,
                    labelKey: labelKey || config.labelKey,
                    multiValued: config.multiValued,
                    mode: config.mode,
                    addMissing: config.autoSelectFirstItem !== undefined ? config.autoSelectFirstItem : false,
                    statusMessage: config.statusMessage,
                    showRecordBrowserIcon: config.showRecordBrowserIcon,
                    autoSelectFirstItem: config.autoSelectFirstItem,
                    autoSelectOnlyOption: config.autoSelectOnlyOption,
                    keepSelectionInList: config.keepSelectionInList !== undefined ? config.keepSelectionInList : !config.multiValued
                }))
            );
        }
    }]);

    return AssociationTypeahead;
}(_react2.default.Component);

exports.default = AssociationTypeahead;


AssociationTypeahead.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)({
    options: _propTypes2.default.arrayOf(_propTypes2.default.object),
    columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        includeInFilter: _propTypes2.default.bool,
        isSortable: _propTypes2.default.bool,
        key: _propTypes2.default.string.isRequired,
        label: _propTypes2.default.string.isRequired
    })),
    multiValued: _propTypes2.default.bool.isRequired,
    mode: _propTypes2.default.oneOf(["client", "server"]),
    otherEntityKey: _propTypes2.default.string,
    valueKey: _propTypes2.default.string,
    labelKey: _propTypes2.default.string,
    addMissing: _propTypes2.default.bool,
    showRecordBrowserIcon: _propTypes2.default.bool,
    autoSelectFirstItem: _propTypes2.default.bool,
    autoSelectOnlyOption: _propTypes2.default.bool
}), {

    // Value is assumed to be the inflated value(s) or null. Meaning an object
    // with {[valueKey]: ... , [labelKey]: ... } or array of those objects.
    // This is different from how the jQuery control worked which only supplied
    // the value string(s) and expected the inflated value to exist in the
    // options list.
    value: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.arrayOf(_propTypes2.default.object)]),

    options: _propTypes2.default.arrayOf(_propTypes2.default.object),
    onRecordbrowserClick: _propTypes2.default.func,
    onSearch: _propTypes2.default.func,
    valueKey: _propTypes2.default.string,
    labelKey: _propTypes2.default.string,

    // these are required for server lists
    isLoading: _propTypes2.default.bool,
    isPartial: _propTypes2.default.bool,
    isError: _propTypes2.default.bool
});

/***/ }),
/* 446 */,
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _formhelpers = __webpack_require__(5);

var _Checkbox = __webpack_require__(906);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = function (_React$Component) {
    _inherits(Checkbox, _React$Component);

    function Checkbox(props) {
        _classCallCheck(this, Checkbox);

        var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));

        _this.onCommitChange = _this.onCommitChange.bind(_this);
        return _this;
    }

    _createClass(Checkbox, [{
        key: "onCommitChange",
        value: function onCommitChange(descriptor, value) {
            var onCommitChange = this.props.onCommitChange;

            onCommitChange && onCommitChange(descriptor, value);
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                descriptor = _props.descriptor,
                controlOnly = _props.controlOnly,
                enabled = _props.enabled,
                placeholder = _props.placeholder;

            var selector = "control-container-" + descriptor.key;

            if (descriptor.disableBehaviour === "hide" && !enabled) {
                // control is disabled and should be hidden.
                return null;
            }

            var control = void 0;
            if (placeholder || !controlOnly) {
                control = _react2.default.createElement(
                    "label",
                    null,
                    _react2.default.createElement(_Checkbox2.default, _extends({}, this.props, {
                        onCommitChange: this.onCommitChange
                    })),
                    descriptor.label
                );
            } else {
                control = _react2.default.createElement(_Checkbox2.default, _extends({}, this.props, {
                    onCommitChange: this.onCommitChange
                }));
            }
            var ControlContainer = _react2.default.createElement(
                "div",
                {
                    id: descriptor.id,
                    className: selector + " " + (placeholder ? "checkbox" : "") + " control react-control checkbox-field " + (controlOnly ? "control-only" : ""),
                    "data-control-type": descriptor.control,
                    "data-shortname": descriptor.key
                },
                control
            );

            if (controlOnly) {
                return ControlContainer;
            }

            return _react2.default.createElement(
                "div",
                { className: "form-item" },
                _react2.default.createElement("div", { className: "left-side" }),
                _react2.default.createElement(
                    "div",
                    { className: "right-side checkbox" },
                    ControlContainer
                )
            );
        }
    }]);

    return Checkbox;
}(_react2.default.Component);

exports.default = Checkbox;


Checkbox.propTypes = (0, _formhelpers.controlPropTypes)({
    copyOnClickMappings: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        source: _propTypes2.default.string.isRequired,
        target: _propTypes2.default.string.isRequired
    })),
    checkedValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool, _propTypes2.default.number]),
    uncheckedValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool, _propTypes2.default.number])
});

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Dropdown;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(213);

var _Select2 = _interopRequireDefault(_Select);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _formhelpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Dropdown(props) {
    var options = props.options,
        descriptor = props.descriptor;

    var config = descriptor.config || {};

    return _react2.default.createElement(
        _ControlTemplate2.default,
        _extends({}, props, { className: "choice-field" }),
        _react2.default.createElement(_Select2.default, _extends({}, props, {
            options: options,
            valueKey: config.valueKey || "name",
            labelKey: config.labelKey || "label",
            addMissing: true
        }))
    );
}

Dropdown.propTypes = (0, _formhelpers.controlPropTypes)(undefined, true);

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _formhelpers = __webpack_require__(5);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Label = function (_React$Component) {
    _inherits(Label, _React$Component);

    function Label() {
        _classCallCheck(this, Label);

        return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
    }

    _createClass(Label, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                choiceKey = _props.choiceKey,
                value = _props.value;


            var valueStr = "";
            if (Array.isArray(value)) {
                valueStr = ArmusScript["toOptionLabel(Array<String>,String)"](value, choiceKey).join(", ");
            } else if (value) {
                valueStr = ArmusScript["toOptionLabel(String,String)"](value, choiceKey);
            }
            return _react2.default.createElement(
                _ControlTemplate2.default,
                _extends({}, this.props, { className: "choice-field" }),
                _react2.default.createElement(
                    "span",
                    null,
                    valueStr
                )
            );
        }
    }]);

    return Label;
}(_react2.default.Component);

exports.default = Label;


Label.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)(), {
    choiceKey: _propTypes2.default.string.isRequired
});

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Typeahead = __webpack_require__(291);

var _Typeahead2 = _interopRequireDefault(_Typeahead);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _formhelpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChoiceTypeahead = function (_React$Component) {
    _inherits(ChoiceTypeahead, _React$Component);

    function ChoiceTypeahead() {
        _classCallCheck(this, ChoiceTypeahead);

        return _possibleConstructorReturn(this, (ChoiceTypeahead.__proto__ || Object.getPrototypeOf(ChoiceTypeahead)).apply(this, arguments));
    }

    _createClass(ChoiceTypeahead, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                descriptor = _props.descriptor,
                value = _props.value,
                options = _props.options,
                columns = _props.columns,
                valueKey = _props.valueKey,
                labelKey = _props.labelKey;

            var config = descriptor.config || { options: [] };
            return _react2.default.createElement(
                _ControlTemplate2.default,
                _extends({}, this.props, { className: "choice-field", extraProps: { style: { display: "block" } } }),
                _react2.default.createElement(_Typeahead2.default, _extends({}, this.props, {
                    value: value,
                    options: options || config.options,
                    columns: columns || config.columns,
                    valueKey: valueKey || config.valueKey,
                    labelKey: labelKey || config.labelKey,
                    multiValued: config.multiValued,
                    mode: config.mode,
                    addMissing: config.autoSelectFirstItem !== undefined ? config.autoSelectFirstItem : !config.multiValued,
                    statusMessage: config.statusMessage,
                    showRecordBrowserIcon: config.showRecordBrowserIcon,
                    showSelectAll: config.showSelectAll,
                    autoSelectFirstItem: config.autoSelectFirstItem,
                    autoSelectOnlyOption: config.autoSelectOnlyOption,
                    keepSelectionInList: config.keepSelectionInList !== undefined ? config.keepSelectionInList : !config.multiValued
                }))
            );
        }
    }]);

    return ChoiceTypeahead;
}(_react2.default.Component);

exports.default = ChoiceTypeahead;


ChoiceTypeahead.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)({
    options: _propTypes2.default.arrayOf(_propTypes2.default.object),
    columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        includeInFilter: _propTypes2.default.bool,
        isSortable: _propTypes2.default.bool,
        key: _propTypes2.default.string.isRequired,
        label: _propTypes2.default.string.isRequired
    })),
    multiValued: _propTypes2.default.bool.isRequired,
    mode: _propTypes2.default.oneOf(["client", "server"]),
    otherEntityKey: _propTypes2.default.string,
    valueKey: _propTypes2.default.string,
    labelKey: _propTypes2.default.string,
    addMissing: _propTypes2.default.bool,
    showRecordBrowserIcon: _propTypes2.default.bool,
    showSelectAll: _propTypes2.default.bool,
    autoSelectFirstItem: _propTypes2.default.bool,
    autoSelectOnlyOption: _propTypes2.default.bool,

    // TODO: This seems like a propsResolver concern. It was used to listen
    // and update the control on "RECORD" changes.
    otherEntityType: _propTypes2.default.string
}), {

    // Value is assumed to be the inflated value(s) or null. Meaning an object
    // with {[valueKey]: ... , [labelKey]: ... } or array of those objects.
    // This is different from how the jQuery control worked which only supplied
    // the value string(s) and expected the inflated value to exist in the
    // options list.
    value: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.arrayOf(_propTypes2.default.object)]),

    onRecordbrowserClick: _propTypes2.default.func,
    onSearch: _propTypes2.default.func,
    valueKey: _propTypes2.default.string,
    labelKey: _propTypes2.default.string
});

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _DateInput = __webpack_require__(292);

var _DateInput2 = _interopRequireDefault(_DateInput);

var _formhelpers = __webpack_require__(5);

var _MaskConstants = __webpack_require__(219);

var _MaskConstants2 = _interopRequireDefault(_MaskConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Calendar = function (_React$Component) {
    _inherits(Calendar, _React$Component);

    function Calendar() {
        _classCallCheck(this, Calendar);

        return _possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).apply(this, arguments));
    }

    _createClass(Calendar, [{
        key: "render",
        value: function render() {
            var descriptor = this.props.descriptor;
            var granularity = descriptor.config.granularity;


            var format = _MaskConstants2.default.armus_date_day;
            var showCalendar = true;
            if (granularity === "DAY") {
                format = _MaskConstants2.default.armus_date_day;
                showCalendar = true;
            } else if (granularity === "MONTH") {
                format = _MaskConstants2.default.armus_date_month;
                showCalendar = true;
            } else if (granularity === "YEAR") {
                format = _MaskConstants2.default.armus_date_year;
                showCalendar = true;
            }

            return _react2.default.createElement(
                _ControlTemplate2.default,
                _extends({}, this.props, { className: "date-field" }),
                _react2.default.createElement(_DateInput2.default, _extends({}, this.props, {
                    maskFormat: format,
                    showCalendar: showCalendar
                }))
            );
        }
    }]);

    return Calendar;
}(_react2.default.Component);

exports.default = Calendar;


Calendar.propTypes = (0, _formhelpers.controlPropTypes)({
    granularity: _propTypes2.default.string
});

/***/ }),
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _formhelpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Label = function (_React$Component) {
    _inherits(Label, _React$Component);

    function Label() {
        _classCallCheck(this, Label);

        return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
    }

    _createClass(Label, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                descriptor = _props.descriptor,
                value = _props.value;

            var valueStr = ArmusScript["dateFormat(Date,String)"](value, descriptor.config.mask) || "";
            return _react2.default.createElement(
                _ControlTemplate2.default,
                _extends({}, this.props, { className: "date-field" }),
                _react2.default.createElement(
                    "span",
                    null,
                    valueStr
                )
            );
        }
    }]);

    return Label;
}(_react2.default.Component);

exports.default = Label;


Label.propTypes = (0, _formhelpers.controlPropTypes)();

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _formhelpers = __webpack_require__(5);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Label = function (_React$Component) {
    _inherits(Label, _React$Component);

    function Label() {
        _classCallCheck(this, Label);

        return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
    }

    _createClass(Label, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                descriptor = _props.descriptor,
                value = _props.value;

            var valueStr = ArmusScript["numberFormat(Number,String)"](value, descriptor.config.mask) || "";
            return _react2.default.createElement(
                _ControlTemplate2.default,
                _extends({}, this.props, { className: "decimal-field" }),
                _react2.default.createElement(
                    "span",
                    null,
                    valueStr
                )
            );
        }
    }]);

    return Label;
}(_react2.default.Component);

exports.default = Label;


Label.propTypes = (0, _formhelpers.controlPropTypes)({
    mask: _propTypes2.default.string.isRequired
});

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Text;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Input = __webpack_require__(215);

var _Input2 = _interopRequireDefault(_Input);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _formhelpers = __webpack_require__(5);

var _alertAndRefocusBuilder = __webpack_require__(461);

var _alertAndRefocusBuilder2 = _interopRequireDefault(_alertAndRefocusBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Text(props) {
    return _react2.default.createElement(
        _ControlTemplate2.default,
        _extends({}, props, { className: "decimal-field" }),
        _react2.default.createElement(_Input2.default, _extends({}, props, {
            valueType: _Input.INPUT_VALUE_TYPES.DECIMAL,
            onIllegal: (0, _alertAndRefocusBuilder2.default)(props)
        }))
    );
}

Text.propTypes = (0, _formhelpers.controlPropTypes)();

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.alertAndRefocusBuilder = undefined;

var _withOver = __webpack_require__(58);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _NavigationActions = __webpack_require__(80);

var _NavigationActions2 = _interopRequireDefault(_NavigationActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var alertAndRefocusBuilder = exports.alertAndRefocusBuilder = function alertAndRefocusBuilder(controlProps) {
    var entityForm = controlProps.entityForm,
        activeRecord = controlProps.activeRecord,
        descriptor = controlProps.descriptor;

    return function (msg) {
        return (0, _withOver.appAlert)(msg, function () {
            if (entityForm) {
                _Dispatcher2.default.contextDispatch(entityForm.fluxContext, {
                    type: _NavigationActions2.default.FOCUS_FIELD,
                    entityKey: activeRecord.entityKey,
                    recordId: activeRecord.id,
                    fieldKey: descriptor.key
                });
                return;
            }
            if (!descriptor) return;
            if (!descriptor.id) return;
            var el = document.querySelector("#" + descriptor.id + " .focusable, #" + descriptor.id + " input, #" + descriptor.id + " select");
            if (!el) return;
            // I allow the "close the alert" event (which we don't have access to
            // here) to finish itself before focus is placed. If it's a mouse click
            // then that click event will end up focusing the button at the very
            // end, making this focus request irrelevant.
            //
            // eslint-disable-next-line no-settimeout
            setTimeout(function () {
                if (!document.body.contains(el)) return;
                try {
                    el.focus();
                } catch (e) {
                    console.warn("failed to focus #" + descriptor.id, el, e);
                }
            });
        });
    };
};

exports.default = alertAndRefocusBuilder;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _flux = __webpack_require__(927);

var _ContextedReduceStore = __webpack_require__(30);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContextedDispatcher = function (_Dispatcher) {
    _inherits(ContextedDispatcher, _Dispatcher);

    function ContextedDispatcher() {
        _classCallCheck(this, ContextedDispatcher);

        return _possibleConstructorReturn(this, (ContextedDispatcher.__proto__ || Object.getPrototypeOf(ContextedDispatcher)).apply(this, arguments));
    }

    _createClass(ContextedDispatcher, [{
        key: "contextDispatch",
        value: function contextDispatch(context, payload) {
            payload[_ContextedReduceStore.ACTION_CONTEXT_KEY] = context;
            _get(ContextedDispatcher.prototype.__proto__ || Object.getPrototypeOf(ContextedDispatcher.prototype), "dispatch", this).call(this, payload);
        }
    }]);

    return ContextedDispatcher;
}(_flux.Dispatcher);

exports.default = ContextedDispatcher;

/***/ }),
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _formhelpers = __webpack_require__(5);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FileFieldRow = __webpack_require__(940);

var _FileFieldRow2 = _interopRequireDefault(_FileFieldRow);

var _keyEvents = __webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FileField = function (_React$Component) {
    _inherits(FileField, _React$Component);

    function FileField(props) {
        _classCallCheck(this, FileField);

        var _this = _possibleConstructorReturn(this, (FileField.__proto__ || Object.getPrototypeOf(FileField)).call(this, props));

        _this.inputRef = _react2.default.createRef();
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onClick = _this.onClick.bind(_this);
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.onFileUpload = _this.onFileUpload.bind(_this);
        _this.onFileOpen = _this.onFileOpen.bind(_this);
        _this.onFileRemove = _this.onFileRemove.bind(_this);
        return _this;
    }

    _createClass(FileField, [{
        key: "onFocus",
        value: function onFocus(e) {
            var _props = this.props,
                descriptor = _props.descriptor,
                onFocus = _props.onFocus;

            onFocus && onFocus(e, descriptor);
        }
    }, {
        key: "onBlur",
        value: function onBlur(e) {
            var _props2 = this.props,
                descriptor = _props2.descriptor,
                onBlur = _props2.onBlur;

            onBlur && onBlur(e, descriptor);
        }
    }, {
        key: "onClick",
        value: function onClick(e) {
            var _props3 = this.props,
                descriptor = _props3.descriptor,
                onClick = _props3.onClick;

            onClick && onClick(e, descriptor);
        }
    }, {
        key: "onKeyDown",
        value: function onKeyDown(e) {
            var _props4 = this.props,
                descriptor = _props4.descriptor,
                onKeyDown = _props4.onKeyDown;

            var keyDownName = (0, _keyEvents.processKeyName)(e.key);
            if (["Enter", " "].includes(keyDownName)) {
                this.inputRef.current.click();
                e.preventDefault();
                e.stopPropagation();
                return;
            }
            onKeyDown && onKeyDown(e, descriptor);
        }
    }, {
        key: "onFileUpload",
        value: function onFileUpload(e) {
            var _props5 = this.props,
                descriptor = _props5.descriptor,
                onFileUpload = _props5.onFileUpload;

            onFileUpload && onFileUpload(e, descriptor, e.target.files);
        }
    }, {
        key: "onFileOpen",
        value: function onFileOpen(e, file, index) {
            var _props6 = this.props,
                descriptor = _props6.descriptor,
                onFileOpen = _props6.onFileOpen;

            onFileOpen && onFileOpen(e, descriptor, file, index);
        }
    }, {
        key: "onFileRemove",
        value: function onFileRemove(e, file, index) {
            var _props7 = this.props,
                descriptor = _props7.descriptor,
                onFileRemove = _props7.onFileRemove;

            onFileRemove && onFileRemove(e, descriptor, file, index);
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props8 = this.props,
                files = _props8.files,
                descriptor = _props8.descriptor,
                style = _props8.style,
                enabled = _props8.enabled,
                multiSelect = _props8.multiSelect,
                readOnly = _props8.readOnly;

            var config = descriptor.config || {};
            var items = _react2.default.createElement(
                "div",
                { className: "row" },
                _react2.default.createElement(
                    "div",
                    { className: "file-list container-fluid" },
                    files.map(function (file, i) {
                        return _react2.default.createElement(_FileFieldRow2.default, {
                            key: i,
                            readOnly: readOnly,
                            onFileOpen: _this2.onFileOpen,
                            onFileRemove: _this2.onFileRemove,
                            file: file,
                            index: i
                        });
                    })
                )
            );

            if (readOnly) return items;

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                items,
                _react2.default.createElement(
                    "div",
                    { className: "row" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-6" },
                        _react2.default.createElement(
                            "a",
                            {
                                href: "#",
                                className: "form-control focusable btn btn-default btn-file",
                                onClick: this.onClick,
                                onKeyDown: this.onKeyDown,
                                onFocus: this.onFocus,
                                onBlur: this.onBlur
                            },
                            _react2.default.createElement("span", null),
                            " ",
                            " ",
                            "Upload New File",
                            _react2.default.createElement("input", {
                                ref: this.inputRef,
                                type: "file",
                                tabIndex: "-1",
                                className: "form-control",
                                onChange: this.onFileUpload,
                                disabled: !enabled,
                                style: style,
                                multiple: multiSelect || config.multiValued || false
                            })
                        )
                    )
                )
            );
        }
    }]);

    return FileField;
}(_react2.default.Component);

exports.default = FileField;


FileField.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)({ multiValued: _propTypes2.default.bool }), {
    files: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
        filename: _propTypes2.default.string.isRequired,
        status: _propTypes2.default.string.isRequired,
        progress: _propTypes2.default.number.isRequired,
        filesize: _propTypes2.default.number.isRequired
    })),
    multiValued: _propTypes2.default.bool,
    onFileOpen: _propTypes2.default.func, //...(event, descriptor, file, index)
    onFileRemove: _propTypes2.default.func, //...(event, descriptor, file, index)

    // html control event methods
    onFileUpload: _propTypes2.default.func.isRequired, //...(event, descriptor)
    readOnly: _propTypes2.default.bool
});

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _formhelpers = __webpack_require__(5);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Label = function (_React$Component) {
    _inherits(Label, _React$Component);

    function Label() {
        _classCallCheck(this, Label);

        return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
    }

    _createClass(Label, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                _props$descriptor$con = _props.descriptor.config,
                config = _props$descriptor$con === undefined ? {} : _props$descriptor$con,
                value = _props.value;

            var valueStr = ArmusScript["numberFormat(Number,String)"](value, config.mask) || "";
            return _react2.default.createElement(
                _ControlTemplate2.default,
                _extends({}, this.props, { className: "integer-field" }),
                _react2.default.createElement(
                    "span",
                    null,
                    valueStr
                )
            );
        }
    }]);

    return Label;
}(_react2.default.Component);

exports.default = Label;


Label.propTypes = (0, _formhelpers.controlPropTypes)({
    mask: _propTypes2.default.string.isRequired
});

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _Input = __webpack_require__(215);

var _Input2 = _interopRequireDefault(_Input);

var _formhelpers = __webpack_require__(5);

var _alertAndRefocusBuilder = __webpack_require__(461);

var _alertAndRefocusBuilder2 = _interopRequireDefault(_alertAndRefocusBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Spinner = function (_React$Component) {
    _inherits(Spinner, _React$Component);

    function Spinner() {
        _classCallCheck(this, Spinner);

        return _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).apply(this, arguments));
    }

    _createClass(Spinner, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                _ControlTemplate2.default,
                _extends({}, this.props, { className: "integer-field" }),
                _react2.default.createElement(_Input2.default, _extends({}, this.props, {
                    valueType: _Input.INPUT_VALUE_TYPES.INTEGER,
                    onIllegal: (0, _alertAndRefocusBuilder2.default)(this.props)
                }))
            );
        }
    }]);

    return Spinner;
}(_react2.default.Component);

exports.default = Spinner;


Spinner.propTypes = (0, _formhelpers.controlPropTypes)();

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = __webpack_require__(213);

var _Select2 = _interopRequireDefault(_Select);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _formhelpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Dropdown = function (_React$Component) {
    _inherits(Dropdown, _React$Component);

    function Dropdown() {
        _classCallCheck(this, Dropdown);

        return _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).apply(this, arguments));
    }

    _createClass(Dropdown, [{
        key: "render",
        value: function render() {
            var descriptor = this.props.descriptor;
            var _descriptor$config = descriptor.config,
                _descriptor$config$op = _descriptor$config.options,
                rawOptions = _descriptor$config$op === undefined ? [] : _descriptor$config$op,
                _descriptor$config$va = _descriptor$config.valueKey,
                valueKey = _descriptor$config$va === undefined ? "value" : _descriptor$config$va,
                _descriptor$config$la = _descriptor$config.labelKey,
                labelKey = _descriptor$config$la === undefined ? "label" : _descriptor$config$la,
                allowNull = _descriptor$config.allowNull;

            var options = rawOptions.map(function (option) {
                var _ref;

                return typeof option === "string" ? (_ref = {}, _defineProperty(_ref, valueKey, option), _defineProperty(_ref, labelKey, option), _ref) : option;
            });

            return _react2.default.createElement(
                _ControlTemplate2.default,
                _extends({}, this.props, { className: "choice-field" }),
                _react2.default.createElement(_Select2.default, _extends({}, this.props, {
                    options: options,
                    valueKey: valueKey,
                    labelKey: labelKey,
                    addMissing: allowNull
                }))
            );
        }
    }]);

    return Dropdown;
}(_react2.default.Component);

exports.default = Dropdown;


Dropdown.propTypes = (0, _formhelpers.controlPropTypes)({
    allowNull: _propTypes2.default.bool,
    options: _propTypes2.default.array.isRequired
});

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _DateInput = __webpack_require__(292);

var _DateInput2 = _interopRequireDefault(_DateInput);

var _formhelpers = __webpack_require__(5);

var _MaskConstants = __webpack_require__(219);

var _MaskConstants2 = _interopRequireDefault(_MaskConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Spinner = function (_React$Component) {
    _inherits(Spinner, _React$Component);

    function Spinner() {
        _classCallCheck(this, Spinner);

        return _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).apply(this, arguments));
    }

    _createClass(Spinner, [{
        key: "render",
        value: function render() {
            var descriptor = this.props.descriptor;
            var granularity = descriptor.config.granularity;


            var format = _MaskConstants2.default.armus_time_second;
            var showCalendar = false;
            if (granularity === "SECOND") {
                format = _MaskConstants2.default.armus_time_second;
                showCalendar = false;
            } else if (granularity === "MINUTE") {
                format = _MaskConstants2.default.armus_time_minute;
                showCalendar = false;
            } else if (granularity === "HOUR") {
                format = _MaskConstants2.default.armus_time_hour;
                showCalendar = false;
            }

            return _react2.default.createElement(
                _ControlTemplate2.default,
                _extends({}, this.props, { className: "time-field" }),
                _react2.default.createElement(_DateInput2.default, _extends({}, this.props, {
                    maskFormat: format,
                    showCalendar: showCalendar
                }))
            );
        }
    }]);

    return Spinner;
}(_react2.default.Component);

exports.default = Spinner;


Spinner.propTypes = (0, _formhelpers.controlPropTypes)({
    granularity: _propTypes2.default.string
});

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _formhelpers = __webpack_require__(5);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Label = function (_React$Component) {
    _inherits(Label, _React$Component);

    function Label() {
        _classCallCheck(this, Label);

        return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
    }

    _createClass(Label, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                descriptor = _props.descriptor,
                value = _props.value;

            var valueStr = ArmusScript["dateFormat(Date,String)"](value, descriptor.config.mask) || "";
            return _react2.default.createElement(
                _ControlTemplate2.default,
                _extends({}, this.props, { className: "time-field" }),
                _react2.default.createElement(
                    "span",
                    null,
                    valueStr
                )
            );
        }
    }]);

    return Label;
}(_react2.default.Component);

exports.default = Label;


Label.propTypes = (0, _formhelpers.controlPropTypes)({
    mask: _propTypes2.default.string.isRequired
});

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _formhelpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Label = function (_React$Component) {
    _inherits(Label, _React$Component);

    function Label() {
        _classCallCheck(this, Label);

        return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
    }

    _createClass(Label, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                descriptor = _props.descriptor,
                enabled = _props.enabled,
                controlOnly = _props.controlOnly;

            var selector = "control-container-" + descriptor.key;
            if (descriptor.disableBehaviour === "hide" && !enabled) {
                // control is disabled and should be hidden.
                return null;
            }

            var Control = _react2.default.createElement(
                "div",
                {
                    id: descriptor.id,
                    className: selector + " react-control widget-label " + (controlOnly ? "form-group" : ""),
                    "data-control-type": descriptor.control,
                    "data-shortname": descriptor.key,
                    "data-widget-label": descriptor.label
                },
                _react2.default.createElement(
                    "span",
                    null,
                    descriptor.label
                )
            );

            if (controlOnly) {
                return Control;
            }

            return _react2.default.createElement(
                "div",
                { className: "form-item" },
                Control
            );
        }
    }]);

    return Label;
}(_react2.default.Component);

exports.default = Label;


Label.propTypes = (0, _formhelpers.controlPropTypes)(null, false);

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var StereotypesActions = {
    // for the collection
    START_LOAD: "stereotypes/start-load",
    LOADED: "stereotypes/loaded",
    LOAD_ERROR: "stereotypes/load-error",
    // for an individual [synthetic] stereotype
    START_STEREOTYPE_LOAD: "stereotypes/start-stereotype-load",
    STEREOTYPE_LOADED: "stereotypes/stereotype-loaded",
    STEREOTYPE_LOAD_ERROR: "stereotypes/stereotype-load-error"
};

exports.default = StereotypesActions;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
I am a simple cache manager, which provides a region-based cache based on
simple JavaScript objects.  This means that both regions and keys must be
simple strings.  Values are treated as opaque, but are stored with hard
references (JS has no alternative) so caching a value WILL prevent that
value from being garbage collected.  Thus it's important to evict values
which are no longer needed to avoid memory leaks.
*/
var CacheManager = function () {
    function CacheManager() {
        _classCallCheck(this, CacheManager);

        this.get = this.get.bind(this);
        this.has = this.has.bind(this);
        this.put = this.put.bind(this);
        this.evict = this.evict.bind(this);
        this.size = this.size.bind(this);
        this.regions = this.regions.bind(this);

        this._cache = {};
    }

    // I retrieve a value from the cache, or null if no value is currently cached


    _createClass(CacheManager, [{
        key: "get",
        value: function get(region, key) {
            if (region == null || key == null) {
                return null;
            }
            var r = this._cache[region];
            if (r != null && r[key] != null) {
                return r[key];
            } else {
                return null;
            }
        }

        // I return whether a 'get' call with the same arguments will return non-null

    }, {
        key: "has",
        value: function has(region, key) {
            if (region == null || key == null) {
                return false;
            }
            var r = this._cache[region];
            return r != null && r[key] != null;
        }

        // I put a value into the cache, overwriting any previous value, and return the
        // newly cached value (for passthrough chaining).  If you want the previous
        // value (e.g., like java.util.Map), you must use 'get' to retrieve it before
        // you put the new value.

    }, {
        key: "put",
        value: function put(region, key, value) {
            if (region == null || key == null) {
                throw new Error("CacheManager does not support the null region or key");
            }
            var r = this._cache[region];
            if (r == null) {
                r = this._cache[region] = {};
            }
            return r[key] = value;
        }

        // I evict a single key, a whole region, or the all regions, depending on the
        // passed arguments and return void.  Since neither region or key can be null
        // for actual caches, omititng parameters to evict is not ambiguious.

    }, {
        key: "evict",
        value: function evict(region, key) {
            if (region != null && key != null) {
                var r = this._cache[region];
                if (r != null) {
                    delete r[key];
                    if (_.size(r) === 0) {
                        this.evict(region);
                    }
                }
            } else if (region != null) {
                delete this._cache[region];
            } else {
                this._cache = {};
            }
            return undefined;
        }

        // I return the number of keys in the specified region, or all regions,
        // depending on the passed argument.

    }, {
        key: "size",
        value: function size(region) {
            var r = void 0;
            if (region != null) {
                r = this._cache[region];
                if (r != null) {
                    return _.size(r);
                } else {
                    return 0;
                }
            } else {
                var s = 0;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = Object.keys(this._cache)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var n = _step.value;

                        r = this._cache[n];
                        s += _.size(r);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return s;
            }
        }

        // I return an object with a key per region and values of the region's size

    }, {
        key: "regions",
        value: function regions() {
            var o = {};
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Object.keys(this._cache)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var n = _step2.value;

                    var r = this._cache[n];
                    o[n] = _.size(r);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return o;
        }
    }]);

    return CacheManager;
}();

exports.default = new CacheManager();

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.comparatorForEntity = exports.comparatorForField = exports.arrayBuilder = exports.objectBuilder = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

var _get_type_key = __webpack_require__(476);

var _get_type_key2 = _interopRequireDefault(_get_type_key);

var _infoTypeToFieldType = __webpack_require__(221);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _TableColumnMetaStore = __webpack_require__(125);

var _TableColumnMetaStore2 = _interopRequireDefault(_TableColumnMetaStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// a and b are records, components is an array of three-tuples:
// (String fieldname, String|int type, boolean ascending)
var compareRecords = function compareRecords(a, b, components) {
    return arrayBuilder(components)(a, b);
};

// components are objects w/ key, type, ascending keys, a and b are records
var objectBuilder = exports.objectBuilder = function objectBuilder(components) {
    return function (a, b) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = components[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _ref = _step.value;
                var key = _ref.key,
                    type = _ref.type,
                    ascending = _ref.ascending;

                var af = a.get(key);
                var bf = b.get(key);
                if (af == null && bf == null) continue;
                if (!ascending) {
                    // descending
                    var temp = af;
                    af = bf;
                    bf = temp;
                }
                if (af == null) return -1;
                if (bf == null) return 1;
                // type-based restatement if both are non-null
                switch (typeof type === "string" ? type : (0, _get_type_key2.default)(type)) {
                    case "STRING":
                        af = af.toLowerCase();
                        bf = bf.toLowerCase();
                        break;
                    case "INTEGER":
                    case "DECIMAL":
                        break;
                    case "INTERVAL":
                        // Moment.duration instances
                        af = af.asMilliseconds();
                        bf = bf.asMilliseconds();
                        break;
                    case "TZTIMESTAMP":
                    case "TIME":
                    case "DATE":
                    case "DATETIME":
                        // all Moment instances...
                        af = af.valueOf();
                        bf = bf.valueOf();
                        break;
                    case "CHOICE":
                        af = af.toString();
                        bf = bf.toString();
                        break;
                    case "ASSOCIATION":
                        // todo: multi-valued associations
                        af = af.compareTo(bf);
                        bf = 0;
                        break;
                    default:
                        throw new Error("Unknown field type: " + type);
                }
                // if comparisons are non-zero, call it
                if (af < bf) return -1;
                if (af > bf) return 1;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return 0; // didn't find any diffs, so they're equivalent.
    };
};

// components are arrays w/ key, type, ascending elements, a and b are records
var arrayBuilder = exports.arrayBuilder = function arrayBuilder(components) {
    return objectBuilder(components.map(function (it) {
        return {
            key: it[0],
            type: it[1],
            ascending: it[2]
        };
    }));
};

var typeForKey = function typeForKey(entityKey, fieldKey) {
    return (0, _infoTypeToFieldType.infoTypeToFieldType)(_entityFieldMetaStore2.default.getInfo(entityKey, fieldKey).type);
};

var comparator_cache = {};
var cc_stat = {
    get: 0,
    hit: 0,
    miss: 0,
    stale: 0,
    put: 0,
    purge: 0
};
window.comparator_cache_stat = cc_stat;
var cc_get = function cc_get(key, info) {
    cc_stat.get += 1;
    var c = comparator_cache[key];
    if (c == null) {
        cc_stat.miss += 1;
        return;
    }
    if (c.info !== info) {
        cc_stat.stale += 1;
        return;
    }
    cc_stat.hit += 1;
    return c.comparator;
};
var cc_put = function cc_put(key, info, comparator) {
    cc_stat.put += 1;
    var keys = Object.keys(comparator_cache);
    if (keys.length > 100) {
        for (var i = 0; i < 25; i++) {
            cc_stat.purge += 1;
            delete comparator_cache[keys[i]];
        }
    }
    comparator_cache[key] = {
        info: info,
        comparator: comparator
    };
};

var comparatorForField = exports.comparatorForField = function comparatorForField(info) {
    (0, _invariant2.default)(info && info.key && info.otherEntityKey, "comparatorForField must be passed a valid fieldInfo");
    var key = info.entityKey + "." + info.key;
    var comparator = cc_get(key, info);
    if (comparator !== undefined) return comparator;

    if (info.orderingComponents && info.orderingComponents.length > 0) {
        // if a field defines a sort order, use the field's ordering components.
        var components = info.orderingComponents.map(function (it) {
            return _extends({}, it, {
                type: typeForKey(info.otherEntityKey, it.key)
            });
        });
        var c = objectBuilder(components);
        cc_put(key, info, c);
        return c;
    }

    // order is undefined.
    cc_put(key, info, null);
    return null;
};

var comparatorForEntity = exports.comparatorForEntity = function comparatorForEntity(info) {
    var comparator = cc_get(info.key, info);
    if (comparator !== undefined) return comparator;

    var comps = info.orderingComponents;
    if (!comps) {
        throw new Error("'" + info.key + "' is not Comparable.");
    }
    var c = arrayBuilder(comps.map(function (it) {
        return [it.key, _TableColumnMetaStore2.default.getInfoByName(info.tableKey, _entityFieldMetaStore2.default.getInfo(info.key, it.key).logicalColumn).type, it.ascending];
    }));
    cc_put(info.key, info, c);
    return c;
};

exports.default = compareRecords;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (id) {
    switch (id) {
        case 1:
            return "CHOICE";
        case 2:
            return "ASSOCIATION";
        case 3:
            return "STRING";
        case 4:
            return "INTEGER";
        case 5:
            return "DECIMAL";
        case 7:
            return "TZTIMESTAMP";
        case 8:
            return "INTERVAL";
        case 9:
            return "TIME";
        case 10:
            return "DATE";
        case 11:
            return "DATETIME";
        case 12:
            return "FILE";
        default:
            throw new Error("Unrecognized type id: " + id);
    }
};

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var humanizedKeyList = function humanizedKeyList(object) {
    if (!object) return "[null]";
    var keys = Object.keys(object).sort();
    if (keys.length === 0) return "[empty]";
    if (keys.length > 5) {
        keys = [].concat(_toConsumableArray(keys.slice(0, 2)), ["\u2026skip " + (keys.length - 3) + "\u2026", keys[keys.length - 1]]);
    }
    return keys.join(", ");
};

exports.default = humanizedKeyList;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadEntityIntoState = exports.loadTableIntoState = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _utils = __webpack_require__(13);

var _DefineActions = __webpack_require__(124);

var _DefineActions2 = _interopRequireDefault(_DefineActions);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var loadTableIntoState = exports.loadTableIntoState = function loadTableIntoState(state, info) {
    var allowByDefault = _userStore2.default.getState().isEmpty();
    return _extends({}, state, _defineProperty({}, info.key, {
        canCreate: allowByDefault,
        canWrite: allowByDefault,
        canDelete: allowByDefault
    }));
};

var loadEntityIntoState = exports.loadEntityIntoState = function loadEntityIntoState(state, entityKey) {
    if (_userStore2.default.getState().isEmpty()) return state;
    var info = _entityMetaStore2.default.getInfo(entityKey);
    var tableKey = info.tableKey;
    return _extends({}, state, _defineProperty({}, tableKey, {
        canCreate: state[tableKey].canCreate || info.canCreate,
        canWrite: state[tableKey].canWrite || info.canWrite,
        canDelete: state[tableKey].canDelete || info.canDelete
    }));
};

var TableMetaStore = function (_ReduceStore) {
    _inherits(TableMetaStore, _ReduceStore);

    function TableMetaStore() {
        _classCallCheck(this, TableMetaStore);

        return _possibleConstructorReturn(this, (TableMetaStore.__proto__ || Object.getPrototypeOf(TableMetaStore)).apply(this, arguments));
    }

    _createClass(TableMetaStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {};
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {

                case _DefineActions2.default._UNLOAD:
                    return this.getInitialState();

                case _DefineActions2.default.TABLE:
                    return loadTableIntoState(state, action.def);

                case _DefineActions2.default.ENTITY:
                    this.__dispatcher.waitFor([_entityMetaStore2.default.getDispatchToken()]);
                    return loadEntityIntoState(state, action.key);

                default:
                    return state;
            }
        }
    }, {
        key: "_getInfo",
        value: function _getInfo(key) {
            var s = this.getState();
            if (!s.hasOwnProperty(key)) {
                throw new Error("No '" + key + "' table is known.");
            }
            return s[key];
        }
    }, {
        key: "canCreate",
        value: function canCreate(key) {
            return this._getInfo(key).canCreate;
        }
    }, {
        key: "canWrite",
        value: function canWrite(key) {
            return this._getInfo(key).canWrite;
        }
    }, {
        key: "canDelete",
        value: function canDelete(key) {
            return this._getInfo(key).canDelete;
        }
    }]);

    return TableMetaStore;
}(_utils.ReduceStore);

TableMetaStore.stateTypes = _propTypes2.default.objectOf(_propTypes2.default.shape({
    canCreate: _propTypes2.default.bool.isRequired,
    canWrite: _propTypes2.default.bool.isRequired,
    canDelete: _propTypes2.default.bool.isRequired
}));

exports.default = (0, _typeCheckingStore2.default)(new TableMetaStore(_Dispatcher2.default));

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parseId = function parseId(idString) {
    return _ClientId2.default.is(idString) ? idString : parseInt(idString, 10);
};

exports.default = parseId;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Given a key extraction function, return a function that will filter a
 * collection to return only the first instance for each extracted key.
 * @param keyExtractor function which extracts a key from a collection element
 * @return {function(*=): boolean} a filter function, providing uniqueness
 */
var uniqueFilterBuilder = function uniqueFilterBuilder(keyExtractor) {
    var uniquer = new Set();
    return function (it) {
        var key = keyExtractor(it);
        if (uniquer.has(key)) return false;
        uniquer.add(key);
        return true;
    };
};

exports.default = uniqueFilterBuilder;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildState = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*
                                                                                                                                                                                                                                                                               * decaffeinate suggestions:
                                                                                                                                                                                                                                                                               * DS102: Remove unnecessary code created because of implicit returns
                                                                                                                                                                                                                                                                               * DS205: Consider reworking code to avoid use of IIFEs
                                                                                                                                                                                                                                                                               * DS207: Consider shorter variations of null checks
                                                                                                                                                                                                                                                                               * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
                                                                                                                                                                                                                                                                               */


var _error = __webpack_require__(225);

var _error2 = _interopRequireDefault(_error);

var _utils = __webpack_require__(175);

var _ChoiceStore = __webpack_require__(174);

var _ChoiceStore2 = _interopRequireDefault(_ChoiceStore);

var _audit = __webpack_require__(173);

var _HybridConfig = __webpack_require__(41);

var _HybridConfig2 = _interopRequireDefault(_HybridConfig);

var _options = __webpack_require__(156);

var _asArray = __webpack_require__(157);

var _asArray2 = _interopRequireDefault(_asArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildState = exports.buildState = function buildState(info, code, message, unusual) {
    code = parseInt((code == null ? _error2.default.UNUSUAL.code : code).toString(10), 10);
    var displayName = info.name,
        seqnum = info.seqnum;

    var state = {
        code: code,
        message: displayName + (message ? " - " + message : seqnum ? " -" : "") + (seqnum ? " (" + seqnum + ")" : "")
    };
    state.isUnusual = unusual != null && unusual;
    return state;
};

var getValidationMessage = function getValidationMessage(info, code) {
    if (code >= _error2.default.BLOCKING.code) {
        return _error2.default.BLOCKING.message;
    }
    if (code >= _error2.default.ILLEGAL.code) {
        return info.illegalMessage || _error2.default.ILLEGAL.message;
    }
    if (code >= _error2.default.WARNING.code) {
        return info.warningMessage || _error2.default.WARNING.message;
    }
    if (code >= _error2.default.MISSING.code) {
        return _error2.default.MISSING.message;
    }
    if (code >= _error2.default.UNUSUAL.code) {
        return _error2.default.UNUSUAL.message;
    }
    return _error2.default.OK.message;
};

var __conditional_choice = function __conditional_choice(info, value, options) {
    value = (0, _asArray2.default)(value);
    var activeOpts = _.pluck(options, "name");
    var allOpts = _ChoiceStore2.default.getChoiceByKey(info.choiceKey).options.map(function (o) {
        return o.name;
    });
    // if any val in allOpts and not in activeOpts, error!
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var v = _step.value;

            if (allOpts.includes(v) && !activeOpts.includes(v)) {
                return buildState(info, info.codes.inactive, (0, _utils.sprintf)(_error2.default.byCode(info.codes.inactive).message, v));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};

var _vfac_precision = function _vfac_precision(precision, code) {
    return {
        code: code,
        getComp: function getComp() {
            return precision;
        },
        doComp: function doComp(comp, value) {
            var str = typeof value === "string" ? value : value.toString(10);
            var di = str.indexOf(".");
            return str.length - (di >= 0 ? 1 : 0) > (value < 0 ? comp + 1 : comp);
        }
    };
};

var _vfac_scale = function _vfac_scale(scale, code) {
    return {
        code: code,
        getComp: function getComp() {
            return scale;
        },
        doComp: function doComp(comp, value) {
            var str = typeof value === "string" ? value : value.toString(10);
            var di = str.indexOf(".");
            if (di < 0) {
                return false;
            }
            return str.substr(di + 1).length > comp;
        }
    };
};

var _vfac_min = function _vfac_min(compFn, code) {
    return {
        code: code,
        getComp: compFn,
        doComp: function doComp(comp, value) {
            return ArmusScript._op_gt(Number(comp), Number(value));
        }
    };
};

var _vfac_max = function _vfac_max(compFn, code) {
    return {
        code: code,
        getComp: compFn,
        doComp: function doComp(comp, value) {
            return ArmusScript._op_lt(Number(comp), Number(value));
        }
    };
};

var doContinuousField = function doContinuousField(self, info, value) {
    var comp = void 0;
    var v = void 0;
    var unusuals = [];

    for (var _len = arguments.length, validators = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        validators[_key - 3] = arguments[_key];
    }

    if (info.scripts.min != null && info.codes.min !== _error2.default.OK.code) {
        validators.push(_vfac_min(info.scripts.min, info.codes.min));
    }
    if (info.scripts.max != null && info.codes.max !== _error2.default.OK.code) {
        validators.push(_vfac_max(info.scripts.max, info.codes.max));
    }
    if (info.scripts.usualMin != null && info.codes.usualMin !== _error2.default.OK.code) {
        unusuals.push(_vfac_min(info.scripts.usualMin, info.codes.usualMin));
    }
    if (info.scripts.usualMax != null && info.codes.usualMax !== _error2.default.OK.code) {
        unusuals.push(_vfac_max(info.scripts.usualMax, info.codes.usualMax));
    }
    var toString = function () {
        if (info.mask != null) {
            if (info.type === "TimeField") {
                return function (v) {
                    return ArmusScript["timeFormat(Time,String)"](v, info.mask);
                };
            } else if (["DateField", "DateTimeField", "TZTimestampField"].includes(info.type)) {
                return function (v) {
                    return ArmusScript["dateFormat(Date,String)"](v, info.mask);
                };
            }
        }
    }();
    toString = toString || function (it) {
        return it.toString();
    };

    if (validators != null) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = validators[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                v = _step2.value;
                // disregard null/falsey validators
                if (v) {
                    comp = v.getComp(self);
                    if (comp != null && v.doComp(comp, value)) {
                        var unusual = false;
                        // have to check if it's unusual, even if it fails validation...
                        if (unusuals != null) {
                            var _iteratorNormalCompletion3 = true;
                            var _didIteratorError3 = false;
                            var _iteratorError3 = undefined;

                            try {
                                for (var _iterator3 = unusuals[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                    var u = _step3.value;

                                    var ucomp = u.getComp(self);
                                    if (ucomp != null && u.doComp(ucomp, value)) {
                                        unusual = true;
                                        break;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError3 = true;
                                _iteratorError3 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                        _iterator3.return();
                                    }
                                } finally {
                                    if (_didIteratorError3) {
                                        throw _iteratorError3;
                                    }
                                }
                            }
                        }
                        return buildState(info, v.code, (0, _utils.sprintf)(_error2.default.byCode(v.code).message, toString(value), toString(comp)), unusual);
                    }
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    }
    if (unusuals != null) {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
            for (var _iterator4 = unusuals[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                v = _step4.value;

                comp = v.getComp(self);
                if (comp != null && v.doComp(comp, value)) {
                    return buildState(info, v.code, (0, _utils.sprintf)(_error2.default.byCode(v.code).message, toString(value), toString(comp)), true);
                }
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                }
            } finally {
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }
    }
    return buildState(info, _error2.default.OK.code);
};

// info -> value -> vState
var _or_validate = function _or_validate(info, value, self) {
    var maxLen = void 0,
        minLen = void 0;
    if (!info.dqr) {
        if (["AssociationField", "CompositionField"].includes(info.type)) {
            return buildState(info, _error2.default.OK.code);
        } else {
            (console.warn || console.log)(self.getKey() + "." + info.key + "'s validate function was called, but it's excluded from DQR.");
            return; // no validation state for this field
        }
    }

    // if it's not enabled, it must be OK
    if (!self.isFieldEnabled(info)) {
        return buildState(info, _error2.default.OK.code);
    }

    // if it's missing, do that
    var isMissing = value == null || (_.isArray(value) || value instanceof Backbone.Collection) && value.length === 0;
    if (isMissing && info.codes.missing != null) {
        return buildState(info, info.codes.missing, "missing");
    }

    // run the validation function
    if (info.scripts.validation != null) {
        var v = info.scripts.validation(self);
        if (v instanceof Array) {
            // scream about old-old int[] returns
            console.error("ValidationScript for '" + self.constructor.KEY + "." + info.key + "' should return Validation or int; int[] is obsolete.");
        } else if (typeof v === "number") {
            // support old int returns
            if (v !== _error2.default.OK.code) {
                return buildState(info, v, getValidationMessage(info, v));
            }
        } else if (v != null && v.code != null) {
            // modern valdiation returns
            if (v.code !== _error2.default.OK.code) {
                return buildState(info, v.code, v.message);
            }
        }
    }

    // no need to do type-specific value checks if it's missing
    if (isMissing) {
        return buildState(info, _error2.default.OK.code);
    }

    // at this point, we know it's enabled, it's not missing, and it passed the
    // explicit validation function (if one existed).

    // the "distributor"
    if (info.type === "IntegerField") {
        return doContinuousField(self, info, value, info.precision != null && _vfac_precision(info.precision, _error2.default.ILLEGAL_PRECISION.code));
    } else if (info.type === "DecimalField") {
        return doContinuousField(self, info, value, info.precision != null && _vfac_precision(info.precision, _error2.default.ILLEGAL_PRECISION.code), info.scale != null && _vfac_scale(info.scale, _error2.default.ILLEGAL_SCALE.code));
    } else if (["DateField", "DateTimeField", "IntervalField", "TimeField", "TZTimestampField"].includes(info.type)) {
        return doContinuousField(self, info, value);
    } else if (info.type === "StringField") {
        minLen = info.scripts.minLength && info.scripts.minLength(self);
        maxLen = info.scripts.maxLength && info.scripts.maxLength(self);
        if (minLen != null && ArmusScript._op_gt(minLen, value.length)) {
            return buildState(info, info.codes.minLength, (0, _utils.sprintf)(_error2.default.byCode(info.codes.minLength).message, value, minLen.toString()));
        }
        if (maxLen != null && ArmusScript._op_lt(maxLen, value.length)) {
            return buildState(info, info.codes.maxLength, (0, _utils.sprintf)(_error2.default.byCode(info.codes.maxLength).message, value, maxLen.toString()));
        }
        return buildState(info, _error2.default.OK.code);
    } else if (info.type === "FileField") {
        minLen = info.scripts.minLength && info.scripts.minLength(self);
        maxLen = info.scripts.maxLength && info.scripts.maxLength(self);
        // value is either a FileInfo, or a Array/Collection of them
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
            for (var _iterator5 = (value instanceof Backbone.Collection ? value.models : _.isArray(value) ? value : value != null ? [value] : [])[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var it = _step5.value;

                if (minLen != null && ArmusScript._op_gt(minLen, it.size)) {
                    return buildState(info, info.codes.minLength, (0, _utils.sprintf)(_error2.default.byCode(info.codes.minLength).message, it.filename, minLen.toString()));
                }
                if (maxLen != null && ArmusScript._op_lt(maxLen, it.size)) {
                    return buildState(info, info.codes.maxLength, (0, _utils.sprintf)(_error2.default.byCode(info.codes.maxLength).message, it.filename, maxLen.toString()));
                }
            }
        } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                }
            } finally {
                if (_didIteratorError5) {
                    throw _iteratorError5;
                }
            }
        }

        return buildState(info, _error2.default.OK.code);
    } else if (info.type === "ChoiceField") {
        if (info.multiValued && info.codes.atomic !== _error2.default.OK.code) {
            // do atomicity check first
            var c = _ChoiceStore2.default.getChoiceByKey(info.choiceKey);
            if (c.atomic && _.isArray(value) && value.length > 1) {
                var _loop = function _loop(_v) {
                    if (c.options.some(function (o) {
                        return o.atomic && o.name === _v;
                    })) {
                        return {
                            v: buildState(info, info.codes.atomic, (0, _utils.sprintf)(_error2.default.byCode(info.codes.atomic).message, _v))
                        };
                    }
                };

                // there are at least two options, so bomb if any are atomic
                var _iteratorNormalCompletion6 = true;
                var _didIteratorError6 = false;
                var _iteratorError6 = undefined;

                try {
                    for (var _iterator6 = value[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                        var _v = _step6.value;

                        var _ret = _loop(_v);

                        if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
                    }
                } catch (err) {
                    _didIteratorError6 = true;
                    _iteratorError6 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion6 && _iterator6.return) {
                            _iterator6.return();
                        }
                    } finally {
                        if (_didIteratorError6) {
                            throw _iteratorError6;
                        }
                    }
                }
            }
        }
        var s = __conditional_choice(info, value, (0, _options.optionsForField)(info, self, _ChoiceStore2.default.getChoiceByKey(info.choiceKey)));
        if (s != null) {
            return s;
        }
        return buildState(info, _error2.default.OK.code);
    } else {
        return buildState(info, _error2.default.OK.code);
    }
};

exports.default = _HybridConfig2.default.auditScriptlets() ? (0, _audit.auditable)("validate", _or_validate) : _or_validate;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(13);

var _UserActions = __webpack_require__(123);

var _UserActions2 = _interopRequireDefault(_UserActions);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _slices = __webpack_require__(172);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * I wrap a named preference which stores a field set definition, and allow
 * performant querying of whether fields are included in it, across all
 * implementations the user has access to for their active organization.
 */
var FieldSetPreferenceCache = function (_ReduceStore) {
    _inherits(FieldSetPreferenceCache, _ReduceStore);

    function FieldSetPreferenceCache(dispatcher, prefName) {
        _classCallCheck(this, FieldSetPreferenceCache);

        var _this = _possibleConstructorReturn(this, (FieldSetPreferenceCache.__proto__ || Object.getPrototypeOf(FieldSetPreferenceCache)).call(this, dispatcher));

        _this.prefName = prefName;
        return _this;
    }

    _createClass(FieldSetPreferenceCache, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {}; // Object<implKey, Map<entityKey, Set<fieldKey>>>
        }
    }, {
        key: "_updateFieldSet",
        value: function _updateFieldSet(state, implKey, value) {
            try {
                var map = new Map();
                if (value) {
                    var parsed = JSON.parse(value);
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = Object.keys(parsed)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var ek = _step.value;

                            map.set(ek, new Set(parsed[ek]));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                return _extends({}, state, _defineProperty({}, implKey, map));
            } catch (e) {
                console.warn("Error processing " + this.prefName + " for " + implKey, e);
                return state;
            }
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            var _this2 = this;

            switch (action.type) {
                case _UserActions2.default.LOADED:
                    {
                        this.__dispatcher.waitFor([_userStore2.default.getDispatchToken()]);
                        return (0, _slices.fromSlice)(_userStore2.default.getActiveOrg().lics).reduce(function (s, l) {
                            return _this2._updateFieldSet(s, l.key, l.prefs && l.prefs[_this2.prefName]);
                        }, state);
                    }

                case _UserActions2.default.LICENSE_PREFERENCE_UPDATED:
                    {
                        if (action.pref !== this.prefName) return state;
                        return this._updateFieldSet(state, action.impl, action.newValue);
                    }

                default:
                    return state;
            }
        }

        /**
         * I indicate whether the specified field is included by the preference's
         * fieldset. The `entity` parameter may be qualified, but doesn't have to
         * be. Thus, to check `cath/5/patient.firstname`, all of these argument
         * tuples will behave the same:
         *
         *  * `isIncluded("cath", "patient", "firstname")`
         *  * `isIncluded("cath", "cath/5/patient", "firstname")`
         *  * `isIncluded("cath/5/patient", "firstname")`
         *
         * In the second variant, the first segment of the three-part entity key is
         * ignored. It _should_ be the same as the passed implementation key, but
         * will not be validated as such. In both the second and third variants, the
         * version key is ignored, as fieldset preferences span all versions of the
         * implementation.
         */

    }, {
        key: "isIncluded",
        value: function isIncluded(impl, entity, field) {
            if (arguments.length === 2) {
                // variant three
                field = entity;
                var en = new _EntityName2.default(impl);
                impl = en.implKey;
                entity = en.bareEntityKey;
            } else if (entity.indexOf("/") > 0) {
                // variant two
                var _en = new _EntityName2.default(entity);
                if (false) {
                    console.warn("isIncluded was passed a three-part entity key (%s) inconsistent w/ the passed impl key (%s).", entity, impl);
                }
                entity = _en.bareEntityKey;
            }
            var s = this.getState();
            if (!s.hasOwnProperty(impl)) return false;
            var es = s[impl];
            if (!es.has(entity)) return false;
            return es.get(entity).has(field);
        }
    }]);

    return FieldSetPreferenceCache;
}(_utils.ReduceStore);

exports.default = FieldSetPreferenceCache;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

var _MappingVisitor2 = __webpack_require__(231);

var _MappingVisitor3 = _interopRequireDefault(_MappingVisitor2);

var _MappingStore = __webpack_require__(65);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _MappingInfoStore = __webpack_require__(160);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableMappingVisitor = function (_MappingVisitor) {
    _inherits(TableMappingVisitor, _MappingVisitor);

    function TableMappingVisitor(state, access, snapshot) {
        _classCallCheck(this, TableMappingVisitor);

        var _this = _possibleConstructorReturn(this, (TableMappingVisitor.__proto__ || Object.getPrototypeOf(TableMappingVisitor)).call(this, state, access, snapshot));

        _this._indexStack = [];
        /*
         * This is a pretty kludgey way of doing this, but it _is_ correct. It'd
         * be better to actually enumerate the downstreams for each changed
         * field, and then only do that set of fields on the next pass.
         */
        var ek = _this.state.target.entityKey;
        var ei = _entityMetaStore2.default.getInfo(ek);
        (0, _invariant2.default)(ei.maxDepGraphSet >= 0, "%s's 'maxDepGraphSet' is negative?!", ek);
        _this.endDepSetIndex = ei.maxDepGraphSet + 1; // half open
        return _this;
    }

    _createClass(TableMappingVisitor, [{
        key: "execute",
        value: function execute(ctx) {
            (0, _invariant2.default)(this._indexStack.length === 0, "Someone's bad at corner cases...");
            for (var idx = 0; idx < this.endDepSetIndex; idx += 1) {
                this._fieldSetIndex = idx;
                _get(TableMappingVisitor.prototype.__proto__ || Object.getPrototypeOf(TableMappingVisitor.prototype), "execute", this).call(this, ctx);
            }
            (0, _invariant2.default)(this._indexStack.length === 0, "Someone's bad at corner cases...");
            return this;
        }
    }, {
        key: "_catchUp",
        value: function _catchUp(ctx, target, sourceOrSources, edgeInfo) {
            var _this2 = this;

            var endIndex = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this._fieldSetIndex;

            this._indexStack.push(this._fieldSetIndex);
            try {
                this.__forEach(sourceOrSources, function (source) {
                    for (var idx = 0; idx < endIndex; idx += 1) {
                        _this2._fieldSetIndex = idx;
                        _this2.doRecord(ctx, target, false, source, edgeInfo);
                    }
                });
            } finally {
                this._fieldSetIndex = this._indexStack.pop();
            }
        }
    }, {
        key: "_isDepSet",
        value: function _isDepSet(fieldInfo) {
            return fieldInfo.depGraphSet === this._fieldSetIndex;
        }
    }, {
        key: "shouldDoField",
        value: function shouldDoField(ctx, target, excluded, fieldInfo) {
            if (!_get(TableMappingVisitor.prototype.__proto__ || Object.getPrototypeOf(TableMappingVisitor.prototype), "shouldDoField", this).call(this, ctx, target, excluded, fieldInfo)) return false;
            return this._isDepSet(fieldInfo);
        }
    }, {
        key: "shouldDoCrossTree",
        value: function shouldDoCrossTree(ctx, target, excluded, fieldInfo) {
            if (!_get(TableMappingVisitor.prototype.__proto__ || Object.getPrototypeOf(TableMappingVisitor.prototype), "shouldDoCrossTree", this).call(this, ctx, target, excluded, fieldInfo)) return false;
            return this._isDepSet(fieldInfo);
        }
    }, {
        key: "doField",
        value: function doField(ctx, target, excluded, fieldInfo, sourceValue) {
            var value = excluded ? this.__oldValue(target, fieldInfo) : sourceValue;
            this._set(target, fieldInfo, value);
        }
    }, {
        key: "_set",
        value: function _set(target, fieldInfo, value) {
            this.access.updateEntityRecordField(target.entityKey, target.id, fieldInfo.key, value);
        }
    }, {
        key: "doMagicRoot",
        value: function doMagicRoot(ctx, target, excluded, fieldInfo, sourceValue) {
            (0, _invariant2.default)(!excluded, "Magic roots can't be excluded");
            (0, _invariant2.default)(sourceValue instanceof _EntityProxy2.default, "Magic root isn't single-valued?!");
            // assert already present and wired.
            var lo = this.__getTargetIdLO(sourceValue, target, fieldInfo);
            (0, _invariant2.default)(lo.hasValue(), "Magic root isn't wired in mapping?!");
            var id = lo.getValueEnforcing();
            (0, _invariant2.default)(this.access.hasEntityRecord(fieldInfo.otherEntityKey, id), "Magic root doesn't exist?!");
            var curr = target.tableProxy.get(fieldInfo.logicalColumn);
            (0, _invariant2.default)(curr === id, "Mapping is attempting to change a magic root (from %s to %s w/in %s.%s)?!", curr, id, target.tableProxy.tableKey, fieldInfo.name);
            // Nothing to actually do, since we've vetted there's nothing to do.
            _get(TableMappingVisitor.prototype.__proto__ || Object.getPrototypeOf(TableMappingVisitor.prototype), "doMagicRoot", this).call(this, ctx, target, excluded, fieldInfo, sourceValue);
        }

        /*
        When an assoc is first wired, we need to immediately process all prior
        depSetIndex on _just_ that subtree, before passing it to super (which
        will do the current depSetIndex).
         */

    }, {
        key: "doGlobalAssoc",
        value: function doGlobalAssoc(ctx, target, excluded, fieldInfo, sourceValue, createIfMissing) {
            var _this3 = this;

            var newValue = [];
            this.__forEach(excluded ? this.__oldValue(target, fieldInfo) : sourceValue, function (it) {
                var lo = _this3.__getTargetIdLO(it, target, fieldInfo);

                // Can't do anything if we're waiting for an answer
                if (!lo.isDone() || lo.isEmpty()) return;

                (0, _invariant2.default)(lo.hasValue() || lo.hasError(), "Global LO is empty (for %s.%s)?!", target.entityKey, fieldInfo.key);
                if (lo.hasError()) {
                    var err = lo.getErrorEnforcing();
                    if (err === _MappingStore.ERR_NO_MATCH_FOUND) {
                        // skip it
                    } else if (err === _MappingStore.ERR_MULTIPLE_MATCHES_FOUND) {
                        // skip it
                    } else if (lo.hasValue()) {
                        // leave whatever was there...
                        newValue.push(lo.getValueEnforcing());
                    }
                    return;
                }

                // Wire it into the tree
                var id = lo.getValueEnforcing();
                if (!(0, _MappingStore.isExcluded)(_this3.state, target.id, fieldInfo.logicalColumn, id)) {
                    newValue.push(id);
                    if (!_this3.access.hasEntityRecord(fieldInfo.otherEntityKey, id)) {
                        _this3.access.createEntityRecord(fieldInfo.otherEntityKey, id);
                        // Catch it up
                        _this3._catchUp(ctx, target, it, fieldInfo);
                    }
                }
            });

            if (!excluded) {
                if (this._isDepSet(fieldInfo)) {
                    this._set(target, fieldInfo, this.__cleanMultiplicity(fieldInfo, newValue));
                }
                _get(TableMappingVisitor.prototype.__proto__ || Object.getPrototypeOf(TableMappingVisitor.prototype), "doGlobalAssoc", this).call(this, ctx, target, excluded, fieldInfo, sourceValue, createIfMissing);
            }
        }
    }, {
        key: "doComposition",
        value: function doComposition(ctx, target, excluded, fieldInfo, sourceValue) {
            var _this4 = this;

            this.__forEach(sourceValue, function (it) {
                var lo = _this4.__getTargetIdLO(it, target, fieldInfo);

                // No value means it hasn't been through MappingStore yet, which
                // means it's the child of a just-wired record. Ignore for now, and
                // it'll get processed on the next iteration (which is guaranteed to
                // occur, because a new record was wired).
                if (!lo.hasValue()) return;

                // Wire it into the tree
                var id = lo.getValueEnforcing();

                var childExists = _this4.access.hasEntityRecord(fieldInfo.otherEntityKey, id);
                if ((0, _MappingStore.isExcluded)(_this4.state, target.id, fieldInfo.logicalColumn, id)) {
                    if (childExists) {
                        _this4.access.deleteEntityChild(target.entityInfo, target.id, fieldInfo, id);
                    }
                } else {
                    if (!childExists) {
                        // create it!
                        _this4.access.createEntityChild(target.entityInfo, target.id, fieldInfo, id);
                        // Catch it up
                        _this4._catchUp(ctx, target, it, fieldInfo);
                    }
                }
            });

            // Keep on walking
            _get(TableMappingVisitor.prototype.__proto__ || Object.getPrototypeOf(TableMappingVisitor.prototype), "doComposition", this).call(this, ctx, target, excluded, fieldInfo, sourceValue);
        }
    }, {
        key: "doAutomanaged",
        value: function doAutomanaged(ctx, target, excluded, fieldInfo, autoManagedByFieldInfo, sourceValue) {
            var _this5 = this;

            this.__forEach(sourceValue, function (s) {
                var t = _this5.__getAutomanagedTarget(target, s, fieldInfo);
                if (t == null) return;
                _this5.doRecord(ctx, t, false, s, _MappingInfoStore.FT_CHILD, fieldInfo);
            });
        }
    }, {
        key: "doCrossTree",
        value: function doCrossTree(ctx, target, excluded, fieldInfo, sourceValue) {
            var _this6 = this;

            (0, _invariant2.default)(!excluded, "Cross-tree associations can't be excluded");
            // For each owner pair, get the source CTA's ids, translate them to
            // the the corresponding target CTA's ids and set the ids in.
            var oek = fieldInfo.otherEntityKey;
            var ids = [];
            this.__forEach(sourceValue, function (it) {
                var lo = _this6.__getTargetIdLO(it, target, fieldInfo);
                if (!lo.hasValue()) return;
                var id = lo.getValueEnforcing();
                if (!_this6.access.hasEntityRecord(oek, id)) return;
                ids.push(id);
            });
            this._set(target, fieldInfo, ids);
        }
    }]);

    return TableMappingVisitor;
}(_MappingVisitor3.default);

exports.default = TableMappingVisitor;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var DataDefActions = {
    START_LOAD: "data-def/start-load",
    LOADED: "data-def/loaded",
    LOAD_ERROR: "data-def/load-error"
};

exports.default = DataDefActions;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var AboutActions = {
    START_LOAD_VERSION_INFO: "about/start-load-version-info",
    LOADED_VERSION_INFO: "about/loaded-version-info",
    LOAD_VERSION_INFO_ERROR: "about/load-version-info-error"
};

exports.default = AboutActions;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.itemShapeType = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _utils = __webpack_require__(13);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _loadObjectOf = __webpack_require__(220);

var _loadObjectOf2 = _interopRequireDefault(_loadObjectOf);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _storeUtils = __webpack_require__(54);

var _GxepActions = __webpack_require__(171);

var _GxepActions2 = _interopRequireDefault(_GxepActions);

var _DataManager = __webpack_require__(43);

var _DataManager2 = _interopRequireDefault(_DataManager);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GxepStore = function (_ReduceStore) {
    _inherits(GxepStore, _ReduceStore);

    function GxepStore() {
        _classCallCheck(this, GxepStore);

        return _possibleConstructorReturn(this, (GxepStore.__proto__ || Object.getPrototypeOf(GxepStore)).call(this, _Dispatcher2.default));
    }

    _createClass(GxepStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return _LoadObject2.default.empty();
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {

                case _GxepActions2.default.START_LOAD:
                    {
                        return state.loading(_DataManager2.default.loadGxepInfo(_userStore2.default.getActiveOrgKey()));
                    }

                case _GxepActions2.default.LOADED:
                    {
                        return state.done().clearError().setValue(action.data);
                    }

                case _GxepActions2.default.LOAD_ERROR:
                    {
                        return _LoadObject2.default.withError(action.error);
                    }

                case _GxepActions2.default.UPDATE_PASSWORD:
                    {
                        return state.map(function (ps) {
                            return ps.map(function (it) {
                                return it.key === action.key ? _extends({}, it, { password: action.password }) : it;
                            });
                        });
                    }

                case _GxepActions2.default.START_SAVE:
                    {
                        return state.updating(_DataManager2.default.saveGxepInfo(_userStore2.default.getActiveOrgKey(), state.getValueEnforcing()));
                    }

                case _GxepActions2.default.SAVED:
                case _GxepActions2.default.SAVE_ERROR:
                case _GxepActions2.default.DIALOG_CLOSED:
                    {
                        return this.getInitialState();
                    }

                default:
                    return state;
            }
        }
    }, {
        key: "getState",
        value: function getState() {
            var _this2 = this;

            return (0, _storeUtils.hotLoadObject)(function () {
                return _get(GxepStore.prototype.__proto__ || Object.getPrototypeOf(GxepStore.prototype), "getState", _this2).call(_this2);
            }, function () {
                return _Dispatcher2.default.dispatch({
                    type: _GxepActions2.default.START_LOAD
                });
            });
        }
    }]);

    return GxepStore;
}(_utils.ReduceStore);

var itemShapeType = exports.itemShapeType = _propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    password: _propTypes2.default.string.isRequired
});

GxepStore.stateTypes = (0, _loadObjectOf2.default)(_propTypes2.default.arrayOf(itemShapeType));

exports.default = (0, _typeCheckingStore2.default)(new GxepStore());

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var AppLayout, AppModel, Application, DataEntryController, DataQualityReport, DataQualityReportModule, HEXController, MainController, Model, MonitoringController, RecordBrowserController, Router, SessionController, ViewController,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Model = __webpack_require__(83)["default"];

AppModel = __webpack_require__(324);

AppLayout = __webpack_require__(995)["default"];

Router = __webpack_require__(1026)["default"];

DataQualityReport = __webpack_require__(1453)["default"];

DataQualityReportModule = __webpack_require__(1454)["default"];

ViewController = __webpack_require__(1468)["default"];

MainController = __webpack_require__(1508)["default"];

MonitoringController = __webpack_require__(1511)["default"];

RecordBrowserController = __webpack_require__(1584)["default"];

DataEntryController = __webpack_require__(1586);

HEXController = __webpack_require__(1588)["default"];

SessionController = __webpack_require__(1590)["default"];

Application = (function(_super) {
  __extends(Application, _super);

  Application.prototype.__allow_initialization__ = true;

  function Application() {
    this.initialize = __bind(this.initialize, this);
    this.addInitializationPromise = __bind(this.addInitializationPromise, this);    Application.__super__.constructor.call(this);
    this.initializationPromises = [];
  }

  Application.prototype.addInitializationPromise = function(promise) {
    var self;

    self = this;
    return this.initializationPromises.push(promise.then(function(v) {
      return v;
    }, function(reason) {
      self.__allow_initialization__ = false;
      if (!(promise instanceof Promise)) {
        console.log("INIT REJECT", reason || "[no reason given]");
      }
      throw reason;
    }));
  };

  Application.prototype.initialize = function() {
    var self,
      _this = this;

    if (!this.__allow_initialization__) {
      return;
    }
    self = this;
    if (this.initializationPromises.length) {
      Promise.all(this.initializationPromises).then(function() {
        return self.initialize();
      });
      this.initializationPromises = [];
      return;
    }
    this.__allow_initialization__ = false;
    this.model = new AppModel();
    this.addInitializer(function(options) {
      _this.model.set("hex", new Model({
        dateRange: null,
        participants: null
      }));
      return _this.model.set("dataQualityReport", new DataQualityReport());
    });
    this.on("initialize:after", function(options) {
      return _this.mainController.dispatch("load:initialData");
    });
    this.addInitializer(function(options) {
      return _this.layout = new AppLayout({
        appModel: _this.model
      });
    });
    this.addInitializer(function(options) {
      _this.viewController = new ViewController({
        model: _this.model,
        app: _this
      });
      _this.mainController = new MainController({
        model: _this.model,
        app: _this
      });
      _this.monitoringController = new MonitoringController({
        model: _this.model,
        app: _this
      });
      _this.hexController = new HEXController({
        model: _this.model.get("hex")
      });
      _this.recordBrowserController = new RecordBrowserController({
        model: _this.model,
        app: _this
      });
      _this.dataEntryController = new DataEntryController();
      return _this.DataQualityReportModule = new DataQualityReportModule(_this);
    });
    this.addInitializer(function(options) {
      return _this.router = new Router(_this);
    });
    this.addInitializer(function(options) {
      return _this.logoutController = new SessionController();
    });
    this.addInitializer(function(options) {
      var PlatformDetect, el, isMobile, platformDetect;

      el = $('body');
      PlatformDetect = __webpack_require__(1591);
      platformDetect = new PlatformDetect();
      platformDetect.addPlatformClassesToElement(el);
      isMobile = platformDetect.isMobile();
      return _this.reqres.addHandler("isMobile", function() {
        return isMobile;
      });
    });
    this.start();
    return this;
  };

  return Application;

})(Backbone.Marionette.Application);

module.exports = new Application();


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var Collection, Model, Stereotype, Stereotypes, _ref,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Collection = __webpack_require__(145);

Model = __webpack_require__(83)["default"];

Stereotype = __webpack_require__(489);

module.exports = Stereotypes = (function(_super) {
  __extends(Stereotypes, _super);

  function Stereotypes() {
    this.inflateRelationship = __bind(this.inflateRelationship, this);
    this.inflateRelationships = __bind(this.inflateRelationships, this);
    this.populate = __bind(this.populate, this);    _ref = Stereotypes.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  Stereotypes.prototype.model = Stereotype;

  Stereotypes.prototype.populate = function(data, test) {
    this.all = new Collection(data, {
      model: this.model
    });
    this.reset(_.filter(data, test));
    return this.inflateRelationships();
  };

  Stereotypes.prototype.inflateRelationships = function() {
    var _this = this;

    return this.each(function(type) {
      return _this.inflateRelationship(type.get('fields'));
    });
  };

  Stereotypes.prototype.inflateRelationship = function(fields) {
    var _this = this;

    return fields.each(function(field) {
      if (field.get('type') === 'to-one' || field.get('type') === 'to-many') {
        return _this.all.where({
          key: field.get('otherStereotype')
        }).forEach(function(relType) {
          field.set('name', relType.get('name'));
          return field.set('value', relType.get('fields'));
        });
      }
    });
  };

  return Stereotypes;

})(Collection);


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var Collection, Creatable, Field, Model, Stereotype, _ref,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Collection = __webpack_require__(145);

Model = __webpack_require__(83)["default"];

Creatable = __webpack_require__(992);

Field = __webpack_require__(994);

module.exports = Stereotype = (function(_super) {
  __extends(Stereotype, _super);

  function Stereotype() {
    this.getMagicRootEntityName = __bind(this.getMagicRootEntityName, this);
    this.getMagicRoot = __bind(this.getMagicRoot, this);
    this.initialize = __bind(this.initialize, this);    _ref = Stereotype.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  Stereotype.prototype.defaults = {
    creatables: null,
    fields: null
  };

  Stereotype.prototype.initialize = function() {
    this.set("creatables", new Collection(this.attributes.creatables, {
      model: Creatable
    }));
    return this.set("fields", new Collection(this.attributes.fields, {
      model: Field,
      defaultKey: this.attributes.defaultFieldKey
    }));
  };

  Stereotype.prototype.getMagicRoot = function() {
    var _this = this;

    if (this.get("magicRoot") === true || !this.collection) {
      return this;
    } else {
      return this.collection.find(function(item) {
        return item.get('key') === _this.get("magicRootKey");
      });
    }
  };

  Stereotype.prototype.getMagicRootEntityName = function() {
    return this.getMagicRoot().get('name');
  };

  return Stereotype;

})(Model);


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var Collection, Model, RecordBrowserState, _ref,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Model = __webpack_require__(83)["default"];

Collection = __webpack_require__(145);

module.exports = RecordBrowserState = (function(_super) {
  __extends(RecordBrowserState, _super);

  function RecordBrowserState() {
    this.initialize = __bind(this.initialize, this);    _ref = RecordBrowserState.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  RecordBrowserState.prototype.defaults = {
    isGlobal: false,
    keywords: null,
    searchResults: null,
    closeOnSelect: null
  };

  RecordBrowserState.prototype.initialize = function() {
    var _this = this;

    return this.on("change:stereotype", function() {
      _this.set('keywords', "");
      _this.set('searchResults', void 0);
      _this.versions = new Collection();
      return _this.get('stereotype').get('creatables').each(function(creatable) {
        return creatable.get('versions').each(function(version) {
          return _this.versions.add({
            label: creatable.get('label') + " " + version.get("label"),
            version: version,
            lookup: _this.lookup
          });
        });
      });
    });
  };

  return RecordBrowserState;

})(Model);


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _promisify = __webpack_require__(97);

var _promisify2 = _interopRequireDefault(_promisify);

var _BaseServices = __webpack_require__(76);

var _BaseServices2 = _interopRequireDefault(_BaseServices);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var dehydrate = function dehydrate(m) {
    return {
        activeAt: (m.activeAt || moment()).valueOf(),
        expiresAt: m.expiresAt.valueOf(),
        message: m.message.trim()
    };
};

var rehydrate = function rehydrate(m) {
    return _extends({}, m, {
        activeAt: moment(m.activeAt),
        expiresAt: moment(m.expiresAt)
    });
};

var BroadcastServices = function () {
    function BroadcastServices() {
        _classCallCheck(this, BroadcastServices);
    }

    _createClass(BroadcastServices, [{
        key: "getMessages",
        value: function getMessages(after) {
            return (0, _promisify2.default)(_BaseServices2.default.getRequest("broadcast?after=" + after, null, { background: true })).then(function (ms) {
                return ms.map(rehydrate);
            });
        }
    }, {
        key: "getAllMessages",
        value: function getAllMessages() {
            return (0, _promisify2.default)(_BaseServices2.default.getRequest(["broadcast", "admin"])).then(function (ms) {
                return ms.map(rehydrate);
            });
        }
    }, {
        key: "createMessage",
        value: function createMessage(m) {
            return (0, _promisify2.default)(_BaseServices2.default.jsonPost(["broadcast", "admin"], dehydrate(m)));
        }
    }, {
        key: "deleteMessage",
        value: function deleteMessage(m) {
            return (0, _promisify2.default)(_BaseServices2.default.jsonPost(["broadcast", "admin", m.id], null, { type: "DELETE" }));
        }
    }]);

    return BroadcastServices;
}();

exports.default = new BroadcastServices();

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Services = __webpack_require__(110);

var _Services2 = _interopRequireDefault(_Services);

var _ajaxHelper = __webpack_require__(318);

var _ajaxHelper2 = _interopRequireDefault(_ajaxHelper);

var _DevelopmentActions = __webpack_require__(98);

var _DevelopmentActions2 = _interopRequireDefault(_DevelopmentActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DevDataManager = {
    loadITManifest: function loadITManifest() {
        return (0, _ajaxHelper2.default)(_Services2.default.loadITManifest(), {
            type: _DevelopmentActions2.default.IT_MANIFEST_LOADED
        }, {
            type: _DevelopmentActions2.default.IT_MANIFEST_ERROR
        });
    },
    loadMocksetManifest: function loadMocksetManifest() {
        return (0, _ajaxHelper2.default)(_Services2.default.loadMocksetManifest(), {
            type: _DevelopmentActions2.default.MOCKSET_MANIFEST_LOADED
        }, {
            type: _DevelopmentActions2.default.MOCKSET_MANIFEST_ERROR
        });
    }
};

exports.default = DevDataManager;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(13);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _DevelopmentActions = __webpack_require__(98);

var _DevelopmentActions2 = _interopRequireDefault(_DevelopmentActions);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ITTestStore = function (_ReduceStore) {
    _inherits(ITTestStore, _ReduceStore);

    function ITTestStore() {
        _classCallCheck(this, ITTestStore);

        return _possibleConstructorReturn(this, (ITTestStore.__proto__ || Object.getPrototypeOf(ITTestStore)).call(this, _Dispatcher2.default));
    }

    _createClass(ITTestStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {};
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {
                case _DevelopmentActions2.default.SELECT_IT_TEST:
                    return {
                        path: action.path,
                        script: action.script
                    };
                case _DevelopmentActions2.default.AD_HOC_IT_TEST:
                    return {
                        path: null,
                        script: action.script
                    };
                case _DevelopmentActions2.default.IT_TEST_ERROR:
                    return _extends({}, state, {
                        success: false,
                        message: action.message
                    });
                case _DevelopmentActions2.default.IT_TEST_SUCCESS:
                    if (state.success != null) return state;
                    return _extends({}, state, {
                        success: true
                    });
                default:
                    return state;
            }
        }
    }]);

    return ITTestStore;
}(_utils.ReduceStore);

ITTestStore.stateTypes = {
    path: _propTypes2.default.string,
    script: _propTypes2.default.string
};

exports.default = (0, _typeCheckingStore2.default)(new ITTestStore());

/***/ }),
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DrawerLayout2 = __webpack_require__(328);

var _DrawerLayout3 = _interopRequireDefault(_DrawerLayout2);

var _asMarionetteView = __webpack_require__(101);

var _Default = __webpack_require__(1028);

var _Default2 = _interopRequireDefault(_Default);

var _SearchModule = __webpack_require__(499);

var _DataEntryFormModule = __webpack_require__(1036);

var _DataEntryFormModule2 = _interopRequireDefault(_DataEntryFormModule);

var _CallbackContainer = __webpack_require__(1442);

var _CallbackContainer2 = _interopRequireDefault(_CallbackContainer);

var _NavigatorStore = __webpack_require__(33);

var _NavigatorStore2 = _interopRequireDefault(_NavigatorStore);

var _FormStore = __webpack_require__(142);

var _FormStore2 = _interopRequireDefault(_FormStore);

var _BrowserStore = __webpack_require__(354);

var _BrowserStore2 = _interopRequireDefault(_BrowserStore);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _SearchFormActions = __webpack_require__(75);

var _SearchFormActions2 = _interopRequireDefault(_SearchFormActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MarionetteSearchModule = (0, _asMarionetteView.asMarionetteView)(_SearchModule.BackboneSearchModule);

var DataEntryModule = function (_DrawerLayout) {
    _inherits(DataEntryModule, _DrawerLayout);

    function DataEntryModule() {
        var _ref;

        _classCallCheck(this, DataEntryModule);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = DataEntryModule.__proto__ || Object.getPrototypeOf(DataEntryModule)).call.apply(_ref, [this].concat(args)));

        _this.onRender = _this.onRender.bind(_this);
        _this.searchOnRender = !!args[0].searchOnRender;
        _this.useDefaultSearch = !!args[0].useDefaultSearch;
        return _this;
    }

    _createClass(DataEntryModule, [{
        key: "onDomRefresh",
        value: function onDomRefresh() {
            this.model.set("boundingElement", this.$el[0].parentNode);
        }
    }, {
        key: "onRender",
        value: function onRender() {
            var _this2 = this;

            var model = this.model;

            var fluxContext = model.get("fluxContext");

            // select the default stereotype, if one isn't already selected
            _Dispatcher2.default.contextDispatch(fluxContext, {
                type: _SearchFormActions2.default.INITIALIZE_CONTEXT,
                key: _StereotypesStore2.default.getDefaultKey(),
                availableKeys: _StereotypesStore2.default.getDataEntryStereotypes().map(function (s) {
                    return s.key;
                }),
                useDefaultSearch: this.useDefaultSearch,
                initiateSearch: this.searchOnRender
            });
            this.searchModule = new MarionetteSearchModule({
                appModel: this.model,
                showCreate: true,
                useDefaultSearch: this.useDefaultSearch
            });

            this.drawer.show(this.searchModule);
            var resizeToken = _CallbackContainer2.default.createFunctional(function () {
                return _this2.searchModule.render();
            }, function () {
                return [_BrowserStore2.default];
            }, function () {
                return _BrowserStore2.default.getSize();
            });
            this.on("before:close", function () {
                return resizeToken.close();
            });

            var formToken = _CallbackContainer2.default.createFunctional(function (props) {
                //create and display the data entry form
                if (props && props.hasForm) {
                    if (_this2.dev == null) {
                        _this2.dev = new _DataEntryFormModule2.default({
                            fluxContext: _this2.model.get("fluxContext"),
                            isModal: _this2.model.get("isModal")
                        });
                    }
                    if (_this2.dev !== _this2.content.currentView) {
                        // this replaces the DOM for the entire DE layer
                        _this2.content.show(_this2.dev);
                    }
                    if (props.doFormTransition) {
                        _this2.onDrawerEnable();
                        _this2.onDrawerClose();
                    }
                    _this2.dev.showForm();
                } else {
                    if (props.doFormTransition) {
                        var mv = new ((0, _asMarionetteView.asMarionetteView)(_Default2.default))({
                            fluxContext: fluxContext
                        });
                        _this2.onDrawerOpen();
                        _this2.content.show(mv);
                    }
                }
            }, function () {
                return [_NavigatorStore2.default, _FormStore2.default];
            }, function (prev) {
                var next = _extends({}, _NavigatorStore2.default.getState(fluxContext));
                // This is sorta wonky, because Flux/React are about rendering
                // while Marionette is about transitioning. C'est la vie.
                next.hasForm = next && next.magic != null;
                next.doFormTransition = prev == null || next.hasForm !== prev.hasForm || next.magic !== prev.magic;
                // End wonky.
                if (next.record) {
                    next.formLO = _FormStore2.default.getFormLO(next.record.key);
                }
                if (prev == null) return next;
                if (prev.magic !== next.magic) return next;
                if (prev.record !== next.record) return next;
                if (prev.formLO !== next.formLO) return next;
                return prev;
            });
            formToken.force();
            this.on("before:close", function () {
                return formToken.close();
            });
        }
    }]);

    return DataEntryModule;
}(_DrawerLayout3.default);

DataEntryModule.prototype.className = "de-layout";

exports.default = DataEntryModule;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BackboneSearchModule = exports.SearchModule = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(51);

var _classnames2 = _interopRequireDefault(_classnames);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _Button = __webpack_require__(52);

var _Button2 = _interopRequireDefault(_Button);

var _SearchForm = __webpack_require__(233);

var _SearchForm2 = _interopRequireDefault(_SearchForm);

var _SearchResults = __webpack_require__(1029);

var _SearchResults2 = _interopRequireDefault(_SearchResults);

var _backboneConnect = __webpack_require__(127);

var _withOver = __webpack_require__(58);

var _SearchFormStore = __webpack_require__(82);

var _SearchFormStore2 = _interopRequireDefault(_SearchFormStore);

var _stereotypes = __webpack_require__(126);

var _ErrorBoundary = __webpack_require__(329);

var _ErrorBoundary2 = _interopRequireDefault(_ErrorBoundary);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _SearchResultStore = __webpack_require__(159);

var _SearchResultStore2 = _interopRequireDefault(_SearchResultStore);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _SearchFormActions = __webpack_require__(75);

var _SearchFormActions2 = _interopRequireDefault(_SearchFormActions);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _SplitButton = __webpack_require__(501);

var _SplitButton2 = _interopRequireDefault(_SplitButton);

var _useFluxStore2 = __webpack_require__(9);

var _useFluxStore3 = _interopRequireDefault(_useFluxStore2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TheButton = function TheButton(props) {
    var stereoKey = props.stereoKey,
        menuItemOnClick = props.menuItemOnClick;

    var _useFluxStore = (0, _useFluxStore3.default)(function () {
        var stereo = _StereotypesStore2.default.getStereotypeByKey(stereoKey);
        if (stereo.magicRootKey != null) {
            stereo = _StereotypesStore2.default.getStereotypeByKey(stereo.magicRootKey);
        }
        return {
            options: (0, _stereotypes.buildMenu)(stereo.key).map(function (it) {
                return _extends({ value: it.key }, it);
            }),
            newTypeLabel: stereo.name
        };
    }, [_StereotypesStore2.default], [stereoKey]),
        options = _useFluxStore.options,
        newTypeLabel = _useFluxStore.newTypeLabel;

    if (options.length === 0) {
        return null; // nothing to create.
    }
    return _react2.default.createElement(_Button2.default, {
        id: "newEntity",
        enabled: true,
        onClick: menuItemOnClick,
        className: "btn btn-create",
        options: options,
        dataAlign: "fill",
        ddActionName: "Create " + newTypeLabel,
        label: "Create a new " + newTypeLabel
    });
};

TheButton.propTypes = {
    stereoKey: _propTypes2.default.string.isRequired,
    menuItemOnClick: _propTypes2.default.func.isRequired
};

var SearchModule = exports.SearchModule = function (_React$Component) {
    _inherits(SearchModule, _React$Component);

    function SearchModule(props) {
        _classCallCheck(this, SearchModule);

        var _this = _possibleConstructorReturn(this, (SearchModule.__proto__ || Object.getPrototypeOf(SearchModule)).call(this, props));

        _this.state = {
            resultMaxHeight: "30vh"
        };

        _this.onSearch = _this.onSearch.bind(_this);
        _this.onSearchAndSave = _this.onSearchAndSave.bind(_this);
        _this.onRestoreAndSearch = _this.onRestoreAndSearch.bind(_this);

        _this.formLayoutRef = _react2.default.createRef();
        return _this;
    }

    _createClass(SearchModule, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.measure();
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            this.measure();
        }
    }, {
        key: "measure",
        value: function measure() {
            var boundingElement = this.props.boundingElement;

            if (!boundingElement) return;
            var boundingRect = boundingElement.getBoundingClientRect();
            var availableHeight = boundingRect.height;
            if (availableHeight === 0) return; // thanks marionette
            var fel = this.formLayoutRef.current;
            if (!fel) return;
            if (!document.body.contains(fel)) return; // thanks marionette
            var resultMaxHeight = Math.max(80, // always want this much
            availableHeight + boundingRect.top + // chrome
            -fel.getBoundingClientRect().bottom + // form
            -55 // pull
            - 38 // pagination
            ) + "px";
            this.setState(function (s) {
                if (s.resultMaxHeight === resultMaxHeight) return;
                return {
                    resultMaxHeight: resultMaxHeight
                };
            });
        }
    }, {
        key: "onSearch",
        value: function onSearch() {
            var _props = this.props,
                fluxContext = _props.fluxContext,
                onSearch = _props.onSearch,
                showEmptySearchAlert = _props.showEmptySearchAlert;

            if (!_SearchFormStore2.default.hasValues(fluxContext)) {
                showEmptySearchAlert();
                return;
            }
            onSearch && onSearch();
        }
    }, {
        key: "onSearchAndSave",
        value: function onSearchAndSave() {
            var _props2 = this.props,
                fluxContext = _props2.fluxContext,
                onSearchAndSaveDefault = _props2.onSearchAndSaveDefault,
                showEmptySearchAlert = _props2.showEmptySearchAlert;

            if (!_SearchFormStore2.default.hasValues(fluxContext)) {
                showEmptySearchAlert();
                return;
            }
            onSearchAndSaveDefault && onSearchAndSaveDefault();
        }
    }, {
        key: "onRestoreAndSearch",
        value: function onRestoreAndSearch() {
            var _props3 = this.props,
                defaultSearch = _props3.defaultSearch,
                onRestoreDefaultSearch = _props3.onRestoreDefaultSearch,
                showNoSavedSearchAlert = _props3.showNoSavedSearchAlert;

            if (!defaultSearch.enabled || !defaultSearch.query) {
                showNoSavedSearchAlert();
                return;
            }
            onRestoreDefaultSearch && onRestoreDefaultSearch();
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props4 = this.props,
                _props4$title = _props4.title,
                title = _props4$title === undefined ? "Find or Create New Record" : _props4$title,
                stereotypes = _props4.stereotypes,
                selectedStereotype = _props4.selectedStereotype,
                fluxContext = _props4.fluxContext,
                menuItemOnClick = _props4.menuItemOnClick,
                onStereotypeSelect = _props4.onStereotypeSelect,
                records = _props4.records,
                selectedRecord = _props4.selectedRecord,
                columns = _props4.columns,
                sorts = _props4.sorts,
                onSort = _props4.onSort,
                onRecordSelection = _props4.onRecordSelection,
                showDisabled = _props4.showDisabled,
                defaultSearch = _props4.defaultSearch,
                _props4$showAdvanced = _props4.showAdvanced,
                showAdvanced = _props4$showAdvanced === undefined ? false : _props4$showAdvanced,
                _props4$showCreate = _props4.showCreate,
                showCreate = _props4$showCreate === undefined ? true : _props4$showCreate,
                _props4$pagination = _props4.pagination,
                pagination = _props4$pagination === undefined ? {} : _props4$pagination,
                onPage = _props4.onPage,
                isLoading = _props4.isLoading;


            var hasStereotypes = stereotypes.length > 1;
            var typesClasses = (0, _classnames2.default)({
                "col-md-3": hasStereotypes,
                "hidden": !hasStereotypes
            });
            var formClasses = (0, _classnames2.default)({
                "col-md-6": hasStereotypes,
                "col-md-9": !hasStereotypes
            });

            var searchByValue = selectedStereotype.key,
                searchByName = selectedStereotype.name,
                supportsEnablement = selectedStereotype.supportsEnablement;

            var searchByOptions = stereotypes.map(function (item) {
                var value = item.key;
                return {
                    value: value,
                    // dynamic label
                    label: searchByValue === value ? "Search By " + item.name : item.name
                };
            });

            var useDefaultSearch = !!defaultSearch ? defaultSearch.enabled : false;
            var useStandardSearch = !useDefaultSearch;
            var hasDefaultSearch = useDefaultSearch ? defaultSearch.query : false;
            var missingDefaultSearch = !hasDefaultSearch;
            var searchButton = useStandardSearch ? _react2.default.createElement(_Button2.default, {
                enabled: true,
                icon: "search",
                onClick: this.onSearch,
                className: "btn btn-primary search-button",
                label: "Search",
                ddActionName: "Search " + searchByName
            }) : [_react2.default.createElement(_SplitButton2.default, {
                key: "search-button",
                type: "primary",
                className: "search-button",
                ddActionName: "Search " + searchByName,
                actions: [{
                    icon: "search",
                    label: "Search",
                    value: "search",
                    onSelect: this.onSearch
                }, {
                    label: "Search and Save as Default",
                    value: "save",
                    onSelect: this.onSearchAndSave
                }, {
                    label: "Restore Default Search",
                    value: "restore",
                    onSelect: this.onRestoreAndSearch
                }]
            }), missingDefaultSearch && _react2.default.createElement(
                "span",
                {
                    key: "no-saved-search",
                    className: "no-saved-search",
                    style: {
                        fontSize: "80%",
                        opacity: 0.6
                    }
                },
                _react2.default.createElement(
                    "sup",
                    null,
                    "*"
                ),
                "No default search saved"
            )];

            return _react2.default.createElement(
                _ErrorBoundary2.default,
                null,
                _react2.default.createElement(
                    "div",
                    { className: "search-form-layout", ref: this.formLayoutRef },
                    _react2.default.createElement(
                        "div",
                        { className: "row" },
                        _react2.default.createElement(
                            "div",
                            { className: "col-md-12" },
                            _react2.default.createElement(
                                "h2",
                                null,
                                title
                            )
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "row" },
                        _react2.default.createElement(
                            "div",
                            { className: typesClasses, id: "types" },
                            hasStereotypes && _react2.default.createElement(_Select2.default, {
                                id: "stereotype",
                                options: searchByOptions,
                                onCommitChange: onStereotypeSelect,
                                value: searchByValue,
                                label: "Search By"
                            })
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: formClasses, id: "form" },
                            _react2.default.createElement(_SearchForm2.default, {
                                fluxContext: fluxContext,
                                onSubmit: this.onSearch,
                                showAdvanced: showAdvanced,
                                supportsRelativeDates: true,
                                onHeightChange: function onHeightChange() {
                                    return _this2.forceUpdate();
                                }
                            })
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "row" },
                        _react2.default.createElement(
                            "div",
                            { className: "col-md-7" },
                            searchButton
                        ),
                        showCreate && _react2.default.createElement(
                            "div",
                            { className: "col-md-offset-2 col-md-3", id: "new-entity" },
                            _react2.default.createElement(
                                "div",
                                { className: "btn-group full" },
                                _react2.default.createElement(TheButton, {
                                    stereoKey: selectedStereotype.key,
                                    menuItemOnClick: menuItemOnClick
                                })
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { id: "results" },
                    (records || isLoading) && _react2.default.createElement(_SearchResults2.default, {
                        records: records,
                        selected: selectedRecord,
                        columns: columns,
                        sorts: sorts,
                        onSort: onSort,
                        hasStereotype: hasStereotypes,
                        onRecordSelection: onRecordSelection,
                        showDisabled: showDisabled,
                        supportsEnablement: supportsEnablement,
                        maxHeight: this.state.resultMaxHeight,
                        pagination: pagination,
                        onPage: onPage,
                        isLoading: isLoading
                    })
                )
            );
        }
    }]);

    return SearchModule;
}(_react2.default.Component);

SearchModule.propTypes = {
    boundingElement: _propTypes2.default.instanceOf(Node),

    // search form props
    fluxContext: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string,
    stereotypes: _propTypes2.default.array.isRequired,
    defaultSearch: _propTypes2.default.shape({
        enabled: _propTypes2.default.bool.isRequired,
        query: _propTypes2.default.object
    }),
    selectedStereotype: _propTypes2.default.object.isRequired,
    onSearch: _propTypes2.default.func.isRequired,
    onSearchAndSaveDefault: _propTypes2.default.func,
    onRestoreDefaultSearch: _propTypes2.default.func,
    showEmptySearchAlert: _propTypes2.default.func.isRequired,
    showNoSavedSearchAlert: _propTypes2.default.func,
    menuItemOnClick: _propTypes2.default.func.isRequired,
    onStereotypeSelect: _propTypes2.default.func.isRequired,
    showCreate: _propTypes2.default.bool,
    showAdvanced: _propTypes2.default.bool,

    // search result props
    records: _propTypes2.default.array,
    selectedRecord: _propTypes2.default.object,
    columns: _propTypes2.default.array,
    sorts: _propTypes2.default.object,
    onSort: _propTypes2.default.func.isRequired,
    onRecordSelection: _propTypes2.default.func.isRequired,
    showDisabled: _propTypes2.default.bool,
    pagination: _propTypes2.default.shape({
        page: _propTypes2.default.number,
        pageCount: _propTypes2.default.number,
        pageSize: _propTypes2.default.number,
        totalResultCount: _propTypes2.default.number
    }).isRequired,
    onPage: _propTypes2.default.func,
    isLoading: _propTypes2.default.bool
};

var config = function config(props) {
    return {
        boundingElement: {
            listenOn: "appModel"
        }
    };
};

var BackboneSearchModule = exports.BackboneSearchModule = (0, _backboneConnect.backboneConnect)(config)(function (props) {
    var state = (0, _useFluxStore3.default)(function () {
        var fluxContext = props.appModel.get("fluxContext");
        var searchKey = _SearchFormStore2.default.getKey(fluxContext);
        var searchResults = _SearchResultStore2.default.getMostRecentSearch(searchKey);
        var defaultSearch = props.useDefaultSearch ? _userStore2.default.getDefaultSearchConfig() : { enabled: false };
        return {
            fluxContext: fluxContext,
            stereotypes: _StereotypesStore2.default.getStereotypesByKeys(_SearchFormStore2.default.getAvailableKeys(fluxContext)),
            defaultSearch: defaultSearch,
            selectedStereotype: _StereotypesStore2.default.getStereotypeByKey(searchKey),
            isLoading: _SearchResultStore2.default.isMostRecentSearchLoading(searchKey),
            records: searchResults && searchResults.results,
            pagination: {
                // Currently some paging values can not be trusted from the
                // results. Instead we are using the SearchFormStore's values
                // until there is a need to fix the values from the server.
                page: _SearchFormStore2.default.getPage(fluxContext),
                pageCount: searchResults && searchResults.pageCount, // cant be trusted
                pageSize: _SearchFormStore2.default.getPageSize(fluxContext),
                totalResultCount: searchResults && searchResults.totalResultCount // cant be trusted.
            },
            columns: _SearchFormStore2.default.getFields(fluxContext),
            sorts: _SearchFormStore2.default.getSorts(fluxContext),
            onSort: function onSort(column) {
                _Dispatcher2.default.contextDispatch(fluxContext, {
                    type: _SearchFormActions2.default.SORT,
                    key: column.key
                });
            },
            onPage: function onPage(page) {
                _Dispatcher2.default.contextDispatch(fluxContext, {
                    type: _SearchFormActions2.default.SELECT_PAGE,
                    page: page
                });
            },
            selectedRecord: _SearchFormStore2.default.getSelectedResult(fluxContext),
            onRecordSelection: function onRecordSelection(result) {
                _Dispatcher2.default.contextDispatch(fluxContext, {
                    type: _SearchFormActions2.default.SELECT_RESULT,
                    result: result
                });
                Backbone.dispatcher.trigger("entity:load", result, props.appModel);
            },
            menuItemOnClick: function menuItemOnClick(e, d, creatable) {
                return Backbone.dispatcher.trigger("entity:new", creatable.key, creatable.org, creatable.entity, props.appModel);
            },
            onSearch: function onSearch() {
                return _Dispatcher2.default.contextDispatch(fluxContext, {
                    type: _SearchFormActions2.default.INITIATE_SEARCH,
                    key: searchKey
                });
            },
            onSearchAndSaveDefault: function onSearchAndSaveDefault() {
                return _Dispatcher2.default.contextDispatch(fluxContext, {
                    type: _SearchFormActions2.default.INITIATE_SEARCH_AND_SAVE_DEFAULT,
                    key: searchKey
                });
            },
            onRestoreDefaultSearch: function onRestoreDefaultSearch() {
                return _Dispatcher2.default.contextDispatch(fluxContext, {
                    type: _SearchFormActions2.default.RESTORE_DEFAULT_AND_INITIATE_SEARCH,
                    key: defaultSearch.query.key
                });
            },
            showEmptySearchAlert: function showEmptySearchAlert() {
                return (0, _withOver.appAlert)("Search requires at least one criterion.");
            },
            showNoSavedSearchAlert: function showNoSavedSearchAlert() {
                return (0, _withOver.appAlert)("No default search is available to restore.");
            },
            onStereotypeSelect: function onStereotypeSelect(key) {
                return _Dispatcher2.default.contextDispatch(fluxContext, {
                    type: _SearchFormActions2.default.SELECT_STEREOTYPE,
                    key: key
                });
            }
        };
    }, [_SearchFormStore2.default, _SearchResultStore2.default, _userStore2.default], [props.appModel]);
    return _react2.default.createElement(SearchModule, _extends({}, props, state));
});

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FileTemplate = function (_React$Component) {
    _inherits(FileTemplate, _React$Component);

    function FileTemplate() {
        _classCallCheck(this, FileTemplate);

        return _possibleConstructorReturn(this, (FileTemplate.__proto__ || Object.getPrototypeOf(FileTemplate)).apply(this, arguments));
    }

    _createClass(FileTemplate, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                data = _props.data,
                onDownloadClick = _props.onDownloadClick;
            var id = data.id,
                filename = data.filename,
                recordCount = data.recordCount;

            if (filename == null) return null;
            return _react2.default.createElement(
                "a",
                { href: "#", className: "download",
                    onClick: onDownloadClick.bind(this, data),
                    "data-id": id,
                    "data-filename": filename,
                    "data-count": recordCount },
                _react2.default.createElement("span", { className: "glyphicon glyphicon-download-alt" }),
                " ",
                filename,
                " "
            );
        }
    }]);

    return FileTemplate;
}(_react2.default.Component);

exports.default = FileTemplate;


FileTemplate.propTypes = {
    data: _propTypes2.default.object.isRequired,
    onDownloadClick: _propTypes2.default.func
};

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Button = __webpack_require__(52);

var _Button2 = _interopRequireDefault(_Button);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames3 = __webpack_require__(51);

var _classnames4 = _interopRequireDefault(_classnames3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function SplitButton(_ref) {
    var actions = _ref.actions,
        type = _ref.type,
        className = _ref.className,
        disabled = _ref.disabled,
        passthrough = _objectWithoutProperties(_ref, ["actions", "type", "className", "disabled"]);

    var dropdownAnchorRef = _react2.default.useRef();

    function handleSelect(e, ignored, action) {
        e.preventDefault();
        action && action.onSelect && action.onSelect();
    }

    return _react2.default.createElement(
        "div",
        {
            className: (0, _classnames4.default)("btn-group", "split-button", className),
            ref: dropdownAnchorRef
        },
        _react2.default.createElement(_Button2.default, _extends({}, passthrough, {
            enabled: !disabled,
            icon: actions[0].icon,
            onClick: handleSelect,
            className: (0, _classnames4.default)("btn", "btn-" + type, _defineProperty({}, "primary-" + className, !!className)),
            label: actions[0].label,
            value: actions[0]
        })),
        _react2.default.createElement(_Button2.default, {
            enabled: !disabled,
            onClick: handleSelect,
            className: (0, _classnames4.default)("btn", "btn-" + type, _defineProperty({}, "split-" + className, !!className)),
            options: actions,
            anchorRef: dropdownAnchorRef
        })
    );
}

SplitButton.propTypes = {
    type: _propTypes2.default.string,
    className: _propTypes2.default.string,
    actions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        label: _propTypes2.default.node.isRequired,
        value: _propTypes2.default.any.isRequired,
        onSelect: _propTypes2.default.func.isRequired
    })).isRequired,
    disabled: _propTypes2.default.bool
};

SplitButton.defaultProps = {
    type: "default"
};

exports.default = SplitButton;

/***/ }),
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _ActiveSectionActions = __webpack_require__(224);

var _ActiveSectionActions2 = _interopRequireDefault(_ActiveSectionActions);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _ContextedReduceStore2 = __webpack_require__(30);

var _ContextedReduceStore3 = _interopRequireDefault(_ContextedReduceStore2);

var _ActiveFormActions = __webpack_require__(111);

var _ActiveFormActions2 = _interopRequireDefault(_ActiveFormActions);

var _typedefs = __webpack_require__(44);

var _FormStore = __webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ActiveSectionStore = function (_ContextedReduceStore) {
    _inherits(ActiveSectionStore, _ContextedReduceStore);

    function ActiveSectionStore() {
        _classCallCheck(this, ActiveSectionStore);

        return _possibleConstructorReturn(this, (ActiveSectionStore.__proto__ || Object.getPrototypeOf(ActiveSectionStore)).call(this, _Dispatcher2.default));
    }

    _createClass(ActiveSectionStore, [{
        key: "getInitialContext",
        value: function getInitialContext() {
            return {
                key: null,
                id: null,
                currentSection: _FormStore.IMPLICIT_TOP_OF_FORM_SECTION_NAME
            };
        }
    }, {
        key: "reduceContext",
        value: function reduceContext(ctx, action) {
            switch (action.type) {
                case _ActiveFormActions2.default.START_RENDER:
                    if (action.key !== ctx.key || action.id !== ctx.id) {
                        return this.getInitialContext();
                    }
                    return ctx;
                case _ActiveSectionActions2.default.SCROLL:
                    if (ctx.key === action.key && ctx.id === action.id && ctx.currentSection === action.section) {
                        return ctx;
                    }
                    return _extends({}, ctx, {
                        key: action.key,
                        id: action.id,
                        currentSection: action.section
                    });
                case _ActiveSectionActions2.default.JUMP_TO_SECTION:
                    return _extends({}, ctx, {
                        currentSection: action.section
                    });
                default:
                    return ctx;
            }
        }
    }, {
        key: "getCurrentSection",
        value: function getCurrentSection(context) {
            return this.getState(context).currentSection;
        }
    }]);

    return ActiveSectionStore;
}(_ContextedReduceStore3.default);

ActiveSectionStore.contextTypes = {
    key: _propTypes2.default.string,
    id: _typedefs.recordIdType,
    currentSection: _propTypes2.default.string
};

exports.default = (0, _typeCheckingStore2.default)(new ActiveSectionStore());

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ActiveFormActions = __webpack_require__(111);

var _ActiveFormActions2 = _interopRequireDefault(_ActiveFormActions);

var _safeDispatch = __webpack_require__(169);

var _safeDispatch2 = _interopRequireDefault(_safeDispatch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoFormView = function NoFormView() {
    _react2.default.useEffect(function () {
        (0, _safeDispatch2.default)({
            type: _ActiveFormActions2.default.NO_FORM_TO_RENDER
        });
    }, []);
    return _react2.default.createElement(
        "h2",
        null,
        "Please select a record above"
    );
};

exports.default = NoFormView;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Formform = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formhelpers = __webpack_require__(5);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _Kids = __webpack_require__(148);

var _Kids2 = _interopRequireDefault(_Kids);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Formform = exports.Formform = function (_React$Component) {
    _inherits(Formform, _React$Component);

    function Formform(props) {
        _classCallCheck(this, Formform);

        var _this = _possibleConstructorReturn(this, (Formform.__proto__ || Object.getPrototypeOf(Formform)).call(this, props));

        _this.onKeyDown = _this.onKeyDown.bind(_this);
        return _this;
    }

    _createClass(Formform, [{
        key: "onKeyDown",
        value: function onKeyDown(e) {
            if (e.key === "Enter" || e.key === "Tab") {
                // Don't submit or save on "enter" key down.
                // Yes allow propagation for DropdownWrapper portal.
                e.preventDefault();
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                selector = _props.selector,
                fluxContext = _props.fluxContext,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor,
                onBlur = _props.onBlur,
                onFocus = _props.onFocus,
                onKeyDown = _props.onKeyDown,
                onGlobalRecordLookup = _props.onGlobalRecordLookup;

            return _react2.default.createElement(
                "form",
                {
                    id: descriptor.id,
                    "data-title": descriptor.label,
                    onKeyDown: this.onKeyDown
                },
                _react2.default.createElement(
                    "div",
                    { className: selector },
                    _react2.default.createElement(_Kids2.default, { descriptor: descriptor,
                        fluxContext: fluxContext,
                        activeRecord: activeRecord,
                        onFocus: onFocus,
                        onBlur: onBlur,
                        onKeyDown: onKeyDown,
                        onGlobalRecordLookup: onGlobalRecordLookup
                    })
                )
            );
        }
    }]);

    return Formform;
}(_react2.default.Component);

Formform.propTypes = {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)(null, false, true)),
    fluxContext: _propTypes2.default.string.isRequired,
    activeRecord: _propTypes2.default.instanceOf(_EntityProxy2.default).isRequired,
    selector: _propTypes2.default.string,
    onFocus: _propTypes2.default.func.isRequired,
    onBlur: _propTypes2.default.func.isRequired,
    onKeyDown: _propTypes2.default.func.isRequired,
    onGlobalRecordLookup: _propTypes2.default.func.isRequired
};

exports.default = Formform;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FileFieldmanager = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _formhelpers = __webpack_require__(5);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _manager = __webpack_require__(297);

var _manager2 = _interopRequireDefault(_manager);

var _fileUploads = __webpack_require__(349);

var _FileUploadStore = __webpack_require__(227);

var _FileUploadStore2 = _interopRequireDefault(_FileUploadStore);

var _FileUploadActions = __webpack_require__(223);

var _FileUploadActions2 = _interopRequireDefault(_FileUploadActions);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FileFieldmanager = exports.FileFieldmanager = function (_BaseFormItem) {
    _inherits(FileFieldmanager, _BaseFormItem);

    function FileFieldmanager(props) {
        _classCallCheck(this, FileFieldmanager);

        var _this = _possibleConstructorReturn(this, (FileFieldmanager.__proto__ || Object.getPrototypeOf(FileFieldmanager)).call(this, props));

        _this.onFilePreview = _this.onFilePreview.bind(_this);
        _this.onFileUpload = _this.onFileUpload.bind(_this);
        _this.onRemoveFile = _this.onRemoveFile.bind(_this);
        _this.getCompletetedFiles = _this.getCompletetedFiles.bind(_this);
        _this.buildFiles = _this.buildFiles.bind(_this);
        _this.setFileMeta = _this.setFileMeta.bind(_this);
        return _this;
    }

    _createClass(FileFieldmanager, [{
        key: "buildFiles",
        value: function buildFiles() {
            var _this2 = this;

            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor;

            var completedCollection = this.getCompletetedFiles().map(function (f) {
                f._status = Hybrid.FileInfo.FILEUPLOADSTATES.COMPLETE;
                return _this2.setFileMeta(f);
            });
            return (0, _fileUploads.buildFilesForField)(descriptor.key, activeRecord.id, completedCollection).map(
            // add meta
            function (f) {
                return {
                    id: f.id,
                    filename: f.filename,
                    status: f._status,
                    progress: f._progress || 0,
                    filesize: f.size,
                    model: f
                };
            });
        }
    }, {
        key: "setFileMeta",
        value: function setFileMeta(file) {
            var _props2 = this.props,
                activeRecord = _props2.activeRecord,
                descriptor = _props2.descriptor;

            var config = descriptor.config || {};
            var org = _userStore2.default.getActiveOrgKey();
            return (0, _fileUploads.buildFileMeta)(descriptor.key, activeRecord.id, org, activeRecord.entityKey, !!config.multiValued, file);
        }
    }, {
        key: "getCompletetedFiles",
        value: function getCompletetedFiles() {
            var _props3 = this.props,
                activeRecord = _props3.activeRecord,
                descriptor = _props3.descriptor;

            var value = activeRecord.get(descriptor.key);
            if (value && !Array.isArray(value)) {
                // always return an array.
                value = [value];
            }
            return value === null ? [] : [].concat(_toConsumableArray(value)); // always return new copy of the array.
        }
    }, {
        key: "onFileUpload",
        value: function onFileUpload(e, d, files) {
            var _props4 = this.props,
                activeRecord = _props4.activeRecord,
                descriptor = _props4.descriptor;

            var completedFiles = this.getCompletetedFiles();
            // files is always an array.
            for (var i = 0; i < files.length; i++) {
                var rawFile = files[i];
                var index = i + completedFiles.length;
                var id = descriptor.key + activeRecord.id + index + new Date().getTime();
                // add extra file meta
                var file = this.setFileMeta({
                    id: id,
                    filename: rawFile.name,
                    contentType: rawFile.type,
                    size: rawFile.size,
                    _data: rawFile,
                    _index: index
                });

                _Dispatcher2.default.dispatch({
                    type: _FileUploadActions2.default.QUEUED,
                    recordKey: activeRecord.entityKey,
                    recordId: activeRecord.id,
                    fieldKey: descriptor.key,
                    file: file
                });
            }
        }
    }, {
        key: "onFilePreview",
        value: function onFilePreview(e, d, file, index) {
            (0, _fileUploads.previewFile)(file.model);
        }
    }, {
        key: "onRemoveFile",
        value: function onRemoveFile(e, d, file, index) {
            var _props5 = this.props,
                activeRecord = _props5.activeRecord,
                descriptor = _props5.descriptor;

            if (file.status === Hybrid.FileInfo.FILEUPLOADSTATES.COMPLETE) {
                var files = this.getCompletetedFiles();
                var fileIndex = _.findIndex(files, function (f) {
                    return f.id === file.model.id;
                });
                files.splice(fileIndex, 1);
                this.onCommitChange(descriptor, files.length ? files : null);
            } else {
                _Dispatcher2.default.dispatch({
                    type: _FileUploadActions2.default.CANCEL,
                    recordKey: activeRecord.entityKey,
                    recordId: activeRecord.id,
                    fieldKey: descriptor.key,
                    file: file.model
                });
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _props6 = this.props,
                activeRecord = _props6.activeRecord,
                descriptor = _props6.descriptor,
                readOnly = _props6.readOnly;

            var config = descriptor.config || {};
            // connect to FileUploadStore
            return _react2.default.createElement(ConnectedControl, _extends({}, this.getPlumbingProps(), {
                value: activeRecord.get(descriptor.key),
                readOnly: readOnly,
                enabled: activeRecord.isFieldEnabled(descriptor.key),
                multiValued: !!config.multiValued,
                onFileOpen: this.onFilePreview,
                onFileRemove: this.onRemoveFile,
                onFileUpload: this.onFileUpload
                // for ConnectedControl to call
                , buildFiles: this.buildFiles
            }));
        }
    }]);

    return FileFieldmanager;
}(_BaseFormItem3.default);

var ConnectedControl = function ConnectedControl(props) {
    var state = (0, _useFluxStore2.default)(function () {
        return {
            files: props.buildFiles()
        };
    }, [_FileUploadStore2.default], [props]);
    return _react2.default.createElement(_manager2.default, _extends({}, props, state));
};

ConnectedControl.propTypes = {
    buildFiles: _propTypes2.default.func.isRequired
};

FileFieldmanager.propTypes = {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)({
        multiValued: _propTypes2.default.bool,
        readOnly: _propTypes2.default.bool
    }))
};

exports.default = FileFieldmanager;

/***/ }),
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var WidgetActions = exports.WidgetActions = {
    WIDGET_CLICK: "widget/widget-click"
};

exports.default = WidgetActions;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ControlResolver = __webpack_require__(139);

exports.default = function (props) {
  return (0, _ControlResolver.buildDescriptorControl)("ChoiceField", "checkbox", props);
};

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var BrowserActions = {
    RESIZE: "browser/resize"
};

exports.default = BrowserActions;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var RecordBrowserActions = exports.RecordBrowserActions = {
    GLOBAL_LOOKUP_CLICK: "record-browser/global-lookup-click"
};

exports.default = RecordBrowserActions;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var PrintActions = {
    LAUNCH_DIALOG: "print/launch-dialog"
};

exports.default = PrintActions;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildRecordItem = exports.buildExcludesFilter = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ValidationTreeStore = __webpack_require__(1415);

var _ValidationTreeStore2 = _interopRequireDefault(_ValidationTreeStore);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _ValidationTreeActions = __webpack_require__(620);

var _ValidationTreeActions2 = _interopRequireDefault(_ValidationTreeActions);

var _ValidationTree = __webpack_require__(1416);

var _ValidationTree2 = _interopRequireDefault(_ValidationTree);

var _treeItemPredicate = __webpack_require__(1421);

var _treeItemPredicate2 = _interopRequireDefault(_treeItemPredicate);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _or_validate2 = __webpack_require__(481);

var _or_validate3 = _interopRequireDefault(_or_validate2);

var _utils = __webpack_require__(175);

var _EntityProxy = __webpack_require__(31);

var _superRecords = __webpack_require__(63);

var _SuperRecordStore = __webpack_require__(36);

var _SuperRecordStore2 = _interopRequireDefault(_SuperRecordStore);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _stereotypes = __webpack_require__(126);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _NavigatorStore = __webpack_require__(33);

var _NavigatorStore2 = _interopRequireDefault(_NavigatorStore);

var _ValidationExcludeStore = __webpack_require__(1422);

var _ValidationExcludeStore2 = _interopRequireDefault(_ValidationExcludeStore);

var _error = __webpack_require__(225);

var _error2 = _interopRequireDefault(_error);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

var _safeContextDispatch = __webpack_require__(251);

var _safeContextDispatch2 = _interopRequireDefault(_safeContextDispatch);

var _NavigationActions = __webpack_require__(80);

var _NavigationActions2 = _interopRequireDefault(_NavigationActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// impure!
var updateContainment = function updateContainment(me, kid) {
    if (!me._contains_blocking) {
        me._contains_blocking = kid._is_blocking || kid._contains_blocking;
    }
    if (!me._contains_illegal) {
        me._contains_illegal = kid._is_illegal || kid._contains_illegal;
    }
    if (!me._contains_warning) {
        me._contains_warning = kid._is_warning || kid._contains_warning;
    }
    if (!me._contains_ok) {
        me._contains_ok = kid._is_ok || kid._contains_ok;
    }
};

var buildExcludesFilter = exports.buildExcludesFilter = function buildExcludesFilter(implKey) {
    return function (it) {
        if (it.fieldKey == null || it.entityName == null) {
            return true;
        }
        return !_ValidationExcludeStore2.default.isIncluded(implKey, it.entityName, it.fieldKey);
    };
};

var metaSkeleton = function metaSkeleton(entityKey) {
    return {
        entityName: new _EntityName2.default(entityKey).bareEntityKey, // this is questionable at best...
        _is_blocking: false,
        _is_illegal: false,
        _is_warning: false,
        _is_ok: false,
        _contains_blocking: false,
        _contains_illegal: false,
        _contains_warning: false,
        _contains_ok: false
    };
};

var assembleItem = function assembleItem(meta, entityKey, recordId, cid, message, children, onNavToField) {
    return {
        meta: meta,
        data: {
            entityKey: entityKey,
            recordId: recordId,
            cid: cid,
            message: message,
            state: meta._is_blocking ? "blocking" : meta._is_illegal ? "illegal" : meta._is_warning ? "warning" : meta._is_ok ? "ok" : "unknown",
            nestedState: meta._contains_blocking ? "blocking" : meta._contains_illegal ? "illegal" : meta._contains_warning ? "warning" : meta._contains_ok ? "ok" : "unknown",
            children: children,
            fieldKey: meta.fieldKey,
            onNavToField: onNavToField
        }
    };
};

var buildFieldItem = function buildFieldItem(ep, fi, excludeFilter, checkboxFilter, onNavToField) {
    var entityKey = ep.entityKey;
    var value = ep.get(fi);
    var meta = metaSkeleton(entityKey);
    meta.fieldKey = fi.key;
    var state = excludeFilter(meta) ? (0, _or_validate3.default)(fi, value, ep) : (0, _or_validate2.buildState)(fi, _error2.default.OK.code);
    meta._is_blocking = (0, _utils.isBlocking)(state.code);
    meta._is_illegal = (0, _utils.isIllegal)(state.code);
    meta._is_warning = (0, _utils.isWarning)(state.code);
    meta._is_ok = (0, _utils.isOk)(state.code);
    updateContainment(meta, meta);
    var children = value != null && (0, _EntityProxy.isAbstractAssoc)(fi) && !(0, _EntityProxy.isInverseAssoc)(fi) ? (Array.isArray(value) ? value : [value]).map(function (c) {
        return buildRecordItem(c, excludeFilter, checkboxFilter, onNavToField);
    }).map(function (it) {
        // update containment (passthrough)
        updateContainment(meta, it.meta);
        return it;
    }).filter(function (it) {
        return checkboxFilter(it.meta);
    }).map(function (it) {
        return it.data;
    }) : undefined;
    return assembleItem(meta, entityKey, ep.id, fi.key, state.message, children, onNavToField);
};

var buildRecordItem = exports.buildRecordItem = function buildRecordItem(ep, excludeFilter, checkboxFilter, onNavToField) {
    var entityKey = ep.entityKey;
    var meta = metaSkeleton(entityKey);
    var children = _entityFieldMetaStore2.default.getAllInfos(entityKey, function (it) {
        var isNotMrP = !it.mrPointer;
        var isDqr = it.dqr;
        var isAbstractAssocOrDqr = isDqr || (0, _EntityProxy.isAbstractAssoc)(it);
        var isNotInverseAssocOrDqr = isDqr || !(0, _EntityProxy.isInverseAssoc)(it);
        return isNotMrP && isAbstractAssocOrDqr && isNotInverseAssocOrDqr;
    }).map(function (fi) {
        return buildFieldItem(ep, fi, excludeFilter, checkboxFilter, onNavToField);
    }).filter(function (it) {
        if (it.data.children && it.data.children.length) return true;
        return excludeFilter(it.meta);
    }).map(function (it) {
        // update containment (passthrough)
        updateContainment(meta, it.meta);
        return it;
    }).filter(function (it) {
        return checkboxFilter(it.meta);
    }).map(function (it) {
        return it.data;
    });
    meta._is_blocking = meta._contains_blocking;
    meta._is_illegal = meta._contains_illegal;
    meta._is_warning = meta._contains_warning;
    meta._is_ok = meta._contains_ok;
    return assembleItem(meta, entityKey, ep.id, ep.getKey(), ep.getLabel(), children, onNavToField);
};

var addMagicChildren = function addMagicChildren(item, ep, mcis, mrInfo, excludeFilter, checkboxFilter, onNavToField) {
    if (mcis.length > 0) {
        var meta = metaSkeleton(ep.entityKey);
        meta._is_ok = true;
        var coll = assembleItem(meta, ep.entityKey, ep.id, mrInfo.magicChildKey, _StereotypesStore2.default.getStereotypeByKey(mrInfo.magicChildKey).pluralName, mcis.map(function (it) {
            // update containment (passthrough)
            updateContainment(meta, it.meta);
            return it;
        }).filter(function (it) {
            return checkboxFilter(it.meta);
        }).map(function (it) {
            return it.data;
        }), onNavToField);
        updateContainment(item.meta, coll.meta);
        if (!item.data.children) {
            item.data.children = [];
        }
        item.data.children.push(coll.data);
    }
};

var buildRootItem = function buildRootItem(ep, excludeFilter, checkboxFilter, allLevels, ctx, onNavToField) {
    var mrInfo = _StereotypesStore2.default.getMagicRoot(ep.entityKey);
    if ((0, _stereotypes.isCreatableFrom)(mrInfo, ep.entityKey)) {
        // 1.  A magic root record is open for editing. In this case the root of the tree
        //     is the active record, with the magic edge represented in the tree as a
        //     stereotypical association field, including the magic children which are the
        //     same version as the root. The "All Levels" checkbox does nothing.
        // it's a magic root record
        var item = buildRecordItem(ep, excludeFilter, checkboxFilter, onNavToField);
        var versionPrefix = (0, _utils.getKeyPrefix)(ep.entityKey) + "/";
        var srLO = _SuperRecordStore2.default.getRecordLO(mrInfo.key, ep.id);
        if (srLO.hasValue()) {
            // if the superrecord isn't loaded yet, can't do the kids.
            var mcis = (0, _superRecords.getTopLevelRecords)(_TableStore2.default, srLO.getValueEnforcing()).filter(function (r) {
                return r.entityKey.indexOf(versionPrefix) === 0;
            }).map(function (r) {
                return buildRecordItem(r, excludeFilter, checkboxFilter, onNavToField);
            });
            addMagicChildren(item, ep, mcis, mrInfo, excludeFilter, checkboxFilter, onNavToField);
        }
        return item;
    } else if (allLevels) {
        // 1.  A non-magic root record is open for editing, w/ "All Levels" _checked_. In
        //     this case the root of the tree is the active record's top-level record's
        //     magic root record with the magic edge represented in the tree as a
        //     stereotypical association field, including only the top-level record
        //     described above (not any of it's peers at the version, implementation, or
        //     magic levels).
        // find ep's TLR
        var ppk = void 0;
        var ei = void 0;
        while (ppk = (ei = _entityMetaStore2.default.getInfo(ep.entityKey)).parentPointerKey) {
            ep = ep.get(ppk);
        }
        // build an item for that guy
        var _item = buildRecordItem(ep, excludeFilter, checkboxFilter, onNavToField);
        if (ei.magicRootPointerKey) {
            // flip the magic root over
            var mrep = ep.get(ei.magicRootPointerKey);
            var mri = buildRecordItem(mrep, excludeFilter, checkboxFilter, onNavToField);
            addMagicChildren(mri, mrep, [_item], mrInfo, excludeFilter, checkboxFilter, onNavToField);
            return mri;
        }
        return _item;
    } else {
        // 1.  A non-magic root record is open for editing, w/ "All Levels" _unchecked_.
        //     This is the simple case; the root of the tree is the active record.
        return buildRecordItem(ep, excludeFilter, checkboxFilter, onNavToField);
    }
};

var ValidationTreeContainer = function ValidationTreeContainer(props) {
    var fluxContext = props.fluxContext;

    var state = (0, _useFluxStore2.default)(function () {
        var filters = _ValidationTreeStore2.default.getFilters(fluxContext);
        var checkboxFilter = (0, _treeItemPredicate2.default)(filters);
        var recState = _NavigatorStore2.default.getRecordState(fluxContext);
        var item = null;
        if (recState != null) {
            var activeRecord = _TableStore2.default.getEntityProxy(recState.key, recState.id);
            var implKey = new _EntityName2.default(activeRecord.entityKey).implKey;
            item = buildRootItem(_TableStore2.default.getEntityProxy(activeRecord.entityKey, activeRecord.id), buildExcludesFilter(implKey), checkboxFilter, filters.all, fluxContext, function (entityKey, recordId, fieldKey) {
                var magic = _NavigatorStore2.default.getMagicState(fluxContext);

                var _rerouteFieldNav = (0, _superRecords.rerouteFieldNav)(magic, entityKey, recordId, fieldKey);

                var _rerouteFieldNav2 = _slicedToArray(_rerouteFieldNav, 3);

                entityKey = _rerouteFieldNav2[0];
                recordId = _rerouteFieldNav2[1];
                fieldKey = _rerouteFieldNav2[2];

                (0, _safeContextDispatch2.default)(fluxContext, {
                    type: _NavigationActions2.default.SELECT_RECORD,
                    entityKey: entityKey,
                    recordId: recordId,
                    fieldKey: fieldKey
                });
            });
        }

        return {
            filters: filters,
            toggleFilter: function toggleFilter(filter) {
                _Dispatcher2.default.contextDispatch(fluxContext, {
                    type: _ValidationTreeActions2.default.TOGGLE_FILTER,
                    filter: filter
                });
            },
            // the real ones
            item: item && checkboxFilter(item.meta) ? item.data : null,
            ctx: fluxContext + ":validation"
        };
    }, [_ValidationTreeStore2.default, _TableStore2.default, _SuperRecordStore2.default, _NavigatorStore2.default, _ValidationExcludeStore2.default], [fluxContext]);
    return _react2.default.createElement(_ValidationTree2.default, state);
};

ValidationTreeContainer.propTypes = {
    fluxContext: _propTypes2.default.string.isRequired
};

exports.default = ValidationTreeContainer;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ValidationTreeActions = {
    TOGGLE_FILTER: "validation-tree/toggle-filter"
};

exports.default = ValidationTreeActions;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var TreeItemTypes = {
    COLLAPSE_ALL: "TREE_ITEM_COLLAPSE_ALL",
    EXPAND_ALL: "TREE_ITEM_EXPAND_ALL",
    COLLAPSE_OR_EXPAND: "TREE_ITEM_COLLAPSE_OR_EXPAND"
};

exports.default = TreeItemTypes;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.makeTreeItem = makeTreeItem;

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function makeTreeItem(WrappedComponent) {
    var TreeItem = function (_React$Component) {
        _inherits(TreeItem, _React$Component);

        function TreeItem() {
            var _ref;

            _classCallCheck(this, TreeItem);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            var _this = _possibleConstructorReturn(this, (_ref = TreeItem.__proto__ || Object.getPrototypeOf(TreeItem)).call.apply(_ref, [this].concat(args)));

            _this.toggleControl = _this.toggleControl.bind(_this);
            return _this;
        }

        _createClass(TreeItem, [{
            key: "toggleControl",
            value: function toggleControl(e) {
                var _props = this.props,
                    nodeKey = _props.nodeKey,
                    onChildCollapseOrExpand = _props.onChildCollapseOrExpand;


                onChildCollapseOrExpand(nodeKey);
                this.toggleCollapse(e);
            }
        }, {
            key: "toggleCollapse",
            value: function toggleCollapse(e) {
                if (e) {
                    e.preventDefault();
                }
            }
        }, {
            key: "render",
            value: function render() {
                var _props2 = this.props,
                    _props2$nodeKey = _props2.nodeKey,
                    nodeKey = _props2$nodeKey === undefined ? "" : _props2$nodeKey,
                    item = _props2.item,
                    isKeyExpanded = _props2.isKeyExpanded,
                    onChildCollapseOrExpand = _props2.onChildCollapseOrExpand,
                    _props2$expanded = _props2.expanded,
                    expanded = _props2$expanded === undefined ? true : _props2$expanded,
                    filter = _props2.filter;
                var children = item.children,
                    _item$depth = item.depth,
                    depth = _item$depth === undefined ? 0 : _item$depth,
                    type = item.type;


                var hasChildren = children && children.length > 0;
                var items = void 0;
                if (hasChildren && expanded) {
                    items = (typeof filter === "function" ? children.filter(filter) : children).map(function (m) {
                        var newItem = _extends({}, m, {
                            depth: depth != null ? depth + 1 : undefined,
                            children: m.children,
                            parentType: type
                        });

                        // todo: `cid` is bad here. and it's not cid anyway?
                        var childKey = nodeKey.length === 0 ? m.cid : m.cid + "." + nodeKey;
                        return React.createElement(
                            "li",
                            { key: childKey },
                            React.createElement(TreeItem, {
                                nodeKey: childKey,
                                isKeyExpanded: isKeyExpanded,
                                onChildCollapseOrExpand: onChildCollapseOrExpand,
                                expanded: !isKeyExpanded || isKeyExpanded(childKey),
                                item: newItem,
                                filter: filter
                            })
                        );
                    });
                }

                return React.createElement(
                    "ul",
                    null,
                    React.createElement(WrappedComponent, _extends({}, this.props, this.state, {
                        expanded: expanded,
                        toggleControl: this.toggleControl
                    })),
                    items
                );
            }
        }]);

        return TreeItem;
    }(React.Component);

    TreeItem.propTypes = {
        nodeKey: _propTypes2.default.string,
        isKeyExpanded: _propTypes2.default.func,
        onChildCollapseOrExpand: _propTypes2.default.func,
        expanded: _propTypes2.default.bool,
        item: _propTypes2.default.shape({
            children: _propTypes2.default.array,
            depth: _propTypes2.default.number,
            type: _propTypes2.default.string
            // and whatever else the actual itemRenderer needs
        }).isRequired,
        filter: _propTypes2.default.func
    };

    return TreeItem;
}

/***/ }),
/* 623 */,
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ContextedReduceStore2 = __webpack_require__(30);

var _ContextedReduceStore3 = _interopRequireDefault(_ContextedReduceStore2);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _AbstractionAiActions = __webpack_require__(321);

var _AbstractionAiActions2 = _interopRequireDefault(_AbstractionAiActions);

var _dotPropImmutable = __webpack_require__(40);

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _SuperRecordStore = __webpack_require__(36);

var _SuperRecordStore2 = _interopRequireDefault(_SuperRecordStore);

var _NavigatorStore = __webpack_require__(33);

var _NavigatorStore2 = _interopRequireDefault(_NavigatorStore);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _DataManager = __webpack_require__(43);

var _DataManager2 = _interopRequireDefault(_DataManager);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

var _hydration = __webpack_require__(304);

var _ActiveFormStore = __webpack_require__(112);

var _ActiveFormActions = __webpack_require__(111);

var _ActiveFormActions2 = _interopRequireDefault(_ActiveFormActions);

var _RecordActions = __webpack_require__(60);

var _RecordActions2 = _interopRequireDefault(_RecordActions);

var _TableStore3 = __webpack_require__(10);

var _TableStore4 = _interopRequireDefault(_TableStore3);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _AbstractionAIService = __webpack_require__(1431);

var _AbstractionAIService2 = _interopRequireDefault(_AbstractionAIService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var keyPath = function keyPath(entityKey, fieldKey) {
    if (typeof entityKey !== "string") {
        // assume it's an action
        var a = entityKey;
        entityKey = a.entityKey || a.recordKey;
        fieldKey = a.fieldKey;
    }
    return entityKey + "." + fieldKey;
};

var getRecordAiSuggestFieldKeys = function getRecordAiSuggestFieldKeys(recordsPath) {
    var fields = [];
    _entityMetaStore2.default.getAllInfos(function (it) {
        return (it.keys || []).filter(function (key) {
            return key.name === "ai-suggestion";
        }).length && // only ai-suggestKeys
        recordsPath.filter(function (r) {
            return it.key === r.key;
        }).length;
    } // only currently open records path
    ).forEach(function (it) {
        (it.keys || []).filter(function (key) {
            return key.name === "ai-suggestion";
        }).forEach(function (field) {
            field.fieldKeys.forEach(function (fk) {
                fields.push({
                    key: it.key,
                    type: it.type,
                    fieldName: fk,
                    fieldAlias: field.fieldAliases[fk]
                });
            });
        });
    });
    return fields;
};

var checkIfAcceptedSuggestion = function checkIfAcceptedSuggestion(state, action) {
    //  if field has suggestion
    //  see if set value matches any ai-suggestions
    //  value must first be converted to its label
    //  log accept
    var entityKey = action.entityKey || action.recordKey;
    var fieldKey = action.fieldKey;
    var lo = state[keyPath(entityKey, fieldKey)];
    if (lo && lo.hasValue() && lo.getRequiredValue()) {
        var data = lo.getRequiredValue();
        if (
        // do we have all the suggestion info we need?
        data.status === "SUCCESS" && data.suggestion && data.suggestion.fieldSuggestion && data.suggestion.fieldSuggestion.length) {
            var fieldSuggestionId = data.suggestion.fieldSuggestionId;
            var suggestions = ((data.suggestion || {}).fieldSuggestion || []).map(function (it) {
                return it.toString().toLowerCase();
            } // make all answers lowercase
            );
            var label = action.label || action.value;
            var acceptIndices = [];
            if (label !== null) {
                if (Array.isArray(label)) {
                    // multi valued
                    label.forEach(function (it) {
                        var index = suggestions.indexOf(it.toString().toLowerCase()); // make all labels lowercase
                        if (index !== -1) {
                            acceptIndices.push(index);
                        }
                    });
                } else {
                    var index = suggestions.indexOf(label.toString().toLowerCase()); // make all labels lowercase
                    if (index !== -1) {
                        acceptIndices.push(index);
                    }
                }
                if (acceptIndices.length) {
                    // user selected ai-suggest recommendation(s)
                    _AbstractionAIService2.default.sendAccept(fieldSuggestionId, acceptIndices);
                }
            }
        }
    }
};

var getAiSuggestKeyInfo = function getAiSuggestKeyInfo(fluxContext) {
    //  field keys `ai-suggestion` and their values.
    // `ai-suggestion` keys found in EntityMetaStore
    // create a payload shaped like this: [{"value":"mylastname", field:"lastName"},...]
    // EntityMetaStore contains all metadata impls not just the ones
    // associated with the currently open record. We need to only find the values of the currently open
    // record(s) this means we need to know the current open record and its parent(s) as show in the
    // selected navigator columns.
    var selectedRecords = _NavigatorStore2.default.getRecordPath(fluxContext);
    var hasRequiredValues = true;
    var keyComponents = [];
    var payload = getRecordAiSuggestFieldKeys(selectedRecords).map(function (it) {
        var key = it.key;
        var fieldName = it.fieldName;
        var activeRecord = selectedRecords.find(function (r) {
            return r.key === key;
        });
        var id = null;
        var value = null;
        if (activeRecord) {
            id = activeRecord.id;
            var ep = _TableStore2.default.getEntityProxy(key, id);
            var fieldType = ep.getAttributeType(fieldName);
            value = ep.get(fieldName); // hydrated value
            if (value != null) {
                switch (fieldType) {
                    case "DATETIME":
                        value = value.format("YYYY-MM-DD HH:mm");
                        break;
                    case "TIME":
                        value = value.format("HH:mm");
                        break;
                    case "DATE":
                        //case "TZTIMESTAMP": not sure what TZTIMESTAMP is?
                        // server needs string version of date "YYYY-MM-DD"
                        // convert moment to that format.
                        value = value.format("YYYY-MM-DD");
                        break;
                    default:
                        value = (0, _hydration.dehydrateField)(value, fieldType); // dehydrated value
                    // do nothing
                }
            }
        }

        var _key$split = key.split("/"),
            _key$split2 = _slicedToArray(_key$split, 3),
            implementation = _key$split2[0],
            version = _key$split2[1],
            entityName = _key$split2[2];

        if (!value) {
            hasRequiredValues = false;
            keyComponents.push({
                implementation: implementation,
                version: version,
                entityName: entityName,
                id: id,
                fieldName: fieldName
            });
        }
        // return payload item shape
        return {
            value: value,
            fieldName: it.fieldAlias != null ? it.fieldAlias : fieldName
        };
    }).filter(function (it) {
        return it !== null;
    });
    return {
        keyComponents: keyComponents,
        hasRequiredValues: hasRequiredValues,
        payload: payload
    };
};

var AbstractionAiStore = function (_ContextedReduceStore) {
    _inherits(AbstractionAiStore, _ContextedReduceStore);

    function AbstractionAiStore() {
        _classCallCheck(this, AbstractionAiStore);

        return _possibleConstructorReturn(this, (AbstractionAiStore.__proto__ || Object.getPrototypeOf(AbstractionAiStore)).call(this, _Dispatcher2.default));
    }

    _createClass(AbstractionAiStore, [{
        key: "getInitialContext",
        value: function getInitialContext() {
            return {
                feedback: {}
            };
        }

        /* 
            AI Suggest Store - Reducer 
            This is where events and data flow are handled.
            TODO: hook up to the new ai suggest service API here.
        */

    }, {
        key: "reduceContext",
        value: function reduceContext(state, action, fluxContext) {
            switch (action.type) {
                case _ActiveFormActions2.default.FOCUS_ELEMENT:
                case _RecordActions2.default.SET_FIELD:
                    this.__dispatcher.waitFor([_userStore2.default.getDispatchToken(), _TableStore4.default.getDispatchToken(), _entityMetaStore2.default.getDispatchToken(), _NavigatorStore2.default.getDispatchToken(), _SuperRecordStore2.default.getDispatchToken()]);
                    try {
                        // Check if user/org has AI suggestion permission before making any requests
                        // This prevents unnecessary API calls for orgs without the feature enabled
                        if (!this.hasAISuggestionPermission(fluxContext)) {
                            return state;
                        }

                        // Check if entity has ai-suggestion key before making any requests
                        // This prevents unnecessary API calls for entities which do not have an ai-suggestion key defined
                        if (!this.hasAISuggestionKey(action.entityKey)) {
                            return _dotPropImmutable2.default.set(state, [keyPath(action)], _LoadObject2.default.withValue({
                                // fake api response for ENTITY_NOT_SUPPORTED
                                status: "ENTITY_NOT_SUPPORTED",
                                suggestion: { answerLabels: [] },
                                keyComponents: []
                            }));
                        }

                        // none of this functionality is critical to the applications functionality and can be ignored if
                        // any of it fails for some reason.
                        if (action.type === _RecordActions2.default.SET_FIELD) {
                            checkIfAcceptedSuggestion(state, action);
                        }

                        var _getAiSuggestKeyInfo = getAiSuggestKeyInfo(fluxContext),
                            keyComponents = _getAiSuggestKeyInfo.keyComponents,
                            hasRequiredValues = _getAiSuggestKeyInfo.hasRequiredValues,
                            payload = _getAiSuggestKeyInfo.payload;

                        if (!hasRequiredValues || payload.length < 1) {
                            // cant make the request yet because required values are not met
                            return _dotPropImmutable2.default.set(state, [keyPath(action)], _LoadObject2.default.withValue({
                                // fake api response for INCOMPLETE_SUGGEST_KEY
                                status: "INCOMPLETE_SUGGEST_KEY",
                                suggestion: { answerLabels: [] },
                                keyComponents: keyComponents
                            }));
                        }
                        // we have everything we need to make the full ai-suggest request :)
                        return _dotPropImmutable2.default.set(state, [keyPath(action)], _LoadObject2.default.empty().loading(_DataManager2.default.loadAbstractionAiApi(_userStore2.default.getActiveOrgKey(), action.entityKey || action.recordKey, action.fieldKey, payload)));
                    } catch (error) {
                        // allow the app to continue to function. but log the error to the console.
                        console.warn("A problem occured while processing the AbstractionAiStore.", error);
                        return state;
                    }
                case _AbstractionAiActions2.default.FEEDBACK:
                    // log the feedback
                    _AbstractionAIService2.default.sendFeedback(action.evidenceId, action.feedback);
                    return _extends({}, state, {
                        feedback: _extends({}, state.feedback || {}, _defineProperty({}, action.evidenceId, action.feedback))
                    });
                default:
                    return state;
            }
        }
    }, {
        key: "reduceEachContext",
        value: function reduceEachContext(state, action, fluxContext) {
            switch (action.type) {
                case _AbstractionAiActions2.default.LOADED:
                    if (!_dotPropImmutable2.default.get(state, [keyPath(action)])) {
                        return state;
                    }
                    var data = action.data;
                    if (data.answer && data.answer.suggestion.fieldSuggestionId) {
                        // log an impression
                        _AbstractionAIService2.default.sendImpression(this.hasAISuggestionPermission(fluxContext), data.answer.suggestion.fieldSuggestionId);
                    }
                    return _dotPropImmutable2.default.set(state, [keyPath(action)], function (lo) {
                        return lo.receiveValue(data);
                    });
                case _AbstractionAiActions2.default.LOAD_ERROR:
                    if (!_dotPropImmutable2.default.get(state, [keyPath(action)])) {
                        return state;
                    }
                    return _dotPropImmutable2.default.set(state, [keyPath(action)], function (lo) {
                        return lo.receiveError(action.error);
                    });
                default:
                    return state;
            }
        }
    }, {
        key: "hasAISuggestionPermission",
        value: function hasAISuggestionPermission(fluxContext) {
            var activeRecord = _NavigatorStore2.default.getRecordState(fluxContext);
            if (!activeRecord) {
                return false;
            }
            var implKey = activeRecord && activeRecord.key ? new _EntityName2.default(activeRecord.key).implKey : false;
            if (!implKey) {
                return false;
            }
            return _userStore2.default.canAISuggestion(implKey);
        }

        /* 
            AI Suggest Store - Required Fields 
            This is just an example that there are required fields before suggestions can be looked up for the current registry.
            These required fields are described in metadata search for '<Key name="ai-suggestion">' in xml files to see how it is used.
        */

    }, {
        key: "hasAISuggestionKeys",
        value: function hasAISuggestionKeys(fluxContext) {
            var activeRecord = _NavigatorStore2.default.getRecordState(fluxContext);
            if (!activeRecord) {
                return false;
            }
            // check if open record has any ai-suggest keys
            return getRecordAiSuggestFieldKeys([activeRecord]).length > 0;
        }
    }, {
        key: "hasAISuggestionKey",
        value: function hasAISuggestionKey(entityKey) {
            return (_entityMetaStore2.default.getInfo(entityKey).keys || []).filter(function (key) {
                return key.name === "ai-suggestion";
            }).length > 0;
        }
    }, {
        key: "canAISuggestion",
        value: function canAISuggestion(fluxContext, entityKey) {
            return this.hasAISuggestionKeys(fluxContext) && this.hasAISuggestionPermission(fluxContext);
        }
    }, {
        key: "getAbstractionAiSuggest",
        value: function getAbstractionAiSuggest(ctx, entityKey, fieldKey) {
            return this.getAbstractionAiSuggestLO(entityKey, fieldKey).getRequiredValue();
        }
    }, {
        key: "getAbstractionAiSuggestLO",
        value: function getAbstractionAiSuggestLO(ctx, entityKey, fieldKey) {
            (0, _invariant2.default)(entityKey && fieldKey && fieldKey !== _ActiveFormStore.FIRST_FIELD, "C'mon, field '" + entityKey + "." + fieldKey + "'? Really?");
            return this.getState(ctx)[keyPath(entityKey, fieldKey)] || null;
        }
    }, {
        key: "getFeedback",
        value: function getFeedback(ctx, evidenceId) {
            return this.getState(ctx).feedback[evidenceId];
        }
    }]);

    return AbstractionAiStore;
}(_ContextedReduceStore3.default);

exports.default = new AbstractionAiStore();

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lockStore = __webpack_require__(144);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LockMessage(_ref) {
    var _ref$label = _ref.label,
        label = _ref$label === undefined ? "this record" : _ref$label,
        lock = _ref.lock;

    if (lock && lock.violated && !lock.dismissed) {
        return _react2.default.createElement(
            "div",
            {
                className: "alert alert-info pesslock-status pesslock-warning"
            },
            _react2.default.createElement("i", { className: "glyphicon glyphicon-exclamation-sign" }),
            " ",
            lock.violators.join(", "),
            " ",
            "also ",
            lock.violators.length === 1 ? "has" : "have",
            " ",
            label,
            " open."
        );
    }
    return null;
}

LockMessage.propTypes = {
    lock: _propTypes2.default.shape(_lockStore.lockShape),
    label: _propTypes2.default.element
};

exports.default = LockMessage;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.navShape = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _NavigatorStore = __webpack_require__(33);

var _NavigatorStore2 = _interopRequireDefault(_NavigatorStore);

var _SuperRecordStore = __webpack_require__(36);

var _SuperRecordStore2 = _interopRequireDefault(_SuperRecordStore);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _superRecords = __webpack_require__(63);

var _records = __webpack_require__(113);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

var _RecordActions = __webpack_require__(60);

var _RecordActions2 = _interopRequireDefault(_RecordActions);

var _NavigationActions = __webpack_require__(80);

var _NavigationActions2 = _interopRequireDefault(_NavigationActions);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HiddenFieldStore = __webpack_require__(306);

var _HiddenFieldStore2 = _interopRequireDefault(_HiddenFieldStore);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildNavContainer = function buildNavContainer(Nav) {
    var propsFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (raw, contained) {
        return contained;
    };
    return function (props) {
        // eslint-disable-next-line react/prop-types
        var ctx = props.fluxContext;

        var state = (0, _useFluxStore2.default)(function () {
            var navState = _NavigatorStore2.default.getState(ctx);
            var magicState = navState.magic;
            if (magicState == null) return { gonk: true };
            var isSuperRecord = !_EntityName2.default.is(magicState.key);
            var srLO = void 0;
            if (isSuperRecord) {
                srLO = _SuperRecordStore2.default.getRecordLO(magicState.key, magicState.id);
                if (!srLO.hasValue()) return { gonk: true };
            }
            return propsFilter(props, {
                gonk: false,
                isSuperRecord: isSuperRecord,
                tree: isSuperRecord ? (0, _superRecords.superNavTree)(_TableStore2.default, srLO.getRequiredValue(), navState, magicState.key, magicState.id, ctx) : (0, _records.navTree)(_TableStore2.default, navState, magicState.key, magicState.id),
                onAddMagicChild: function onAddMagicChild(recordKey, recordId, entityKey) {
                    return _Dispatcher2.default.contextDispatch(ctx, {
                        type: _SuperRecordActions2.default.NEW_MAGIC_CHILD,
                        recordKey: recordKey,
                        recordId: recordId,
                        entityKey: entityKey,
                        newId: _ClientId2.default.next(),
                        navigate: true
                    });
                },
                onAddChild: function onAddChild(recordKey, recordId, fieldKey, entityKey) {
                    return _Dispatcher2.default.contextDispatch(ctx, {
                        type: _RecordActions2.default.NEW_CHILD,
                        recordKey: recordKey,
                        recordId: recordId,
                        fieldKey: fieldKey,
                        entityKey: entityKey,
                        newId: _ClientId2.default.next(),
                        navigate: true
                    });
                },
                onDeleteMagicChild: function onDeleteMagicChild(recordKey, recordId) {
                    return _Dispatcher2.default.contextDispatch(ctx, {
                        type: _RecordActions2.default.DELETE_RECORD,
                        recordKey: recordKey,
                        recordId: recordId
                    });
                },
                onDeleteChild: function onDeleteChild(recordKey, recordId, fieldKey, childKey, childId) {
                    return _Dispatcher2.default.contextDispatch(ctx, {
                        type: _RecordActions2.default.DELETE_CHILD,
                        recordKey: recordKey,
                        recordId: recordId,
                        fieldKey: fieldKey,
                        childKey: childKey,
                        childId: childId
                    });
                },
                onSelectRecord: function onSelectRecord(entityKey, recordId) {
                    return _Dispatcher2.default.contextDispatch(ctx, {
                        type: _NavigationActions2.default.SELECT_RECORD,
                        entityKey: entityKey,
                        recordId: recordId
                    });
                },
                onSelectImpl: function onSelectImpl(implementationKey) {
                    return _Dispatcher2.default.contextDispatch(ctx, {
                        type: _NavigationActions2.default.SELECT_IMPLEMENTATION,
                        implementationKey: implementationKey
                    });
                },
                onSelectAllImpls: function onSelectAllImpls() {
                    return _Dispatcher2.default.contextDispatch(ctx, {
                        type: _NavigationActions2.default.SELECT_ALL_IMPLEMENTATIONS
                    });
                },
                onExpansionChange: function onExpansionChange(implementationKey) {
                    return _Dispatcher2.default.contextDispatch(ctx, {
                        type: _NavigationActions2.default.TOGGLE_IMPLEMENTATION,
                        implementationKey: implementationKey
                    });
                }
            });
        }, [_NavigatorStore2.default, _SuperRecordStore2.default, _TableStore2.default, _HiddenFieldStore2.default], [ctx]);
        return state.gonk ? null : _react2.default.createElement(Nav, _extends({}, props, state));
    };
};

var navShape = exports.navShape = {
    isSuperRecord: _propTypes2.default.bool.isRequired,
    tree: _propTypes2.default.shape({
        name: _propTypes2.default.string.isRequired,
        projections: _propTypes2.default.array.isRequired
        // various other recursive things....
    }).isRequired,
    onAddMagicChild: _propTypes2.default.func.isRequired,
    onAddChild: _propTypes2.default.func.isRequired,
    onDeleteMagicChild: _propTypes2.default.func.isRequired,
    onDeleteChild: _propTypes2.default.func.isRequired,
    onSelectRecord: _propTypes2.default.func.isRequired,
    onSelectImpl: _propTypes2.default.func.isRequired,
    onSelectAllImpls: _propTypes2.default.func.isRequired,
    onExpansionChange: _propTypes2.default.func.isRequired
};

exports.default = buildNavContainer;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var HexActions = {
    RERUN_EXPORT: "hex/rerun-export"
};

exports.default = HexActions;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useAllMembers = useAllMembers;
exports.useMembersForExporter = useMembersForExporter;
exports.useMembersForStereotype = useMembersForStereotype;

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _organizationsStore = __webpack_require__(357);

var _organizationsStore2 = _interopRequireDefault(_organizationsStore);

var _propertyComparatorBuilder = __webpack_require__(629);

var _propertyComparatorBuilder2 = _interopRequireDefault(_propertyComparatorBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var orgComparator = (0, _propertyComparatorBuilder2.default)("name", "key");

function buildMembers(orgKeyProvider) {
    if (!_userStore2.default.isAggregate()) return null;
    var keys = orgKeyProvider();
    if (keys.length === 0) return null;
    var byKey = _organizationsStore2.default.getKeyLookup();
    return keys.map(function (k) {
        return byKey[k];
    }).sort(orgComparator);
}

function useAllMembers() {
    return (0, _useFluxStore2.default)(function () {
        return buildMembers(function () {
            return _userStore2.default.getDescendantOrgKeys();
        });
    }, [_userStore2.default, _organizationsStore2.default]);
}

function useMembersForExporter(key) {
    return (0, _useFluxStore2.default)(function () {
        if (!key) return [null, false];
        var members = buildMembers(function () {
            return _userStore2.default.getExporterFilterOrgKeys(key);
        });
        return [members || buildMembers(function () {
            return _userStore2.default.getDescendantOrgKeys();
        }), !!members];
    }, [_userStore2.default, _organizationsStore2.default], [key]);
}

function useMembersForStereotype(stereoKey) {
    return (0, _useFluxStore2.default)(function () {
        return buildMembers(function () {
            if (!stereoKey) return null;
            var iKeys = new Set(_StereotypesStore2.default.getImplementations(stereoKey).map(function (it) {
                return it.implementationKey;
            }));
            return _userStore2.default.getImplementationDescendantOrgKeys.apply(_userStore2.default, _toConsumableArray(iKeys));
        });
    }, [_StereotypesStore2.default, _userStore2.default, _organizationsStore2.default], [stereoKey]);
}

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function val(obj, key) {
    var val = obj[key];
    return typeof val === "string" ? val.toLowerCase() : val;
}

var propertyComparatorBuilder = function propertyComparatorBuilder() {
    for (var _len = arguments.length, keys = Array(_len), _key = 0; _key < _len; _key++) {
        keys[_key] = arguments[_key];
    }

    return function (a, b) {
        if (a === b) return 0;
        if (a == null) return b == null ? 0 : -1;
        if (b == null) return 1;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var k = _step.value;

                var x = val(a, k);
                var y = val(b, k);
                if (x == null && y != null) return -1;
                if (x != null && y == null) return 1;
                if (x < y) return -1;
                if (x > y) return 1;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return 0;
    };
};

exports.default = propertyComparatorBuilder;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BackboneResultsView = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.useOrgLookup = useOrgLookup;
exports.ResultsView = ResultsView;

var _FileTemplate = __webpack_require__(500);

var _FileTemplate2 = _interopRequireDefault(_FileTemplate);

var _GeneratedTemplate = __webpack_require__(1450);

var _GeneratedTemplate2 = _interopRequireDefault(_GeneratedTemplate);

var _ParametersTemplate = __webpack_require__(1451);

var _ParametersTemplate2 = _interopRequireDefault(_ParametersTemplate);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _SelectionTable = __webpack_require__(234);

var _backboneConnect = __webpack_require__(127);

var _withOver = __webpack_require__(58);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

var _organizationsStore = __webpack_require__(357);

var _organizationsStore2 = _interopRequireDefault(_organizationsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrgLookupContext = _react2.default.createContext({});

function useOrgLookup() {
    return _react2.default.useContext(OrgLookupContext);
}

function ResultsView(props) {
    var orgLookup = (0, _useFluxStore2.default)(function () {
        return _organizationsStore2.default.getKeyLookup();
    }, [_organizationsStore2.default]);
    var fields = new Backbone.Collection([{
        name: "Generated",
        key: "Generated",
        type: "template",
        itemTemplate: _GeneratedTemplate2.default
    }, {
        name: "File Type",
        key: "typeName",
        type: "string"
    }, {
        name: "Username",
        key: "username",
        type: "string"
    }, {
        name: "Parameters",
        key: "parameters",
        type: "template",
        itemTemplate: _ParametersTemplate2.default
    }, {
        name: "Number of Records",
        key: "recordCount",
        type: "string"
    }, {
        name: "File",
        key: "file",
        type: "template",
        itemTemplate: _FileTemplate2.default
    }, {
        name: "Status",
        key: "status",
        type: "string"
    }]);

    return _react2.default.createElement(
        OrgLookupContext.Provider,
        { value: orgLookup },
        _react2.default.createElement(_SelectionTable.BackboneSelectionTable, _extends({}, props, {
            sorts: new Backbone.Model({}),
            sortable: false,
            fields: fields }))
    );
}

ResultsView.propTypes = {
    model: _propTypes2.default.instanceOf(Backbone.Model).isRequired,
    collection: _propTypes2.default.instanceOf(Backbone.Collection).isRequired,
    hasHover: _propTypes2.default.bool.isRequired
};

var noop = function noop() {/* noop */};

var config = function config(props) {
    return {
        collection: {
            listenOn: "collection",
            event: "all",
            get: function get() {
                return props.collection;
            }
        },
        onSort: noop,
        onRecordSelection: noop,
        onDownloadClick: function onDownloadClick(data, event) {
            event.preventDefault();

            var view = props.view,
                recordCount = data.recordCount,
                id = data.id,
                filename = data.filename;


            if (recordCount > 499) {
                (0, _withOver.appAlert)({
                    message: "This file contains more than 499 records. Please be aware that if you lose this file, you are required to report the loss of PHI in compliance with your organization's HIPAA policies and procedures.",
                    spinner: false,
                    actions: [{
                        label: "Cancel",
                        callback: noop
                    }, {
                        label: "Ok",
                        callback: function callback() {
                            view.dispatch("get:hex_file_download", id, filename);
                        }
                    }]
                });
            } else {
                view.dispatch("get:hex_file_download", id, filename);
            }
        }

    };
};

var BackboneResultsView = exports.BackboneResultsView = (0, _backboneConnect.backboneConnect)(config)(ResultsView);

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BackboneDataQualityResultsLayout = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.DataQualityResultsLayout = DataQualityResultsLayout;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DataQualityResults = __webpack_require__(1461);

var _DataQualityResults2 = _interopRequireDefault(_DataQualityResults);

var _Paginator = __webpack_require__(1462);

var _backboneConnect = __webpack_require__(127);

var _useFluxStore3 = __webpack_require__(9);

var _useFluxStore4 = _interopRequireDefault(_useFluxStore3);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DataQualityResultsLayout(_ref) {
    var stereotype = _ref.stereotype,
        searchResults = _ref.searchResults,
        page = _ref.page,
        pageSize = _ref.pageSize,
        sorts = _ref.sorts,
        getReportTypeKey = _ref.getReportTypeKey,
        onRecordSelection = _ref.onRecordSelection,
        onSort = _ref.onSort,
        paginatorSearch = _ref.paginatorSearch;

    var _useFluxStore = (0, _useFluxStore4.default)(function () {
        return [_userStore2.default.isAggregate(), _userStore2.default.canUseDE()];
    }, [_userStore2.default]),
        _useFluxStore2 = _slicedToArray(_useFluxStore, 2),
        isAggregate = _useFluxStore2[0],
        canUseDE = _useFluxStore2[1];

    var collection = searchResults.get("results");
    var fields = stereotype.get("fields");
    if (isAggregate) {
        fields = new Backbone.Collection(fields.models);
        fields.add({
            key: "ao_owner_name",
            name: "Data Owner",
            type: "string"
        }, { at: 0 });
    }

    var pageCount = searchResults.get("pageCount");
    var results = searchResults.get("results");

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            "div",
            { className: "header" },
            _react2.default.createElement(
                "div",
                { className: "title" },
                _react2.default.createElement(
                    "h1",
                    null,
                    "Report Results"
                )
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "results" },
            _react2.default.createElement(_DataQualityResults2.default, { fields: fields,
                collection: collection || new Backbone.Collection(),
                hasStereotype: true,
                reportTypeKey: getReportTypeKey(),
                onRecordSelection: canUseDE ? onRecordSelection : null,
                onSort: onSort,
                sorts: sorts
            })
        ),
        _react2.default.createElement(
            "div",
            { className: "footer" },
            _react2.default.createElement(_Paginator.Paginator, { search: paginatorSearch,
                page: page,
                results: results,
                pageSize: pageSize,
                pageCount: pageCount })
        )
    );
}

DataQualityResultsLayout.propTypes = {
    stereotype: _propTypes2.default.object.isRequired,
    searchResults: _propTypes2.default.object.isRequired,
    page: _propTypes2.default.number.isRequired,
    pageSize: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    pageCount: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    results: _propTypes2.default.object,
    getReportTypeKey: _propTypes2.default.func.isRequired,
    onRecordSelection: _propTypes2.default.func,
    onSort: _propTypes2.default.func.isRequired,
    sorts: _propTypes2.default.instanceOf(Backbone.Model),
    paginatorSearch: _propTypes2.default.func.isRequired
};

var config = function config(props) {
    return {
        stereotype: {
            listenOn: "model"
        },
        searchResults: {
            listenOn: "model"
        },
        page: {
            listenOn: "model"
        },
        pageSize: {
            listenOn: "model"
        },
        sorts: {
            listenOn: "model"
        },
        getReportTypeKey: function getReportTypeKey() {
            return props.model.getReportTypeKey();
        },
        onRecordSelection: function onRecordSelection(record) {
            return props.view.dispatch("load:dataQualityDetails", record);
        },
        onSort: function onSort() {
            props.model.resetPagination();
            props.view.dispatch("search:dataQualityReport", props.model);
        },
        paginatorSearch: function paginatorSearch(page, pageSize) {
            var model = props.model;
            if (parseInt(pageSize)) {
                model.set("pageSize", pageSize);
            }
            if (model.hasChanged("pageSize")) {
                model.resetPagination();
            } else {
                if (parseInt(page)) {
                    model.set("page", page);
                }
            }
            props.view.dispatch("search:dataQualityReport", model);
        }
    };
};

var BackboneDataQualityResultsLayout = exports.BackboneDataQualityResultsLayout = (0, _backboneConnect.backboneConnect)(config)(DataQualityResultsLayout);

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _RecordSourceTreeItem = __webpack_require__(1479);

var _RecordSourceTreeItem2 = _interopRequireDefault(_RecordSourceTreeItem);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RootTreeLayout = function RootTreeLayout(props) {
    var targetRecordType = props.targetRecordType,
        rootItem = props.rootItem,
        isMagicRoot = props.isMagicRoot,
        onIncludeMagicRootFields = props.onIncludeMagicRootFields,
        onExcludeMagicRootFields = props.onExcludeMagicRootFields,
        onExpandAll = props.onExpandAll,
        onCollapseAll = props.onCollapseAll,
        isKeyExpanded = props.isKeyExpanded,
        onChildCollapseOrExpand = props.onChildCollapseOrExpand;

    var gridRef = _react2.default.useRef();

    var _React$useState = _react2.default.useState(110),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        gridOffset = _React$useState2[0],
        setGridOffset = _React$useState2[1];

    _react2.default.useEffect(function () {
        // calculate the table offset
        setGridOffset(gridRef.current.offsetTop);
    });

    var _React$useState3 = _react2.default.useState(false),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        showNullValueFields = _React$useState4[0],
        setShowNullValueFields = _React$useState4[1];

    var rootFields = void 0;
    if (isMagicRoot) {
        rootFields = _react2.default.createElement(
            "span",
            { className: "magic-root-fields" },
            _react2.default.createElement(
                "a",
                {
                    className: "include-fields",
                    onClick: onIncludeMagicRootFields,
                    style: { cursor: "pointer" }
                },
                "Include ",
                targetRecordType,
                " Fields"
            ),
            " / ",
            _react2.default.createElement(
                "a",
                {
                    className: "exclude-fields",
                    onClick: onExcludeMagicRootFields,
                    style: { cursor: "pointer" }
                },
                "Exclude ",
                targetRecordType,
                " Fields"
            )
        );
    }

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            "div",
            { className: "row mapping-treegrid-header" },
            _react2.default.createElement(
                "div",
                { className: "col-md-6 col-lg-8" },
                "Target Entity"
            ),
            _react2.default.createElement(
                "div",
                { className: "col-md-3 col-lg-2" },
                "Post-Mapped Value (if checked)"
            ),
            _react2.default.createElement(
                "div",
                { className: "col-md-3 col-lg-2" },
                "Pre-Mapped Value"
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "row mapping-actions" },
            _react2.default.createElement(
                "div",
                { className: "col-md-12" },
                _react2.default.createElement(
                    "button",
                    {
                        type: "button",
                        className: "btn btn-expand-all",
                        onClick: onExpandAll
                    },
                    _react2.default.createElement("span", null)
                ),
                _react2.default.createElement(
                    "button",
                    {
                        type: "button",
                        className: "btn btn-collapse-all",
                        onClick: onCollapseAll
                    },
                    _react2.default.createElement("span", null)
                ),
                _react2.default.createElement(
                    "span",
                    null,
                    "\xA0"
                ),
                rootFields,
                " ",
                _react2.default.createElement(
                    "span",
                    { className: "missing-fields" },
                    _react2.default.createElement(
                        "a",
                        {
                            className: "show-fields",
                            onClick: function onClick() {
                                return setShowNullValueFields(true);
                            },
                            style: { cursor: "pointer" }
                        },
                        "Show Fields with No Data"
                    ),
                    " / ",
                    _react2.default.createElement(
                        "a",
                        {
                            className: "hide-fields",
                            onClick: function onClick() {
                                return setShowNullValueFields(false);
                            },
                            style: { cursor: "pointer" }
                        },
                        "Hide Fields with No Data"
                    )
                )
            )
        ),
        _react2.default.createElement("div", { ref: gridRef }),
        _react2.default.createElement(
            "div",
            { className: "row mapping-grid", style: { top: gridOffset } },
            _react2.default.createElement(_RecordSourceTreeItem2.default, {
                isKeyExpanded: isKeyExpanded,
                onChildCollapseOrExpand: onChildCollapseOrExpand,
                expanded: true,
                item: rootItem,
                filter: function filter(item) {
                    return showNullValueFields ? true : item.old !== "" || item.value !== "" || item.children && item.children.length > 0;
                }
            })
        )
    );
};

RootTreeLayout.propTypes = {
    rootItem: _propTypes2.default.object.isRequired,
    targetRecordType: _propTypes2.default.string.isRequired,
    isMagicRoot: _propTypes2.default.bool.isRequired,
    onIncludeMagicRootFields: _propTypes2.default.func.isRequired,
    onExcludeMagicRootFields: _propTypes2.default.func.isRequired,
    onExpandAll: _propTypes2.default.func.isRequired,
    onCollapseAll: _propTypes2.default.func.isRequired,
    isKeyExpanded: _propTypes2.default.func.isRequired,
    onChildCollapseOrExpand: _propTypes2.default.func.isRequired
};

exports.default = RootTreeLayout;

/***/ }),
/* 633 */,
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(51);

var _classnames2 = _interopRequireDefault(_classnames);

var _GonkBoundary = __webpack_require__(635);

var _GonkBoundary2 = _interopRequireDefault(_GonkBoundary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DrawerLayoutJS = function (_React$Component) {
    _inherits(DrawerLayoutJS, _React$Component);

    function DrawerLayoutJS(props) {
        _classCallCheck(this, DrawerLayoutJS);

        var _this = _possibleConstructorReturn(this, (DrawerLayoutJS.__proto__ || Object.getPrototypeOf(DrawerLayoutJS)).call(this, props));

        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.onClick = _this.onClick.bind(_this);
        _this.bodyContentRef = _react2.default.createRef();
        _this.state = {
            height: null
        };
        return _this;
    }

    _createClass(DrawerLayoutJS, [{
        key: "onKeyDown",
        value: function onKeyDown(e) {
            if (["Enter", " "].includes(e.key)) {
                e.preventDefault();
                this.onClick(e);
            }
        }
    }, {
        key: "onClick",
        value: function onClick(e) {
            var _props = this.props,
                enabled = _props.enabled,
                onDrawerToggle = _props.onDrawerToggle,
                open = _props.open;

            if (!enabled) return;
            onDrawerToggle(e, open);
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            this.updateBodyHeight();
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            this.updateBodyHeight();
        }
    }, {
        key: "updateBodyHeight",
        value: function updateBodyHeight() {
            var _this2 = this;

            this.setState(function (s) {
                var bodyContentElm = _this2.bodyContentRef.current;
                if (bodyContentElm == null) return;
                var height = bodyContentElm.clientHeight;
                if (s.height === null && height === 0) {
                    // weird case when content first renders open and the clientHeight
                    // is initially 0.
                    height = null;
                }
                if (s.height === height) return;
                return { height: height };
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _props2 = this.props,
                enabled = _props2.enabled,
                open = _props2.open,
                drawerContent = _props2.drawerContent,
                content = _props2.content;

            var drawerClasses = (0, _classnames2.default)("drawer-container", {
                "disabled": !enabled,
                "enabled": enabled,
                "open": open
            });
            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    "div",
                    { className: drawerClasses, style: { top: open ? 0 : -this.state.height } },
                    _react2.default.createElement(
                        "div",
                        { className: "drawer-body", style: { height: open ? null : this.state.height } },
                        _react2.default.createElement(
                            _GonkBoundary2.default,
                            null,
                            _react2.default.createElement(
                                "div",
                                { ref: this.bodyContentRef },
                                drawerContent
                            )
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "drawer-pull", onClick: this.onClick, onKeyDown: this.onKeyDown },
                        _react2.default.createElement(
                            "div",
                            { className: "drawer-tab" },
                            _react2.default.createElement(
                                "a",
                                { className: "btn btn-drawer-pull" },
                                _react2.default.createElement("span", { className: "glyphicon glyphicon-search" }),
                                _react2.default.createElement("span", { className: "glyphicon glyphicon-chevron-down" })
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "drawer-content" },
                    _react2.default.createElement(
                        _GonkBoundary2.default,
                        null,
                        content
                    )
                )
            );
        }
    }]);

    return DrawerLayoutJS;
}(_react2.default.Component);

DrawerLayoutJS.propTypes = {
    enabled: _propTypes2.default.bool.isRequired,
    open: _propTypes2.default.bool.isRequired,
    onDrawerToggle: _propTypes2.default.func.isRequired,
    drawerContent: _propTypes2.default.node,
    content: _propTypes2.default.node
};

exports.default = DrawerLayoutJS;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _GonkBox = __webpack_require__(212);

var _GonkBox2 = _interopRequireDefault(_GonkBox);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GonkBoundary = function (_React$PureComponent) {
    _inherits(GonkBoundary, _React$PureComponent);

    function GonkBoundary(props) {
        _classCallCheck(this, GonkBoundary);

        var _this = _possibleConstructorReturn(this, (GonkBoundary.__proto__ || Object.getPrototypeOf(GonkBoundary)).call(this, props));

        _this.state = { hasError: false };
        return _this;
    }

    _createClass(GonkBoundary, [{
        key: "componentDidCatch",
        value: function componentDidCatch(error, errorInfo) {
            this.setState({
                hasError: true,
                error: error,
                errorInfo: errorInfo
            });
            console.error("GonkBoundary", error, errorInfo);
        }
    }, {
        key: "render",
        value: function render() {
            if (this.state.hasError) {
                return _react2.default.createElement(
                    _GonkBox2.default,
                    null,
                    _react2.default.createElement(
                        "p",
                        null,
                        this.state.error.message
                    )
                );
            }

            return this.props.children || null;
        }
    }]);

    return GonkBoundary;
}(_react2.default.PureComponent);

GonkBoundary.propTypes = {
    children: _propTypes2.default.any
};

exports.default = GonkBoundary;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MergeBodyLayout = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

var _lockStore = __webpack_require__(144);

var _lockStore2 = _interopRequireDefault(_lockStore);

var _LockMessage = __webpack_require__(625);

var _LockMessage2 = _interopRequireDefault(_LockMessage);

var _MergeStore = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MergeBodyLayoutView = function MergeBodyLayoutView(props) {
    var isMagicRoot = props.isMagicRoot,
        sourceLabel = props.sourceLabel,
        targetLabel = props.targetLabel,
        typeLabel = props.typeLabel,
        sourceChildren = props.sourceChildren,
        targetOptlock = props.targetOptlock,
        sourceOptlock = props.sourceOptlock,
        targetPesslock = props.targetPesslock,
        sourcePesslock = props.sourcePesslock,
        onCancel = props.onCancel,
        onMerge = props.onMerge,
        children = props.children;

    var optlockViolated = targetOptlock && targetOptlock.violated || sourceOptlock && sourceOptlock.violated;
    return _react2.default.createElement(
        "div",
        { className: "merge-content" },
        _react2.default.createElement(
            "div",
            { className: "row merge-header" },
            _react2.default.createElement(
                "div",
                { className: "col-md-12" },
                sourceLabel,
                " ",
                _react2.default.createElement("img", { alt: "", src: "images/mapping_arrow.svg" }),
                " ",
                targetLabel
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "row merge-action-bar" },
            _react2.default.createElement(
                "div",
                { className: "col-md-12" },
                !optlockViolated && _react2.default.createElement(
                    "button",
                    { type: "button", className: "btn btn-merge btn-primary", onClick: onMerge },
                    _react2.default.createElement("span", null),
                    " Merge"
                ),
                _react2.default.createElement(
                    "button",
                    { type: "button", className: "btn btn-cancel", onClick: onCancel },
                    _react2.default.createElement("span", null),
                    " Cancel"
                ),
                _react2.default.createElement(_LockMessage2.default, { lock: targetPesslock, label: targetLabel }),
                _react2.default.createElement(_LockMessage2.default, { lock: sourcePesslock, label: sourceLabel })
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "merge-body" },
            "Clicking the MERGE button will:",
            _react2.default.createElement(
                "ol",
                null,
                !isMagicRoot ? _react2.default.createElement(
                    "li",
                    null,
                    "Change all references FROM ",
                    sourceLabel,
                    " TO ",
                    targetLabel
                ) : _react2.default.createElement(
                    "li",
                    null,
                    "Move the following FROM the selected ",
                    typeLabel,
                    " ",
                    sourceLabel,
                    ":",
                    _react2.default.createElement(
                        "ul",
                        null,
                        sourceChildren.map(function (g) {
                            return (
                                // combine all children to same level.
                                g.items.map(function (l, i) {
                                    return _react2.default.createElement(
                                        "li",
                                        { key: i },
                                        l
                                    );
                                })
                            );
                        })
                    ),
                    "TO ",
                    typeLabel,
                    " ",
                    targetLabel,
                    "."
                ),
                _react2.default.createElement(
                    "li",
                    null,
                    "Update ",
                    typeLabel,
                    " data for selected fields from the Pre-Mapped value to the Post-Mapped value. (Uncheck any field to retain the pre-mapped value.)"
                ),
                _react2.default.createElement(
                    "li",
                    null,
                    "Delete the FROM ",
                    typeLabel,
                    " ",
                    sourceLabel
                )
            ),
            children
        )
    );
};

MergeBodyLayoutView.propTypes = {
    isMagicRoot: _propTypes2.default.bool,
    fluxContext: _propTypes2.default.string.isRequired,
    targetLabel: _propTypes2.default.any.isRequired,
    sourceLabel: _propTypes2.default.any,
    typeLabel: _propTypes2.default.string.isRequired,
    sourceChildren: _propTypes2.default.array.isRequired,
    sourceOptlock: _propTypes2.default.any,
    sourcePesslock: _propTypes2.default.any,
    targetOptlock: _propTypes2.default.any,
    targetPesslock: _propTypes2.default.any,
    onCancel: _propTypes2.default.func.isRequired,
    onMerge: _propTypes2.default.func.isRequired,
    children: _propTypes2.default.any
};

var MergeBodyLayout = exports.MergeBodyLayout = function MergeBodyLayout(props) {
    var state = (0, _useFluxStore2.default)(function () {
        var sourceLockContext = props.fluxContext;
        var targetLockContext = props.fluxContext.replace(_MergeStore.MERGE_CONTEXT, "");
        return {
            sourceOptlock: _lockStore2.default.getOptLock(sourceLockContext),
            sourcePesslock: _lockStore2.default.getPessLock(sourceLockContext),
            targetOptlock: _lockStore2.default.getOptLock(targetLockContext),
            targetPesslock: _lockStore2.default.getPessLock(targetLockContext)
        };
    }, [_lockStore2.default], [props]);
    return _react2.default.createElement(MergeBodyLayoutView, _extends({}, props, state));
};

MergeBodyLayout.propTypes = {
    isMagicRoot: _propTypes2.default.bool,
    fluxContext: _propTypes2.default.string.isRequired,
    targetLabel: _propTypes2.default.any.isRequired,
    sourceLabel: _propTypes2.default.any,
    typeLabel: _propTypes2.default.string.isRequired,
    sourceChildren: _propTypes2.default.array.isRequired,
    onCancel: _propTypes2.default.func.isRequired,
    onMerge: _propTypes2.default.func.isRequired,
    children: _propTypes2.default.any
};

exports.default = MergeBodyLayout;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FluxMergeRecordSourceTreeGridLayout = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TreeItemStore = __webpack_require__(162);

var _TreeItemStore2 = _interopRequireDefault(_TreeItemStore);

var _TreeItemActions = __webpack_require__(355);

var _TreeItemActions2 = _interopRequireDefault(_TreeItemActions);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _MappingStore = __webpack_require__(65);

var _MappingStore2 = _interopRequireDefault(_MappingStore);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _MapDialogActions = __webpack_require__(64);

var _MapDialogActions2 = _interopRequireDefault(_MapDialogActions);

var _BuildMappingTreeVisitor = __webpack_require__(314);

var _BuildMappingTreeVisitor2 = _interopRequireDefault(_BuildMappingTreeVisitor);

var _TableAccess = __webpack_require__(77);

var _TableAccess2 = _interopRequireDefault(_TableAccess);

var _OverStore = __webpack_require__(61);

var _OverStore2 = _interopRequireDefault(_OverStore);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

var _RootTreeLayout = __webpack_require__(632);

var _RootTreeLayout2 = _interopRequireDefault(_RootTreeLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FluxMergeRecordSourceTreeGridLayout = exports.FluxMergeRecordSourceTreeGridLayout = function FluxMergeRecordSourceTreeGridLayout(props) {
    var ctx = props.ctx,
        isKeyExpanded = props.isKeyExpanded;

    var state = (0, _useFluxStore2.default)(function (prevState) {
        if (_OverStore2.default.isModalShowing()) return prevState;
        if (!_MappingStore2.default.isReady()) return prevState;

        var tree = new _BuildMappingTreeVisitor2.default(_MappingStore2.default.getState(), new _TableAccess2.default(_TableStore2.default.getState()), new _TableAccess2.default(_TableStore2.default.getSnapshot())).execute().getTree();

        var sourceKey = tree.source.entityKey;
        var targetKey = tree.target.entityKey;
        var treeItemState = _TreeItemStore2.default.getState(ctx);
        return {
            // the main goodies
            rootItem: _extends({}, tree, {
                depth: 0
            }),

            // chrome bits
            isMagicRoot: tree.isMagicRoot || false,
            sourceRecordType: _entityMetaStore2.default.getInfo(sourceKey).label,
            targetRecordLabel: tree.label,
            targetRecordType: _entityMetaStore2.default.getInfo(targetKey).label,

            // mapping event handlers
            onIncludeMagicRootFields: function onIncludeMagicRootFields() {
                return _Dispatcher2.default.dispatch({
                    type: _MapDialogActions2.default.SET_MAGIC_ROOT_EXCLUSION,
                    excluded: false
                });
            },
            onExcludeMagicRootFields: function onExcludeMagicRootFields() {
                return _Dispatcher2.default.dispatch({
                    type: _MapDialogActions2.default.SET_MAGIC_ROOT_EXCLUSION,
                    excluded: true
                });
            },

            // TreeGrid handlers
            isKeyExpanded: isKeyExpanded,
            expandedAll: treeItemState.expandAllNodes,
            onChildCollapseOrExpand: _TreeItemActions2.default.childCollapseOrExpand.bind(undefined, ctx),
            onCollapseAll: _TreeItemActions2.default.collapseAll.bind(undefined, ctx),
            onExpandAll: _TreeItemActions2.default.expandAll.bind(undefined, ctx)
        };
    }, [_MappingStore2.default, _TreeItemStore2.default, _TableStore2.default, _OverStore2.default], [ctx, isKeyExpanded]);
    return state && state.rootItem ? _react2.default.createElement(_RootTreeLayout2.default, state) : null; // render nothing
};

FluxMergeRecordSourceTreeGridLayout.propTypes = {
    mergePlugin: _propTypes2.default.string.isRequired,
    ctx: _propTypes2.default.string.isRequired,
    isKeyExpanded: _propTypes2.default.func
};

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(13);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _AboutActions = __webpack_require__(485);

var _AboutActions2 = _interopRequireDefault(_AboutActions);

var _storeUtils = __webpack_require__(54);

var _dotPropImmutable = __webpack_require__(40);

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _DataManager = __webpack_require__(43);

var _DataManager2 = _interopRequireDefault(_DataManager);

var _version = __webpack_require__(1488);

var _version2 = _interopRequireDefault(_version);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AGGREGATE_MODULE = "hybrid-accsts-version";

function mungeApiIntoApp(app, api) {
    var parts = app.split(":");
    app = parts[2];
    parts[2] = app.indexOf("-SNAPSHOT") < 0 ? app // only snapshot versions can care
    : app + "." + (api || 0);
    return parts.join(":");
}

var AboutStore = function (_ReduceStore) {
    _inherits(AboutStore, _ReduceStore);

    function AboutStore() {
        _classCallCheck(this, AboutStore);

        return _possibleConstructorReturn(this, (AboutStore.__proto__ || Object.getPrototypeOf(AboutStore)).call(this, _Dispatcher2.default));
    }

    _createClass(AboutStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {
                clientVersion: _version2.default.client,
                requiredApiVersion: _version2.default.requiredApiVersion
            };
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {
                case _AboutActions2.default.START_LOAD_VERSION_INFO:
                    return _dotPropImmutable2.default.set(state, ["apiVersion"], _LoadObject2.default.empty().withPropTypes({
                        application: _propTypes2.default.string.isRequired,
                        aggregate: _propTypes2.default.string,
                        meta: _propTypes2.default.arrayOf(_propTypes2.default.shape({
                            key: _propTypes2.default.string.isRequired,
                            version: _propTypes2.default.string.isRequired
                        })),
                        modules: _propTypes2.default.arrayOf(_propTypes2.default.string)
                    }, "AboutStore").loading(_DataManager2.default.loadVersionInfo()));
                case _AboutActions2.default.LOADED_VERSION_INFO:
                    return _dotPropImmutable2.default.set(state, ["apiVersion"], function (lo) {
                        return lo.receiveValue(_extends({}, action.data, {
                            application: mungeApiIntoApp(action.data.application, action.data.api),
                            aggregate: action.data.modules.find(function (it) {
                                return it.split(":")[1] === AGGREGATE_MODULE;
                            })
                        }));
                    });
                case _AboutActions2.default.LOAD_VERSION_INFO_ERROR:
                    return _dotPropImmutable2.default.set(state, ["apiVersion"], function (lo) {
                        return lo.receiveError(action.error);
                    });
                default:
                    return state;
            }
        }
    }, {
        key: "getClientVersion",
        value: function getClientVersion() {
            return this.getState().clientVersion;
        }
    }, {
        key: "getRequiredApiVersion",
        value: function getRequiredApiVersion() {
            return this.getState().requiredApiVersion;
        }
    }, {
        key: "getApiVersion",
        value: function getApiVersion() {
            return this.getApiVersionLO().getRequiredValue();
        }
    }, {
        key: "getApiVersionLO",
        value: function getApiVersionLO() {
            var _this2 = this;

            return (0, _storeUtils.hotLoadObject)(function () {
                return _this2.getState().apiVersion;
            }, function () {
                return _Dispatcher2.default.dispatch({
                    type: _AboutActions2.default.START_LOAD_VERSION_INFO
                });
            });
        }
    }]);

    return AboutStore;
}(_utils.ReduceStore);

AboutStore.stateTypes = {
    clientVersion: _propTypes2.default.string.isRequired,
    requiredApiVersion: _propTypes2.default.string.isRequired,
    apiVersion: _propTypes2.default.instanceOf(_LoadObject2.default)
};

exports.default = (0, _typeCheckingStore2.default)(new AboutStore());

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _slices = __webpack_require__(172);

var _TwoPaneMultiSelect = __webpack_require__(1493);

var _TwoPaneMultiSelect2 = _interopRequireDefault(_TwoPaneMultiSelect);

var _TwoPaneMultiSelectStore = __webpack_require__(1495);

var _TwoPaneMultiSelectStore2 = _interopRequireDefault(_TwoPaneMultiSelectStore);

var _TwoPaneMultiSelectActions = __webpack_require__(641);

var _TwoPaneMultiSelectActions2 = _interopRequireDefault(_TwoPaneMultiSelectActions);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildTree(groups, selection) {
    return (0, _slices.toSlice)(groups, "key", function (g) {
        var hasGroup = selection.hasOwnProperty(g.key);
        return _extends({}, g, {
            items: (0, _slices.toSlice)(g.items, "key", function (it) {
                return _extends({}, it, {
                    selected: hasGroup && selection[g.key].indexOf(it.key) >= 0
                });
            })
        });
    });
}

function splitTree(tree, selected) {
    return tree.keys.map(function (gk) {
        var g = tree.byKey[gk];
        return {
            key: g.key,
            name: g.name,
            items: g.items.keys.map(function (ik) {
                return g.items.byKey[ik];
            }).filter(function (it) {
                return selected ? it.selected : !it.selected;
            }).map(function (it) {
                return {
                    key: it.key,
                    name: it.name
                };
            })
        };
    }).filter(function (g) {
        return g.items.length > 0;
    });
}

var TwoPaneMultiSelectContainer = function TwoPaneMultiSelectContainer(props) {
    var state = (0, _useFluxStore2.default)(function () {
        var groups = _TwoPaneMultiSelectStore2.default.getGroups();
        var selection = _TwoPaneMultiSelectStore2.default.getSelection();
        var tree = buildTree(groups, selection);
        return {
            triggerSave: function triggerSave() {
                return props.triggerSave(selection);
            },
            scrollState: _TwoPaneMultiSelectStore2.default.getScrollState(),
            unselectedTree: splitTree(tree, false),
            selectedTree: splitTree(tree, true),
            onToggleItem: _TwoPaneMultiSelectActions2.default.toggleItem,
            onHandleScroll: _TwoPaneMultiSelectActions2.default.handleScroll,
            onUpdatePositions: _TwoPaneMultiSelectActions2.default.updatePositions
        };
    }, [_TwoPaneMultiSelectStore2.default], [props.triggerSave]);
    return _react2.default.createElement(_TwoPaneMultiSelect2.default, _extends({}, props, state));
};

TwoPaneMultiSelectContainer.propTypes = {
    triggerClose: _propTypes2.default.func.isRequired,
    triggerSave: _propTypes2.default.func.isRequired,
    contentBlocks: _TwoPaneMultiSelect.contentBlocksType
};

exports.default = TwoPaneMultiSelectContainer;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var TwoPaneMultiSelectTypes = {
    TOGGLE_ITEM: "2panemultiselect/toggle-item",
    POPULATE: "2panemultiselect/populate",
    HANDLE_SCROLL: "2panemultiselect/handle-scroll",
    UPDATE_POSITIONS: "2panemultiselect/update-positions"
};

exports.default = TwoPaneMultiSelectTypes;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _TwoPaneMultiSelectTypes = __webpack_require__(640);

var _TwoPaneMultiSelectTypes2 = _interopRequireDefault(_TwoPaneMultiSelectTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TwoPaneMultiSelectActions = {
    toggleItem: function toggleItem(groupKey, itemKey) {
        _Dispatcher2.default.dispatch({
            type: _TwoPaneMultiSelectTypes2.default.TOGGLE_ITEM,
            groupKey: groupKey,
            itemKey: itemKey
        });
    },
    populate: function populate(groups, selection) {
        _Dispatcher2.default.dispatch({
            type: _TwoPaneMultiSelectTypes2.default.POPULATE,
            groups: groups,
            selection: selection
        });
    },
    handleScroll: function handleScroll(state) {
        _Dispatcher2.default.dispatch(_extends({}, state, {
            type: _TwoPaneMultiSelectTypes2.default.HANDLE_SCROLL
        }));
    },
    updatePositions: function updatePositions(groups, prevGroups) {
        _Dispatcher2.default.dispatch({
            type: _TwoPaneMultiSelectTypes2.default.UPDATE_POSITIONS,
            groups: groups,
            prevGroups: prevGroups
        });
    }
};

exports.default = TwoPaneMultiSelectActions;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.isActiveOrg = isActiveOrg;

var _Forest = __webpack_require__(1499);

var _Forest2 = _interopRequireDefault(_Forest);

var _OrgSelect = __webpack_require__(643);

var _OrgSelect2 = _interopRequireDefault(_OrgSelect);

var _parseSpec3 = __webpack_require__(1500);

var _parseSpec4 = _interopRequireDefault(_parseSpec3);

var _ReauthModule = __webpack_require__(253);

var _Spec = __webpack_require__(1501);

var _Spec2 = _interopRequireDefault(_Spec);

var _updateForestForImpls = __webpack_require__(1502);

var _updateForestForImpls2 = _interopRequireDefault(_updateForestForImpls);

var _useSpec3 = __webpack_require__(1503);

var _useSpec4 = _interopRequireDefault(_useSpec3);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActiveOrgContext = _react2.default.createContext(undefined);

function isActiveOrg(name) {
    return _react2.default.useContext(ActiveOrgContext) === name;
}

function FormItem(_ref) {
    var label = _ref.label,
        children = _ref.children;

    return _react2.default.createElement(
        "div",
        { className: "flex" },
        _react2.default.createElement(
            "label",
            { className: "flex-label" },
            label,
            ":"
        ),
        children
    );
}

FormItem.propTypes = {
    label: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.element
};

var ORG_ARMUS = "armus";

function newKid(name, disallowAccess) {
    var kid = {
        name: name,
        kids: []
    };
    if (disallowAccess) {
        kid.perms = ["NONE"];
    }
    return kid;
}

function Form(_ref2) {
    var cookie = _ref2.cookie,
        onSave = _ref2.onSave,
        onCancel = _ref2.onCancel;

    var _React$useState = _react2.default.useState("fred"),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        user = _React$useState2[0],
        setUser = _React$useState2[1];

    var _React$useState3 = _react2.default.useState(""),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        activeOrg = _React$useState4[0],
        setActiveOrg = _React$useState4[1];

    var _React$useState5 = _react2.default.useState([]),
        _React$useState6 = _slicedToArray(_React$useState5, 2),
        forest = _React$useState6[0],
        setForest = _React$useState6[1];

    var armusExists = (0, _ReauthModule.useArmusExists)();
    var orgs = (0, _ReauthModule.useOrgs)();
    var impls = (0, _ReauthModule.useImpls)();
    var users = _react2.default.useMemo(function () {
        var result = [{ id: "fred", label: "fred" }, { id: "admin", label: "admin (a superuser)" }];
        if (user && result.every(function (r) {
            return r.id !== user;
        })) {
            result.unshift({ id: user, label: user });
        }
        return result;
    }, [user]);

    function handleTextUpdate(curr) {
        if (!curr) return;

        var _parseSpec = (0, _parseSpec4.default)(curr),
            _parseSpec2 = _slicedToArray(_parseSpec, 3),
            user = _parseSpec2[0],
            org = _parseSpec2[1],
            forestUpdater = _parseSpec2[2];

        user && setUser(user);
        org && setActiveOrg(org);
        setForest(forestUpdater);
    }

    function _buildImplLicense(implementer, activeOrg) {
        var kid = newKid(implementer, activeOrg !== implementer);
        if (activeOrg !== implementer) {
            var lowest = kid;
            if (implementer !== ORG_ARMUS && armusExists) {
                lowest = newKid(ORG_ARMUS, activeOrg !== ORG_ARMUS);
                kid.kids.push(lowest);
            }
            if (activeOrg !== ORG_ARMUS) {
                lowest.kids.push(newKid(activeOrg));
            }
        }
        return kid;
    }

    function handleGuess() {
        var badOrgs = new Set();
        badOrgs.add("armus");
        badOrgs.add("armus-admin");
        forest.forEach(function (it) {
            return badOrgs.add(it.implementer);
        });
        var org = activeOrg;
        if (badOrgs.has(org)) {
            // see if there's a better one...
            var o = orgs.find(function (it) {
                return !badOrgs.has(it);
            });
            if (o) {
                org = o;
                setActiveOrg(org);
            }
        }
        setForest(function (frst) {
            var impl = frst.map(function (it) {
                return [it.name === "adt" ? 2 : 1, it.name === "hemo" ? 2 : 1, it.implementer === "armus" ? 2 : 1, it.implementer === "armus-admin" ? 2 : 1, it.name].join(",");
            }).sort().map(function (it) {
                return it.split(",")[4];
            })[0];
            var idx = frst.findIndex(function (it) {
                return it.name === impl;
            });
            return frst.map(function (it, i) {
                return _extends({}, it, {
                    kids: i === idx ? [_buildImplLicense(impl, org)] : []
                });
            });
        });
    }

    _react2.default.useEffect(function () {
        return handleTextUpdate(cookie);
    }, [cookie]);

    _react2.default.useEffect(function () {
        if (!orgs) return;
        setActiveOrg(function (o) {
            return o || orgs[0];
        });
    }, [orgs]);
    _react2.default.useEffect(function () {
        if (!impls) return;
        setForest(function (f) {
            return (0, _updateForestForImpls2.default)(f, impls);
        });
    }, [impls]);

    var _useSpec = (0, _useSpec4.default)(user, activeOrg, forest),
        _useSpec2 = _slicedToArray(_useSpec, 3),
        spec = _useSpec2[0],
        valid = _useSpec2[1],
        ancestry = _useSpec2[2];

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        cookie && _react2.default.createElement(
            FormItem,
            { label: "Cookie" },
            _react2.default.createElement(_Spec2.default, {
                spec: cookie,
                collapsed: true
            })
        ),
        _react2.default.createElement(
            FormItem,
            { label: "Username" },
            _react2.default.createElement(
                "select",
                {
                    value: user,
                    onChange: function onChange(e) {
                        return setUser(e.target.value);
                    }
                },
                users.map(function (u) {
                    return _react2.default.createElement(
                        "option",
                        { key: u.id, value: u.id },
                        u.label
                    );
                })
            )
        ),
        _react2.default.createElement(
            FormItem,
            { label: "Active Org" },
            _react2.default.createElement(_OrgSelect2.default, {
                value: activeOrg,
                onChange: function onChange(e) {
                    return setActiveOrg(e.target.value);
                }
            })
        ),
        _react2.default.createElement(FormItem, { label: "Licenses" }),
        _react2.default.createElement(
            ActiveOrgContext.Provider,
            { value: activeOrg },
            _react2.default.createElement(_Forest2.default, {
                forest: forest,
                ancestry: ancestry,
                onChange: setForest,
                buildImplLicense: function buildImplLicense(impl) {
                    return _buildImplLicense(impl, activeOrg);
                }
            })
        ),
        _react2.default.createElement(
            FormItem,
            { label: "Spec" },
            _react2.default.createElement(_Spec2.default, {
                spec: spec,
                onChange: handleTextUpdate
            })
        ),
        _react2.default.createElement(
            "div",
            { className: "modal-footer" },
            _react2.default.createElement(
                "button",
                {
                    className: "btn btn-save",
                    disabled: !valid,
                    onClick: function onClick() {
                        return onSave(spec);
                    }
                },
                _react2.default.createElement("span", null),
                " Reauthorize"
            ),
            cookie && _react2.default.createElement(
                "button",
                {
                    className: "btn btn-refresh",
                    disabled: cookie === spec,
                    onClick: function onClick() {
                        return handleTextUpdate(cookie);
                    },
                    title: "Restore the authorization from your cookie"
                },
                _react2.default.createElement("span", null),
                " Reset"
            ),
            _react2.default.createElement(
                "button",
                {
                    className: "btn btn-refresh",
                    onClick: handleGuess,
                    title: "Guess a likely authorization structure."
                },
                _react2.default.createElement("span", null),
                " Guess?"
            ),
            _react2.default.createElement(
                "button",
                {
                    className: "btn btn-cancel",
                    onClick: onCancel
                },
                _react2.default.createElement("span", null),
                " Cancel"
            )
        )
    );
}

Form.propTypes = {
    cookie: _propTypes2.default.string,
    onSave: _propTypes2.default.func.isRequired,
    onCancel: _propTypes2.default.func.isRequired
};

exports.default = Form;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ReauthModule = __webpack_require__(253);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OrgSelect(_ref) {
    var value = _ref.value,
        _ref$excludes = _ref.excludes,
        excludes = _ref$excludes === undefined ? [] : _ref$excludes,
        onChange = _ref.onChange,
        _ref$allowBlank = _ref.allowBlank,
        allowBlank = _ref$allowBlank === undefined ? false : _ref$allowBlank,
        title = _ref.title;

    var allOrgs = (0, _ReauthModule.useOrgs)();
    var orgs = _react2.default.useMemo(function () {
        var s = new Set(excludes);
        return allOrgs.filter(function (o) {
            return !s.has(o);
        });
    }, [allOrgs, excludes]);
    return _react2.default.createElement(
        "select",
        {
            value: value,
            onChange: onChange,
            title: title,
            disabled: orgs.length === 0
        },
        allowBlank && _react2.default.createElement("option", null),
        orgs.map(function (o) {
            return _react2.default.createElement(
                "option",
                { key: o },
                o
            );
        })
    );
}

OrgSelect.propTypes = {
    value: _propTypes2.default.string.isRequired,
    excludes: _propTypes2.default.arrayOf(_propTypes2.default.string),
    onChange: _propTypes2.default.func.isRequired,
    allowBlank: _propTypes2.default.bool,
    title: _propTypes2.default.string
};

exports.default = OrgSelect;

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.USER_COOKIE_NAME = undefined;
exports.readCookie = readCookie;
exports.setCookie = setCookie;
exports.clearCookie = clearCookie;

var _jsCookie = __webpack_require__(1504);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// the cookie name is defined by com.armus.hybrid.web.security.test.UserManagerServiceImpl.USER_COOKIE_NAME
var USER_COOKIE_NAME = exports.USER_COOKIE_NAME = "web.security.test.user";

var Cookies = function () {
    var delim = "/";
    var a = window.location.pathname.split(delim);
    a.pop();
    return _jsCookie2.default.withAttributes({ path: a.join(delim) + delim });
}();

function readCookie() {
    var spec = Cookies.get(USER_COOKIE_NAME);
    while (spec && spec.indexOf("%") >= 0) {
        spec = decodeURIComponent(spec).trim();
    }
    return spec;
}

function setCookie(spec) {
    Cookies.set(USER_COOKIE_NAME, encodeURIComponent(spec).replace(/\(/g, "%28").replace(/\)/g, "%29"));
}

function clearCookie() {
    Cookies.remove(USER_COOKIE_NAME);
}

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var contextFromAppModelOrContext = function contextFromAppModelOrContext(appModelOrFluxContext) {
    return typeof appModelOrFluxContext === "string" ? appModelOrFluxContext : appModelOrFluxContext.get("fluxContext");
};

exports.default = contextFromAppModelOrContext;

/***/ }),
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var id_seq = 0;
var next = function next() {
    return ++id_seq;
};

var LockClient = function () {
    function LockClient() {
        _classCallCheck(this, LockClient);
    }

    _createClass(LockClient, [{
        key: "updateRecordOnServer",
        value: function updateRecordOnServer(table, id, username) {
            this._addViolator(table, id, "optimistic", username, true);
        }
    }, {
        key: "openRecordInNewClient",
        value: function openRecordInNewClient(table, id, username) {
            this._addViolator(table, id, "pessimistic", {
                id: next(),
                username: username
            });
        }
    }, {
        key: "_addViolator",
        value: function _addViolator(table, id, type, violator) {
            var munge = function munge(obj) {
                var key = type + "Violators";
                if (!obj[key]) {
                    obj[key] = [];
                }
                if (obj[key].indexOf(violator) < 0) {
                    obj[key].push(violator);
                }
            };

            this._workOnLock(table, id, function (ls, l) {
                munge(l);
                munge(ls);
            });
        }
    }, {
        key: "_workOnLock",
        value: function _workOnLock(table, id, work) {
            if (!this.locksets) return;
            Object.values(this.locksets).forEach(function (ls) {
                if (!ls.locks.hasOwnProperty(table)) return;
                // noinspection EqualityComparisonWithCoercionJS
                ls.locks[table].filter(function (l) {
                    return l.id == id;
                }).forEach(function (l) {
                    return work(ls, l);
                });
            });
        }
    }, {
        key: "closeRecordInOtherClient",
        value: function closeRecordInOtherClient(table, id, username) {
            var gonk = function gonk() {
                throw new Error(username + " does not have " + table + "#" + id + " open");
            };

            var munge = function munge(obj) {
                if (!obj.pessimisticViolators) gonk();
                var idx = obj.pessimisticViolators.findIndex(function (v) {
                    return v.username === username;
                });
                if (idx < 0) gonk();
                if (obj.pessimisticViolators.length === 1) {
                    obj.pessimisticViolators = null;
                } else {
                    obj.pessimisticViolators.splice(idx, 1);
                }
            };

            this._workOnLock(table, id, function (ls, l) {
                munge(l);
                munge(ls);
            });
        }
    }, {
        key: "createClient",
        value: function createClient() {
            this.id = next();
            this.locksets = {};
            return {
                id: this.id,
                username: "alice"
            };
        }
    }, {
        key: "createLockSet",
        value: function createLockSet(data) {
            var id = next();
            this.locksets[id] = {
                id: id,
                acquiredAt: Date.now(),
                confirmedAt: Date.now(),
                locks: data.locks
            };
            return this.locksets[id];
        }
    }, {
        key: "confirmLockSet",
        value: function confirmLockSet(id) {
            this.locksets[id].confirmedAt = Date.now();
            return this.locksets[id];
        }
    }, {
        key: "releaseLockSet",
        value: function releaseLockSet(id) {
            delete this.locksets[id];
            return { id: parseInt(id, 10) };
        }
    }, {
        key: "releaseClient",
        value: function releaseClient(id) {
            delete this.id;
            delete this.locksets;
            return { id: parseInt(id, 10) };
        }
    }]);

    return LockClient;
}();

exports.default = new LockClient();

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ajax = ajax;
exports.over = over;
exports.viewstack = viewstack;
exports.sync = sync;
exports.tick = tick;

var _utils = __webpack_require__(365);

var _OverStore = __webpack_require__(61);

var _OverStore2 = _interopRequireDefault(_OverStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
    Spin until 'conditionFn' returns true, then execute 'fn'.  If it takes more
    than the 'for' key of the 'options' object's value (1000ms by default) give
    up.  If a 'timeoutFn' is provided, it will be invoked and passed the
    augmented 'options' object (including an __error key), otherwise an error
    will be raised.
*/
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// derived from WebSpecter (https://github.com/jgonera/webspecter) MIT license
var _until = function _until(conditionFn, options, fn, timeoutFn) {
    if (options instanceof Function) {
        fn = options;
        options = {};
    }
    (0, _utils.extendLeft)(options, {
        "for": 1000,
        message: conditionFn.message || conditionFn.toString()
    });
    if (options.__timed_out) {
        return;
    }
    if (conditionFn()) {
        clearTimeout(options.timeoutId);
        fn();
    } else {
        if (!options.timeoutId) {
            // eslint-disable-next-line no-settimeout
            options.timeoutId = setTimeout(function () {
                options.__timed_out = true;
                options.__error = new Error("Timeout waiting until: " + options.message);
                if (timeoutFn != null) {
                    return timeoutFn(options);
                } else {
                    throw options.__error;
                }
            }, options.for);
        }
        // eslint-disable-next-line no-settimeout
        setTimeout(function () {
            _until(conditionFn, options, fn, timeoutFn);
        }, 250);
    }
};

/*
    Spin while 'conditionFn' returns true, then execute 'fn'. The exact inverse
    of 'until', with all the same options and semantics.
*/
var _while = function _while(conditionFn, options, fn, timeoutFn) {
    var negatedConditionFn = function negatedConditionFn() {
        return !conditionFn();
    };
    _until(negatedConditionFn, options, fn, timeoutFn);
};

var ajaxCount = 0;
var ajaxRunning = false;
var ajaxDelayCount = 0;
var ajaxDelayed = false;
$(document).ajaxStart(function () {
    return ajaxRunning = true;
}).ajaxSend(function () {
    return ajaxCount++;
}).ajaxComplete(function () {
    if (ajaxCount > 0) {
        return ajaxCount--;
    } else {
        return console.log("IT> {ajax completed, but count was already zero...}");
    }
}).ajaxStop(function () {
    if (!ajaxRunning) {
        console.log("IT> {ajax stop, but not running...}");
    }
    return ajaxRunning = false;
}).on("ajaxDelay", function () {
    ajaxDelayCount++;
    return ajaxDelayed = true;
}).on("ajaxResume", function () {
    if (!ajaxDelayed) {
        console.log("IT> {ajax resume, but not delayed...}");
    }
    if (ajaxDelayCount > 0) {
        ajaxDelayCount--;
    } else {
        console.log("IT> {ajax resumed, but count was already zero...}");
    }
    return ajaxDelayed = ajaxDelayCount > 0;
});

/*
    Spin until all in-flight Ajax calls are complete, then execute 'fn'.
    Equivalent to "while( -> [[ajax in flight]], options, fn)".
*/
function ajax(options, fn, timeoutFn) {
    if (options instanceof Function) {
        fn = options;
        options = {};
    }
    (0, _utils.extendLeft)(options, { message: "wait.ajax (ajax is done)" });
    var conditionFn = function conditionFn() {
        return ajaxRunning || ajaxDelayed || window.hotLoadObjectActiveCount > 0;
    };
    _while(conditionFn, options, fn, timeoutFn);
}

var isOverShowing = function isOverShowing() {
    return _OverStore2.default.isModalShowing();
};

/*
    Spin until all overs have closed, then execute 'fn'.  Equivalent to
    "while ( -> [[over visible]], options, fn)".
*/
function over(options, fn, timeoutFn) {
    if (options instanceof Function) {
        fn = options;
        options = {};
    }
    (0, _utils.extendLeft)(options, { message: "wait.over (overs are closed)" });
    var conditionFn = function conditionFn() {
        return isOverShowing();
    };
    _while(conditionFn, options, fn, timeoutFn);
}

var viewStackCount = 0;
var viewStackPending = false;
Backbone.dispatcher.on("viewstack:next", function () {
    viewStackCount++;
    return viewStackPending = true;
}).on("viewstack:ready", function () {
    if (viewStackCount > 0) {
        viewStackCount--;
    } else {
        console.log("IT> {viewstack ready, but count was already zero...}");
    }
    if (!viewStackPending) {
        console.log("IT> {viewstack:ready, but nothing pending...}");
    }
    return viewStackPending = viewStackCount > 0;
});
/*
    Spin until all pending viewstack operations have concluded, then execute
    'fn'.  Equivalent to "while ( -> [[viewstack pending]], options, fn)".
*/
function viewstack(options, fn, timeoutFn) {
    if (options instanceof Function) {
        fn = options;
        options = {};
    }
    (0, _utils.extendLeft)(options, { message: "wait.viewstack (viewstack is ready)" });
    var conditionFn = function conditionFn() {
        return viewStackPending;
    };
    _while(conditionFn, options, fn, timeoutFn);
}

/*
    Spin until all Ajax calls are complete and overs are hidden, then
    execute 'fn'.  This is a combination of 'over' and 'ajax'.
*/
function sync(options, fn, timeoutFn) {
    if (options instanceof Function) {
        fn = options;
        options = {};
    }
    (0, _utils.extendLeft)(options, { message: "wait.sync (ajax, over, and viewstack)" });
    var conditionFn = function conditionFn() {
        return ajaxRunning || ajaxDelayed || isOverShowing() || viewStackPending || window.hotLoadObjectActiveCount > 0;
    };
    _while(conditionFn, options, fn, timeoutFn);
}

/*
    Spin until the current call stack is complete, then execute 'fn'.  If a
    specific delay is desired, it may be passed as the 'for' key in the options
    (expressed in milliseconds).
*/
function tick(options, fn, timeoutFn) {
    if (options instanceof Function) {
        fn = options;
        options = {};
    }
    if (options.delay != null) {
        throw new Error("The 'delay' option is obsolete; use 'for' instead.");
    }
    (0, _utils.extendLeft)(options, { for: 0 });
    // all the _while machinery is irrelevant, short circuit
    // eslint-disable-next-line no-settimeout
    setTimeout(fn, options.for, timeoutFn);
}

exports.default = {
    "while": _while,
    "until": _until,
    ajax: ajax,
    over: over,
    viewstack: viewstack,
    sync: sync,
    tick: tick
};

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _Mock = __webpack_require__(1612);

var _Mock2 = _interopRequireDefault(_Mock);

var _lockClient = __webpack_require__(665);

var _lockClient2 = _interopRequireDefault(_lockClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
This configures the mocking subsystem that can use a mockset instead of the
real API to "service" requests. Order matters; patterns are searched in the
declared order and the first match wins, even if a more specific pattern is
declared farther down.
*/

var newIdOnPostFilter = function newIdOnPostFilter(data, req, config) {
    var postData = JSON.parse(config.data);
    data.newIds[postData.id] = data.id;
    return data;
};

var noOpPostProcessor = function noOpPostProcessor(url) {
    return "/noop.json?" + url;
};

/**
 * I return a post-processor which will ensure the params in the URL are as
 * expected. By default, no params are allowed. Required and optional param
 * names may be specified, as well as passing a flag to allow arbitrary extra
 * params. Note that the `_` parameter the system appends behind the scenes for
 * cache control is exempt from the checks.
 * @param requiredParams An array of parameter names that must be provided.
 * @param optionalParams And array of parameter names that may be provided.
 * @param allowExtras Whether to allow extra parameters to be provided.
 * @return {function(*, *): *} The post-processor to wire onto the request.
 */
function paramValidatingPostProcessor() {
    var requiredParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var optionalParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var allowExtras = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    return function (url, xhr) {
        var names = xhr.url.split("?").slice(1).join("?").split("&").map(function (pair) {
            var segments = pair.split("=");
            var name = segments.shift();
            var value = segments.join("=");
            return [decodeURIComponent(name), decodeURIComponent(value)];
        }).map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 1),
                name = _ref2[0];

            return name;
        }).filter(function (n) {
            return n !== "_";
        });
        requiredParams.forEach(function (n) {
            if (!names.includes(n)) {
                throw new Error("Required param '" + n + "' was not provided to " + url + " (params: " + names.join(",") + ")");
            }
        });
        if (!allowExtras) {
            names.forEach(function (n) {
                if (!requiredParams.includes(n) && !optionalParams.includes(n)) {
                    throw new Error("Extra param '" + n + "' was provided to " + url + " (params: " + names.join(",") + ")");
                }
            });
        }
        return url;
    };
}

// system
_Mock2.default.GET("/meta/armusscript.js");
_Mock2.default.GET("/broadcast");
_Mock2.default.GET("/user");
_Mock2.default.PUT("/user/active-organizations");
_Mock2.default.POST("/user/active-organizations");
_Mock2.default.GET("/user/prefs/{org}/{pref}");
_Mock2.default.PUT("/user/prefs/{org}/{pref}");
_Mock2.default.POST("/user/prefs/{org}/{pref}");
_Mock2.default.GET("/prefs/{org}/{impl}/{pref}");
_Mock2.default.PUT("/prefs/{org}/{impl}/{pref}");
_Mock2.default.POST("/prefs/{org}/{impl}/{pref}");
_Mock2.default.GET("/gxep/{org}");
_Mock2.default.PUT("/gxep/{org}").suffixed("POST");
// ADT remoting
_Mock2.default.GET("/remote/data-source/adt/{org}/search");
// Hemo remoting
_Mock2.default.GET("/remote/data-source/hemo/{org}/search");
// exports
_Mock2.default.GET("/export/{org}/saved-params");
_Mock2.default.POST("/export/{org}/saved-params");
_Mock2.default.PUT("/export/{org}/saved-params/{id}");
_Mock2.default.DELETE("/export/{org}/saved-params/{id}");
_Mock2.default.POST("/export/{org}/generic-xml/export");
_Mock2.default.GET("/export/{org}/history");
// metadata
_Mock2.default.GET("/meta/version");
_Mock2.default.GET("/meta/stereotype");
_Mock2.default.GET("/meta/stereotype/{stereo}");
_Mock2.default.GET("/meta/stereotype/{impl}/{version}/{entity}");
_Mock2.default.GET("/meta/{org}/{stereo}/model.json");
_Mock2.default.GET("/meta/{org}/{impl}/{version}/{entity}/model.json");
_Mock2.default.GET("/meta/{org}/{impl}/{version}/{entity}/form.json");
_Mock2.default.GET("/meta/{org}/{impl}/{version}/{entity}/form").extension("json");
_Mock2.default.GET("/meta/{org}/{impl}/{version}/{entity}/fields/{field}");
_Mock2.default.GET("/meta/{org}/{impl}/{version}/{entity}/mapping-src/{srcImpl}/{srcVersion}/{srcEntity}.json");
_Mock2.default.GET("/meta/{org}/{impl}");
_Mock2.default.GET("/meta/{org}/{impl}/{version}");
// occurrence data
_Mock2.default.GET("/dqr/{stereo}").paged();
_Mock2.default.GET("/dqr/{stereo}/fields").paged();
_Mock2.default.GET("/search/{stereo}").paged();
_Mock2.default.GET("/search/{impl}/{version}/{entity}").paged();
_Mock2.default.GET("/{org}/{stereo}");
_Mock2.default.POST("/{org}/{stereo}").suffixed("POST").filtered(newIdOnPostFilter);
_Mock2.default.GET("/{org}/{stereo}/{id:i}");
_Mock2.default.PUT("/{org}/{stereo}/{id:i}");
_Mock2.default.POST("/{org}/{stereo}/{id:i}");
_Mock2.default.DELETE("/{org}/{stereo}/{id:i}");
_Mock2.default.GET("/{org}/{impl}/{version}/{entity}");
_Mock2.default.POST("/{org}/{impl}/{version}/{entity}").suffixed("POST").filtered(newIdOnPostFilter);
_Mock2.default.GET("/{org}/{impl}/{version}/{entity}/{id:i}");
_Mock2.default.PUT("/{org}/{impl}/{version}/{entity}/{id:i}");
_Mock2.default.POST("/{org}/{impl}/{version}/{entity}/{id:i}");
_Mock2.default.DELETE("/{org}/{impl}/{version}/{entity}/{id:i}");
_Mock2.default.POST("/{org}/{impl}/{version}/suggest/{field}");
_Mock2.default.POST("/{org}/{impl}/{version}/suggest/api/{entityName}/{field}");
// lock monitoring - all fake!
_Mock2.default.POST("/lock").postprocess(noOpPostProcessor).filtered(function () {
    return _lockClient2.default.createClient();
});
_Mock2.default.POST("/lock/{clientId}/set").postprocess(noOpPostProcessor).filtered(function (data, req, config) {
    return _lockClient2.default.createLockSet(JSON.parse(config.data));
});
_Mock2.default.PUT("/lock/{clientId}/set/{locksetId}/active").postprocess(noOpPostProcessor).filtered(function (data, req) {
    return _lockClient2.default.confirmLockSet(req.split("/")[4]);
});
_Mock2.default.DELETE("/lock/{clientId}/set/{locksetId}").postprocess(noOpPostProcessor).filtered(function (data, req) {
    return _lockClient2.default.releaseLockSet(req.split("/")[4]);
});
_Mock2.default.DELETE("/lock/{clientId}").postprocess(noOpPostProcessor).filtered(function (data, req) {
    return _lockClient2.default.releaseClient(req.split("/")[2]);
});

/*
 * Exporters don't actually exist, so spit back some static answers
 */
// shared by all
var participantOptions = [{
    hospname: "Certification Hospital",
    particid: "999999"
}, {
    hospname: "Test Hospital",
    particid: "12345"
}];
_Mock2.default.GET("/export/{org}/{impl}/{type}/participants").postprocess(noOpPostProcessor).filtered(function () {
    return participantOptions;
});
_Mock2.default.GET("/export/{org}/{impl}/{type}/date-range").postprocess(noOpPostProcessor).filtered(function (data, req, xhr) {
    if (xhr.url.indexOf("12345") >= 0) {
        return {
            from: [2016, 2, 17],
            to: [2021, 4, 12]
        };
    }
    return {
        from: [2018, 4, 1],
        to: [2020, 11, 10]
    };
});
var fieldOptions = {
    entities: [{
        fields: [{
            key: "ageatadmit",
            name: "Age at Admission",
            type: "integer"
        }, {
            key: "admitdate",
            name: "Date of Admission",
            type: "date"
        }],
        key: "episode",
        name: "Episode"
    }, {
        fields: [{
            key: "dob",
            name: "Date Of Birth",
            type: "date"
        }, {
            key: "race",
            name: "Race",
            type: "choice"
        }, {
            key: "sex",
            name: "Sex",
            type: "choice"
        }],
        key: "patient",
        name: "Patient"
    }, {
        fields: [{
            key: "surgid",
            name: "Surgeon ID",
            type: "string"
        }],
        key: "surgeon",
        name: "Surgeon"
    }],
    key: "sts-adult-cardiac-surgery",
    name: "Adult Cardiac Surgery"
};
// STS Harvests
_Mock2.default.GET("/export/{org}/adult-cardiac/harvest/optional-fields").postprocess(noOpPostProcessor).filtered(function () {
    return fieldOptions;
});
_Mock2.default.GET("/export/{org}/congenital/harvest/optional-fields").postprocess(noOpPostProcessor).filtered(function () {
    return fieldOptions;
});
_Mock2.default.GET("/export/{org}/thoracic/harvest/optional-fields").postprocess(noOpPostProcessor).filtered(function () {
    return fieldOptions;
});
// Adult Cardiac Exporter
_Mock2.default.GET("/export/{org}/adult-cardiac/export/exportable/hospitals").postprocess(paramValidatingPostProcessor([])).postprocess(noOpPostProcessor).filtered(function () {
    return participantOptions;
});
_Mock2.default.GET("/export/{org}/adult-cardiac/export/exportable/surgdt-range").postprocess(paramValidatingPostProcessor(["particid"], ["datavrsns", "surgeons"])).postprocess(noOpPostProcessor).filtered(function (data, req, xhr) {
    if (xhr.url.indexOf("Physician A") >= 0) {
        return {
            from: [2021, 2, 17],
            to: [2021, 4, 12]
        };
    }
    if (xhr.url.indexOf("4.20.2") >= 0) {
        return {
            from: [2020, 2, 17],
            to: [2021, 4, 12]
        };
    }
    if (xhr.url.indexOf("12345") >= 0) {
        return {
            from: [2016, 2, 17],
            to: [2021, 4, 12]
        };
    }
    return {
        from: [2018, 4, 1],
        to: [2020, 11, 10]
    };
});
_Mock2.default.GET("/export/{org}/adult-cardiac/export/exportable/fields").postprocess(paramValidatingPostProcessor([])).postprocess(noOpPostProcessor).filtered(function () {
    return [{
        fields: [{
            "entity": "episode",
            "key": "case_id",
            "name": "ARMUS Case ID",
            "type": "STRING"
        }, {
            "entity": "patient",
            "key": "adminsectionnotes",
            "name": "Administrative Section Notes",
            "type": "STRING"
        }],
        name: "A. Administrative"
    }, {
        fields: [{
            "entity": "patient",
            "key": "custom_armuscustompatient01",
            "name": "ARMUS Custom Patient 01",
            "type": "STRING"
        }, {
            "entity": "episode",
            "key": "patcountry",
            "name": "Patient's Country",
            "type": "CHOICE"
        }],
        name: "B. Demographics"
    }];
});
var filteredDatavrsns = function filteredDatavrsns(data, req, xhr) {
    if (xhr.url.indexOf("12345") >= 0) {
        return [{ "name": "2.9" }, { "name": "1.0" }];
    }
    return [{ "name": "4.20.2" }, { "name": "2.9" }, { "name": "2.81" }];
};
var filteredSurgeons = function filteredSurgeons(data, req, xhr) {
    if (xhr.url.indexOf("4.20.2") >= 0) {
        return [{ "name": "Surgeons A", "npi": "12345" }];
    }
    if (xhr.url.indexOf("12345") >= 0) {
        return [{ "name": "Surgeons C", "npi": null }];
    }
    return [{ "name": "Surgeons A", "npi": "12345" }, { "name": "Surgeons B", "npi": "99999" }, { "name": "Surgeons C", "npi": null }];
};
_Mock2.default.GET("/export/{org}/adult-cardiac/export/exportable/datavrsns").postprocess(paramValidatingPostProcessor(["particid"], ["surgeons"])).postprocess(noOpPostProcessor).filtered(filteredDatavrsns);
_Mock2.default.GET("/export/{org}/adult-cardiac/export/exportable/surgeons").postprocess(paramValidatingPostProcessor(["particid"], ["datavrsns", "surgdtStart", "surgdtEnd"])).postprocess(noOpPostProcessor).filtered(filteredSurgeons);
_Mock2.default.GET("/export/{org}/adult-cardiac/export/exportable/procedure-types").postprocess(noOpPostProcessor).filtered(function () {
    return ["Cheese", "Sauce", "Pepperoni"].map(function (name) {
        return { name: name };
    });
});
_Mock2.default.GET("/export/{org}/thoracic/export/exportable/datavrsns").postprocess(paramValidatingPostProcessor(["particid"], ["surgeons"])).postprocess(noOpPostProcessor).filtered(filteredDatavrsns);
_Mock2.default.GET("/export/{org}/thoracic/export/exportable/surgeons").postprocess(paramValidatingPostProcessor(["particid"], ["datavrsns"])).postprocess(noOpPostProcessor).filtered(filteredSurgeons);

/***/ }),
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(686);
__webpack_require__(897);
__webpack_require__(898);
__webpack_require__(980);
__webpack_require__(981);
__webpack_require__(982);
__webpack_require__(983);
__webpack_require__(984);
__webpack_require__(985);
__webpack_require__(986);
__webpack_require__(987);
__webpack_require__(988);
__webpack_require__(989);
module.exports = __webpack_require__(990);


/***/ }),
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _QuarterYearSelect = __webpack_require__(81);

var _QuarterYearSelect2 = _interopRequireDefault(_QuarterYearSelect);

var _useKeyValueState3 = __webpack_require__(38);

var _useKeyValueState4 = _interopRequireDefault(_useKeyValueState3);

var _formRegistry = __webpack_require__(74);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormView = function FormView(_ref) {
    var _onChange = _ref.onChange,
        state = _ref.state,
        data = _ref.data;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Participant ID"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "particid",
                            className: "participant form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("particid", v);
                            },
                            value: state.particid,
                            options: data.particid,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Quarter"
                ),
                _react2.default.createElement(_QuarterYearSelect2.default, {
                    quarter: state.quarter,
                    year: state.year,
                    min: data.daterange.from,
                    max: data.daterange.to,
                    onChange: _onChange,
                    disabled: !state.particid,
                    required: true
                }),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Submission Type"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "submissionType",
                            className: "submissionType form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("submissionType", v);
                            },
                            value: state.submissionType,
                            options: data.submissionType,
                            disabled: !state.particid
                        })
                    )
                )
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Export Options"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "checkbox" },
                    _react2.default.createElement(
                        "label",
                        null,
                        _react2.default.createElement("input", {
                            type: "checkbox",
                            className: "exclude_ncdr_patient_identifiers",
                            onChange: function onChange(e) {
                                return _onChange("excludePatientIdentifiers", e.target.checked ? "true" : "false");
                            },
                            checked: state.excludePatientIdentifiers === "true"
                        }),
                        "Exclude NCDR Patient Identifiers"
                    )
                )
            )
        )
    );
};

var selectShape = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
}));

FormView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    state: _propTypes2.default.shape({
        start: _propTypes2.default.string,
        end: _propTypes2.default.string,
        submissionType: _propTypes2.default.string,
        excludePatientIdentifiers: _propTypes2.default.string,
        particid: _propTypes2.default.string
    }),
    data: _propTypes2.default.shape({
        particid: selectShape,
        quarter: _propTypes2.default.string,
        year: _propTypes2.default.string,
        submissionType: _propTypes2.default.array
    })
};

var asString = function asString(v) {
    return v == null ? "" : v.toString();
};

var initialStateWithDefaults = function initialStateWithDefaults() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        quarter: asString(state.quarter),
        year: asString(state.year),
        particid: asString(state.particid),
        submissionType: asString(state.submissionType) || "",
        excludePatientIdentifiers: asString(state.excludePatientIdentifiers) || "false"
    };
};

var initialData = {
    particid: [],
    daterange: { from: [], to: [] }
};

var AccAFibExportForm = function AccAFibExportForm(_ref2) {
    var initialState = _ref2.initialState,
        needServerData = _ref2.needServerData,
        onReady = _ref2.onReady,
        onNotReady = _ref2.onNotReady;

    var _React$useState = _react2.default.useState(function () {
        return initialStateWithDefaults(initialState);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(initialStateWithDefaults(initialState));
    }, [initialState]);

    var _useKeyValueState = (0, _useKeyValueState4.default)(initialData),
        _useKeyValueState2 = _slicedToArray(_useKeyValueState, 2),
        data = _useKeyValueState2[0],
        setDataKey = _useKeyValueState2[1];

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/participants",
            loadingMessage: "Loading Participants...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.particid + ": " + it.hospname,
                        value: it.particid
                    };
                });
                data.unshift({ label: "", value: "" });
                setDataKey("particid", data);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var particid = state.particid;

        if (!particid) return;
        needServerData({
            endpoint: "/date-range",
            loadingMessage: "Loading Available Date Range...",
            params: {
                particid: particid
            },
            onData: function onData(data) {
                return setDataKey("daterange", { from: data.from, to: data.to });
            }
        });
    }, [state.particid]);

    _react2.default.useEffect(function () {
        if (state.quarter && state.year && state.particid) {
            onReady(_extends({}, state));
        } else {
            onNotReady();
        }
    }, [state]);

    var handleChange = _react2.default.useCallback(function (key, value) {
        return setState(function (s) {
            return _extends({}, s, _defineProperty({}, key, value));
        });
    }, [setState]);

    var dataWithSubmissionTypes = _extends({}, data, { submissionType: [{ value: "", label: "" }, { value: "1", label: "Episode of Care Records" }, { value: "2", label: "Follow-Up Records" }] });

    return _react2.default.createElement(FormView, {
        state: state,
        data: dataWithSubmissionTypes,
        onChange: handleChange
    });
};

AccAFibExportForm.propTypes = {
    initialState: _propTypes2.default.shape({
        quarter: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        year: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        particid: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        submissionType: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        excludePatientIdentifiers: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string])
    }),
    needServerData: _propTypes2.default.func.isRequired,
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

AccAFibExportForm.canRerun = function (params) {
    return !!(params && params.particid);
};

AccAFibExportForm.apiPrefix = "afib";

(0, _formRegistry.registerForm)("acc-afib-export", AccAFibExportForm);

/***/ }),
/* 899 */,
/* 900 */,
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _formhelpers = __webpack_require__(5);

var _GonkBox = __webpack_require__(212);

var _GonkBox2 = _interopRequireDefault(_GonkBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NotFound = function (_React$PureComponent) {
    _inherits(NotFound, _React$PureComponent);

    function NotFound() {
        _classCallCheck(this, NotFound);

        return _possibleConstructorReturn(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).apply(this, arguments));
    }

    _createClass(NotFound, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var descriptor = this.props.descriptor;

            console.warn("No '<code>app/lib/common/descriptorcontrols/" + descriptor.type + "/" + descriptor.control + ".js</code>' found for '" + descriptor.key + "'.");
        }
    }, {
        key: "render",
        value: function render() {
            var descriptor = this.props.descriptor;

            return _react2.default.createElement(
                _GonkBox2.default,
                {
                    id: descriptor.id,
                    "data-control-type": descriptor.control,
                    "data-shortname": descriptor.key
                },
                "No '",
                _react2.default.createElement(
                    "code",
                    null,
                    "app/lib/common/descriptorcontrols/",
                    descriptor.type,
                    "/",
                    descriptor.control,
                    ".js"
                ),
                "' found for '",
                descriptor.key,
                "'."
            );
        }
    }]);

    return NotFound;
}(_react2.default.PureComponent);

exports.default = NotFound;


NotFound.propTypes = (0, _formhelpers.controlPropTypes)();

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MISSING = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(51);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formhelpers = __webpack_require__(5);

var _DropdownMenu = __webpack_require__(903);

var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);

var _keyEvents = __webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MISSING = exports.MISSING = { VALUE: "_NULL", LABEL: "Missing" };

var TypeaheadCore = function (_React$Component) {
    _inherits(TypeaheadCore, _React$Component);

    function TypeaheadCore(props) {
        _classCallCheck(this, TypeaheadCore);

        // input bindings
        var _this = _possibleConstructorReturn(this, (TypeaheadCore.__proto__ || Object.getPrototypeOf(TypeaheadCore)).call(this, props));

        _this.inputRef = _react2.default.createRef();
        _this.onInputFocus = _this.onInputFocus.bind(_this);
        _this.onInputBlur = _this.onInputBlur.bind(_this);
        _this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
        _this.onSearch = _this.onSearch.bind(_this);
        _this.onRecordbrowserClick = _this.onRecordbrowserClick.bind(_this);

        // typeahead bindings
        _this.typeaheadRef = _react2.default.createRef();
        _this.onClick = _this.onClick.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onClearValue = _this.onClearValue.bind(_this);
        _this.onSelectAll = _this.onSelectAll.bind(_this);

        // dropdown bindings
        _this.onSelect = _this.onSelect.bind(_this);
        _this.onSort = _this.onSort.bind(_this);
        _this.hideDropdownMenu = _this.hideDropdownMenu.bind(_this);
        _this.showDropdownMenu = _this.showDropdownMenu.bind(_this);

        _this.state = {
            searchText: "",
            focused: false, // if typeahead is currently focused.
            showDropdownMenu: false, // if dropdown menu is currently opened.
            selectedActiveIndex: null, // for multiselect backspace key
            sort: {
                key: "",
                dir: ""
            }
        };
        return _this;
    }

    _createClass(TypeaheadCore, [{
        key: "onRecordbrowserClick",
        value: function onRecordbrowserClick(e) {
            var _props = this.props,
                onRecordbrowserClick = _props.onRecordbrowserClick,
                descriptor = _props.descriptor;

            onRecordbrowserClick && onRecordbrowserClick(e, descriptor);
        }
    }, {
        key: "onSearch",
        value: function onSearch(e) {
            var onSearch = this.props.onSearch;

            this.setState({ searchText: e.target.value, showDropdownMenu: true, selectedActiveIndex: null });
            onSearch && onSearch(e.target.value || "", this.state.sort);
        }
    }, {
        key: "onInputKeyDown",
        value: function onInputKeyDown(e) {
            var _props2 = this.props,
                descriptor = _props2.descriptor,
                onKeyDown = _props2.onKeyDown,
                value = _props2.value,
                multiValued = _props2.multiValued;
            var _state = this.state,
                searchText = _state.searchText,
                selectedActiveIndex = _state.selectedActiveIndex;

            var newValue = value;
            if (multiValued) {
                newValue = Array.isArray(value) ? [].concat(_toConsumableArray(value)) : [];
            }
            var keyDownName = (0, _keyEvents.processKeyName)(e.key);
            var openKeys = multiValued && newValue.length ? ["ArrowDown"] : ["ArrowDown", "ArrowLeft", "ArrowRight"];
            if (!this.state.showDropdownMenu && openKeys.includes(keyDownName)) {
                e.preventDefault();
                e.stopPropagation();
                this.showDropdownMenu();
                return;
            } else if (multiValued && ["ArrowLeft", "ArrowRight", "Backspace", "Escape"].includes(keyDownName)) {
                if (this.state.showDropdownMenu && keyDownName === "Backspace" && searchText.length === 0) {
                    this.hideDropdownMenu();
                }
                // multiValued allows removing items with the backspace.
                // use the Left/Right arrow keys to highlight a field.
                if (keyDownName === "Backspace" && newValue.length && searchText.length === 0) {
                    if (selectedActiveIndex === null) {
                        this.setState({ selectedActiveIndex: newValue.length - 1 });
                    } else {
                        newValue.splice(selectedActiveIndex, 1); // remove the active item.
                        this.onChange(newValue.length ? newValue : null);
                        this.setState({ selectedActiveIndex: null });
                    }
                } else if (["ArrowLeft", "ArrowRight"].includes(keyDownName) && newValue.length) {
                    var newActiveItem = selectedActiveIndex;
                    if (newActiveItem == null) {
                        newActiveItem = -1;
                    }
                    keyDownName === "ArrowLeft" ? newActiveItem-- : newActiveItem++;
                    if (newActiveItem < 0) {
                        newActiveItem = newValue.length - 1;
                    }
                    if (newActiveItem >= newValue.length) {
                        newActiveItem = 0;
                    }
                    this.setState({ selectedActiveIndex: newActiveItem });
                } else if (keyDownName === "Escape") {
                    this.setState({ selectedActiveIndex: null });
                }
            }
            if (keyDownName === "Enter") {
                if (this.state.showDropdownMenu) {
                    // if the dropdown is open on enter do not advance to the next control.
                    return;
                }
            }
            onKeyDown && onKeyDown(e, descriptor, newValue);
        }
    }, {
        key: "onInputFocus",
        value: function onInputFocus(e) {
            var _props3 = this.props,
                descriptor = _props3.descriptor,
                onFocus = _props3.onFocus,
                value = _props3.value;

            if (!this.state.focused) {
                // only trigger focus once when changing from unfocused.
                this.setState({ focused: true });
                onFocus && onFocus(e, descriptor, value);
            }
        }
    }, {
        key: "onInputBlur",
        value: function onInputBlur(e) {
            var _props4 = this.props,
                descriptor = _props4.descriptor,
                onBlur = _props4.onBlur,
                value = _props4.value;

            if (this.state.focused && !this.state.showDropdownMenu) {
                this.setState({ focused: false, selectedActiveIndex: null });
                onBlur && onBlur(e, descriptor, value);
            }
        }
    }, {
        key: "onClick",
        value: function onClick(e) {
            var _props5 = this.props,
                enabled = _props5.enabled,
                descriptor = _props5.descriptor,
                onClick = _props5.onClick,
                onFocus = _props5.onFocus,
                value = _props5.value;

            if (enabled) {
                if (!this.state.focused) {
                    // only trigger focus once when changing from unfocused.
                    this.setState({ focused: true });
                    onFocus && onFocus(e, descriptor, value);
                }
                // show options menu.
                this.showDropdownMenu();
            }
            onClick && onClick(e, descriptor, value);
        }
    }, {
        key: "onSelect",
        value: function onSelect(item) {
            var _props6 = this.props,
                value = _props6.value,
                valueKey = _props6.valueKey,
                multiValued = _props6.multiValued;

            var newValue = void 0;
            if (multiValued) {
                if (value === null || item.atomic) {
                    newValue = [];
                } else {
                    // we can never add a new selection to an atomic option
                    newValue = value.some(function (it) {
                        return it.atomic;
                    }) ? [] : [].concat(_toConsumableArray(value));
                }
                var index = newValue.findIndex(function (v) {
                    return v[valueKey] == item[valueKey];
                });
                if (index !== -1) {
                    // remove the selected value
                    newValue.splice(index, 1);
                    if (newValue.length === 0) {
                        newValue = null;
                    }
                } else {
                    // add the selected value
                    newValue.push(_extends({}, item));
                }
            } else {
                newValue = _extends({}, item);
            }
            this.onChange(newValue);
        }
    }, {
        key: "onSort",
        value: function onSort(sort) {
            var _this2 = this;

            var onSearch = this.props.onSearch;
            var searchText = this.state.searchText;

            this.setState({ sort: sort }, function () {
                _this2.inputRef.current.focus();
            });
            onSearch && onSearch(searchText, sort);
        }
    }, {
        key: "onRemoveItem",
        value: function onRemoveItem(e, item, index) {
            // multi only event
            e.preventDefault();
            e.stopPropagation();
            var _props7 = this.props,
                _props7$value = _props7.value,
                value = _props7$value === undefined ? [] : _props7$value,
                valueKey = _props7.valueKey,
                multiValued = _props7.multiValued;

            if (multiValued) {
                var newValue = [].concat(_toConsumableArray(value));
                if (newValue[index][valueKey] == item[valueKey]) {
                    // allow string/number coercions
                    // selected item aligns with prop values
                    // ok to remove
                    newValue.splice(index, 1);
                    this.onChange(newValue.length ? newValue : null);
                }
            }
        }
    }, {
        key: "onClearValue",
        value: function onClearValue() {
            this.onChange(null);
        }
    }, {
        key: "onSelectAll",
        value: function onSelectAll() {
            var options = this.props.options;

            this.onChange(options.filter(function (it) {
                return !it.atomic;
            }));
        }
    }, {
        key: "onChange",
        value: function onChange(newValue) {
            var _props8 = this.props,
                descriptor = _props8.descriptor,
                onCommitChange = _props8.onCommitChange,
                enabled = _props8.enabled,
                multiValued = _props8.multiValued,
                labelKey = _props8.labelKey;

            var label = void 0;
            // get the labels
            if (newValue) {
                if (multiValued) {
                    if (newValue) {
                        label = newValue.map(function (it) {
                            return it[labelKey];
                        });
                    }
                } else {
                    label = newValue[labelKey];
                }
            }
            enabled && onCommitChange && onCommitChange(descriptor, newValue, true, label);
        }
    }, {
        key: "showDropdownMenu",
        value: function showDropdownMenu() {
            var _this3 = this;

            this.setState({ focused: true, showDropdownMenu: true, searchText: "" }, function () {
                _this3.inputRef.current.focus();
            });
        }
    }, {
        key: "hideDropdownMenu",
        value: function hideDropdownMenu() {
            var _this4 = this;

            var onSearch = this.props.onSearch;

            this.setState({ focused: true, showDropdownMenu: false, searchText: "" }, function () {
                _this4.inputRef.current.focus();
            });
            onSearch && onSearch("", this.state.sort); // reset dropdown results
        }
    }, {
        key: "convertValueToSelected",
        value: function convertValueToSelected(value) {
            var _props9 = this.props,
                addMissing = _props9.addMissing,
                multiValued = _props9.multiValued,
                valueKey = _props9.valueKey,
                labelKey = _props9.labelKey;

            if (multiValued) {
                if (value === undefined || value === null) {
                    return [];
                }
                return value;
            } else {
                if (addMissing && (value === undefined || value === null)) {
                    var _ref;

                    return _ref = {}, _defineProperty(_ref, valueKey, MISSING.VALUE), _defineProperty(_ref, labelKey, MISSING.LABEL), _ref;
                }
                return value;
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this5 = this;

            var _props10 = this.props,
                multiValued = _props10.multiValued,
                value = _props10.value,
                enabled = _props10.enabled,
                labelKey = _props10.labelKey,
                showRecordBrowserIcon = _props10.showRecordBrowserIcon,
                showSelectAll = _props10.showSelectAll,
                autoSelectFirstItem = _props10.autoSelectFirstItem,
                isLoading = _props10.isLoading,
                isPartial = _props10.isPartial,
                isError = _props10.isError,
                isServer = _props10.isServer,
                options = _props10.options;
            var _state2 = this.state,
                focused = _state2.focused,
                searchText = _state2.searchText,
                showDropdownMenu = _state2.showDropdownMenu,
                sort = _state2.sort,
                selectedActiveIndex = _state2.selectedActiveIndex;

            var showInput = searchText.length > 0;

            var selected = this.convertValueToSelected(value);
            var hasValue = multiValued ? selected.length > 0 : selected !== undefined && selected !== null;

            var classnames = (0, _classnames2.default)({
                typeahead: true,
                active: focused,
                disabled: !enabled,
                multiselect: multiValued,
                open: showDropdownMenu
            });
            return _react2.default.createElement(
                "div",
                { ref: this.typeaheadRef, className: showRecordBrowserIcon ? "input-group" : "" },
                _react2.default.createElement(
                    "div",
                    {
                        className: classnames,
                        "data-loading": isLoading,
                        "data-partial": isPartial !== undefined ? isPartial : options.length > 100,
                        "data-error": isError,
                        "data-open": showDropdownMenu,
                        "data-count": options.length,
                        onClick: this.onClick
                    },
                    _react2.default.createElement("input", {
                        ref: this.inputRef,
                        onFocus: this.onInputFocus,
                        onBlur: this.onInputBlur,
                        onKeyDown: this.onInputKeyDown,
                        onChange: this.onSearch,
                        disabled: !enabled,
                        className: "form-control focusable",
                        type: "text",
                        style: showInput ? { opacity: 1, width: "calc(100% - 20px)" } : { opacity: 0, position: "absolute", zIndex: -1 },
                        value: searchText
                    }),
                    _react2.default.createElement(
                        "div",
                        { className: "pull-right" },
                        _react2.default.createElement("span", { className: "caret" })
                    ),
                    !hasValue && !showInput && focused && _react2.default.createElement(
                        "div",
                        { className: "no-query-label" },
                        "Enter a search term"
                    ),
                    multiValued ? _react2.default.createElement(
                        "div",
                        null,
                        selected.map(function (item, index) {
                            return _react2.default.createElement(
                                "span",
                                { key: index, className: "item-selection " + (index === selectedActiveIndex ? "active" : "") },
                                item[labelKey],
                                _react2.default.createElement(
                                    "span",
                                    {
                                        className: "item-selection-close", onClick: function onClick(e) {
                                            return _this5.onRemoveItem(e, item, index);
                                        } },
                                    _react2.default.createElement(
                                        "span",
                                        {
                                            className: "item-selection-close-inner" },
                                        "\xD7"
                                    )
                                )
                            );
                        })
                    ) : hasValue && _react2.default.createElement(
                        "div",
                        { className: "single-item-selection" },
                        selected[labelKey]
                    )
                ),
                showRecordBrowserIcon && enabled && _react2.default.createElement(
                    "a",
                    { href: "#", className: "input-group-addon icon-search", onClick: this.onRecordbrowserClick },
                    _react2.default.createElement("span", null)
                ),
                !autoSelectFirstItem && !multiValued && _react2.default.createElement(
                    "a",
                    { href: "#", className: "typeahead-icon-button clear-value", onClick: this.onClearValue },
                    _react2.default.createElement("span", null)
                ),
                showSelectAll && multiValued && _react2.default.createElement(
                    "a",
                    { href: "#", title: "Select all options", className: "typeahead-icon-button select-all", onClick: this.onSelectAll },
                    _react2.default.createElement("span", null)
                ),
                _react2.default.createElement(_DropdownMenu2.default, _extends({}, this.props, {
                    targetRef: this.typeaheadRef,
                    show: showDropdownMenu,
                    onHide: this.hideDropdownMenu,
                    onSelect: this.onSelect,
                    onSort: this.onSort,
                    sort: sort,
                    searchText: searchText,
                    selected: selected
                })),
                !isServer && isLoading && _react2.default.createElement(
                    "div",
                    { className: "local-over-modal" },
                    "Searching..."
                )
            );
        }
    }]);

    return TypeaheadCore;
}(_react2.default.Component);

exports.default = TypeaheadCore;


TypeaheadCore.defaultProps = {
    options: [],
    columns: [],
    valueKey: "value",
    labelKey: "label"
};

TypeaheadCore.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)(), {
    onSearch: _propTypes2.default.func,

    // Value is assumed to be the inflated value(s) or null. Meaning an object
    // with {[valueKey]: ... , [labelKey]: ... } or array of those objects.
    // This is different from how the jQuery control worked which only supplied
    // the value string(s) and expected the inflated value to exist in the
    // options list.
    value: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.arrayOf(_propTypes2.default.object)]),

    options: _propTypes2.default.arrayOf(_propTypes2.default.object.isRequired),
    columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        includeInFilter: _propTypes2.default.bool,
        isSortable: _propTypes2.default.bool,
        key: _propTypes2.default.string.isRequired,
        label: _propTypes2.default.string
    })).isRequired,
    valueKey: _propTypes2.default.string.isRequired,
    labelKey: _propTypes2.default.string.isRequired,
    dropdownLength: _propTypes2.default.number,
    addMissing: _propTypes2.default.bool,
    multiValued: _propTypes2.default.bool,
    statusMessage: _propTypes2.default.string,
    showRecordBrowserIcon: _propTypes2.default.bool,
    showSelectAll: _propTypes2.default.bool,
    autoSelectFirstItem: _propTypes2.default.bool,
    keepSelectionInList: _propTypes2.default.bool,
    isServer: _propTypes2.default.bool,
    isLoading: _propTypes2.default.bool
});

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(51);

var _classnames2 = _interopRequireDefault(_classnames);

var _Typeahead = __webpack_require__(291);

var _DropdownWrapper = __webpack_require__(214);

var _DropdownWrapper2 = _interopRequireDefault(_DropdownWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropdownMenu = function (_React$Component) {
    _inherits(DropdownMenu, _React$Component);

    function DropdownMenu(props) {
        _classCallCheck(this, DropdownMenu);

        var _this = _possibleConstructorReturn(this, (DropdownMenu.__proto__ || Object.getPrototypeOf(DropdownMenu)).call(this, props));

        _this.onSort = _this.onSort.bind(_this);
        _this.renderedItems = [];
        return _this;
    }

    _createClass(DropdownMenu, [{
        key: "onSort",
        value: function onSort(e, key) {
            var _props = this.props,
                onSort = _props.onSort,
                sort = _props.sort;

            e.preventDefault();
            e.stopPropagation();
            var dir = "asc";
            if (key === sort.key) {
                if (sort.dir === "asc") {
                    // change direction
                    dir = "desc";
                } else if (sort.dir === "desc") {
                    // remove sort
                    dir = "";
                    key = "";
                }
            }
            onSort && onSort({ key: key, dir: dir });
        }
    }, {
        key: "filteredOptions",
        value: function filteredOptions() {
            var _this2 = this;

            var _props2 = this.props,
                options = _props2.options,
                columns = _props2.columns,
                searchText = _props2.searchText,
                keepSelectionInList = _props2.keepSelectionInList,
                sort = _props2.sort,
                isServer = _props2.isServer;


            var newOptions = [].concat(_toConsumableArray(options));
            if (!keepSelectionInList) {
                // remove selected item(s) from list
                newOptions = newOptions.filter(function (item) {
                    return !_this2.isItemSelected(item);
                });
            }

            if (isServer) {
                // Server options are not sorted or searched.
                return newOptions;
            }
            // first filter the options
            if (searchText.length) {
                // Search multiple terms separated by space.
                var terms = searchText.trim().toLowerCase().split(" ");
                newOptions = newOptions.filter(function (item) {
                    var found = false;
                    if (searchText.length) {
                        var foundAll = 0;
                        // create a synthetic string for all the filterable columns.
                        var rowText = "";
                        columns.forEach(function (column) {
                            if (column.includeInFilter === false) {
                                return;
                            }
                            var value = item[column.key] || "";
                            // build the text we want to search against
                            rowText += value.toString().toLowerCase();
                        });
                        terms.forEach(function (s) {
                            if (rowText.indexOf(s) !== -1) {
                                // a term was found
                                foundAll++;
                            }
                        });
                        if (terms.length <= foundAll) {
                            // found all the terms
                            found = true;
                        }
                    } else {
                        found = true;
                    }
                    return found;
                });
            }

            // now sort the options
            var sortDir = sort.dir === "asc" ? 1 : -1;
            if (sort.key && sort.dir) {
                var beginswith = [];
                var caseSensitive = [];
                var caseInsensitive = [];
                var item = undefined;
                while (item = newOptions.shift()) {
                    if (!item[sort.key]) {
                        // key does not exist
                        continue;
                    }
                    var label = item[sort.key].toString();
                    if (label.toLowerCase().indexOf(searchText.toLowerCase()) === 0) {
                        beginswith.push(item);
                    } else if (label.indexOf(searchText) >= 0) {
                        caseSensitive.push(item);
                    } else {
                        caseInsensitive.push(item);
                    }
                }
                newOptions = beginswith.concat(caseSensitive, caseInsensitive);

                newOptions.sort(function (obj1, obj2) {
                    if (obj1[sort.key] > obj2[sort.key]) {
                        return sortDir;
                    }
                    if (obj1[sort.key] < obj2[sort.key]) {
                        return -sortDir;
                    }
                    return 0;
                });
            }
            return newOptions;
        }
    }, {
        key: "buildHeaderColumns",
        value: function buildHeaderColumns() {
            var _this3 = this;

            var _props3 = this.props,
                columns = _props3.columns,
                sort = _props3.sort;

            if (columns.length <= 1) {
                return null;
            }

            return _react2.default.createElement(
                "tr",
                null,
                columns.map(function (column, index) {
                    var classnames = (0, _classnames2.default)(_defineProperty({
                        "sortable": column.isSortable !== false
                    }, sort.dir, sort.key === column.key && column.isSortable !== false));
                    return _react2.default.createElement(
                        "th",
                        {
                            key: index,
                            className: classnames,
                            onClick: function onClick(e) {
                                return column.isSortable !== false ? _this3.onSort(e, column.key) : null;
                            }
                        },
                        column.label,
                        " ",
                        _react2.default.createElement("span", null)
                    );
                })
            );
        }
    }, {
        key: "buildItemColumns",
        value: function buildItemColumns(item, index) {
            var _props4 = this.props,
                onSelect = _props4.onSelect,
                columns = _props4.columns,
                searchText = _props4.searchText,
                labelKey = _props4.labelKey;

            var selected = this.isItemSelected(item);
            return _react2.default.createElement(
                "tr",
                { className: selected ? "active" : "", key: index, onClick: function onClick() {
                        return onSelect(item, index);
                    } },
                columns.map(function (column, index) {
                    var label = item[column.key] || item[labelKey];
                    if (label.length && column.includeInFilter && searchText.length) {
                        searchText.trim().split(" ").forEach(function (s) {
                            var query = s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
                            label = label.replace(new RegExp("(" + query + ")", "ig"), function ($1, match) {
                                return "<strong>" + match + "</strong>";
                            });
                        });
                    }
                    return _react2.default.createElement("td", { key: index, dangerouslySetInnerHTML: { __html: label } });
                })
            );
        }
    }, {
        key: "getActiveIndex",
        value: function getActiveIndex(items) {
            var _props5 = this.props,
                selected = _props5.selected,
                multiValued = _props5.multiValued,
                keepSelectionInList = _props5.keepSelectionInList;

            if (selected && !multiValued && keepSelectionInList) {
                for (var index in items) {
                    var item = items[index];
                    if (this.isItemSelected(item)) {
                        return parseInt(index, 10);
                    }
                }
            }
            return 0;
        }
    }, {
        key: "isItemSelected",
        value: function isItemSelected(item) {
            var _props6 = this.props,
                selected = _props6.selected,
                multiValued = _props6.multiValued,
                valueKey = _props6.valueKey;

            var active = false;
            if (selected !== null) {
                if (multiValued) {
                    active = selected.find(function (v) {
                        return v[valueKey] == item[valueKey];
                    });
                } else {
                    if (item[valueKey] == selected[valueKey]) {
                        active = true;
                    }
                }
            }
            return active;
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            var _props7 = this.props,
                show = _props7.show,
                statusMessage = _props7.statusMessage,
                isLoading = _props7.isLoading;


            if (!show) {
                return _react2.default.createElement("div", { ref: this.dropdownRef });
            }
            var items = this.filteredOptions();

            var status = statusMessage;
            if (items.length > 100 && !statusMessage) {
                status = _Typeahead.STATUS_MESSAGE.PARTIAL;
                items = items.slice(0, 100);
            }

            this.renderedItems = items;

            return this.props.show && _react2.default.createElement(
                _DropdownWrapper2.default,
                {
                    targetRef: this.props.targetRef,
                    dropdownLength: this.props.dropdownLength,
                    itemSelector: "tbody tr",
                    ignoreClickSelector: ".sortable",
                    initialActiveIndex: this.getActiveIndex(this.renderedItems),
                    activeItemClass: "hover",
                    ignoreSpaceKey: true,
                    onHide: this.props.onHide,
                    onEnterKey: function onEnterKey(e, index) {
                        _this4.props.onSelect(_this4.renderedItems[index], index);
                        _this4.props.onHide();
                    }
                },
                _react2.default.createElement(
                    "div",
                    { ref: this.dropdownRef, className: "typeahead-dropdown " + (isLoading ? "" : "with-scroller") },
                    _react2.default.createElement(
                        "table",
                        { className: "table scroller" },
                        _react2.default.createElement(
                            "thead",
                            null,
                            this.buildHeaderColumns()
                        ),
                        _react2.default.createElement(
                            "tbody",
                            null,
                            items.map(function (item, index) {
                                return _this4.buildItemColumns(item, index);
                            })
                        )
                    ),
                    items.length === 0 && _react2.default.createElement(
                        "div",
                        { className: "list-group-item empty" },
                        _react2.default.createElement(
                            "strong",
                            null,
                            _Typeahead.STATUS_MESSAGE.EMPTY
                        )
                    ),
                    status && _react2.default.createElement(
                        "div",
                        { className: "list-group-item status-message" },
                        _react2.default.createElement(
                            "strong",
                            null,
                            status
                        )
                    ),
                    isLoading && _react2.default.createElement(
                        "div",
                        { className: "list-group-item loading" },
                        _react2.default.createElement(
                            "strong",
                            null,
                            _Typeahead.STATUS_MESSAGE.LOADING
                        )
                    )
                )
            );
        }
    }]);

    return DropdownMenu;
}(_react2.default.Component);

exports.default = DropdownMenu;


DropdownMenu.defaultProps = {
    dropdownLength: 8,
    searchText: ""
};

DropdownMenu.propTypes = {
    targetRef: _propTypes2.default.object.isRequired,
    show: _propTypes2.default.bool.isRequired,
    selected: _propTypes2.default.any,
    searchText: _propTypes2.default.string,
    onSelect: _propTypes2.default.func.isRequired,
    onHide: _propTypes2.default.func.isRequired,
    onSort: _propTypes2.default.func,
    sort: _propTypes2.default.shape({
        key: _propTypes2.default.string,
        dir: _propTypes2.default.string
    }).isRequired,
    options: _propTypes2.default.arrayOf(_propTypes2.default.object.isRequired).isRequired,
    columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        includeInFilter: _propTypes2.default.bool,
        isSortable: _propTypes2.default.bool,
        key: _propTypes2.default.string.isRequired,
        label: _propTypes2.default.string
    })).isRequired,
    valueKey: _propTypes2.default.string.isRequired,
    labelKey: _propTypes2.default.string.isRequired,
    multiValued: _propTypes2.default.bool,
    statusMessage: _propTypes2.default.string,
    dropdownLength: _propTypes2.default.number,
    keepSelectionInList: _propTypes2.default.bool,
    isServer: _propTypes2.default.bool,
    isLoading: _propTypes2.default.bool
};

/***/ }),
/* 904 */,
/* 905 */,
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _formhelpers = __webpack_require__(5);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = function (_React$Component) {
    _inherits(Checkbox, _React$Component);

    function Checkbox(props) {
        _classCallCheck(this, Checkbox);

        var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));

        _this.onChange = _this.onChange.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onClick = _this.onClick.bind(_this);
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        return _this;
    }

    _createClass(Checkbox, [{
        key: "convertBoolToValue",
        value: function convertBoolToValue(value) {
            var config = this.props.descriptor.config || {};
            if (value) {
                return config.checkedValue !== undefined ? config.checkedValue : true;
            }
            return config.uncheckedValue !== undefined ? config.uncheckedValue : false;
        }
    }, {
        key: "convertValueToBool",
        value: function convertValueToBool(value) {
            var config = this.props.descriptor.config || {};
            var checkedValue = config.checkedValue !== undefined ? config.checkedValue : true;
            return value === checkedValue;
        }
    }, {
        key: "onChange",
        value: function onChange(e) {
            var _props = this.props,
                descriptor = _props.descriptor,
                onCommitChange = _props.onCommitChange,
                value = _props.value,
                enabled = _props.enabled,
                onChange = _props.onChange;

            var newValue = this.convertBoolToValue(e.target.checked);
            if (enabled) {
                if (newValue !== value) {
                    onCommitChange && onCommitChange(descriptor, newValue);
                }
            }
            onChange && onChange(e, descriptor, newValue);
        }
    }, {
        key: "onKeyDown",
        value: function onKeyDown(e) {
            var _props2 = this.props,
                descriptor = _props2.descriptor,
                onKeyDown = _props2.onKeyDown;

            onKeyDown && onKeyDown(e, descriptor, this.convertBoolToValue(e.target.checked), false);
        }
    }, {
        key: "onClick",
        value: function onClick(e) {
            var _props3 = this.props,
                descriptor = _props3.descriptor,
                onClick = _props3.onClick;

            onClick && onClick(e, descriptor, this.convertBoolToValue(e.target.checked));
        }
    }, {
        key: "onFocus",
        value: function onFocus(e) {
            var _props4 = this.props,
                descriptor = _props4.descriptor,
                onFocus = _props4.onFocus;

            onFocus && onFocus(e, descriptor, this.convertBoolToValue(e.target.checked));
        }
    }, {
        key: "onBlur",
        value: function onBlur(e) {
            var _props5 = this.props,
                descriptor = _props5.descriptor,
                onBlur = _props5.onBlur;

            var value = this.convertBoolToValue(e.target.checked);
            onBlur && onBlur(e, descriptor, value);
        }
    }, {
        key: "render",
        value: function render() {
            var _props6 = this.props,
                enabled = _props6.enabled,
                value = _props6.value;


            return _react2.default.createElement("input", {
                type: "checkbox",
                className: "focusable",
                onChange: this.onChange,
                checked: this.convertValueToBool(value),
                onClick: this.onClick,
                onFocus: this.onFocus,
                onBlur: this.onBlur,
                onKeyDown: this.onKeyDown,
                disabled: !enabled
            });
        }
    }]);

    return Checkbox;
}(_react2.default.Component);

exports.default = Checkbox;


Checkbox.propTypes = (0, _formhelpers.controlPropTypes)({
    copyOnClickMappings: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        source: _propTypes2.default.string.isRequired,
        target: _propTypes2.default.string.isRequired
    })),
    checkedValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
    uncheckedValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool])
});

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.paddedIntegerNumber = exports.MASK_FORMAT_HANDLERS = exports.MASK_FORMAT_CHAR = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _reactInputMask = __webpack_require__(908);

var _reactInputMask2 = _interopRequireDefault(_reactInputMask);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// set up the mask chars.
var MASK_FORMAT_CHAR = exports.MASK_FORMAT_CHAR = "_";
var MASK_FORMAT_HANDLERS = exports.MASK_FORMAT_HANDLERS = {
    // basic masks
    "#": { // Number
        reg: "[0-9]"
    },
    "a": { // Character
        reg: "[A-Za-z]"
    },
    "*": { // Alpha Numeric
        reg: "[A-Za-z0-9]"
    },

    // date time masks
    "M": { // Month
        reg: "[0-9]",
        validate: function validate(chunk) {
            if (chunk.length === 2) {
                chunk.value = paddedIntegerNumber(chunk.value, "01", "12", chunk.placeholder);
            }
            return chunk;
        }
    },
    "D": { // Day
        reg: "[0-9]",
        validate: function validate(chunk, chunks) {
            if (chunk.length === 2) {
                var maxDays = "31"; // default to 31 days.
                var monthChunk = chunks.find(function (c) {
                    return c.mask === "M";
                });
                // check if month mask comes before day mask
                if (monthChunk && monthChunk.index < chunk.index) {
                    // get the number of days in the month
                    switch (monthChunk.value) {
                        case "02":
                            // february, 28/29
                            maxDays = "29";
                            break;
                        case "04":case "06":case "09":case "11":
                            // may, june, september, november, 30
                            maxDays = "30";
                            break;
                        default:
                            maxDays = "31";
                    }
                }
                chunk.value = paddedIntegerNumber(chunk.value, "01", maxDays, chunk.placeholder);
            }
            return chunk;
        }
    },
    "Y": { // Year
        reg: "[0-9]",
        validate: function validate(chunk) {
            if (chunk.length === 4) {
                if (["18", "19", "20"].includes(chunk.value.substr(0, 2))) {
                    // valid centuries
                    chunk.value = paddedIntegerNumber(chunk.value, "1850", "2099", chunk.placeholder);
                } else {
                    // partial year
                    chunk.value = paddedIntegerNumber(chunk.value.substr(0, 2), "00", "99", chunk.placeholder) + chunk.placeholder + chunk.placeholder;
                }
            }
            return chunk;
        }
    },
    "H": { // 24 Hour
        reg: "[0-9]",
        validate: function validate(chunk) {
            if (chunk.length === 2) {
                chunk.value = paddedIntegerNumber(chunk.value, "00", "23", chunk.placeholder);
            }
            return chunk;
        }
    },
    "h": { // 12 Hour
        reg: "[0-9]",
        validate: function validate(chunk) {
            if (chunk.length === 2) {
                chunk.value = paddedIntegerNumber(chunk.value, "01", "12", chunk.placeholder);
            }
            return chunk;
        }
    },
    "m": { // Minute
        reg: "[0-9]",
        validate: function validate(chunk) {
            if (chunk.length === 2) {
                chunk.value = paddedIntegerNumber(chunk.value, "00", "59", chunk.placeholder);
            }
            return chunk;
        }
    },
    "s": { // Second
        reg: "[0-9]",
        validate: function validate(chunk) {
            if (chunk.length === 2) {
                chunk.value = paddedIntegerNumber(chunk.value, "00", "59", chunk.placeholder);
            }
            return chunk;
        }
    }
};

var MASK_FORMAT_CHARS = {};
var MASK_FORMAT_KEYS = Object.keys(MASK_FORMAT_HANDLERS);
MASK_FORMAT_KEYS.forEach(function (v) {
    return MASK_FORMAT_CHARS[v] = MASK_FORMAT_HANDLERS[v].reg;
});

var InputMask = function (_React$Component) {
    _inherits(InputMask, _React$Component);

    function InputMask(props) {
        _classCallCheck(this, InputMask);

        var _this = _possibleConstructorReturn(this, (InputMask.__proto__ || Object.getPrototypeOf(InputMask)).call(this, props));

        _this.inputRef = props._ref || _react2.default.createRef();

        if (props.maskFormat) {
            _this.onMouseEnter = _this.onMouseEnter.bind(_this);
            _this.onMouseLeave = _this.onMouseLeave.bind(_this);
            _this.onBlur = _this.onBlur.bind(_this);
            _this.onChange = _this.onChange.bind(_this);
            _this.onBeforeMaskedValueChange = _this.onBeforeMaskedValueChange.bind(_this);
            var maskFormat = props.maskFormat;
            if (maskFormat.mask && maskFormat.placeholder && maskFormat.mask.length !== maskFormat.placeholder.length) {
                // The placeholder characters can be different from mask but the
                // placeholder.length needs to be the same as mask.length
                // this is so we can look up the correct placeholder based caret
                // location.
                console.error("InputMask: maskFormat.placeholder and maskFormat.mask must be same length.");
            }
        }
        return _this;
    }

    _createClass(InputMask, [{
        key: "onMouseEnter",
        value: function onMouseEnter(e) {
            var _props = this.props,
                onMouseEnter = _props.onMouseEnter,
                maskFormat = _props.maskFormat,
                disabled = _props.disabled;

            !disabled && maskFormat && maskFormat.placeholder && this.inputRef.current.setAttribute("placeholder", maskFormat.placeholder);
            onMouseEnter && onMouseEnter(e);
        }
    }, {
        key: "onMouseLeave",
        value: function onMouseLeave(e) {
            var _props2 = this.props,
                onMouseLeave = _props2.onMouseLeave,
                maskFormat = _props2.maskFormat;

            maskFormat && this.inputRef.current.setAttribute("placeholder", this.props.placeholder);
            onMouseLeave && onMouseLeave(e);
        }
    }, {
        key: "onBlur",
        value: function onBlur(e) {
            var onBlur = this.props.onBlur;

            onBlur && onBlur(e);
        }
    }, {
        key: "onChange",
        value: function onChange(e) {
            var onChange = this.props.onChange;

            onChange && onChange(e);
        }
    }, {
        key: "replaceMaskWithLetter",
        value: function replaceMaskWithLetter() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
            var letter = arguments[1];

            return value.replace(new RegExp("[_" + letter + "]", "g"), letter);
        }
    }, {
        key: "fillInMaskWithPlaceholderLetters",
        value: function fillInMaskWithPlaceholderLetters(value) {
            var _this2 = this;

            var maskFormat = this.props.maskFormat;

            if (!value) return "";
            // make chunks
            var chunks = [];
            var chunkValue = "";
            var chunkLength = 0;
            value.split("").forEach(function (c, index) {
                var m = maskFormat.mask.charAt(index);
                if (!MASK_FORMAT_KEYS.includes(m) || index === maskFormat.mask.length - 1) {
                    if (index === maskFormat.mask.length - 1) {
                        chunkLength++;
                        chunkValue += c;
                    }
                    chunks.push({
                        index: chunks.length,
                        length: chunkLength,
                        value: chunkValue,
                        placeholder: maskFormat.placeholder ? maskFormat.placeholder.charAt(index - 1) || MASK_FORMAT_CHAR : MASK_FORMAT_CHAR,
                        mask: maskFormat.mask.charAt(index - 1),
                        join: index === maskFormat.mask.length - 1 ? "" : m
                    });
                    chunkValue = "";
                    chunkLength = 0;
                } else {
                    chunkLength++;
                    chunkValue += c;
                }
            });
            // put chunks back together and run format function if defined.
            return chunks.map(function (chunk) {
                if (MASK_FORMAT_HANDLERS[chunk.mask] && typeof MASK_FORMAT_HANDLERS[chunk.mask].validate === "function") {
                    chunk = MASK_FORMAT_HANDLERS[chunk.mask].validate(chunk, chunks, value);
                }
                return _this2.replaceMaskWithLetter(chunk.value, chunk.placeholder) + chunk.join;
            }).join("");
        }
    }, {
        key: "findFirstPlaceholderIndex",
        value: function findFirstPlaceholderIndex(value) {
            var maskFormat = this.props.maskFormat;

            for (var index = 0; index < value.length; index++) {
                var c = value.charAt(index);
                if (c === MASK_FORMAT_CHAR) {
                    return index;
                }
                if (maskFormat.placeholder && c === maskFormat.placeholder.charAt(index)) {
                    if (MASK_FORMAT_KEYS.includes(maskFormat.mask.charAt(index))) {
                        return index;
                    }
                }
            }
            return null;
        }
    }, {
        key: "onBeforeMaskedValueChange",
        value: function onBeforeMaskedValueChange(maskState) {
            var maskFormat = this.props.maskFormat;

            var newMaskState = {
                value: this.fillInMaskWithPlaceholderLetters(maskState.value),
                selection: maskState.selection ? _extends({}, maskState.selection) : null
            };

            var index = this.findFirstPlaceholderIndex(newMaskState.value) || newMaskState.value.length - 1;
            if (newMaskState.selection && index !== newMaskState.value.length - 1) {
                // reset placeholder values after first found placeholder character.
                // Replaces 01/0d/2000 with 01/0d/yyyy
                // This only happens when user copy & pasts a improperly formatted
                // string or hits backspace in the middle of the input mask.
                newMaskState.value = newMaskState.value.substr(0, index) + maskFormat.placeholder.substr(index);
                // update the cursor position
                newMaskState.selection = {
                    start: index,
                    end: index
                };
            }
            return newMaskState;
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            var _props3 = this.props,
                maskFormat = _props3.maskFormat,
                placeholder = _props3.placeholder,
                value = _props3.value;

            var cleanProps = _extends({}, this.props);
            delete cleanProps._ref;
            delete cleanProps.inputRef;
            delete cleanProps.maskFormat;
            delete cleanProps.maxLength;
            if (!maskFormat) {
                // nothing needs to be overloaded. Pass through all props to the input and be done.
                return _react2.default.createElement("input", _extends({}, cleanProps, {
                    ref: this.inputRef
                }));
            }
            // wire up all the maskFormat event wrappers.
            return _react2.default.createElement(_reactInputMask2.default, _extends({}, cleanProps, {
                type: "input",
                inputRef: function inputRef(ref) {
                    return _this3.inputRef.current = ref;
                },
                mask: maskFormat.mask,
                maskChar: MASK_FORMAT_CHAR,
                formatChars: MASK_FORMAT_CHARS,
                alwaysShowMask: false,
                beforeMaskedValueChange: this.onBeforeMaskedValueChange,
                onChange: this.onChange,
                onBlur: this.onBlur,
                onMouseEnter: this.onMouseEnter,
                onMouseLeave: this.onMouseLeave,
                value: value,
                placeholder: placeholder
            }));
        }
    }]);

    return InputMask;
}(_react2.default.Component);

exports.default = InputMask;


InputMask.propTypes = {
    maskFormat: _propTypes.PropTypes.shape({
        mask: _propTypes.PropTypes.string.isRequired,
        placeholder: _propTypes.PropTypes.string,
        momentjs: _propTypes.PropTypes.string
    }),
    value: _propTypes.PropTypes.string
};

// format helper functions
var paddedIntegerNumber = exports.paddedIntegerNumber = function paddedIntegerNumber(value, min, max) {
    var placeholder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : MASK_FORMAT_CHAR;

    if (value.indexOf(placeholder) === 0) {
        // nothing typed
        return value;
    }
    // split numbers into arrays with padding
    var minInts = min.split("").map(function (c) {
        return parseInt(c, 10);
    });
    var maxInts = max.split("").map(function (c) {
        return parseInt(c, 10);
    });
    var valueInts = value.split("").map(function (c) {
        return parseInt(c, 10);
    });
    var valueChars = value.split("");

    if (max.length === 2 && valueInts[0] > maxInts[0]) {
        // add leading zero
        valueInts[1] = valueInts[0];
        valueInts[0] = 0;
    }

    // prevent input if the provided value is going to be greater or less then
    // min and max.
    var checkMax = true;
    var checkMin = true;
    var clearRemaining = false;
    valueInts = valueInts.map(function (v, index) {
        if (isNaN(v) || clearRemaining) {
            return NaN;
        }
        if (checkMax && v > maxInts[index]) {
            clearRemaining = true;
            return NaN; // the current index value is out of range set to NaN
        }
        if (checkMin && v < minInts[index]) {
            clearRemaining = true;
            return NaN; // the current index value is out of range set to NaN
        }
        checkMax = v === maxInts[index];
        checkMin = v === minInts[index];
        return v;
    });
    // put it back together
    return valueChars.map(function (c, i) {
        return !isNaN(valueInts[i]) ? valueInts[i].toString() : placeholder;
    }).join("");
};

/***/ }),
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.actionGroupInConsole = exports.logActionToConsole = exports.actionsBlacklist = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ContextedReduceStore = __webpack_require__(30);

var actionsBlacklist = exports.actionsBlacklist = ["global-define/", "global-load/", "over/", "development/"];

var actionToConsoleBuilder = function actionToConsoleBuilder(handler) {
    return function (action) {
        for (var _len = arguments.length, extraArgs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            extraArgs[_key - 1] = arguments[_key];
        }

        // primitive string or typedAction
        var actionName = action.type.toString();
        if (actionsBlacklist.some(function (it) {
            return actionName.indexOf(it) >= 0;
        })) {
            return false; // blacklisted...
        }
        var args = ["FLUX>", actionName];
        // so we can delete top-level key(s)
        action = _extends({}, action);
        delete action.type;
        if (action.hasOwnProperty(_ContextedReduceStore.ACTION_CONTEXT_KEY)) {
            args.push(action[_ContextedReduceStore.ACTION_CONTEXT_KEY]);
            delete action[_ContextedReduceStore.ACTION_CONTEXT_KEY];
        }
        args.push(action);
        args.push.apply(args, extraArgs);
        console[handler].apply(undefined, args);
        return true;
    };
};

var logActionToConsole = exports.logActionToConsole = actionToConsoleBuilder("log");
var actionGroupInConsole = exports.actionGroupInConsole = actionToConsoleBuilder("group");

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _FileField = __webpack_require__(466);

var _FileField2 = _interopRequireDefault(_FileField);

var _manager = __webpack_require__(297);

var _manager2 = _interopRequireDefault(_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Label = function (_React$Component) {
    _inherits(Label, _React$Component);

    function Label() {
        _classCallCheck(this, Label);

        return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
    }

    _createClass(Label, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                _ControlTemplate2.default,
                _extends({}, this.props, { className: "file-field" }),
                _react2.default.createElement(_FileField2.default, _extends({}, this.props, { readOnly: true }))
            );
        }
    }]);

    return Label;
}(_react2.default.Component);

exports.default = Label;


Label.propTypes = _manager2.default.propTypes;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _filesize = __webpack_require__(405);

var _filesize2 = _interopRequireDefault(_filesize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FileFieldRow = function (_React$Component) {
    _inherits(FileFieldRow, _React$Component);

    function FileFieldRow(props) {
        _classCallCheck(this, FileFieldRow);

        var _this = _possibleConstructorReturn(this, (FileFieldRow.__proto__ || Object.getPrototypeOf(FileFieldRow)).call(this, props));

        _this.onFileOpen = _this.onFileOpen.bind(_this);
        _this.onFileRemove = _this.onFileRemove.bind(_this);
        return _this;
    }

    _createClass(FileFieldRow, [{
        key: "onFileOpen",
        value: function onFileOpen(e) {
            var _props = this.props,
                onFileOpen = _props.onFileOpen,
                file = _props.file,
                index = _props.index;

            onFileOpen && onFileOpen(e, file, index);
        }
    }, {
        key: "onFileRemove",
        value: function onFileRemove(e) {
            var _props2 = this.props,
                onFileRemove = _props2.onFileRemove,
                file = _props2.file,
                index = _props2.index;

            onFileRemove && onFileRemove(e, file, index);
        }
    }, {
        key: "humanReadableFileSize",
        value: function humanReadableFileSize(bytes) {
            return (0, _filesize2.default)(bytes);
        }
    }, {
        key: "render",
        value: function render() {
            var _props3 = this.props,
                file = _props3.file,
                readOnly = _props3.readOnly;

            var showProgress = file.status !== Hybrid.FileInfo.FILEUPLOADSTATES.COMPLETE;
            var isError = file.status === Hybrid.FileInfo.FILEUPLOADSTATES.ERROR;
            var style = isError ? { color: "red" } : {};
            var unique = file.id;
            return _react2.default.createElement(
                "div",
                { id: "fileRow_" + unique, className: "row fileRow", style: style },
                _react2.default.createElement(
                    "div",
                    { className: "col-md-" + (showProgress ? 6 : 10) + " filename" },
                    _react2.default.createElement(
                        "a",
                        { id: "fileLink_" + unique, href: "#", className: "file-link", style: style, onClick: this.onFileOpen },
                        file.filename
                    ),
                    " (",
                    _react2.default.createElement(
                        "span",
                        { className: "file-size" },
                        this.humanReadableFileSize(file.filesize)
                    ),
                    ")",
                    isError && _react2.default.createElement(
                        "div",
                        null,
                        _react2.default.createElement(
                            "small",
                            null,
                            "The upload encountered a problem."
                        )
                    )
                ),
                showProgress && _react2.default.createElement(
                    "div",
                    { className: "col-md-4" },
                    _react2.default.createElement(
                        "div",
                        { className: "progress" },
                        _react2.default.createElement(
                            "div",
                            { className: "progress-bar", role: "progressbar", "aria-valuenow": file.progress, "aria-valuemin": "0", "aria-valuemax": "100", style: { width: file.progress + "%" } },
                            file.progress,
                            "%"
                        )
                    )
                ),
                !readOnly && _react2.default.createElement(
                    "div",
                    { className: "col-md-2 text-right" },
                    _react2.default.createElement(
                        "a",
                        { id: "fileOpen_" + unique, href: "#", className: "file-open", onClick: this.onFileOpen },
                        _react2.default.createElement("span", { className: "glyphicon glyphicon-new-window" })
                    ),
                    " ",
                    _react2.default.createElement(
                        "a",
                        { id: "fileRemove_" + unique, href: "#", className: "file-remove", onClick: this.onFileRemove },
                        _react2.default.createElement("span", { className: "glyphicon glyphicon-remove-circle" })
                    )
                )
            );
        }
    }]);

    return FileFieldRow;
}(_react2.default.Component);

exports.default = FileFieldRow;
;

FileFieldRow.propTypes = {
    onFileOpen: _propTypes2.default.func,
    onFileRemove: _propTypes2.default.func,
    file: _propTypes2.default.shape({
        id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
        filename: _propTypes2.default.string.isRequired,
        progress: _propTypes2.default.number.isRequired,
        filesize: _propTypes2.default.number.isRequired,
        status: _propTypes2.default.string.isRequired //Hybrid.FileInfo.FILEUPLOADSTATES
    }),
    index: _propTypes2.default.number.isRequired,
    readOnly: _propTypes2.default.bool
};

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _form = __webpack_require__(107);

var _form2 = _interopRequireDefault(_form);

var _formhelpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Column = function (_React$Component) {
    _inherits(Column, _React$Component);

    function Column() {
        _classCallCheck(this, Column);

        return _possibleConstructorReturn(this, (Column.__proto__ || Object.getPrototypeOf(Column)).apply(this, arguments));
    }

    _createClass(Column, [{
        key: "render",
        value: function render() {
            var descriptor = this.props.descriptor;

            var selector = "control-container-" + descriptor.key;
            return _react2.default.createElement(
                "div",
                {
                    id: descriptor.id,
                    className: selector + " control-layout-column"
                },
                _react2.default.createElement(_form2.default, this.props)
            );
        }
    }]);

    return Column;
}(_react2.default.Component);

Column.defaultProps = {
    descriptor: {},
    controlOnly: true,
    placeholder: true
};

Column.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)(null, false, true), {
    propsResolver: _propTypes2.default.func.isRequired,
    onCommitChange: _propTypes2.default.func // not required
});

exports.default = Column;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _form = __webpack_require__(107);

var _form2 = _interopRequireDefault(_form);

var _formhelpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Columnset = function (_React$Component) {
    _inherits(Columnset, _React$Component);

    function Columnset() {
        _classCallCheck(this, Columnset);

        return _possibleConstructorReturn(this, (Columnset.__proto__ || Object.getPrototypeOf(Columnset)).apply(this, arguments));
    }

    _createClass(Columnset, [{
        key: "render",
        value: function render() {
            var descriptor = this.props.descriptor;

            var selector = "control-container-" + descriptor.key;
            return _react2.default.createElement(
                "div",
                {
                    id: descriptor.id,
                    className: selector + " control-layout-columnset"
                },
                _react2.default.createElement(_form2.default, this.props)
            );
        }
    }]);

    return Columnset;
}(_react2.default.Component);

Columnset.defaultProps = {
    descriptor: {},
    controlOnly: true,
    placeholder: true
};

Columnset.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)(null, false, true), {
    propsResolver: _propTypes2.default.func.isRequired,
    onCommitChange: _propTypes2.default.func // not required
});

exports.default = Columnset;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _form = __webpack_require__(107);

var _form2 = _interopRequireDefault(_form);

var _formhelpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Grid = function (_React$Component) {
    _inherits(Grid, _React$Component);

    function Grid() {
        _classCallCheck(this, Grid);

        return _possibleConstructorReturn(this, (Grid.__proto__ || Object.getPrototypeOf(Grid)).apply(this, arguments));
    }

    _createClass(Grid, [{
        key: "render",
        value: function render() {
            var descriptor = this.props.descriptor;

            var config = descriptor.config || {};
            var selector = "control-container-" + descriptor.key;
            var summaryClass = config.style === "summary" ? " control-layout-grid-summary" : "";
            return _react2.default.createElement(
                "table",
                {
                    id: descriptor.id,
                    className: "control-layout-grid" + summaryClass
                },
                _react2.default.createElement(
                    "tbody",
                    { className: selector },
                    _react2.default.createElement(_form2.default, this.props)
                )
            );
        }
    }]);

    return Grid;
}(_react2.default.Component);

Grid.defaultProps = {
    descriptor: {},
    controlOnly: true,
    placeholder: true
};

Grid.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)({
    style: _propTypes2.default.oneOf(["summary"])
}, false, true), {
    propsResolver: _propTypes2.default.func.isRequired,
    onCommitChange: _propTypes2.default.func // not required
});

exports.default = Grid;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _form = __webpack_require__(107);

var _form2 = _interopRequireDefault(_form);

var _formhelpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GridRow = function (_React$Component) {
    _inherits(GridRow, _React$Component);

    function GridRow() {
        _classCallCheck(this, GridRow);

        return _possibleConstructorReturn(this, (GridRow.__proto__ || Object.getPrototypeOf(GridRow)).apply(this, arguments));
    }

    _createClass(GridRow, [{
        key: "render",
        value: function render() {
            var descriptor = this.props.descriptor;

            var selector = "control-container-" + descriptor.key;
            return _react2.default.createElement(
                "tr",
                {
                    id: descriptor.id,
                    className: selector + " control-layout-gridrow"
                },
                _react2.default.createElement(_form2.default, this.props)
            );
        }
    }]);

    return GridRow;
}(_react2.default.Component);

GridRow.defaultProps = {
    descriptor: {},
    controlOnly: true,
    placeholder: true
};

GridRow.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)(null, false, true), {
    propsResolver: _propTypes2.default.func.isRequired,
    onCommitChange: _propTypes2.default.func // not required
});

exports.default = GridRow;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _form = __webpack_require__(107);

var _form2 = _interopRequireDefault(_form);

var _formhelpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GridCell = function (_React$Component) {
    _inherits(GridCell, _React$Component);

    function GridCell() {
        _classCallCheck(this, GridCell);

        return _possibleConstructorReturn(this, (GridCell.__proto__ || Object.getPrototypeOf(GridCell)).apply(this, arguments));
    }

    _createClass(GridCell, [{
        key: "render",
        value: function render() {
            var descriptor = this.props.descriptor;

            var config = descriptor.config || {};
            var selector = "control-container-" + descriptor.key;

            var className = [selector, "control-layout-gridcell"];
            if (config.controlOnly) {
                className.push("control-only");
            }
            switch (config.align) {
                case "right":
                    className.push("text-right");
                    break;
                case "center":
                    className.push("text-center");
                    break;
                case "left":
                default:
                    className.push("text-left");
            }

            var CellType = config.heading ? _react2.default.createElement("th", null) : _react2.default.createElement("td", null);

            return _react2.default.createElement(
                CellType,
                {
                    id: descriptor.id,
                    className: className,
                    width: config.width,
                    colSpan: config.colSpan
                },
                _react2.default.createElement(_form2.default, _extends({}, this.props, { controlOnly: config.controlOnly }))
            );
        }
    }]);

    return GridCell;
}(_react2.default.Component);

GridCell.defaultProps = {
    descriptor: {
        config: {
            controlOnly: true,
            heading: false,
            align: "left"
        }
    },
    controlOnly: true,
    placeholder: true
};

GridCell.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)({
    controlOnly: _propTypes2.default.bool,
    heading: _propTypes2.default.bool,
    align: _propTypes2.default.oneOf(["left", "right", "center"]),
    width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    colSpan: _propTypes2.default.number
}, false, false), {
    propsResolver: _propTypes2.default.func.isRequired,
    onCommitChange: _propTypes2.default.func // not required
});

exports.default = GridCell;

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ControlResolver = __webpack_require__(139);

var _ControlResolver2 = _interopRequireDefault(_ControlResolver);

var _formhelpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Row = function (_React$Component) {
    _inherits(Row, _React$Component);

    function Row() {
        _classCallCheck(this, Row);

        return _possibleConstructorReturn(this, (Row.__proto__ || Object.getPrototypeOf(Row)).apply(this, arguments));
    }

    _createClass(Row, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                descriptor = _props.descriptor,
                propsResolver = _props.propsResolver,
                controlOnly = _props.controlOnly;

            var kids = descriptor.childItems;
            var last = kids.length > 0 && kids[kids.length - 1];
            var colsPerKid = void 0,
                colsForLastKid = void 0;
            if (last && last.type === "checkbox" && /missing$/.test(last.key)) {
                // reserve four-ish for the missing checkbox; distribute the rest
                colsPerKid = Math.round(8 / (kids.length - 1));
                colsForLastKid = 12 - colsPerKid * (kids.length - 1);
            } else {
                // distributed evenly, protecting from divide-by-zero
                colsPerKid = 12 / (kids.length > 0 ? kids.length : 1);
                colsForLastKid = colsPerKid;
            }
            var Control = _react2.default.createElement(
                "div",
                { className: "row range-field" },
                kids.map(function (itemDescriptor) {
                    var columnClass = "col-md-" + (itemDescriptor === last ? colsForLastKid : colsPerKid);
                    var controlProps = _extends({}, _this2.props, {
                        propsResolver: propsResolver,
                        descriptor: itemDescriptor }, propsResolver(itemDescriptor));
                    var Control = (0, _ControlResolver2.default)(controlProps.descriptor);
                    return _react2.default.createElement(
                        "div",
                        { className: columnClass, key: controlProps.descriptor.key },
                        _react2.default.createElement(Control, _extends({}, controlProps, { controlOnly: true }))
                    );
                })
            );

            if (controlOnly) {
                return Control;
            }

            return _react2.default.createElement(
                "div",
                { className: "form-item" },
                _react2.default.createElement(
                    "div",
                    { className: "left-side" },
                    _react2.default.createElement(
                        "label",
                        null,
                        descriptor.label
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "right-side" },
                    Control
                )
            );
        }
    }]);

    return Row;
}(_react2.default.Component);

Row.defaultProps = {
    descriptor: {},
    controlOnly: true,
    placeholder: true
};

Row.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)(null, false, true), {
    propsResolver: _propTypes2.default.func.isRequired,
    onCommitChange: _propTypes2.default.func // not required
});

exports.default = Row;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _form = __webpack_require__(107);

var _form2 = _interopRequireDefault(_form);

var _formhelpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Section = function (_React$Component) {
    _inherits(Section, _React$Component);

    function Section() {
        _classCallCheck(this, Section);

        return _possibleConstructorReturn(this, (Section.__proto__ || Object.getPrototypeOf(Section)).apply(this, arguments));
    }

    _createClass(Section, [{
        key: "render",
        value: function render() {
            var descriptor = this.props.descriptor;

            var selector = "control-container-" + descriptor.key;
            return _react2.default.createElement(
                "fieldset",
                null,
                _react2.default.createElement(
                    "div",
                    {
                        id: descriptor.id,
                        className: selector + " control-section-header",
                        "data-title": descriptor.label
                    },
                    _react2.default.createElement(
                        "span",
                        {
                            className: "uic-sh-message-title" },
                        descriptor.label
                    ),
                    _react2.default.createElement("span", { className: "uic-sh-message-subtitle" })
                ),
                _react2.default.createElement(_form2.default, this.props)
            );
        }
    }]);

    return Section;
}(_react2.default.Component);

Section.defaultProps = {
    descriptor: {},
    controlOnly: true,
    placeholder: true
};

Section.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)(null, false, true), {
    propsResolver: _propTypes2.default.func.isRequired,
    onCommitChange: _propTypes2.default.func // not required
});

exports.default = Section;

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _formhelpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Textarea = function (_React$Component) {
    _inherits(Textarea, _React$Component);

    function Textarea(props) {
        _classCallCheck(this, Textarea);

        var _this = _possibleConstructorReturn(this, (Textarea.__proto__ || Object.getPrototypeOf(Textarea)).call(this, props));

        _this.inputRef = props._ref || _react2.default.createRef();
        /* Some controls will require a local state so editing can take place
         * before the final value is actually committed.
         */
        _this.state = {
            value: _this.convertValueToString(props.value)
        };
        _this.hasChanges = false; // this is used so onBlur only commits when changes have been made.
        _this.hasFocus = false; // only commit change when control has focus.
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onClick = _this.onClick.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        return _this;
    }

    _createClass(Textarea, [{
        key: "convertStringToValue",
        value: function convertStringToValue(value) {
            if (value === "") {
                return null;
            }
            return value;
        }
    }, {
        key: "convertValueToString",
        value: function convertValueToString(value) {
            if (value === undefined || value === null) {
                return "";
            }
            return value;
        }
    }, {
        key: "onKeyDown",
        value: function onKeyDown(e) {
            var _props = this.props,
                descriptor = _props.descriptor,
                onKeyDown = _props.onKeyDown;

            var newValue = this.convertStringToValue(e.target.value);
            onKeyDown && onKeyDown(e, descriptor, newValue);
        }
    }, {
        key: "onClick",
        value: function onClick(e) {
            var _props2 = this.props,
                descriptor = _props2.descriptor,
                onClick = _props2.onClick;

            onClick && onClick(e, descriptor, this.convertStringToValue(e.target.value));
        }
    }, {
        key: "onFocus",
        value: function onFocus(e) {
            var _props3 = this.props,
                descriptor = _props3.descriptor,
                onFocus = _props3.onFocus;

            onFocus && onFocus(e, descriptor, this.convertStringToValue(e.target.value));
            this.hasFocus = true;
        }
    }, {
        key: "onBlur",
        value: function onBlur(e) {
            var _props4 = this.props,
                descriptor = _props4.descriptor,
                onBlur = _props4.onBlur,
                value = _props4.value,
                enabled = _props4.enabled,
                onCommitChange = _props4.onCommitChange;

            if (!this.hasFocus) {
                // control does not have focus.
                return;
            }
            var newValue = this.convertStringToValue(e.target.value);
            if (newValue !== value) {
                // commit the value change
                enabled && onCommitChange(descriptor, newValue);
            }
            this.hasChanges = false;
            enabled && onBlur && onBlur(e, descriptor, newValue);
            this.hasFocus = false;
        }
    }, {
        key: "UNSAFE_componentWillReceiveProps",
        value: function UNSAFE_componentWillReceiveProps(newProps) {
            // if the control has focus and has changes then don't change the local state.
            // the user is most editing a while records are updating in the background.
            if (this.hasChanges && this.hasFocus) return;

            /* Make sure the local state stays in sync with the passed in props.
             */
            var nextValue = this.convertValueToString(newProps.value);
            if (this.state.value !== nextValue || this.inputRef.current.value !== nextValue) {
                this.setState({ value: nextValue });
                this.hasChanges = false;
            }
        }
    }, {
        key: "onChange",
        value: function onChange(e) {
            var _props5 = this.props,
                descriptor = _props5.descriptor,
                onChange = _props5.onChange;

            var value = this.convertStringToValue(e.target.value);
            this.setState({ value: this.convertValueToString(value) });
            this.hasChanges = true;
            onChange && onChange(e, descriptor, value);
        }
    }, {
        key: "render",
        value: function render() {
            var _props6 = this.props,
                className = _props6.className,
                descriptor = _props6.descriptor,
                placeholder = _props6.placeholder,
                enabled = _props6.enabled,
                style = _props6.style;


            var value = this.state.value || "";
            var classname = (className || "form-control") + " focusable";

            return _react2.default.createElement("textarea", {
                ref: this.inputRef,
                className: classname,
                onClick: this.onClick,
                onChange: this.onChange,
                onFocus: this.onFocus,
                onBlur: this.onBlur,
                onKeyDown: this.onKeyDown,
                value: value,
                placeholder: placeholder ? descriptor.label : "",
                disabled: !enabled,
                style: style
            });
        }
    }]);

    return Textarea;
}(_react2.default.Component);

exports.default = Textarea;


Textarea.propTypes = (0, _formhelpers.controlPropTypes)();

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _formhelpers = __webpack_require__(5);

var _Button = __webpack_require__(52);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ValueMutationButton = function (_React$Component) {
    _inherits(ValueMutationButton, _React$Component);

    function ValueMutationButton() {
        _classCallCheck(this, ValueMutationButton);

        return _possibleConstructorReturn(this, (ValueMutationButton.__proto__ || Object.getPrototypeOf(ValueMutationButton)).apply(this, arguments));
    }

    _createClass(ValueMutationButton, [{
        key: "render",
        value: function render() {
            var descriptor = this.props.descriptor;

            return _react2.default.createElement(
                _ControlTemplate2.default,
                _extends({}, this.props, {
                    descriptor: _extends({}, descriptor, { label: "" }),
                    className: "",
                    extraProps: {
                        "data-widget-label": descriptor.label
                    }
                }),
                _react2.default.createElement(_Button2.default, _extends({
                    label: descriptor.label,
                    value: descriptor.label
                }, this.props))
            );
        }
    }]);

    return ValueMutationButton;
}(_react2.default.Component);

exports.default = ValueMutationButton;


ValueMutationButton.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)({
    collectionFieldName: _propTypes2.default.string.isRequired,
    newValue: _propTypes2.default.string.isRequired
}, false), {
    onCommitChange: _propTypes2.default.func
});

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _QuarterYearSelect = __webpack_require__(81);

var _QuarterYearSelect2 = _interopRequireDefault(_QuarterYearSelect);

var _useKeyValueState3 = __webpack_require__(38);

var _useKeyValueState4 = _interopRequireDefault(_useKeyValueState3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormView = function FormView(_ref) {
    var _onChange = _ref.onChange,
        state = _ref.state,
        data = _ref.data;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Participant ID"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "particid",
                            className: "participant form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("particid", v);
                            },
                            value: state.particid,
                            options: data.particid,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Quarter"
                ),
                _react2.default.createElement(_QuarterYearSelect2.default, {
                    quarter: state.quarter,
                    year: state.year,
                    min: data.daterange.from,
                    max: data.daterange.to,
                    onChange: _onChange,
                    disabled: !state.particid,
                    required: true
                }),
                _react2.default.createElement(
                    "div",
                    { className: "ncdr-attention after-form-group" },
                    "Attention: The NCDR will not accept harvest files prior to Q1/2019."
                ),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Submission Type"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "submissionType",
                            className: "submissionType form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("submissionType", v);
                            },
                            value: state.submissionType,
                            options: data.submissionType,
                            disabled: !state.particid
                        })
                    )
                )
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Export Options"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "checkbox" },
                    _react2.default.createElement(
                        "label",
                        null,
                        _react2.default.createElement("input", {
                            type: "checkbox",
                            className: "exclude_ncdr_patient_identifiers",
                            onChange: function onChange(e) {
                                return _onChange("excludePatientIdentifiers", e.target.checked ? "true" : "false");
                            },
                            checked: state.excludePatientIdentifiers === "true"
                        }),
                        "Exclude NCDR Patient Identifiers"
                    )
                )
            )
        )
    );
};

var selectShape = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
}));

FormView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    state: _propTypes2.default.shape({
        start: _propTypes2.default.string,
        end: _propTypes2.default.string,
        submissionType: _propTypes2.default.string,
        excludePatientIdentifiers: _propTypes2.default.string,
        particid: _propTypes2.default.string
    }),
    data: _propTypes2.default.shape({
        particid: selectShape,
        quarter: _propTypes2.default.string,
        year: _propTypes2.default.string,
        submissionType: _propTypes2.default.array
    })
};

var asString = function asString(v) {
    return v == null ? "" : v.toString();
};

var initialStateWithDefaults = function initialStateWithDefaults() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        quarter: asString(state.quarter),
        year: asString(state.year),
        particid: asString(state.particid),
        submissionType: asString(state.submissionType),
        excludePatientIdentifiers: asString(state.excludePatientIdentifiers) || "false"
    };
};

var initialData = {
    particid: [],
    daterange: { from: [], to: [] },
    submissionType: [{ value: "", label: "" }, { value: "1", label: "Episode of Care Records" }, { value: "2", label: "Follow-Up Records" }, { value: "3", label: "Auxiliary Data Collection" }]
};

var AccActionExportForm = function AccActionExportForm(_ref2) {
    var initialState = _ref2.initialState,
        needServerData = _ref2.needServerData,
        onReady = _ref2.onReady,
        onNotReady = _ref2.onNotReady;

    var _React$useState = _react2.default.useState(function () {
        return initialStateWithDefaults(initialState);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(initialStateWithDefaults(initialState));
    }, [initialState]);

    var _useKeyValueState = (0, _useKeyValueState4.default)(initialData),
        _useKeyValueState2 = _slicedToArray(_useKeyValueState, 2),
        data = _useKeyValueState2[0],
        setDataKey = _useKeyValueState2[1];

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/participants",
            loadingMessage: "Loading Participants...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.particid + ": " + it.hospname,
                        value: it.particid
                    };
                });
                data.unshift({ label: "", value: "" });
                setDataKey("particid", data);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var particid = state.particid;

        if (!particid) return;
        needServerData({
            endpoint: "/date-range",
            loadingMessage: "Loading Available Date Range...",
            params: {
                particid: particid
            },
            onData: function onData(data) {
                return setDataKey("daterange", { from: data.from, to: data.to });
            }
        });
    }, [state.particid]);

    _react2.default.useEffect(function () {
        if (state.quarter && state.year && state.particid) {
            onReady(_extends({}, state));
        } else {
            onNotReady();
        }
    }, [state]);

    var handleChange = _react2.default.useCallback(function (key, value) {
        return setState(function (s) {
            return _extends({}, s, _defineProperty({}, key, value));
        });
    }, [setState]);

    return _react2.default.createElement(FormView, {
        state: state,
        data: data,
        onChange: handleChange
    });
};

AccActionExportForm.propTypes = {
    initialState: _propTypes2.default.shape({
        quarter: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        year: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        particid: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        submissionType: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        excludePatientIdentifiers: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string])
    }),
    needServerData: _propTypes2.default.func.isRequired,
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

AccActionExportForm.canRerun = function (params) {
    return !!(params && params.particid);
};

AccActionExportForm.apiPrefix = "action";

exports.default = AccActionExportForm;

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _QuarterYearSelect = __webpack_require__(81);

var _QuarterYearSelect2 = _interopRequireDefault(_QuarterYearSelect);

var _useKeyValueState3 = __webpack_require__(38);

var _useKeyValueState4 = _interopRequireDefault(_useKeyValueState3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormView = function FormView(_ref) {
    var _onChange = _ref.onChange,
        state = _ref.state,
        data = _ref.data;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Participant ID"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "particid",
                            className: "participant form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("particid", v);
                            },
                            value: state.particid,
                            options: data.particid,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Quarter"
                ),
                _react2.default.createElement(_QuarterYearSelect2.default, {
                    quarter: state.quarter,
                    year: state.year,
                    min: data.daterange.from,
                    max: data.daterange.to,
                    onChange: _onChange,
                    disabled: !state.particid,
                    required: true
                })
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Export Options"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "checkbox" },
                    _react2.default.createElement(
                        "label",
                        null,
                        _react2.default.createElement("input", {
                            type: "checkbox",
                            className: "exclude_ncdr_patient_identifiers",
                            onChange: function onChange(e) {
                                return _onChange("excludePatientIdentifiers", e.target.checked ? "true" : "false");
                            },
                            checked: state.excludePatientIdentifiers === "true"
                        }),
                        "Exclude NCDR Patient Identifiers"
                    )
                )
            )
        )
    );
};

var selectShape = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
}));

FormView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    state: _propTypes2.default.shape({
        start: _propTypes2.default.string,
        end: _propTypes2.default.string,
        excludePatientIdentifiers: _propTypes2.default.string,
        particid: _propTypes2.default.string
    }),
    data: _propTypes2.default.shape({
        particid: selectShape,
        quarter: _propTypes2.default.string,
        year: _propTypes2.default.string
    })
};

var asString = function asString(v) {
    return v == null ? "" : v.toString();
};

var initialStateWithDefaults = function initialStateWithDefaults() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        quarter: asString(state.quarter),
        year: asString(state.year),
        particid: asString(state.particid),
        excludePatientIdentifiers: asString(state.excludePatientIdentifiers) || "false"
    };
};

var initialData = {
    particid: [],
    daterange: { from: [], to: [] }
};

var AccAFibExportForm = function AccAFibExportForm(_ref2) {
    var initialState = _ref2.initialState,
        needServerData = _ref2.needServerData,
        onReady = _ref2.onReady,
        onNotReady = _ref2.onNotReady;

    var _React$useState = _react2.default.useState(function () {
        return initialStateWithDefaults(initialState);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(initialStateWithDefaults(initialState));
    }, [initialState]);

    var _useKeyValueState = (0, _useKeyValueState4.default)(initialData),
        _useKeyValueState2 = _slicedToArray(_useKeyValueState, 2),
        data = _useKeyValueState2[0],
        setDataKey = _useKeyValueState2[1];

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/participants",
            loadingMessage: "Loading Participants...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.particid + ": " + it.hospname,
                        value: it.particid
                    };
                });
                data.unshift({ label: "", value: "" });
                setDataKey("particid", data);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var particid = state.particid;

        if (!particid) return;
        needServerData({
            endpoint: "/date-range",
            loadingMessage: "Loading Available Date Range...",
            params: {
                particid: particid
            },
            onData: function onData(data) {
                return setDataKey("daterange", { from: data.from, to: data.to });
            }
        });
    }, [state.particid]);

    _react2.default.useEffect(function () {
        if (state.quarter && state.year && state.particid) {
            onReady(_extends({}, state));
        } else {
            onNotReady();
        }
    }, [state]);

    var handleChange = _react2.default.useCallback(function (key, value) {
        return setState(function (s) {
            return _extends({}, s, _defineProperty({}, key, value));
        });
    }, [setState]);

    return _react2.default.createElement(FormView, {
        state: state,
        data: data,
        onChange: handleChange
    });
};

AccAFibExportForm.propTypes = {
    initialState: _propTypes2.default.shape({
        quarter: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        year: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        particid: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        excludePatientIdentifiers: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string])
    }),
    needServerData: _propTypes2.default.func.isRequired,
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

AccAFibExportForm.canRerun = function (params) {
    return !!(params && params.particid);
};

AccAFibExportForm.apiPrefix = "afib";

exports.default = AccAFibExportForm;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _QuarterYearSelect = __webpack_require__(81);

var _QuarterYearSelect2 = _interopRequireDefault(_QuarterYearSelect);

var _useKeyValueState3 = __webpack_require__(38);

var _useKeyValueState4 = _interopRequireDefault(_useKeyValueState3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormView = function FormView(_ref) {
    var _onChange = _ref.onChange,
        state = _ref.state,
        data = _ref.data;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Participant ID"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "particid",
                            className: "participant form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("particid", v);
                            },
                            value: state.particid,
                            options: data.particid,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Quarter"
                ),
                _react2.default.createElement(_QuarterYearSelect2.default, {
                    quarter: state.quarter,
                    year: state.year,
                    min: data.daterange.from,
                    max: data.daterange.to,
                    onChange: _onChange,
                    disabled: !state.particid,
                    required: true
                }),
                _react2.default.createElement(
                    "div",
                    { className: "ncdr-attention after-form-group" },
                    "Attention: The NCDR will not accept harvest files prior to Q1/2018."
                ),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Submission Type"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "submissionType",
                            className: "submissionType form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("submissionType", v);
                            },
                            value: state.submissionType,
                            options: data.submissionType,
                            disabled: !state.particid
                        })
                    )
                )
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Export Options"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "checkbox" },
                    _react2.default.createElement(
                        "label",
                        null,
                        _react2.default.createElement("input", {
                            type: "checkbox",
                            className: "exclude_diagnostic_cath_only",
                            onChange: function onChange(e) {
                                return _onChange("excludeDiagnosticCathOnly", e.target.checked ? "true" : "false");
                            },
                            checked: state.excludeDiagnosticCathOnly === "true"
                        }),
                        "Exclude Diagnostic Cath Only Episodes"
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "checkbox" },
                    _react2.default.createElement(
                        "label",
                        null,
                        _react2.default.createElement("input", {
                            type: "checkbox",
                            className: "exclude_ncdr_patient_identifiers",
                            onChange: function onChange(e) {
                                return _onChange("excludePatientIdentifiers", e.target.checked ? "true" : "false");
                            },
                            checked: state.excludePatientIdentifiers === "true"
                        }),
                        "Exclude NCDR Patient Identifiers"
                    )
                )
            )
        )
    );
};

var selectShape = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
}));

FormView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    state: _propTypes2.default.shape({
        start: _propTypes2.default.string,
        end: _propTypes2.default.string,
        submissionType: _propTypes2.default.string,
        excludePatientIdentifiers: _propTypes2.default.string,
        excludeDiagnosticCathOnly: _propTypes2.default.string,
        particid: _propTypes2.default.string
    }),
    data: _propTypes2.default.shape({
        particid: selectShape,
        quarter: _propTypes2.default.string,
        year: _propTypes2.default.string,
        submissionType: _propTypes2.default.array
    })
};

var asString = function asString(v) {
    return v == null ? "" : v.toString();
};

var initialStateWithDefaults = function initialStateWithDefaults() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        quarter: asString(state.quarter),
        year: asString(state.year),
        particid: asString(state.particid),
        submissionType: asString(state.submissionType) || "",
        excludePatientIdentifiers: asString(state.excludePatientIdentifiers) || "false",
        excludeDiagnosticCathOnly: asString(state.excludeDiagnosticCathOnly) || "false"
    };
};

var initialData = {
    particid: [],
    daterange: { from: [], to: [] },
    submissionType: [{ value: "", label: "" }, { value: "1", label: "Episode of Care Records" }, { value: "2", label: "Follow-Up Records" }, { value: "3", label: "Auxiliary Data Collection" }]
};

var AccCathPciExportForm = function AccCathPciExportForm(_ref2) {
    var initialState = _ref2.initialState,
        needServerData = _ref2.needServerData,
        onReady = _ref2.onReady,
        onNotReady = _ref2.onNotReady;

    var _React$useState = _react2.default.useState(function () {
        return initialStateWithDefaults(initialState);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(initialStateWithDefaults(initialState));
    }, [initialState]);

    var _useKeyValueState = (0, _useKeyValueState4.default)(initialData),
        _useKeyValueState2 = _slicedToArray(_useKeyValueState, 2),
        data = _useKeyValueState2[0],
        setDataKey = _useKeyValueState2[1];

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/participants",
            loadingMessage: "Loading Participants...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.particid + ": " + it.hospname,
                        value: it.particid
                    };
                });
                data.unshift({ label: "", value: "" });
                setDataKey("particid", data);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var particid = state.particid;

        if (!particid) return;
        needServerData({
            endpoint: "/date-range",
            loadingMessage: "Loading Available Date Range...",
            params: {
                particid: particid
            },
            onData: function onData(data) {
                return setDataKey("daterange", { from: data.from, to: data.to, particid: particid });
            }
        });
    }, [state.particid]);

    _react2.default.useEffect(function () {
        if (state.quarter && state.year && state.particid) {
            onReady(_extends({}, state, {
                // for backwards compatibility
                excludeDiagnosticCathOnlyEpisodes: state.excludeDiagnosticCathOnly
            }));
        } else {
            onNotReady();
        }
    }, [state]);

    var handleChange = _react2.default.useCallback(function (key, value) {
        return setState(function (s) {
            return _extends({}, s, _defineProperty({}, key, value));
        });
    }, [setState]);

    return _react2.default.createElement(FormView, {
        state: state,
        data: data,
        onChange: handleChange
    });
};

AccCathPciExportForm.propTypes = {
    initialState: _propTypes2.default.shape({
        quarter: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        year: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        particid: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        submissionType: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        excludePatientIdentifiers: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
        excludeDiagnosticCathOnly: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string])
    }),
    needServerData: _propTypes2.default.func.isRequired,
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

AccCathPciExportForm.canRerun = function (params) {
    return !!(params && params.particid);
};

AccCathPciExportForm.apiPrefix = "cathpci";

exports.default = AccCathPciExportForm;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _QuarterYearSelect = __webpack_require__(81);

var _QuarterYearSelect2 = _interopRequireDefault(_QuarterYearSelect);

var _useKeyValueState3 = __webpack_require__(38);

var _useKeyValueState4 = _interopRequireDefault(_useKeyValueState3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormView = function FormView(_ref) {
    var _onChange = _ref.onChange,
        state = _ref.state,
        data = _ref.data;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Participant ID"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "particid",
                            className: "participant form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("particid", v);
                            },
                            value: state.particid,
                            options: data.particid,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Quarter"
                ),
                _react2.default.createElement(_QuarterYearSelect2.default, {
                    quarter: state.quarter,
                    year: state.year,
                    min: data.daterange.from,
                    max: data.daterange.to,
                    onChange: _onChange,
                    disabled: !state.particid,
                    required: true
                }),
                _react2.default.createElement(
                    "div",
                    { className: "ncdr-attention after-form-group" },
                    "Attention: The NCDR will not accept harvest files prior to Q2/2016."
                ),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Patient Population"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "patientPopulation",
                            className: "patient_population partdep form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("patientPopulation", v);
                            },
                            value: state.patientPopulation,
                            options: data.patientPopulation,
                            disabled: !state.particid
                        })
                    )
                )
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Export Options"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "checkbox" },
                    _react2.default.createElement(
                        "label",
                        null,
                        _react2.default.createElement("input", {
                            type: "checkbox",
                            className: "exclude_ncdr_patient_identifiers",
                            onChange: function onChange(e) {
                                return _onChange("excludePatientIdentifiers", e.target.checked ? "true" : "false");
                            },
                            checked: state.excludePatientIdentifiers === "true"
                        }),
                        "Exclude NCDR Patient Identifiers (does not apply to discharge dates before Q2 2016)"
                    )
                )
            )
        )
    );
};

var selectShape = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
}));

FormView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    state: _propTypes2.default.shape({
        start: _propTypes2.default.string,
        end: _propTypes2.default.string,
        patientPopulation: _propTypes2.default.string,
        excludePatientIdentifiers: _propTypes2.default.string,
        particid: _propTypes2.default.string
    }),
    data: _propTypes2.default.shape({
        particid: selectShape,
        quarter: _propTypes2.default.string,
        year: _propTypes2.default.string,
        patientPopulation: _propTypes2.default.array
    })
};

var asString = function asString(v) {
    return v == null ? "" : v.toString();
};

var initialStateWithDefaults = function initialStateWithDefaults() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        quarter: asString(state.quarter),
        year: asString(state.year),
        particid: asString(state.particid),
        patientPopulation: asString(state.patientPopulation),
        excludePatientIdentifiers: asString(state.excludePatientIdentifiers) || "false"
    };
};

var initialData = {
    particid: [],
    daterange: { from: [], to: [] },
    patientPopulation: [{ value: "", label: "" }, { value: "1", label: "All ICD Patients" }, { value: "2", label: "Medicare Primary Prevention ICD Patients" }]
};

var AccIcdExportForm = function AccIcdExportForm(_ref2) {
    var initialState = _ref2.initialState,
        needServerData = _ref2.needServerData,
        onReady = _ref2.onReady,
        onNotReady = _ref2.onNotReady;

    var _React$useState = _react2.default.useState(function () {
        return initialStateWithDefaults(initialState);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(initialStateWithDefaults(initialState));
    }, [initialState]);

    var _useKeyValueState = (0, _useKeyValueState4.default)(initialData),
        _useKeyValueState2 = _slicedToArray(_useKeyValueState, 2),
        data = _useKeyValueState2[0],
        setDataKey = _useKeyValueState2[1];

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/participants",
            loadingMessage: "Loading Participants...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.particid + ": " + it.hospname,
                        value: it.particid
                    };
                });
                data.unshift({ label: "", value: "" });
                setDataKey("particid", data);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var particid = state.particid;

        if (!particid) return;
        needServerData({
            endpoint: "/date-range",
            loadingMessage: "Loading Available Date Range...",
            params: {
                particid: particid
            },
            onData: function onData(data) {
                return setDataKey("daterange", { from: data.from, to: data.to });
            }
        });
    }, [state.particid]);

    _react2.default.useEffect(function () {
        if (state.quarter && state.year && state.particid) {
            onReady(_extends({}, state));
        } else {
            onNotReady();
        }
    }, [state]);

    var handleChange = _react2.default.useCallback(function (key, value) {
        return setState(function (s) {
            return _extends({}, s, _defineProperty({}, key, value));
        });
    }, [setState]);

    return _react2.default.createElement(FormView, {
        state: state,
        data: data,
        onChange: handleChange
    });
};

AccIcdExportForm.propTypes = {
    initialState: _propTypes2.default.shape({
        quarter: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        year: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        particid: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        patientPopulation: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        excludePatientIdentifiers: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string])
    }),
    needServerData: _propTypes2.default.func.isRequired,
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

AccIcdExportForm.canRerun = function (params) {
    return !!(params && params.particid);
};

AccIcdExportForm.apiPrefix = "icd";

exports.default = AccIcdExportForm;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _QuarterYearSelect = __webpack_require__(81);

var _QuarterYearSelect2 = _interopRequireDefault(_QuarterYearSelect);

var _useKeyValueState3 = __webpack_require__(38);

var _useKeyValueState4 = _interopRequireDefault(_useKeyValueState3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormView = function FormView(_ref) {
    var _onChange = _ref.onChange,
        state = _ref.state,
        data = _ref.data;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Participant ID"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "particid",
                            className: "participant form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("particid", v);
                            },
                            value: state.particid,
                            options: data.particid,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Quarter"
                ),
                _react2.default.createElement(_QuarterYearSelect2.default, {
                    quarter: state.quarter,
                    year: state.year,
                    min: data.daterange.from,
                    max: data.daterange.to,
                    onChange: _onChange,
                    disabled: !state.particid,
                    required: true
                }),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Submission Type"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "submissionType",
                            className: "submissionType form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("submissionType", v);
                            },
                            value: state.submissionType,
                            options: data.submissionType,
                            disabled: !state.particid
                        })
                    )
                )
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Export Options"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "checkbox" },
                    _react2.default.createElement(
                        "label",
                        null,
                        _react2.default.createElement("input", {
                            type: "checkbox",
                            className: "exclude_ncdr_patient_identifiers",
                            onChange: function onChange(e) {
                                return _onChange("excludePatientIdentifiers", e.target.checked ? "true" : "false");
                            },
                            checked: state.excludePatientIdentifiers === "true"
                        }),
                        "Exclude NCDR Patient Identifiers"
                    )
                )
            )
        )
    );
};

var selectShape = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
}));

FormView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    state: _propTypes2.default.shape({
        start: _propTypes2.default.string,
        end: _propTypes2.default.string,
        submissionType: _propTypes2.default.string,
        excludePatientIdentifiers: _propTypes2.default.string,
        particid: _propTypes2.default.string
    }),
    data: _propTypes2.default.shape({
        particid: selectShape,
        quarter: _propTypes2.default.string,
        year: _propTypes2.default.string,
        submissionType: _propTypes2.default.array
    })
};

var asString = function asString(v) {
    return v == null ? "" : v.toString();
};

var initialStateWithDefaults = function initialStateWithDefaults() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        quarter: asString(state.quarter),
        year: asString(state.year),
        particid: asString(state.particid),
        submissionType: asString(state.submissionType),
        excludePatientIdentifiers: asString(state.excludePatientIdentifiers) || "false"
    };
};

var initialData = {
    particid: [],
    daterange: { from: [], to: [] },
    submissionType: [{ value: "", label: "" }, { value: "1", label: "Episode of Care Records" }, { value: "2", label: "Follow-Up Records" }]
};

var AccImpactExportForm = function AccImpactExportForm(_ref2) {
    var initialState = _ref2.initialState,
        needServerData = _ref2.needServerData,
        onReady = _ref2.onReady,
        onNotReady = _ref2.onNotReady;

    var _React$useState = _react2.default.useState(function () {
        return initialStateWithDefaults(initialState);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(initialStateWithDefaults(initialState));
    }, [initialState]);

    var _useKeyValueState = (0, _useKeyValueState4.default)(initialData),
        _useKeyValueState2 = _slicedToArray(_useKeyValueState, 2),
        data = _useKeyValueState2[0],
        setDataKey = _useKeyValueState2[1];

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/participants",
            loadingMessage: "Loading Participants...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.particid + ": " + it.hospname,
                        value: it.particid
                    };
                });
                data.unshift({ label: "", value: "" });
                setDataKey("particid", data);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var particid = state.particid;

        if (!particid) return;
        needServerData({
            endpoint: "/date-range",
            loadingMessage: "Loading Available Date Range...",
            params: {
                particid: particid
            },
            onData: function onData(data) {
                return setDataKey("daterange", { from: data.from, to: data.to });
            }
        });
    }, [state.particid]);

    _react2.default.useEffect(function () {
        if (state.quarter && state.year && state.particid) {
            onReady(_extends({}, state));
        } else {
            onNotReady();
        }
    }, [state]);

    var handleChange = _react2.default.useCallback(function (key, value) {
        return setState(function (s) {
            return _extends({}, s, _defineProperty({}, key, value));
        });
    }, [setState]);

    return _react2.default.createElement(FormView, {
        state: state,
        data: data,
        onChange: handleChange
    });
};

AccImpactExportForm.propTypes = {
    initialState: _propTypes2.default.shape({
        quarter: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        year: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        particid: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        submissionType: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        excludePatientIdentifiers: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string])
    }),
    needServerData: _propTypes2.default.func.isRequired,
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

AccImpactExportForm.canRerun = function (params) {
    return !!(params && params.particid);
};

AccImpactExportForm.apiPrefix = "impact";

exports.default = AccImpactExportForm;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _QuarterYearSelect = __webpack_require__(81);

var _QuarterYearSelect2 = _interopRequireDefault(_QuarterYearSelect);

var _useKeyValueState3 = __webpack_require__(38);

var _useKeyValueState4 = _interopRequireDefault(_useKeyValueState3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormView = function FormView(_ref) {
    var _onChange = _ref.onChange,
        state = _ref.state,
        data = _ref.data;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Participant ID"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "particid",
                            className: "participant form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("particid", v);
                            },
                            value: state.particid,
                            options: data.particid,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Quarter"
                ),
                _react2.default.createElement(_QuarterYearSelect2.default, {
                    quarter: state.quarter,
                    year: state.year,
                    min: data.daterange.from,
                    max: data.daterange.to,
                    onChange: _onChange,
                    disabled: !state.particid,
                    required: true
                }),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Submission Type"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "submissionType",
                            className: "submissionType form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("submissionType", v);
                            },
                            value: state.submissionType,
                            options: data.submissionType,
                            disabled: !state.particid
                        })
                    )
                )
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Export Options"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "checkbox" },
                    _react2.default.createElement(
                        "label",
                        null,
                        _react2.default.createElement("input", {
                            type: "checkbox",
                            className: "exclude_ncdr_patient_identifiers",
                            onChange: function onChange(e) {
                                return _onChange("excludePatientIdentifiers", e.target.checked ? "true" : "false");
                            },
                            checked: state.excludePatientIdentifiers === "true"
                        }),
                        "Exclude NCDR Patient Identifiers"
                    )
                )
            )
        )
    );
};

var selectShape = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
}));

FormView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    state: _propTypes2.default.shape({
        start: _propTypes2.default.string,
        end: _propTypes2.default.string,
        submissionType: _propTypes2.default.string,
        excludePatientIdentifiers: _propTypes2.default.string,
        particid: _propTypes2.default.string
    }),
    data: _propTypes2.default.shape({
        particid: selectShape,
        quarter: _propTypes2.default.string,
        year: _propTypes2.default.string,
        submissionType: _propTypes2.default.array
    })
};

var asString = function asString(v) {
    return v == null ? "" : v.toString();
};

var initialStateWithDefaults = function initialStateWithDefaults() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        quarter: asString(state.quarter),
        year: asString(state.year),
        particid: asString(state.particid),
        submissionType: asString(state.submissionType),
        excludePatientIdentifiers: asString(state.excludePatientIdentifiers) || "false"
    };
};

var initialData = {
    particid: [],
    daterange: { from: [], to: [] },
    submissionType: [{ value: "", label: "" }, { value: "1", label: "Episode of Care Records" }, { value: "2", label: "Follow-Up Records" }]
};

var AccPVIExportForm = function AccPVIExportForm(_ref2) {
    var initialState = _ref2.initialState,
        needServerData = _ref2.needServerData,
        onReady = _ref2.onReady,
        onNotReady = _ref2.onNotReady;

    var _React$useState = _react2.default.useState(function () {
        return initialStateWithDefaults(initialState);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(initialStateWithDefaults(initialState));
    }, [initialState]);

    var _useKeyValueState = (0, _useKeyValueState4.default)(initialData),
        _useKeyValueState2 = _slicedToArray(_useKeyValueState, 2),
        data = _useKeyValueState2[0],
        setDataKey = _useKeyValueState2[1];

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/participants",
            loadingMessage: "Loading Participants...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.particid + ": " + it.hospname,
                        value: it.particid
                    };
                });
                data.unshift({ label: "", value: "" });
                setDataKey("particid", data);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var particid = state.particid;

        if (!particid) return;
        needServerData({
            endpoint: "/date-range",
            loadingMessage: "Loading Available Date Range...",
            params: {
                particid: particid
            },
            onData: function onData(data) {
                return setDataKey("daterange", { from: data.from, to: data.to });
            }
        });
    }, [state.particid]);

    _react2.default.useEffect(function () {
        if (state.quarter && state.year && state.particid) {
            onReady(_extends({}, state));
        } else {
            onNotReady();
        }
    }, [state]);

    var handleChange = _react2.default.useCallback(function (key, value) {
        return setState(function (s) {
            return _extends({}, s, _defineProperty({}, key, value));
        });
    }, [setState]);

    return _react2.default.createElement(FormView, {
        state: state,
        data: data,
        onChange: handleChange
    });
};

AccPVIExportForm.propTypes = {
    initialState: _propTypes2.default.shape({
        quarter: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        year: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        particid: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        submissionType: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        excludePatientIdentifiers: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string])
    }),
    needServerData: _propTypes2.default.func.isRequired,
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

AccPVIExportForm.canRerun = function (params) {
    return !!(params && params.particid);
};

AccPVIExportForm.apiPrefix = "pvi";

exports.default = AccPVIExportForm;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _OptionGroup = __webpack_require__(108);

var _OptionGroup2 = _interopRequireDefault(_OptionGroup);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _DateRange = __webpack_require__(95);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _useKeyValueState3 = __webpack_require__(38);

var _useKeyValueState4 = _interopRequireDefault(_useKeyValueState3);

var _serializeParams = __webpack_require__(96);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var filterVersions = function filterVersions(options, val) {
    var greater = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    // convert versions into comparable values
    var found = false;
    return options.filter(function (it) {
        if (val === it.value) {
            found = true;
            return true;
        }
        return greater ? found : !found;
    });
};

var DataVersionSelect = function DataVersionSelect(_ref) {
    var name = _ref.name,
        onChange = _ref.onChange,
        _ref$value = _ref.value,
        value = _ref$value === undefined ? [] : _ref$value,
        options = _ref.options,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === undefined ? false : _ref$disabled;

    var hasFromSelected = value.length >= 1;
    var toOptions = filterVersions(options, value[0], true);
    var handleChange = function handleChange(key, v) {
        if (key === "to") {
            // exporter expects a list of datavrsns within the selected range.
            var from = value[0];
            var to = v || value[0];
            var inRange = false;
            v = [];
            toOptions.forEach(function (it) {
                if (it.value === from) {
                    inRange = true;
                }
                if (inRange) {
                    v.push(it.value);
                }
                if (it.value === to) {
                    inRange = false;
                }
            });
        } else {
            v = [v];
        }
        onChange(v.filter(function (it) {
            return it !== "";
        }));
    };
    return _react2.default.createElement(
        "div",
        { className: "form-group" },
        _react2.default.createElement(
            "div",
            { className: "col-sm-6" },
            "From",
            _react2.default.createElement(_Select2.default, {
                name: name + "-from",
                className: "dataversions-from form-control",
                onCommitChange: function onCommitChange(v) {
                    return handleChange("from", v);
                },
                value: value[0],
                options: options,
                disabled: disabled
            })
        ),
        _react2.default.createElement(
            "div",
            { className: "col-sm-6" },
            "To",
            _react2.default.createElement(_Select2.default, {
                name: name + "-to",
                className: "dataversions-to form-control",
                onCommitChange: function onCommitChange(v) {
                    return handleChange("to", v);
                },
                value: value[value.length - 1],
                options: toOptions,
                disabled: disabled || !hasFromSelected
            })
        )
    );
};

DataVersionSelect.propTypes = {
    name: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    value: _propTypes2.default.array,
    options: _propTypes2.default.array,
    disabled: _propTypes2.default.bool
};

var FormView = function FormView(_ref2) {
    var _onChange = _ref2.onChange,
        state = _ref2.state,
        data = _ref2.data;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Participant ID"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "particid",
                            className: "participant form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("particid", v);
                            },
                            value: state.particid,
                            options: data.particid,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(
                    "h5",
                    null,
                    "Data Versions"
                ),
                _react2.default.createElement(DataVersionSelect, {
                    name: "datavrsns",
                    onChange: function onChange(v) {
                        return _onChange("datavrsns", v);
                    },
                    value: state.datavrsns,
                    options: data.datavrsns,
                    disabled: !state.particid
                }),
                _react2.default.createElement(_DateRange2.default, {
                    start: state.start,
                    end: state.end,
                    min: data.daterange.from,
                    max: data.daterange.to,
                    onChange: _onChange,
                    disabled: !state.particid,
                    required: true
                }),
                _react2.default.createElement(
                    "h5",
                    null,
                    "Surgeons"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "surgeons",
                            className: "surgeons form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("surgeons", v);
                            },
                            value: state.surgeons,
                            multiple: true,
                            options: data.surgeons,
                            disabled: !state.particid || !(0, _DateRange.isDateRangeValid)(state.start, state.end)
                        })
                    )
                ),
                _react2.default.createElement(
                    "h5",
                    null,
                    "Procedure Type"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "procedureTypes",
                            className: "procedureTypes form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("procedureTypes", v);
                            },
                            value: state.procedureTypes,
                            multiple: true,
                            options: data.procedureTypes,
                            disabled: !state.particid
                        })
                    )
                )
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Export Options"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "", className: "col-md-5 control-label" },
                        "Field Name Format"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "fieldnameFormat",
                            className: "fieldnameFormat format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("fieldnameFormat", v);
                            },
                            value: state.fieldnameFormat,
                            options: data.fieldnameFormat
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "",
                            className: "col-md-5 control-label" },
                        "Delimiter"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "delimiter",
                            className: "delimiter format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("delimiter", v);
                            },
                            value: state.delimiter,
                            options: data.delimiter
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "", className: "col-md-5 control-label" },
                        "Choice Format"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "optionFormat",
                            className: "optionFormat format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("optionFormat", v);
                            },
                            value: state.optionFormat,
                            options: data.optionFormat
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "", className: "col-md-5 control-label" },
                        "Date Format"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "dateFormat",
                            className: "dateFormat format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("dateFormat", v);
                            },
                            value: state.dateFormat,
                            options: data.dateFormat
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "", className: "col-md-5 control-label" },
                        "Field Sort"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "fieldSort",
                            className: "dateFormat format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("fieldSort", v);
                            },
                            value: state.fieldSort,
                            options: data.fieldSort
                        })
                    )
                )
            ),
            _react2.default.createElement(_OptionGroup2.default, {
                state: state.exportFields,
                data: data.exportFields,
                expanded: false,
                onChange: function onChange(value) {
                    return _onChange("exportFields", value);
                },
                hasFieldEntity: true
            })
        )
    );
};

var selectShape = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
}));

FormView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    state: _propTypes2.default.shape({
        start: _propTypes2.default.string,
        end: _propTypes2.default.string,
        particid: _propTypes2.default.string,
        fieldnameFormat: _propTypes2.default.string,
        delimiter: _propTypes2.default.string,
        optionFormat: _propTypes2.default.string,
        dateFormat: _propTypes2.default.string,
        fieldSort: _propTypes2.default.string,
        datavrsns: _propTypes2.default.array,
        surgeons: _propTypes2.default.array,
        procedureTypes: _propTypes2.default.array,
        exportFields: _propTypes2.default.object
    }),
    data: _propTypes2.default.shape({
        fieldnameFormat: selectShape,
        delimiter: selectShape,
        optionFormat: selectShape,
        dateFormat: selectShape,
        fieldSort: selectShape,
        particid: selectShape,
        datavrsns: selectShape,
        surgeons: selectShape,
        procedureTypes: selectShape,
        daterange: _propTypes2.default.shape({
            from: _propTypes2.default.array,
            to: _propTypes2.default.array
        }),
        exportFields: _propTypes2.default.array
    })
};

var initialStateWithDefaults = function initialStateWithDefaults() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var newState = {
        start: (0, _DateRange.dateToString)(state.start),
        end: (0, _DateRange.dateToString)(state.end),
        particid: state.particid || "",
        fieldnameFormat: state.fieldnameFormat || "SHORT",
        delimiter: state.delimiter || "|",
        optionFormat: state.optionFormat || "NAME",
        dateFormat: state.dateFormat || "MM/dd/yyyy",
        fieldSort: state.fieldSort || "FIELD",
        datavrsns: state.datavrsns || [],
        surgeons: state.surgeons || [],
        procedureTypes: state.procedureTypes || [],
        exportFields: state.exportFields || {}
    };
    return (0, _serializeParams.unstringifyJson)((0, _serializeParams.fromCommaSafeArray)(newState, "surgeons", "procedureTypes"), "exportFields");
};

var serverDataParams = function serverDataParams(params) {
    return (0, _serializeParams.stringifyJson)((0, _serializeParams.toCommaSafeArray)(params, "surgeons", "procedureTypes"), "exportFields");
};

var initialData = {
    fieldnameFormat: ["SHORT", "LONG"].map(function (v) {
        return { label: v, value: v };
    }),
    delimiter: [{ value: "|", label: "|" }, { value: "&#09;", label: "TAB" }, { value: ",", label: "," }],
    optionFormat: ["NAME", "HARVEST_VALUE"].map(function (v) {
        return { label: v, value: v };
    }),
    dateFormat: ["MM/dd/yyyy", "yyyy-MM-dd", "dd/MM/yyyy"].map(function (v) {
        return { label: v, value: v };
    }),
    fieldSort: [{
        label: "By Field Name",
        value: "FIELD"
    }, {
        label: "By Section then Field Name",
        value: "SECTIONFIELD"
    }],
    particid: [],
    datavrsns: [],
    surgeons: [],
    procedureTypes: [],
    daterange: { from: [], to: [] },
    exportFields: []
};

var AdultCardiacExportForm = function AdultCardiacExportForm(_ref3) {
    var initialState = _ref3.initialState,
        needServerData = _ref3.needServerData,
        onReady = _ref3.onReady,
        onNotReady = _ref3.onNotReady;

    var _React$useState = _react2.default.useState(function () {
        return initialStateWithDefaults(initialState);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(initialStateWithDefaults(initialState));
    }, [initialState]);

    var _useKeyValueState = (0, _useKeyValueState4.default)(initialData),
        _useKeyValueState2 = _slicedToArray(_useKeyValueState, 2),
        data = _useKeyValueState2[0],
        setDataKey = _useKeyValueState2[1];

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/exportable/hospitals",
            loadingMessage: "Loading Participants...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.particid + ": " + it.hospname,
                        value: it.particid
                    };
                });
                data.unshift({ label: "", value: "" });
                setDataKey("particid", data);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/exportable/fields",
            loadingMessage: "Loading Available Fields...",
            onData: function onData(data) {
                var fields = data;
                if (_.isEmpty(state.exportFields)) {
                    // initially all fields are selected if none were provided.
                    var selected = {};
                    fields.forEach(function (it) {
                        it.fields.forEach(function (f) {
                            if (!selected[f.entity]) {
                                selected[f.entity] = [];
                            }
                            selected[f.entity].push(f.key);
                        });
                    });
                    handleChange("exportFields", selected);
                }
                setDataKey("exportFields", fields);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var particid = state.particid;

        if (!particid) return;
        needServerData({
            endpoint: "/exportable/datavrsns",
            loadingMessage: "Loading Available Data Versions...",
            params: serverDataParams({
                particid: particid
            }),
            onData: function onData(data) {
                data = data.map(function (it) {
                    return { label: it.name, value: it.name };
                });
                data.reverse();
                data.unshift({ label: "", value: "" });
                setDataKey("datavrsns", data);
            }
        });
    }, [state.particid]);

    _react2.default.useEffect(function () {
        var particid = state.particid,
            datavrsns = state.datavrsns,
            start = state.start,
            end = state.end;

        if (!particid || !(0, _DateRange.isDateRangeValid)(state.start, state.end)) return;
        needServerData({
            endpoint: "/exportable/surgeons",
            loadingMessage: "Loading Available Surgeons...",
            params: serverDataParams({
                particid: particid,
                datavrsns: datavrsns,
                surgdtStart: start,
                surgdtEnd: end
            }),
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.npi ? it.npi + ": " + it.name : it.name,
                        value: it.name
                    };
                });
                data.unshift({ label: "All Surgeons", value: "" });
                setDataKey("surgeons", data);
            }
        });
    }, [state.particid, state.datavrsns, state.start, state.end]);

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/exportable/procedure-types",
            loadingMessage: "Loading Procedure Types...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.name,
                        value: it.name
                    };
                });
                data.unshift({ label: "All Procedure Types", value: "" });
                setDataKey("procedureTypes", data);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var particid = state.particid,
            datavrsns = state.datavrsns;

        if (!particid) return;
        needServerData({
            endpoint: "/exportable/surgdt-range",
            loadingMessage: "Loading Available Date Range...",
            params: serverDataParams({
                particid: particid,
                datavrsns: datavrsns
            }),
            onData: function onData(data) {
                return setDataKey("daterange", { from: data.from, to: data.to });
            }
        });
    }, [state.particid, state.datavrsns]);

    _react2.default.useEffect(function () {
        // update the submit button and data
        if ((0, _DateRange.isDateRangeValid)(state.start, state.end) && !!state.particid) {
            var availableSurgeons = new Set(data.surgeons.map(function (it) {
                return it.value;
            }));
            onReady(serverDataParams(_extends({}, state, {
                surgeons: state.surgeons.filter(function (it) {
                    return availableSurgeons.has(it);
                }),
                exportFields: Object.entries(state.exportFields).reduce(function (agg, _ref4) {
                    var _ref5 = _slicedToArray(_ref4, 2),
                        e = _ref5[0],
                        fs = _ref5[1];

                    if (fs && fs.length) agg[e] = fs;
                    return agg;
                }, {})
            })));
        } else {
            onNotReady();
        }
    }, [state, data]);

    var handleChange = _react2.default.useCallback(function (key, value) {
        return setState(function (s) {
            return _extends({}, s, _defineProperty({}, key, value));
        });
    }, [setState]);

    return _react2.default.createElement(FormView, {
        state: state,
        data: data,
        onChange: handleChange
    });
};

AdultCardiacExportForm.propTypes = {
    initialState: _propTypes2.default.shape({
        start: _propTypes2.default.any,
        end: _propTypes2.default.any,
        particid: _propTypes2.default.string,
        fieldnameFormat: _propTypes2.default.string,
        delimiter: _propTypes2.default.string,
        optionFormat: _propTypes2.default.string,
        dateFormat: _propTypes2.default.string,
        fieldSort: _propTypes2.default.string,
        datavrsns: _propTypes2.default.arrayOf(_propTypes2.default.string),
        surgeons: _propTypes2.default.arrayOf(_propTypes2.default.string),
        procedureTypes: _propTypes2.default.arrayOf(_propTypes2.default.string),
        // history stores an object, saved params have JSON strings
        exportFields: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string])
    }),
    needServerData: _propTypes2.default.func.isRequired,
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

AdultCardiacExportForm.canRerun = function (params) {
    return params.hasOwnProperty("fieldnameFormat") && params.hasOwnProperty("delimiter") && params.hasOwnProperty("optionFormat") && params.hasOwnProperty("dateFormat") && params.hasOwnProperty("exportFields");
};

AdultCardiacExportForm.apiPrefix = "adult-cardiac";

exports.default = AdultCardiacExportForm;

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ControlResolver = __webpack_require__(139);

exports.default = function (props) {
  return (0, _ControlResolver.buildDescriptorControl)("DateField", "calendar", props);
};

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _DateRange = __webpack_require__(95);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _OptionGroup = __webpack_require__(108);

var _OptionGroup2 = _interopRequireDefault(_OptionGroup);

var _useKeyValueState3 = __webpack_require__(38);

var _useKeyValueState4 = _interopRequireDefault(_useKeyValueState3);

var _serializeParams = __webpack_require__(96);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormView = function FormView(_ref) {
    var _onChange = _ref.onChange,
        state = _ref.state,
        data = _ref.data;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Participant ID"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "particid",
                            className: "participant form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("particid", v);
                            },
                            value: state.particid,
                            options: data.particid,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(_DateRange2.default, {
                    start: state.start,
                    end: state.end,
                    min: data.daterange.from,
                    max: data.daterange.to,
                    onChange: _onChange,
                    disabled: !state.particid,
                    required: true
                })
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(_OptionGroup2.default, {
                state: state.optionalFields,
                data: data.optionalFields,
                expanded: true,
                onChange: function onChange(value) {
                    return _onChange("optionalFields", value);
                }
            })
        )
    );
};

var selectShape = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
}));

FormView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    state: _propTypes2.default.shape({
        start: _propTypes2.default.string,
        end: _propTypes2.default.string,
        particid: _propTypes2.default.string,
        optionalFields: _propTypes2.default.object
    }),
    data: _propTypes2.default.shape({
        particid: selectShape,
        daterange: _propTypes2.default.shape({
            from: _propTypes2.default.array,
            to: _propTypes2.default.array
        }),
        optionalFields: _propTypes2.default.array
    })
};

var initialStateWithDefaults = function initialStateWithDefaults() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var newState = {
        start: (0, _DateRange.dateToString)(state.start),
        end: (0, _DateRange.dateToString)(state.end),
        particid: state.particid || "",
        optionalFields: state.optionalFields || {}
    };
    return (0, _serializeParams.unstringifyJson)(newState, "optionalFields");
};

var serverDataParams = function serverDataParams(params) {
    return (0, _serializeParams.stringifyJson)(params, "optionalFields");
};

var initialData = {
    particid: [],
    daterange: { from: [], to: [] },
    optionalFields: []
};

var AdultCardiacHarvestForm = function AdultCardiacHarvestForm(_ref2) {
    var initialState = _ref2.initialState,
        needServerData = _ref2.needServerData,
        onReady = _ref2.onReady,
        onNotReady = _ref2.onNotReady;

    var _React$useState = _react2.default.useState(function () {
        return initialStateWithDefaults(initialState);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(initialStateWithDefaults(initialState));
    }, [initialState]);

    var _useKeyValueState = (0, _useKeyValueState4.default)(initialData),
        _useKeyValueState2 = _slicedToArray(_useKeyValueState, 2),
        data = _useKeyValueState2[0],
        setDataKey = _useKeyValueState2[1];

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/participants",
            loadingMessage: "Loading Participants...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.particid + ": " + it.hospname,
                        value: it.particid
                    };
                });
                data.unshift({ label: "", value: "" });
                setDataKey("particid", data);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/optional-fields",
            loadingMessage: "Loading Available Fields...",
            onData: function onData(data) {
                var fields = data.entities;
                if (_.isEmpty(state.optionalFields)) {
                    // initially all fields are selected if none were provided.
                    var selected = {};
                    fields.forEach(function (f) {
                        selected[f.key] = f.fields.map(function (it) {
                            return it.key;
                        });
                    });
                    handleChange("optionalFields", selected);
                }
                setDataKey("optionalFields", fields);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var particid = state.particid;

        if (!particid) return;
        needServerData({
            endpoint: "/date-range",
            loadingMessage: "Loading Available Date Range...",
            params: serverDataParams({
                particid: particid
            }),
            onData: function onData(data) {
                return setDataKey("daterange", { from: data.from, to: data.to });
            }
        });
    }, [state.particid]);

    _react2.default.useEffect(function () {
        if ((0, _DateRange.isDateRangeValid)(state.start, state.end) && state.particid) {
            onReady(serverDataParams(state));
        } else {
            onNotReady();
        }
    }, [state]);

    var handleChange = _react2.default.useCallback(function (key, value) {
        return setState(function (s) {
            return _extends({}, s, _defineProperty({}, key, value));
        });
    }, [setState]);

    return _react2.default.createElement(FormView, {
        state: state,
        data: data,
        onChange: handleChange
    });
};

AdultCardiacHarvestForm.propTypes = {
    initialState: _propTypes2.default.shape({
        start: _propTypes2.default.any,
        end: _propTypes2.default.any,
        particid: _propTypes2.default.string,
        optionalFields: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string])
    }),
    needServerData: _propTypes2.default.func.isRequired,
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

AdultCardiacHarvestForm.canRerun = function (params) {
    return !!(params && params.particid);
};

AdultCardiacHarvestForm.apiPrefix = "adult-cardiac";

exports.default = AdultCardiacHarvestForm;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _DateRange = __webpack_require__(95);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _useKeyValueState3 = __webpack_require__(38);

var _useKeyValueState4 = _interopRequireDefault(_useKeyValueState3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormView = function FormView(_ref) {
    var onChange = _ref.onChange,
        state = _ref.state,
        data = _ref.data;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Participant ID"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "particid",
                            className: "participant form-control",
                            onCommitChange: function onCommitChange(v) {
                                return onChange("particid", v);
                            },
                            value: state.particid,
                            options: data.particid,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(_DateRange2.default, {
                    start: state.start,
                    end: state.end,
                    min: data.daterange.from,
                    max: data.daterange.to,
                    onChange: onChange,
                    disabled: !state.particid,
                    required: true
                })
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Export Options"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "", className: "col-md-5 control-label" },
                        "Field Name Format"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "headingFormat",
                            className: "headingFormat format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return onChange("headingFormat", v);
                            },
                            value: state.headingFormat,
                            options: data.headingFormat
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "",
                            className: "col-md-5 control-label" },
                        "Delimiter"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "delimiter",
                            className: "delimiter format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return onChange("delimiter", v);
                            },
                            value: state.delimiter,
                            options: data.delimiter
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "", className: "col-md-5 control-label" },
                        "Choice Format"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "optionFormat",
                            className: "optionFormat format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return onChange("optionFormat", v);
                            },
                            value: state.optionFormat,
                            options: data.optionFormat
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "", className: "col-md-5 control-label" },
                        "Date Format"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "dateFormat",
                            className: "dateFormat format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return onChange("dateFormat", v);
                            },
                            value: state.dateFormat,
                            options: data.dateFormat
                        })
                    )
                )
            )
        )
    );
};

var selectShape = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
}));

FormView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    state: _propTypes2.default.shape({
        start: _propTypes2.default.string,
        end: _propTypes2.default.string,
        particid: _propTypes2.default.string,
        headingFormat: _propTypes2.default.string,
        delimiter: _propTypes2.default.string,
        optionFormat: _propTypes2.default.string,
        dateFormat: _propTypes2.default.string
    }),
    data: _propTypes2.default.shape({
        headingFormat: selectShape,
        delimiter: selectShape,
        optionFormat: selectShape,
        dateFormat: selectShape,
        particid: selectShape,
        daterange: _propTypes2.default.shape({
            from: _propTypes2.default.array,
            to: _propTypes2.default.array
        })
    })
};

var initialStateWithDefaults = function initialStateWithDefaults() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        start: (0, _DateRange.dateToString)(state.start),
        end: (0, _DateRange.dateToString)(state.end),
        particid: state.particid || "",
        headingFormat: state.headingFormat || "SHORT",
        delimiter: state.delimiter || "|",
        optionFormat: state.optionFormat || "NAME",
        dateFormat: state.dateFormat || "MM/dd/yyyy"
    };
};

var initialData = {
    headingFormat: ["SHORT", "LONG"].map(function (v) {
        return { label: v, value: v };
    }),
    delimiter: [{ value: "|", label: "|" }, { value: "&#09;", label: "TAB" }, { value: ",", label: "," }],
    optionFormat: ["NAME", "HARVEST_VALUE"].map(function (v) {
        return { label: v, value: v };
    }),
    dateFormat: ["MM/dd/yyyy", "yyyy-MM-dd", "dd/MM/yyyy"].map(function (v) {
        return { label: v, value: v };
    }),
    particid: [],
    daterange: { from: [], to: [] }
};

var CongenitalExportForm = function CongenitalExportForm(_ref2) {
    var initialState = _ref2.initialState,
        needServerData = _ref2.needServerData,
        onReady = _ref2.onReady,
        onNotReady = _ref2.onNotReady;

    var _React$useState = _react2.default.useState(function () {
        return initialStateWithDefaults(initialState);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(initialStateWithDefaults(initialState));
    }, [initialState]);

    var _useKeyValueState = (0, _useKeyValueState4.default)(initialData),
        _useKeyValueState2 = _slicedToArray(_useKeyValueState, 2),
        data = _useKeyValueState2[0],
        setDataKey = _useKeyValueState2[1];

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/participants",
            loadingMessage: "Loading Participants...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.particid + ": " + it.hospname,
                        value: it.particid
                    };
                });
                data.unshift({ label: "", value: "" });
                setDataKey("particid", data);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var particid = state.particid,
            datavrsns = state.datavrsns,
            surgeons = state.surgeons;

        if (!particid) return;
        needServerData({
            endpoint: "/date-range",
            loadingMessage: "Loading Available Date Range...",
            params: {
                particid: particid,
                datavrsns: datavrsns,
                surgeons: surgeons
            },
            onData: function onData(data) {
                return setDataKey("daterange", { from: data.from, to: data.to });
            }

        });
    }, [state.particid, state.datavrsns, state.surgeons]);

    _react2.default.useEffect(function () {
        if ((0, _DateRange.isDateRangeValid)(state.start, state.end) && !!state.particid) {
            onReady(_extends({}, state, {
                // for backwards compatibility
                fieldnameFormat: state.headingFormat
            }));
        } else {
            onNotReady();
        }
    }, [state]);

    var handleChange = _react2.default.useCallback(function (key, value) {
        return setState(function (s) {
            return _extends({}, s, _defineProperty({}, key, value));
        });
    }, [setState]);

    return _react2.default.createElement(FormView, {
        state: state,
        data: data,
        onChange: handleChange
    });
};

CongenitalExportForm.propTypes = {
    initialState: _propTypes2.default.shape({
        start: _propTypes2.default.any,
        end: _propTypes2.default.any,
        particid: _propTypes2.default.string,
        headingFormat: _propTypes2.default.string,
        delimiter: _propTypes2.default.string,
        optionFormat: _propTypes2.default.string,
        dateFormat: _propTypes2.default.string
    }),
    needServerData: _propTypes2.default.func.isRequired,
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

CongenitalExportForm.canRerun = function (params) {
    return !!(params && params.particid);
};

CongenitalExportForm.apiPrefix = "congenital";

exports.default = CongenitalExportForm;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _DateRange = __webpack_require__(95);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _OptionGroup = __webpack_require__(108);

var _OptionGroup2 = _interopRequireDefault(_OptionGroup);

var _useKeyValueState3 = __webpack_require__(38);

var _useKeyValueState4 = _interopRequireDefault(_useKeyValueState3);

var _serializeParams = __webpack_require__(96);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormView = function FormView(_ref) {
    var _onChange = _ref.onChange,
        state = _ref.state,
        data = _ref.data;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Participant ID"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "particid",
                            className: "participant form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("particid", v);
                            },
                            value: state.particid,
                            options: data.particid,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(_DateRange2.default, {
                    start: state.start,
                    end: state.end,
                    min: data.daterange.from,
                    max: data.daterange.to,
                    onChange: _onChange,
                    disabled: !state.particid,
                    required: true
                })
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(_OptionGroup2.default, {
                state: state.optionalFields,
                data: data.optionalFields,
                expanded: false,
                onChange: function onChange(value) {
                    return _onChange("optionalFields", value);
                }
            })
        ),
        _react2.default.createElement(
            "div",
            { className: "harvest-export-alerts" },
            _react2.default.createElement(
                "span",
                { className: "ncdr-attention" },
                "Files generated before 07/01/2023 will not be accepted by STS due to the new filename requirements.  To submit older data, please re-generate a harvest file with the new format. "
            )
        )
    );
};

var selectShape = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
}));

FormView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    state: _propTypes2.default.shape({
        start: _propTypes2.default.string,
        end: _propTypes2.default.string,
        particid: _propTypes2.default.string,
        dateFormat: _propTypes2.default.string,
        optionalFields: _propTypes2.default.object
    }),
    data: _propTypes2.default.shape({
        particid: selectShape,
        daterange: _propTypes2.default.shape({
            from: _propTypes2.default.array,
            to: _propTypes2.default.array
        }),
        optionalFields: _propTypes2.default.array
    })
};

var initialStateWithDefaults = function initialStateWithDefaults() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var newState = {
        start: (0, _DateRange.dateToString)(state.start),
        end: (0, _DateRange.dateToString)(state.end),
        particid: state.particid || "",
        optionalFields: state.optionalFields || {}
    };
    return (0, _serializeParams.unstringifyJson)(newState, "optionalFields");
};

var serverDataParams = function serverDataParams(params) {
    return (0, _serializeParams.stringifyJson)(params, "optionalFields");
};

var initialData = {
    particid: [],
    daterange: { from: [], to: [] },
    optionalFields: []
};

var CongenitalHarvestForm = function CongenitalHarvestForm(_ref2) {
    var initialState = _ref2.initialState,
        needServerData = _ref2.needServerData,
        onReady = _ref2.onReady,
        onNotReady = _ref2.onNotReady;

    var _React$useState = _react2.default.useState(function () {
        return initialStateWithDefaults(initialState);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(initialStateWithDefaults(initialState));
    }, [initialState]);

    var _useKeyValueState = (0, _useKeyValueState4.default)(initialData),
        _useKeyValueState2 = _slicedToArray(_useKeyValueState, 2),
        data = _useKeyValueState2[0],
        setDataKey = _useKeyValueState2[1];

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/participants",
            loadingMessage: "Loading Participants...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.particid + ": " + it.hospname,
                        value: it.particid
                    };
                });
                data.unshift({ label: "", value: "" });
                setDataKey("particid", data);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/optional-fields",
            loadingMessage: "Loading Available Fields...",
            onData: function onData(data) {
                var fields = data.entities;
                if (_.isEmpty(state.optionalFields)) {
                    // initially all fields are selected if none were provided.
                    var selected = {};
                    fields.forEach(function (f) {
                        selected[f.key] = f.fields.map(function (it) {
                            return it.key;
                        });
                    });
                    handleChange("optionalFields", selected);
                }
                setDataKey("optionalFields", fields);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var particid = state.particid,
            datavrsns = state.datavrsns,
            surgeons = state.surgeons;

        if (!particid) return;
        needServerData({
            endpoint: "/date-range",
            loadingMessage: "Loading Available Date Range...",
            params: serverDataParams({
                particid: particid,
                datavrsns: datavrsns,
                surgeons: surgeons
            }),
            onData: function onData(data) {
                return setDataKey("daterange", { from: data.from, to: data.to });
            }
        });
    }, [state.particid, state.datavrsns, state.surgeons]);

    _react2.default.useEffect(function () {
        if ((0, _DateRange.isDateRangeValid)(state.start, state.end) && !!state.particid) {
            onReady(serverDataParams(state));
        } else {
            onNotReady();
        }
    }, [state]);

    var handleChange = _react2.default.useCallback(function (key, value) {
        return setState(function (s) {
            return _extends({}, s, _defineProperty({}, key, value));
        });
    }, [setState]);

    return _react2.default.createElement(FormView, {
        state: state,
        data: data,
        onChange: handleChange
    });
};

CongenitalHarvestForm.propTypes = {
    initialState: _propTypes2.default.shape({
        start: _propTypes2.default.any,
        end: _propTypes2.default.any,
        particid: _propTypes2.default.string,
        optionalFields: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string])
    }),
    needServerData: _propTypes2.default.func.isRequired,
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

CongenitalHarvestForm.canRerun = function (params) {
    return !!(params && params.particid);
};

CongenitalHarvestForm.apiPrefix = "congenital";

exports.default = CongenitalHarvestForm;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

var _SearchFormActions = __webpack_require__(75);

var _SearchFormActions2 = _interopRequireDefault(_SearchFormActions);

var _SearchFormStore = __webpack_require__(82);

var _SearchFormStore2 = _interopRequireDefault(_SearchFormStore);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _ContextActions = __webpack_require__(170);

var _ContextActions2 = _interopRequireDefault(_ContextActions);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _SearchForm = __webpack_require__(233);

var _SearchForm2 = _interopRequireDefault(_SearchForm);

var _GenericXmlExportPasswordAdmin = __webpack_require__(323);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fluxContext = "CTX-export-generic-xml";

function FormView(_ref) {
    var stereotypes = _ref.stereotypes,
        selectedStereotype = _ref.selectedStereotype,
        onStereotypeSelect = _ref.onStereotypeSelect,
        isAvailable = _ref.isAvailable,
        isAdmin = _ref.isAdmin,
        onShowAdmin = _ref.onShowAdmin;

    var header = void 0,
        body = void 0;
    if (isAvailable) {
        header = stereotypes.length === 1 ? "Export By " + stereotypes[0].name : _react2.default.createElement(_Select2.default, {
            id: "stereotype",
            options: stereotypes.map(function (s) {
                return {
                    value: s.key,
                    label: (s.key === selectedStereotype ? "Export By " : "") + s.name
                };
            }),
            onCommitChange: onStereotypeSelect,
            value: selectedStereotype,
            label: "Search By"
        });
        body = _react2.default.createElement(_SearchForm2.default, {
            fluxContext: fluxContext,
            onSubmit: console.log,
            alwaysShowAdvanced: true
        });
    } else {
        header = "No Password!";
        body = [_react2.default.createElement(
            "p",
            { key: "nope" },
            "Your organization doesn't have a password configured to secure ARMUS XML Exports, so they are currently disabled."
        )];
        if (isAdmin) {
            body.push(_react2.default.createElement(
                "p",
                { key: "admin" },
                "As an administrator, you can set one via the ",
                _react2.default.createElement(
                    "button",
                    {
                        className: "btn btn-sm btn-dark",
                        onClick: function onClick(e) {
                            e.preventDefault();
                            onShowAdmin();
                        }
                    },
                    _GenericXmlExportPasswordAdmin.title
                ),
                "."
            ));
        }
    }
    return _react2.default.createElement(
        "div",
        { className: "form-section form-section-single generic-xml-export" },
        _react2.default.createElement(
            "div",
            { className: "form-section-header" },
            header
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section-inner" },
            body
        )
    );
}

FormView.propTypes = {
    stereotypes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        key: _propTypes2.default.string.isRequired,
        name: _propTypes2.default.string.isRequired
    })).isRequired,
    selectedStereotype: _propTypes2.default.string.isRequired,
    onStereotypeSelect: _propTypes2.default.func.isRequired,
    onShowAdmin: _propTypes2.default.func.isRequired,
    isAvailable: _propTypes2.default.bool.isRequired,
    isAdmin: _propTypes2.default.bool.isRequired
};

var GenericXmlExportForm = function GenericXmlExportForm(props) {
    var params = props.initialState,
        onReady = props.onReady,
        onNotReady = props.onNotReady;

    var state = (0, _useFluxStore2.default)(function () {
        var stereotypes = _StereotypesStore2.default.getDataQualityStereotypes();
        var selectedStereotype = _SearchFormStore2.default.getKey(fluxContext);
        var onStereotypeSelect = function onStereotypeSelect(key, copyExisting) {
            return _Dispatcher2.default.contextDispatch(fluxContext, {
                type: _SearchFormActions2.default.SELECT_STEREOTYPE,
                fields: _StereotypesStore2.default.getStereotypeFieldsByKey(key),
                copyExisting: copyExisting,
                key: key
            });
        };
        // Calling back to on[Not]Ready synchronously is bad, but we can't hoist
        // state at the moment, since it lives in a Flux store. Once we can get
        // to Context, that'll magically fix itself.
        //
        // eslint-disable-next-line no-settimeout
        setTimeout(function () {
            if (_SearchFormStore2.default.hasValues(fluxContext)) {
                onReady({
                    // these are used for processing
                    s: selectedStereotype,
                    q: _SearchFormStore2.default.getQ(fluxContext).toAS(),
                    // these are used for labeling ('h' for 'human')
                    hq: _SearchFormStore2.default.getHuman(fluxContext),
                    hs: _StereotypesStore2.default.getStereotypeByKey(selectedStereotype).name,
                    // this is used for rerunning
                    _form: JSON.stringify((0, _SearchFormStore.extractSearchToSave)(_SearchFormStore2.default.getState(fluxContext)))
                });
            } else {
                onNotReady();
            }
        });
        return {
            stereotypes: stereotypes,
            selectedStereotype: selectedStereotype,
            onStereotypeSelect: onStereotypeSelect,
            isAvailable: _userStore2.default.isGenericXmlExportAvailable(),
            isAdmin: _userStore2.default.isPrefManForAnything()
        };
    }, [_StereotypesStore2.default, _SearchFormStore2.default, _userStore2.default], [onReady, onNotReady]);
    _react2.default.useEffect(function () {
        // Initialize the search context, either bare or from passed params.
        //
        // eslint-disable-next-line no-settimeout
        setTimeout(function () {
            var action = {
                type: _SearchFormActions2.default.INITIALIZE_CONTEXT,
                key: state.stereotypes[0].key,
                availableKeys: state.stereotypes.map(function (s) {
                    return s.key;
                })
            };
            if (params && params._form) {
                try {
                    action.query = JSON.parse(params._form);
                    action.key = action.query.key;
                } catch (e) {
                    console.warn("Error inflating Generic XML Export form state: " + e, e);
                }
            }
            _Dispatcher2.default.contextDispatch(fluxContext, action);
        });
        // and close it when we unmount
        return function () {
            return _Dispatcher2.default.contextDispatch(fluxContext, {
                type: _ContextActions2.default.CLOSE
            });
        };
    }, [params]);
    return _react2.default.createElement(FormView, _extends({
        onShowAdmin: function onShowAdmin() {
            return Backbone.dispatcher.trigger("load:genericXmlPasswordAdmin");
        }
    }, props, state));
};

GenericXmlExportForm.propTypes = {
    initialState: _propTypes2.default.shape({
        _form: _propTypes2.default.string
    }),
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

GenericXmlExportForm.canRerun = function (params) {
    return params.hasOwnProperty("_form");
};

GenericXmlExportForm.apiPrefix = "generic-xml";

exports.default = GenericXmlExportForm;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _recordLabel = __webpack_require__(303);

var _recordLabel2 = _interopRequireDefault(_recordLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StereotypeProjection = function () {
    function StereotypeProjection(stereoInfo, entityProxy) {
        var _this = this;

        _classCallCheck(this, StereotypeProjection);

        this.stereoInfo = stereoInfo;
        this.entityProxy = entityProxy;
        // todo: use an index, not a scan
        this.impl = stereoInfo.implementations.find(function (it) {
            return it.key === _this.entityProxy.entityKey;
        });
        if (this.impl == null) {
            throw new Error("Entity '" + this.entityProxy.entityKey + "' doesn't implement '" + this.stereoInfo.key + "'");
        }
    }

    _createClass(StereotypeProjection, [{
        key: "get",
        value: function get(field) {
            // todo: use an index, not a scan
            var fi = this.impl.fieldImpls.find(function (it) {
                return it.key === field;
            });
            if (fi == null) return null; // no field def provided
            return fi.script(this.entityProxy);
        }
    }, {
        key: "getKey",
        value: function getKey() {
            return this.stereoInfo.key + "[" + this.entityProxy.entityKey + "]#" + this.entityProxy.id;
        }
    }, {
        key: "equals",
        value: function equals(o) {
            if (o == null) return false;
            if (!(o instanceof StereotypeProjection)) return false;
            if (this.stereoInfo.key !== o.stereoInfo.key) return false;
            if (!this.entityProxy.equals(o.entityProxy)) return false;
            return true;
        }
    }, {
        key: "getLabel",
        value: function getLabel() {
            return (0, _recordLabel2.default)(this.stereoInfo, this);
        }
    }]);

    return StereotypeProjection;
}();

exports.default = StereotypeProjection;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cleanValue = function cleanValue(value, type) {
    if (value === "") {
        value = null;
    }
    if (value != null) {
        if (type === "DATE") {
            (0, _invariant2.default)(moment.isMoment(value), type + " fields only accept Moment values, not '" + value + "'.");
            // midnight
            value.startOf("day");
        } else if (type === "TIME") {
            (0, _invariant2.default)(moment.isMoment(value), type + " fields only accept Moment values, not '" + value + "'.");
            // time after epoch
            value.year(1970);
            value.month(0);
            value.date(1);
        } else if (type === "DATETIME") {
            (0, _invariant2.default)(moment.isMoment(value), type + " fields only accept Moment values, not '" + value + "'.");
        } else if (type === "INTEGER") {
            // for loosey-goosey AS scriptlets
            value = Math.round(value);
        } else if (type === "DECIMAL") {
            if (typeof value !== "string") {
                value = value.toString();
            }
        }
    }
    return value;
};

exports.default = cleanValue;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _AdtPlugin = __webpack_require__(965);

var _AdtPlugin2 = _interopRequireDefault(_AdtPlugin);

var _CrossRecordPlugin = __webpack_require__(966);

var _CrossRecordPlugin2 = _interopRequireDefault(_CrossRecordPlugin);

var _HemoPlugin = __webpack_require__(967);

var _HemoPlugin2 = _interopRequireDefault(_HemoPlugin);

var _EcmoEmrPlugin = __webpack_require__(968);

var _EcmoEmrPlugin2 = _interopRequireDefault(_EcmoEmrPlugin);

var _CrossAppPlugin = __webpack_require__(969);

var _CrossAppPlugin2 = _interopRequireDefault(_CrossAppPlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (key, options) {
    switch (key) {
        case "adt":
            return new _AdtPlugin2.default(options);
        case "cross-record":
            return new _CrossRecordPlugin2.default(options);
        case "hemo":
            return new _HemoPlugin2.default(options);
        case "ecmoemr":
            return new _EcmoEmrPlugin2.default(options);
        case "cross-app":
            return new _CrossAppPlugin2.default(options);
        default:
            throw Error("Cannot find mapping plugin with key " + key + ".");
    }
};

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BasePlugin2 = __webpack_require__(179);

var _BasePlugin3 = _interopRequireDefault(_BasePlugin2);

var _AdtStore = __webpack_require__(228);

var _AdtStore2 = _interopRequireDefault(_AdtStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function dateFormat(dt) {
    return ArmusScript["dateFormat(Date,String)"](dt, "MM/dd/yy");
}

function patientLabelHunks(pat) {
    var mrn = pat.get("medrecn");
    var first = pat.get("stspatfname");
    var last = pat.get("stspatlname");
    var dob = dateFormat(pat.get("stsdob"));
    return ["MRN: " + mrn, "Name: " + first + " " + last + ", DOB: " + dob];
}

var AdtPlugin = function (_BasePlugin) {
    _inherits(AdtPlugin, _BasePlugin);

    function AdtPlugin() {
        _classCallCheck(this, AdtPlugin);

        return _possibleConstructorReturn(this, (AdtPlugin.__proto__ || Object.getPrototypeOf(AdtPlugin)).apply(this, arguments));
    }

    _createClass(AdtPlugin, [{
        key: "initialize",
        value: function initialize(options) {
            _get(AdtPlugin.prototype.__proto__ || Object.getPrototypeOf(AdtPlugin.prototype), "initialize", this).call(this, options);

            this.set("fluxContext", "CTX_MappingPlugin_ADT");
            this.set("name", "ADT");
            this.set("id", "adt");
            this.set("fields", [{ key: "mrn", type: "string", name: "MRN" }, { key: "admitdate", type: "date", name: "Admit Date" }, { key: "firstname", type: "string", name: "First Name" }, { key: "lastname", type: "string", name: "Last Name" }, { key: "dob", type: "date", name: "Date of Birth" }]);
        }
    }, {
        key: "hasPaginationParams",
        value: function hasPaginationParams() {
            return true;
        }
    }, {
        key: "getPagination",
        value: function getPagination(query) {
            return _AdtStore2.default.getPagination(query);
        }
    }, {
        key: "getQueryLO",
        value: function getQueryLO(query, initiate, interactive) {
            return initiate ? _AdtStore2.default.getHotLO(query, interactive) : _AdtStore2.default.getColdLO(query);
        }
    }, {
        key: "getLabelForResult",
        value: function getLabelForResult(ep) {
            var hunks = void 0;
            if (ep.entityKey === "adt/1-0/patient") {
                hunks = patientLabelHunks(ep);
            } else if (ep.entityKey === "adt/1-0/episode") {
                hunks = patientLabelHunks(ep.get("patient"));
                var admit = dateFormat(ep.get("stsadmitdt"));
                var disch = dateFormat(ep.get("stsdischdt"));
                hunks.splice(1, 0, "Admission: " + admit + " - " + disch);
            } else {
                return _get(AdtPlugin.prototype.__proto__ || Object.getPrototypeOf(AdtPlugin.prototype), "getLabelForResult", this).call(this, ep);
            }
            return hunks.join(", ");
        }
    }, {
        key: "getButtonListingPrefix",
        value: function getButtonListingPrefix() {
            return "Map From ADT Record ";
        }
    }]);

    return AdtPlugin;
}(_BasePlugin3.default);

exports.default = AdtPlugin;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BasePlugin2 = __webpack_require__(179);

var _BasePlugin3 = _interopRequireDefault(_BasePlugin2);

var _superRecords = __webpack_require__(63);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _SuperRecordStore = __webpack_require__(36);

var _SuperRecordStore2 = _interopRequireDefault(_SuperRecordStore);

var _NavigatorStore = __webpack_require__(33);

var _NavigatorStore2 = _interopRequireDefault(_NavigatorStore);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CrossRecordPlugin = function (_BasePlugin) {
    _inherits(CrossRecordPlugin, _BasePlugin);

    function CrossRecordPlugin() {
        _classCallCheck(this, CrossRecordPlugin);

        return _possibleConstructorReturn(this, (CrossRecordPlugin.__proto__ || Object.getPrototypeOf(CrossRecordPlugin)).apply(this, arguments));
    }

    _createClass(CrossRecordPlugin, [{
        key: "initialize",
        value: function initialize() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            _get(CrossRecordPlugin.prototype.__proto__ || Object.getPrototypeOf(CrossRecordPlugin.prototype), "initialize", this).call(this, options);

            this.set("name", "Cross Record");
            this.set("id", "cross-record");
            this.set("fluxContext", "CTX_MappingPlugin_CrossRecord");
            this.set("fields", []);
        }
    }, {
        key: "getButtonListingPrefix",
        value: function getButtonListingPrefix() {
            return "Map From ";
        }
    }, {
        key: "getPagination",
        value: function getPagination() {
            return {
                page: 1,
                pageCount: 1,
                pageSize: 25,
                totalResultCount: 0
            };
        }
    }, {
        key: "getQueryLO",
        value: function getQueryLO(query, initiate) {
            var _this2 = this;

            var magic = _NavigatorStore2.default.getMagicState(this.fluxContext);
            var srInfo = _SuperRecordStore2.default.getRecord(magic.key, magic.id);
            var tlrs = (0, _superRecords.getTopLevelRecords)(_TableStore2.default, srInfo);
            return _LoadObject2.default.withValue(tlrs.filter(function (it) {
                return !it.equals(_this2.activeRecord);
            }));
        }
    }, {
        key: "searchFromActiveRecord",
        value: function searchFromActiveRecord() {
            return this._searchInternal({}, true);
        }
    }]);

    return CrossRecordPlugin;
}(_BasePlugin3.default);

exports.default = CrossRecordPlugin;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BasePlugin2 = __webpack_require__(179);

var _BasePlugin3 = _interopRequireDefault(_BasePlugin2);

var _HemoStore = __webpack_require__(229);

var _HemoStore2 = _interopRequireDefault(_HemoStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HemoPlugin = function (_BasePlugin) {
    _inherits(HemoPlugin, _BasePlugin);

    function HemoPlugin() {
        _classCallCheck(this, HemoPlugin);

        return _possibleConstructorReturn(this, (HemoPlugin.__proto__ || Object.getPrototypeOf(HemoPlugin)).apply(this, arguments));
    }

    _createClass(HemoPlugin, [{
        key: "initialize",
        value: function initialize(options) {
            _get(HemoPlugin.prototype.__proto__ || Object.getPrototypeOf(HemoPlugin.prototype), "initialize", this).call(this, options);

            this.set("name", "Hemo");
            this.set("id", "hemo");
            this.set("fluxContext", "CTX_MappingPlugin_Hemo");

            this.set("fields", [{ key: "studyid", type: "string", name: "Study ID" }, { key: "lastname", type: "string", name: "Last Name" }, { key: "proceduredate", type: "date", name: "Procedure Date" }, { key: "sitepatientid", type: "string", name: "Site Patient ID" }]);
        }
    }, {
        key: "hasPaginationParams",
        value: function hasPaginationParams() {
            return true;
        }
    }, {
        key: "getQueryLO",
        value: function getQueryLO(query, initiate, interactive) {
            return initiate ? _HemoStore2.default.getHotLO(query, interactive) : _HemoStore2.default.getColdLO(query);
        }
    }, {
        key: "getPagination",
        value: function getPagination(query) {
            return _HemoStore2.default.getPagination(query);
        }
    }, {
        key: "getButtonListingPrefix",
        value: function getButtonListingPrefix() {
            return "Map From Hemo Record ";
        }
    }]);

    return HemoPlugin;
}(_BasePlugin3.default);

exports.default = HemoPlugin;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BasePlugin2 = __webpack_require__(179);

var _BasePlugin3 = _interopRequireDefault(_BasePlugin2);

var _EcmoEmrStore = __webpack_require__(230);

var _EcmoEmrStore2 = _interopRequireDefault(_EcmoEmrStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EcmoEmrPlugin = function (_BasePlugin) {
    _inherits(EcmoEmrPlugin, _BasePlugin);

    function EcmoEmrPlugin() {
        _classCallCheck(this, EcmoEmrPlugin);

        return _possibleConstructorReturn(this, (EcmoEmrPlugin.__proto__ || Object.getPrototypeOf(EcmoEmrPlugin)).apply(this, arguments));
    }

    _createClass(EcmoEmrPlugin, [{
        key: "initialize",
        value: function initialize(options) {
            _get(EcmoEmrPlugin.prototype.__proto__ || Object.getPrototypeOf(EcmoEmrPlugin.prototype), "initialize", this).call(this, options);

            this.set("name", "EcmoEmr");
            this.set("id", "ecmoemr");
            this.set("fluxContext", "CTX_MappingPlugin_EcmoEmr");

            this.set("fields", [{ key: "mrn", type: "string", name: "Medical Record Number" }]);
        }
    }, {
        key: "hasPaginationParams",
        value: function hasPaginationParams() {
            return true;
        }
    }, {
        key: "getPagination",
        value: function getPagination(query) {
            return _EcmoEmrStore2.default.getPagination(query);
        }
    }, {
        key: "getQueryLO",
        value: function getQueryLO(query, initiate, interactive) {
            return initiate ? _EcmoEmrStore2.default.getHotLO(query, interactive) : _EcmoEmrStore2.default.getColdLO(query);
        }
    }, {
        key: "getButtonListingPrefix",
        value: function getButtonListingPrefix() {
            return "Map From ECMO EMR Record ";
        }
    }]);

    return EcmoEmrPlugin;
}(_BasePlugin3.default);

exports.default = EcmoEmrPlugin;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BasePlugin2 = __webpack_require__(179);

var _BasePlugin3 = _interopRequireDefault(_BasePlugin2);

var _CrossAppStore = __webpack_require__(312);

var _CrossAppStore2 = _interopRequireDefault(_CrossAppStore);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _SearchFormStore = __webpack_require__(82);

var _SearchFormStore2 = _interopRequireDefault(_SearchFormStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CrossAppPlugin = function (_BasePlugin) {
    _inherits(CrossAppPlugin, _BasePlugin);

    function CrossAppPlugin() {
        _classCallCheck(this, CrossAppPlugin);

        return _possibleConstructorReturn(this, (CrossAppPlugin.__proto__ || Object.getPrototypeOf(CrossAppPlugin)).apply(this, arguments));
    }

    _createClass(CrossAppPlugin, [{
        key: "initialize",
        value: function initialize(options) {
            var _this2 = this;

            _get(CrossAppPlugin.prototype.__proto__ || Object.getPrototypeOf(CrossAppPlugin.prototype), "initialize", this).call(this, options);

            var searchStereotypes = options.mapping.searchStereotypes.map(function (it) {
                return {
                    stereotypeKey: it.searchStereotypeKey,
                    name: _this2.getStereotypeName(it.searchStereotypeKey),
                    implementingEntityKey: it.implementingEntityKey
                };
            });

            this.set("name", "Cross App");
            this.set("id", "cross-app");
            this.set("fluxContext", "CTX_MappingPlugin_CrossApp");
            this.set("searchStereotypes", searchStereotypes);
            this.set("selectedStereotype", searchStereotypes[0]);
            this.set("fields", this.getFields(searchStereotypes[0].stereotypeKey));
        }
    }, {
        key: "selectStereotype",
        value: function selectStereotype(stereotypeKey) {
            this.set("selectedStereotype", this.getSearchStereotype(stereotypeKey));
            this.set("fields", this.getFields(stereotypeKey));
            this.loadFields();
        }
    }, {
        key: "hasPaginationParams",
        value: function hasPaginationParams() {
            return true;
        }
    }, {
        key: "getPagination",
        value: function getPagination(query) {
            return _CrossAppStore2.default.getPagination(query);
        }
    }, {
        key: "getQueryLO",
        value: function getQueryLO(query, params, initiate, interactive) {
            return initiate ? _CrossAppStore2.default.getHotLO(query, params, this.get("selectedStereotype").stereotypeKey, this.get("selectedStereotype").implementingEntityKey, interactive) : _CrossAppStore2.default.getColdLO(query, this.get("selectedStereotype").implementingEntityKey);
        }
    }, {
        key: "getButtonListingPrefix",
        value: function getButtonListingPrefix() {
            return "Map From Cross-App Datasource";
        }
    }, {
        key: "getFields",
        value: function getFields(stereotypeKey) {
            return _StereotypesStore2.default.getStereotypeFieldsByKey(stereotypeKey);
        }
    }, {
        key: "getStereotypeName",
        value: function getStereotypeName(stereotypeKey) {
            return _StereotypesStore2.default.getStereotypeByKey(stereotypeKey).name;
        }
    }, {
        key: "searchInteractive",
        value: function searchInteractive() {
            var initiate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var params = this.collectionSearchParams();
            return this._searchInternal(params, initiate, true);
        }
    }, {
        key: "_searchInternal",
        value: function _searchInternal(params, initiate, interactive) {
            var query = this.getAsQuery();
            return this.getQueryLO(query, params, initiate, interactive).map(this.filterRecords);
        }
    }, {
        key: "getAsQuery",
        value: function getAsQuery() {
            return _SearchFormStore2.default.getQ(this.get("fluxContext")).toAS();
        }
    }, {
        key: "getSearchStereotype",
        value: function getSearchStereotype(stereotypeKey) {
            return this.get("searchStereotypes").find(function (stereotype) {
                return stereotype.stereotypeKey === stereotypeKey;
            });
        }
    }]);

    return CrossAppPlugin;
}(_BasePlugin3.default);

exports.default = CrossAppPlugin;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _MappingVisitor2 = __webpack_require__(231);

var _MappingVisitor3 = _interopRequireDefault(_MappingVisitor2);

var _TableAccess = __webpack_require__(77);

var _TableAccess2 = _interopRequireDefault(_TableAccess);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

var _entityFields = __webpack_require__(158);

var _infoTypeToFieldType = __webpack_require__(221);

var _SearchResultStore = __webpack_require__(159);

var _SearchResultStore2 = _interopRequireDefault(_SearchResultStore);

var _SuperRecordActions = __webpack_require__(25);

var _MappingStore = __webpack_require__(65);

var _Q = __webpack_require__(176);

var _Q2 = _interopRequireDefault(_Q);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _SuperRecordListStore = __webpack_require__(155);

var _SuperRecordListStore2 = _interopRequireDefault(_SuperRecordListStore);

var _TableMappingVisitor = __webpack_require__(483);

var _TableMappingVisitor2 = _interopRequireDefault(_TableMappingVisitor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var buildQuery = function buildQuery(fieldKeys, instance) {
    return _Q2.default.conjunction(fieldKeys.map(function (fn) {
        return _entityFieldMetaStore2.default.getInfo( // switch to fieldInfo
        instance.entityKey, fn);
    }).filter(function (fi) {
        return fi.type !== "FileField";
    }) // exclude file fields
    .map(function (fi) {
        return _Q2.default.ref(fi.key).eq(_Q2.default.value(instance.get(fi.key), (0, _infoTypeToFieldType.infoTypeToFieldType)(fi.type)));
    }));
};

var loadGlobalMatch = function loadGlobalMatch(it, targetKey, candidateFilter) {
    var targetInfo = _entityMetaStore2.default.getInfo(targetKey);
    var keyFields = targetInfo.keys[0].fieldKeys;
    var q = buildQuery(keyFields, it);
    var rawMatchFound = false;
    var lo = (0, _SuperRecordActions.clientFilteredSearch)(_SearchResultStore2.default, targetKey, q, null, 2, function (r) {
        rawMatchFound = true;
        return r.isRecordEnabled() && candidateFilter(r);
    });
    return {
        lo: lo,
        rawMatchFound: rawMatchFound
    };
};

var MappingWorkflowVisitor = function (_MappingVisitor) {
    _inherits(MappingWorkflowVisitor, _MappingVisitor);

    function MappingWorkflowVisitor(state) {
        _classCallCheck(this, MappingWorkflowVisitor);

        var _this = _possibleConstructorReturn(this, (MappingWorkflowVisitor.__proto__ || Object.getPrototypeOf(MappingWorkflowVisitor)).call(this, state, new _TableAccess2.default(_TableStore2.default.getState())));

        _this.__doItAgain = null;
        return _this;
    }

    _createClass(MappingWorkflowVisitor, [{
        key: "getState",
        value: function getState() {
            return this.state;
        }
    }, {
        key: "_doItAgain",
        value: function _doItAgain(reason) {
            if (this.__doItAgain == null) {
                this.__doItAgain = new Set();
            }
            this.__doItAgain.add(reason);
        }
    }, {
        key: "isDoItAgain",
        value: function isDoItAgain() {
            return this.__doItAgain != null;
        }
    }, {
        key: "getDoItAgainReason",
        value: function getDoItAgainReason() {
            var reasons = [];
            this.__doItAgain.forEach(function (r) {
                return reasons.push(r);
            });
            return reasons.join(", ");
        }
    }, {
        key: "loadIdPair",
        value: function loadIdPair(sourceId, recordKey, fieldKey, lo) {
            this.state = (0, _MappingStore.setPairLO)(this.state, sourceId, recordKey, fieldKey, lo);
        }

        // Returns the ensured pair (NOT wrapped in an LO!)

    }, {
        key: "ensureIdPair",
        value: function ensureIdPair(sourceId, recordKey, fieldKey, targetKey) {
            var global = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

            var curr = (0, _MappingStore.getPairLO)(this.state, sourceId, recordKey, fieldKey);
            var v = void 0;
            if (curr.hasValue()) {
                v = curr.getValueEnforcing();
                (0, _invariant2.default)(v.key === targetKey, "Ensuring on a different target key?! '%s' vs '%s'", v.key, targetKey);
            } else {
                v = {
                    key: targetKey,
                    id: _ClientId2.default.next(),
                    global: global
                };
            }
            this.loadIdPair(sourceId, recordKey, fieldKey, _LoadObject2.default.withValue(v));
            return v;
        }
    }, {
        key: "doRecord",
        value: function doRecord(ctx, target, excluded, source, type, edgeInfo) {
            if (excluded) return;
            _get(MappingWorkflowVisitor.prototype.__proto__ || Object.getPrototypeOf(MappingWorkflowVisitor.prototype), "doRecord", this).call(this, ctx, target, excluded, source, type, edgeInfo);
        }
    }, {
        key: "doMagicRoot",
        value: function doMagicRoot(ctx, target, excluded, fieldInfo, sourceValue) {
            this.loadIdPair(sourceValue.id, target.getKey(), fieldInfo.key, _LoadObject2.default.withValue({
                key: fieldInfo.otherEntityKey,
                id: target.get(fieldInfo).id
            }));
            _get(MappingWorkflowVisitor.prototype.__proto__ || Object.getPrototypeOf(MappingWorkflowVisitor.prototype), "doMagicRoot", this).call(this, ctx, target, excluded, fieldInfo, sourceValue);
        }
    }, {
        key: "doGlobalAssoc",
        value: function doGlobalAssoc(ctx, target, excluded, fieldInfo, sourceValue, createIfMissing) {
            var _this2 = this;

            var candidateFilter = (0, _entityFields.getCandidateFilter)(fieldInfo, target);
            var matchesPending = false;
            this.__forEach(sourceValue, function (it) {
                var _loadGlobalMatch = loadGlobalMatch(_this2._getGarageGlobal(it, fieldInfo.otherEntityKey), fieldInfo.otherEntityKey, candidateFilter),
                    lo = _loadGlobalMatch.lo,
                    rawMatchFound = _loadGlobalMatch.rawMatchFound;

                if (!lo.hasValue()) {
                    if (lo.getError() === _SuperRecordActions.ERR_NOT_YET_PROCESSED_BY_TABLESTORE) {
                        /*
                         The issue is that clientFilteredSearch needs to get records
                         from TableStore, and TableStore needs to have the mapping
                         work done before it can execute mapping. That is, the fact
                         that this bit of code right here is running means we're
                         processing a LOADED action on some global being searched
                         for, but we have a cyclic dependency between MappingStore
                         and TableStore. Specifically, the mapping code needs to run
                         after TableStore has jammed the newly-LOADED record into
                         its state, but before TableStore reevaluates the mapping
                         operation currently in progress.
                         */
                        _this2._doItAgain("Load global into TableStore");
                    }
                    _this2.loadIdPair(it.id, target.getKey(), fieldInfo.key, _LoadObject2.default.loading("garbage"));
                    matchesPending = true;
                    return;
                }
                var matches = lo.getRequiredValue();
                if (matches.length === 0) {
                    if (createIfMissing && !rawMatchFound) {
                        _this2.ensureIdPair(it.id, target.getKey(), fieldInfo.key, fieldInfo.otherEntityKey, true);
                    } else {
                        _this2.loadIdPair(it.id, target.getKey(), fieldInfo.key, _LoadObject2.default.withError(_MappingStore.ERR_NO_MATCH_FOUND));
                    }
                } else if (matches.length === 1) {
                    // do we need to process a previous match?
                    // do we need to clean up a previously created value?
                    _this2.loadIdPair(it.id, target.getKey(), fieldInfo.key, _LoadObject2.default.withValue({
                        key: fieldInfo.otherEntityKey,
                        id: matches[0].id,
                        global: true
                    }));
                } else {
                    _this2.loadIdPair(it.id, target.getKey(), fieldInfo.key, _LoadObject2.default.withError(_MappingStore.ERR_MULTIPLE_MATCHES_FOUND));
                }
            });
            if (matchesPending) return;
            _get(MappingWorkflowVisitor.prototype.__proto__ || Object.getPrototypeOf(MappingWorkflowVisitor.prototype), "doGlobalAssoc", this).call(this, ctx, target, excluded, fieldInfo, sourceValue, createIfMissing);
        }
    }, {
        key: "doComposition",
        value: function doComposition(ctx, target, excluded, fieldInfo, sourceValue) {
            var _this3 = this;

            var hasNew = false;
            this.__forEach(sourceValue, function (it) {
                var p = _this3.ensureIdPair(it.id, target.getKey(), fieldInfo.key, fieldInfo.otherEntityKey);
                hasNew = hasNew || !_this3.access.hasEntityRecord(p.key, p.id);
            });
            // Do we need to wait for TableStore to do it's thing?
            if (!hasNew) {
                _get(MappingWorkflowVisitor.prototype.__proto__ || Object.getPrototypeOf(MappingWorkflowVisitor.prototype), "doComposition", this).call(this, ctx, target, excluded, fieldInfo, sourceValue);
            }
        }
    }, {
        key: "_getGarageGlobal",
        value: function _getGarageGlobal(sourceGlobal, targetEK) {
            var garageAccess = new _TableAccess2.default(_TableStore2.default.getInitialState());
            var garageId = _ClientId2.default.next();
            garageAccess.createEntityRecord(targetEK, garageId);
            var garageGlobal = garageAccess.getEntityProxy(targetEK, garageId);
            var tmv = new _TableMappingVisitor2.default({
                target: garageGlobal,
                source: sourceGlobal,
                modelLO: _LoadObject2.default.withValue(null)
            }, garageAccess);
            tmv.execute();
            return garageGlobal;
        }
    }, {
        key: "doAutomanaged",
        value: function doAutomanaged(ctx, target, excluded, fieldInfo, autoManagedByFieldInfo, sourceValue, sourceManagedByGetter) {
            var _this4 = this;

            // Get the  list of target global records
            var gEK = autoManagedByFieldInfo.otherEntityKey;
            var targetGlobalsLO = (0, _SuperRecordActions.clientFilteredList)(_SuperRecordListStore2.default, this.access, gEK
            // don't test here, so we only have to assemble the list once...
            );
            if (!targetGlobalsLO.hasValue()) return;
            var targetGlobals = targetGlobalsLO.getValueEnforcing();

            // For each source, see if there's a target, and record it if there is
            var globalInfo = _entityMetaStore2.default.getInfo(gEK);
            var keyFields = globalInfo.keys ? globalInfo.keys[0].fieldKeys : [];
            var amtl = this.__getAutomanagedTargetLookup(target, fieldInfo);
            if (amtl == null) return;
            this.__forEach(sourceValue, function (s) {
                var sourceGlobal = sourceManagedByGetter(s);
                var garageGlobal = _this4._getGarageGlobal(sourceGlobal, gEK);
                var q = buildQuery(keyFields, garageGlobal);
                var targetGlobal = targetGlobals.find(q.test);
                if (targetGlobal == null) return;
                if (!amtl.hasOwnProperty(targetGlobal.id)) return;
                // child -> child
                _this4.loadIdPair(s.id, target.entityKey, fieldInfo.key, _LoadObject2.default.withValue({
                    key: fieldInfo.otherEntityKey,
                    id: amtl[targetGlobal.id].id
                }));
                // global -> global
                _this4.loadIdPair(sourceGlobal.id, amtl[targetGlobal.id].getKey(), fieldInfo.autoManageKey, _LoadObject2.default.withValue({
                    key: gEK,
                    id: targetGlobal.id,
                    global: true
                }));
            });

            // Recurse
            _get(MappingWorkflowVisitor.prototype.__proto__ || Object.getPrototypeOf(MappingWorkflowVisitor.prototype), "doAutomanaged", this).call(this, ctx, target, excluded, fieldInfo, autoManagedByFieldInfo, sourceValue, sourceManagedByGetter);
        }
    }, {
        key: "doCrossTree",
        value: function doCrossTree(ctx, target, excluded, fieldInfo, sourceValue) {
            var _this5 = this;

            this.__forEach(sourceValue, function (it) {
                // These _deliberately_ don't use the helpers. Composed children are
                // managed synchronously throughout all the mapping machinery, and
                // CTAs are always between newly-created composed children, so the
                // data is guaranteed available at this point. Since TableStore will
                // end up updating (to create the children), the workflow will end
                // up running again, but there's no point in waiting, since we can
                // make the above guarantee.
                var lo = (0, _MappingStore.getPairedIdLO)(_this5.state, it.id, fieldInfo.entityKey, // compositions are only entity-scoped, not record-scoped
                fieldInfo.key);
                if (lo.hasValue()) return; // gravy!
                lo = (0, _MappingStore.getPairedIdLO_unqualified)(_this5.state, it.id);
                _this5.loadIdPair(it.id, target.getKey(), fieldInfo.key, _LoadObject2.default.withValue({
                    key: fieldInfo.otherEntityKey,
                    id: lo.getValueEnforcing()
                }));
            });
        }
    }, {
        key: "shouldDoField",
        value: function shouldDoField(ctx, target, excluded, fieldInfo) {
            // we don't care about fields at all
            return false;
        }
    }]);

    return MappingWorkflowVisitor;
}(_MappingVisitor3.default);

exports.default = MappingWorkflowVisitor;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSelfToSelfMappingDefs = exports.buildSelfToSelfMappingDef = exports.buildCrossTreeInfo = exports.getAllParentsEntityInfo = exports.buildCrossTreeDef = exports.buildChildDef = undefined;

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _MappingInfoStore = __webpack_require__(160);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildChildDef = exports.buildChildDef = function buildChildDef(edgeKey, sourceKey, type) {
    return {
        edge: {
            fieldKey: edgeKey,
            sourceFieldKey: edgeKey
        },
        sourceKey: sourceKey,
        targetKey: sourceKey,
        type: type
    };
};

var buildCrossTreeDef = exports.buildCrossTreeDef = function buildCrossTreeDef(fieldKey, ownerPath) {
    return {
        fieldKey: fieldKey,
        sourceFieldKey: fieldKey,
        sourceOwnerPath: ownerPath,
        targetOwnerPath: ownerPath
    };
};

var getAllParentsEntityInfo = exports.getAllParentsEntityInfo = function getAllParentsEntityInfo(info) {
    var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    if (!info.parentPointerKey) {
        return [];
    }
    var pInfo = _entityFieldMetaStore2.default.getInfo(info.key, info.parentPointerKey);
    parents.push(pInfo);
    if (pInfo.parentPointerKey === "parent") {
        // recursive
        return getAllParentsEntityInfo(pInfo, parents);
    }
    return parents;
};

var buildCrossTreeInfo = exports.buildCrossTreeInfo = function buildCrossTreeInfo(sourceEntityInfo, targetEntityInfo) {
    var sourceParentsInfo = getAllParentsEntityInfo(sourceEntityInfo);
    var targetParentsInfo = getAllParentsEntityInfo(targetEntityInfo);
    // find common ancestors and use inverse key as path
    var path = [];
    var rootKey = sourceEntityInfo.key;
    breakAll: for (var spIndex in sourceParentsInfo) {
        var spi = sourceParentsInfo[spIndex];
        for (var tpIndex in targetParentsInfo) {
            var tpi = targetParentsInfo[tpIndex];
            if (spi.otherEntityKey === tpi.otherEntityKey) {
                rootKey = tpi.otherEntityKey;
                path.push(spi.inverseKey);
                break breakAll; // break out of both, all done.
            }
        }
    }
    return {
        rootKey: rootKey, // key where crossTree def belongs
        path: path // parent path from root to field
    };
};

var buildSelfToSelfMappingDef = exports.buildSelfToSelfMappingDef = function buildSelfToSelfMappingDef(KeyOrEntityInfo) {
    var entityInfo = typeof KeyOrEntityInfo === "string" ? _entityMetaStore2.default.getInfo(KeyOrEntityInfo) : KeyOrEntityInfo;
    var entityFieldInfos = _entityFieldMetaStore2.default.getAllInfos(entityInfo.key);
    var children = [];
    var fields = [];
    var crossTree = [];
    var ei = {};
    entityFieldInfos.forEach(function (fi) {
        if (fi.mrPointer) return; // ignore magic root pointer fields
        if (fi.calculated && !fi.nonUpdateable) return; // ignore updateable calculated fields
        if (fi.offForm) return; // ignore off-form fields
        switch (fi.type) {
            case "FileField": // file fields should not be mapped.
            case "InverseAssociationField":
                // will be taken care of for free.
                break;
            case "AssociationField":
                ei = _entityMetaStore2.default.getInfo(fi.otherEntityKey);
                if (ei.type === "GLOBAL") {
                    children.push(buildChildDef(fi.key, fi.otherEntityKey, _MappingInfoStore.FT_GLOBAL_REFERENCE_ONLY));
                } else {
                    // if ei.type is not global then it is a cross tree.
                    // this is just indicator that we have a cross tree
                    // the cross tree belongs to a different mapping definition.
                    var cti = buildCrossTreeInfo(entityInfo, ei);
                    crossTree.push({
                        key: cti.rootKey,
                        def: buildCrossTreeDef(fi.key, cti.path)
                    });
                }
                break;
            case "CompositionField":
                // always children
                if (!!fi.autoManageKey) {
                    // TODO: we remove auto managed fields here because mapping
                    // exclusions currently does not support the ability to
                    // exclude all of its child fields. This gets us around that
                    // limitation.
                    return;
                }
                ei = _entityMetaStore2.default.getInfo(fi.otherEntityKey);
                children.push(buildChildDef(fi.key, fi.otherEntityKey, _MappingInfoStore.FT_CHILD));
                break;
            default:
                // everything else is a field
                fields.push({
                    fieldKey: fi.key,
                    sourceFieldKey: fi.key
                });
        }
    });

    return {
        INFO: {
            children: children,
            crossTrees: [], // has to be reconciled outside this function.
            fields: fields,
            sourceKey: entityInfo.key, // should be the same
            targetKey: entityInfo.key,
            type: entityInfo.type
        },
        crossTreeRoots: crossTree // used to reconcile crossTrees
    };
};

var getSelfToSelfMappingDefs = exports.getSelfToSelfMappingDefs = function getSelfToSelfMappingDefs() {
    var mappingDefs = [];
    var crossTreeDefs = {};
    _entityMetaStore2.default.getAllInfos().forEach(function (info) {
        var def = buildSelfToSelfMappingDef(info);
        if (def.crossTreeRoots.length) {
            // store cross tree definitions in lookup table keyed by who it belong to.
            def.crossTreeRoots.forEach(function (ct) {
                if (!crossTreeDefs[ct.key]) {
                    crossTreeDefs[ct.key] = [];
                }
                crossTreeDefs[ct.key].push(ct.def);
            });
        }
        delete def.crossTreeRoots; // removed
        mappingDefs.push(def);
    });
    mappingDefs.forEach(function (def) {
        if (crossTreeDefs.hasOwnProperty(def.INFO.sourceKey)) {
            // add cross tree to def.INFO.crossTrees
            def.INFO.crossTrees = crossTreeDefs[def.INFO.sourceKey];
        }
    });
    return mappingDefs;
};

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildMergeExclusions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _TableAccess = __webpack_require__(77);

var _TableAccess2 = _interopRequireDefault(_TableAccess);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _MappingStore = __webpack_require__(65);

var _BuildMappingTreeVisitor = __webpack_require__(314);

var _BuildMappingTreeVisitor2 = _interopRequireDefault(_BuildMappingTreeVisitor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildMergeExclusions = exports.buildMergeExclusions = function buildMergeExclusions(state) {
    state = _extends({}, state);
    var tree = new _BuildMappingTreeVisitor2.default(state, new _TableAccess2.default(_TableStore2.default.getState()), new _TableAccess2.default(_TableStore2.default.getSnapshot())).execute().getTree();

    var processItem = function processItem(st, fields) {
        // By Default, the checkboxes should be Unchecked if the Post-Mapped
        // value (targetValue) is NULL, and the Pre-Mapped value (sourceValue)
        // is NOT NULL; else, they should be CHECKED. (user can then override
        // as desired)
        st = (fields || []).reduce(function (s, field) {
            if (Array.isArray(field.children) && field.children.length) {
                s = processItem(s, field.children); // walk
            }
            return (0, _MappingStore.setExclusion)(s, field.exclusionInfo.recordId, field.exclusionInfo.columnKey, field.itemKey, !(field.targetValue == null && field.sourceValue != null));
        }, st);
        return st;
    };

    state = processItem(state, tree.children);

    return state.exclusions;
};

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var isMoment = function isMoment(value) {
    return value.hasOwnProperty("_d") && value.hasOwnProperty("_a") && value.hasOwnProperty("_isUTC");
};

exports.default = isMoment;

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LiveMap = __webpack_require__(178);

var _LiveMap2 = _interopRequireDefault(_LiveMap);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _superRecords = __webpack_require__(63);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _SuperRecordStore = __webpack_require__(36);

var _SuperRecordStore2 = _interopRequireDefault(_SuperRecordStore);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

var _records = __webpack_require__(113);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LockBuilder = function () {
    function LockBuilder(tableAccess, key, id) {
        _classCallCheck(this, LockBuilder);

        this.access = tableAccess;
        this.entityToWritable = new _LiveMap2.default(function (ek) {
            var info = _entityMetaStore2.default.getInfo(ek);
            return info.canWrite || info.canDelete;
        });
        this.locks = new Map(); // Map<table, Map<id, {id, _ts}>>

        this._lockEntityRecord = this._lockEntityRecord.bind(this);

        if (key.indexOf("/") > 0) {
            this.lockEntityRecord(key, id);
        } else {
            this.lockStereoRecord(key, id);
        }
    }

    _createClass(LockBuilder, [{
        key: "_isEntityWritable",
        value: function _isEntityWritable(entityKey) {
            return this.entityToWritable.get(entityKey);
        }
    }, {
        key: "_lockEntityRecord",
        value: function _lockEntityRecord(ep) {
            if (!this._isEntityWritable(ep.entityKey)) {
                return;
            }
            if (_ClientId2.default.is(ep.id)) {
                return;
            }
            var tk = ep.entityInfo.tableKey;
            if (!this.locks.has(tk)) {
                this.locks.set(tk, new Map());
            }
            var id = ep.id;
            this.locks.get(tk).set(id, { id: id, _ts: ep.getRecordMeta().ts });
            (0, _records.getChildren)(ep).forEach(this._lockEntityRecord);
        }
    }, {
        key: "lockEntityRecord",
        value: function lockEntityRecord(key, id) {
            if (!this._isEntityWritable(key)) {
                return;
            }
            this._lockEntityRecord(this.access.getEntityProxy(key, id));
        }
    }, {
        key: "lockStereoRecord",
        value: function lockStereoRecord(key, id) {
            var _this = this;

            var si = _StereotypesStore2.default.getStereotypeByKey(key);
            si.implementations
            // the record exists (not a multi-table global)
            .filter(function (it) {
                return _this.access.hasEntityRecord(it.key, id);
            })
            // can write to the impl
            .filter(function (it) {
                return _this._isEntityWritable(it.key);
            })
            // lock it!
            .forEach(function (it) {
                return _this.lockEntityRecord(it.key, id);
            });
            if (si.magicRoot) {
                (0, _superRecords.getTopLevelRecords)(_TableStore2.default, _SuperRecordStore2.default.getRecord(key, id)).forEach(this._lockEntityRecord);
            }
        }
    }, {
        key: "isEmpty",
        value: function isEmpty() {
            return this.locks.size === 0;
        }
    }, {
        key: "toLockSet",
        value: function toLockSet() {
            var locks = {};
            this.locks.forEach(function (ls, tn) {
                return locks[tn] = Array.from(ls.values());
            });
            return {
                id: _ClientId2.default.next(),
                locks: locks
            };
        }
    }]);

    return LockBuilder;
}();

exports.default = LockBuilder;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function oxfordList(items) {
    if (typeof items === "string") {
        return items;
    }
    if (!items || !(Symbol.iterator in items)) {
        return "" + items;
    }
    items = Array.from(items).map(function (it) {
        return "" + it;
    });
    if (items.length === 0) {
        return "";
    }
    if (items.length === 1) {
        return items[0];
    }
    if (items.length === 2 && items.join) {
        return items.join(" and ");
    }
    var last = items.pop();
    return items.join(", ") + ", and " + last;
}

exports.default = oxfordList;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = ModalPrompt;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _text = __webpack_require__(298);

var _text2 = _interopRequireDefault(_text);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _Button = __webpack_require__(52);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ModalPrompt(_ref) {
    var title = _ref.title,
        label = _ref.label,
        initialValue = _ref.initialValue,
        callback = _ref.callback;

    var _React$useState = _react2.default.useState(initialValue),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        value = _React$useState2[0],
        setValue = _React$useState2[1];

    var formRef = _react2.default.useRef(null);
    _react2.default.useLayoutEffect(function () {
        if (!formRef.current || !formRef.current.elements) return;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = formRef.current.elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var el = _step.value;

                if (el.classList && el.classList.contains("focusable")) {
                    el.focus && el.focus();
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }, []);

    function handleOk(e) {
        e && e.preventDefault();
        callback(value);
    }

    function handleCancel() {
        callback(null);
    }

    return _react2.default.createElement(
        "form",
        {
            ref: formRef,
            className: "modal-prompt",
            action: "#unbound",
            onSubmit: handleOk
        },
        _react2.default.createElement(
            "header",
            null,
            _react2.default.createElement(
                "h4",
                { className: "title" },
                title
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "loading-body" },
            _react2.default.createElement(
                "fieldset",
                { style: { display: "flex", flexDirection: "column", gap: "1em" } },
                _react2.default.createElement(_text2.default, {
                    descriptor: {
                        id: "value",
                        key: "value",
                        type: "string",
                        control: "text",
                        label: label,
                        disableBehaviour: "disable",
                        config: {},
                        required: true
                    },
                    value: value,
                    onCommitChange: function onCommitChange(desc, val) {
                        return setValue(val);
                    },
                    enabled: true
                }),
                _react2.default.createElement(
                    _ControlTemplate2.default,
                    {
                        descriptor: {
                            id: "modal-actions",
                            key: "actions",
                            type: "widget",
                            control: "button",
                            label: "",
                            disableBehaviour: "disable",
                            config: {}
                        }
                    },
                    _react2.default.createElement(_Button2.default, {
                        label: "OK",
                        onClick: handleOk,
                        className: "btn btn-primary",
                        enabled: true
                    }),
                    _react2.default.createElement(_Button2.default, {
                        label: "Cancel",
                        onClick: handleCancel,
                        className: "btn btn-default",
                        enabled: true
                    })
                )
            )
        )
    );
}

ModalPrompt.propTypes = {
    title: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired,
    initialValue: _propTypes2.default.string.isRequired,
    callback: _propTypes2.default.func.isRequired
};

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _HybridConfig = __webpack_require__(41);

var _HybridConfig2 = _interopRequireDefault(_HybridConfig);

var _audit = __webpack_require__(173);

var _entityFields = __webpack_require__(158);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _or_munge_info(statics) {
    if (statics == null) return null;
    statics.KEY = statics.INFO.key;
    statics.TABLE = statics.INFO.logicalKey;
    statics.LABEL = statics.INFO.name;
    statics.PLURAL_LABEL = statics.INFO.pluralName;
    statics.ORDERING_COMPONENTS = statics.INFO.orderingComponents;
    statics.KEYS = statics.INFO.keys;
    statics.IMPLEMENTATION = (statics.KEY || "").split("/")[0];
    statics.FIELD_ORDER = {};
    statics.FIELD_INFO = {};
    statics.LOGICAL_KEY_MAP = {};
    var iterable = statics.INFO.fields || [];
    for (var i = 0; i < iterable.length; i++) {
        var f = iterable[i];
        f.order = i;
        statics.FIELD_ORDER[f.key] = i;
        statics.FIELD_INFO[f.key] = f;
        if (f.key !== f.logicalKey) {
            statics.LOGICAL_KEY_MAP[f.key] = f.logicalKey;
        }
        if (f.hasOwnProperty("conditions")) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = f.conditions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var c = _step.value;

                    c.expression = Function("instance", "return " + c.expression + ";");
                    if (_HybridConfig2.default.auditScriptlets()) {
                        c.expression = (0, _audit.auditable)("choicecondition", c.expression);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        var scripts = f.scripts;

        if (Object.keys(scripts).length === 0) {
            continue;
        }
        var object = {
            ENABLEMENT: ["enable"],
            ASSIGNMENT: ["recalc"],
            VALIDATION: ["validation", "minLength", "maxLength", "min", "max", "usualMin", "usualMax"],
            CANDIDATE_FILTER: ["filter", "partialFilter"]
        };
        for (var depType in object) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = object[depType][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var sn = _step2.value;

                    if (scripts.hasOwnProperty(sn) && scripts[sn] != null) {
                        if (sn === "filter") {
                            scripts[sn] = Function("instance", "it" /*com.armus.script.transform.MapperBinder.ITEM_NAME*/
                            , "return " + scripts[sn] + ";");
                        } else if (sn === "partialFilter") {
                            if (_HybridConfig2.default.get("ui.usePartialCandidateFilter", true) == false) {
                                // allows testing of fallback candidateFilter search.
                                scripts[sn] = null;
                                continue;
                            }
                            scripts[sn] = (0, _entityFields.buildInterpolator)(scripts[sn]);
                        } else if (f.type === "DecimalField" && ["recalc", "min", "max", "usualMin", "usualMax"].includes(sn)) {
                            // per HO-2159, taken from the old `vfac` macro
                            scripts[sn] = function (raw) {
                                return function (instance) {
                                    var v = raw(instance);
                                    if (v != null) {
                                        v = v.toString();
                                    }
                                    return v;
                                };
                            }(Function("instance", scripts[sn]));
                        } else {
                            scripts[sn] = Function("instance", scripts[sn]);
                        }
                        if (_HybridConfig2.default.auditScriptlets()) {
                            scripts[sn] = (0, _audit.auditable)(sn, scripts[sn]);
                        }
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    }
    if (statics.ASSOCIATIONS != null) {
        for (var k in statics.ASSOCIATIONS) {
            var v = statics.ASSOCIATIONS[k];
            statics.ASSOCIATIONS[k] = v.split(",");
        }
    }
    return statics;
} /* eslint-disable no-new-func */
exports.default = _or_munge_info;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _MappingVisitor2 = __webpack_require__(231);

var _MappingVisitor3 = _interopRequireDefault(_MappingVisitor2);

var _MappingStore = __webpack_require__(65);

var _MappingStore2 = _interopRequireDefault(_MappingStore);

var _TableAccess = __webpack_require__(77);

var _TableAccess2 = _interopRequireDefault(_TableAccess);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _SuperRecordStore = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SuperRecordMappingVisitor = function (_MappingVisitor) {
    _inherits(SuperRecordMappingVisitor, _MappingVisitor);

    function SuperRecordMappingVisitor(state) {
        _classCallCheck(this, SuperRecordMappingVisitor);

        var _this = _possibleConstructorReturn(this, (SuperRecordMappingVisitor.__proto__ || Object.getPrototypeOf(SuperRecordMappingVisitor)).call(this, _MappingStore2.default.getState(), new _TableAccess2.default(_TableStore2.default.getState())));

        _this.srstate = state;
        return _this;
    }

    _createClass(SuperRecordMappingVisitor, [{
        key: "getState",
        value: function getState() {
            return this.srstate;
        }
    }, {
        key: "doGlobalAssoc",
        value: function doGlobalAssoc(ctx, target, excluded, fieldInfo, sourceValue, createIfMissing) {
            var _this2 = this;

            if (!createIfMissing) return;
            this.__forEach(sourceValue, function (it) {
                var lo = _this2.__getTargetIdLO(it, target, fieldInfo);
                if (!lo.hasValue()) return;
                var id = lo.getValueEnforcing();
                if ((0, _MappingStore.isExcluded)(_this2.state, target.id, fieldInfo.logicalColumn, id)) return;
                if (_this2.srstate[id] != null) return;
                _this2.srstate = (0, _SuperRecordStore.addNew)(_this2.srstate, fieldInfo.otherEntityKey, id);
            });
            return _get(SuperRecordMappingVisitor.prototype.__proto__ || Object.getPrototypeOf(SuperRecordMappingVisitor.prototype), "doGlobalAssoc", this).call(this, ctx, target, excluded, fieldInfo, sourceValue, createIfMissing);
        }
    }]);

    return SuperRecordMappingVisitor;
}(_MappingVisitor3.default);

exports.default = SuperRecordMappingVisitor;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _QuarterYearSelect = __webpack_require__(81);

var _QuarterYearSelect2 = _interopRequireDefault(_QuarterYearSelect);

var _useKeyValueState3 = __webpack_require__(38);

var _useKeyValueState4 = _interopRequireDefault(_useKeyValueState3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormView = function FormView(_ref) {
    var _onChange = _ref.onChange,
        state = _ref.state,
        data = _ref.data;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Participant ID"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "particid",
                            className: "participant form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("particid", v);
                            },
                            value: state.particid,
                            options: data.particid,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Quarter"
                ),
                _react2.default.createElement(_QuarterYearSelect2.default, {
                    quarter: state.quarter,
                    year: state.year,
                    min: data.daterange.from,
                    max: data.daterange.to,
                    onChange: _onChange,
                    disabled: !state.particid,
                    required: true
                }),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Submission Type"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "submissionType",
                            className: "submissionType form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("submissionType", v);
                            },
                            value: state.submissionType,
                            options: data.submissionType,
                            disabled: !state.particid
                        })
                    )
                )
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Export Options"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "checkbox" },
                    _react2.default.createElement(
                        "label",
                        null,
                        _react2.default.createElement("input", {
                            type: "checkbox",
                            className: "exclude_ncdr_patient_identifiers",
                            onChange: function onChange(e) {
                                return _onChange("excludePatientIdentifiers", e.target.checked ? "true" : "false");
                            },
                            checked: state.excludePatientIdentifiers === "true"
                        }),
                        "Exclude NCDR Patient Identifiers"
                    )
                )
            )
        )
    );
};

var selectShape = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
}));

FormView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    state: _propTypes2.default.shape({
        start: _propTypes2.default.string,
        end: _propTypes2.default.string,
        submissionType: _propTypes2.default.string,
        excludePatientIdentifiers: _propTypes2.default.string,
        particid: _propTypes2.default.string
    }),
    data: _propTypes2.default.shape({
        particid: selectShape,
        quarter: _propTypes2.default.string,
        year: _propTypes2.default.string,
        submissionType: _propTypes2.default.array
    })
};

var asString = function asString(v) {
    return v == null ? "" : v.toString();
};

var initialStateWithDefaults = function initialStateWithDefaults() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        quarter: asString(state.quarter),
        year: asString(state.year),
        particid: asString(state.particid),
        submissionType: asString(state.submissionType),
        excludePatientIdentifiers: asString(state.excludePatientIdentifiers)
    };
};

var initialData = {
    particid: [],
    daterange: { from: [], to: [] },
    submissionType: [{ value: "", label: "" }, { value: "1", label: "Episode of Care Records" }, { value: "2", label: "Follow-Up Records" }]
};

var StsAccTvtExportForm = function StsAccTvtExportForm(_ref2) {
    var initialState = _ref2.initialState,
        needServerData = _ref2.needServerData,
        onReady = _ref2.onReady,
        onNotReady = _ref2.onNotReady;

    var _React$useState = _react2.default.useState(function () {
        return initialStateWithDefaults(initialState);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(initialStateWithDefaults(initialState));
    }, [initialState]);

    var _useKeyValueState = (0, _useKeyValueState4.default)(initialData),
        _useKeyValueState2 = _slicedToArray(_useKeyValueState, 2),
        data = _useKeyValueState2[0],
        setDataKey = _useKeyValueState2[1];

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/participants",
            loadingMessage: "Loading Participants...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.particid + ": " + it.hospname,
                        value: it.particid
                    };
                });
                data.unshift({ label: "", value: "" });
                setDataKey("particid", data);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var particid = state.particid;

        if (!particid) return;
        needServerData({
            endpoint: "/date-range",
            loadingMessage: "Loading Available Date Range...",
            params: {
                particid: particid
            },
            onData: function onData(data) {
                return setDataKey("daterange", { from: data.from, to: data.to });
            }
        });
    }, [state.particid]);

    _react2.default.useEffect(function () {
        if (state.quarter && state.year && state.particid) {
            onReady(_extends({}, state));
        } else {
            onNotReady();
        }
    }, [state]);

    var handleChange = _react2.default.useCallback(function (key, value) {
        return setState(function (s) {
            return _extends({}, s, _defineProperty({}, key, value));
        });
    }, [setState]);

    return _react2.default.createElement(FormView, {
        state: state,
        data: data,
        onChange: handleChange
    });
};

StsAccTvtExportForm.propTypes = {
    initialState: _propTypes2.default.shape({
        quarter: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        year: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        particid: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        submissionType: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        excludePatientIdentifiers: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string])
    }),
    needServerData: _propTypes2.default.func.isRequired,
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

StsAccTvtExportForm.canRerun = function (params) {
    return !!(params && params.particid);
};

StsAccTvtExportForm.apiPrefix = "tvt";

exports.default = StsAccTvtExportForm;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _QuarterYearSelect = __webpack_require__(81);

var _QuarterYearSelect2 = _interopRequireDefault(_QuarterYearSelect);

var _useKeyValueState3 = __webpack_require__(38);

var _useKeyValueState4 = _interopRequireDefault(_useKeyValueState3);

var _formRegistry = __webpack_require__(74);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormView = function FormView(_ref) {
    var _onChange = _ref.onChange,
        state = _ref.state,
        data = _ref.data;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Participant ID"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "particid",
                            className: "participant form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("particid", v);
                            },
                            value: state.particid,
                            options: data.particid,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Quarter"
                ),
                _react2.default.createElement(_QuarterYearSelect2.default, {
                    quarter: state.quarter,
                    year: state.year,
                    min: data.daterange.from,
                    max: data.daterange.to,
                    onChange: _onChange,
                    disabled: !state.particid,
                    required: true
                }),
                _react2.default.createElement(
                    "div",
                    { className: "ncdr-attention after-form-group" },
                    "Attention: The NCDR will not accept harvest files prior to Q1/2018."
                ),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Submission Type"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "submissionType",
                            className: "submissionType form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("submissionType", v);
                            },
                            value: state.submissionType,
                            options: data.submissionType,
                            disabled: !state.particid
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "ncdr-attention after-form-group" },
                    "Attention: Auxiliary Dataset Submissions are no longer accepted for Discharge dates after 6/30/2023. (COVID-19 dataset discontinued as of 7/1/23; Shockwave discontinued as of 2/1/23)"
                )
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Export Options"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "checkbox" },
                    _react2.default.createElement(
                        "label",
                        null,
                        _react2.default.createElement("input", {
                            type: "checkbox",
                            className: "exclude_diagnostic_cath_only",
                            onChange: function onChange(e) {
                                return _onChange("excludeDiagnosticCathOnly", e.target.checked ? "true" : "false");
                            },
                            checked: state.excludeDiagnosticCathOnly === "true"
                        }),
                        "Exclude Diagnostic Cath Only Episodes"
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "checkbox" },
                    _react2.default.createElement(
                        "label",
                        null,
                        _react2.default.createElement("input", {
                            type: "checkbox",
                            className: "exclude_ncdr_patient_identifiers",
                            onChange: function onChange(e) {
                                return _onChange("excludePatientIdentifiers", e.target.checked ? "true" : "false");
                            },
                            checked: state.excludePatientIdentifiers === "true"
                        }),
                        "Exclude NCDR Patient Identifiers"
                    )
                )
            )
        )
    );
};

var selectShape = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
}));

FormView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    state: _propTypes2.default.shape({
        start: _propTypes2.default.string,
        end: _propTypes2.default.string,
        submissionType: _propTypes2.default.string,
        excludePatientIdentifiers: _propTypes2.default.string,
        excludeDiagnosticCathOnly: _propTypes2.default.string,
        particid: _propTypes2.default.string
    }),
    data: _propTypes2.default.shape({
        particid: selectShape,
        quarter: _propTypes2.default.string,
        year: _propTypes2.default.string,
        submissionType: _propTypes2.default.array
    })
};

var asString = function asString(v) {
    return v == null ? "" : v.toString();
};

var initialStateWithDefaults = function initialStateWithDefaults() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        quarter: asString(state.quarter),
        year: asString(state.year),
        particid: asString(state.particid),
        submissionType: asString(state.submissionType) || "",
        excludePatientIdentifiers: asString(state.excludePatientIdentifiers) || "false",
        excludeDiagnosticCathOnly: asString(state.excludeDiagnosticCathOnly) || "false"
    };
};

var initialData = {
    particid: [],
    daterange: { from: [], to: [] }
};

var AccCathPciExportForm = function AccCathPciExportForm(_ref2) {
    var initialState = _ref2.initialState,
        needServerData = _ref2.needServerData,
        onReady = _ref2.onReady,
        onNotReady = _ref2.onNotReady;

    var _React$useState = _react2.default.useState(function () {
        return initialStateWithDefaults(initialState);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(initialStateWithDefaults(initialState));
    }, [initialState]);

    var _useKeyValueState = (0, _useKeyValueState4.default)(initialData),
        _useKeyValueState2 = _slicedToArray(_useKeyValueState, 2),
        data = _useKeyValueState2[0],
        setDataKey = _useKeyValueState2[1];

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/participants",
            loadingMessage: "Loading Participants...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.particid + ": " + it.hospname,
                        value: it.particid
                    };
                });
                data.unshift({ label: "", value: "" });
                setDataKey("particid", data);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var particid = state.particid;

        if (!particid) return;
        needServerData({
            endpoint: "/date-range",
            loadingMessage: "Loading Available Date Range...",
            params: {
                particid: particid
            },
            onData: function onData(data) {
                return setDataKey("daterange", { from: data.from, to: data.to, particid: particid });
            }
        });
    }, [state.particid]);

    _react2.default.useEffect(function () {
        if (state.quarter && state.year && state.particid) {
            onReady(_extends({}, state, {
                // for backwards compatibility
                excludeDiagnosticCathOnlyEpisodes: state.excludeDiagnosticCathOnly
            }));
        } else {
            onNotReady();
        }
    }, [state]);

    var handleChange = _react2.default.useCallback(function (key, value) {
        return setState(function (s) {
            return _extends({}, s, _defineProperty({}, key, value));
        });
    }, [setState]);

    var dataWithSubmissionTypes = _extends({}, data, { submissionType: [{ value: "", label: "" }, { value: "1", label: "Episode of Care Records" }, { value: "2", label: "Follow-Up Records" }, { value: "3", label: "Auxiliary Data Collection" }] });

    return _react2.default.createElement(FormView, {
        state: state,
        data: dataWithSubmissionTypes,
        onChange: handleChange
    });
};

AccCathPciExportForm.propTypes = {
    initialState: _propTypes2.default.shape({
        quarter: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        year: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        particid: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        submissionType: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        excludePatientIdentifiers: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
        excludeDiagnosticCathOnly: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string])
    }),
    needServerData: _propTypes2.default.func.isRequired,
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

AccCathPciExportForm.canRerun = function (params) {
    return !!(params && params.particid);
};

AccCathPciExportForm.apiPrefix = "cathpci";

(0, _formRegistry.registerForm)("acc-cathpci-export", AccCathPciExportForm);

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _QuarterYearSelect = __webpack_require__(81);

var _QuarterYearSelect2 = _interopRequireDefault(_QuarterYearSelect);

var _useKeyValueState3 = __webpack_require__(38);

var _useKeyValueState4 = _interopRequireDefault(_useKeyValueState3);

var _formRegistry = __webpack_require__(74);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormView = function FormView(_ref) {
    var _onChange = _ref.onChange,
        state = _ref.state,
        data = _ref.data;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Participant ID"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "particid",
                            className: "participant form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("particid", v);
                            },
                            value: state.particid,
                            options: data.particid,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Quarter"
                ),
                _react2.default.createElement(_QuarterYearSelect2.default, {
                    quarter: state.quarter,
                    year: state.year,
                    min: data.daterange.from,
                    max: data.daterange.to,
                    onChange: _onChange,
                    disabled: !state.particid,
                    required: true
                }),
                _react2.default.createElement(
                    "div",
                    { className: "ncdr-attention after-form-group" },
                    "Attention: The NCDR will not accept harvest files prior to Q1/2019."
                ),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Submission Type"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "submissionType",
                            className: "submissionType form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("submissionType", v);
                            },
                            value: state.submissionType,
                            options: data.submissionType,
                            disabled: !state.particid
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "ncdr-attention after-form-group" },
                    "Attention: Auxiliary Dataset Submissions are no longer accepted for Discharge dates after 6/30/2023."
                )
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Export Options"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "checkbox" },
                    _react2.default.createElement(
                        "label",
                        null,
                        _react2.default.createElement("input", {
                            type: "checkbox",
                            className: "exclude_ncdr_patient_identifiers",
                            onChange: function onChange(e) {
                                return _onChange("excludePatientIdentifiers", e.target.checked ? "true" : "false");
                            },
                            checked: state.excludePatientIdentifiers === "true"
                        }),
                        "Exclude NCDR Patient Identifiers"
                    )
                )
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    { style: { marginBottom: 0 } },
                    "Submission Administration Fields"
                ),
                _react2.default.createElement(
                    "p",
                    { style: { marginTop: 0 } },
                    "(This reflects current hospital demographics values)"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(
                            "label",
                            null,
                            "Submission Dataset:"
                        ),
                        " ",
                        state.submissionDataset
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(
                            "label",
                            null,
                            "Patient Population:"
                        ),
                        " ",
                        state.patientPop
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(
                            "label",
                            null,
                            "Sampling:"
                        ),
                        " ",
                        state.sampling
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(
                            "label",
                            null,
                            "Sampling Patients Types:"
                        ),
                        " ",
                        state.sampPtTypes
                    )
                )
            )
        )
    );
};

var selectShape = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
}));

FormView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    state: _propTypes2.default.shape({
        start: _propTypes2.default.string,
        end: _propTypes2.default.string,
        submissionType: _propTypes2.default.string,
        excludePatientIdentifiers: _propTypes2.default.string,
        submissionDataset: _propTypes2.default.string,
        patientPop: _propTypes2.default.string,
        sampling: _propTypes2.default.string,
        sampPtTypes: _propTypes2.default.string,
        particid: _propTypes2.default.string

    }),
    data: _propTypes2.default.shape({
        particid: selectShape,
        quarter: _propTypes2.default.string,
        year: _propTypes2.default.string,
        submissionType: _propTypes2.default.array
    })
};

var asString = function asString(v) {
    return v == null ? "" : v.toString();
};

var initialStateWithDefaults = function initialStateWithDefaults() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        quarter: asString(state.quarter),
        year: asString(state.year),
        particid: asString(state.particid),
        submissionType: asString(state.submissionType) || "",
        submissionDataset: asString(state.submissionDataset) || "",
        patientPop: asString(state.patientPop) || "",
        sampling: asString(state.sampling) || "",
        sampPtTypes: asString(state.sampPtTypes) || "",
        excludePatientIdentifiers: asString(state.excludePatientIdentifiers) || "false"
    };
};

var initialData = {
    particid: [],
    daterange: { from: [], to: [] },
    submissionType: [{ value: "", label: "" }, { value: "1", label: "Episode of Care Records" }, { value: "2", label: "Follow-Up Records" }, { value: "3", label: "Auxiliary Data Collection" }]
};

var AccActionExportForm = function AccActionExportForm(_ref2) {
    var initialState = _ref2.initialState,
        needServerData = _ref2.needServerData,
        onReady = _ref2.onReady,
        onNotReady = _ref2.onNotReady;

    var _React$useState = _react2.default.useState(function () {
        return initialStateWithDefaults(initialState);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(initialStateWithDefaults(initialState));
    }, [initialState]);

    var _useKeyValueState = (0, _useKeyValueState4.default)(initialData),
        _useKeyValueState2 = _slicedToArray(_useKeyValueState, 2),
        data = _useKeyValueState2[0],
        setDataKey = _useKeyValueState2[1];

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/participants",
            loadingMessage: "Loading Participants...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.particid + ": " + it.hospname,
                        value: it.particid
                    };
                });
                data.unshift({ label: "", value: "" });
                setDataKey("particid", data);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var particid = state.particid;

        if (!particid) return;
        needServerData({
            endpoint: "/date-range",
            loadingMessage: "Loading Available Date Range...",
            params: {
                particid: particid
            },
            onData: function onData(data) {
                return setDataKey("daterange", { from: data.from, to: data.to });
            }
        });

        needServerData({
            endpoint: "/submissiondefaults",
            loadingMessage: "Loading Default Submission Parameters for Participant...",
            params: { particid: particid },
            onData: function onData(data) {
                setState(function (s) {
                    return _extends({}, s, {
                        submissionDataset: data.submissionDataset,
                        patientPop: data.patientPop,
                        sampling: data.sampling,
                        sampPtTypes: data.sampPtTypes
                    });
                });
            }
        });
    }, [state.particid]);

    _react2.default.useEffect(function () {
        if (state.quarter && state.year && state.particid) {
            onReady(_extends({}, state));
        } else {
            onNotReady();
        }
    }, [state]);

    var handleChange = _react2.default.useCallback(function (key, value) {
        if (key === "particid") {
            needServerData({
                endpoint: "/submissiondefaults",
                loadingMessage: "Loading Default Submission Parameters for Participant...",
                params: { particid: value },
                onData: function onData(data) {
                    setState(function (s) {
                        return _extends({}, s, {
                            submissionDataset: data.submissionDataset,
                            patientPop: data.patientPop,
                            sampling: data.sampling,
                            sampPtTypes: data.sampPtTypes
                        });
                    });
                }
            });
        }
        setState(function (s) {
            return _extends({}, s, _defineProperty({}, key, value));
        });
    }, [setState]);

    return _react2.default.createElement(FormView, {
        state: state,
        data: data,
        onChange: handleChange
    });
};

AccActionExportForm.propTypes = {
    initialState: _propTypes2.default.shape({
        quarter: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        year: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        particid: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        submissionType: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        submissionDataset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        patientPop: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        sampling: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        sampPtTypes: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        excludePatientIdentifiers: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string])
    }),
    needServerData: _propTypes2.default.func.isRequired,
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

AccActionExportForm.canRerun = function (params) {
    return !!(params && params.particid);
};

AccActionExportForm.apiPrefix = "action";

(0, _formRegistry.registerForm)("acc-action-export", AccActionExportForm);

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _DateRange = __webpack_require__(95);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _OptionGroup = __webpack_require__(108);

var _OptionGroup2 = _interopRequireDefault(_OptionGroup);

var _formRegistry = __webpack_require__(74);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _useKeyValueState3 = __webpack_require__(38);

var _useKeyValueState4 = _interopRequireDefault(_useKeyValueState3);

var _serializeParams = __webpack_require__(96);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormView = function FormView(_ref) {
    var onChange = _ref.onChange,
        state = _ref.state,
        data = _ref.data;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Center"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "centerno",
                            className: "center form-control",
                            onCommitChange: function onCommitChange(v) {
                                return onChange("centerno", v);
                            },
                            value: state.centerno,
                            options: data.centers,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(_DateRange2.default, {
                    start: state.start,
                    end: state.end,
                    min: data.daterange.from,
                    max: data.daterange.to,
                    onChange: onChange,
                    disabled: !state.centerno,
                    required: true
                })
            )
        )
    );
};

var selectShape = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
}));

FormView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    state: _propTypes2.default.shape({
        start: _propTypes2.default.string,
        end: _propTypes2.default.string,
        centerno: _propTypes2.default.string
    }),
    data: _propTypes2.default.shape({
        centerno: selectShape,
        daterange: _propTypes2.default.shape({
            from: _propTypes2.default.array,
            to: _propTypes2.default.array
        })
    })
};

var initialStateWithDefaults = function initialStateWithDefaults() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var newState = {
        start: (0, _DateRange.dateToString)(state.start),
        end: (0, _DateRange.dateToString)(state.end),
        centerno: state.centerno || ""
    };
    return (0, _serializeParams.unstringifyJson)((0, _serializeParams.fromCommaSafeArray)(newState));
};

var serverDataParams = function serverDataParams(params) {
    return (0, _serializeParams.stringifyJson)((0, _serializeParams.toCommaSafeArray)(params));
};

var initialData = {
    centers: [],
    daterange: { from: [], to: [] }
};

var ECMOExportForm = function ECMOExportForm(_ref2) {
    var initialState = _ref2.initialState,
        needServerData = _ref2.needServerData,
        onReady = _ref2.onReady,
        onNotReady = _ref2.onNotReady;

    var _React$useState = _react2.default.useState(function () {
        return initialStateWithDefaults(initialState);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(initialStateWithDefaults(initialState));
    }, [initialState]);

    var _useKeyValueState = (0, _useKeyValueState4.default)(initialData),
        _useKeyValueState2 = _slicedToArray(_useKeyValueState, 2),
        data = _useKeyValueState2[0],
        setDataKey = _useKeyValueState2[1];

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/centers",
            loadingMessage: "Loading Centers...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.centerNo + ": " + it.centerName,
                        value: it.centerNo
                    };
                });
                data.unshift({ label: "", value: "" });
                setDataKey("centers", data);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var centerno = state.centerno;

        if (!centerno) {
            return; // not yet!
        }
        needServerData({
            endpoint: "/date-range",
            loadingMessage: "Loading Available Date Range...",
            params: serverDataParams({
                centerno: centerno
            }),
            onData: function onData(data) {
                return setDataKey("daterange", {
                    from: data.from,
                    to: data.to
                });
            }
        });
    }, [state.centerno]);

    _react2.default.useEffect(function () {
        // update the submit button and data
        if ((0, _DateRange.isDateRangeValid)(state.start, state.end) && !!state.centerno) {
            onReady(serverDataParams(_extends({}, state)));
        } else {
            onNotReady();
        }
    }, [state, data]);

    var handleChange = _react2.default.useCallback(function (key, value) {
        return setState(function (s) {
            return _extends({}, s, _defineProperty({}, key, value));
        });
    }, [setState]);

    return _react2.default.createElement(FormView, {
        state: state,
        data: data,
        onChange: handleChange
    });
};

ECMOExportForm.propTypes = {
    initialState: _propTypes2.default.shape({
        start: _propTypes2.default.any,
        end: _propTypes2.default.any,
        centerno: _propTypes2.default.string
    }),
    needServerData: _propTypes2.default.func.isRequired,
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

ECMOExportForm.canRerun = function (params) {
    return !!(params && params.centerno);
};

ECMOExportForm.apiPrefix = "ecmo";

(0, _formRegistry.registerForm)("ecmo-export", ECMOExportForm);

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formRegistry = __webpack_require__(74);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _QuarterYearSelect = __webpack_require__(81);

var _QuarterYearSelect2 = _interopRequireDefault(_QuarterYearSelect);

var _useKeyValueState3 = __webpack_require__(38);

var _useKeyValueState4 = _interopRequireDefault(_useKeyValueState3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormView = function FormView(_ref) {
    var _onChange = _ref.onChange,
        state = _ref.state,
        data = _ref.data;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Participant ID"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "particid",
                            className: "participant form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("particid", v);
                            },
                            value: state.particid,
                            options: data.particid,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Quarter"
                ),
                _react2.default.createElement(_QuarterYearSelect2.default, {
                    quarter: state.quarter,
                    year: state.year,
                    min: data.daterange.from,
                    max: data.daterange.to,
                    onChange: _onChange,
                    disabled: !state.particid,
                    required: true
                }),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Submission Type"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "submissionType",
                            className: "submissionType form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("submissionType", v);
                            },
                            value: state.submissionType,
                            options: data.submissionType,
                            disabled: !state.particid
                        })
                    )
                )
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Export Options"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "checkbox" },
                    _react2.default.createElement(
                        "label",
                        null,
                        _react2.default.createElement("input", {
                            type: "checkbox",
                            className: "exclude_ncdr_patient_identifiers",
                            onChange: function onChange(e) {
                                return _onChange("excludePatientIdentifiers", e.target.checked ? "true" : "false");
                            },
                            checked: state.excludePatientIdentifiers === "true"
                        }),
                        "Exclude NCDR Patient Identifiers"
                    )
                )
            )
        )
    );
};

var selectShape = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
}));

FormView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    state: _propTypes2.default.shape({
        start: _propTypes2.default.string,
        end: _propTypes2.default.string,
        submissionType: _propTypes2.default.string,
        excludePatientIdentifiers: _propTypes2.default.string,
        particid: _propTypes2.default.string
    }),
    data: _propTypes2.default.shape({
        particid: selectShape,
        quarter: _propTypes2.default.string,
        year: _propTypes2.default.string,
        submissionType: _propTypes2.default.array
    })
};

var asString = function asString(v) {
    return v == null ? "" : v.toString();
};

var initialStateWithDefaults = function initialStateWithDefaults() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        quarter: asString(state.quarter),
        year: asString(state.year),
        particid: asString(state.particid),
        submissionType: asString(state.submissionType),
        excludePatientIdentifiers: asString(state.excludePatientIdentifiers)
    };
};

var initialData = {
    particid: [],
    daterange: { from: [], to: [] },
    submissionType: [{ value: "", label: "" }, { value: "1", label: "Episode of Care Records" }, { value: "2", label: "Follow-Up Records" }]
};

var LaaoExportForm = function LaaoExportForm(_ref2) {
    var initialState = _ref2.initialState,
        needServerData = _ref2.needServerData,
        onReady = _ref2.onReady,
        onNotReady = _ref2.onNotReady;

    var _React$useState = _react2.default.useState(function () {
        return initialStateWithDefaults(initialState);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(initialStateWithDefaults(initialState));
    }, [initialState]);

    var _useKeyValueState = (0, _useKeyValueState4.default)(initialData),
        _useKeyValueState2 = _slicedToArray(_useKeyValueState, 2),
        data = _useKeyValueState2[0],
        setDataKey = _useKeyValueState2[1];

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/participants",
            loadingMessage: "Loading Participants...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.particid + ": " + it.hospname,
                        value: it.particid
                    };
                });
                data.unshift({ label: "", value: "" });
                setDataKey("particid", data);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var particid = state.particid;

        if (!particid) return;
        needServerData({
            endpoint: "/date-range",
            loadingMessage: "Loading Available Date Range...",
            params: {
                particid: particid
            },
            onData: function onData(data) {
                return setDataKey("daterange", { from: data.from, to: data.to });
            }
        });
    }, [state.particid]);

    _react2.default.useEffect(function () {
        if (state.quarter && state.year && state.particid) {
            onReady(_extends({}, state));
        } else {
            onNotReady();
        }
    }, [state]);

    var handleChange = _react2.default.useCallback(function (key, value) {
        return setState(function (s) {
            return _extends({}, s, _defineProperty({}, key, value));
        });
    }, [setState]);

    return _react2.default.createElement(FormView, {
        state: state,
        data: data,
        onChange: handleChange
    });
};

LaaoExportForm.propTypes = {
    initialState: _propTypes2.default.shape({
        quarter: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        year: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        particid: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        submissionType: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        excludePatientIdentifiers: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string])
    }),
    needServerData: _propTypes2.default.func.isRequired,
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

LaaoExportForm.canRerun = function (params) {
    return !!(params && params.particid);
};

LaaoExportForm.apiPrefix = "laao";

(0, _formRegistry.registerForm)("laao-export", LaaoExportForm);

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _OptionGroup = __webpack_require__(108);

var _OptionGroup2 = _interopRequireDefault(_OptionGroup);

var _formRegistry = __webpack_require__(74);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _DateRange = __webpack_require__(95);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _useKeyValueState3 = __webpack_require__(38);

var _useKeyValueState4 = _interopRequireDefault(_useKeyValueState3);

var _serializeParams = __webpack_require__(96);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormView = function FormView(_ref) {
    var _onChange = _ref.onChange,
        state = _ref.state,
        data = _ref.data;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Hospital"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "hospitals",
                            className: "participant form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("hospitals", v);
                            },
                            onBlur: function onBlur(v) {
                                return _onChange("hospitalsBlur", state.hospitals);
                            },
                            value: state.hospitals,
                            options: data.hospitals,
                            multiple: true,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(
                    "h5",
                    null,
                    "Surgery Date Range"
                ),
                _react2.default.createElement(_DateRange2.default, {
                    start: state.start,
                    end: state.end,
                    min: data.daterange.from,
                    max: data.daterange.to,
                    onChange: _onChange,
                    disabled: state.hospitals.length == 0,
                    required: true
                })
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Export Options"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "", className: "col-md-5 control-label" },
                        "Field Name Format"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "fieldnameFormat",
                            className: "fieldnameFormat format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("fieldnameFormat", v);
                            },
                            value: state.fieldnameFormat,
                            options: data.fieldnameFormat
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "",
                            className: "col-md-5 control-label" },
                        "Delimiter"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "delimiter",
                            className: "delimiter format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("delimiter", v);
                            },
                            value: state.delimiter,
                            options: data.delimiter
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "", className: "col-md-5 control-label" },
                        "Choice Format"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "optionFormat",
                            className: "optionFormat format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("optionFormat", v);
                            },
                            value: state.optionFormat,
                            options: data.optionFormat
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "", className: "col-md-5 control-label" },
                        "Date Format"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "dateFormat",
                            className: "dateFormat format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("dateFormat", v);
                            },
                            value: state.dateFormat,
                            options: data.dateFormat
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "", className: "col-md-5 control-label" },
                        "Field Sort"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "fieldSort",
                            className: "dateFormat format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("fieldSort", v);
                            },
                            value: state.fieldSort,
                            options: data.fieldSort
                        })
                    )
                )
            ),
            _react2.default.createElement(_OptionGroup2.default, {
                state: state.exportFields,
                data: data.exportFields,
                expanded: false,
                onChange: function onChange(value) {
                    return _onChange("exportFields", value);
                },
                hasFieldEntity: true
            })
        )
    );
};

var selectShape = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
}));

FormView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    state: _propTypes2.default.shape({
        start: _propTypes2.default.string,
        end: _propTypes2.default.string,
        hospitals: _propTypes2.default.array,
        fieldnameFormat: _propTypes2.default.string,
        delimiter: _propTypes2.default.string,
        optionFormat: _propTypes2.default.string,
        dateFormat: _propTypes2.default.string,
        fieldSort: _propTypes2.default.string,
        exportFields: _propTypes2.default.object,
        hospitalsBlur: _propTypes2.default.array,
        activeMembers: _propTypes2.default.array
    }),
    data: _propTypes2.default.shape({
        fieldnameFormat: selectShape,
        delimiter: selectShape,
        optionFormat: selectShape,
        dateFormat: selectShape,
        fieldSort: selectShape,
        hospitals: selectShape,
        daterange: _propTypes2.default.shape({
            from: _propTypes2.default.array,
            to: _propTypes2.default.array
        }),
        exportFields: _propTypes2.default.array,
        activeMembers: selectShape
    })
};

var initialStateWithDefaults = function initialStateWithDefaults() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var newState = {
        start: (0, _DateRange.dateToString)(state.start || ""),
        end: (0, _DateRange.dateToString)(state.end || ""),
        hospitals: state.hospitals || [],
        fieldnameFormat: state.fieldnameFormat || "SHORT",
        delimiter: state.delimiter || "|",
        optionFormat: state.optionFormat || "NAME",
        dateFormat: state.dateFormat || "MM/dd/yyyy",
        fieldSort: state.fieldSort || "FIELD",
        exportFields: state.exportFields || {},
        hospitalsBlur: state.hospitalsBlur || []
    };
    return (0, _serializeParams.unstringifyJson)((0, _serializeParams.fromCommaSafeArray)(newState), "exportFields");
};

var serverDataParams = function serverDataParams(params) {
    return (0, _serializeParams.stringifyJson)((0, _serializeParams.toCommaSafeArray)(params), "exportFields");
};

var initialData = {
    fieldnameFormat: ["SHORT", "LONG"].map(function (v) {
        return { label: v, value: v };
    }),
    delimiter: [{ value: "|", label: "|" }, { value: "&#09;", label: "TAB" }, { value: ",", label: "," }],
    optionFormat: ["NAME", "HARVEST_VALUE"].map(function (v) {
        return { label: v, value: v };
    }),
    dateFormat: ["MM/dd/yyyy", "yyyy-MM-dd", "dd/MM/yyyy"].map(function (v) {
        return { label: v, value: v };
    }),
    fieldSort: [{
        label: "By Field Name",
        value: "FIELD"
    }, {
        label: "By Section then Field Name",
        value: "SECTIONFIELD"
    }],
    hospitals: [],
    daterange: { from: [], to: [] },
    exportFields: []
};

var ScoapExportForm = function ScoapExportForm(_ref2) {
    var initialState = _ref2.initialState,
        needServerData = _ref2.needServerData,
        onReady = _ref2.onReady,
        onNotReady = _ref2.onNotReady,
        activeMembers = _ref2.activeMembers;

    var _React$useState = _react2.default.useState(function () {
        return initialStateWithDefaults(initialState);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(initialStateWithDefaults(initialState));
    }, [initialState]);

    var _useKeyValueState = (0, _useKeyValueState4.default)(initialData),
        _useKeyValueState2 = _slicedToArray(_useKeyValueState, 2),
        data = _useKeyValueState2[0],
        setDataKey = _useKeyValueState2[1];

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/exportable/hospitals",
            loadingMessage: "Loading Hospitals...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.hospcode + ": " + it.hospname,
                        value: it.hospcode
                    };
                });
                data.unshift({ label: "All Hospitals", value: "" });
                setDataKey("hospitals", data);
            }
        });
    }, [activeMembers]);

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/exportable/fields",
            loadingMessage: "Loading Available Fields...",
            onData: function onData(data) {
                var fields = data;
                if (_.isEmpty(state.exportFields)) {
                    // initially all fields are selected if none were provided.
                    var selected = {};
                    fields.forEach(function (it) {
                        it.fields.forEach(function (f) {
                            if (!selected[f.entity]) {
                                selected[f.entity] = [];
                            }
                            selected[f.entity].push(f.key);
                        });
                    });
                    handleChange("exportFields", selected);
                }
                setDataKey("exportFields", fields);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var hospitals = state.hospitals,
            hospitalsBlur = state.hospitalsBlur;

        if (!hospitals || hospitals.length < 1) return;
        needServerData({
            endpoint: "/exportable/surgdt-range",
            loadingMessage: "Loading Available Date Range...",
            params: serverDataParams({
                hospitals: hospitals
            }),
            onData: function onData(data) {
                return setDataKey("daterange", { from: data.from, to: data.to });
            }
        });
    }, [state.hospitalsBlur]);

    _react2.default.useEffect(function () {
        // update the submit button and data
        if ((0, _DateRange.isDateRangeValid)(state.start, state.end) && !!state.hospitals) {
            onReady(serverDataParams(_extends({}, state, {
                exportFields: Object.entries(state.exportFields).reduce(function (agg, _ref3) {
                    var _ref4 = _slicedToArray(_ref3, 2),
                        e = _ref4[0],
                        fs = _ref4[1];

                    if (fs && fs.length) agg[e] = fs;
                    return agg;
                }, {})
            })));
        } else {
            onNotReady();
        }
    }, [state, data]);

    var handleChange = _react2.default.useCallback(function (key, value) {
        return setState(function (s) {
            return _extends({}, s, _defineProperty({}, key, value));
        });
    }, [setState]);

    return _react2.default.createElement(FormView, {
        state: state,
        data: data,
        onChange: handleChange
    });
};

ScoapExportForm.propTypes = {
    initialState: _propTypes2.default.shape({
        start: _propTypes2.default.any,
        end: _propTypes2.default.any,
        hospitals: _propTypes2.default.arrayOf(_propTypes2.default.string),
        fieldnameFormat: _propTypes2.default.string,
        delimiter: _propTypes2.default.string,
        optionFormat: _propTypes2.default.string,
        dateFormat: _propTypes2.default.string,
        fieldSort: _propTypes2.default.string,
        // history stores an object, saved params have JSON strings
        exportFields: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string])
    }),
    needServerData: _propTypes2.default.func.isRequired,
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

// ScoapExportForm.canRerun = params =>
//     params.hasOwnProperty("fieldnameFormat") &&
//     params.hasOwnProperty("delimiter") &&
//     params.hasOwnProperty("optionFormat") &&
//     params.hasOwnProperty("dateFormat") &&
//     params.hasOwnProperty("exportFields");

ScoapExportForm.canRerun = function (params) {
    return !!params;
};

ScoapExportForm.apiPrefix = "scoap";

(0, _formRegistry.registerForm)("scoap-export", ScoapExportForm);

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _OptionGroup = __webpack_require__(108);

var _OptionGroup2 = _interopRequireDefault(_OptionGroup);

var _formRegistry = __webpack_require__(74);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _DateRange = __webpack_require__(95);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _useKeyValueState3 = __webpack_require__(38);

var _useKeyValueState4 = _interopRequireDefault(_useKeyValueState3);

var _serializeParams = __webpack_require__(96);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var filterVersions = function filterVersions(options, val) {
    var greater = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    // convert versions into comparable values
    var found = false;
    return options.filter(function (it) {
        if (val === it.value) {
            found = true;
            return true;
        }
        return greater ? found : !found;
    });
};

var DataVersionSelect = function DataVersionSelect(_ref) {
    var name = _ref.name,
        onChange = _ref.onChange,
        _ref$value = _ref.value,
        value = _ref$value === undefined ? [] : _ref$value,
        options = _ref.options,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === undefined ? false : _ref$disabled;

    var hasFromSelected = value.length >= 1;
    var toOptions = filterVersions(options, value[0], true);
    var handleChange = function handleChange(key, v) {
        if (key === "to") {
            // exporter expects a list of datavrsns within the selected range.
            var from = value[0];
            var to = v || value[0];
            var inRange = false;
            v = [];
            toOptions.forEach(function (it) {
                if (it.value === from) {
                    inRange = true;
                }
                if (inRange) {
                    v.push(it.value);
                }
                if (it.value === to) {
                    inRange = false;
                }
            });
        } else {
            v = [v];
        }
        onChange(v.filter(function (it) {
            return it !== "";
        }));
    };
    return _react2.default.createElement(
        "div",
        { className: "form-group" },
        _react2.default.createElement(
            "div",
            { className: "col-sm-6" },
            "From",
            _react2.default.createElement(_Select2.default, {
                name: name + "-from",
                className: "dataversions-from form-control",
                onCommitChange: function onCommitChange(v) {
                    return handleChange("from", v);
                },
                value: value[0],
                options: options,
                disabled: disabled
            })
        ),
        _react2.default.createElement(
            "div",
            { className: "col-sm-6" },
            "To",
            _react2.default.createElement(_Select2.default, {
                name: name + "-to",
                className: "dataversions-to form-control",
                onCommitChange: function onCommitChange(v) {
                    return handleChange("to", v);
                },
                value: value[value.length - 1],
                options: toOptions,
                disabled: disabled || !hasFromSelected
            })
        )
    );
};

DataVersionSelect.propTypes = {
    name: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    value: _propTypes2.default.array,
    options: _propTypes2.default.array,
    disabled: _propTypes2.default.bool
};

var FormView = function FormView(_ref2) {
    var _onChange = _ref2.onChange,
        state = _ref2.state,
        data = _ref2.data;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Participant ID"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "particids",
                            className: "participant form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("particids", v);
                            },
                            onBlur: function onBlur(v) {
                                return _onChange("particidsBlur", state.particids);
                            },
                            value: state.particids,
                            options: data.particids,
                            multiple: true,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(
                    "h5",
                    null,
                    "Data Versions"
                ),
                _react2.default.createElement(DataVersionSelect, {
                    name: "datavrsns",
                    onChange: function onChange(v) {
                        return _onChange("datavrsns", v);
                    },
                    value: state.datavrsns,
                    options: data.datavrsns,
                    disabled: state.particids.length == 0
                }),
                _react2.default.createElement(_DateRange2.default, {
                    start: state.start,
                    end: state.end,
                    min: data.daterange.from,
                    max: data.daterange.to,
                    onChange: _onChange,
                    disabled: state.particids.length == 0,
                    required: true
                }),
                _react2.default.createElement(
                    "h5",
                    null,
                    "Surgeons"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "surgeons",
                            className: "surgeons form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("surgeons", v);
                            },
                            value: state.surgeons,
                            multiple: true,
                            options: data.surgeons,
                            disabled: state.particids.length == 0 || !(0, _DateRange.isDateRangeValid)(state.start, state.end)
                        })
                    )
                ),
                _react2.default.createElement(
                    "h5",
                    null,
                    "Procedure Type"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "procedureTypes",
                            className: "procedureTypes form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("procedureTypes", v);
                            },
                            value: state.procedureTypes,
                            multiple: true,
                            options: data.procedureTypes,
                            disabled: state.particids.length == 0
                        })
                    )
                )
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Export Options"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "", className: "col-md-5 control-label" },
                        "Field Name Format"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "fieldnameFormat",
                            className: "fieldnameFormat format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("fieldnameFormat", v);
                            },
                            value: state.fieldnameFormat,
                            options: data.fieldnameFormat
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "",
                            className: "col-md-5 control-label" },
                        "Delimiter"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "delimiter",
                            className: "delimiter format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("delimiter", v);
                            },
                            value: state.delimiter,
                            options: data.delimiter
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "", className: "col-md-5 control-label" },
                        "Choice Format"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "optionFormat",
                            className: "optionFormat format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("optionFormat", v);
                            },
                            value: state.optionFormat,
                            options: data.optionFormat
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "", className: "col-md-5 control-label" },
                        "Date Format"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "dateFormat",
                            className: "dateFormat format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("dateFormat", v);
                            },
                            value: state.dateFormat,
                            options: data.dateFormat
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "", className: "col-md-5 control-label" },
                        "Field Sort"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "fieldSort",
                            className: "dateFormat format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("fieldSort", v);
                            },
                            value: state.fieldSort,
                            options: data.fieldSort
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "", className: "col-md-5 control-label" },
                        "File Format"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "fileFormat",
                            className: "dateFormat format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("fileFormat", v);
                            },
                            value: state.fileFormat,
                            options: data.fileFormat
                        })
                    )
                )
            ),
            _react2.default.createElement(_OptionGroup2.default, {
                state: state.exportFields,
                data: data.exportFields,
                expanded: false,
                onChange: function onChange(value) {
                    return _onChange("exportFields", value);
                },
                hasFieldEntity: true
            })
        )
    );
};

var selectShape = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
}));

FormView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    state: _propTypes2.default.shape({
        start: _propTypes2.default.string,
        end: _propTypes2.default.string,
        particids: _propTypes2.default.array,
        fieldnameFormat: _propTypes2.default.string,
        delimiter: _propTypes2.default.string,
        optionFormat: _propTypes2.default.string,
        dateFormat: _propTypes2.default.string,
        fieldSort: _propTypes2.default.string,
        datavrsns: _propTypes2.default.array,
        surgeons: _propTypes2.default.array,
        procedureTypes: _propTypes2.default.array,
        exportFields: _propTypes2.default.object,
        fileFormat: _propTypes2.default.string,
        particidsBlur: _propTypes2.default.array,
        activeMembers: _propTypes2.default.array
    }),
    data: _propTypes2.default.shape({
        fieldnameFormat: selectShape,
        delimiter: selectShape,
        optionFormat: selectShape,
        dateFormat: selectShape,
        fieldSort: selectShape,
        particids: selectShape,
        datavrsns: selectShape,
        surgeons: selectShape,
        procedureTypes: selectShape,
        daterange: _propTypes2.default.shape({
            from: _propTypes2.default.array,
            to: _propTypes2.default.array
        }),
        exportFields: _propTypes2.default.array,
        fileFormat: selectShape,
        activeMembers: selectShape
    })
};

var initialStateWithDefaults = function initialStateWithDefaults() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var newState = {
        start: (0, _DateRange.dateToString)(state.start || ""),
        end: (0, _DateRange.dateToString)(state.end || ""),
        particids: state.particids || [],
        fieldnameFormat: state.fieldnameFormat || "SHORT",
        delimiter: state.delimiter || "|",
        optionFormat: state.optionFormat || "NAME",
        dateFormat: state.dateFormat || "MM/dd/yyyy",
        fieldSort: state.fieldSort || "FIELD",
        datavrsns: state.datavrsns || [],
        surgeons: state.surgeons || [],
        procedureTypes: state.procedureTypes || [],
        exportFields: state.exportFields || {},
        fileFormat: state.fileFormat || "SINGLE_FILE",
        particidsBlur: state.particidsBlur || []
    };
    return (0, _serializeParams.unstringifyJson)((0, _serializeParams.fromCommaSafeArray)(newState, "surgeons", "procedureTypes"), "exportFields");
};

var serverDataParams = function serverDataParams(params) {
    return (0, _serializeParams.stringifyJson)((0, _serializeParams.toCommaSafeArray)(params, "surgeons", "procedureTypes"), "exportFields");
};

var initialData = {
    fieldnameFormat: ["SHORT", "LONG"].map(function (v) {
        return { label: v, value: v };
    }),
    delimiter: [{ value: "|", label: "|" }, { value: "&#09;", label: "TAB" }, { value: ",", label: "," }],
    optionFormat: ["NAME", "HARVEST_VALUE"].map(function (v) {
        return { label: v, value: v };
    }),
    fileFormat: [{
        label: "Single File",
        value: "SINGLE_FILE"
    }, {
        label: "File Per-Participant",
        value: "FILE_PER_PARTICIPANT"
    }],
    dateFormat: ["MM/dd/yyyy", "yyyy-MM-dd", "dd/MM/yyyy"].map(function (v) {
        return { label: v, value: v };
    }),
    fieldSort: [{
        label: "By Field Name",
        value: "FIELD"
    }, {
        label: "By Section then Field Name",
        value: "SECTIONFIELD"
    }],
    particids: [],
    datavrsns: [],
    surgeons: [],
    procedureTypes: [],
    daterange: { from: [], to: [] },
    exportFields: []
};

var AdultCardiacExportForm = function AdultCardiacExportForm(_ref3) {
    var initialState = _ref3.initialState,
        needServerData = _ref3.needServerData,
        onReady = _ref3.onReady,
        onNotReady = _ref3.onNotReady,
        activeMembers = _ref3.activeMembers;

    var _React$useState = _react2.default.useState(function () {
        return initialStateWithDefaults(initialState);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(initialStateWithDefaults(initialState));
    }, [initialState]);

    var _useKeyValueState = (0, _useKeyValueState4.default)(initialData),
        _useKeyValueState2 = _slicedToArray(_useKeyValueState, 2),
        data = _useKeyValueState2[0],
        setDataKey = _useKeyValueState2[1];

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/exportable/hospitals",
            loadingMessage: "Loading Participants...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.particid + ": " + it.hospname,
                        value: it.particid
                    };
                });
                data.unshift({ label: "All Hospitals", value: "" });
                setDataKey("particids", data);
            }
        });
    }, [activeMembers]);

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/exportable/fields",
            loadingMessage: "Loading Available Fields...",
            onData: function onData(data) {
                var fields = data;
                if (_.isEmpty(state.exportFields)) {
                    // initially all fields are selected if none were provided.
                    var selected = {};
                    fields.forEach(function (it) {
                        it.fields.forEach(function (f) {
                            if (!selected[f.entity]) {
                                selected[f.entity] = [];
                            }
                            selected[f.entity].push(f.key);
                        });
                    });
                    handleChange("exportFields", selected);
                }
                setDataKey("exportFields", fields);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var particids = state.particids,
            particidsBlur = state.particidsBlur;

        if (!particids || particids.length == 0) return;
        needServerData({
            endpoint: "/exportable/datavrsns",
            loadingMessage: "Loading Available Data Versions...",
            params: serverDataParams({
                particids: particids
            }),
            onData: function onData(data) {
                data = data.map(function (it) {
                    return { label: it.name, value: it.name };
                });
                data.reverse();
                data.unshift({ label: "", value: "" });
                setDataKey("datavrsns", data);
            }
        });
    }, [state.particidsBlur]);

    _react2.default.useEffect(function () {
        var particids = state.particids,
            datavrsns = state.datavrsns,
            start = state.start,
            end = state.end,
            particidsBlur = state.particidsBlur;

        if (!particids || particids.length == 0 || !(0, _DateRange.isDateRangeValid)(state.start, state.end)) return;
        needServerData({
            endpoint: "/exportable/surgeons",
            loadingMessage: "Loading Available Surgeons...",
            params: serverDataParams({
                particids: particids,
                datavrsns: datavrsns,
                surgdtStart: start,
                surgdtEnd: end
            }),
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.npi ? it.npi + ": " + it.name : it.name,
                        value: it.name
                    };
                });
                data.unshift({ label: "All Surgeons", value: "" });
                setDataKey("surgeons", data);
            }
        });
    }, [state.particidsBlur, state.datavrsns, state.start, state.end]);

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/exportable/procedure-type-names",
            loadingMessage: "Loading Procedure Types...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it,
                        value: it
                    };
                });
                data.unshift({ label: "All Procedure Types", value: "" });
                setDataKey("procedureTypes", data);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var particids = state.particids,
            datavrsns = state.datavrsns,
            particidsBlur = state.particidsBlur;

        if (!particids || particids.length < 1) return;
        needServerData({
            endpoint: "/exportable/surgdt-range",
            loadingMessage: "Loading Available Date Range...",
            params: serverDataParams({
                particids: particids,
                datavrsns: datavrsns
            }),
            onData: function onData(data) {
                return setDataKey("daterange", { from: data.from, to: data.to });
            }
        });
    }, [state.particidsBlur, state.datavrsns]);

    _react2.default.useEffect(function () {
        // update the submit button and data
        if ((0, _DateRange.isDateRangeValid)(state.start, state.end) && !!state.particids) {
            var availableSurgeons = new Set(data.surgeons.map(function (it) {
                return it.value;
            }));
            onReady(serverDataParams(_extends({}, state, {
                surgeons: state.surgeons.filter(function (it) {
                    return availableSurgeons.has(it);
                }),
                exportFields: Object.entries(state.exportFields).reduce(function (agg, _ref4) {
                    var _ref5 = _slicedToArray(_ref4, 2),
                        e = _ref5[0],
                        fs = _ref5[1];

                    if (fs && fs.length) agg[e] = fs;
                    return agg;
                }, {})
            })));
        } else {
            onNotReady();
        }
    }, [state, data]);

    var handleChange = _react2.default.useCallback(function (key, value) {
        return setState(function (s) {
            return _extends({}, s, _defineProperty({}, key, value));
        });
    }, [setState]);

    return _react2.default.createElement(FormView, {
        state: state,
        data: data,
        onChange: handleChange
    });
};

AdultCardiacExportForm.propTypes = {
    initialState: _propTypes2.default.shape({
        start: _propTypes2.default.any,
        end: _propTypes2.default.any,
        particids: _propTypes2.default.arrayOf(_propTypes2.default.string),
        fieldnameFormat: _propTypes2.default.string,
        delimiter: _propTypes2.default.string,
        optionFormat: _propTypes2.default.string,
        dateFormat: _propTypes2.default.string,
        fieldSort: _propTypes2.default.string,
        datavrsns: _propTypes2.default.arrayOf(_propTypes2.default.string),
        surgeons: _propTypes2.default.arrayOf(_propTypes2.default.string),
        procedureTypes: _propTypes2.default.arrayOf(_propTypes2.default.string),
        // history stores an object, saved params have JSON strings
        exportFields: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
        fileFormat: _propTypes2.default.string
    }),
    needServerData: _propTypes2.default.func.isRequired,
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

// AdultCardiacExportForm.canRerun = params =>
//     params.hasOwnProperty("fieldnameFormat") &&
//     params.hasOwnProperty("delimiter") &&
//     params.hasOwnProperty("optionFormat") &&
//     params.hasOwnProperty("dateFormat") &&
//     params.hasOwnProperty("exportFields");

AdultCardiacExportForm.canRerun = function (params) {
    return !!params;
};

AdultCardiacExportForm.apiPrefix = "adult-cardiac";

(0, _formRegistry.registerForm)("adult-cardiac-export", AdultCardiacExportForm);

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _OptionGroup = __webpack_require__(108);

var _OptionGroup2 = _interopRequireDefault(_OptionGroup);

var _formRegistry = __webpack_require__(74);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _DateRange = __webpack_require__(95);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _useKeyValueState3 = __webpack_require__(38);

var _useKeyValueState4 = _interopRequireDefault(_useKeyValueState3);

var _serializeParams = __webpack_require__(96);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormView = function FormView(_ref) {
    var _onChange = _ref.onChange,
        state = _ref.state,
        data = _ref.data;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Participant ID"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "particid",
                            className: "participant form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("particid", v);
                            },
                            value: state.particid,
                            options: data.particid,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(_DateRange2.default, {
                    start: state.start,
                    end: state.end,
                    min: data.daterange.from,
                    max: data.daterange.to,
                    onChange: _onChange,
                    disabled: !state.particid,
                    required: true
                })
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(_OptionGroup2.default, {
                state: state.optionalFields,
                data: data.optionalFields,
                expanded: true,
                onChange: function onChange(value) {
                    return _onChange("optionalFields", value);
                }
            })
        )
    );
};

var selectShape = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
}));

FormView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    state: _propTypes2.default.shape({
        start: _propTypes2.default.string,
        end: _propTypes2.default.string,
        particid: _propTypes2.default.string,
        optionalFields: _propTypes2.default.object
    }),
    data: _propTypes2.default.shape({
        particid: selectShape,
        daterange: _propTypes2.default.shape({
            from: _propTypes2.default.array,
            to: _propTypes2.default.array
        }),
        optionalFields: _propTypes2.default.array
    })
};

var initialStateWithDefaults = function initialStateWithDefaults() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var newState = {
        start: (0, _DateRange.dateToString)(state.start),
        end: (0, _DateRange.dateToString)(state.end),
        particid: state.particid || "",
        optionalFields: state.optionalFields || {}
    };
    return (0, _serializeParams.unstringifyJson)(newState, "optionalFields");
};

var serverDataParams = function serverDataParams(params) {
    return (0, _serializeParams.stringifyJson)(params, "optionalFields");
};

var initialData = {
    particid: [],
    daterange: { from: [], to: [] },
    optionalFields: []
};

var AdultCardiacHarvestForm = function AdultCardiacHarvestForm(_ref2) {
    var initialState = _ref2.initialState,
        needServerData = _ref2.needServerData,
        onReady = _ref2.onReady,
        onNotReady = _ref2.onNotReady;

    var _React$useState = _react2.default.useState(function () {
        return initialStateWithDefaults(initialState);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(initialStateWithDefaults(initialState));
    }, [initialState]);

    var _useKeyValueState = (0, _useKeyValueState4.default)(initialData),
        _useKeyValueState2 = _slicedToArray(_useKeyValueState, 2),
        data = _useKeyValueState2[0],
        setDataKey = _useKeyValueState2[1];

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/participants",
            loadingMessage: "Loading Participants...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.particid + ": " + it.hospname,
                        value: it.particid
                    };
                });
                data.unshift({ label: "", value: "" });
                setDataKey("particid", data);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/optional-fields",
            loadingMessage: "Loading Available Fields...",
            onData: function onData(data) {
                var fields = data.entities;
                if (_.isEmpty(state.optionalFields)) {
                    // initially all fields are selected if none were provided.
                    var selected = {};
                    fields.forEach(function (f) {
                        selected[f.key] = f.fields.map(function (it) {
                            return it.key;
                        });
                    });
                    handleChange("optionalFields", selected);
                }
                setDataKey("optionalFields", fields);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var particid = state.particid;

        if (!particid) return;
        needServerData({
            endpoint: "/date-range",
            loadingMessage: "Loading Available Date Range...",
            params: serverDataParams({
                particid: particid
            }),
            onData: function onData(data) {
                return setDataKey("daterange", { from: data.from, to: data.to });
            }
        });
    }, [state.particid]);

    _react2.default.useEffect(function () {
        if ((0, _DateRange.isDateRangeValid)(state.start, state.end) && state.particid) {
            onReady(serverDataParams(state));
        } else {
            onNotReady();
        }
    }, [state]);

    var handleChange = _react2.default.useCallback(function (key, value) {
        return setState(function (s) {
            return _extends({}, s, _defineProperty({}, key, value));
        });
    }, [setState]);

    return _react2.default.createElement(FormView, {
        state: state,
        data: data,
        onChange: handleChange
    });
};

AdultCardiacHarvestForm.propTypes = {
    initialState: _propTypes2.default.shape({
        start: _propTypes2.default.any,
        end: _propTypes2.default.any,
        particid: _propTypes2.default.string,
        optionalFields: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string])
    }),
    needServerData: _propTypes2.default.func.isRequired,
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

AdultCardiacHarvestForm.canRerun = function (params) {
    return !!(params && params.particid);
};

AdultCardiacHarvestForm.apiPrefix = "adult-cardiac";

(0, _formRegistry.registerForm)("adult-cardiac-harvest", AdultCardiacHarvestForm);

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _DateRange = __webpack_require__(95);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _OptionGroup = __webpack_require__(108);

var _OptionGroup2 = _interopRequireDefault(_OptionGroup);

var _formRegistry = __webpack_require__(74);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _useKeyValueState3 = __webpack_require__(38);

var _useKeyValueState4 = _interopRequireDefault(_useKeyValueState3);

var _serializeParams = __webpack_require__(96);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var filterVersions = function filterVersions(options, val) {
    var greater = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    // convert versions into comparable values
    var found = false;
    return options.filter(function (it) {
        if (val === it.value) {
            found = true;
            return true;
        }
        return greater ? found : !found;
    });
};

var DataVersionSelect = function DataVersionSelect(_ref) {
    var name = _ref.name,
        onChange = _ref.onChange,
        _ref$value = _ref.value,
        value = _ref$value === undefined ? [] : _ref$value,
        options = _ref.options,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === undefined ? false : _ref$disabled;

    var hasFromSelected = value.length >= 1;
    var toOptions = filterVersions(options, value[0], true);
    var handleChange = function handleChange(key, v) {
        if (key === "to") {
            // exporter expects a list of datavrsns within the selected range.
            var from = value[0];
            var to = v || value[0];
            var inRange = false;
            v = [];
            toOptions.forEach(function (it) {
                if (it.value === from) {
                    inRange = true;
                }
                if (inRange) {
                    v.push(it.value);
                }
                if (it.value === to) {
                    inRange = false;
                }
            });
        } else {
            v = [v];
        }
        onChange(v.filter(function (it) {
            return it !== "";
        }));
    };
    return _react2.default.createElement(
        "div",
        { className: "form-group" },
        _react2.default.createElement(
            "div",
            { className: "col-sm-6" },
            "From",
            _react2.default.createElement(_Select2.default, {
                name: name + "-from",
                className: "dataversions-from form-control",
                onCommitChange: function onCommitChange(v) {
                    return handleChange("from", v);
                },
                value: value[0],
                options: options,
                disabled: disabled
            })
        ),
        _react2.default.createElement(
            "div",
            { className: "col-sm-6" },
            "To",
            _react2.default.createElement(_Select2.default, {
                name: name + "-to",
                className: "dataversions-to form-control",
                onCommitChange: function onCommitChange(v) {
                    return handleChange("to", v);
                },
                value: value[value.length - 1],
                options: toOptions,
                disabled: disabled || !hasFromSelected

            })
        )
    );
};

DataVersionSelect.propTypes = {
    name: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    value: _propTypes2.default.array,
    options: _propTypes2.default.array
};

var FormView = function FormView(_ref2) {
    var _onChange = _ref2.onChange,
        state = _ref2.state,
        data = _ref2.data;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Participant ID"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "particids",
                            className: "participant form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("particids", v);
                            },
                            onBlur: function onBlur(v) {
                                return _onChange("particidsBlur", state.particids);
                            },
                            value: state.particids,
                            options: data.particids,
                            multiple: true,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(
                    "h5",
                    null,
                    "Data Versions"
                ),
                _react2.default.createElement(DataVersionSelect, {
                    name: "datavrsns",
                    onChange: function onChange(v) {
                        return _onChange("datavrsns", v);
                    },
                    value: state.datavrsns,
                    options: data.datavrsns,
                    disabled: state.particids.length == 0
                }),
                _react2.default.createElement(_DateRange2.default, {
                    start: state.start,
                    end: state.end,
                    min: data.daterange.from,
                    max: data.daterange.to,
                    onChange: _onChange,
                    disabled: state.particids.length == 0,
                    required: true
                }),
                _react2.default.createElement(
                    "h5",
                    null,
                    "Surgeons"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "surgeons",
                            className: "surgeons form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("surgeons", v);
                            },
                            value: state.surgeons,
                            multiple: true,
                            options: data.surgeons,
                            disabled: state.particids.length == 0 || !(0, _DateRange.isDateRangeValid)(state.start, state.end)
                        })
                    )
                )
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Export Options"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "", className: "col-md-5 control-label" },
                        "Field Name Format"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "headingFormat",
                            className: "headingFormat format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("headingFormat", v);
                            },
                            value: state.headingFormat,
                            options: data.headingFormat
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "",
                            className: "col-md-5 control-label" },
                        "Delimiter"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "delimiter",
                            className: "delimiter format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("delimiter", v);
                            },
                            value: state.delimiter,
                            options: data.delimiter
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "", className: "col-md-5 control-label" },
                        "Choice Format"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "optionFormat",
                            className: "optionFormat format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("optionFormat", v);
                            },
                            value: state.optionFormat,
                            options: data.optionFormat
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "", className: "col-md-5 control-label" },
                        "Date Format"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "dateFormat",
                            className: "dateFormat format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("dateFormat", v);
                            },
                            value: state.dateFormat,
                            options: data.dateFormat
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "", className: "col-md-5 control-label" },
                        "Field Sort"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "fieldSort",
                            className: "dateFormat format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("fieldSort", v);
                            },
                            value: state.fieldSort,
                            options: data.fieldSort
                        })
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "label",
                        { htmlFor: "", className: "col-md-5 control-label" },
                        "File Format"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-7" },
                        _react2.default.createElement(_Select2.default, {
                            name: "fileFormat",
                            className: "dateFormat format_select form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("fileFormat", v);
                            },
                            value: state.fileFormat,
                            options: data.fileFormat
                        })
                    )
                )
            ),
            _react2.default.createElement(_OptionGroup2.default, {
                state: state.exportFields,
                data: data.exportFields,
                expanded: false,
                onChange: function onChange(value) {
                    return _onChange("exportFields", value);
                },
                hasFieldEntity: true
            })
        )
    );
};

var selectShape = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
}));

FormView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    state: _propTypes2.default.shape({
        start: _propTypes2.default.string,
        end: _propTypes2.default.string,
        particids: _propTypes2.default.array,
        datavrsns: _propTypes2.default.array,
        surgeons: _propTypes2.default.array,
        headingFormat: _propTypes2.default.string,
        delimiter: _propTypes2.default.string,
        optionFormat: _propTypes2.default.string,
        dateFormat: _propTypes2.default.string,
        fieldSort: _propTypes2.default.string,
        exportFields: _propTypes2.default.object,
        fileFormat: _propTypes2.default.string,
        particidsBlur: _propTypes2.default.array,
        activeMembers: _propTypes2.default.array
    }),
    data: _propTypes2.default.shape({
        headingFormat: selectShape,
        delimiter: selectShape,
        optionFormat: selectShape,
        dateFormat: selectShape,
        fieldSort: selectShape,
        particids: selectShape,
        datavrsns: selectShape,
        surgeons: selectShape,
        daterange: _propTypes2.default.shape({
            from: _propTypes2.default.array,
            to: _propTypes2.default.array
        }),
        exportFields: _propTypes2.default.array,
        fileFormat: selectShape,
        activeMembers: selectShape
    })
};

var initialStateWithDefaults = function initialStateWithDefaults() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var newState = {
        start: (0, _DateRange.dateToString)(state.start),
        end: (0, _DateRange.dateToString)(state.end),
        particids: state.particids || [],
        datavrsns: state.datavrsns || [],
        surgeons: state.surgeons || [],
        headingFormat: state.headingFormat || "SHORT",
        delimiter: state.delimiter || "|",
        optionFormat: state.optionFormat || "NAME",
        dateFormat: state.dateFormat || "MM/dd/yyyy",
        fieldSort: state.fieldSort || "FIELD",
        exportFields: state.exportFields || {},
        fileFormat: state.fileFormat || "SINGLE_FILE",
        particidsBlur: state.particidsBlur || []
    };
    return (0, _serializeParams.unstringifyJson)((0, _serializeParams.fromCommaSafeArray)(newState, "surgeons"), "exportFields");
};

var serverDataParams = function serverDataParams(params) {
    return (0, _serializeParams.stringifyJson)((0, _serializeParams.toCommaSafeArray)(params, "surgeons"), "exportFields");
};

var initialData = {
    headingFormat: ["SHORT", "LONG"].map(function (v) {
        return { label: v, value: v };
    }),
    delimiter: [{ value: "|", label: "|" }, { value: "&#09;", label: "TAB" }, { value: ",", label: "," }],
    optionFormat: ["NAME", "HARVEST_VALUE"].map(function (v) {
        return { label: v, value: v };
    }),
    fileFormat: [{
        label: "Single File",
        value: "SINGLE_FILE"
    }, {
        label: "File Per-Participant",
        value: "FILE_PER_PARTICIPANT"
    }],
    dateFormat: ["MM/dd/yyyy", "yyyy-MM-dd", "dd/MM/yyyy"].map(function (v) {
        return { label: v, value: v };
    }),
    particids: [],
    datavrsns: [],
    surgeons: [],
    daterange: { from: [], to: [] },
    fieldSort: [{
        label: "By Field Name",
        value: "FIELD"
    }, {
        label: "By Section then Field Name",
        value: "SECTIONFIELD"
    }],
    exportFields: []
};

var buildExportFieldSelection = function buildExportFieldSelection(fields) {
    var selected = {};
    fields.forEach(function (section) {
        section.fields.forEach(function (field) {
            if (!selected[field.entity]) {
                selected[field.entity] = [];
            }
            selected[field.entity].push(field.key);
        });
    });
    return selected;
};

var filterExportFieldSelection = function filterExportFieldSelection(selectedFields, allowedFields) {
    return Object.entries(selectedFields).reduce(function (agg, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            entity = _ref4[0],
            fields = _ref4[1];

        var allowedEntityFields = new Set(allowedFields[entity] || []);
        var scopedFields = fields.filter(function (field) {
            return allowedEntityFields.has(field);
        });
        if (scopedFields.length) {
            agg[entity] = scopedFields;
        }
        return agg;
    }, {});
};

var ThoracicExportForm = function ThoracicExportForm(_ref5) {
    var initialState = _ref5.initialState,
        needServerData = _ref5.needServerData,
        onReady = _ref5.onReady,
        onNotReady = _ref5.onNotReady,
        activeMembers = _ref5.activeMembers;

    var _React$useState = _react2.default.useState(function () {
        return initialStateWithDefaults(initialState);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(initialStateWithDefaults(initialState));
    }, [initialState]);

    var _useKeyValueState = (0, _useKeyValueState4.default)(initialData),
        _useKeyValueState2 = _slicedToArray(_useKeyValueState, 2),
        data = _useKeyValueState2[0],
        setDataKey = _useKeyValueState2[1];

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/exportable/hospitals",
            loadingMessage: "Loading Participants...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.particid + ": " + it.hospname,
                        value: it.particid
                    };
                });
                data.unshift({ label: "All Hospitals", value: "" });
                setDataKey("particids", data);
            }
        });
    }, [activeMembers]);

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/exportable/fields",
            loadingMessage: "Loading Available Fields...",
            onData: function onData(data) {
                var fields = data;
                var allSelected = buildExportFieldSelection(fields);
                var nextSelection = _.isEmpty(state.exportFields) ? allSelected : filterExportFieldSelection(state.exportFields, allSelected);
                var normalizedSelection = _.isEmpty(nextSelection) ? allSelected : nextSelection;
                if (!_.isEqual(normalizedSelection, state.exportFields)) {
                    handleChange("exportFields", normalizedSelection);
                }
                setDataKey("exportFields", fields);
            }
        });
    }, [activeMembers]);

    _react2.default.useEffect(function () {
        var particids = state.particids,
            particidsBlur = state.particidsBlur;

        if (!particids || particids.length == 0) return;
        needServerData({
            endpoint: "/exportable/datavrsns",
            loadingMessage: "Loading Available Data Versions...",
            params: serverDataParams({
                particids: particids
            }),
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.name,
                        value: it.name
                    };
                });
                data.reverse();
                data.unshift({ label: "", value: "" });
                setDataKey("datavrsns", data);
            }
        });
    }, [state.particidsBlur]);

    _react2.default.useEffect(function () {
        var particids = state.particids,
            datavrsns = state.datavrsns,
            start = state.start,
            end = state.end,
            particidsBlur = state.particidsBlur;

        if (!particids || particids.length == 0 || !(0, _DateRange.isDateRangeValid)(state.start, state.end)) return;

        needServerData({
            endpoint: "/exportable/surgeons",
            loadingMessage: "Loading Available Surgeons...",
            params: serverDataParams({
                particids: particids,
                datavrsns: datavrsns,
                surgdtStart: start,
                surgdtEnd: end
            }),
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.npi ? it.npi + ": " + it.name : it.name,
                        value: it.name
                    };
                });
                data.unshift({ label: "All Surgeons", value: "" });
                setDataKey("surgeons", data);
            }
        });
    }, [state.particidsBlur, state.datavrsns, state.start, state.end]);

    _react2.default.useEffect(function () {
        var particids = state.particids,
            datavrsns = state.datavrsns,
            particidsBlur = state.particidsBlur;

        if (!particids || particids.length < 1) return;
        needServerData({
            endpoint: "/exportable/surgdt-range",
            loadingMessage: "Loading Available Date Range...",
            params: serverDataParams({
                particids: particids,
                datavrsns: datavrsns
            }),
            onData: function onData(data) {
                return setDataKey("daterange", {
                    from: data.from,
                    to: data.to
                });
            }
        });
    }, [state.particidsBlur, state.datavrsns]);

    _react2.default.useEffect(function () {
        // update the submit button and data
        if ((0, _DateRange.isDateRangeValid)(state.start, state.end) && !!state.particids) {
            var availableSurgeons = new Set(data.surgeons.map(function (it) {
                return it.value;
            }));
            onReady(serverDataParams(_extends({}, state, {
                surgeons: state.surgeons.filter(function (it) {
                    return availableSurgeons.has(it);
                }),
                exportFields: Object.entries(state.exportFields).reduce(function (agg, _ref6) {
                    var _ref7 = _slicedToArray(_ref6, 2),
                        e = _ref7[0],
                        fs = _ref7[1];

                    if (fs && fs.length) agg[e] = fs;
                    return agg;
                }, {}),
                // for backwards compatibility
                fieldnameFormat: state.headingFormat
            })));
        } else {
            onNotReady();
        }
    }, [state, data]);

    var handleChange = _react2.default.useCallback(function (key, value) {
        return setState(function (s) {
            return _extends({}, s, _defineProperty({}, key, value));
        });
    }, [setState]);

    return _react2.default.createElement(FormView, {
        state: state,
        data: data,
        onChange: handleChange
    });
};

ThoracicExportForm.propTypes = {
    initialState: _propTypes2.default.shape({
        start: _propTypes2.default.any,
        end: _propTypes2.default.any,
        particids: _propTypes2.default.arrayOf(_propTypes2.default.string),
        datavrsns: _propTypes2.default.arrayOf(_propTypes2.default.string),
        surgeons: _propTypes2.default.arrayOf(_propTypes2.default.string),
        headingFormat: _propTypes2.default.string,
        delimiter: _propTypes2.default.string,
        optionFormat: _propTypes2.default.string,
        dateFormat: _propTypes2.default.string,
        fieldSort: _propTypes2.default.string,
        exportFields: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
        fileFormat: _propTypes2.default.string
    }),
    needServerData: _propTypes2.default.func.isRequired,
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

ThoracicExportForm.canRerun = function (params) {
    return !!params;
};

ThoracicExportForm.apiPrefix = "thoracic";

(0, _formRegistry.registerForm)("thoracic-export", ThoracicExportForm);

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _DateRange = __webpack_require__(95);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _OptionGroup = __webpack_require__(108);

var _OptionGroup2 = _interopRequireDefault(_OptionGroup);

var _formRegistry = __webpack_require__(74);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _useKeyValueState3 = __webpack_require__(38);

var _useKeyValueState4 = _interopRequireDefault(_useKeyValueState3);

var _serializeParams = __webpack_require__(96);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormView = function FormView(_ref) {
    var _onChange = _ref.onChange,
        state = _ref.state,
        data = _ref.data;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Participant ID"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "particid",
                            className: "participant form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("particid", v);
                            },
                            value: state.particid,
                            options: data.particid,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(_DateRange2.default, {
                    start: state.start,
                    end: state.end,
                    min: data.daterange.from,
                    max: data.daterange.to,
                    onChange: _onChange,
                    disabled: !state.particid,
                    required: true
                })
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(_OptionGroup2.default, {
                state: state.optionalFields,
                data: data.optionalFields,
                expanded: false,
                onChange: function onChange(value) {
                    return _onChange("optionalFields", value);
                }
            })
        )
    );
};

var selectShape = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
}));

FormView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    state: _propTypes2.default.shape({
        start: _propTypes2.default.string,
        end: _propTypes2.default.string,
        particid: _propTypes2.default.string,
        dateFormat: _propTypes2.default.string,
        optionalFields: _propTypes2.default.object
    }),
    data: _propTypes2.default.shape({
        particid: selectShape,
        daterange: _propTypes2.default.shape({
            from: _propTypes2.default.array,
            to: _propTypes2.default.array
        }),
        optionalFields: _propTypes2.default.array
    })
};

var initialStateWithDefaults = function initialStateWithDefaults() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var newState = {
        start: (0, _DateRange.dateToString)(state.start),
        end: (0, _DateRange.dateToString)(state.end),
        particid: state.particid || "",
        optionalFields: state.optionalFields || {}
    };
    return (0, _serializeParams.unstringifyJson)(newState, "optionalFields");
};

var serverDataParams = function serverDataParams(params) {
    return (0, _serializeParams.stringifyJson)(params, "optionalFields");
};

var initialData = {
    particid: [],
    daterange: { from: [], to: [] },
    optionalFields: []
};

var ThoracicHarvestForm = function ThoracicHarvestForm(_ref2) {
    var initialState = _ref2.initialState,
        needServerData = _ref2.needServerData,
        onReady = _ref2.onReady,
        onNotReady = _ref2.onNotReady;

    var _React$useState = _react2.default.useState(function () {
        return initialStateWithDefaults(initialState);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(initialStateWithDefaults(initialState));
    }, [initialState]);

    var _useKeyValueState = (0, _useKeyValueState4.default)(initialData),
        _useKeyValueState2 = _slicedToArray(_useKeyValueState, 2),
        data = _useKeyValueState2[0],
        setDataKey = _useKeyValueState2[1];

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/participants",
            loadingMessage: "Loading Participants...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.particid + ": " + it.hospname,
                        value: it.particid
                    };
                });
                data.unshift({ label: "", value: "" });
                setDataKey("particid", data);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/optional-fields",
            loadingMessage: "Loading Available Fields...",
            onData: function onData(data) {
                var fields = data.entities;
                if (_.isEmpty(state.optionalFields)) {
                    // initially all fields are selected if none were provided.
                    var selected = {};
                    fields.forEach(function (f) {
                        selected[f.key] = f.fields.map(function (it) {
                            return it.key;
                        });
                    });
                    handleChange("optionalFields", selected);
                }
                setDataKey("optionalFields", fields);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var particid = state.particid,
            datavrsns = state.datavrsns,
            surgeons = state.surgeons;

        needServerData({
            endpoint: "/date-range",
            loadingMessage: "Loading Available Date Range...",
            params: serverDataParams({
                particid: particid,
                datavrsns: datavrsns,
                surgeons: surgeons
            }),
            onData: function onData(data) {
                return setDataKey("daterange", { from: data.from, to: data.to });
            }
        });
    }, [state.particid, state.datavrsns, state.surgeons]);

    _react2.default.useEffect(function () {
        if ((0, _DateRange.isDateRangeValid)(state.start, state.end) && !!state.particid) {
            onReady(serverDataParams(state));
        } else {
            onNotReady();
        }
    }, [state]);

    var handleChange = _react2.default.useCallback(function (key, value) {
        return setState(function (s) {
            return _extends({}, s, _defineProperty({}, key, value));
        });
    }, [setState]);

    return _react2.default.createElement(FormView, {
        state: state,
        data: data,
        onChange: handleChange
    });
};

ThoracicHarvestForm.propTypes = {
    initialState: _propTypes2.default.shape({}),
    needServerData: _propTypes2.default.func.isRequired,
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

ThoracicHarvestForm.canRerun = function (params) {
    return !!(params && params.particid);
};

ThoracicHarvestForm.apiPrefix = "thoracic";

(0, _formRegistry.registerForm)("thoracic-harvest", ThoracicHarvestForm);

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _QuarterYearSelect = __webpack_require__(81);

var _QuarterYearSelect2 = _interopRequireDefault(_QuarterYearSelect);

var _useKeyValueState3 = __webpack_require__(38);

var _useKeyValueState4 = _interopRequireDefault(_useKeyValueState3);

var _formRegistry = __webpack_require__(74);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FormView = function FormView(_ref) {
    var _onChange = _ref.onChange,
        state = _ref.state,
        data = _ref.data;
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Participant ID"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "particid",
                            className: "participant form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("particid", v);
                            },
                            value: state.particid,
                            options: data.particid,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Submission Type"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-group" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-12" },
                        _react2.default.createElement(_Select2.default, {
                            name: "submissionType",
                            className: "submissionType form-control",
                            onCommitChange: function onCommitChange(v) {
                                return _onChange("submissionType", v);
                            },
                            value: state.submissionType,
                            options: data.submissionType,
                            disabled: !state.particid,
                            required: true
                        })
                    )
                ),
                _react2.default.createElement(
                    "h3",
                    null,
                    "Quarter"
                ),
                _react2.default.createElement(_QuarterYearSelect2.default, {
                    quarter: state.quarter,
                    year: state.year,
                    min: data.daterange.from,
                    max: data.daterange.to,
                    onChange: _onChange,
                    disabled: !state.particid || !state.submissionType,
                    required: true
                })
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-section form-horizontal" },
            _react2.default.createElement(
                "div",
                { className: "form-section-inner" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Export Options"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "checkbox" },
                    _react2.default.createElement(
                        "label",
                        null,
                        _react2.default.createElement("input", {
                            type: "checkbox",
                            className: "exclude_ncdr_patient_identifiers",
                            onChange: function onChange(e) {
                                return _onChange("excludePatientIdentifiers", e.target.checked ? "true" : "false");
                            },
                            checked: state.excludePatientIdentifiers === "true"
                        }),
                        "Exclude NCDR Patient Identifiers"
                    )
                )
            )
        )
    );
};

var selectShape = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
}));

FormView.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    state: _propTypes2.default.shape({
        start: _propTypes2.default.string,
        end: _propTypes2.default.string,
        submissionType: _propTypes2.default.string,
        excludePatientIdentifiers: _propTypes2.default.string,
        particid: _propTypes2.default.string
    }),
    data: _propTypes2.default.shape({
        particid: selectShape,
        quarter: _propTypes2.default.string,
        year: _propTypes2.default.string,
        submissionType: _propTypes2.default.array
    })
};

var asString = function asString(v) {
    return v == null ? "" : v.toString();
};

var initialStateWithDefaults = function initialStateWithDefaults() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        quarter: asString(state.quarter),
        year: asString(state.year),
        particid: asString(state.particid),
        submissionType: asString(state.submissionType),
        excludePatientIdentifiers: asString(state.excludePatientIdentifiers)
    };
};

var initialData = {
    particid: [],
    daterange: { from: [], to: [] },
    submissionType: [{ value: "", label: "" }, { value: "1", label: "Episode of Care Records" }, { value: "2", label: "Follow-Up Records" }]
};

var StsAccTvtExportForm = function StsAccTvtExportForm(_ref2) {
    var initialState = _ref2.initialState,
        needServerData = _ref2.needServerData,
        onReady = _ref2.onReady,
        onNotReady = _ref2.onNotReady;

    var _React$useState = _react2.default.useState(function () {
        return initialStateWithDefaults(initialState);
    }),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    _react2.default.useEffect(function () {
        return setState(initialStateWithDefaults(initialState));
    }, [initialState]);

    var _useKeyValueState = (0, _useKeyValueState4.default)(initialData),
        _useKeyValueState2 = _slicedToArray(_useKeyValueState, 2),
        data = _useKeyValueState2[0],
        setDataKey = _useKeyValueState2[1];

    _react2.default.useEffect(function () {
        needServerData({
            endpoint: "/participants",
            loadingMessage: "Loading Participants...",
            onData: function onData(data) {
                data = data.map(function (it) {
                    return {
                        label: it.particid + ": " + it.hospname,
                        value: it.particid
                    };
                });
                data.unshift({ label: "", value: "" });
                setDataKey("particid", data);
            }
        });
    }, []);

    _react2.default.useEffect(function () {
        var particid = state.particid,
            submissionType = state.submissionType;

        if (!particid || !submissionType) return;
        needServerData({
            endpoint: "/date-range",
            loadingMessage: "Loading Available Date Range...",
            params: {
                particid: particid,
                submissionType: submissionType
            },
            onData: function onData(data) {
                return setDataKey("daterange", { from: data.from, to: data.to });
            }
        });
    }, [state.particid, state.submissionType]);

    _react2.default.useEffect(function () {
        if (state.quarter && state.year && state.particid && state.submissionType) {
            onReady(_extends({}, state));
        } else {
            onNotReady();
        }
    }, [state]);

    var handleChange = _react2.default.useCallback(function (key, value) {
        return setState(function (s) {
            return _extends({}, s, _defineProperty({}, key, value));
        });
    }, [setState]);

    return _react2.default.createElement(FormView, {
        state: state,
        data: data,
        onChange: handleChange
    });
};

StsAccTvtExportForm.propTypes = {
    initialState: _propTypes2.default.shape({
        quarter: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        year: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        particid: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        submissionType: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        excludePatientIdentifiers: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string])
    }),
    needServerData: _propTypes2.default.func.isRequired,
    onReady: _propTypes2.default.func.isRequired,
    onNotReady: _propTypes2.default.func.isRequired
};

StsAccTvtExportForm.canRerun = function (params) {
    return !!(params && params.particid);
};

StsAccTvtExportForm.apiPrefix = "tvt";

(0, _formRegistry.registerForm)("sts-acc-tvt-export", StsAccTvtExportForm);

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _application = __webpack_require__(487);

var _application2 = _interopRequireDefault(_application);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _BrowserActions = __webpack_require__(616);

var _BrowserActions2 = _interopRequireDefault(_BrowserActions);

var _DevelopmentActions = __webpack_require__(98);

var _DevelopmentActions2 = _interopRequireDefault(_DevelopmentActions);

var _NavigationStore = __webpack_require__(1592);

var _NavigationStore2 = _interopRequireDefault(_NavigationStore);

var _BaseServices = __webpack_require__(76);

var _BaseServices2 = _interopRequireDefault(_BaseServices);

var _query_string = __webpack_require__(192);

var _query_string2 = _interopRequireDefault(_query_string);

__webpack_require__(1593);

__webpack_require__(1595);

var _LockApi = __webpack_require__(317);

var _LockApi2 = _interopRequireDefault(_LockApi);

var _hasUnsavedChanges = __webpack_require__(319);

var _hasUnsavedChanges2 = _interopRequireDefault(_hasUnsavedChanges);

var _ITDriver = __webpack_require__(1596);

var _ITDriver2 = _interopRequireDefault(_ITDriver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.Hybrid = __webpack_require__(1614);

if (false) {
    // so it can receive the selection action (before app bootstrap)
    // eslint-disable-next-line no-unused-expressions
    require("data/dev/MocksetStore").default;
}

if (false) {
    // this should stay 'require', even after conversion to JS
    var reduxDevToolsHelper = require("data/util/reduxDevToolsHelper").default;
    _Dispatcher2.default.register(reduxDevToolsHelper);
}

_application2.default.addInitializationPromise(new $.Deferred(function (d) {
    return $(function () {
        return d.resolve();
    });
}).promise());

window.addEventListener("resize", function () {
    return _Dispatcher2.default.dispatch({ type: _BrowserActions2.default.RESIZE });
});

window.addEventListener("beforeunload", function (e) {
    if ((0, _hasUnsavedChanges2.default)() && !_BaseServices2.default.__mocked && _NavigationStore2.default.canPromptExternalNavigation()) {
        e.preventDefault();
        return e.returnValue = "Changes you made may not be saved.";
    }
});

window.addEventListener("unload", function () {
    return _LockApi2.default.releaseClient();
});

if (window.location.search !== "") {
    var params = _query_string2.default.parse();
    window.AB = params.ab === "b" || params.ab === "B" ? "B" : "A";
    if (params.IT != null || params.ITmanifest != null) {
        window.location.hash = "";
        $("head > title").text("HO : " + (params.IT || "IT").trim().split("\n")[0]);
        _ITDriver2.default.initialize(params);
    }
    if (params.mock != null) {
        var mockset = $.trim(params.mock);
        if (mockset === "" || mockset === "true") {
            if (window.HybridConfig.mockRoot != null) {
                console.log("Using default configured mockset: " + window.HybridConfig.mockRoot);
            } else {
                console.log("No mockset specified on the URL, nor configured in config.js");
            }
        } else {
            window.HybridConfig.mockRoot = "mocks/" + mockset + "/";
            _application2.default.addInitializer(function () {
                return _Dispatcher2.default.dispatch({
                    type: _DevelopmentActions2.default.SELECT_MOCKSET,
                    mockset: mockset
                });
            });
        }
        __webpack_require__(667);
    }
} else {
    window.AB = "A";
}

_application2.default.initialize();

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

var DataEntry, Model, _ref,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Model = __webpack_require__(83)["default"];

module.exports = DataEntry = (function(_super) {
  __extends(DataEntry, _super);

  function DataEntry() {
    this.get = __bind(this.get, this);    _ref = DataEntry.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  DataEntry.prototype.defaults = {
    selectedSidebar: null
  };

  DataEntry.prototype.get = function(key) {
    if (key === "entity") {
      throw new Error("No getting a superrecord, yo");
    }
    return DataEntry.__super__.get.call(this, key);
  };

  return DataEntry;

})(Model);


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

var Collection, Creatable, Model, Version, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Collection = __webpack_require__(145);

Model = __webpack_require__(83)["default"];

Version = __webpack_require__(993);

module.exports = Creatable = (function(_super) {
  __extends(Creatable, _super);

  function Creatable() {
    _ref = Creatable.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  Creatable.prototype.initialize = function() {
    return this.set("versions", new Collection(this.attributes.versions, {
      model: Version
    }));
  };

  return Creatable;

})(Model);


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

var Collection, Model, Version, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Collection = __webpack_require__(145);

Model = __webpack_require__(83)["default"];

module.exports = Version = (function(_super) {
  __extends(Version, _super);

  function Version() {
    _ref = Version.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  Version.prototype.initialize = function() {};

  return Version;

})(Model);


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

var Collection, Field, Model, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Collection = __webpack_require__(145);

Model = __webpack_require__(83)["default"];

module.exports = Field = (function(_super) {
  __extends(Field, _super);

  function Field() {
    _ref = Field.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  Field.prototype.defaults = {
    value: null
  };

  return Field;

})(Model);


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reactDom = __webpack_require__(154);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ViewStackRegion = __webpack_require__(996);

var _ViewStackRegion2 = _interopRequireDefault(_ViewStackRegion);

var _HybridConfig = __webpack_require__(41);

var _HybridConfig2 = _interopRequireDefault(_HybridConfig);

var _NavbarView = __webpack_require__(997);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AppLayout = function (_Backbone$Marionette$) {
    _inherits(AppLayout, _Backbone$Marionette$);

    function AppLayout() {
        var _ref;

        _classCallCheck(this, AppLayout);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = AppLayout.__proto__ || Object.getPrototypeOf(AppLayout)).call.apply(_ref, [this].concat(args)));

        _this.showModal = _this.showModal.bind(_this);
        _this.initialize = _this.initialize.bind(_this);
        _this.onRender = _this.onRender.bind(_this);
        _this.logoUrl = _HybridConfig2.default.get("ui.logoUrl", "");
        return _this;
    }

    _createClass(AppLayout, [{
        key: "initialize",
        value: function initialize(options) {
            this.appModel = options.appModel;
            this.listenTo(this.modal, "show", function () {
                return (
                    //  Cause the modal's div to become visible.
                    $("body").addClass("modal-open")
                );
            });
            this.listenTo(this.modal, "region:close", function () {
                return $("body").removeClass("modal-open");
            });
        }

        // I use the passed view factory function to render a modal, and return a
        // promise which will resolve when the modal is popped off the stack. The
        // factory function may be invoked multiple times, if another modal is
        // rendered atop it, but the promise will only resolve when the modal is
        // popped off the stack (not hidden).

    }, {
        key: "showModal",
        value: function showModal(viewFn) {
            var _this2 = this;

            return new Promise(function (resolve) {
                var onPop = function onPop(vfn) {
                    if (vfn !== viewFn) {
                        return;
                    }
                    _this2.stopListening(_this2.modal, "region:pop", onPop);
                    resolve();
                };
                _this2.listenTo(_this2.modal, "region:pop", onPop);
                _this2.modal.showOnStack(viewFn);
            });
        }
    }, {
        key: "onRender",
        value: function onRender() {
            _reactDom2.default.render(_react2.default.createElement(_NavbarView.BackboneNavbarView, { appModel: this.appModel, logoUrl: this.logoUrl }), document.getElementById("global-navbar"));
        }
    }]);

    return AppLayout;
}(Backbone.Marionette.Layout);

AppLayout.prototype.template = __webpack_require__(1010);
AppLayout.prototype.el = "body";

AppLayout.prototype.regions = {
    de: "#content_de",
    hex: "#content_hex",
    modal: {
        selector: "#modal",
        regionType: _ViewStackRegion2.default
    }
};

AppLayout.prototype.events = {};

exports.default = AppLayout;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewStackRegion = function (_Backbone$Marionette$) {
    _inherits(ViewStackRegion, _Backbone$Marionette$);

    function ViewStackRegion() {
        var _ref;

        _classCallCheck(this, ViewStackRegion);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = ViewStackRegion.__proto__ || Object.getPrototypeOf(ViewStackRegion)).call.apply(_ref, [this].concat(args)));

        _this.showOnStack = _this.showOnStack.bind(_this);
        _this.onViewClose = _this.onViewClose.bind(_this);
        return _this;
    }

    _createClass(ViewStackRegion, [{
        key: "initialize",
        value: function initialize() {
            this._viewStack = [];
        }
    }, {
        key: "_showNext",
        value: function _showNext() {
            this.dispatch("viewstack:next", this);
            // Prevent an endless loop
            if (this.currentView != null) {
                this.stopListening(this.currentView);
            }
            var view = this._viewStack[this._viewStack.length - 1]();
            try {
                this.show(view);
                this.listenTo(view, "close", this.onViewClose);
            } catch (e) {
                throw new Error("Couldn't show view: " + e);
            } finally {
                this.dispatch("viewstack:ready", this);
            }
        }

        // The viewFn should return a view, not be a view

    }, {
        key: "showOnStack",
        value: function showOnStack(viewFn) {
            if (typeof viewFn !== "function") {
                throw new Error("Non-function viewFn passed to ViewStackRegion.showOnStack");
            }
            this._viewStack.push(viewFn);
            this.trigger("region:push", viewFn);
            this._showNext();
        }
    }, {
        key: "onViewClose",
        value: function onViewClose() {
            if (this.currentView != null) {
                this.stopListening(this.currentView);
            }

            this.trigger("region:pop", this._viewStack.pop());
            if (this._viewStack.length > 0) {
                this._showNext();
            } else {
                this.trigger("region:close");
                this.close();
            }
        }
    }]);

    return ViewStackRegion;
}(Backbone.Marionette.Region);

exports.default = ViewStackRegion;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BackboneNavbarView = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.NavbarView = NavbarView;

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

var _OverActions = __webpack_require__(122);

var _OverActions2 = _interopRequireDefault(_OverActions);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _BroadcastListener = __webpack_require__(998);

var _BroadcastListener2 = _interopRequireDefault(_BroadcastListener);

var _backboneConnect = __webpack_require__(127);

var _GenericXmlExportPasswordAdmin = __webpack_require__(323);

var _LockListener = __webpack_require__(1000);

var _LockListener2 = _interopRequireDefault(_LockListener);

var _promisify = __webpack_require__(97);

var _promisify2 = _interopRequireDefault(_promisify);

var _Services = __webpack_require__(110);

var _Services2 = _interopRequireDefault(_Services);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _DevNavItemsContainer = __webpack_require__(1001);

var _DevNavItemsContainer2 = _interopRequireDefault(_DevNavItemsContainer);

var _DropDown = __webpack_require__(326);

var _DropDown2 = _interopRequireDefault(_DropDown);

var _WhoAmIListener = __webpack_require__(1009);

var _WhoAmIListener2 = _interopRequireDefault(_WhoAmIListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KeyedItem = function (_React$PureComponent) {
    _inherits(KeyedItem, _React$PureComponent);

    function KeyedItem(props) {
        _classCallCheck(this, KeyedItem);

        var _this = _possibleConstructorReturn(this, (KeyedItem.__proto__ || Object.getPrototypeOf(KeyedItem)).call(this, props));

        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }

    _createClass(KeyedItem, [{
        key: "onClick",
        value: function onClick(event) {
            event.preventDefault();
            var _props = this.props,
                onClick = _props.onClick,
                key = _props.itemKey;

            onClick && onClick(key);
        }
    }, {
        key: "render",
        value: function render() {
            var _props2 = this.props,
                key = _props2.itemKey,
                name = _props2.name,
                active = _props2.active,
                sectionKey = _props2.sectionKey;

            return active ? _react2.default.createElement(
                "li",
                { className: "active", "data-section": sectionKey },
                _react2.default.createElement(
                    "a",
                    { href: "#", "data-key": key },
                    name
                )
            ) : _react2.default.createElement(
                "li",
                { "data-section": sectionKey },
                _react2.default.createElement(
                    "a",
                    {
                        href: "#",
                        onClick: this.onClick,
                        onTouchStart: this.onClick,
                        "data-key": key
                    },
                    name
                )
            );
        }
    }]);

    return KeyedItem;
}(_react2.default.PureComponent);

KeyedItem.propTypes = {
    onClick: _propTypes2.default.func.isRequired,
    itemKey: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    active: _propTypes2.default.bool,
    sectionKey: _propTypes2.default.string
};

var KeyedSection = function (_React$PureComponent2) {
    _inherits(KeyedSection, _React$PureComponent2);

    function KeyedSection() {
        _classCallCheck(this, KeyedSection);

        return _possibleConstructorReturn(this, (KeyedSection.__proto__ || Object.getPrototypeOf(KeyedSection)).apply(this, arguments));
    }

    _createClass(KeyedSection, [{
        key: "render",
        value: function render() {
            var _props3 = this.props,
                items = _props3.items,
                label = _props3.label,
                onClick = _props3.onClick,
                divider = _props3.divider;

            if (items == null || items.length === 0) return null;
            var sectionKey = label.replace(/[^a-z0-9]+/gi, " ").trim().replace(/ /g, "-");
            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                divider && _react2.default.createElement("li", { className: "divider" }),
                _react2.default.createElement(
                    "li",
                    { className: "dropdown-header section", "data-section": sectionKey },
                    label
                ),
                items.map(function (v) {
                    return _react2.default.createElement(KeyedItem, _extends({
                        itemKey: v.key,
                        onClick: onClick,
                        sectionKey: sectionKey
                    }, v));
                })
            );
        }
    }]);

    return KeyedSection;
}(_react2.default.PureComponent);

KeyedSection.propTypes = {
    label: _propTypes2.default.string.isRequired,
    items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        key: _propTypes2.default.string.isRequired,
        name: _propTypes2.default.string.isRequired,
        active: _propTypes2.default.bool
    })),
    onClick: _propTypes2.default.func.isRequired,
    divider: _propTypes2.default.bool
};

var KeyedDropdown = function (_React$PureComponent3) {
    _inherits(KeyedDropdown, _React$PureComponent3);

    function KeyedDropdown() {
        _classCallCheck(this, KeyedDropdown);

        return _possibleConstructorReturn(this, (KeyedDropdown.__proto__ || Object.getPrototypeOf(KeyedDropdown)).apply(this, arguments));
    }

    _createClass(KeyedDropdown, [{
        key: "render",
        value: function render() {
            var _props4 = this.props,
                items = _props4.items,
                label = _props4.label,
                className = _props4.className,
                title = _props4.title,
                onClick = _props4.onClick;

            if (items == null || items.length === 0) return null;
            return _react2.default.createElement(
                _DropDown2.default,
                {
                    title: title,
                    label: label,
                    className: className
                },
                items.map(function (v) {
                    return _react2.default.createElement(KeyedItem, _extends({
                        itemKey: v.key,
                        onClick: onClick
                    }, v));
                })
            );
        }
    }]);

    return KeyedDropdown;
}(_react2.default.PureComponent);

KeyedDropdown.propTypes = _extends({}, KeyedSection.propTypes, {
    className: _propTypes2.default.string,
    title: _propTypes2.default.string
});

function generateApplications(user) {
    var applications = [];

    if (user.canUseDE) {
        applications.push({
            key: "de",
            name: "Data Entry"
        });
    }
    if (user.canUseDqr) {
        applications.push({
            key: "dqr",
            name: "DQR"
        });
    }

    if (user.canUseHex) {
        applications.push({
            key: "hex",
            name: "Harvest/Export"
        });
    }

    return applications;
}

/*******************************************************************************
 *
 * NavbarView uses `process.env.NODE_ENV` in several places to change the way
 * nav works in non-production. If you want the production experience in
 * development, search and replace the "development" string to some garbage,
 * just make sure you don't commit it that way. :)
 *
 * This dance is needed (instead of using a flag) because the environment
 * variable is evaluated at _compile_ time, and thus changes the generated
 * bundle. Using a flag would only ensure that the flag itself was initialized
 * to a constant in the bundles, it wouldn't be able to tree-shake the dev-only
 * code from the production bundle, because the flag itself won't be evaluated
 * until runtime.
 *
 ******************************************************************************/
function NavbarView(props) {
    var lookups = props.lookups,
        userInfo = props.userInfo,
        selectOrg = props.selectOrg,
        onLookupClick = props.onLookupClick,
        onValidationAdminClick = props.onValidationAdminClick,
        onHiddenFieldsAdminClick = props.onHiddenFieldsAdminClick,
        onAboutClick = props.onAboutClick,
        onPreferencesClick = props.onPreferencesClick,
        onGenericXmlPasswordAdmin = props.onGenericXmlPasswordAdmin,
        onBroadcastAdmin = props.onBroadcastAdmin,
        onLogoutClick = props.onLogoutClick,
        onReauthClick = props.onReauthClick,
        view = props.view,
        logoUrl = props.logoUrl;

    // this is just asinine, but such is our kludgey frankenapp.

    _react2.default.useEffect(function () {
        if (!document || !document.body || !document.body.classList) return;
        if (onReauthClick) {
            document.body.classList.add("security-mode-client");
        } else {
            document.body.classList.remove("security-mode-client");
        }
    }, [onReauthClick]);

    var orgs = userInfo.allOrgs;
    var navTree = userInfo.navTree;
    var activeOrg = userInfo.activeOrg;
    var showValidationAdmin = function showValidationAdmin(key) {
        return onValidationAdminClick(key, activeOrg.key);
    };
    var showHiddenFieldsAdmin = function showHiddenFieldsAdmin(key) {
        return onHiddenFieldsAdminClick(key, activeOrg.key);
    };
    var applications = generateApplications(userInfo);
    var globalLookups = lookups != null ? lookups.models.map(function (it) {
        return {
            key: it.get("key"),
            name: it.get("pluralName") || it.get("name")
        };
    }) : null;
    var navTreeItems = navTree == null ? null : navTree.items.map(function (n) {
        return _react2.default.createElement(
            "li",
            { key: n.label },
            _react2.default.createElement(
                "a",
                { href: n.url },
                n.label
            )
        );
    });
    var adminItems = [];
    if (onGenericXmlPasswordAdmin) {
        adminItems.push(_react2.default.createElement(KeyedItem, {
            key: "gxep",
            onClick: onGenericXmlPasswordAdmin,
            itemKey: "gxep",
            name: _GenericXmlExportPasswordAdmin.title
        }));
    }
    if (onBroadcastAdmin) {
        adminItems.push(_react2.default.createElement(KeyedItem, {
            key: "broadcast",
            onClick: onBroadcastAdmin,
            itemKey: "broadcast",
            name: "Admin Broadcast"
        }));
    }
    if (globalLookups != null && globalLookups.length > 0) {
        adminItems.push(_react2.default.createElement(KeyedSection, {
            key: "global-lookups",
            label: "Global Lookups",
            items: globalLookups,
            onClick: onLookupClick,
            divider: adminItems.length > 0
        }));
    }
    if (userInfo.validationAdminImpls != null && userInfo.validationAdminImpls.length > 0) {
        adminItems.push(_react2.default.createElement(KeyedSection, {
            key: "validation-admin",
            label: "Validation Administration",
            items: userInfo.validationAdminImpls,
            onClick: showValidationAdmin,
            divider: adminItems.length > 0
        }));
    }
    if (userInfo.hiddenFieldAdminImpls != null && userInfo.hiddenFieldAdminImpls.length >= 0) {
        adminItems.push(_react2.default.createElement(KeyedSection, {
            key: "hidden-field-admin",
            label: "Hidden Field Administration",
            items: userInfo.hiddenFieldAdminImpls,
            onClick: showHiddenFieldsAdmin,
            divider: adminItems.length > 0
        }));
    }

    var viewLabel = applications.length === 1 ? applications[0].name : (applications.find(function (it) {
        return it.key === (view || "de");
    }) || {}).name || "Views";

    // noinspection HtmlUnknownTarget
    return _react2.default.createElement(
        "div",
        { className: "navbar-inner" },
        _react2.default.createElement(_BroadcastListener2.default, null),
        _react2.default.createElement(_LockListener2.default, null),
        _react2.default.createElement(_WhoAmIListener2.default, {
            user: userInfo.username,
            org: activeOrg.key
        }),
        _react2.default.createElement(
            "div",
            { className: "container-fluid" },
            _react2.default.createElement(
                "div",
                { className: "navbar-header" },
                _react2.default.createElement(
                    "button",
                    { type: "button", className: "navbar-toggle",
                        "data-toggle": "collapse",
                        "data-target": "#navbar-collapse" },
                    _react2.default.createElement(
                        "span",
                        { className: "sr-only" },
                        "Toggle navigation"
                    ),
                    _react2.default.createElement("span", { className: "icon-bar" }),
                    _react2.default.createElement("span", { className: "icon-bar" }),
                    _react2.default.createElement("span", { className: "icon-bar" })
                ),
                _react2.default.createElement(
                    "a",
                    { className: "navbar-brand", href: "#" },
                    _react2.default.createElement("img", { height: "37", widht: "100%", src: "images/hc.svg", alt: "HealthCatalyst" })
                )
            ),
            _react2.default.createElement(
                "div",
                { className: "collapse navbar-collapse", id: "navbar-collapse" },
                _react2.default.createElement(
                    "ul",
                    { className: "nav navbar-nav" },
                    _react2.default.createElement(
                        "li",
                        { className: "navbar-app" },
                        "HybridOutcomes"
                    ),
                    applications.length === 1 ? _react2.default.createElement(
                        "li",
                        null,
                        _react2.default.createElement(
                            "p",
                            { className: "navbar-text" },
                            applications[0].name
                        )
                    ) : _react2.default.createElement(
                        _DropDown2.default,
                        { label: viewLabel,
                            className: "menu-hybrid control" },
                        applications.map(function (a) {
                            return _react2.default.createElement(
                                "li",
                                { key: a.name },
                                _react2.default.createElement(
                                    "a",
                                    { href: "#" + a.key },
                                    a.name
                                )
                            );
                        })
                    ),
                    orgs && _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        orgs.length === 1 ? _react2.default.createElement(
                            "li",
                            { title: activeOrg.name, className: "navbar-text navbar-orgs" },
                            activeOrg.name,
                            " ",
                            onReauthClick && _react2.default.createElement(
                                "button",
                                {
                                    className: "btn btn-dark btn-xs",
                                    onClick: onReauthClick
                                },
                                "Reauth"
                            )
                        ) : _react2.default.createElement(KeyedDropdown, {
                            title: activeOrg.name,
                            label: activeOrg.name,
                            className: "menu-orgs navbar-orgs",
                            items: orgs,
                            onClick: selectOrg
                        })
                    )
                ),
                _react2.default.createElement(
                    "ul",
                    { className: "nav navbar-nav navbar-right" },
                    "production" === "development" && _react2.default.createElement(_DevNavItemsContainer2.default, null),
                    _react2.default.createElement(_DropDown2.default, {
                        label:  false ? null : "Administration",
                        icon: "cog",
                        className: "menu-settings",
                        align: "right",
                        children: adminItems
                    }),
                    _react2.default.createElement(_DropDown2.default, {
                        label:  false ? null : "Applications",
                        icon: "th-list",
                        className: "menu-navtree",
                        align: "right",
                        children: navTreeItems
                    }),
                    _react2.default.createElement(
                        _DropDown2.default,
                        {
                            icon: "user",
                            label: _react2.default.createElement(
                                "span",
                                { className: "greeting" },
                                userInfo.displayName
                            ),
                            className: "menu-user",
                            align: "right"
                        },
                        _react2.default.createElement(KeyedItem, {
                            onClick: onAboutClick,
                            itemKey: "about",
                            name: "About"
                        }),
                        userInfo.canUseDE && _react2.default.createElement(KeyedItem, {
                            onClick: onPreferencesClick,
                            itemKey: "preferences",
                            name: "Preferences"
                        }),
                        _react2.default.createElement(
                            "li",
                            null,
                            _react2.default.createElement(
                                "a",
                                { href: "https://armussupport.zendesk.com",
                                    target: "_blank",
                                    rel: "noopener noreferrer" },
                                "ARMUS Support"
                            )
                        ),
                        _react2.default.createElement("li", { className: "divider" }),
                        onLogoutClick && _react2.default.createElement(KeyedItem, {
                            onClick: onLogoutClick,
                            itemKey: "logout",
                            name: "Logout"
                        }),
                        onReauthClick && _react2.default.createElement(KeyedItem, {
                            onClick: onReauthClick,
                            itemKey: "reauth",
                            name: "Reauthorize [TEST]"
                        })
                    ),
                    _react2.default.createElement(
                        "li",
                        { className: "navbar-cobrand" },
                        _react2.default.createElement("img", { src: logoUrl ? logoUrl : "/images/armus-logo.png", alt: "ARMUS by HealthCatalyst" })
                    )
                )
            )
        )
    );
}

var passthroughPropTypes = {
    selectOrg: _propTypes2.default.func.isRequired,
    lookups: _propTypes2.default.object,
    onLookupClick: _propTypes2.default.func.isRequired,
    onAboutClick: _propTypes2.default.func.isRequired,
    onPreferencesClick: _propTypes2.default.func.isRequired,
    onGenericXmlPasswordAdmin: _propTypes2.default.func,
    onBroadcastAdmin: _propTypes2.default.func,
    onLogoutClick: _propTypes2.default.func,
    onReauthClick: _propTypes2.default.func,
    onValidationAdminClick: _propTypes2.default.func.isRequired,
    onHiddenFieldsAdminClick: _propTypes2.default.func.isRequired
};

NavbarView.propTypes = _extends({}, passthroughPropTypes, {
    userInfo: _propTypes2.default.shape({
        displayName: _propTypes2.default.string.isRequired,
        canUseDE: _propTypes2.default.bool.isRequired,
        canUseDqr: _propTypes2.default.bool.isRequired,
        canUseHex: _propTypes2.default.bool.isRequired,
        navTree: _propTypes2.default.object,
        allOrgs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            key: _propTypes2.default.string.isRequired,
            name: _propTypes2.default.string.isRequired,
            active: _propTypes2.default.bool.isRequired
        })).isRequired,
        activeOrg: _propTypes2.default.shape({
            key: _propTypes2.default.string.isRequired,
            name: _propTypes2.default.string.isRequired
        }).isRequired,
        validationAdminImpls: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
        hiddenFieldAdminImpls: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
    }).isRequired,
    view: _propTypes2.default.string,
    logoUrl: _propTypes2.default.string
});

var NavbarViewContainer = function NavbarViewContainer(props) {
    var userInfo = (0, _useFluxStore2.default)(function () {
        return {
            displayName: _userStore2.default.getDisplayName(),
            superuser: _userStore2.default.isSuperuser(),
            canUseDE: _userStore2.default.canUseDE(),
            canUseDqr: _userStore2.default.canUseDqr(),
            canUseHex: _userStore2.default.canUseHex(),
            anyPrefMan: _userStore2.default.isPrefManForAnything(),
            navTree: _userStore2.default.getNavTree(),
            allOrgs: _userStore2.default.getAllOrgs(),
            activeOrg: _userStore2.default.getActiveOrg(),
            username: _userStore2.default.getUsername(),
            validationAdminImpls: _userStore2.default.getImplsWithValidationAdmin(),
            hiddenFieldAdminImpls: _userStore2.default.getImplsWithHiddenFieldAdmin(),
            isRealSession: _userStore2.default.isRealSession()
        };
    }, [_userStore2.default]);
    props = _extends({}, props);
    if (!userInfo.anyPrefMan) {
        delete props.onGenericXmlPasswordAdmin;
    }
    if (!userInfo.superuser) {
        delete props.onBroadcastAdmin;
    }
    if (!userInfo.canUseDE) {
        delete props.lookups;
    }
    if (userInfo.isRealSession) {
        delete props.onReauthClick;
    } else {
        delete props.onLogoutClick;
    }
    return _react2.default.createElement(NavbarView, _extends({}, props, { userInfo: userInfo }));
};

NavbarViewContainer.propTypes = passthroughPropTypes;

function onReauthClick() {
    Backbone.dispatcher.trigger("load:test-reauth");
}

var config = function config(props) {
    return {
        selectOrg: function selectOrg(key) {
            _Dispatcher2.default.dispatch({
                type: _OverActions2.default.EXTERNAL_NAV,
                message: "Loading...",
                callback: function callback() {
                    (0, _promisify2.default)(_Services2.default.saveActiveOrgs([key])).then(function () {
                        window.location.hash = ""; //  kludge to remove any path, as it'll be invalid w/ new org
                        window.location.reload();
                    });
                }
            });
        },
        lookups: {
            listenOn: "appModel"
        },
        view: {
            listenOn: "appModel"
        },
        onLookupClick: function onLookupClick(key) {
            return Backbone.dispatcher.trigger("load:global_lookup", key);
        },
        onValidationAdminClick: function onValidationAdminClick(key, org) {
            return Backbone.dispatcher.trigger("load:validation_filter", org, key);
        },
        onHiddenFieldsAdminClick: function onHiddenFieldsAdminClick(key, org) {
            return Backbone.dispatcher.trigger("load:hidden_field_admin", org, key);
        },
        onAboutClick: function onAboutClick() {
            return Backbone.dispatcher.trigger("load:about");
        },
        onPreferencesClick: function onPreferencesClick() {
            return Backbone.dispatcher.trigger("load:preferences");
        },
        onGenericXmlPasswordAdmin: function onGenericXmlPasswordAdmin() {
            return Backbone.dispatcher.trigger("load:genericXmlPasswordAdmin");
        },
        onBroadcastAdmin: function onBroadcastAdmin() {
            return Backbone.dispatcher.trigger("load:broadcastAdmin");
        },
        onLogoutClick: function onLogoutClick() {
            return Backbone.dispatcher.trigger("confirm:user:logout", props.appModel);
        },
        onReauthClick: onReauthClick
    };
};

var BackboneNavbarView = exports.BackboneNavbarView = (0, _backboneConnect.backboneConnect)(config)(NavbarViewContainer);

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _HybridConfig = __webpack_require__(41);

var _HybridConfig2 = _interopRequireDefault(_HybridConfig);

var _BroadcastServices = __webpack_require__(491);

var _BroadcastServices2 = _interopRequireDefault(_BroadcastServices);

var _withOver = __webpack_require__(58);

var _usePeriodicTask = __webpack_require__(325);

var _usePeriodicTask2 = _interopRequireDefault(_usePeriodicTask);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_POLL_INTERVAL = 15 * 60 * 1000;

function BroadcastListener() {
    var _React$useState = _react2.default.useState(0),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        last = _React$useState2[0],
        setLast = _React$useState2[1];

    (0, _usePeriodicTask2.default)(function () {
        _BroadcastServices2.default.getMessages(last).then(function (ms) {
            if (ms.length === 0) return;
            ms.sort(function (a, b) {
                return b.activeAt - a.activeAt;
            });
            ms.forEach(function (m) {
                return (0, _withOver.appAlert)(m.message);
            });
            setLast(ms[0].activeAt);
        });
    }, _HybridConfig2.default.get("broadcast.pollInterval", DEFAULT_POLL_INTERVAL), [last]);
    return null;
}

exports.default = BroadcastListener;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function processAdapterConfig(adapter, config) {
    var statics = {};
    if (typeof config === "function") {
        config = config(adapter.props);
    }
    if (!(config instanceof Array)) {
        // an Object w/ keys as props
        var ca = [];
        for (var k in config) {
            if (config.hasOwnProperty(k)) {
                var c = config[k];
                if (c.hasOwnProperty("prop")) {
                    console.warn("The bind config for prop '" + k + "' has an explicit `prop` attribute (" + c.prop + ").");
                }
                if (typeof c === "function") {
                    statics[k] = c;
                } else {
                    ca.push(Object.assign({ prop: k, attribute: k }, c));
                }
            }
        }
        config = ca;
    }
    var items = config.map(function (it) {
        var c = Object.assign({}, it);
        if (!c.hasOwnProperty("event")) {
            c.event = "change:" + c.attribute;
        }
        if (!c.hasOwnProperty("func")) {
            if (!c.hasOwnProperty("prop")) {
                c.prop = c.attribute;
            }
            if (c.hasOwnProperty("value")) {
                c.func = function () {
                    return _defineProperty({}, c.prop, c.value);
                };
            } else if (c.hasOwnProperty("get")) {
                c.func = function () {
                    return _defineProperty({}, c.prop, c.get.apply(c, arguments));
                };
            } else {
                c.func = function (model) {
                    var result = void 0;
                    if (c.hasOwnProperty("errorValue")) {
                        try {
                            result = model.get(c.attribute);
                        } catch (e) {
                            result = c.errorValue;
                        }
                    } else {
                        result = model.get(c.attribute);
                    }
                    return _defineProperty({}, c.prop, result);
                };
            }
        }

        c.listenerFunc = function () {
            var _arguments = arguments;

            adapter.setState(function () {
                return c.func.apply(c, _arguments);
            });
        };
        return c;
    });
    items.statics = statics;
    return items;
}

exports.default = processAdapterConfig;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _HybridConfig = __webpack_require__(41);

var _HybridConfig2 = _interopRequireDefault(_HybridConfig);

var _LockApi = __webpack_require__(317);

var _LockApi2 = _interopRequireDefault(_LockApi);

var _lockStore = __webpack_require__(144);

var _lockStore2 = _interopRequireDefault(_lockStore);

var _usePeriodicTask = __webpack_require__(325);

var _usePeriodicTask2 = _interopRequireDefault(_usePeriodicTask);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_POLL_INTERVAL = 60 * 1000;

function LockListener() {
    (0, _usePeriodicTask2.default)(function () {
        return _lockStore2.default.getActiveLocksetIds().forEach(_LockApi2.default.confirmLockset);
    }, _HybridConfig2.default.get("lockMonitoring.pollInterval", DEFAULT_POLL_INTERVAL), []);
    return null;
}

exports.default = LockListener;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ITManifestStore = __webpack_require__(1002);

var _ITManifestStore2 = _interopRequireDefault(_ITManifestStore);

var _ITTestStore = __webpack_require__(493);

var _ITTestStore2 = _interopRequireDefault(_ITTestStore);

var _DevNavItems = __webpack_require__(1003);

var _DevNavItems2 = _interopRequireDefault(_DevNavItems);

var _MocksetManifestStore = __webpack_require__(1007);

var _MocksetManifestStore2 = _interopRequireDefault(_MocksetManifestStore);

var _MocksetStore = __webpack_require__(1008);

var _MocksetStore2 = _interopRequireDefault(_MocksetStore);

var _ITTestHistoryStore = __webpack_require__(327);

var _ITTestHistoryStore2 = _interopRequireDefault(_ITTestHistoryStore);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var state = (0, _useFluxStore2.default)(function () {
        return {
            mocksetLO: _MocksetManifestStore2.default.getLoadObject(),
            activeMockset: _MocksetStore2.default.getState().mockset,
            itTestLO: _ITManifestStore2.default.getLoadObject(),
            activeTest: _ITTestStore2.default.getState().path,
            history: _ITTestHistoryStore2.default.getState()
        };
    }, [_MocksetManifestStore2.default, _MocksetStore2.default, _ITManifestStore2.default, _ITTestStore2.default, _ITTestHistoryStore2.default]);
    return _react2.default.createElement(_DevNavItems2.default, state);
};

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(13);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _storeUtils = __webpack_require__(54);

var _DevelopmentActions = __webpack_require__(98);

var _DevelopmentActions2 = _interopRequireDefault(_DevelopmentActions);

var _DevDataManager = __webpack_require__(492);

var _DevDataManager2 = _interopRequireDefault(_DevDataManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ITManifestStore = function (_ReduceStore) {
    _inherits(ITManifestStore, _ReduceStore);

    function ITManifestStore() {
        _classCallCheck(this, ITManifestStore);

        return _possibleConstructorReturn(this, (ITManifestStore.__proto__ || Object.getPrototypeOf(ITManifestStore)).call(this, _Dispatcher2.default));
    }

    _createClass(ITManifestStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return _LoadObject2.default.empty().withPropTypes({
                root: _propTypes2.default.string.isRequired,
                // map of directory-name -> list-of-filename
                tests: _propTypes2.default.objectOf(_propTypes2.default.arrayOf(_propTypes2.default.string)).isRequired
            });
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {
                case _DevelopmentActions2.default.START_IT_MANIFEST_LOAD:
                    return state.loading(_DevDataManager2.default.loadITManifest());
                case _DevelopmentActions2.default.IT_MANIFEST_LOADED:
                    return state.receiveValue({
                        root: action.data.root,
                        tests: action.data.tests.split("\n").map(function (it) {
                            return it.trim();
                        }).filter(function (it) {
                            return it.length > 0;
                        }).reduce(function (dirs, path) {
                            var parts = path.split("/");
                            var fn = parts.pop();
                            var dir = parts.join("/");
                            if (!dirs.hasOwnProperty(dir)) {
                                dirs[dir] = [];
                            }
                            dirs[dir].push(fn);
                            return dirs; // tee-hee
                        }, {})
                    });
                case _DevelopmentActions2.default.IT_MANIFEST_ERROR:
                    return state.receiveError(action.error);
                default:
                    return state;
            }
        }
    }, {
        key: "getLoadObject",
        value: function getLoadObject() {
            var _this2 = this;

            return (0, _storeUtils.hotLoadObject)(function () {
                return _this2.getState();
            }, function () {
                return _Dispatcher2.default.dispatch({
                    type: _DevelopmentActions2.default.START_IT_MANIFEST_LOAD
                });
            });
        }
    }]);

    return ITManifestStore;
}(_utils.ReduceStore);

exports.default = new ITManifestStore();

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MocksetNavItem = __webpack_require__(1004);

var _MocksetNavItem2 = _interopRequireDefault(_MocksetNavItem);

var _ITTestNavItem = __webpack_require__(1005);

var _ITTestNavItem2 = _interopRequireDefault(_ITTestNavItem);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _ITTestHistoryStore = __webpack_require__(327);

var _ITTestHistoryStore2 = _interopRequireDefault(_ITTestHistoryStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DevNavItems = function DevNavItems(props) {
    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(_MocksetNavItem2.default, { mocksetLO: props.mocksetLO, activeMockset: props.activeMockset }),
        _react2.default.createElement(_ITTestNavItem2.default, { itTestLO: props.itTestLO, activeTest: props.activeTest, history: props.history })
    );
};

DevNavItems.propTypes = {
    activeTest: _propTypes2.default.string,
    itTestLO: _propTypes2.default.instanceOf(_LoadObject2.default),
    activeMockset: _propTypes2.default.string,
    mocksetLO: _propTypes2.default.instanceOf(_LoadObject2.default),
    history: _ITTestHistoryStore2.default.constructor.stateTypes // this is questionable.
};

exports.default = DevNavItems;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _DropDown = __webpack_require__(326);

var _DropDown2 = _interopRequireDefault(_DropDown);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MocksetNavItem = function MocksetNavItem(_ref) {
    var mocksetLO = _ref.mocksetLO,
        activeMockset = _ref.activeMockset;

    if (mocksetLO.isPending()) {
        return _react2.default.createElement(
            "li",
            { className: "navbar-text" },
            "Loading..."
        );
    }
    if (mocksetLO.hasError()) {
        return _react2.default.createElement(
            "li",
            { className: "navbar-text", title: "There was an error loading the mockset manifest." },
            "Error!"
        );
    }

    var _mocksetLO$getRequire = mocksetLO.getRequiredValue(),
        mocksets = _mocksetLO$getRequire.mocksets;

    if (mocksets && mocksets.length > 0) {
        return _react2.default.createElement(
            _DropDown2.default,
            { label: activeMockset || "Mocks",
                align: "right" },
            mocksets.map(function (s) {
                return _react2.default.createElement(
                    "li",
                    { key: s, className: s === activeMockset ? "active" : null },
                    _react2.default.createElement(
                        "a",
                        { href: "?mock=" + s },
                        s
                    )
                );
            })
        );
    }
    return null;
};

MocksetNavItem.propTypes = {
    activeMockset: _propTypes2.default.string,
    mocksetLO: _propTypes2.default.instanceOf(_LoadObject2.default)
};

exports.default = MocksetNavItem;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DropDown = __webpack_require__(326);

var _DropDown2 = _interopRequireDefault(_DropDown);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _filenameToLabel = __webpack_require__(1006);

var _filenameToLabel2 = _interopRequireDefault(_filenameToLabel);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _ITTestHistoryStore = __webpack_require__(327);

var _ITTestHistoryStore2 = _interopRequireDefault(_ITTestHistoryStore);

var _classnames = __webpack_require__(51);

var _classnames2 = _interopRequireDefault(_classnames);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _DevelopmentActions = __webpack_require__(98);

var _DevelopmentActions2 = _interopRequireDefault(_DevelopmentActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var removePrefix = function removePrefix(str, prefix) {
    return str.indexOf(prefix) === 0 ? str.substr(prefix.length) : str;
};

var ITTestNavItem = function (_React$Component) {
    _inherits(ITTestNavItem, _React$Component);

    function ITTestNavItem(props) {
        _classCallCheck(this, ITTestNavItem);

        var _this = _possibleConstructorReturn(this, (ITTestNavItem.__proto__ || Object.getPrototypeOf(ITTestNavItem)).call(this, props));

        _this.state = {
            text: null
        };
        _this.onClear = _this.onClear.bind(_this);
        _this.doKeyDown = _this.doKeyDown.bind(_this);
        _this.onHide = _this.onHide.bind(_this);
        return _this;
    }

    _createClass(ITTestNavItem, [{
        key: "onClear",
        value: function onClear() {
            _Dispatcher2.default.dispatch({
                type: _DevelopmentActions2.default.RESET_IT_TEST_STATUS
            });
        }
    }, {
        key: "doKeyDown",
        value: function doKeyDown(e) {
            var _this2 = this;

            var k = e.key;
            if (this.resetTimeout != null) {
                clearTimeout(this.resetTimeout);
                this.resetTimeout = null;
            }
            // eslint-disable-next-line no-settimeout
            this.resetTimeout = setTimeout(function () {
                _this2.setState({
                    text: null
                });
            }, 5000);
            if (k === "Escape") {
                // this is bad form, but we need synchronicity, and it'll be close
                // enough for a dev-only thing that doesn't have to be perfect.
                var hadText = !!this.state.text;
                this.setState({
                    text: null
                });
                if (!hadText) return;
            } else if (k === "Backspace") {
                this.setState(function (s) {
                    return {
                        text: s.text == null ? null : s.text.substr(0, s.text.length - 1)
                    };
                });
            } else if (k.length === 1) {
                this.setState(function (s) {
                    return {
                        text: s.text == null ? k : s.text + k
                    };
                });
            } else {
                return;
            }
            e.stopPropagation();
            e.preventDefault();
        }
    }, {
        key: "onHide",
        value: function onHide() {
            this.setState({
                text: null
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                itTestLO = _props.itTestLO,
                history = _props.history;
            var activeTest = this.props.activeTest;
            var filterText = this.state.text;

            if (itTestLO.isPending()) {
                return _react2.default.createElement(
                    "li",
                    { className: "navbar-text" },
                    "Loading..."
                );
            }
            if (itTestLO.hasError()) {
                return _react2.default.createElement(
                    "li",
                    { className: "navbar-text",
                        title: "There was an error loading the IT test manifest." },
                    "Error!"
                );
            }

            var _itTestLO$getRequired = itTestLO.getRequiredValue(),
                root = _itTestLO$getRequired.root,
                allTests = _itTestLO$getRequired.tests;

            var tests = void 0;
            if (filterText) {
                (function () {
                    var textToWords = function textToWords(text) {
                        return text.replace(/([^A-Z])([A-Z])/g, "$1 $2").toLowerCase().split(" ").map(function (it) {
                            return it.trim();
                        }).filter(function (it) {
                            return it.length;
                        });
                    };
                    var catWords = null;
                    var nameText = filterText;
                    var slashIdx = filterText.indexOf("/");
                    if (slashIdx >= 0) {
                        catWords = textToWords(filterText.substr(0, slashIdx));
                        nameText = filterText.substr(slashIdx + 1);
                    }
                    var words = textToWords(nameText);
                    var isMatch = function isMatch(words, str) {
                        var lc = str.toLowerCase();
                        return words.every(function (w) {
                            return lc.indexOf(w) >= 0;
                        });
                    };
                    tests = {};

                    var _loop = function _loop(cat) {
                        var ts = void 0;
                        if (catWords) {
                            if (!isMatch(catWords, cat)) return "continue";
                            ts = allTests[cat].filter(function (t) {
                                return isMatch(words, t);
                            });
                        } else if (isMatch(words, cat)) {
                            ts = allTests[cat];
                        } else {
                            ts = allTests[cat].filter(function (t) {
                                return isMatch(words, cat + "/" + t);
                            });
                        }
                        if (ts.length > 0) {
                            tests[cat] = ts;
                        }
                    };

                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = Object.keys(allTests)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var cat = _step.value;

                            var _ret2 = _loop(cat);

                            if (_ret2 === "continue") continue;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                })();
            } else {
                tests = allTests;
            }
            if (activeTest) {
                if (window.location.origin) {
                    activeTest = removePrefix(activeTest, window.location.origin + "/");
                }
                activeTest = removePrefix(activeTest, root + "/");
            }
            var activeCats = Object.keys(tests).sort(function (a, b) {
                var A = a.toUpperCase();
                var B = b.toUpperCase();
                if (A < B) return -1;
                if (A > B) return 1;
                return 0;
            });
            var label = activeTest || "IT Tests";
            var maxLen = 30;
            if (label.length > maxLen) {
                var parts = label.split("/");
                label = parts.map(function (s, i) {
                    return i === parts.length - 1 ? s : s.substring(0, 1);
                }).join("/");
            }
            if (label.length > maxLen) {
                var _parts = label.split("/");
                var last = _parts.pop();
                var len = last.length;
                var toCull = Math.min(label.length - maxLen, len - 6);
                if (toCull > 3) {
                    _parts.push(last.substring(0, (len - toCull) / 2 - 4) + "..." + last.substring(len - 4 - (len - toCull) / 2));
                    label = _parts.join("/");
                }
            }
            return _react2.default.createElement(
                _DropDown2.default,
                {
                    label: label,
                    align: "right",
                    onKeyDown: this.doKeyDown,
                    onHide: this.onHide
                },
                _react2.default.createElement(
                    "li",
                    { className: "dropdown-header" },
                    filterText ? _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        "Filter: ",
                        _react2.default.createElement(
                            "code",
                            null,
                            filterText
                        )
                    ) : _react2.default.createElement(
                        "em",
                        null,
                        "Start typing to filter..."
                    )
                ),
                filterText && activeCats.length === 0 && _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.createElement(
                        "li",
                        null,
                        _react2.default.createElement(
                            "a",
                            null,
                            "Zero tests match the filter."
                        )
                    ),
                    _react2.default.createElement("li", { role: "separator", className: "divider" })
                ),
                activeCats.map(function (k) {
                    return _react2.default.createElement(
                        _react2.default.Fragment,
                        { key: k },
                        _react2.default.createElement(
                            "li",
                            { className: "dropdown-header", title: k },
                            _react2.default.createElement(
                                "code",
                                null,
                                (0, _filenameToLabel2.default)(k)
                            )
                        ),
                        tests[k].map(function (t) {
                            var fullPath = root + "/" + k + "/" + t;
                            return _react2.default.createElement(
                                "li",
                                { key: t, title: k + "/" + t,
                                    className: (0, _classnames2.default)("IT-item", {
                                        active: k + "/" + t === activeTest,
                                        "IT-item-success": (0, _ITTestHistoryStore.isSuccess)(history, fullPath),
                                        "IT-item-error": (0, _ITTestHistoryStore.isError)(history, fullPath)
                                    }) },
                                _react2.default.createElement(
                                    "a",
                                    { href: "?IT=" + fullPath },
                                    (0, _filenameToLabel2.default)(t)
                                )
                            );
                        }),
                        _react2.default.createElement("li", { role: "separator", className: "divider" })
                    );
                }),
                _react2.default.createElement(
                    "li",
                    null,
                    _react2.default.createElement(
                        "a",
                        { onClick: this.onClear },
                        "Clear History"
                    )
                ),
                _react2.default.createElement(
                    "li",
                    null,
                    _react2.default.createElement(
                        "a",
                        { href: "test/IT-runner.html", target: "_blank" },
                        "Runner UI"
                    )
                ),
                _react2.default.createElement(
                    "li",
                    null,
                    _react2.default.createElement(
                        "a",
                        { href: "test/IT.html", target: "_blank" },
                        "Setup Instructions"
                    )
                )
            );
        }
    }]);

    return ITTestNavItem;
}(_react2.default.Component);

ITTestNavItem.propTypes = {
    activeTest: _propTypes2.default.string,
    itTestLO: _propTypes2.default.instanceOf(_LoadObject2.default).isRequired,
    history: _ITTestHistoryStore2.default.constructor.stateTypes // this is questionable.
};

exports.default = ITTestNavItem;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function filenameToLabel(fn) {
    if (fn.indexOf("/") >= 0) {
        return fn.split("/").map(filenameToLabel).join(" / ").trim();
    }
    if (fn.substr(fn.length - 4) === ".txt") {
        fn = fn.substr(0, fn.length - 4);
    }
    if (/^[A-Z]{2,}-[0-9]+(-|$)/.test(fn)) {
        // don't touch JIRA ticket numbers
        var _parts = fn.split("-");
        if (_parts.length === 2) return fn;
        return _parts[0] + "-" + _parts[1] + " " + filenameToLabel(_parts.slice(2).join("-"));
    }
    fn = fn.replace(/[-_]+/g, " ");
    var parts = [];
    var buffer = "";
    for (var i = 0; i < fn.length; i++) {
        var first = i === 0;
        var last = i === fn.length - 1;
        var nextUpper = false;
        var prevUpper = false;
        var prevNumeric = false;
        if (!last) {
            var n = fn.charAt(i + 1);
            nextUpper = n >= "A" && n <= "Z";
        }
        if (!first) {
            var p = fn.charAt(i - 1);
            prevUpper = p >= "A" && p <= "Z";
            prevNumeric = p >= "0" && p <= "9";
        }
        var c = fn.charAt(i);
        if (c >= "A" && c <= "Z") {
            if (!prevUpper) {
                parts.push(buffer);
                buffer = "";
            }
            if (nextUpper || prevUpper && last) {
                buffer += c;
            } else {
                parts.push(buffer);
                buffer = c.toLowerCase();
            }
        } else if (c >= "a" && c <= "z") {
            if (prevNumeric) {
                parts.push(buffer);
                buffer = c;
            } else {
                buffer += c;
            }
        } else if (c >= "0" && c <= "9") {
            if (prevNumeric) {
                buffer += c;
            } else {
                parts.push(buffer);
                buffer = c;
            }
        } else {
            buffer += c;
        }
    }
    parts.push(buffer);
    return parts.map(function (it) {
        return it.trim();
    }).filter(function (it) {
        return it;
    }).join(" ");
}

exports.default = filenameToLabel;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(13);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _storeUtils = __webpack_require__(54);

var _DevelopmentActions = __webpack_require__(98);

var _DevelopmentActions2 = _interopRequireDefault(_DevelopmentActions);

var _DevDataManager = __webpack_require__(492);

var _DevDataManager2 = _interopRequireDefault(_DevDataManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MocksetManifestStore = function (_ReduceStore) {
    _inherits(MocksetManifestStore, _ReduceStore);

    function MocksetManifestStore() {
        _classCallCheck(this, MocksetManifestStore);

        return _possibleConstructorReturn(this, (MocksetManifestStore.__proto__ || Object.getPrototypeOf(MocksetManifestStore)).call(this, _Dispatcher2.default));
    }

    _createClass(MocksetManifestStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return _LoadObject2.default.empty().withPropTypes({
                mocksets: _propTypes2.default.arrayOf(_propTypes2.default.string)
            });
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {
                case _DevelopmentActions2.default.START_MOCKSET_MANIFEST_LOAD:
                    return state.loading(_DevDataManager2.default.loadMocksetManifest());
                case _DevelopmentActions2.default.MOCKSET_MANIFEST_LOADED:
                    return state.receiveValue({
                        mocksets: action.data.split("\n").map(function (it) {
                            return it.trim();
                        }).filter(function (it) {
                            return it.length > 0;
                        })
                    });
                case _DevelopmentActions2.default.MOCKSET_MANIFEST_ERROR:
                    return state.receiveError(action.error);
                default:
                    return state;
            }
        }
    }, {
        key: "getLoadObject",
        value: function getLoadObject() {
            var _this2 = this;

            return (0, _storeUtils.hotLoadObject)(function () {
                return _this2.getState();
            }, function () {
                return _Dispatcher2.default.dispatch({
                    type: _DevelopmentActions2.default.START_MOCKSET_MANIFEST_LOAD
                });
            });
        }
    }]);

    return MocksetManifestStore;
}(_utils.ReduceStore);

exports.default = new MocksetManifestStore();

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(13);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _DevelopmentActions = __webpack_require__(98);

var _DevelopmentActions2 = _interopRequireDefault(_DevelopmentActions);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MocksetStore = function (_ReduceStore) {
    _inherits(MocksetStore, _ReduceStore);

    function MocksetStore() {
        _classCallCheck(this, MocksetStore);

        return _possibleConstructorReturn(this, (MocksetStore.__proto__ || Object.getPrototypeOf(MocksetStore)).call(this, _Dispatcher2.default));
    }

    _createClass(MocksetStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {};
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {
                case _DevelopmentActions2.default.SELECT_MOCKSET:
                    return {
                        mockset: action.mockset
                    };
                default:
                    return state;
            }
        }
    }]);

    return MocksetStore;
}(_utils.ReduceStore);

MocksetStore.stateTypes = {
    mockset: _propTypes2.default.string
};

exports.default = (0, _typeCheckingStore2.default)(new MocksetStore());

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = WhoAmIListener;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _OverActions = __webpack_require__(122);

var _OverActions2 = _interopRequireDefault(_OverActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STORAGE_KEY = "ao:whoami:" + window.location.pathname;

var OVER_KEY = "WHO_I_AM_CHANGED_" + Math.random().toString().substr(2);

var buildReloadPayload = function buildReloadPayload(message) {
    return {
        type: _OverActions2.default.SHOW,
        options: {
            key: OVER_KEY,
            message: message,
            actions: [{
                label: "Ok",
                callback: function callback() {
                    window.location.hash = ""; //  kludge to remove any path, as it'll be invalid w/ new org
                    window.location.reload();
                }
            }]
        }
    };
};

function readNewValue(e) {
    if (!e.newValue) return e.newValue;
    try {
        return JSON.parse(e.newValue);
    } catch (err) {
        console.error("error parsing new " + STORAGE_KEY + " value", err, e.newValue);
    }
    return undefined;
}

function WhoAmIListener(whoami) {
    // write it down
    _react2.default.useEffect(function () {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(whoami));
    }, [whoami.user, whoami.org]);

    // monitor for changes
    _react2.default.useEffect(function () {
        var handler = function handler(e) {
            if (e.key !== STORAGE_KEY) return;
            var next = readNewValue(e);
            if (!next) return;
            var payload = void 0;
            if (whoami.user !== next.user) {
                payload = buildReloadPayload("You changed users; reload as '" + next.user + "'.");
            } else if (whoami.org !== next.org) {
                var newOrg = _userStore2.default.getAllOrgs().find(function (it) {
                    return it.key === next.org;
                });
                var label = (newOrg || {}).name || next.org;
                payload = buildReloadPayload("You changed organizations; reload as '" + label + "'.");
            } else {
                payload = {
                    type: _OverActions2.default.HIDE,
                    key: OVER_KEY
                };
            }
            _Dispatcher2.default.dispatch(payload);
        };
        window.addEventListener("storage", handler);
        return function () {
            return window.removeEventListener("storage", handler);
        };
    }, []);

    return null;
}

WhoAmIListener.propTypes = {
    user: _propTypes2.default.string.isRequired,
    org: _propTypes2.default.string.isRequired
};

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(99);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<nav class=\"navbar navbar-inverse navbar-fixed-top\" role=\"navigation\" id=\"global-navbar\"></nav>\n\n<div class=\"container-fluid\">\n    <div id=\"content\">\n        <div id=\"content_de\"></div>\n        <div id=\"content_dqr\"></div>\n        <div id=\"content_hex\"></div>\n    </div>\n</div>\n\n<div id=\"modal\"></div>\n<div id=\"loading-modal-container\">\n    <div class=\"loading-modal\">\n        <div class=\"loading-box\">\n            <header>\n                <h4 class=\"title\">title here</h4>\n            </header>\n\n            <div class=\"loading-body\">\n                <p>Loading...</p>\n            </div>\n            <img src=\"images/waiting.svg\"/>\n            <div class=\"loading-modal-actions\"></div>\n        </div>\n    </div>\n</div>\n\n<!-- see BaseServices.endSession -->\n<form id=\"logout-form\" style=\"display:none\">\n    <input type=\"hidden\" />\n</form>\n";
},"useData":true});

/***/ }),
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DataEntryModule = __webpack_require__(498);

var _DataEntryModule2 = _interopRequireDefault(_DataEntryModule);

var _HarvestExportModule = __webpack_require__(1444);

var _HarvestExportModule2 = _interopRequireDefault(_HarvestExportModule);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _withOver = __webpack_require__(58);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Router = function (_Backbone$Router) {
    _inherits(Router, _Backbone$Router);

    function Router() {
        _classCallCheck(this, Router);

        return _possibleConstructorReturn(this, (Router.__proto__ || Object.getPrototypeOf(Router)).apply(this, arguments));
    }

    _createClass(Router, [{
        key: "initialize",
        value: function initialize(application) {
            this.app = application;
            //@dataEntryModule = application.DataEntryModule
            this.dataQualityReportModule = application.DataQualityReportModule;
        }
    }, {
        key: "decider",
        value: function decider(path) {
            var canUseDE = _userStore2.default.canUseDE();
            var canUseDqr = _userStore2.default.canUseDqr();
            var canUseHex = _userStore2.default.canUseHex();
            if (!path) {
                path = "de";
            }

            //we have a path so lets route this correctly
            if (/^dqr/.test(path) && canUseDqr) {
                this.dataQualityReport(path);
            } else if (/^hex/.test(path) && canUseHex) {
                this.harvest(path);
            } else if (canUseDE) {
                this.dataentry(path);
            } else if (canUseHex) {
                window.location.hash = "hex";
            } else if (canUseDqr) {
                window.location.hash = "dqr";
            } else {
                (0, _withOver.appAlert)("This user has no access to the application");
            }
        }
    }, {
        key: "dataentry",
        value: function dataentry(path) {
            this.dispatch("user:activity");

            if (!this.dataEntryModule) {
                this.dataEntryModule = new _DataEntryModule2.default({
                    model: this.app.model,
                    useDefaultSearch: true
                });
                this.app.layout.de.show(this.dataEntryModule);
            }

            $("#content").removeClass("dqr").removeClass("hex").addClass("de");
            this.app.model.set("view", "de");

            //@dataEntryModule.start( @app )
            //after the module is started lets see if we need to preload any items
            if (path && path.split("~").length >= 4) {
                var maybeParseInt = function maybeParseInt(v) {
                    if (v != null) {
                        return parseInt(v);
                    } else {
                        return v;
                    }
                };
                // eslint-disable-next-line

                var _path$split = path.split("~"),
                    _path$split2 = _slicedToArray(_path$split, 7),
                    n = _path$split2[0],
                    org = _path$split2[1],
                    key = _path$split2[2],
                    id = _path$split2[3],
                    ekey = _path$split2[4],
                    eid = _path$split2[5],
                    shortname = _path$split2[6];

                if (!shortname) {
                    shortname = null;
                }
                this.dispatch("confirm:load:entity_data", org, key, maybeParseInt(id), ekey, maybeParseInt(eid), shortname, this.app.model);
            }
        }
    }, {
        key: "dataQualityReport",
        value: function dataQualityReport() {
            this.dispatch("user:activity");
            $("#content").removeClass("de").removeClass("hex").addClass("dqr");
            this.app.model.set("view", "dqr");
            this.dataQualityReportModule.start(this.app);
        }
    }, {
        key: "harvest",
        value: function harvest() {
            this.dispatch("user:activity");
            $("#content").removeClass("de").removeClass("dqr").addClass("hex");
            this.app.model.set("view", "hex");
            if (!this.hexModule) {
                this.hexModule = new _HarvestExportModule2.default({ model: this.app.model.get("hex") });
                this.app.layout.hex.show(this.hexModule);
            }
        }
    }]);

    return Router;
}(Backbone.Router);

Router.prototype.routes = {
    "*path": "decider"
    // 'de*path': "dataentry"
    // 'dqr': "dataQualityReport"
    // 'new': "dataentry"
};

exports.default = Router;

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(99);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"open disabled drawer-container\">\n    <div class=\"drawer-body\"></div>\n    <div class=\"drawer-pull\">\n        <div class=\"drawer-tab\">\n            <a class=\"btn btn-drawer-pull\">\n                <span class=\"glyphicon glyphicon-search\"></span>\n                <span class=\"glyphicon glyphicon-chevron-down\"></span>\n            </a>\n        </div>\n    </div>\n</div>\n<div class=\"drawer-content\"></div>\n";
},"useData":true});

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InnerDefault = undefined;

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _SearchFormStore = __webpack_require__(82);

var _SearchFormStore2 = _interopRequireDefault(_SearchFormStore);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InnerDefault = exports.InnerDefault = function InnerDefault(_ref) {
    var magicName = _ref.magicName,
        _ref$defaultName = _ref.defaultName,
        defaultName = _ref$defaultName === undefined ? magicName : _ref$defaultName,
        displayName = _ref.displayName;
    return _react2.default.createElement(
        "section",
        { className: "welcome" },
        _react2.default.createElement(
            "b",
            null,
            "Hey, ",
            displayName,
            ". "
        ),
        "Find an existing ",
        defaultName,
        " record with our search tools",
        _react2.default.createElement("br", null),
        "or create a new ",
        magicName,
        " record."
    );
};

InnerDefault.propTypes = {
    displayName: _propTypes2.default.string.isRequired,
    magicName: _propTypes2.default.string.isRequired,
    defaultName: _propTypes2.default.string
};

var Default = function Default(props) {
    var fluxContext = props.fluxContext;

    var state = (0, _useFluxStore2.default)(function () {
        var availableKeys = _SearchFormStore2.default.getAvailableKeys(fluxContext);
        var magicRoot = _StereotypesStore2.default.getMagicRoot();
        var defaultKey = _StereotypesStore2.default.getDefaultKey();
        var magicName = availableKeys.includes(magicRoot.key) ? magicRoot.name : _StereotypesStore2.default.getStereotypeByKey(_SearchFormStore2.default.getKey(fluxContext)).name;
        var defaultName = availableKeys.includes(defaultKey) ? _StereotypesStore2.default.getStereotypeByKey(defaultKey).name : magicName;
        return {
            displayName: _userStore2.default.getDisplayName(),
            defaultName: defaultName,
            magicName: magicName
        };
    }, [_userStore2.default, _SearchFormStore2.default], [fluxContext]);
    return _react2.default.createElement(InnerDefault, state);
};

Default.propTypes = {
    fluxContext: _propTypes2.default.string.isRequired
};

exports.default = Default;

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SelectionTable = __webpack_require__(234);

var _SelectionTable2 = _interopRequireDefault(_SelectionTable);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Button = __webpack_require__(52);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchResults = function (_React$Component) {
    _inherits(SearchResults, _React$Component);

    function SearchResults() {
        _classCallCheck(this, SearchResults);

        return _possibleConstructorReturn(this, (SearchResults.__proto__ || Object.getPrototypeOf(SearchResults)).apply(this, arguments));
    }

    _createClass(SearchResults, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                isLoading = _props.isLoading,
                _props$records = _props.records,
                records = _props$records === undefined ? [] : _props$records,
                onPage = _props.onPage,
                pagination = _props.pagination;

            var indexZeroPage = pagination.page - 1;
            return _react2.default.createElement(
                "div",
                { className: "search-results-container" },
                isLoading && _react2.default.createElement(
                    "div",
                    { className: "local-over-modal" },
                    _react2.default.createElement("img", { src: "images/waiting.svg", alt: "Loading..." })
                ),
                _react2.default.createElement(_SelectionTable2.default, _extends({}, this.props, { fixedHeaders: true })),
                (
                // Only show pagination controls when there are
                // multiple pages or we are on a page other then 1.
                records.length >= pagination.pageSize || pagination.page > 1) && _react2.default.createElement(
                    "div",
                    { className: "row search-pagination" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-6" },
                        _react2.default.createElement(
                            "div",
                            { className: "search-pagination-summary" },
                            "Showing results ",
                            indexZeroPage * pagination.pageSize + 1,
                            " to ",
                            indexZeroPage * pagination.pageSize + records.length
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-sm-6 text-right" },
                        _react2.default.createElement(
                            "div",
                            { className: "search-pagination-buttons" },
                            _react2.default.createElement(_Button2.default, {
                                enabled: pagination.page > 1,
                                onClick: function onClick() {
                                    return onPage(pagination.page - 1);
                                },
                                label: "<"
                            }),
                            _react2.default.createElement(
                                "strong",
                                null,
                                " Page ",
                                pagination.page,
                                " "
                            ),
                            _react2.default.createElement(_Button2.default, {
                                enabled: records.length >= pagination.pageSize,
                                onClick: function onClick() {
                                    return onPage(pagination.page + 1);
                                },
                                label: ">"
                            })
                        )
                    )
                )
            );
        }
    }]);

    return SearchResults;
}(_react2.default.Component);

exports.default = SearchResults;


SearchResults.propTypes = {
    isLoading: _propTypes2.default.bool,
    records: _propTypes2.default.array,
    selectedRecord: _propTypes2.default.object,
    columns: _propTypes2.default.array,
    supportsEnablement: _propTypes2.default.bool,
    sorts: _propTypes2.default.object,
    onSort: _propTypes2.default.func.isRequired,
    onRecordSelection: _propTypes2.default.func.isRequired,
    showDisabled: _propTypes2.default.bool,
    maxHeight: _propTypes2.default.string,
    onPage: _propTypes2.default.func,
    pagination: _propTypes2.default.shape({
        page: _propTypes2.default.number,
        pageCount: _propTypes2.default.number,
        pageSize: _propTypes2.default.number,
        totalResultCount: _propTypes2.default.number
    }).isRequired
};

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Row = __webpack_require__(1031);

var _Row2 = _interopRequireDefault(_Row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Body = function (_React$Component) {
    _inherits(Body, _React$Component);

    function Body() {
        _classCallCheck(this, Body);

        return _possibleConstructorReturn(this, (Body.__proto__ || Object.getPrototypeOf(Body)).apply(this, arguments));
    }

    _createClass(Body, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                _props$records = _props.records,
                records = _props$records === undefined ? [] : _props$records,
                columns = _props.columns,
                selected = _props.selected,
                onDownloadClick = _props.onDownloadClick,
                onRecordSelection = _props.onRecordSelection,
                renderUnsafe = _props.renderUnsafe;


            var items = void 0;

            if (records.length > 0) {
                items = records.map(function (record) {
                    var isActive = selected ? selected.id === record.id : false;
                    return _react2.default.createElement(_Row2.default, {
                        key: record.id,
                        ITid: record.id,
                        onRecordSelection: onRecordSelection,
                        onDownloadClick: onDownloadClick,
                        record: record,
                        columns: columns,
                        renderUnsafe: renderUnsafe,
                        isActive: isActive
                    });
                });
            } else {
                items = _react2.default.createElement(
                    "tr",
                    { id: "nosearchresults_row", className: "disabled" },
                    _react2.default.createElement(
                        "td",
                        { id: "nosearchresults_cell", colSpan: columns.length },
                        "No Results Found"
                    )
                );
            }

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                items
            );
        }
    }]);

    return Body;
}(_react2.default.Component);

exports.default = Body;


Body.propTypes = {
    records: _propTypes2.default.array,
    columns: _propTypes2.default.array.isRequired,
    selected: _propTypes2.default.object,
    onRecordSelection: _propTypes2.default.func.isRequired,
    onDownloadClick: _propTypes2.default.func,
    renderUnsafe: _propTypes2.default.bool.isRequired
};

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Item = __webpack_require__(1032);

var _Item2 = _interopRequireDefault(_Item);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _typedefs = __webpack_require__(44);

var _formatId = __webpack_require__(114);

var _formatId2 = _interopRequireDefault(_formatId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Row = function (_React$Component) {
    _inherits(Row, _React$Component);

    function Row() {
        _classCallCheck(this, Row);

        return _possibleConstructorReturn(this, (Row.__proto__ || Object.getPrototypeOf(Row)).apply(this, arguments));
    }

    _createClass(Row, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                columns = _props.columns,
                isActive = _props.isActive,
                record = _props.record,
                onDownloadClick = _props.onDownloadClick,
                ITid = _props.ITid;


            var items = columns.map(function (column, idx) {
                return _react2.default.createElement(_Item2.default, {
                    key: column.key,
                    ITid: (0, _formatId2.default)(ITid + "." + idx, "table-item"),
                    onDownloadClick: onDownloadClick,
                    optionsKey: column.key,
                    type: column.type,
                    ItemTemplate: column.itemTemplate,
                    renderUnsafe: record.renderUnsafe,
                    data: record.data,
                    isActive: isActive,
                    valueMap: column.expectedValueLookup
                });
            });

            var classes = "selection-table-row";
            if (isActive) {
                classes += " active";
            }

            return _react2.default.createElement(
                "tr",
                {
                    className: classes,
                    onDoubleClick: this.onDoubleClick.bind(this),
                    id: (0, _formatId2.default)(ITid, "selection-table-row")
                },
                items
            );
        }
    }, {
        key: "onDoubleClick",
        value: function onDoubleClick(event) {
            event.preventDefault();
            var _props2 = this.props,
                record = _props2.record,
                onRecordSelection = _props2.onRecordSelection;

            onRecordSelection(record);
        }
    }]);

    return Row;
}(_react2.default.Component);

exports.default = Row;


Row.propTypes = {
    columns: _propTypes2.default.array.isRequired,
    record: _propTypes2.default.object.isRequired,
    onRecordSelection: _propTypes2.default.func.isRequired,
    onDownloadClick: _propTypes2.default.func,
    isActive: _propTypes2.default.bool,
    ITid: _typedefs.recordIdType
};

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FileTemplate = __webpack_require__(500);

var _FileTemplate2 = _interopRequireDefault(_FileTemplate);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pad = __webpack_require__(1033);

var _formatId = __webpack_require__(114);

var _formatId2 = _interopRequireDefault(_formatId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Item = function (_React$Component) {
    _inherits(Item, _React$Component);

    function Item() {
        _classCallCheck(this, Item);

        return _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));
    }

    _createClass(Item, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                _props$renderUnsafe = _props.renderUnsafe,
                renderUnsafe = _props$renderUnsafe === undefined ? false : _props$renderUnsafe,
                type = _props.type,
                ITid = _props.ITid;

            var template = void 0;
            if (renderUnsafe && type !== "template") {
                template = _react2.default.createElement("span", { dangerouslySetInnerHTML: { __html: this.getLabel() } });
            } else {
                template = this.getLabel();
            }
            return _react2.default.createElement(
                "td",
                { "data-control-type": "label", id: (0, _formatId2.default)(ITid, "selection-table-field") },
                template
            );
        }
    }, {
        key: "getLabel",
        value: function getLabel() {
            var _props2 = this.props,
                optionsKey = _props2.optionsKey,
                data = _props2.data,
                type = _props2.type,
                ItemTemplate = _props2.ItemTemplate,
                onDownloadClick = _props2.onDownloadClick,
                valueMap = _props2.valueMap;

            var value = data[optionsKey];
            if (valueMap && valueMap.hasOwnProperty(value)) {
                value = valueMap[value];
            }
            var display = "";
            if (value != null) {
                switch (type.replace(/ormissing$/, "")) {
                    case "datetimerelative":
                    case "datetimerange":
                    case "datetime":
                        if (value.length >= 2) {
                            value = [].concat(value);
                            value[1] -= 1; // zero indexed month
                        }
                        display = moment(value).format("MM/DD/YYYY h:mm a");
                        break;
                    case "daterelative":
                    case "daterange":
                    case "date":
                        if (value.length >= 2) {
                            value = [].concat(value);
                            value[1] -= 1; // zero indexed month
                        }
                        display = moment(value).format("MM/DD/YYYY");
                        break;
                    case "time":
                        if (value.length < 2) {
                            display = "";
                        } else {
                            display = (0, _pad.leftPad)(value[0], 2, "0") + ":" + (0, _pad.leftPad)(value[1], 2, "0");
                        }
                        break;
                    case "tztimestamp":
                        display = moment(new Date(value)).format("MM/DD/YYYY h:mm a");
                        break;
                    case "string":
                    case "to-one":
                    case "integer":
                        display = value.toString();
                        break;
                    case "template":
                        display = _react2.default.createElement(_FileTemplate2.default, { onDownloadClick: onDownloadClick,
                            data: data });
                        break;
                    case "to-many":
                        if (value instanceof Array) {
                            display = value.join(", ");
                        } else {
                            display = value.toString();
                        }
                        break;
                    default:
                        display = "UNKNOWN TYPE '" + type + "'";
                }
            } else if (type === "template" && ItemTemplate != null) {
                display = _react2.default.createElement(ItemTemplate, { onDownloadClick: onDownloadClick,
                    data: data });
            }
            return display;
        }
    }]);

    return Item;
}(_react2.default.Component);

exports.default = Item;


Item.propTypes = {
    optionsKey: _propTypes2.default.string.isRequired,
    data: _propTypes2.default.object.isRequired,
    type: _propTypes2.default.string,
    ItemTemplate: _propTypes2.default.func,
    onDownloadClick: _propTypes2.default.func,
    renderUnsafe: _propTypes2.default.bool,
    ITid: _propTypes2.default.string,
    valueMap: _propTypes2.default.object // used for translation
};

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function sanitize(value, length, char) {
    if (!(typeof length === "number") || length < 0) {
        throw new Error("You can't pad to a negative length");
    }
    if (!(typeof char === "string") || char.length !== 1) {
        throw new Error("You must pad with a single character");
    }
    if (value == null) {
        value = "";
    }
    if (!(typeof value === "string")) {
        value = value.toString();
    }
    return value;
}

var rightPad = exports.rightPad = function rightPad(value, length, char) {
    value = sanitize(value, length, char);
    while (value.length < length) {
        value += char;
    }
    return value;
};

var leftPad = exports.leftPad = function leftPad(value, length, char) {
    value = sanitize(value, length, char);
    while (value.length < length) {
        value = char + value;
    }
    return value;
};

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Column = __webpack_require__(1035);

var _Column2 = _interopRequireDefault(_Column);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_React$Component) {
    _inherits(Header, _React$Component);

    function Header() {
        _classCallCheck(this, Header);

        return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
    }

    _createClass(Header, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                columns = _props.columns,
                sorts = _props.sorts,
                onSort = _props.onSort,
                fixedHeaders = _props.fixedHeaders;


            return columns.map(function (column) {
                return _react2.default.createElement(_Column2.default, {
                    onSort: onSort,
                    fixedHeaders: fixedHeaders,
                    key: column.key,
                    sorts: sorts,
                    column: column,
                    name: column.name
                });
            });
        }
    }]);

    return Header;
}(_react2.default.Component);

exports.default = Header;


Header.propTypes = {
    columns: _propTypes2.default.array.isRequired,
    fixedHeaders: _propTypes2.default.bool,
    sorts: _propTypes2.default.object.isRequired,
    onSort: _propTypes2.default.func
};

Header.defaultProps = {
    fixedHeaders: false
};

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formatId = __webpack_require__(114);

var _formatId2 = _interopRequireDefault(_formatId);

var _classnames = __webpack_require__(51);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Column = function (_React$Component) {
    _inherits(Column, _React$Component);

    function Column(props) {
        _classCallCheck(this, Column);

        var _this = _possibleConstructorReturn(this, (Column.__proto__ || Object.getPrototypeOf(Column)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(Column, [{
        key: "handleClick",
        value: function handleClick() {
            var _props = this.props,
                onSort = _props.onSort,
                column = _props.column;

            onSort && onSort(column);
        }
    }, {
        key: "render",
        value: function render() {
            var _props2 = this.props,
                key = _props2.column.key,
                sorts = _props2.sorts,
                name = _props2.name,
                onSort = _props2.onSort;

            return _react2.default.createElement(
                "th",
                {
                    id: (0, _formatId2.default)(key, "header-item"),
                    onClick: this.handleClick,
                    "data-key": key,
                    className: (0, _classnames2.default)(sorts[key], {
                        sortable: !!onSort
                    })
                },
                name,
                _react2.default.createElement("span", null)
            );
        }
    }]);

    return Column;
}(_react2.default.Component);

exports.default = Column;


Column.propTypes = {
    fixedHeaders: _propTypes2.default.bool,
    column: _propTypes2.default.shape({
        key: _propTypes2.default.string.isRequired
    }).isRequired,
    sorts: _propTypes2.default.object.isRequired,
    name: _propTypes2.default.string,
    onSort: _propTypes2.default.func
};

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _asMarionetteView = __webpack_require__(101);

var _BottomPane = __webpack_require__(1037);

var _BottomPane2 = _interopRequireDefault(_BottomPane);

var _VerticalResizableLayout = __webpack_require__(1434);

var _VerticalResizableLayout2 = _interopRequireDefault(_VerticalResizableLayout);

var _EntityHeader = __webpack_require__(1436);

var _ColumnNavigator = __webpack_require__(1438);

var _ColumnNavigator2 = _interopRequireDefault(_ColumnNavigator);

var _HybridConfig = __webpack_require__(41);

var _HybridConfig2 = _interopRequireDefault(_HybridConfig);

var _BreadcrumbNavigator = __webpack_require__(1441);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MarionetteEntityHeader = (0, _asMarionetteView.asMarionetteView)(_EntityHeader.FluxEntityHeader);
var MarionetteColumnNavigator = (0, _asMarionetteView.asMarionetteView)(_ColumnNavigator2.default);
var MarionetteBreadcrumbNavigator = (0, _asMarionetteView.asMarionetteView)(_BreadcrumbNavigator.FluxBreadcrumbNavigator);
//const MarionetteBottomPane = asMarionetteView(BottomPane);

var DataEntryFormModule = function (_VerticalResizableLay) {
    _inherits(DataEntryFormModule, _VerticalResizableLay);

    function DataEntryFormModule() {
        var _ref;

        _classCallCheck(this, DataEntryFormModule);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = DataEntryFormModule.__proto__ || Object.getPrototypeOf(DataEntryFormModule)).call.apply(_ref, [this].concat(args)));

        _this.initialize = _this.initialize.bind(_this);
        _this.onRender = _this.onRender.bind(_this);
        _this.showForm = _this.showForm.bind(_this);
        return _this;
    }

    _createClass(DataEntryFormModule, [{
        key: "initialize",
        value: function initialize(options) {
            this.fluxContext = options.fluxContext;
            this.isModal = options.isModal;
            this.showTreeNavigator = _HybridConfig2.default.get("ui.showTreeNavigator", false);
            this.showEntityNavigator = _HybridConfig2.default.get("ui.showEntityNavigator", true);
        }
    }, {
        key: "onRender",
        value: function onRender() {
            var fluxContext = this.fluxContext;
            if (this.showTreeNavigator) {
                this.header.show(new MarionetteBreadcrumbNavigator({
                    fluxContext: fluxContext
                }));
            } else {
                this.header.show(new MarionetteEntityHeader({
                    fluxContext: fluxContext
                }));
            }

            if (this.showEntityNavigator) {
                this.topPaneView = new MarionetteColumnNavigator({
                    fluxContext: fluxContext
                });
                this.topPane.show(this.topPaneView);
            } else {
                // this is here to hide the EntityNavigator
                this.resize(52);
                this.$(".slider-wrapper").remove();
            }

            this.bottomPaneView = new _BottomPane2.default({
                fluxContext: fluxContext,
                showTreeNavigator: this.showTreeNavigator,
                isModal: this.isModal
            });
            this.bottomPane.show(this.bottomPaneView);

            //rebind dom events after replacing contents
            this.delegateEvents();
        }
    }, {
        key: "showForm",
        value: function showForm() {
            if (this.bottomPaneView) {
                this.bottomPaneView.showForm();
            }
        }
    }]);

    return DataEntryFormModule;
}(_VerticalResizableLayout2.default);

DataEntryFormModule.prototype.className = "data-entry";

exports.default = DataEntryFormModule;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EntityForm = __webpack_require__(1038);

var _EntityForm2 = _interopRequireDefault(_EntityForm);

var _ActionBar = __webpack_require__(1410);

var _FormStore = __webpack_require__(142);

var _FormStore2 = _interopRequireDefault(_FormStore);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _withOver = __webpack_require__(58);

var _SidebarLayout = __webpack_require__(1414);

var _SidebarLayout2 = _interopRequireDefault(_SidebarLayout);

var _NoFormView = __webpack_require__(606);

var _NoFormView2 = _interopRequireDefault(_NoFormView);

var _ValidationBar = __webpack_require__(1432);

var _records = __webpack_require__(113);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _TableAccess = __webpack_require__(77);

var _TableAccess2 = _interopRequireDefault(_TableAccess);

var _NavigatorStore = __webpack_require__(33);

var _NavigatorStore2 = _interopRequireDefault(_NavigatorStore);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _superRecords = __webpack_require__(63);

var _SuperRecordStore = __webpack_require__(36);

var _SuperRecordStore2 = _interopRequireDefault(_SuperRecordStore);

var _ValidationTreeContainer = __webpack_require__(619);

var _LiveMap = __webpack_require__(178);

var _LiveMap2 = _interopRequireDefault(_LiveMap);

var _stereotypes = __webpack_require__(126);

var _userEditedRecordStore = __webpack_require__(315);

var _userEditedRecordStore2 = _interopRequireDefault(_userEditedRecordStore);

var _uniqueFilterBuilder = __webpack_require__(480);

var _uniqueFilterBuilder2 = _interopRequireDefault(_uniqueFilterBuilder);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _isMissing = __webpack_require__(443);

var _isMissing2 = _interopRequireDefault(_isMissing);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _NavigationActions = __webpack_require__(80);

var _NavigationActions2 = _interopRequireDefault(_NavigationActions);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

var _useFluxStore2 = __webpack_require__(9);

var _useFluxStore3 = _interopRequireDefault(_useFluxStore2);

var _asMarionetteView = __webpack_require__(101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function sharedPrefix(a, b) {
    var l = Math.min(a.length, b.length);
    var prefix = "";
    var c = void 0;
    for (var i = 0; i < l; i++) {
        c = a.charAt(i);
        if (b.charAt(i) !== c) break;
        prefix += c;
    }
    return prefix;
}

var getMissingRequiredFields = function getMissingRequiredFields(fluxContext) {
    var activeKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return (
        // for each edited entity record in this context
        _userEditedRecordStore2.default.getRecordKeys(fluxContext).filter(function (k) {
            return _TableStore2.default.hasEntityRecord(k.key, k.id);
        }).map(function (k) {
            return _TableStore2.default.getEntityProxy(k.key, k.id);
        })
        //     find its top-level record
        .map(function (ep) {
            do {
                var parent = ep.getParent();
                if (parent == null) {
                    return ep;
                }
                ep = parent;
            } while (true);
        }).filter((0, _uniqueFilterBuilder2.default)(function (ep) {
            return ep.getKey();
        }))
        //     find its table record
        .map(function (ep) {
            return ep.tableProxy;
        })
        //     find every fronting entity record
        .flatMap(function (tp) {
            return tp.getEntityProxies();
        })
        //     find all records in its entire composition tree
        .flatMap(function (ep) {
            var queue = [ep];
            var result = [];

            var _loop = function _loop() {
                var curr = queue.pop();
                result.push(curr);
                queue.push.apply(queue, _toConsumableArray(curr.entityInfo.associations.cmv.flatMap(function (c) {
                    return curr.getField(c);
                })));
            };

            while (queue.length) {
                _loop();
            }
            return result;
        })
        //     find all fields which are required, enabled, and missing
        .flatMap(function (ep) {
            return _entityFieldMetaStore2.default.getAllInfos(ep.entityKey, function (fi) {
                return fi.requiredInDataEntry;
            }).filter(function (fi) {
                return ep.isFieldEnabled(fi);
            }).filter(function (fi) {
                return (0, _isMissing2.default)(ep.getField(fi));
            }).map(function (fi) {
                return [ep, fi];
            });
        })
        // pick the one "closest" to the active record
        .sort(function (_ref, _ref2) {
            var _ref4 = _slicedToArray(_ref, 1),
                a = _ref4[0];

            var _ref3 = _slicedToArray(_ref2, 1),
                b = _ref3[0];

            return (
                // longest matching prefix first
                sharedPrefix(b.getKey(), activeKey).length - sharedPrefix(a.getKey(), activeKey).length
            );
        })
        // deduplicate by table column
        .filter((0, _uniqueFilterBuilder2.default)(function (_ref5) {
            var _ref6 = _slicedToArray(_ref5, 2),
                ep = _ref6[0],
                fi = _ref6[1];

            return ep.tableProxy.tableKey + "." + fi.logicalKey;
        }))
    );
};

var disallowSaveBecauseIllegal = function disallowSaveBecauseIllegal(fluxContext) {
    var magic = _NavigatorStore2.default.getMagicState(fluxContext);
    var srInfo = _SuperRecordStore2.default.getRecord(magic.key, magic.id);
    var stereoInfo = _StereotypesStore2.default.getStereotypeByKey(magic.key);
    var access = new _TableAccess2.default(_TableStore2.default.getState());
    var stereoImplementations = (0, _stereotypes.getImplementations)(stereoInfo, access, magic.id);
    var canSaveIllegals = new _LiveMap2.default(function (implKey) {
        return _userStore2.default.getLicensePreference("allow-saving-illegal-values", implKey);
    });
    var excludeFilters = new _LiveMap2.default(function (implKey) {
        return (0, _ValidationTreeContainer.buildExcludesFilter)(implKey);
    });
    var reduceWork = function reduceWork(hi, ep) {
        if (hi) return hi;
        var implKey = new _EntityName2.default(ep.entityKey).implKey;

        var _buildRecordItem = (0, _ValidationTreeContainer.buildRecordItem)(ep, excludeFilters.get(implKey), function () {
            return true;
        } // do everything
        ),
            meta = _buildRecordItem.meta;

        if (meta._is_blocking || meta._contains_blocking) {
            return true;
        }
        if (canSaveIllegals.get(implKey)) {
            return false;
        }
        return meta._is_illegal || meta._contains_illegal;
    };
    return (0, _superRecords.getTopLevelRecords)(_TableStore2.default, srInfo).reduce(reduceWork, stereoImplementations.map(function (impl) {
        return _TableStore2.default.getEntityProxy(impl.key, magic.id);
    }).reduce(reduceWork, false));
};

var MarionetteActionBar = (0, _asMarionetteView.asMarionetteView)(_ActionBar.FluxActionBar);
var MarionetteValidationBar = (0, _asMarionetteView.asMarionetteView)(_ValidationBar.FluxValidationBar);
var MarionetteSidebar = (0, _asMarionetteView.asMarionetteView)(_SidebarLayout2.default, { className: "sidebar" });
var MarionetteEntityForm = (0, _asMarionetteView.asMarionetteView)(_EntityForm2.default);
var MarionetteNoFormView = (0, _asMarionetteView.asMarionetteView)(_NoFormView2.default);

var BottomPane = function (_Backbone$Marionette$) {
    _inherits(BottomPane, _Backbone$Marionette$);

    function BottomPane() {
        var _ref7;

        _classCallCheck(this, BottomPane);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref7 = BottomPane.__proto__ || Object.getPrototypeOf(BottomPane)).call.apply(_ref7, [this].concat(args)));

        _this.initialize = _this.initialize.bind(_this);
        _this.onRender = _this.onRender.bind(_this);
        _this.showNoForm = _this.showNoForm.bind(_this);
        _this.showForm = _this.showForm.bind(_this);
        return _this;
    }

    _createClass(BottomPane, [{
        key: "initialize",
        value: function initialize(options) {
            this.fluxContext = options.fluxContext;
            this.isModal = options.isModal;
            this.showTreeNavigator = options.showTreeNavigator;
        }
    }, {
        key: "onRender",
        value: function onRender() {
            this.showNoForm();
        }
    }, {
        key: "showNoForm",
        value: function showNoForm() {
            this.form.show(new MarionetteNoFormView());
        }
    }, {
        key: "showForm",
        value: function showForm() {
            var _this2 = this;

            var nothingToSeeHere = function nothingToSeeHere() {
                _this2.ef && _this2.ef.close();
                _this2.ab && _this2.ab.close();
                _this2.vb && _this2.vb.close();
                _this2.showNoForm();
            };
            var fluxContext = this.fluxContext;
            var activeRecord = (0, _records.getActiveRecord)(_TableStore2.default, _NavigatorStore2.default.getRecordState(fluxContext));

            if (this.sb == null) {
                this.sb = new MarionetteSidebar({
                    fluxContext: fluxContext
                });
                this.sidebar.show(this.sb);
            }

            if (activeRecord == null) {
                return nothingToSeeHere();
            }

            var lo = _FormStore2.default.getFormLO(activeRecord.entityKey);
            if (!lo.hasValue()) {
                return nothingToSeeHere();
            }
            var descriptor = lo.getRequiredValue();
            if (descriptor.childItems == null || descriptor.childItems.length === 0) {
                return nothingToSeeHere();
            }

            this.ef = new MarionetteEntityForm({
                descriptor: descriptor,
                entityKey: activeRecord.entityKey,
                id: activeRecord.id,
                fluxContext: fluxContext
            });

            this.ab = new MarionetteActionBar({
                fluxContext: fluxContext,
                recordId: activeRecord.id,
                entityKey: activeRecord.entityKey,
                versionDropdownEnabled: this.showTreeNavigator,

                isModal: this.isModal,
                allowSave: _ClientId2.default.is(activeRecord.id) ? activeRecord.canCreate() : activeRecord.canWrite(),
                allowCancel: true,
                allowSectionJump: true,
                onSave: function onSave() {
                    if (disallowSaveBecauseIllegal(fluxContext)) {
                        (0, _withOver.appAlert)("Cannot save with current errors. Please review record and correct noted errors.");
                        return;
                    }
                    var missingRequireds = getMissingRequiredFields(fluxContext, activeRecord.getKey());
                    if (missingRequireds.length > 0) {
                        var maxToShow = 5;
                        if (missingRequireds.length === maxToShow + 1) {
                            maxToShow = missingRequireds.length;
                        }
                        var jumpTarget = missingRequireds[0];
                        var jumpProxy = jumpTarget[0];
                        var jumpFieldInfo = jumpTarget[1];
                        (0, _withOver.appAlert)({
                            title: "Missing Required Fields",
                            message: function message() {
                                return _react2.default.createElement(
                                    _react2.default.Fragment,
                                    null,
                                    _react2.default.createElement(
                                        "p",
                                        null,
                                        "You must enter a value for the following ",
                                        missingRequireds.length === 1 ? "field" : "fields",
                                        ":"
                                    ),
                                    _react2.default.createElement(
                                        "ul",
                                        null,
                                        missingRequireds.slice(0, maxToShow).map(function (_ref8, i) {
                                            var _ref9 = _slicedToArray(_ref8, 2),
                                                ep = _ref9[0],
                                                fi = _ref9[1];

                                            return _react2.default.createElement(
                                                "li",
                                                { key: i },
                                                ep.getLabel(),
                                                " > ",
                                                fi.name
                                            );
                                        }),
                                        missingRequireds.length > maxToShow && _react2.default.createElement(
                                            "li",
                                            null,
                                            "And ",
                                            missingRequireds.length - maxToShow,
                                            " more..."
                                        )
                                    )
                                );
                            },

                            actions: [{
                                label: "Go to " + jumpFieldInfo.name,
                                callback: function callback() {
                                    return _Dispatcher2.default.contextDispatch(fluxContext, {
                                        type: _NavigationActions2.default.SELECT_RECORD,
                                        entityKey: jumpProxy.entityKey,
                                        recordId: jumpProxy.id,
                                        fieldKey: jumpFieldInfo.key
                                    });
                                }
                            }, {
                                label: "Cancel"
                            }]
                        });
                        return;
                    }
                    _Dispatcher2.default.contextDispatch(fluxContext, {
                        type: _SuperRecordActions2.default.SAVE
                    });
                }
            });

            this.vb = new MarionetteValidationBar({
                fluxContext: fluxContext
            });

            this.actionbar.show(this.ab);
            this.form.show(this.ef);
            this.validationbar.show(this.vb);

            // listen for events from adapters that we need to translate to localized events for this de module
            this.ef.listenTo(this.ef, "ef:record:new-child", function (record, fieldKey, entityKey, options) {
                throw new Error("Don't do that; dispatch 'record:new-child' directly");
            });
            this.ef.listenTo(this.ef, "widget:click", function (config) {
                throw new Error("Don't do that; flux dispatch 'WidgetActions.WIDGET_CLICK' directly");
            });
        }
    }]);

    return BottomPane;
}(Backbone.Marionette.Layout);

BottomPane.prototype.template = __webpack_require__(1433);
BottomPane.prototype.regions = {
    actionbar: "header.header",
    form: "section.entity-form-container",
    validationbar: ".form.footer",
    sidebar: ".de_sidebar"
};

exports.default = BottomPane;

// TODO: BottomPane react version. This was started but is not quite ready to be used.

var BottomPaneView = function BottomPaneView(props) {
    var fluxContext = props.fluxContext,
        showTreeNavigator = props.showTreeNavigator,
        isModal = props.isModal;

    var activeRecord = (0, _records.getActiveRecord)(_TableStore2.default, _NavigatorStore2.default.getRecordState(fluxContext));
    var entityKey = activeRecord ? activeRecord.entityKey : null;
    var id = activeRecord ? activeRecord.id : null;

    var _useFluxStore = (0, _useFluxStore3.default)(function () {
        var descriptor = null;
        if (activeRecord !== null) {
            var lo = _FormStore2.default.getFormLO(entityKey);
            if (lo.hasValue()) {
                descriptor = lo.getRequiredValue();
            }
        }
        return {
            descriptor: descriptor
        };
    }, [_FormStore2.default, _NavigatorStore2.default], [fluxContext, entityKey, id]),
        descriptor = _useFluxStore.descriptor;

    var onSave = _react2.default.useCallback(function () {
        if (disallowSaveBecauseIllegal(fluxContext)) {
            (0, _withOver.appAlert)("Cannot save with current errors. Please review record and correct noted errors.");
            return;
        }
        var missingRequireds = getMissingRequiredFields(fluxContext, activeRecord.getKey());
        if (missingRequireds.length > 0) {
            var maxToShow = 5;
            if (missingRequireds.length === maxToShow + 1) {
                maxToShow = missingRequireds.length;
            }
            var jumpTarget = missingRequireds[0];
            var jumpProxy = jumpTarget[0];
            var jumpFieldInfo = jumpTarget[1];
            (0, _withOver.appAlert)({
                title: "Missing Required Fields",
                message: function message() {
                    return _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        _react2.default.createElement(
                            "p",
                            null,
                            "You must enter a value for the following ",
                            missingRequireds.length === 1 ? "field" : "fields",
                            ":"
                        ),
                        _react2.default.createElement(
                            "ul",
                            null,
                            missingRequireds.slice(0, maxToShow).map(function (_ref10, i) {
                                var _ref11 = _slicedToArray(_ref10, 2),
                                    ep = _ref11[0],
                                    fi = _ref11[1];

                                return _react2.default.createElement(
                                    "li",
                                    { key: i },
                                    ep.getLabel(),
                                    " > ",
                                    fi.name
                                );
                            }),
                            missingRequireds.length > maxToShow && _react2.default.createElement(
                                "li",
                                null,
                                "And ",
                                missingRequireds.length - maxToShow,
                                " more..."
                            )
                        )
                    );
                },

                actions: [{
                    label: "Go to " + jumpFieldInfo.name,
                    callback: function callback() {
                        return _Dispatcher2.default.contextDispatch(fluxContext, {
                            type: _NavigationActions2.default.SELECT_RECORD,
                            entityKey: jumpProxy.entityKey,
                            recordId: jumpProxy.id,
                            fieldKey: jumpFieldInfo.key
                        });
                    }
                }, {
                    label: "Cancel"
                }]
            });
            return;
        }

        _Dispatcher2.default.contextDispatch(fluxContext, {
            type: _SuperRecordActions2.default.SAVE
        });
    }, [fluxContext]);

    if (activeRecord == null) {
        return _react2.default.createElement(_NoFormView2.default, null);
    }
    var body = null;
    if (descriptor !== null) {
        if (!(descriptor.childItems == null || descriptor.childItems.length === 0)) {
            body = _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    "header",
                    { className: "form header" },
                    _react2.default.createElement(_ActionBar.FluxActionBar, {
                        fluxContext: fluxContext,
                        entityKey: activeRecord.entityKey,
                        recordId: activeRecord.id,
                        versionDropdownEnabled: showTreeNavigator,

                        isModal: isModal,
                        allowSave: _ClientId2.default.is(activeRecord.id) ? activeRecord.canCreate() : activeRecord.canWrite(),
                        allowCancel: true,
                        allowSectionJump: true,
                        onSave: onSave
                    })
                ),
                _react2.default.createElement(
                    "section",
                    { className: "entity-form-container" },
                    _react2.default.createElement(_EntityForm2.default, {
                        fluxContext: fluxContext,
                        entityKey: activeRecord.entityKey,
                        id: activeRecord.id,
                        descriptor: descriptor
                    })
                ),
                _react2.default.createElement(
                    "header",
                    { className: "form footer" },
                    _react2.default.createElement(_ValidationBar.FluxValidationBar, {
                        fluxContext: fluxContext
                    })
                )
            );
        }
    }

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            "div",
            { className: "de_pane" },
            body
        ),
        _react2.default.createElement(
            "div",
            { className: "de_sidebar" },
            _react2.default.createElement(_SidebarLayout2.default, {
                fluxContext: fluxContext
            })
        )
    );
};

BottomPaneView.propTypes = {
    fluxContext: _propTypes2.default.string.isRequired,
    showTreeNavigator: _propTypes2.default.bool,
    isModal: _propTypes2.default.bool
};

//export default BottomPaneView;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moveFocus = __webpack_require__(1039);

var _moveFocus2 = _interopRequireDefault(_moveFocus);

var _rxjs = __webpack_require__(502);

var _rxjs2 = _interopRequireDefault(_rxjs);

var _operators = __webpack_require__(347);

var _ActiveFormActions = __webpack_require__(111);

var _ActiveFormActions2 = _interopRequireDefault(_ActiveFormActions);

var _ActiveFormStore = __webpack_require__(112);

var _ActiveFormStore2 = _interopRequireDefault(_ActiveFormStore);

var _ActiveSectionStore = __webpack_require__(605);

var _ActiveSectionStore2 = _interopRequireDefault(_ActiveSectionStore);

var _ActiveSectionActions = __webpack_require__(224);

var _ActiveSectionActions2 = _interopRequireDefault(_ActiveSectionActions);

var _OverStore = __webpack_require__(61);

var _OverStore2 = _interopRequireDefault(_OverStore);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _FormStore = __webpack_require__(142);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _NoFormView = __webpack_require__(606);

var _NoFormView2 = _interopRequireDefault(_NoFormView);

var _NavigatorStore = __webpack_require__(33);

var _NavigatorStore2 = _interopRequireDefault(_NavigatorStore);

var _form = __webpack_require__(607);

var _BrowserStore = __webpack_require__(354);

var _BrowserStore2 = _interopRequireDefault(_BrowserStore);

var _HiddenFieldStore = __webpack_require__(306);

var _HiddenFieldStore2 = _interopRequireDefault(_HiddenFieldStore);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

var _RecordBrowserActions = __webpack_require__(617);

var _RecordBrowserActions2 = _interopRequireDefault(_RecordBrowserActions);

var _safeContextDispatch = __webpack_require__(251);

var _safeContextDispatch2 = _interopRequireDefault(_safeContextDispatch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildElementAction(type, currentTarget, keyboardShortcuts) {
    var $el = $(currentTarget);
    var domId = $el.attr("id");
    var ctx = $el.parents(".entity-context");
    // this is weird but the dom is holding onto the "correct" entity-key/id
    // when the event is fired and works with blur during form change.
    return {
        type: type,
        domId: domId,
        entityKey: ctx.data("entity-key"),
        recordId: ctx.data("id"),
        fieldKey: $el.get(0).dataset.shortname,
        // this isn't super awesome, but it's been this way since "forever"
        keyboardShortcuts: keyboardShortcuts || $el.get(0).dataset.keyboardShortcuts
    };
}

/*
 This should probably interrogate the descriptor to enumerate sections, and then
 only ask the DOM about positions, rather than asking the DOM to enumerate as
 well. But only so much unstupiding can happen at a time.
 */
function getSectionBounds(container) {
    var bounds = [];
    try {
        var containerOffset = container.offset().top;
        container.find(".control-section-header").each(function (i, e) {
            bounds.push({
                title: $(e).data("title"),
                top: $(e).offset().top - containerOffset
            });
        });
    } catch (error) {
        // it's unclear why this was here, but it was, and silently ignored errors?!
        console.warn("Error finding section bounds", error);
    }
    return bounds;
}

var getActiveRecord = function getActiveRecord(fluxContext, entityKey, id) {
    var rec = _NavigatorStore2.default.getRecordState(fluxContext);
    if (rec == null) return null;
    if (rec.key !== entityKey || rec.id !== id) {
        return null;
    }
    // opting for try..catch over an existence check, because it
    // truly is exceptional that NavigationStore is stale, and
    // an existence check is relatively expensive to be done on
    // every change.
    try {
        return _TableStore2.default.getEntityProxy(rec.key, rec.id);
    } catch (e) {
        if (e.message && e.message.indexOf("record is known")) {
            return null;
        }
        throw e;
    }
};

/*
I focus the specified control, despite my name. The passed field (which
specifies the control) may be one of three things:

1.  a control data packet, likely from ActiveFormStore.getActiveControl(),
1.  an element data packet, likely from ActiveFormStore.getFocusedElement(),
1.  DEPRECATED: a string, which is shortname of the field to focus the
    fronting control of, or
1.  DEPRECATED: an array, which is unclear, but appears to be a composition
    path through a record grid control? it doesn't work, and relies on
    non-standard $control.focus method behaviour.
*/
var focusField = function focusField(container, fluxContext, field) {
    var $container = $(container);
    if (_OverStore2.default.isModalInteractive()) {
        return; // prevent any lingering focus changes when modal is visible and interactive.
    }
    if (field.hasOwnProperty("domId") && field.domId != null) {
        var $el = $container.find("#" + field.domId);
        if ($el.length > 0) {
            if ((0, _ActiveFormStore.isElement)(field) || (0, _ActiveFormStore.isControl)(field)) {
                if ($el.parents((0, _moveFocus.makeRecordSelector)(field)).length > 0) {
                    return (0, _moveFocus.placeFocus)($el);
                }
            } else {
                return (0, _moveFocus.placeFocus)($el);
            }
        }
        console.warn("domId focus request missed", field.domId, $container);
    }
    if ((0, _ActiveFormStore.isControl)(field)) {
        var recordSelector = (0, _moveFocus.makeRecordSelector)(field);
        if (field.fieldKey === _ActiveFormStore.FIRST_FIELD) {
            var _$el = $container.is(recordSelector) ? $container : $(recordSelector);
            (0, _moveFocus2.default)(fluxContext, _$el);
            return true;
        } else {
            // fall back to the selector-based stuff
            var controlSelector = (0, _moveFocus.makeControlSelector)(field);
            var _$el2 = $container.is(recordSelector) ? $(controlSelector) : $(recordSelector + " " + controlSelector);

            if (_$el2.length > 0) {
                if (_$el2.length > 1) {
                    console.warn("focus request matched " + _$el2.length + " elements", field, _$el2);
                }
                // this could, in theory, match the wrong control if a child
                // record type has a field of the same name, and a grid of
                // those children are earlier in the DOM than the right one.
                return (0, _moveFocus.placeFocus)(_$el2);
            }
            // console.warn("didn't find", $el.selector);
        }
    } else if (typeof field === "string") {
        console.warn("DEPRECATED: EntityForm.focusField(String) w/", field);
        var _$el3 = $(".control-container-" + field);
        if (_$el3.length > 0) {
            return (0, _moveFocus.placeFocus)(_$el3);
        }
    } else {
        console.error("EntityForm.focusField was passed something unexpected", field);
    }
    return false;
};

var doResize = function doResize(container) {
    // this should be passed down as a prop into Form/form.js
    // leaving it as is for now.
    var $el = $(container);
    $el.find("form > div > :last-child").css({ "min-height": $el.find(".entity-information").height() });
};

var uniqueEntityFormId = function uniqueEntityFormId(fluxContext, entityKey, id, descriptor) {
    return fluxContext + "." + entityKey + "." + id + "." + descriptor.id;
};

var EntityForm = function EntityForm(props) {
    var fluxContext = props.fluxContext,
        entityKey = props.entityKey,
        id = props.id,
        descriptor = props.descriptor;

    var firstRenderRef = _react2.default.useRef(null);
    var lastSectionRef = _react2.default.useRef(_ActiveSectionStore2.default.getCurrentSection(fluxContext));
    var entityFormRef = _react2.default.useRef();
    var scrollSubscription = _react2.default.useRef(null);
    var scrollContainerRef = _react2.default.useRef();

    var state = (0, _useFluxStore2.default)(function () {
        return {
            activeRecord: getActiveRecord(fluxContext, entityKey, id),
            size: _BrowserStore2.default.getSize(),
            section: _ActiveSectionStore2.default.getCurrentSection(fluxContext)
        };
    }, [_BrowserStore2.default, _ActiveFormStore2.default, _TableStore2.default, _NavigatorStore2.default, _HiddenFieldStore2.default, _ActiveSectionStore2.default], [fluxContext, entityKey, id]);
    var activeRecord = state.activeRecord,
        section = state.section;


    var uniqueId = uniqueEntityFormId(fluxContext, entityKey, id, descriptor);
    if (firstRenderRef.current !== uniqueId) {
        firstRenderRef.current = uniqueId;
        // This START_RENDER and RENDERED should eventually be consolidated.
        _Dispatcher2.default.contextDispatch(fluxContext, {
            type: _ActiveFormActions2.default.START_RENDER,
            key: entityKey,
            id: id
        });
    }

    _react2.default.useEffect(function () {
        var $scrollContainer = $(scrollContainerRef.current);
        if (scrollSubscription.current !== null) {
            scrollSubscription.current.unsubscribe();
        }
        scrollSubscription.current = _rxjs2.default.Observable.fromEvent($scrollContainer[0], "scroll").pipe((0, _operators.debounceTime)(100)).subscribe(function () {
            var section = void 0;
            var bounds = getSectionBounds($scrollContainer);
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = bounds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (item.top <= 0) {
                        section = item;
                    } else {
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            lastSectionRef.current = section ? section.title : _FormStore.IMPLICIT_TOP_OF_FORM_SECTION_NAME;
            _Dispatcher2.default.contextDispatch(fluxContext, {
                type: _ActiveSectionActions2.default.SCROLL,
                key: entityKey,
                id: id,
                section: lastSectionRef.current
            });
        });

        _Dispatcher2.default.contextDispatch(fluxContext, {
            type: _ActiveFormActions2.default.RENDERED,
            key: entityKey,
            id: id
        });
        return function () {
            // on destroy
            scrollSubscription.current.unsubscribe();
        };
    }, [fluxContext, entityKey, id, descriptor]);

    _react2.default.useEffect(function () {
        if (section !== lastSectionRef.current) {
            var $scrollContainer = $(scrollContainerRef.current);
            if (section === _FormStore.IMPLICIT_TOP_OF_FORM_SECTION_NAME) {
                $scrollContainer.scrollTop(0);
            } else {
                var target = $(".control-section-header[data-title='" + section + "']");
                var offset = target.offset().top - $scrollContainer.offset().top;
                $scrollContainer.scrollTop(offset + $scrollContainer.scrollTop());
            }
        }
    }, [section, lastSectionRef.current]);

    _react2.default.useEffect(function () {
        // called after every render
        doResize(entityFormRef.current);

        var fm = _ActiveFormStore2.default.getFocusMovement(fluxContext);
        if (fm != null) {
            (0, _moveFocus.doFocusMovement)($(entityFormRef.current), fm);
            return;
        }
        var ac = _ActiveFormStore2.default.getActiveControl(fluxContext);
        var lb = _ActiveFormStore2.default.getLastBlurredControl(fluxContext);
        if (ac != null && !(0, _ActiveFormStore.isSameControl)(ac, lb)) {
            focusField(entityFormRef.current, fluxContext, ac);
        }
    });

    var onFocus = _react2.default.useCallback(function (e, k) {
        e.stopPropagation();
        e.preventDefault();
        (0, _safeContextDispatch2.default)(fluxContext, buildElementAction(_ActiveFormActions2.default.FOCUS_ELEMENT, e.currentTarget, k));
    }, [fluxContext, entityKey, id]);

    var onBlur = _react2.default.useCallback(function (e) {
        e.stopPropagation();
        e.preventDefault();
        (0, _safeContextDispatch2.default)(fluxContext, buildElementAction(_ActiveFormActions2.default.BLUR_ELEMENT, e.currentTarget));
    }, [fluxContext, entityKey, id]);

    var onKeyDown = _react2.default.useCallback(function (e, isKeyboardShortcut) {
        var $el = $(entityFormRef.current);
        if (isKeyboardShortcut) {
            e.preventDefault();
            e.stopPropagation();
            var tgt = e.target;
            tgt.blur();
            if (!tgt.classList.contains("react-control")) {
                // oof.
                tgt = $(tgt).parents(".react-control")[0];
            }
            // This solves move focus happening too soon and gives
            // onCommitChange a chance to change field enablement.
            // wait a tick before trying to move.
            //
            // eslint-disable-next-line no-settimeout
            setTimeout(function () {
                (0, _moveFocus2.default)(fluxContext, $(entityFormRef.current), tgt);
            });

            return;
        }
        if (![9, 13].includes(e.keyCode) || e.altKey || e.ctrlKey) {
            // we're only interested in TAB and ENTER, optionally with SHIFT
            // pressed. Otherwise we don't care.
            return;
        }
        var forward = !e.shiftKey;
        e.target.blur();
        var $tgt = $(e.target);
        var $ctrl = $tgt.parents(".control");
        if ($ctrl.length > 0) {
            (0, _moveFocus2.default)(fluxContext, $el, $ctrl, forward);
        } else {
            (0, _moveFocus2.default)(fluxContext, $el, $tgt, forward);
        }
    }, [fluxContext, entityKey, id]);

    var onGlobalRecordLookup = _react2.default.useCallback(function (key, field, candidateFilter, currId) {
        var lookupCallback = function (ar, field, key) {
            return function (rbs, model) {
                return ar.set(field, model.getProjectionForVersion(key).getRecord());
            };
        }(activeRecord, field, key);

        var focusCallback = function focusCallback() {
            return focusField(entityFormRef.current, fluxContext, field);
        };

        _Dispatcher2.default.dispatch({
            type: _RecordBrowserActions2.default.GLOBAL_LOOKUP_CLICK,
            key: key,
            lookupCallback: lookupCallback,
            focusCallback: focusCallback,
            candidateFilter: candidateFilter,
            currId: currId
        });
    }, [fluxContext, entityKey, id]);

    return _react2.default.createElement(
        "div",
        {
            ref: entityFormRef,
            id: "data-entity-form",
            className: "entity-context",
            "data-context": fluxContext,
            "data-id": activeRecord != null ? activeRecord.id : "",
            "data-entity-key": activeRecord != null ? activeRecord.entityKey : ""
        },
        _react2.default.createElement(
            "div",
            { ref: scrollContainerRef, className: "entity-information" },
            _react2.default.createElement(
                "div",
                { className: "form-target" },
                activeRecord == null ? _react2.default.createElement(_NoFormView2.default, null) : _react2.default.createElement(_form.Formform, {
                    selector: "i-am-the-form-body-yo",
                    descriptor: descriptor,
                    activeRecord: activeRecord,
                    fluxContext: fluxContext,
                    onFocus: onFocus,
                    onBlur: onBlur,
                    onKeyDown: onKeyDown,
                    onGlobalRecordLookup: onGlobalRecordLookup
                })
            )
        )
    );
};
EntityForm.propTypes = {
    fluxContext: _propTypes2.default.string.isRequired,
    entityKey: _propTypes2.default.string.isRequired,
    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    descriptor: _propTypes2.default.object.isRequired
};

exports.default = EntityForm;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.doFocusMovement = exports.makeControlSelector = exports.makeRecordSelector = exports.FOCUS_TRACKABLE_SELECTOR = undefined;
exports.placeFocus = placeFocus;

var _OverStore = __webpack_require__(61);

var _OverStore2 = _interopRequireDefault(_OverStore);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _ActiveFormActions = __webpack_require__(111);

var _ActiveFormActions2 = _interopRequireDefault(_ActiveFormActions);

var _ActiveFormStore = __webpack_require__(112);

var _decaf = __webpack_require__(1040);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FOCUS_TRACKABLE_SELECTOR = exports.FOCUS_TRACKABLE_SELECTOR = ".control, .keyboard-focusable";

/**
 * I record a focus movement request w/in a container, based on the current
 * element. If no current element is specified (i.e., is `null`), focus will be
 * moved to the first focusable element.
 * @param fluxContext the flux context focus is moving within
 * @param $container jQuery instance to move focus within (a record context).
 * @param curr DOM node that currently has focus to move relative to.
 * @param forward boolean whether to move forward (the default) or not.
 */
var moveFocus = function moveFocus(fluxContext, $container, curr) {
    var forward = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    if (curr) {
        if (curr instanceof jQuery) {
            curr = curr[0]; // unwrap
        }
        if (!curr.id) {
            if (false) {
                throw new Error("Focus anchor with no ID!");
            }
            return; // can't do anything...
        }
        _Dispatcher2.default.contextDispatch(fluxContext, {
            type: _ActiveFormActions2.default.MOVE_FOCUS,
            recordId: $container.data("id"),
            fieldKey: curr.dataset.shortname, // null for non-controls
            domId: curr.id,
            delta: forward ? 1 : -1
        });
    } else {
        _Dispatcher2.default.contextDispatch(fluxContext, {
            type: _ActiveFormActions2.default.PLACE_FOCUS_AT_START,
            recordId: $container.data("id")
        });
    }
};

var makeRecordSelector = exports.makeRecordSelector = function makeRecordSelector(tuple) {
    return (
        // don't do this, to allow maintaining focus across a version change
        //   [data-entity-key='${tuple.entityKey}']
        ".entity-context[data-id=" + tuple.recordId + "]"
    );
};

var makeControlSelector = exports.makeControlSelector = function makeControlSelector(tuple) {
    return ".control-container-" + tuple.fieldKey;
};

var focusMovementHelper = function focusMovementHelper($container, curr, delta) {
    if (_OverStore2.default.isModalInteractive()) {
        return; // prevent any lingering focus changes when modal is visible and interactive.
    }
    var $form_items = $container.find(FOCUS_TRACKABLE_SELECTOR);
    var index = -1; // before the start
    if (curr != null) {
        index = $form_items.index(curr);
        if (delta === 0) {
            placeFocus(curr);
            return; // don't need to move, just place
        }
    }
    if (delta > 0 && index + delta >= $form_items.length) {
        placeFocus(curr);
        return; // already at the end
    }
    if (delta < 0 && index === 0) {
        placeFocus(curr);
        return; // already at the beginning
    }
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = Array.from(delta > 0 ? (0, _decaf.__range__)(index + delta, $form_items.length, false) : (0, _decaf.__range__)(index + delta, 0, true))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var i = _step.value;

            if (placeFocus($form_items.get(i))) {
                return;
            }
        }
        // well hell
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    placeFocus(curr);
};

var doFocusMovement = exports.doFocusMovement = function doFocusMovement($form, fm) {
    var recSel = makeRecordSelector(fm);
    var $container = $form.is(recSel) ? $form : $form.find(recSel);
    if ($container.length === 0) {
        return;
    }
    if (fm.domId) {
        var byId = document.getElementById(fm.domId);
        if (byId && $container[0].contains(byId)) {
            focusMovementHelper($container, byId, fm.delta);
            return; // woo!
        }
    }
    if (fm.fieldKey) {
        if (fm.fieldKey === _ActiveFormStore.FIRST_FIELD) {
            focusMovementHelper($container, null, 1);
            return;
        }
        var $byKey = $container.find(makeControlSelector(fm));
        if ($byKey.length) {
            var delta = fm.delta;
            // orNextEnabled will try to land focus on the exact field or if
            // it is disabled will moved to the next enabled field.
            if (fm.orNextEnabled && delta === 0) {
                var $focusable = getFocusable($byKey);
                if ($focusable != null && !isEnabled($focusable)) {
                    delta = 1;
                }
            }
            focusMovementHelper($byKey.parents(recSel).first(), $byKey, delta);
        }
    }
    // console.warn("doFocusMovement missed:", it);
};

var CONTROL_TYPE = {
    REACT: "react",
    OTHER: "dom"
};

function placeFocus(it) {
    var $it = $(it);
    try {
        var $focusable = getFocusable($it);
        if ($focusable != null && isEnabled($focusable)) {
            $focusable.focus();
            return true;
        }
    } catch (e) {
        console.error("placeFocus errored:", e.message, it, e);
    }
    // console.warn("placeFocus missed:", it);
    return false;
}

var isEnabled = function isEnabled($it) {
    return $it.is(":enabled") || !$it.is("[disabled]");
};

var getFocusable = function getFocusable($it) {
    if (getControlType($it) === CONTROL_TYPE.REACT) {
        // The controls use .focusable, but buttons and other non-controls
        // use .keyboard-focusable. We want the control to win, but if there
        // isn't one, look for a button or whatever.
        var _arr = [".focusable", FOCUS_TRACKABLE_SELECTOR];
        for (var _i = 0; _i < _arr.length; _i++) {
            var sel = _arr[_i];
            var $focusable = $it.find(sel);
            if ($focusable.length > 0) {
                return $focusable.first();
            }
        }
        return null;
    }
    return $it;
};

var getControlType = function getControlType($it) {
    if ($it.is(".react-control")) return CONTROL_TYPE.REACT;
    if ($it.is(".control")) {
        console.log("non-React control:", $it[0]);
        throw new Error("Found a non-React control?!");
    }
    return CONTROL_TYPE.OTHER;
};

exports.default = moveFocus;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.__range__ = __range__;
/*
 There are a couple things that coffeescript would generate for you, and thus
 which are duplicated in misc formerly-coffeescript modules. They go here.
 */

function __range__(left, right, inclusive) {
    var range = [];
    var ascending = left < right;
    var end = !inclusive ? right : ascending ? right + 1 : right - 1;
    for (var i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
        range.push(i);
    }
    return range;
}

/***/ }),
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Layoutcolumn = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _formhelpers = __webpack_require__(5);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Kids = __webpack_require__(148);

var _Kids2 = _interopRequireDefault(_Kids);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Layoutcolumn = exports.Layoutcolumn = function (_React$Component) {
    _inherits(Layoutcolumn, _React$Component);

    function Layoutcolumn() {
        _classCallCheck(this, Layoutcolumn);

        return _possibleConstructorReturn(this, (Layoutcolumn.__proto__ || Object.getPrototypeOf(Layoutcolumn)).apply(this, arguments));
    }

    _createClass(Layoutcolumn, [{
        key: "render",
        value: function render() {
            var descriptor = this.props.descriptor;

            this.selector = "control-layout-" + descriptor.key;
            return _react2.default.createElement(
                "div",
                {
                    key: descriptor.key,
                    id: descriptor.id,
                    className: "control-layout-" + descriptor.key + " control-layout-column"
                },
                _react2.default.createElement(_Kids2.default, _extends({}, this.props, { controlOnly: false }))
            );
        }
    }]);

    return Layoutcolumn;
}(_react2.default.Component);

Layoutcolumn.propTypes = {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)(null, false, true)),
    fluxContext: _propTypes2.default.string.isRequired,
    activeRecord: _propTypes2.default.instanceOf(_EntityProxy2.default).isRequired
};

exports.default = Layoutcolumn;

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Layoutcolumnset = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _formhelpers = __webpack_require__(5);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Kids = __webpack_require__(148);

var _Kids2 = _interopRequireDefault(_Kids);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Layoutcolumnset = exports.Layoutcolumnset = function (_React$Component) {
    _inherits(Layoutcolumnset, _React$Component);

    function Layoutcolumnset() {
        _classCallCheck(this, Layoutcolumnset);

        return _possibleConstructorReturn(this, (Layoutcolumnset.__proto__ || Object.getPrototypeOf(Layoutcolumnset)).apply(this, arguments));
    }

    _createClass(Layoutcolumnset, [{
        key: "render",
        value: function render() {
            var descriptor = this.props.descriptor;

            return _react2.default.createElement(
                "div",
                {
                    key: descriptor.key,
                    id: descriptor.id,
                    className: "control-layout-" + descriptor.key + " control-layout-columnset"
                },
                _react2.default.createElement(_Kids2.default, _extends({}, this.props, { controlOnly: false }))
            );
        }
    }]);

    return Layoutcolumnset;
}(_react2.default.Component);

Layoutcolumnset.propTypes = {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)(null, false, true)),
    fluxContext: _propTypes2.default.string.isRequired,
    activeRecord: _propTypes2.default.instanceOf(_EntityProxy2.default).isRequired
};

exports.default = Layoutcolumnset;

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Layoutgrid = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _formhelpers = __webpack_require__(5);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Kids = __webpack_require__(148);

var _Kids2 = _interopRequireDefault(_Kids);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Layoutgrid = exports.Layoutgrid = function (_React$Component) {
    _inherits(Layoutgrid, _React$Component);

    function Layoutgrid() {
        _classCallCheck(this, Layoutgrid);

        return _possibleConstructorReturn(this, (Layoutgrid.__proto__ || Object.getPrototypeOf(Layoutgrid)).apply(this, arguments));
    }

    _createClass(Layoutgrid, [{
        key: "render",
        value: function render() {
            var descriptor = this.props.descriptor;

            var config = descriptor.config || {};
            var summaryClass = config.style === "summary" ? " control-layout-grid-summary" : "";
            return _react2.default.createElement(
                "div",
                { key: descriptor.key },
                _react2.default.createElement(
                    "table",
                    { id: descriptor.id, className: "control-layout-grid" + summaryClass },
                    _react2.default.createElement(
                        "tbody",
                        { className: "control-layout-" + descriptor.key },
                        _react2.default.createElement(_Kids2.default, _extends({}, this.props, { controlOnly: false }))
                    )
                )
            );
        }
    }]);

    return Layoutgrid;
}(_react2.default.Component);

Layoutgrid.propTypes = {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)({
        style: _propTypes2.default.oneOf(["summary"])
    }, false, true)),
    fluxContext: _propTypes2.default.string.isRequired,
    activeRecord: _propTypes2.default.instanceOf(_EntityProxy2.default).isRequired
};

exports.default = Layoutgrid;

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Layoutgridcell = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formhelpers = __webpack_require__(5);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Kids = __webpack_require__(148);

var _Kids2 = _interopRequireDefault(_Kids);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Layoutgridcell = exports.Layoutgridcell = function (_React$Component) {
    _inherits(Layoutgridcell, _React$Component);

    function Layoutgridcell() {
        _classCallCheck(this, Layoutgridcell);

        return _possibleConstructorReturn(this, (Layoutgridcell.__proto__ || Object.getPrototypeOf(Layoutgridcell)).apply(this, arguments));
    }

    _createClass(Layoutgridcell, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                descriptor = _props.descriptor,
                activeRecord = _props.activeRecord;

            var config = Object.assign({}, Layoutgridcell.defaultProps.descriptor.config, descriptor.config);
            var Control = config.heading === true ? "th" : "td";
            var classes = [this.selector, "control-layout-gridcell"];
            if (config.controlOnly) {
                classes.push("control-only");
            }
            switch (config.align) {
                case "right":
                    classes.push("text-right");
                    break;
                case "center":
                    classes.push("text-center");
                    break;
                case "left":
                default:
                    classes.push("text-left");
            }
            var children = void 0;
            if (config.heading === true && config.headingFor) {
                var label = null;
                try {
                    label = _entityFieldMetaStore2.default.getInfo(activeRecord.entityKey, config.headingFor).name;
                } catch (e) {
                    console.warn("Layoutgridcell: headingFor references unknown field '" + config.headingFor + "' on entity '" + (activeRecord && activeRecord.entityKey) + "'", e);
                }
                children = _react2.default.createElement(
                    "span",
                    { className: "widget-label" },
                    label
                );
            } else {
                children = _react2.default.createElement(_Kids2.default, _extends({}, this.props, { controlOnly: config.controlOnly }));
            }
            return _react2.default.createElement(
                Control,
                {
                    key: descriptor.key,
                    id: descriptor.id,
                    className: classes.join(" "),
                    width: config.width,
                    colSpan: config.colSpan
                },
                children
            );
        }
    }]);

    return Layoutgridcell;
}(_react2.default.Component);

Layoutgridcell.defaultProps = {
    descriptor: {
        config: {
            controlOnly: true,
            heading: false,
            align: "left"
        }
    }
};

Layoutgridcell.propTypes = {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)({
        controlOnly: _propTypes2.default.bool,
        heading: _propTypes2.default.bool,
        align: _propTypes2.default.oneOf(["left", "right", "center"]),
        width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        colSpan: _propTypes2.default.number,
        headingFor: _propTypes2.default.string
    }, false, false)),
    fluxContext: _propTypes2.default.string.isRequired,
    activeRecord: _propTypes2.default.instanceOf(_EntityProxy2.default).isRequired
};

exports.default = Layoutgridcell;

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Layoutgridrow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _formhelpers = __webpack_require__(5);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Kids = __webpack_require__(148);

var _Kids2 = _interopRequireDefault(_Kids);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Layoutgridrow = exports.Layoutgridrow = function (_React$Component) {
    _inherits(Layoutgridrow, _React$Component);

    function Layoutgridrow() {
        _classCallCheck(this, Layoutgridrow);

        return _possibleConstructorReturn(this, (Layoutgridrow.__proto__ || Object.getPrototypeOf(Layoutgridrow)).apply(this, arguments));
    }

    _createClass(Layoutgridrow, [{
        key: "render",
        value: function render() {
            var descriptor = this.props.descriptor;

            return _react2.default.createElement(
                "tr",
                {
                    key: descriptor.key,
                    id: descriptor.id,
                    className: "control-layout-" + descriptor.key + " control-layout-gridrow"
                },
                _react2.default.createElement(_Kids2.default, _extends({}, this.props, { controlOnly: false }))
            );
        }
    }]);

    return Layoutgridrow;
}(_react2.default.Component);

Layoutgridrow.propTypes = {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)(null, false, true)),
    fluxContext: _propTypes2.default.string.isRequired,
    activeRecord: _propTypes2.default.instanceOf(_EntityProxy2.default).isRequired
};

exports.default = Layoutgridrow;

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Layoutsection = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _formhelpers = __webpack_require__(5);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Kids = __webpack_require__(148);

var _Kids2 = _interopRequireDefault(_Kids);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Layoutsection = exports.Layoutsection = function (_React$Component) {
    _inherits(Layoutsection, _React$Component);

    function Layoutsection() {
        _classCallCheck(this, Layoutsection);

        return _possibleConstructorReturn(this, (Layoutsection.__proto__ || Object.getPrototypeOf(Layoutsection)).apply(this, arguments));
    }

    _createClass(Layoutsection, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                descriptor = _props.descriptor,
                controlOnly = _props.controlOnly;

            var control = _react2.default.createElement(
                "div",
                { key: descriptor.key },
                _react2.default.createElement(
                    "div",
                    { id: descriptor.id,
                        className: "control-container-" + descriptor.key + " control-section-header",
                        "data-title": descriptor.label },
                    _react2.default.createElement(
                        "span",
                        {
                            className: "uic-sh-message-title" },
                        descriptor.label
                    )
                ),
                _react2.default.createElement(_Kids2.default, _extends({}, this.props, { controlOnly: false }))
            );
            return controlOnly ? control : _react2.default.createElement(
                "fieldset",
                { key: descriptor.key },
                control
            );
        }
    }]);

    return Layoutsection;
}(_react2.default.Component);

Layoutsection.propTypes = {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)(null, false, true)),
    fluxContext: _propTypes2.default.string.isRequired,
    activeRecord: _propTypes2.default.instanceOf(_EntityProxy2.default).isRequired,
    controlOnly: _propTypes2.default.bool
};

exports.default = Layoutsection;

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NotFound = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _formhelpers = __webpack_require__(5);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _GonkBox = __webpack_require__(212);

var _GonkBox2 = _interopRequireDefault(_GonkBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFound = exports.NotFound = function NotFound(_ref) {
    var descriptor = _ref.descriptor;
    return _react2.default.createElement(
        _GonkBox2.default,
        {
            id: descriptor.id,
            "data-type": descriptor.type,
            "data-control-type": descriptor.control,
            "data-shortname": descriptor.key
        },
        _react2.default.createElement(
            "code",
            null,
            "formitems/",
            descriptor.type,
            "/",
            descriptor.control,
            ".js"
        ),
        " doesn't export a ",
        _react2.default.createElement(
            "code",
            null,
            descriptor.type,
            descriptor.control
        ),
        " Component (for ",
        _react2.default.createElement(
            "code",
            null,
            descriptor.key
        ),
        ")."
    );
};

NotFound.propTypes = {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)())
};

exports.default = NotFound;

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StringFielddropdown = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _dropdown = __webpack_require__(469);

var _dropdown2 = _interopRequireDefault(_dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StringFielddropdown = exports.StringFielddropdown = function (_BaseFormItem) {
    _inherits(StringFielddropdown, _BaseFormItem);

    function StringFielddropdown() {
        _classCallCheck(this, StringFielddropdown);

        return _possibleConstructorReturn(this, (StringFielddropdown.__proto__ || Object.getPrototypeOf(StringFielddropdown)).apply(this, arguments));
    }

    _createClass(StringFielddropdown, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor;

            return _react2.default.createElement(_dropdown2.default, _extends({}, this.getPlumbingProps(), {
                value: activeRecord.get(descriptor.key),
                enabled: activeRecord.isFieldEnabled(descriptor.key) }));
        }
    }]);

    return StringFielddropdown;
}(_BaseFormItem3.default);

exports.default = StringFielddropdown;

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 *
 */

/*eslint-disable */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StringFieldlabel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _label = __webpack_require__(300);

var _label2 = _interopRequireDefault(_label);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StringFieldlabel = exports.StringFieldlabel = function (_BaseFormItem) {
    _inherits(StringFieldlabel, _BaseFormItem);

    function StringFieldlabel() {
        _classCallCheck(this, StringFieldlabel);

        return _possibleConstructorReturn(this, (StringFieldlabel.__proto__ || Object.getPrototypeOf(StringFieldlabel)).apply(this, arguments));
    }

    _createClass(StringFieldlabel, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor;

            return _react2.default.createElement(_label2.default, _extends({}, this.getPlumbingProps(), {
                value: activeRecord.get(descriptor.key),
                enabled: activeRecord.isFieldEnabled(descriptor.key)
            }));
        }
    }]);

    return StringFieldlabel;
}(_BaseFormItem3.default);

exports.default = StringFieldlabel;

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StringFieldtext = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _text = __webpack_require__(298);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StringFieldtext = exports.StringFieldtext = function (_BaseFormItem) {
    _inherits(StringFieldtext, _BaseFormItem);

    function StringFieldtext(props) {
        _classCallCheck(this, StringFieldtext);

        var _this = _possibleConstructorReturn(this, (StringFieldtext.__proto__ || Object.getPrototypeOf(StringFieldtext)).call(this, props));

        var activeRecord = props.activeRecord,
            descriptor = props.descriptor;
        // these can't change

        _this.info = _entityFieldMetaStore2.default.getInfo(activeRecord.entityKey, descriptor.key);
        _this.maxLengthScript = _this.info ? _this.info.scripts.maxLength : undefined;
        _this.__enablePureOverValueAndEnabledHandling();
        return _this;
    }

    _createClass(StringFieldtext, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
            if (this.maxLengthScript) return true;
            return _get(StringFieldtext.prototype.__proto__ || Object.getPrototypeOf(StringFieldtext.prototype), "shouldComponentUpdate", this).call(this, nextProps, nextState, nextContext);
        }
    }, {
        key: "render",
        value: function render() {
            var _state = this.state,
                value = _state.value,
                enabled = _state.enabled;

            var mls = this.maxLengthScript;
            var maxLength = mls ? mls(this.props.activeRecord) : undefined;
            if (maxLength > 15) {
                maxLength = undefined;
            }
            return _react2.default.createElement(_text2.default, _extends({}, this.getPlumbingProps(), {
                maxLength: maxLength,
                value: value,
                enabled: enabled
            }));
        }
    }]);

    return StringFieldtext;
}(_BaseFormItem3.default);

exports.default = StringFieldtext;

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StringFieldtextarea = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _textarea = __webpack_require__(299);

var _textarea2 = _interopRequireDefault(_textarea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StringFieldtextarea = exports.StringFieldtextarea = function (_BaseFormItem) {
    _inherits(StringFieldtextarea, _BaseFormItem);

    function StringFieldtextarea() {
        _classCallCheck(this, StringFieldtextarea);

        return _possibleConstructorReturn(this, (StringFieldtextarea.__proto__ || Object.getPrototypeOf(StringFieldtextarea)).apply(this, arguments));
    }

    _createClass(StringFieldtextarea, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor;

            return _react2.default.createElement(_textarea2.default, _extends({}, this.getPlumbingProps(), {
                value: activeRecord.get(descriptor.key),
                enabled: activeRecord.isFieldEnabled(descriptor.key) }));
        }
    }]);

    return StringFieldtextarea;
}(_BaseFormItem3.default);

exports.default = StringFieldtextarea;

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IntegerFieldlabel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _label = __webpack_require__(467);

var _label2 = _interopRequireDefault(_label);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IntegerFieldlabel = exports.IntegerFieldlabel = function (_BaseFormItem) {
    _inherits(IntegerFieldlabel, _BaseFormItem);

    function IntegerFieldlabel() {
        _classCallCheck(this, IntegerFieldlabel);

        return _possibleConstructorReturn(this, (IntegerFieldlabel.__proto__ || Object.getPrototypeOf(IntegerFieldlabel)).apply(this, arguments));
    }

    _createClass(IntegerFieldlabel, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor;

            return _react2.default.createElement(_label2.default, _extends({}, this.getPlumbingProps(), {
                value: activeRecord.get(descriptor.key),
                enabled: activeRecord.isFieldEnabled(descriptor.key)
            }));
        }
    }]);

    return IntegerFieldlabel;
}(_BaseFormItem3.default);

exports.default = IntegerFieldlabel;

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IntegerFieldspinner = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _spinner = __webpack_require__(468);

var _spinner2 = _interopRequireDefault(_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IntegerFieldspinner = exports.IntegerFieldspinner = function (_BaseFormItem) {
    _inherits(IntegerFieldspinner, _BaseFormItem);

    function IntegerFieldspinner() {
        _classCallCheck(this, IntegerFieldspinner);

        return _possibleConstructorReturn(this, (IntegerFieldspinner.__proto__ || Object.getPrototypeOf(IntegerFieldspinner)).apply(this, arguments));
    }

    _createClass(IntegerFieldspinner, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor;

            return _react2.default.createElement(_spinner2.default, _extends({}, this.getPlumbingProps(), {
                value: activeRecord.get(descriptor.key),
                enabled: activeRecord.isFieldEnabled(descriptor.key)
            }));
        }
    }]);

    return IntegerFieldspinner;
}(_BaseFormItem3.default);

exports.default = IntegerFieldspinner;

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DateTimeFieldcalendar = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _calendar = __webpack_require__(294);

var _calendar2 = _interopRequireDefault(_calendar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DateTimeFieldcalendar = exports.DateTimeFieldcalendar = function (_BaseFormItem) {
    _inherits(DateTimeFieldcalendar, _BaseFormItem);

    function DateTimeFieldcalendar() {
        _classCallCheck(this, DateTimeFieldcalendar);

        return _possibleConstructorReturn(this, (DateTimeFieldcalendar.__proto__ || Object.getPrototypeOf(DateTimeFieldcalendar)).apply(this, arguments));
    }

    _createClass(DateTimeFieldcalendar, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor;

            return _react2.default.createElement(_calendar2.default, _extends({}, this.getPlumbingProps(), {
                value: activeRecord.get(descriptor.key),
                enabled: activeRecord.isFieldEnabled(descriptor.key)
            }));
        }
    }]);

    return DateTimeFieldcalendar;
}(_BaseFormItem3.default);

exports.default = DateTimeFieldcalendar;

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DateTimeFieldlabel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _label = __webpack_require__(295);

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DateTimeFieldlabel = exports.DateTimeFieldlabel = function (_BaseFormItem) {
    _inherits(DateTimeFieldlabel, _BaseFormItem);

    function DateTimeFieldlabel() {
        _classCallCheck(this, DateTimeFieldlabel);

        return _possibleConstructorReturn(this, (DateTimeFieldlabel.__proto__ || Object.getPrototypeOf(DateTimeFieldlabel)).apply(this, arguments));
    }

    _createClass(DateTimeFieldlabel, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor;

            return _react2.default.createElement(_label2.default, _extends({}, this.getPlumbingProps(), {
                value: activeRecord.get(descriptor.key),
                enabled: activeRecord.isFieldEnabled(descriptor.key)
            }));
        }
    }]);

    return DateTimeFieldlabel;
}(_BaseFormItem3.default);

exports.default = DateTimeFieldlabel;

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DateFieldcalendar = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _calendar = __webpack_require__(451);

var _calendar2 = _interopRequireDefault(_calendar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DateFieldcalendar = exports.DateFieldcalendar = function (_BaseFormItem) {
    _inherits(DateFieldcalendar, _BaseFormItem);

    function DateFieldcalendar() {
        _classCallCheck(this, DateFieldcalendar);

        return _possibleConstructorReturn(this, (DateFieldcalendar.__proto__ || Object.getPrototypeOf(DateFieldcalendar)).apply(this, arguments));
    }

    _createClass(DateFieldcalendar, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor;

            return _react2.default.createElement(_calendar2.default, _extends({}, this.getPlumbingProps(), {
                value: activeRecord.get(descriptor.key),
                enabled: activeRecord.isFieldEnabled(descriptor.key)
            }));
        }
    }]);

    return DateFieldcalendar;
}(_BaseFormItem3.default);

exports.default = DateFieldcalendar;

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DateFieldlabel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _label = __webpack_require__(458);

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DateFieldlabel = exports.DateFieldlabel = function (_BaseFormItem) {
    _inherits(DateFieldlabel, _BaseFormItem);

    function DateFieldlabel() {
        _classCallCheck(this, DateFieldlabel);

        return _possibleConstructorReturn(this, (DateFieldlabel.__proto__ || Object.getPrototypeOf(DateFieldlabel)).apply(this, arguments));
    }

    _createClass(DateFieldlabel, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor;

            return _react2.default.createElement(_label2.default, _extends({}, this.getPlumbingProps(), {
                value: activeRecord.get(descriptor.key),
                enabled: activeRecord.isFieldEnabled(descriptor.key)
            }));
        }
    }]);

    return DateFieldlabel;
}(_BaseFormItem3.default);

exports.default = DateFieldlabel;

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DecimalFieldlabel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _label = __webpack_require__(459);

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DecimalFieldlabel = exports.DecimalFieldlabel = function (_BaseFormItem) {
    _inherits(DecimalFieldlabel, _BaseFormItem);

    function DecimalFieldlabel() {
        _classCallCheck(this, DecimalFieldlabel);

        return _possibleConstructorReturn(this, (DecimalFieldlabel.__proto__ || Object.getPrototypeOf(DecimalFieldlabel)).apply(this, arguments));
    }

    _createClass(DecimalFieldlabel, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor;

            return _react2.default.createElement(_label2.default, _extends({}, this.getPlumbingProps(), {
                value: activeRecord.get(descriptor.key),
                enabled: activeRecord.isFieldEnabled(descriptor.key)
            }));
        }
    }]);

    return DecimalFieldlabel;
}(_BaseFormItem3.default);

exports.default = DecimalFieldlabel;

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DecimalFieldtext = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _text = __webpack_require__(460);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DecimalFieldtext = exports.DecimalFieldtext = function (_BaseFormItem) {
    _inherits(DecimalFieldtext, _BaseFormItem);

    function DecimalFieldtext(props) {
        _classCallCheck(this, DecimalFieldtext);

        var _this = _possibleConstructorReturn(this, (DecimalFieldtext.__proto__ || Object.getPrototypeOf(DecimalFieldtext)).call(this, props));

        _this.__enablePureOverValueAndEnabledHandling();
        return _this;
    }

    _createClass(DecimalFieldtext, [{
        key: "render",
        value: function render() {
            var _state = this.state,
                value = _state.value,
                enabled = _state.enabled;

            return _react2.default.createElement(_text2.default, _extends({}, this.getPlumbingProps(), {
                value: value,
                enabled: enabled
            }));
        }
    }]);

    return DecimalFieldtext;
}(_BaseFormItem3.default);

exports.default = DecimalFieldtext;

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FileFieldlabel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _manager = __webpack_require__(608);

var _manager2 = _interopRequireDefault(_manager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileFieldlabel = exports.FileFieldlabel = function FileFieldlabel(props) {
    return _react2.default.createElement(_manager2.default, _extends({}, props, { readOnly: true }));
};

exports.default = FileFieldlabel;

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FileFieldrfpi = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _formhelpers = __webpack_require__(5);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _rfpi = __webpack_require__(1357);

var _rfpi2 = _interopRequireDefault(_rfpi);

var _fileUploads = __webpack_require__(349);

var _FileUploadStore = __webpack_require__(227);

var _FileUploadStore2 = _interopRequireDefault(_FileUploadStore);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _Select = __webpack_require__(213);

var _Select2 = _interopRequireDefault(_Select);

var _classnames = __webpack_require__(51);

var _classnames2 = _interopRequireDefault(_classnames);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FileFieldrfpi = exports.FileFieldrfpi = function (_BaseFormItem) {
    _inherits(FileFieldrfpi, _BaseFormItem);

    function FileFieldrfpi(props) {
        _classCallCheck(this, FileFieldrfpi);

        var _this = _possibleConstructorReturn(this, (FileFieldrfpi.__proto__ || Object.getPrototypeOf(FileFieldrfpi)).call(this, props));

        _this.state = {
            comparison: undefined,
            mode: "individual"
        };

        _this.onCommitChange = _this.onCommitChange.bind(_this);
        _this.onClick = _this.onClick.bind(_this);
        _this.comparisons = {};
        return _this;
    }

    _createClass(FileFieldrfpi, [{
        key: "onCommitChange",
        value: function onCommitChange(d, v) {
            this.setState({
                comparison: v
            });
        }
    }, {
        key: "onClick",
        value: function onClick(e) {
            e.preventDefault();
            this.setState({
                comparison: e.target.value === "individual" ? undefined : this.state.comparison,
                mode: e.target.value
            });
        }
    }, {
        key: "gatherComparisons",
        value: function gatherComparisons(activeRecord) {
            var _this2 = this;

            var _activeRecord$get = activeRecord.get("parent"),
                entityInfo = _activeRecord$get.entityInfo,
                id = _activeRecord$get.id;

            var patientID = _TableStore2.default.getRecordData(entityInfo.tableKey, id).data.patient_id;
            var comparisonIDs = _TableStore2.default.getRecordData("patient", patientID).data.comparisons_id;
            var result = [{
                label: "Select a comparison",
                value: ""
            }];
            comparisonIDs.forEach(function (compId) {
                var x = _TableStore2.default.getRecordData("rfpi_imaging_comparison", compId).data;
                // TODO: fix labels (i.e.: use toString script)
                //  Barney thinks both invocations of `entityInfo.scripts.toString`,
                //  should instead be `activeRecord.getLabel()`? Maybe? They aren't
                //  going to do anything useful as-written, at least.
                if (x.episode_one_id === activeRecord.id) {
                    result.push({
                        label: entityInfo.scripts.toString() + " - Episode " + x.episode_two_id,
                        value: compId
                    });
                    _this2.comparisons[compId] = x;
                }
                if (x.episode_two_id === activeRecord.id) {
                    result.push({
                        label: entityInfo.scripts.toString() + " - Episode " + x.episode_one_id,
                        value: compId
                    });
                    _this2.comparisons[compId] = x;
                }
            });
            return result;
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor;

            var comparisons = this.gatherComparisons(activeRecord);

            var btnClasses = ["btn", "btn-toggle"];
            var individual = (0, _classnames2.default)(btnClasses, {
                "individual": this.state.mode === "individual"
            });
            var comparison = (0, _classnames2.default)(btnClasses, {
                "comparison": this.state.mode === "comparison"
            });

            var Selector = function Selector(props) {
                return _react2.default.createElement(
                    "div",
                    { className: "mode-selector" },
                    _react2.default.createElement(
                        "button",
                        { className: individual, value: "individual", onClick: _this3.onClick },
                        "Individual"
                    ),
                    _react2.default.createElement(
                        "button",
                        { className: comparison, value: "comparison", onClick: _this3.onClick },
                        "Comparison"
                    )
                );
            };

            // TODO: this is quite hacky and it's here because of the related
            // IT test. needs clean up.
            var Dropdown = function Dropdown(props) {
                return _react2.default.createElement(
                    "div",
                    {
                        className: "dropdown-container control-container-comparisonselector",
                        "data-control-type": "dropdown" },
                    _react2.default.createElement(_Select2.default, _extends({}, props, {
                        onCommitChange: _this3.onCommitChange,
                        value: _this3.state.comparison,
                        enabled: true
                    }))
                );
            };

            var dropdown = void 0,
                selector = void 0;
            if (!_.isEmpty(comparisons)) {
                dropdown = _react2.default.createElement(Dropdown, { options: comparisons });
                selector = _react2.default.createElement(Selector, null);
            }

            var org = _userStore2.default.getActiveOrgKey();

            var imageFile = void 0;
            if (activeRecord.get("imagefile")) {
                imageFile = (0, _fileUploads.buildFileMeta)(descriptor.key, activeRecord.id, org, activeRecord.entityKey, false, activeRecord.get("imagefile"));
            }

            var selectedComparisons = void 0;
            if (this.state.comparison) {
                var one = (0, _fileUploads.buildFileMeta)("imagefile_one", this.state.comparison, org, "rfpi/1-0/comparison", false, this.comparisons[this.state.comparison].imagefile_one_id);
                var two = (0, _fileUploads.buildFileMeta)("imagefile_two", this.state.comparison, org, "rfpi/1-0/comparison", false, this.comparisons[this.state.comparison].imagefile_two_id);

                if (this.comparisons[this.state.comparison].episode_one_id === activeRecord.id) {
                    selectedComparisons = [one, two];
                } else {
                    selectedComparisons = [two, one];
                }
            }

            return _react2.default.createElement(ConnectedControl, _extends({}, this.getPlumbingProps(), {
                onClick: this.onClick,
                value: activeRecord.get(descriptor.key),
                enabled: activeRecord.isFieldEnabled(descriptor.key),
                imageFile: imageFile,
                selectedComparisons: selectedComparisons,
                dropdown: dropdown,
                selector: selector,
                mode: this.state.mode
            }));
        }
    }]);

    return FileFieldrfpi;
}(_BaseFormItem3.default);

var ConnectedControl = function ConnectedControl(props) {
    var state = (0, _useFluxStore2.default)(function () {
        return {};
    }, [_FileUploadStore2.default], [props]);
    return _react2.default.createElement(_rfpi2.default, _extends({}, props, state));
};

FileFieldrfpi.propTypes = {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)())
};

exports.default = FileFieldrfpi;

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _RFPI = __webpack_require__(1358);

var _RFPI2 = _interopRequireDefault(_RFPI);

var _formhelpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rfpi = function (_React$Component) {
    _inherits(Rfpi, _React$Component);

    function Rfpi() {
        _classCallCheck(this, Rfpi);

        return _possibleConstructorReturn(this, (Rfpi.__proto__ || Object.getPrototypeOf(Rfpi)).apply(this, arguments));
    }

    _createClass(Rfpi, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                _ControlTemplate2.default,
                _extends({}, this.props, { className: "rfpi-file-field" }),
                _react2.default.createElement(_RFPI2.default, this.props)
            );
        }
    }]);

    return Rfpi;
}(_react2.default.Component);

exports.default = Rfpi;


Rfpi.propTypes = (0, _formhelpers.controlPropTypes)();

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _VideoPlayer = __webpack_require__(1359);

var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);

var _fileUploads = __webpack_require__(349);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO: add proptypes
var RFPI = function (_React$Component) {
    _inherits(RFPI, _React$Component);

    function RFPI() {
        _classCallCheck(this, RFPI);

        return _possibleConstructorReturn(this, (RFPI.__proto__ || Object.getPrototypeOf(RFPI)).apply(this, arguments));
    }

    _createClass(RFPI, [{
        key: "buildFile",
        value: function buildFile(f) {
            return _extends({}, f, {
                id: f.id,
                filename: f.filename,
                _status: Hybrid.FileInfo.FILEUPLOADSTATES.COMPLETE,
                progress: f._progress || 0,
                filesize: f.size,
                model: f
            });
        }
    }, {
        key: "buildVideoProps",
        value: function buildVideoProps(file) {
            if (file) {
                var sources = [{
                    src: (0, _fileUploads.buildFileUrl)(this.buildFile(file)),
                    type: file.contentType
                }];

                return {
                    controls: true,
                    loop: true,
                    height: 800,
                    width: 800,
                    sources: sources,
                    seekSize: 1 / 30
                };
            }

            return {};
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                imageFile = _props.imageFile,
                selectedComparisons = _props.selectedComparisons,
                dropdown = _props.dropdown,
                selector = _props.selector,
                mode = _props.mode;


            var videoProps = this.buildVideoProps(imageFile);

            var body = void 0;
            if (selectedComparisons) {
                // TODO: clean this up
                var comparisonVideoProps = [this.buildVideoProps(selectedComparisons[0]), this.buildVideoProps(selectedComparisons[1])];
                body = _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.createElement(_VideoPlayer2.default, comparisonVideoProps[0]),
                    _react2.default.createElement(_VideoPlayer2.default, comparisonVideoProps[1])
                );
            } else {
                body = _react2.default.createElement(_VideoPlayer2.default, videoProps);
            }

            switch (mode) {
                case "comparison":
                    return _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        selector,
                        dropdown,
                        _react2.default.createElement(
                            "div",
                            { className: "video-container" },
                            body
                        )
                    );
                case "individual":
                default:
                    return _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        selector,
                        _react2.default.createElement(
                            "div",
                            { className: "video-container" },
                            body
                        )
                    );
            }
        }
    }]);

    return RFPI;
}(_react2.default.Component);

exports.default = RFPI;

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _video = __webpack_require__(350);

var _video2 = _interopRequireDefault(_video);

__webpack_require__(1384);

var _LoopButton = __webpack_require__(1385);

var _LoopButton2 = _interopRequireDefault(_LoopButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VideoPlayer = function (_React$Component) {
    _inherits(VideoPlayer, _React$Component);

    function VideoPlayer() {
        _classCallCheck(this, VideoPlayer);

        return _possibleConstructorReturn(this, (VideoPlayer.__proto__ || Object.getPrototypeOf(VideoPlayer)).apply(this, arguments));
    }

    _createClass(VideoPlayer, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            this.player = (0, _video2.default)(this.videoNode, this.props);
            var _props = this.props,
                seekSize = _props.seekSize,
                loop = _props.loop;


            if (seekSize) {
                this.player.seekButtons({
                    forward: seekSize,
                    back: seekSize
                });
            }

            if (loop) {
                var loopButton = new _LoopButton2.default(this.player);
                this.player.controlBar.addChild(loopButton);
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            if (this.player) {
                this.player.dispose();
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var sources = this.props.sources;


            return _react2.default.createElement(
                "div",
                { className: "vjs-container" },
                _react2.default.createElement(
                    "div",
                    { "data-vjs-player": true },
                    _react2.default.createElement("video", {
                        src: sources ? sources[0].src : undefined,
                        ref: function ref(node) {
                            return _this2.videoNode = node;
                        },
                        className: "video-js" })
                )
            );
        }
    }]);

    return VideoPlayer;
}(_react2.default.Component);

exports.default = VideoPlayer;


VideoPlayer.propTypes = {
    sources: _propTypes2.default.array.isRequired,

    loop: _propTypes2.default.bool,
    seekSize: _propTypes2.default.number
};

/***/ }),
/* 1360 */,
/* 1361 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _video = __webpack_require__(350);

var _video2 = _interopRequireDefault(_video);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoopButton = function (_videojs$getComponent) {
    _inherits(LoopButton, _videojs$getComponent);

    function LoopButton(player) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, LoopButton);

        var _this = _possibleConstructorReturn(this, (LoopButton.__proto__ || Object.getPrototypeOf(LoopButton)).call(this, player, options));

        _this.addClass("vjs-loop-button");
        _this.addClass("vjs-looping-on");
        return _this;
    }

    _createClass(LoopButton, [{
        key: "handleClick",
        value: function handleClick(e) {
            if (this.player_.loop()) {
                this.removeClass("vjs-looping-on");
                this.addClass("vjs-looping-off");
            } else {
                this.removeClass("vjs-looping-off");
                this.addClass("vjs-looping-on");
            }

            this.player_.loop(!this.player_.loop());
        }
    }, {
        key: "createEl",
        value: function createEl() {
            var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "button";
            var props = arguments[1];
            var attributes = arguments[2];

            var el = _get(LoopButton.prototype.__proto__ || Object.getPrototypeOf(LoopButton.prototype), "createEl", this).call(this, tag, props, attributes);
            el.innerHTML = "LOOP";
            return el;
        }
    }]);

    return LoopButton;
}(_video2.default.getComponent("Button"));

exports.default = LoopButton;

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TimeFieldlabel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _label = __webpack_require__(471);

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TimeFieldlabel = exports.TimeFieldlabel = function (_BaseFormItem) {
    _inherits(TimeFieldlabel, _BaseFormItem);

    function TimeFieldlabel() {
        _classCallCheck(this, TimeFieldlabel);

        return _possibleConstructorReturn(this, (TimeFieldlabel.__proto__ || Object.getPrototypeOf(TimeFieldlabel)).apply(this, arguments));
    }

    _createClass(TimeFieldlabel, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor;

            return _react2.default.createElement(_label2.default, _extends({}, this.getPlumbingProps(), {
                value: activeRecord.get(descriptor.key),
                enabled: activeRecord.isFieldEnabled(descriptor.key)
            }));
        }
    }]);

    return TimeFieldlabel;
}(_BaseFormItem3.default);

exports.default = TimeFieldlabel;

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TimeFieldspinner = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _spinner = __webpack_require__(470);

var _spinner2 = _interopRequireDefault(_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TimeFieldspinner = exports.TimeFieldspinner = function (_BaseFormItem) {
    _inherits(TimeFieldspinner, _BaseFormItem);

    function TimeFieldspinner() {
        _classCallCheck(this, TimeFieldspinner);

        return _possibleConstructorReturn(this, (TimeFieldspinner.__proto__ || Object.getPrototypeOf(TimeFieldspinner)).apply(this, arguments));
    }

    _createClass(TimeFieldspinner, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor;

            return _react2.default.createElement(_spinner2.default, _extends({}, this.getPlumbingProps(), {
                value: activeRecord.get(descriptor.key),
                enabled: activeRecord.isFieldEnabled(descriptor.key)
            }));
        }
    }]);

    return TimeFieldspinner;
}(_BaseFormItem3.default);

exports.default = TimeFieldspinner;

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Widgetbutton = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _formhelpers = __webpack_require__(5);

var _button = __webpack_require__(301);

var _button2 = _interopRequireDefault(_button);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WidgetActions = __webpack_require__(614);

var _WidgetActions2 = _interopRequireDefault(_WidgetActions);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Widgetbutton = exports.Widgetbutton = function (_BaseFormItem) {
    _inherits(Widgetbutton, _BaseFormItem);

    function Widgetbutton(props) {
        _classCallCheck(this, Widgetbutton);

        var _this = _possibleConstructorReturn(this, (Widgetbutton.__proto__ || Object.getPrototypeOf(Widgetbutton)).call(this, props));

        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }

    _createClass(Widgetbutton, [{
        key: "onClick",
        value: function onClick(e, d, v) {
            var _props = this.props,
                fluxContext = _props.fluxContext,
                descriptor = _props.descriptor;

            _Dispatcher2.default.contextDispatch(fluxContext, {
                type: _WidgetActions2.default.WIDGET_CLICK,
                config: descriptor.config
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _props2 = this.props,
                activeRecord = _props2.activeRecord,
                descriptor = _props2.descriptor;

            return _react2.default.createElement(_button2.default, _extends({}, this.getPlumbingProps(), {
                onClick: this.onClick,
                onFocus: undefined,
                onBlur: undefined,
                enabled: !descriptor.boundTo || activeRecord.isFieldEnabled(descriptor.boundTo)
            }));
        }
    }]);

    return Widgetbutton;
}(_BaseFormItem3.default);

Widgetbutton.propTypes = _extends({}, Widgetbutton.propTypes, {
    fluxContext: _propTypes2.default.string.isRequired,
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)(null, false))
});

exports.default = Widgetbutton;

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Widgetlabel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _label = __webpack_require__(472);

var _label2 = _interopRequireDefault(_label);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formhelpers = __webpack_require__(5);

var _resolver = __webpack_require__(348);

var _label3 = __webpack_require__(300);

var _label4 = _interopRequireDefault(_label3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Widgetlabel = exports.Widgetlabel = function (_BaseFormItem) {
    _inherits(Widgetlabel, _BaseFormItem);

    function Widgetlabel() {
        _classCallCheck(this, Widgetlabel);

        return _possibleConstructorReturn(this, (Widgetlabel.__proto__ || Object.getPrototypeOf(Widgetlabel)).apply(this, arguments));
    }

    _createClass(Widgetlabel, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor;

            var config = descriptor.config;
            var enabled = !descriptor.boundTo || activeRecord.isFieldEnabled(descriptor.boundTo);
            if (config) {
                if (config.itemInfo) {
                    // use a full form item
                    var Label = (0, _resolver.resolver)(config.itemInfo);
                    var newDesc = _extends({}, descriptor, config.itemInfo);
                    return _react2.default.createElement(Label, _extends({}, this.props, {
                        descriptor: newDesc
                    }));
                }
                if (config.script) {
                    // just a control here...
                    var value = void 0;
                    try {
                        /* eslint-disable-next-line no-new-func */
                        value = Function("instance", config.script)(activeRecord);
                    } catch (e) {
                        console.warn("Error executing widget label script " + config.script, e);
                        value = "" + e;
                    }
                    return _react2.default.createElement(_label4.default, _extends({}, this.getPlumbingProps(), {
                        descriptor: _extends({}, descriptor, {
                            key: descriptor.label.toLowerCase().replace(/[^a-z0-9_]/g, "-")
                        }),
                        controlOnly: false,
                        value: value,
                        enabled: enabled
                    }));
                }
            }
            return _react2.default.createElement(_label2.default, _extends({}, this.getPlumbingProps(), {
                enabled: enabled
            }));
        }
    }]);

    return Widgetlabel;
}(_BaseFormItem3.default);

Widgetlabel.propTypes = _extends({}, Widgetlabel.propTypes, {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)(null, false))
});

exports.default = Widgetlabel;

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Widgettimestamp = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _label = __webpack_require__(295);

var _label2 = _interopRequireDefault(_label);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formhelpers = __webpack_require__(5);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Widgettimestamp = exports.Widgettimestamp = function (_BaseFormItem) {
    _inherits(Widgettimestamp, _BaseFormItem);

    function Widgettimestamp() {
        _classCallCheck(this, Widgettimestamp);

        return _possibleConstructorReturn(this, (Widgettimestamp.__proto__ || Object.getPrototypeOf(Widgettimestamp)).apply(this, arguments));
    }

    _createClass(Widgettimestamp, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor;

            var enabled = !_ClientId2.default.is(activeRecord.id);
            var value = null;
            if (enabled) {
                var meta = activeRecord.getMetadata();
                if (descriptor.key === "ao_created_at") {
                    value = meta.cts;
                } else if (descriptor.key === "ao_updated_at") {
                    value = meta.ts;
                }
            }
            return _react2.default.createElement(_label2.default, _extends({}, this.getPlumbingProps(), {
                value: value,
                enabled: enabled
            }));
        }
    }]);

    return Widgettimestamp;
}(_BaseFormItem3.default);

Widgettimestamp.propTypes = _extends({}, Widgettimestamp.propTypes, {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)(null, false))
});

exports.default = Widgettimestamp;

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Widgetvaluemutationbutton = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _formhelpers = __webpack_require__(5);

var _button = __webpack_require__(301);

var _button2 = _interopRequireDefault(_button);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Widgetvaluemutationbutton = exports.Widgetvaluemutationbutton = function (_BaseFormItem) {
    _inherits(Widgetvaluemutationbutton, _BaseFormItem);

    function Widgetvaluemutationbutton(props) {
        _classCallCheck(this, Widgetvaluemutationbutton);

        var _this = _possibleConstructorReturn(this, (Widgetvaluemutationbutton.__proto__ || Object.getPrototypeOf(Widgetvaluemutationbutton)).call(this, props));

        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }

    _createClass(Widgetvaluemutationbutton, [{
        key: "onClick",
        value: function onClick(e, d, v) {
            var _this2 = this;

            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor;

            var config = descriptor.config;
            var processField = function processField(record, fieldName) {
                var info = void 0;
                try {
                    info = _entityFieldMetaStore2.default.getInfo(record.entityKey, fieldName);
                } catch (e) {
                    if (e.message.indexOf(fieldName) < 0) throw e;
                    console.error("Value mutation button '" + descriptor.label + "': " + e.message);
                    return;
                }

                // We do not want to set a value on a disabled field.
                if (!record.isFieldEnabled(info)) return;

                var value = record.get(info);
                if (value == null) {
                    value = "MISSING";
                }

                if (value === config.expectedValue.toUpperCase()) {
                    _this2.doSetField(record, fieldName, config.newValue.toUpperCase());
                }
            };

            var processRecord = function processRecord(rec) {
                config.fieldNames.forEach(function (name) {
                    processField(rec, name);
                });
            };

            if (config.collectionFieldName) {
                var target = activeRecord.get(config.collectionFieldName);
                target.forEach(function (r) {
                    return processRecord(r);
                });
            } else {
                processRecord(activeRecord);
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _props2 = this.props,
                activeRecord = _props2.activeRecord,
                descriptor = _props2.descriptor;

            return _react2.default.createElement(_button2.default, _extends({}, this.getPlumbingProps(), {
                onClick: this.onClick,
                onFocus: undefined,
                onBlur: undefined,
                enabled: !descriptor.boundTo || activeRecord.isFieldEnabled(descriptor.boundTo)
            }));
        }
    }]);

    return Widgetvaluemutationbutton;
}(_BaseFormItem3.default);

Widgetvaluemutationbutton.propTypes = _extends({}, Widgetvaluemutationbutton.propTypes, {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)(null, false))
});

exports.default = Widgetvaluemutationbutton;

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Widgetmagicrootsummarysection = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Label = __webpack_require__(352);

var _Label2 = _interopRequireDefault(_Label);

var _formhelpers = __webpack_require__(5);

var _magicrootsummarysection = __webpack_require__(1393);

var _magicrootsummarysection2 = _interopRequireDefault(_magicrootsummarysection);

var _RecordGridDataGateway = __webpack_require__(250);

var _SuperRecordStore = __webpack_require__(36);

var _SuperRecordStore2 = _interopRequireDefault(_SuperRecordStore);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _RecordGrid = __webpack_require__(161);

var _NavigatorStore = __webpack_require__(33);

var _NavigatorStore2 = _interopRequireDefault(_NavigatorStore);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _superRecords = __webpack_require__(63);

var _InlineLoader = __webpack_require__(353);

var _InlineLoader2 = _interopRequireDefault(_InlineLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Widgetmagicrootsummarysection = exports.Widgetmagicrootsummarysection = function (_React$Component) {
    _inherits(Widgetmagicrootsummarysection, _React$Component);

    function Widgetmagicrootsummarysection() {
        _classCallCheck(this, Widgetmagicrootsummarysection);

        return _possibleConstructorReturn(this, (Widgetmagicrootsummarysection.__proto__ || Object.getPrototypeOf(Widgetmagicrootsummarysection)).apply(this, arguments));
    }

    _createClass(Widgetmagicrootsummarysection, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                controlOnly = _props.controlOnly,
                descriptor = _props.descriptor,
                fluxContext = _props.fluxContext,
                onFocus = _props.onFocus,
                onBlur = _props.onBlur,
                onKeyDown = _props.onKeyDown;

            var magicInfo = _NavigatorStore2.default.getMagicState(fluxContext);
            var sp = _TableStore2.default.getStereotypeProxy(magicInfo.key, magicInfo.id);
            var childInfo = _StereotypesStore2.default.getStereotypeByKey(sp.stereoInfo.magicChildKey);
            var srLO = _SuperRecordStore2.default.getRecordLO(sp.stereoKey, sp.id);
            if (!srLO.hasValue()) {
                return _react2.default.createElement(_InlineLoader2.default, null);
            }
            var srInfo = srLO.getRequiredValue();

            var ar = {
                entityKey: sp.stereoKey,
                id: sp.id,
                topLevelRecords: (0, _superRecords.getSuperRecordItems)((0, _superRecords.getTopLevelRecords)(_TableStore2.default, srInfo), childInfo)
            };

            var creatables = (0, _superRecords.getSuperRecordCreatables)(childInfo).map(function (it) {
                return (0, _RecordGridDataGateway.buildCreatable)(it.implKey, it.name, it.key);
            });

            var columns = [(0, _RecordGridDataGateway.buildColumn)({
                id: "title",
                content: function content(record) {
                    return _react2.default.createElement(_Label2.default, { value: record.getLabel() });
                },
                label: "",
                width: ""
            })];

            return _react2.default.createElement(_RecordGridDataGateway.MagicRecordGridDataGateway, {
                key: descriptor.key,
                component: _magicrootsummarysection2.default,
                controlOnly: controlOnly,
                activeRecord: ar,
                shortname: _superRecords.TOP_LEVEL_RECORDS_KEY,
                fluxContext: fluxContext,
                descriptor: descriptor,
                addMode: _RecordGrid.ADD_TOP,
                allowView: true,
                allowCreate: true,
                allowRemove: true,
                columns: columns,
                creatables: creatables,
                onFocus: onFocus,
                onBlur: onBlur,
                onKeyDown: onKeyDown
            });
        }
    }]);

    return Widgetmagicrootsummarysection;
}(_react2.default.Component);

Widgetmagicrootsummarysection.propTypes = {
    activeRecord: _propTypes2.default.object,
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)(null, false)),
    fluxContext: _propTypes2.default.string.isRequired,
    controlOnly: _propTypes2.default.bool,
    onFocus: _propTypes2.default.func.isRequired,
    onBlur: _propTypes2.default.func.isRequired,
    onKeyDown: _propTypes2.default.func.isRequired
};

exports.default = Widgetmagicrootsummarysection;

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formhelpers = __webpack_require__(5);

var _RecordGrid = __webpack_require__(161);

var _RecordGrid2 = _interopRequireDefault(_RecordGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MagicRootSummarySection = function (_React$Component) {
    _inherits(MagicRootSummarySection, _React$Component);

    function MagicRootSummarySection() {
        _classCallCheck(this, MagicRootSummarySection);

        return _possibleConstructorReturn(this, (MagicRootSummarySection.__proto__ || Object.getPrototypeOf(MagicRootSummarySection)).apply(this, arguments));
    }

    _createClass(MagicRootSummarySection, [{
        key: "render",
        value: function render() {
            var descriptor = this.props.descriptor;

            return _react2.default.createElement(
                "div",
                { className: "form-item full-width" },
                _react2.default.createElement(
                    "div",
                    {
                        id: descriptor.id,
                        className: "control-container-" + descriptor.control + " control-widget-" + descriptor.key + " magicrootsummarysection",
                        "data-widget-type": descriptor.control,
                        "data-widget-label": descriptor.label
                    },
                    _react2.default.createElement(_RecordGrid2.default, this.props)
                )
            );
        }
    }]);

    return MagicRootSummarySection;
}(_react2.default.Component);

exports.default = MagicRootSummarySection;


MagicRootSummarySection.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)(null, false), {
    onCommitChange: _propTypes2.default.func

});

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(51);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderCell = function HeaderCell(props) {
    var column = props.column,
        onClick = props.onClick;

    return _react2.default.createElement(
        "th",
        {
            onClick: onClick,
            width: column.width,
            className: (0, _classnames2.default)({
                "align-center": column.align === "center"
            })
        },
        column.label
    );
};

HeaderCell.propTypes = {
    column: _propTypes2.default.shape({
        label: _propTypes2.default.any,
        width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        align: _propTypes2.default.string
    }),
    onClick: _propTypes2.default.func
};

exports.default = HeaderCell;

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(51);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HybridCell = function HybridCell(props) {
    var column = props.column,
        record = props.record,
        onDoubleClick = props.onDoubleClick;

    return _react2.default.createElement(
        "td",
        {
            "data-id": column.entityContext ? column.id : record.id,
            "data-entity-key": column.entityContext || record.entityKey,
            className: (0, _classnames2.default)("entity-context", {
                "align-center": column.align === "center"
            }),
            onDoubleClick: onDoubleClick,
            width: column.width
        },
        _react2.default.createElement(
            "div",
            { className: "form-item" },
            column.content(record)
        )
    );
};

HybridCell.propTypes = {
    record: _propTypes2.default.object,
    column: _propTypes2.default.shape({
        label: _propTypes2.default.any,
        width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
        align: _propTypes2.default.string
    }),
    onDoubleClick: _propTypes2.default.func
};

exports.default = HybridCell;

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CompositionFieldsummarysection = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _formhelpers = __webpack_require__(5);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RecordGridDataGateway = __webpack_require__(250);

var _RecordGridDataGateway2 = _interopRequireDefault(_RecordGridDataGateway);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _summarysection = __webpack_require__(1397);

var _summarysection2 = _interopRequireDefault(_summarysection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // for now ignore the bad practice of using eval.
/*eslint no-new-func: 0*/


var CompositionFieldsummarysection = exports.CompositionFieldsummarysection = function (_React$Component) {
    _inherits(CompositionFieldsummarysection, _React$Component);

    function CompositionFieldsummarysection() {
        _classCallCheck(this, CompositionFieldsummarysection);

        return _possibleConstructorReturn(this, (CompositionFieldsummarysection.__proto__ || Object.getPrototypeOf(CompositionFieldsummarysection)).apply(this, arguments));
    }

    _createClass(CompositionFieldsummarysection, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                controlOnly = _props.controlOnly,
                descriptor = _props.descriptor,
                fluxContext = _props.fluxContext,
                activeRecord = _props.activeRecord,
                onFocus = _props.onFocus,
                onBlur = _props.onBlur,
                onKeyDown = _props.onKeyDown;

            var config = descriptor.config || {};
            var creatables = [];
            if (!config.autoManaged) {
                for (var i = 0, l = config.creatables.length; i < l; i++) {
                    var creatable = config.creatables[i];
                    var ei = _entityMetaStore2.default.getInfo(creatable.key);
                    creatables.push((0, _RecordGridDataGateway.buildCreatable)(ei.implKey, creatable.name, creatable.key, creatable.collectionKey, activeRecord));
                }
            }

            var columns = (0, _RecordGridDataGateway.buildColumnsFromConfig)(config.columns, this.props);

            return _react2.default.createElement(_RecordGridDataGateway2.default, {
                key: descriptor.key,
                enabled: activeRecord.isFieldEnabled(descriptor.key),
                component: _summarysection2.default,
                controlOnly: controlOnly,
                activeRecord: activeRecord,
                shortname: descriptor.key,
                singularLabel: config.otherEntityName,
                fluxContext: fluxContext,
                descriptor: descriptor,
                addMode: config.addMode,
                allowView: !config.inline,
                allowCreate: true,
                allowRemove: !config.autoManaged,
                columns: columns,
                creatables: creatables,
                onFocus: onFocus,
                onBlur: onBlur,
                onKeyDown: onKeyDown
            });
        }
    }]);

    return CompositionFieldsummarysection;
}(_react2.default.Component);

CompositionFieldsummarysection.propTypes = {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)({
        inline: _propTypes2.default.bool,
        autoManaged: _propTypes2.default.bool,
        otherEntityName: _propTypes2.default.string.isRequired,
        addMode: _propTypes2.default.string.isRequired,
        columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            heading: _propTypes2.default.string.isRequired,
            width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
            type: _propTypes2.default.string.isRequired,
            script: _propTypes2.default.string,
            itemInfo: _propTypes2.default.object
        })).isRequired,
        creatables: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            name: _propTypes2.default.string.isRequired,
            key: _propTypes2.default.string.isRequired,
            collectionKey: _propTypes2.default.string.isRequired
        })) // required, except if auto-managed
    })),
    fluxContext: _propTypes2.default.string.isRequired,
    activeRecord: _propTypes2.default.instanceOf(_EntityProxy2.default).isRequired,
    controlOnly: _propTypes2.default.bool,
    onFocus: _propTypes2.default.func.isRequired,
    onBlur: _propTypes2.default.func.isRequired,
    onKeyDown: _propTypes2.default.func.isRequired
};

exports.default = CompositionFieldsummarysection;

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formhelpers = __webpack_require__(5);

var _RecordGrid = __webpack_require__(161);

var _RecordGrid2 = _interopRequireDefault(_RecordGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Summarysection = function (_React$Component) {
    _inherits(Summarysection, _React$Component);

    function Summarysection() {
        _classCallCheck(this, Summarysection);

        return _possibleConstructorReturn(this, (Summarysection.__proto__ || Object.getPrototypeOf(Summarysection)).apply(this, arguments));
    }

    _createClass(Summarysection, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                descriptor = _props.descriptor,
                enabled = _props.enabled;


            if (descriptor.disableBehaviour === "hide" && !enabled) {
                return null;
            }

            return _react2.default.createElement(
                "div",
                { className: "form-item full-width" },
                _react2.default.createElement(
                    "div",
                    {
                        id: descriptor.id,
                        className: "control-container-" + descriptor.key + " composition-field full-width react-control",
                        "data-control-type": descriptor.control,
                        "data-shortname": descriptor.key
                    },
                    _react2.default.createElement(_RecordGrid2.default, this.props)
                )
            );
        }
    }]);

    return Summarysection;
}(_react2.default.Component);

exports.default = Summarysection;


Summarysection.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)(null, false), {
    onCommitChange: _propTypes2.default.func

});

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CompositionFielddevicelesiongrid = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _formhelpers = __webpack_require__(5);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RecordGridDataGateway = __webpack_require__(250);

var _RecordGridDataGateway2 = _interopRequireDefault(_RecordGridDataGateway);

var _RecordActions = __webpack_require__(60);

var _RecordActions2 = _interopRequireDefault(_RecordActions);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _devicelesiongrid = __webpack_require__(1399);

var _devicelesiongrid2 = _interopRequireDefault(_devicelesiongrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * DeviceLesionGrid composition field component with enablement tracking.
 * 
 * This component tracks enablement state changes to handle the scenario where
 * a parent field's EnableScript dynamically disables the grid. Since React's
 * shallow comparison doesn't detect changes within the same EntityProxy reference,
 * we explicitly track the enabled state and clear grid items when transitioning
 * from enabled to disabled.
 * 
 * @see HJC-661 - Correct issue with devicelesiongrid enablement
 */
var CompositionFielddevicelesiongrid = exports.CompositionFielddevicelesiongrid = function (_React$Component) {
    _inherits(CompositionFielddevicelesiongrid, _React$Component);

    /**
     * Tracks enablement state to detect when the field's EnableScript result changes.
     * Since activeRecord is the same EntityProxy instance across renders, React's
     * shallow comparison won't detect enablement changes. We must explicitly track
     * the computed enabled state in component state.
     * 
     * @param {Object} props - Component props
     * @see HJC-661 - Fix for devicelesiongrid enablement tracking
     */
    function CompositionFielddevicelesiongrid(props) {
        _classCallCheck(this, CompositionFielddevicelesiongrid);

        var _this = _possibleConstructorReturn(this, (CompositionFielddevicelesiongrid.__proto__ || Object.getPrototypeOf(CompositionFielddevicelesiongrid)).call(this, props));

        _this.state = {
            wasEnabled: _this.isEnabled(props)
        };
        _this.clearGridItems = _this.clearGridItems.bind(_this);
        return _this;
    }

    /**
     * Computes the current enabled state by calling activeRecord.isFieldEnabled().
     * This evaluates the EnableScript and returns the current enabled state.
     * 
     * @param {Object} props - Component props (defaults to this.props)
     * @returns {boolean} True if field is enabled, false otherwise
     */


    _createClass(CompositionFielddevicelesiongrid, [{
        key: "isEnabled",
        value: function isEnabled() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
            var activeRecord = props.activeRecord,
                descriptor = props.descriptor;

            return activeRecord.isFieldEnabled(descriptor.key);
        }

        /**
         * Detects enablement state changes and clears grid when transitioning to disabled.
         * This ensures the UI reflects the business logic: when a field becomes disabled,
         * its value should be cleared (empty device list).
         * 
         * @param {Object} prevProps - Previous component props
         */

    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            var currentlyEnabled = this.isEnabled();
            var wasEnabled = this.state.wasEnabled;

            // Detect enablement state change

            if (wasEnabled !== currentlyEnabled) {
                this.setState({ wasEnabled: currentlyEnabled });

                // If transitioning from enabled to disabled, clear the grid.
                // Pass prevProps.activeRecord so clearGridItems can read records that existed
                // BEFORE the TableStore enablement system cleared the composition collection.
                if (!currentlyEnabled && wasEnabled) {
                    this.clearGridItems(prevProps.activeRecord);
                }
            }
        }

        /**
         * Clears all grid items by dispatching DELETE_CHILD actions.
         *
         * The TableStore enablement system automatically clears the composition collection
         * when the field becomes disabled, before React's componentDidUpdate fires.
         * We read records from prevActiveRecord (the pre-disable state) to know what to delete.
         *
         * @param {EntityProxy} prevActiveRecord - activeRecord from prevProps, holds old record list
         */

    }, {
        key: "clearGridItems",
        value: function clearGridItems(prevActiveRecord) {
            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor,
                fluxContext = _props.fluxContext;

            var config = descriptor.config;

            // Defensive check for config
            if (!config || !config.rowSourceEntityFieldKey) {
                console.warn("devicelesiongrid: missing config for grid clearing");
                return;
            }

            // Read from prevActiveRecord — current state was already cleared by enablement system
            var prevRecord = prevActiveRecord || activeRecord;
            var records = prevRecord.get(config.rowSourceEntityFieldKey) || [];

            // Dispatch DELETE_CHILD action for each record to maintain data integrity
            records.forEach(function (childRecord) {
                _Dispatcher2.default.contextDispatch(fluxContext, _defineProperty({
                    type: _RecordActions2.default.DELETE_CHILD,
                    recordKey: activeRecord.entityKey,
                    recordId: activeRecord.id,
                    fieldKey: config.rowSourceEntityFieldKey,
                    childKey: childRecord.entityKey,
                    childId: childRecord.id
                }, _RecordActions.OPT_USER_CONFIRMED, true));
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _props2 = this.props,
                descriptor = _props2.descriptor,
                fluxContext = _props2.fluxContext,
                activeRecord = _props2.activeRecord,
                onFocus = _props2.onFocus,
                onBlur = _props2.onBlur,
                onKeyDown = _props2.onKeyDown;

            var config = descriptor.config;

            var creatables = [];
            for (var i = 0, l = config.creatables.length; i < l; i++) {
                var creatable = config.creatables[i];
                var ei = _entityMetaStore2.default.getInfo(creatable.key);
                creatables.push((0, _RecordGridDataGateway.buildCreatable)(ei.implKey, creatable.name, creatable.key, creatable.collectionKey, activeRecord));
            }

            var columns = (0, _RecordGridDataGateway.buildColumnsFromConfig)(config.columns, this.props).concat((0, _RecordGridDataGateway.buildDevicelesiongridCheckboxColumns)(this.props, null));
            return _react2.default.createElement(_RecordGridDataGateway2.default, {
                key: descriptor.key,
                enabled: activeRecord.isFieldEnabled(descriptor.key),
                component: _devicelesiongrid2.default,
                activeRecord: activeRecord,
                shortname: config.rowSourceEntityFieldKey,
                singularLabel: config.otherEntityName,
                fluxContext: fluxContext,
                descriptor: descriptor,
                addMode: config.addMode,
                allowView: !config.inline,
                allowCreate: true,
                allowRemove: true,
                columns: columns,
                creatables: creatables,
                onFocus: onFocus,
                onBlur: onBlur,
                onKeyDown: onKeyDown
            });
        }
    }]);

    return CompositionFielddevicelesiongrid;
}(_react2.default.Component);

CompositionFielddevicelesiongrid.propTypes = {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)({
        inline: _propTypes2.default.bool,
        otherEntityName: _propTypes2.default.string.isRequired,
        rowSourceEntityFieldKey: _propTypes2.default.string.isRequired,
        rowSourceEntityCollectionKey: _propTypes2.default.string.isRequired,
        addMode: _propTypes2.default.string.isRequired,
        columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            heading: _propTypes2.default.string.isRequired,
            width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
            type: _propTypes2.default.string.isRequired,
            script: _propTypes2.default.string,
            itemInfo: _propTypes2.default.object
        })).isRequired,
        creatables: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            name: _propTypes2.default.string.isRequired,
            key: _propTypes2.default.string.isRequired,
            collectionKey: _propTypes2.default.string.isRequired
        })).isRequired
    })),
    fluxContext: _propTypes2.default.string.isRequired,
    activeRecord: _propTypes2.default.instanceOf(_EntityProxy2.default).isRequired,
    onFocus: _propTypes2.default.func.isRequired,
    onBlur: _propTypes2.default.func.isRequired,
    onKeyDown: _propTypes2.default.func.isRequired
};

exports.default = CompositionFielddevicelesiongrid;

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formhelpers = __webpack_require__(5);

var _RecordGrid = __webpack_require__(161);

var _RecordGrid2 = _interopRequireDefault(_RecordGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Devicelesiongrid = function (_React$Component) {
    _inherits(Devicelesiongrid, _React$Component);

    function Devicelesiongrid() {
        _classCallCheck(this, Devicelesiongrid);

        return _possibleConstructorReturn(this, (Devicelesiongrid.__proto__ || Object.getPrototypeOf(Devicelesiongrid)).apply(this, arguments));
    }

    _createClass(Devicelesiongrid, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                descriptor = _props.descriptor,
                enabled = _props.enabled;


            if (descriptor.disableBehaviour === "hide" && !enabled) {
                return null;
            }

            return _react2.default.createElement(
                "div",
                { className: "form-item full-width" },
                _react2.default.createElement(
                    "div",
                    {
                        id: descriptor.id,
                        className: "control-container-" + descriptor.key + " composition-field full-width react-control",
                        "data-control-type": descriptor.control,
                        "data-shortname": descriptor.key
                    },
                    _react2.default.createElement(_RecordGrid2.default, this.props)
                )
            );
        }
    }]);

    return Devicelesiongrid;
}(_react2.default.Component);

exports.default = Devicelesiongrid;


Devicelesiongrid.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)(null, false), {
    onCommitChange: _propTypes2.default.func

});

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AssociationFieldrecordbrowser = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _formhelpers = __webpack_require__(5);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _entityFields = __webpack_require__(158);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _recordbrowser = __webpack_require__(444);

var _recordbrowser2 = _interopRequireDefault(_recordbrowser);

var _SuperRecordListStore = __webpack_require__(155);

var _SuperRecordListStore2 = _interopRequireDefault(_SuperRecordListStore);

var _SuperRecordListActions = __webpack_require__(140);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

var _typedefs = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssociationFieldrecordbrowser = exports.AssociationFieldrecordbrowser = function (_BaseFormItem) {
    _inherits(AssociationFieldrecordbrowser, _BaseFormItem);

    function AssociationFieldrecordbrowser() {
        var _ref;

        _classCallCheck(this, AssociationFieldrecordbrowser);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = AssociationFieldrecordbrowser.__proto__ || Object.getPrototypeOf(AssociationFieldrecordbrowser)).call.apply(_ref, [this].concat(args)));

        _this.buildOptions = _this.buildOptions.bind(_this);
        _this.onRecordbrowserClick = _this.onRecordbrowserClick.bind(_this);
        return _this;
    }

    _createClass(AssociationFieldrecordbrowser, [{
        key: "getCandidateFilter",
        value: function getCandidateFilter() {
            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor;

            return (0, _entityFields.getCandidateFilter)(_entityFieldMetaStore2.default.getInfo(activeRecord.entityKey, descriptor.key), activeRecord);
        }
    }, {
        key: "buildOptions",
        value: function buildOptions(currId, allRecords, enabled) {
            var _this2 = this;

            var descriptor = this.props.descriptor;

            var options = [];
            var candidateFilter = this.getCandidateFilter();
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = allRecords[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var record = _step.value;

                    // unwrap and check candidacy
                    if (record.id === currId || record.isRecordEnabled()) {
                        if (record.id === currId || candidateFilter(record)) {
                            options.push({
                                name: record.id,
                                display: record.getLabel(),
                                record: record
                            });
                        }
                    }
                }

                // autoSelectOnlyOption only option. Only when the field is enabled.
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (enabled && descriptor.config.autoSelectOnlyOption && options.length === 1 && currId === null) {
                // Because this may be invoked during component construction, it
                // can't do a synchronous dispatch without violating React's rules
                // about state changes. At least for the moment. Once we don't have
                // all the synchronous backbone-based flows, it can probably vanish.
                //
                // eslint-disable-next-line no-settimeout
                setTimeout(function () {
                    return _this2.onCommitChange(descriptor, options[0].record.id);
                });
            }
            return options;
        }
    }, {
        key: "onRecordbrowserClick",
        value: function onRecordbrowserClick(e) {
            var _props2 = this.props,
                onGlobalRecordLookup = _props2.onGlobalRecordLookup,
                descriptor = _props2.descriptor;

            e.stopPropagation();
            onGlobalRecordLookup(descriptor.config.otherEntityKey, descriptor.key, this.getCandidateFilter());
        }
    }, {
        key: "onCommitChange",
        value: function onCommitChange(d, v) {
            _get(AssociationFieldrecordbrowser.prototype.__proto__ || Object.getPrototypeOf(AssociationFieldrecordbrowser.prototype), "onCommitChange", this).call(this, d, v === null ? null : parseInt(v));
        }
    }, {
        key: "render",
        value: function render() {
            var _props3 = this.props,
                activeRecord = _props3.activeRecord,
                descriptor = _props3.descriptor;

            var value = activeRecord.get(descriptor.key);
            var id = value == null ? null : value.id;
            return _react2.default.createElement(ConnCtrl, _extends({}, this.getPlumbingProps(), {
                valueKey: "name",
                labelKey: "display",
                isLoading: true,
                onRecordbrowserClick: this.onRecordbrowserClick,
                value: id,
                enabled: activeRecord.isFieldEnabled(descriptor.key)
                // for the data connection
                , otherEntityKey: descriptor.config.otherEntityKey,
                builder: this.buildOptions
            }));
        }
    }]);

    return AssociationFieldrecordbrowser;
}(_BaseFormItem3.default);

var ConnCtrl = function ConnCtrl(props) {
    var otherEntityKey = props.otherEntityKey,
        value = props.value,
        builder = props.builder,
        enabled = props.enabled;

    var state = (0, _useFluxStore2.default)(function () {
        var lo = (0, _SuperRecordListActions.getSuperRecordListRecords)(otherEntityKey);
        return {
            isLoading: lo.isLoading(),
            isError: lo.hasError(),
            allRecords: lo.hasValue() ? lo.getValue() || [] : []
        };
    }, [_SuperRecordListStore2.default], [otherEntityKey]);
    return _react2.default.createElement(_recordbrowser2.default, _extends({}, props, state, {
        options: builder(value, state.allRecords, enabled)
    }));
};

ConnCtrl.propTypes = {
    otherEntityKey: _propTypes2.default.string.isRequired,
    enabled: _propTypes2.default.bool,
    value: _typedefs.recordIdType,
    builder: _propTypes2.default.func.isRequired
};

AssociationFieldrecordbrowser.propTypes = _extends({}, AssociationFieldrecordbrowser.propTypes, {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)({
        otherEntityKey: _propTypes2.default.string.isRequired,
        autoSelectOnlyOption: _propTypes2.default.bool,
        showRecordBrowserIcon: _propTypes2.default.bool
    }))
});

exports.default = AssociationFieldrecordbrowser;

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AssociationFieldlabel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _label = __webpack_require__(442);

var _label2 = _interopRequireDefault(_label);

var _asArray = __webpack_require__(157);

var _asArray2 = _interopRequireDefault(_asArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssociationFieldlabel = exports.AssociationFieldlabel = function (_BaseFormItem) {
    _inherits(AssociationFieldlabel, _BaseFormItem);

    function AssociationFieldlabel() {
        _classCallCheck(this, AssociationFieldlabel);

        return _possibleConstructorReturn(this, (AssociationFieldlabel.__proto__ || Object.getPrototypeOf(AssociationFieldlabel)).apply(this, arguments));
    }

    _createClass(AssociationFieldlabel, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor;


            var value = (0, _asArray2.default)(activeRecord.get(descriptor.key)).map(function (v) {
                return v.getLabel();
            }).join(", ");

            return _react2.default.createElement(_label2.default, _extends({}, this.getPlumbingProps(), {
                value: value,
                enabled: activeRecord.isFieldEnabled(descriptor.key)
            }));
        }
    }]);

    return AssociationFieldlabel;
}(_BaseFormItem3.default);

exports.default = AssociationFieldlabel;

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AssociationFieldtypeahead = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _formhelpers = __webpack_require__(5);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SuperRecordActions = __webpack_require__(25);

var _entityFields = __webpack_require__(158);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _typeahead = __webpack_require__(445);

var _typeahead2 = _interopRequireDefault(_typeahead);

var _pathWalker = __webpack_require__(1403);

var _pathWalker2 = _interopRequireDefault(_pathWalker);

var _SearchResultStore = __webpack_require__(159);

var _SearchResultStore2 = _interopRequireDefault(_SearchResultStore);

var _SuperRecordListStore = __webpack_require__(155);

var _SuperRecordListStore2 = _interopRequireDefault(_SuperRecordListStore);

var _SuperRecordListActions = __webpack_require__(140);

var _SuperRecordStore = __webpack_require__(36);

var _SuperRecordStore2 = _interopRequireDefault(_SuperRecordStore);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var buildConfig = function buildConfig(descriptor) {
    var baseConfig = {
        searchPageSize: 20,
        searchDebounce: 250,
        valueKey: "id",
        labelKey: "_displayString",
        isServer: false,
        mode: "client",
        multiValued: false
    };
    var config = _extends({}, baseConfig, descriptor.config) || baseConfig;
    config.columns = config.columns || [{ key: config.valueKey, label: config.labelKey }];
    config.isServer = config.mode === "server" && config.otherEntityKey != null;
    return config;
};

var getConnectedCtrl = function getConnectedCtrl(config) {
    // choose which DataGateway to use.
    var withData = config.isServer ? withServerDataGateway : config.otherEntityType === "RECORD" ? withSourceCollectionDataGateway : OtherEntityRecordsDataGateway;
    return withData(function (props) {
        var value = props.value,
            allRecords = props.allRecords,
            builder = props.builder,
            enabled = props.enabled;
        // convert allRecords into options prop

        return _react2.default.createElement(_typeahead2.default, _extends({}, props, {
            options: builder(value, allRecords, enabled)
        }));
    });
};

var AssociationFieldtypeahead = exports.AssociationFieldtypeahead = function (_BaseFormItem) {
    _inherits(AssociationFieldtypeahead, _BaseFormItem);

    function AssociationFieldtypeahead() {
        var _ref;

        _classCallCheck(this, AssociationFieldtypeahead);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        // descriptor is static, so this is safe.
        var _this = _possibleConstructorReturn(this, (_ref = AssociationFieldtypeahead.__proto__ || Object.getPrototypeOf(AssociationFieldtypeahead)).call.apply(_ref, [this].concat(args)));

        _this.config = buildConfig(_this.props.descriptor);
        _this.buildOptions = _this.buildOptions.bind(_this);
        _this.onRecordbrowserClick = _this.onRecordbrowserClick.bind(_this);
        _this.serverSearch = _this.serverSearch.bind(_this);

        //
        _this.control = getConnectedCtrl(_this.config);
        return _this;
    }

    _createClass(AssociationFieldtypeahead, [{
        key: "getCandidateFilter",
        value: function getCandidateFilter() {
            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor;

            return (0, _entityFields.getCandidateFilter)(_entityFieldMetaStore2.default.getInfo(activeRecord.entityKey, descriptor.key), activeRecord);
        }
    }, {
        key: "getPartialCandidateFilter",
        value: function getPartialCandidateFilter() {
            var _props2 = this.props,
                activeRecord = _props2.activeRecord,
                descriptor = _props2.descriptor;

            return (0, _entityFields.getPartialCandidateFilter)(_entityFieldMetaStore2.default.getInfo(activeRecord.entityKey, descriptor.key), activeRecord);
        }
    }, {
        key: "onRecordbrowserClick",
        value: function onRecordbrowserClick(e) {
            var _props3 = this.props,
                onGlobalRecordLookup = _props3.onGlobalRecordLookup,
                descriptor = _props3.descriptor;

            e.stopPropagation();
            onGlobalRecordLookup(descriptor.config.otherEntityKey, descriptor.key, this.getCandidateFilter());
        }
    }, {
        key: "onCommitChange",
        value: function onCommitChange(d, v) {
            var userInvoked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
            var label = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            var config = this.config;

            if (config.multiValued) {
                if (Array.isArray(v)) {
                    v = v.map(function (it) {
                        return it[config.valueKey];
                    });
                } else {
                    v = null;
                }
            } else {
                v = v === null ? null : v[config.valueKey];
            }
            _get(AssociationFieldtypeahead.prototype.__proto__ || Object.getPrototypeOf(AssociationFieldtypeahead.prototype), "onCommitChange", this).call(this, d, v, userInvoked, label);
        }
    }, {
        key: "buildOptions",
        value: function buildOptions(currValue, allRecords, enabled) {
            var _this2 = this;

            var descriptor = this.props.descriptor;
            var config = this.config;

            var candidateFilter = this.getCandidateFilter();
            var filteredOptions = [];
            var keys = _.pluck(config.columns, "key").filter(function (it) {
                return it !== "id";
            });
            var vals = currValue ? Array.isArray(currValue) ? currValue : [currValue] : [];

            var buildOptionFromRecord = function buildOptionFromRecord(record) {
                var o = {
                    record: record // this provides quicker lookup on the onCommitChange side.
                };
                _.each(keys, function (key) {
                    return o[key] = (record.get(key) || "").toString();
                });
                o[config.valueKey] = record.id;
                o[config.labelKey] = record.getLabel();
                return o;
            };

            allRecords.forEach(function (record) {
                var o = buildOptionFromRecord(record);
                // include selected value in the list even if it was filtered out.
                var hasValue = vals.map(function (i) {
                    return i.record.id;
                }).includes(record.id);
                if (hasValue || record.isRecordEnabled() && candidateFilter(record)) {
                    filteredOptions.push(o);
                }
            });

            if (config.isServer && !config.multiValued && currValue) {
                // for server requests we need to add back the selected value if
                // it does not exist in the returned list.
                vals.forEach(function (v) {
                    if (filteredOptions.find(function (o) {
                        return o[config.valueKey] === v[config.valueKey];
                    })) {
                        // selected value already in list
                        return;
                    }
                    var o = buildOptionFromRecord(v.record);
                    filteredOptions.unshift(o);
                });
            }
            // autoSelectOnlyOption only option. Only when the field is enabled.
            if (enabled && config.autoSelectOnlyOption && filteredOptions.length === 1 && currValue === null) {

                // Because this may be invoked during component construction, it
                // can't do a synchonous dispatch without violating React's rules
                // about state changes. At least for the moment. Once we don't have
                // all the synchronous backbone-based flows, it can probably vanish.
                //
                // eslint-disable-next-line no-settimeout
                setTimeout(function () {
                    return _this2.onCommitChange(descriptor, filteredOptions[0]);
                });
            }

            // also make sure the selected value labels are up to date.
            return filteredOptions;
        }
    }, {
        key: "serverSearch",


        // builds query for clientFilteredSearch, invokes it, and returns the LO
        value: function serverSearch(query, candidateFilter, partialCandidateFilter) {
            var sort = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var config = this.config;

            var otherEntityKey = config.otherEntityKey;
            var columns = config.columns;
            var filters = [];
            if (query) {
                columns.forEach(function (c) {
                    if (c.includeInFilter == null || c.includeInFilter) {
                        return filters.push(c.key + ".toString().toLowerCase().contains(\"" + query.toLowerCase() + "\")");
                    }
                });
            }
            var orderer = "";
            if (sort.key) {
                orderer = sort.key + " " + sort.dir;
            }
            if (partialCandidateFilter != null) {
                // server side filtering
                if (filters.length > 0) {
                    filters = "(" + filters.join("||") + ")" + (partialCandidateFilter ? "&&(" + partialCandidateFilter + ")" : "");
                } else {
                    filters = partialCandidateFilter || "true";
                }
                return (0, _SuperRecordActions.serverFilteredSearch)(_SearchResultStore2.default, otherEntityKey, filters, orderer, config.searchPageSize + 1, // size
                1, // page
                false, // showLoadingModal
                true // onlyEnabledRecords
                );
            } else {
                // client side filtering
                if (filters.length > 0) {
                    filters = filters.join("||");
                } else {
                    filters = "true";
                }
                return (0, _SuperRecordActions.clientFilteredSearch)(_SearchResultStore2.default, otherEntityKey, filters, orderer, config.searchPageSize + 1, function (r) {
                    return r.isRecordEnabled() && candidateFilter(r);
                }, false // showLoadingModal
                );
            }
        }
    }, {
        key: "buildValue",
        value: function buildValue(v) {
            var config = this.config;

            var buildValue = function buildValue(r) {
                var _ref2;

                return _ref2 = {}, _defineProperty(_ref2, config.valueKey, r.id), _defineProperty(_ref2, config.labelKey, r.getLabel()), _defineProperty(_ref2, "record", r), _ref2;
            };

            var value = null;
            if (v != null) {
                if (config.multiValued) {
                    value = v.map(function (r) {
                        return buildValue(r);
                    });
                } else {
                    value = buildValue(v);
                }
            }
            return value;
        }
    }, {
        key: "render",
        value: function render() {
            var _props4 = this.props,
                activeRecord = _props4.activeRecord,
                descriptor = _props4.descriptor,
                fluxContext = _props4.fluxContext;
            var config = this.config;

            var ConnectedCtrl = this.control;
            return _react2.default.createElement(ConnectedCtrl, _extends({}, this.getPlumbingProps(), {
                enabled: activeRecord.isFieldEnabled(descriptor.key),
                valueKey: config.valueKey,
                labelKey: config.labelKey,
                value: this.buildValue(activeRecord.get(descriptor.key)),
                isLoading: true,
                isPartial: false,
                isError: false,
                onRecordbrowserClick: this.onRecordbrowserClick

                // for the data connection
                , isServer: config.isServer,
                otherEntityKey: config.otherEntityKey,
                activeRecord: activeRecord,
                fluxContext: fluxContext,
                builder: this.buildOptions,
                serverSearch: this.serverSearch,
                candidateFilter: this.getCandidateFilter(),
                partialCandidateFilter: this.getPartialCandidateFilter(),
                searchPageSize: config.searchPageSize
            }));
        }
    }]);

    return AssociationFieldtypeahead;
}(_BaseFormItem3.default);

var withServerDataGateway = function withServerDataGateway(WrappedComponent) {
    var WithSearchResults = function WithSearchResults(props) {
        var serverSearch = props.serverSearch,
            candidateFilter = props.candidateFilter,
            partialCandidateFilter = props.partialCandidateFilter,
            text = props.text,
            sort = props.sort,
            searchPageSize = props.searchPageSize;

        var state = (0, _useFluxStore2.default)(function () {
            var lo = serverSearch(text, candidateFilter, partialCandidateFilter, sort);
            var allRecords = [];
            if (lo.hasValue()) {
                var eps = lo.getRequiredValue();
                var mv = Array.isArray(eps);
                allRecords = mv ? eps : [eps];
            }

            return {
                isLoading: lo.isLoading(),
                isError: lo.hasError(),
                allRecords: allRecords,
                isPartial: allRecords.length > searchPageSize
            };
        }, [_SuperRecordStore2.default, _SearchResultStore2.default], [serverSearch, candidateFilter, text, sort, searchPageSize]);
        var newProps = _extends({}, props);
        delete newProps.activeRecord;
        return _react2.default.createElement(WrappedComponent, _extends({}, newProps, state));
    };

    WithSearchResults.propTypes = {
        serverSearch: _propTypes2.default.func.isRequired,
        candidateFilter: _propTypes2.default.func.isRequired,
        partialCandidateFilter: _propTypes2.default.string,
        text: _propTypes2.default.string.isRequired,
        sort: _propTypes2.default.object,
        searchPageSize: _propTypes2.default.number.isRequired
    };

    var ServerDataGateway = function (_React$PureComponent) {
        _inherits(ServerDataGateway, _React$PureComponent);

        function ServerDataGateway(props) {
            _classCallCheck(this, ServerDataGateway);

            var _this3 = _possibleConstructorReturn(this, (ServerDataGateway.__proto__ || Object.getPrototypeOf(ServerDataGateway)).apply(this, arguments));

            _this3.state = {
                text: "",
                sort: {}
            };
            _this3.onSearch = _this3.onSearch.bind(_this3);
            return _this3;
        }

        _createClass(ServerDataGateway, [{
            key: "onSearch",
            value: function onSearch(d, text, sort) {
                this.setState({ text: text, sort: sort });
            }
        }, {
            key: "render",
            value: function render() {
                var newProps = _extends({}, this.props);
                delete newProps.activeRecord;
                return _react2.default.createElement(WithSearchResults, _extends({
                    onSearch: this.onSearch
                }, newProps, this.state));
            }
        }]);

        return ServerDataGateway;
    }(_react2.default.PureComponent);

    ServerDataGateway.propTypes = {
        isServer: _propTypes2.default.bool.isRequired,
        serverSearch: _propTypes2.default.func.isRequired,
        candidateFilter: _propTypes2.default.func.isRequired,
        onFocus: _propTypes2.default.func.isRequired
    };

    return ServerDataGateway;
};

var withSourceCollectionDataGateway = function withSourceCollectionDataGateway(WrappedComponent) {
    var SourceCollectionDataGateway = function SourceCollectionDataGateway(props) {
        var activeRecord = props.activeRecord,
            descriptor = props.descriptor;

        var config = descriptor.config || {};
        var newProps = _extends({}, props);
        delete newProps.activeRecord;
        return _react2.default.createElement(WrappedComponent, _extends({}, newProps, {
            isLoading: false,
            allRecords: (0, _pathWalker2.default)(activeRecord, config.sourceCollectionPath) || []
        }));
    };

    SourceCollectionDataGateway.propTypes = {
        activeRecord: _propTypes2.default.instanceOf(_EntityProxy2.default).isRequired,
        descriptor: _propTypes2.default.shape({
            config: _propTypes2.default.shape({
                sourceCollectionPath: _propTypes2.default.string.isRequired
            }).isRequired
        }).isRequired
    };
    return SourceCollectionDataGateway;
};

var OtherEntityRecordsDataGateway = function OtherEntityRecordsDataGateway(WrappedComponent) {
    return function (props) {
        // eslint-disable-next-line react/prop-types
        var fluxContext = props.fluxContext,
            otherEntityKey = props.otherEntityKey;

        var state = (0, _useFluxStore2.default)(function () {
            var lo = (0, _SuperRecordListActions.getSuperRecordListRecords)(otherEntityKey, fluxContext);
            return {
                isLoading: lo.isLoading(),
                isError: lo.hasError(),
                allRecords: lo.hasValue() ? lo.getValue() || [] : []
            };
        }, [_SuperRecordListStore2.default], [fluxContext, otherEntityKey]);
        var newProps = _extends({}, props);
        delete newProps.activeRecord;
        return _react2.default.createElement(WrappedComponent, _extends({}, newProps, state));
    };
};

AssociationFieldtypeahead.propTypes = _extends({}, AssociationFieldtypeahead.propTypes, {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)({
        mode: _propTypes2.default.string,
        multiValued: _propTypes2.default.bool.isRequired,
        otherEntityKey: _propTypes2.default.string.isRequired,
        otherEntityType: _propTypes2.default.string.isRequired
    }))
});

exports.default = AssociationFieldtypeahead;

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
    start - The model to begin with.
    path - period delimited string of attributes to walk returning the final attribute. It must ALWAYS begin with 'instance'.

    NOTE: To simplify syntax a path cannot traverse a collection but can terminate at one.
*/
var pathWalkerStep = function pathWalkerStep(start) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    if (path.length === 0) return start;

    if (start instanceof Backbone.Collection) throw new Error("PathWalker cannot traverse a collection");

    var key = path.shift();
    return pathWalkerStep(start.get(key), path);
};

var pathWalker = function pathWalker(root) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

    var pathArray = path.split(".");
    if (pathArray.shift() !== "instance") throw new Error("First entry in path should be \"instance\"");

    return pathWalkerStep(root, pathArray);
};

exports.default = pathWalker;

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChoiceFieldtypeahead = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _formhelpers = __webpack_require__(5);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _ChoiceStore = __webpack_require__(174);

var _ChoiceStore2 = _interopRequireDefault(_ChoiceStore);

var _options = __webpack_require__(156);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _typeahead = __webpack_require__(450);

var _typeahead2 = _interopRequireDefault(_typeahead);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_VALUE_KEY = "name";
var DEFAULT_LABEL_KEY = "label";

var inflateValue = function inflateValue(config, options, v) {
    var valueKey = config.valueKey || DEFAULT_VALUE_KEY;
    var findValue = function findValue(val) {
        return options.find(function (it) {
            return val === it[valueKey];
        });
    };

    if (v !== null) {
        if (config.multiValued) {
            // find in options array
            v = v.map(function (it) {
                return findValue(it);
            }).filter(function (it) {
                return it;
            });
        } else {
            v = findValue(v);
        }
    }
    return v;
};

var ChoiceFieldtypeahead = exports.ChoiceFieldtypeahead = function (_BaseFormItem) {
    _inherits(ChoiceFieldtypeahead, _BaseFormItem);

    function ChoiceFieldtypeahead(props) {
        _classCallCheck(this, ChoiceFieldtypeahead);

        var _this = _possibleConstructorReturn(this, (ChoiceFieldtypeahead.__proto__ || Object.getPrototypeOf(ChoiceFieldtypeahead)).call(this, props));

        var activeRecord = props.activeRecord,
            descriptor = props.descriptor;
        // these can't change

        _this.info = _entityFieldMetaStore2.default.getInfo(activeRecord.entityKey, descriptor.key);
        _this.choice = _ChoiceStore2.default.getChoiceByKey(_this.info.choiceKey);
        _this.conditional = _this.info.conditions && _this.info.conditions.length > 0;
        _this.__enablePureOverValueAndEnabledHandling();
        return _this;
    }

    _createClass(ChoiceFieldtypeahead, [{
        key: "onCommitChange",
        value: function onCommitChange(d, v) {
            var userInvoked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
            var label = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            var descriptor = this.props.descriptor;

            var config = descriptor.config || {};
            var valueKey = config.valueKey || DEFAULT_VALUE_KEY;
            // deflate value
            if (config.multiValued) {
                if (Array.isArray(v)) {
                    v = v.map(function (it) {
                        return it[valueKey];
                    });
                } else {
                    v = null;
                }
            } else {
                v = v === null ? null : v[valueKey];
            }
            _get(ChoiceFieldtypeahead.prototype.__proto__ || Object.getPrototypeOf(ChoiceFieldtypeahead.prototype), "onCommitChange", this).call(this, d, v, userInvoked, label);
        }
    }, {
        key: "render",
        value: function render() {
            var _state = this.state,
                value = _state.value,
                enabled = _state.enabled;
            var descriptor = this.props.descriptor;

            var config = descriptor.config || {};
            var valueKey = config.valueKey || DEFAULT_VALUE_KEY;
            var labelKey = config.labelKey || DEFAULT_LABEL_KEY;
            var options = (0, _options.optionsForField)(this.info, this.conditional ? this.props.activeRecord : null, this.choice, true);
            return _react2.default.createElement(_typeahead2.default, _extends({}, this.getPlumbingProps(), {
                valueKey: valueKey,
                labelKey: labelKey,
                options: options,
                value: inflateValue(config, options, value),
                enabled: enabled,
                onCommitChange: this.onCommitChange
            }));
        }
    }]);

    return ChoiceFieldtypeahead;
}(_BaseFormItem3.default);

ChoiceFieldtypeahead.propTypes = _extends({}, ChoiceFieldtypeahead.propTypes, {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)({
        multiValued: _propTypes2.default.bool.isRequired
    }))
});

exports.default = ChoiceFieldtypeahead;

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChoiceFieldcheckbox = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _formhelpers = __webpack_require__(5);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _checkbox = __webpack_require__(447);

var _checkbox2 = _interopRequireDefault(_checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChoiceFieldcheckbox = exports.ChoiceFieldcheckbox = function (_BaseFormItem) {
    _inherits(ChoiceFieldcheckbox, _BaseFormItem);

    function ChoiceFieldcheckbox() {
        var _ref;

        _classCallCheck(this, ChoiceFieldcheckbox);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = ChoiceFieldcheckbox.__proto__ || Object.getPrototypeOf(ChoiceFieldcheckbox)).call.apply(_ref, [this].concat(args)));

        _this.onCommitChange = _this.onCommitChange.bind(_this);
        return _this;
    }

    _createClass(ChoiceFieldcheckbox, [{
        key: "onCommitChange",
        value: function onCommitChange(d, v) {
            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor;

            var config = descriptor.config;
            var checkedValue = config.checkedValue || true;
            _get(ChoiceFieldcheckbox.prototype.__proto__ || Object.getPrototypeOf(ChoiceFieldcheckbox.prototype), "onCommitChange", this).call(this, d, v);
            if (v === checkedValue && config.copyOnClickMappings) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = config.copyOnClickMappings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var m = _step.value;

                        var src = activeRecord.get(m.source);
                        if (src) {
                            _get(ChoiceFieldcheckbox.prototype.__proto__ || Object.getPrototypeOf(ChoiceFieldcheckbox.prototype), "doSetField", this).call(this, activeRecord, m.target, src);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _props2 = this.props,
                activeRecord = _props2.activeRecord,
                descriptor = _props2.descriptor;

            return _react2.default.createElement(_checkbox2.default, _extends({}, this.getPlumbingProps(), {
                value: activeRecord.get(descriptor.key),
                enabled: activeRecord.isFieldEnabled(descriptor.key)
            }));
        }
    }]);

    return ChoiceFieldcheckbox;
}(_BaseFormItem3.default);

ChoiceFieldcheckbox.propTypes = _extends({}, ChoiceFieldcheckbox.propTypes, {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)({
        copyOnClickMappings: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            source: _propTypes2.default.string.isRequired,
            target: _propTypes2.default.string.isRequired
        })),
        checkedValue: _propTypes2.default.string.isRequired,
        uncheckedValue: _propTypes2.default.string.isRequired
    }))
});

exports.default = ChoiceFieldcheckbox;

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChoiceFielddropdown = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _ChoiceStore = __webpack_require__(174);

var _ChoiceStore2 = _interopRequireDefault(_ChoiceStore);

var _options = __webpack_require__(156);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _dropdown = __webpack_require__(448);

var _dropdown2 = _interopRequireDefault(_dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChoiceFielddropdown = exports.ChoiceFielddropdown = function (_BaseFormItem) {
    _inherits(ChoiceFielddropdown, _BaseFormItem);

    function ChoiceFielddropdown(props) {
        _classCallCheck(this, ChoiceFielddropdown);

        var _this = _possibleConstructorReturn(this, (ChoiceFielddropdown.__proto__ || Object.getPrototypeOf(ChoiceFielddropdown)).call(this, props));

        var activeRecord = props.activeRecord,
            descriptor = props.descriptor;
        // these can't change

        _this.info = _entityFieldMetaStore2.default.getInfo(activeRecord.entityKey, descriptor.key);
        _this.choice = _ChoiceStore2.default.getChoiceByKey(_this.info.choiceKey);
        _this.conditional = _this.info.conditions && _this.info.conditions.length > 0;
        _this.__enablePureOverValueAndEnabledHandling();
        return _this;
    }

    _createClass(ChoiceFielddropdown, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
            if (this.conditional) return true;
            return _get(ChoiceFielddropdown.prototype.__proto__ || Object.getPrototypeOf(ChoiceFielddropdown.prototype), "shouldComponentUpdate", this).call(this, nextProps, nextState, nextContext);
        }
    }, {
        key: "render",
        value: function render() {
            var _state = this.state,
                value = _state.value,
                enabled = _state.enabled;

            return _react2.default.createElement(_dropdown2.default, _extends({}, this.getPlumbingProps(), {
                valueKey: "name",
                labelKey: "label",
                options: (0, _options.optionsForField)(this.info, this.conditional ? this.props.activeRecord : null, this.choice, true),
                value: value,
                enabled: enabled
            }));
        }
    }]);

    return ChoiceFielddropdown;
}(_BaseFormItem3.default);

exports.default = ChoiceFielddropdown;

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AssociationFielddevicelesiongrid = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _formhelpers = __webpack_require__(5);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RecordGridDataGateway = __webpack_require__(250);

var _RecordGridDataGateway2 = _interopRequireDefault(_RecordGridDataGateway);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _RecordActions = __webpack_require__(60);

var _RecordActions2 = _interopRequireDefault(_RecordActions);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _devicelesiongrid = __webpack_require__(1408);

var _devicelesiongrid2 = _interopRequireDefault(_devicelesiongrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * DeviceLesionGrid association field component with enablement tracking.
 * 
 * This component tracks enablement state changes to handle the scenario where
 * a parent field's EnableScript dynamically disables the grid. Since React's
 * shallow comparison doesn't detect changes within the same EntityProxy reference,
 * we explicitly track the enabled state and clear grid items when transitioning
 * from enabled to disabled.
 * 
 * **Key Difference from CompositionField:**
 * AssociationField base records (devices, workshops) are owned by the parentRecord's
 * composition. clearGridItems performs a two-phase delete: first removes each join
 * record from activeRecord, then deletes the base record from parentRecord if no
 * other sibling column entity still references it.
 * 
 * @see HJC-661 - Correct issue with devicelesiongrid enablement
 */
var AssociationFielddevicelesiongrid = exports.AssociationFielddevicelesiongrid = function (_React$Component) {
    _inherits(AssociationFielddevicelesiongrid, _React$Component);

    /**
     * Tracks enablement state to detect when the field's EnableScript result changes.
     * Since activeRecord is the same EntityProxy instance across renders, React's
     * shallow comparison won't detect enablement changes. We must explicitly track
     * the computed enabled state in component state.
     * 
     * @param {Object} props - Component props
     * @see HJC-661 - Fix for devicelesiongrid enablement tracking
     */
    function AssociationFielddevicelesiongrid(props) {
        _classCallCheck(this, AssociationFielddevicelesiongrid);

        var _this = _possibleConstructorReturn(this, (AssociationFielddevicelesiongrid.__proto__ || Object.getPrototypeOf(AssociationFielddevicelesiongrid)).call(this, props));

        _this.state = {
            wasEnabled: _this.isEnabled(props)
        };
        _this.clearGridItems = _this.clearGridItems.bind(_this);
        return _this;
    }

    /**
     * Computes the current enabled state by calling activeRecord.isFieldEnabled().
     * This evaluates the EnableScript and returns the current enabled state.
     * 
     * @param {Object} props - Component props (defaults to this.props)
     * @returns {boolean} True if field is enabled, false otherwise
     */


    _createClass(AssociationFielddevicelesiongrid, [{
        key: "isEnabled",
        value: function isEnabled() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
            var activeRecord = props.activeRecord,
                descriptor = props.descriptor;

            return activeRecord.isFieldEnabled(descriptor.key);
        }

        /**
         * Detects enablement state changes and clears grid when transitioning to disabled.
         * This ensures the UI reflects the business logic: when a field becomes disabled,
         * its value should be cleared (empty device list).
         * 
         * @param {Object} prevProps - Previous component props
         */

    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            var currentlyEnabled = this.isEnabled();
            var wasEnabled = this.state.wasEnabled;

            // Detect enablement state change

            if (wasEnabled !== currentlyEnabled) {
                this.setState({ wasEnabled: currentlyEnabled });

                // If transitioning from enabled to disabled, clear the grid.
                // Pass prevProps.activeRecord so clearGridItems can read the join records
                // that existed BEFORE the TableStore enablement system cleared them.
                if (!currentlyEnabled && wasEnabled) {
                    this.clearGridItems(prevProps.activeRecord);
                }
            }
        }

        /**
         * Clears orphaned pool records when the field transitions from enabled to disabled.
         *
         * The TableStore enablement system automatically clears the join collection
         * (rowSourceEntityCollectionKey) on the activeRecord when a field becomes disabled.
         * By the time clearGridItems is called, activeRecord.get(joinKey) is already [].
         * We therefore read the join records from prevActiveRecord (the pre-disable state)
         * so we know which pool records to clean up.
         *
         * Phase 1 (unlinking from activeRecord's join collection) is already handled by
         * the enablement system. We only need Phase 2: removing orphaned base records
         * from the parent's composition pool (rowSourceEntityFieldKey).
         *
         * @param {EntityProxy} prevActiveRecord - activeRecord from prevProps, holds old join data
         */

    }, {
        key: "clearGridItems",
        value: function clearGridItems(prevActiveRecord) {
            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor,
                fluxContext = _props.fluxContext;

            var config = descriptor.config;

            if (!config || !config.rowSourceEntityCollectionKey || !config.columnSourceEntityFieldKey) {
                console.warn("devicelesiongrid: missing config for grid clearing");
                return;
            }

            var parentRecord = activeRecord.get("parent");
            if (!parentRecord) {
                console.warn("devicelesiongrid: parentRecord not found, cannot clear pool");
                return;
            }

            // Read join records from the PREVIOUS state — the current state has already been
            // cleared by the TableStore enablement system, so joinRecords would be [] otherwise.
            var prevRecord = prevActiveRecord || activeRecord;
            var joinRecords = prevRecord.get(config.rowSourceEntityCollectionKey) || [];

            // Other sibling entities in CURRENT state. This weapon's join collection is already
            // cleared, so any other sibling still holding a reference must keep the pool record.
            var allColumnRecords = parentRecord.get(config.columnSourceEntityFieldKey) || [];
            var activeId = String(activeRecord.id);
            var otherColumnRecords = allColumnRecords.filter(function (r) {
                return String(r.id) !== activeId;
            });

            joinRecords.forEach(function (baseRecord) {
                var baseId = String(baseRecord.id);

                // If any OTHER sibling still references this base record, leave the pool record.
                var referencedElsewhere = otherColumnRecords.some(function (sibling) {
                    var siblingLinks = sibling.get(config.rowSourceEntityCollectionKey) || [];
                    return siblingLinks.some(function (r) {
                        return String(r.id) === baseId;
                    });
                });

                if (!referencedElsewhere) {
                    // Not referenced by any other sibling: delete from the parent's pool.
                    _Dispatcher2.default.contextDispatch(fluxContext, _defineProperty({
                        type: _RecordActions2.default.DELETE_CHILD,
                        recordKey: parentRecord.entityKey,
                        recordId: parentRecord.id,
                        fieldKey: config.rowSourceEntityFieldKey,
                        childKey: baseRecord.entityKey,
                        childId: baseRecord.id
                    }, _RecordActions.OPT_USER_CONFIRMED, true));
                }
                // If referenced elsewhere, Phase 1 is already handled by the enablement system;
                // the pool record stays for the other siblings that still reference it.
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _props2 = this.props,
                controlOnly = _props2.controlOnly,
                descriptor = _props2.descriptor,
                fluxContext = _props2.fluxContext,
                activeRecord = _props2.activeRecord,
                onFocus = _props2.onFocus,
                onBlur = _props2.onBlur,
                onKeyDown = _props2.onKeyDown;

            var config = descriptor.config;
            var parentRecord = activeRecord.get("parent");

            var creatables = [];
            for (var i = 0, l = config.creatables.length; i < l; i++) {
                var creatable = config.creatables[i];
                var ei = _entityMetaStore2.default.getInfo(creatable.key);
                creatables.push((0, _RecordGridDataGateway.buildCreatable)(ei.implKey, creatable.name, creatable.key, creatable.collectionKey, parentRecord));
            }

            var columnCollection = parentRecord.get(config.columnSourceEntityFieldKey);
            var columns = (0, _RecordGridDataGateway.buildColumnsFromConfig)(config.columns, this.props).concat((0, _RecordGridDataGateway.buildDevicelesiongridCheckboxColumns)(this.props, columnCollection));

            return _react2.default.createElement(_RecordGridDataGateway2.default, {
                key: descriptor.key,
                enabled: this.isEnabled(),
                component: _devicelesiongrid2.default,
                controlOnly: controlOnly,
                colCoords: {
                    record: parentRecord,
                    fieldKey: config.rowSourceEntityFieldKey
                },
                activeRecord: activeRecord,
                shortname: config.rowSourceEntityFieldKey,
                singularLabel: config.otherEntityName,
                fluxContext: fluxContext,
                descriptor: descriptor,
                addMode: config.addMode,
                allowView: !config.inline,
                allowCreate: true,
                allowRemove: true,
                columns: columns,
                creatables: creatables,
                onFocus: onFocus,
                onBlur: onBlur,
                onKeyDown: onKeyDown
            });
        }
    }]);

    return AssociationFielddevicelesiongrid;
}(_react2.default.Component);

AssociationFielddevicelesiongrid.propTypes = {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)({
        inline: _propTypes2.default.bool,
        otherEntityName: _propTypes2.default.string.isRequired,
        rowSourceEntityFieldKey: _propTypes2.default.string.isRequired,
        columnSourceEntityFieldKey: _propTypes2.default.string.isRequired,
        rowSourceEntityCollectionKey: _propTypes2.default.string.isRequired,
        addMode: _propTypes2.default.string.isRequired,
        columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            heading: _propTypes2.default.string.isRequired,
            width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
            type: _propTypes2.default.string.isRequired,
            script: _propTypes2.default.string,
            itemInfo: _propTypes2.default.object
        })).isRequired,
        creatables: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            name: _propTypes2.default.string.isRequired,
            key: _propTypes2.default.string.isRequired,
            collectionKey: _propTypes2.default.string.isRequired
        })).isRequired
    })),
    fluxContext: _propTypes2.default.string.isRequired,
    activeRecord: _propTypes2.default.instanceOf(_EntityProxy2.default).isRequired,
    controlOnly: _propTypes2.default.bool,
    onFocus: _propTypes2.default.func.isRequired,
    onBlur: _propTypes2.default.func.isRequired,
    onKeyDown: _propTypes2.default.func.isRequired
};

exports.default = AssociationFielddevicelesiongrid;

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formhelpers = __webpack_require__(5);

var _RecordGrid = __webpack_require__(161);

var _RecordGrid2 = _interopRequireDefault(_RecordGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Devicelesiongrid = function (_React$Component) {
    _inherits(Devicelesiongrid, _React$Component);

    function Devicelesiongrid() {
        _classCallCheck(this, Devicelesiongrid);

        return _possibleConstructorReturn(this, (Devicelesiongrid.__proto__ || Object.getPrototypeOf(Devicelesiongrid)).apply(this, arguments));
    }

    _createClass(Devicelesiongrid, [{
        key: "render",
        value: function render() {
            var descriptor = this.props.descriptor;

            return _react2.default.createElement(
                "div",
                { className: "form-item full-width" },
                _react2.default.createElement(
                    "div",
                    {
                        id: descriptor.id,
                        className: "control-container-" + descriptor.key + " composition-field full-width react-control",
                        "data-control-type": descriptor.control,
                        "data-shortname": descriptor.key
                    },
                    _react2.default.createElement(_RecordGrid2.default, this.props)
                )
            );
        }
    }]);

    return Devicelesiongrid;
}(_react2.default.Component);

exports.default = Devicelesiongrid;


Devicelesiongrid.propTypes = _extends({}, (0, _formhelpers.controlPropTypes)(null, false), {
    onCommitChange: _propTypes2.default.func

});

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChoiceFieldlabel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseFormItem2 = __webpack_require__(28);

var _BaseFormItem3 = _interopRequireDefault(_BaseFormItem2);

var _formhelpers = __webpack_require__(5);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _label = __webpack_require__(449);

var _label2 = _interopRequireDefault(_label);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var inflateValue = function inflateValue(v, c) {
    return v instanceof Array ? ArmusScript["toOptionLabel(Array<String>,String)"](v, c).join(", ") : ArmusScript["toOptionLabel(String,String)"](v, c);
};

var ChoiceFieldlabel = exports.ChoiceFieldlabel = function (_BaseFormItem) {
    _inherits(ChoiceFieldlabel, _BaseFormItem);

    function ChoiceFieldlabel() {
        _classCallCheck(this, ChoiceFieldlabel);

        return _possibleConstructorReturn(this, (ChoiceFieldlabel.__proto__ || Object.getPrototypeOf(ChoiceFieldlabel)).apply(this, arguments));
    }

    _createClass(ChoiceFieldlabel, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                activeRecord = _props.activeRecord,
                descriptor = _props.descriptor;

            var info = _entityFieldMetaStore2.default.getInfo(activeRecord.entityKey, descriptor.key);
            return _react2.default.createElement(_label2.default, _extends({}, this.getPlumbingProps(), {
                choiceKey: info.choiceKey,
                value: inflateValue(activeRecord.get(descriptor.key), info.choiceKey),
                enabled: activeRecord.isFieldEnabled(descriptor.key)
            }));
        }
    }]);

    return ChoiceFieldlabel;
}(_BaseFormItem3.default);

ChoiceFieldlabel.propTypes = _extends({}, ChoiceFieldlabel.propTypes, {
    descriptor: _propTypes2.default.shape((0, _formhelpers.descriptorPropTypes)())
});

exports.default = ChoiceFieldlabel;

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FluxActionBar = exports.ActionBar = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(51);

var _classnames2 = _interopRequireDefault(_classnames);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _ActiveSectionActions = __webpack_require__(224);

var _ActiveSectionActions2 = _interopRequireDefault(_ActiveSectionActions);

var _ActiveSectionStore = __webpack_require__(605);

var _ActiveSectionStore2 = _interopRequireDefault(_ActiveSectionStore);

var _FormStore = __webpack_require__(142);

var _FormStore2 = _interopRequireDefault(_FormStore);

var _NavigatorStore = __webpack_require__(33);

var _NavigatorStore2 = _interopRequireDefault(_NavigatorStore);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _NavigationActions = __webpack_require__(80);

var _NavigationActions2 = _interopRequireDefault(_NavigationActions);

var _MapButton = __webpack_require__(1411);

var _MapButton2 = _interopRequireDefault(_MapButton);

var _typedefs = __webpack_require__(44);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

var _PrintButton = __webpack_require__(1413);

var _PrintButton2 = _interopRequireDefault(_PrintButton);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _HybridConfig = __webpack_require__(41);

var _HybridConfig2 = _interopRequireDefault(_HybridConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ActionBar = exports.ActionBar = function (_React$Component) {
    _inherits(ActionBar, _React$Component);

    function ActionBar(props) {
        _classCallCheck(this, ActionBar);

        var _this = _possibleConstructorReturn(this, (ActionBar.__proto__ || Object.getPrototypeOf(ActionBar)).call(this, props));

        _this.onSectionChange = _this.onSectionChange.bind(_this);
        _this.onVersionSelect = _this.onVersionSelect.bind(_this);
        return _this;
    }

    _createClass(ActionBar, [{
        key: "onSectionChange",
        value: function onSectionChange(event) {
            event.preventDefault();
            this.props.onSectionChange(event.target.value);
        }
    }, {
        key: "onVersionSelect",
        value: function onVersionSelect(event) {
            event.preventDefault();
            this.props.onVersionSelect(event.target.value);
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                fluxContext = _props.fluxContext,
                onSave = _props.onSave,
                onCancel = _props.onCancel,
                sectionNames = _props.sectionNames,
                currentSection = _props.currentSection,
                allowSectionJump = _props.allowSectionJump,
                allowSave = _props.allowSave,
                showMapButton = _props.showMapButton,
                showPrintButton = _props.showPrintButton,
                entityKey = _props.entityKey,
                recordId = _props.recordId,
                allowCancel = _props.allowCancel,
                availableVersions = _props.availableVersions,
                activeVersion = _props.activeVersion,
                showVersionDropdown = _props.showVersionDropdown;


            var saveBtnClasses = (0, _classnames2.default)("btn", "btn-save", "actionSave");

            var sectionJump = !allowSectionJump && "disabled",
                save = !allowSave && "disabled",
                cancel = !allowCancel && "disabled";
            return _react2.default.createElement(
                "div",
                { className: "form-inline" },
                _react2.default.createElement(
                    "button",
                    {
                        onClick: onSave,
                        type: "button",
                        className: saveBtnClasses,
                        disabled: save
                    },
                    _react2.default.createElement("span", null),
                    " Save"
                ),
                showMapButton && _react2.default.createElement(_MapButton2.default, {
                    entityKey: entityKey,
                    recordId: recordId,
                    fluxContext: fluxContext
                }),
                showPrintButton && _react2.default.createElement(_PrintButton2.default, {
                    entityKey: entityKey,
                    recordId: recordId
                }),
                _react2.default.createElement(
                    "button",
                    { onClick: onCancel,
                        type: "button",
                        className: "btn cancel btn-cancel actionCancel",
                        disabled: cancel },
                    _react2.default.createElement("span", null),
                    " Cancel"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "form-impl" },
                    showVersionDropdown && availableVersions.length > 1 && _react2.default.createElement(
                        "div",
                        { className: "from-group version-section",
                            "data-control-type": "dropdown" },
                        _react2.default.createElement(
                            "label",
                            null,
                            "Version:"
                        ),
                        " ",
                        _react2.default.createElement(
                            "select",
                            { onChange: this.onVersionSelect,
                                value: activeVersion,
                                className: "form-control version-select" },
                            availableVersions.map(function (it) {
                                return _react2.default.createElement(
                                    "option",
                                    { key: it.key, value: it.key },
                                    it.name
                                );
                            })
                        )
                    )
                ),
                allowSectionJump && sectionNames.length > 1 && _react2.default.createElement(
                    "div",
                    { className: "pull-right from-group form-section",
                        "data-control-type": "dropdown" },
                    _react2.default.createElement(
                        "label",
                        null,
                        "Jump to:"
                    ),
                    " ",
                    _react2.default.createElement(
                        "select",
                        { onChange: this.onSectionChange,
                            value: currentSection,
                            className: "form-control section-select", disabled: sectionJump },
                        sectionNames.map(function (n) {
                            return _react2.default.createElement(
                                "option",
                                { key: n },
                                n
                            );
                        })
                    )
                )
            );
        }
    }]);

    return ActionBar;
}(_react2.default.Component);

ActionBar.propTypes = {
    fluxContext: _propTypes2.default.string.isRequired,
    sectionNames: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
    currentSection: _propTypes2.default.string,
    allowSectionJump: _propTypes2.default.bool,
    allowSave: _propTypes2.default.bool,
    showMapButton: _propTypes2.default.bool,
    showPrintButton: _propTypes2.default.bool,
    allowCancel: _propTypes2.default.bool,
    onSave: _propTypes2.default.func,
    onCancel: _propTypes2.default.func,
    onSectionChange: _propTypes2.default.func,
    availableVersions: _propTypes2.default.array,
    activeVersion: _propTypes2.default.string,
    entityKey: _propTypes2.default.string.isRequired,
    recordId: _typedefs.recordIdType.isRequired,
    onVersionSelect: _propTypes2.default.func,
    showVersionDropdown: _propTypes2.default.bool
};

var FluxActionBar = exports.FluxActionBar = function FluxActionBar(props) {
    var entityKey = props.entityKey,
        recordId = props.recordId,
        fluxContext = props.fluxContext,
        versionDropdownEnabled = props.versionDropdownEnabled,
        allowSave = props.allowSave,
        allowCancel = props.allowCancel,
        isModal = props.isModal,
        _onSave = props.onSave;

    var state = (0, _useFluxStore2.default)(function () {
        var state = {
            fluxContext: fluxContext,
            showMapButton: !isModal,
            showPrintButton: !_ClientId2.default.is(recordId) && _HybridConfig2.default.get("export.enablePrintToPdf", true) && _entityMetaStore2.default.isRootRecord(entityKey) // BE CAREFUL : this ensures an "is lookup" is irrelevant, so one isn't made
            && _userStore2.default.canPrint(new _EntityName2.default(entityKey).implKey),
            sectionNames: _FormStore2.default.getSectionNames(entityKey),
            currentSection: _ActiveSectionStore2.default.getCurrentSection(fluxContext),
            onSectionChange: function onSectionChange(section) {
                _Dispatcher2.default.contextDispatch(fluxContext, {
                    type: _ActiveSectionActions2.default.JUMP_TO_SECTION,
                    section: section
                });
            },
            onSave: function onSave() {
                if (allowSave) {
                    _onSave && _onSave();
                }
            },
            onCancel: function onCancel() {
                return allowCancel && _Dispatcher2.default.contextDispatch(fluxContext, {
                    type: _SuperRecordActions2.default.CANCEL
                });
            }
        };

        var _NavigatorStore$getSt = _NavigatorStore2.default.getState(fluxContext),
            magic = _NavigatorStore$getSt.magic,
            record = _NavigatorStore$getSt.record;

        if (versionDropdownEnabled && record != null && magic.id === record.id) {
            state.onVersionSelect = function (entityKey) {
                _Dispatcher2.default.contextDispatch(fluxContext, {
                    type: _NavigationActions2.default.SELECT_RECORD,
                    entityKey: entityKey,
                    recordId: record.id
                });
            };
            state.activeVersion = record.key;
            state.availableVersions = _StereotypesStore2.default.getStereotypeByKey(magic.key).implementations;
            state.showVersionDropdown = state.availableVersions.length > 1;
        } else {
            state.showVersionDropdown = false;
        }
        return state;
    }, [_userStore2.default, _entityMetaStore2.default, _ActiveSectionStore2.default, _FormStore2.default, _NavigatorStore2.default], [entityKey, fluxContext, versionDropdownEnabled, allowSave, allowCancel]);
    return _react2.default.createElement(ActionBar, _extends({}, props, state));
};

FluxActionBar.propTypes = {
    fluxContext: _propTypes2.default.string.isRequired,
    isModal: _propTypes2.default.bool,
    versionDropdownEnabled: _propTypes2.default.bool,
    allowSectionJump: _propTypes2.default.bool,
    allowSave: _propTypes2.default.bool,
    allowCancel: _propTypes2.default.bool,
    onSave: _propTypes2.default.func.isRequired,
    entityKey: _propTypes2.default.string.isRequired,
    recordId: _typedefs.recordIdType.isRequired
};

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Button = __webpack_require__(52);

var _Button2 = _interopRequireDefault(_Button);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _typedefs = __webpack_require__(44);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _entities = __webpack_require__(311);

var _getMapToTypes = __webpack_require__(1412);

var _getMapToTypes2 = _interopRequireDefault(_getMapToTypes);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _records = __webpack_require__(113);

var _AdtStore = __webpack_require__(228);

var _AdtStore2 = _interopRequireDefault(_AdtStore);

var _HemoStore = __webpack_require__(229);

var _HemoStore2 = _interopRequireDefault(_HemoStore);

var _EcmoEmrStore = __webpack_require__(230);

var _EcmoEmrStore2 = _interopRequireDefault(_EcmoEmrStore);

var _CrossAppStore = __webpack_require__(312);

var _CrossAppStore2 = _interopRequireDefault(_CrossAppStore);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

var _MapButtonActions = __webpack_require__(141);

var _MapButtonActions2 = _interopRequireDefault(_MapButtonActions);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

var _NavigatorStore = __webpack_require__(33);

var _NavigatorStore2 = _interopRequireDefault(_NavigatorStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var MapButtonView = function MapButtonView(props) {
    var items = props.items;

    if (items == null || items.length === 0) return null;
    return _react2.default.createElement(_Button2.default, {
        label: "Map",
        enabled: items.length !== 0,
        className: "btn btn-mapping",
        options: items.map(function (it) {
            return _extends({}, it, { value: it.id });
        }),
        onClick: function onClick(e, d, item) {
            return item.onClick && item.onClick();
        },
        collapse: items.length === 1 && items[0].type === "dialog"
    });
};

MapButtonView.propTypes = {
    items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.any.isRequired,
        label: _propTypes2.default.string.isRequired,
        type: _propTypes2.default.string.isRequired,
        onClick: _propTypes2.default.func // loading items won't have one...
    })).isRequired
};

var MapButton = function MapButton(props) {
    var key = props.entityKey,
        id = props.recordId,
        fluxContext = props.fluxContext;

    var state = (0, _useFluxStore2.default)(function () {
        var activeRecord = (0, _records.getActiveRecord)(_TableStore2.default, { key: key, id: id });
        // If there's no active record, it's because marionette hasn't caught up
        // with Flux/React yet, so we have to have this escape hatch. ActionBar
        // will be rerendering _very_ shortly, and not drawing the map button
        // since there isn't an AR, but for the moment we have to imperatively
        // code around the race. Whee!
        if (activeRecord == null) return null;

        var canUseDialog = false;
        var items = [];
        var canWrite = activeRecord.canWrite();
        if (canWrite) {
            items.push.apply(items, _toConsumableArray((0, _entities.getMappingPlugins)(activeRecord, fluxContext).flatMap(function (p) {
                if (p.get("id") !== "cross-record") {
                    canUseDialog = true;
                }
                var lo = p.searchFromActiveRecord();
                if (lo.hasValue()) {
                    var sources = lo.getRequiredValue();
                    if (sources.length > 0) {
                        canUseDialog = true;
                    }
                    return sources.map(function (src) {
                        return {
                            label: p.getButtonListingPrefix() + src.getLabel(),
                            type: "map-from",
                            id: src.id,
                            onClick: function onClick() {
                                return _Dispatcher2.default.contextDispatch(fluxContext, {
                                    type: _MapButtonActions2.default.AUTOMAP_FROM,
                                    target: activeRecord,
                                    source: src
                                });
                            }
                        };
                    });
                }
                if (lo.isLoading()) {
                    return [_extends({}, p.loadingMessage(), {
                        id: p.get("name") + "-loading",
                        type: "loading"
                    })];
                }
                return []; // huh? whatever.
            })));
        }
        items.push.apply(items, _toConsumableArray((0, _getMapToTypes2.default)(key, _StereotypesStore2.default.getDataEntryStereotypes(), function (targetKey) {
            var newId = _ClientId2.default.next();
            _Dispatcher2.default.contextDispatch(fluxContext, {
                type: _MapButtonActions2.default.AUTOMAP_TO_NEW_MAGIC_CHILD,
                entityKey: targetKey,
                newId: newId,
                source: activeRecord,
                navigate: true
            });
        })));
        if (canUseDialog) {
            items.unshift({
                label: "Launch Mapping Dialog",
                id: "dialog",
                type: "dialog",
                onClick: function onClick() {
                    return _Dispatcher2.default.contextDispatch(fluxContext, {
                        type: _MapButtonActions2.default.LAUNCH_DIALOG,
                        target: (0, _records.getActiveRecord)(_TableStore2.default, _NavigatorStore2.default.getRecordState(fluxContext))
                    });
                }
            });
        }
        return {
            items: items
        };
    }, [_TableStore2.default, _AdtStore2.default, _HemoStore2.default, _EcmoEmrStore2.default, _CrossAppStore2.default], [key, id, fluxContext]);
    return state == null ? null : _react2.default.createElement(MapButtonView, state);
};

MapButton.propTypes = {
    fluxContext: _propTypes2.default.string.isRequired,
    recordId: _typedefs.recordIdType.isRequired,
    entityKey: _EntityName2.default.propType.isRequired
};

exports.default = MapButton;

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getMapToTypes;

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getMapToTypes(activeRecordKey, stereotypes, doMapToKey) {
    var targets = {};
    var targatableStereotypes = stereotypes.filter(function (stereotype) {
        if (stereotype.magicRoot) return false;
        if (!stereotype.magicRootKey) return false;
        var found = false;
        stereotype.creatables.forEach(function (creatable) {
            creatable.versions.forEach(function (version) {
                return found = found || version.key === activeRecordKey;
            });
        });
        return found;
    });
    targatableStereotypes.forEach(function (stereotype) {
        stereotype.creatables.forEach(function (creatable) {
            var dk = creatable.defaultKey;
            creatable.versions.forEach(function (version) {
                var k = version.key;
                if (k === dk || !dk) {
                    targets[k] = dk ? "Map To New " + creatable.label + " " + targatableStereotypes[0].name : "Map To New " + creatable.label + " " + version.label + " " + targatableStereotypes[0].name;
                }
            });
        });
    });
    return _entityMetaStore2.default.getAllInfos(function (info) {
        if (!info.canCreate) return false;
        if (!targets.hasOwnProperty(info.key)) return false;
        if (info.mappingSources == null) return false;
        var crs = info.mappingSources.find(function (s) {
            return s.pluginKey === "cross-record";
        });
        if (crs == null) return false;
        if (crs.types.indexOf(activeRecordKey) < 0) return false;
        return true;
    }).map(function (info) {
        return {
            label: targets[info.key],
            id: "new-" + info.key,
            type: "map-to-new",
            key: info.key,
            onClick: function onClick() {
                return doMapToKey(info.key);
            }
        };
    });
}

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _typedefs = __webpack_require__(44);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _PrintActions = __webpack_require__(618);

var _PrintActions2 = _interopRequireDefault(_PrintActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PrintButton(props) {
    var entityKey = props.entityKey,
        id = props.recordId;


    var handleClick = function handleClick() {
        return _Dispatcher2.default.dispatch({
            type: _PrintActions2.default.LAUNCH_DIALOG,
            entityKey: entityKey,
            id: id
        });
    };

    return _react2.default.createElement(
        "button",
        {
            className: "btn btn-secondary btn-print",
            onClick: handleClick
        },
        _react2.default.createElement("i", { className: "glyphicon glyphicon-print" }),
        " Print..."
    );
}

PrintButton.propTypes = {
    entityKey: _propTypes2.default.string.isRequired,
    recordId: _typedefs.recordIdType.isRequired
};

exports.default = PrintButton;

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InnerSidebarLayout = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ValidationTreeContainer = __webpack_require__(619);

var _ValidationTreeContainer2 = _interopRequireDefault(_ValidationTreeContainer);

var _ActiveFormStore = __webpack_require__(112);

var _ActiveFormStore2 = _interopRequireDefault(_ActiveFormStore);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _ActiveFormActions = __webpack_require__(111);

var _ActiveFormActions2 = _interopRequireDefault(_ActiveFormActions);

var _NavTabs = __webpack_require__(1423);

var _NavTabs2 = _interopRequireDefault(_NavTabs);

var _DataDefinitionsContainer = __webpack_require__(1425);

var _DataDefinitionsContainer2 = _interopRequireDefault(_DataDefinitionsContainer);

var _AbstractionAiContainer = __webpack_require__(1428);

var _AbstractionAiContainer2 = _interopRequireDefault(_AbstractionAiContainer);

var _NavigatorStore = __webpack_require__(33);

var _NavigatorStore2 = _interopRequireDefault(_NavigatorStore);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

var _AbstractionAiStore = __webpack_require__(624);

var _AbstractionAiStore2 = _interopRequireDefault(_AbstractionAiStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*  
    AI Suggest right pane - 
    This is where the the AI Suggest gets put into the right pane and resizes based on if the section is expanded or collapsed. 
*/

var InnerSidebarLayout = exports.InnerSidebarLayout = function (_React$Component) {
    _inherits(InnerSidebarLayout, _React$Component);

    function InnerSidebarLayout(props) {
        _classCallCheck(this, InnerSidebarLayout);

        var _this = _possibleConstructorReturn(this, (InnerSidebarLayout.__proto__ || Object.getPrototypeOf(InnerSidebarLayout)).call(this, props));

        _this.state = {
            openId: props.hasAbstractionAi ? null : "definitions"
        };
        _this.toggleOpenId = _this.toggleOpenId.bind(_this);
        return _this;
    }

    _createClass(InnerSidebarLayout, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            // sync openId when AI support becomes available or unavailable
            if (prevProps.hasAbstractionAi !== this.props.hasAbstractionAi) {
                this.setState({ openId: this.props.hasAbstractionAi ? null : "definitions" });
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                activeTabId = _props.activeTabId,
                setActiveTabId = _props.setActiveTabId,
                hasActiveRecord = _props.hasActiveRecord,
                hasAbstractionAi = _props.hasAbstractionAi;

            var tabs = [];
            if (hasActiveRecord) {
                tabs.push({
                    id: "definitions",
                    name: "Definitions" + (hasAbstractionAi ? " & Suggestions" : ""),
                    class: "definitions",
                    icon: "book"
                }, {
                    id: "validation",
                    name: "Validation",
                    class: "validation",
                    icon: "check-square-o"
                });
            }
            if (tabs.length === 0) return null;
            var actuallyActiveTabId = activeTabId;
            if (tabs.every(function (t) {
                return t.id !== activeTabId;
            })) {
                actuallyActiveTabId = tabs[0].id;
            }
            return _react2.default.createElement(
                "div",
                { className: "sidebar" },
                _react2.default.createElement(
                    "div",
                    { className: "navigation", key: "tabs" },
                    _react2.default.createElement(_NavTabs2.default, {
                        tabs: tabs.map(function (t) {
                            return _extends({}, t, {
                                active: t.id === actuallyActiveTabId
                            });
                        }),
                        doSelect: setActiveTabId
                    })
                ),
                _react2.default.createElement(
                    "div",
                    { className: "sidebar_content", key: "content" },
                    _react2.default.createElement(
                        "div",
                        null,
                        this.renderActive(actuallyActiveTabId)
                    )
                )
            );
        }
    }, {
        key: "toggleOpenId",
        value: function toggleOpenId(id) {
            var openId = this.state.openId;
            var hasAbstractionAi = this.props.hasAbstractionAi;

            if (!hasAbstractionAi) {
                // don't do anything
                return;
            }
            if (openId === id) {
                id = null;
            }
            this.setState(_extends({}, this.state, { openId: id }));
        }
    }, {
        key: "renderActive",
        value: function renderActive(activeTabId) {
            var _this2 = this;

            var _props2 = this.props,
                fluxContext = _props2.fluxContext,
                hasAbstractionAi = _props2.hasAbstractionAi;
            var openId = this.state.openId;

            switch (activeTabId) {
                case "definitions":
                    return _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        _react2.default.createElement(_DataDefinitionsContainer2.default, {
                            open: openId === null ? null : openId === "definitions",
                            onToggleOpen: function onToggleOpen() {
                                return _this2.toggleOpenId("definitions");
                            },
                            fluxContext: fluxContext
                        }),
                        hasAbstractionAi && _react2.default.createElement(_AbstractionAiContainer2.default, {
                            open: openId === null ? null : openId === "abstractionai",
                            onToggleOpen: function onToggleOpen() {
                                return _this2.toggleOpenId("abstractionai");
                            },
                            fluxContext: fluxContext
                        })
                    );
                case "validation":
                    return _react2.default.createElement(_ValidationTreeContainer2.default, { fluxContext: fluxContext });
                default:
                    console.log("tab", activeTabId);
                    return;
            }
        }
    }]);

    return InnerSidebarLayout;
}(_react2.default.Component);

InnerSidebarLayout.propTypes = {
    activeTabId: _propTypes2.default.string.isRequired,
    activeFieldKey: _propTypes2.default.string,
    setActiveTabId: _propTypes2.default.func.isRequired,
    hasActiveRecord: _propTypes2.default.bool.isRequired,
    hasAbstractionAi: _propTypes2.default.bool.isRequired,
    fluxContext: _propTypes2.default.string.isRequired
};

var SidebarLayout = function SidebarLayout(props) {
    var fluxContext = props.fluxContext;

    var ctrl = _ActiveFormStore2.default.getActiveControl(fluxContext);
    var fieldKey = ctrl == null ? null : ctrl.fieldKey;
    var state = (0, _useFluxStore2.default)(function () {
        return {
            fluxContext: fluxContext,
            hasActiveRecord: _NavigatorStore2.default.getRecordState(fluxContext) != null,
            hasAbstractionAi: _AbstractionAiStore2.default.canAISuggestion(fluxContext),
            activeTabId: _ActiveFormStore2.default.getActiveSidebarTab(fluxContext),
            activeFieldKey: fieldKey,
            setActiveTabId: function setActiveTabId(id) {
                return _Dispatcher2.default.contextDispatch(fluxContext, {
                    type: _ActiveFormActions2.default.SELECT_SIDEBAR_TAB,
                    id: id
                });
            }
        };
    }, [_ActiveFormStore2.default, _NavigatorStore2.default, _TableStore2.default], [fluxContext, fieldKey]);
    return _react2.default.createElement(InnerSidebarLayout, _extends({}, props, state));
};

SidebarLayout.propTypes = {
    fluxContext: _propTypes2.default.string.isRequired
};

exports.default = SidebarLayout;

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toggleFilter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _ContextedReduceStore2 = __webpack_require__(30);

var _ContextedReduceStore3 = _interopRequireDefault(_ContextedReduceStore2);

var _ValidationTreeActions = __webpack_require__(620);

var _ValidationTreeActions2 = _interopRequireDefault(_ValidationTreeActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var toggleFilter = exports.toggleFilter = function toggleFilter(ctx, filter) {
    return _extends({}, ctx, {
        filters: _extends({}, ctx.filters, _defineProperty({}, filter, !ctx.filters[filter]))
    });
};

var ValidationTreeStore = function (_ContextedReduceStore) {
    _inherits(ValidationTreeStore, _ContextedReduceStore);

    function ValidationTreeStore() {
        _classCallCheck(this, ValidationTreeStore);

        return _possibleConstructorReturn(this, (ValidationTreeStore.__proto__ || Object.getPrototypeOf(ValidationTreeStore)).call(this, _Dispatcher2.default));
    }

    _createClass(ValidationTreeStore, [{
        key: "getInitialContext",
        value: function getInitialContext() {
            return {
                filters: {
                    blocking: true,
                    illegal: true,
                    warning: true,
                    ok: false,
                    all: true
                }
            };
        }
    }, {
        key: "reduceContext",
        value: function reduceContext(ctx, action) {
            switch (action.type) {
                case _ValidationTreeActions2.default.TOGGLE_FILTER:
                    return toggleFilter(ctx, action.filter);
                default:
                    return ctx;
            }
        }
    }, {
        key: "getFilters",
        value: function getFilters(contextId) {
            return this.getState(contextId).filters;
        }
    }]);

    return ValidationTreeStore;
}(_ContextedReduceStore3.default);

ValidationTreeStore.contextTypes = {
    filters: _propTypes2.default.shape({
        blocking: _propTypes2.default.bool.isRequired,
        illegal: _propTypes2.default.bool.isRequired,
        warning: _propTypes2.default.bool.isRequired,
        ok: _propTypes2.default.bool.isRequired,
        all: _propTypes2.default.bool.isRequired
    }).isRequired
};

exports.default = (0, _typeCheckingStore2.default)(new ValidationTreeStore());

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _PanelHeading = __webpack_require__(1417);

var _PanelHeading2 = _interopRequireDefault(_PanelHeading);

var _PanelBodyPOC = __webpack_require__(1418);

var _types = __webpack_require__(356);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import PanelBody from "./PanelBody";


var ValidationTree = function (_React$Component) {
    _inherits(ValidationTree, _React$Component);

    function ValidationTree() {
        _classCallCheck(this, ValidationTree);

        return _possibleConstructorReturn(this, (ValidationTree.__proto__ || Object.getPrototypeOf(ValidationTree)).apply(this, arguments));
    }

    _createClass(ValidationTree, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                toggleFilter = _props.toggleFilter,
                filters = _props.filters,
                item = _props.item,
                ctx = _props.ctx;

            var illegalLabel = item ? _userStore2.default.getIllegalLabel(item.entityKey) : null;
            return _react2.default.createElement(
                "div",
                { className: "validation-panel" },
                _react2.default.createElement(_PanelHeading2.default, _extends({}, filters, {
                    illegalLabel: illegalLabel,
                    onFilterClick: toggleFilter })),
                item && _react2.default.createElement(_PanelBodyPOC.PanelBodyContainer, { item: item,
                    ctx: ctx
                })
            );
        }
    }]);

    return ValidationTree;
}(_react2.default.Component);

ValidationTree.propTypes = {
    ctx: _propTypes2.default.string.isRequired,
    item: _types.itemType,
    filters: _propTypes2.default.shape({
        blocking: _propTypes2.default.bool.isRequired,
        illegal: _propTypes2.default.bool.isRequired,
        warning: _propTypes2.default.bool.isRequired,
        ok: _propTypes2.default.bool.isRequired,
        all: _propTypes2.default.bool.isRequired
    }).isRequired,
    toggleFilter: _propTypes2.default.func.isRequired
};

exports.default = ValidationTree;

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FilterButton = undefined;

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterButton = exports.FilterButton = function FilterButton(_ref) {
    var name = _ref.name,
        label = _ref.label,
        onClick = _ref.onClick,
        filterState = _ref.filterState;
    return React.createElement(
        "li",
        { onClick: onClick },
        React.createElement(
            "div",
            { className: name + (filterState === true ? " checked" : ""), "data-control-type": "validationfilter" },
            React.createElement("span", null)
        ),
        label
    );
};

FilterButton.propTypes = {
    name: _propTypes2.default.string,
    label: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    filterState: _propTypes2.default.bool
};

var filters = [{
    key: "blocking",
    label: "Blocking"
}, {
    key: "illegal",
    label: "Illegal"
}, {
    key: "warning",
    label: "Warning"
}, {
    key: "ok",
    label: "OK"
}, {
    key: "all",
    label: "All Levels"
}];

var PanelHeading = function PanelHeading(props) {
    return React.createElement(
        "div",
        { className: "panel-heading" },
        React.createElement(
            "div",
            { className: "filters" },
            React.createElement(
                "ul",
                null,
                filters.map(function (_ref2) {
                    var key = _ref2.key,
                        label = _ref2.label;
                    return React.createElement(FilterButton, {
                        key: key,
                        name: key,
                        label: key === "illegal" && props.illegalLabel ? props.illegalLabel : label,
                        onClick: function onClick() {
                            return props.onFilterClick(key);
                        },
                        filterState: props[key]
                    });
                })
            )
        )
    );
};

PanelHeading.propTypes = {
    onFilterClick: _propTypes2.default.func.isRequired,
    illegalLabel: _propTypes2.default.string,
    blocking: _propTypes2.default.bool.isRequired,
    illegal: _propTypes2.default.bool.isRequired,
    warning: _propTypes2.default.bool.isRequired,
    ok: _propTypes2.default.bool.isRequired,
    all: _propTypes2.default.bool.isRequired
};

exports.default = PanelHeading;

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PanelBodyContainer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

var _TreeItemStore = __webpack_require__(162);

var _TreeItemStore2 = _interopRequireDefault(_TreeItemStore);

var _TreeItemActions = __webpack_require__(355);

var _TreeItemActions2 = _interopRequireDefault(_TreeItemActions);

var _ValidationTreeItem = __webpack_require__(1419);

var _ValidationTreeItem2 = _interopRequireDefault(_ValidationTreeItem);

var _types = __webpack_require__(356);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PanelBody = function (_React$Component) {
    _inherits(PanelBody, _React$Component);

    function PanelBody() {
        _classCallCheck(this, PanelBody);

        return _possibleConstructorReturn(this, (PanelBody.__proto__ || Object.getPrototypeOf(PanelBody)).apply(this, arguments));
    }

    _createClass(PanelBody, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                item = _props.item,
                onExpandAll = _props.onExpandAll,
                onCollapseAll = _props.onCollapseAll,
                collapsedAll = _props.collapsedAll,
                expandedAll = _props.expandedAll;

            var extendedItem = _extends({}, item, {
                collapsedAll: collapsedAll,
                expandedAll: expandedAll
            });

            return React.createElement(
                "div",
                { className: "panel-body" },
                React.createElement(
                    "div",
                    { className: "validationtree" },
                    React.createElement(
                        "div",
                        { className: "actions" },
                        React.createElement(
                            "button",
                            { type: "button", className: "btn btn-expand-all", onClick: onExpandAll },
                            React.createElement("span", null)
                        ),
                        React.createElement(
                            "span",
                            null,
                            "\xA0"
                        ),
                        React.createElement(
                            "button",
                            { type: "button", className: "btn btn-collapse-all", onClick: onCollapseAll },
                            React.createElement("span", null)
                        )
                    ),
                    React.createElement(_ValidationTreeItem2.default, {
                        nodeKey: "",
                        isKeyExpanded: this.props.isKeyExpanded,
                        onChildCollapseOrExpand: this.props.onChildCollapseOrExpand,
                        expanded: this.props.isKeyExpanded(""),
                        item: extendedItem
                    })
                )
            );
        }
    }]);

    return PanelBody;
}(React.Component);

PanelBody.propTypes = {
    collapsedAll: _propTypes2.default.bool.isRequired,
    expandedAll: _propTypes2.default.bool.isRequired,
    item: _types.itemType.isRequired,
    onChildCollapseOrExpand: _propTypes2.default.func.isRequired,
    onCollapseAll: _propTypes2.default.func.isRequired,
    onExpandAll: _propTypes2.default.func.isRequired,
    isKeyExpanded: _propTypes2.default.func.isRequired
};

var PanelBodyContainer = exports.PanelBodyContainer = function PanelBodyContainer(props) {
    var ctx = props.ctx;

    var state = (0, _useFluxStore2.default)(function () {
        return {
            collapsedAll: !_TreeItemStore2.default.isExpandAll(ctx),
            expandedAll: _TreeItemStore2.default.isExpandAll(ctx),
            onChildCollapseOrExpand: _TreeItemActions2.default.childCollapseOrExpand.bind(undefined, ctx),
            onCollapseAll: _TreeItemActions2.default.collapseAll.bind(undefined, ctx),
            onExpandAll: _TreeItemActions2.default.expandAll.bind(undefined, ctx),
            isKeyExpanded: _TreeItemStore2.default.getExpandedTest(ctx)
        };
    }, [_TreeItemStore2.default], [ctx]);
    return React.createElement(PanelBody, _extends({}, props, state));
};

PanelBodyContainer.propTypes = {
    ctx: _propTypes2.default.string.isRequired,
    item: _types.itemType.isRequired
};

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TreeItem = __webpack_require__(622);

var _react = __webpack_require__(1);

var React = _interopRequireWildcard(_react);

var _Expander = __webpack_require__(1420);

var _types = __webpack_require__(356);

var _formatId = __webpack_require__(114);

var _formatId2 = _interopRequireDefault(_formatId);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ValTreeItem = function (_React$Component) {
    _inherits(ValTreeItem, _React$Component);

    function ValTreeItem() {
        _classCallCheck(this, ValTreeItem);

        return _possibleConstructorReturn(this, (ValTreeItem.__proto__ || Object.getPrototypeOf(ValTreeItem)).apply(this, arguments));
    }

    _createClass(ValTreeItem, [{
        key: "onDoubleClick",
        value: function onDoubleClick(e) {
            e.stopPropagation();
            var it = this.props.item;
            it.onNavToField(it.entityKey, it.recordId, it.fieldKey // may be undefined (for records)
            );
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                item = _props.item,
                toggleControl = _props.toggleControl;
            var message = item.message,
                entityKey = item.entityKey,
                recordId = item.recordId,
                fieldKey = item.fieldKey,
                state = item.state,
                nestedState = item.nestedState,
                children = item.children;

            var classBase = fieldKey || item.cid;
            var classNames = "tree-item-" + classBase;

            var controlValue = state;
            var indicatorClass = "indicator-container indicator-container-" + classBase + " is-" + state + " contains-" + nestedState;

            var messageClass = "message message-container-" + classBase;
            var hasChildren = children != null && children.length > 0;
            return React.createElement(
                "li",
                { className: classNames, id: (0, _formatId2.default)(entityKey + "#" + recordId + "." + fieldKey, "val-tree-item") },
                React.createElement(
                    "div",
                    { className: "tree-row" },
                    React.createElement(_Expander.ConditionalExpander, {
                        show: hasChildren,
                        expanded: this.props.expanded,
                        onClick: toggleControl.bind(this) }),
                    React.createElement(
                        "div",
                        { className: indicatorClass,
                            "data-shortname": fieldKey,
                            "data-control-value": controlValue,
                            "data-control-type": "validationindicator",
                            onDoubleClick: this.onDoubleClick.bind(this)
                        },
                        React.createElement(
                            "div",
                            { className: "indicator-container-inner" },
                            React.createElement("div", { className: "indicator-top" }),
                            React.createElement("div", { className: "indicator-bottom" })
                        )
                    ),
                    React.createElement(
                        "div",
                        { className: messageClass,
                            "data-control-type": "label",
                            onDoubleClick: this.onDoubleClick.bind(this)
                        },
                        message || "\xA0"
                    )
                )
            );
        }
    }]);

    return ValTreeItem;
}(React.Component);

ValTreeItem.propTypes = {
    expanded: _propTypes2.default.bool.isRequired,
    item: _propTypes2.default.shape(_types.validationTreeItemType).isRequired,
    toggleControl: _propTypes2.default.func.isRequired
};

var ValidationTreeItem = (0, _TreeItem.makeTreeItem)(ValTreeItem);
exports.default = ValidationTreeItem;

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ConditionalExpander = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Expander = function Expander(_ref) {
    var onClick = _ref.onClick,
        expanded = _ref.expanded;

    var className = "expander";

    if (expanded) {
        className += " expanded";
    }

    return _react2.default.createElement(
        "div",
        { onClick: onClick, className: className },
        expanded
    );
};

Expander.propTypes = {
    expanded: _propTypes2.default.bool.isRequired,
    onClick: _propTypes2.default.func.isRequired
};

exports.default = Expander;
var ConditionalExpander = exports.ConditionalExpander = function ConditionalExpander(_ref2) {
    var show = _ref2.show,
        expanded = _ref2.expanded,
        onClick = _ref2.onClick;
    return show ? _react2.default.createElement(Expander, { expanded: expanded, onClick: onClick }) : _react2.default.createElement("div", { className: "expander placeholder" });
};

ConditionalExpander.propTypes = _extends({}, Expander.propTypes, {
    show: _propTypes2.default.bool.isRequired
});

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var treeItemPredicate = function treeItemPredicate(filterState) {
    return function (treeState) {
        var isBlocking = filterState.blocking && (treeState._contains_blocking || treeState._is_blocking);
        var isIllegal = filterState.illegal && (treeState._contains_illegal || treeState._is_illegal);
        var isWarning = filterState.warning && (treeState._contains_warning || treeState._is_warning);
        var isOk = filterState.ok && (treeState._contains_ok || treeState._is_ok);

        return isBlocking || isIllegal || isWarning || isOk;
    };
};

exports.default = treeItemPredicate;

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _FieldSetPreferenceCache = __webpack_require__(482);

var _FieldSetPreferenceCache2 = _interopRequireDefault(_FieldSetPreferenceCache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _FieldSetPreferenceCache2.default(_Dispatcher2.default, "validation-excluded-fields");

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _NavTab = __webpack_require__(1424);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavTabs = function (_React$Component) {
    _inherits(NavTabs, _React$Component);

    function NavTabs() {
        _classCallCheck(this, NavTabs);

        return _possibleConstructorReturn(this, (NavTabs.__proto__ || Object.getPrototypeOf(NavTabs)).apply(this, arguments));
    }

    _createClass(NavTabs, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var items = this.props.tabs.map(function (it) {
                return _react2.default.createElement(_NavTab.NavTab, { key: it.id,
                    className: it.class,
                    name: it.name,
                    active: it.active,
                    icon: it.icon,
                    doSelect: function doSelect() {
                        return _this2.props.doSelect(it.id);
                    }
                });
            });

            return _react2.default.createElement(
                "ul",
                { className: "nav nav-pills nav-justified" },
                items
            );
        }
    }]);

    return NavTabs;
}(_react2.default.Component);

exports.default = NavTabs;


NavTabs.propTypes = {
    doSelect: _propTypes2.default.func.isRequired,
    tabs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.string.isRequired,
        name: _propTypes2.default.string.isRequired,
        class: _propTypes2.default.string.isRequired,
        active: _propTypes2.default.bool.isRequired
    })).isRequired
};

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NavTab = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavTab = exports.NavTab = function (_React$Component) {
    _inherits(NavTab, _React$Component);

    function NavTab(props) {
        _classCallCheck(this, NavTab);

        var _this = _possibleConstructorReturn(this, (NavTab.__proto__ || Object.getPrototypeOf(NavTab)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(NavTab, [{
        key: "handleClick",
        value: function handleClick(event) {
            event.preventDefault();
            this.props.doSelect();
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                className = _props.className,
                _props$active = _props.active,
                active = _props$active === undefined ? false : _props$active,
                name = _props.name,
                _props$icon = _props.icon,
                icon = _props$icon === undefined ? "" : _props$icon;


            var classes = className;

            if (active) {
                classes += " active";
            }

            return _react2.default.createElement(
                "li",
                { className: classes },
                _react2.default.createElement(
                    "a",
                    { onClick: this.handleClick,
                        href: "#" },
                    _react2.default.createElement("span", { className: "fa fa-" + icon }),
                    "\xA0",
                    name
                )
            );
        }
    }]);

    return NavTab;
}(_react2.default.Component);

NavTab.propTypes = {
    doSelect: _propTypes2.default.func.isRequired,
    active: _propTypes2.default.bool.isRequired,
    className: _propTypes2.default.string.isRequired,
    icon: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired
};

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _DataDefinitionModule = __webpack_require__(1426);

var _DataDefinitionModule2 = _interopRequireDefault(_DataDefinitionModule);

var _ActiveFormStore = __webpack_require__(112);

var _ActiveFormStore2 = _interopRequireDefault(_ActiveFormStore);

var _DataDefStore = __webpack_require__(1427);

var _DataDefStore2 = _interopRequireDefault(_DataDefStore);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataDefinitionsContainer = function DataDefinitionsContainer(props) {
    var ctx = props.fluxContext;
    var state = (0, _useFluxStore2.default)(function () {
        var ctrl = _ActiveFormStore2.default.getActiveControl(ctx);
        var next = {};
        if (ctrl == null) return next;
        if (ctrl.fieldKey !== _ActiveFormStore.FIRST_FIELD) {
            var lo = _DataDefStore2.default.getDefinitionsLO(ctrl.entityKey, ctrl.fieldKey);
            if (lo.hasValue()) {
                Object.assign(next, lo.getRequiredValue());
            }
        }
        next.shortName = ctrl.fieldKey;
        next.keyboardShortcuts = ctrl.keyboardShortcuts;
        return next;
    }, [_ActiveFormStore2.default, _DataDefStore2.default], [ctx]);
    return _react2.default.createElement(_DataDefinitionModule2.default, _extends({}, state, { open: props.open, onToggleOpen: props.onToggleOpen }));
};

DataDefinitionsContainer.propTypes = {
    fluxContext: _propTypes2.default.string.isRequired,
    open: _propTypes2.default.any,
    onToggleOpen: _propTypes2.default.func.isRequired
};

exports.default = DataDefinitionsContainer;

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataDefinitionModule = function (_React$Component) {
    _inherits(DataDefinitionModule, _React$Component);

    function DataDefinitionModule() {
        _classCallCheck(this, DataDefinitionModule);

        return _possibleConstructorReturn(this, (DataDefinitionModule.__proto__ || Object.getPrototypeOf(DataDefinitionModule)).apply(this, arguments));
    }

    _createClass(DataDefinitionModule, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                open = _props.open,
                onToggleOpen = _props.onToggleOpen,
                name = _props.name,
                error = _props.error,
                keyboardShortcuts = _props.keyboardShortcuts,
                options = _props.options,
                sequenceNumber = _props.sequenceNumber,
                codingInstructions = _props.codingInstructions,
                targetValue = _props.targetValue,
                definitions = _props.definitions,
                notes = _props.notes,
                shortName = _props.shortName,
                relatedLinks = _props.relatedLinks;


            var shortcuts = keyboardShortcuts && keyboardShortcuts.slice(0, 10).map(function (option) {
                return _react2.default.createElement(
                    "li",
                    { key: option.key },
                    _react2.default.createElement(
                        "kbd",
                        null,
                        option.key
                    ),
                    "= ",
                    option.name
                );
            });
            var optionItemsDetailed = options.map(function (option) {
                return _react2.default.createElement(
                    "li",
                    { key: option.label },
                    option.label,
                    option.description ? ": " + option.description : ""
                );
            });
            var codingInstructionsItems = codingInstructions.map(function (inst) {
                return _react2.default.createElement(
                    "p",
                    { key: inst.body },
                    inst.body.trim()
                );
            });
            var targetValueItems = targetValue.map(function (tv) {
                return _react2.default.createElement(
                    "p",
                    { key: tv.body },
                    tv.body.trim()
                );
            });
            var definitonItems = definitions.map(function (d, i) {
                return _react2.default.createElement(
                    "div",
                    { key: d.term },
                    _react2.default.createElement(
                        "strong",
                        null,
                        d.term
                    ),
                    _react2.default.createElement(
                        "p",
                        null,
                        d.definition.trim(),
                        _react2.default.createElement("br", null),
                        _react2.default.createElement(
                            "cite",
                            null,
                            d.source
                        )
                    )
                );
            });
            var noteItems = notes.map(function (note) {
                return _react2.default.createElement(
                    "p",
                    { key: note.body },
                    note.body.trim()
                );
            });
            var relatedLinksItems = relatedLinks.map(function (note) {
                var body = note.body;
                // find and replace all the MD links in body and convert them to html links that open in a new tab.
                var regexMdLinks = /\[([^[]+)](\([^)]*\))/gm;
                var mdLinkMatches = body.match(regexMdLinks);
                var singleMatch = /\[([^[]+)]\((.*)\)/;
                for (var i = 0; i < mdLinkMatches.length; i++) {
                    var linkInfo = singleMatch.exec(mdLinkMatches[i]);

                    var _linkInfo = _slicedToArray(linkInfo, 3),
                        title = _linkInfo[1],
                        url = _linkInfo[2];

                    body = body.replace(mdLinkMatches[i], "<a href=\"" + url + "\" target=\"_blank\">" + title + "</a>");
                }
                return _react2.default.createElement("li", { key: note.body, dangerouslySetInnerHTML: { __html: body } });
            });
            var headingTitle = name ? name + " - Definition" : "";
            return _react2.default.createElement(
                "div",
                { className: "data-definitions " + (open === null ? "neutral" : open ? "expanded" : "collapsed") },
                _react2.default.createElement(
                    "div",
                    { className: "panel-heading", onClick: onToggleOpen },
                    headingTitle,
                    "\u200B"
                ),
                _react2.default.createElement(
                    "div",
                    { className: "panel-body" },
                    error ? _react2.default.createElement(
                        "h2",
                        null,
                        "Unable to load definitions from server due to network error."
                    ) : _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        shortcuts && _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            _react2.default.createElement(
                                "div",
                                { className: "section-title" },
                                "Keyboard Shortcuts"
                            ),
                            _react2.default.createElement(
                                "ul",
                                { className: "keyboard-shortcuts" },
                                shortcuts
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "section-title" },
                            "Field Definitions"
                        ),
                        _react2.default.createElement(
                            "dl",
                            { className: "field-definitions" },
                            sequenceNumber && _react2.default.createElement(
                                _react2.default.Fragment,
                                null,
                                _react2.default.createElement(
                                    "dt",
                                    { className: "pull-left" },
                                    "Seq. #:"
                                ),
                                _react2.default.createElement(
                                    "dd",
                                    { className: "text-right" },
                                    sequenceNumber
                                )
                            ),
                            shortName && _react2.default.createElement(
                                _react2.default.Fragment,
                                null,
                                _react2.default.createElement(
                                    "dt",
                                    { className: "pull-left" },
                                    "Short Name:"
                                ),
                                _react2.default.createElement(
                                    "dd",
                                    { className: "text-right" },
                                    shortName
                                )
                            ),
                            codingInstructions.length > 0 && _react2.default.createElement(
                                _react2.default.Fragment,
                                null,
                                _react2.default.createElement(
                                    "dt",
                                    null,
                                    "Coding Instruction"
                                ),
                                _react2.default.createElement(
                                    "dd",
                                    null,
                                    codingInstructionsItems
                                )
                            ),
                            targetValue.length > 0 && _react2.default.createElement(
                                _react2.default.Fragment,
                                null,
                                _react2.default.createElement(
                                    "dt",
                                    null,
                                    "Target Value"
                                ),
                                _react2.default.createElement(
                                    "dd",
                                    null,
                                    targetValueItems
                                )
                            ),
                            options.length > 0 && _react2.default.createElement(
                                _react2.default.Fragment,
                                null,
                                _react2.default.createElement(
                                    "dt",
                                    null,
                                    "Selections"
                                ),
                                _react2.default.createElement(
                                    "dd",
                                    null,
                                    _react2.default.createElement(
                                        "ul",
                                        { className: "selection-definitions" },
                                        optionItemsDetailed
                                    )
                                )
                            ),
                            definitions.length > 0 && _react2.default.createElement(
                                _react2.default.Fragment,
                                null,
                                _react2.default.createElement(
                                    "dt",
                                    null,
                                    "Supporting Definitions"
                                ),
                                _react2.default.createElement(
                                    "dd",
                                    null,
                                    definitonItems
                                )
                            ),
                            notes.length > 0 && _react2.default.createElement(
                                _react2.default.Fragment,
                                null,
                                _react2.default.createElement(
                                    "dt",
                                    null,
                                    "Additional Notes"
                                ),
                                _react2.default.createElement(
                                    "dd",
                                    null,
                                    noteItems
                                )
                            ),
                            relatedLinks.length > 0 && _react2.default.createElement(
                                _react2.default.Fragment,
                                null,
                                _react2.default.createElement(
                                    "dt",
                                    null,
                                    "Related Links"
                                ),
                                _react2.default.createElement(
                                    "dd",
                                    null,
                                    _react2.default.createElement(
                                        "ul",
                                        { className: "links-definitions" },
                                        relatedLinksItems
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return DataDefinitionModule;
}(_react2.default.Component);

exports.default = DataDefinitionModule;


DataDefinitionModule.propTypes = {
    name: _propTypes2.default.string,
    error: _propTypes2.default.any,
    open: _propTypes2.default.any,
    onToggleOpen: _propTypes2.default.func.isRequired,
    options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        label: _propTypes2.default.string.isRequired,
        description: _propTypes2.default.string
    })).isRequired,
    keyboardShortcuts: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        key: _propTypes2.default.string.isRequired,
        name: _propTypes2.default.string.isRequired
    })),
    sequenceNumber: _propTypes2.default.string,
    shortName: _propTypes2.default.string,
    codingInstructions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        body: _propTypes2.default.string.isRequired
    })).isRequired,
    targetValue: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        body: _propTypes2.default.string.isRequired
    })).isRequired,
    definitions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        term: _propTypes2.default.string.isRequired,
        definition: _propTypes2.default.string.isRequired,
        source: _propTypes2.default.string
    })).isRequired,
    notes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        body: _propTypes2.default.string.isRequired
    })).isRequired,
    relatedLinks: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        body: _propTypes2.default.string.isRequired
    })).isRequired
};

DataDefinitionModule.defaultProps = {
    options: [],
    codingInstructions: [],
    targetValue: [],
    definitions: [],
    notes: [],
    relatedLinks: []
};

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(13);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _DataDefActions = __webpack_require__(484);

var _DataDefActions2 = _interopRequireDefault(_DataDefActions);

var _storeUtils = __webpack_require__(54);

var _dotPropImmutable = __webpack_require__(40);

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _DataManager = __webpack_require__(43);

var _DataManager2 = _interopRequireDefault(_DataManager);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

var _ActiveFormStore = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var keyPath = function keyPath(entityKey, fieldKey) {
    if (typeof entityKey !== "string") {
        // assume it's an action
        var a = entityKey;
        entityKey = a.entityKey;
        fieldKey = a.fieldKey;
    }
    return entityKey + "." + fieldKey;
};

/*
 * Once we get to `model.json` (or whatever), this will become obsolete-ish...
 */

var DataDefStore = function (_ReduceStore) {
    _inherits(DataDefStore, _ReduceStore);

    function DataDefStore() {
        _classCallCheck(this, DataDefStore);

        return _possibleConstructorReturn(this, (DataDefStore.__proto__ || Object.getPrototypeOf(DataDefStore)).call(this, _Dispatcher2.default));
    }

    _createClass(DataDefStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {};
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {
                case _DataDefActions2.default.START_LOAD:
                    this.__dispatcher.waitFor([_userStore2.default.getDispatchToken()]);
                    // todo: withPropTypes!
                    return _dotPropImmutable2.default.set(state, [keyPath(action)], _LoadObject2.default.empty().loading(_DataManager2.default.loadDataDefinition(action.entityKey, action.fieldKey, _userStore2.default.getActiveOrgKey())));
                case _DataDefActions2.default.LOADED:
                    return _dotPropImmutable2.default.set(state, [keyPath(action)], function (lo) {
                        return lo.receiveValue(action.data);
                    });
                case _DataDefActions2.default.LOAD_ERROR:
                    return _dotPropImmutable2.default.set(state, [keyPath(action)], function (lo) {
                        return lo.receiveError(action.error);
                    });
                default:
                    return state;
            }
        }
    }, {
        key: "getDefinitions",
        value: function getDefinitions(entityKey, fieldKey) {
            return this.getDefinitionsLO(entityKey, fieldKey).getRequiredValue();
        }
    }, {
        key: "getDefinitionsLO",
        value: function getDefinitionsLO(entityKey, fieldKey) {
            var _this2 = this;

            (0, _invariant2.default)(entityKey && fieldKey && fieldKey !== _ActiveFormStore.FIRST_FIELD, "C'mon, field '" + entityKey + "." + fieldKey + "'? Really?");
            return (0, _storeUtils.hotLoadObject)(function () {
                return _this2.getState()[keyPath(entityKey, fieldKey)];
            }, function () {
                return _Dispatcher2.default.dispatch({
                    type: _DataDefActions2.default.START_LOAD,
                    entityKey: entityKey,
                    fieldKey: fieldKey
                });
            });
        }
    }]);

    return DataDefStore;
}(_utils.ReduceStore);

exports.default = new DataDefStore();

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*  
                                                                                                                                                                                                                                                                      AI Suggest Container - 
                                                                                                                                                                                                                                                                      This is where the the AI Suggest store state is connected to the view and then kicks off the rendering of the react module.
                                                                                                                                                                                                                                                                      All events flow through this file.
                                                                                                                                                                                                                                                                  */

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _AbstractionAiModule = __webpack_require__(1429);

var _AbstractionAiModule2 = _interopRequireDefault(_AbstractionAiModule);

var _ActiveFormStore = __webpack_require__(112);

var _ActiveFormStore2 = _interopRequireDefault(_ActiveFormStore);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _AbstractionAiStore = __webpack_require__(624);

var _AbstractionAiStore2 = _interopRequireDefault(_AbstractionAiStore);

var _NavigationActions = __webpack_require__(80);

var _NavigationActions2 = _interopRequireDefault(_NavigationActions);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

var _safeContextDispatch = __webpack_require__(251);

var _safeContextDispatch2 = _interopRequireDefault(_safeContextDispatch);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _AbstractionAiActions = __webpack_require__(321);

var _AbstractionAiActions2 = _interopRequireDefault(_AbstractionAiActions);

var _HybridConfig = __webpack_require__(41);

var _HybridConfig2 = _interopRequireDefault(_HybridConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AbstractionAiContainer = function AbstractionAiContainer(props) {
    var ctx = props.fluxContext;
    var state = (0, _useFluxStore2.default)(function () {
        var ctrl = _ActiveFormStore2.default.getActiveControl(ctx);
        var next = {};
        if (ctrl == null) return next;
        var fieldInfo = _entityFieldMetaStore2.default.getInfo(ctrl.entityKey, ctrl.fieldKey);
        var lo = _AbstractionAiStore2.default.getAbstractionAiSuggestLO(ctx, ctrl.entityKey, ctrl.fieldKey);
        if (lo.hasValue()) {
            Object.assign(next, lo.getRequiredValue());
        }
        if (lo.hasError()) {
            Object.assign(next, { error: true });
        }
        next.feedbackEnabled = _HybridConfig2.default.get("aiAnalytics.enabled", false);
        next.key = ctrl.entityKey + ctrl.fieldKey;
        next.isLoading = lo.isLoading();
        next.shortName = ctrl.fieldKey;
        next.name = fieldInfo.name;
        next.keyboardShortcuts = ctrl.keyboardShortcuts;
        next.getFieldLabel = function (entityKey, fieldKey) {
            return _entityFieldMetaStore2.default.getInfo(entityKey, fieldKey).name;
        };
        next.getEntityLabel = function (entityKey) {
            return _entityMetaStore2.default.getInfo(entityKey).name;
        };
        next.onNavToField = function (entityKey, recordId, fieldKey) {
            (0, _safeContextDispatch2.default)(ctx, {
                type: _NavigationActions2.default.SELECT_RECORD,
                entityKey: entityKey,
                recordId: recordId,
                fieldKey: fieldKey
            });
        };
        next.onFeedback = function (evidenceId, feedback) {
            (0, _safeContextDispatch2.default)(ctx, {
                type: _AbstractionAiActions2.default.FEEDBACK,
                evidenceId: evidenceId,
                feedback: feedback
            });
        };

        next.getFeedback = function (evidenceId) {
            return _AbstractionAiStore2.default.getFeedback(ctx, evidenceId);
        };
        return next;
    }, [_ActiveFormStore2.default, _AbstractionAiStore2.default, _entityFieldMetaStore2.default], [ctx]);
    return _react2.default.createElement(_AbstractionAiModule2.default, _extends({}, state, { open: props.open, onToggleOpen: props.onToggleOpen }));
};

AbstractionAiContainer.propTypes = {
    fluxContext: _propTypes2.default.string.isRequired,
    open: _propTypes2.default.any,
    onToggleOpen: _propTypes2.default.func.isRequired
};

exports.default = AbstractionAiContainer;

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /*  
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             AI Suggest Module - 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             This is where the meat of the ract UI lives for AI Suggest. 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             The AI Suggest right pane inners and all its subsections are rendered from this file. 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             TODO: this is where you will hook into the data that is returned from the new ai suggest store service api.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         */

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _testUtils = __webpack_require__(623);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MaskConstants = __webpack_require__(219);

var _MaskConstants2 = _interopRequireDefault(_MaskConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var highlightText = function highlightText() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var words = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var out = text;
    words.forEach(function (word) {
        var reg = new RegExp("" + word, "gi");
        out.replace(reg, "<span class=\"answer-highlight\">" + word + "</span>");
    });
    return out;
};
var AbstractionAiSuggestion = function AbstractionAiSuggestion(_ref) {
    var answer = _ref.answer,
        keyboardShortcuts = _ref.keyboardShortcuts,
        referenceDocuments = _ref.referenceDocuments,
        _onClick = _ref.onClick,
        feedbackEnabled = _ref.feedbackEnabled,
        onFeedback = _ref.onFeedback,
        getFeedback = _ref.getFeedback;

    var _React$useState = _react2.default.useState(null),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        expand = _React$useState2[0],
        setExpand = _React$useState2[1];

    var total = 0;
    var hasShortcuts = false;
    var suggestion = answer.suggestion;
    var primarySuggestion = suggestion.suggestion_value !== null ? [suggestion.suggestion_value.toString()] : [];
    var alternatives = !!primarySuggestion.length ? suggestion.alternatives.map(function (alt) {
        return alt.toString();
    }) : [];
    var fieldSuggestions = primarySuggestion.concat(alternatives);
    var answersInfo = fieldSuggestions.map(function (label) {
        var keyboardShortcut = keyboardShortcuts.find(function (sc) {
            return sc.name === label;
        });
        if (!!keyboardShortcut) {
            keyboardShortcut = keyboardShortcut.key;
            hasShortcuts = true;
        }
        return {
            label: label,
            keyboardShortcut: keyboardShortcut
        };
    });
    var handleKeydown = function handleKeydown(e) {
        if (!hasShortcuts) {
            return; // no shortcuts "`" does nothing.
        }
        if (e.key === "`") {
            var shortname = "suggest";
            var qs = "[data-shortname=\"" + shortname + "\"] .form-control";
            var els = document.querySelectorAll(qs);
            if (els.length) {
                answersInfo.forEach(function (answer) {
                    _testUtils.Simulate.keyDown(els[0], { "key": answer.keyboardShortcut }); // old react events
                    //els[0].dispatchEvent(new KeyboardEvent('keydown',{'key': keyboardShortcut})); // new react events
                });
            }
        }
    };

    _react2.default.useEffect(function () {
        window.addEventListener("keydown", handleKeydown);
        return function () {
            window.removeEventListener("keydown", handleKeydown);
        };
    }, [handleKeydown]);

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            "div",
            { style: { color: "rgba( 0, 0, 0, .5)" } },
            "* Ai-Suggested Answer(s) are intended to supplement your review of all relevant records related to the episode."
        ),
        _react2.default.createElement(
            "div",
            { className: "section-title" },
            "Suggested Answer *"
        ),
        _react2.default.createElement(
            "ul",
            { className: "keyboard-shortcuts" },
            answersInfo.map(function (answer) {
                return _react2.default.createElement(
                    "li",
                    { key: answer.label },
                    !!answer.keyboardShortcut && _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        _react2.default.createElement(
                            "kbd",
                            { title: "Keyboard Shortcut = " + answer.keyboardShortcut + " - " + answer.label },
                            answer.keyboardShortcut
                        ),
                        "= \xA0"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "chip chip-blue" },
                        _react2.default.createElement(
                            "span",
                            { className: "chip-content" },
                            answer.label
                        )
                    )
                );
            })
        ),
        _react2.default.createElement("br", null),
        suggestion.reasoning && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                "div",
                { className: "section-title" },
                "Explanation for AI Suggested Answer"
            ),
            _react2.default.createElement(
                "p",
                null,
                suggestion.reasoning
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "section-title" },
            "Relevant Notes"
        ),
        _react2.default.createElement(
            "ol",
            { className: "evidence-list" },
            suggestion.segments.map(function (segment) {
                return segment.evidence.map(function (evidence) {
                    var key = segment.document_id + "." + evidence.evidence_id;
                    var expanded = expand === key;
                    var evidenceText = highlightText(evidence.evidence_text, fieldSuggestions);
                    var segmentText = highlightText(segment.segment_text, fieldSuggestions);
                    total++;
                    var index = total;
                    var document = referenceDocuments[segment.document_id];
                    var feedback = getFeedback(evidence.evidence_id);
                    return _react2.default.createElement(
                        "li",
                        { key: key },
                        _react2.default.createElement("div", { dangerouslySetInnerHTML: { "__html": evidenceText } }),
                        _react2.default.createElement(
                            "div",
                            { className: "document-header" },
                            _react2.default.createElement("span", { className: "fa " + (expanded ? "fa-caret-down" : "fa-caret-right"), onClick: function onClick() {
                                    return setExpand(expanded ? null : key);
                                } }),
                            "\xA0",
                            _react2.default.createElement(
                                "span",
                                { className: "document-link", onClick: function onClick() {
                                        return setExpand(expanded ? null : key);
                                    } },
                                document.document_type,
                                " - ",
                                moment(document.document_created_date).format(_MaskConstants2.default.armus_date_day.momentjs)
                            ),
                            "\xA0",
                            _react2.default.createElement("span", { className: "document-details-icon fa fa-file-text-o", onClick: function onClick(e) {
                                    return _onClick(e, { segment: segment, evidence: evidence, index: index, answer: fieldSuggestions });
                                } }),
                            feedbackEnabled && _react2.default.createElement(
                                "span",
                                { className: "evidence-feedback-group" },
                                _react2.default.createElement("span", {
                                    className: "evidence-feedback feedback-good fa fa-thumbs-up " + (feedback === true ? "active" : ""),
                                    onClick: function onClick() {
                                        return onFeedback(evidence.evidence_id, true);
                                    },
                                    title: "This relevant note is good!"
                                }),
                                _react2.default.createElement("span", {
                                    className: "evidence-feedback feedback-bad fa fa-thumbs-down " + (feedback === false ? "active" : ""),
                                    onClick: function onClick() {
                                        return onFeedback(evidence.evidence_id, false);
                                    },
                                    title: "This relevant note is bad."
                                })
                            )
                        ),
                        expanded && _react2.default.createElement("div", {
                            className: "document-text",
                            dangerouslySetInnerHTML: { "__html": segmentText }
                        })
                    );
                });
            })
        )
    );
};

AbstractionAiSuggestion.propTypes = {
    onClick: _propTypes2.default.func.isRequired,
    feedbackEnabled: _propTypes2.default.bool.isRequired,
    onFeedback: _propTypes2.default.func.isRequired,
    getFeedback: _propTypes2.default.func.isRequired,
    answer: _propTypes2.default.object.isRequired,
    keyboardShortcuts: _propTypes2.default.array,
    referenceDocuments: _propTypes2.default.object.isRequired
};

var AbstractionAiDetails = function AbstractionAiDetails(_ref2) {
    var details = _ref2.details,
        referenceDocuments = _ref2.referenceDocuments;
    var evidence = details.evidence,
        segment = details.segment,
        answer = details.answer,
        index = details.index;

    var document = referenceDocuments[segment.document_id];
    var document_created_date = document.document_created_date,
        document_type = document.document_type;

    var documentText = highlightText(document.document_text, [segment.segment_text]);
    var evidence_text = highlightText(evidence.evidence_text, answer);

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            "div",
            { className: "section-title" },
            "Relevant Note"
        ),
        _react2.default.createElement(
            "ol",
            null,
            _react2.default.createElement("li", { value: index, dangerouslySetInnerHTML: { "__html": evidence_text } })
        ),
        _react2.default.createElement(
            "div",
            { className: "section-title" },
            document_type,
            " - ",
            moment(document_created_date).format(_MaskConstants2.default.armus_date_day.momentjs)
        ),
        _react2.default.createElement("div", { className: "document-details", dangerouslySetInnerHTML: { "__html": documentText } })
    );
};

AbstractionAiDetails.propTypes = {
    details: _propTypes2.default.object.isRequired,
    referenceDocuments: _propTypes2.default.object.isRequired
};

var AbstractionAiModule = function AbstractionAiModule(_ref3) {
    var isLoading = _ref3.isLoading,
        open = _ref3.open,
        onToggleOpen = _ref3.onToggleOpen,
        name = _ref3.name,
        error = _ref3.error,
        answer = _ref3.answer,
        referenceDocuments = _ref3.referenceDocuments,
        status = _ref3.status,
        keyComponents = _ref3.keyComponents,
        onNavToField = _ref3.onNavToField,
        getFieldLabel = _ref3.getFieldLabel,
        getEntityLabel = _ref3.getEntityLabel,
        keyboardShortcuts = _ref3.keyboardShortcuts,
        feedbackEnabled = _ref3.feedbackEnabled,
        _onFeedback = _ref3.onFeedback,
        getFeedback = _ref3.getFeedback;

    var _React$useState3 = _react2.default.useState(null),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        details = _React$useState4[0],
        setDetails = _React$useState4[1];

    var document = details ? referenceDocuments[details.segment.document_id] : {};
    var hasAnswer = void 0;
    var answerCount = 0;
    var statusMessage = void 0;
    switch (status) {
        case "NO_RECORD_FOUND":
            statusMessage = "No record found.";
            hasAnswer = false;
            break;
        case "APPLICATION_NOT_SUPPORTED":
            statusMessage = "Application not supported.";
            hasAnswer = false;
            break;
        case "IMPLEMENTATION_NOT_SUPPORTED":
            statusMessage = "Implementation not supported.";
            hasAnswer = false;
            break;
        case "ENTITY_NOT_SUPPORTED":
            statusMessage = "Entity not supported.";
            hasAnswer = false;
            break;
        case "INCOMPLETE_SUGGEST_KEY":
            statusMessage = _react2.default.createElement(
                _react2.default.Fragment,
                null,
                "Suggestions will be enabled when enough information has been entered to identify the record in the suggestion service. ",
                _react2.default.createElement("br", null),
                _react2.default.createElement("br", null),
                !!keyComponents.length && _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    "Fields required to enable Abstraction AI are:",
                    _react2.default.createElement("br", null)
                ),
                _react2.default.createElement(
                    "ul",
                    null,
                    keyComponents.map(function (fieldInfo) {
                        var entityKey = fieldInfo.implementation + "/" + fieldInfo.version + "/" + fieldInfo.entityName;
                        var recordId = fieldInfo.id;
                        var fieldKey = fieldInfo.fieldName;
                        var fieldLongName = getFieldLabel(entityKey, fieldKey);
                        var entityLongName = getEntityLabel(entityKey);
                        return _react2.default.createElement(
                            "li",
                            { key: entityKey + "/" + recordId + "/" + fieldKey },
                            entityLongName,
                            " - ",
                            !!recordId ? _react2.default.createElement(
                                "span",
                                {
                                    className: "shortcut-link",
                                    title: "Click here to navigate to " + entityLongName + " and provide a value for " + fieldLongName,
                                    onClick: function onClick() {
                                        return onNavToField(entityKey, recordId, fieldKey);
                                    }
                                },
                                fieldLongName
                            ) : _react2.default.createElement(
                                "strong",
                                {
                                    title: "Please navigate to a " + entityLongName + " and provide a value for " + fieldLongName
                                },
                                fieldLongName
                            )
                        );
                    })
                )
            );
            hasAnswer = false;
            break;
        case "NO_SUGGESTION_FILE":
            statusMessage = "No suggestion file available.";
            hasAnswer = false;
            break;
        case "NO_SUGGESTION_FIELD":
            statusMessage = "No suggestion field available.";
            hasAnswer = false;
            break;
        case "SUCCESS":
            statusMessage = "This field does not have any suggestions to offer at this time.";
            hasAnswer = !!answer.suggestion.suggestion_value.toString().length;
            answerCount = hasAnswer ? 1 + answer.suggestion.alternatives.length : 0;
            break;
        default:
            hasAnswer = false;
            statusMessage = "This field does not have any suggestions to offer at this time.";
    }
    var headingTitle = name ? name + " - Suggestions (" + answerCount + ")" : "";
    if (isLoading) {
        return _react2.default.createElement(
            "div",
            { className: "data-definitions suggestion-ai" },
            _react2.default.createElement(
                "div",
                { className: "panel-heading" },
                _react2.default.createElement(
                    "span",
                    null,
                    headingTitle,
                    "\u200B"
                )
            ),
            _react2.default.createElement(
                "div",
                { className: "panel-body" },
                _react2.default.createElement(
                    "div",
                    { className: "loading" },
                    _react2.default.createElement("img", { src: "images/waiting.svg", width: 25, height: 25, alt: "Loading..." }),
                    "\xA0\xA0Loading suggestion..."
                )
            )
        );
    }
    return _react2.default.createElement(
        "div",
        { className: "data-definitions suggestion-ai " + (open === null ? "neutral" : open ? "expanded" : "collapsed") },
        _react2.default.createElement(
            "div",
            { className: "panel-heading", onClick: onToggleOpen },
            error || !details || !hasAnswer ? _react2.default.createElement(
                "span",
                null,
                headingTitle,
                "\u200B"
            ) : _react2.default.createElement(
                "div",
                { className: "details-heading" },
                _react2.default.createElement(
                    "div",
                    { className: "document-details-close", onClick: function onClick(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            setDetails(null);
                        } },
                    _react2.default.createElement("span", { className: "fa fa-chevron-left" })
                ),
                _react2.default.createElement(
                    "div",
                    { className: "document-details-title" },
                    document.document_type,
                    " - ",
                    moment(document.document_created_date).format(_MaskConstants2.default.armus_date_day.momentjs)
                )
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "panel-body" },
            error || !hasAnswer ? _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    "div",
                    { className: "section-title" },
                    "No AI Suggestion is Available"
                ),
                statusMessage
            ) : !details ? _react2.default.createElement(AbstractionAiSuggestion, {
                answer: answer,
                keyboardShortcuts: keyboardShortcuts,
                referenceDocuments: referenceDocuments,
                onClick: function onClick(e, v) {
                    return setDetails(v);
                },
                feedbackEnabled: feedbackEnabled,
                onFeedback: function onFeedback(evidenceId, feedback) {
                    return _onFeedback(evidenceId, feedback);
                },
                getFeedback: getFeedback
            }) : _react2.default.createElement(AbstractionAiDetails, {
                details: details,
                referenceDocuments: referenceDocuments
            })
        )
    );
};

AbstractionAiModule.propTypes = {
    isLoading: _propTypes2.default.bool,
    name: _propTypes2.default.string,
    status: _propTypes2.default.string,
    keyComponents: _propTypes2.default.array,
    keyboardShortcuts: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        key: _propTypes2.default.string.isRequired,
        name: _propTypes2.default.string.isRequired
    })),
    error: _propTypes2.default.any,
    referenceDocuments: _propTypes2.default.object,
    answer: _propTypes2.default.object,
    onNavToField: _propTypes2.default.func,
    getFieldLabel: _propTypes2.default.func,
    getEntityLabel: _propTypes2.default.func,
    feedbackEnabled: _propTypes2.default.bool.isRequired,
    onFeedback: _propTypes2.default.func,
    getFeedback: _propTypes2.default.func,
    open: _propTypes2.default.any,
    onToggleOpen: _propTypes2.default.func.isRequired
};

AbstractionAiModule.defaultProps = {
    name: "",
    status: "",
    error: false,
    isLoading: false,
    keyboardShortcuts: [],
    referenceDocuments: {},
    answer: {}
};

exports.default = AbstractionAiModule;

/***/ }),
/* 1430 */,
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _HybridConfig = __webpack_require__(41);

var _HybridConfig2 = _interopRequireDefault(_HybridConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AbstractionAIServices = function () {
    function AbstractionAIServices() {
        _classCallCheck(this, AbstractionAIServices);

        this.enabled = _HybridConfig2.default.get("aiAnalytics.enabled", false);
        this.url = _HybridConfig2.default.get("apiRoot", false) + "analytics/";
    }

    _createClass(AbstractionAIServices, [{
        key: "sendAccept",
        value: function sendAccept(fieldSuggestionId) {
            var acceptIndices = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            return this.sendRequest("accept", {
                fieldSuggestionId: fieldSuggestionId,
                acceptIndices: acceptIndices
            });
        }
    }, {
        key: "sendFeedback",
        value: function sendFeedback(evidenceId, feedback) {
            return this.sendRequest("feedback", {
                evidenceId: evidenceId,
                feedback: feedback
            });
        }
    }, {
        key: "sendImpression",
        value: function sendImpression() {
            var hasPermission = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var fieldSuggestionId = arguments[1];

            return this.sendRequest("impression", {
                group: hasPermission,
                fieldSuggestionId: fieldSuggestionId
            });
        }
    }, {
        key: "sendRequest",
        value: function sendRequest(path, payload) {
            if (!this.enabled) {
                return new Promise(function (resolve) {
                    resolve();
                });
            }
            return $.ajax({
                type: "POST",
                url: this.url + path,
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(_extends({}, payload)),
                background: true,
                ignoreFailure: true
            });
        }
    }]);

    return AbstractionAIServices;
}();

exports.default = new AbstractionAIServices();

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FluxValidationBar = exports.ValidationBar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ActiveFormStore = __webpack_require__(112);

var _ActiveFormStore2 = _interopRequireDefault(_ActiveFormStore);

var _records = __webpack_require__(113);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _utils = __webpack_require__(175);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ValidationBar = exports.ValidationBar = function (_React$Component) {
    _inherits(ValidationBar, _React$Component);

    function ValidationBar() {
        _classCallCheck(this, ValidationBar);

        return _possibleConstructorReturn(this, (ValidationBar.__proto__ || Object.getPrototypeOf(ValidationBar)).apply(this, arguments));
    }

    _createClass(ValidationBar, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                code = _props.code,
                message = _props.message;

            return _react2.default.createElement(
                "div",
                { className: "row" },
                _react2.default.createElement(
                    "div",
                    { className: "col-md-12 msg", title: "status bar" },
                    message != null && !(0, _utils.isOk)(code) && message
                )
            );
        }
    }]);

    return ValidationBar;
}(_react2.default.Component);

ValidationBar.propTypes = {
    code: _propTypes2.default.number,
    message: _propTypes2.default.string
};

var FluxValidationBar = exports.FluxValidationBar = function FluxValidationBar(props) {
    var fluxContext = props.fluxContext;

    var state = (0, _useFluxStore2.default)(function () {
        return (0, _records.lastBlurredValidation)(fluxContext, _TableStore2.default, _ActiveFormStore2.default);
    }, [_TableStore2.default, _ActiveFormStore2.default], [fluxContext]);
    return _react2.default.createElement(ValidationBar, state);
};

FluxValidationBar.propTypes = {
    fluxContext: _propTypes2.default.string.isRequired
};

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(99);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"de_pane\">\n  <header class=\"form header\">\n  </header><!-- /header.form -->\n\n  <section class=\"entity-form-container\">\n  </section><!-- /section.entity-form-container -->\n\n  <header class=\"form footer\">\n  </header><!-- /header.form -->\n</div>\n<div class=\"de_sidebar\">\n\n</div>\n";
},"useData":true});

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

var VerticalResizableLayout, _ref,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

module.exports = VerticalResizableLayout = (function(_super) {
  __extends(VerticalResizableLayout, _super);

  function VerticalResizableLayout() {
    this.resize = __bind(this.resize, this);
    this.calculatePosition = __bind(this.calculatePosition, this);
    this.onMouseMove = __bind(this.onMouseMove, this);
    this.onSliderMouseUp = __bind(this.onSliderMouseUp, this);
    this.onSliderMouseDown = __bind(this.onSliderMouseDown, this);    _ref = VerticalResizableLayout.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  VerticalResizableLayout.prototype.template = __webpack_require__(1435);

  VerticalResizableLayout.prototype.events = {
    "mousedown > .slider-wrapper": "onSliderMouseDown"
  };

  VerticalResizableLayout.prototype.ui = {
    "header": ".header",
    "topPane": ".top-pane",
    "bottomPane": ".bottom-pane",
    "slider": ".slider-wrapper"
  };

  VerticalResizableLayout.prototype.regions = {
    "header": ".header",
    "topPane": ".top-pane",
    "bottomPane": ".bottom-pane"
  };

  VerticalResizableLayout.prototype.onSliderMouseDown = function(e) {
    e.preventDefault();
    $('body').bind('mouseup', this.onSliderMouseUp);
    return $('body').bind('mousemove', this.onMouseMove);
  };

  VerticalResizableLayout.prototype.onSliderMouseUp = function(e) {
    e.preventDefault();
    $('body').unbind('mouseup', this.onSliderMouseUp);
    return $('body').unbind('mousemove', this.onMouseMove);
  };

  VerticalResizableLayout.prototype.onMouseMove = function(e) {
    e.preventDefault();
    return this.resize(this.calculatePosition(e));
  };

  VerticalResizableLayout.prototype.calculatePosition = function(e) {
    var elementOffset, offset;

    elementOffset = this.$el.offset();
    offset = elementOffset.top > 0 ? elementOffset.top : 0;
    return Math.max(20, e.pageY - offset);
  };

  VerticalResizableLayout.prototype.resize = function(position) {
    var sliderOffset;

    sliderOffset = this.ui.slider.height();
    this.ui.slider.css('top', "" + position + "px");
    this.ui.topPane.css('height', "" + (position - sliderOffset - this.ui.header.height()) + "px");
    return this.ui.bottomPane.css('top', "" + (position + sliderOffset) + "px");
  };

  return VerticalResizableLayout;

})(Backbone.Marionette.Layout);


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(99);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"header\"></div>\n<div class=\"top-pane\"></div>\n<div class=\"slider-wrapper horizontal\">\n    <div class=\"slider-base\">\n        <div class=\"slider-handle\">\n        </div>\n    </div>\n</div>\n<div class=\"bottom-pane\"></div>\n";
},"useData":true});

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FluxEntityHeader = exports.EntityHeader = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _superRecords = __webpack_require__(63);

var _NavigatorStore = __webpack_require__(33);

var _NavigatorStore2 = _interopRequireDefault(_NavigatorStore);

var _GlobalMergeButton = __webpack_require__(1437);

var _GlobalMergeButton2 = _interopRequireDefault(_GlobalMergeButton);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

var _lockStore = __webpack_require__(144);

var _lockStore2 = _interopRequireDefault(_lockStore);

var _LockMessage = __webpack_require__(625);

var _LockMessage2 = _interopRequireDefault(_LockMessage);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EntityHeader = exports.EntityHeader = function (_React$Component) {
    _inherits(EntityHeader, _React$Component);

    function EntityHeader() {
        _classCallCheck(this, EntityHeader);

        return _possibleConstructorReturn(this, (EntityHeader.__proto__ || Object.getPrototypeOf(EntityHeader)).apply(this, arguments));
    }

    _createClass(EntityHeader, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                fluxContext = _props.fluxContext,
                label = _props.label,
                detailString = _props.detailString,
                _props$allowDelete = _props.allowDelete,
                allowDelete = _props$allowDelete === undefined ? false : _props$allowDelete,
                _props$allowMerge = _props.allowMerge,
                allowMerge = _props$allowMerge === undefined ? false : _props$allowMerge,
                typeLabel = _props.typeLabel,
                onClick = _props.onClick,
                pesslock = _props.pesslock;

            return _react2.default.createElement(
                "h1",
                { className: "top" },
                _react2.default.createElement(
                    "span",
                    { className: "entity-label" },
                    label
                ),
                "\xA0",
                _react2.default.createElement(
                    "small",
                    null,
                    detailString && _react2.default.createElement(
                        "span",
                        { className: "entity-detail" },
                        detailString
                    ),
                    "\xA0",
                    _react2.default.createElement(
                        "div",
                        { className: "entity-actions" },
                        allowMerge && _react2.default.createElement(_GlobalMergeButton2.default, {
                            fluxContext: fluxContext
                        }),
                        allowDelete && onClick && _react2.default.createElement(
                            "button",
                            {
                                className: "btn btn-small btn-delete deleteRoot btn-dark",
                                onClick: onClick
                            },
                            _react2.default.createElement("span", null),
                            " Delete ",
                            typeLabel
                        ),
                        _react2.default.createElement(_LockMessage2.default, { lock: pesslock })
                    )
                )
            );
        }
    }]);

    return EntityHeader;
}(_react2.default.Component);

EntityHeader.propTypes = {
    fluxContext: _propTypes2.default.string,
    label: _propTypes2.default.string,
    onClick: _propTypes2.default.func.isRequired,
    onMergeClick: _propTypes2.default.func,
    detailString: _propTypes2.default.string,
    allowDelete: _propTypes2.default.bool,
    allowMerge: _propTypes2.default.bool,
    typeLabel: _propTypes2.default.string,
    pesslock: _propTypes2.default.shape(_lockStore.lockShape)
};

var FluxEntityHeader = exports.FluxEntityHeader = function FluxEntityHeader(props) {
    var fluxContext = props.fluxContext;

    var state = (0, _useFluxStore2.default)(function () {
        var magicState = _NavigatorStore2.default.getMagicState(fluxContext);
        if (magicState == null) return { gonk: true };
        var sp = _TableStore2.default.getStereotypeProxy(magicState.key, magicState.id);
        var rs = _NavigatorStore2.default.getRecordState(fluxContext);
        if (rs != null) sp.withEntityContext(rs.key);
        return {
            fluxContext: fluxContext,
            label: sp.getLabel(),
            onClick: function onClick() {
                _Dispatcher2.default.contextDispatch(fluxContext, {
                    type: _SuperRecordActions2.default.DELETE_RECORD,
                    key: magicState.key,
                    id: magicState.id
                });
            },
            detailString: sp.getDetailString(),
            allowDelete: (0, _superRecords.canDeleteSuperRecord)(sp),
            allowMerge: (0, _superRecords.canMergeSuperRecord)(sp),
            typeLabel: sp.stereoInfo.name,
            pesslock: _lockStore2.default.getPessLock(fluxContext)
        };
    }, [_StereotypesStore2.default, _TableStore2.default, _NavigatorStore2.default, _lockStore2.default], [fluxContext]);
    return state.gonk ? null : _react2.default.createElement(EntityHeader, _extends({}, props, state));
};

FluxEntityHeader.propTypes = {
    fluxContext: _propTypes2.default.string.isRequired
};

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GlobalMergeButtonView = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = __webpack_require__(52);

var _Button2 = _interopRequireDefault(_Button);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _MergeActions = __webpack_require__(59);

var _MergeActions2 = _interopRequireDefault(_MergeActions);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _NavigatorStore = __webpack_require__(33);

var _NavigatorStore2 = _interopRequireDefault(_NavigatorStore);

var _stereotypes = __webpack_require__(126);

var _MergeStore = __webpack_require__(53);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GlobalMergeButtonView = exports.GlobalMergeButtonView = function (_React$Component) {
    _inherits(GlobalMergeButtonView, _React$Component);

    function GlobalMergeButtonView() {
        _classCallCheck(this, GlobalMergeButtonView);

        return _possibleConstructorReturn(this, (GlobalMergeButtonView.__proto__ || Object.getPrototypeOf(GlobalMergeButtonView)).apply(this, arguments));
    }

    _createClass(GlobalMergeButtonView, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                _props$items = _props.items,
                items = _props$items === undefined ? [] : _props$items,
                label = _props.label,
                _onClick = _props.onClick;

            if (!_onClick || items.length === 0) {
                return null;
            }
            return _react2.default.createElement(_Button2.default, {
                label: label,
                enabled: items.length !== 0,
                className: "btn btn-small btn-secondary btn-merge mergeRoot btn-dark",
                options: items,
                onClick: function onClick(e, d, item) {
                    return _onClick && _onClick(e, item);
                },
                collapse: true
            });
        }
    }]);

    return GlobalMergeButtonView;
}(_react2.default.Component);

GlobalMergeButtonView.propTypes = {
    label: _propTypes2.default.string.isRequired,
    items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        label: _propTypes2.default.string.isRequired,
        value: _propTypes2.default.any.isRequired
    })),
    onClick: _propTypes2.default.func
};

var GlobalMergeButton = function GlobalMergeButton(props) {
    var fluxContext = props.fluxContext,
        onClick = props.onClick;

    var state = (0, _useFluxStore2.default)(function () {
        if (!fluxContext) return null;
        var magicState = _NavigatorStore2.default.getMagicState(fluxContext);
        if (!magicState) return null;
        var stereoInfo = _StereotypesStore2.default.getStereotypeByKey(magicState.key);

        var backedTables = (0, _stereotypes.getTableKeys)(stereoInfo);

        // If there is more then one table backing the sp then we should not allow
        // merging until we can guarantee that the two tables are indeed compatible.
        if (backedTables.length > 1) {
            return null;
        }

        var targetRecord = _TableStore2.default.getStereotypeProxy(magicState.key, magicState.id);
        // global merge plugins ... if we add more do it here.
        var items = [{
            label: "Merge to " + targetRecord.getLabel(),
            value: _MergeStore.MERGE_PLUGINS.GLOBAL_MERGE,
            _record: {
                stereoKey: magicState.key,
                id: magicState.id
            }
        }];
        var label = "Merge " + stereoInfo.name;
        return {
            items: items,
            label: label,
            onClick: function onClick(e, item) {
                // initialize the merge store for interactive modal.
                _Dispatcher2.default.contextDispatch(fluxContext + _MergeStore.MERGE_CONTEXT, {
                    type: _MergeActions2.default.LAUNCH_DIALOG,
                    title: item.label,
                    plugin: item.value,
                    target: item._record
                });
            }
        };
    }, [_TableStore2.default, _NavigatorStore2.default], [fluxContext, onClick]);
    return state == null ? null : _react2.default.createElement(GlobalMergeButtonView, _extends({}, props, state));
};

GlobalMergeButton.propTypes = {
    fluxContext: _propTypes2.default.string,
    onClick: _propTypes2.default.func
};

exports.default = GlobalMergeButton;

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _NavigatorColumn = __webpack_require__(1439);

var _NavigatorColumn2 = _interopRequireDefault(_NavigatorColumn);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _buildNavContainer = __webpack_require__(626);

var _buildNavContainer2 = _interopRequireDefault(_buildNavContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var magicItems = function magicItems(tree) {
    var items = [];
    tree.projections.forEach(function (p) {
        items.push({
            // one for the projection
            cid: p.implementationKey,
            label: p.implementationName,
            implKey: p.implementationKey,
            nestLevel: 0,
            selected: p.selected,
            expanded: p.expanded,
            childCount: p.childCount,
            type: "impl"
        });
        if (!p.expanded) return;
        p.versions.forEach(function (v) {
            items.push({
                // one per version
                cid: tree.isMagic ? v.versionKey : v.key,
                label: tree.isMagic ? v.versionName : v.versionName + " " + v.name,
                implKey: p.implementationKey,
                nestLevel: 1,
                selected: v.selected,
                childCount: v.childCount,
                // passthrough
                type: "record",
                versionKey: v.versionKey,
                entityKey: v.key,
                recordId: tree.id
            });
        });
    });
    if (tree.isMagic && tree.projections.length > 1) {
        items.push({
            // one for "all"
            cid: "all-impls",
            label: "All Implementations",
            selected: tree.selected,
            childCount: tree.childCount,
            // passthrough
            type: "all-impls"
        });
    }
    return items;
};

var recordItems = function recordItems(field) {
    return field.items.map(function (it) {
        return {
            cid: it.id,
            label: it.label,
            selected: it.selected,
            childCount: it.childCount,
            // passthrough
            type: "record",
            entityKey: it.entityKey,
            recordId: it.id,
            implKey: it.implKey
        };
    });
};

var ColNav = function (_React$PureComponent) {
    _inherits(ColNav, _React$PureComponent);

    function ColNav() {
        var _ref;

        _classCallCheck(this, ColNav);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = ColNav.__proto__ || Object.getPrototypeOf(ColNav)).call.apply(_ref, [this].concat(args)));

        _this.onAddItem = _this.onAddItem.bind(_this);
        _this.onRemove = _this.onRemove.bind(_this);
        _this.onSelectItem = _this.onSelectItem.bind(_this);
        return _this;
    }

    _createClass(ColNav, [{
        key: "onAddItem",
        value: function onAddItem(container, entityKey) {
            var _props = this.props,
                onAddMagicChild = _props.onAddMagicChild,
                onAddChild = _props.onAddChild;

            if (_EntityName2.default.is(container.recordKey)) {
                onAddChild(container.recordKey, container.recordId, container.key, entityKey);
            } else {
                onAddMagicChild(container.recordKey, container.recordId, entityKey);
            }
        }
    }, {
        key: "onRemove",
        value: function onRemove(container) {
            var _props2 = this.props,
                onDeleteChild = _props2.onDeleteChild,
                onDeleteMagicChild = _props2.onDeleteMagicChild;

            var item = container.items.find(function (it) {
                return it.selected;
            });
            if (_EntityName2.default.is(container.recordKey)) {
                onDeleteChild(container.recordKey, container.recordId, container.key, item.entityKey, item.id);
            } else {
                onDeleteMagicChild(item.entityKey, item.id);
            }
        }
    }, {
        key: "onSelectItem",
        value: function onSelectItem(container, item) {
            var _props3 = this.props,
                onSelectRecord = _props3.onSelectRecord,
                onSelectImpl = _props3.onSelectImpl,
                onSelectAllImpls = _props3.onSelectAllImpls;

            switch (item.type) {
                case "record":
                    onSelectRecord(item.entityKey, item.recordId);
                    break;
                case "impl":
                    onSelectImpl(item.implKey);
                    break;
                case "all-impls":
                    onSelectAllImpls();
                    break;
                default:
                    console.warn("Unrecognized '" + item.type + "' item selected?");
                    break;
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props4 = this.props,
                isSuperRecord = _props4.isSuperRecord,
                tree = _props4.tree,
                onExpansionChange = _props4.onExpansionChange;

            var columns = [];

            var addMagicRootColumn = function addMagicRootColumn(tree) {
                return columns.push(_react2.default.createElement(_NavigatorColumn2.default, {
                    key: tree.id,
                    ITid: tree.id,
                    label: tree.name + " Forms",
                    items: magicItems(tree),
                    active: true,
                    showAdd: false,
                    showRemove: false,
                    onSelectItem: function onSelectItem() {
                        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                            args[_key2] = arguments[_key2];
                        }

                        return _this2.onSelectItem.apply(_this2, [tree].concat(args));
                    },
                    onExpansionChange: onExpansionChange
                }));
            };

            var addFieldsToColumns = function addFieldsToColumns(fields) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var f = _step.value;

                        addFieldToColumns(f);
                        var sel = f.items.find(function (it) {
                            return it.selected;
                        });
                        if (sel != null) {
                            addFieldsToColumns(sel.fields);
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            };

            var addFieldToColumns = function addFieldToColumns(field) {
                var items = recordItems(field);
                return columns.push(_react2.default.createElement(_NavigatorColumn2.default, {
                    key: field.key,
                    ITid: field.key,
                    label: field.name,
                    items: items,
                    active: true,
                    showAdd: field.creatables != null && field.creatables.length > 0,
                    creatables: field.creatables.map(function (c) {
                        return {
                            value: c.key,
                            label: c.name,
                            implKey: c.implKey
                        };
                    }),
                    showRemove: items.some(function (it) {
                        return it.selected;
                    }),
                    onAddItem: function onAddItem() {
                        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                            args[_key3] = arguments[_key3];
                        }

                        return _this2.onAddItem.apply(_this2, [field].concat(args));
                    },
                    onRemove: function onRemove() {
                        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                            args[_key4] = arguments[_key4];
                        }

                        return _this2.onRemove.apply(_this2, [field].concat(args));
                    },
                    onSelectItem: function onSelectItem() {
                        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                            args[_key5] = arguments[_key5];
                        }

                        return _this2.onSelectItem.apply(_this2, [field].concat(args));
                    }
                }));
            };

            if (isSuperRecord) {
                addMagicRootColumn(tree);
                addFieldsToColumns(tree.fields);
            } else {
                addFieldsToColumns([tree]);
            }
            return _react2.default.createElement(
                "nav",
                { className: "entity navigator" },
                columns
            );
        }
    }]);

    return ColNav;
}(_react2.default.PureComponent);

ColNav.propTypes = _buildNavContainer.navShape;

var ColumnNavigator = (0, _buildNavContainer2.default)(ColNav);

ColumnNavigator.propTypes = {
    fluxContext: _propTypes2.default.string.isRequired
};

exports.default = ColumnNavigator;

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ColumnItem = __webpack_require__(1440);

var _ColumnItem2 = _interopRequireDefault(_ColumnItem);

var _ActionButton = __webpack_require__(249);

var _ActionButton2 = _interopRequireDefault(_ActionButton);

var _formatId = __webpack_require__(114);

var _formatId2 = _interopRequireDefault(_formatId);

var _typedefs = __webpack_require__(44);

var _ErrorBoundary = __webpack_require__(329);

var _ErrorBoundary2 = _interopRequireDefault(_ErrorBoundary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NavigatorColumn(props) {
    var items = props.items,
        showRemove = props.showRemove,
        active = props.active,
        label = props.label,
        showAdd = props.showAdd,
        creatables = props.creatables,
        onSelectItem = props.onSelectItem,
        ITid = props.ITid,
        onExpansionChange = props.onExpansionChange;


    var addOnClick = function addOnClick(event, d, v) {
        var onAddItem = props.onAddItem;

        onAddItem && onAddItem(v.value);
    };

    var removeOnClick = function removeOnClick(event) {
        event.preventDefault();
        props.onRemove();
    };

    var selectedRef = _react2.default.useRef(null);
    var selectedRecord = null;
    var selectedKey = null;
    var itemElements = items.map(function (it) {
        if (it.selected) {
            selectedRecord = it;
            selectedKey = selectedRecord.entityKey + "#" + selectedRecord.recordId;
        }
        return _react2.default.createElement(_ColumnItem2.default, {
            ref: it.selected ? selectedRef : null,
            key: it.cid,
            ITid: ITid + "-" + it.cid,
            label: it.label,
            datakey: it.implKey,
            nestLevel: it.nestLevel,
            selected: it.selected,
            childCount: it.childCount,
            expanded: it.nestLevel === 0 && it.expanded,
            onSelect: function onSelect() {
                return onSelectItem(it);
            },
            changeExpanded: function changeExpanded() {
                return onExpansionChange(it.implKey);
            }
        });
    });
    var activeClass = active ? "active" : "";

    _react2.default.useEffect(function () {
        if (!selectedRef.current) return;
        selectedRef.current.scrollIntoView(false);
    }, [selectedRef, selectedKey]);

    var headerStyle = {
        position: "relative"
    };

    return _react2.default.createElement(
        _ErrorBoundary2.default,
        null,
        _react2.default.createElement(
            "div",
            { className: "column " + activeClass, id: (0, _formatId2.default)(ITid, "nav-col") },
            _react2.default.createElement(
                "header",
                { style: headerStyle },
                _react2.default.createElement(
                    "span",
                    { className: "column-header" },
                    label
                ),
                showAdd && _react2.default.createElement(_ActionButton2.default, {
                    actionType: "add",
                    dataAlign: "right",
                    enabled: true,
                    onClick: addOnClick,
                    options: creatables
                }),
                showRemove && !!selectedRecord && _react2.default.createElement(_ActionButton2.default, {
                    actionType: "remove",
                    dataAlign: "right",
                    enabled: true,
                    onClick: removeOnClick,
                    entityKey: selectedRecord.entityKey,
                    disableBehaviour: "disable"
                })
            ),
            _react2.default.createElement(
                "ul",
                { className: "list-unstyled items" },
                itemElements
            )
        )
    );
}

NavigatorColumn.propTypes = {
    items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        cid: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
        key: _propTypes2.default.string, // not present for "all impls"
        implKey: _propTypes2.default.string,
        entityKey: _propTypes2.default.string,
        recordId: _typedefs.recordIdType,
        nestLevel: _propTypes2.default.number, // only for first column
        label: _propTypes2.default.string.isRequired,
        selected: _propTypes2.default.bool.isRequired,
        childCount: _propTypes2.default.number.isRequired
    })).isRequired,
    implKey: _propTypes2.default.string,
    showRemove: _propTypes2.default.bool.isRequired,
    active: _propTypes2.default.bool.isRequired,
    label: _propTypes2.default.string.isRequired,
    showAdd: _propTypes2.default.bool.isRequired,
    creatables: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.string.isRequired,
        label: _propTypes2.default.string.isRequired,
        implKey: _propTypes2.default.string.isRequired
    })),
    onAddItem: _propTypes2.default.func,
    onRemove: _propTypes2.default.func,
    onSelectItem: _propTypes2.default.func.isRequired,
    onExpansionChange: _propTypes2.default.func, // only magic root forms column
    ITid: _propTypes2.default.any
};

exports.default = NavigatorColumn;

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(51);

var _classnames2 = _interopRequireDefault(_classnames);

var _formatId = __webpack_require__(114);

var _formatId2 = _interopRequireDefault(_formatId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ColumnItem = _react2.default.forwardRef(function (props, ref) {
    var _classNames;

    var label = props.label,
        datakey = props.datakey,
        nestLevel = props.nestLevel,
        childCount = props.childCount,
        selected = props.selected,
        expanded = props.expanded,
        ITid = props.ITid;


    var onSelect = function onSelect(e) {
        e.preventDefault();
        e.stopPropagation();
        props.onSelect();
    };

    var onExpanderClick = function onExpanderClick(e) {
        e.preventDefault();
        e.stopPropagation();
        props.changeExpanded();
    };

    var expandable = datakey != null && nestLevel === 0;
    var classes = (0, _classnames2.default)("children-possible", (_classNames = {}, _defineProperty(_classNames, "nest-" + nestLevel, nestLevel != null), _defineProperty(_classNames, datakey, datakey != null), _defineProperty(_classNames, "expandable", expandable), _defineProperty(_classNames, "children-exist", childCount > 0), _defineProperty(_classNames, "active", selected), _defineProperty(_classNames, "expanded", expanded), _classNames));

    return _react2.default.createElement(
        "li",
        {
            ref: ref,
            className: classes,
            onClick: onSelect,
            id: (0, _formatId2.default)(ITid, "nav-item")
        },
        _react2.default.createElement("i", { className: (0, _classnames2.default)("expander", "glyphicon", expandable ? {
                "glyphicon-triangle-right": !expanded,
                "glyphicon-triangle-bottom": expanded
            } : "glyphicon-placeholder"),
            onClick: onExpanderClick,
            "data-key": datakey }),
        label
    );
});

ColumnItem.propTypes = {
    label: _propTypes2.default.string.isRequired,
    datakey: _propTypes2.default.string,
    nestLevel: _propTypes2.default.number,
    selected: _propTypes2.default.bool,
    childCount: _propTypes2.default.number,
    onSelect: _propTypes2.default.func.isRequired,
    changeExpanded: _propTypes2.default.func.isRequired,
    expanded: _propTypes2.default.bool,
    ITid: _propTypes2.default.any
};

exports.default = ColumnItem;

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FluxBreadcrumbNavigator = exports.BreadcrumbNavigator = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _buildNavContainer = __webpack_require__(626);

var _buildNavContainer2 = _interopRequireDefault(_buildNavContainer);

var _Button = __webpack_require__(52);

var _Button2 = _interopRequireDefault(_Button);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BreadcrumbNavigator = exports.BreadcrumbNavigator = function (_React$Component) {
    _inherits(BreadcrumbNavigator, _React$Component);

    function BreadcrumbNavigator() {
        _classCallCheck(this, BreadcrumbNavigator);

        return _possibleConstructorReturn(this, (BreadcrumbNavigator.__proto__ || Object.getPrototypeOf(BreadcrumbNavigator)).apply(this, arguments));
    }

    _createClass(BreadcrumbNavigator, [{
        key: "onSelectItem",
        value: function onSelectItem(e, item) {
            e.preventDefault();
            var _props = this.props,
                onSelectImpl = _props.onSelectImpl,
                onSelectRecord = _props.onSelectRecord;

            if (item.isMagic) {
                onSelectImpl(item.projections[0].implementationKey);
            } else {
                onSelectRecord(item.entityKey, item.id);
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                tree = _props2.tree,
                items = _props2.items,
                onDelete = _props2.onDelete;

            return _react2.default.createElement(
                "div",
                { className: "button-group" },
                _react2.default.createElement(
                    "div",
                    { className: "root" },
                    _react2.default.createElement(
                        "a",
                        { className: "entity", href: "#",
                            onClick: function onClick(e) {
                                return _this2.onSelectItem(e, tree);
                            } },
                        tree.label,
                        tree.detail && _react2.default.createElement(
                            "span",
                            { className: "entity-detail" },
                            " - ",
                            tree.detail
                        )
                    ),
                    !tree.supportsEnablement && _react2.default.createElement(_Button2.default, {
                        enabled: true,
                        onClick: onDelete,
                        options: [{
                            value: "delete",
                            label: "Delete " + tree.name
                        }],
                        className: "btn-link dropdown-toggle",
                        collapse: false
                    })
                ),
                _react2.default.createElement(
                    "div",
                    { className: "navigator btn-group" },
                    items.map(function (item) {
                        return _react2.default.createElement(
                            "span",
                            { key: item.id },
                            _react2.default.createElement("span", { className: "glyphicon glyphicon-chevron-up" }),
                            _react2.default.createElement(
                                "a",
                                { className: "title",
                                    onClick: function onClick(e) {
                                        return _this2.onSelectItem(e, item);
                                    } },
                                item.label
                            )
                        );
                    })
                )
            );
        }
    }]);

    return BreadcrumbNavigator;
}(_react2.default.Component);

BreadcrumbNavigator.propTypes = _extends({}, _buildNavContainer.navShape, {
    onDelete: _propTypes2.default.func.isRequired
});

var findSelectedItems = function findSelectedItems(tree) {
    var result = [];
    var doFields = function doFields(fields) {
        if (fields == null) return;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var f = _step.value;

                doItems(f.items);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var doItems = function doItems(items) {
        if (items == null) return;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var it = _step2.value;

                doItem(it);
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    };
    var doItem = function doItem(it) {
        if (!it.selected) return;
        result.push(it);
        doFields(it.fields);
    };
    if (tree.isMagic) {
        doFields(tree.fields);
    } else {
        doFields(tree.items[0].fields);
    }
    return result;
};

var FluxBreadcrumbNavigator = exports.FluxBreadcrumbNavigator = (0, _buildNavContainer2.default)(BreadcrumbNavigator, function (raw, contained) {
    return _extends({}, contained, {
        items: findSelectedItems(contained.tree),
        onDelete: function onDelete() {
            return _Dispatcher2.default.contextDispatch(raw.fluxContext, {
                type: _SuperRecordActions2.default.DELETE_RECORD,
                key: contained.tree.key,
                id: contained.tree.id
            });
        }
    });
});

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _FluxContainerSubscriptions = __webpack_require__(296);

var _FluxContainerSubscriptions2 = _interopRequireDefault(_FluxContainerSubscriptions);

var _distinctUntilChangedBuilder = __webpack_require__(1443);

var _distinctUntilChangedBuilder2 = _interopRequireDefault(_distinctUntilChangedBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_OPTIONS = {
    async: true
};

/*
 * I am basically identical to Flux's Container's `createFunctional`, except
 * instead of taking a React render function as my first parameter, I take an
 * arbitrary void callback. Like the render function, the callback will be
 * passed the result of invoking calculateState, though there is no concept of
 * the props or context passthrough Container provides. That is, the callback
 * and calculateState will always be passed a single arg, and getStores will be
 * passed zero args.
 *
 * Where Container returns a React HoC, CallbackContainer returns a token that
 * can be used to close it. Calling the `close()` function on the returned token
 * is equivalent to unmounting the React HoC that Container creates. Similarly,
 * where React doesn't rerender on no-op state changes, the callback won't be
 * reinvoked on no-op state changes.
 *
 * By default, the callback will be executed _asynchronously_. You may pass
 * `{async:false}` as a fourth parameter to override this behaviour.
 *
 * The use of this helper should be consider a code smell, and only invoked to
 * deal with the Flux vs. Backbone impedance mismatch. Callbacks created this
 * way are trivially converted to a Store's reduce function by creating a `case`
 * that `.waitFor`s the result of getStores, runs `calculateState` to get data
 * from them, and if it's changed, does the callback to update the store.
 */
var createFunctional = function createFunctional(callback, getStores, calculateState, options) {
    var isOpen = true;
    var realOptions = _extends({}, DEFAULT_OPTIONS, options || {});

    var prevState = undefined;
    var _fluxContainerSubscriptions = new _FluxContainerSubscriptions2.default();
    _fluxContainerSubscriptions.setStores(getStores());
    _fluxContainerSubscriptions.addListener((0, _distinctUntilChangedBuilder2.default)(function () {
        return calculateState(prevState);
    }, function (state) {
        prevState = state;
        if (realOptions.async) {
            // This is specifically designed to allow callbacks into Backbone
            // stuff, which may go back into Flux stuff and create a reentrant
            // dispatch.
            //
            // eslint-disable-next-line no-settimeout
            setTimeout(function () {
                if (isOpen) {
                    callback(state);
                }
            });
        } else {
            callback(state);
        }
    }));

    return {
        force: function force() {
            callback(calculateState(prevState));
        },
        close: function close() {
            _fluxContainerSubscriptions.reset();
            isOpen = false;
        }
    };
};

exports.default = { createFunctional: createFunctional };

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * I return a zero-arg function which when invoked will use the passed selector
 * function(s) to obtain values, and if any are different from their
 * corresponding prior value (according to `===`), pass them to the work
 * function.
 *
     f = distinctUntilChangedBuilder(
       () => 1,
       () => 2,
       (a, b) => {
         console.log("work", a, b);
         return Math.max(a, b);
       }
     )
     const x = f(); // x == 2, logs "work 1 2"
     const y = f(); // y == 2
 *
 * This is sorta like Flux's Container's pair: getStores and calculateState, but
 * with memoization.
 *
 * This is sorta like Rx's operator of the same name, but twisted to work with
 * selectors instead of an Observable pipe.
 *
 * This is sorta like reselect.
 *
 * @param selector function (or several of them) used to obtain parameter(s) for
 *  the work function
 * @param work function to invoke w/ current value(s) when they change
 * @return {Function} a zero-arg function returning work's result
 */
function distinctUntilChangedBuilder(selector, work) {
    var l = arguments.length - 1; // last one is work
    var selectors = [];
    var lastValues = [];
    for (var i = 0; i < l; i++) {
        selectors[i] = arguments[i];
        lastValues[i] = selectors[i]();
    }
    work = arguments[l];
    var lastResult = undefined;
    return function () {
        var nextValues = [];
        var invoke = false;
        for (var _i = 0; _i < l; _i++) {
            nextValues[_i] = selectors[_i]();
            invoke = invoke || lastValues[_i] !== nextValues[_i];
        }
        if (invoke) {
            lastValues = nextValues;
            lastResult = work.apply(null, lastValues);
        }
        return lastResult;
    };
}

exports.default = distinctUntilChangedBuilder;

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _DrawerLayout2 = __webpack_require__(328);

var _DrawerLayout3 = _interopRequireDefault(_DrawerLayout2);

var _asMarionetteView = __webpack_require__(101);

var _HexActions = __webpack_require__(627);

var _HexActions2 = _interopRequireDefault(_HexActions);

var _ExportForms = __webpack_require__(1445);

var _ExportForms2 = _interopRequireDefault(_ExportForms);

var _ResultsLayout = __webpack_require__(1449);

var _ResultsLayout2 = _interopRequireDefault(_ResultsLayout);

var _ExportParamActions = __webpack_require__(180);

var _ExportParamActions2 = _interopRequireDefault(_ExportParamActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormLayout = (0, _asMarionetteView.asMarionetteView)(_ExportForms2.default);

var HarvestExportModule = function (_DrawerLayout) {
    _inherits(HarvestExportModule, _DrawerLayout);

    function HarvestExportModule() {
        _classCallCheck(this, HarvestExportModule);

        return _possibleConstructorReturn(this, (HarvestExportModule.__proto__ || Object.getPrototypeOf(HarvestExportModule)).apply(this, arguments));
    }

    _createClass(HarvestExportModule, [{
        key: "initialize",
        value: function initialize(options) {
            var _this2 = this;

            this.onRender = this.onRender.bind(this);
            this.onChangeResults = this.onChangeResults.bind(this);
            this.model = options.model;
            this.delegateEvents();
            this.fluxToken = _Dispatcher2.default.register(function (action) {
                if (action.type === _HexActions2.default.RERUN_EXPORT) {
                    // The fact that we're in a dispatch is just a shitshow, but was
                    // the option while double-crossing the Marionette boundary, so
                    // just delay a tick and pretend it didn't happen.
                    //
                    // eslint-disable-next-line no-settimeout
                    setTimeout(function () {
                        _this2.onDrawerOpen();
                        _this2._rerender({
                            key: action.typeKey,
                            params: action.params
                        });
                    });
                }
            });
        }
    }, {
        key: "onDrawerOpen",
        value: function onDrawerOpen() {
            var _get2;

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            (_get2 = _get(HarvestExportModule.prototype.__proto__ || Object.getPrototypeOf(HarvestExportModule.prototype), "onDrawerOpen", this)).call.apply(_get2, [this].concat(args));
            _Dispatcher2.default.dispatch({
                type: _ExportParamActions2.default.INVALIDATE_CACHE
            });
        }
    }, {
        key: "onClose",
        value: function onClose() {
            _Dispatcher2.default.unregister(this.fluxToken);
        }
    }, {
        key: "onRender",
        value: function onRender() {
            this.onDrawerEnable();
            this.dispatch("get:harvest_history");
            this.onChangeResults(this.model);
            this._rerender();
        }
    }, {
        key: "_rerender",
        value: function _rerender(rerun) {
            this.drawer.show(new FormLayout({
                rerun: rerun
            }));
        }
    }, {
        key: "onChangeResults",
        value: function onChangeResults(model) {
            var _this3 = this;

            var collection = this.model.get("results");
            this.resultsLayout = new _ResultsLayout2.default({ model: this.model, collection: collection });
            this.content.show(this.resultsLayout);
            this.listenTo(this.resultsLayout, "get_harvest_history", function () {
                if (!_this3.open) {
                    _this3.dispatch("get:harvest_history");
                }
            });

            if (typeof model.previous("results") !== "undefined") {
                this.onDrawerClose();
            }
        }
    }]);

    return HarvestExportModule;
}(_DrawerLayout3.default);

HarvestExportModule.prototype.modelEvents = {
    "change:results": "onChangeResults"
};

exports.default = HarvestExportModule;

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

var _aggregateMembers = __webpack_require__(628);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _propertyComparatorBuilder = __webpack_require__(629);

var _propertyComparatorBuilder2 = _interopRequireDefault(_propertyComparatorBuilder);

var _Sidebar = __webpack_require__(1446);

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _formRegistry = __webpack_require__(74);

var _formRegistry2 = _interopRequireDefault(_formRegistry);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _SplitButton = __webpack_require__(501);

var _SplitButton2 = _interopRequireDefault(_SplitButton);

var _exportParamsStore = __webpack_require__(1447);

var _exportParamsStore2 = _interopRequireDefault(_exportParamsStore);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _ExportParamActions = __webpack_require__(180);

var _ExportParamActions2 = _interopRequireDefault(_ExportParamActions);

var _serializeParams = __webpack_require__(96);

var _serializeParams2 = _interopRequireDefault(_serializeParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ThereIsNoForm() {
    return _react2.default.createElement(
        "div",
        { className: "form-section-single form-horizontal" },
        _react2.default.createElement(
            "h2",
            null,
            "There is no form."
        ),
        _react2.default.createElement(
            "p",
            null,
            "This indicates a code and/or configuration - not licensing or permission - issue of some sort or another, which could be client- or server-side. Or both!"
        )
    );
}

function ExportForms(_ref) {
    var rerun = _ref.rerun;

    var _React$useState = _react2.default.useState(rerun && rerun.key || ""),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        formKey = _React$useState2[0],
        setFormKey = _React$useState2[1];

    var _React$useState3 = _react2.default.useState(rerun && rerun.params),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        initialState = _React$useState4[0],
        setInitialState = _React$useState4[1];

    var _React$useState5 = _react2.default.useState(undefined),
        _React$useState6 = _slicedToArray(_React$useState5, 2),
        exportState = _React$useState6[0],
        setExportState = _React$useState6[1];

    var _useMembersForExporte = (0, _aggregateMembers.useMembersForExporter)(formKey),
        _useMembersForExporte2 = _slicedToArray(_useMembersForExporte, 2),
        allMembers = _useMembersForExporte2[0],
        canFilterByMember = _useMembersForExporte2[1];

    var _React$useState7 = _react2.default.useState(function () {
        return rerun && rerun.params && rerun.params.activeMembers ? rerun.params.activeMembers.split(",") : [""];
    }),
        _React$useState8 = _slicedToArray(_React$useState7, 2),
        activeMembers = _React$useState8[0],
        setActiveMembers = _React$useState8[1];

    var forms = (0, _useFluxStore2.default)(function () {
        var forms = _userStore2.default.getHexForms().sort((0, _propertyComparatorBuilder2.default)("name", "key"));
        if (false) {
            var key = "example";
            if (_formRegistry2.default.hasOwnProperty(key) && forms.every(function (f) {
                return f.key !== key;
            })) {
                forms.push({
                    key: key,
                    name: "[[ Dev Example ]]"
                });
            }
        }
        // // Comment this in to allow accessing any form. In the case of aggregates, EXPORT support is assumed.
        // for (const key of Object.keys(formRegistry).sort()) {
        //     if (forms.find(it => it.key === key) != null) continue;
        //     forms.push({
        //         key,
        //         name: key
        //             .split("-")
        //             .map(s => s.length <= 3
        //                 ? s.toUpperCase()
        //                 : s.substr(0, 1).toUpperCase() + s.substr(1))
        //             .join(" "),
        //     });
        // }
        // // End access to all forms
        return forms;
    }, [_userStore2.default]);

    var allParamSetsLO = (0, _useFluxStore2.default)(function () {
        return _exportParamsStore2.default.getLoadObject();
    }, [_exportParamsStore2.default]);

    var _React$useMemo = _react2.default.useMemo(function () {
        var report = "export";
        var Form = _formRegistry2.default[formKey];
        if (!formKey) {
            return [null, null, report];
        } else if (!Form) {
            return [ThereIsNoForm, null, report];
        }
        var parts = formKey.split("-");
        var last = parts[parts.length - 1];
        if (last === "export" || last === "harvest") {
            report = last;
        }
        return [Form, Form ? Form.apiPrefix : null, report];
    }, [formKey]),
        _React$useMemo2 = _slicedToArray(_React$useMemo, 3),
        Form = _React$useMemo2[0],
        impl = _React$useMemo2[1],
        report = _React$useMemo2[2];

    var allParamSets = _react2.default.useMemo(function () {
        if (!formKey || !Form.canRerun) return undefined;
        if (!allParamSetsLO.hasValue()) return undefined;
        var byFormKey = allParamSetsLO.getValueEnforcing().reduce(function (agg, it) {
            return _extends({}, agg, _defineProperty({}, it.typeKey, (agg[it.typeKey] || []).concat(it)));
        }, {});
        var items = byFormKey[formKey];
        if (!items || items.length === 0) return undefined;
        return items.map(function (it) {
            return _extends({}, it, {
                key: it.id.toString(),
                canRerun: Form.canRerun(it.params)
            });
        }).sort((0, _propertyComparatorBuilder2.default)("name", "id"));
    }, [allParamSetsLO, formKey, Form]);

    var _React$useState9 = _react2.default.useState(),
        _React$useState10 = _slicedToArray(_React$useState9, 2),
        activeParamSet = _React$useState10[0],
        setActiveParamSet = _React$useState10[1];

    _react2.default.useEffect(function () {
        if (!activeParamSet) return;
        if (!allParamSets || allParamSets.every(function (it) {
            return it.id !== activeParamSet.id;
        })) {
            setActiveParamSet(undefined);
        }
    }, [allParamSets, activeParamSet]);

    function addMembersToParams(params) {
        if (!params) params = {};
        if (!canFilterByMember) return params;
        if (!activeMembers || activeMembers.length === 0) return params;
        if (typeof params === "string") return params;
        if (params instanceof Array) return params;
        if (params.hasOwnProperty("activeMembers")) return params;
        if (activeMembers.every(function (it) {
            return it !== "";
        })) {
            params = _extends({}, params, {
                "activeMembers": [].concat(_toConsumableArray(new Set(activeMembers))).sort().join(",")
            });
        }
        return params;
    }

    var stateWithMembers = _react2.default.useMemo(function () {
        return addMembersToParams(exportState);
    }, [exportState, activeMembers]);

    var isParamSetRerunable = _react2.default.useMemo(function () {
        if (!formKey || !Form.canRerun) return false;
        if (!stateWithMembers) return false;
        return Form.canRerun(stateWithMembers);
    }, [Form, stateWithMembers]);

    /**
     * Call me to get data from an endpoint of the exporter's API, and
     * asynchronously passed to an onData callback. For example:
     *
     * ```
     * this.needServerData({
     *     endpoint: "/date-range", // relative to the exporter's API
     *     params: {
     *         particid: e.target.value,
     *     },
     *     onData: this.buildDateRange,
     * });
     * ```
     *
     * @param options An object with at least `endpoint` and `onData` keys. A
     *  `params` key may be provided with any params to send to the endpoint.
     */
    function needServerData(options) {
        Backbone.dispatcher.trigger("load:data", impl, report, _extends({}, options, {
            params: (0, _serializeParams2.default)(addMembersToParams(options.params))
        }));
    }

    // because of marionette races, this reset must be imperative/synchronous...
    function handleFormSelect(key) {
        setFormKey(key);
        setInitialState(undefined);
        setExportState(undefined);
        setActiveMembers([""]);
        setActiveParamSet(undefined);
    }

    var handleReady = _react2.default.useCallback(function (state) {
        return setExportState(state);
    }, [setExportState]);

    var handleNotReady = _react2.default.useCallback(function () {
        return setExportState(undefined);
    }, [setExportState]);

    function handleExport() {
        if (formKey && exportState) {
            Backbone.dispatcher.trigger("get:export", impl, report, (0, _serializeParams2.default)(stateWithMembers));
            handleFormSelect("");
        } else {
            console.error("The '" + formKey + "' view is enabled, but has no state?!");
        }
    }

    function handleParamSetSelect(key) {
        var p = (allParamSets || []).find(function (it) {
            return it.key === key;
        });
        setActiveParamSet(p);
        setInitialState(p && p.params);
        setActiveMembers(p && p.params && p.params.activeMembers ? p.params.activeMembers.split(",") : [""]);
    }

    function handleParamSetRename() {
        if (!activeParamSet) return;
        _Dispatcher2.default.dispatch({
            type: _ExportParamActions2.default.RENAME,
            id: activeParamSet.id,
            oldName: activeParamSet.name
        });
    }

    function handleParamSetDelete() {
        _Dispatcher2.default.dispatch({
            type: _ExportParamActions2.default.DELETE,
            id: activeParamSet.id
        });
    }

    function handleExportAndSaveNew() {
        _Dispatcher2.default.dispatch({
            type: _ExportParamActions2.default.CREATE,
            formKey: formKey,
            params: stateWithMembers
        });
        handleExport();
    }

    function handleExportAndUpdateSelected() {
        _Dispatcher2.default.dispatch({
            type: _ExportParamActions2.default.UPDATE,
            id: activeParamSet.id,
            params: stateWithMembers
        });
        handleExport();
    }

    var exportButton = void 0;
    if (isParamSetRerunable || allParamSets && allParamSets.length) {
        exportButton = _react2.default.createElement(_SplitButton2.default, {
            key: "export-button",
            type: "primary",
            className: "search-button btn-do-export",
            disabled: !exportState,
            actions: [{
                icon: "search",
                label: "Export",
                value: "export",
                onSelect: handleExport
            }, {
                label: "Export and Save New Parameter Selection",
                value: "save",
                disabled: !isParamSetRerunable,
                onSelect: handleExportAndSaveNew
            }, {
                label: "Export and Update Parameter Selection",
                value: "restore",
                disabled: !isParamSetRerunable || !activeParamSet,
                onSelect: handleExportAndUpdateSelected
            }]
        });
    } else {
        exportButton = _react2.default.createElement(
            "button",
            {
                className: "btn btn-search btn-do-export",
                disabled: !exportState,
                type: "submit",
                onClick: handleExport
            },
            _react2.default.createElement("span", null),
            " Export"
        );
    }

    return _react2.default.createElement(
        "div",
        { className: "search-form-layout" },
        _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
                "div",
                { className: "col-md-12" },
                _react2.default.createElement(
                    "h1",
                    null,
                    "Harvest and Export"
                )
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-row form-container" },
            _react2.default.createElement(
                "div",
                { className: "form-section-container" },
                _react2.default.createElement(_Sidebar2.default, {
                    forms: forms,
                    formKey: formKey,
                    onFormSelect: handleFormSelect,
                    allParamSets: allParamSets,
                    activeParamSet: activeParamSet,
                    onParamSetSelect: handleParamSetSelect,
                    onParamSetRename: handleParamSetRename,
                    onParamSetDelete: handleParamSetDelete,
                    allMembers: canFilterByMember ? allMembers : null,
                    activeMembers: activeMembers,
                    onActiveMembersSelect: setActiveMembers
                }),
                Form && _react2.default.createElement(Form, {
                    initialState: initialState,
                    needServerData: needServerData,
                    onReady: handleReady,
                    onNotReady: handleNotReady,
                    aggregate: !!allMembers,
                    allMembers: allMembers,
                    activeMembers: canFilterByMember ? activeMembers : null
                })
            )
        ),
        _react2.default.createElement(
            "div",
            { id: "v-actions", className: "form-row" },
            _react2.default.createElement(
                "div",
                { className: "form-actions" },
                exportButton
            )
        )
    );
}

ExportForms.propTypes = {
    rerun: _propTypes2.default.shape({
        key: _propTypes2.default.string.isRequired,
        params: _propTypes2.default.shape({
            activeMembers: _propTypes2.default.string
            // ... et al
        })
    })
};

exports.default = ExportForms;

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Button = __webpack_require__(52);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * I build a histogram over the passed items, using the extractKey function to
 * assign each item to a key/bucket. The result is a Map (not an Object).
 */
function histogram(items) {
    var extractKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (it) {
        return it;
    };

    var buckets = new Map();
    items.forEach(function (it) {
        var key = extractKey(it);
        buckets.set(key, (buckets.get(key) || 0) + 1);
    });
    return buckets;
}

function Sidebar(_ref) {
    var forms = _ref.forms,
        formKey = _ref.formKey,
        onFormSelect = _ref.onFormSelect,
        allParamSets = _ref.allParamSets,
        activeParamSet = _ref.activeParamSet,
        onParamSetSelect = _ref.onParamSetSelect,
        onParamSetRename = _ref.onParamSetRename,
        onParamSetDelete = _ref.onParamSetDelete,
        allMembers = _ref.allMembers,
        activeMembers = _ref.activeMembers,
        onActiveMembersSelect = _ref.onActiveMembersSelect;

    var formOpts = _react2.default.useMemo(function () {
        return [{
            key: "",
            name: ""
        }].concat(forms);
    }, [forms]);
    var params = _react2.default.useMemo(function () {
        if (allParamSets && allParamSets.length > 1) {
            var names = histogram(allParamSets, function (it) {
                return it.name;
            });
            if (allParamSets.length > names.size) {
                allParamSets = allParamSets.map(function (it) {
                    if (names.get(it.name) === 1) {
                        return it;
                    }
                    return _extends({}, it, {
                        name: it.name + " (" + new Date(it.createdAt).toLocaleDateString() + ")"
                    });
                });
            }
        }
        return [{
            key: "",
            name: ""
        }].concat(allParamSets);
    }, [allParamSets]);
    var members = _react2.default.useMemo(function () {
        if (!allMembers) return null;
        return [{
            name: "All",
            key: ""
        }].concat(allMembers);
    }, [allMembers]);
    return _react2.default.createElement(
        "div",
        { className: "form-section" },
        _react2.default.createElement(
            "div",
            { className: "form-section-inner" },
            _react2.default.createElement(
                "h3",
                null,
                "Export Type"
            ),
            _react2.default.createElement(_Select2.default, {
                className: "form-control export-type-select",
                value: formKey,
                onCommitChange: onFormSelect,
                options: formOpts,
                labelKey: "name",
                valueKey: "key"
            }),
            allParamSets && _react2.default.createElement(
                "section",
                { className: "param-sets" },
                _react2.default.createElement(
                    "h3",
                    null,
                    "Saved Parameter Selections"
                ),
                _react2.default.createElement(_Select2.default, {
                    className: "form-control param-set-select",
                    value: activeParamSet && activeParamSet.key,
                    onCommitChange: onParamSetSelect,
                    options: params,
                    labelKey: "name",
                    valueKey: "key"
                }),
                activeParamSet && _react2.default.createElement(
                    "div",
                    { style: { display: "flex", justifyContent: "flex-end" } },
                    onParamSetRename && _react2.default.createElement(_Button2.default, {
                        className: "btn btn-sm btn-link param-set-rename",
                        label: "Rename",
                        icon: "pencil",
                        onClick: function onClick(e) {
                            e.preventDefault();
                            onParamSetRename();
                        },
                        enabled: true
                    }),
                    onParamSetDelete && _react2.default.createElement(_Button2.default, {
                        className: "btn btn-sm btn-link param-set-delete",
                        label: "Delete",
                        icon: "remove",
                        onClick: function onClick(e) {
                            e.preventDefault();
                            onParamSetDelete();
                        },
                        enabled: true
                    })
                ),
                activeParamSet && !activeParamSet.canRerun && "** This selection may not have reloaded correctly."
            ),
            members && _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    "h3",
                    null,
                    "Data Owners"
                ),
                _react2.default.createElement(_Select2.default, {
                    className: "form-control data-owner-select",
                    value: activeMembers || [],
                    onCommitChange: onActiveMembersSelect,
                    options: members,
                    labelKey: "name",
                    valueKey: "key",
                    multiple: true,
                    size: Math.min(members.length, 8),
                    disabled: members.length < 3
                })
            )
        )
    );
}

var selectListType = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired
}));
Sidebar.propTypes = {
    forms: selectListType.isRequired,
    formKey: _propTypes2.default.string.isRequired,
    onFormSelect: _propTypes2.default.func.isRequired,
    allParamSets: selectListType,
    activeParamSet: _propTypes2.default.shape({
        id: _propTypes2.default.number.isRequired,
        key: _propTypes2.default.string.isRequired
    }),
    onParamSetSelect: _propTypes2.default.func,
    onParamSetRename: _propTypes2.default.func,
    onParamSetDelete: _propTypes2.default.func,
    allMembers: selectListType,
    activeMembers: _propTypes2.default.arrayOf(_propTypes2.default.string),
    onActiveMembersSelect: _propTypes2.default.func
};

exports.default = Sidebar;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(13);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _LoadObjectState = __webpack_require__(1448);

var _LoadObjectState2 = _interopRequireDefault(_LoadObjectState);

var _ExportParamActions = __webpack_require__(180);

var _ExportParamActions2 = _interopRequireDefault(_ExportParamActions);

var _DataManager = __webpack_require__(43);

var _DataManager2 = _interopRequireDefault(_DataManager);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _RecordActions = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExportParamsStore = function (_ReduceStore) {
    _inherits(ExportParamsStore, _ReduceStore);

    function ExportParamsStore() {
        _classCallCheck(this, ExportParamsStore);

        return _possibleConstructorReturn(this, (ExportParamsStore.__proto__ || Object.getPrototypeOf(ExportParamsStore)).apply(this, arguments));
    }

    _createClass(ExportParamsStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            var _this2 = this;

            return new _LoadObjectState2.default(function () {
                return _this2.__dispatcher.dispatch({
                    type: _ExportParamActions2.default.START_LOAD
                });
            });
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {
                case _ExportParamActions2.default.START_LOAD:
                    {
                        _DataManager2.default.loadExportParams(_userStore2.default.getActiveOrgKey());
                        return state.setLoadObject(_LoadObject2.default.loading());
                    }

                case _ExportParamActions2.default.LOADED:
                    {
                        return state.setLoadObject(_LoadObject2.default.withValue(action.data));
                    }

                case _ExportParamActions2.default.LOAD_ERROR:
                    {
                        return state.setLoadObject(_LoadObject2.default.withError(action.error));
                    }

                case _ExportParamActions2.default.INVALIDATE_CACHE:
                    {
                        return state.setLoadObject(_LoadObject2.default.empty());
                    }

                case _ExportParamActions2.default.CREATE:
                    {
                        if (!action.name) return state;
                        _DataManager2.default.createExportParams(_userStore2.default.getActiveOrgKey(), {
                            name: action.name,
                            typeKey: action.formKey,
                            params: action.params
                        });
                        return state.mapLO(function (lo) {
                            return lo.creating();
                        });
                    }

                case _ExportParamActions2.default.UPDATE:
                    {
                        _DataManager2.default.updateExportParams(_userStore2.default.getActiveOrgKey(), {
                            id: action.id,
                            params: action.params
                        });
                        return state.mapLO(function (lo) {
                            return lo.updating();
                        });
                    }

                case _ExportParamActions2.default.RENAME:
                    {
                        if (!action.name) return state;
                        _DataManager2.default.updateExportParams(_userStore2.default.getActiveOrgKey(), {
                            id: action.id,
                            name: action.name
                        });
                        return state.mapLO(function (lo) {
                            return lo.updating();
                        });
                    }

                case _ExportParamActions2.default.DELETE:
                    {
                        if (!action[_RecordActions.OPT_USER_CONFIRMED]) return state;
                        _DataManager2.default.deleteExportParams(_userStore2.default.getActiveOrgKey(), action.id);
                        return state.mapLO(function (lo) {
                            return lo.deleting();
                        });
                    }

                case _ExportParamActions2.default.CREATED:
                    {
                        return state.mapLO(function (lo) {
                            return lo.done().map(function (value) {
                                return value.concat(action.data);
                            });
                        });
                    }

                case _ExportParamActions2.default.UPDATED:
                case _ExportParamActions2.default.RENAMED:
                    {
                        return state.mapLO(function (lo) {
                            return lo.done().map(function (value) {
                                return value.map(function (s) {
                                    return s.id === action.data.id ? action.data : s;
                                });
                            });
                        });
                    }

                case _ExportParamActions2.default.DELETED:
                    {
                        return state.mapLO(function (lo) {
                            return lo.done().map(function (value) {
                                return value.filter(function (s) {
                                    return s.id !== action.data.id;
                                });
                            });
                        });
                    }

                case _ExportParamActions2.default.CREATE_ERROR:
                case _ExportParamActions2.default.UPDATE_ERROR:
                case _ExportParamActions2.default.RENAME_ERROR:
                case _ExportParamActions2.default.DELETE_ERROR:
                    {
                        return state.mapLO(function (lo) {
                            return lo.done().setError(action.error);
                        });
                    }

                default:
                    return state;
            }
        }
    }, {
        key: "getLoadObject",
        value: function getLoadObject() {
            return this.getState().getLoadObject();
        }
    }]);

    return ExportParamsStore;
}(_utils.ReduceStore);

exports.default = new ExportParamsStore(_Dispatcher2.default);

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2014-present, Facebook, Inc.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * This source code is licensed under the BSD-style license found in the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LICENSE file in the root directory of this source tree. An additional grant
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * of patent rights can be found in the PATENTS file in the same directory.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This helps work with state that can be represented by a single load object.
 * Similar to LoadObjectMap.
 */
var LoadObjectState /*<V>*/ = function () {
  // _data: LoadObject<V>;
  // _load: () => void;
  // _shouldLoad: (lo: LoadObject<V>) => boolean;
  //
  // _preventLoadsForThisFrame: boolean;
  // _clearPreventLoadsForThisFrame: mixed;

  function LoadObjectState(load /*: () => void*/
  , shouldLoad /*?: (lo: LoadObject<V>) => boolean*/
  ) {
    _classCallCheck(this, LoadObjectState);

    this._data = _LoadObject2.default.empty();
    this._load = load;
    this._shouldLoad = shouldLoad || function (lo) {
      return lo.isEmpty();
    };
    this._preventLoadsForThisFrame = false;
    this._clearPreventLoadsForThisFrame = null;
  }

  _createClass(LoadObjectState, [{
    key: "getLoadObject",
    value: function getLoadObject() /*: LoadObject<V>*/{
      var _this = this;

      if (!this._preventLoadsForThisFrame && this._shouldLoad(this._data)) {
        this._preventLoadsForThisFrame = true;
        // eslint-disable-next-line no-settimeout
        this._clearPreventLoadsForThisFrame = setTimeout(function () {
          _this._load();
          _this._preventLoadsForThisFrame = false;
          _this._clearPreventLoadsForThisFrame = null;
        }, 0);
      }
      return this._data;
    }
  }, {
    key: "setLoadObject",
    value: function setLoadObject(lo /*: LoadObject<V>*/) /*: LoadObjectState<V>*/{
      if (lo === this._data) {
        return this;
      }
      var next = new LoadObjectState(this._load, this._shouldLoad);
      next._data = lo;
      return next;
    }
  }, {
    key: "mapLO",
    value: function mapLO(fn /*: (lo: LoadObject<V>) => LoadObject<V>*/) /*: LoadObjectState<V>*/{
      var lo = fn(this.getLoadObject());
      if (lo === this._data) {
        return this;
      }
      var next = new LoadObjectState(this._load, this._shouldLoad);
      next._data = lo;
      return next;
    }
  }, {
    key: "map",
    value: function map(fn /*: (value: V) => V*/) /*: LoadObjectState<V>*/{
      return this.mapLO(function (lo) {
        return lo.map(fn);
      });
    }
  }]);

  return LoadObjectState;
}();

exports.default = LoadObjectState;

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ResultsView = __webpack_require__(630);

var _asMarionetteView = __webpack_require__(101);

var _layout = __webpack_require__(1452);

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResultsLayout = function (_Backbone$Marionette$) {
    _inherits(ResultsLayout, _Backbone$Marionette$);

    function ResultsLayout() {
        var _ref;

        _classCallCheck(this, ResultsLayout);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = ResultsLayout.__proto__ || Object.getPrototypeOf(ResultsLayout)).call.apply(_ref, [this].concat(args)));

        _this.onRender = _this.onRender.bind(_this);
        _this.onHarvestHistoryRefresh = _this.onHarvestHistoryRefresh.bind(_this);
        return _this;
    }

    _createClass(ResultsLayout, [{
        key: "onRender",
        value: function onRender() {
            var resultsView = new ((0, _asMarionetteView.asMarionetteView)(_ResultsView.BackboneResultsView))({
                model: this.model,
                collection: this.collection || new Backbone.Collection(),
                sorts: this.model.get("sorts"),
                hasHover: false
            });
            this.results.show(resultsView);
        }
    }, {
        key: "onHarvestHistoryRefresh",
        value: function onHarvestHistoryRefresh() {
            this.trigger("get_harvest_history");
        }
    }]);

    return ResultsLayout;
}(Backbone.Marionette.Layout);

ResultsLayout.prototype.template = _layout2.default;

ResultsLayout.prototype.triggers = { "click button.refresh": "harvest:history:refresh" };

ResultsLayout.prototype.regions = {
    "header": "div.header",
    "results": "div.results",
    "footer": "div.footer"
};

exports.default = ResultsLayout;

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeneratedTemplate = function (_React$Component) {
    _inherits(GeneratedTemplate, _React$Component);

    function GeneratedTemplate() {
        _classCallCheck(this, GeneratedTemplate);

        return _possibleConstructorReturn(this, (GeneratedTemplate.__proto__ || Object.getPrototypeOf(GeneratedTemplate)).apply(this, arguments));
    }

    _createClass(GeneratedTemplate, [{
        key: "render",
        value: function render() {
            var data = this.props.data;
            var requestedAt = data.requestedAt;

            var date = new Date(requestedAt); // Fri Mar 02 2018 18:03:51 GMT+0000 (GMT)
            var dateString = date.toLocaleString(); // 3/2/2018, 6:03:51 PM
            return dateString;
        }
    }]);

    return GeneratedTemplate;
}(_react2.default.Component);

exports.default = GeneratedTemplate;


GeneratedTemplate.propTypes = {
    data: _propTypes2.default.object.isRequired
};

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ParametersTemplate;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _HexActions = __webpack_require__(627);

var _HexActions2 = _interopRequireDefault(_HexActions);

var _ResultsView = __webpack_require__(630);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ParametersTemplate(props) {
    var data = props.data;
    var params = data.params,
        typeName = data.typeName,
        typeKey = data.typeKey,
        allowRerun = data.allowRerun;

    if (!params._human) {
        // it's an old-style one...
        if (params.human) {
            // for Generic XML exports
            var label = params.label,
                text = params.human;

            params._human = {
                label: label,
                text: text
            };
        } else if (params.particid) {
            // for the society exports/harvests
            var particid = params.particid,
                start = params.start,
                end = params.end,
                quarter = params.quarter,
                year = params.year;

            var startDate = "";
            if (start != null) {
                startDate = new Date(start).toLocaleDateString();
            }
            var endDate = "";
            if (end != null) {
                if (start != null) {
                    endDate = " - ";
                }
                endDate += new Date(end).toLocaleDateString();
            }
            var quarterString = "";
            if (quarter != null) {
                quarterString = year + "Q" + quarter;
            }
            params._human = {
                text: "Participant ID: " + particid + ", " + startDate + endDate + quarterString
            };
        }
    }
    var body = void 0;
    if (params._human) {
        var _params$_human = params._human,
            _label = _params$_human.label,
            _text = _params$_human.text;

        body = _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _label && _react2.default.createElement(
                "label",
                null,
                _label
            ),
            _text
        );
    } else {
        // just dump 'em all out
        body = Object.keys(params).filter(function (p) {
            return p.charAt(0) !== "_" && params[p];
        }).map(function (p) {
            var value = params[p].toString();
            if (p === "query") {
                value = value.replace(/&&/g, " && ").replace(/\|\|/g, " || ");
            }
            return _react2.default.createElement(
                "div",
                { key: p },
                _react2.default.createElement(
                    "label",
                    null,
                    p
                ),
                value
            );
        });
    }
    var orgLookup = (0, _ResultsView.useOrgLookup)();
    var members = _react2.default.useMemo(function () {
        if (!params.activeMembers) return null;
        return params.activeMembers.split(",").map(function (k) {
            return orgLookup.hasOwnProperty(k) ? orgLookup[k].name || k : k;
        }).sort();
    }, [orgLookup, params.activeMembers]);
    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        allowRerun && _react2.default.createElement(
            "button",
            {
                className: "rerun-export btn btn-link btn-small",
                title: "Rerun this " + typeName,
                onClick: function onClick() {
                    return _Dispatcher2.default.dispatch({
                        type: _HexActions2.default.RERUN_EXPORT,
                        typeKey: typeKey,
                        params: params
                    });
                }
            },
            _react2.default.createElement("i", { className: "glyphicon glyphicon-refresh" })
        ),
        body,
        members && _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
                "label",
                null,
                "Data ",
                members.length === 1 ? "Owner" : "Owners"
            ),
            members.join(", ")
        )
    );
}

ParametersTemplate.propTypes = {
    data: _propTypes2.default.shape({
        params: _propTypes2.default.object.isRequired,
        typeName: _propTypes2.default.string.isRequired,
        typeKey: _propTypes2.default.string.isRequired,
        allowRerun: _propTypes2.default.bool
    }).isRequired
};

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(99);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"header\">\n    <button class=\"btn btn-default pull-right refresh\"><i class=\"glyphicon glyphicon-refresh\"></i> Refresh</button>\n    <div class=\"title\">\n        <h1>Harvest / Export Activity Log</h1>\n    </div>\n</div>\n<div class=\"results\"></div>\n<div class=\"footer\">\n\n</div>\n";
},"useData":true});

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _HybridConfig = __webpack_require__(41);

var _HybridConfig2 = _interopRequireDefault(_HybridConfig);

var _Model2 = __webpack_require__(83);

var _Model3 = _interopRequireDefault(_Model2);

var _Stereotypes = __webpack_require__(488);

var _Stereotypes2 = _interopRequireDefault(_Stereotypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataQualityReport = function (_Model) {
    _inherits(DataQualityReport, _Model);

    function DataQualityReport() {
        var _ref;

        _classCallCheck(this, DataQualityReport);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = DataQualityReport.__proto__ || Object.getPrototypeOf(DataQualityReport)).call.apply(_ref, [this].concat(args)));

        _this.initialize = _this.initialize.bind(_this);
        _this.resetPagination = _this.resetPagination.bind(_this);
        _this.getReportTypeKey = _this.getReportTypeKey.bind(_this);
        _this.getValidationTypeCode = _this.getValidationTypeCode.bind(_this);
        return _this;
    }

    _createClass(DataQualityReport, [{
        key: "defaults",
        value: function defaults() {
            var reportTypeOptionsCollection = new Backbone.Collection([{ name: "Summary Quality Report", key: "s" }, { name: "Detail Quality Report", key: "d" }, { name: "All Records Report", key: "a" }]);

            var validationTypeOptionCollection = new Backbone.Collection([{
                template: function template() {
                    var illegalLabel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Illegal";
                    return illegalLabel + " Values or Warning";
                },
                key: "iw",
                code: "illegal,warning"
            }, {
                template: function template() {
                    var illegalLabel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Illegal";
                    return illegalLabel + " Values";
                },
                key: "i",
                code: "illegal"
            }, {
                template: function template() {
                    var illegalLabel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Illegal";
                    return "Warnings";
                },
                key: "w",
                code: "warning"
            }]);

            return {
                stereotypes: new _Stereotypes2.default(),
                pageSize: _HybridConfig2.default.get("dqr.defaultPageSize", 500),
                reportType: reportTypeOptionsCollection.first(),
                reportTypeOptionsCollection: reportTypeOptionsCollection,

                searchParameters: new Backbone.Collection(),
                searchResults: new Backbone.Collection(),
                sorts: new Backbone.Model(),

                validationType: validationTypeOptionCollection.first(),
                validationTypeOptionCollection: validationTypeOptionCollection,

                owners: [""],

                // previously anonymous attributes
                page: null,
                serverSearchResults: null,
                stereotype: null,
                searchQuery: null
            };
        }
    }, {
        key: "initialize",
        value: function initialize() {
            var _this2 = this;

            var reportTypeOptionsCollection = this.get("reportTypeOptionsCollection");
            this.listenTo(reportTypeOptionsCollection, "selected", function (model) {
                return _this2.set("reportType", model);
            });

            var validationTypeOptionCollection = this.get("validationTypeOptionCollection");
            this.listenTo(validationTypeOptionCollection, "selected", function (model) {
                return _this2.set("validationType", model);
            });

            this.numberOfPagesToPreload = _HybridConfig2.default.get("dqr.numberOfPagesToPreload", 10);
            this.resetPagination();
        }
    }, {
        key: "resetPagination",
        value: function resetPagination() {
            this.set("page", 1);
            var pageSize = this.get("pageSize");

            // This roughly emulates what the server returns from a search request.
            var resultsModel = new Backbone.Model({
                results: new Backbone.Collection(),
                pageSize: pageSize * this.numberOfPagesToPreload,
                page: 1
            });
            this.set("serverSearchResults", resultsModel);
        }
    }, {
        key: "getReportTypeKey",
        value: function getReportTypeKey() {
            return this.get("reportType").get("key");
        }
    }, {
        key: "getValidationTypeCode",
        value: function getValidationTypeCode() {
            return this.get("validationType").get("code");
        }
    }]);

    return DataQualityReport;
}(_Model3.default);

exports.default = DataQualityReport;

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _DqrController = __webpack_require__(1455);

var _DqrController2 = _interopRequireDefault(_DqrController);

var _DataQualityReportLayout = __webpack_require__(1467);

var _DataQualityReportLayout2 = _interopRequireDefault(_DataQualityReportLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DataQualityReportModule = function DataQualityReportModule(application) {
    _classCallCheck(this, DataQualityReportModule);

    return application.module("DataQualityReport", function (mod, app, Backbone, Marionette, $, _) {
        mod.startWithParent = false;

        mod.addInitializer(function (application) {
            mod.model = application.model;

            mod.controller = new _DqrController2.default(mod);

            mod.layout = new _DataQualityReportLayout2.default({
                model: application.model.get("dataQualityReport")
            });
            mod.layout.render();

            // Freeze the object
            //Object.freeze? this
        });

        mod.on("start", function () {
            return mod.controller.dispatch("load:dqr_home");
        });

        mod.addFinalizer(function () {
            mod.controller.stopListening();
            delete mod.controller;
        });
    });
};

exports.default = DataQualityReportModule;

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _asMarionetteView = __webpack_require__(101);

var _BaseServices = __webpack_require__(76);

var _BaseServices2 = _interopRequireDefault(_BaseServices);

var _Services = __webpack_require__(110);

var _Services2 = _interopRequireDefault(_Services);

var _DataQualityForm = __webpack_require__(1456);

var _DataQualityResultsLayout = __webpack_require__(631);

var _promisify = __webpack_require__(97);

var _promisify2 = _interopRequireDefault(_promisify);

var _withOver = __webpack_require__(58);

var _withOver2 = _interopRequireDefault(_withOver);

var _SearchResults = __webpack_require__(1464);

var _SearchResults2 = _interopRequireDefault(_SearchResults);

var _DataQualityResultsCollection = __webpack_require__(1465);

var _DataQualityResultsCollection2 = _interopRequireDefault(_DataQualityResultsCollection);

var _sortsToOrder = __webpack_require__(322);

var _sortsToOrder2 = _interopRequireDefault(_sortsToOrder);

var _query_string = __webpack_require__(192);

var _query_string2 = _interopRequireDefault(_query_string);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _organizationsStore = __webpack_require__(357);

var _organizationsStore2 = _interopRequireDefault(_organizationsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MarionetteResults = (0, _asMarionetteView.asMarionetteView)(_DataQualityResultsLayout.BackboneDataQualityResultsLayout);

var DqrController = function (_Backbone$Controller) {
    _inherits(DqrController, _Backbone$Controller);

    function DqrController() {
        var _ref;

        _classCallCheck(this, DqrController);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = DqrController.__proto__ || Object.getPrototypeOf(DqrController)).call.apply(_ref, [this].concat(args)));

        _this.initialize = _this.initialize.bind(_this);
        _this.onLoadHome = _this.onLoadHome.bind(_this);
        _this.onLoadDetails = _this.onLoadDetails.bind(_this);
        _this.onSearch = _this.onSearch.bind(_this);
        _this.getSearchResults = _this.getSearchResults.bind(_this);
        return _this;
    }

    _createClass(DqrController, [{
        key: "initialize",
        value: function initialize(application) {
            this.app = application;
        }
    }, {
        key: "onLoadHome",
        value: function onLoadHome() {
            var model = this.app.model.get("dataQualityReport");
            var sb = new _DataQualityForm.DataQualityFormContainer({ model: model });
            this.app.layout.drawer.show(sb);

            var fields = model.get("stereotype").get("fields");
            var rv = new MarionetteResults({
                model: model,
                fields: fields,
                className: "empty-dqr"
            });
            this.app.layout.content.show(rv);
        }
    }, {
        key: "onLoadDetails",
        value: function onLoadDetails(model) {
            var data = model.get("data");
            if (data) {
                var mrc = model.get("magicRootCoordinates");
                var ekey = model.get("key");
                var eid = model.get("id");
                var org = data._owner;
                var key = mrc.key;
                var id = mrc.id;

                var shortname = data._shortname;
                this.dispatch("navigate", org, key, id, ekey, eid, shortname, true);
            }
        }
    }, {
        key: "onSearch",
        value: function onSearch(model, collection) {
            this.dispatch("user:activity");

            var page = model.get("page");
            var pageSize = model.get("pageSize");

            // Calculate the page we need on the server results.
            var serverSearchResults = model.get("serverSearchResults");
            var serverPageSize = serverSearchResults.get("pageSize");

            // We take the ceiling because the server side pagination is 1 indexed.
            var requestedServerPage = Math.ceil(page * pageSize / serverPageSize);

            // load search results from the server.
            this.getSearchResults(model, requestedServerPage, serverPageSize).then(function () {
                var serverSearchResults = model.get("serverSearchResults");
                var totalResultCount = serverSearchResults.get("totalResultCount");
                var serverPageSize = serverSearchResults.get("pageSize");
                var pageCount = Math.ceil(totalResultCount / pageSize);
                var results = serverSearchResults.get("results");
                var resultsModel = new Backbone.Model({
                    results: new _DataQualityResultsCollection2.default(results.slice(0, serverPageSize)),
                    page: page,
                    pageSize: serverPageSize,
                    pageCount: pageCount
                });
                model.set("searchResults", resultsModel);
            });
        }
    }, {
        key: "searchAll",
        value: function searchAll(stereotype, q, code, page, pageSize, sorts, owners) {
            // this is just a wrapper to line up searchEntity parameters with
            // loadDQRDetail and loadDQRSummary
            // 'code' is ignored and stereotype key is extracted.
            // everything else should be the same.
            return _Services2.default.searchEntity(q, sorts, stereotype.get("key"), pageSize, page, false, owners);
        }
    }, {
        key: "_getOwners",
        value: function _getOwners(model) {
            var owners = model.get("owners");
            if (owners.some(function (it) {
                return it === "";
            })) {
                return "";
            }
            return [].concat(_toConsumableArray(new Set(owners))).sort().join(",");
        }
    }, {
        key: "getSearchResults",
        value: function getSearchResults(model, page, pageSize) {
            var q = model.get("searchQuery").slice(0);
            var owners = this._getOwners(model);
            var stereotype = model.get("stereotype");

            var s = model.get("sorts");
            var sorts = (0, _sortsToOrder2.default)(s.attributes);
            var rt = model.getReportTypeKey();
            var service = rt === "d" ? _Services2.default.loadDQRDetail : rt === "a" ? this.searchAll : _Services2.default.loadDQRSummary;

            var code = model.getValidationTypeCode();

            return (0, _withOver2.default)("Searching...", function () {
                return (0, _promisify2.default)(service(stereotype, q, code, page, pageSize, sorts, owners)).then(function (data) {
                    if (_userStore2.default.isAggregate()) {
                        var byKey = _organizationsStore2.default.getKeyLookup();
                        data = _extends({}, data, {
                            results: data.results.map(function (r) {
                                return _extends({}, r, {
                                    data: _extends({}, r.data, {
                                        ao_owner_name: byKey.hasOwnProperty(r.owner) ? byKey[r.owner].name : r.owner
                                    })
                                });
                            })
                        });
                    }
                    data.results = new _DataQualityResultsCollection2.default(data.results);
                    var searchResults = new _SearchResults2.default(data);
                    return model.set("serverSearchResults", searchResults);
                }, function (jqXHR) {
                    if (jqXHR.status < 500) return;
                    console.error(jqXHR);
                    return (0, _withOver.appAlert)("An error has occurred.");
                });
            });
        }
    }, {
        key: "onExport",
        value: function onExport(model) {
            this.dispatch("user:activity");
            var stereotype = model.get("stereotype");
            var q = model.get("searchQuery");
            var owners = this._getOwners(model);
            var code = model.getValidationTypeCode();

            var s = model.get("sorts");
            var sorts = (0, _sortsToOrder2.default)(s.attributes);

            var rt = model.getReportTypeKey();

            var data = _query_string2.default.serialize({
                q: q,
                code: code,
                o: sorts,
                p: 1,
                ps: 1000000000,
                owners: owners
            });

            var path = void 0;
            if (rt === "d") {
                path = ["dqr", stereotype.get("key"), "fields"];
            } else if (rt === "a") {
                path = ["search", stereotype.get("key")];
            } else {
                path = ["dqr", stereotype.get("key")];
            }

            window.open(_BaseServices2.default.url(path) + ".xls?" + data, "_blank");
        }
    }, {
        key: "setModelAttribute",
        value: function setModelAttribute(model, attr, val) {
            model.set(attr, val);
        }
    }]);

    return DqrController;
}(Backbone.Controller);

DqrController.prototype.events = {
    "search:dataQualityReport": "onSearch",
    "load:dqr_home": "onLoadHome",
    "load:dataQualityDetails": "onLoadDetails",
    "export:dataQualityReport": "onExport",
    "set:dqr:model:attribute": "setModelAttribute"
};

exports.default = DqrController;

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DataQualityFormContainer = exports.DataQualityForm = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _DataQualityFormLayout = __webpack_require__(1457);

var _DataQualityFormLayout2 = _interopRequireDefault(_DataQualityFormLayout);

var _BackboneContainer = __webpack_require__(1459);

var _BackboneContainer2 = _interopRequireDefault(_BackboneContainer);

var _asMarionetteView = __webpack_require__(101);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _SearchFormActions = __webpack_require__(75);

var _SearchFormActions2 = _interopRequireDefault(_SearchFormActions);

var _SearchFormStore = __webpack_require__(82);

var _SearchFormStore2 = _interopRequireDefault(_SearchFormStore);

var _withOver = __webpack_require__(58);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataQualityForm = exports.DataQualityForm = function (_React$Component) {
    _inherits(DataQualityForm, _React$Component);

    function DataQualityForm(props) {
        _classCallCheck(this, DataQualityForm);

        var _this = _possibleConstructorReturn(this, (DataQualityForm.__proto__ || Object.getPrototypeOf(DataQualityForm)).call(this, props));

        _this.loadStore = props.loadSearchFormStore.bind(_this);
        _this.onExport = props.onXLSExportClick.bind(_this, props);
        _this.onSubmit = props.onFormSubmit.bind(_this, props);
        return _this;
    }

    _createClass(DataQualityForm, [{
        key: "render",
        value: function render() {
            var searchForm = this.props.searchForm;


            var props = _extends({}, this.props, {
                loadSearchFormStore: this.loadStore,
                onExport: this.onExport,
                onSubmit: this.onSubmit
            });

            return _react2.default.createElement(
                "div",
                { id: "form-dqr", className: "search-form-layout" },
                searchForm(props)
            );
        }
    }]);

    return DataQualityForm;
}(_react2.default.Component);

DataQualityForm.propTypes = {
    fluxContext: _propTypes.string.isRequired,
    loadSearchFormStore: _propTypes.func.isRequired,
    model: _propTypes.object,
    onFormSubmit: _propTypes.func.isRequired,
    onXLSExportClick: _propTypes.func.isRequired,
    pageModel: _propTypes.object,
    searchForm: _propTypes.func.isRequired
};

var DataQualityFormContainer = exports.DataQualityFormContainer = (0, _asMarionetteView.asMarionetteView)(_BackboneContainer2.default.createFunctional(function (props) {
    return _react2.default.createElement(DataQualityForm, props);
}, function (props) {
    return [];
}, function (prevState, props) {
    var fluxContext = "CTX_dqr";
    var pageSizeModel = new Backbone.Model({
        key: "pageSize",
        name: "Page Size",
        type: "integer",
        value: props.model.get("pageSize")
    });

    var loadSearchFormStore = function loadSearchFormStore(stereotypeModel) {
        // load up the SearchFormStore from a given stereotype.
        var key = stereotypeModel.get("key");
        _Dispatcher2.default.contextDispatch(fluxContext, {
            type: _SearchFormActions2.default.SELECT_STEREOTYPE,
            key: key
        });
    };

    loadSearchFormStore(props.model.get("stereotype"));

    // yes, this does smell, however it's necessary
    // in order to improve testability. this way
    // ReportOptions is decoupled from DataQualityForm
    // and thus there is no need to pass in a lot of
    // ReportOptions related props in the DataQualityForm tests.
    // although one could argue whether that's worth the smell,
    // since the number of unit tests is low and they are
    // rather primitive...
    var searchForm = function searchForm(props) {
        return _react2.default.createElement(ReportOptions, props);
    };

    return _extends({}, props, {
        fluxContext: fluxContext,
        reportTypeOptionsCollection: props.model.get("reportTypeOptionsCollection"),
        validationTypeOptionCollection: props.model.get("validationTypeOptionCollection"),
        stereotype: props.model.get("stereotype"),
        searchForm: searchForm,
        pageModel: pageSizeModel,
        loadSearchFormStore: loadSearchFormStore,
        onFormSubmit: function onFormSubmit(passedProps, e) {
            e.preventDefault();
            e.stopPropagation();

            var fluxContext = passedProps.fluxContext,
                model = passedProps.model,
                pageModel = passedProps.pageModel,
                search = passedProps.search,
                checkForm = passedProps.checkForm,
                setModelAttribute = passedProps.setModelAttribute;


            if (checkForm(fluxContext)) {
                var query = _SearchFormStore2.default.getQ(fluxContext).toAS();

                // We only pull page size on submit.
                var pageSize = pageModel.get("value");
                if (pageSize) {
                    setModelAttribute("pageSize", pageSize);
                }

                model.resetPagination();
                setModelAttribute("sorts", new Backbone.Model());
                setModelAttribute("searchQuery", query);
                search();
            }
        },
        onXLSExportClick: function onXLSExportClick(passedProps, e) {
            e.preventDefault();
            e.stopPropagation();

            var exportReport = passedProps.exportReport,
                fluxContext = passedProps.fluxContext,
                model = passedProps.model,
                checkForm = passedProps.checkForm,
                setModelAttribute = passedProps.setModelAttribute;


            if (checkForm(fluxContext)) {
                var query = _SearchFormStore2.default.getQ(fluxContext).toAS();

                model.resetPagination();
                setModelAttribute("sorts", new Backbone.Model());
                setModelAttribute("searchQuery", query);
                exportReport();
            }
        },
        checkForm: function checkForm(fluxContext) {
            // Check if any parameter has been set.
            var hasChangedValue = _SearchFormStore2.default.hasValues(fluxContext);

            if (!hasChangedValue) {
                (0, _withOver.appAlert)("Search requires at least one criterion.");
            }

            return hasChangedValue;
        },
        search: function search() {
            Backbone.dispatcher.trigger("search:dataQualityReport", props.model);
        },
        exportReport: function exportReport() {
            Backbone.dispatcher.trigger("export:dataQualityReport", props.model);
        },
        setModelAttribute: function setModelAttribute(attr, val) {
            Backbone.dispatcher.trigger("set:dqr:model:attribute", props.model, attr, val);
        }
    });
}));

var ReportOptions = _BackboneContainer2.default.createFunctional(function (props) {
    return _react2.default.createElement(_DataQualityFormLayout2.default, props);
}, function (props) {
    return [[props.model, "change:stereotype", "change:reportType", "change:validationType", "change:owners"], [props.pageModel, "change:value"]];
}, function (prevState, props) {
    // stereotype options/value
    var stereotype = props.model.get("stereotype");
    var stereotypes = props.model.get("stereotypes");
    var searchByValue = stereotype.get("key");
    var searchByOptions = stereotypes.map(function (item) {
        var value = item.get("key");
        return {
            value: value,
            // dynamic label
            label: searchByValue === value ? "Search By " + item.get("name") : item.get("name")
        };
    });
    var searchByOnCommitChange = function searchByOnCommitChange(value) {
        stereotypes.forEach(function (model) {
            var modelKey = model.get("key");
            if (modelKey === value) {
                props.model.set("stereotype", model);
                props.loadSearchFormStore(model);
            }
        });
    };

    var reportTypeValue = props.model.get("reportType").get("key");
    var reportTypes = props.model.get("reportTypeOptionsCollection");
    var reportTypeOptions = reportTypes.map(function (item) {
        return {
            value: item.get("key"),
            label: item.get("name")
        };
    });
    var reportTypeOnCommitChange = function reportTypeOnCommitChange(value) {
        reportTypes.forEach(function (model) {
            var modelKey = model.get("key");
            if (modelKey === value) {
                props.model.set("reportType", model);
            }
        });
    };

    var validationTypeValue = props.model.get("validationType").get("key");
    var validationTypes = props.model.get("validationTypeOptionCollection");
    var firstEntityKey = stereotype.get("implementations")[0].key;
    var illegalLabel = _userStore2.default.getIllegalLabel(firstEntityKey);
    var validationTypeOptions = validationTypes.map(function (item) {
        return {
            value: item.get("key"),
            label: item.get("template")(illegalLabel)
        };
    });
    var validationTypeOnCommitChange = function validationTypeOnCommitChange(value) {
        validationTypes.forEach(function (model) {
            var modelKey = model.get("key");
            if (modelKey === value) {
                props.model.set("validationType", model);
            }
        });
    };

    var ownersValue = props.model.get("owners");
    var ownersOnCommitChange = function ownersOnCommitChange(value) {
        return props.model.set("owners", value);
    };

    // page value
    var pageSizeValue = props.pageModel.get("value");
    var pageSizeOnCommitChange = function pageSizeOnCommitChange(value) {
        props.pageModel.set("value", value);
    };

    return {
        searchByOnCommitChange: searchByOnCommitChange,
        searchByOptions: searchByOptions,
        searchByValue: searchByValue,

        reportTypeOnCommitChange: reportTypeOnCommitChange,
        reportTypeValue: reportTypeValue,
        reportTypeOptions: reportTypeOptions,

        validationTypeOnCommitChange: validationTypeOnCommitChange,
        validationTypeValue: validationTypeValue,
        validationTypeOptions: validationTypeOptions,

        ownersOnCommitChange: ownersOnCommitChange,
        ownersValue: ownersValue,

        pageSizeOnCommitChange: pageSizeOnCommitChange,
        pageSizeValue: pageSizeValue,

        fluxContext: props.fluxContext,
        onSubmit: props.onSubmit,
        onExport: props.onExport
    };
});

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DataQualityFormLayout = DataQualityFormLayout;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SearchForm = __webpack_require__(233);

var _SearchForm2 = _interopRequireDefault(_SearchForm);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _Integer = __webpack_require__(1458);

var _Integer2 = _interopRequireDefault(_Integer);

var _Button = __webpack_require__(52);

var _Button2 = _interopRequireDefault(_Button);

var _aggregateMembers = __webpack_require__(628);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useSanitizeSelectionEffect(allItems, selected, updateCallback) {
    var extractKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (it) {
        return it.key;
    };

    _react2.default.useEffect(function () {
        if (!allItems) return;
        if (selected.length === 0) {
            updateCallback([extractKey(allItems[0])]);
            return;
        }
        var known = new Set(allItems.map(extractKey));
        var next = selected.filter(function (it) {
            return known.has(it);
        });
        if (selected.length !== next) {
            updateCallback(next);
        }
    }, [allItems, selected]);
}

function DataQualityFormLayout(props) {
    var searchByOnCommitChange = props.searchByOnCommitChange,
        searchByOptions = props.searchByOptions,
        searchByValue = props.searchByValue,
        reportTypeOnCommitChange = props.reportTypeOnCommitChange,
        reportTypeValue = props.reportTypeValue,
        reportTypeOptions = props.reportTypeOptions,
        validationTypeOnCommitChange = props.validationTypeOnCommitChange,
        validationTypeValue = props.validationTypeValue,
        validationTypeOptions = props.validationTypeOptions,
        ownersOnCommitChange = props.ownersOnCommitChange,
        ownersValue = props.ownersValue,
        pageSizeOnCommitChange = props.pageSizeOnCommitChange,
        pageSizeValue = props.pageSizeValue,
        fluxContext = props.fluxContext,
        onSubmit = props.onSubmit,
        onExport = props.onExport;


    var rawMembers = (0, _aggregateMembers.useMembersForStereotype)(searchByValue);
    var members = _react2.default.useMemo(function () {
        if (!rawMembers) return null;
        return [{ name: "All", key: "" }].concat(rawMembers);
    }, [rawMembers]);
    useSanitizeSelectionEffect(members, ownersValue, ownersOnCommitChange);

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
                "div",
                { className: "col-md-12" },
                _react2.default.createElement(
                    "h2",
                    null,
                    "Data Quality Report"
                )
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "form-container" },
            _react2.default.createElement(
                "div",
                { className: "row" },
                _react2.default.createElement(
                    "div",
                    { id: "dqr-report-options", className: "col-md-3" },
                    searchByOptions.length > 1 && _react2.default.createElement(_Select2.default, {
                        id: "stereotype",
                        options: searchByOptions,
                        onCommitChange: searchByOnCommitChange,
                        value: searchByValue,
                        label: "Search By"
                    }),
                    _react2.default.createElement(_Select2.default, {
                        id: "reporttype",
                        options: reportTypeOptions,
                        onCommitChange: reportTypeOnCommitChange,
                        value: reportTypeValue,
                        label: "Report Type"
                    }),
                    _react2.default.createElement(_Select2.default, {
                        id: "validationtype",
                        options: validationTypeOptions,
                        onCommitChange: validationTypeOnCommitChange,
                        value: validationTypeValue,
                        label: "Report Type",
                        disabled: reportTypeValue === "a"
                    }),
                    members && _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        _react2.default.createElement(
                            "label",
                            null,
                            "Data Owners"
                        ),
                        _react2.default.createElement(_Select2.default, {
                            id: "owner",
                            value: ownersValue,
                            onCommitChange: ownersOnCommitChange,
                            options: members,
                            labelKey: "name",
                            valueKey: "key",
                            multiple: true,
                            size: Math.min(members.length, 8),
                            disabled: members.length < 3
                        })
                    ),
                    _react2.default.createElement(
                        "label",
                        null,
                        "Page Size"
                    ),
                    _react2.default.createElement(_Integer2.default, {
                        id: "pagesize",
                        onCommitChange: pageSizeOnCommitChange,
                        value: pageSizeValue,
                        label: "Page Size"
                    })
                ),
                _react2.default.createElement(
                    "div",
                    { id: "dqr-search-form", className: "col-md-6" },
                    _react2.default.createElement(_SearchForm2.default, {
                        fluxContext: fluxContext,
                        showAdvanced: true,
                        supportsRelativeDates: true,
                        onSubmit: onSubmit
                    })
                )
            )
        ),
        _react2.default.createElement(
            "div",
            { id: "v-actions", className: "form-row" },
            _react2.default.createElement(
                "div",
                { className: "form-actions" },
                _react2.default.createElement(
                    "button",
                    { className: "btn btn-search", type: "submit",
                        onClick: onSubmit },
                    _react2.default.createElement("span", null),
                    " Search"
                ),
                " ",
                _react2.default.createElement(_Button2.default, {
                    enabled: true,
                    label: "Export",
                    options: [{ value: "xls", label: "Excel (XLS)" }],
                    className: "btn btn-export export-button",
                    collapse: false,
                    onClick: function onClick(e, d, v) {
                        return onExport(e, v.value);
                    }
                })
            )
        )
    );
}

DataQualityFormLayout.propTypes = {
    searchByOnCommitChange: _propTypes2.default.func.isRequired,
    searchByValue: _propTypes2.default.string.isRequired,
    searchByOptions: _propTypes2.default.array.isRequired,

    reportTypeOnCommitChange: _propTypes2.default.func.isRequired,
    reportTypeValue: _propTypes2.default.string.isRequired,
    reportTypeOptions: _propTypes2.default.array.isRequired,

    validationTypeOnCommitChange: _propTypes2.default.func.isRequired,
    validationTypeValue: _propTypes2.default.string.isRequired,
    validationTypeOptions: _propTypes2.default.array.isRequired,

    ownersOnCommitChange: _propTypes2.default.func.isRequired,
    ownersValue: _propTypes2.default.arrayOf(_propTypes2.default.string),

    pageSizeOnCommitChange: _propTypes2.default.func.isRequired,
    pageSizeValue: _propTypes2.default.number.isRequired,

    fluxContext: _propTypes2.default.string.isRequired,
    onSubmit: _propTypes2.default.func.isRequired,
    onExport: _propTypes2.default.func.isRequired
};

exports.default = DataQualityFormLayout;

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ControlResolver = __webpack_require__(139);

exports.default = function (props) {
  return (0, _ControlResolver.buildDescriptorControl)("IntegerField", "spinner", props);
};

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ModelSubscriptions = __webpack_require__(1460);

var _ModelSubscriptions2 = _interopRequireDefault(_ModelSubscriptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * I am a React HoC in the style of Flux's Container, but based on data stored
 * in Backbone Models. I accept the same three callbacks as Flux's Container's
 * `createFunctional`, but with slightly different semantics.
 *
 * The `getModels` callback should return an array of Watchable, which are
 * either an object that mixes in Backbone.Events, or an array containing such
 * an object followed by N event names. If no event names are passed, "all" is
 * implied.
 *
 * The `calculateState` callback receives an extra third argument for
 * registering one-shot Watchables from "further down the tree". Since Backbone
 * provides no way to aggregate events, they must be listened for at whatever
 * level emits them. One-shot Watchables registered this way will, when fired,
 * retrigger the entire container, which mirrors the way Flux's Container works,
 * and how React's default "same" checks operate.
 *
 * Unlike Flux's Container, props are always passed through, as a Backbone-based
 * container will need to get it's Model(s) from somewhere.
 *
 * @param viewFn
 * @param getModels
 * @param calculateState
 * @return {BackboneContainer}
 */
// Watchable := Model | MultiTuple<model, event...>
var createFunctional = function createFunctional(viewFn, // props -> element
getModels, // props -> list<Watchable>
calculateState) // prevState -> props -> (list<Watchable> -> void) -> nextProps
{
    var BackboneContainer = function (_React$PureComponent) {
        _inherits(BackboneContainer, _React$PureComponent);

        function BackboneContainer(props) {
            _classCallCheck(this, BackboneContainer);

            var _this = _possibleConstructorReturn(this, (BackboneContainer.__proto__ || Object.getPrototypeOf(BackboneContainer)).call(this, props));

            _this.subscriptions = new _ModelSubscriptions2.default();
            _this.oneShot = function (watchable) {
                return _this.subscriptions.addOneShotWatchable(watchable);
            };
            _this.subscriptions.setCallback(function () {
                return _this.setState(function (prevState, props) {
                    return calculateState(prevState, props, _this.oneShot);
                });
            });
            _this.subscriptions.setWatchables(getModels(props) || []);
            _this.state = calculateState(undefined, props, _this.oneShot);
            return _this;
        }

        _createClass(BackboneContainer, [{
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                var _this2 = this;

                this.subscriptions.setWatchables(getModels(nextProps));
                this.setState(function (prevState) {
                    return calculateState(prevState, nextProps, _this2.oneShot);
                });
            }
        }, {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.subscriptions.reset();
            }
        }, {
            key: "render",
            value: function render() {
                return viewFn(this.state);
            }
        }]);

        return BackboneContainer;
    }(_react2.default.PureComponent);

    return BackboneContainer;
};

exports.default = { createFunctional: createFunctional };

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function dissectWatchable(w) {
    if (!(w instanceof Array)) {
        w = [w];
    }
    var model = w.shift();
    var events = w.length === 0 ? "all" : w.join(" ");
    return { model: model, events: events };
}

/**
 * I encapsulate watching a set of Watchables (e.g., Backbone.Model) for a set
 * of events ("all" by default), and doing "something". The "something" may also
 * register one-shot Watchables which will also trigger doing "something". The
 * one-shot Watchables operate via Backbone.Events.once, and have the same
 * semantics across the entire ModelSubscription: as soon as one fires, they're
 * all unregistered. Of course, since they were registered by the "something",
 * and they do "something" when one fires, chances are good they'll be re-added
 * very shortly.
 *
 * Each Watchable is either a single object mixing in Backbone.Events, or an
 * array with the zeroth element being an object mixing in Backbone.Events and
 * the remaining elements being specific events to watch. In the former case, or
 * no events are enumerated in the latter case, the "all" event will be used.
 *
 * Note that the registerd callback is _not_ provided any information about what
 * changed, just that something changed. This is in the Flux and React style,
 * as that is the target consumer. If you care about more granular updates or
 * avoiding recalculation, it's trivial to memoize within the callback, but it's
 * up to the client to decide if it's necessary.
 *
 * One little wrinkle here is that because Backbone's event dispatch is
 * synchronous, if there are multiple events which cause an update in the same
 * tick the callback will be invoked multiple times. This can result in a lot of
 * needless work, so one-shot listeners are unregistered before being registered
 * which cuts down on a lot (but not all) of the reentrant calculations.
 */

var ModelSubscriptions = function () {
    function ModelSubscriptions() {
        _classCallCheck(this, ModelSubscriptions);

        this.watchables = null;
        this.oneShots = [];
    }

    _createClass(ModelSubscriptions, [{
        key: "setCallback",
        value: function setCallback(callback) {
            var _this = this;

            this.listener = function () {
                _this._resetOneShots();
                return callback();
            };
        }
    }, {
        key: "setWatchables",
        value: function setWatchables(watchables) {
            var _this2 = this;

            this.reset();
            // wire model listeners
            this.watchables = watchables.map(function (w) {
                var _dissectWatchable = dissectWatchable(w),
                    model = _dissectWatchable.model,
                    events = _dissectWatchable.events;

                model.on(events, _this2.listener);
                return { model: model, events: events };
            });
        }
    }, {
        key: "addOneShotWatchable",
        value: function addOneShotWatchable(watchable) {
            // wire one-shot listener
            var _dissectWatchable2 = dissectWatchable(watchable),
                model = _dissectWatchable2.model,
                events = _dissectWatchable2.events;

            model.off(events, this.listener);
            model.once(events, this.listener);
            this.oneShots.push({ model: model, events: events });
        }
    }, {
        key: "reset",
        value: function reset() {
            this._resetModels();
            this._resetOneShots();
        }
    }, {
        key: "_resetModels",
        value: function _resetModels() {
            if (this.watchables) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.watchables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var _ref = _step.value;
                        var model = _ref.model,
                            events = _ref.events;

                        model.off(events, this.listener);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                this.watchables = null;
            }
        }
    }, {
        key: "_resetOneShots",
        value: function _resetOneShots() {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = this.oneShots[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _ref2 = _step2.value;
                    var model = _ref2.model,
                        events = _ref2.events;

                    model.off(events, this.listener);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            this.oneShots = [];
        }
    }]);

    return ModelSubscriptions;
}();

exports.default = ModelSubscriptions;

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SelectionTable = __webpack_require__(234);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataQualityResults = function (_React$Component) {
    _inherits(DataQualityResults, _React$Component);

    function DataQualityResults() {
        _classCallCheck(this, DataQualityResults);

        return _possibleConstructorReturn(this, (DataQualityResults.__proto__ || Object.getPrototypeOf(DataQualityResults)).apply(this, arguments));
    }

    _createClass(DataQualityResults, [{
        key: "render",

        // REPORT_TYPE_SUMMARY: 's'
        // REPORT_TYPE_DETAIL: 'd'

        // VALIDATION_TYPE_ILLEGAL_AND_WARNING: 'iw'
        // VALIDATION_TYPE_ILLEGAL: 'i'
        // VALIDATION_TYPE_WARNING: 'w'
        value: function render() {
            return _react2.default.createElement(_SelectionTable.BackboneSelectionTable, this.props);
        }
    }]);

    return DataQualityResults;
}(_react2.default.Component);

exports.default = DataQualityResults;


DataQualityResults.propTypes = {
    collection: _propTypes2.default.instanceOf(Backbone.Collection),
    fields: _propTypes2.default.instanceOf(Backbone.Collection),
    hasStereotype: _propTypes2.default.bool.isRequired,
    reportTypeKey: _propTypes2.default.string.isRequired,
    onRecordSelection: _propTypes2.default.func,
    onSort: _propTypes2.default.func.isRequired
};

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BackbonePaginator = exports.Paginator = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _backboneConnect = __webpack_require__(127);

var _PaginatorTemplate = __webpack_require__(1463);

var _PaginatorTemplate2 = _interopRequireDefault(_PaginatorTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Paginator = exports.Paginator = function (_React$Component) {
    _inherits(Paginator, _React$Component);

    function Paginator(props) {
        _classCallCheck(this, Paginator);

        var _this = _possibleConstructorReturn(this, (Paginator.__proto__ || Object.getPrototypeOf(Paginator)).call(this, props));

        var page = props.page,
            pageSize = props.pageSize;


        _this.state = {
            pageNumber: page + "",
            pageSize: pageSize + "",
            originalPageSize: pageSize + ""
        };

        return _this;
    }

    _createClass(Paginator, [{
        key: "render",
        value: function render() {
            var pageCount = this.props.pageCount;


            var start = this.getStart();
            var end = this.getEnd();
            var hasNextPage = this.getHasNextPage();
            var hasPreviousPage = this.getHasPreviousPage();

            return _react2.default.createElement(_PaginatorTemplate2.default, {
                pageCount: pageCount,
                hasPreviousPage: hasPreviousPage,
                hasNextPage: hasNextPage,
                start: start,
                end: end,
                pageNumber: this.state.pageNumber,
                pageSize: this.state.pageSize,
                onPageNumberChange: this.onPageNumberChange.bind(this),
                onPageSizeChange: this.onPageSizeChange.bind(this),
                onPaginatorPageNext: this.onPaginatorPageNext.bind(this),
                onPaginatorPagePrevious: this.onPaginatorPagePrevious.bind(this),
                onPaginatorSubmit: this.onPaginatorSubmit.bind(this)
            });
        }
    }, {
        key: "onPaginatorPageNext",
        value: function onPaginatorPageNext(event) {
            event.preventDefault();
            var page = this.props.page;
            var originalPageSize = this.state.originalPageSize;

            this.dispatchSearch(page + 1, originalPageSize);
        }
    }, {
        key: "onPaginatorPagePrevious",
        value: function onPaginatorPagePrevious(event) {
            event.preventDefault();
            var page = this.props.page;
            var originalPageSize = this.state.originalPageSize;

            this.dispatchSearch(page - 1, originalPageSize);
        }
    }, {
        key: "onPaginatorSubmit",
        value: function onPaginatorSubmit(event) {
            event.preventDefault();
            var _state = this.state,
                pageSize = _state.pageSize,
                pageNumber = _state.pageNumber;

            this.dispatchSearch(pageNumber, pageSize);
        }
    }, {
        key: "dispatchSearch",
        value: function dispatchSearch(page, pageSize) {
            var search = this.props.search;

            search(page, pageSize);
        }
    }, {
        key: "onPageNumberChange",
        value: function onPageNumberChange(event) {
            var value = event.target.value;
            this.setState({
                pageNumber: value
            });
        }
    }, {
        key: "onPageSizeChange",
        value: function onPageSizeChange(event) {
            var value = event.target.value;
            this.setState({
                pageSize: value
            });
        }
    }, {
        key: "getStart",
        value: function getStart() {
            var _props = this.props,
                pageSize = _props.pageSize,
                page = _props.page;

            if (pageSize == null) {
                return 1;
            }
            var zeroIndexPageNumber = page - 1;
            return zeroIndexPageNumber * pageSize + 1;
        }
    }, {
        key: "getEnd",
        value: function getEnd() {
            var _props2 = this.props,
                pageSize = _props2.pageSize,
                page = _props2.page,
                results = _props2.results;

            if (pageSize == null) {
                return 0;
            }
            var zeroIndexPageNumber = page - 1;
            var currentPageLength = results ? results.length : 0;
            return zeroIndexPageNumber * pageSize + currentPageLength;
        }
    }, {
        key: "getHasNextPage",
        value: function getHasNextPage() {
            var _props3 = this.props,
                page = _props3.page,
                pageCount = _props3.pageCount;

            if (pageCount == null) {
                return false;
            }
            return page < pageCount;
        }
    }, {
        key: "getHasPreviousPage",
        value: function getHasPreviousPage() {
            var page = this.props.page;

            return page > 1;
        }
    }]);

    return Paginator;
}(_react2.default.Component);

Paginator.propTypes = {
    search: _propTypes2.default.func.isRequired,
    page: _propTypes2.default.number.isRequired,
    pageSize: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    pageCount: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    results: _propTypes2.default.object
};

var config = function config(props) {
    return {
        search: function search(page, pageSize) {
            var model = props.model;
            if (parseInt(pageSize)) {
                model.set("pageSize", pageSize);
            }
            if (model.hasChanged("pageSize")) {
                model.resetPagination();
            } else {
                if (parseInt(page)) {
                    model.set("page", page);
                }
            }
            props.view.dispatch("search:dataQualityReport", model);
        },
        page: { listenOn: "model" },
        pageSize: { listenOn: "model" },
        pageCount: { listenOn: "searchResults" },
        results: { listenOn: "searchResults" }
    };
};

var BackbonePaginator = exports.BackbonePaginator = (0, _backboneConnect.backboneConnect)(config)(Paginator);

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = PaginatorTemplate;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PaginatorTemplate(_ref) {
    var pageCount = _ref.pageCount,
        hasPreviousPage = _ref.hasPreviousPage,
        hasNextPage = _ref.hasNextPage,
        start = _ref.start,
        end = _ref.end,
        onPageNumberChange = _ref.onPageNumberChange,
        onPageSizeChange = _ref.onPageSizeChange,
        onPaginatorPageNext = _ref.onPaginatorPageNext,
        onPaginatorPagePrevious = _ref.onPaginatorPagePrevious,
        onPaginatorSubmit = _ref.onPaginatorSubmit,
        pageNumber = _ref.pageNumber,
        pageSize = _ref.pageSize;


    return _react2.default.createElement(
        "form",
        { className: "form-inline pager-form",
            onSubmit: onPaginatorSubmit },
        _react2.default.createElement(
            "div",
            { className: "col-md-4" },
            pageCount ? _react2.default.createElement(
                "div",
                { className: "pull-left" },
                _react2.default.createElement(
                    "h4",
                    null,
                    "Showing results ",
                    start,
                    " to ",
                    end
                )
            ) : null
        ),
        _react2.default.createElement(
            "div",
            { className: "text-center col-md-4" },
            hasPreviousPage ? _react2.default.createElement(
                "a",
                { href: "#", className: "btn btn-default pager-previousPage",
                    onClick: onPaginatorPagePrevious },
                "\xAB Previous Page"
            ) : null,
            pageCount ? _react2.default.createElement(
                "label",
                { className: "control-label" },
                "Page ",
                _react2.default.createElement("input", {
                    className: "form-control pager-page input-mini",
                    type: "text",
                    onChange: onPageNumberChange,
                    value: pageNumber }),
                "of ",
                pageCount
            ) : null,
            hasNextPage ? _react2.default.createElement(
                "a",
                { href: "#", className: "btn btn-default pager-nextPage",
                    onClick: onPaginatorPageNext },
                "Next Page \xBB"
            ) : null
        ),
        _react2.default.createElement(
            "div",
            { className: "col-md-4" },
            _react2.default.createElement(
                "div",
                { className: "pull-right" },
                pageCount ? _react2.default.createElement(
                    "label",
                    { className: "control-label" },
                    "Results per Page ",
                    _react2.default.createElement("input", {
                        className: "form-control pager-page-size input-mini",
                        type: "text",
                        onChange: onPageSizeChange,
                        value: pageSize })
                ) : null,
                pageCount ? _react2.default.createElement(
                    "button",
                    { type: "submit", className: "btn btn-refresh" },
                    _react2.default.createElement("span", null),
                    " Reload"
                ) : null
            )
        )
    );
}

PaginatorTemplate.propTypes = {
    pageCount: _propTypes2.default.number,
    hasPreviousPage: _propTypes2.default.bool.isRequired,
    hasNextPage: _propTypes2.default.bool.isRequired,
    start: _propTypes2.default.number.isRequired,
    end: _propTypes2.default.number.isRequired,
    onPageNumberChange: _propTypes2.default.func.isRequired,
    onPageSizeChange: _propTypes2.default.func.isRequired,
    onPaginatorPageNext: _propTypes2.default.func.isRequired,
    onPaginatorPagePrevious: _propTypes2.default.func.isRequired,
    onPaginatorSubmit: _propTypes2.default.func.isRequired,
    pageNumber: _propTypes2.default.string,
    pageSize: _propTypes2.default.string
};

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

var Model, SearchResults, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Model = __webpack_require__(83)["default"];

module.exports = SearchResults = (function(_super) {
  __extends(SearchResults, _super);

  function SearchResults() {
    _ref = SearchResults.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  return SearchResults;

})(Model);


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DataQualityResult = __webpack_require__(1466);

var _DataQualityResult2 = _interopRequireDefault(_DataQualityResult);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataQualityResultsCollection = function (_Backbone$Collection) {
  _inherits(DataQualityResultsCollection, _Backbone$Collection);

  function DataQualityResultsCollection() {
    _classCallCheck(this, DataQualityResultsCollection);

    return _possibleConstructorReturn(this, (DataQualityResultsCollection.__proto__ || Object.getPrototypeOf(DataQualityResultsCollection)).apply(this, arguments));
  }

  return DataQualityResultsCollection;
}(Backbone.Collection);

DataQualityResultsCollection.prototype.model = _DataQualityResult2.default;

exports.default = DataQualityResultsCollection;

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Model2 = __webpack_require__(83);

var _Model3 = _interopRequireDefault(_Model2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataQualityResult = function (_Model) {
    _inherits(DataQualityResult, _Model);

    function DataQualityResult() {
        var _ref;

        _classCallCheck(this, DataQualityResult);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = DataQualityResult.__proto__ || Object.getPrototypeOf(DataQualityResult)).call.apply(_ref, [this].concat(args)));

        _this.initialize = _this.initialize.bind(_this);
        return _this;
    }

    _createClass(DataQualityResult, [{
        key: "initialize",
        value: function initialize(options) {
            // id-key-data_shortname
            this.set("compositeId", options.id + "-" + options.key + "-" + options.data._shortname);
        }
    }]);

    return DataQualityResult;
}(_Model3.default);

DataQualityResult.prototype.defaults = {
    // previously anonymous attributes
    compositeId: null
};

DataQualityResult.prototype.idAttribute = "compositeId";

exports.default = DataQualityResult;

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _asMarionetteView = __webpack_require__(101);

var _DrawerLayout2 = __webpack_require__(328);

var _DrawerLayout3 = _interopRequireDefault(_DrawerLayout2);

var _DataQualityResultsLayout = __webpack_require__(631);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MarionetteResultsView = (0, _asMarionetteView.asMarionetteView)(_DataQualityResultsLayout.BackboneDataQualityResultsLayout);

var DataQualityReportLayout = function (_DrawerLayout) {
    _inherits(DataQualityReportLayout, _DrawerLayout);

    function DataQualityReportLayout() {
        var _ref;

        _classCallCheck(this, DataQualityReportLayout);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = DataQualityReportLayout.__proto__ || Object.getPrototypeOf(DataQualityReportLayout)).call.apply(_ref, [this].concat(args)));

        _this.onChangeSearchResults = _this.onChangeSearchResults.bind(_this);
        return _this;
    }

    _createClass(DataQualityReportLayout, [{
        key: "onChangeSearchResults",
        value: function onChangeSearchResults() {
            this.onDrawerEnable();
            this.onDrawerClose();

            var rv = new MarionetteResultsView({ model: this.model });
            this.content.show(rv);
        }
    }]);

    return DataQualityReportLayout;
}(_DrawerLayout3.default);

DataQualityReportLayout.prototype.el = "#content_dqr";

DataQualityReportLayout.prototype.modelEvents = {
    "change:searchResults": "onChangeSearchResults"
};

exports.default = DataQualityReportLayout;

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _withOver = __webpack_require__(58);

var _withOver2 = _interopRequireDefault(_withOver);

var _asMarionetteView = __webpack_require__(101);

var _MappingModalModule = __webpack_require__(1469);

var _MappingModalModule2 = _interopRequireDefault(_MappingModalModule);

var _MergeModalResolver = __webpack_require__(1481);

var _MergeModalResolver2 = _interopRequireDefault(_MergeModalResolver);

var _AboutModule = __webpack_require__(1486);

var _PreferencesModule = __webpack_require__(1490);

var _ValidationFilterModal = __webpack_require__(1492);

var _ValidationFilterModal2 = _interopRequireDefault(_ValidationFilterModal);

var _HiddenFieldAdminModal = __webpack_require__(1496);

var _HiddenFieldAdminModal2 = _interopRequireDefault(_HiddenFieldAdminModal);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _NavigatorStore = __webpack_require__(33);

var _NavigatorStore2 = _interopRequireDefault(_NavigatorStore);

var _superRecords = __webpack_require__(63);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _SuperRecordStore = __webpack_require__(36);

var _SuperRecordStore2 = _interopRequireDefault(_SuperRecordStore);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _MapButtonActions = __webpack_require__(141);

var _MapButtonActions2 = _interopRequireDefault(_MapButtonActions);

var _MergeActions = __webpack_require__(59);

var _MergeActions2 = _interopRequireDefault(_MergeActions);

var _WidgetActions = __webpack_require__(614);

var _WidgetActions2 = _interopRequireDefault(_WidgetActions);

var _GXEPModule = __webpack_require__(1497);

var _BroadcastAdminModule = __webpack_require__(1498);

var _ReauthModule = __webpack_require__(253);

var _implementationFieldsByEntity = __webpack_require__(1505);

var _implementationFieldsByEntity2 = _interopRequireDefault(_implementationFieldsByEntity);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _UserActions = __webpack_require__(123);

var _UserActions2 = _interopRequireDefault(_UserActions);

var _TwoPaneMultiSelectActions = __webpack_require__(641);

var _TwoPaneMultiSelectActions2 = _interopRequireDefault(_TwoPaneMultiSelectActions);

var _PrintModule = __webpack_require__(1506);

var _PrintModule2 = _interopRequireDefault(_PrintModule);

var _PrintActions = __webpack_require__(618);

var _PrintActions2 = _interopRequireDefault(_PrintActions);

var _DataManager = __webpack_require__(43);

var _DataManager2 = _interopRequireDefault(_DataManager);

var _ContextedReduceStore = __webpack_require__(30);

var _contextFromAppModelOrContext = __webpack_require__(645);

var _contextFromAppModelOrContext2 = _interopRequireDefault(_contextFromAppModelOrContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var MarionetteAboutModal = (0, _asMarionetteView.asMarionetteView)(_AboutModule.BackboneAboutModule);
var MarionettePreferencesModal = (0, _asMarionetteView.asMarionetteView)(_PreferencesModule.BackbonePreferencesModule);
var MarionetteValidationFilterModal = (0, _asMarionetteView.asMarionetteView)(_ValidationFilterModal2.default);
var MarionetteHiddenFieldAdminModal = (0, _asMarionetteView.asMarionetteView)(_HiddenFieldAdminModal2.default);
var MarionetteMappingModalModule = (0, _asMarionetteView.asMarionetteView)(_MappingModalModule2.default);
var MarionetteMergeModalResolver = (0, _asMarionetteView.asMarionetteView)(_MergeModalResolver2.default);
var MarionetteGenericXmlPasswordAdmin = (0, _asMarionetteView.asMarionetteView)(_GXEPModule.BackboneGenericXmlExportPasswordAdmin);
var MarionettePrintDialog = (0, _asMarionetteView.asMarionetteView)(_PrintModule2.default);
var MarionetteBroadcastAdmin = (0, _asMarionetteView.asMarionetteView)(_BroadcastAdminModule.BackboneBroadcastAdmin);
var MarionetteTestReauth = (0, _asMarionetteView.asMarionetteView)(_ReauthModule.BackboneTestReauth);

var findTargetId = function findTargetId(tree, record, config) {
    var targetId = null;
    // see if it's the current record
    if (record.key === config.entity) {
        targetId = record.id;
    }
    var find = function find(filter) {
        var queue = [];
        if (tree != null) queue.push(tree);
        while (queue.length > 0) {
            var item = queue.shift();
            if (item.entityKey === config.entity) {
                return item.id;
            }
            if (!item.fields) continue;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = item.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var f = _step.value;

                    if (!f.items) continue;
                    var it = f.items.find(filter);
                    if (it) queue.push(it);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    };
    // see if it's an ancestor
    if (targetId == null) {
        targetId = find(function (it) {
            return it.selected;
        });
    }
    // look in the entire tree
    if (targetId == null) {
        targetId = find(function () {
            return true;
        });
    }
    return targetId;
};

var addPeer = function addPeer(appModelOrFluxContext, tree, activeRecord, config, dispatch) {
    // find me in the tree...
    var queue = [];
    if (tree != null) queue.push.apply(queue, _toConsumableArray(tree.fields));
    while (queue.length > 0) {
        var field = queue.shift();
        if (!field.items) continue;
        if (field.creatables.some(function (it) {
            return it.key === config.entity;
        }) && field.items.some(function (it) {
            return it.id === activeRecord.id;
        })) {
            dispatch("record:new-child", _TableStore2.default.getEntityProxy(field.recordKey, field.recordId), field.key, config.entity, { shortname: config.field }, appModelOrFluxContext);
            return true;
        }
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = field.items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var it = _step2.value;

                if (!it.fields) continue;
                queue.push.apply(queue, _toConsumableArray(it.fields));
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    }
    return false;
};

var ViewController = function (_Backbone$Controller) {
    _inherits(ViewController, _Backbone$Controller);

    function ViewController() {
        _classCallCheck(this, ViewController);

        return _possibleConstructorReturn(this, (ViewController.__proto__ || Object.getPrototypeOf(ViewController)).apply(this, arguments));
    }

    _createClass(ViewController, [{
        key: "initialize",
        value: function initialize(options) {
            var _this2 = this;

            this.model = options.model;
            this.app = options.app;
            _Dispatcher2.default.register(function (action) {
                switch (action.type) {
                    case _PrintActions2.default.LAUNCH_DIALOG:
                        _this2.app.layout.showModal(function () {
                            return new MarionettePrintDialog(action);
                        });
                        break;
                    case _MapButtonActions2.default.LAUNCH_DIALOG:
                        // MappingModule causes a secondary dispatch to load
                        // the mapping plugins search forms with selected stereotype
                        // and default values. This setTimeout gets us past that.
                        //
                        // eslint-disable-next-line no-settimeout
                        setTimeout(function () {
                            _this2.app.layout.showModal(function () {
                                return new MarionetteMappingModalModule({
                                    fluxContext: action[_ContextedReduceStore.ACTION_CONTEXT_KEY]
                                });
                            });
                        });
                        break;
                    case _WidgetActions2.default.WIDGET_CLICK:
                        _this2.onClickWidgetButton(action.config, action[_ContextedReduceStore.ACTION_CONTEXT_KEY]);
                        break;
                    case _MergeActions2.default.LAUNCH_DIALOG:
                        _this2.onShowMergeModal(action[_ContextedReduceStore.ACTION_CONTEXT_KEY]);
                        break;
                    default:
                }
            });
        }
    }, {
        key: "onShowMergeModal",
        value: function onShowMergeModal(appModelOrFluxContext) {
            var fluxContext = (0, _contextFromAppModelOrContext2.default)(appModelOrFluxContext);
            this.app.layout.showModal(function () {
                return new MarionetteMergeModalResolver({
                    fluxContext: fluxContext
                });
            });
        }
    }, {
        key: "onAbout",
        value: function onAbout() {
            this.app.layout.showModal(function () {
                return new MarionetteAboutModal();
            });
        }
    }, {
        key: "onPreferences",
        value: function onPreferences() {
            this.app.layout.showModal(function () {
                return new MarionettePreferencesModal();
            });
        }
    }, {
        key: "onGenericXmlPasswordAdmin",
        value: function onGenericXmlPasswordAdmin() {
            this.app.layout.showModal(function () {
                return new MarionetteGenericXmlPasswordAdmin();
            });
        }
    }, {
        key: "onBroadcastAdmin",
        value: function onBroadcastAdmin() {
            this.app.layout.showModal(function () {
                return new MarionetteBroadcastAdmin();
            });
        }
    }, {
        key: "onTestReauth",
        value: function onTestReauth() {
            this.app.layout.showModal(function () {
                return new MarionetteTestReauth();
            });
        }
    }, {
        key: "_doFieldAdmin",
        value: function _doFieldAdmin(org, implKey, groupsBuilder, pref, Modal) {
            var _this3 = this;

            (0, _withOver2.default)("Loading...", function () {
                return _DataManager2.default.promiseImplementationAwareness(org, implKey).then(function () {
                    _TwoPaneMultiSelectActions2.default.populate(groupsBuilder(), JSON.parse(_userStore2.default.getLicensePreference(pref, implKey)));
                    _this3.app.layout.showModal(function () {
                        return new Modal({
                            triggerSave: function triggerSave(selection) {
                                return _Dispatcher2.default.dispatch({
                                    type: _UserActions2.default.UPDATE_LICENSE_PREFERENCE,
                                    impl: implKey,
                                    pref: pref,
                                    value: JSON.stringify(selection)
                                });
                            }
                        });
                    });
                });
            });
        }
    }, {
        key: "onLoadValidationFilter",
        value: function onLoadValidationFilter(org, implKey) {
            this._doFieldAdmin(org, implKey, function () {
                return (0, _implementationFieldsByEntity2.default)(implKey, function (fi) {
                    return fi.dqr;
                });
            }, "validation-excluded-fields", MarionetteValidationFilterModal);
        }
    }, {
        key: "onLoadHiddenFieldAdmin",
        value: function onLoadHiddenFieldAdmin(org, implKey) {
            this._doFieldAdmin(org, implKey, function () {
                return (0, _implementationFieldsByEntity2.default)(implKey, function (fi) {
                    return fi.userHideable;
                }, true);
            }, "user-hidden-fields", MarionetteHiddenFieldAdminModal);
        }
    }, {
        key: "onClickWidgetButton",
        value: function onClickWidgetButton(config, fluxContext) {
            if (config.command === "continue") {
                this.onContinue(config, false, fluxContext);
            } else if (config.command === "create") {
                this.onContinue(config, true, fluxContext);
            } else if (false) {
                console.warn("bad button widget config", config);
            }
        }
    }, {
        key: "onContinue",
        value: function onContinue(config, forceCreate, appModelOrFluxContext) {
            var fluxContext = (0, _contextFromAppModelOrContext2.default)(appModelOrFluxContext);
            var navState = _NavigatorStore2.default.getState(fluxContext);
            var magic = navState.magic,
                record = navState.record;

            var tree = (0, _superRecords.superNavTree)(_TableStore2.default, _SuperRecordStore2.default.getRecord(magic.key, magic.id, fluxContext), navState, magic.key, magic.id)
            // but only this TLR's tree...
            .fields.find(function (it) {
                return it.key === _superRecords.TOP_LEVEL_RECORDS_KEY;
            }).items.find(function (it) {
                return it.selected;
            });
            var targetId = void 0;
            if (!forceCreate) {
                targetId = findTargetId(tree, record, config);
            }
            if (targetId != null) {
                // this key passing is stupid, but that's how it works
                this.dispatch("validation:load", config.entity, targetId, config.field, appModelOrFluxContext);
                return;
            }
            // ok, find a place to create one...

            var activeRecord = _TableStore2.default.getEntityProxy(record.key, record.id);

            // if i have a collection of the right type, add one there
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = activeRecord.entityInfo.associations.cmv[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var fk = _step3.value;

                    var fieldInfo = _entityFieldMetaStore2.default.getInfo(record.key, fk);
                    if (fieldInfo.otherEntityKey === config.entity) {
                        this.dispatch("record:new-child", activeRecord, fk, config.entity, { shortname: config.field }, appModelOrFluxContext);
                        return;
                    }
                }

                // if i am of the right type, add a peer
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            if (activeRecord.entityKey === config.entity) {
                if (addPeer(appModelOrFluxContext, tree, activeRecord, config, this.dispatch)) {
                    // successful peer location found
                    return;
                }
            }

            // otherwise, bomb
            (0, _withOver.appAlert)("No suitable location to create record.");
        }
    }]);

    return ViewController;
}(Backbone.Controller);

ViewController.prototype.events = {
    "load:about": "onAbout",
    "load:preferences": "onPreferences",
    "load:genericXmlPasswordAdmin": "onGenericXmlPasswordAdmin",
    "load:broadcastAdmin": "onBroadcastAdmin",
    "load:test-reauth": "onTestReauth",
    "load:validation_filter": "onLoadValidationFilter",
    "load:hidden_field_admin": "onLoadHiddenFieldAdmin"
};

exports.default = ViewController;

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _MappingModule = __webpack_require__(1470);

var _MappingModule2 = _interopRequireDefault(_MappingModule);

var _ModalLayout = __webpack_require__(252);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _MappingActions = __webpack_require__(109);

var _MappingActions2 = _interopRequireDefault(_MappingActions);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _MapDialogActions = __webpack_require__(64);

var _MapDialogActions2 = _interopRequireDefault(_MapDialogActions);

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MappingModalModule = function (_React$Component) {
    _inherits(MappingModalModule, _React$Component);

    function MappingModalModule(props) {
        _classCallCheck(this, MappingModalModule);

        var _this = _possibleConstructorReturn(this, (MappingModalModule.__proto__ || Object.getPrototypeOf(MappingModalModule)).call(this, props));

        _this.onImport = _this.onImport.bind(_this);
        _this.onClose = _this.onClose.bind(_this);
        _this.onCancel = _this.onCancel.bind(_this);
        return _this;
    }

    _createClass(MappingModalModule, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            this.closeToken = _Dispatcher2.default.register(function (action) {
                if (action.type !== _SuperRecordActions2.default.CANCEL_FOR_OPTLOCK) return;
                _this2.onClose();
            });
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            if (this.closeToken != null) {
                _Dispatcher2.default.unregister(this.closeToken);
                delete this.closeToken;
            }
            if (this.importToken != null) {
                _Dispatcher2.default.unregister(this.importToken);
                delete this.importToken;
            }
        }
    }, {
        key: "onClose",
        value: function onClose() {
            var view = this.props.view;

            view && view.close();
        }
    }, {
        key: "onImport",
        value: function onImport() {
            var _this3 = this;

            if (this.importToken != null) {
                console.warn("import requested while one is already going?");
                return;
            }
            _Dispatcher2.default.dispatch({
                type: _MapDialogActions2.default.IMPORT
            });
            this.importToken = _Dispatcher2.default.register(function (action) {
                if (action.type !== _MappingActions2.default.IT_IS_DONE) return;
                _Dispatcher2.default.waitFor([_TableStore2.default.getDispatchToken()]);
                _this3.onClose();
            });
        }
    }, {
        key: "onCancel",
        value: function onCancel() {
            _Dispatcher2.default.dispatch({
                type: _MapDialogActions2.default.CANCEL
            });
            this.onClose();
        }
    }, {
        key: "render",
        value: function render() {
            var fluxContext = this.props.fluxContext;


            var modalOptions = {
                title: "Record Mapping",
                size: "modal-xlg"
            };

            return _react2.default.createElement(
                _ModalLayout.ModalLayout,
                {
                    modalOptions: modalOptions,
                    triggerClose: this.onCancel,
                    resizeBodyOnRender: true
                },
                _react2.default.createElement(_MappingModule2.default, {
                    fluxContext: fluxContext,
                    onImport: this.onImport,
                    onCancel: this.onCancel
                })
            );
        }
    }]);

    return MappingModalModule;
}(_react2.default.Component);

MappingModalModule.propTypes = {
    fluxContext: _propTypes2.default.string.isRequired,
    view: _propTypes2.default.instanceOf(Backbone.Marionette.View)
};

exports.default = MappingModalModule;

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MappingModule = MappingModule;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withOver = __webpack_require__(58);

var _SearchForm = __webpack_require__(1471);

var _RecordSourceTreeGridLayoutJS = __webpack_require__(1476);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _MappingStore = __webpack_require__(65);

var _MappingStore2 = _interopRequireDefault(_MappingStore);

var _entities = __webpack_require__(311);

var _records = __webpack_require__(113);

var _NavigatorStore = __webpack_require__(33);

var _NavigatorStore2 = _interopRequireDefault(_NavigatorStore);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _DrawerLayoutJS = __webpack_require__(634);

var _DrawerLayoutJS2 = _interopRequireDefault(_DrawerLayoutJS);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _AdtStore = __webpack_require__(228);

var _AdtStore2 = _interopRequireDefault(_AdtStore);

var _HemoStore = __webpack_require__(229);

var _HemoStore2 = _interopRequireDefault(_HemoStore);

var _EcmoEmrStore = __webpack_require__(230);

var _EcmoEmrStore2 = _interopRequireDefault(_EcmoEmrStore);

var _CrossAppStore = __webpack_require__(312);

var _CrossAppStore2 = _interopRequireDefault(_CrossAppStore);

var _MappingInfoStore = __webpack_require__(160);

var _MappingInfoStore2 = _interopRequireDefault(_MappingInfoStore);

var _TreeItemStore = __webpack_require__(162);

var _TreeItemStore2 = _interopRequireDefault(_TreeItemStore);

var _SearchResultStore = __webpack_require__(159);

var _SearchResultStore2 = _interopRequireDefault(_SearchResultStore);

var _MapDialogActions = __webpack_require__(64);

var _MapDialogActions2 = _interopRequireDefault(_MapDialogActions);

var _useFluxStore2 = __webpack_require__(9);

var _useFluxStore3 = _interopRequireDefault(_useFluxStore2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MappingModule(props) {
    var onImport = props.onImport,
        onCancel = props.onCancel,
        fluxContext = props.fluxContext;

    var _useFluxStore = (0, _useFluxStore3.default)(function (prevState) {
        var plugins = void 0;
        if (prevState == null) {
            var activeRecord = (0, _records.getActiveRecord)(_TableStore2.default, _NavigatorStore2.default.getRecordState(fluxContext));
            plugins = (0, _entities.getMappingPlugins)(activeRecord, fluxContext);
            plugins.forEach(function (p) {
                p.loadFields();
                p.deriveDefaultValuesFromActiveRecord();
            });
        } else {
            plugins = prevState.plugins;
        }
        var mapState = _MappingStore2.default.getState();
        var pluginKey = mapState.pluginKey;
        var plugin = plugins.find(function (p) {
            return p.get("id") === pluginKey;
        });
        var state = {
            plugins: plugins,
            layout: {
                enabled: mapState.source != null,
                open: mapState.drawerOpen,
                onToggle: function onToggle() {
                    _Dispatcher2.default.dispatch({
                        type: _MapDialogActions2.default.TOGGLE_DRAWER
                    });
                }
            },
            searchForm: {
                typeOptions: plugins.map(function (it) {
                    return {
                        value: it.get("id"),
                        label: it.get("name")
                    };
                }),
                resultsLO: plugin == null ? _LoadObject2.default.empty() : plugin.searchInteractive(),
                onSelectSource: function onSelectSource(pluginKey) {
                    _Dispatcher2.default.dispatch({
                        type: _MapDialogActions2.default.SELECT_PLUGIN,
                        key: pluginKey
                    });
                },
                onPage: function onPage(page) {
                    _Dispatcher2.default.contextDispatch(plugin.get("fluxContext"), {
                        type: _MapDialogActions2.default.SELECT_PAGE,
                        page: page
                    });
                    plugin.searchInteractive(true);
                },
                onSearch: function onSearch() {
                    if (!plugin.validate()) {
                        (0, _withOver.appAlert)("Search requires at least one criterion.");
                        return;
                    }
                    plugin.searchInteractive(true);
                },
                onSelectSourceRecord: function onSelectSourceRecord(source) {
                    _Dispatcher2.default.dispatch({
                        type: _MapDialogActions2.default.SELECT_SOURCE,
                        source: source
                    });
                },
                onSelectStereotype: function onSelectStereotype(stereotype) {
                    _Dispatcher2.default.dispatch({
                        type: _MapDialogActions2.default.SELECT_STEREOTYPE,
                        selectedStereotype: stereotype
                    });
                    plugin.selectStereotype(stereotype);
                }
            }
        };
        if (plugin != null) {
            state.searchForm.fields = plugin.get("fields");
            var searchStereotypes = plugin.get("searchStereotypes");
            if (searchStereotypes !== undefined) {
                state.searchForm.stereoOptions = searchStereotypes.map(function (it) {
                    return {
                        value: it.stereotypeKey,
                        label: it.name
                    };
                });
            }
            state.searchForm.fluxContext = plugin.get("fluxContext");
            state.searchForm.resultLabeler = plugin.getLabelForResult;
            state.searchForm.hasPagination = plugin.hasPaginationParams();
            state.searchForm.pagination = plugin.searchPaginationResult();
        }
        if (mapState.source) {
            var ctx = fluxContext + ":mapping";
            state.body = {
                onImport: onImport,
                onCancel: onCancel,
                // for TreeStore
                ctx: ctx,
                isKeyExpanded: _TreeItemStore2.default.getExpandedTest(ctx)
            };
        }
        return state;
    }, [
    // these are _used_, but the app guarantees they can't change
    // TableStore,
    // NavigatorStore,
    _MappingStore2.default, _AdtStore2.default, _HemoStore2.default, _EcmoEmrStore2.default, _CrossAppStore2.default, _MappingInfoStore2.default, _TreeItemStore2.default, _SearchResultStore2.default], [fluxContext, onImport, onCancel]),
        layout = _useFluxStore.layout,
        searchForm = _useFluxStore.searchForm,
        body = _useFluxStore.body;

    return _react2.default.createElement(_DrawerLayoutJS2.default, {
        enabled: layout.enabled,
        open: !layout.enabled || layout.open,
        onDrawerToggle: layout.onToggle,
        drawerContent: _react2.default.createElement(_SearchForm.SearchForm, searchForm),
        content: body && _react2.default.createElement(_RecordSourceTreeGridLayoutJS.FluxRecordSourceTreeGridLayout, body)
    });
}

MappingModule.propTypes = {
    fluxContext: _propTypes2.default.string.isRequired,
    onImport: _propTypes2.default.func.isRequired,
    onCancel: _propTypes2.default.func.isRequired
};

exports.default = MappingModule;

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.SearchForm = SearchForm;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RecordSourceInstanceGrid = __webpack_require__(1472);

var _RecordSourceInstanceGrid2 = _interopRequireDefault(_RecordSourceInstanceGrid);

var _RecordSourcePluginView = __webpack_require__(1473);

var _LoadObject = __webpack_require__(19);

var _LoadObject2 = _interopRequireDefault(_LoadObject);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

var _BrowserStore = __webpack_require__(354);

var _BrowserStore2 = _interopRequireDefault(_BrowserStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// todo: this is search form and results?!
function SearchForm(props) {
    var fluxContext = props.fluxContext,
        fields = props.fields,
        resultsLO = props.resultsLO,
        typeOptions = props.typeOptions,
        stereoOptions = props.stereoOptions,
        onSelectSource = props.onSelectSource,
        onSelectStereotype = props.onSelectStereotype,
        onSearch = props.onSearch,
        onSelectSourceRecord = props.onSelectSourceRecord,
        resultLabeler = props.resultLabeler,
        hasPagination = props.hasPagination,
        pagination = props.pagination,
        onPage = props.onPage;


    var formRef = (0, _react.useRef)();

    var _useState = (0, _react.useState)("80px"),
        _useState2 = _slicedToArray(_useState, 2),
        resultMaxHeight = _useState2[0],
        setResultMaxHeight = _useState2[1];

    (0, _react.useEffect)(function () {
        var boundingElement = document.querySelector("#modal .modal-body"); // todo: this is silly
        if (!boundingElement) return;
        var boundingRect = boundingElement.getBoundingClientRect();
        var availableHeight = boundingRect.height;
        if (availableHeight === 0) return; // thanks marionette
        setResultMaxHeight(Math.max(80, // always want this much
        availableHeight + -formRef.current.getBoundingClientRect().height + // form
        -55 // pull
        ) + "px");
    });
    (0, _useFluxStore2.default)(function () {
        return setResultMaxHeight("auto");
    }, // force rerender
    [_BrowserStore2.default]);

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            "div",
            {
                className: "search-form-layout",
                ref: formRef
            },
            _react2.default.createElement(_RecordSourcePluginView.RecordSourcePluginView, {
                typeOptions: typeOptions,
                stereoOptions: stereoOptions,
                fluxContext: fluxContext,
                fields: fields,
                onTypeChange: onSelectSource,
                onStereotypeChange: onSelectStereotype,
                onSubmit: onSearch
            })
        ),
        _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
                "div",
                { className: "col-md-12" },
                resultsLO.hasValue() && _react2.default.createElement(_RecordSourceInstanceGrid2.default, {
                    resultLabeler: resultLabeler,
                    results: resultsLO.getRequiredValue(),
                    onSelectModel: onSelectSourceRecord,
                    maxHeight: resultMaxHeight,
                    hasPagination: hasPagination,
                    pagination: pagination,
                    onPage: onPage
                })
            )
        )
    );
}

SearchForm.propTypes = {
    resultsLO: _propTypes2.default.instanceOf(_LoadObject2.default), // w/ Array<EntityProxy> inside
    typeOptions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.any.isRequired,
        label: _propTypes2.default.string.isRequired
    })).isRequired,
    stereoOptions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.any.isRequired,
        label: _propTypes2.default.string.isRequired
    })),
    onSelectSource: _propTypes2.default.func.isRequired,
    onSelectStereotype: _propTypes2.default.func.isRequired,
    onSearch: _propTypes2.default.func.isRequired,
    onSelectSourceRecord: _propTypes2.default.func.isRequired,
    resultLabeler: _propTypes2.default.func.isRequired,
    fluxContext: _propTypes2.default.string,
    fields: _propTypes2.default.array,
    onPage: _propTypes2.default.func,
    hasPagination: _propTypes2.default.bool,
    pagination: _propTypes2.default.any
};

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _typedefs = __webpack_require__(44);

var _SelectionTable = __webpack_require__(234);

var _SelectionTable2 = _interopRequireDefault(_SelectionTable);

var _Button = __webpack_require__(52);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RecordSourceInstanceGrid(props) {
    var results = props.results,
        onSelectModel = props.onSelectModel,
        resultLabeler = props.resultLabeler,
        maxHeight = props.maxHeight,
        hasPagination = props.hasPagination,
        pagination = props.pagination,
        onPage = props.onPage,
        _props$isLoading = props.isLoading,
        isLoading = _props$isLoading === undefined ? false : _props$isLoading;

    var items = results.map(function (ep) {
        return {
            ep: ep,
            id: ep.id,
            data: {
                label: resultLabeler ? resultLabeler(ep) : ep.getLabel()
            }
        };
    });
    var indexZeroPage = pagination.page - 1;
    return _react2.default.createElement(
        "div",
        { className: "search-results-container" },
        isLoading && _react2.default.createElement(
            "div",
            { className: "local-over-modal" },
            _react2.default.createElement("img", { src: "images/waiting.svg", alt: "Loading..." })
        ),
        _react2.default.createElement(_SelectionTable2.default, {
            records: items,
            fixedHeaders: true,
            columns: [{
                key: "label",
                name: "Results",
                type: "string"
            }],
            onRecordSelection: function onRecordSelection(it) {
                return onSelectModel(it.ep);
            },
            maxHeight: maxHeight
        }),
        hasPagination && (items.length >= pagination.pageSize || pagination.page > 1) && _react2.default.createElement(
            "div",
            { className: "row search-pagination" },
            _react2.default.createElement(
                "div",
                { className: "col-sm-6" },
                _react2.default.createElement(
                    "div",
                    { className: "search-pagination-summary" },
                    "Showing results ",
                    indexZeroPage * pagination.pageSize + 1,
                    " to ",
                    indexZeroPage * pagination.pageSize + items.length
                )
            ),
            _react2.default.createElement(
                "div",
                { className: "col-sm-6 text-right" },
                _react2.default.createElement(
                    "div",
                    { className: "search-pagination-buttons" },
                    _react2.default.createElement(_Button2.default, {
                        enabled: pagination.page > 1,
                        onClick: function onClick() {
                            return onPage(pagination.page - 1);
                        },
                        label: "<"
                    }),
                    _react2.default.createElement(
                        "strong",
                        null,
                        " Page ",
                        pagination.page,
                        " "
                    ),
                    _react2.default.createElement(_Button2.default, {
                        enabled: items.length >= pagination.pageSize,
                        onClick: function onClick() {
                            return onPage(pagination.page + 1);
                        },
                        label: ">"
                    })
                )
            )
        )
    );
}

RecordSourceInstanceGrid.propTypes = {
    results: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _typedefs.recordIdType.isRequired,
        getLabel: _propTypes2.default.func.isRequired
    })).isRequired,
    pagination: _propTypes2.default.shape({
        page: _propTypes2.default.number,
        pageSize: _propTypes2.default.number,
        totalResultCount: _propTypes2.default.number
    }),
    onSelectModel: _propTypes2.default.func.isRequired,
    resultLabeler: _propTypes2.default.func,
    maxHeight: _propTypes2.default.string,
    onPage: _propTypes2.default.func,
    hasPagination: _propTypes2.default.bool,
    isLoading: _propTypes2.default.bool
};

exports.default = RecordSourceInstanceGrid;

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RecordSourcePluginView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SearchForm = __webpack_require__(233);

var _SearchForm2 = _interopRequireDefault(_SearchForm);

var _RecordSourceSelection = __webpack_require__(1474);

var _RecordSourceSelection2 = _interopRequireDefault(_RecordSourceSelection);

var _SearchStereotypeSelection = __webpack_require__(1475);

var _SearchStereotypeSelection2 = _interopRequireDefault(_SearchStereotypeSelection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RecordSourcePluginView = exports.RecordSourcePluginView = function (_React$Component) {
    _inherits(RecordSourcePluginView, _React$Component);

    function RecordSourcePluginView(props) {
        _classCallCheck(this, RecordSourcePluginView);

        var _this = _possibleConstructorReturn(this, (RecordSourcePluginView.__proto__ || Object.getPrototypeOf(RecordSourcePluginView)).call(this, props));

        _this.onFormSubmit = _this.onFormSubmit.bind(_this);
        return _this;
    }

    _createClass(RecordSourcePluginView, [{
        key: "onFormSubmit",
        value: function onFormSubmit(e) {
            e.preventDefault();
            this.props.onSubmit();
            return false;
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                fluxContext = _props.fluxContext,
                onTypeChange = _props.onTypeChange,
                onStereotypeChange = _props.onStereotypeChange,
                fields = _props.fields,
                typeOptions = _props.typeOptions,
                stereoOptions = _props.stereoOptions;


            if (fluxContext == null || fields == null) {
                console.warn("RecordSourcePluginView was passed no data.");
                return null;
            }

            return _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                    "div",
                    { className: "row" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-3" },
                        _react2.default.createElement(_RecordSourceSelection2.default, { onChange: onTypeChange, options: typeOptions }),
                        stereoOptions !== undefined && _react2.default.createElement(_SearchStereotypeSelection2.default, { onChange: onStereotypeChange, options: stereoOptions })
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-6" },
                        fields.length > 0 && _react2.default.createElement(_SearchForm2.default, {
                            fluxContext: fluxContext,
                            alwaysShowAdvanced: true,
                            onSubmit: this.onFormSubmit
                        })
                    )
                ),
                fields.length > 0 && _react2.default.createElement(
                    "div",
                    { className: "row" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-12" },
                        _react2.default.createElement(
                            "button",
                            { onSubmit: this.onFormSubmit, onClick: this.onFormSubmit, type: "submit", className: "btn btn-search" },
                            _react2.default.createElement("span", null),
                            " Search"
                        )
                    )
                )
            );
        }
    }]);

    return RecordSourcePluginView;
}(_react2.default.Component);

RecordSourcePluginView.propTypes = {
    fluxContext: _propTypes2.default.string,
    fields: _propTypes2.default.array,
    onSubmit: _propTypes2.default.func.isRequired,
    onTypeChange: _propTypes2.default.func.isRequired,
    onStereotypeChange: _propTypes2.default.func,
    typeOptions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.any.isRequired,
        label: _propTypes2.default.string.isRequired
    })).isRequired,
    stereoOptions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.any.isRequired,
        label: _propTypes2.default.string.isRequired
    }))
};

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _Label = __webpack_require__(352);

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RecordSourceSelection = function (_React$Component) {
    _inherits(RecordSourceSelection, _React$Component);

    function RecordSourceSelection(props) {
        _classCallCheck(this, RecordSourceSelection);

        var _this = _possibleConstructorReturn(this, (RecordSourceSelection.__proto__ || Object.getPrototypeOf(RecordSourceSelection)).call(this, props));

        _this.state = {
            selectedKey: props.options[0].value // always select the first item
        };
        _this.onCommitChange = _this.onCommitChange.bind(_this);
        return _this;
    }

    _createClass(RecordSourceSelection, [{
        key: "onCommitChange",
        value: function onCommitChange(value) {
            var onChange = this.props.onChange;

            this.setState({ selectedKey: value });
            onChange(value);
        }
    }, {
        key: "render",
        value: function render() {
            var options = this.props.options;

            if (options.length === 1) {
                var activeLabel = options[0].label;
                return _react2.default.createElement(_Label2.default, { id: "source-type", label: "Source:", value: activeLabel, controlOnly: false });
            } else {
                return _react2.default.createElement(_Select2.default, { id: "source-type", label: "Source:", onCommitChange: this.onCommitChange, options: options, value: this.state.selectedKey, controlOnly: false });
            }
        }
    }]);

    return RecordSourceSelection;
}(_react2.default.Component);

exports.default = RecordSourceSelection;


RecordSourceSelection.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    options: _propTypes2.default.array.isRequired
};

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = __webpack_require__(23);

var _Select2 = _interopRequireDefault(_Select);

var _Label = __webpack_require__(352);

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchStereotypeSelection = function (_React$Component) {
    _inherits(SearchStereotypeSelection, _React$Component);

    function SearchStereotypeSelection(props) {
        _classCallCheck(this, SearchStereotypeSelection);

        var _this = _possibleConstructorReturn(this, (SearchStereotypeSelection.__proto__ || Object.getPrototypeOf(SearchStereotypeSelection)).call(this, props));

        _this.state = {
            selectedStereotype: props.options[0].value // always select the first item
        };
        _this.onCommitChange = _this.onCommitChange.bind(_this);
        return _this;
    }

    _createClass(SearchStereotypeSelection, [{
        key: "onCommitChange",
        value: function onCommitChange(value) {
            var onChange = this.props.onChange;

            this.setState({ selectedStereotype: value });
            onChange(value);
        }
    }, {
        key: "render",
        value: function render() {
            var options = this.props.options;

            if (options.length === 1) {
                var activeLabel = options[0].label;
                return _react2.default.createElement(_Label2.default, { id: "source-type", label: "Search by:", value: activeLabel, controlOnly: false });
            } else {
                return _react2.default.createElement(_Select2.default, { id: "source-type", label: "Search by:", onCommitChange: this.onCommitChange, options: options, value: this.state.selectedStereotype, controlOnly: false });
            }
        }
    }]);

    return SearchStereotypeSelection;
}(_react2.default.Component);

exports.default = SearchStereotypeSelection;


SearchStereotypeSelection.propTypes = {
    onChange: _propTypes2.default.func.isRequired,
    options: _propTypes2.default.array.isRequired
};

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FluxRecordSourceTreeGridLayout = exports.RecordSourceTreeGridLayout = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ActionBarJS = __webpack_require__(1477);

var _EmptyFieldList = __webpack_require__(1478);

var _EmptyFieldList2 = _interopRequireDefault(_EmptyFieldList);

var _RootTreeLayout = __webpack_require__(632);

var _RootTreeLayout2 = _interopRequireDefault(_RootTreeLayout);

var _TreeItemStore = __webpack_require__(162);

var _TreeItemStore2 = _interopRequireDefault(_TreeItemStore);

var _TreeItemActions = __webpack_require__(355);

var _TreeItemActions2 = _interopRequireDefault(_TreeItemActions);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _MappingStore = __webpack_require__(65);

var _MappingStore2 = _interopRequireDefault(_MappingStore);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _MapDialogActions = __webpack_require__(64);

var _MapDialogActions2 = _interopRequireDefault(_MapDialogActions);

var _BuildMappingTreeVisitor = __webpack_require__(314);

var _BuildMappingTreeVisitor2 = _interopRequireDefault(_BuildMappingTreeVisitor);

var _TableAccess = __webpack_require__(77);

var _TableAccess2 = _interopRequireDefault(_TableAccess);

var _OverStore = __webpack_require__(61);

var _OverStore2 = _interopRequireDefault(_OverStore);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RecordSourceTreeGridLayout = exports.RecordSourceTreeGridLayout = function (_React$Component) {
    _inherits(RecordSourceTreeGridLayout, _React$Component);

    function RecordSourceTreeGridLayout() {
        _classCallCheck(this, RecordSourceTreeGridLayout);

        return _possibleConstructorReturn(this, (RecordSourceTreeGridLayout.__proto__ || Object.getPrototypeOf(RecordSourceTreeGridLayout)).apply(this, arguments));
    }

    _createClass(RecordSourceTreeGridLayout, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                rootItem = _props.rootItem,
                sourceRecordType = _props.sourceRecordType,
                targetRecordType = _props.targetRecordType,
                targetRecordLabel = _props.targetRecordLabel,
                isMagicRoot = _props.isMagicRoot,
                onCancel = _props.onCancel,
                onSave = _props.onSave,
                onIncludeMagicRootFields = _props.onIncludeMagicRootFields,
                onExcludeMagicRootFields = _props.onExcludeMagicRootFields,
                onExpandAll = _props.onExpandAll,
                onCollapseAll = _props.onCollapseAll,
                isKeyExpanded = _props.isKeyExpanded,
                onChildCollapseOrExpand = _props.onChildCollapseOrExpand;

            var resultsTable = void 0,
                actionBar = void 0;
            if (rootItem) {
                resultsTable = _react2.default.createElement(
                    "div",
                    { className: "results-table" },
                    _react2.default.createElement(_RootTreeLayout2.default, {
                        targetRecordType: targetRecordType,
                        rootItem: rootItem,
                        isMagicRoot: isMagicRoot,
                        onIncludeMagicRootFields: onIncludeMagicRootFields,
                        onExcludeMagicRootFields: onExcludeMagicRootFields,
                        onExpandAll: onExpandAll,
                        onCollapseAll: onCollapseAll,
                        isKeyExpanded: isKeyExpanded,
                        onChildCollapseOrExpand: onChildCollapseOrExpand
                    })
                );

                actionBar = _react2.default.createElement(
                    "div",
                    { className: "row mapping-action-bar" },
                    _react2.default.createElement(_ActionBarJS.ActionBar, {
                        onCancel: onCancel,
                        onSave: onSave
                    })
                );
            } else {
                actionBar = _react2.default.createElement(
                    "div",
                    { className: "row mapping-action-bar" },
                    _react2.default.createElement(_EmptyFieldList2.default, null)
                );
            }

            return _react2.default.createElement(
                "div",
                { className: "mapping-content" },
                _react2.default.createElement(
                    "div",
                    { className: "row mapping-header" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-12" },
                        sourceRecordType,
                        " ",
                        _react2.default.createElement("img", { alt: "", src: "images/mapping_arrow.svg" }),
                        " ",
                        targetRecordType,
                        " ",
                        targetRecordLabel
                    )
                ),
                actionBar,
                resultsTable
            );
        }
    }]);

    return RecordSourceTreeGridLayout;
}(_react2.default.Component);

RecordSourceTreeGridLayout.propTypes = {
    rootItem: _propTypes2.default.object.isRequired,
    sourceRecordType: _propTypes2.default.string.isRequired,
    targetRecordType: _propTypes2.default.string.isRequired,
    targetRecordLabel: _propTypes2.default.string.isRequired,
    isMagicRoot: _propTypes2.default.bool.isRequired,
    onCancel: _propTypes2.default.func.isRequired,
    onSave: _propTypes2.default.func.isRequired,
    onIncludeMagicRootFields: _propTypes2.default.func.isRequired,
    onExcludeMagicRootFields: _propTypes2.default.func.isRequired,
    onExpandAll: _propTypes2.default.func.isRequired,
    onCollapseAll: _propTypes2.default.func.isRequired,
    isKeyExpanded: _propTypes2.default.func.isRequired,
    onChildCollapseOrExpand: _propTypes2.default.func.isRequired
};

var FluxRecordSourceTreeGridLayout = exports.FluxRecordSourceTreeGridLayout = function FluxRecordSourceTreeGridLayout(props) {
    var ctx = props.ctx,
        onImport = props.onImport,
        onCancel = props.onCancel,
        isKeyExpanded = props.isKeyExpanded;

    var state = (0, _useFluxStore2.default)(function (prevState) {
        if (_OverStore2.default.isModalShowing()) return prevState;
        if (!_MappingStore2.default.isReady()) return prevState;
        var mappingState = _MappingStore2.default.getState();
        var tree = new _BuildMappingTreeVisitor2.default(mappingState, new _TableAccess2.default(_TableStore2.default.getState()), new _TableAccess2.default(_TableStore2.default.getSnapshot())).execute().getTree();
        var sourceKey = tree.source.entityKey;
        var targetKey = tree.target.entityKey;
        var treeItemState = _TreeItemStore2.default.getState(ctx);
        return {
            // the main goodies
            rootItem: _extends({}, tree, {
                depth: 0
            }),

            // chrome bits
            onSave: onImport,
            onCancel: onCancel,
            isMagicRoot: tree.isMagicRoot,
            sourceRecordType: _entityMetaStore2.default.getInfo(sourceKey).label,
            targetRecordLabel: tree.label,
            targetRecordType: _entityMetaStore2.default.getInfo(targetKey).label,

            // mapping event handlers
            onIncludeMagicRootFields: function onIncludeMagicRootFields() {
                return _Dispatcher2.default.dispatch({
                    type: _MapDialogActions2.default.SET_MAGIC_ROOT_EXCLUSION,
                    excluded: false
                });
            },
            onExcludeMagicRootFields: function onExcludeMagicRootFields() {
                return _Dispatcher2.default.dispatch({
                    type: _MapDialogActions2.default.SET_MAGIC_ROOT_EXCLUSION,
                    excluded: true
                });
            },

            // TreeGrid handlers
            isKeyExpanded: isKeyExpanded,
            expandedAll: treeItemState.expandAllNodes,
            onChildCollapseOrExpand: _TreeItemActions2.default.childCollapseOrExpand.bind(undefined, ctx),
            onCollapseAll: _TreeItemActions2.default.collapseAll.bind(undefined, ctx),
            onExpandAll: _TreeItemActions2.default.expandAll.bind(undefined, ctx)
        };
    }, [_MappingStore2.default, _TreeItemStore2.default, _TableStore2.default, _OverStore2.default], [ctx, onImport, onCancel, isKeyExpanded]);
    return state && state.rootItem ? _react2.default.createElement(RecordSourceTreeGridLayout, state) : null; // render nothing
};

FluxRecordSourceTreeGridLayout.propTypes = {
    ctx: _propTypes2.default.string.isRequired,
    onImport: _propTypes2.default.func,
    onCancel: _propTypes2.default.func,
    isKeyExpanded: _propTypes2.default.func
};

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ActionBar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ActionBar = exports.ActionBar = function (_React$Component) {
    _inherits(ActionBar, _React$Component);

    function ActionBar() {
        _classCallCheck(this, ActionBar);

        return _possibleConstructorReturn(this, (ActionBar.__proto__ || Object.getPrototypeOf(ActionBar)).apply(this, arguments));
    }

    _createClass(ActionBar, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                onCancel = _props.onCancel,
                onSave = _props.onSave;

            return _react2.default.createElement(
                "div",
                { className: "col-md-12" },
                _react2.default.createElement(
                    "button",
                    { type: "button", className: "btn btn-import", onClick: onSave },
                    _react2.default.createElement("span", null),
                    " Import"
                ),
                _react2.default.createElement(
                    "button",
                    { type: "button", className: "btn btn-cancel", onClick: onCancel },
                    _react2.default.createElement("span", null),
                    " Cancel"
                )
            );
        }
    }]);

    return ActionBar;
}(_react2.default.Component);

ActionBar.propTypes = {
    onCancel: _propTypes.func.isRequired,
    onSave: _propTypes.func.isRequired
};

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmptyFieldList = function (_React$Component) {
    _inherits(EmptyFieldList, _React$Component);

    function EmptyFieldList() {
        _classCallCheck(this, EmptyFieldList);

        return _possibleConstructorReturn(this, (EmptyFieldList.__proto__ || Object.getPrototypeOf(EmptyFieldList)).apply(this, arguments));
    }

    _createClass(EmptyFieldList, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "div",
                { className: "disabled" },
                _react2.default.createElement(
                    "div",
                    { style: { paddingLeft: "20px" } },
                    "There are no fields available for mapping."
                )
            );
        }
    }]);

    return EmptyFieldList;
}(_react2.default.Component);

exports.default = EmptyFieldList;

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RecordSourceTreeGrid = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TreeItem = __webpack_require__(622);

var _bind = __webpack_require__(633);

var _bind2 = _interopRequireDefault(_bind);

var _types = __webpack_require__(1480);

var _formatId = __webpack_require__(114);

var _formatId2 = _interopRequireDefault(_formatId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StateToggle = function (_React$PureComponent) {
    _inherits(StateToggle, _React$PureComponent);

    function StateToggle() {
        _classCallCheck(this, StateToggle);

        return _possibleConstructorReturn(this, (StateToggle.__proto__ || Object.getPrototypeOf(StateToggle)).apply(this, arguments));
    }

    _createClass(StateToggle, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                label = _props.label,
                onClick = _props.onClick,
                active = _props.active,
                title = _props.title;

            var disabled = onClick == null;
            var classes = (0, _bind2.default)({
                "toggle-state": !disabled,
                "toggle-state-placeholder": disabled,
                "checked": active
            });
            return _react2.default.createElement(
                "label",
                {
                    onClick: disabled ? undefined : onClick,
                    title: title
                },
                _react2.default.createElement(
                    "div",
                    {
                        className: classes
                    },
                    _react2.default.createElement("span", null)
                ),
                " ",
                label
            );
        }
    }]);

    return StateToggle;
}(_react2.default.PureComponent);

StateToggle.propTypes = {
    label: _propTypes2.default.string.isRequired,
    active: _propTypes2.default.bool,
    title: _propTypes2.default.string,
    onClick: _propTypes2.default.func
};

var CollapseHandle = function (_React$PureComponent2) {
    _inherits(CollapseHandle, _React$PureComponent2);

    function CollapseHandle() {
        _classCallCheck(this, CollapseHandle);

        return _possibleConstructorReturn(this, (CollapseHandle.__proto__ || Object.getPrototypeOf(CollapseHandle)).apply(this, arguments));
    }

    _createClass(CollapseHandle, [{
        key: "render",
        value: function render() {
            var onClick = this.props.onClick;

            var disabled = onClick == null;
            var classes = (0, _bind2.default)({
                "collapse-handle": !disabled,
                "collapse-handle-placeholder": disabled
            });
            return _react2.default.createElement(
                "div",
                {
                    className: classes,
                    onClick: disabled ? undefined : onClick
                },
                _react2.default.createElement("span", null)
            );
        }
    }]);

    return CollapseHandle;
}(_react2.default.PureComponent);

CollapseHandle.propTypes = {
    onClick: _propTypes2.default.func
};

var RecordSourceTreeGrid = exports.RecordSourceTreeGrid = function (_React$Component) {
    _inherits(RecordSourceTreeGrid, _React$Component);

    function RecordSourceTreeGrid(props) {
        _classCallCheck(this, RecordSourceTreeGrid);

        var _this3 = _possibleConstructorReturn(this, (RecordSourceTreeGrid.__proto__ || Object.getPrototypeOf(RecordSourceTreeGrid)).call(this, props));

        _this3.typesWithoutCheckBox = ["RECORD_MAPPING_TYPE_TARGET", "RECORD_MAPPING_TYPE_UPDATE", "RECORD_MAPPING_TYPE_PLACEHOLDER", "RECORD_MAPPING_TYPE_EXISTING"];

        _this3.typesToHideChildren = ["RECORD_MAPPING_TYPE_REFERENCE"];

        _this3.toggleState = _this3.toggleState.bind(_this3);
        return _this3;
    }

    _createClass(RecordSourceTreeGrid, [{
        key: "check",
        value: function check(types, type) {
            return types.indexOf(type) < 0;
        }
    }, {
        key: "toggleState",
        value: function toggleState(e) {
            e.preventDefault();
            this.props.item.toggleActive();
        }
    }, {
        key: "render",
        value: function render() {
            var _props$item = this.props.item,
                children = _props$item.children,
                depth = _props$item.depth,
                isMagicRoot = _props$item.isMagicRoot,
                label = _props$item.label,
                old = _props$item.old,
                parentType = _props$item.parentType,
                shortname = _props$item.shortname,
                type = _props$item.type,
                value = _props$item.value,
                forceActive = _props$item.forceActive,
                active = _props$item.active,
                cid = _props$item.cid;
            var _props2 = this.props,
                expanded = _props2.expanded,
                toggleControl = _props2.toggleControl;


            var itemView = void 0;
            if (!isMagicRoot && this.check(this.typesToHideChildren, parentType)) {
                var stateToggle = void 0;
                if (forceActive) {
                    stateToggle = _react2.default.createElement(StateToggle, { active: true, title: forceActive, label: label });
                } else {
                    stateToggle = _react2.default.createElement(StateToggle, { active: active, onClick: this.toggleState, label: label });
                }

                var collapseHandle = void 0;
                if (this.check(this.typesToHideChildren, type) && children != null && children.length > 0) {
                    collapseHandle = _react2.default.createElement(CollapseHandle, { onClick: toggleControl });
                } else {
                    collapseHandle = _react2.default.createElement(CollapseHandle, null);
                }

                var highlightNewValue = active || forceActive;

                itemView = _react2.default.createElement(
                    "div",
                    { id: (0, _formatId2.default)(cid, "mr"), className: "row item-view", "data-shortname": shortname, "data-control-type": "mappingrow" },
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-6 col-lg-8" },
                        _react2.default.createElement(
                            "div",
                            { style: {
                                    marginLeft: 25 * depth + "px"
                                } },
                            _react2.default.createElement(
                                "div",
                                { className: "target-entity-heading" },
                                collapseHandle,
                                stateToggle
                            )
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-3 col-lg-2 new-value " + (highlightNewValue ? "active-value" : "inactive-value") },
                        value
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "col-md-3 col-lg-2 old-value " + (!highlightNewValue ? "active-value" : "inactive-value") },
                        old
                    )
                );
            }

            var treeClasses = void 0;
            if (children) {
                treeClasses = (0, _bind2.default)({
                    "record-source-tree-grid": true,
                    "parent": children.length > 0,
                    "leaf": children.length === 0,
                    "collapsed": !expanded
                });
            } else {
                treeClasses = (0, _bind2.default)({
                    "record-source-tree-grid": true,
                    "parent": false,
                    "leaf": true,
                    "collapsed": !expanded
                });
            }

            return _react2.default.createElement(
                "div",
                { className: treeClasses },
                itemView
            );
        }
    }]);

    return RecordSourceTreeGrid;
}(_react2.default.Component);

RecordSourceTreeGrid.propTypes = {
    expanded: _propTypes2.default.bool.isRequired,
    item: _propTypes2.default.shape(_types.recordSourceTreeItemShape).isRequired,
    toggleControl: _propTypes2.default.func.isRequired
};

var RecordSourceTreeItem = (0, _TreeItem.makeTreeItem)(RecordSourceTreeGrid);
exports.default = RecordSourceTreeItem;

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.recordSourceTreeItemShape = exports.recordSourceTreeGridShape = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(0);

var recordSourceTreeGridShape = exports.recordSourceTreeGridShape = {
    children: (0, _propTypes.oneOfType)([_propTypes.array, (0, _propTypes.instanceOf)(Backbone.Collection) // todo: remove
    ]),
    label: _propTypes.string.isRequired,
    model: _propTypes.object,
    parentType: _propTypes.string,
    shortname: _propTypes.string.isRequired,
    type: _propTypes.string,
    // these are not ubiquitous...
    collapsedAll: _propTypes.bool,
    expandedAll: _propTypes.bool,
    onCollapseAll: _propTypes.func,
    onExpandAll: _propTypes.func
};

var recordSourceTreeItemShape = exports.recordSourceTreeItemShape = _extends({
    active: _propTypes.bool.isRequired,
    toggleActive: _propTypes.func,
    depth: _propTypes.number.isRequired,
    isMagicRoot: _propTypes.bool,
    recordSourceRecordType: _propTypes.string }, recordSourceTreeGridShape);

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MergeModalResolver = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _GlobalMergeModule = __webpack_require__(1482);

var _GlobalMergeModule2 = _interopRequireDefault(_GlobalMergeModule);

var _RecordMergeModule = __webpack_require__(1485);

var _RecordMergeModule2 = _interopRequireDefault(_RecordMergeModule);

var _ModalLayout = __webpack_require__(252);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _MergeActions = __webpack_require__(59);

var _MergeActions2 = _interopRequireDefault(_MergeActions);

var _MergeStore = __webpack_require__(53);

var _MergeStore2 = _interopRequireDefault(_MergeStore);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MergeModalView = function (_React$Component) {
    _inherits(MergeModalView, _React$Component);

    function MergeModalView(props) {
        _classCallCheck(this, MergeModalView);

        var _this = _possibleConstructorReturn(this, (MergeModalView.__proto__ || Object.getPrototypeOf(MergeModalView)).call(this, props));

        _this.onClose = _this.onClose.bind(_this);
        _this.onCancel = _this.onCancel.bind(_this);
        return _this;
    }

    _createClass(MergeModalView, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            this.closeToken = _Dispatcher2.default.register(function (action) {
                if (action.type !== _SuperRecordActions2.default.CANCEL_FOR_OPTLOCK) return;
                _this2.onClose();
            });
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            if (this.closeToken != null) {
                _Dispatcher2.default.unregister(this.closeToken);
                delete this.closeToken;
            }
            this.onClose();
        }
    }, {
        key: "onClose",
        value: function onClose() {
            var view = this.props.view;

            view && view.close();
        }
    }, {
        key: "onCancel",
        value: function onCancel() {
            var fluxContext = this.props.fluxContext;

            _Dispatcher2.default.contextDispatch(fluxContext, {
                type: _MergeActions2.default.CANCEL
            });
            this.onClose();
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                _props$title = _props.title,
                title = _props$title === undefined ? "Record Merge" : _props$title,
                fluxContext = _props.fluxContext,
                mergePlugin = _props.mergePlugin;


            var modalOptions = {
                title: title,
                size: "modal-xlg"
            };
            var MergePlugin = null;
            switch (mergePlugin) {
                case _MergeStore.MERGE_PLUGINS.GLOBAL_MERGE:
                    MergePlugin = _GlobalMergeModule2.default;
                    break;
                case _MergeStore.MERGE_PLUGINS.RECORD_MERGE:
                    MergePlugin = _RecordMergeModule2.default;
                    break;
                case _MergeStore.MERGE_PLUGINS.CHILD_MERGE:
                    MergePlugin = "No child merge";
                    break;
                default:
                    throw Error("Unknown merge modal plugin... \"" + mergePlugin + "\"");
            }

            return _react2.default.createElement(
                _ModalLayout.ModalLayout,
                {
                    modalOptions: modalOptions,
                    triggerClose: this.onCancel,
                    resizeBodyOnRender: true
                },
                _react2.default.createElement(MergePlugin, {
                    fluxContext: fluxContext,
                    mergePlugin: mergePlugin,
                    onCancel: this.onCancel
                })
            );
        }
    }]);

    return MergeModalView;
}(_react2.default.Component);

MergeModalView.propTypes = {
    title: _propTypes2.default.string.isRequired,
    fluxContext: _propTypes2.default.string.isRequired,
    mergePlugin: _propTypes2.default.string.isRequired,
    view: _propTypes2.default.instanceOf(Backbone.Marionette.View)
};

var MergeModalResolver = exports.MergeModalResolver = function MergeModalResolver(props) {
    var state = (0, _useFluxStore2.default)(function () {
        var mergeState = _MergeStore2.default.getState();
        return {
            title: mergeState.modalParams.title,
            mergePlugin: _MergeStore2.default.getPluginKey()
        };
    }, [_MergeStore2.default], []);
    return state.mergePlugin ? _react2.default.createElement(MergeModalView, _extends({}, props, state)) : null;
};

exports.default = MergeModalResolver;

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GlobalMergeModule = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _SearchFormStore = __webpack_require__(82);

var _SearchFormStore2 = _interopRequireDefault(_SearchFormStore);

var _MergeActions = __webpack_require__(59);

var _MergeActions2 = _interopRequireDefault(_MergeActions);

var _sortsToOrder = __webpack_require__(322);

var _sortsToOrder2 = _interopRequireDefault(_sortsToOrder);

var _GlobalMergeContainer = __webpack_require__(1483);

var _SearchResultActions = __webpack_require__(143);

var _SearchResultActions2 = _interopRequireDefault(_SearchResultActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GlobalMergeModule = exports.GlobalMergeModule = function (_React$Component) {
    _inherits(GlobalMergeModule, _React$Component);

    function GlobalMergeModule(props) {
        _classCallCheck(this, GlobalMergeModule);

        var _this = _possibleConstructorReturn(this, (GlobalMergeModule.__proto__ || Object.getPrototypeOf(GlobalMergeModule)).call(this, props));

        _this.state = {
            search: {}
        };

        _this.onMerge = _this.onMerge.bind(_this);
        _this.onSearch = _this.onSearch.bind(_this);
        return _this;
    }

    _createClass(GlobalMergeModule, [{
        key: "onSearch",
        value: function onSearch() {
            var fluxContext = this.props.fluxContext;

            var key = _SearchFormStore2.default.getKey(fluxContext);
            var query = _SearchFormStore2.default.getQ(fluxContext).toAS();
            var order = (0, _sortsToOrder2.default)(_SearchFormStore2.default.getSorts(fluxContext));
            _Dispatcher2.default.dispatch({
                type: _SearchResultActions2.default.RESET_SEARCH,
                key: key,
                query: query,
                order: order
            });
            this.setState({
                search: {
                    key: key,
                    query: query,
                    order: order
                }
            });
        }
    }, {
        key: "onMerge",
        value: function onMerge() {
            var fluxContext = this.props.fluxContext;

            _Dispatcher2.default.contextDispatch(fluxContext, {
                type: _MergeActions2.default.DO_MERGE
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                onCancel = _props.onCancel,
                fluxContext = _props.fluxContext,
                mergePlugin = _props.mergePlugin;

            return _react2.default.createElement(_GlobalMergeContainer.GlobalMergeModuleContainer, {
                mergePlugin: mergePlugin,
                fluxContext: fluxContext,
                onCancel: onCancel,
                onMerge: this.onMerge,
                onSearch: this.onSearch,
                search: this.state.search
            });
        }
    }]);

    return GlobalMergeModule;
}(_react2.default.Component);

exports.default = GlobalMergeModule;


GlobalMergeModule.propTypes = {
    fluxContext: _propTypes2.default.string.isRequired,
    mergePlugin: _propTypes2.default.string.isRequired,
    onCancel: _propTypes2.default.func.isRequired
};

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GlobalMergeModuleContainer = exports.MergeComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withOver = __webpack_require__(58);

var _withOver2 = _interopRequireDefault(_withOver);

var _SearchModule = __webpack_require__(499);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _MergeStore = __webpack_require__(53);

var _MergeStore2 = _interopRequireDefault(_MergeStore);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _SearchFormStore = __webpack_require__(82);

var _SearchFormStore2 = _interopRequireDefault(_SearchFormStore);

var _SuperRecordStore = __webpack_require__(36);

var _SuperRecordStore2 = _interopRequireDefault(_SuperRecordStore);

var _mergeHelpers = __webpack_require__(232);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _DrawerLayoutJS = __webpack_require__(634);

var _DrawerLayoutJS2 = _interopRequireDefault(_DrawerLayoutJS);

var _SearchResultStore = __webpack_require__(159);

var _SearchResultStore2 = _interopRequireDefault(_SearchResultStore);

var _MergeActions = __webpack_require__(59);

var _MergeActions2 = _interopRequireDefault(_MergeActions);

var _SearchFormActions = __webpack_require__(75);

var _SearchFormActions2 = _interopRequireDefault(_SearchFormActions);

var _GlobalMergeBody = __webpack_require__(1484);

var _GlobalMergeBody2 = _interopRequireDefault(_GlobalMergeBody);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MergeComponent = exports.MergeComponent = function (_React$Component) {
    _inherits(MergeComponent, _React$Component);

    function MergeComponent() {
        _classCallCheck(this, MergeComponent);

        return _possibleConstructorReturn(this, (MergeComponent.__proto__ || Object.getPrototypeOf(MergeComponent)).apply(this, arguments));
    }

    _createClass(MergeComponent, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                layout = _props.layout,
                searchForm = _props.searchForm,
                body = _props.body;

            return _react2.default.createElement(_DrawerLayoutJS2.default, {
                enabled: layout.enabled,
                open: !layout.enabled || layout.open,
                onDrawerToggle: layout.onToggle,
                drawerContent: _react2.default.createElement(_SearchModule.SearchModule, searchForm),
                content: body ? _react2.default.createElement(_GlobalMergeBody2.default, body) : null
            });
        }
    }]);

    return MergeComponent;
}(_react2.default.Component);

MergeComponent.propTypes = {
    layout: _propTypes2.default.shape({
        enabled: _propTypes2.default.bool.isRequired,
        open: _propTypes2.default.bool.isRequired,
        onToggle: _propTypes2.default.func
    }).isRequired,
    searchForm: _propTypes2.default.object.isRequired,
    body: _propTypes2.default.object
};

var GlobalMergeModuleContainer = exports.GlobalMergeModuleContainer = function GlobalMergeModuleContainer(props) {
    var fluxContext = props.fluxContext,
        search = props.search,
        _onSearch = props.onSearch;

    var state = (0, _useFluxStore2.default)(function () {
        var searchKey = _SearchFormStore2.default.getKey(fluxContext);
        var mergeState = _MergeStore2.default.getState();
        var stereotypes = _StereotypesStore2.default.getMergeStereotypes();
        var selectedStereotype = _StereotypesStore2.default.getStereotypeByKey(searchKey);
        var sorts = _SearchFormStore2.default.getSorts(fluxContext);
        var results = search.key ? _SearchResultStore2.default.getSearchLO(search.key, search.query, search.order).getValue() // null is fine.
        : null;
        var state = {
            layout: {
                enabled: mergeState.source != null,
                open: mergeState.modalParams.drawerOpen,
                onToggle: function onToggle() {
                    _Dispatcher2.default.dispatch({
                        type: _MergeActions2.default.TOGGLE_DRAWER
                    });
                }
            },
            searchForm: {
                // search form props
                fluxContext: fluxContext,
                stereotypes: stereotypes,
                showAdvanced: true,
                title: "Find a " + selectedStereotype.name + " to Merge From",
                selectedStereotype: selectedStereotype,
                onStereotypeSelect: function onStereotypeSelect(key) {
                    _Dispatcher2.default.contextDispatch(fluxContext, {
                        type: _SearchFormActions2.default.SELECT_STEREOTYPE,
                        key: key
                    });
                },
                onSearch: function onSearch() {
                    _onSearch();
                },
                showEmptySearchAlert: function showEmptySearchAlert() {
                    (0, _withOver.appAlert)("Search requires at least one criterion.");
                },
                menuItemOnClick: function menuItemOnClick() {
                    /* noop */
                },
                // search result props

                records: results && results.results ? results.results.filter(function (r) {
                    return mergeState.target.id !== r.id;
                }) : null,
                columns: selectedStereotype.fields,
                sorts: sorts,
                pagination: {
                    // Currently some paging values can not be trusted from the
                    // results. Instead we are using the SearchFormStore's values
                    // until there is a need to fix the values from the server.
                    page: _SearchFormStore2.default.getPage(fluxContext),
                    pageCount: results && results.pageCount, // cant be trusted
                    pageSize: _SearchFormStore2.default.getPageSize(fluxContext),
                    totalResultCount: results && results.totalResultCount // cant be trusted.
                },
                selectedRecord: mergeState.source ? { id: mergeState.source.id } : null,
                supportsEnablement: selectedStereotype.supportsEnablement,
                showDisabled: selectedStereotype.supportsEnablement,
                showCreate: false,
                onRecordSelection: function onRecordSelection(record) {
                    var key = record.key;
                    var id = record.id;
                    (0, _withOver2.default)("Loading...", function () {
                        return _SuperRecordStore2.default.getRecordLO(key, id, true).promise().then(function () {
                            return _Dispatcher2.default.contextDispatch(fluxContext, {
                                type: _MergeActions2.default.SELECT_SOURCE,
                                source: {
                                    stereoKey: key,
                                    id: id
                                }
                            });
                        }).catch(function (jqXHR) {
                            if (jqXHR.status < 500) return;
                            console.error("error loading source record " + key + "#" + id, jqXHR);
                            var msg = "Unable to load source record";
                            if (jqXHR.responseText !== "") {
                                try {
                                    var resp = JSON.parse(jqXHR.responseText);
                                    msg = resp.message;
                                } catch (error) {
                                    /* noop */
                                }
                            }
                            return (0, _withOver.appAlert)(msg);
                        });
                    });
                },
                onSort: function onSort(sortBy) {
                    _Dispatcher2.default.contextDispatch(fluxContext, {
                        type: _SearchFormActions2.default.SORT,
                        key: sortBy.key
                    });
                }
            }
        };

        if (mergeState.source) {
            var _MergeStore$getProxyP = _MergeStore2.default.getProxyPair(),
                source = _MergeStore$getProxyP.source,
                target = _MergeStore$getProxyP.target;

            state.body = {
                isMagicRoot: target.stereoInfo.magicRoot,
                mergePlugin: props.mergePlugin,
                onMerge: props.onMerge,
                onCancel: props.onCancel,
                fluxContext: fluxContext,
                target: target,
                source: source,
                sourceChildren: (0, _mergeHelpers.getAutoMergeGlobalSummary)(mergeState.source)
            };
        }

        return state;
    }, [_TableStore2.default, _SearchFormStore2.default, _MergeStore2.default, _SearchResultStore2.default], [fluxContext, search, _onSearch]);
    return _react2.default.createElement(MergeComponent, state);
};

GlobalMergeModuleContainer.propTypes = {
    fluxContext: _propTypes2.default.string.isRequired,
    mergePlugin: _propTypes2.default.string.isRequired,
    search: _propTypes2.default.shape({
        key: _propTypes2.default.string,
        query: _propTypes2.default.string,
        order: _propTypes2.default.string
    }).isRequired,
    onMerge: _propTypes2.default.func.isRequired,
    onCancel: _propTypes2.default.func.isRequired,
    onSearch: _propTypes2.default.func.isRequired
};

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _StereotypeProxy = __webpack_require__(305);

var _StereotypeProxy2 = _interopRequireDefault(_StereotypeProxy);

var _TreeItemStore = __webpack_require__(162);

var _TreeItemStore2 = _interopRequireDefault(_TreeItemStore);

var _MergeBodyLayout = __webpack_require__(636);

var _MergeBodyLayout2 = _interopRequireDefault(_MergeBodyLayout);

var _FluxMergeRecordSourceTreeGridLayout = __webpack_require__(637);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function RecordLabel(_ref) {
    var record = _ref.record;

    return _react2.default.createElement(
        "strong",
        null,
        record.getLabel()
    );
}

RecordLabel.propTypes = {
    record: _propTypes2.default.instanceOf(_StereotypeProxy2.default).isRequired
};

var GlobalMergeBody = function (_React$Component) {
    _inherits(GlobalMergeBody, _React$Component);

    function GlobalMergeBody() {
        _classCallCheck(this, GlobalMergeBody);

        return _possibleConstructorReturn(this, (GlobalMergeBody.__proto__ || Object.getPrototypeOf(GlobalMergeBody)).apply(this, arguments));
    }

    _createClass(GlobalMergeBody, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                fluxContext = _props.fluxContext,
                isMagicRoot = _props.isMagicRoot,
                source = _props.source,
                target = _props.target,
                onCancel = _props.onCancel,
                onMerge = _props.onMerge,
                sourceChildren = _props.sourceChildren;

            var typeLabelTitle = target.stereoInfo.name;
            var typeLabel = typeLabelTitle.toLowerCase();
            if (!source) {
                return null;
            }

            var ctx = fluxContext;
            var body = _extends({}, this.props, {
                // for TreeStore
                ctx: ctx + ":global-merge",
                isKeyExpanded: _TreeItemStore2.default.getExpandedTest(ctx)
            });

            return _react2.default.createElement(
                _MergeBodyLayout2.default,
                {
                    isMagicRoot: isMagicRoot,
                    fluxContext: fluxContext,
                    sourceLabel: _react2.default.createElement(RecordLabel, { record: source }),
                    targetLabel: _react2.default.createElement(RecordLabel, { record: target }),
                    typeLabel: typeLabel,
                    sourceChildren: sourceChildren,
                    onMerge: onMerge,
                    onCancel: onCancel
                },
                _react2.default.createElement(_FluxMergeRecordSourceTreeGridLayout.FluxMergeRecordSourceTreeGridLayout, body)
            );
        }
    }]);

    return GlobalMergeBody;
}(_react2.default.Component);

GlobalMergeBody.propTypes = {
    fluxContext: _propTypes2.default.string.isRequired,
    mergePlugin: _propTypes2.default.string.isRequired,
    isMagicRoot: _propTypes2.default.bool,
    target: _propTypes2.default.instanceOf(_StereotypeProxy2.default).isRequired,
    source: _propTypes2.default.instanceOf(_StereotypeProxy2.default),
    onCancel: _propTypes2.default.func.isRequired,
    onMerge: _propTypes2.default.func.isRequired,
    sourceChildren: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        label: _propTypes2.default.string.isRequired,
        items: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
    }))
};

exports.default = GlobalMergeBody;

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _FluxMergeRecordSourceTreeGridLayout = __webpack_require__(637);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TreeItemStore = __webpack_require__(162);

var _TreeItemStore2 = _interopRequireDefault(_TreeItemStore);

var _MergeBodyLayout = __webpack_require__(636);

var _MergeBodyLayout2 = _interopRequireDefault(_MergeBodyLayout);

var _MergeStore = __webpack_require__(53);

var _MergeStore2 = _interopRequireDefault(_MergeStore);

var _mergeHelpers = __webpack_require__(232);

var _MappingStore = __webpack_require__(65);

var _MappingStore2 = _interopRequireDefault(_MappingStore);

var _MergeActions = __webpack_require__(59);

var _MergeActions2 = _interopRequireDefault(_MergeActions);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _TableStore = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RecordMergeModuleView = function RecordMergeModuleView(props) {
    var fluxContext = props.fluxContext,
        target = props.target,
        source = props.source,
        onCancel = props.onCancel,
        onMerge = props.onMerge,
        mergePlugin = props.mergePlugin,
        sourceChildren = props.sourceChildren;

    var ctx = props.fluxContext;
    var typeLabelTitle = target.entityInfo.label;
    var typeLabel = typeLabelTitle.toLowerCase();
    if (!source) {
        return null;
    }

    var sourceLabel = _react2.default.createElement(
        "strong",
        null,
        source.getLabel()
    );
    var targetLabel = _react2.default.createElement(
        "strong",
        null,
        target.getLabel()
    );

    var body = _extends({}, props, {
        // for TreeStore
        ctx: ctx + ":" + mergePlugin,
        isKeyExpanded: _TreeItemStore2.default.getExpandedTest(ctx)
    });
    return _react2.default.createElement(
        "div",
        { style: { marginLeft: -15, marginRight: -15 } },
        _react2.default.createElement(
            _MergeBodyLayout2.default,
            {
                fluxContext: fluxContext,
                sourceLabel: sourceLabel,
                targetLabel: targetLabel,
                typeLabel: typeLabel,
                sourceChildren: sourceChildren,
                onMerge: onMerge,
                onCancel: onCancel
            },
            _react2.default.createElement(_FluxMergeRecordSourceTreeGridLayout.FluxMergeRecordSourceTreeGridLayout, body)
        )
    );
};

RecordMergeModuleView.propTypes = {
    fluxContext: _propTypes2.default.string.isRequired,
    mergePlugin: _propTypes2.default.string.isRequired,
    target: _propTypes2.default.instanceOf(_EntityProxy2.default).isRequired,
    source: _propTypes2.default.instanceOf(_EntityProxy2.default),
    sourceChildren: _propTypes2.default.array,
    onMerge: _propTypes2.default.func.isRequired,
    onCancel: _propTypes2.default.func.isRequired
};

var RecordMergeModule = function RecordMergeModule(props) {
    var fluxContext = props.fluxContext;

    var state = (0, _useFluxStore2.default)(function () {
        var mergeState = _MergeStore2.default.getState();

        var _MergeStore$getProxyP = _MergeStore2.default.getProxyPair(),
            source = _MergeStore$getProxyP.source,
            target = _MergeStore$getProxyP.target;

        return _extends({}, props, {
            target: target,
            source: source,
            sourceChildren: (0, _mergeHelpers.getAutoMergeRecordSummary)(source),
            onMerge: function onMerge() {
                return _Dispatcher2.default.contextDispatch(fluxContext, {
                    type: _MergeActions2.default.DO_MERGE,
                    source: mergeState.source
                });
            }
        });
    }, [_MappingStore2.default, _TableStore.TableStore], [fluxContext]);
    return state.target !== null ? _react2.default.createElement(RecordMergeModuleView, state) : null;
};

RecordMergeModule.propTypes = {
    fluxContext: _propTypes2.default.string.isRequired,
    mergePlugin: _propTypes2.default.string.isRequired,
    onCancel: _propTypes2.default.func.isRequired
};

exports.default = RecordMergeModule;

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BackboneAboutModule = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Body = __webpack_require__(1487);

var _AboutStore = __webpack_require__(638);

var _AboutStore2 = _interopRequireDefault(_AboutStore);

var _asModal = __webpack_require__(130);

var _asModal2 = _interopRequireDefault(_asModal);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackboneAboutModule = exports.BackboneAboutModule = (0, _asModal2.default)("About Hybrid Outcomes")(function () {
    var state = (0, _useFluxStore2.default)(function () {
        var api = _AboutStore2.default.getApiVersion();
        return {
            client: _AboutStore2.default.getClientVersion(),
            api: api.application,
            aggregate: api.aggregate,
            requiredApi: _AboutStore2.default.getRequiredApiVersion(),
            meta: api.meta,
            modules: api.modules
        };
    }, [_AboutStore2.default]);
    return _react2.default.createElement(_Body.Body, state);
});

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Body = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Body = exports.Body = function (_React$Component) {
    _inherits(Body, _React$Component);

    function Body() {
        _classCallCheck(this, Body);

        var _this = _possibleConstructorReturn(this, (Body.__proto__ || Object.getPrototypeOf(Body)).call(this));

        _this.state = {
            modulesExpanded: false
        };
        _this.toggleModules = _this.toggleModules.bind(_this);
        return _this;
    }

    _createClass(Body, [{
        key: "toggleModules",
        value: function toggleModules() {
            this.setState(function (state) {
                return {
                    modulesExpanded: !state.modulesExpanded
                };
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                client = _props.client,
                api = _props.api,
                aggregate = _props.aggregate,
                requiredApi = _props.requiredApi,
                meta = _props.meta,
                modules = _props.modules;
            var modulesExpanded = this.state.modulesExpanded;


            var rows = meta.map(function (m, i) {
                return _react2.default.createElement(
                    "tr",
                    { key: i },
                    _react2.default.createElement(
                        "td",
                        { nowrap: "nowrap" },
                        _react2.default.createElement(
                            "code",
                            null,
                            m.key
                        )
                    ),
                    _react2.default.createElement(
                        "td",
                        { nowrap: "nowrap" },
                        _react2.default.createElement(
                            "code",
                            null,
                            m.version
                        )
                    )
                );
            });

            var versions = meta.map(function (m, i) {
                var comma = i + 1 < meta.length ? "," : "";
                return _react2.default.createElement(
                    _react2.default.Fragment,
                    { key: i },
                    m.key,
                    ":",
                    m.version,
                    comma
                );
            });

            return _react2.default.createElement(
                "div",
                { className: "row" },
                _react2.default.createElement(
                    "div",
                    { className: "col-md-12" },
                    requiredApi.indexOf("-SNAPSHOT") > 0 && _react2.default.createElement(
                        "div",
                        { className: "alert alert-warning" },
                        _react2.default.createElement(
                            "strong",
                            null,
                            "SNAPSHOT API REQUIREMENT:"
                        ),
                        " ",
                        _react2.default.createElement(
                            "code",
                            null,
                            requiredApi
                        )
                    ),
                    _react2.default.createElement(
                        "table",
                        { className: "table-alt table-striped table-condensed" },
                        _react2.default.createElement(
                            "thead",
                            null,
                            _react2.default.createElement(
                                "tr",
                                null,
                                _react2.default.createElement(
                                    "th",
                                    null,
                                    "Module"
                                ),
                                _react2.default.createElement(
                                    "th",
                                    null,
                                    "Version"
                                )
                            )
                        ),
                        _react2.default.createElement(
                            "tbody",
                            null,
                            aggregate && _react2.default.createElement(
                                "tr",
                                null,
                                _react2.default.createElement(
                                    "td",
                                    null,
                                    "Aggregate"
                                ),
                                _react2.default.createElement(
                                    "td",
                                    null,
                                    _react2.default.createElement(
                                        "code",
                                        null,
                                        aggregate
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                "tr",
                                null,
                                _react2.default.createElement(
                                    "td",
                                    null,
                                    "Client"
                                ),
                                _react2.default.createElement(
                                    "td",
                                    null,
                                    _react2.default.createElement(
                                        "code",
                                        null,
                                        client
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                "tr",
                                null,
                                _react2.default.createElement(
                                    "td",
                                    null,
                                    "API"
                                ),
                                _react2.default.createElement(
                                    "td",
                                    null,
                                    modules && _react2.default.createElement(
                                        "div",
                                        { className: "pull-right" },
                                        _react2.default.createElement(
                                            "a",
                                            {
                                                onClick: this.toggleModules,
                                                style: {
                                                    cursor: "pointer",
                                                    userSelect: "none"
                                                }
                                            },
                                            modulesExpanded ? "Hide" : "Show",
                                            " Modules"
                                        )
                                    ),
                                    _react2.default.createElement(
                                        "code",
                                        null,
                                        api
                                    )
                                )
                            ),
                            modulesExpanded && modules && modules.map(function (m) {
                                return _react2.default.createElement(
                                    "tr",
                                    { key: m },
                                    _react2.default.createElement("td", null),
                                    _react2.default.createElement(
                                        "td",
                                        null,
                                        _react2.default.createElement(
                                            "code",
                                            null,
                                            m
                                        )
                                    )
                                );
                            }),
                            rows
                        ),
                        _react2.default.createElement(
                            "tfoot",
                            null,
                            _react2.default.createElement(
                                "tr",
                                null,
                                _react2.default.createElement(
                                    "td",
                                    null,
                                    "Combined"
                                ),
                                _react2.default.createElement(
                                    "td",
                                    null,
                                    _react2.default.createElement(
                                        "code",
                                        null,
                                        client,
                                        "<",
                                        api,
                                        "[",
                                        versions,
                                        "]>"
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Body;
}(_react2.default.Component);

Body.propTypes = {
    client: _propTypes2.default.string.isRequired,
    api: _propTypes2.default.string.isRequired,
    aggregate: _propTypes2.default.string,
    requiredApi: _propTypes2.default.string.isRequired,
    meta: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        key: _propTypes2.default.string.isRequired,
        version: _propTypes2.default.string.isRequired
    })).isRequired,
    modules: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = { aggregate: "com.armus.product:hybrid-accsts-jsclient:2026.09.22:20260922-1544",
    client: "com.armus:hybrid-jsclient:2026.09.21:20260921-2110",
    requiredApiVersion: "1.86.0"
};

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ModalActions = {
    PRINT_DIALOG: "modal/print-dialog",
    CLOSE: "modal/close"
};

exports.default = ModalActions;

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BackbonePreferencesModule = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Body = __webpack_require__(1491);

var _Body2 = _interopRequireDefault(_Body);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _asModal = __webpack_require__(130);

var _asModal2 = _interopRequireDefault(_asModal);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _UserActions = __webpack_require__(123);

var _UserActions2 = _interopRequireDefault(_UserActions);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackbonePreferencesModule = exports.BackbonePreferencesModule = (0, _asModal2.default)({
    title: "User Preferences",
    size: "md"
})(function () {
    var state = (0, _useFluxStore2.default)(function () {
        return {
            defaultSearch: _userStore2.default.getDefaultSearchConfig(),
            updateDefaultSearchEnablement: function updateDefaultSearchEnablement(enabled) {
                return _Dispatcher2.default.dispatch({
                    type: _UserActions2.default.UPDATE_ORG_USER_PREFERENCE,
                    pref: "use-default-search",
                    value: !!enabled
                });
            }
        };
    }, [_userStore2.default]);
    return _react2.default.createElement(_Body2.default, state);
});

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Checkbox = __webpack_require__(615);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Body = function Body(props) {
    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(_Checkbox2.default, {
            label: "Enable Default Search: Checking this box allows you to save a default search that will be loaded upon logging in.",
            shortname: "useDefaultSearch",
            value: props.defaultSearch.enabled,
            onCommitChange: props.updateDefaultSearchEnablement
        })
    );
};

Body.propTypes = {
    defaultSearch: _propTypes2.default.shape({
        enabled: _propTypes2.default.bool.isRequired,
        query: _propTypes2.default.object
    }).isRequired,
    updateDefaultSearchEnablement: _propTypes2.default.func.isRequired
};

exports.default = Body;

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Wrapper = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TwoPaneMultiSelectContainer = __webpack_require__(639);

var _TwoPaneMultiSelectContainer2 = _interopRequireDefault(_TwoPaneMultiSelectContainer);

var _asModal = __webpack_require__(130);

var _asModal2 = _interopRequireDefault(_asModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = exports.Wrapper = function Wrapper(_ref) {
    var triggerClose = _ref.triggerClose,
        triggerSave = _ref.triggerSave;
    return _react2.default.createElement(_TwoPaneMultiSelectContainer2.default, {
        triggerClose: triggerClose,
        triggerSave: triggerSave,
        contentBlocks: {
            header: "Please select the fields you would like to exclude from the Validation and DQR Results.",
            unselectedPane: "Available Fields For Exclusion",
            selectIcon: "Exclude",
            selectedPane: "Excluded Fields",
            unselectIcon: "Don't Exclude"
        }
    });
};

Wrapper.propTypes = {
    triggerClose: _propTypes2.default.func.isRequired,
    triggerSave: _propTypes2.default.func.isRequired
};

exports.default = (0, _asModal2.default)("Manage Validation Configuration")(Wrapper);

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.contentBlocksType = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rxjs = __webpack_require__(502);

var _operators = __webpack_require__(347);

var _Pane = __webpack_require__(1494);

var _Pane2 = _interopRequireDefault(_Pane);

var _Button = __webpack_require__(52);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TwoPaneMultiSelect = function (_React$Component) {
    _inherits(TwoPaneMultiSelect, _React$Component);

    function TwoPaneMultiSelect() {
        var _ref;

        _classCallCheck(this, TwoPaneMultiSelect);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = TwoPaneMultiSelect.__proto__ || Object.getPrototypeOf(TwoPaneMultiSelect)).call.apply(_ref, [this].concat(args)));

        _this.scrollSubject = new _rxjs.Subject();
        _this.onScroll = _this.onScroll.bind(_this);
        return _this;
    }

    _createClass(TwoPaneMultiSelect, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            this.scrollSubscription = this.scrollSubject.pipe((0, _operators.debounceTime)(100)).subscribe(function (state) {
                return _this2.props.onHandleScroll(state);
            });
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.scrollSubscription.unsubscribe();
        }
    }, {
        key: "onScroll",
        value: function onScroll(event, source) {
            this.scrollSubject.next({
                top: event.currentTarget.scrollTop,
                source: source
            });
        }
    }, {
        key: "handleToggleAll",
        value: function handleToggleAll(groups) {
            var onToggleItem = this.props.onToggleItem;

            groups.forEach(function (group) {
                var groupKey = group.key,
                    items = group.items;

                items.forEach(function (_ref2) {
                    var itemKey = _ref2.key;

                    onToggleItem(groupKey, itemKey);
                });
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                onToggleItem = _props.onToggleItem,
                onUpdatePositions = _props.onUpdatePositions,
                scrollState = _props.scrollState,
                unselectedTree = _props.unselectedTree,
                selectedTree = _props.selectedTree,
                contentBlocks = _props.contentBlocks;

            var _ref3 = contentBlocks || {},
                headerContent = _ref3.header,
                _ref3$unselectedPane = _ref3.unselectedPane,
                unselectedPane = _ref3$unselectedPane === undefined ? "Unselected" : _ref3$unselectedPane,
                _ref3$selectIcon = _ref3.selectIcon,
                selectIcon = _ref3$selectIcon === undefined ? "Select" : _ref3$selectIcon,
                _ref3$selectedPane = _ref3.selectedPane,
                selectedPane = _ref3$selectedPane === undefined ? "Selected" : _ref3$selectedPane,
                _ref3$unselectIcon = _ref3.unselectIcon,
                unselectIcon = _ref3$unselectIcon === undefined ? "Unselect" : _ref3$unselectIcon,
                footerContent = _ref3.footer;

            var flexContainerStyles = {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingRight: "5px"
            };

            return _react2.default.createElement(
                "div",
                { id: "two-pane-multi-select" },
                headerContent,
                _react2.default.createElement(
                    "div",
                    { className: "container-fluid" },
                    _react2.default.createElement(
                        "div",
                        { className: "row" },
                        _react2.default.createElement(
                            "div",
                            { className: "col-md-6" },
                            _react2.default.createElement(
                                "div",
                                { style: flexContainerStyles },
                                _react2.default.createElement(
                                    "h2",
                                    null,
                                    unselectedPane
                                ),
                                _react2.default.createElement(_Button2.default, { label: "Select All", onClick: function onClick() {
                                        return _this3.handleToggleAll(unselectedTree);
                                    }, className: "btn btn-xs btn-default", enabled: true, style: { height: "40px" } })
                            ),
                            _react2.default.createElement(
                                "div",
                                { id: "unselected-list" },
                                _react2.default.createElement(_Pane2.default, {
                                    type: "unselected",
                                    iconTitle: selectIcon,
                                    groups: unselectedTree,
                                    scrollState: scrollState.unselected,
                                    toggleItem: onToggleItem,
                                    updatePositions: onUpdatePositions,
                                    handleScroll: function handleScroll(e) {
                                        return _this3.onScroll(e, "unselected");
                                    }
                                })
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "col-md-6" },
                            _react2.default.createElement(
                                "div",
                                { style: flexContainerStyles },
                                _react2.default.createElement(
                                    "h2",
                                    null,
                                    selectedPane
                                ),
                                _react2.default.createElement(_Button2.default, { label: "Clear All", onClick: function onClick() {
                                        return _this3.handleToggleAll(selectedTree);
                                    }, className: "btn btn-xs btn-default", enabled: true, style: { height: "40px" } })
                            ),
                            _react2.default.createElement(
                                "div",
                                { id: "selected-list" },
                                _react2.default.createElement(_Pane2.default, {
                                    type: "selected",
                                    iconTitle: unselectIcon,
                                    groups: selectedTree,
                                    scrollState: scrollState.selected,
                                    toggleItem: onToggleItem,
                                    updatePositions: onUpdatePositions,
                                    handleScroll: function handleScroll(e) {
                                        return _this3.onScroll(e, "selected");
                                    }
                                })
                            )
                        )
                    )
                ),
                footerContent && _react2.default.createElement(
                    "div",
                    { style: { margin: "0.5em" } },
                    footerContent
                ),
                _react2.default.createElement(
                    "div",
                    { className: "modal-footer" },
                    _react2.default.createElement(
                        "a",
                        { href: "#", className: "btn btn-save save",
                            onClick: function onClick(event) {
                                event.preventDefault();
                                _this3.props.triggerSave();
                                _this3.props.triggerClose();
                            } },
                        "Save"
                    )
                )
            );
        }
    }]);

    return TwoPaneMultiSelect;
}(_react2.default.Component);

var groupsPropType = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        key: _propTypes2.default.string.isRequired,
        name: _propTypes2.default.string.isRequired
    })),
    key: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired
}));

var contentBlocksType = exports.contentBlocksType = _propTypes2.default.shape({
    header: _propTypes2.default.string,
    unselectedPane: _propTypes2.default.string,
    selectIcon: _propTypes2.default.string,
    selectedPane: _propTypes2.default.string,
    unselectIcon: _propTypes2.default.string,
    footer: _propTypes2.default.string
});

TwoPaneMultiSelect.propTypes = {
    unselectedTree: groupsPropType.isRequired,
    selectedTree: groupsPropType.isRequired,
    scrollState: _propTypes2.default.object.isRequired,
    onToggleItem: _propTypes2.default.func.isRequired,
    onHandleScroll: _propTypes2.default.func.isRequired,
    onUpdatePositions: _propTypes2.default.func.isRequired,
    triggerSave: _propTypes2.default.func,
    triggerClose: _propTypes2.default.func,
    contentBlocks: contentBlocksType
};

exports.default = TwoPaneMultiSelect;

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _bind = __webpack_require__(633);

var _bind2 = _interopRequireDefault(_bind);

var _formatId = __webpack_require__(114);

var _formatId2 = _interopRequireDefault(_formatId);

var _Button = __webpack_require__(52);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pane = function (_React$Component) {
    _inherits(Pane, _React$Component);

    function Pane(props) {
        _classCallCheck(this, Pane);

        var _this = _possibleConstructorReturn(this, (Pane.__proto__ || Object.getPrototypeOf(Pane)).call(this, props));

        _this.handleGroupLevelSelectAll = _this.handleGroupLevelSelectAll.bind(_this);
        return _this;
    }

    _createClass(Pane, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
            var _props = this.props,
                groups = _props.groups,
                updatePositions = _props.updatePositions;

            // This "action" is really a "please measure DOM" request. So it has to
            // come from here (post render), and needs to delay a tick in case the
            // render was caused by an action.
            //
            // eslint-disable-next-line no-settimeout

            setTimeout(function () {
                return updatePositions(groups, prevProps.groups);
            });
        }
    }, {
        key: "handleGroupLevelSelectAll",
        value: function handleGroupLevelSelectAll(groupKey, itemKeys) {
            var toggleItem = this.props.toggleItem;

            itemKeys.forEach(function (itemKey) {
                toggleItem(groupKey, itemKey);
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                type = _props2.type,
                iconTitle = _props2.iconTitle,
                groups = _props2.groups,
                scrollState = _props2.scrollState,
                toggleItem = _props2.toggleItem,
                handleScroll = _props2.handleScroll;


            var isSelected = type === "selected";

            var aClasses = (0, _bind2.default)("list-group-item", {
                "selected": isSelected
            });
            var iClasses = (0, _bind2.default)("glyphicon", {
                "glyphicon-remove-circle": isSelected,
                "glyphicon-plus-circle": !isSelected
            });

            var groupItems = groups && groups.map(function (group) {
                var groupName = group.name,
                    groupKey = group.key,
                    items = group.items;

                var id = "two-pane-" + type + "-" + groupKey;
                var kids = items.map(function (_ref) {
                    var itemKey = _ref.key,
                        name = _ref.name;
                    return _react2.default.createElement(
                        "a",
                        {
                            href: "#",
                            key: itemKey,
                            id: (0, _formatId2.default)(groupKey + "-" + itemKey, "two-pane-tree-item"),
                            className: aClasses,
                            onClick: toggleItem.bind(_this2, groupKey, itemKey),
                            "data-key": itemKey,
                            "data-group": groupKey
                        },
                        _react2.default.createElement("i", {
                            title: iconTitle,
                            className: iClasses
                        }),
                        " ",
                        name
                    );
                });

                if (kids.length > 0) {
                    return _react2.default.createElement(
                        "div",
                        { id: id,
                            key: groupKey,
                            className: "panel panel-default list-group",
                            "data-group": groupKey },
                        _react2.default.createElement(
                            "div",
                            { className: "panel-heading", style: { display: "flex", justifyContent: "space-between", alignItems: "center" } },
                            _react2.default.createElement(
                                "div",
                                { className: "group-name" },
                                groupName
                            ),
                            _react2.default.createElement(
                                "div",
                                null,
                                !isSelected && _react2.default.createElement(_Button2.default, {
                                    label: "Select All",
                                    onClick: function onClick() {
                                        return _this2.handleGroupLevelSelectAll(groupKey, items.map(function (_ref2) {
                                            var key = _ref2.key;
                                            return key;
                                        }));
                                    },
                                    className: "btn btn-xs btn-default",
                                    style: {
                                        fontSize: "10px"
                                    },
                                    enabled: true
                                })
                            )
                        ),
                        _react2.default.createElement(
                            "div",
                            { className: "panel-body" },
                            kids
                        )
                    );
                } else {
                    return null;
                }
            });

            var header = _.isEmpty(scrollState.positions) ? null : _react2.default.createElement(
                "div",
                { className: "panel panel-default section-label" },
                _react2.default.createElement(
                    "div",
                    { className: "panel-heading" },
                    scrollState.title
                )
            );
            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                header,
                _react2.default.createElement(
                    "div",
                    { id: "selection-tree",
                        className: "scroll",
                        "data-spy": "scroll",
                        "data-target": ".panel-default.section-label",
                        onScroll: handleScroll,
                        style: { paddingTop: header ? 45 : 0 }
                    },
                    groupItems
                )
            );
        }
    }]);

    return Pane;
}(_react2.default.Component);

exports.default = Pane;


Pane.propTypes = {
    type: _propTypes2.default.string.isRequired,
    iconTitle: _propTypes2.default.string.isRequired,
    groups: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            key: _propTypes2.default.string.isRequired,
            name: _propTypes2.default.string.isRequired
        })),
        key: _propTypes2.default.string.isRequired,
        name: _propTypes2.default.string.isRequired
    })),
    scrollState: _propTypes2.default.object.isRequired,
    toggleItem: _propTypes2.default.func.isRequired,
    updatePositions: _propTypes2.default.func.isRequired,
    handleScroll: _propTypes2.default.func.isRequired
};

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _utils = __webpack_require__(13);

var _dotPropImmutable = __webpack_require__(40);

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _TwoPaneMultiSelectTypes = __webpack_require__(640);

var _TwoPaneMultiSelectTypes2 = _interopRequireDefault(_TwoPaneMultiSelectTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TwoPaneMultiSelectStore = function (_ReduceStore) {
    _inherits(TwoPaneMultiSelectStore, _ReduceStore);

    function TwoPaneMultiSelectStore() {
        _classCallCheck(this, TwoPaneMultiSelectStore);

        return _possibleConstructorReturn(this, (TwoPaneMultiSelectStore.__proto__ || Object.getPrototypeOf(TwoPaneMultiSelectStore)).apply(this, arguments));
    }

    _createClass(TwoPaneMultiSelectStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {
                groups: [],
                selection: {},
                scrollState: {
                    selected: {
                        positions: {},
                        currentPos: 0,
                        title: ""
                    },
                    unselected: {
                        positions: {},
                        currentPos: 0,
                        title: ""
                    }
                }
            };
        }
    }, {
        key: "getScrollState",
        value: function getScrollState() {
            return this.getState().scrollState;
        }
    }, {
        key: "getGroups",
        value: function getGroups() {
            return this.getState().groups;
        }
    }, {
        key: "getSelection",
        value: function getSelection() {
            return this.getState().selection;
        }
    }, {
        key: "calculatePositions",
        value: function calculatePositions(state, source) {
            var positions = {};

            this.getGroups().map(function (g) {
                return g.key;
            }).forEach(function (k) {
                var header = document.querySelector("#two-pane-" + source + "-" + k);
                var items = document.querySelectorAll("#two-pane-" + source + "-" + k + " a[data-group=" + k + "]");
                var lastItem = items[items.length - 1];

                if (items.length > 0) {
                    positions[k] = [header.offsetTop, lastItem.offsetTop];
                }
            });

            state = _dotPropImmutable2.default.set(state, "scrollState." + source + ".positions", positions);

            return this.setTitle(state, source);
        }
    }, {
        key: "setTitle",
        value: function setTitle(newState, source) {
            var _newState = newState,
                scrollState = _newState.scrollState;


            var pos = scrollState[source].currentPos;

            if (!_.isEmpty(scrollState[source].positions)) {
                this.getGroups().forEach(function (g) {
                    var k = g.key;
                    if (scrollState[source].positions.hasOwnProperty(k)) {
                        var p0 = scrollState[source].positions[k][0];
                        var p1 = scrollState[source].positions[k][1];

                        if (p0 <= pos && pos <= p1) {
                            newState = _dotPropImmutable2.default.set(newState, "scrollState." + source + ".title", g.name);
                        }
                    }
                });
            }
            return newState;
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            var _this2 = this;

            var source = action.source,
                groups = action.groups,
                prevGroups = action.prevGroups;


            switch (action.type) {
                case _TwoPaneMultiSelectTypes2.default.TOGGLE_ITEM:
                    var groupPath = ["selection", action.groupKey];
                    if (!state.selection.hasOwnProperty(action.groupKey)) {
                        // no group - must be a new exclude
                        return _dotPropImmutable2.default.set(state, groupPath, [action.itemKey]);
                    }

                    var items = state.selection[action.groupKey];
                    var i = items.indexOf(action.itemKey);
                    if (i < 0) {
                        // append it
                        return _dotPropImmutable2.default.set(state, groupPath, function (v) {
                            return v.concat(action.itemKey);
                        });
                    }
                    if (items.length === 1) {
                        // the only one
                        return _dotPropImmutable2.default.delete(state, groupPath);
                    } else {
                        items = items.slice(); // duplicate
                        items.splice(i, 1);
                        return _dotPropImmutable2.default.set(state, groupPath, items);
                    }

                case _TwoPaneMultiSelectTypes2.default.POPULATE:
                    return _extends({}, this.getInitialState(), {
                        groups: groups,
                        selection: action.selection
                    });

                case _TwoPaneMultiSelectTypes2.default.HANDLE_SCROLL:
                    state = _dotPropImmutable2.default.set(state, "scrollState." + source + ".currentPos", action.top);

                    ["selected", "unselected"].forEach(function (source) {
                        if (_.isEmpty(state.scrollState[source].positions)) {
                            state = _this2.calculatePositions(state, source);
                        }
                    });

                    state = this.setTitle(state, source);

                    return state;

                case _TwoPaneMultiSelectTypes2.default.UPDATE_POSITIONS:
                    if (!_.isEqual(prevGroups, groups)) {
                        ["unselected", "selected"].forEach(function (source) {
                            state = _this2.calculatePositions(state, source);
                        });
                    }

                    return state;

                default:
                    return state;
            }
        }
    }]);

    return TwoPaneMultiSelectStore;
}(_utils.ReduceStore);

exports.default = new TwoPaneMultiSelectStore(_Dispatcher2.default);

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TwoPaneMultiSelectContainer = __webpack_require__(639);

var _TwoPaneMultiSelectContainer2 = _interopRequireDefault(_TwoPaneMultiSelectContainer);

var _asModal = __webpack_require__(130);

var _asModal2 = _interopRequireDefault(_asModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HiddenFieldAdminModal = function HiddenFieldAdminModal(_ref) {
    var triggerClose = _ref.triggerClose,
        triggerSave = _ref.triggerSave;
    return _react2.default.createElement(_TwoPaneMultiSelectContainer2.default, {
        triggerClose: triggerClose,
        triggerSave: triggerSave,
        contentBlocks: {
            header: "Please select the fields you would like to hide within data entry.",
            unselectedPane: "Available Fields",
            selectIcon: "Hide",
            selectedPane: "Hidden Fields",
            unselectIcon: "Show",
            footer: "* only applies to a subset of versions"
        }
    });
};

HiddenFieldAdminModal.propTypes = {
    triggerClose: _propTypes2.default.func.isRequired,
    triggerSave: _propTypes2.default.func.isRequired
};

exports.default = (0, _asModal2.default)("Hidden Fields Administration")(HiddenFieldAdminModal);

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BackboneGenericXmlExportPasswordAdmin = undefined;

var _GxepStore = __webpack_require__(486);

var _GxepStore2 = _interopRequireDefault(_GxepStore);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _GxepActions = __webpack_require__(171);

var _GxepActions2 = _interopRequireDefault(_GxepActions);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _GenericXmlExportPasswordAdmin = __webpack_require__(323);

var _asModal = __webpack_require__(130);

var _asModal2 = _interopRequireDefault(_asModal);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackboneGenericXmlExportPasswordAdmin = exports.BackboneGenericXmlExportPasswordAdmin = (0, _asModal2.default)(_GenericXmlExportPasswordAdmin.title)(function (props) {
    var triggerClose = props.triggerClose;

    var state = (0, _useFluxStore2.default)(function () {
        return {
            passwordsLO: _GxepStore2.default.getState(),
            onCancel: function onCancel() {
                _Dispatcher2.default.dispatch({
                    type: _GxepActions2.default.DIALOG_CLOSED
                });
                triggerClose();
            },
            onChange: function onChange(key, password) {
                return _Dispatcher2.default.dispatch({
                    type: _GxepActions2.default.UPDATE_PASSWORD,
                    key: key,
                    password: password
                });
            },
            onSave: function onSave() {
                _Dispatcher2.default.dispatch({
                    type: _GxepActions2.default.START_SAVE
                });
                triggerClose();
            }
        };
    }, [_GxepStore2.default], [triggerClose]);
    return _react2.default.createElement(_GenericXmlExportPasswordAdmin.GenericXmlExportPasswordAdmin, state);
});

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BackboneBroadcastAdmin = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.BroadcastAdmin = BroadcastAdmin;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _asModal = __webpack_require__(130);

var _asModal2 = _interopRequireDefault(_asModal);

var _BroadcastServices = __webpack_require__(491);

var _BroadcastServices2 = _interopRequireDefault(_BroadcastServices);

var _calendar = __webpack_require__(294);

var _calendar2 = _interopRequireDefault(_calendar);

var _textarea = __webpack_require__(299);

var _textarea2 = _interopRequireDefault(_textarea);

var _ControlTemplate = __webpack_require__(26);

var _ControlTemplate2 = _interopRequireDefault(_ControlTemplate);

var _ActionButton = __webpack_require__(249);

var _ActionButton2 = _interopRequireDefault(_ActionButton);

var _Button = __webpack_require__(52);

var _Button2 = _interopRequireDefault(_Button);

var _classnames = __webpack_require__(51);

var _classnames2 = _interopRequireDefault(_classnames);

var _InlineLoader = __webpack_require__(353);

var _InlineLoader2 = _interopRequireDefault(_InlineLoader);

var _usePeriodicTask = __webpack_require__(325);

var _usePeriodicTask2 = _interopRequireDefault(_usePeriodicTask);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function emptyMessage() {
    return {
        activeAt: null,
        expiresAt: moment().add("hours", 1),
        message: ""
    };
}

function formatMoment(m) {
    var s = m.fromNow();
    if (Math.abs(m - moment()) < 12 * 60 * 60 * 1000) {
        s += " (" + m.format("HH:mm") + ")";
    }
    return s;
}

function BroadcastAdmin() {
    var _React$useState = _react2.default.useState(false),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        loading = _React$useState2[0],
        setLoading = _React$useState2[1];

    var _React$useState3 = _react2.default.useState(undefined),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        error = _React$useState4[0],
        setError = _React$useState4[1];

    var _React$useState5 = _react2.default.useState([]),
        _React$useState6 = _slicedToArray(_React$useState5, 2),
        allMessages = _React$useState6[0],
        setAllMessages = _React$useState6[1];

    var _React$useState7 = _react2.default.useState(0),
        _React$useState8 = _slicedToArray(_React$useState7, 2),
        lastRefresh = _React$useState8[0],
        setLastRefresh = _React$useState8[1];

    var refresh = function refresh(background) {
        if (background && lastRefresh > Date.now() - 15 * 1000) return;
        setLoading(true);
        _BroadcastServices2.default.getAllMessages().then(function (ms) {
            setAllMessages(ms);
            setLastRefresh(Date.now());
        }).catch(setError).finally(function () {
            return setLoading(false);
        });
    };

    (0, _usePeriodicTask2.default)(function () {
        return refresh(true);
    }, 30 * 1000, [lastRefresh]);

    var _React$useState9 = _react2.default.useState(emptyMessage()),
        _React$useState10 = _slicedToArray(_React$useState9, 2),
        draft = _React$useState10[0],
        setDraft = _React$useState10[1];

    var resetForm = function resetForm() {
        return setDraft(emptyMessage());
    };

    var handleCommit = function handleCommit(desc, val) {
        setDraft(function (d) {
            return _extends({}, d, _defineProperty({}, desc.key, val));
        });
    };

    var handleChange = function handleChange(e, desc, val) {
        return handleCommit(desc, val);
    };

    var handleReset = function handleReset(e) {
        e.preventDefault();
        resetForm();
    };

    var handleCreate = function handleCreate(e) {
        e.preventDefault();
        setLoading(true);
        _BroadcastServices2.default.createMessage(draft).then(function () {
            return refresh(false);
        }).then(resetForm).catch(setError);
    };

    var handleDelete = function handleDelete(e, m) {
        e.preventDefault();
        setLoading(true);
        _BroadcastServices2.default.deleteMessage(m).then(function () {
            return refresh(false);
        }).catch(setError);
    };

    var enableBroadcast = !loading && !!draft.message && !!draft.expiresAt;
    var now = moment();

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            "div",
            { className: "broadcast-title-warning" },
            "Note: This will send a message to all logged in users."
        ),
        _react2.default.createElement(
            "div",
            { className: "record-grid-container" },
            _react2.default.createElement(
                "div",
                { className: "record-grid" },
                _react2.default.createElement(
                    "table",
                    { className: "table-alt table-condensed" },
                    _react2.default.createElement(
                        "thead",
                        null,
                        _react2.default.createElement(
                            "tr",
                            null,
                            _react2.default.createElement(
                                "th",
                                null,
                                loading && _react2.default.createElement(_InlineLoader2.default, { message: null }),
                                "Active"
                            ),
                            _react2.default.createElement(
                                "th",
                                null,
                                "Expires"
                            ),
                            _react2.default.createElement(
                                "th",
                                null,
                                "Message"
                            ),
                            _react2.default.createElement("th", null)
                        )
                    ),
                    _react2.default.createElement(
                        "tbody",
                        null,
                        allMessages.length ? allMessages.map(function (m, i) {
                            return _react2.default.createElement(
                                "tr",
                                {
                                    key: m.id,
                                    className: (0, _classnames2.default)({
                                        "broadcast-past": m.expiresAt < now,
                                        "broadcast-present": m.activeAt <= now && m.expiresAt >= now,
                                        "broadcast-future": m.activeAt > now
                                    })
                                },
                                _react2.default.createElement(
                                    "td",
                                    { title: m.activeAt.format() },
                                    formatMoment(m.activeAt)
                                ),
                                _react2.default.createElement(
                                    "td",
                                    { title: m.expiresAt.format() },
                                    formatMoment(m.expiresAt)
                                ),
                                _react2.default.createElement(
                                    "td",
                                    null,
                                    m.message
                                ),
                                _react2.default.createElement(
                                    "td",
                                    { align: "right" },
                                    _react2.default.createElement(_ActionButton2.default, {
                                        actionType: "remove",
                                        onClick: function onClick(e) {
                                            return handleDelete(e, m);
                                        }
                                    })
                                )
                            );
                        }) : _react2.default.createElement(
                            "tr",
                            null,
                            _react2.default.createElement(
                                "td",
                                { colSpan: 4 },
                                "No Broadcast Messages"
                            )
                        )
                    ),
                    error && _react2.default.createElement(
                        "tfoot",
                        null,
                        _react2.default.createElement(
                            "tr",
                            null,
                            _react2.default.createElement(
                                "td",
                                {
                                    colSpan: 4,
                                    className: "alert-danger"
                                },
                                error.message || error.statusText || error.toString()
                            )
                        )
                    )
                )
            )
        ),
        _react2.default.createElement(
            "form",
            {
                onSubmit: handleCreate,
                style: {
                    padding: "2em 0",
                    margin: "2em 0",
                    borderTop: "1px solid gray"
                }
            },
            _react2.default.createElement(_calendar2.default, {
                descriptor: {
                    id: "broadcast-activeAt",
                    key: "activeAt",
                    type: "datetime",
                    control: "calendar",
                    label: "Active At",
                    disableBehaviour: "disable",
                    config: {
                        granularity: "MINUTE"
                    }
                },
                value: draft.activeAt,
                onCommitChange: handleCommit,
                enabled: true
            }),
            _react2.default.createElement(_calendar2.default, {
                descriptor: {
                    id: "broadcast-expiresAt",
                    key: "expiresAt",
                    type: "datetime",
                    control: "calendar",
                    label: "Expires At",
                    disableBehaviour: "disable",
                    config: {
                        granularity: "MINUTE"
                    },
                    required: true
                },
                value: draft.expiresAt,
                onCommitChange: handleCommit,
                enabled: true
            }),
            _react2.default.createElement(_textarea2.default, {
                descriptor: {
                    id: "broadcast-message",
                    key: "message",
                    type: "string",
                    control: "textarea",
                    label: "Message",
                    disableBehaviour: "disable",
                    config: {},
                    required: true
                },
                value: draft.message,
                onChange: handleChange,
                onCommitChange: handleCommit,
                enabled: true
            }),
            _react2.default.createElement(
                _ControlTemplate2.default,
                {
                    descriptor: {
                        id: "broadcast-actions",
                        key: "actions",
                        type: "widget",
                        control: "button",
                        label: "",
                        disableBehaviour: "disable",
                        config: {}
                    }
                },
                _react2.default.createElement(_Button2.default, {
                    label: "Broadcast",
                    onClick: handleCreate,
                    className: "btn btn-primary",
                    enabled: enableBroadcast
                }),
                _react2.default.createElement(_Button2.default, {
                    label: "Reset Form",
                    onClick: handleReset,
                    className: "btn btn-default",
                    enabled: true
                })
            )
        ),
        _react2.default.createElement("br", { clear: "both" })
    );
}

var BackboneBroadcastAdmin = exports.BackboneBroadcastAdmin = (0, _asModal2.default)("Broadcast Admin")(BroadcastAdmin);

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _Form = __webpack_require__(642);

var _OrgSelect = __webpack_require__(643);

var _OrgSelect2 = _interopRequireDefault(_OrgSelect);

var _ReauthModule = __webpack_require__(253);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var AncestryContext = _react2.default.createContext(undefined);

function isActiveAncestor(name) {
    var ancestry = _react2.default.useContext(AncestryContext);
    return ancestry && ancestry.has(name);
}

function Perms(_ref) {
    var org = _ref.org,
        onPermsChange = _ref.onPermsChange;

    var _React$useState = _react2.default.useState(false),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        editing = _React$useState2[0],
        setEditing = _React$useState2[1];

    var _React$useState3 = _react2.default.useState(0),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        modifiersActive = _React$useState4[0],
        setModifiersActive = _React$useState4[1];

    var perms = (0, _ReauthModule.usePerms)();
    if (!editing) {
        return _react2.default.createElement(
            "span",
            { className: "perms" },
            "( ",
            _react2.default.createElement(
                "ul",
                null,
                org.perms && org.perms.length ? org.perms.map(function (p) {
                    return _react2.default.createElement(
                        "li",
                        { key: p },
                        p
                    );
                }) : _react2.default.createElement(
                    "li",
                    null,
                    "ALL"
                )
            ),
            onPermsChange && _react2.default.createElement(
                "button",
                {
                    onClick: function onClick() {
                        return setEditing(true);
                    },
                    title: "Edit license grants"
                },
                "\u2710"
            ),
            " )"
        );
    }

    function handleKeyEvent(e, delta) {
        if (e.key === "Control" || e.key === "Shift" || e.key === "Alt") {
            setModifiersActive(function (n) {
                return n + delta;
            });
        }
    }

    function handleChange(e) {
        var newPerms = Array.from(e.target.selectedOptions, function (option) {
            return option.value;
        });
        if (newPerms.length === 0) {
            newPerms = undefined;
        } else if (newPerms) {
            newPerms = [].concat(_toConsumableArray(new Set(newPerms)));
            // ALL, ACCESS, and NONE are special...
            if (modifiersActive > 0 && newPerms.length > 1) {
                newPerms = newPerms.filter(function (p) {
                    return p !== "NONE" && p !== "ALL" && p !== "ACCESS";
                });
                if (newPerms.length === 0) {
                    newPerms = undefined;
                }
            } else if (newPerms.some(function (p) {
                return p === "NONE";
            })) {
                newPerms = ["NONE"];
                if (modifiersActive === 0) {
                    setEditing(false);
                }
            } else if (newPerms.some(function (p) {
                return p === "ALL";
            })) {
                newPerms = undefined;
                if (modifiersActive === 0) {
                    setEditing(false);
                }
            } else if (newPerms.length > 1) {
                newPerms = newPerms.filter(function (p) {
                    return p !== "ACCESS";
                });
            }
        }
        onPermsChange(newPerms);
    }

    return _react2.default.createElement(
        "span",
        { className: "perms" },
        _react2.default.createElement(
            "select",
            {
                value: org.perms || ["ALL"],
                autoFocus: true,
                multiple: true,
                size: perms.length,
                onKeyDown: function onKeyDown(e) {
                    return handleKeyEvent(e, 1);
                },
                onKeyUp: function onKeyUp(e) {
                    return handleKeyEvent(e, -1);
                },
                onChange: handleChange,
                onBlur: function onBlur() {
                    return setEditing(false);
                }
            },
            perms.map(function (p) {
                return _react2.default.createElement(
                    "option",
                    { key: p, value: p },
                    p
                );
            })
        )
    );
}

var orgType = _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    kids: _propTypes2.default.array.isRequired
});
Perms.propTypes = {
    org: orgType.isRequired,
    onPermsChange: _propTypes2.default.func
};

function Org(_ref2) {
    var org = _ref2.org,
        ancestors = _ref2.ancestors,
        onKidsChange = _ref2.onKidsChange,
        onPermsChange = _ref2.onPermsChange,
        onDelete = _ref2.onDelete;

    var active = (0, _Form.isActiveOrg)(org.name);
    var ancestor = isActiveAncestor(org.name);
    var selfAndAncestors = _react2.default.useMemo(function () {
        return (ancestors || []).concat(org.name);
    }, [org.name, ancestors]);

    return _react2.default.createElement(
        "li",
        {
            className: active ? "org active" : ancestor ? "org ancestor" : "org"
        },
        _react2.default.createElement(
            "div",
            {
                className: "flex",
                style: { justifyContent: "space-between" }
            },
            _react2.default.createElement(
                "span",
                {
                    className: "flex"
                },
                org.name,
                _react2.default.createElement(Perms, {
                    org: org,
                    onPermsChange: onPermsChange
                })
            ),
            _react2.default.createElement(
                "span",
                { className: "flex" },
                onDelete && _react2.default.createElement(
                    "button",
                    {
                        onClick: onDelete,
                        title: "Remove this license"
                    },
                    "\xD7"
                ),
                _react2.default.createElement(_OrgSelect2.default, {
                    excludes: selfAndAncestors,
                    allowBlank: true,
                    title: "Create a new child license",
                    value: "",
                    onChange: function onChange(e) {
                        return onKidsChange(org.kids.concat({
                            name: e.target.value,
                            kids: []
                        }));
                    }
                })
            )
        ),
        _react2.default.createElement(Kids, {
            kids: org.kids,
            ancestors: selfAndAncestors,
            onChange: onKidsChange
        })
    );
}

Org.propTypes = {
    org: orgType.isRequired,
    ancestors: _propTypes2.default.arrayOf(_propTypes2.default.string),
    onKidsChange: _propTypes2.default.func.isRequired,
    onPermsChange: _propTypes2.default.func,
    onDelete: _propTypes2.default.func
};

function augmentIth(arr, i, augment) {
    var next = arr.slice();
    next[i] = _extends({}, next[i], augment);
    return next;
}

function Kids(_ref3) {
    var kids = _ref3.kids,
        ancestors = _ref3.ancestors,
        onChange = _ref3.onChange;

    if (!kids || !kids.length) return null;
    return _react2.default.createElement(
        "ul",
        null,
        kids.map(function (k, i) {
            return _react2.default.createElement(Org, {
                key: k.name,
                org: k,
                ancestors: ancestors,
                onKidsChange: function onKidsChange(newKids) {
                    return onChange(augmentIth(kids, i, {
                        kids: newKids
                    }));
                },
                onPermsChange: function onPermsChange(newPerms) {
                    return onChange(augmentIth(kids, i, {
                        perms: newPerms
                    }));
                },
                onDelete: function onDelete(e) {
                    e.preventDefault();
                    var next = kids.slice();
                    next.splice(i, 1);
                    onChange(next);
                }
            });
        })
    );
}

Kids.propTypes = {
    kids: _propTypes2.default.arrayOf(orgType),
    ancestors: _propTypes2.default.arrayOf(_propTypes2.default.string),
    onChange: _propTypes2.default.func.isRequired
};

function Forest(_ref4) {
    var forest = _ref4.forest,
        ancestry = _ref4.ancestry,
        onChange = _ref4.onChange,
        buildImplLicense = _ref4.buildImplLicense;

    return _react2.default.createElement(
        "ul",
        null,
        forest.map(function (it, i) {
            var handleKidsChange = function handleKidsChange(newKids) {
                return onChange(function (f) {
                    return augmentIth(f, i, {
                        kids: newKids
                    });
                });
            };
            var handleImplLicense = function handleImplLicense(implementer) {
                return handleKidsChange(it.kids.concat(buildImplLicense(implementer)));
            };
            return _react2.default.createElement(
                "li",
                {
                    key: it.name,
                    className: "impl"
                },
                _react2.default.createElement(
                    "div",
                    {
                        className: "flex",
                        style: { justifyContent: "space-between" }
                    },
                    _react2.default.createElement(
                        "span",
                        null,
                        it.name,
                        " (",
                        it.implementer,
                        ")"
                    ),
                    (!it.kids || it.kids.length === 0) && _react2.default.createElement(
                        "button",
                        {
                            title: "Create root license",
                            onClick: function onClick(e) {
                                e.preventDefault();
                                handleImplLicense(it.implementer);
                            }
                        },
                        "license"
                    )
                ),
                _react2.default.createElement(
                    AncestryContext.Provider,
                    { value: ancestry[it.name] },
                    _react2.default.createElement(Kids, {
                        kids: it.kids,
                        onChange: handleKidsChange
                    })
                )
            );
        })
    );
}

Forest.propTypes = {
    forest: _propTypes2.default.array.isRequired,
    ancestry: _propTypes2.default.object.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    buildImplLicense: _propTypes2.default.func.isRequired
};

exports.default = Forest;

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function splitTrim(string, delim) {
    return string.split(delim).map(function (it) {
        return it.trim();
    });
}

function parseSpec(curr) {
    var _splitTrim = splitTrim(curr.replace(/]/, ""), "["),
        _splitTrim2 = _slicedToArray(_splitTrim, 2),
        userSegment = _splitTrim2[0],
        licsSegment = _splitTrim2[1];

    var _userSegment$split = userSegment.split(":"),
        _userSegment$split2 = _slicedToArray(_userSegment$split, 2),
        user = _userSegment$split2[0],
        org = _userSegment$split2[1];

    var licenses = licsSegment.split(",").map(function (l) {
        var _splitTrim3 = splitTrim(l.replace(/\)/, ""), "("),
            _splitTrim4 = _slicedToArray(_splitTrim3, 2),
            path = _splitTrim4[0],
            perms = _splitTrim4[1];

        var chain = splitTrim(path, ">");
        var impl = void 0;
        if (chain[0].indexOf(":") < 0) {
            impl = chain[0];
            chain[0] = org;
        } else {
            var _splitTrim5 = splitTrim(chain[0], ":"),
                _splitTrim6 = _slicedToArray(_splitTrim5, 2),
                i = _splitTrim6[0],
                o = _splitTrim6[1];

            impl = i;
            chain[0] = o;
        }
        return {
            impl: impl,
            chain: chain,
            perms: perms ? splitTrim(perms, "|") : undefined
        };
    });

    var map = new Map();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = licenses[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var l = _step.value;

            if (!map.has(l.impl)) {
                map.set(l.impl, {
                    name: l.impl,
                    implementer: l.chain[l.chain.length - 1],
                    kids: new Map()
                });
            }
            var path = l.chain.slice().reverse();
            path.reduce(function (it, o) {
                if (!it.kids.has(o)) {
                    it.kids.set(o, {
                        name: o,
                        kids: new Map()
                    });
                }
                return it.kids.get(o);
            }, map.get(l.impl)).perms = l.perms;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    function walk(it) {
        return _extends({}, it, {
            kids: [].concat(_toConsumableArray(it.kids.values())).map(walk)
        });
    }

    var forestUpdater = function forestUpdater(f) {
        return f.map(function (it) {
            if (map.has(it.name)) {
                var _l = map.get(it.name);
                map.delete(it.name);
                return walk(_l);
            } else {
                return _extends({}, it, {
                    kids: []
                });
            }
        }).concat([].concat(_toConsumableArray(map.values())).map(walk));
    };

    return [user, org, forestUpdater];
}

exports.default = parseSpec;

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Spec(_ref) {
    var spec = _ref.spec,
        onChange = _ref.onChange,
        collapsed = _ref.collapsed;

    var _React$useState = _react2.default.useState(null),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        copied = _React$useState2[0],
        setCopied = _React$useState2[1];

    var _React$useState3 = _react2.default.useState(false),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        editing = _React$useState4[0],
        setEditing = _React$useState4[1];

    var _React$useState5 = _react2.default.useState(spec),
        _React$useState6 = _slicedToArray(_React$useState5, 2),
        newVal = _React$useState6[0],
        setNewVal = _React$useState6[1];

    _react2.default.useEffect(function () {
        return setNewVal(spec);
    }, [spec]);
    _react2.default.useEffect(function () {
        // eslint-disable-next-line no-settimeout
        var id = setTimeout(function () {
            return setCopied(null);
        }, 3000);
        return function () {
            return clearTimeout(id);
        };
    }, [copied]);
    if (editing) {
        return _react2.default.createElement("textarea", {
            value: newVal,
            onChange: function onChange(e) {
                return setNewVal(e.target.value);
            },
            onBlur: function onBlur() {
                onChange(newVal);
                setEditing(false);
            },
            rows: 4,
            style: { width: "100%" },
            autoFocus: true
        });
    }
    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            "code",
            { style: { position: "relative" } },
            onChange && _react2.default.createElement(
                "button",
                {
                    onClick: function onClick() {
                        return setEditing(true);
                    },
                    title: "Edit raw spec",
                    style: { position: "absolute", top: 0, right: 0 }
                },
                "\u2710"
            ),
            collapsed ? spec.replace(/([[,(|:])/g, "$1\u200B") : spec.replace(/([[,])/g, "$1 ").split(" ").map(function (it, i) {
                return _react2.default.createElement(
                    "div",
                    {
                        key: i,
                        className: i === 0 ? null : "indent"
                    },
                    it.replace(/([(])/g, "$1 ").split(" ").map(function (it, i) {
                        return _react2.default.createElement(
                            "div",
                            {
                                key: i,
                                className: i === 0 ? null : "indent"
                            },
                            it
                        );
                    })
                );
            })
        ),
        (!onChange || !editing) && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                "button",
                {
                    onClick: function onClick() {
                        return navigator.clipboard.writeText(spec).then(function () {
                            return setCopied(Date.now());
                        });
                    }
                },
                "raw"
            ),
            _react2.default.createElement(
                "button",
                {
                    onClick: function onClick() {
                        return navigator.clipboard.writeText(encodeURIComponent(spec)).then(function () {
                            return setCopied(Date.now());
                        });
                    }
                },
                "encoded"
            ),
            copied && _react2.default.createElement(
                "span",
                { className: "alert alert-info" },
                "Copied!"
            )
        )
    );
}

Spec.propTypes = {
    spec: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func,
    collapsed: _propTypes2.default.bool
};

exports.default = Spec;

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function updateForestForImpls(f, impls) {
    var names = new Map(f.map(function (it, idx) {
        return [it.name, idx];
    }));
    return Object.keys(impls).reduce(function (f, name) {
        if (!names.has(name)) {
            var _impl = {
                name: name,
                implementer: impls[name],
                kids: []
            };
            names.set(name, f.length);
            return f.concat(_impl);
        }
        if (f[names.get(name)].implementer === impls[name]) {
            return f;
        }
        f = f.slice();
        var impl = f[names.get(name)];
        impl.implementer = impls[name];
        impl.kids = [];
        return f;
    }, f).sort(function (a, b) {
        return a.name < b.name ? -1 : 1;
    });
}

exports.default = updateForestForImpls;

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useSpec(user, activeOrg, forest) {
    var _React$useState = _react2.default.useState(""),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        spec = _React$useState2[0],
        setSpec = _React$useState2[1];

    var _React$useState3 = _react2.default.useState(false),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        valid = _React$useState4[0],
        setValid = _React$useState4[1];

    var _React$useState5 = _react2.default.useState({}),
        _React$useState6 = _slicedToArray(_React$useState5, 2),
        ancestry = _React$useState6[0],
        setAncestry = _React$useState6[1];

    _react2.default.useEffect(function () {
        var ancestry = {};

        function walk(it) {
            return it.kids.flatMap(walk).map(function (c) {
                return _extends({}, c, {
                    path: c.path.concat(it.name)
                });
            }).concat({
                path: [it.name],
                perms: it.perms
            });
        }

        var toPathStr = function toPathStr(c) {
            return c.path.join(">");
        };
        var chains = forest.filter(function (f) {
            return f.kids && f.kids.length;
        }).flatMap(function (f) {
            var allLicenses = f.kids.flatMap(walk);
            var aops = allLicenses.filter(function (c) {
                return c.path[0] === activeOrg;
            });
            ancestry[f.name] = new Set(aops.flatMap(function (c) {
                return c.path;
            }));
            var activeOrgPaths = aops.map(toPathStr);
            var toKeep = allLicenses.filter(function (c) {
                // it has perms
                if (c.perms && c.perms.length) return true;
                // it's active org or a descendant
                if (c.path.some(function (it) {
                    return it === activeOrg;
                })) return true;
                // it's not the active org's ancestor
                var pathStr = toPathStr(c);
                return !activeOrgPaths.some(function (aop) {
                    return aop.endsWith(pathStr);
                });
            });
            return toKeep.map(function (c) {
                var path = c.path.map(function (it, i) {
                    return i === 0 ? it === activeOrg ? f.name : f.name + ":" + it : it;
                }).join(">");
                return c.perms ? path + "(" + c.perms.join("|") + ")" : path;
            });
        }).sort(function (a, b) {
            // active org first
            var ac = a.indexOf(":") >= 0;
            var bc = b.indexOf(":") >= 0;
            if (!ac && bc) return -1;
            if (ac && !bc) return 1;
            // lexicographical
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
        });
        setAncestry(ancestry);
        setSpec(user + ":" + activeOrg + "[" + chains.join(",") + "]");
        setValid(chains.length > 0);
    }, [user, activeOrg, forest]);
    return [spec, valid, ancestry];
}

exports.default = useSpec;

/***/ }),
/* 1504 */,
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _TableColumnMetaStore = __webpack_require__(125);

var _TableColumnMetaStore2 = _interopRequireDefault(_TableColumnMetaStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var implementationFieldsByEntity = function implementationFieldsByEntity(implKey, fieldFilter) {
    var indicatePartials = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (fieldFilter == null) indicatePartials = false;
    var entityInfos = _entityMetaStore2.default.getAllInfos(function (ei) {
        return ei.implKey === implKey;
    });
    var orderedRootEntityKeys = entityInfos.filter(function (ei) {
        return ei.type === "ROOT";
    }).sort(_entityMetaStore.entityInfoComparator).map(function (ei) {
        return ei.key;
    });
    var orderedVersionKeys = orderedRootEntityKeys.map(function (k) {
        return new _EntityName2.default(k).versionKey;
    });
    var fieldsByEntity = new Map(); // Map<baseEntityKey, Map<fieldKey, itemIdx>>
    var groupLookup = new Map(); // Map<bareEntityKey, Group>
    entityInfos.sort(function (a, b) {
        var avk = new _EntityName2.default(a.key).versionKey;
        var bvk = new _EntityName2.default(b.key).versionKey;
        return orderedVersionKeys.indexOf(avk) - orderedVersionKeys.indexOf(bvk);
    }).forEach(function (ei) {
        var fieldInfos = _entityFieldMetaStore2.default.getAllInfos(ei.key, indicatePartials ? null : function (fi) {
            if (!fieldFilter || fieldFilter(fi)) return true;
            return fi.otherEntityKey && !_TableColumnMetaStore2.default.getInfoByKey(ei.logicalKey, fi.logicalKey).inverse;
        });
        if (fieldInfos.length === 0) return;
        var bareEntityKey = new _EntityName2.default(ei.key).bareEntityKey;
        var group = void 0;
        var fieldKeyIndexes = fieldsByEntity.get(bareEntityKey);
        if (fieldKeyIndexes == null) {
            fieldsByEntity.set(bareEntityKey, fieldKeyIndexes = new Map());
            group = {
                key: bareEntityKey,
                typePriority: ei.typePriority,
                name: ei.name,
                pluralName: ei.pluralName,
                items: []
            };
            groupLookup.set(group.key, group);
        } else {
            group = groupLookup.get(bareEntityKey);
        }
        fieldInfos.forEach(function (fi) {
            if (!fieldKeyIndexes.has(fi.key)) {
                fieldKeyIndexes.set(fi.key, group.items.length);
                if (indicatePartials) {
                    var filter = fieldFilter(fi);
                    fi = _extends({}, fi, {
                        __any: filter,
                        __all: filter
                    });
                }
                group.items.push(fi);
            } else if (indicatePartials) {
                var _filter = fieldFilter(fi);
                var agg = group.items[fieldKeyIndexes.get(fi.key)];
                if (agg.__all && !_filter) {
                    agg.name += " *";
                }
                agg.__any = agg.__any || _filter;
                agg.__all = agg.__all && _filter;
            }
        });
    });
    var groups = [];
    var doEntityKeys = function doEntityKeys(entityKeys) {
        return entityKeys.map(function (ek) {
            return new _EntityName2.default(ek).bareEntityKey;
        }).map(function (bek) {
            // IMPURE
            if (!groupLookup.has(bek)) return undefined;
            var g = groupLookup.get(bek);
            groupLookup.delete(bek);
            return g;
        }).filter(function (g) {
            return g;
        }) // it's a DAG, not a tree. and worse: multi-version
        .sort(function (a, b) {
            return a.typePriority - b.typePriority;
        }).forEach(function (g) {
            groups.push(g);
            g.items.sort(function (a, b) {
                if (a.name !== b.name) {
                    return a.name < b.name ? -1 : 1;
                }
                return a.key < b.key ? -1 : 1;
            });
            doEntityKeys(g.items.filter(function (f) {
                return f.otherEntityKey;
            }).map(function (f) {
                return f.otherEntityKey;
            }));
            // now do the full filter, which means we need to re-filter assocs,
            // while non-assocs that managed to get here are known to be good.
            if (fieldFilter) {
                g.items = g.items.filter(indicatePartials ? function (it) {
                    return it.__any;
                } : function (it) {
                    return !it.otherEntityKey || fieldFilter(it);
                });
            }
        });
    };
    doEntityKeys(orderedRootEntityKeys);
    return groups;
};

exports.default = implementationFieldsByEntity;

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _asModal = __webpack_require__(130);

var _asModal2 = _interopRequireDefault(_asModal);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _PrintDialog = __webpack_require__(1507);

var _PrintDialog2 = _interopRequireDefault(_PrintDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PrintModule = (0, _asModal2.default)("Print Options")(function (props) {
    var triggerClose = props.triggerClose,
        passthrough = _objectWithoutProperties(props, ["triggerClose"]);

    var handleCancel = function handleCancel() {
        triggerClose();
    };

    return _react2.default.createElement(_PrintDialog2.default, _extends({}, passthrough, {
        onCancel: handleCancel
    }));
});

exports.default = PrintModule;

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _typedefs = __webpack_require__(44);

var _HybridConfig = __webpack_require__(41);

var _HybridConfig2 = _interopRequireDefault(_HybridConfig);

var _form = __webpack_require__(107);

var _form2 = _interopRequireDefault(_form);

var _query_string = __webpack_require__(192);

var _query_string2 = _interopRequireDefault(_query_string);

var _useFluxStore3 = __webpack_require__(9);

var _useFluxStore4 = _interopRequireDefault(_useFluxStore3);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function item(key, label, type, control) {
    var config = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    return {
        config: config,
        key: key,
        id: key,
        path: key,
        label: label,
        disableBehaviour: "hide",
        type: type,
        control: control
    };
}

function layout(control, label, childItems) {
    if (label instanceof Array) {
        childItems = label;
        label = "Unlabeled";
    }
    var l = item(Math.random().toString().substr(2), label, control === "form" ? "Form" : "Layout", control);
    l.childItems = childItems;
    return l;
}

var FORM_DESCRIPTOR = layout("form", [item("textSize", "Font Size", "StringField", "dropdown", {
    options: ["Small", "Large"]
}), item("columnCount", "Number of Data Columns", "StringField", "dropdown", {
    options: ["1", "2", "3"]
}), item("labelWidth", "Field Name Column Width", "IntegerField", "spinner"), item("dataWidth", "Value Column Width", "IntegerField", "spinner"), layout("section", "Show", [item("showCellBorders", "Cell Borders", "ChoiceField", "checkbox"), item("showExportDate", "Print Date", "ChoiceField", "checkbox"), item("includeDisabledFields", "Disabled Fields", "ChoiceField", "checkbox"), item("includeUserHiddenFields", "Hidden Fields", "ChoiceField", "checkbox"), item("includeOffFormFields", "Off-Form Fields", "ChoiceField", "checkbox"), item("includeMissingValuedFields", "Missing Values", "ChoiceField", "checkbox"), item("showSectionFrames", "Frames", "ChoiceField", "checkbox")]), layout("section", "Mark", [item("markHarvestableFields", "Harvestable Fields", "ChoiceField", "checkbox"), item("markDisabledFields", "Disabled Fields", "ChoiceField", "checkbox")])]);

var initialState = {
    columnCount: "2",
    labelWidth: 200,
    dataWidth: 100,
    showCellBorders: true,
    showExportDate: true,
    showSectionFrames: true,
    textSize: "Large",
    includeOffFormFields: false,
    includeDisabledFields: true,
    includeMissingValuedFields: true,
    markDisabledFields: false,
    markHarvestableFields: false,
    includeUserHiddenFields: false
};

function PrintDialog(props) {
    var entityKey = props.entityKey,
        id = props.id,
        onCancel = props.onCancel;


    var org = _userStore2.default.getActiveOrgKey();

    var _React$useState = _react2.default.useState(initialState),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        state = _React$useState2[0],
        setState = _React$useState2[1];

    var _useFluxStore = (0, _useFluxStore4.default)(function () {
        var implKey = new _EntityName2.default(entityKey).implKey;
        return [_userStore2.default.hasLicenseFeature("user-hidden-fields", implKey), _userStore2.default.hasLicenseFeature("harvestable-fields", implKey)];
    }, [_userStore2.default], [entityKey]),
        _useFluxStore2 = _slicedToArray(_useFluxStore, 2),
        hideFeature = _useFluxStore2[0],
        harvestFeature = _useFluxStore2[1];

    var handleCancel = function handleCancel(e) {
        e.preventDefault();
        onCancel();
    };

    var handleChange = function handleChange(desc, value) {
        return setState(function (s) {
            return _extends({}, s, _defineProperty({}, desc.key, value));
        });
    };

    return _react2.default.createElement(
        "div",
        { className: "print-dialog" },
        _react2.default.createElement(
            "form",
            { action: "#" },
            _react2.default.createElement(_form2.default, {
                descriptor: FORM_DESCRIPTOR,
                propsResolver: function propsResolver(it) {
                    return {
                        descriptor: it,
                        onCommitChange: handleChange,
                        value: state[it.key],
                        enabled: it.key === "includeUserHiddenFields" ? hideFeature : it.key === "markHarvestableFields" ? harvestFeature : true
                    };
                }
            })
        ),
        _react2.default.createElement(
            "div",
            { className: "modal-footer" },
            _react2.default.createElement(
                "a",
                {
                    className: "btn btn-primary",
                    href: _HybridConfig2.default.get("apiRoot") + "export/" + org + "/pdf/export/" + entityKey + "/" + id + ".pdf?" + _query_string2.default.serialize(state),
                    target: "_blank",
                    rel: "noopener noreferrer",
                    onClick: onCancel
                },
                "Print"
            ),
            _react2.default.createElement(
                "button",
                {
                    onClick: handleCancel,
                    className: "btn btn-secondary"
                },
                "Cancel"
            )
        )
    );
}

PrintDialog.propTypes = {
    entityKey: _propTypes2.default.string.isRequired,
    id: _typedefs.recordIdType.isRequired,
    onCancel: _propTypes2.default.func.isRequired
};

exports.default = PrintDialog;

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(154);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _OverActions = __webpack_require__(122);

var _OverActions2 = _interopRequireDefault(_OverActions);

var _OverModal = __webpack_require__(1509);

var _OverModal2 = _interopRequireDefault(_OverModal);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _Services = __webpack_require__(110);

var _Services2 = _interopRequireDefault(_Services);

var _AboutStore = __webpack_require__(638);

var _AboutStore2 = _interopRequireDefault(_AboutStore);

var _compareVersions = __webpack_require__(1510);

var _compareVersions2 = _interopRequireDefault(_compareVersions);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _query_string = __webpack_require__(192);

var _query_string2 = _interopRequireDefault(_query_string);

var _promisify = __webpack_require__(97);

var _promisify2 = _interopRequireDefault(_promisify);

var _withOver = __webpack_require__(58);

var _SearchFormActions = __webpack_require__(75);

var _SearchFormActions2 = _interopRequireDefault(_SearchFormActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEEP_LINK_STORAGE_KEY = "ao:deep-link";
var RE_LINK_PARAM = /[?&]link=[a-zA-Z0-9]+(&|$)/;
function cleanUpDeepLink() {
    var loc = window.location;
    if (loc.search) {
        var next = loc.href.replace(RE_LINK_PARAM, "$1");
        if (next !== loc.href) {
            window.history.replaceState({}, "", next);
        }
    }
    window.sessionStorage.removeItem(DEEP_LINK_STORAGE_KEY);
}

/**
 * I handle incoming deep-links, potentially aborting initialization.
 * @param orgKey The active org's key
 * @param fluxContext The current Flux context
 * @return {boolean} Whether to abort initialization
 */
function handleDeepLink(orgKey, fluxContext) {
    var deepLinkJSON = window.sessionStorage.getItem(DEEP_LINK_STORAGE_KEY);
    if (!deepLinkJSON) return;
    var oops = function oops(msg) {
        var _console;

        for (var _len = arguments.length, moar = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            moar[_key - 1] = arguments[_key];
        }

        return (_console = console).warn.apply(_console, ["DEEPLINK: " + msg].concat(moar));
    };
    var deepLinkState = {};
    try {
        deepLinkState = JSON.parse(deepLinkJSON);
    } catch (e) {
        oops("Failed to parse:", deepLinkJSON);
        cleanUpDeepLink();
        return;
    }
    var qs = _query_string2.default.parse();
    if (qs.link !== deepLinkState.link) {
        oops("Expired link key");
        cleanUpDeepLink();
        return;
    }
    var data = _query_string2.default.parse(deepLinkState.search, function (agg, it) {
        return agg instanceof Array ? agg.concat(it) : [agg, it];
    });
    if (data.go === "de-search-result") {
        if (!data.org) {
            oops("No org specified");
        } else if (!data.stereo) {
            oops("No stereo specified");
        } else if (!data.f) {
            oops("No field(s) specified");
        } else if (_userStore2.default.getAllOrgs().every(function (it) {
            return it.key !== data.org;
        })) {
            oops("Unknown org specified");
        } else if (data.org !== orgKey) {
            (0, _promisify2.default)(_Services2.default.saveActiveOrgs([data.org])).then(function () {
                return window.location.reload();
            }).catch(function (jqXHR) {
                if (jqXHR.status < 500) return;
                (0, _withOver.appAlert)("Failed to switch organizations");
            });
            return true; // skip the rest of bootstrapping
        } else {
            // we are go!
            window.location.hash = "#de";
            if (typeof data.f === "string") {
                data.f = [data.f];
            }
            _Dispatcher2.default.contextDispatch(fluxContext, {
                type: _SearchFormActions2.default.DEEP_LINKED_SEARCH,
                key: data.stereo,
                fieldData: data.f.map(function (it) {
                    var parts = it.split(":");
                    return [parts.shift(), parts.join(":")];
                })
            });
        }
    }
    cleanUpDeepLink();
}

var MainController = function (_Backbone$Controller) {
    _inherits(MainController, _Backbone$Controller);

    function MainController() {
        var _ref;

        _classCallCheck(this, MainController);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        var _this = _possibleConstructorReturn(this, (_ref = MainController.__proto__ || Object.getPrototypeOf(MainController)).call.apply(_ref, [this].concat(args)));

        _this.initialize = _this.initialize.bind(_this);
        _this.onNavigate = _this.onNavigate.bind(_this);
        return _this;
    }

    _createClass(MainController, [{
        key: "initialize",
        value: function initialize(options) {
            this.model = options.model;
            this.app = options.app;
        }
    }, {
        key: "onNavigate",
        value: function onNavigate(org, key, id, ekey, eid, shortname, trigger) {
            if (trigger == null) {
                trigger = false;
            }
            this.dispatch("user:activity");
            // Hybrid is only ever viewing data through the lens of a single org.
            // HJC-250 - For now if org is not passed in we will set it to the
            // default.
            if (!org) {
                org = _userStore2.default.getActiveOrgKey();
            }

            // This now updates the url but triggers loading based on trigger
            // DQR passes true but DE wont pass it and uses the default
            // the url so that we can load data into the appropriate
            //
            if (ekey) {
                this.app.router.navigate(["de", org, key, id, ekey, eid, shortname].join("~"), { trigger: trigger });
            } else {
                this.app.router.navigate(["de", org, key, id].join("~"), { trigger: trigger });
            }
        }
    }, {
        key: "loadInitialData",
        value: function loadInitialData() {
            var _this2 = this;

            _userStore2.default.getUserLO().promise().then(function () {
                var orgKey = _userStore2.default.getActiveOrgKey();
                var fluxContext = _this2.model.get("fluxContext");
                if (handleDeepLink(orgKey, fluxContext)) return;
                _this2.dispatch("monitoring:set:username", _userStore2.default.getUsername());
                _this2.dispatch("monitoring:set:active:organization", orgKey);

                //console.log('user', user)
                var dg = [];
                dg.push(_Services2.default.loadArmusScript());

                dg.push(_AboutStore2.default.getApiVersionLO().promise().then(function (data) {
                    _this2.dispatch("monitoring:add:release:version", "client", _AboutStore2.default.getClientVersion());
                    _this2.dispatch("monitoring:add:release:version", "application", data.application);

                    _.forEach(data.meta, function (meta) {
                        return _this2.dispatch("monitoring:add:release:version", "meta:" + meta.key, meta.version);
                    });

                    var actual = _AboutStore2.default.getApiVersion().application.split(":")[2];
                    // the "inter-project" part of version numbers should be ignored
                    actual = actual.replace(/-[A-Z]{2,}-[0-9]+-/, "-");
                    // the build part of version numbers should be ignored
                    actual = actual.replace(/_b(\d+)/, "+$1");
                    var required = _AboutStore2.default.getRequiredApiVersion();
                    if ((0, _compareVersions2.default)(actual, required) < 0) {
                        var message = "API version '" + actual + "' is too old; at least '" + required + "' is required.";
                        $(".loading-modal").find(".loading-body p").text(message).end().find("img").hide();
                        // this emulates the IT framework's result
                        $("body").addClass("IT-error").addClass("IT-complete").attr("data-error", message);
                        throw new Error(message);
                    }
                }));
                dg.push(_StereotypesStore2.default.getAllStereotypesLO().promise().then(function (data) {
                    var types = _this2.model.get("stereotypes");
                    types.default = data.defaultKey;
                    types.populate(data.stereotypes, function (it) {
                        return it.magicRoot || it.magicRootKey != null;
                    });

                    var lookups = _this2.model.get("lookups");
                    lookups.populate(data.stereotypes, function (it) {
                        return !it.magicRoot && it.magicRootKey == null && it.creatables.length;
                    });

                    var dataQualityReport = _this2.model.get("dataQualityReport");
                    var dqrTypes = dataQualityReport.get("stereotypes");
                    dqrTypes.populate(data.stereotypes, function (it) {
                        return it.magicRootKey != null;
                    });
                    dataQualityReport.set("stereotype", dqrTypes.first());
                    return data; // I'm a real boy!
                }));
                Promise.all(dg).then(function () {
                    _this2.app.layout.render();
                    _this2.createOverContainer();
                    Backbone.history.start();
                    $("body").addClass("loaded");
                });
            });
        }
    }, {
        key: "createOverContainer",
        value: function createOverContainer() {
            var handleHide = function handleHide(key) {
                return _Dispatcher2.default.dispatch({
                    type: _OverActions2.default.HIDE,
                    key: key
                });
            };
            _reactDom2.default.render(_react2.default.createElement(_OverModal2.default, { onHide: handleHide }), document.getElementById("loading-modal-container"));
        }
    }]);

    return MainController;
}(Backbone.Controller);

MainController.prototype.events = {
    "load:initialData": "loadInitialData",
    "navigate": "onNavigate"
};

MainController.prototype.cache = __webpack_require__(474);

exports.default = MainController;

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OverComponent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _OverStore = __webpack_require__(61);

var _OverStore2 = _interopRequireDefault(_OverStore);

var _useFluxStore = __webpack_require__(9);

var _useFluxStore2 = _interopRequireDefault(_useFluxStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverComponent = exports.OverComponent = function (_React$Component) {
    _inherits(OverComponent, _React$Component);

    function OverComponent(props) {
        _classCallCheck(this, OverComponent);

        var _this = _possibleConstructorReturn(this, (OverComponent.__proto__ || Object.getPrototypeOf(OverComponent)).call(this, props));

        _this.alertTitleInterval = null;
        _this.documentTitle = "";
        _this.startTitleAlertInterval = _this.startTitleAlertInterval.bind(_this);
        _this.endTitleAlertInterval = _this.endTitleAlertInterval.bind(_this);
        _this.alertTitleToggle = _this.alertTitleToggle.bind(_this);
        return _this;
    }

    _createClass(OverComponent, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            var options = this.props.options;
            // always try to refocus the first action on update.

            this.focusActionBtn(this.firstActionRef);
            if (!options) {
                this.endTitleAlertInterval();
                return;
            }
            var actions = options.actions || [];
            if (actions.length > 1) {
                this.startTitleAlertInterval();
            } else {
                this.endTitleAlertInterval();
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.endTitleAlertInterval();
        }
    }, {
        key: "startTitleAlertInterval",
        value: function startTitleAlertInterval() {
            if (this.alertTitleInterval) {
                // already blinking
                return;
            }
            if (!this.documentTitle && document.title) {
                this.documentTitle = document.title;
            }
            // TODO: Play Sound here maybe?
            //
            // Start an interval to toggle the window title.
            // eslint-disable-next-line no-settimeout
            this.alertTitleInterval = setInterval(this.alertTitleToggle, 600);
        }
    }, {
        key: "endTitleAlertInterval",
        value: function endTitleAlertInterval() {
            if (this.alertTitleInterval) {
                clearInterval(this.alertTitleInterval);
                this.alertTitleInterval = null;
                document.title = this.documentTitle;
            }
        }
    }, {
        key: "alertTitleToggle",
        value: function alertTitleToggle() {
            // blinks the title bar text
            if (document.title !== this.documentTitle) {
                document.title = this.documentTitle;
            } else {
                document.title = "** Attention **";
            }
        }
    }, {
        key: "focusActionBtn",
        value: function focusActionBtn(ActionRef) {
            if (ActionRef) ActionRef.focus();
        }
    }, {
        key: "onActionClick",
        value: function onActionClick(e, action) {
            var _props = this.props,
                options = _props.options,
                onHide = _props.onHide;

            if (options.autoHide) {
                onHide(options.key);
            }
            if (action.callback) action.callback();
        }
    }, {
        key: "onActionKeyDown",
        value: function onActionKeyDown(e, action) {
            if (e.keyCode === action.keyCode) {
                this.onActionClick(e, action);
            }
            if (e.keyCode === 9) {
                // prevent the user from tabbing out of the AlertModal
                if (e.target === this.lastActionRef && !e.shiftKey) {
                    // last action - tab
                    this.focusActionBtn(this.firstActionRef);
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                } else if (e.target === this.firstActionRef && e.shiftKey) {
                    // first action - shift+tab
                    this.focusActionBtn(this.lastActionRef);
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var options = this.props.options;

            if (!options) {
                // no active modal on the stack.
                /* todo:
                   this dummy container is only for AppDriver visibility check...
                   It would be much gooder to just return null.
                 */
                return _react2.default.createElement(
                    "div",
                    { className: "loading-modal", style: { display: "none" } },
                    _react2.default.createElement("div", { className: "loading-box" })
                );
            }
            this.firstActionRef = undefined;
            this.lastActionRef = undefined;
            if (false) {
                if (typeof options.message === "string" && options.message.indexOf(">") >= 0) {
                    console.warn("An over using an HTML string detected. Prefer a React render function.");
                }
            }
            var Message = typeof options.message === "function" ? options.message : function () {
                return options.message && options.message.indexOf(">") >= 0 ? _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: options.message } }) : _react2.default.createElement(
                    "p",
                    null,
                    options.message
                );
            };
            var hasActions = false;
            var ui = void 0;
            if (options.messageIsUi) {
                ui = _react2.default.createElement(Message, null);
            } else {
                var actions = options.actions;
                var Actions = null;
                if (typeof actions === "function") {
                    hasActions = true;
                    Actions = actions;
                } else if (actions) {
                    hasActions = actions.length > 0;
                    Actions = function Actions() {
                        return actions.map(function (action, index) {
                            return _react2.default.createElement("input", {
                                ref: function ref(refAction) {
                                    if (index === 0) {
                                        _this2.firstActionRef = refAction;
                                    }
                                    if (index === actions.length - 1) {
                                        _this2.lastActionRef = refAction;
                                    }
                                },
                                key: index,
                                type: "button",
                                id: "modal-action-" + index,
                                className: "btn",
                                onClick: function onClick(e) {
                                    return _this2.onActionClick(e, action);
                                },
                                onKeyDown: function onKeyDown(e) {
                                    return _this2.onActionKeyDown(e, action);
                                },
                                value: action.label
                            });
                        });
                    };
                }
                ui = _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    options.title && _react2.default.createElement(
                        "header",
                        null,
                        _react2.default.createElement(
                            "h4",
                            { className: "title" },
                            options.title
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "loading-body" },
                        _react2.default.createElement(Message, null)
                    ),
                    options.spinner && _react2.default.createElement("img", { src: "images/waiting.svg", alt: "Loading..." }),
                    Actions && _react2.default.createElement(
                        "div",
                        { className: "loading-modal-actions" },
                        _react2.default.createElement(Actions, null)
                    )
                );
            }

            return _react2.default.createElement(
                "div",
                { className: "loading-modal " + (options.title ? "title-bar" : "") + " " + (hasActions ? "interactive" : ""), onClick: function onClick() {
                        return _this2.focusActionBtn(_this2.firstActionRef);
                    } },
                _react2.default.createElement(
                    "div",
                    { className: "loading-box" },
                    ui
                )
            );
        }
    }]);

    return OverComponent;
}(_react2.default.Component);

OverComponent.propTypes = {
    options: _OverStore.optionTypes,
    onHide: _propTypes2.default.func.isRequired
};

var OverModal = function OverModal(props) {
    var state = (0, _useFluxStore2.default)(function () {
        return {
            options: _OverStore2.default.getActiveItem()
        };
    }, [_OverStore2.default]);
    return _react2.default.createElement(OverComponent, _extends({}, props, state));
};

exports.default = OverModal;

/***/ }),
/* 1510 */,
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _HybridConfig = __webpack_require__(41);

var _HybridConfig2 = _interopRequireDefault(_HybridConfig);

var _browserRum = __webpack_require__(1512);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// All our explicit calls to third party monitoring services should be wired in here.
var MonitoringController = function (_Backbone$Controller) {
    _inherits(MonitoringController, _Backbone$Controller);

    function MonitoringController() {
        var _ref;

        _classCallCheck(this, MonitoringController);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = MonitoringController.__proto__ || Object.getPrototypeOf(MonitoringController)).call.apply(_ref, [this].concat(args)));

        var _hybridConfig$get = _HybridConfig2.default.get("datadog", {}),
            ddEnabled = _hybridConfig$get.enabled,
            ddUserConfig = _hybridConfig$get.userConfiguration;

        if (ddEnabled && ddUserConfig) {
            _browserRum.datadogRum.init(_extends({
                sampleRate: 100,
                actionNameAttribute: "data-shortname"
            }, ddUserConfig));
        }
        return _this;
    }

    _createClass(MonitoringController, [{
        key: "onAddReleaseVersion",
        value: function onAddReleaseVersion(name, version) {
            /* will be overloaded */
        }
    }, {
        key: "onSetUsername",
        value: function onSetUsername(username) {
            _browserRum.datadogRum.setUser({
                name: username
            });
        }
    }, {
        key: "onSetActiveOrganization",
        value: function onSetActiveOrganization(org) {
            _browserRum.datadogRum.addRumGlobalContext("organization", org);
        }
    }]);

    return MonitoringController;
}(Backbone.Controller);

MonitoringController.prototype.events = {
    "monitoring:add:release:version": "onAddReleaseVersion",
    "monitoring:set:username": "onSetUsername",
    "monitoring:set:active:organization": "onSetActiveOrganization"
};

exports.default = MonitoringController;

/***/ }),
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AppModel = __webpack_require__(324);

var _AppModel2 = _interopRequireDefault(_AppModel);

var _Stereotype = __webpack_require__(489);

var _Stereotype2 = _interopRequireDefault(_Stereotype);

var _RecordBrowserModule = __webpack_require__(1585);

var _RecordBrowserState = __webpack_require__(490);

var _RecordBrowserState2 = _interopRequireDefault(_RecordBrowserState);

var _asMarionetteView = __webpack_require__(101);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _ContextActions = __webpack_require__(170);

var _ContextActions2 = _interopRequireDefault(_ContextActions);

var _StereotypesStore = __webpack_require__(20);

var _StereotypesStore2 = _interopRequireDefault(_StereotypesStore);

var _SearchFormActions = __webpack_require__(75);

var _SearchFormActions2 = _interopRequireDefault(_SearchFormActions);

var _RecordBrowserActions = __webpack_require__(617);

var _RecordBrowserActions2 = _interopRequireDefault(_RecordBrowserActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MarionetteRecordBrowserModule = (0, _asMarionetteView.asMarionetteView)(_RecordBrowserModule.BackboneRecordBrowserModule, {
    className: "record-browser"
});

var RecordBrowserController = function (_Backbone$Controller) {
    _inherits(RecordBrowserController, _Backbone$Controller);

    function RecordBrowserController() {
        var _ref;

        _classCallCheck(this, RecordBrowserController);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = RecordBrowserController.__proto__ || Object.getPrototypeOf(RecordBrowserController)).call.apply(_ref, [this].concat(args)));

        _this.initialize = _this.initialize.bind(_this);
        _this.onGlobalLookup = _this.onGlobalLookup.bind(_this);
        return _this;
    }

    _createClass(RecordBrowserController, [{
        key: "initialize",
        value: function initialize(options) {
            var _this2 = this;

            this.model = options.model;
            this.app = options.app;
            this.fluxToken = _Dispatcher2.default.register(function (action) {
                // eventually this should live in a proper flux store.
                switch (action.type) {
                    case _RecordBrowserActions2.default.GLOBAL_LOOKUP_CLICK:
                        _this2.onGlobalLookup(action.key, action.lookupCallback, action.focusCallback, action.candidateFilter, action.currId);
                        break;
                    default:
                }
            });
        }
    }, {
        key: "onClose",
        value: function onClose() {
            _Dispatcher2.default.unregister(this.fluxToken);
        }
    }, {
        key: "onGlobalLookup",
        value: function onGlobalLookup(key, lookupCallback, focusCallback, candidateFilter, currId) {
            var _this3 = this;

            // todo: get currId wherever it needs to be so the corresponding record can always be "hot" in the modal
            var deModel = new _AppModel2.default();
            deModel.set("isModal", true);
            var recordBrowserState = new _RecordBrowserState2.default({
                candidateFilter: candidateFilter,
                currId: currId,
                isGlobal: true,
                deModel: deModel
            });

            _StereotypesStore2.default.getStereotypeLO(key).promise().then(function (data) {
                _Dispatcher2.default.contextDispatch(deModel.get("fluxContext"), {
                    type: _SearchFormActions2.default.INITIALIZE_CONTEXT,
                    key: key,
                    availableKeys: [key]
                });
                var lookup = new _Stereotype2.default(data);

                recordBrowserState.set({
                    stereotype: lookup
                });

                if (lookupCallback != null) {
                    recordBrowserState.set("closeOnSelect", true);
                    _this3.listenToOnce(recordBrowserState, "change:selected", lookupCallback);
                }

                _this3.app.layout.showModal(function () {
                    return new MarionetteRecordBrowserModule({
                        app: _this3.app,
                        title: data.name,
                        deModel: deModel
                    });
                }).then(function () {
                    // This timeout allows the rest of the view hierarchy to
                    // close before we act on the new state
                    //
                    // eslint-disable-next-line no-settimeout
                    setTimeout(function () {
                        _Dispatcher2.default.contextDispatch(deModel.get("fluxContext"), {
                            type: _ContextActions2.default.CLOSE
                        });
                        if (focusCallback != null) {
                            focusCallback();
                        }
                    }, 0);
                });
            });
        }
    }]);

    return RecordBrowserController;
}(Backbone.Controller);

RecordBrowserController.prototype.events = {
    "load:global_lookup": "onGlobalLookup"
};

exports.default = RecordBrowserController;

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BackboneRecordBrowserModule = exports.RecordBrowserModule = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AppModel = __webpack_require__(324);

var _AppModel2 = _interopRequireDefault(_AppModel);

var _DataEntryModule = __webpack_require__(498);

var _DataEntryModule2 = _interopRequireDefault(_DataEntryModule);

var _ModalLayout = __webpack_require__(252);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _backboneConnect = __webpack_require__(127);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RecordBrowserModule = exports.RecordBrowserModule = function (_React$Component) {
    _inherits(RecordBrowserModule, _React$Component);

    function RecordBrowserModule() {
        _classCallCheck(this, RecordBrowserModule);

        return _possibleConstructorReturn(this, (RecordBrowserModule.__proto__ || Object.getPrototypeOf(RecordBrowserModule)).apply(this, arguments));
    }

    _createClass(RecordBrowserModule, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                deModel = _props.deModel,
                app = _props.app,
                title = _props.title,
                triggerClose = _props.triggerClose,
                view = _props.view;


            var modalOptions = {
                size: "modal-xlg",
                class: "record-browser",
                title: title + " Browser"
            };

            var dem = new _DataEntryModule2.default({
                model: deModel,
                application: app,
                searchOnRender: true
            });

            // this is retarded. holy cow is it dumb. :)
            if (view != null) view.on("before:close", function () {
                return dem.close();
            });

            return _react2.default.createElement(_ModalLayout.ModalLayout, {
                modalOptions: modalOptions,
                triggerClose: triggerClose,
                moduleRef: dem
            });
        }
    }]);

    return RecordBrowserModule;
}(_react2.default.Component);

RecordBrowserModule.propTypes = {
    deModel: _propTypes2.default.instanceOf(_AppModel2.default).isRequired,
    app: _propTypes2.default.instanceOf(Backbone.Marionette.Application).isRequired,
    triggerClose: _propTypes2.default.func.isRequired,
    title: _propTypes2.default.string.isRequired,
    view: _propTypes2.default.instanceOf(Backbone.Marionette.View)
};

var config = function config(props) {
    return {
        triggerClose: function triggerClose() {
            props.view.trigger("close");
        }
    };
};

var BackboneRecordBrowserModule = exports.BackboneRecordBrowserModule = (0, _backboneConnect.backboneConnect)(config)(RecordBrowserModule);

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

var ClientId, DataEntryController, DataEntryControllerJS, Dispatcher, Services, StereotypesStore, SuperRecordActions, SuperRecordStore, TableStore, appAlert, promisify, _ref,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Services = __webpack_require__(110)["default"];

Dispatcher = __webpack_require__(4)["default"];

promisify = __webpack_require__(97)["default"];

SuperRecordStore = __webpack_require__(36)["default"];

TableStore = __webpack_require__(10)["default"];

StereotypesStore = __webpack_require__(20)["default"];

SuperRecordActions = __webpack_require__(25)["default"];

ClientId = __webpack_require__(27)["default"];

DataEntryControllerJS = __webpack_require__(1587)["default"];

appAlert = __webpack_require__(58).appAlert;

module.exports = DataEntryController = (function(_super) {
  __extends(DataEntryController, _super);

  function DataEntryController() {
    this.activateNewEntity = __bind(this.activateNewEntity, this);
    this.onLoadEntity = __bind(this.onLoadEntity, this);    _ref = DataEntryController.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  DataEntryController.prototype.events = {
    "entity:load": "onConfirmLoadEntity",
    "entity:new": "onConfirmEntityNew",
    "load:entity_data": "onDataEntry",
    "confirm:load:entity_data": "onConfirmDataEntry",
    "confirm:user:logout": "onConfirmUserLogout",
    "entity:save": "onSaveEntity",
    "validation:load": "onValidationLoadEntity",
    "record:open": "onRecordOpen",
    "record:new-child": "onRecordNewChild"
  };

  DataEntryController.prototype.queue = [];

  DataEntryController.prototype.onLoadEntity = function(searchResult, appModel) {
    var data, form, id, key, mrCoords, org, _ref1;

    org = searchResult.owner;
    mrCoords = searchResult.magicRootCoordinates;
    if (mrCoords != null) {
      key = mrCoords.key;
      id = mrCoords.id;
    } else {
      key = searchResult.key;
      id = searchResult.id;
    }
    _ref1 = [null, null], form = _ref1[0], data = _ref1[1];
    if (mrCoords) {
      if (searchResult.magicRoot) {
        this.dispatch('navigate', org, key, id);
        return this.onDataEntry(org, key, id, void 0, void 0, void 0, appModel);
      } else {
        this.dispatch('navigate', org, key, id, searchResult.key, searchResult.id);
        return this.onDataEntry(org, key, id, searchResult.key, searchResult.id, void 0, appModel);
      }
    } else if (key.indexOf('/') > 0) {
      return this.onDataEntry(org, key, id, key, id, void 0, appModel);
    } else {
      return this.onDataEntry(org, key, id, void 0, void 0, void 0, appModel);
    }
  };

  DataEntryController.prototype.activateNewEntity = function(entity, key, id, ekey, eid, shortname, appModel) {
    var creatable, creatables, e, impls, styp, _ref1;

    impls = this.getImplFromProjection(entity.projections);
    if (ekey !== void 0) {
      _ref1 = entity.findNearestParent(ekey, eid, shortname), ekey = _ref1[0], eid = _ref1[1], shortname = _ref1[2];
      try {
        return Backbone.dispatcher.trigger("record:open", ekey, eid, shortname, appModel);
      } catch (_error) {
        e = _error;
        return console.warn('not navigable', ekey, eid, shortname);
      }
    } else if (impls.length === 1) {
      styp = appModel.get('searchState').get('stereotype');
      if (styp !== void 0) {
        creatables = styp.get('creatables');
        if (creatables.length === 1) {
          creatable = creatables.first();
          if (creatable.get('defaultKey')) {
            return Backbone.dispatcher.trigger("record:open", creatable.get('defaultKey'), id, shortname, appModel);
          }
        }
      }
    }
  };

  DataEntryController.prototype.getImplFromProjection = function(projections) {
    var impls;

    impls = {};
    _(projections).each(function(p, key, list) {
      return impls[key.split('/')[0]] = 0;
    });
    return _.keys(impls);
  };

  return DataEntryController;

})(DataEntryControllerJS);


/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SuperRecordActions = __webpack_require__(25);

var _SuperRecordActions2 = _interopRequireDefault(_SuperRecordActions);

var _withOver = __webpack_require__(58);

var _withOver2 = _interopRequireDefault(_withOver);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _safeContextDispatch = __webpack_require__(251);

var _safeContextDispatch2 = _interopRequireDefault(_safeContextDispatch);

var _safeDispatch = __webpack_require__(169);

var _safeDispatch2 = _interopRequireDefault(_safeDispatch);

var _NavigationActions = __webpack_require__(80);

var _NavigationActions2 = _interopRequireDefault(_NavigationActions);

var _RecordActions = __webpack_require__(60);

var _RecordActions2 = _interopRequireDefault(_RecordActions);

var _SuperRecordStore = __webpack_require__(36);

var _SuperRecordStore2 = _interopRequireDefault(_SuperRecordStore);

var _ClientId = __webpack_require__(27);

var _ClientId2 = _interopRequireDefault(_ClientId);

var _superRecords = __webpack_require__(63);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _entityFieldMetaStore = __webpack_require__(21);

var _entityFieldMetaStore2 = _interopRequireDefault(_entityFieldMetaStore);

var _NavigatorStore = __webpack_require__(33);

var _NavigatorStore2 = _interopRequireDefault(_NavigatorStore);

var _TableStore = __webpack_require__(10);

var _TableStore2 = _interopRequireDefault(_TableStore);

var _saveit = __webpack_require__(226);

var _EntityName = __webpack_require__(24);

var _EntityName2 = _interopRequireDefault(_EntityName);

var _OverActions = __webpack_require__(122);

var _OverActions2 = _interopRequireDefault(_OverActions);

var _ContextedReduceStore = __webpack_require__(30);

var _hasUnsavedChanges = __webpack_require__(319);

var _hasUnsavedChanges2 = _interopRequireDefault(_hasUnsavedChanges);

var _DataManager = __webpack_require__(43);

var _DataManager2 = _interopRequireDefault(_DataManager);

var _contextFromAppModelOrContext = __webpack_require__(645);

var _contextFromAppModelOrContext2 = _interopRequireDefault(_contextFromAppModelOrContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var findDeepestItem = function findDeepestItem(tree) {
    var maxDepth = -1;
    var deepestItem = null;
    var dig = function dig(item) {
        var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        if (_ClientId2.default.is(item.id)) return; // can't be down this way
        if (item.isMagic) {
            // find the selected version in projections
            var v = (0, _superRecords.getSuperSelectedVersion)(item);
            if (v) {
                maxDepth = depth;
                deepestItem = { id: item.id, entityKey: v.key };
            }
        } else if (item.selected) {
            if (depth > maxDepth) {
                maxDepth = depth;
                deepestItem = item;
            }
        }
        if (item.fields == null) return;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = item.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var f = _step.value;

                if (f.items == null) continue;
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = f.items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var it = _step2.value;

                        dig(it, depth + 1);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    dig(tree);
    return deepestItem;
};

var noop = function noop() {
    /* noop */
};

var DataEntryControllerJS = function (_Backbone$Controller) {
    _inherits(DataEntryControllerJS, _Backbone$Controller);

    function DataEntryControllerJS() {
        _classCallCheck(this, DataEntryControllerJS);

        var _this = _possibleConstructorReturn(this, (DataEntryControllerJS.__proto__ || Object.getPrototypeOf(DataEntryControllerJS)).call(this));

        _Dispatcher2.default.register(function (action) {
            // bridge from Flux back to Backbone.Controller-ish, but leave a
            // tick since many things come out of BB.C dispatch.
            switch (action.type) {
                case _SuperRecordActions2.default.CANCEL:
                    // eslint-disable-next-line no-settimeout
                    setTimeout(function () {
                        return _this.onConfirmCancelEntity(action[_ContextedReduceStore.ACTION_CONTEXT_KEY]);
                    });
                    break;
                case _SuperRecordActions2.default.CANCEL_FOR_OPTLOCK:
                    // we need to waitFor TableStore here, but the setTimeout will
                    // do it for us for free.
                    // eslint-disable-next-line no-settimeout
                    setTimeout(function () {
                        return _this.onCancelEntity(action[_ContextedReduceStore.ACTION_CONTEXT_KEY]);
                    });
                    break;
                case _SuperRecordActions2.default.SAVE:
                    _this.onSaveEntity(action[_ContextedReduceStore.ACTION_CONTEXT_KEY]);
                    break;
                default:
            }
        });
        return _this;
    }

    _createClass(DataEntryControllerJS, [{
        key: "_promiseSaveConfirmation",
        value: function _promiseSaveConfirmation(appModelOrFluxContext) {
            var _this2 = this;

            var fluxContext = (0, _contextFromAppModelOrContext2.default)(appModelOrFluxContext);
            if ((0, _hasUnsavedChanges2.default)(fluxContext)) {
                return new Promise(function (resolve, reject) {
                    var yes_action = { label: "Yes", callback: function callback() {
                            var token = _Dispatcher2.default.register(function (action) {
                                // eslint-disable-next-line default-case
                                switch (action.type) {
                                    case _SuperRecordActions2.default.CREATED:
                                    case _SuperRecordActions2.default.UPDATED:
                                        _Dispatcher2.default.unregister(token);
                                        return resolve(true);
                                    case _SuperRecordActions2.default.CREATE_ERROR:
                                    case _SuperRecordActions2.default.UPDATE_ERROR:
                                        _Dispatcher2.default.unregister(token);
                                        return reject();
                                }
                            });
                            _this2.dispatch("entity:save", fluxContext);
                        } };
                    var no_action = { label: "No", callback: function callback() {
                            return resolve(false);
                        } };
                    var cancel_action = { label: "Cancel", callback: reject };
                    (0, _withOver.appAlert)({
                        message: "Would you like to save your changes?",
                        actions: [cancel_action, no_action, yes_action],
                        spinner: false
                    });
                });
            } else {
                return Promise.resolve();
            }
        }
    }, {
        key: "_promiseCancelConfirmation",
        value: function _promiseCancelConfirmation(appModelOrFluxContext) {
            var fluxContext = (0, _contextFromAppModelOrContext2.default)(appModelOrFluxContext);
            if ((0, _hasUnsavedChanges2.default)(fluxContext)) {
                return new Promise(function (resolve, reject) {
                    var yes_action = { label: "Yes", callback: resolve };
                    var no_action = { label: "No", callback: reject };
                    (0, _withOver.appAlert)({
                        message: "Are you sure you would like to cancel your changes?",
                        actions: [no_action, yes_action],
                        spinner: false
                    });
                });
            } else {
                return Promise.resolve();
            }
        }
    }, {
        key: "onConfirmUserLogout",
        value: function onConfirmUserLogout(appModel) {
            var _this3 = this;

            this._promiseSaveConfirmation(appModel).then(function () {
                var _Dispatcher$dispatch;

                return _Dispatcher2.default.dispatch((_Dispatcher$dispatch = {
                    type: _OverActions2.default.EXTERNAL_NAV
                }, _defineProperty(_Dispatcher$dispatch, _RecordActions.OPT_USER_CONFIRMED, true), _defineProperty(_Dispatcher$dispatch, "message", "Logging out..."), _defineProperty(_Dispatcher$dispatch, "callback", function callback() {
                    return setTimeout(function () {
                        return _this3.dispatch("user:logout");
                    });
                }), _Dispatcher$dispatch));
            }, noop);
        }
    }, {
        key: "onConfirmLoadEntity",
        value: function onConfirmLoadEntity(searchResult, appModel) {
            var _this4 = this;

            this._promiseSaveConfirmation(appModel).then(function () {
                return _this4.onLoadEntity(searchResult, appModel);
            }, noop);
        }
    }, {
        key: "onConfirmEntityNew",
        value: function onConfirmEntityNew(key, org, entity, appModel) {
            var _this5 = this;

            this._promiseSaveConfirmation(appModel).then(function () {
                return _this5.onEntityNew(key, org, entity, appModel);
            }, noop);
        }
    }, {
        key: "onConfirmCancelEntity",
        value: function onConfirmCancelEntity(appModelOrFluxContext) {
            var _this6 = this;

            var fluxContext = (0, _contextFromAppModelOrContext2.default)(appModelOrFluxContext);
            this._promiseCancelConfirmation(fluxContext).then(function () {
                return _this6.onCancelEntity(fluxContext);
            }, noop);
        }
    }, {
        key: "onCancelEntity",
        value: function onCancelEntity(fluxContext) {
            var magic = _NavigatorStore2.default.getMagicState(fluxContext);
            if (!magic) return;
            if (_ClientId2.default.is(magic.id)) {
                _Dispatcher2.default.contextDispatch(fluxContext, _defineProperty({
                    type: _SuperRecordActions2.default.DELETE_RECORD,
                    key: magic.key,
                    id: magic.id
                }, _RecordActions.OPT_USER_CONFIRMED, true));
            } else {
                this.getDeepestPersisted(fluxContext);
            }
        }
    }, {
        key: "getDeepestPersisted",
        value: function getDeepestPersisted(appModelOrFluxContext) {
            var fluxContext = (0, _contextFromAppModelOrContext2.default)(appModelOrFluxContext);
            var navState = _NavigatorStore2.default.getState(fluxContext);
            var magic = navState.magic;

            var tree = (0, _superRecords.superNavTree)(_TableStore2.default, _SuperRecordStore2.default.getRecord(magic.key, magic.id), navState, magic.key, magic.id);

            var deepestItem = findDeepestItem(tree);
            var org = _userStore2.default.getActiveOrgKey();
            var ekey = undefined;
            var eid = undefined;
            if (deepestItem != null) {
                // if we're synthesizing a stereotype, still use that key
                ekey = deepestItem.stereoKey && _EntityName2.default.is(deepestItem.stereoKey) ? deepestItem.stereoKey : deepestItem.entityKey;
                eid = deepestItem.id;
            }
            this.dispatch("load:entity_data", org, magic.key, magic.id, ekey, eid, undefined, fluxContext);
        }
    }, {
        key: "onEntityNew",
        value: function onEntityNew(key, org, stereoKey, appModel) {
            this.dispatch("user:activity");
            (0, _withOver2.default)("Creating new record...", function () {
                return _DataManager2.default.promiseModelAwareness(org, stereoKey).then(function () {
                    _Dispatcher2.default.contextDispatch(appModel.get("fluxContext"), _defineProperty({
                        type: _SuperRecordActions2.default.NEW,
                        stereoKey: stereoKey,
                        recordKey: key,
                        newId: _ClientId2.default.next(),
                        navigate: true
                    }, _RecordActions.OPT_USER_CONFIRMED, true));
                });
            });
        }
    }, {
        key: "onConfirmDataEntry",
        value: function onConfirmDataEntry(org, key, id, ekey, eid, shortname, appModel) {
            var _this7 = this;

            this._promiseSaveConfirmation(appModel).then(function () {
                return _this7.onDataEntry(org, key, id, ekey, eid, shortname, appModel);
            }, noop);
        }
    }, {
        key: "onDataEntry",
        value: function onDataEntry(org, key, id, ekey, eid, field, appModelOrFluxContext) {
            var _this8 = this;

            var fluxContext = (0, _contextFromAppModelOrContext2.default)(appModelOrFluxContext);
            if (_userStore2.default.getActiveOrgKey() !== org) {
                return;
            }
            return (0, _withOver2.default)("Loading...", function () {
                return (
                    //todo: these two loads (model and data) should be parallel, but
                    // they race, and it's easier to serialize rather than lock.
                    _DataManager2.default.promiseModelAwareness(org, key).then(function () {
                        return _SuperRecordStore2.default.getRecordLO(key, id, true).promise();
                    }).then(function () {
                        if (ekey && eid && field) {
                            var _rerouteFieldNav2 = _this8.rerouteFieldNav({ key: key, id: id }, ekey, eid, field);

                            var _rerouteFieldNav3 = _slicedToArray(_rerouteFieldNav2, 3);

                            ekey = _rerouteFieldNav3[0];
                            eid = _rerouteFieldNav3[1];
                            field = _rerouteFieldNav3[2];
                        }
                        _Dispatcher2.default.contextDispatch(fluxContext, {
                            type: _SuperRecordActions2.default.OPEN,
                            key: key,
                            id: id,
                            entityKey: ekey || null,
                            recordId: eid || null,
                            fieldKey: field || null
                        });
                    }).catch(function (jqXHR) {
                        if (jqXHR.status < 500) return;
                        console.error("error loading record " + key + "#" + id, jqXHR);
                        var msg = "Unable to load record";
                        if (jqXHR.responseText !== "") {
                            //xhr.responseText = '{"message":"Record 2138743 does not exist in the database for stereotype patient","type":"RecordNotFoundException","id":2138743,"key":null}'
                            try {
                                var resp = JSON.parse(jqXHR.responseText);
                                msg = resp.message;
                            } catch (error) {/* noop */}
                        }
                        (0, _withOver.appAlert)(msg);
                    })
                );
            });
        }
    }, {
        key: "onSaveEntity",
        value: function onSaveEntity(appModelOrFluxContext) {
            var fluxContext = (0, _contextFromAppModelOrContext2.default)(appModelOrFluxContext);
            var sr = _NavigatorStore2.default.getMagicState(fluxContext);
            (0, _saveit.saveSuperRecord)(sr.key, sr.id, fluxContext);
            _SuperRecordStore2.default.getRecordLO(sr.key, sr.id).promise();
        }

        // "topLevelRecords" is a magic `fieldKey` indicating record is a magic root
        // and the new child is a magic child.

    }, {
        key: "onRecordNewChild",
        value: function onRecordNewChild(record, fieldKey, entityKey) {
            var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var appModelOrFluxContext = arguments[4];

            var fluxContext = (0, _contextFromAppModelOrContext2.default)(appModelOrFluxContext);
            var isMagic = fieldKey === _superRecords.TOP_LEVEL_RECORDS_KEY;
            var newId = _ClientId2.default.next();
            if (isMagic) {
                (0, _safeDispatch2.default)({
                    type: _SuperRecordActions2.default.NEW_MAGIC_CHILD,
                    recordKey: record.entityKey,
                    recordId: record.id,
                    entityKey: entityKey,
                    newId: newId
                    // navigate: true, // todo: shouldn't this be here?
                });
            } else {
                // this double-dispatch is kludge-y, but the stores are still too
                // "inverted" to do correctly at the moment
                var navigate = _entityFieldMetaStore2.default.getInfo(record.entityKey, fieldKey).navigable;
                (0, _safeContextDispatch2.default)(fluxContext, {
                    type: _RecordActions2.default.NEW_CHILD,
                    recordKey: record.entityKey,
                    recordId: record.id,
                    fieldKey: fieldKey,
                    entityKey: entityKey,
                    newId: newId,
                    focusFieldKey: options.shortname,
                    insertAt: options.at,
                    navigate: navigate
                });
            }
        }

        // this is where:
        //  onRecordNewChild
        //  onValidationLoadEntity
        //  onActiveRecordChange
        //  onDataEntry (maybe?)
        // will refocus

    }, {
        key: "onRecordOpen",
        value: function onRecordOpen(entityKey, recordId, fieldKey, appModelOrFluxContext) {
            var fluxContext = (0, _contextFromAppModelOrContext2.default)(appModelOrFluxContext);
            (0, _safeContextDispatch2.default)(fluxContext, {
                type: _NavigationActions2.default.SELECT_RECORD,
                entityKey: entityKey,
                recordId: recordId,
                fieldKey: fieldKey
            });
        }
    }, {
        key: "rerouteFieldNav",
        value: function rerouteFieldNav(magic, entityKey, recordId, fieldKey) {
            return (0, _superRecords.rerouteFieldNav)(magic, entityKey, recordId, fieldKey);
        }
    }, {
        key: "onValidationLoadEntity",
        value: function onValidationLoadEntity(key, id, field, appModelOrFluxContext) {
            // it's be awesome to combine this w/ onChildNew, but
            // there's still to much navigation/focus collusion
            var fluxContext = (0, _contextFromAppModelOrContext2.default)(appModelOrFluxContext);
            var magic = _NavigatorStore2.default.getMagicState(fluxContext);

            var _rerouteFieldNav4 = this.rerouteFieldNav(magic, key, id, field);

            var _rerouteFieldNav5 = _slicedToArray(_rerouteFieldNav4, 3);

            key = _rerouteFieldNav5[0];
            id = _rerouteFieldNav5[1];
            field = _rerouteFieldNav5[2];

            this.onRecordOpen(key, id, field, appModelOrFluxContext);
        }
    }]);

    return DataEntryControllerJS;
}(Backbone.Controller);

exports.default = DataEntryControllerJS;

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _collection = __webpack_require__(145);

var _collection2 = _interopRequireDefault(_collection);

var _HEXServices = __webpack_require__(1589);

var _HEXServices2 = _interopRequireDefault(_HEXServices);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _withOver = __webpack_require__(58);

var _withOver2 = _interopRequireDefault(_withOver);

var _formRegistry = __webpack_require__(74);

var _formRegistry2 = _interopRequireDefault(_formRegistry);

var _BaseServices = __webpack_require__(76);

var _BaseServices2 = _interopRequireDefault(_BaseServices);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var dateFromParts = function dateFromParts(parts) {
    return new Date(parts[0], parts[1] - 1, parts[2]);
};

var HEXController = function (_Backbone$Controller) {
    _inherits(HEXController, _Backbone$Controller);

    function HEXController() {
        var _ref;

        _classCallCheck(this, HEXController);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = HEXController.__proto__ || Object.getPrototypeOf(HEXController)).call.apply(_ref, [this].concat(args)));

        _this.initialize = _this.initialize.bind(_this);
        _this.onGetHarvestHistory = _this.onGetHarvestHistory.bind(_this);
        _this.onError = _this.onError.bind(_this);
        _this.onGetExport = _this.onGetExport.bind(_this);
        return _this;
    }

    _createClass(HEXController, [{
        key: "initialize",
        value: function initialize(options) {
            this.model = options.model;
        }
    }, {
        key: "onGetHarvestHistory",
        value: function onGetHarvestHistory() {
            var _this2 = this;

            (0, _withOver2.default)("Loading Harvest History...", function () {
                return _HEXServices2.default.loadHexHistory(_userStore2.default.getActiveOrgKey()).done(function (data) {
                    var results = new _collection2.default();
                    var allowedExportTypes = new Set(_userStore2.default.getHexForms().map(function (f) {
                        return f.key;
                    }));
                    _(data).each(function (h) {
                        h.requestedAt = new Date(h.requestedAt);

                        if (h.start != null) h.start = dateFromParts(h.start);
                        if (h.end != null) h.end = dateFromParts(h.end);

                        if (h.params.start != null) {
                            h.params.start = dateFromParts(h.params.start);
                        }
                        if (h.params.end != null) {
                            h.params.end = dateFromParts(h.params.end);
                        }

                        var form = _formRegistry2.default[h.typeKey];
                        h.allowRerun = form && form.canRerun && form.canRerun(h.params) && allowedExportTypes.has(h.typeKey);

                        var m = new Backbone.Model({ id: h.id, data: h });
                        results.add(m);
                    });

                    _this2.model.set("results", results);
                }).error(_this2.onError);
            });
        }
    }, {
        key: "onError",
        value: function onError(jqXHR) {
            if (jqXHR.status < 500) return;
            console.error(jqXHR);
            (0, _withOver.appAlert)("An error has occurred.");
        }
    }, {
        key: "onGetHexDownload",
        value: function onGetHexDownload(id, filename) {
            return _HEXServices2.default.getHexDownload(_userStore2.default.getActiveOrgKey(), id, filename);
        }
    }, {
        key: "onGetExport",
        value: function onGetExport(impl, report, data) {
            var _this3 = this;

            if (_BaseServices2.default.__mocked) {
                console.log(impl.toUpperCase(), report.toUpperCase(), data);
            }
            var org = _userStore2.default.getActiveOrgKey();
            (0, _withOver2.default)("Queueing " + report.substr(0, 1).toUpperCase() + report.substr(1) + "...", function () {
                return _HEXServices2.default.getReport(org, impl, report, data).done(function () {
                    // Reload data to cause UI refresh
                    _this3.onGetHarvestHistory();
                }).error(_this3.onError);
            });
        }
    }, {
        key: "onLoadData",
        value: function onLoadData(impl, report, options) {
            var _this4 = this;

            var endpoint = options.endpoint,
                params = options.params,
                onData = options.onData,
                _options$loadingMessa = options.loadingMessage,
                loadingMessage = _options$loadingMessa === undefined ? "Loading..." : _options$loadingMessa;

            var org = _userStore2.default.getActiveOrgKey();
            (0, _withOver2.default)(loadingMessage, function () {
                return _HEXServices2.default.loadData(org, impl, report, endpoint, params).done(onData).error(_this4.onError);
            });
        }
    }]);

    return HEXController;
}(Backbone.Controller);

HEXController.prototype.events = {
    "get:harvest_history": "onGetHarvestHistory",
    "load:data": "onLoadData",
    "get:export": "onGetExport",
    "get:hex_file_download": "onGetHexDownload"
};

exports.default = HEXController;

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseServices = __webpack_require__(76);

var _BaseServices2 = _interopRequireDefault(_BaseServices);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HEXServices = function () {
    function HEXServices() {
        _classCallCheck(this, HEXServices);
    }

    _createClass(HEXServices, [{
        key: "getReport",
        value: function getReport(org, impl, report, data) {
            return _BaseServices2.default.rawPost(["export", org, impl, report], data);
        }
    }, {
        key: "getHexDownload",
        value: function getHexDownload(org, id, filename) {
            var url = _BaseServices2.default.url(["export", org, "history", id, filename]);
            window.open(url, "_blank");
        }
    }, {
        key: "loadHexHistory",
        value: function loadHexHistory(org) {
            return _BaseServices2.default.getRequest(["export", org, "history"]);
        }
    }, {
        key: "loadHexParticipants",
        value: function loadHexParticipants(org, impl, report) {
            return this.loadData(org, impl, report, "participants");
        }
    }, {
        key: "loadHexDateRange",
        value: function loadHexDateRange(org, impl, report, data) {
            return this.loadData(org, impl, report, "date-range", data);
        }
    }, {
        key: "loadHexOptionalFields",
        value: function loadHexOptionalFields(org, impl, report) {
            return this.loadData(org, impl, report, "optional-fields");
        }
    }, {
        key: "loadData",
        value: function loadData(org, impl, report, endpoint, params) {
            return _BaseServices2.default.getRequest(["export", org, impl, report, endpoint], params);
        }
    }]);

    return HEXServices;
}();

exports.default = new HEXServices();

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseServices = __webpack_require__(76);

var _BaseServices2 = _interopRequireDefault(_BaseServices);

var _HybridConfig = __webpack_require__(41);

var _HybridConfig2 = _interopRequireDefault(_HybridConfig);

var _userStore = __webpack_require__(8);

var _userStore2 = _interopRequireDefault(_userStore);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _SessionActions = __webpack_require__(320);

var _SessionActions2 = _interopRequireDefault(_SessionActions);

var _BaseServices3 = __webpack_require__(76);

var _BaseServices4 = _interopRequireDefault(_BaseServices3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SessionController = function (_Backbone$Controller) {
    _inherits(SessionController, _Backbone$Controller);

    function SessionController() {
        var _ref;

        _classCallCheck(this, SessionController);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = SessionController.__proto__ || Object.getPrototypeOf(SessionController)).call.apply(_ref, [this].concat(args)));

        _this.initialize = _this.initialize.bind(_this);
        _this.onUserActivity = _this.onUserActivity.bind(_this);
        return _this;
    }

    _createClass(SessionController, [{
        key: "initialize",
        value: function initialize() {
            var _this2 = this;

            this.doKeepAlive = _HybridConfig2.default.get("session.keepAlive", true);
            this.doAutoLogout = _HybridConfig2.default.get("session.autoLogout", true);
            // the length of time a session is allowed to stick around without user activity
            this.sessionTimeout = _HybridConfig2.default.get("session.timeout", 45 * 60 * 1000);
            // the length of time before a session ends that the user should be prompted that it is imminent
            this.sessionTimeoutImminentDelta = _HybridConfig2.default.get("session.timeoutImminentDelta", 5 * 60 * 1000);
            // how often we should check to see if the session is expired
            this.logoutCheckInterval = _HybridConfig2.default.get("session.logoutCheckInterval", 60 * 1000);
            // how often we should ping the server to ensure the session is alive there
            this.keepaliveInterval = _HybridConfig2.default.get("session.keepaliveInterval", 5 * 60 * 1000);
            // how often we should check to see if we should issue a keepalive
            this.keepaliveCheckInterval = _HybridConfig2.default.get("session.keepaliveCheckInterval", 30 * 1000);
            // the Date of the user's last session-prolonging activity, as set via @dispatch("user:activity")
            this.lastActivity = new Date();

            // check if we need to issue a keepalive request to the server
            if (this.doKeepAlive) {
                // eslint-disable-next-line no-settimeout
                this._keepaliveInterval = setInterval(function () {
                    if (false) {
                        // dev-time fake session. don't do stuff.
                        clearInterval(_this2._keepaliveInterval);
                        delete _this2._keepaliveInterval;
                        return;
                    }
                    var lastSuccess = _BaseServices2.default.getLastSuccess();
                    var age = lastSuccess != null ? new Date().valueOf() - lastSuccess.valueOf() : 0;
                    // console.log("ensure?", age, this.keepaliveInterval)
                    if (age > _this2.keepaliveInterval) {
                        // it's been long enough, send it!
                        // console.log("ensure.")
                        _BaseServices2.default.ensureSession();
                    }
                }, this.keepaliveCheckInterval);
            }

            // check if we should log the user out due to lack of activity
            if (this.doAutoLogout) {
                // eslint-disable-next-line no-settimeout
                this._logoutInterval = setInterval(function () {
                    if (false) {
                        // dev-time fake session. don't do stuff.
                        clearInterval(_this2._logoutInterval);
                        delete _this2._logoutInterval;
                        return;
                    }
                    var age = new Date().valueOf() - _this2.lastActivity.valueOf();
                    // console.log("end?", age, this.sessionTimeout)
                    if (age > _this2.sessionTimeout) {
                        // it's been long enough, do it!
                        // alert("end.")
                        _Dispatcher2.default.dispatch({
                            type: _SessionActions2.default.timeout
                        });
                        clearInterval(_this2._keepaliveInterval);
                        _BaseServices2.default.endSession();
                    } else if (age > _this2.sessionTimeout - _this2.sessionTimeoutImminentDelta) {
                        _Dispatcher2.default.dispatch({
                            type: _SessionActions2.default.timeoutImminent,
                            timeLeft: _this2.sessionTimeout - age
                        });
                    }
                }, this.logoutCheckInterval);
            }
        }
    }, {
        key: "onUserActivity",
        value: function onUserActivity() {
            // console.log("onUserActivity")
            this.lastActivity = new Date();
        }
    }, {
        key: "onUserLogout",
        value: function onUserLogout() {
            _BaseServices4.default.endSession();
        }
    }]);

    return SessionController;
}(Backbone.Controller);

SessionController.prototype.events = {
    "user:activity": "onUserActivity",
    "user:logout": "onUserLogout"
};

exports.default = SessionController;

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

var PlatformDetect,
  __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

PlatformDetect = (function() {
  function PlatformDetect() {
    this.addPlatformClassesToElement = __bind(this.addPlatformClassesToElement, this);
    this.getPlatform = __bind(this.getPlatform, this);
    this.isMobile = __bind(this.isMobile, this);
  }

  PlatformDetect.prototype.Android = function() {
    if (navigator.userAgent.match(/Android/i)) {
      return "Android";
    }
  };

  PlatformDetect.prototype.BlackBerry = function() {
    if (navigator.userAgent.match(/BlackBerry/i)) {
      return "BlackBerry";
    }
  };

  PlatformDetect.prototype.iOS = function() {
    if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
      return "iOS";
    }
  };

  PlatformDetect.prototype.Opera = function() {
    if (navigator.userAgent.match(/Opera Mini/i)) {
      return "Opera-Mini";
    }
  };

  PlatformDetect.prototype.Windows = function() {
    if (navigator.userAgent.match(/IEMobile/i)) {
      return 'IEMobile';
    }
  };

  PlatformDetect.prototype.isMobile = function() {
    return this.getPlatform() !== "Desktop";
  };

  PlatformDetect.prototype.getPlatform = function() {
    return this.Android() || this.BlackBerry() || this.iOS() || this.Opera() || this.Windows() || "Desktop";
  };

  PlatformDetect.prototype.addPlatformClassesToElement = function(el) {
    var platform;

    platform = this.getPlatform();
    el.addClass("platform-" + platform);
    return el;
  };

  return PlatformDetect;

})();

module.exports = PlatformDetect;


/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(13);

var _typeCheckingStore = __webpack_require__(18);

var _typeCheckingStore2 = _interopRequireDefault(_typeCheckingStore);

var _OverActions = __webpack_require__(122);

var _OverActions2 = _interopRequireDefault(_OverActions);

var _OverStore = __webpack_require__(61);

var _SessionActions = __webpack_require__(320);

var _SessionActions2 = _interopRequireDefault(_SessionActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavigationStore = function (_ReduceStore) {
    _inherits(NavigationStore, _ReduceStore);

    function NavigationStore() {
        _classCallCheck(this, NavigationStore);

        return _possibleConstructorReturn(this, (NavigationStore.__proto__ || Object.getPrototypeOf(NavigationStore)).call(this, _Dispatcher2.default));
    }

    _createClass(NavigationStore, [{
        key: "getInitialState",
        value: function getInitialState() {
            return {
                promptExternalNavigation: true
            };
        }
    }, {
        key: "reduce",
        value: function reduce(state, action) {
            switch (action.type) {
                case _SessionActions2.default.timeout:
                    {
                        return {
                            promptExternalNavigation: false
                        };
                    }
                case _OverActions2.default.EXTERNAL_NAV:
                    {
                        if ((0, _OverStore.isConfirmed)(action)) {
                            return {
                                promptExternalNavigation: false
                            };
                        }
                        return state;
                    }
                default:
                    return state;
            }
        }
    }, {
        key: "canPromptExternalNavigation",
        value: function canPromptExternalNavigation() {
            return this.getState().promptExternalNavigation;
        }
    }]);

    return NavigationStore;
}(_utils.ReduceStore);

NavigationStore.stateTypes = {
    promptExternalNavigation: _propTypes2.default.bool.isRequired
};

exports.default = (0, _typeCheckingStore2.default)(new NavigationStore());

/***/ }),
/* 1593 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1594 */,
/* 1595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * decaffeinate suggestions:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DS101: Remove unnecessary use of Array.from
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DS102: Remove unnecessary code created because of implicit returns
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DS203: Remove `|| {}` from converted for-own loops
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DS205: Consider reworking code to avoid use of IIFEs
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DS207: Consider shorter variations of null checks
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
/*
    I contain a high-level wrapper for "driving" the application with code, but
    using nomenclature that a human would use to describe the operations.
*/


var _application = __webpack_require__(487);

var _application2 = _interopRequireDefault(_application);

var _Services = __webpack_require__(110);

var _Services2 = _interopRequireDefault(_Services);

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _DevelopmentActions = __webpack_require__(98);

var _DevelopmentActions2 = _interopRequireDefault(_DevelopmentActions);

var _UserActions = __webpack_require__(123);

var _UserActions2 = _interopRequireDefault(_UserActions);

var _promisify = __webpack_require__(97);

var _promisify2 = _interopRequireDefault(_promisify);

var _AppDriver = __webpack_require__(1597);

var _AppDriver2 = _interopRequireDefault(_AppDriver);

var _utils = __webpack_require__(365);

var _utils2 = _interopRequireDefault(_utils);

var _wait = __webpack_require__(666);

var _wait2 = _interopRequireDefault(_wait);

var _ITState = __webpack_require__(1600);

var _ITState2 = _interopRequireDefault(_ITState);

var _Interpreter = __webpack_require__(1602);

var _Interpreter2 = _interopRequireDefault(_Interpreter);

var _RunnerUi = __webpack_require__(1606);

var _RunnerUi2 = _interopRequireDefault(_RunnerUi);

var _utils3 = __webpack_require__(644);

var _HybridConfig = __webpack_require__(41);

var _HybridConfig2 = _interopRequireDefault(_HybridConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

if (false) {
    // so it can receive the selection action (before app bootstrap)
    // eslint-disable-next-line no-unused-expressions
    require("data/dev/ITTestStore").default;
}

var Iterator = function () {
    function Iterator(elements) {
        _classCallCheck(this, Iterator);

        this.size = this.size.bind(this);
        this.hasNext = this.hasNext.bind(this);
        this.next = this.next.bind(this);
        this.elements = elements;
        this.i = -1;
    }

    _createClass(Iterator, [{
        key: "size",
        value: function size() {
            return this.elements.length;
        }
    }, {
        key: "hasNext",
        value: function hasNext() {
            return this.i < this.elements.length - 1;
        }
    }, {
        key: "next",
        value: function next() {
            if (!this.hasNext()) {
                throw new Error("This iterator is out of elements");
            }
            return new ITDriver(this.elements[++this.i], this.elements.selector);
        }
    }]);

    return Iterator;
}();

var rootContext = "html";
var selectors = {};
var addSelector = function addSelector(name, selector, factory) {
    if (!selectors.hasOwnProperty(name)) {
        selectors[name] = {};
    }
    return selectors[name][selector] = factory;
};

var buildSelectors = function buildSelectors(block, ctx) {
    return function () {
        var result = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = Object.keys(block || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var n = _step.value;

                var nb = block[n];
                result.push(function (n, nb) {
                    if (n !== "selector") {
                        // it's a subcontext
                        var nc = void 0;
                        if (nb instanceof Function) {
                            nc = ctx + " " + n;
                            addSelector(n, nc, nb);
                        } else {
                            if (nb.selector == null) {
                                throw new Error("malformed AppDriver elements definitions: no selector key for \"" + ctx + " " + n + "\"");
                            }
                            nc = ctx + " " + nb.selector;
                            addSelector(n, nc);
                        }
                        return buildSelectors(nb, nc);
                    }
                }(n, nb));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return result;
    }();
};

buildSelectors(_AppDriver2.default.elements, rootContext);

var cleanSemanticSelector = function cleanSemanticSelector(s) {
    return s.replace(new RegExp(" +([^ ]|$)", "g"), function (m, g1) {
        return g1.toUpperCase();
    });
};

var cleanCssSelector = function cleanCssSelector(s) {
    return s.replace(new RegExp(" +", "g"), " ");
};

var uncleanSemanticSelector = function uncleanSemanticSelector(s) {
    return s.replace(new RegExp("([A-Z]+)", "g"), function (m, g1) {
        return " " + g1.toLowerCase();
    });
};

var instanceCounter = 0;

var ITDriver = function () {
    function ITDriver() {
        var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rootContext;
        var selector = arguments[1];

        _classCallCheck(this, ITDriver);

        this.with = this.with.bind(this);
        this.pop = this.pop.bind(this);
        this.drawTargets = this.drawTargets.bind(this);
        this.size = this.size.bind(this);
        this.iterator = this.iterator.bind(this);
        this.id = instanceCounter++;
        this.chain = [{
            element: this.element = $(start),
            selector: this.selector = cleanCssSelector(selector != null ? selector : this.element.selector)
        }];
    }

    _createClass(ITDriver, [{
        key: "with",
        value: function _with() {
            var _this = this;

            var args = Array.prototype.slice.call(arguments);
            var work = args.pop();
            if (!(work instanceof Function)) {
                args.push(work);
                work = null;
            }
            var unwind = 0;
            var atElement = $(this.element.selector);
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = args[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var selector = _step2.value;

                    var domSel = void 0,
                        newEl = void 0,
                        newSel = void 0;
                    unwind += 1;
                    if (typeof selector === "number") {
                        var idxEl = atElement.eq(selector - 1);
                        if (idxEl.length === 0) {
                            throw new Error("Element " + selector + " of '" + this.element.selector + "' doesn't exit.");
                        }
                        var id = idxEl.attr("id");
                        if (id == null) {
                            throw new Error("Element " + selector + " of '" + this.element.selector + "' doesn't have an id attribute, and thus can't be indexed.");
                        }
                        newEl = $(atElement.selector.trim() + "#" + id);
                        if (newEl.length !== 1) {
                            throw new Error("Element " + selector + " of '" + this.element.selector + "' has an id of '" + id + "', which is ... not unique?!");
                        }
                        newSel = this.selector;
                    } else {
                        (function () {
                            // semantic selector
                            selector = $.trim(selector);

                            var _Array$from = Array.from(selector.split(":")),
                                _Array$from2 = _toArray(_Array$from),
                                sel = _Array$from2[0],
                                factoryArgs = _Array$from2.slice(1);

                            factoryArgs.unshift(atElement);
                            var semSel = cleanSemanticSelector(sel);
                            if (!selectors.hasOwnProperty(semSel)) {
                                throw new Error("No \"" + selector + "\" (" + semSel + ") element is known.");
                            }
                            var paths = Object.keys(selectors[semSel]).filter(function (p) {
                                return p.indexOf(_this.selector) === 0;
                            }).map(function (p) {
                                return {
                                    p: p,
                                    f: selectors[semSel][p]
                                };
                            });
                            var pathUniquer = {};
                            var existingPaths = [];

                            var _loop = function _loop(path) {
                                domSel = function () {
                                    if (path.f != null) {
                                        if (path.f.length !== factoryArgs.length) {
                                            throw new Error("Incorrect number of arguments to the \"" + sel + "\" dynamic selector");
                                        }
                                        var block = path.f.apply(null, factoryArgs);
                                        buildSelectors(block, _this.selector + " " + block.selector);
                                        return block.selector;
                                    } else {
                                        return path.p.substr(_this.selector.length);
                                    }
                                }();
                                pathUniquer[domSel] = true;
                            };

                            var _iteratorNormalCompletion3 = true;
                            var _didIteratorError3 = false;
                            var _iteratorError3 = undefined;

                            try {
                                for (var _iterator3 = paths[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                    var path = _step3.value;

                                    _loop(path);
                                }
                            } catch (err) {
                                _didIteratorError3 = true;
                                _iteratorError3 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                        _iterator3.return();
                                    }
                                } finally {
                                    if (_didIteratorError3) {
                                        throw _iteratorError3;
                                    }
                                }
                            }

                            var _iteratorNormalCompletion4 = true;
                            var _didIteratorError4 = false;
                            var _iteratorError4 = undefined;

                            try {
                                for (var _iterator4 = Object.keys(pathUniquer || {})[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                    domSel = _step4.value;

                                    var el = $(domSel, atElement);
                                    if (el.length) {
                                        var exists = false;
                                        var _iteratorNormalCompletion5 = true;
                                        var _didIteratorError5 = false;
                                        var _iteratorError5 = undefined;

                                        try {
                                            for (var _iterator5 = existingPaths[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                                var ep = _step5.value;

                                                if (ep.length !== el.length) {
                                                    continue;
                                                }
                                                exists = true;
                                                for (var i = 0; i < ep.length; i++) {
                                                    var e = ep[i];
                                                    if (e !== el[i]) {
                                                        exists = false;
                                                        break;
                                                    }
                                                }
                                            }
                                        } catch (err) {
                                            _didIteratorError5 = true;
                                            _iteratorError5 = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                                    _iterator5.return();
                                                }
                                            } finally {
                                                if (_didIteratorError5) {
                                                    throw _iteratorError5;
                                                }
                                            }
                                        }

                                        if (exists) {
                                            console.warn("Selector \"" + selector + "\" (" + semSel + ") within (" + _this.selector + ") has multiple paths of resolution, though they currently all resolve the same. It's not a bug, but may introduce flakiness if AppDriver changes in seemingly unrelated ways.");
                                        } else {
                                            existingPaths.push(el);
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError4 = true;
                                _iteratorError4 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                        _iterator4.return();
                                    }
                                } finally {
                                    if (_didIteratorError4) {
                                        throw _iteratorError4;
                                    }
                                }
                            }

                            if (existingPaths.length === 0) {
                                throw new Error("No \"" + selector + "\" (" + semSel + ") element is known in this context (" + _this.selector + ").  Either it doesn't exist here or a developer needs to add support for it in AppDriver.");
                            } else if (existingPaths.length > 1) {
                                throw new Error("Multiple \"" + selector + "\" (" + semSel + ") elements are known in this context (" + _this.selector + ").  The test need to be more specific.");
                            }

                            newEl = existingPaths[0];
                            newSel = cleanCssSelector(newEl.selector);
                        })();
                    }
                    if (newEl.length === 0) {
                        throw new Error("no \"" + selector + "\" (" + domSel + ") element found in this context (" + this.selector + ").  A developer probably changed the DOM and didn't update AppDriver");
                    }
                    this.chain.push({
                        element: this.element = newEl,
                        selector: this.selector = newSel
                    });
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            if (work != null) {
                work();
                while (unwind > 0) {
                    unwind -= 1;
                    this.pop();
                }
            }
            // to avoid leaking a return value
        }
    }, {
        key: "pop",
        value: function pop() {
            this.chain.pop();
            if (this.chain.length === 0) {
                this.element = null;
                this.selector = null;
            } else {
                var last = this.chain[this.chain.length - 1];
                this.element = last.element;
                this.selector = last.selector;
            }
            // to avoid leaking a return value
        }
    }, {
        key: "drawTargets",
        value: function drawTargets() {
            this.clearTargets();
            var targets = [];
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = Object.keys(selectors || {})[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var n = _step6.value;

                    var ss = selectors[n];
                    var _iteratorNormalCompletion8 = true;
                    var _didIteratorError8 = false;
                    var _iteratorError8 = undefined;

                    try {
                        for (var _iterator8 = Object.keys(ss || {})[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                            var p = _step8.value;

                            var f = ss[p];
                            if (p.indexOf(this.selector) === 0 && f == null) {
                                targets.push({ selector: p, label: uncleanSemanticSelector(n) });
                            }
                        }
                    } catch (err) {
                        _didIteratorError8 = true;
                        _iteratorError8 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                _iterator8.return();
                            }
                        } finally {
                            if (_didIteratorError8) {
                                throw _iteratorError8;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }

            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
                for (var _iterator7 = targets[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var t = _step7.value;

                    $(t.selector).addClass("IT-target").attr("title", t.label);
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                        _iterator7.return();
                    }
                } finally {
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }
        }
    }, {
        key: "clearTargets",
        value: function clearTargets() {
            $(".IT-target").removeClass("IT-target").removeAttr("title");
            $("#IT-target-labels").remove();
        }
    }, {
        key: "size",
        value: function size() {
            return $(this.element.selector).length;
        }
    }, {
        key: "iterator",
        value: function iterator() {
            return new Iterator($(this.element.selector));
        }
    }]);

    return ITDriver;
}();

var addAction = function addAction(action, fn, type) {
    if (ITDriver.prototype[action] != null) {
        var msg = "There are multiple \"" + action + "\" helpers defined in AppDriver.";
        _utils2.default.error(msg);
        throw new Error(msg);
    }
    return ITDriver.prototype[action] = function () {
        var _this2 = this;

        var result = null;
        var args = Array.prototype.slice.call(arguments);
        var interfaceArgCount = fn.length - 1;
        var atElement = $(this.element.selector);
        if (args.length > interfaceArgCount) {
            var pathArgCount = args.length - interfaceArgCount;
            var workArgs = args.slice(0, pathArgCount);
            var actionArgs = args.slice(pathArgCount);
            workArgs.push(function () {
                actionArgs.unshift(atElement);
                return result = fn.apply(_this2, actionArgs);
            });
            this.with.apply(this, workArgs);
        } else {
            args.unshift(atElement);
            result = fn.apply(this, args);
        }
        if (type === "inspection") {
            return result;
        }
    };
};

for (var action in _AppDriver2.default.actions) {
    addAction(action, _AppDriver2.default.actions[action], "action");
}

for (var insp in _AppDriver2.default.inspections) {
    addAction(insp, _AppDriver2.default.inspections[insp], "inspection");
}

exports.default = {
    initialize: function initialize(params) {
        var delay = void 0,
            script = void 0;
        _utils2.default.setUpDOM();
        var interpreter = null;
        var spec = $.trim(params.IT != null ? params.IT : "");
        var mSpec = $.trim(params.ITmanifest != null ? params.ITmanifest : "");
        var state = new _ITState2.default({
            spec: spec,
            manifestSpec: mSpec,
            autoPlay: params.ITautoPlay !== "false",
            tickDelay: params.ITtickDelay != null && !isNaN(delay = parseInt(params.ITtickDelay)) ? delay : 50
        });
        var badThingCount = 0;
        var badThingsMan = function badThingsMan(message) {
            if (++badThingCount >= 5) {
                if (badThingCount === 5) {
                    console.warn("Things went really bad. Like REALLY bad...");
                }
                return;
            }
            if (interpreter != null) {
                interpreter.pause();
            }
            state.set({
                scriptState: "error",
                chromeType: "danger"
            });
            _utils2.default.addErrorData(message);
            _utils2.default.error(message);
            return _utils2.default.complete(false);
        };
        window.addEventListener("error", function (event) {
            return (
                // eslint-disable-next-line no-settimeout
                setTimeout(function () {
                    return badThingsMan(event.message);
                })
            );
        });
        window.addEventListener("unhandledrejection", function (event) {
            if (event.reason.__ignore_ajax_failure) {
                console.warn("This \"Uncaught (in promise)\" was requested to be ignored.");
                return;
            }
            // eslint-disable-next-line no-settimeout
            setTimeout(function () {
                return badThingsMan("Uncaught (in promise) " + event.reason);
            });
        });

        var requests = [];
        if (spec === "") {
            // no script
            state.set("autoInitialize", false);
            state.set("autoPlay", false);
            state.set("scriptState", "edit");
            script = "// enter (or paste) your scenario here\n// mockset [name]\nclick search / form / new button\nwait";
            state.set("script", script);
            _Dispatcher2.default.dispatch({
                type: _DevelopmentActions2.default.AD_HOC_IT_TEST,
                script: script
            });
        } else if (spec.indexOf("\n") < 0) {
            // script url
            requests.push((0, _promisify2.default)($.ajax({
                url: spec,
                data: { _: Date.now()
                },
                dataType: "text"
            })).then(function (data) {
                state.set("script", data);
                return _Dispatcher2.default.dispatch({
                    type: _DevelopmentActions2.default.SELECT_IT_TEST,
                    path: spec,
                    script: data
                });
            }, function (xhr) {
                state.set("autoInitialize", false);
                return state.set("script", "// Failed to load \"" + spec + "\"\n// " + xhr.status + " " + xhr.statusText + "\nfail \"loading error\"\n");
            }));
        } else {
            // literal script
            state.set("script", spec);
            _Dispatcher2.default.dispatch({
                type: _DevelopmentActions2.default.AD_HOC_IT_TEST,
                script: spec
            });
        }

        if (mSpec !== "") {
            if (mSpec.indexOf("\n") < 0) {
                // manifest url
                requests.push($.ajax({
                    url: mSpec,
                    dataType: "text"
                }).then(
                // eslint-disable-next-line no-restricted-globals
                function (data) {
                    return self.set("manifest", data);
                }));
            } else {
                // literal manifest
                this.set("manifest", mSpec);
            }
        }

        return _application2.default.addInitializationPromise(Promise.all(requests).then(function () {
            return new Promise(function (resolve) {
                interpreter = new _Interpreter2.default(_AppDriver2.default, state.get("script"), { tickDelay: state.get("tickDelay") });
                state.set("interpreter", interpreter);
                var ui = new _RunnerUi2.default({ model: state });
                var driver = new ITDriver();
                var resetTargets = function resetTargets() {
                    var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : state.get("showTargets");

                    if (v) {
                        return driver.drawTargets();
                    } else {
                        return driver.clearTargets();
                    }
                };

                state.on("change:showTargets", function (m, v) {
                    return resetTargets(v);
                });

                _utils2.default.itview(ui);
                interpreter.on("validated", function (errors) {
                    if (errors.length) {
                        _utils2.default.addErrorData(errors[0]);
                        state.set({
                            scriptState: "error",
                            chromeType: "danger"
                        });
                        return _utils2.default.complete(false);
                    }
                }).on("start", function (promise) {
                    state.set({ scriptState: "start" });
                    return promise.done(function () {
                        state.set({
                            scriptState: "success",
                            chromeType: "success"
                        });
                        return _utils2.default.complete(true);
                    }).fail(function (e) {
                        _utils2.default.addErrorData(e);
                        state.set({
                            scriptState: "error",
                            chromeType: "danger"
                        });
                        return _utils2.default.complete(false);
                    });
                }).on("play", function () {
                    return state.set({ scriptState: "play" });
                }).on("pause", function () {
                    return state.set({ scriptState: "pause" });
                }).on("close", function () {
                    return ui.close();
                }).on("all", function (n) {
                    if (n === "with:start" || n.substr(n.length - 5) === ":done") {
                        return resetTargets();
                    }
                });
                if (state.get("autoInitialize")) {
                    interpreter.validate();
                    if (interpreter.errors.length) {
                        state.set("autoInitialize", false);
                    } else {
                        var mockset = interpreter.getMockset();
                        if (mockset != null) {
                            if (_Services2.default.__mocked) {
                                throw new Error("Mocking is already configured, so this IT can't set up what it needs.");
                            }
                            window.HybridConfig.mockRoot = "mocks/" + mockset + "/";
                            __webpack_require__(667);
                        }

                        var user = interpreter.getUser();
                        if (user != null) {
                            (0, _utils3.setCookie)(user);
                        } else {
                            (0, _utils3.clearCookie)();
                        }

                        var config = interpreter.getConfig() || {};
                        var _iteratorNormalCompletion9 = true;
                        var _didIteratorError9 = false;
                        var _iteratorError9 = undefined;

                        try {
                            for (var _iterator9 = Object.keys(config)[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                                var key = _step9.value;

                                _HybridConfig2.default.set(key, config[key]);
                            }
                        } catch (err) {
                            _didIteratorError9 = true;
                            _iteratorError9 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion9 && _iterator9.return) {
                                    _iterator9.return();
                                }
                            } finally {
                                if (_didIteratorError9) {
                                    throw _iteratorError9;
                                }
                            }
                        }

                        var prefs = interpreter.getPreferences() || {};
                        if (Object.keys(prefs).length > 0) {
                            var token = _Dispatcher2.default.register(function (action) {
                                if (action.type !== _UserActions2.default.LOADED) {
                                    return;
                                }
                                // eslint-disable-next-line no-settimeout
                                setTimeout(function () {
                                    return function () {
                                        var result = [];
                                        var _iteratorNormalCompletion10 = true;
                                        var _didIteratorError10 = false;
                                        var _iteratorError10 = undefined;

                                        try {
                                            for (var _iterator10 = Object.keys(prefs)[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                                                var _key = _step10.value;

                                                var parts = _key.split(".");
                                                result.push(_Dispatcher2.default.dispatch({
                                                    type: _UserActions2.default.UPDATE_LICENSE_PREFERENCE,
                                                    impl: parts[0],
                                                    pref: parts[1],
                                                    value: prefs[_key]
                                                }));
                                            }
                                        } catch (err) {
                                            _didIteratorError10 = true;
                                            _iteratorError10 = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion10 && _iterator10.return) {
                                                    _iterator10.return();
                                                }
                                            } finally {
                                                if (_didIteratorError10) {
                                                    throw _iteratorError10;
                                                }
                                            }
                                        }

                                        return result;
                                    }();
                                }, 0);
                                return _Dispatcher2.default.unregister(token);
                            });
                        }
                    }
                }

                if (state.get("autoInitialize")) {
                    _application2.default.on("start", function () {
                        return _application2.default.layout.on("render", function () {
                            _utils2.default.itview(ui);
                            return _wait2.default.sync({ for: 60000 }, function () {
                                interpreter.start(driver);
                                if (state.get("autoPlay") && !interpreter.errors.length) {
                                    return interpreter.play();
                                }
                            });
                        });
                    });
                    return resolve();
                }
                // if autoInitialize is false, leave the promise unresolved
            });
        }));
    }
};

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
                                                                                                                                                                                                                                                                      I describe how to get and interact with elements based on high-level
                                                                                                                                                                                                                                                                      user-centric names of things (e.g., "patient search"). I'm used for driving
                                                                                                                                                                                                                                                                      integration tests.
                                                                                                                                                                                                                                                                  
                                                                                                                                                                                                                                                                      The 'elements' key stores selectors for semantically identifying elements
                                                                                                                                                                                                                                                                      in the DOM.  Each level must be an object with a 'selector' key for the
                                                                                                                                                                                                                                                                      CSS path the element(s) in question.  The object may have additional keys
                                                                                                                                                                                                                                                                      which semantically identify subelements.  In all cases the key is the
                                                                                                                                                                                                                                                                      semantic name (converted to camel-case) of the element.
                                                                                                                                                                                                                                                                  
                                                                                                                                                                                                                                                                      The 'actions' key stores functions for taking actions on a given element.
                                                                                                                                                                                                                                                                      These should be fail-fast where appropriate to help test authors debug
                                                                                                                                                                                                                                                                      errors they may have made.  These cannot return values, use an inspection
                                                                                                                                                                                                                                                                      for that.
                                                                                                                                                                                                                                                                  
                                                                                                                                                                                                                                                                      The 'inspections' key stores functions for inspecting a given element.
                                                                                                                                                                                                                                                                      These should be fail-fast where appropriate to help test authors debug
                                                                                                                                                                                                                                                                      errors they may have made.  These may not mutate the state of the element,
                                                                                                                                                                                                                                                                      use an action for that.
                                                                                                                                                                                                                                                                  
                                                                                                                                                                                                                                                                      Actions and inspections can both accept arguments beyond the element to act
                                                                                                                                                                                                                                                                      upon and tests will be forced to provide the correct number of arguments.
                                                                                                                                                                                                                                                                      Thus they cannot use optional arguments.  Sorry.
                                                                                                                                                                                                                                                                  */

var _entityMetaStore = __webpack_require__(22);

var _entityMetaStore2 = _interopRequireDefault(_entityMetaStore);

var _lockClient = __webpack_require__(665);

var _lockClient2 = _interopRequireDefault(_lockClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReactTestUtils = __webpack_require__(623);

var augment = function augment(base) {
    for (var _len = arguments.length, others = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        others[_key - 1] = arguments[_key];
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = others[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var other = _step.value;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Object.keys(other)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var key = _step2.value;

                    if (base[key] == null) {
                        base[key] = other[key];
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return base;
};

var recordGridChildren = {
    topadd: {
        selector: "thead > tr > th.actions button",
        caret: {
            selector: ".caret"
        }
    },
    bottomadd: {
        selector: ".bottom-button-row button"
    },
    rows: {
        selector: "tbody tr",
        add: {
            selector: "button.btn-add"
        },
        delete: {
            selector: "button.btn-remove"
        },
        view: {
            selector: "button.btn-view"
        }
    }
};

var controlSelect = function controlSelect($el, key) {
    var block = { selector: ".control-container-" + key };

    var $tgt = $el.find(block.selector);
    switch ($tgt.data("controlType")) {
        case "recordbrowser":
            block.browse = {
                selector: ".icon-search"
            };
            break;
        case "typeahead":
            block.browse = {
                selector: ".icon-search"
            };
            block.clear = {
                selector: ".clear-value"
            };
            block.selectAll = {
                selector: ".select-all"
            };
            break;
        case "summarysection":
            Object.assign(block, recordGridChildren);
            // also need control nesting
            block.rows.control = controlSelect;
            break;
        case "devicelesiongrid":
            Object.assign(block, recordGridChildren);
            // also need control nesting
            block.rows.control = controlSelect;
            block.rows.checkbox = function ($el, key) {
                return {
                    selector: ".control.checkbox-field[data-shortname=" + key + "]"
                };
            };
            break;

        case "calendar":
        case "spinner":
            block.dropdown = { selector: ".calendar-button" };
            break;
        case "manager":
            block.files = {
                selector: ".file-link"
            };
            block.remove = {
                selector: ".file-remove"
            };
            break;
        default:
        // no type-specific augmentation needed
    }

    return block;
};

var searchFormControl = function searchFormControl($el, key) {
    var selector = ".control-container-" + key;
    if ($el.find(selector + "val").length) {
        selector += "val";
    }
    return {
        selector: selector
    };
};

var asSplitButton = function asSplitButton(sel) {
    return {
        primary: {
            selector: sel.replace(/\./g, ".primary-")
        },
        dropdown: {
            selector: sel.replace(/\./g, ".split-")
        }
    };
};

var searchBlockBuilder = function searchBlockBuilder() {
    var searchButtonSelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ".btn-search";
    return {
        selector: ".drawer-body",
        form: {
            selector: ".search-form-layout",
            control: searchFormControl,

            inputField: {
                selector: ".search-inputs .control:first"
            },
            typeField: {
                selector: "#types .control"
            },
            advancedSearchToggle: {
                selector: ".advanced-search-toggle"
            },
            relativeDateToggle: {
                selector: ".togglerelativedates"
            },
            searchButton: _extends({
                selector: searchButtonSelector
            }, asSplitButton(searchButtonSelector)),
            noSavedSearch: {
                selector: ".no-saved-search"
            },
            newButton: {
                selector: ".btn-create"
            },
            clearSearch: {
                selector: ".clear"
            }
        },
        showDisabled: {
            selector: ".showDisabled"
        },
        headers: {
            selector: ".search-results thead tr th"
        },
        results: {
            selector: ".search-results tbody tr.selection-table-row",
            fields: {
                selector: "td"
            }
        },
        noResults: {
            selector: ".search-results tbody tr#nosearchresults_row"
        }
    };
};

var fieldAdminPaneBuilder = function fieldAdminPaneBuilder(selector) {
    var sectionSkeleton = {
        heading: {
            selector: ".panel-heading .group-name"
        },
        items: {
            selector: ".list-group-item"
        }
    };
    return {
        selector: selector,
        sections: _extends({
            selector: ".list-group"
        }, sectionSkeleton),
        section: function section($el, key) {
            return _extends({
                selector: ".list-group[data-group='" + key + "']"
            }, sectionSkeleton, {
                item: function item($el, key) {
                    return {
                        selector: ".list-group-item[data-key='" + key + "']"
                    };
                }
            });
        }
    };
};

var modalSkeleton = {
    selector: "#modal .modal-content",
    title: {
        selector: ".modal-title"
    },
    close: {
        selector: ".modal-close"
    }
};

var elements = {
    dropdownMenu: {
        selector: "body .dropdown-wrapper .dropdown-menu"
    },
    navbar: {
        selector: "#global-navbar",
        hybrid: {
            selector: ".menu-hybrid"
        },
        settings: {
            selector: ".menu-settings"
        },
        orgs: {
            selector: ".menu-orgs"
        },
        userMenu: {
            selector: ".menu-user",
            toggle: {
                selector: ".dropdown-toggle"
            },
            logout: {
                selector: ".logout-link"
            }
        }
    },

    dataEntry: {
        selector: "#content_de",
        search: searchBlockBuilder(".search-button"),
        drawerPull: {
            selector: ".btn-drawer-pull"
        },
        drawer: {
            selector: ".drawer-container"
        },
        openRecord: {
            selector: ".drawer-content",
            headerBar: {
                selector: ".header h1",
                label: {
                    selector: ".entity-label"
                },
                detail: {
                    selector: ".entity-detail"
                },
                delete: {
                    selector: "button.deleteRoot"
                },
                merge: {
                    selector: "button.mergeRoot"
                },
                pesslockWarning: {
                    selector: ".pesslock-warning"
                }
            },
            breadcrumb: {
                selector: ".header .button-group",
                root: {
                    selector: ".root",
                    button: {
                        selector: "a.entity"
                    },
                    rootMenu: {
                        selector: ".dropdown-toggle"
                    },
                    delete: {
                        selector: ".deleteRoot"
                    }
                },
                list: {
                    selector: ".navigator.btn-group > span"
                }
            },
            navigatorColumns: {
                selector: ".entity.navigator .column",
                header: {
                    selector: "header .column-header"
                },
                add: {
                    selector: "header .btn-add"
                },
                remove: {
                    selector: "header .btn-remove"
                },
                itemList: {
                    selector: ".items",
                    items: {
                        selector: "li:visible"
                    }
                }
            },
            bottomPane: {
                selector: ".bottom-pane",
                saveButton: {
                    selector: "button.actionSave"
                },
                cancelButton: {
                    selector: "button.actionCancel"
                },
                mapButton: {
                    selector: "button.btn-mapping"
                },
                mapButtonDropDown: {
                    selector: "button.btn-mapping-dropdown"
                },
                mergeButton: {
                    selector: "button.btn-merge"
                },
                mergeButtonDropDown: {
                    selector: "button.btn-merge-dropdown"
                },
                printButton: {
                    selector: "button.btn-print"
                },
                jumpTo: {
                    selector: ".form-section"
                },
                versionDropDown: {
                    selector: ".version-section"
                },
                form: {
                    selector: ".de_pane .entity-information",
                    control: controlSelect,
                    widget: function widget($el, label) {
                        var block = {
                            selector: "[data-widget-label=\"" + label.replace(/"/g, "\\\"") + "\"]"
                        };
                        var $tgt = $el.find(block.selector);
                        switch ($tgt.data("widgetType")) {
                            case "magicrootsummarysection":
                                Object.assign(block, recordGridChildren);
                                break;
                            default:
                            // no type-specific augmentation needed
                        }
                        return block;
                    },

                    vjsPlayer: {
                        selector: ".video-js"
                    },
                    modeSelector: {
                        selector: ".mode-selector",
                        individualButton: {
                            selector: ".btn[value=individual]"
                        },
                        comparisonButton: {
                            selector: ".btn[value=comparison]"
                        }
                    },
                    comparisonSelector: {
                        selector: ".dropdown-container"
                    }
                },
                definitionsTab: {
                    selector: ".sidebar .navigation li.definitions a"
                },

                dataDefinitions: {
                    selector: ".sidebar .data-definitions",
                    header: {
                        selector: ".panel-heading"
                    },
                    keyboardShortcuts: {
                        selector: ".keyboard-shortcuts li"
                    }
                },

                statusBar: {
                    selector: ".form.footer .msg"
                },

                validationTab: {
                    selector: ".sidebar .navigation li.validation a"
                },

                validationPanel: {
                    selector: ".sidebar .validation-panel",
                    filter: function filter($el, key) {
                        var block = { selector: "." + key };

                        return block;
                    },


                    panelBody: {
                        selector: ".panel-body",

                        tree: {
                            selector: ".validationtree",

                            item: function item($el, key) {
                                return {
                                    selector: ".tree-item-" + key,
                                    status: {
                                        selector: ".indicator-container"
                                    },
                                    expander: {
                                        selector: ".expander"
                                    },
                                    message: {
                                        selector: ".message"
                                    }
                                };
                            }
                        }
                    }
                }
            }
        }
    },

    modalPrompt: {
        selector: ".modal-prompt",
        value: {
            selector: ".control-container-value"
        },
        ok: {
            selector: "button.btn-primary"
        },
        cancel: {
            selector: "button.btn-default"
        }
    },

    loadingModal: {
        selector: ".loading-box",
        message: {
            selector: ".loading-body"
        },
        // these are grandfathered in
        no: {
            selector: "[value^=No]"
        },
        yes: {
            selector: "[value^=Yes]"
        },
        ok: {
            selector: "[value^=Ok]"
        },
        cancel: {
            selector: "[value^=Cancel]"
        },
        button: function button($el, prefix) {
            return {
                selector: "[value^=\"" + prefix + "\"]"
            };
        }
    },

    globalModal: _extends({}, modalSkeleton),

    gxepModal: _extends({}, modalSkeleton, {
        save: {
            selector: ".btn-save"
        },
        cancel: {
            selector: ".btn-cancel"
        }
    }),

    preferencesDialog: _extends({}, modalSkeleton),

    printDialog: {
        selector: "#modal .modal-content",
        printButton: {
            selector: ".modal-footer .btn-primary"
        },
        cancelButton: {
            selector: ".modal-footer .btn-secondary"
        },
        form: {
            selector: "form",
            control: controlSelect
        }
    },

    gxepDialog: {
        selector: "#modal .modal-content",
        saveButton: {
            selector: ".btn-save"
        },
        cancelButton: {
            selector: ".btn-cancel"
        }
    },

    mappingDialog: _extends({}, modalSkeleton, {
        search: _extends({}, searchBlockBuilder(), {
            source: {
                selector: ".control-container-source-type"
            }
        }),
        drawerPull: {
            selector: ".btn-drawer-pull"
        },
        actionBar: {
            selector: ".mapping-action-bar",
            import: {
                selector: ".btn-import"
            },
            cancel: {
                selector: ".btn-cancel"
            }
        },
        openRecord: {
            selector: ".drawer-content",
            targetLabel: {
                selector: ".mapping-header div.col-md-12"
            },
            includeFields: {
                selector: ".include-fields"
            },
            excludeFields: {
                selector: ".exclude-fields"
            },
            showMissingFields: {
                selector: ".show-fields"
            },
            hideMissingFields: {
                selector: ".hide-fields"
            },
            results: {
                selector: ".mapping-grid",
                fields: {
                    selector: "[data-shortname]",
                    checked: {
                        selector: "label .checked"
                    }
                },
                field: function field($el, key) {
                    var block = {
                        selector: "[data-shortname='" + key + "']",
                        label: {
                            selector: ".target-entity-heading label"
                        },
                        newValue: {
                            selector: ".new-value"
                        },
                        oldValue: {
                            selector: ".old-value"
                        },

                        toggleState: {
                            selector: ".toggle-state"
                        }
                    };

                    return block;
                }
            }
        }
    }),

    mergeDialog: {
        // this will be augmented with .mappingDialog, except .actionBar
        openRecord: {
            // this will be augmented with .mappingDialog.openRecord
            merge: {
                selector: ".btn-merge"
            },
            cancelMerge: {
                selector: ".btn-cancel"
            }
        }
    },

    recordBrowser: _extends({}, modalSkeleton, {
        selector: "#modal .record-browser .modal-content"
    }),

    hex: {
        selector: "#content_hex",
        drawerPull: {
            selector: ".btn-drawer-pull"
        },
        search: {
            selector: ".drawer-body",
            exportType: {
                selector: ".export-type-select"
            },
            paramSets: {
                selector: ".param-sets",
                select: {
                    selector: ".param-set-select"
                },
                rename: {
                    selector: ".param-set-rename"
                },
                delete: {
                    selector: ".param-set-delete"
                }
            },
            dataOwners: {
                selector: ".data-owner-select"
            },
            armusXmlExport: {
                selector: ".generic-xml-export",
                stereotype: {
                    selector: ".form-section-header .control-container-stereotype"
                },
                control: searchFormControl
            },
            exportButton: {
                selector: ".btn-do-export button:first-child"
            },
            exportDropdown: {
                selector: ".btn-do-export button:last-child"
            }
        },
        header: {
            selector: ".search-results thead tr",
            fields: {
                selector: "th"
            }
        },
        results: {
            selector: ".search-results tbody tr",
            fields: {
                selector: "td"
            }
        }
    },

    dqr: {
        selector: "#content_dqr",
        drawerPull: {
            selector: ".btn-drawer-pull"
        },
        search: searchBlockBuilder(),

        header: {
            selector: ".search-results thead tr",
            fields: {
                selector: "th"
            }
        },
        results: {
            selector: ".search-results tbody tr",
            fields: {
                selector: "td"
            }
        }
    },

    fieldsetAdmin: {
        selector: "#two-pane-multi-select",
        unselected: fieldAdminPaneBuilder("#unselected-list"),
        selected: fieldAdminPaneBuilder("#selected-list"),
        save: {
            selector: ".btn-save"
        }
    }
};

augment(elements.recordBrowser, elements.dataEntry);
augment(elements.globalModal, elements.dataEntry);
augment(elements.mergeDialog, elements.mappingDialog);
delete elements.mergeDialog.actionBar;
augment(elements.mergeDialog.openRecord, elements.mappingDialog.openRecord);

var isReactElement = function isReactElement(el) {
    return (
        // tests if an element is controlled by react fiber.
        // this is pretty hacky but works our case.
        Object.keys(el).filter(function (it) {
            return it.indexOf("__react") !== -1;
        }).length > 0
    );
};

var getVisibleInput = function getVisibleInput($el) {
    var item = $el.find(":input:visible");
    if (item.length === 0) {
        throw new Error("Failed to find a :input w/in control (" + $el.selector + "); AppDriver needs augmentation");
    }
    return item;
};

var performClick = function performClick($el) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "click";

    if ($el.is(":disabled")) {
        throw new Error($el.selector + " is disabled");
    }
    var activeElement = document.activeElement;

    // first comes mouse down
    var downEvent = document.createEvent("MouseEvents");
    downEvent.initEvent("mousedown", true, true);
    $el.get(0).dispatchEvent(downEvent);

    // then blur
    $(activeElement).blur();

    // then click
    var clickEvent = document.createEvent("MouseEvents");
    clickEvent.initEvent(type, true, true);
    $el.get(0).dispatchEvent(clickEvent);

    // finally mouse up
    var upEvent = document.createEvent("MouseEvents");
    upEvent.initEvent("mouseup", true, true);
    $el.get(0).dispatchEvent(upEvent);
};

var performChange = function performChange($el, value) {
    // .change() is not enough to trigger react lifecycle change
    var $elem = $el.first();
    if (!$el.is("input, select, textarea, button")) {
        $elem = $el.find("input, select, textarea, button").first();
    }
    if (isReactElement($elem.get(0))) {
        // react element
        ReactTestUtils.Simulate.focus($elem.get(0));
        ReactTestUtils.Simulate.change($elem.get(0), { target: { value: value, checked: !!value } });
        ReactTestUtils.Simulate.blur($elem.get(0)); // triggers onCommitChange
    } else {
        // vanilla element
        $elem.focus();
        $elem.val(value); // set the controls input value.
        $elem.change();
        $elem.blur();
    }
};

// don't make up your own names. please. use these:
// https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
var KEY_MAP = {
    Backspace: 8,
    Tab: 9,
    Enter: 13,
    " ": 32,
    Escape: 27,
    End: 35,
    Home: 36,
    ArrowDown: 40
};
var KEY_ALIAS_MAP = {
    Space: " ",
    Spacebar: " "
};
var MODIFIER_MAP = {
    Shift: "shiftKey"
};
var _iteratorNormalCompletion3 = true;
var _didIteratorError3 = false;
var _iteratorError3 = undefined;

try {
    for (var _iterator3 = Object.keys(KEY_ALIAS_MAP)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var a = _step3.value;

        if (!KEY_MAP.hasOwnProperty(KEY_ALIAS_MAP[a])) {
            throw new Error("AppDriver has bad key config: alias '" + KEY_ALIAS_MAP[a] + "' doesn't reference a known key");
        }
    }
} catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
} finally {
    try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
        }
    } finally {
        if (_didIteratorError3) {
            throw _iteratorError3;
        }
    }
}

var doKeyEvent = function doKeyEvent(type, key) {
    var $el = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document.activeElement;

    var init = {
        cancelable: true,
        bubbles: true
    };
    if (key.indexOf("-") > 0) {
        // there are modifiers
        var parts = key.split("-");
        key = parts.pop();
        parts.forEach(function (it) {
            if (MODIFIER_MAP.hasOwnProperty(it)) {
                init[MODIFIER_MAP[it]] = true;
            } else {
                throw new Error("Unrecognized '" + it + "' modifier; augment AppDriver?");
            }
        });
    }
    var code = function () {
        if (KEY_ALIAS_MAP.hasOwnProperty(key)) {
            key = KEY_ALIAS_MAP[key];
        }
        if (KEY_MAP.hasOwnProperty(key)) {
            return KEY_MAP[key];
        } else if (key.length === 1) {
            return key.charCodeAt(0);
        } else {
            throw new Error("Unrecognized '" + key + "' key value; augment AppDriver?");
        }
    }();
    var simulateMethod = void 0;
    if (type === "keydown") {
        simulateMethod = "keyDown";
    } else if (type === "keyup") {
        simulateMethod = "keyUp";
    } else if (type === "keypress") {
        simulateMethod = "keyPress";
    } else {
        console.warn("non-react-simulatable '" + type + "' event; augment AppDriver?");
    }
    ReactTestUtils.Simulate[simulateMethod]($el, _extends({}, init, {
        key: key,
        keyCode: code
    }));
};

var assertSingle = function assertSingle($el) {
    if ($el.length !== 1) {
        console.error("Expected a single element; got", $el);
        throw new Error("Expected a single element; got " + $el.length + ". The matched elements are available in the console.");
    }
};

var itemsFromDropdown = function itemsFromDropdown(itemSelector, options) {
    options = _extends({
        $trigger: null, // if present, click it to open the dropdown
        closeAfter: true, // if true, close the dropdown after extracting items
        section: null }, options);
    if (options.$trigger) {
        performClick(
        // make sure to click the correct element.
        options.$trigger.hasClass("dropdown-toggle") ? options.$trigger : options.$trigger.find(".dropdown-toggle"));
    }
    // pre-condition: the dropdown is open in the portal
    var $ddWrapper = $("body .dropdown-wrapper");
    var $optWrapper = $ddWrapper;
    if (options.section) {
        var $sec = $ddWrapper.find("li.section[data-section]").filter(function () {
            return $(this).text() === options.section;
        });
        if ($sec.length > 1) assertSingle($sec);
        var key = $sec.data("section");
        $optWrapper = $ddWrapper.find("li[data-section='" + key + "']");
    }
    var items = $optWrapper.find(itemSelector);
    if (options.closeAfter) {
        // Send 'esc' key to close the dropdown
        doKeyEvent("keydown", "Escape", $ddWrapper.get(0));
    }
    return items;
};

function entityCoords($el) {
    assertSingle($el);
    var data = ($el.hasClass("entity-context") ? $el : $el.parents(".entity-context"))[0].dataset;
    var ek = data.entityKey;
    var id = data.id;
    if (!ek || !id) {
        throw new Error($el.selector + " is not within a entity context");
    }
    return [ek, id];
}

var actions = {
    click: function click($el) {
        assertSingle($el);
        switch ($el.get(0).dataset.controlType) {
            case "button":
            case "valuemutationbutton":
                $el = $el.find("button");
                break;
            case "checkbox":
                $el = getVisibleInput($el);
                break;

            case "mappingrow":
                $el = $el.find(".toggle-state");
                break;
            default:
            // just leave it alone
        }

        performClick($el);
    },
    doubleClick: function doubleClick($el) {
        assertSingle($el);
        performClick($el, "dblclick");
    },
    focus: function focus($el) {
        assertSingle($el);
        // todo: it seems that we should only allow focusing enabled stuff?
        if ($el.is(".control")) {
            var $elem = $el.find("input, select, textarea, button").first();
            $elem.focus();
            ReactTestUtils.Simulate.focus($elem.get(0));
        } else if ($el.is("a[href], a[tabindex], :input") && $el.is(":visible") && !$el.is(":disabled")) {
            $el.focus();
        } else {
            throw new Error($el.selector + " can't be focused; augment AppDriver?");
        }
    },
    type: function type($el, text) {
        assertSingle($el);
        switch ($el.get(0).dataset.controlType) {
            case "calendar":
            case "spinner":
                performChange($el.find("input"), text);
                break;
            case "text":
            case "calendar_masked":
                performChange($el, text);
                break;
            case "typeahead":
                var $input = $el.find("input.form-control");
                performChange($input, text); // open dropdown and set filter
                break;
            default:
                throw new Error($el.selector + " can't be typed into. (type " + $el.get(0).dataset.controlType + ")");
        }
    },
    press: function press($el, key) {
        assertSingle($el);
        actions.focus($el);
        doKeyEvent("keydown", key);
    },
    scrollTo: function scrollTo($el, top, left) {
        assertSingle($el);
        $el[0].scrollTop = top;
        $el[0].scrollLeft = left;
    },
    clear: function clear($el) {
        assertSingle($el);
        switch ($el.get(0).dataset.controlType) {
            case "calendar":
            case "spinner":
                performChange($el, undefined);
                break;
            case "text":
            case "calendar_masked":
                performChange($el, undefined);
                break;
            case "typeahead":
                performClick($el.find(".item-selection-close, .clear-value"));
                break;
            default:
                throw new Error($el.selector + " can't be cleared. (type " + $el.get(0).dataset.controlType + ")");
        }
    },
    clearConsole: function clearConsole(ignored) {
        console.clear();
    },
    uploadFile: function uploadFile($el, filename) {
        assertSingle($el);
        actions.uploadFileWithContent($el, filename, "Hello! This is a dummy file created by AppDriver!");
    },
    uploadFileWithContent: function uploadFileWithContent($el, filename, content) {
        assertSingle($el);
        switch ($el.get(0).dataset.controlType) {
            case "manager":
                var $elem = $el.find("input").first();
                ReactTestUtils.Simulate.focus($elem.get(0));
                var files = [new File([content], filename, {
                    type: "text/plain",
                    lastModified: new Date().getTime()
                })];
                ReactTestUtils.Simulate.change($elem.get(0), {
                    target: {
                        files: files
                    }
                });
                $elem.change();
                break;
            default:
                throw new Error($el.selector + " can't upload files. (type " + $el.get(0).dataset.controlType + ")");
        }
    },
    violateOptlock: function violateOptlock($el, username) {
        var _entityCoords = entityCoords($el),
            _entityCoords2 = _slicedToArray(_entityCoords, 2),
            ek = _entityCoords2[0],
            id = _entityCoords2[1];

        var tk = _entityMetaStore2.default.getInfo(ek).tableKey;
        _lockClient2.default.updateRecordOnServer(tk, id, username);
    },
    openInNewClient: function openInNewClient($el, username) {
        var _entityCoords3 = entityCoords($el),
            _entityCoords4 = _slicedToArray(_entityCoords3, 2),
            ek = _entityCoords4[0],
            id = _entityCoords4[1];

        var tk = _entityMetaStore2.default.getInfo(ek).tableKey;
        _lockClient2.default.openRecordInNewClient(tk, id, username);
    },
    closeOtherClient: function closeOtherClient($el, username) {
        var _entityCoords5 = entityCoords($el),
            _entityCoords6 = _slicedToArray(_entityCoords5, 2),
            ek = _entityCoords6[0],
            id = _entityCoords6[1];

        var tk = _entityMetaStore2.default.getInfo(ek).tableKey;
        _lockClient2.default.closeRecordInOtherClient(tk, id, username);
    },


    // implemented in the interpreter, but declared here for validation
    pause: function pause(ignored) {
        throw new Error("Native Implementation");
    },
    exit: function exit(ignored, message) {
        throw new Error("Native Implementation");
    },
    close: function close(ignored) {
        throw new Error("Native Implementation");
    }
};

function workOnSelectElement($el, text) {
    var $opt = $el.find("option").filter(function () {
        return $(this).text() === text;
    });
    assertSingle($opt);
    performChange($el, $opt.val());
}

actions.select = function ($el, optionalSection, text) {
    if (arguments.length === 2) {
        text = optionalSection;
        optionalSection = null;
    }
    assertSingle($el);
    switch ($el.get(0).dataset.controlType) {
        case "bootstrap-dropdown":
            var item = itemsFromDropdown("a", {
                $trigger: $el,
                closeAfter: false,
                section: optionalSection
            }).filter(function () {
                return $(this).text().trim() === text;
            });
            assertSingle(item);
            performClick(item);
            break;

        case "typeahead":
            if (optionalSection) {
                throw new Error("Typeaheads don't have sections");
            }
            var $input = $el.find("input.form-control");
            $input.focus();
            if (typeof text === "string") {
                // the normal case
                performChange($input, text); // open dropdown and set filter
            } else {
                doKeyEvent("keydown", "ArrowDown", $input.get(0)); // open the dropdown
                for (var i = parseInt(text); i > 1; i--) {
                    doKeyEvent("keydown", "ArrowDown", $("body .dropdown-wrapper").get(0));
                }
            }
            // fake enter key
            doKeyEvent("keydown", "Enter", $("body .dropdown-wrapper").get(0));
            // close the dropdown menu
            doKeyEvent("keydown", "Escape", $("body .dropdown-wrapper").get(0));
            break;

        case "dropdown":
        case "recordbrowser":
            if (optionalSection) {
                throw new Error("Dropdowns/record browsers don't have sections");
            }
            $el = $el.find("select");
            workOnSelectElement($el, text);
            break;
        default:
            if ($el.get(0).nodeName === "SELECT") {
                workOnSelectElement($el, text);
            } else {
                throw new Error("non-selectable element " + $el.selector);
            }
    }
};
actions.select.meta = {
    optionalArgCount: 1
};

var hasClass = function hasClass($el, className) {
    return !!$el.hasClass(className);
};

var inspections = {
    text: function text($el) {
        assertSingle($el);
        return $el.text();
    },
    placeholder: function placeholder($el) {
        assertSingle($el);
        return $el.find("input").attr("placeholder");
    },
    active: function active($el) {
        if ($el.length === 1) {
            return hasClass($el, "active");
        }
        // looking for an index in the nodelist...
        var idxs = [];
        for (var i = 0; i < $el.length; i++) {
            if (hasClass($($el.get(i)), "active")) {
                idxs.push(i);
            }
        }
        if (idxs.length === 0) {
            return 0;
        } else if (idxs.length === 1) {
            return idxs[0] + 1;
        } else {
            throw new Error("Multiple active items were found.");
        }
    },
    value: function value($el) {
        assertSingle($el);
        var v = null;
        var item = null;
        switch ($el.get(0).dataset.controlType) {
            case "bootstrap-dropdown":
                v = $el.find(".dropdown-toggle .pull-left").text();
                break;
            case "typeahead":
                v = $el.find(".item-selection,.single-item-selection").clone().children().remove().end().map(function () {
                    return $(this).text();
                }).get().join(",");

                return v;
            case "choice":
            case "dropdown":
            case "recordbrowser":
                item = getVisibleInput($el);
                v = item.find("option:selected").text();
                break;
            case "text":
            case "calendar":
            case "spinner":
                item = getVisibleInput($el);
                v = item.val();
                break;
            case "label":
                if ($el.is(".file-field")) {
                    v = $el.find(".file-link").map(function () {
                        return $(this).text();
                    }).get().join(",");
                } else {
                    v = $el.text();
                }
                break;
            case "validationindicator":
                v = $el.get(0).dataset.controlValue;
                break;
            case "validationfilter":
                v = $el.is(".checked");
                break;
            case "mappingrow":
                v = $el.find(".toggle-state").is(".checked");
                break;
            case "checkbox":
                item = getVisibleInput($el);
                v = item.is(":checked");
                break;
            default:
                throw new Error("non-valued element " + $el.selector);
        }

        return v;
    },
    rawValue: function rawValue($el) {
        assertSingle($el);
        if ($el.is(":input")) {
            return $el.val();
        }

        if ($el.is(".control")) {
            return $el.find("input, select, textarea, button").first().val();
        }

        throw new Error("non-valued element " + $el.selector);
    },
    focused: function focused($el) {
        assertSingle($el);
        if ($el.is(".control")) {
            var item = getVisibleInput($el);
            return item.is(":focus") || item.get(0) === document.activeElement;
        }

        return $el[0] === document.activeElement;
    },
    enabled: function enabled($el) {
        assertSingle($el);
        if ($el.is(".control")) {
            /*
             * This used to switch on type and do different stuff, but now that
             * jsclient itself relies on a zero-arg invocation of "enabled"
             * acting as a getter, AppDriver should follow suit.
             */
            return $el.find("input, select, textarea, button").first().is(":enabled");
        } else {
            return $el.is(":enabled");
        }
    },
    disabled: function disabled($el) {
        console.log("the 'disabled' inspection is deprecated. use 'enabled' w/ `false`.");
        return !inspections.enabled($el);
    },
    visible: function visible($el) {
        assertSingle($el);
        // this may or may not be clever, but it appears to work pretty well,
        // and is certainly more representative than what jQuery does.
        function isInView(el) {
            function isDescendant(n) {
                do {
                    if (n === el) {
                        return true;
                    }
                    n = n.parentElement;
                } while (n != null);
                return false;
            }
            // getBoundingClientRect is a draft, but widely supported...
            var r = el.getBoundingClientRect();
            var x = r.left + r.width / 2;
            var y = r.top + r.height / 2;
            if (x < 0 || x > window.innerWidth) {
                return false;
            }
            if (y < 0 || y > window.innerHeight) {
                return false;
            }
            var itUi = document.getElementById("IT-UI");
            itUi && (itUi.style.display = "none");
            try {
                // elementFromPoint is experimental, but widely supported...
                return isDescendant(document.elementFromPoint(x, y));
            } finally {
                itUi && (itUi.style.display = "block");
            }
        }

        var visible = $el.is(":visible");
        if ($el.is(".dropdown-helper-placeholder")) {
            // DropdownHelper left this node for targeting, but it's a cheat.
            // However, DropdownHelper's entire purpose is to ensure that helped
            // dropdowns are the only element available for interaction. Which
            // is even stronger than "visible", so just trust it. Unit tests
            // will bomb out if it's doing stuff wrong.
            return visible;
        }
        return visible && isInView($el[0]);
    },
    isPartial: function isPartial($el) {
        assertSingle($el);
        switch ($el.get(0).dataset.controlType) {
            case "typeahead":
                {
                    return $el.find(".typeahead").get(0).dataset.partial === "true";
                }
            default:
                return $el.get(0).dataset.partial === "true";
        }
    },
    isLoading: function isLoading($el) {
        assertSingle($el);
        switch ($el.get(0).dataset.controlType) {
            case "typeahead":
                {
                    return $el.find(".typeahead").get(0).dataset.loading === "true";
                }
            default:
                return $el.get(0).dataset.loading === "true";
        }
    },
    isOpen: function isOpen($el) {
        assertSingle($el);
        return hasClass($el, "open");
    },
    isRequired: function isRequired($el) {
        assertSingle($el);
        return hasClass($el, "required");
    },
    isIllegal: function isIllegal($el) {
        assertSingle($el);
        return hasClass($el, "illegal");
    },
    count: function count($el) {
        switch ($el.get(0).dataset.controlType) {
            case "typeahead":
                {
                    return parseInt($el.find(".typeahead").get(0).dataset.count, 10);
                }
            default:
                return $el.length;
        }
    },
    scrollTop: function scrollTop($el) {
        assertSingle($el);
        return $el[0].scrollTop;
    },
    scrollLeft: function scrollLeft($el) {
        assertSingle($el);
        return $el[0].scrollLeft;
    },
    checked: function checked($el) {
        assertSingle($el);
        return hasClass($el, "checked");
    },


    // implemented in the interpreter, but declared here for validation
    exists: function exists(ignored) {
        throw new Error("Native Implementation");
    }
};

// Whether the element has the named option
inspections.hasOption = function ($el, optionalSection, option) {
    if (arguments.length === 2) {
        option = optionalSection;
        optionalSection = null;
    }
    assertSingle($el);
    var options = null;
    var fromPortal = function fromPortal(itemSelector, options) {
        return itemsFromDropdown(itemSelector, options).map(function () {
            return $(this).text().trim();
        }).toArray();
    };
    switch ($el.get(0).dataset.controlType) {
        case "bootstrap-dropdown":
            {
                options = fromPortal("a", {
                    $trigger: $el,
                    section: optionalSection
                });
                break;
            }
        case "typeahead":
            {
                if (optionalSection) {
                    throw new Error("Typeaheads don't have sections");
                }
                var $input = $el.find("input.form-control");
                $input.focus();
                doKeyEvent("keydown", "ArrowDown", $input.get(0));
                options = fromPortal(".typeahead-dropdown tr td");
                break;
            }
        case "recordbrowser":
        case "dropdown":
            if (optionalSection) {
                throw new Error("Record browsers don't have sections");
            }
            options = $el.find("select option").map(function () {
                return $(this).text();
            }).toArray();
            break;
        default:
            console.warn("non-choice element " + $el.selector + " can NEVER have options?");
            return false;
    }
    options = options.filter(function (it) {
        return it === option;
    });
    if (options.length > 1) {
        throw new Error("Multiple '" + option + "' options present?!");
    }
    return options.length === 1;
};
inspections.hasOption.meta = {
    optionalArgCount: 1
};

exports.default = {
    actions: actions,
    inspections: inspections,
    elements: elements
};

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(99);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"panel panel-"
    + alias4(((helper = (helper = lookupProperty(helpers,"type") || (depth0 != null ? lookupProperty(depth0,"type") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"type","hash":{},"data":data,"loc":{"start":{"line":1,"column":24},"end":{"line":1,"column":32}}}) : helper)))
    + " IT-window\" role=\"dialog\" style=\"top:"
    + alias4(((helper = (helper = lookupProperty(helpers,"top") || (depth0 != null ? lookupProperty(depth0,"top") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"top","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":76}}}) : helper)))
    + "%;left:"
    + alias4(((helper = (helper = lookupProperty(helpers,"left") || (depth0 != null ? lookupProperty(depth0,"left") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"left","hash":{},"data":data,"loc":{"start":{"line":1,"column":83},"end":{"line":1,"column":91}}}) : helper)))
    + "%\">\n    <button type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n    <div class=\"panel-heading\">\n        <h3 class=\"panel-title\">"
    + alias4(((helper = (helper = lookupProperty(helpers,"title") || (depth0 != null ? lookupProperty(depth0,"title") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"title","hash":{},"data":data,"loc":{"start":{"line":4,"column":32},"end":{"line":4,"column":41}}}) : helper)))
    + "</h3>\n    </div>\n    <div class=\"panel-body\">"
    + alias4(((helper = (helper = lookupProperty(helpers,"body") || (depth0 != null ? lookupProperty(depth0,"body") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"body","hash":{},"data":data,"loc":{"start":{"line":6,"column":28},"end":{"line":6,"column":36}}}) : helper)))
    + "</div>\n</div>\n";
},"useData":true});

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(99);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<p>Errors:</p>\n<ul></ul>\n";
},"useData":true});

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(1601);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ITState = function (_Backbone$Model) {
    _inherits(ITState, _Backbone$Model);

    function ITState() {
        _classCallCheck(this, ITState);

        return _possibleConstructorReturn(this, (ITState.__proto__ || Object.getPrototypeOf(ITState)).apply(this, arguments));
    }

    return ITState;
}(Backbone.Model);

ITState.prototype.defaults = {
    spec: "",
    manifestSpec: "",
    autoInitialize: true,
    autoPlay: true,
    tickDelay: 0,
    scriptView: "lines",
    scriptState: "pending",
    chromeType: "primary",
    showTargets: false,
    // previously anonymous attributes
    scriptMode: null,
    script: null,
    interpreter: null
};

exports.default = ITState;

/***/ }),
/* 1601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * decaffeinate suggestions:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DS102: Remove unnecessary code created because of implicit returns
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DS103: Rewrite code to no longer use __guard__
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DS202: Simplify dynamic range loops
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DS203: Remove `|| {}` from converted for-own loops
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DS205: Consider reworking code to avoid use of IIFEs
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * DS207: Consider shorter variations of null checks
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
/*
    I interpret a test script to execute it against an ITDriver instance,
    instead of actually coding the driver interactions.  The language is
    designed to be highly human readable and minimize unneeded syntactic
    constructs (especially punctuation).  It took inspiration from the simple
    line-oriented format of Selenese (from Selenium IDE), the 'with' construct
    in ECMAScript, and semantic white-space of Python/CoffeeScript/etc.  That
    said, both 'with' and semantic whitespace are completely optional and only
    provide a means of reducing duplication between instructions, no additional
    functionality.

    The implementation uses a PEG grammar, which is compiled by PEG.js into a
    JavaScript parser implementation.  The resulting parse tree is then further
    analyzed, and if all is well, loaded into the application initialization
    framework and interpreted when it's ready.

    Events are triggered (using Backbone.Events) for all script errors,
    failures and command executions.  Error events are dispatched in an 'error'
    namespace with 'indent', 'syntax', or 'assert' or the offending command
    name as the local name.  All commands, actions, and inspections dispatch
    two with their name as the namespace and 'start' and 'done' as the local
    names.  While 'fail' conceptually does this, execution always terminates
    before it's 'done' event can trigger.

    With the exception of 'parse', 'parsed', 'validate', 'validated', 'start',
    'play', 'pause', 'close', and 'success', all events are passed the same
    three args: atom, payload, and a millisecond timestamp.  The specific
    payload varies between command types, with all error events receiving a
    string message. The first four exceptions listed above are passed a two
    arguments: an array of errors that have been identified and a timestamp. The
    'start' event is also passed two arguments: the promise returned by the
    invocation of the start method and a timestamp.  The 'play', 'pause',
    'close', and 'success' events are passed only a timestamp.

    By defaults, errors are NOT thrown by the methods, only events are
    dispatched.  The constructor's 'options' object supports a 'throwOnError'
    option which can be set to true to change this behaviour.  All errors are
    also aggregated in an 'errors' array on the object itself.
*/

var _IT = __webpack_require__(1603);

var _IT2 = _interopRequireDefault(_IT);

var _wait = __webpack_require__(666);

var _wait2 = _interopRequireDefault(_wait);

var _utils = __webpack_require__(365);

var _utils2 = _interopRequireDefault(_utils);

var _assert_moar = __webpack_require__(1604);

var _assert_moar2 = _interopRequireDefault(_assert_moar);

var _HybridConfig = __webpack_require__(41);

var _HybridConfig2 = _interopRequireDefault(_HybridConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var toIt = function toIt(it) {
    var ts = void 0;
    if (it == null) {
        return it;
    }
    switch (ts = Object.prototype.toString.call(it)) {
        case "[object Array]":
            return it.map(function (o) {
                return o.it;
            });
        case "[object Object]":
            return it.it;
        default:
            throw new Error("toIt doesn't support " + ts);
    }
};

var Interpreter = function () {
    function Interpreter(appDriver, script, options) {
        _classCallCheck(this, Interpreter);

        this.parse = this.parse.bind(this);
        this._error = this._error.bind(this);
        this.now = this.now.bind(this);
        this._event = this._event.bind(this);
        this.validate = this.validate.bind(this);
        this.getScenario = this.getScenario.bind(this);
        this.getMockset = this.getMockset.bind(this);
        this.getUser = this.getUser.bind(this);
        this.getConfig = this.getConfig.bind(this);
        this.getPreferences = this.getPreferences.bind(this);
        this.start = this.start.bind(this);
        this.pause = this.pause.bind(this);
        this.close = this.close.bind(this);
        this.play = this.play.bind(this);
        this._closeWiths = this._closeWiths.bind(this);
        this._next = this._next.bind(this);
        this.step = this.step.bind(this);
        this.appDriver = appDriver;
        this.script = script;
        this.options = _utils2.default.extend({
            throwOnError: false,
            tickDelay: 0
        }, options);
        this._start = new Date().valueOf();
        this.playing = false;
        this.errors = [];
    }

    _createClass(Interpreter, [{
        key: "parse",
        value: function parse() {
            if (this.parsed) {
                return;
            }
            this.trigger("parse", this.errors, this.now());
            try {
                this.commands = _IT2.default.parse(this.script);
            } catch (e) {
                if (e instanceof _IT2.default.SyntaxError) {
                    this._error(e, {
                        offset: e.offset,
                        line: e.line,
                        column: e.column,
                        len: e.found.length
                    });
                    this.commands = [];
                } else {
                    throw e;
                }
            }
            // check indentation
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.commands[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var c = _step.value;

                    if (c.indent.it.indexOf("\t") >= 0) {
                        this._error("indent", c.indent, "Test scripts cannot use tabs for indentation, only spaces");
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.parsed = true;
            this.trigger("parsed", this.errors, this.now());
            return this;
        }
    }, {
        key: "_error",
        value: function _error(errorOrType, atom, message) {
            var error = void 0;
            var type = "error:unknown";
            if (errorOrType instanceof _IT2.default.SyntaxError) {
                type = "error:syntax";
                error = errorOrType;
            } else {
                if (errorOrType instanceof _assert_moar2.default.AssertionError) {
                    type = "error:assert";
                    error = errorOrType;
                } else if (errorOrType instanceof Error) {
                    error = errorOrType;
                } else {
                    type = "error:" + errorOrType;
                    error = new Error(message != null ? message : "unknown error");
                }
                error.line = atom.line;
                error.column = atom.column;
            }
            this.errors.push(error);
            this._event(type, atom, error.message != null ? error.message : message);
            if (this.options.throwOnError) {
                throw error;
            } else {
                return console.error(error.message, error);
            }
        }
    }, {
        key: "now",
        value: function now() {
            return new Date().valueOf() - this._start;
        }
    }, {
        key: "_event",
        value: function _event(type, atom, payload) {
            return this.trigger(type, atom, payload, this.now());
        }
    }, {
        key: "validate",
        value: function validate() {
            var _this = this;

            var d = void 0;
            if (this.validated) {
                return;
            }
            this.parse();
            this.trigger("validate", this.errors, this.now());
            // check the individual commands
            var blockDepths = [0];
            var directivesComplete = false;
            this.config = {};
            this.prefs = {};
            var counts = {
                mockset: 0,
                user: 0
            };
            for (var i = 0; i < this.commands.length; i++) {
                var curr = this.commands[i];
                counts[curr.cmd.it] += 1;
                var prev = i > 0 ? this.commands[i - 1] : null;
                var next = i < this.commands.length ? this.commands[i + 1] : null;
                if (prev != null) {
                    if (curr.depth > prev.depth) {
                        if (prev.cmd.it !== "with") {
                            this._error("indent", curr, "unexpected indent; only 'with' commands introduce new indentation for their nested commands.");
                        }
                    }
                    if (curr.depth < prev.depth) {
                        if (blockDepths.indexOf(curr.depth) < 0) {
                            this._error("indent", curr, "unexpected outdent.");
                        }
                    }
                }
                if (curr.d) {
                    if (directivesComplete) {
                        this._error("", curr, "Directives (like '" + curr.cmd.it + "' on " + curr.line + ") must precede all commands");
                    }
                } else if (!directivesComplete) {
                    directivesComplete = true;
                }
                switch (curr.cmd.it) {
                    case "scenario":
                        if (curr.line !== 1) {
                            this._error("scenario", curr, "scenario is only allowed on the first line");
                        }
                        break;
                    case "mockset":case "user":
                        if (counts[curr.cmd.it] > 1) {
                            this._error("", curr, "Only one '" + curr.cmd.it + "' directive is allowed per script'");
                        }
                        if (curr.val == null) {
                            this._error("", curr, curr.cmd.it + " requires one parameter");
                        } else if (curr.val.it.indexOf(" ") >= 0) {
                            this._error("", curr, curr.cmd.it + " does not accept multiple parameters");
                        }
                        break;
                    case "config":
                        if (this.config.hasOwnProperty(curr.key.text)) {
                            this._error("", curr, "Duplicate config '" + curr.key.text + "' found'");
                        }
                        this.config[curr.key.text] = curr.val.it;
                        break;
                    case "preference":
                        {
                            if (this.prefs.hasOwnProperty(curr.key.text)) {
                                this._error("", curr, "Duplicate preference '" + curr.key.text + "' found'");
                            }
                            var idx = curr.key.text.indexOf(".");
                            if (idx < 0 || idx !== curr.key.text.lastIndexOf(".")) {
                                this._error("", curr, "Preferences are set via a dot-separated 'impl-name.pref-name' pair.");
                            }
                            this.prefs[curr.key.text] = curr.val.it;
                            break;
                        }
                    case "with":
                        {
                            var _ret = function () {
                                if (next == null || next.depth <= curr.depth) {
                                    _this._error("with", curr, "'with' block has no nested commands");
                                }
                                var bi = next.depth;
                                // eslint-disable-next-line no-loop-func
                                blockDepths = function () {
                                    var result = [];
                                    var _iteratorNormalCompletion2 = true;
                                    var _didIteratorError2 = false;
                                    var _iteratorError2 = undefined;

                                    try {
                                        for (var _iterator2 = blockDepths[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                            d = _step2.value;
                                            if (d < bi) {
                                                result.push(d);
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError2 = true;
                                        _iteratorError2 = err;
                                    } finally {
                                        try {
                                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                                _iterator2.return();
                                            }
                                        } finally {
                                            if (_didIteratorError2) {
                                                throw _iteratorError2;
                                            }
                                        }
                                    }

                                    return result;
                                }();
                                blockDepths.push(bi);
                                return "break";
                            }();

                            if (_ret === "break") break;
                        }
                    case "wait":
                        if (curr.val != null && !["sync", "ajax", "over", "viewstack"].includes(curr.val.it)) {
                            this._error("wait", curr.val, "'wait' command with an illegal type (" + curr.val.it + ")");
                        }
                        break;
                    case "fail":
                        // no validation, just need to cover it so it's not treated as an action/inspection
                        break;
                    default:
                        {
                            var _ret2 = function () {
                                if (curr.cmd.it === "exists") {
                                    // this one is special
                                    if (curr.chain == null) {
                                        _this._error(curr.cmd.it, curr.cmd, "The 'exists' assertion must have a local selector chain");
                                    }
                                }
                                var isAssert = curr.hasOwnProperty("assert");
                                var type = isAssert ? "inspections" : "actions";
                                var otherType = isAssert ? "actions" : "inspections";
                                if (!_this.appDriver[type].hasOwnProperty(curr.cmd.it)) {
                                    var msg = "unrecognized '" + curr.cmd.it + "' " + (isAssert ? "inspection" : "action");
                                    if (_this.appDriver[otherType].hasOwnProperty(curr.cmd.it)) {
                                        msg += ", did you want the '" + curr.cmd.it + "' " + (isAssert ? "action" : "inspection") + "?";
                                    }
                                    msg += " (available " + type + ": " + function () {
                                        var result1 = [];
                                        var _iteratorNormalCompletion3 = true;
                                        var _didIteratorError3 = false;
                                        var _iteratorError3 = undefined;

                                        try {
                                            for (var _iterator3 = Object.keys(_this.appDriver[type] || {})[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                                var n = _step3.value;

                                                result1.push(n);
                                            }
                                        } catch (err) {
                                            _didIteratorError3 = true;
                                            _iteratorError3 = err;
                                        } finally {
                                            try {
                                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                                    _iterator3.return();
                                                }
                                            } finally {
                                                if (_didIteratorError3) {
                                                    throw _iteratorError3;
                                                }
                                            }
                                        }

                                        return result1;
                                    }().join(", ") + ")";
                                    _this._error(curr.cmd.it, curr.cmd, msg);
                                    return "continue";
                                }
                                var argCount = (curr.args != null ? curr.args.length : undefined) != null ? curr.args != null ? curr.args.length : undefined : 0;
                                var func = _this.appDriver[type][curr.cmd.it];
                                var maxArgCount = func.length - 1;
                                var optionalArgCount = (func.meta != null ? func.meta.optionalArgCount : undefined) != null ? func.meta.optionalArgCount : 0;
                                var minArgCount = maxArgCount - optionalArgCount;
                                if (argCount < minArgCount || argCount > maxArgCount) {
                                    _this._error(curr.cmd.it, argCount > maxArgCount ? curr.args[maxArgCount] : curr, "passed " + argCount + " argument" + (argCount === 1 ? "" : "s") + " to '" + curr.cmd.it + "' which requires " + minArgCount + (minArgCount === maxArgCount ? "" : "-" + maxArgCount));
                                }
                                if (isAssert) {
                                    // inspection
                                    if (!_assert_moar2.default.hasOwnProperty(curr.assert.op.it)) {
                                        _this._error(curr.cmd.it, curr.assert.op, "unsupported '" + curr.assert.op.it + "' assertion");
                                    }
                                }
                            }();

                            if (_ret2 === "continue") continue;
                        }
                }
            }
            this.validated = true;
            this.trigger("validated", this.errors, this.now());
            return this;
        }
    }, {
        key: "getScenario",
        value: function getScenario() {
            this.parse();
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = this.commands[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var c = _step4.value;

                    if (c.cmd.it === "scenario") {
                        return c.val.it;
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            return null;
        }
    }, {
        key: "getMockset",
        value: function getMockset() {
            this.parse();
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = this.commands[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var c = _step5.value;

                    if (c.cmd.it === "mockset") {
                        return c.val.it;
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            return null;
        }
    }, {
        key: "getUser",
        value: function getUser() {
            this.parse();
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = this.commands[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var c = _step6.value;

                    if (c.cmd.it === "user") {
                        return c.val.it;
                    }
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }

            return null;
        }
    }, {
        key: "getConfig",
        value: function getConfig() {
            this.parse();
            return this.config;
        }
    }, {
        key: "getPreferences",
        value: function getPreferences() {
            this.parse();
            return this.prefs;
        }
    }, {
        key: "start",
        value: function start(driver) {
            this.driver = driver;
            this._deferred = new $.Deferred();
            this.validate();
            var p = this._deferred.promise();
            if (this.errors.length) {
                this._deferred.reject(this.errors[0]);
            } else {
                this._index = null;
                this.trigger("start", p, this.now());
            }
            return p;
        }
    }, {
        key: "pause",
        value: function pause() {
            if (this.playing) {
                this.playing = false;
                return this.trigger("pause", this.now());
            }
        }
    }, {
        key: "close",
        value: function close() {
            return this.trigger("close", this.now());
        }
    }, {
        key: "play",
        value: function play() {
            if (!this.playing) {
                this.playing = true;
                this.trigger("play", this.now());
                return this._next();
            }
        }
    }, {
        key: "_closeWiths",
        value: function _closeWiths(newDepth) {
            var _this2 = this;

            var prev = this.commands[this._index - 1];
            if (prev != null && newDepth < prev.depth) {
                // need to pop some 'with' contexts
                var threshold = prev.depth - 1;
                return function () {
                    var result = [];
                    for (var start = _this2._index - 2, i = start, asc = start <= 0; asc ? i <= 0 : i >= 0; asc ? i++ : i--) {
                        var c = _this2.commands[i];
                        if (c.cmd.it === "with" && c.depth < threshold && c.depth >= newDepth) {
                            threshold = c.depth;
                            for (var j = 1, end = c.chain.length, asc1 = 1 <= end; asc1 ? j <= end : j >= end; asc1 ? j++ : j--) {
                                _this2.driver.pop();
                            }
                            result.push(_this2._event("with:done", c.cmd, c.chain));
                        } else {
                            result.push(undefined);
                        }
                    }
                    return result;
                }();
            }
        }
    }, {
        key: "_next",
        value: function _next() {
            var _this3 = this;

            return _wait2.default.tick({ for: this.options.tickDelay }, function () {
                if (!_this3.playing) {
                    return;
                }
                return _this3.step();
            });
        }
    }, {
        key: "step",
        value: function step() {
            var _this4 = this;

            if (this._index != null) {
                this._index += 1;
            } else {
                this._index = 0;
            }

            this._deferred.notify(this._index / this.commands.length);

            if (this._index >= this.commands.length) {
                this._closeWiths(0);
                this._deferred.resolve();
                this.trigger("success", this.now());
                return;
            }

            var curr = this.commands[this._index];
            console.group("IT> " + curr.text);
            var event = function event(typeSuffix, payload) {
                var type = void 0;
                if (payload != null) {
                    type = curr.cmd.it + ":" + typeSuffix;
                } else {
                    payload = typeSuffix;
                    type = curr.cmd.it;
                }
                return _this4._event(type, curr.cmd, payload);
            };
            var doChain = function doChain(chain) {
                var proceed = true;
                var _iteratorNormalCompletion7 = true;
                var _didIteratorError7 = false;
                var _iteratorError7 = undefined;

                try {
                    for (var _iterator7 = chain[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                        var link = _step7.value;

                        try {
                            _this4.driver.with.call(_this4.driver, link.it);
                        } catch (se) {
                            _this4._error(se, link);
                            _this4._deferred.reject(se);
                            proceed = false;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError7 = true;
                    _iteratorError7 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion7 && _iterator7.return) {
                            _iterator7.return();
                        }
                    } finally {
                        if (_didIteratorError7) {
                            throw _iteratorError7;
                        }
                    }
                }

                if (proceed && _HybridConfig2.default.get("it.autoscroll", true)) {
                    _this4.driver.element[0].scrollIntoView(false);
                }
                return proceed;
            };
            if (this._index > 0) {
                this._closeWiths(curr.depth);
            }
            try {
                switch (curr.cmd.it) {
                    case "scenario":case "mockset":case "user":
                        event("start", curr.val.it);
                        event("done", curr.val.it);
                        return this._next();
                    case "config":case "preference":
                        event("start", curr.key.it, curr.val.it);
                        event("done", curr.key.it, curr.val.it);
                        return this._next();
                    case "wait":
                        {
                            var delay = 10000;
                            var val = "sync";
                            if (curr.val != null && curr.delay != null) {
                                val = curr.val.it;
                                delay = curr.delay.it;
                            } else if (curr.val != null) {
                                val = curr.val.it;
                            } else if (curr.delay != null) {
                                val = "tick";
                                delay = curr.delay.it;
                            }
                            event("start", val);
                            return _wait2.default[val]({ for: delay }, function () {
                                event("done", val);
                                return _this4._next();
                            }, function (o) {
                                _this4._error(o.__error, curr);
                                return _this4._deferred.reject(o.__error);
                            });
                        }
                    case "with":
                        _wait2.default.sync({ for: 10000 }, function () {}, function (o) {
                            _this4._error(o.__error, curr);
                            return _this4._deferred.reject(o.__error);
                        });
                        event("start", toIt(curr.chain));
                        if (doChain(curr.chain)) {
                            return this._next();
                        }
                        break;
                    case "fail":
                        {
                            var msg = __guard__(curr.args != null ? curr.args[0] : undefined, function (x) {
                                return x.it;
                            }) != null ? __guard__(curr.args != null ? curr.args[0] : undefined, function (x) {
                                return x.it;
                            }) : "Fail";
                            event("start", msg);
                            _assert_moar2.default.ok(false, msg);
                            return event("done", msg);
                        }
                    case "exit":
                        {
                            var _msg = __guard__(curr.args != null ? curr.args[0] : undefined, function (x1) {
                                return x1.it;
                            }) != null ? __guard__(curr.args != null ? curr.args[0] : undefined, function (x1) {
                                return x1.it;
                            }) : "Early Exit";
                            _utils2.default.info("Exit", _msg);
                            this._index = this.commands.length;
                            return this._next();
                        }
                    case "pause":
                        event("start", "pause");
                        event("done", "pause");
                        // eslint-disable-next-line no-settimeout
                        return setTimeout(function () {
                            return _this4.pause();
                        }, 0);
                    case "close":
                        // eslint-disable-next-line no-settimeout
                        return setTimeout(function () {
                            _this4.playing = false;
                            return _this4.close();
                        }, 0);
                    default:
                        // invocation is the same for both actions and inspections
                        var isAssert = curr.hasOwnProperty("assert");
                        var payload = {
                            chain: toIt(curr.chain),
                            args: toIt(curr.args)
                        };
                        if (isAssert) {
                            payload.op = curr.assert.op.it;
                            payload.val = curr.assert.val.it;
                        }
                        event("start", payload);
                        var value = undefined;
                        var isExists = curr.cmd.it === "exists";
                        if (isExists) {
                            // this one is special
                            var last = curr.chain[curr.chain.length - 1];
                            value = true;
                            var chainHead = curr.chain.slice(0, curr.chain.length - 1);
                            if (!doChain(chainHead)) {
                                break;
                            }
                            try {
                                this.driver.with.call(this.driver, last.it);
                                this.driver.pop();
                            } catch (error) {
                                value = false;
                            }
                            // eslint-disable-next-line no-unused-vars
                            var _iteratorNormalCompletion8 = true;
                            var _didIteratorError8 = false;
                            var _iteratorError8 = undefined;

                            try {
                                for (var _iterator8 = chainHead[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                                    var c = _step8.value;

                                    this.driver.pop();
                                }
                            } catch (err) {
                                _didIteratorError8 = true;
                                _iteratorError8 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion8 && _iterator8.return) {
                                        _iterator8.return();
                                    }
                                } finally {
                                    if (_didIteratorError8) {
                                        throw _iteratorError8;
                                    }
                                }
                            }
                        } else {
                            if (curr.chain != null) {
                                if (!doChain(curr.chain)) {
                                    break;
                                }
                            }
                            var fn = this.driver[curr.cmd.it];
                            value = fn.apply(this.driver, curr.args != null ? payload.args : []);
                        }
                        if (isAssert) {
                            // inspection
                            var _val = curr.assert.val.it;
                            if (typeof _val === "string") {
                                _val = $.trim(_val);
                                value = $.trim(value);
                            }
                            try {
                                _assert_moar2.default[curr.assert.op.it](value, _val);
                            } catch (ae) {
                                this._error(ae, curr.assert.op);
                                this._deferred.reject(ae);
                                break;
                            }
                        }
                        if (!isExists && curr.chain != null) {
                            // eslint-disable-next-line no-unused-vars
                            var _iteratorNormalCompletion9 = true;
                            var _didIteratorError9 = false;
                            var _iteratorError9 = undefined;

                            try {
                                for (var _iterator9 = curr.chain[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                                    var _c = _step9.value;

                                    this.driver.pop();
                                }
                            } catch (err) {
                                _didIteratorError9 = true;
                                _iteratorError9 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion9 && _iterator9.return) {
                                        _iterator9.return();
                                    }
                                } finally {
                                    if (_didIteratorError9) {
                                        throw _iteratorError9;
                                    }
                                }
                            }
                        }
                        event("done", payload);
                        return this._next();
                }
            } catch (e) {
                this._error(e, curr.cmd);
                return this._deferred.reject(e);
            } finally {
                console.groupEnd();
            }
        }
    }]);

    return Interpreter;
}();

_.extend(Interpreter.prototype, Backbone.Events);
exports.default = Interpreter;


function __guard__(value, transform) {
    return typeof value !== "undefined" && value !== null ? transform(value) : undefined;
}

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  /*
   * Generated by PEG.js 0.8.0.
   *
   * http://pegjs.majda.cz/
   */

  function peg$subclass(child, parent) {
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function SyntaxError(message, expected, found, offset, line, column) {
    this.message = message;
    this.expected = expected;
    this.found = found;
    this.offset = offset;
    this.line = line;
    this.column = column;

    this.name = "SyntaxError";
  }

  peg$subclass(SyntaxError, Error);

  function parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        peg$FAILED = {},
        peg$startRuleFunctions = { script: peg$parsescript },
        peg$startRuleFunction = peg$parsescript,
        peg$c0 = peg$FAILED,
        peg$c1 = [],
        peg$c2 = "\n",
        peg$c3 = { type: "literal", value: "\n", description: "\"\\n\"" },
        peg$c4 = null,
        peg$c5 = function peg$c5(l) {
      return l;
    },
        peg$c6 = function peg$c6(l, ls) {
      ls.unshift(l);
      return stripnull(ls);
    },
        peg$c7 = "#",
        peg$c8 = { type: "literal", value: "#", description: "\"#\"" },
        peg$c9 = "//",
        peg$c10 = { type: "literal", value: "//", description: "\"//\"" },
        peg$c11 = /^[^\n]/,
        peg$c12 = { type: "class", value: "[^\\n]", description: "[^\\n]" },
        peg$c13 = function peg$c13() {
      return null;
    },
        peg$c14 = function peg$c14(d, p) {
      return { cmd: d, val: p, d: true };
    },
        peg$c15 = "=",
        peg$c16 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c17 = ":",
        peg$c18 = { type: "literal", value: ":", description: "\":\"" },
        peg$c19 = function peg$c19(d, k, v) {
      return { cmd: atom(d), key: k, val: v, d: true };
    },
        peg$c20 = "user",
        peg$c21 = { type: "literal", value: "user", description: "\"user\"" },
        peg$c22 = /^[a-zA-Z0-9_\-:[,>\](|) ]/,
        peg$c23 = { type: "class", value: "[a-zA-Z0-9_\\-:[,>\\](|) ]", description: "[a-zA-Z0-9_\\-:[,>\\](|) ]" },
        peg$c24 = function peg$c24(d, u) {
      return { cmd: atom(d), val: atom(u.join('')), d: true };
    },
        peg$c25 = function peg$c25(cm, c) {
      return { cmd: cm, chain: c };
    },
        peg$c26 = "for",
        peg$c27 = { type: "literal", value: "for", description: "\"for\"" },
        peg$c28 = function peg$c28(cm, d, p) {
      return { cmd: cm, val: p, delay: d };
    },
        peg$c29 = function peg$c29(ins, ca, a) {
      return { cmd: ins, chain: ca[0], args: ca[1], assert: a };
    },
        peg$c30 = function peg$c30(act, ca) {
      return { cmd: act, chain: ca[0], args: ca[1] };
    },
        peg$c31 = function peg$c31() {
      // blank line
      return null;
    },
        peg$c32 = function peg$c32(c) {
      return c;
    },
        peg$c33 = function peg$c33(s, l) {
      if (l != null) {
        l.indent = s;
        l.depth = s.len; // for easier access

        l = atom(l);
      }
      return l;
    },
        peg$c34 = "scenario",
        peg$c35 = { type: "literal", value: "scenario", description: "\"scenario\"" },
        peg$c36 = "mockset",
        peg$c37 = { type: "literal", value: "mockset", description: "\"mockset\"" },
        peg$c38 = function peg$c38(d) {
      return atom(d);
    },
        peg$c39 = "config",
        peg$c40 = { type: "literal", value: "config", description: "\"config\"" },
        peg$c41 = "preference",
        peg$c42 = { type: "literal", value: "preference", description: "\"preference\"" },
        peg$c43 = "with",
        peg$c44 = { type: "literal", value: "with", description: "\"with\"" },
        peg$c45 = function peg$c45(c) {
      return atom(c);
    },
        peg$c46 = "wait",
        peg$c47 = { type: "literal", value: "wait", description: "\"wait\"" },
        peg$c48 = function peg$c48(n, u) {
      return atom({ it: n.it * u.factor, num: n, unit: u });
    },
        peg$c49 = "seconds",
        peg$c50 = { type: "literal", value: "seconds", description: "\"seconds\"" },
        peg$c51 = "second",
        peg$c52 = { type: "literal", value: "second", description: "\"second\"" },
        peg$c53 = "sec",
        peg$c54 = { type: "literal", value: "sec", description: "\"sec\"" },
        peg$c55 = function peg$c55(l) {
      var a = atom(l);
      a.factor = 1000;
      return a;
    },
        peg$c56 = "minutes",
        peg$c57 = { type: "literal", value: "minutes", description: "\"minutes\"" },
        peg$c58 = "minute",
        peg$c59 = { type: "literal", value: "minute", description: "\"minute\"" },
        peg$c60 = "min",
        peg$c61 = { type: "literal", value: "min", description: "\"min\"" },
        peg$c62 = function peg$c62(l) {
      var a = atom(l);
      a.factor = 60 * 1000;
      return a;
    },
        peg$c63 = "milliseconds",
        peg$c64 = { type: "literal", value: "milliseconds", description: "\"milliseconds\"" },
        peg$c65 = "millisecond",
        peg$c66 = { type: "literal", value: "millisecond", description: "\"millisecond\"" },
        peg$c67 = "ms",
        peg$c68 = { type: "literal", value: "ms", description: "\"ms\"" },
        peg$c69 = function peg$c69(l) {
      var a = atom(l);
      a.factor = 1;
      return a;
    },
        peg$c70 = /^[a-z]/i,
        peg$c71 = { type: "class", value: "[a-z]i", description: "[a-z]i" },
        peg$c72 = /^[a-z0-9]/i,
        peg$c73 = { type: "class", value: "[a-z0-9]i", description: "[a-z0-9]i" },
        peg$c74 = function peg$c74(i, r) {
      return atom(i + r.join(''));
    },
        peg$c75 = ".",
        peg$c76 = { type: "literal", value: ".", description: "\".\"" },
        peg$c77 = "-",
        peg$c78 = { type: "literal", value: "-", description: "\"-\"" },
        peg$c79 = function peg$c79(id) {
      return id;
    },
        peg$c80 = function peg$c80(i, r) {
      r.unshift(i);
      return atom(r.map(function (id) {
        return id.it;
      }));
    },
        peg$c81 = function peg$c81(o, v) {
      return atom({ op: o, val: v });
    },
        peg$c82 = function peg$c82() {
      return null;
    },
        peg$c83 = ",",
        peg$c84 = { type: "literal", value: ",", description: "\",\"" },
        peg$c85 = function peg$c85(a) {
      return a;
    },
        peg$c86 = function peg$c86(c, a) {
      return [c, a];
    },
        peg$c87 = function peg$c87(a) {
      return [null, a];
    },
        peg$c88 = ">",
        peg$c89 = { type: "literal", value: ">", description: "\">\"" },
        peg$c90 = "/",
        peg$c91 = { type: "literal", value: "/", description: "\"/\"" },
        peg$c92 = "[",
        peg$c93 = { type: "literal", value: "[", description: "\"[\"" },
        peg$c94 = "]",
        peg$c95 = { type: "literal", value: "]", description: "\"]\"" },
        peg$c96 = function peg$c96(l, ls) {
      ls.unshift(l);
      return ls;
    },
        peg$c97 = /^[a-z0-9:]/i,
        peg$c98 = { type: "class", value: "[a-z0-9:]i", description: "[a-z0-9:]i" },
        peg$c99 = function peg$c99(i, r, j) {
      return atom(trim(i + r.join('') + j.text.replace(/(^\"|\"$)/g, '')));
    },
        peg$c100 = /^[a-z0-9: _\-]/i,
        peg$c101 = { type: "class", value: "[a-z0-9: _\\-]i", description: "[a-z0-9: _\\-]i" },
        peg$c102 = function peg$c102(i, r) {
      return atom(trim(i + r.join('')));
    },
        peg$c103 = function peg$c103(a) {
      return a;
    },
        peg$c104 = function peg$c104(a, as) {
      as.unshift(a);
      return as;
    },
        peg$c105 = "==",
        peg$c106 = { type: "literal", value: "==", description: "\"==\"" },
        peg$c107 = "!=",
        peg$c108 = { type: "literal", value: "!=", description: "\"!=\"" },
        peg$c109 = "<",
        peg$c110 = { type: "literal", value: "<", description: "\"<\"" },
        peg$c111 = "<=",
        peg$c112 = { type: "literal", value: "<=", description: "\"<=\"" },
        peg$c113 = ">=",
        peg$c114 = { type: "literal", value: ">=", description: "\">=\"" },
        peg$c115 = function peg$c115(o) {
      return atom(o);
    },
        peg$c116 = "=~",
        peg$c117 = { type: "literal", value: "=~", description: "\"=~\"" },
        peg$c118 = "!~",
        peg$c119 = { type: "literal", value: "!~", description: "\"!~\"" },
        peg$c120 = "null",
        peg$c121 = { type: "literal", value: "null", description: "\"null\"" },
        peg$c122 = function peg$c122() {
      return atom(null);
    },
        peg$c123 = "\\/",
        peg$c124 = { type: "literal", value: "\\/", description: "\"\\\\/\"" },
        peg$c125 = function peg$c125() {
      return '/';
    },
        peg$c126 = "\\\\",
        peg$c127 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c128 = function peg$c128() {
      return '\\\\';
    },
        peg$c129 = /^[^\/]/,
        peg$c130 = { type: "class", value: "[^\\/]", description: "[^\\/]" },
        peg$c131 = /^[a-z]/,
        peg$c132 = { type: "class", value: "[a-z]", description: "[a-z]" },
        peg$c133 = function peg$c133(c, f) {
      return atom(new RegExp(c.join(''), f));
    },
        peg$c134 = "\"",
        peg$c135 = { type: "literal", value: "\"", description: "\"\\\"\"" },
        peg$c136 = "\\\"",
        peg$c137 = { type: "literal", value: "\\\"", description: "\"\\\\\\\"\"" },
        peg$c138 = function peg$c138() {
      return '"';
    },
        peg$c139 = function peg$c139() {
      return '\\';
    },
        peg$c140 = /^[^"\\]/,
        peg$c141 = { type: "class", value: "[^\"\\\\]", description: "[^\"\\\\]" },
        peg$c142 = function peg$c142(c) {
      return atom(c.join(''));
    },
        peg$c143 = /^[0-9]/,
        peg$c144 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c145 = function peg$c145(i) {
      return atom(parseInt(i.join(''), 10));
    },
        peg$c146 = function peg$c146(i, f) {
      return atom(parseFloat(i.join('') + '.' + f.join('')));
    },
        peg$c147 = "true",
        peg$c148 = { type: "literal", value: "true", description: "\"true\"" },
        peg$c149 = function peg$c149() {
      return atom(true);
    },
        peg$c150 = "false",
        peg$c151 = { type: "literal", value: "false", description: "\"false\"" },
        peg$c152 = function peg$c152() {
      return atom(false);
    },
        peg$c153 = /^[ \t]/,
        peg$c154 = { type: "class", value: "[ \\t]", description: "[ \\t]" },
        peg$c155 = function peg$c155(c) {
      return atom(c.join(''));
    },
        peg$c156 = " ",
        peg$c157 = { type: "literal", value: " ", description: "\" \"" },
        peg$currPos = 0,
        peg$reportedPos = 0,
        peg$cachedPos = 0,
        peg$cachedPosDetails = { line: 1, column: 1, seenCR: false },
        peg$maxFailPos = 0,
        peg$maxFailExpected = [],
        peg$silentFails = 0,
        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$reportedPos, peg$currPos);
    }

    function offset() {
      return peg$reportedPos;
    }

    function line() {
      return peg$computePosDetails(peg$reportedPos).line;
    }

    function column() {
      return peg$computePosDetails(peg$reportedPos).column;
    }

    function expected(description) {
      throw peg$buildException(null, [{ type: "other", description: description }], peg$reportedPos);
    }

    function error(message) {
      throw peg$buildException(message, null, peg$reportedPos);
    }

    function peg$computePosDetails(pos) {
      function advance(details, startPos, endPos) {
        var p, ch;

        for (p = startPos; p < endPos; p++) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) {
              details.line++;
            }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }
        }
      }

      if (peg$cachedPos !== pos) {
        if (peg$cachedPos > pos) {
          peg$cachedPos = 0;
          peg$cachedPosDetails = { line: 1, column: 1, seenCR: false };
        }
        advance(peg$cachedPosDetails, peg$cachedPos, pos);
        peg$cachedPos = pos;
      }

      return peg$cachedPosDetails;
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) {
        return;
      }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, pos) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function (a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) {
            return ch.charCodeAt(0).toString(16).toUpperCase();
          }

          return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\x08/g, '\\b').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\f/g, '\\f').replace(/\r/g, '\\r').replace(/[\x00-\x07\x0B\x0E\x0F]/g, function (ch) {
            return '\\x0' + hex(ch);
          }).replace(/[\x10-\x1F\x80-\xFF]/g, function (ch) {
            return '\\x' + hex(ch);
          }).replace(/[\u0180-\u0FFF]/g, function (ch) {
            return "\\u0" + hex(ch);
          }).replace(/[\u1080-\uFFFF]/g, function (ch) {
            return "\\u" + hex(ch);
          });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc,
            foundDesc,
            i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1 ? expectedDescs.slice(0, -1).join(", ") + " or " + expectedDescs[expected.length - 1] : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      var posDetails = peg$computePosDetails(pos),
          found = pos < input.length ? input.charAt(pos) : null;

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new SyntaxError(message !== null ? message : buildMessage(expected, found), expected, found, pos, posDetails.line, posDetails.column);
    }

    function peg$parsescript() {
      var s0;

      s0 = peg$parselines();

      return s0;
    }

    function peg$parselines() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = peg$parseline();
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 10) {
          s4 = peg$c2;
          peg$currPos++;
        } else {
          s4 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c3);
          }
        }
        if (s4 !== peg$FAILED) {
          s5 = peg$parseline();
          if (s5 === peg$FAILED) {
            s5 = peg$c4;
          }
          if (s5 !== peg$FAILED) {
            peg$reportedPos = s3;
            s4 = peg$c5(s5);
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$c0;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$c0;
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 10) {
            s4 = peg$c2;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c3);
            }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parseline();
            if (s5 === peg$FAILED) {
              s5 = peg$c4;
            }
            if (s5 !== peg$FAILED) {
              peg$reportedPos = s3;
              s4 = peg$c5(s5);
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$c0;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$c0;
          }
        }
        if (s2 !== peg$FAILED) {
          peg$reportedPos = s0;
          s1 = peg$c6(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$c0;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c0;
      }

      return s0;
    }

    function peg$parsecomment() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 35) {
        s1 = peg$c7;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c8);
        }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 2) === peg$c9) {
          s1 = peg$c9;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c10);
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = [];
        if (peg$c11.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c12);
          }
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          if (peg$c11.test(input.charAt(peg$currPos))) {
            s3 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c12);
            }
          }
        }
        if (s2 !== peg$FAILED) {
          peg$reportedPos = s0;
          s1 = peg$c13();
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$c0;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c0;
      }

      return s0;
    }

    function peg$parseline() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;

      s0 = peg$currPos;
      s1 = peg$parseindent();
      if (s1 !== peg$FAILED) {
        s2 = peg$currPos;
        s3 = peg$parsedirective();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            s5 = peg$parsename();
            if (s5 !== peg$FAILED) {
              peg$reportedPos = s2;
              s3 = peg$c14(s3, s5);
              s2 = s3;
            } else {
              peg$currPos = s2;
              s2 = peg$c0;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$c0;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$c0;
        }
        if (s2 === peg$FAILED) {
          s2 = peg$currPos;
          s3 = peg$parsesetting();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsecompound_id();
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  s7 = peg$currPos;
                  if (input.charCodeAt(peg$currPos) === 61) {
                    s8 = peg$c15;
                    peg$currPos++;
                  } else {
                    s8 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c16);
                    }
                  }
                  if (s8 === peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 58) {
                      s8 = peg$c17;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c18);
                      }
                    }
                  }
                  if (s8 !== peg$FAILED) {
                    s9 = peg$parse_();
                    if (s9 !== peg$FAILED) {
                      s8 = [s8, s9];
                      s7 = s8;
                    } else {
                      peg$currPos = s7;
                      s7 = peg$c0;
                    }
                  } else {
                    peg$currPos = s7;
                    s7 = peg$c0;
                  }
                  if (s7 === peg$FAILED) {
                    s7 = peg$c4;
                  }
                  if (s7 !== peg$FAILED) {
                    s8 = peg$parsevalue();
                    if (s8 !== peg$FAILED) {
                      peg$reportedPos = s2;
                      s3 = peg$c19(s3, s5, s8);
                      s2 = s3;
                    } else {
                      peg$currPos = s2;
                      s2 = peg$c0;
                    }
                  } else {
                    peg$currPos = s2;
                    s2 = peg$c0;
                  }
                } else {
                  peg$currPos = s2;
                  s2 = peg$c0;
                }
              } else {
                peg$currPos = s2;
                s2 = peg$c0;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c0;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$c0;
          }
          if (s2 === peg$FAILED) {
            s2 = peg$currPos;
            if (input.substr(peg$currPos, 4) === peg$c20) {
              s3 = peg$c20;
              peg$currPos += 4;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c21);
              }
            }
            if (s3 !== peg$FAILED) {
              s4 = peg$parse_();
              if (s4 !== peg$FAILED) {
                s5 = [];
                if (peg$c22.test(input.charAt(peg$currPos))) {
                  s6 = input.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s6 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c23);
                  }
                }
                if (s6 !== peg$FAILED) {
                  while (s6 !== peg$FAILED) {
                    s5.push(s6);
                    if (peg$c22.test(input.charAt(peg$currPos))) {
                      s6 = input.charAt(peg$currPos);
                      peg$currPos++;
                    } else {
                      s6 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c23);
                      }
                    }
                  }
                } else {
                  s5 = peg$c0;
                }
                if (s5 !== peg$FAILED) {
                  peg$reportedPos = s2;
                  s3 = peg$c24(s3, s5);
                  s2 = s3;
                } else {
                  peg$currPos = s2;
                  s2 = peg$c0;
                }
              } else {
                peg$currPos = s2;
                s2 = peg$c0;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c0;
            }
            if (s2 === peg$FAILED) {
              s2 = peg$currPos;
              s3 = peg$parsewithCommand();
              if (s3 !== peg$FAILED) {
                s4 = peg$parse_();
                if (s4 !== peg$FAILED) {
                  s5 = peg$parsechain();
                  if (s5 !== peg$FAILED) {
                    peg$reportedPos = s2;
                    s3 = peg$c25(s3, s5);
                    s2 = s3;
                  } else {
                    peg$currPos = s2;
                    s2 = peg$c0;
                  }
                } else {
                  peg$currPos = s2;
                  s2 = peg$c0;
                }
              } else {
                peg$currPos = s2;
                s2 = peg$c0;
              }
              if (s2 === peg$FAILED) {
                s2 = peg$currPos;
                s3 = peg$parsewaitCommand();
                if (s3 !== peg$FAILED) {
                  s4 = peg$parse_();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsedelay();
                    if (s5 === peg$FAILED) {
                      s5 = peg$c4;
                    }
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parse_();
                      if (s6 !== peg$FAILED) {
                        if (input.substr(peg$currPos, 3) === peg$c26) {
                          s7 = peg$c26;
                          peg$currPos += 3;
                        } else {
                          s7 = peg$FAILED;
                          if (peg$silentFails === 0) {
                            peg$fail(peg$c27);
                          }
                        }
                        if (s7 === peg$FAILED) {
                          s7 = peg$c4;
                        }
                        if (s7 !== peg$FAILED) {
                          s8 = peg$parse_();
                          if (s8 !== peg$FAILED) {
                            s9 = peg$parsename();
                            if (s9 === peg$FAILED) {
                              s9 = peg$c4;
                            }
                            if (s9 !== peg$FAILED) {
                              peg$reportedPos = s2;
                              s3 = peg$c28(s3, s5, s9);
                              s2 = s3;
                            } else {
                              peg$currPos = s2;
                              s2 = peg$c0;
                            }
                          } else {
                            peg$currPos = s2;
                            s2 = peg$c0;
                          }
                        } else {
                          peg$currPos = s2;
                          s2 = peg$c0;
                        }
                      } else {
                        peg$currPos = s2;
                        s2 = peg$c0;
                      }
                    } else {
                      peg$currPos = s2;
                      s2 = peg$c0;
                    }
                  } else {
                    peg$currPos = s2;
                    s2 = peg$c0;
                  }
                } else {
                  peg$currPos = s2;
                  s2 = peg$c0;
                }
                if (s2 === peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$parseid();
                  if (s3 !== peg$FAILED) {
                    s4 = peg$parse_();
                    if (s4 !== peg$FAILED) {
                      s5 = peg$parsechain_and_args();
                      if (s5 !== peg$FAILED) {
                        s6 = peg$parse_();
                        if (s6 !== peg$FAILED) {
                          s7 = peg$parseassert();
                          if (s7 !== peg$FAILED) {
                            peg$reportedPos = s2;
                            s3 = peg$c29(s3, s5, s7);
                            s2 = s3;
                          } else {
                            peg$currPos = s2;
                            s2 = peg$c0;
                          }
                        } else {
                          peg$currPos = s2;
                          s2 = peg$c0;
                        }
                      } else {
                        peg$currPos = s2;
                        s2 = peg$c0;
                      }
                    } else {
                      peg$currPos = s2;
                      s2 = peg$c0;
                    }
                  } else {
                    peg$currPos = s2;
                    s2 = peg$c0;
                  }
                  if (s2 === peg$FAILED) {
                    s2 = peg$currPos;
                    s3 = peg$parseid();
                    if (s3 !== peg$FAILED) {
                      s4 = peg$parse_();
                      if (s4 !== peg$FAILED) {
                        s5 = peg$parsechain_and_args();
                        if (s5 !== peg$FAILED) {
                          peg$reportedPos = s2;
                          s3 = peg$c30(s3, s5);
                          s2 = s3;
                        } else {
                          peg$currPos = s2;
                          s2 = peg$c0;
                        }
                      } else {
                        peg$currPos = s2;
                        s2 = peg$c0;
                      }
                    } else {
                      peg$currPos = s2;
                      s2 = peg$c0;
                    }
                    if (s2 === peg$FAILED) {
                      s2 = peg$currPos;
                      s3 = [];
                      if (s3 !== peg$FAILED) {
                        peg$reportedPos = s2;
                        s3 = peg$c31();
                      }
                      s2 = s3;
                    }
                  }
                }
              }
            }
          }
        }
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            s5 = peg$parsecomment();
            if (s5 === peg$FAILED) {
              s5 = peg$c4;
            }
            if (s5 !== peg$FAILED) {
              peg$reportedPos = s3;
              s4 = peg$c32(s5);
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$c0;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$c0;
          }
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c33(s1, s2);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c0;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c0;
      }

      return s0;
    }

    function peg$parsedirective() {
      var s0, s1;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 8) === peg$c34) {
        s1 = peg$c34;
        peg$currPos += 8;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c35);
        }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 7) === peg$c36) {
          s1 = peg$c36;
          peg$currPos += 7;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c37);
          }
        }
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c38(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsesetting() {
      var s0, s1;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c39) {
        s1 = peg$c39;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c40);
        }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 10) === peg$c41) {
          s1 = peg$c41;
          peg$currPos += 10;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c42);
          }
        }
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c38(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsewithCommand() {
      var s0, s1;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 4) === peg$c43) {
        s1 = peg$c43;
        peg$currPos += 4;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c44);
        }
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c45(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsewaitCommand() {
      var s0, s1;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 4) === peg$c46) {
        s1 = peg$c46;
        peg$currPos += 4;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c47);
        }
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c45(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsedelay() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$parsefloat();
      if (s1 === peg$FAILED) {
        s1 = peg$parseinteger();
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsetimeUnits();
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c48(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c0;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c0;
      }

      return s0;
    }

    function peg$parsetimeUnits() {
      var s0, s1;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c49) {
        s1 = peg$c49;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c50);
        }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 6) === peg$c51) {
          s1 = peg$c51;
          peg$currPos += 6;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c52);
          }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 3) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 3;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c54);
            }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c55(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 7) === peg$c56) {
          s1 = peg$c56;
          peg$currPos += 7;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c57);
          }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 6) === peg$c58) {
            s1 = peg$c58;
            peg$currPos += 6;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c59);
            }
          }
          if (s1 === peg$FAILED) {
            if (input.substr(peg$currPos, 3) === peg$c60) {
              s1 = peg$c60;
              peg$currPos += 3;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c61);
              }
            }
          }
        }
        if (s1 !== peg$FAILED) {
          peg$reportedPos = s0;
          s1 = peg$c62(s1);
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 12) === peg$c63) {
            s1 = peg$c63;
            peg$currPos += 12;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c64);
            }
          }
          if (s1 === peg$FAILED) {
            if (input.substr(peg$currPos, 11) === peg$c65) {
              s1 = peg$c65;
              peg$currPos += 11;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c66);
              }
            }
            if (s1 === peg$FAILED) {
              if (input.substr(peg$currPos, 2) === peg$c67) {
                s1 = peg$c67;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c68);
                }
              }
            }
          }
          if (s1 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c69(s1);
          }
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseid() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (peg$c70.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c71);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = [];
        if (peg$c72.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c73);
          }
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          if (peg$c72.test(input.charAt(peg$currPos))) {
            s3 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c73);
            }
          }
        }
        if (s2 !== peg$FAILED) {
          peg$reportedPos = s0;
          s1 = peg$c74(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$c0;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c0;
      }

      return s0;
    }

    function peg$parsecompound_id() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = peg$parseid();
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 46) {
          s4 = peg$c75;
          peg$currPos++;
        } else {
          s4 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c76);
          }
        }
        if (s4 === peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 45) {
            s4 = peg$c77;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c78);
            }
          }
        }
        if (s4 !== peg$FAILED) {
          s5 = peg$parseid();
          if (s5 !== peg$FAILED) {
            peg$reportedPos = s3;
            s4 = peg$c79(s5);
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$c0;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$c0;
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 46) {
            s4 = peg$c75;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c76);
            }
          }
          if (s4 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 45) {
              s4 = peg$c77;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c78);
              }
            }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parseid();
            if (s5 !== peg$FAILED) {
              peg$reportedPos = s3;
              s4 = peg$c79(s5);
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$c0;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$c0;
          }
        }
        if (s2 !== peg$FAILED) {
          peg$reportedPos = s0;
          s1 = peg$c80(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$c0;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c0;
      }

      return s0;
    }

    function peg$parseassert() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$parseop();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsevalue();
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c81(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c0;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c0;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsereop();
        if (s1 !== peg$FAILED) {
          s2 = peg$parse_();
          if (s2 !== peg$FAILED) {
            s3 = peg$parseregex();
            if (s3 !== peg$FAILED) {
              peg$reportedPos = s0;
              s1 = peg$c81(s1, s3);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c0;
        }
      }

      return s0;
    }

    function peg$parsechain_and_args() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      s1 = peg$currPos;
      s2 = peg$parsechain();
      if (s2 !== peg$FAILED) {
        peg$reportedPos = s1;
        s2 = peg$c32(s2);
      }
      s1 = s2;
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 46) {
          s2 = peg$c75;
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c76);
          }
        }
        if (s2 !== peg$FAILED) {
          peg$reportedPos = s1;
          s2 = peg$c82();
        }
        s1 = s2;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$currPos;
        s3 = peg$parse_();
        if (s3 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c83;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c84);
            }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parseargs();
              if (s6 !== peg$FAILED) {
                peg$reportedPos = s2;
                s3 = peg$c85(s6);
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$c0;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c0;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$c0;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$c0;
        }
        if (s2 === peg$FAILED) {
          s2 = peg$c4;
        }
        if (s2 !== peg$FAILED) {
          peg$reportedPos = s0;
          s1 = peg$c86(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$c0;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c0;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseargs();
        if (s1 === peg$FAILED) {
          s1 = peg$c4;
        }
        if (s1 !== peg$FAILED) {
          peg$reportedPos = s0;
          s1 = peg$c87(s1);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parsechain() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      s0 = peg$currPos;
      s1 = peg$parselink();
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = peg$parse_();
        if (s4 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 62) {
            s5 = peg$c88;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c89);
            }
          }
          if (s5 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 47) {
              s5 = peg$c90;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c91);
              }
            }
          }
          if (s5 !== peg$FAILED) {
            s6 = peg$parse_();
            if (s6 !== peg$FAILED) {
              s7 = peg$parselink();
              if (s7 !== peg$FAILED) {
                peg$reportedPos = s3;
                s4 = peg$c5(s7);
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$c0;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$c0;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$c0;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$c0;
        }
        if (s3 === peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 91) {
            s4 = peg$c92;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c93);
            }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parseinteger();
            if (s5 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 93) {
                s6 = peg$c94;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c95);
                }
              }
              if (s6 !== peg$FAILED) {
                peg$reportedPos = s3;
                s4 = peg$c5(s5);
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$c0;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$c0;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$c0;
          }
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 62) {
              s5 = peg$c88;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c89);
              }
            }
            if (s5 === peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 47) {
                s5 = peg$c90;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c91);
                }
              }
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();
              if (s6 !== peg$FAILED) {
                s7 = peg$parselink();
                if (s7 !== peg$FAILED) {
                  peg$reportedPos = s3;
                  s4 = peg$c5(s7);
                  s3 = s4;
                } else {
                  peg$currPos = s3;
                  s3 = peg$c0;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$c0;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$c0;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$c0;
          }
          if (s3 === peg$FAILED) {
            s3 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 91) {
              s4 = peg$c92;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c93);
              }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parseinteger();
              if (s5 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 93) {
                  s6 = peg$c94;
                  peg$currPos++;
                } else {
                  s6 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c95);
                  }
                }
                if (s6 !== peg$FAILED) {
                  peg$reportedPos = s3;
                  s4 = peg$c5(s5);
                  s3 = s4;
                } else {
                  peg$currPos = s3;
                  s3 = peg$c0;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$c0;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$c0;
            }
          }
        }
        if (s2 !== peg$FAILED) {
          peg$reportedPos = s0;
          s1 = peg$c96(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$c0;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c0;
      }

      return s0;
    }

    function peg$parselink() {
      var s0;

      s0 = peg$parsename();
      if (s0 === peg$FAILED) {
        s0 = peg$parseinteger();
      }

      return s0;
    }

    function peg$parsename() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (peg$c70.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c71);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = [];
        if (peg$c97.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c98);
          }
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          if (peg$c97.test(input.charAt(peg$currPos))) {
            s3 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c98);
            }
          }
        }
        if (s2 !== peg$FAILED) {
          s3 = peg$parsestring();
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c99(s1, s2, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c0;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c0;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (peg$c70.test(input.charAt(peg$currPos))) {
          s1 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c71);
          }
        }
        if (s1 !== peg$FAILED) {
          s2 = [];
          if (peg$c100.test(input.charAt(peg$currPos))) {
            s3 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c101);
            }
          }
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            if (peg$c100.test(input.charAt(peg$currPos))) {
              s3 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c101);
              }
            }
          }
          if (s2 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c102(s1, s2);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c0;
        }
      }

      return s0;
    }

    function peg$parseargs() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      s0 = peg$currPos;
      s1 = peg$parsevalue();
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        s4 = peg$parse_();
        if (s4 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s5 = peg$c83;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c84);
            }
          }
          if (s5 !== peg$FAILED) {
            s6 = peg$parse_();
            if (s6 !== peg$FAILED) {
              s7 = peg$parsevalue();
              if (s7 !== peg$FAILED) {
                peg$reportedPos = s3;
                s4 = peg$c103(s7);
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$c0;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$c0;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$c0;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$c0;
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 44) {
              s5 = peg$c83;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c84);
              }
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();
              if (s6 !== peg$FAILED) {
                s7 = peg$parsevalue();
                if (s7 !== peg$FAILED) {
                  peg$reportedPos = s3;
                  s4 = peg$c103(s7);
                  s3 = s4;
                } else {
                  peg$currPos = s3;
                  s3 = peg$c0;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$c0;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$c0;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$c0;
          }
        }
        if (s2 !== peg$FAILED) {
          peg$reportedPos = s0;
          s1 = peg$c104(s1, s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$c0;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c0;
      }

      return s0;
    }

    function peg$parseop() {
      var s0, s1;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 2) === peg$c105) {
        s1 = peg$c105;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c106);
        }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 2) === peg$c107) {
          s1 = peg$c107;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c108);
          }
        }
        if (s1 === peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 60) {
            s1 = peg$c109;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c110);
            }
          }
          if (s1 === peg$FAILED) {
            if (input.substr(peg$currPos, 2) === peg$c111) {
              s1 = peg$c111;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c112);
              }
            }
            if (s1 === peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 62) {
                s1 = peg$c88;
                peg$currPos++;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c89);
                }
              }
              if (s1 === peg$FAILED) {
                if (input.substr(peg$currPos, 2) === peg$c113) {
                  s1 = peg$c113;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c114);
                  }
                }
              }
            }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c115(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsereop() {
      var s0, s1;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 2) === peg$c116) {
        s1 = peg$c116;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c117);
        }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 2) === peg$c118) {
          s1 = peg$c118;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c119);
          }
        }
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c115(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsevalue() {
      var s0, s1;

      s0 = peg$parsestring();
      if (s0 === peg$FAILED) {
        s0 = peg$parsefloat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseinteger();
          if (s0 === peg$FAILED) {
            s0 = peg$parseboolean();
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 4) === peg$c120) {
                s1 = peg$c120;
                peg$currPos += 4;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c121);
                }
              }
              if (s1 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c122();
              }
              s0 = s1;
            }
          }
        }
      }

      return s0;
    }

    function peg$parseregex() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 47) {
        s1 = peg$c90;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c91);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c123) {
          s4 = peg$c123;
          peg$currPos += 2;
        } else {
          s4 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c124);
          }
        }
        if (s4 !== peg$FAILED) {
          peg$reportedPos = s3;
          s4 = peg$c125();
        }
        s3 = s4;
        if (s3 === peg$FAILED) {
          s3 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c126) {
            s4 = peg$c126;
            peg$currPos += 2;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c127);
            }
          }
          if (s4 !== peg$FAILED) {
            peg$reportedPos = s3;
            s4 = peg$c128();
          }
          s3 = s4;
          if (s3 === peg$FAILED) {
            if (peg$c129.test(input.charAt(peg$currPos))) {
              s3 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c130);
              }
            }
          }
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c123) {
            s4 = peg$c123;
            peg$currPos += 2;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c124);
            }
          }
          if (s4 !== peg$FAILED) {
            peg$reportedPos = s3;
            s4 = peg$c125();
          }
          s3 = s4;
          if (s3 === peg$FAILED) {
            s3 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c126) {
              s4 = peg$c126;
              peg$currPos += 2;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c127);
              }
            }
            if (s4 !== peg$FAILED) {
              peg$reportedPos = s3;
              s4 = peg$c128();
            }
            s3 = s4;
            if (s3 === peg$FAILED) {
              if (peg$c129.test(input.charAt(peg$currPos))) {
                s3 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c130);
                }
              }
            }
          }
        }
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 47) {
            s3 = peg$c90;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c91);
            }
          }
          if (s3 !== peg$FAILED) {
            s4 = [];
            if (peg$c131.test(input.charAt(peg$currPos))) {
              s5 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c132);
              }
            }
            while (s5 !== peg$FAILED) {
              s4.push(s5);
              if (peg$c131.test(input.charAt(peg$currPos))) {
                s5 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c132);
                }
              }
            }
            if (s4 !== peg$FAILED) {
              peg$reportedPos = s0;
              s1 = peg$c133(s2, s4);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$c0;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c0;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c0;
      }

      return s0;
    }

    function peg$parsestring() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 34) {
        s1 = peg$c134;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c135);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c136) {
          s4 = peg$c136;
          peg$currPos += 2;
        } else {
          s4 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c137);
          }
        }
        if (s4 !== peg$FAILED) {
          peg$reportedPos = s3;
          s4 = peg$c138();
        }
        s3 = s4;
        if (s3 === peg$FAILED) {
          s3 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c126) {
            s4 = peg$c126;
            peg$currPos += 2;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c127);
            }
          }
          if (s4 !== peg$FAILED) {
            peg$reportedPos = s3;
            s4 = peg$c139();
          }
          s3 = s4;
          if (s3 === peg$FAILED) {
            if (peg$c140.test(input.charAt(peg$currPos))) {
              s3 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c141);
              }
            }
          }
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c136) {
            s4 = peg$c136;
            peg$currPos += 2;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c137);
            }
          }
          if (s4 !== peg$FAILED) {
            peg$reportedPos = s3;
            s4 = peg$c138();
          }
          s3 = s4;
          if (s3 === peg$FAILED) {
            s3 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c126) {
              s4 = peg$c126;
              peg$currPos += 2;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c127);
              }
            }
            if (s4 !== peg$FAILED) {
              peg$reportedPos = s3;
              s4 = peg$c139();
            }
            s3 = s4;
            if (s3 === peg$FAILED) {
              if (peg$c140.test(input.charAt(peg$currPos))) {
                s3 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c141);
                }
              }
            }
          }
        }
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 34) {
            s3 = peg$c134;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c135);
            }
          }
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c142(s2);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c0;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c0;
      }

      return s0;
    }

    function peg$parseinteger() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      if (peg$c143.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c144);
        }
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          if (peg$c143.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c144);
            }
          }
        }
      } else {
        s1 = peg$c0;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c145(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsefloat() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = [];
      if (peg$c143.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c144);
        }
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          if (peg$c143.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c144);
            }
          }
        }
      } else {
        s1 = peg$c0;
      }
      if (s1 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 46) {
          s2 = peg$c75;
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c76);
          }
        }
        if (s2 !== peg$FAILED) {
          s3 = [];
          if (peg$c143.test(input.charAt(peg$currPos))) {
            s4 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c144);
            }
          }
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              if (peg$c143.test(input.charAt(peg$currPos))) {
                s4 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c144);
                }
              }
            }
          } else {
            s3 = peg$c0;
          }
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c146(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c0;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c0;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c0;
      }

      return s0;
    }

    function peg$parseboolean() {
      var s0, s1;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 4) === peg$c147) {
        s1 = peg$c147;
        peg$currPos += 4;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c148);
        }
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c149();
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 5) === peg$c150) {
          s1 = peg$c150;
          peg$currPos += 5;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c151);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$reportedPos = s0;
          s1 = peg$c152();
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parseindent() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      if (peg$c153.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c154);
        }
      }
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        if (peg$c153.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c154);
          }
        }
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c155(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parse_() {
      var s0, s1;

      s0 = [];
      if (input.charCodeAt(peg$currPos) === 32) {
        s1 = peg$c156;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c157);
        }
      }
      while (s1 !== peg$FAILED) {
        s0.push(s1);
        if (input.charCodeAt(peg$currPos) === 32) {
          s1 = peg$c156;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c157);
          }
        }
      }

      return s0;
    }

    function stripnull(a) {
      var na = [];
      for (var i = 0, l = a.length; i < l; i++) {
        if (a[i] != null) {
          na.push(a[i]);
        }
      }
      return na;
    }
    function trim(s) {
      return s.replace(/^\s+|\s+$/g, '');
    }
    function atom(it) {
      var t = text();
      var a = it != null && Object.prototype.toString.apply(it) === '[object Object]' ? it : { it: it };
      a.offset = offset(), a.line = line(), a.column = column(), a.len = t.length, a.text = t;
      return a;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos);
    }
  }

  return {
    SyntaxError: SyntaxError,
    parse: parse
  };
}();

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assert = __webpack_require__(1605);

var _assert2 = _interopRequireDefault(_assert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_assert2.default.lessThan = _assert2.default["<"] = function (actual, expected, message) {
    if (actual >= expected) {
        _assert2.default.fail(actual, expected, message, "<", _assert2.default.lessThan);
    }
}; /*
    * decaffeinate suggestions:
    * DS102: Remove unnecessary code created because of implicit returns
    * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
    */
/*
    I build on the assert library to add a few more assertion types, and export
    the entire assert structure, so I can be required as a direct replacement
    for requiring assert itself.
*/


_assert2.default.lessThanEqual = _assert2.default["<="] = function (actual, expected, message) {
    if (actual > expected) {
        _assert2.default.fail(actual, expected, message, "<=", _assert2.default.lessThanEqual);
    }
};

_assert2.default.greaterThan = _assert2.default[">"] = function (actual, expected, message) {
    if (actual <= expected) {
        _assert2.default.fail(actual, expected, message, ">", _assert2.default.greaterThan);
    }
};

_assert2.default.greaterThanEqual = _assert2.default[">="] = function (actual, expected, message) {
    if (actual < expected) {
        _assert2.default.fail(actual, expected, message, ">=", _assert2.default.greaterThanEqual);
    }
};

_assert2.default["=="] = function (actual, expected, message) {
    if (typeof expected === "string" || typeof expected === "number" || typeof expected === "boolean") {
        return _assert2.default.equal.apply(this, arguments);
    } else {
        return _assert2.default.deepEqual.apply(this, arguments);
    }
};

_assert2.default["!="] = function (actual, expected, message) {
    if (typeof expected === "string" || typeof expected === "number" || typeof expected === "boolean") {
        return _assert2.default.notEqual.apply(this, arguments);
    } else {
        return _assert2.default.notDeepEqual.apply(this, arguments);
    }
};

_assert2.default.match = _assert2.default["=~"] = function (actual, regex, message) {
    if (typeof regex === "string") {
        regex = new RegExp(regex);
    }
    if (!regex.test(actual)) {
        _assert2.default.fail(actual, regex, message, "=~", _assert2.default.match);
    }
};

_assert2.default.notMatch = _assert2.default["!~"] = function (actual, regex, message) {
    if (typeof regex === "string") {
        regex = new RegExp(regex);
    }
    if (regex.test(actual)) {
        _assert2.default.fail(actual, regex, message, "!~", _assert2.default.notMatch);
    }
};

var assert_moar = _assert2.default;

exports.default = assert_moar;

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Copyright (c) 2011 Jxck
//
// Originally from node.js (http://nodejs.org)
// Copyright Joyent, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); // AMD
  } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
    module.exports = factory(); // CommonJS
  } else {
    root.assert = factory(); // Global
  }
})(undefined, function () {

  // UTILITY

  // Object.create compatible in IE
  var create = Object.create || function (p) {
    if (!p) throw Error('no type');
    function f() {};
    f.prototype = p;
    return new f();
  };

  // UTILITY
  var util = {
    inherits: function inherits(ctor, superCtor) {
      ctor.super_ = superCtor;
      ctor.prototype = create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    },
    isArray: function isArray(ar) {
      return Array.isArray(ar);
    },
    isBoolean: function isBoolean(arg) {
      return typeof arg === 'boolean';
    },
    isNull: function isNull(arg) {
      return arg === null;
    },
    isNullOrUndefined: function isNullOrUndefined(arg) {
      return arg == null;
    },
    isNumber: function isNumber(arg) {
      return typeof arg === 'number';
    },
    isString: function isString(arg) {
      return typeof arg === 'string';
    },
    isSymbol: function isSymbol(arg) {
      return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'symbol';
    },
    isUndefined: function isUndefined(arg) {
      return arg === void 0;
    },
    isRegExp: function isRegExp(re) {
      return util.isObject(re) && util.objectToString(re) === '[object RegExp]';
    },
    isObject: function isObject(arg) {
      return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && arg !== null;
    },
    isDate: function isDate(d) {
      return util.isObject(d) && util.objectToString(d) === '[object Date]';
    },
    isError: function isError(e) {
      return isObject(e) && (objectToString(e) === '[object Error]' || e instanceof Error);
    },
    isFunction: function isFunction(arg) {
      return typeof arg === 'function';
    },
    isPrimitive: function isPrimitive(arg) {
      return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'symbol' || // ES6 symbol
      typeof arg === 'undefined';
    },
    objectToString: function objectToString(o) {
      return Object.prototype.toString.call(o);
    }
  };

  var pSlice = Array.prototype.slice;

  // From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
  var Object_keys = typeof Object.keys === 'function' ? Object.keys : function () {
    var hasOwnProperty = Object.prototype.hasOwnProperty,
        hasDontEnumBug = !{ toString: null }.propertyIsEnumerable('toString'),
        dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'],
        dontEnumsLength = dontEnums.length;

    return function (obj) {
      if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' && (typeof obj !== 'function' || obj === null)) {
        throw new TypeError('Object.keys called on non-object');
      }

      var result = [],
          prop,
          i;

      for (prop in obj) {
        if (hasOwnProperty.call(obj, prop)) {
          result.push(prop);
        }
      }

      if (hasDontEnumBug) {
        for (i = 0; i < dontEnumsLength; i++) {
          if (hasOwnProperty.call(obj, dontEnums[i])) {
            result.push(dontEnums[i]);
          }
        }
      }
      return result;
    };
  }();

  // 1. The assert module provides functions that throw
  // AssertionError's when particular conditions are not met. The
  // assert module must conform to the following interface.

  var assert = ok;

  // 2. The AssertionError is defined in assert.
  // new assert.AssertionError({ message: message,
  //                             actual: actual,
  //                             expected: expected })

  assert.AssertionError = function AssertionError(options) {
    this.name = 'AssertionError';
    this.actual = options.actual;
    this.expected = options.expected;
    this.operator = options.operator;
    if (options.message) {
      this.message = options.message;
      this.generatedMessage = false;
    } else {
      this.message = getMessage(this);
      this.generatedMessage = true;
    }
    var stackStartFunction = options.stackStartFunction || fail;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, stackStartFunction);
    } else {
      // try to throw an error now, and from the stack property
      // work out the line that called in to assert.js.
      try {
        this.stack = new Error().stack.toString();
      } catch (e) {}
    }
  };

  // assert.AssertionError instanceof Error
  util.inherits(assert.AssertionError, Error);

  function replacer(key, value) {
    if (util.isUndefined(value)) {
      return '' + value;
    }
    if (util.isNumber(value) && (isNaN(value) || !isFinite(value))) {
      return value.toString();
    }
    if (util.isFunction(value) || util.isRegExp(value)) {
      return value.toString();
    }
    return value;
  }

  function truncate(s, n) {
    if (util.isString(s)) {
      return s.length < n ? s : s.slice(0, n - 3) + "...";
    } else {
      return s;
    }
  }

  function getMessage(self) {
    return truncate(JSON.stringify(self.actual, replacer), 128) + ' ' + self.operator + ' ' + truncate(JSON.stringify(self.expected, replacer), 128);
  }

  // At present only the three keys mentioned above are used and
  // understood by the spec. Implementations or sub modules can pass
  // other keys to the AssertionError's constructor - they will be
  // ignored.

  // 3. All of the following functions must throw an AssertionError
  // when a corresponding condition is not met, with a message that
  // may be undefined if not provided.  All assertion methods provide
  // both the actual and expected values to the assertion error for
  // display purposes.

  function fail(actual, expected, message, operator, stackStartFunction) {
    throw new assert.AssertionError({
      message: message,
      actual: actual,
      expected: expected,
      operator: operator,
      stackStartFunction: stackStartFunction
    });
  }

  // EXTENSION! allows for well behaved errors defined elsewhere.
  assert.fail = fail;

  // 4. Pure assertion tests whether a value is truthy, as determined
  // by !!guard.
  // assert.ok(guard, message_opt);
  // This statement is equivalent to assert.equal(true, !!guard,
  // message_opt);. To test strictly for the value true, use
  // assert.strictEqual(true, guard, message_opt);.

  function ok(value, message) {
    if (!value) fail(value, true, message, '==', assert.ok);
  }
  assert.ok = ok;

  // 5. The equality assertion tests shallow, coercive equality with
  // ==.
  // assert.equal(actual, expected, message_opt);

  assert.equal = function equal(actual, expected, message) {
    if (actual != expected) fail(actual, expected, message, '==', assert.equal);
  };

  // 6. The non-equality assertion tests for whether two objects are not equal
  // with != assert.notEqual(actual, expected, message_opt);

  assert.notEqual = function notEqual(actual, expected, message) {
    if (actual == expected) {
      fail(actual, expected, message, '!=', assert.notEqual);
    }
  };

  // 7. The equivalence assertion tests a deep equality relation.
  // assert.deepEqual(actual, expected, message_opt);

  assert.deepEqual = function deepEqual(actual, expected, message) {
    if (!_deepEqual(actual, expected)) {
      fail(actual, expected, message, 'deepEqual', assert.deepEqual);
    }
  };

  function _deepEqual(actual, expected) {
    // 7.1. All identical values are equivalent, as determined by ===.
    if (actual === expected) {
      return true;

      //  } else if (util.isBuffer(actual) && util.isBuffer(expected)) {
      //    if (actual.length != expected.length) return false;
      //
      //    for (var i = 0; i < actual.length; i++) {
      //      if (actual[i] !== expected[i]) return false;
      //    }
      //
      //    return true;
      //
      // 7.2. If the expected value is a Date object, the actual value is
      // equivalent if it is also a Date object that refers to the same time.
    } else if (util.isDate(actual) && util.isDate(expected)) {
      return actual.getTime() === expected.getTime();

      // 7.3 If the expected value is a RegExp object, the actual value is
      // equivalent if it is also a RegExp object with the same source and
      // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
    } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
      return actual.source === expected.source && actual.global === expected.global && actual.multiline === expected.multiline && actual.lastIndex === expected.lastIndex && actual.ignoreCase === expected.ignoreCase;

      // 7.4. Other pairs that do not both pass typeof value == 'object',
      // equivalence is determined by ==.
    } else if (!util.isObject(actual) && !util.isObject(expected)) {
      return actual == expected;

      // 7.5 For all other Object pairs, including Array objects, equivalence is
      // determined by having the same number of owned properties (as verified
      // with Object.prototype.hasOwnProperty.call), the same set of keys
      // (although not necessarily the same order), equivalent values for every
      // corresponding key, and an identical 'prototype' property. Note: this
      // accounts for both named and indexed properties on Arrays.
    } else {
      return objEquiv(actual, expected);
    }
  }

  var isArguments = function isArguments(object) {
    return Object.prototype.toString.call(object) == '[object Arguments]';
  };

  (function () {
    if (!isArguments(arguments)) {
      isArguments = function isArguments(object) {
        return object != null && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && typeof object.callee === 'function' && typeof object.length === 'number' || false;
      };
    }
  })();

  function objEquiv(a, b) {
    if (util.isNullOrUndefined(a) || util.isNullOrUndefined(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    //~~~I've managed to break Object.keys through screwy arguments passing.
    //   Converting to array solves the problem.
    var aIsArgs = isArguments(a),
        bIsArgs = isArguments(b);
    if (aIsArgs && !bIsArgs || !aIsArgs && bIsArgs) return false;
    if (aIsArgs) {
      a = pSlice.call(a);
      b = pSlice.call(b);
      return _deepEqual(a, b);
    }
    try {
      var ka = Object_keys(a),
          kb = Object_keys(b),
          key,
          i;
    } catch (e) {
      //happens when one is a string literal and the other isn't
      return false;
    }
    // having the same number of owned properties (keys incorporates
    // hasOwnProperty)
    if (ka.length != kb.length) return false;
    //the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    //~~~cheap key test
    for (i = ka.length - 1; i >= 0; i--) {
      if (ka[i] != kb[i]) return false;
    }
    //equivalent values for every corresponding key, and
    //~~~possibly expensive deep test
    for (i = ka.length - 1; i >= 0; i--) {
      key = ka[i];
      if (!_deepEqual(a[key], b[key])) return false;
    }
    return true;
  }

  // 8. The non-equivalence assertion tests for any deep inequality.
  // assert.notDeepEqual(actual, expected, message_opt);

  assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (_deepEqual(actual, expected)) {
      fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
    }
  };

  // 9. The strict equality assertion tests strict equality, as determined by ===.
  // assert.strictEqual(actual, expected, message_opt);

  assert.strictEqual = function strictEqual(actual, expected, message) {
    if (actual !== expected) {
      fail(actual, expected, message, '===', assert.strictEqual);
    }
  };

  // 10. The strict non-equality assertion tests for strict inequality, as
  // determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

  assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (actual === expected) {
      fail(actual, expected, message, '!==', assert.notStrictEqual);
    }
  };

  function expectedException(actual, expected) {
    if (!actual || !expected) {
      return false;
    }

    if (Object.prototype.toString.call(expected) == '[object RegExp]') {
      return expected.test(actual);
    } else if (actual instanceof expected) {
      return true;
    } else if (expected.call({}, actual) === true) {
      return true;
    }

    return false;
  }

  function _throws(shouldThrow, block, expected, message) {
    var actual;

    if (util.isString(expected)) {
      message = expected;
      expected = null;
    }

    try {
      block();
    } catch (e) {
      actual = e;
    }

    message = (expected && expected.name ? ' (' + expected.name + ').' : '.') + (message ? ' ' + message : '.');

    if (shouldThrow && !actual) {
      fail(actual, expected, 'Missing expected exception' + message);
    }

    if (!shouldThrow && expectedException(actual, expected)) {
      fail(actual, expected, 'Got unwanted exception' + message);
    }

    if (shouldThrow && actual && expected && !expectedException(actual, expected) || !shouldThrow && actual) {
      throw actual;
    }
  }

  // 11. Expected to throw an error:
  // assert.throws(block, Error_opt, message_opt);

  assert.throws = function (block, /*optional*/error, /*optional*/message) {
    _throws.apply(this, [true].concat(pSlice.call(arguments)));
  };

  // EXTENSION! This is annoying to write outside this module.
  assert.doesNotThrow = function (block, /*optional*/message) {
    _throws.apply(this, [false].concat(pSlice.call(arguments)));
  };

  assert.ifError = function (err) {
    if (err) {
      throw err;
    }
  };

  return assert;
});

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ScriptView = __webpack_require__(1607);

var _ScriptView2 = _interopRequireDefault(_ScriptView);

var _query_string = __webpack_require__(192);

var _query_string2 = _interopRequireDefault(_query_string);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * decaffeinate suggestions:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DS001: Remove Babel/TypeScript constructor workaround
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DS102: Remove unnecessary code created because of implicit returns
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DS104: Avoid inline assignments
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DS203: Remove `|| {}` from converted for-own loops
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DS204: Change includes calls to have a more natural evaluation order
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DS205: Consider reworking code to avoid use of IIFEs
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DS206: Consider reworking classes to avoid initClass
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DS207: Consider shorter variations of null checks
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var RunnerUi = void 0;

exports.default = RunnerUi = function () {
    RunnerUi = function (_Backbone$Marionette$) {
        _inherits(RunnerUi, _Backbone$Marionette$);

        function RunnerUi() {
            var _ref;

            _classCallCheck(this, RunnerUi);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            var _this = _possibleConstructorReturn(this, (_ref = RunnerUi.__proto__ || Object.getPrototypeOf(RunnerUi)).call.apply(_ref, [this].concat(args)));

            _this.initialize = _this.initialize.bind(_this);
            return _this;
        }

        _createClass(RunnerUi, [{
            key: "_reload",
            value: function _reload(params) {
                params.ITr = Math.random().toString().substr(2);
                return window.location.search = _query_string2.default.serialize(params);
            }
        }, {
            key: "initialize",
            value: function initialize() {
                var _this2 = this;

                this.interpreter = this.model.get("interpreter");
                this.scriptModel = new Backbone.Model({
                    script: this.model.get("script"),
                    view: this.model.get("scriptState") === "edit" ? "editor" : "lines"
                });
                this.lines = new Backbone.Collection(this.model.get("script").replace(/\n\s*$/, "").split("\n").map(function (l) {
                    return new Backbone.Model({
                        text: l
                    });
                }));
                this.listenTo(this.model, "change:scriptState", function (m, v) {
                    return _this2.scriptModel.set({ view: v === "edit" ? "editor" : "lines" });
                });
                this.interpreter.on("all", function (event, atom, payload, ts) {
                    if (arguments.length !== 4 || !(atom != null ? atom.line : undefined)) {
                        return;
                    }
                    var line = this.lines.at(atom.line - 1);
                    if (event.indexOf("error:") === 0) {
                        this.scriptModel.set({ activeLine: atom.line });
                        return line.set({ clazz: "error", error: payload, atom: atom });
                    } else {
                        if (event.indexOf(":start") > 0) {
                            this.scriptModel.set({ activeLine: atom.line });
                            return line.set({ clazz: "active" });
                        } else if (event.indexOf(":done") > 0) {
                            return line.set({ clazz: "done" });
                        }
                    }
                }.bind(this)).on("parsed", function (es) {
                    if (es.length === 0) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = _this2.interpreter.commands[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var c = _step.value;

                                _this2.lines.at(c.line - 1).set({ cmd: c });
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        return function () {
                            var result = [];
                            var _iteratorNormalCompletion2 = true;
                            var _didIteratorError2 = false;
                            var _iteratorError2 = undefined;

                            try {
                                for (var _iterator2 = _this2.lines.models[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    var m = _step2.value;

                                    if (!m.has("cmd")) {
                                        result.push(m.set({ clazz: "comment" }));
                                    } else {
                                        result.push(undefined);
                                    }
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                        _iterator2.return();
                                    }
                                } finally {
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }

                            return result;
                        }();
                    }
                }).on("start", function (p) {
                    return p.always(function () {
                        return _this2.model.set("scriptMode", "done");
                    });
                });
                return this.listenTo(this.model, "change", this.render);
            }
        }, {
            key: "onRender",
            value: function onRender() {
                var _this3 = this;

                this.script.show(new _ScriptView2.default({
                    model: this.scriptModel,
                    collection: this.lines
                }));
                var enabled = [];
                switch (this.model.get("scriptState")) {
                    case "pending":
                        enabled.push("edit");
                        break;
                    case "start":
                        enabled.push("reset");
                        enabled.push("step");
                        enabled.push("play");
                        enabled.push("edit");
                        break;
                    case "play":
                        enabled.push("reset");
                        enabled.push("pause");
                        break;
                    case "pause":
                        enabled.push("reset");
                        enabled.push("step");
                        enabled.push("play");
                        enabled.push("edit");
                        break;
                    case "success":case "error":
                        enabled.push("reset");
                        enabled.push("edit");
                        break;
                    case "edit":
                        enabled.push("trash");
                        enabled.push("run");
                        break;
                    default:
                }
                if (this.model.get("showTargets")) {
                    this.ui.targetsTgl.addClass("active");
                    enabled.push("updateTargets");
                } else {
                    this.ui.targetsTgl.removeClass("active");
                }
                return function () {
                    var result = [];
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = Object.keys(_this3.ui || {})[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var n = _step3.value;

                            var b = _this3.ui[n];
                            if (n.substr(n.length - 3) === "Btn") {
                                var needle = n.substr(0, n.length - 3);
                                if (enabled.includes(needle)) {
                                    result.push(b.removeAttr("disabled"));
                                } else {
                                    result.push(b.attr("disabled", "disabled"));
                                }
                            } else {
                                result.push(undefined);
                            }
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }

                    return result;
                }();
            }
        }], [{
            key: "initClass",
            value: function initClass() {
                this.prototype.template = __webpack_require__(1611);
                this.prototype.regions = { script: ".script" };

                this.prototype.ui = {
                    resetBtn: ".reset-button",
                    pauseBtn: ".pause-button",
                    playBtn: ".play-button",
                    stepBtn: ".step-button",
                    editBtn: ".edit-button",
                    trashBtn: ".trash-button",
                    runBtn: ".run-button",
                    targetsTgl: ".targets-toggle",
                    updateTargetsBtn: ".targets-update-button"
                };

                this.prototype.events = {
                    "click .reset-button": function clickResetButton() {
                        var params = _query_string2.default.parse();
                        if (params.ITautoPlay == null) {
                            params.ITautoPlay = false;
                        }
                        return this._reload(params);
                    },
                    "click .pause-button": function clickPauseButton() {
                        return this.interpreter.pause();
                    },
                    "click .play-button": function clickPlayButton() {
                        return this.interpreter.play();
                    },
                    "click .step-button": function clickStepButton() {
                        return this.interpreter.step();
                    },
                    "click .edit-button": function clickEditButton() {
                        this.model.set("scriptState", "edit");
                        return this.render();
                    },
                    "click .trash-button": function clickTrashButton() {
                        if (window.confirm("Are you sure you'd like to discard your changes?")) {
                            var params = _query_string2.default.parse();
                            delete params.ITautoPlay;
                            return this._reload(params);
                        }
                    },
                    "click .run-button": function clickRunButton() {
                        var params = _query_string2.default.parse();
                        params.IT = this.scriptModel.get("script");
                        delete params.ITautoPlay;
                        return this._reload(params);
                    },
                    "click .targets-toggle": function clickTargetsToggle() {
                        return this.model.set({ showTargets: !this.model.get("showTargets") });
                    },
                    "click .targets-update-button": function clickTargetsUpdateButton() {
                        return this.model.trigger("change:showTargets", this.model, true);
                    }
                };
                // ghetto!!
            }
        }]);

        return RunnerUi;
    }(Backbone.Marionette.Layout);
    RunnerUi.initClass();
    return RunnerUi;
}();

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LineView = __webpack_require__(1608);

var _LineView2 = _interopRequireDefault(_LineView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * decaffeinate suggestions:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DS001: Remove Babel/TypeScript constructor workaround
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DS102: Remove unnecessary code created because of implicit returns
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DS206: Consider reworking classes to avoid initClass
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * DS207: Consider shorter variations of null checks
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var ScriptView = void 0;

exports.default = ScriptView = function () {
    ScriptView = function (_Backbone$Marionette$) {
        _inherits(ScriptView, _Backbone$Marionette$);

        function ScriptView() {
            var _ref;

            _classCallCheck(this, ScriptView);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            var _this = _possibleConstructorReturn(this, (_ref = ScriptView.__proto__ || Object.getPrototypeOf(ScriptView)).call.apply(_ref, [this].concat(args)));

            _this.initialize = _this.initialize.bind(_this);
            _this.onRender = _this.onRender.bind(_this);
            _this.resetScrollPosition = _this.resetScrollPosition.bind(_this);
            return _this;
        }

        _createClass(ScriptView, [{
            key: "initialize",
            value: function initialize() {
                var _this2 = this;

                return this.listenTo(this.model, "change:activeLine", function (m, line) {
                    return _this2.resetScrollPosition(line);
                });
            }
        }, {
            key: "onRender",
            value: function onRender() {
                var _this3 = this;

                this.ui.views.css("display", "none");
                this.ui[this.model.get("view")].css("display", "block");
                // eslint-disable-next-line no-settimeout
                return setTimeout(function () {
                    _this3.resetScrollPosition(_this3.model.get("activeLine"));
                    if (_this3.model.get("view") === "editor") {
                        return _this3.ui.editor.focus();
                    }
                }, 0);
            }
        }, {
            key: "resetScrollPosition",
            value: function resetScrollPosition(line) {
                if (line != null && line > 0) {
                    var lines = this.$el.find(".lines");
                    var lel = lines.find("li:nth(" + line + ")");
                    if (lel.length) {
                        return lines.animate({ scrollTop: Math.max(0, lel.offset().top - lines.offset().top + lines.scrollTop() - lines.height() * 0.4) }, 1);
                    }
                }
            }
        }], [{
            key: "initClass",
            value: function initClass() {
                this.prototype.template = __webpack_require__(1610);
                this.prototype.itemView = _LineView2.default;
                this.prototype.itemViewContainer = ".lines";

                this.prototype.ui = {
                    views: ".script-view",
                    lines: ".script-view.lines",
                    editor: ".script-view.editor"
                };

                this.prototype.events = {
                    "change .script-view.editor": function changeScriptViewEditor() {
                        return this.model.set("script", this.ui.editor.val());
                    }
                };
            }
        }]);

        return ScriptView;
    }(Backbone.Marionette.CompositeView);
    ScriptView.initClass();
    return ScriptView;
}();

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * decaffeinate suggestions:
 * DS001: Remove Babel/TypeScript constructor workaround
 * DS102: Remove unnecessary code created because of implicit returns
 * DS202: Simplify dynamic range loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
var LineView = void 0;

exports.default = LineView = function () {
    LineView = function (_Backbone$Marionette$) {
        _inherits(LineView, _Backbone$Marionette$);

        function LineView() {
            var _ref;

            _classCallCheck(this, LineView);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            var _this = _possibleConstructorReturn(this, (_ref = LineView.__proto__ || Object.getPrototypeOf(LineView)).call.apply(_ref, [this].concat(args)));

            _this.initialize = _this.initialize.bind(_this);
            _this.onRender = _this.onRender.bind(_this);
            return _this;
        }

        _createClass(LineView, [{
            key: "initialize",
            value: function initialize() {
                return this.listenTo(this.model, "change", this.render);
            }
        }, {
            key: "onRender",
            value: function onRender() {
                var a = void 0;
                var i = void 0;
                this.$el.attr("class", this.model.get("clazz"));
                if ((a = this.model.get("atom")) != null) {
                    var ci = function () {
                        var asc = void 0,
                            end = void 0;
                        var result = [];
                        for (i = 1, end = a.column, asc = 1 <= end; asc ? i <= end : i >= end; asc ? i++ : i--) {
                            result.push(" ");
                        }
                        return result;
                    }().join("").substr(1) + function () {
                        var asc1 = void 0,
                            end1 = void 0;
                        var result1 = [];
                        for (i = 1, end1 = a.len, asc1 = 1 <= end1; asc1 ? i <= end1 : i >= end1; asc1 ? i++ : i--) {
                            result1.push("^");
                        }
                        return result1;
                    }().join("");
                    return this.model.set({ columnIndicator: ci });
                }
            }
        }], [{
            key: "initClass",
            value: function initClass() {
                this.prototype.tagName = "li";
                this.prototype.template = __webpack_require__(1609);
            }
        }]);

        return LineView;
    }(Backbone.Marionette.ItemView);
    LineView.initClass();
    return LineView;
}();

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(99);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"code\">"
    + alias4(((helper = (helper = lookupProperty(helpers,"text") || (depth0 != null ? lookupProperty(depth0,"text") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data,"loc":{"start":{"line":1,"column":18},"end":{"line":1,"column":26}}}) : helper)))
    + "</div>\n<div class=\"column-indicator\">"
    + alias4(((helper = (helper = lookupProperty(helpers,"columnIndicator") || (depth0 != null ? lookupProperty(depth0,"columnIndicator") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"columnIndicator","hash":{},"data":data,"loc":{"start":{"line":2,"column":30},"end":{"line":2,"column":49}}}) : helper)))
    + "</div>\n<div class=\"error\">"
    + alias4(((helper = (helper = lookupProperty(helpers,"error") || (depth0 != null ? lookupProperty(depth0,"error") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"error","hash":{},"data":data,"loc":{"start":{"line":3,"column":19},"end":{"line":3,"column":28}}}) : helper)))
    + "</div>\n";
},"useData":true});

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(99);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"script-views\">\n    <ol class=\"lines script-view\"></ol>\n    <textarea class=\"editor script-view\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"script") || (depth0 != null ? lookupProperty(depth0,"script") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"script","hash":{},"data":data,"loc":{"start":{"line":3,"column":41},"end":{"line":3,"column":51}}}) : helper)))
    + "</textarea>\n</div>\n";
},"useData":true});

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(99);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"panel panel-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"chromeType") || (depth0 != null ? lookupProperty(depth0,"chromeType") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"chromeType","hash":{},"data":data,"loc":{"start":{"line":1,"column":24},"end":{"line":1,"column":38}}}) : helper)))
    + " IT-window IT-runner-ui\" role=\"dialog\">\n    <button type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n    <div class=\"panel-heading\">\n        <h3 class=\"panel-title\">Test Runner</h3>\n    </div>\n    <div class=\"panel-body\">\n        <div class=\"btn-group btn-group-sm\">\n            <button type=\"button\" class=\"btn btn-default reset-button\" title=\"Rewind script\"><span class=\"glyphicon glyphicon-fast-backward\"></span></button>\n            <button type=\"button\" class=\"btn btn-default pause-button\" title=\"Pause script\"><span class=\"glyphicon glyphicon-pause\"></span></button>\n            <button type=\"button\" class=\"btn btn-default step-button\" title=\"Run next line\"><span class=\"glyphicon glyphicon-step-forward\"></span></button>\n            <button type=\"button\" class=\"btn btn-default play-button\" typeof=\"Play script\"><span class=\"glyphicon glyphicon-play\"></span></button>\n        </div>\n        <div class=\"btn-group btn-group-sm\">\n            <button type=\"button\" class=\"btn btn-default edit-button\" title=\"Edit script\"><span class=\"glyphicon glyphicon-edit\"></span></button>\n            <button type=\"button\" class=\"btn btn-default trash-button\" title=\"Discard\"><span class=\"glyphicon glyphicon-trash\"></span></button>\n            <button type=\"button\" class=\"btn btn-default run-button\" title=\"Execute\"><span class=\"glyphicon glyphicon-share\"></span></button>\n        </div>\n        <div class=\"btn-group btn-group-sm\">\n            <button type=\"button\" class=\"btn btn-default targets-toggle\" title=\"Show/hide named elements\"><span class=\"glyphicon glyphicon-screenshot\"></span></button>\n            <button type=\"button\" class=\"btn btn-default targets-update-button\" title=\"Update named elements\"><span class=\"glyphicon glyphicon-refresh\"></span></button>\n        </div>\n        <div class=\"script\"></div>\n    </div>\n</div>\n\n";
},"useData":true});

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseServices = __webpack_require__(76);

var _BaseServices2 = _interopRequireDefault(_BaseServices);

var _RequestPattern = __webpack_require__(1613);

var _RequestPattern2 = _interopRequireDefault(_RequestPattern);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var patterns = [];

var Mock = function () {
    function Mock() {
        _classCallCheck(this, Mock);
    }

    _createClass(Mock, [{
        key: "GET",
        value: function GET(path, builder) {
            var p = new _RequestPattern2.default("GET", path, builder);
            patterns.push(p);
            return p;
        }
    }, {
        key: "PUT",
        value: function PUT(path, builder) {
            var p = new _RequestPattern2.default("PUT", path, builder);
            patterns.push(p);
            return p;
        }
    }, {
        key: "POST",
        value: function POST(path, builder) {
            var p = new _RequestPattern2.default("POST", path, builder);
            patterns.push(p);
            return p;
        }
    }, {
        key: "DELETE",
        value: function DELETE(path, builder) {
            var p = new _RequestPattern2.default("DELETE", path, builder, function (url) {
                return url.replace(/^(.*)\.json$/, "$1.DELETE.json");
            });
            patterns.push(p);
            return p;
        }
    }]);

    return Mock;
}();

var config = typeof window !== "undefined" && window !== null ? window.HybridConfig : undefined;
var mockRoot = config != null ? config.mockRoot : undefined;

if (mockRoot == null) {
    var msg = "To use API mocking, if you don't specify a mockset (e.g., 'ob-cath') on the URL, you must declare a 'mockRoot' config param (next to 'apiRoot' in config.js, probably like 'mocks/ob-cath/').";
    alert(msg);
    throw msg;
}

var apiRoot = _BaseServices2.default.root_url;

// for fail-fast behaviour on a bad mockRoot
$.ajax(mockRoot + "/user.json?mock-fail-fast", {
    global: false,
    dataType: "json"
}).fail(function () {
    return alert("No mockset was found at \"" + mockRoot + "\".");
});

$(document).ajaxSend(function (e, jqXHR, config) {
    if (config.url.substr(0, apiRoot.length) === apiRoot) {
        jqXHR.mock = true;
        var path = config.url.substr(apiRoot.length - 1).split("?");
        var verb = config.type.toUpperCase();
        var req = verb + " " + path[0];
        var pattern = patterns.find(function (p) {
            return p.test(req);
        });
        if (pattern == null) {
            var _msg = "You have mocking enabled, but '" + req + "' isn't mocked.";
            console.error(_msg);
            jqXHR.abort(_msg);
            return;
        }
        var newPath = pattern.build(req, config);
        if (newPath) {
            config.type = "GET"; // always gets when we're mocking
            path[0] = mockRoot + newPath.substring(1);
            config.url = path.join("?");
            if (pattern.hasDataFilter()) {
                config.dataFilter = pattern.getDataFilter(req, config);
            }
        } else {
            jqXHR.abort(e);
        }
    }
});

if (config.session != null) {
    console.log("Session management is disabled for Mock-based sessions.");
    config.session.autoLogout = false;
    config.session.keepAlive = false;
}

_BaseServices2.default.endSession = function () {
    window.location.hash = "";
    window.location.reload(true);
};

_BaseServices2.default.__mocked = true;

exports.default = new Mock();

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PAGE_RE = /^.*\?(?:.*&)?p=(\d+).*$/;
var getPageNumberFromUrl = function getPageNumberFromUrl(url) {
    if (PAGE_RE.test(url)) {
        return url.replace(PAGE_RE, "$1");
    } else {
        return 1;
    }
};

var RequestPattern = function () {
    function RequestPattern(verb, patt, builder, postprocessor) {
        _classCallCheck(this, RequestPattern);

        this.verb = verb;
        this.builder = builder;
        this.postprocessor = postprocessor != null ? postprocessor : function (it, config) {
            return it;
        };
        var re = this.verb + " ";
        this.replace = "";
        this.names = [];
        var start = 0;
        while (true) {
            var open = patt.indexOf("{", start);
            var close = patt.indexOf("}", open);
            if (open >= 0 && close > open) {
                var lit = patt.substring(start, open);
                re += lit;
                this.replace += lit;
                var parts = patt.substring(open + 1, close).split(":");
                this.names.push(parts[0]);
                if (parts.length === 1) {
                    parts.push("s");
                }
                re += "(";
                if (parts[1] === "s") {
                    re += "[a-zA-Z0-9_-]+";
                } else if (parts[1] === "i") {
                    re += "[0-9]+";
                } else {
                    throw new Error("Unrecognized pattern expression interpolation type: '" + parts[1] + "'");
                }
                re += ")";
                this.replace += "$" + this.names.length;
                start = close + 1;
            } else {
                var _lit = patt.substring(start);
                re += _lit;
                this.replace += _lit;
                break;
            }
        }

        if (re.indexOf(".") < 0) {
            re += "(\\.json)?";
            this.replace += ".json";
        }
        this.regexp = new RegExp("^" + re + "$");
    }

    _createClass(RequestPattern, [{
        key: "extension",
        value: function extension(ext) {
            var prev = this.postprocessor;
            return this.postprocessor = function (url, config) {
                var parts = prev(url, config).split(".");
                parts.pop();
                parts.push(ext);
                return parts.join(".");
            };
        }
    }, {
        key: "suffixed",
        value: function suffixed(suffix) {
            var prev = this.postprocessor;
            this.postprocessor = function (url, config) {
                url = prev(url, config);
                return url.replace(/^(.*)\.([^.]+)$/, "$1." + suffix + ".$2");
            };
            return this;
        }
    }, {
        key: "paged",
        value: function paged() {
            var prev = this.postprocessor;
            this.postprocessor = function (url, config) {
                url = prev(url, config);
                return url.replace(/^(.*)\.([^.]+)$/, "$1.p." + getPageNumberFromUrl(config.url) + ".$2");
            };
            return this;
        }
    }, {
        key: "postprocess",
        value: function postprocess(callback) {
            var prev = this.postprocessor;
            this.postprocessor = function (url, config) {
                url = prev(url, config);
                return callback(url, config);
            };
            return this;
        }
    }, {
        key: "filtered",
        value: function filtered(f) {
            this.filter = f;
            return this;
        }
    }, {
        key: "hasDataFilter",
        value: function hasDataFilter() {
            return this.filter != null;
        }
    }, {
        key: "getDataFilter",
        value: function getDataFilter(req, config) {
            var _this = this;

            return function (data, type) {
                if (type === "json") {
                    return JSON.stringify(_this.filter(JSON.parse(data), req, config));
                } else {
                    return _this.filter(data, req, config);
                }
            };
        }
    }, {
        key: "test",
        value: function test(req) {
            return this.regexp.test(req);
        }
    }, {
        key: "build",
        value: function build(req, config) {
            return this.postprocessor(this.builder != null ? this.builder(this.getParts(req), config) : req.replace(this.regexp, this.replace), config);
        }
    }, {
        key: "getParts",
        value: function getParts(req) {
            var matches = this.regexp.exec(req);
            matches.shift(); // remove the overall match
            var parts = {};
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.names[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var n = _step.value;

                    parts[n] = matches.shift();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return parts;
        }
    }]);

    return RequestPattern;
}();

exports.default = RequestPattern;

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

var Hybrid;

__webpack_require__(1615);

__webpack_require__(1616);

__webpack_require__(1617);

Hybrid = module.exports;

Hybrid.FileInfo = __webpack_require__(1618)["default"];

Hybrid.error = __webpack_require__(225)["default"];

Hybrid.__unload = __webpack_require__(1619)["default"];

Hybrid.error.byCode = __webpack_require__(1620);

Backbone.Model.prototype.keys = __webpack_require__(1621);

Hybrid;


/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ChoiceStore = __webpack_require__(174);

var _ChoiceStore2 = _interopRequireDefault(_ChoiceStore);

var _options = __webpack_require__(156);

var _EntityProxy = __webpack_require__(31);

var _EntityProxy2 = _interopRequireDefault(_EntityProxy);

var _StereotypeProxy = __webpack_require__(305);

var _StereotypeProxy2 = _interopRequireDefault(_StereotypeProxy);

var _TableProxy = __webpack_require__(222);

var _TableProxy2 = _interopRequireDefault(_TableProxy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// noinspection JSUnresolvedVariable
ArmusScript = function (base) {
    // eslint-disable-line no-native-reassign
    var ArmusScript = base || {};

    if (typeof Backbone !== "undefined") {
        _.each(ArmusScript, function (f, it) {
            if (it.indexOf("Array<") >= 0) {
                // it has an array argument
                ArmusScript[it] = function () {
                    var args = _.toArray(arguments);
                    var l = args.length;
                    for (var i = 0; i < l; i++) {
                        if (args[i] instanceof Backbone.Collection) {
                            args[i] = args[i].models;
                        }
                    }
                    return f.apply(this, args);
                };
            }
        });
    }

    // ensure operand(s) are numeric (not strings) in development
    if (false) {
        _.each(["_op_unary_minus", "_op_unary_plus", "_op_add", "_op_minus", "_op_multiply", "_op_divide", "_op_modulo"], function (it) {
            var f = ArmusScript[it];
            ArmusScript[it] = function () {
                var args = _.toArray(arguments);
                var l = args.length;
                for (var i = 0; i < l; i++) {
                    if (typeof args[i] === "string") {
                        throw new Error("Call to '" + it + "' was passed a string '" + args[i] + "'");
                    }
                }
                return f.apply(this, args);
            };
        });
    }

    ArmusScript._op_get_at = function (a, i) {
        // in Hybrid-land, arrays are Backbone.Collection, not real
        if (a == null || i == null) {
            return null;
        }
        return a instanceof Backbone.Collection ? a.at(i) : a[i];
    };

    ArmusScript["isSameRecord(T,T)"] = function (a, b) {
        if (a == null) {
            return b == null;
        } else if (b == null) {
            return false;
        }
        if (a instanceof _TableProxy2.default || a instanceof _EntityProxy2.default || a instanceof _StereotypeProxy2.default) {
            return a.equals(b);
        }
        throw new Error("Cannot test 'isSameRecord(" + a + ", " + b + ")', try '=='.");
    };

    ArmusScript["toOptionLabel(String,String)"] = function (v, choicename) {
        if (v == null || choicename == null) {
            return v;
        }
        return (0, _options.optionLabel)(choicename)(v) || v;
    };

    ArmusScript["toOptionName(int,String)"] = function (id, choicename) {
        return _ChoiceStore2.default.optionName(choicename)(id);
    };

    ArmusScript._traverse = function (curr, parts) {
        var i = void 0,
            part = void 0,
            next = void 0;
        var l = parts.length;
        for (i = 0; i < l && curr != null; i++) {
            part = parts[i];
            next = curr.get(part);
            if (curr instanceof _TableProxy2.default || curr instanceof _EntityProxy2.default || curr instanceof _StereotypeProxy2.default) {
                if (typeof next === "string" && curr.getAttributeType(part) === "DECIMAL") {
                    curr = Number(next);
                } else {
                    curr = next;
                }
            } else {
                curr = next;
            }
        }
        if (curr === undefined) {
            curr = null;
        }
        return curr;
    };

    var coreToString = ArmusScript["toString(T)"];
    ArmusScript["toString(T)"] = function (v) {
        if (v instanceof _EntityProxy2.default || v instanceof _StereotypeProxy2.default) {
            return v.getLabel();
        }
        return coreToString(v);
    };

    return ArmusScript;
}(ArmusScript);

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
        value: function assign(target, varArgs) {
            // .length of function is 2
            'use strict';

            if (target == null) {
                // TypeError if undefined or null
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var to = Object(target);

            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index];

                if (nextSource != null) {
                    // Skip over if undefined or null
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true
    });
}

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Object.values != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "values", {
        value: function assign(target) {
            'use strict';

            if (target == null) {
                // TypeError if undefined or null
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var result = [];
            for (var nextKey in target) {
                // Avoid bugs when hasOwnProperty is shadowed
                if (Object.prototype.hasOwnProperty.call(target, nextKey)) {
                    result.push(target[nextKey]);
                }
            }
            return result;
        },
        writable: true,
        configurable: true
    });
}

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FileInfo = function (_Backbone$Model) {
    _inherits(FileInfo, _Backbone$Model);

    function FileInfo() {
        _classCallCheck(this, FileInfo);

        return _possibleConstructorReturn(this, (FileInfo.__proto__ || Object.getPrototypeOf(FileInfo)).apply(this, arguments));
    }

    return FileInfo;
}(Backbone.Model);

FileInfo.FILEUPLOADSTATES = {
    QUEUED: "queued",
    INPROGRESS: "inprogress",
    ABORTED: "aborted",
    COMPLETE: "complete",
    ERROR: "error"
};

FileInfo.prototype.defaults = {
    filename: null,
    contentType: null,
    size: null
};

exports.default = FileInfo;

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _unload;

var _Dispatcher = __webpack_require__(4);

var _Dispatcher2 = _interopRequireDefault(_Dispatcher);

var _DefineActions = __webpack_require__(124);

var _DefineActions2 = _interopRequireDefault(_DefineActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _unload() {
    for (var k in Hybrid) {
        if (Hybrid.hasOwnProperty(k) && k.indexOf("/") > 0) {
            delete Hybrid[k];
        }
    }
    _Dispatcher2.default.dispatch({
        type: _DefineActions2.default._UNLOAD
    });
};

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

var error,
  __hasProp = {}.hasOwnProperty;

module.exports = function(code) {
  var it, n;

  for (n in error) {
    if (!__hasProp.call(error, n)) continue;
    it = error[n];
    if (it.code === code) {
      return it;
    }
  }
  throw new Error('Unknown code: ' + code);
};

error = __webpack_require__(225)["default"];


/***/ }),
/* 1621 */
/***/ (function(module, exports) {

module.exports = function() {
  return _.keys(this.attributes);
};


/***/ })
],[685]);


// WEBPACK FOOTER //
// app.bundle.0add969f266420473080.js